(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 90099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(13158);
/**
 * @adobe/target-nodejs-sdk v.2.4.2
 * Copyright 2019 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(62234), __webpack_require__(65301), __webpack_require__(74676), __webpack_require__(37122)) :
  0;
}(this, (function (punycode, crypto, https, http) { 'use strict';

  punycode = punycode && Object.prototype.hasOwnProperty.call(punycode, 'default') ? punycode['default'] : punycode;
  crypto = crypto && Object.prototype.hasOwnProperty.call(crypto, 'default') ? crypto['default'] : crypto;
  https = https && Object.prototype.hasOwnProperty.call(https, 'default') ? https['default'] : https;
  http = http && Object.prototype.hasOwnProperty.call(http, 'default') ? http['default'] : http;

  var global$1 =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global$1 !== 'undefined' && global$1);

  var support = {
    searchParams: 'URLSearchParams' in global$1,
    iterable: 'Symbol' in global$1 && 'iterator' in Symbol,
    blob:
      'FileReader' in global$1 &&
      'Blob' in global$1 &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global$1,
    arrayBuffer: 'ArrayBuffer' in global$1
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  var DOMException = global$1.DOMException;
  try {
    new DOMException();
  } catch (err) {
    DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global$1.location.href ? global$1.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global$1.fetch) {
    global$1.fetch = fetch;
    global$1.Headers = Headers;
    global$1.Request = Request;
    global$1.Response = Response;
  }

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */

  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }

    return Object(val);
  }

  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      } // Detect buggy property enumeration order in older V8 versions.
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118


      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

      test1[5] = 'de';

      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test2 = {};

      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }

      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });

      if (order2.join('') !== '0123456789') {
        return false;
      } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });

      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }

      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;

    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);

      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }

      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);

        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }

    return to;
  };

  var reactorObjectAssign = objectAssign;

  /**
   * Checks if `value` is `null` or `undefined`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
   * @example
   *
   * _.isNil(null);
   * // => true
   *
   * _.isNil(void 0);
   * // => true
   *
   * _.isNil(NaN);
   * // => false
   */
  function isNil(value) {
    return value == null;
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  const {
    isArray
  } = Array;

  const {
    prototype: objectProto
  } = Object;
  const {
    toString: nativeObjectToString
  } = objectProto;

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    return objectToString(value);
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    const type = typeof value;
    /* eslint-disable */

    const notNull = value != null;
    /* eslint-enable */

    return notNull && (type === "object" || type === "function");
  }

  /** `Object#toString` result references. */

  const funcTag = "[object Function]";
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */

  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    return baseGetTag(value) === funcTag;
  }

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Casts `value` to `identity` if it's not a function.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Function} Returns cast function.
   */

  function castFunction(value) {
    return isFunction(value) ? value : identity;
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */

  function keys(object) {
    if (isNil(object)) {
      return [];
    }

    return Object.keys(object);
  }

  const arrayEach = (iteratee, collection) => collection.forEach(iteratee);

  const baseEach = (iteratee, collection) => {
    arrayEach(key => iteratee(collection[key], key), keys(collection));
  };

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */

  function flatten(array) {
    if (isNil(array)) {
      return [];
    }
    /* eslint-disable */


    return [].concat.apply([], array);
    /* eslint-enable */
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    /* eslint-disable */
    const notNull = value != null;
    /* eslint-enable */

    return notNull && typeof value === "object";
  }

  /** `Object#toString` result references. */

  const stringTag = "[object String]";
  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */

  function isString(value) {
    return typeof value === "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) === stringTag;
  }

  /** Used as references for various `Number` constants. */
  const MAX_SAFE_INTEGER = 9007199254740991;
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */

  function isLength(value) {
    return typeof value === "number" && value > -1 && value % 1 === 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  const arrayMap = (iteratee, collection) => collection.map(iteratee);

  function baseValues(props, object) {
    return arrayMap(key => object[key], props);
  }

  function copyArray(source) {
    let index = 0;
    const {
      length
    } = source;
    const array = Array(length);

    while (index < length) {
      array[index] = source[index];
      index += 1;
    }

    return array;
  }

  function stringToArray(str) {
    return str.split("");
  }
  /**
   * Converts `value` to an array.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Array} Returns the converted array.
   * @example
   *
   * _.toArray({ 'a': 1, 'b': 2 });
   * // => [1, 2]
   *
   * _.toArray('abc');
   * // => ['a', 'b', 'c']
   *
   * _.toArray(1);
   * // => []
   *
   * _.toArray(null);
   * // => []
   */


  function toArray(value) {
    if (isNil(value)) {
      return [];
    }

    if (isArrayLike(value)) {
      return isString(value) ? stringToArray(value) : copyArray(value);
    }

    return baseValues(keys(value), value);
  }

  /**
   * Checks if `value` is in `collection`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to inspect.
   * @param {*} value The value to search for.
   * @returns {boolean} Returns `true` if `value` is found, else `false`.
   * @example
   *
   * _.includes([1, 2, 3], 1);
   * // => true
   *
   * _.includes([1, 2, 3], 1, 2);
   * // => false
   *
   * _.includes({ 'a': 1, 'b': 2 }, 1);
   * // => true
   *
   */

  function includes(value, collection) {
    const coll = isArrayLike(collection) ? collection : toArray(collection);
    return coll.indexOf(value) > -1;
  }

  const {
    prototype: objectProto$1
  } = Object;
  const {
    hasOwnProperty: hasOwnProperty$1
  } = objectProto$1;
  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */

  function isEmpty(value) {
    if (value == null) {
      return true;
    }

    if (isArrayLike(value) && (isArray(value) || isString(value) || isFunction(value.splice))) {
      return !value.length;
    }
    /* eslint-disable */


    for (const key in value) {
      if (hasOwnProperty$1.call(value, key)) {
        return false;
      }
    }
    /* eslint-enable */


    return true;
  }

  const {
    prototype: stringProto
  } = String;
  const {
    trim: nativeStringTrim
  } = stringProto;

  function trim(string) {
    return isNil(string) ? "" : nativeStringTrim.call(string);
  }

  /**
   * Checks if `value` is a blank string.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isBlank(null);
   * // => true
   *
   * _.isBlank(undefined);
   * // => true
   *
   * _.isBlank('');
   * // => true
   *
   * * _.isBlank('   ');
   * // => true
   */

  function isBlank(value) {
    return isString(value) ? !trim(value) : isEmpty(value);
  }

  /** `Object#toString` result references. */

  const numberTag = "[object Number]";
  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */

  function isNumber(value) {
    return typeof value === "number" || isObjectLike(value) && baseGetTag(value) === numberTag;
  }

  const objectTag = "[object Object]";
  const {
    prototype: funcProto
  } = Function;
  const {
    prototype: objectProto$2
  } = Object;
  const {
    toString: funcToString
  } = funcProto;
  const {
    hasOwnProperty: hasOwnProperty$2
  } = objectProto$2;
  const objectCtorString = funcToString.call(Object);

  function getPrototype(value) {
    return Object.getPrototypeOf(Object(value));
  }
  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */


  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) !== objectTag) {
      return false;
    }

    const proto = getPrototype(value);

    if (proto === null) {
      return true;
    }

    const Ctor = hasOwnProperty$2.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && Ctor instanceof Ctor && funcToString.call(Ctor) === objectCtorString;
  }

  function join(joiner, collection) {
    if (!isArray(collection)) {
      return "";
    }

    return collection.join(joiner || "");
  }

  function now() {
    return new Date().getTime();
  }

  const arrayReduce = (iteratee, accumulator, collection) => collection.reduce(iteratee, accumulator);

  const baseReduce = (iteratee, accumulator, collection) => {
    let localAcc = accumulator;
    baseEach((value, key) => {
      localAcc = iteratee(localAcc, value, key);
    }, collection);
    return localAcc;
  };
  /**
   * Reduces `collection` to a value which is the accumulated result of running
   * each element in `collection` thru `iteratee`, where each successive
   * invocation is supplied the return value of the previous. If `accumulator`
   * is not given, the first element of `collection` is used as the initial
   * value. The iteratee is invoked with four arguments:
   * (accumulator, value, index|key, collection).
   *
   * Many lodash methods are guarded to work as iteratees for methods like
   * `_.reduce`, `_.reduceRight`, and `_.transform`.
   *
   * The guarded methods are:
   * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
   * and `sortBy`
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {Array|Object} collection The collection to iterate over.
   * @returns {*} Returns the accumulated value.
   * @see _.reduceRight
   * @example
   *
   * _.reduce(function(sum, n) {
   *   return sum + n;
   * }, 0, [1, 2]);
   * // => 3
   *
   * _.reduce(function(result, value, key) {
   *   (result[value] || (result[value] = [])).push(key);
   *   return result;
   * }, {}, { 'a': 1, 'b': 2, 'c': 1 });
   * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
   */


  function reduce(iteratee, accumulator, collection) {
    if (isNil(collection)) {
      return accumulator;
    }

    const func = isArray(collection) ? arrayReduce : baseReduce;
    return func(castFunction(iteratee), accumulator, collection);
  }

  /**
   *
   * @param {Object<any,any>} obj
   * @return {Array<any>}
   */
  function values(obj) {
    if (obj === null || typeof obj !== "object") {
      return [];
    }

    return Object.keys(obj).map(key => obj[key]);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  /* eslint-disable import/prefer-default-export */
  const DECISIONING_METHOD = {
    ON_DEVICE: "on-device",
    SERVER_SIDE: "server-side",
    HYBRID: "hybrid"
  };
  const EXECUTION_MODE = {
    EDGE: "edge",
    LOCAL: "local"
  };

  /* eslint-disable import/prefer-default-export */
  const AT_PREFIX = "AT:";
  const NOOP_LOGGER = {
    // eslint-disable-next-line no-unused-vars
    debug() {},

    // eslint-disable-next-line no-unused-vars
    error() {}

  };
  function getLogger() {
    let logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // don't do anything if the logger was previously built
    if (logger.built) {
      return logger;
    }

    const {
      debug,
      error
    } = logger;
    const targetLogger = reactorObjectAssign({
      built: true
    }, NOOP_LOGGER);

    if (isFunction(debug)) {
      targetLogger.debug = function () {
        for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
          messages[_key] = arguments[_key];
        }

        logger.debug.apply(null, [AT_PREFIX, ...messages]);
      };
    }

    if (isFunction(error)) {
      targetLogger.error = function () {
        for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          messages[_key2] = arguments[_key2];
        }

        logger.error.apply(null, [AT_PREFIX, ...messages]);
      };
    }

    return targetLogger;
  }

  /* eslint-disable import/prefer-default-export */
  const ATTRIBUTE_NOT_EXIST = (keyName, mboxName) => `Attribute '${keyName}' does not exist for mbox '${mboxName}'`;
  const DECISIONING_ENGINE_NOT_READY = "Unable to fulfill request; decisioning engine not ready.";
  const PROPERTY_TOKEN_MISMATCH = (requestProperty, configProperty) => `The property token specified in the request "${requestProperty}" does not match the one specified in the config "${configProperty}".`;
  const NOTIFICATIONS_REQUIRED = "Notifications array is required in request";

  /* eslint-disable import/prefer-default-export */
  const DEFAULT_GLOBAL_MBOX = "target-global-mbox";
  const DEFAULT_NUM_FETCH_RETRIES = 10;

  /**
   *
   * @type {{Web: string, Mobile: string}}
   */

  const ChannelType = {
    Mobile: "mobile",
    Web: "web"
  };
  /**
   *
   * @type {{Click: string, Display: string}}
   */

  const MetricType = {
    Click: "click",
    Display: "display"
  };
  /**
   *
   * @type {{Authenticated: string, Unknown: string, LoggedOut: string}}
   */

  const AuthenticatedState = {
    Unknown: "unknown",
    Authenticated: "authenticated",
    LoggedOut: "logged_out"
  };
  const EMPTY_REQUEST = {
    context: {
      channel: ChannelType.Web
    }
  };
  const ENVIRONMENT_PROD = "production";
  const UNKNOWN_IP_ADDRESS = "unknownIpAddress";

  const VIEWS = "views";
  const MBOXES = "mboxes";
  function isUndefined(value) {
    return typeof value === "undefined";
  }
  function isDefined(value) {
    return !isUndefined(value);
  }
  function isPojo(obj) {
    if (isUndefined(obj) || obj === null || !isObject(obj)) {
      return false;
    }

    return Object.getPrototypeOf(obj) === Object.prototype;
  }
  /**
   *
   * @param {"mboxes"|"views"} itemsKey
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest Target Delivery API request
   * @returns {Set<String>} Set of names
   */

  function getNamesForRequested(itemsKey, deliveryRequest) {
    const resultSet = new Set();
    ["prefetch", "execute"].forEach(type => {
      if (!deliveryRequest || !deliveryRequest[type]) {
        return;
      }

      const items = deliveryRequest[type][itemsKey] instanceof Array ? deliveryRequest[type][itemsKey] : [];
      items.filter(item => isDefined(item.name)).forEach(item => {
        resultSet.add(item.name);
      });
    });
    return resultSet;
  }
  /**
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest Target Delivery API request, required
   * @returns {Set<String>} Set of mbox names
   */


  function getMboxNames(deliveryRequest) {
    return getNamesForRequested(MBOXES, deliveryRequest);
  }
  /**
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest Target Delivery API request, required
   * @returns {Set<String>} Set of view names
   */

  function getViewNames(deliveryRequest) {
    return getNamesForRequested(VIEWS, deliveryRequest);
  }
  /**
   * @param {"mboxes"|"views"} itemsKey
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest Target Delivery API request, required
   * @returns {boolean}
   */

  function hasRequested(itemsKey, deliveryRequest) {
    const types = ["prefetch", "execute"];

    for (let i = 0; i < types.length; i += 1) {
      const type = types[i];
      const items = deliveryRequest && deliveryRequest[type] && deliveryRequest[type][itemsKey] instanceof Array ? deliveryRequest[type][itemsKey] : undefined;

      if (isDefined(items) && items instanceof Array) {
        return true;
      }
    }

    return false;
  }
  /**
   *
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest Target Delivery API request, required
   * @returns {boolean}
   */


  function hasRequestedViews(deliveryRequest) {
    return hasRequested(VIEWS, deliveryRequest);
  }
  /**
   * addMboxesToRequest method.  Ensures the mboxes specified are part of the returned delivery request
   * @param {Array<String>} mboxNames A list of mbox names that contains JSON content attributes, required
   * @param {import("../delivery-api-client/models/DeliveryRequest").DeliveryRequest} request Target View Delivery API request, required
   * @param { 'execute'|'prefetch' } requestType
   */

  function addMboxesToRequest(mboxNames, request) {
    let requestType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "execute";
    const requestedMboxes = getMboxNames(request); // returns a set

    const mboxes = [];

    if (request && request[requestType] && request[requestType].mboxes instanceof Array) {
      Array.prototype.push.apply(mboxes, request[requestType].mboxes);
    }

    const highestUserSpecifiedIndex = mboxes.reduce((highest, mbox) => Math.max(highest, isNumber(mbox.index) ? mbox.index : 0), 0);
    let nextIndex = highestUserSpecifiedIndex + 1;
    mboxNames.filter(mboxName => !requestedMboxes.has(mboxName)).forEach(mboxName => {
      mboxes.push({
        name: mboxName,
        index: nextIndex
      });
      nextIndex += 1;
    });

    const result = _objectSpread2({}, request);

    result[requestType] = _objectSpread2(_objectSpread2({}, request[requestType]), {}, {
      mboxes
    });
    return result;
  }
  function isBrowser() {
    return typeof window !== "undefined";
  }
  function isNodeJS() {
    return typeof __webpack_require__.g !== "undefined";
  }
  const noop = () => undefined;
  const noopPromise = value => Promise.resolve(value);
  function requiresDecisioningEngine(decisioningMethod) {
    return includes(decisioningMethod, [DECISIONING_METHOD.ON_DEVICE, DECISIONING_METHOD.HYBRID]);
  }
  function decisioningEngineReady(decisioningEngine) {
    return isDefined(decisioningEngine) && decisioningEngine.isReady();
  }
  function objectWithoutUndefinedValues(obj) {
    const result = _objectSpread2({}, obj);

    Object.keys(result).forEach(key => {
      if (isUndefined(result[key])) {
        delete result[key];
      }
    });
    return result;
  }
  /**
   *
   * @param { import("../delivery-api-client/models/Property").Property } property
   */

  function getPropertyToken() {
    let property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      token: undefined
    };
    const {
      token = undefined
    } = property;
    return token;
  }
  function getProperty() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let logger = arguments.length > 2 ? arguments[2] : undefined;
    const configPropertyToken = config.propertyToken;
    const requestPropertyToken = getPropertyToken(request.property);
    const propertyToken = requestPropertyToken || configPropertyToken;

    if (isDefined(requestPropertyToken) && requestPropertyToken !== configPropertyToken) {
      getLogger(logger).debug(PROPERTY_TOKEN_MISMATCH(requestPropertyToken, configPropertyToken));
    }

    return propertyToken ? {
      token: propertyToken
    } : undefined;
  }
  function isValidIpAddress(ipAddress) {
    const IP_ADDRESS = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/g;
    return isString(ipAddress) && IP_ADDRESS.test(ipAddress);
  }
  function memoize(func) {
    let keyResolverFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : arr => arr[0];
    const memoizedValues = {};
    return function memoized() {
      for (var _len = arguments.length, funcArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        funcArgs[_key] = arguments[_key];
      }

      const key = keyResolverFunc.call(this, funcArgs);

      if (!isDefined(memoizedValues[key])) {
        memoizedValues[key] = func.call(null, ...funcArgs);
      }

      return memoizedValues[key];
    };
  }
  function isExecutePageLoad(request) {
    return !!request.execute && !!request.execute.pageLoad;
  }
  function executeMboxCount(request) {
    return !!request.execute && !!request.execute.mboxes && request.execute.mboxes.length || 0;
  }
  function isPrefetchPageLoad(request) {
    return !!request.prefetch && !!request.prefetch.pageLoad;
  }
  function prefetchMboxCount(request) {
    return !!request.prefetch && !!request.prefetch.mboxes && request.prefetch.mboxes.length || 0;
  }
  function prefetchViewCount(request) {
    return !!request.prefetch && !!request.prefetch.views && request.prefetch.views.length || 0;
  }
  function formatDecimal(value) {
    let digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if (!value || !isNumber(value)) {
      return undefined;
    }

    return +value.toFixed(digits);
  }

  const NOT_MODIFIED = 304;
  function getFetchApi(fetchApi) {
    if (isFunction(fetchApi)) {
      return fetchApi;
    }

    let api;

    if (isNodeJS() && typeof __webpack_require__.g.fetch === "function") {
      api = __webpack_require__.g.fetch;
    } else if (isBrowser() && // eslint-disable-next-line no-undef
    typeof window.fetch === "function") {
      // eslint-disable-next-line no-undef
      api = window.fetch.bind(window);
    }

    return api;
  }
  function getFetchWithRetry(fetchApi) {
    let maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_NUM_FETCH_RETRIES;
    let errorFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : errorMessage => errorMessage;
    let incidentalFailureCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    return function fetchWithRetry(url, options) {
      let numRetries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : maxRetries;
      return fetchApi(url, options).then(res => {
        if (!res.ok && res.status !== NOT_MODIFIED) {
          throw Error(res.statusText);
        }

        return res;
      }).catch(err => {
        if (isFunction(incidentalFailureCallback)) {
          incidentalFailureCallback.call(undefined, err);
        }

        if (numRetries < 1) {
          throw new Error(errorFunc(err.message));
        } // TODO: Enhance this to do Exponential Backoff


        return fetchWithRetry(url, options, numRetries - 1);
      });
    };
  }

  /**
   * @param {import("../delivery-api-client/models/DeliveryResponse").DeliveryResponse} response
   */

  function createIndexed(response) {
    const result = {};
    ["prefetch", "execute"].forEach(requestType => {
      if (isDefined(response[requestType]) && isDefined(response[requestType].mboxes) && response[requestType].mboxes instanceof Array) {
        response[requestType].mboxes.forEach(mbox => {
          const {
            name,
            options = []
          } = mbox;
          options.forEach(option => {
            const {
              type,
              content
            } = option;

            if (type === "json" && isDefined(content)) {
              result[name] = reactorObjectAssign({}, result[name], content);
            }
          });
        });
      }
    });
    return result;
  }
  /**
   * @param { TargetDeliveryResponse } offersResponse
   */


  function AttributesProvider(offersResponse) {
    const indexed = createIndexed(offersResponse.response);

    function getValue(mboxName, key) {
      if (!Object.prototype.hasOwnProperty.call(indexed, mboxName) || !Object.prototype.hasOwnProperty.call(indexed[mboxName], key)) {
        return new Error(ATTRIBUTE_NOT_EXIST(key, mboxName));
      }

      return indexed[mboxName][key];
    }
    /**
     * @param {string} mboxName
     */


    function getAsObject(mboxName) {
      if (isUndefined(mboxName)) {
        return _objectSpread2({}, indexed);
      }

      return _objectSpread2({}, indexed[mboxName]);
    }

    return {
      getValue: (mboxName, key) => getValue(mboxName, key),
      asObject: mboxName => getAsObject(mboxName),
      toJSON: () => getAsObject(undefined),
      getResponse: () => offersResponse
    };
  }

  /* eslint-disable import/prefer-default-export */

  function TargetEvent(type) {
    let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.type = type;
    Object.keys(payload).forEach(key => {
      this[key] = payload[key];
    });
  }
  /**
   *
   * @param {Object.<String, Function>} events
   */


  function EventProvider() {
    let events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const subscriptions = {};
    let subscriptionCount = 0;
    /**
     *
     * @param {String} eventName
     * @param {Function} callbackFunc
     * @return {string}
     */

    function subscribe(eventName, callbackFunc) {
      subscriptionCount += 1;

      if (isUndefined(subscriptions[eventName])) {
        subscriptions[eventName] = {};
      }

      subscriptions[eventName][subscriptionCount] = callbackFunc;
      return `${eventName}:${subscriptionCount}`;
    }
    /**
     *
     * @param {String} id
     */


    function unsubscribe(id) {
      const [eventName, eventId] = id.split(":");

      if (isDefined(subscriptions[eventName])) {
        delete subscriptions[eventName][eventId];
      }
    }
    /**
     *
     * @param {String} eventName
     * @param {Object} payload
     */


    function emit(eventName) {
      let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const subscribed = subscriptions[eventName] || [];
      values(subscribed).forEach(subscriber => subscriber.call(undefined, new TargetEvent(eventName, payload)));
    }

    Object.keys(events).forEach(eventName => subscribe(eventName, events[eventName]));
    return {
      subscribe,
      unsubscribe,
      emit
    };
  }

  /*
  Copyright 2021 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  function InMemoryTelemetryStore() {
    let telemetryEntries = [];

    function addEntry(entry) {
      telemetryEntries.push(entry);
    }

    function getAndClearEntries() {
      const allEntries = telemetryEntries;
      telemetryEntries = [];
      return allEntries;
    }

    function hasEntries() {
      return telemetryEntries.length > 0;
    }

    return {
      addEntry,
      getAndClearEntries,
      hasEntries
    };
  }

  /* eslint-disable import/prefer-default-export */
  /**
   * The get TelemetryProvider initialization method
   * @param {Boolean} telemetryEnabled whether or not the SDK will collect telemetry data - default: true, optional
   * @param {String} method offer decisioning method that was configured during TargetClient.create() - default: server-side, optional
   * @param {Function} telemetryStore data store for collected telemetry - default: InMemoryTelemetryStore, optional
   */

  function TelemetryProvider() {
    let telemetryEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DECISIONING_METHOD.SERVER_SIDE;
    let telemetryStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : InMemoryTelemetryStore();

    function getMode(response) {
      return response.edgeHost ? EXECUTION_MODE.EDGE : EXECUTION_MODE.LOCAL;
    }

    function getFeatures(request) {
      const features = {};
      const executePageLoad = isExecutePageLoad(request);
      const executeMbox = executeMboxCount(request);
      const prefetchPageLoad = isPrefetchPageLoad(request);
      const prefetchMbox = prefetchMboxCount(request);
      const prefetchView = prefetchViewCount(request);

      if (executePageLoad) {
        features.executePageLoad = executePageLoad;
      }

      if (executeMbox) {
        features.executeMboxCount = executeMbox;
      }

      if (prefetchPageLoad) {
        features.prefetchPageLoad = prefetchPageLoad;
      }

      if (prefetchMbox) {
        features.prefetchMboxCount = prefetchMbox;
      }

      if (prefetchView) {
        features.prefetchViewCount = prefetchView;
      }

      return features;
    }

    function normalizeEntryRequest(entryRequest) {
      const normalized = {};

      if (entryRequest.dns) {
        normalized.dns = formatDecimal(entryRequest.dns);
      }

      if (entryRequest.tls) {
        normalized.tls = formatDecimal(entryRequest.tls);
      }

      if (entryRequest.timeToFirstByte) {
        normalized.timeToFirstByte = formatDecimal(entryRequest.timeToFirstByte);
      }

      if (entryRequest.download) {
        normalized.download = formatDecimal(entryRequest.download);
      }

      if (entryRequest.responseSize) {
        normalized.responseSize = formatDecimal(entryRequest.responseSize);
      }

      return normalized;
    }

    function normalizeEntry(entry) {
      const normalized = {};

      if (entry.execution) {
        normalized.execution = formatDecimal(entry.execution);
      }

      if (entry.parsing) {
        normalized.parsing = formatDecimal(entry.parsing);
      }

      if (entry.request) {
        normalized.request = normalizeEntryRequest(entry.request);
      }

      return reactorObjectAssign(entry, normalized);
    }

    function normalizeAndAddEntry(entry) {
      telemetryStore.addEntry(normalizeEntry(entry));
    }

    function addServerStateEntry(request) {
      if (!telemetryEnabled) {
        return;
      }

      normalizeAndAddEntry({
        requestId: request.requestId,
        timestamp: now()
      });
    }

    function addRenderEntry(renderId, execution) {
      if (!telemetryEnabled) {
        return;
      }

      normalizeAndAddEntry({
        requestId: renderId,
        timestamp: now(),
        execution
      });
    }

    function addRequestEntry(requestId, entry) {
      const requestEntry = reactorObjectAssign(entry, {
        requestId,
        timestamp: now()
      });
      normalizeAndAddEntry(requestEntry);
    }
    /**
     * @param requestId
     * @param {import("@adobe/target-tools/delivery-api-client/models/TelemetryEntry").TelemetryEntry} entry
     */


    function addArtifactRequestEntry(requestId, entry) {
      if (!telemetryEnabled || !entry) {
        return;
      }

      addRequestEntry(requestId, entry);
    }
    /**
     * @param request
     * @param {import("@adobe/target-tools/delivery-api-client/models/TelemetryEntry").TelemetryEntry} entry
     * @param response
     * @param decisioningMethod
     */


    function addDeliveryRequestEntry(request, entry, response) {
      let decisioningMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : method;

      if (!telemetryEnabled || !entry) {
        return;
      }

      const {
        requestId
      } = request;
      const features = reactorObjectAssign(getFeatures(request), {
        decisioningMethod
      });
      const baseEntry = {
        mode: getMode(response),
        features
      };
      const deliveryRequestEntry = reactorObjectAssign(entry, baseEntry);
      addRequestEntry(requestId, deliveryRequestEntry);
    }

    function getAndClearEntries() {
      return telemetryStore.getAndClearEntries();
    }

    function hasEntries() {
      return telemetryStore.hasEntries();
    }

    function addTelemetryToDeliveryRequest(deliveryRequest) {
      if (hasEntries()) {
        return reactorObjectAssign(deliveryRequest, {
          telemetry: {
            entries: getAndClearEntries()
          }
        });
      }

      return deliveryRequest;
    }

    return {
      addDeliveryRequestEntry,
      addArtifactRequestEntry,
      addRenderEntry,
      addServerStateEntry,
      getAndClearEntries,
      hasEntries,
      addTelemetryToDeliveryRequest
    };
  }

  const UNKNOWN = "unknown";

  const withVersion = (matcher, matches) => {
    const version = (matches && matches.length > matcher.versionGroupIndex ? matches[matcher.versionGroupIndex] : matcher.version) || "-1";
    const majorVersion = typeof version === "string" ? parseInt(version.split(".")[0], 10) : -1;
    return {
      name: matcher.name,
      version: majorVersion
    };
  };
  /**
   *
   * @param {Array<Object>} matchersList
   */


  function matchUserAgent(matchersList, processFunc) {
    // eslint-disable-next-line no-param-reassign
    processFunc = typeof processFunc === "function" ? processFunc : matcher => matcher.name;
    return function checkMatches(userAgent) {
      for (let i = 0; i < matchersList.length; i += 1) {
        const matcher = matchersList[i];
        const matches = userAgent.match(matcher.regex);

        if (matches) {
          return processFunc(matcher, matches);
        }
      }

      return processFunc({
        name: UNKNOWN
      });
    };
  }
  /**
   *
   * @param {string} userAgent
   * @return {{name: string, version: number}}
   */


  const browserFromUserAgent = function () {
    let userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return matchUserAgent([{
      name: "Edge",
      regex: /(edge|edgios|edga|edg)\/((\d+)?[\w.]+)/i,
      versionGroupIndex: 2
    }, {
      name: "Mobile Safari",
      regex: /version\/([\w.]+).+?mobile\/\w+\s(safari)/i,
      versionGroupIndex: 1
    }, {
      name: "Safari",
      regex: /version\/([\w.]+).+?(mobile\s?safari|safari)/i,
      versionGroupIndex: 1
    }, {
      name: "Chrome",
      regex: /(chrome)\/v?([\w.]+)/i,
      versionGroupIndex: 2
    }, {
      name: "Firefox",
      regex: /(firefox)\/([\w.-]+)$/i,
      versionGroupIndex: 2
    }, {
      name: "IE",
      regex: /(?:ms|\()(ie)\s([\w.]+)/i,
      versionGroupIndex: 2
    }, {
      name: "IE",
      regex: /(trident).+rv[:\s]([\w.]+).+like\sgecko/i,
      versionGroupIndex: 2,
      version: 11
    }], withVersion)(userAgent);
  };
  /**
   *
   * @param {string} userAgent
   * @return {string}
   */

  const operatingSystemFromUserAgent = userAgent => matchUserAgent([{
    name: "iOS",
    regex: /iPhone|iPad|iPod/
  }, {
    name: "Android",
    regex: /Android [0-9.]+;/
  }, {
    name: "Linux",
    regex: / Linux /
  }, {
    name: "Unix",
    regex: /FreeBSD|OpenBSD|CrOS/
  }, {
    name: "Windows",
    regex: /[( ]Windows /
  }, {
    name: "Mac OS",
    regex: /Macintosh;/
  }])(userAgent);
  /**
   *
   * @param {string} browserUAWithVersion Sec-CH-UA or Sec-CH-UA-Full-Version-List
   * @return {{name: string, version: number}}
   */

  const browserFromClientHintsUA = function () {
    let browserUAWithVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return matchUserAgent([{
      name: "Chrome",
      versionGroupIndex: 1,
      regex: /Chrome";v="([0-9.]+)"/i
    }, {
      name: "Edge",
      versionGroupIndex: 1,
      regex: /Edge";v="([0-9.]+)"/i
    }, {
      name: "Safari",
      versionGroupIndex: 1,
      regex: /Safari";v="([0-9.]+)"/i
    }, {
      name: "Firefox",
      versionGroupIndex: 1,
      regex: /Firefox";v="([0-9.]+)"/i
    }], withVersion)(browserUAWithVersion);
  };
  /**
   *
   * @param {string} userAgent
   * @param {import("../delivery-api-client/models/ClientHints").ClientHints} clientHints
   * @return {{name: string, version: number}}
   */

  const browserFromUserAgentOrClientHintUA = function () {
    let userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    let clientHints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      browserUAWithFullVersion,
      browserUAWithMajorVersion
    } = clientHints;
    return reduce((accumulated, current) => ({
      name: current.name !== UNKNOWN ? current.name : accumulated.name,
      version: current.version >= 0 ? current.version : accumulated.version
    }), {
      name: UNKNOWN,
      version: -1
    }, [browserFromUserAgent(userAgent), browserFromClientHintsUA(browserUAWithFullVersion || browserUAWithMajorVersion)]);
  };
  /**
   *
   * @param {string} userAgent
   * @param {import("../delivery-api-client/models/ClientHints").ClientHints} clientHints
   * @return {string}
   */

  const operatingSystemFromUserAgentOrClientHints = function (userAgent) {
    let clientHints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      platform
    } = clientHints;
    return isDefined(platform) ? platform : operatingSystemFromUserAgent(userAgent);
  };

  /* eslint-disable no-bitwise */

  function mul32(m, n) {
    const nlo = n & 0xffff;
    const nhi = n - nlo;
    return (nhi * m | 0) + (nlo * m | 0) | 0;
  }
  /**
   * Optimized MurmurHash3 (32-bit) hashing algorithm to generate a signed numeric 10-digit hash
   * This method matches the java method used on Target Edge
   * @param stringValue
   * @param seed
   * @returns {number}
   */


  function hashUnencodedCharsRaw(stringValue) {
    let seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let k1;
    const len = stringValue.length;
    const c1 = 0xcc9e2d51;
    const c2 = 0x1b873593;
    let h1 = seed;
    const roundedEnd = len & ~0x1;

    for (let i = 0; i < roundedEnd; i += 2) {
      k1 = stringValue.charCodeAt(i) | stringValue.charCodeAt(i + 1) << 16;
      k1 = mul32(k1, c1);
      k1 = (k1 & 0x1ffff) << 15 | k1 >>> 17; // ROTL32(k1,15);

      k1 = mul32(k1, c2);
      h1 ^= k1;
      h1 = (h1 & 0x7ffff) << 13 | h1 >>> 19; // ROTL32(h1,13);

      h1 = h1 * 5 + 0xe6546b64 | 0;
    }

    if (len % 2 === 1) {
      k1 = stringValue.charCodeAt(roundedEnd);
      k1 = mul32(k1, c1);
      k1 = (k1 & 0x1ffff) << 15 | k1 >>> 17; // ROTL32(k1,15);

      k1 = mul32(k1, c2);
      h1 ^= k1;
    } // finalization


    h1 ^= len << 1; // fmix(h1);

    h1 ^= h1 >>> 16;
    h1 = mul32(h1, 0x85ebca6b);
    h1 ^= h1 >>> 13;
    h1 = mul32(h1, 0xc2b2ae35);
    h1 ^= h1 >>> 16;
    return h1;
  }

  const hashUnencodedChars = memoize(hashUnencodedCharsRaw, arr => arr.join("-"));

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  function getCjsExportFromNamespace (n) {
  	return n && n['default'] || n;
  }

  var performanceNow = createCommonjsModule(function (module) {
    // Generated by CoffeeScript 1.12.2
    (function () {
      var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

      if (typeof performance !== "undefined" && performance !== null && performance.now) {
        module.exports = function () {
          return performance.now();
        };
      } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function () {
          return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };

        hrtime = process.hrtime;

        getNanoSeconds = function () {
          var hr;
          hr = hrtime();
          return hr[0] * 1e9 + hr[1];
        };

        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
      } else if (Date.now) {
        module.exports = function () {
          return Date.now() - loadTime;
        };

        loadTime = Date.now();
      } else {
        module.exports = function () {
          return new Date().getTime() - loadTime;
        };

        loadTime = new Date().getTime();
      }
    }).call(commonjsGlobal);
  });

  /* eslint-disable import/prefer-default-export */
  function createPerfToolInstance() {
    let timingIds = {};
    let startTimes = {};
    let timings = {};
    /**
     * getUniqueTimingId
     * @param {string} id
     * @return {string}
     */

    function getUniqueTimingId(id) {
      const count = (isDefined(timingIds[id]) ? timingIds[id] : 0) + 1;
      timingIds[id] = count;
      return `${id}${count}`;
    }
    /**
     * timeStart
     * @param {string} id
     * @param {boolean} incrementTimer
     * @return {string}
     */


    function timeStart(id) {
      let incrementTimer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const timingId = incrementTimer ? getUniqueTimingId(id) : id;

      if (isUndefined(startTimes[timingId])) {
        startTimes[timingId] = performanceNow();
      }

      return timingId;
    }
    /**
     * timeEnd
     * @param {string} id
     * @param {number} offset
     * @return {number}
     */


    function timeEnd(id) {
      let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (isUndefined(startTimes[id])) {
        return -1;
      }

      const timing = performanceNow() - startTimes[id] - offset;
      timings[id] = timing;
      return timing;
    }

    function clearTiming(id) {
      delete timingIds[id];
      delete startTimes[id];
      delete timings[id];
    }

    function reset() {
      timingIds = {};
      startTimes = {};
      timings = {};
    }

    return {
      timeStart,
      timeEnd,
      getTimings: () => timings,
      getTiming: key => timings[key],
      clearTiming,
      reset
    };
  }
  const perfTool = createPerfToolInstance();

  var src = function (str) {
    let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!str) return undefined;
    const o = {
      key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
      q: {
        name: 'queryKey',
        parser: /(?:^|&)([^&=]*)=?([^&]*)/g
      },
      parser: {
        strict: /^(?:([^:/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?))?((((?:[^?#/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@/]*@)([^:/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#/]*\.[^?#/.]+(?:[?#]|$)))*\/?)?([^?#/]*))(?:\?([^#]*))?(?:#(.*))?)/
      }
    };
    const m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
    const uri = {};
    let i = 14;

    while (i--) uri[o.key[i]] = m[i] || '';

    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
      if ($1) uri[o.q.name][$1] = $2;
    });
    return uri;
  };

  var rules = [
  	"ac",
  	"com.ac",
  	"edu.ac",
  	"gov.ac",
  	"net.ac",
  	"mil.ac",
  	"org.ac",
  	"ad",
  	"nom.ad",
  	"ae",
  	"co.ae",
  	"net.ae",
  	"org.ae",
  	"sch.ae",
  	"ac.ae",
  	"gov.ae",
  	"mil.ae",
  	"aero",
  	"accident-investigation.aero",
  	"accident-prevention.aero",
  	"aerobatic.aero",
  	"aeroclub.aero",
  	"aerodrome.aero",
  	"agents.aero",
  	"aircraft.aero",
  	"airline.aero",
  	"airport.aero",
  	"air-surveillance.aero",
  	"airtraffic.aero",
  	"air-traffic-control.aero",
  	"ambulance.aero",
  	"amusement.aero",
  	"association.aero",
  	"author.aero",
  	"ballooning.aero",
  	"broker.aero",
  	"caa.aero",
  	"cargo.aero",
  	"catering.aero",
  	"certification.aero",
  	"championship.aero",
  	"charter.aero",
  	"civilaviation.aero",
  	"club.aero",
  	"conference.aero",
  	"consultant.aero",
  	"consulting.aero",
  	"control.aero",
  	"council.aero",
  	"crew.aero",
  	"design.aero",
  	"dgca.aero",
  	"educator.aero",
  	"emergency.aero",
  	"engine.aero",
  	"engineer.aero",
  	"entertainment.aero",
  	"equipment.aero",
  	"exchange.aero",
  	"express.aero",
  	"federation.aero",
  	"flight.aero",
  	"fuel.aero",
  	"gliding.aero",
  	"government.aero",
  	"groundhandling.aero",
  	"group.aero",
  	"hanggliding.aero",
  	"homebuilt.aero",
  	"insurance.aero",
  	"journal.aero",
  	"journalist.aero",
  	"leasing.aero",
  	"logistics.aero",
  	"magazine.aero",
  	"maintenance.aero",
  	"media.aero",
  	"microlight.aero",
  	"modelling.aero",
  	"navigation.aero",
  	"parachuting.aero",
  	"paragliding.aero",
  	"passenger-association.aero",
  	"pilot.aero",
  	"press.aero",
  	"production.aero",
  	"recreation.aero",
  	"repbody.aero",
  	"res.aero",
  	"research.aero",
  	"rotorcraft.aero",
  	"safety.aero",
  	"scientist.aero",
  	"services.aero",
  	"show.aero",
  	"skydiving.aero",
  	"software.aero",
  	"student.aero",
  	"trader.aero",
  	"trading.aero",
  	"trainer.aero",
  	"union.aero",
  	"workinggroup.aero",
  	"works.aero",
  	"af",
  	"gov.af",
  	"com.af",
  	"org.af",
  	"net.af",
  	"edu.af",
  	"ag",
  	"com.ag",
  	"org.ag",
  	"net.ag",
  	"co.ag",
  	"nom.ag",
  	"ai",
  	"off.ai",
  	"com.ai",
  	"net.ai",
  	"org.ai",
  	"al",
  	"com.al",
  	"edu.al",
  	"gov.al",
  	"mil.al",
  	"net.al",
  	"org.al",
  	"am",
  	"co.am",
  	"com.am",
  	"commune.am",
  	"net.am",
  	"org.am",
  	"ao",
  	"ed.ao",
  	"gv.ao",
  	"og.ao",
  	"co.ao",
  	"pb.ao",
  	"it.ao",
  	"aq",
  	"ar",
  	"bet.ar",
  	"com.ar",
  	"coop.ar",
  	"edu.ar",
  	"gob.ar",
  	"gov.ar",
  	"int.ar",
  	"mil.ar",
  	"musica.ar",
  	"mutual.ar",
  	"net.ar",
  	"org.ar",
  	"senasa.ar",
  	"tur.ar",
  	"arpa",
  	"e164.arpa",
  	"in-addr.arpa",
  	"ip6.arpa",
  	"iris.arpa",
  	"uri.arpa",
  	"urn.arpa",
  	"as",
  	"gov.as",
  	"asia",
  	"at",
  	"ac.at",
  	"co.at",
  	"gv.at",
  	"or.at",
  	"sth.ac.at",
  	"au",
  	"com.au",
  	"net.au",
  	"org.au",
  	"edu.au",
  	"gov.au",
  	"asn.au",
  	"id.au",
  	"info.au",
  	"conf.au",
  	"oz.au",
  	"act.au",
  	"nsw.au",
  	"nt.au",
  	"qld.au",
  	"sa.au",
  	"tas.au",
  	"vic.au",
  	"wa.au",
  	"act.edu.au",
  	"catholic.edu.au",
  	"nsw.edu.au",
  	"nt.edu.au",
  	"qld.edu.au",
  	"sa.edu.au",
  	"tas.edu.au",
  	"vic.edu.au",
  	"wa.edu.au",
  	"qld.gov.au",
  	"sa.gov.au",
  	"tas.gov.au",
  	"vic.gov.au",
  	"wa.gov.au",
  	"schools.nsw.edu.au",
  	"aw",
  	"com.aw",
  	"ax",
  	"az",
  	"com.az",
  	"net.az",
  	"int.az",
  	"gov.az",
  	"org.az",
  	"edu.az",
  	"info.az",
  	"pp.az",
  	"mil.az",
  	"name.az",
  	"pro.az",
  	"biz.az",
  	"ba",
  	"com.ba",
  	"edu.ba",
  	"gov.ba",
  	"mil.ba",
  	"net.ba",
  	"org.ba",
  	"bb",
  	"biz.bb",
  	"co.bb",
  	"com.bb",
  	"edu.bb",
  	"gov.bb",
  	"info.bb",
  	"net.bb",
  	"org.bb",
  	"store.bb",
  	"tv.bb",
  	"*.bd",
  	"be",
  	"ac.be",
  	"bf",
  	"gov.bf",
  	"bg",
  	"a.bg",
  	"b.bg",
  	"c.bg",
  	"d.bg",
  	"e.bg",
  	"f.bg",
  	"g.bg",
  	"h.bg",
  	"i.bg",
  	"j.bg",
  	"k.bg",
  	"l.bg",
  	"m.bg",
  	"n.bg",
  	"o.bg",
  	"p.bg",
  	"q.bg",
  	"r.bg",
  	"s.bg",
  	"t.bg",
  	"u.bg",
  	"v.bg",
  	"w.bg",
  	"x.bg",
  	"y.bg",
  	"z.bg",
  	"0.bg",
  	"1.bg",
  	"2.bg",
  	"3.bg",
  	"4.bg",
  	"5.bg",
  	"6.bg",
  	"7.bg",
  	"8.bg",
  	"9.bg",
  	"bh",
  	"com.bh",
  	"edu.bh",
  	"net.bh",
  	"org.bh",
  	"gov.bh",
  	"bi",
  	"co.bi",
  	"com.bi",
  	"edu.bi",
  	"or.bi",
  	"org.bi",
  	"biz",
  	"bj",
  	"asso.bj",
  	"barreau.bj",
  	"gouv.bj",
  	"bm",
  	"com.bm",
  	"edu.bm",
  	"gov.bm",
  	"net.bm",
  	"org.bm",
  	"bn",
  	"com.bn",
  	"edu.bn",
  	"gov.bn",
  	"net.bn",
  	"org.bn",
  	"bo",
  	"com.bo",
  	"edu.bo",
  	"gob.bo",
  	"int.bo",
  	"org.bo",
  	"net.bo",
  	"mil.bo",
  	"tv.bo",
  	"web.bo",
  	"academia.bo",
  	"agro.bo",
  	"arte.bo",
  	"blog.bo",
  	"bolivia.bo",
  	"ciencia.bo",
  	"cooperativa.bo",
  	"democracia.bo",
  	"deporte.bo",
  	"ecologia.bo",
  	"economia.bo",
  	"empresa.bo",
  	"indigena.bo",
  	"industria.bo",
  	"info.bo",
  	"medicina.bo",
  	"movimiento.bo",
  	"musica.bo",
  	"natural.bo",
  	"nombre.bo",
  	"noticias.bo",
  	"patria.bo",
  	"politica.bo",
  	"profesional.bo",
  	"plurinacional.bo",
  	"pueblo.bo",
  	"revista.bo",
  	"salud.bo",
  	"tecnologia.bo",
  	"tksat.bo",
  	"transporte.bo",
  	"wiki.bo",
  	"br",
  	"9guacu.br",
  	"abc.br",
  	"adm.br",
  	"adv.br",
  	"agr.br",
  	"aju.br",
  	"am.br",
  	"anani.br",
  	"aparecida.br",
  	"app.br",
  	"arq.br",
  	"art.br",
  	"ato.br",
  	"b.br",
  	"barueri.br",
  	"belem.br",
  	"bhz.br",
  	"bib.br",
  	"bio.br",
  	"blog.br",
  	"bmd.br",
  	"boavista.br",
  	"bsb.br",
  	"campinagrande.br",
  	"campinas.br",
  	"caxias.br",
  	"cim.br",
  	"cng.br",
  	"cnt.br",
  	"com.br",
  	"contagem.br",
  	"coop.br",
  	"coz.br",
  	"cri.br",
  	"cuiaba.br",
  	"curitiba.br",
  	"def.br",
  	"des.br",
  	"det.br",
  	"dev.br",
  	"ecn.br",
  	"eco.br",
  	"edu.br",
  	"emp.br",
  	"enf.br",
  	"eng.br",
  	"esp.br",
  	"etc.br",
  	"eti.br",
  	"far.br",
  	"feira.br",
  	"flog.br",
  	"floripa.br",
  	"fm.br",
  	"fnd.br",
  	"fortal.br",
  	"fot.br",
  	"foz.br",
  	"fst.br",
  	"g12.br",
  	"geo.br",
  	"ggf.br",
  	"goiania.br",
  	"gov.br",
  	"ac.gov.br",
  	"al.gov.br",
  	"am.gov.br",
  	"ap.gov.br",
  	"ba.gov.br",
  	"ce.gov.br",
  	"df.gov.br",
  	"es.gov.br",
  	"go.gov.br",
  	"ma.gov.br",
  	"mg.gov.br",
  	"ms.gov.br",
  	"mt.gov.br",
  	"pa.gov.br",
  	"pb.gov.br",
  	"pe.gov.br",
  	"pi.gov.br",
  	"pr.gov.br",
  	"rj.gov.br",
  	"rn.gov.br",
  	"ro.gov.br",
  	"rr.gov.br",
  	"rs.gov.br",
  	"sc.gov.br",
  	"se.gov.br",
  	"sp.gov.br",
  	"to.gov.br",
  	"gru.br",
  	"imb.br",
  	"ind.br",
  	"inf.br",
  	"jab.br",
  	"jampa.br",
  	"jdf.br",
  	"joinville.br",
  	"jor.br",
  	"jus.br",
  	"leg.br",
  	"lel.br",
  	"log.br",
  	"londrina.br",
  	"macapa.br",
  	"maceio.br",
  	"manaus.br",
  	"maringa.br",
  	"mat.br",
  	"med.br",
  	"mil.br",
  	"morena.br",
  	"mp.br",
  	"mus.br",
  	"natal.br",
  	"net.br",
  	"niteroi.br",
  	"*.nom.br",
  	"not.br",
  	"ntr.br",
  	"odo.br",
  	"ong.br",
  	"org.br",
  	"osasco.br",
  	"palmas.br",
  	"poa.br",
  	"ppg.br",
  	"pro.br",
  	"psc.br",
  	"psi.br",
  	"pvh.br",
  	"qsl.br",
  	"radio.br",
  	"rec.br",
  	"recife.br",
  	"rep.br",
  	"ribeirao.br",
  	"rio.br",
  	"riobranco.br",
  	"riopreto.br",
  	"salvador.br",
  	"sampa.br",
  	"santamaria.br",
  	"santoandre.br",
  	"saobernardo.br",
  	"saogonca.br",
  	"seg.br",
  	"sjc.br",
  	"slg.br",
  	"slz.br",
  	"sorocaba.br",
  	"srv.br",
  	"taxi.br",
  	"tc.br",
  	"tec.br",
  	"teo.br",
  	"the.br",
  	"tmp.br",
  	"trd.br",
  	"tur.br",
  	"tv.br",
  	"udi.br",
  	"vet.br",
  	"vix.br",
  	"vlog.br",
  	"wiki.br",
  	"zlg.br",
  	"bs",
  	"com.bs",
  	"net.bs",
  	"org.bs",
  	"edu.bs",
  	"gov.bs",
  	"bt",
  	"com.bt",
  	"edu.bt",
  	"gov.bt",
  	"net.bt",
  	"org.bt",
  	"bv",
  	"bw",
  	"co.bw",
  	"org.bw",
  	"by",
  	"gov.by",
  	"mil.by",
  	"com.by",
  	"of.by",
  	"bz",
  	"com.bz",
  	"net.bz",
  	"org.bz",
  	"edu.bz",
  	"gov.bz",
  	"ca",
  	"ab.ca",
  	"bc.ca",
  	"mb.ca",
  	"nb.ca",
  	"nf.ca",
  	"nl.ca",
  	"ns.ca",
  	"nt.ca",
  	"nu.ca",
  	"on.ca",
  	"pe.ca",
  	"qc.ca",
  	"sk.ca",
  	"yk.ca",
  	"gc.ca",
  	"cat",
  	"cc",
  	"cd",
  	"gov.cd",
  	"cf",
  	"cg",
  	"ch",
  	"ci",
  	"org.ci",
  	"or.ci",
  	"com.ci",
  	"co.ci",
  	"edu.ci",
  	"ed.ci",
  	"ac.ci",
  	"net.ci",
  	"go.ci",
  	"asso.ci",
  	"aéroport.ci",
  	"int.ci",
  	"presse.ci",
  	"md.ci",
  	"gouv.ci",
  	"*.ck",
  	"!www.ck",
  	"cl",
  	"co.cl",
  	"gob.cl",
  	"gov.cl",
  	"mil.cl",
  	"cm",
  	"co.cm",
  	"com.cm",
  	"gov.cm",
  	"net.cm",
  	"cn",
  	"ac.cn",
  	"com.cn",
  	"edu.cn",
  	"gov.cn",
  	"net.cn",
  	"org.cn",
  	"mil.cn",
  	"公司.cn",
  	"网络.cn",
  	"網絡.cn",
  	"ah.cn",
  	"bj.cn",
  	"cq.cn",
  	"fj.cn",
  	"gd.cn",
  	"gs.cn",
  	"gz.cn",
  	"gx.cn",
  	"ha.cn",
  	"hb.cn",
  	"he.cn",
  	"hi.cn",
  	"hl.cn",
  	"hn.cn",
  	"jl.cn",
  	"js.cn",
  	"jx.cn",
  	"ln.cn",
  	"nm.cn",
  	"nx.cn",
  	"qh.cn",
  	"sc.cn",
  	"sd.cn",
  	"sh.cn",
  	"sn.cn",
  	"sx.cn",
  	"tj.cn",
  	"xj.cn",
  	"xz.cn",
  	"yn.cn",
  	"zj.cn",
  	"hk.cn",
  	"mo.cn",
  	"tw.cn",
  	"co",
  	"arts.co",
  	"com.co",
  	"edu.co",
  	"firm.co",
  	"gov.co",
  	"info.co",
  	"int.co",
  	"mil.co",
  	"net.co",
  	"nom.co",
  	"org.co",
  	"rec.co",
  	"web.co",
  	"com",
  	"coop",
  	"cr",
  	"ac.cr",
  	"co.cr",
  	"ed.cr",
  	"fi.cr",
  	"go.cr",
  	"or.cr",
  	"sa.cr",
  	"cu",
  	"com.cu",
  	"edu.cu",
  	"org.cu",
  	"net.cu",
  	"gov.cu",
  	"inf.cu",
  	"cv",
  	"com.cv",
  	"edu.cv",
  	"int.cv",
  	"nome.cv",
  	"org.cv",
  	"cw",
  	"com.cw",
  	"edu.cw",
  	"net.cw",
  	"org.cw",
  	"cx",
  	"gov.cx",
  	"cy",
  	"ac.cy",
  	"biz.cy",
  	"com.cy",
  	"ekloges.cy",
  	"gov.cy",
  	"ltd.cy",
  	"mil.cy",
  	"net.cy",
  	"org.cy",
  	"press.cy",
  	"pro.cy",
  	"tm.cy",
  	"cz",
  	"de",
  	"dj",
  	"dk",
  	"dm",
  	"com.dm",
  	"net.dm",
  	"org.dm",
  	"edu.dm",
  	"gov.dm",
  	"do",
  	"art.do",
  	"com.do",
  	"edu.do",
  	"gob.do",
  	"gov.do",
  	"mil.do",
  	"net.do",
  	"org.do",
  	"sld.do",
  	"web.do",
  	"dz",
  	"art.dz",
  	"asso.dz",
  	"com.dz",
  	"edu.dz",
  	"gov.dz",
  	"org.dz",
  	"net.dz",
  	"pol.dz",
  	"soc.dz",
  	"tm.dz",
  	"ec",
  	"com.ec",
  	"info.ec",
  	"net.ec",
  	"fin.ec",
  	"k12.ec",
  	"med.ec",
  	"pro.ec",
  	"org.ec",
  	"edu.ec",
  	"gov.ec",
  	"gob.ec",
  	"mil.ec",
  	"edu",
  	"ee",
  	"edu.ee",
  	"gov.ee",
  	"riik.ee",
  	"lib.ee",
  	"med.ee",
  	"com.ee",
  	"pri.ee",
  	"aip.ee",
  	"org.ee",
  	"fie.ee",
  	"eg",
  	"com.eg",
  	"edu.eg",
  	"eun.eg",
  	"gov.eg",
  	"mil.eg",
  	"name.eg",
  	"net.eg",
  	"org.eg",
  	"sci.eg",
  	"*.er",
  	"es",
  	"com.es",
  	"nom.es",
  	"org.es",
  	"gob.es",
  	"edu.es",
  	"et",
  	"com.et",
  	"gov.et",
  	"org.et",
  	"edu.et",
  	"biz.et",
  	"name.et",
  	"info.et",
  	"net.et",
  	"eu",
  	"fi",
  	"aland.fi",
  	"fj",
  	"ac.fj",
  	"biz.fj",
  	"com.fj",
  	"gov.fj",
  	"info.fj",
  	"mil.fj",
  	"name.fj",
  	"net.fj",
  	"org.fj",
  	"pro.fj",
  	"*.fk",
  	"com.fm",
  	"edu.fm",
  	"net.fm",
  	"org.fm",
  	"fm",
  	"fo",
  	"fr",
  	"asso.fr",
  	"com.fr",
  	"gouv.fr",
  	"nom.fr",
  	"prd.fr",
  	"tm.fr",
  	"aeroport.fr",
  	"avocat.fr",
  	"avoues.fr",
  	"cci.fr",
  	"chambagri.fr",
  	"chirurgiens-dentistes.fr",
  	"experts-comptables.fr",
  	"geometre-expert.fr",
  	"greta.fr",
  	"huissier-justice.fr",
  	"medecin.fr",
  	"notaires.fr",
  	"pharmacien.fr",
  	"port.fr",
  	"veterinaire.fr",
  	"ga",
  	"gb",
  	"edu.gd",
  	"gov.gd",
  	"gd",
  	"ge",
  	"com.ge",
  	"edu.ge",
  	"gov.ge",
  	"org.ge",
  	"mil.ge",
  	"net.ge",
  	"pvt.ge",
  	"gf",
  	"gg",
  	"co.gg",
  	"net.gg",
  	"org.gg",
  	"gh",
  	"com.gh",
  	"edu.gh",
  	"gov.gh",
  	"org.gh",
  	"mil.gh",
  	"gi",
  	"com.gi",
  	"ltd.gi",
  	"gov.gi",
  	"mod.gi",
  	"edu.gi",
  	"org.gi",
  	"gl",
  	"co.gl",
  	"com.gl",
  	"edu.gl",
  	"net.gl",
  	"org.gl",
  	"gm",
  	"gn",
  	"ac.gn",
  	"com.gn",
  	"edu.gn",
  	"gov.gn",
  	"org.gn",
  	"net.gn",
  	"gov",
  	"gp",
  	"com.gp",
  	"net.gp",
  	"mobi.gp",
  	"edu.gp",
  	"org.gp",
  	"asso.gp",
  	"gq",
  	"gr",
  	"com.gr",
  	"edu.gr",
  	"net.gr",
  	"org.gr",
  	"gov.gr",
  	"gs",
  	"gt",
  	"com.gt",
  	"edu.gt",
  	"gob.gt",
  	"ind.gt",
  	"mil.gt",
  	"net.gt",
  	"org.gt",
  	"gu",
  	"com.gu",
  	"edu.gu",
  	"gov.gu",
  	"guam.gu",
  	"info.gu",
  	"net.gu",
  	"org.gu",
  	"web.gu",
  	"gw",
  	"gy",
  	"co.gy",
  	"com.gy",
  	"edu.gy",
  	"gov.gy",
  	"net.gy",
  	"org.gy",
  	"hk",
  	"com.hk",
  	"edu.hk",
  	"gov.hk",
  	"idv.hk",
  	"net.hk",
  	"org.hk",
  	"公司.hk",
  	"教育.hk",
  	"敎育.hk",
  	"政府.hk",
  	"個人.hk",
  	"个��.hk",
  	"箇人.hk",
  	"網络.hk",
  	"网络.hk",
  	"组織.hk",
  	"網絡.hk",
  	"网絡.hk",
  	"组织.hk",
  	"組織.hk",
  	"組织.hk",
  	"hm",
  	"hn",
  	"com.hn",
  	"edu.hn",
  	"org.hn",
  	"net.hn",
  	"mil.hn",
  	"gob.hn",
  	"hr",
  	"iz.hr",
  	"from.hr",
  	"name.hr",
  	"com.hr",
  	"ht",
  	"com.ht",
  	"shop.ht",
  	"firm.ht",
  	"info.ht",
  	"adult.ht",
  	"net.ht",
  	"pro.ht",
  	"org.ht",
  	"med.ht",
  	"art.ht",
  	"coop.ht",
  	"pol.ht",
  	"asso.ht",
  	"edu.ht",
  	"rel.ht",
  	"gouv.ht",
  	"perso.ht",
  	"hu",
  	"co.hu",
  	"info.hu",
  	"org.hu",
  	"priv.hu",
  	"sport.hu",
  	"tm.hu",
  	"2000.hu",
  	"agrar.hu",
  	"bolt.hu",
  	"casino.hu",
  	"city.hu",
  	"erotica.hu",
  	"erotika.hu",
  	"film.hu",
  	"forum.hu",
  	"games.hu",
  	"hotel.hu",
  	"ingatlan.hu",
  	"jogasz.hu",
  	"konyvelo.hu",
  	"lakas.hu",
  	"media.hu",
  	"news.hu",
  	"reklam.hu",
  	"sex.hu",
  	"shop.hu",
  	"suli.hu",
  	"szex.hu",
  	"tozsde.hu",
  	"utazas.hu",
  	"video.hu",
  	"id",
  	"ac.id",
  	"biz.id",
  	"co.id",
  	"desa.id",
  	"go.id",
  	"mil.id",
  	"my.id",
  	"net.id",
  	"or.id",
  	"ponpes.id",
  	"sch.id",
  	"web.id",
  	"ie",
  	"gov.ie",
  	"il",
  	"ac.il",
  	"co.il",
  	"gov.il",
  	"idf.il",
  	"k12.il",
  	"muni.il",
  	"net.il",
  	"org.il",
  	"im",
  	"ac.im",
  	"co.im",
  	"com.im",
  	"ltd.co.im",
  	"net.im",
  	"org.im",
  	"plc.co.im",
  	"tt.im",
  	"tv.im",
  	"in",
  	"co.in",
  	"firm.in",
  	"net.in",
  	"org.in",
  	"gen.in",
  	"ind.in",
  	"nic.in",
  	"ac.in",
  	"edu.in",
  	"res.in",
  	"gov.in",
  	"mil.in",
  	"info",
  	"int",
  	"eu.int",
  	"io",
  	"com.io",
  	"iq",
  	"gov.iq",
  	"edu.iq",
  	"mil.iq",
  	"com.iq",
  	"org.iq",
  	"net.iq",
  	"ir",
  	"ac.ir",
  	"co.ir",
  	"gov.ir",
  	"id.ir",
  	"net.ir",
  	"org.ir",
  	"sch.ir",
  	"ایران.ir",
  	"ايران.ir",
  	"is",
  	"net.is",
  	"com.is",
  	"edu.is",
  	"gov.is",
  	"org.is",
  	"int.is",
  	"it",
  	"gov.it",
  	"edu.it",
  	"abr.it",
  	"abruzzo.it",
  	"aosta-valley.it",
  	"aostavalley.it",
  	"bas.it",
  	"basilicata.it",
  	"cal.it",
  	"calabria.it",
  	"cam.it",
  	"campania.it",
  	"emilia-romagna.it",
  	"emiliaromagna.it",
  	"emr.it",
  	"friuli-v-giulia.it",
  	"friuli-ve-giulia.it",
  	"friuli-vegiulia.it",
  	"friuli-venezia-giulia.it",
  	"friuli-veneziagiulia.it",
  	"friuli-vgiulia.it",
  	"friuliv-giulia.it",
  	"friulive-giulia.it",
  	"friulivegiulia.it",
  	"friulivenezia-giulia.it",
  	"friuliveneziagiulia.it",
  	"friulivgiulia.it",
  	"fvg.it",
  	"laz.it",
  	"lazio.it",
  	"lig.it",
  	"liguria.it",
  	"lom.it",
  	"lombardia.it",
  	"lombardy.it",
  	"lucania.it",
  	"mar.it",
  	"marche.it",
  	"mol.it",
  	"molise.it",
  	"piedmont.it",
  	"piemonte.it",
  	"pmn.it",
  	"pug.it",
  	"puglia.it",
  	"sar.it",
  	"sardegna.it",
  	"sardinia.it",
  	"sic.it",
  	"sicilia.it",
  	"sicily.it",
  	"taa.it",
  	"tos.it",
  	"toscana.it",
  	"trentin-sud-tirol.it",
  	"trentin-süd-tirol.it",
  	"trentin-sudtirol.it",
  	"trentin-südtirol.it",
  	"trentin-sued-tirol.it",
  	"trentin-suedtirol.it",
  	"trentino-a-adige.it",
  	"trentino-aadige.it",
  	"trentino-alto-adige.it",
  	"trentino-altoadige.it",
  	"trentino-s-tirol.it",
  	"trentino-stirol.it",
  	"trentino-sud-tirol.it",
  	"trentino-süd-tirol.it",
  	"trentino-sudtirol.it",
  	"trentino-südtirol.it",
  	"trentino-sued-tirol.it",
  	"trentino-suedtirol.it",
  	"trentino.it",
  	"trentinoa-adige.it",
  	"trentinoaadige.it",
  	"trentinoalto-adige.it",
  	"trentinoaltoadige.it",
  	"trentinos-tirol.it",
  	"trentinostirol.it",
  	"trentinosud-tirol.it",
  	"trentinosüd-tirol.it",
  	"trentinosudtirol.it",
  	"trentinosüdtirol.it",
  	"trentinosued-tirol.it",
  	"trentinosuedtirol.it",
  	"trentinsud-tirol.it",
  	"trentinsüd-tirol.it",
  	"trentinsudtirol.it",
  	"trentinsüdtirol.it",
  	"trentinsued-tirol.it",
  	"trentinsuedtirol.it",
  	"tuscany.it",
  	"umb.it",
  	"umbria.it",
  	"val-d-aosta.it",
  	"val-daosta.it",
  	"vald-aosta.it",
  	"valdaosta.it",
  	"valle-aosta.it",
  	"valle-d-aosta.it",
  	"valle-daosta.it",
  	"valleaosta.it",
  	"valled-aosta.it",
  	"valledaosta.it",
  	"vallee-aoste.it",
  	"vallée-aoste.it",
  	"vallee-d-aoste.it",
  	"vallée-d-aoste.it",
  	"valleeaoste.it",
  	"valléeaoste.it",
  	"valleedaoste.it",
  	"valléedaoste.it",
  	"vao.it",
  	"vda.it",
  	"ven.it",
  	"veneto.it",
  	"ag.it",
  	"agrigento.it",
  	"al.it",
  	"alessandria.it",
  	"alto-adige.it",
  	"altoadige.it",
  	"an.it",
  	"ancona.it",
  	"andria-barletta-trani.it",
  	"andria-trani-barletta.it",
  	"andriabarlettatrani.it",
  	"andriatranibarletta.it",
  	"ao.it",
  	"aosta.it",
  	"aoste.it",
  	"ap.it",
  	"aq.it",
  	"aquila.it",
  	"ar.it",
  	"arezzo.it",
  	"ascoli-piceno.it",
  	"ascolipiceno.it",
  	"asti.it",
  	"at.it",
  	"av.it",
  	"avellino.it",
  	"ba.it",
  	"balsan-sudtirol.it",
  	"balsan-südtirol.it",
  	"balsan-suedtirol.it",
  	"balsan.it",
  	"bari.it",
  	"barletta-trani-andria.it",
  	"barlettatraniandria.it",
  	"belluno.it",
  	"benevento.it",
  	"bergamo.it",
  	"bg.it",
  	"bi.it",
  	"biella.it",
  	"bl.it",
  	"bn.it",
  	"bo.it",
  	"bologna.it",
  	"bolzano-altoadige.it",
  	"bolzano.it",
  	"bozen-sudtirol.it",
  	"bozen-südtirol.it",
  	"bozen-suedtirol.it",
  	"bozen.it",
  	"br.it",
  	"brescia.it",
  	"brindisi.it",
  	"bs.it",
  	"bt.it",
  	"bulsan-sudtirol.it",
  	"bulsan-südtirol.it",
  	"bulsan-suedtirol.it",
  	"bulsan.it",
  	"bz.it",
  	"ca.it",
  	"cagliari.it",
  	"caltanissetta.it",
  	"campidano-medio.it",
  	"campidanomedio.it",
  	"campobasso.it",
  	"carbonia-iglesias.it",
  	"carboniaiglesias.it",
  	"carrara-massa.it",
  	"carraramassa.it",
  	"caserta.it",
  	"catania.it",
  	"catanzaro.it",
  	"cb.it",
  	"ce.it",
  	"cesena-forli.it",
  	"cesena-forlì.it",
  	"cesenaforli.it",
  	"cesenaforlì.it",
  	"ch.it",
  	"chieti.it",
  	"ci.it",
  	"cl.it",
  	"cn.it",
  	"co.it",
  	"como.it",
  	"cosenza.it",
  	"cr.it",
  	"cremona.it",
  	"crotone.it",
  	"cs.it",
  	"ct.it",
  	"cuneo.it",
  	"cz.it",
  	"dell-ogliastra.it",
  	"dellogliastra.it",
  	"en.it",
  	"enna.it",
  	"fc.it",
  	"fe.it",
  	"fermo.it",
  	"ferrara.it",
  	"fg.it",
  	"fi.it",
  	"firenze.it",
  	"florence.it",
  	"fm.it",
  	"foggia.it",
  	"forli-cesena.it",
  	"forlì-cesena.it",
  	"forlicesena.it",
  	"forlìcesena.it",
  	"fr.it",
  	"frosinone.it",
  	"ge.it",
  	"genoa.it",
  	"genova.it",
  	"go.it",
  	"gorizia.it",
  	"gr.it",
  	"grosseto.it",
  	"iglesias-carbonia.it",
  	"iglesiascarbonia.it",
  	"im.it",
  	"imperia.it",
  	"is.it",
  	"isernia.it",
  	"kr.it",
  	"la-spezia.it",
  	"laquila.it",
  	"laspezia.it",
  	"latina.it",
  	"lc.it",
  	"le.it",
  	"lecce.it",
  	"lecco.it",
  	"li.it",
  	"livorno.it",
  	"lo.it",
  	"lodi.it",
  	"lt.it",
  	"lu.it",
  	"lucca.it",
  	"macerata.it",
  	"mantova.it",
  	"massa-carrara.it",
  	"massacarrara.it",
  	"matera.it",
  	"mb.it",
  	"mc.it",
  	"me.it",
  	"medio-campidano.it",
  	"mediocampidano.it",
  	"messina.it",
  	"mi.it",
  	"milan.it",
  	"milano.it",
  	"mn.it",
  	"mo.it",
  	"modena.it",
  	"monza-brianza.it",
  	"monza-e-della-brianza.it",
  	"monza.it",
  	"monzabrianza.it",
  	"monzaebrianza.it",
  	"monzaedellabrianza.it",
  	"ms.it",
  	"mt.it",
  	"na.it",
  	"naples.it",
  	"napoli.it",
  	"no.it",
  	"novara.it",
  	"nu.it",
  	"nuoro.it",
  	"og.it",
  	"ogliastra.it",
  	"olbia-tempio.it",
  	"olbiatempio.it",
  	"or.it",
  	"oristano.it",
  	"ot.it",
  	"pa.it",
  	"padova.it",
  	"padua.it",
  	"palermo.it",
  	"parma.it",
  	"pavia.it",
  	"pc.it",
  	"pd.it",
  	"pe.it",
  	"perugia.it",
  	"pesaro-urbino.it",
  	"pesarourbino.it",
  	"pescara.it",
  	"pg.it",
  	"pi.it",
  	"piacenza.it",
  	"pisa.it",
  	"pistoia.it",
  	"pn.it",
  	"po.it",
  	"pordenone.it",
  	"potenza.it",
  	"pr.it",
  	"prato.it",
  	"pt.it",
  	"pu.it",
  	"pv.it",
  	"pz.it",
  	"ra.it",
  	"ragusa.it",
  	"ravenna.it",
  	"rc.it",
  	"re.it",
  	"reggio-calabria.it",
  	"reggio-emilia.it",
  	"reggiocalabria.it",
  	"reggioemilia.it",
  	"rg.it",
  	"ri.it",
  	"rieti.it",
  	"rimini.it",
  	"rm.it",
  	"rn.it",
  	"ro.it",
  	"roma.it",
  	"rome.it",
  	"rovigo.it",
  	"sa.it",
  	"salerno.it",
  	"sassari.it",
  	"savona.it",
  	"si.it",
  	"siena.it",
  	"siracusa.it",
  	"so.it",
  	"sondrio.it",
  	"sp.it",
  	"sr.it",
  	"ss.it",
  	"suedtirol.it",
  	"südtirol.it",
  	"sv.it",
  	"ta.it",
  	"taranto.it",
  	"te.it",
  	"tempio-olbia.it",
  	"tempioolbia.it",
  	"teramo.it",
  	"terni.it",
  	"tn.it",
  	"to.it",
  	"torino.it",
  	"tp.it",
  	"tr.it",
  	"trani-andria-barletta.it",
  	"trani-barletta-andria.it",
  	"traniandriabarletta.it",
  	"tranibarlettaandria.it",
  	"trapani.it",
  	"trento.it",
  	"treviso.it",
  	"trieste.it",
  	"ts.it",
  	"turin.it",
  	"tv.it",
  	"ud.it",
  	"udine.it",
  	"urbino-pesaro.it",
  	"urbinopesaro.it",
  	"va.it",
  	"varese.it",
  	"vb.it",
  	"vc.it",
  	"ve.it",
  	"venezia.it",
  	"venice.it",
  	"verbania.it",
  	"vercelli.it",
  	"verona.it",
  	"vi.it",
  	"vibo-valentia.it",
  	"vibovalentia.it",
  	"vicenza.it",
  	"viterbo.it",
  	"vr.it",
  	"vs.it",
  	"vt.it",
  	"vv.it",
  	"je",
  	"co.je",
  	"net.je",
  	"org.je",
  	"*.jm",
  	"jo",
  	"com.jo",
  	"org.jo",
  	"net.jo",
  	"edu.jo",
  	"sch.jo",
  	"gov.jo",
  	"mil.jo",
  	"name.jo",
  	"jobs",
  	"jp",
  	"ac.jp",
  	"ad.jp",
  	"co.jp",
  	"ed.jp",
  	"go.jp",
  	"gr.jp",
  	"lg.jp",
  	"ne.jp",
  	"or.jp",
  	"aichi.jp",
  	"akita.jp",
  	"aomori.jp",
  	"chiba.jp",
  	"ehime.jp",
  	"fukui.jp",
  	"fukuoka.jp",
  	"fukushima.jp",
  	"gifu.jp",
  	"gunma.jp",
  	"hiroshima.jp",
  	"hokkaido.jp",
  	"hyogo.jp",
  	"ibaraki.jp",
  	"ishikawa.jp",
  	"iwate.jp",
  	"kagawa.jp",
  	"kagoshima.jp",
  	"kanagawa.jp",
  	"kochi.jp",
  	"kumamoto.jp",
  	"kyoto.jp",
  	"mie.jp",
  	"miyagi.jp",
  	"miyazaki.jp",
  	"nagano.jp",
  	"nagasaki.jp",
  	"nara.jp",
  	"niigata.jp",
  	"oita.jp",
  	"okayama.jp",
  	"okinawa.jp",
  	"osaka.jp",
  	"saga.jp",
  	"saitama.jp",
  	"shiga.jp",
  	"shimane.jp",
  	"shizuoka.jp",
  	"tochigi.jp",
  	"tokushima.jp",
  	"tokyo.jp",
  	"tottori.jp",
  	"toyama.jp",
  	"wakayama.jp",
  	"yamagata.jp",
  	"yamaguchi.jp",
  	"yamanashi.jp",
  	"栃木.jp",
  	"愛知.jp",
  	"愛媛.jp",
  	"兵庫.jp",
  	"熊本.jp",
  	"茨城.jp",
  	"北海道.jp",
  	"千葉.jp",
  	"和歌山.jp",
  	"長崎.jp",
  	"長野.jp",
  	"新潟.jp",
  	"青森.jp",
  	"静岡.jp",
  	"東京.jp",
  	"石川.jp",
  	"埼玉.jp",
  	"三重.jp",
  	"京都.jp",
  	"佐賀.jp",
  	"大分.jp",
  	"大阪.jp",
  	"奈良.jp",
  	"宮城.jp",
  	"宮崎.jp",
  	"富山.jp",
  	"山口.jp",
  	"山形.jp",
  	"山梨.jp",
  	"岩手.jp",
  	"岐阜.jp",
  	"岡山.jp",
  	"島根.jp",
  	"広島.jp",
  	"徳島.jp",
  	"沖縄.jp",
  	"滋賀.jp",
  	"神奈川.jp",
  	"福井.jp",
  	"福岡.jp",
  	"福島.jp",
  	"秋田.jp",
  	"群馬.jp",
  	"香川.jp",
  	"高知.jp",
  	"鳥取.jp",
  	"鹿児島.jp",
  	"*.kawasaki.jp",
  	"*.kitakyushu.jp",
  	"*.kobe.jp",
  	"*.nagoya.jp",
  	"*.sapporo.jp",
  	"*.sendai.jp",
  	"*.yokohama.jp",
  	"!city.kawasaki.jp",
  	"!city.kitakyushu.jp",
  	"!city.kobe.jp",
  	"!city.nagoya.jp",
  	"!city.sapporo.jp",
  	"!city.sendai.jp",
  	"!city.yokohama.jp",
  	"aisai.aichi.jp",
  	"ama.aichi.jp",
  	"anjo.aichi.jp",
  	"asuke.aichi.jp",
  	"chiryu.aichi.jp",
  	"chita.aichi.jp",
  	"fuso.aichi.jp",
  	"gamagori.aichi.jp",
  	"handa.aichi.jp",
  	"hazu.aichi.jp",
  	"hekinan.aichi.jp",
  	"higashiura.aichi.jp",
  	"ichinomiya.aichi.jp",
  	"inazawa.aichi.jp",
  	"inuyama.aichi.jp",
  	"isshiki.aichi.jp",
  	"iwakura.aichi.jp",
  	"kanie.aichi.jp",
  	"kariya.aichi.jp",
  	"kasugai.aichi.jp",
  	"kira.aichi.jp",
  	"kiyosu.aichi.jp",
  	"komaki.aichi.jp",
  	"konan.aichi.jp",
  	"kota.aichi.jp",
  	"mihama.aichi.jp",
  	"miyoshi.aichi.jp",
  	"nishio.aichi.jp",
  	"nisshin.aichi.jp",
  	"obu.aichi.jp",
  	"oguchi.aichi.jp",
  	"oharu.aichi.jp",
  	"okazaki.aichi.jp",
  	"owariasahi.aichi.jp",
  	"seto.aichi.jp",
  	"shikatsu.aichi.jp",
  	"shinshiro.aichi.jp",
  	"shitara.aichi.jp",
  	"tahara.aichi.jp",
  	"takahama.aichi.jp",
  	"tobishima.aichi.jp",
  	"toei.aichi.jp",
  	"togo.aichi.jp",
  	"tokai.aichi.jp",
  	"tokoname.aichi.jp",
  	"toyoake.aichi.jp",
  	"toyohashi.aichi.jp",
  	"toyokawa.aichi.jp",
  	"toyone.aichi.jp",
  	"toyota.aichi.jp",
  	"tsushima.aichi.jp",
  	"yatomi.aichi.jp",
  	"akita.akita.jp",
  	"daisen.akita.jp",
  	"fujisato.akita.jp",
  	"gojome.akita.jp",
  	"hachirogata.akita.jp",
  	"happou.akita.jp",
  	"higashinaruse.akita.jp",
  	"honjo.akita.jp",
  	"honjyo.akita.jp",
  	"ikawa.akita.jp",
  	"kamikoani.akita.jp",
  	"kamioka.akita.jp",
  	"katagami.akita.jp",
  	"kazuno.akita.jp",
  	"kitaakita.akita.jp",
  	"kosaka.akita.jp",
  	"kyowa.akita.jp",
  	"misato.akita.jp",
  	"mitane.akita.jp",
  	"moriyoshi.akita.jp",
  	"nikaho.akita.jp",
  	"noshiro.akita.jp",
  	"odate.akita.jp",
  	"oga.akita.jp",
  	"ogata.akita.jp",
  	"semboku.akita.jp",
  	"yokote.akita.jp",
  	"yurihonjo.akita.jp",
  	"aomori.aomori.jp",
  	"gonohe.aomori.jp",
  	"hachinohe.aomori.jp",
  	"hashikami.aomori.jp",
  	"hiranai.aomori.jp",
  	"hirosaki.aomori.jp",
  	"itayanagi.aomori.jp",
  	"kuroishi.aomori.jp",
  	"misawa.aomori.jp",
  	"mutsu.aomori.jp",
  	"nakadomari.aomori.jp",
  	"noheji.aomori.jp",
  	"oirase.aomori.jp",
  	"owani.aomori.jp",
  	"rokunohe.aomori.jp",
  	"sannohe.aomori.jp",
  	"shichinohe.aomori.jp",
  	"shingo.aomori.jp",
  	"takko.aomori.jp",
  	"towada.aomori.jp",
  	"tsugaru.aomori.jp",
  	"tsuruta.aomori.jp",
  	"abiko.chiba.jp",
  	"asahi.chiba.jp",
  	"chonan.chiba.jp",
  	"chosei.chiba.jp",
  	"choshi.chiba.jp",
  	"chuo.chiba.jp",
  	"funabashi.chiba.jp",
  	"futtsu.chiba.jp",
  	"hanamigawa.chiba.jp",
  	"ichihara.chiba.jp",
  	"ichikawa.chiba.jp",
  	"ichinomiya.chiba.jp",
  	"inzai.chiba.jp",
  	"isumi.chiba.jp",
  	"kamagaya.chiba.jp",
  	"kamogawa.chiba.jp",
  	"kashiwa.chiba.jp",
  	"katori.chiba.jp",
  	"katsuura.chiba.jp",
  	"kimitsu.chiba.jp",
  	"kisarazu.chiba.jp",
  	"kozaki.chiba.jp",
  	"kujukuri.chiba.jp",
  	"kyonan.chiba.jp",
  	"matsudo.chiba.jp",
  	"midori.chiba.jp",
  	"mihama.chiba.jp",
  	"minamiboso.chiba.jp",
  	"mobara.chiba.jp",
  	"mutsuzawa.chiba.jp",
  	"nagara.chiba.jp",
  	"nagareyama.chiba.jp",
  	"narashino.chiba.jp",
  	"narita.chiba.jp",
  	"noda.chiba.jp",
  	"oamishirasato.chiba.jp",
  	"omigawa.chiba.jp",
  	"onjuku.chiba.jp",
  	"otaki.chiba.jp",
  	"sakae.chiba.jp",
  	"sakura.chiba.jp",
  	"shimofusa.chiba.jp",
  	"shirako.chiba.jp",
  	"shiroi.chiba.jp",
  	"shisui.chiba.jp",
  	"sodegaura.chiba.jp",
  	"sosa.chiba.jp",
  	"tako.chiba.jp",
  	"tateyama.chiba.jp",
  	"togane.chiba.jp",
  	"tohnosho.chiba.jp",
  	"tomisato.chiba.jp",
  	"urayasu.chiba.jp",
  	"yachimata.chiba.jp",
  	"yachiyo.chiba.jp",
  	"yokaichiba.chiba.jp",
  	"yokoshibahikari.chiba.jp",
  	"yotsukaido.chiba.jp",
  	"ainan.ehime.jp",
  	"honai.ehime.jp",
  	"ikata.ehime.jp",
  	"imabari.ehime.jp",
  	"iyo.ehime.jp",
  	"kamijima.ehime.jp",
  	"kihoku.ehime.jp",
  	"kumakogen.ehime.jp",
  	"masaki.ehime.jp",
  	"matsuno.ehime.jp",
  	"matsuyama.ehime.jp",
  	"namikata.ehime.jp",
  	"niihama.ehime.jp",
  	"ozu.ehime.jp",
  	"saijo.ehime.jp",
  	"seiyo.ehime.jp",
  	"shikokuchuo.ehime.jp",
  	"tobe.ehime.jp",
  	"toon.ehime.jp",
  	"uchiko.ehime.jp",
  	"uwajima.ehime.jp",
  	"yawatahama.ehime.jp",
  	"echizen.fukui.jp",
  	"eiheiji.fukui.jp",
  	"fukui.fukui.jp",
  	"ikeda.fukui.jp",
  	"katsuyama.fukui.jp",
  	"mihama.fukui.jp",
  	"minamiechizen.fukui.jp",
  	"obama.fukui.jp",
  	"ohi.fukui.jp",
  	"ono.fukui.jp",
  	"sabae.fukui.jp",
  	"sakai.fukui.jp",
  	"takahama.fukui.jp",
  	"tsuruga.fukui.jp",
  	"wakasa.fukui.jp",
  	"ashiya.fukuoka.jp",
  	"buzen.fukuoka.jp",
  	"chikugo.fukuoka.jp",
  	"chikuho.fukuoka.jp",
  	"chikujo.fukuoka.jp",
  	"chikushino.fukuoka.jp",
  	"chikuzen.fukuoka.jp",
  	"chuo.fukuoka.jp",
  	"dazaifu.fukuoka.jp",
  	"fukuchi.fukuoka.jp",
  	"hakata.fukuoka.jp",
  	"higashi.fukuoka.jp",
  	"hirokawa.fukuoka.jp",
  	"hisayama.fukuoka.jp",
  	"iizuka.fukuoka.jp",
  	"inatsuki.fukuoka.jp",
  	"kaho.fukuoka.jp",
  	"kasuga.fukuoka.jp",
  	"kasuya.fukuoka.jp",
  	"kawara.fukuoka.jp",
  	"keisen.fukuoka.jp",
  	"koga.fukuoka.jp",
  	"kurate.fukuoka.jp",
  	"kurogi.fukuoka.jp",
  	"kurume.fukuoka.jp",
  	"minami.fukuoka.jp",
  	"miyako.fukuoka.jp",
  	"miyama.fukuoka.jp",
  	"miyawaka.fukuoka.jp",
  	"mizumaki.fukuoka.jp",
  	"munakata.fukuoka.jp",
  	"nakagawa.fukuoka.jp",
  	"nakama.fukuoka.jp",
  	"nishi.fukuoka.jp",
  	"nogata.fukuoka.jp",
  	"ogori.fukuoka.jp",
  	"okagaki.fukuoka.jp",
  	"okawa.fukuoka.jp",
  	"oki.fukuoka.jp",
  	"omuta.fukuoka.jp",
  	"onga.fukuoka.jp",
  	"onojo.fukuoka.jp",
  	"oto.fukuoka.jp",
  	"saigawa.fukuoka.jp",
  	"sasaguri.fukuoka.jp",
  	"shingu.fukuoka.jp",
  	"shinyoshitomi.fukuoka.jp",
  	"shonai.fukuoka.jp",
  	"soeda.fukuoka.jp",
  	"sue.fukuoka.jp",
  	"tachiarai.fukuoka.jp",
  	"tagawa.fukuoka.jp",
  	"takata.fukuoka.jp",
  	"toho.fukuoka.jp",
  	"toyotsu.fukuoka.jp",
  	"tsuiki.fukuoka.jp",
  	"ukiha.fukuoka.jp",
  	"umi.fukuoka.jp",
  	"usui.fukuoka.jp",
  	"yamada.fukuoka.jp",
  	"yame.fukuoka.jp",
  	"yanagawa.fukuoka.jp",
  	"yukuhashi.fukuoka.jp",
  	"aizubange.fukushima.jp",
  	"aizumisato.fukushima.jp",
  	"aizuwakamatsu.fukushima.jp",
  	"asakawa.fukushima.jp",
  	"bandai.fukushima.jp",
  	"date.fukushima.jp",
  	"fukushima.fukushima.jp",
  	"furudono.fukushima.jp",
  	"futaba.fukushima.jp",
  	"hanawa.fukushima.jp",
  	"higashi.fukushima.jp",
  	"hirata.fukushima.jp",
  	"hirono.fukushima.jp",
  	"iitate.fukushima.jp",
  	"inawashiro.fukushima.jp",
  	"ishikawa.fukushima.jp",
  	"iwaki.fukushima.jp",
  	"izumizaki.fukushima.jp",
  	"kagamiishi.fukushima.jp",
  	"kaneyama.fukushima.jp",
  	"kawamata.fukushima.jp",
  	"kitakata.fukushima.jp",
  	"kitashiobara.fukushima.jp",
  	"koori.fukushima.jp",
  	"koriyama.fukushima.jp",
  	"kunimi.fukushima.jp",
  	"miharu.fukushima.jp",
  	"mishima.fukushima.jp",
  	"namie.fukushima.jp",
  	"nango.fukushima.jp",
  	"nishiaizu.fukushima.jp",
  	"nishigo.fukushima.jp",
  	"okuma.fukushima.jp",
  	"omotego.fukushima.jp",
  	"ono.fukushima.jp",
  	"otama.fukushima.jp",
  	"samegawa.fukushima.jp",
  	"shimogo.fukushima.jp",
  	"shirakawa.fukushima.jp",
  	"showa.fukushima.jp",
  	"soma.fukushima.jp",
  	"sukagawa.fukushima.jp",
  	"taishin.fukushima.jp",
  	"tamakawa.fukushima.jp",
  	"tanagura.fukushima.jp",
  	"tenei.fukushima.jp",
  	"yabuki.fukushima.jp",
  	"yamato.fukushima.jp",
  	"yamatsuri.fukushima.jp",
  	"yanaizu.fukushima.jp",
  	"yugawa.fukushima.jp",
  	"anpachi.gifu.jp",
  	"ena.gifu.jp",
  	"gifu.gifu.jp",
  	"ginan.gifu.jp",
  	"godo.gifu.jp",
  	"gujo.gifu.jp",
  	"hashima.gifu.jp",
  	"hichiso.gifu.jp",
  	"hida.gifu.jp",
  	"higashishirakawa.gifu.jp",
  	"ibigawa.gifu.jp",
  	"ikeda.gifu.jp",
  	"kakamigahara.gifu.jp",
  	"kani.gifu.jp",
  	"kasahara.gifu.jp",
  	"kasamatsu.gifu.jp",
  	"kawaue.gifu.jp",
  	"kitagata.gifu.jp",
  	"mino.gifu.jp",
  	"minokamo.gifu.jp",
  	"mitake.gifu.jp",
  	"mizunami.gifu.jp",
  	"motosu.gifu.jp",
  	"nakatsugawa.gifu.jp",
  	"ogaki.gifu.jp",
  	"sakahogi.gifu.jp",
  	"seki.gifu.jp",
  	"sekigahara.gifu.jp",
  	"shirakawa.gifu.jp",
  	"tajimi.gifu.jp",
  	"takayama.gifu.jp",
  	"tarui.gifu.jp",
  	"toki.gifu.jp",
  	"tomika.gifu.jp",
  	"wanouchi.gifu.jp",
  	"yamagata.gifu.jp",
  	"yaotsu.gifu.jp",
  	"yoro.gifu.jp",
  	"annaka.gunma.jp",
  	"chiyoda.gunma.jp",
  	"fujioka.gunma.jp",
  	"higashiagatsuma.gunma.jp",
  	"isesaki.gunma.jp",
  	"itakura.gunma.jp",
  	"kanna.gunma.jp",
  	"kanra.gunma.jp",
  	"katashina.gunma.jp",
  	"kawaba.gunma.jp",
  	"kiryu.gunma.jp",
  	"kusatsu.gunma.jp",
  	"maebashi.gunma.jp",
  	"meiwa.gunma.jp",
  	"midori.gunma.jp",
  	"minakami.gunma.jp",
  	"naganohara.gunma.jp",
  	"nakanojo.gunma.jp",
  	"nanmoku.gunma.jp",
  	"numata.gunma.jp",
  	"oizumi.gunma.jp",
  	"ora.gunma.jp",
  	"ota.gunma.jp",
  	"shibukawa.gunma.jp",
  	"shimonita.gunma.jp",
  	"shinto.gunma.jp",
  	"showa.gunma.jp",
  	"takasaki.gunma.jp",
  	"takayama.gunma.jp",
  	"tamamura.gunma.jp",
  	"tatebayashi.gunma.jp",
  	"tomioka.gunma.jp",
  	"tsukiyono.gunma.jp",
  	"tsumagoi.gunma.jp",
  	"ueno.gunma.jp",
  	"yoshioka.gunma.jp",
  	"asaminami.hiroshima.jp",
  	"daiwa.hiroshima.jp",
  	"etajima.hiroshima.jp",
  	"fuchu.hiroshima.jp",
  	"fukuyama.hiroshima.jp",
  	"hatsukaichi.hiroshima.jp",
  	"higashihiroshima.hiroshima.jp",
  	"hongo.hiroshima.jp",
  	"jinsekikogen.hiroshima.jp",
  	"kaita.hiroshima.jp",
  	"kui.hiroshima.jp",
  	"kumano.hiroshima.jp",
  	"kure.hiroshima.jp",
  	"mihara.hiroshima.jp",
  	"miyoshi.hiroshima.jp",
  	"naka.hiroshima.jp",
  	"onomichi.hiroshima.jp",
  	"osakikamijima.hiroshima.jp",
  	"otake.hiroshima.jp",
  	"saka.hiroshima.jp",
  	"sera.hiroshima.jp",
  	"seranishi.hiroshima.jp",
  	"shinichi.hiroshima.jp",
  	"shobara.hiroshima.jp",
  	"takehara.hiroshima.jp",
  	"abashiri.hokkaido.jp",
  	"abira.hokkaido.jp",
  	"aibetsu.hokkaido.jp",
  	"akabira.hokkaido.jp",
  	"akkeshi.hokkaido.jp",
  	"asahikawa.hokkaido.jp",
  	"ashibetsu.hokkaido.jp",
  	"ashoro.hokkaido.jp",
  	"assabu.hokkaido.jp",
  	"atsuma.hokkaido.jp",
  	"bibai.hokkaido.jp",
  	"biei.hokkaido.jp",
  	"bifuka.hokkaido.jp",
  	"bihoro.hokkaido.jp",
  	"biratori.hokkaido.jp",
  	"chippubetsu.hokkaido.jp",
  	"chitose.hokkaido.jp",
  	"date.hokkaido.jp",
  	"ebetsu.hokkaido.jp",
  	"embetsu.hokkaido.jp",
  	"eniwa.hokkaido.jp",
  	"erimo.hokkaido.jp",
  	"esan.hokkaido.jp",
  	"esashi.hokkaido.jp",
  	"fukagawa.hokkaido.jp",
  	"fukushima.hokkaido.jp",
  	"furano.hokkaido.jp",
  	"furubira.hokkaido.jp",
  	"haboro.hokkaido.jp",
  	"hakodate.hokkaido.jp",
  	"hamatonbetsu.hokkaido.jp",
  	"hidaka.hokkaido.jp",
  	"higashikagura.hokkaido.jp",
  	"higashikawa.hokkaido.jp",
  	"hiroo.hokkaido.jp",
  	"hokuryu.hokkaido.jp",
  	"hokuto.hokkaido.jp",
  	"honbetsu.hokkaido.jp",
  	"horokanai.hokkaido.jp",
  	"horonobe.hokkaido.jp",
  	"ikeda.hokkaido.jp",
  	"imakane.hokkaido.jp",
  	"ishikari.hokkaido.jp",
  	"iwamizawa.hokkaido.jp",
  	"iwanai.hokkaido.jp",
  	"kamifurano.hokkaido.jp",
  	"kamikawa.hokkaido.jp",
  	"kamishihoro.hokkaido.jp",
  	"kamisunagawa.hokkaido.jp",
  	"kamoenai.hokkaido.jp",
  	"kayabe.hokkaido.jp",
  	"kembuchi.hokkaido.jp",
  	"kikonai.hokkaido.jp",
  	"kimobetsu.hokkaido.jp",
  	"kitahiroshima.hokkaido.jp",
  	"kitami.hokkaido.jp",
  	"kiyosato.hokkaido.jp",
  	"koshimizu.hokkaido.jp",
  	"kunneppu.hokkaido.jp",
  	"kuriyama.hokkaido.jp",
  	"kuromatsunai.hokkaido.jp",
  	"kushiro.hokkaido.jp",
  	"kutchan.hokkaido.jp",
  	"kyowa.hokkaido.jp",
  	"mashike.hokkaido.jp",
  	"matsumae.hokkaido.jp",
  	"mikasa.hokkaido.jp",
  	"minamifurano.hokkaido.jp",
  	"mombetsu.hokkaido.jp",
  	"moseushi.hokkaido.jp",
  	"mukawa.hokkaido.jp",
  	"muroran.hokkaido.jp",
  	"naie.hokkaido.jp",
  	"nakagawa.hokkaido.jp",
  	"nakasatsunai.hokkaido.jp",
  	"nakatombetsu.hokkaido.jp",
  	"nanae.hokkaido.jp",
  	"nanporo.hokkaido.jp",
  	"nayoro.hokkaido.jp",
  	"nemuro.hokkaido.jp",
  	"niikappu.hokkaido.jp",
  	"niki.hokkaido.jp",
  	"nishiokoppe.hokkaido.jp",
  	"noboribetsu.hokkaido.jp",
  	"numata.hokkaido.jp",
  	"obihiro.hokkaido.jp",
  	"obira.hokkaido.jp",
  	"oketo.hokkaido.jp",
  	"okoppe.hokkaido.jp",
  	"otaru.hokkaido.jp",
  	"otobe.hokkaido.jp",
  	"otofuke.hokkaido.jp",
  	"otoineppu.hokkaido.jp",
  	"oumu.hokkaido.jp",
  	"ozora.hokkaido.jp",
  	"pippu.hokkaido.jp",
  	"rankoshi.hokkaido.jp",
  	"rebun.hokkaido.jp",
  	"rikubetsu.hokkaido.jp",
  	"rishiri.hokkaido.jp",
  	"rishirifuji.hokkaido.jp",
  	"saroma.hokkaido.jp",
  	"sarufutsu.hokkaido.jp",
  	"shakotan.hokkaido.jp",
  	"shari.hokkaido.jp",
  	"shibecha.hokkaido.jp",
  	"shibetsu.hokkaido.jp",
  	"shikabe.hokkaido.jp",
  	"shikaoi.hokkaido.jp",
  	"shimamaki.hokkaido.jp",
  	"shimizu.hokkaido.jp",
  	"shimokawa.hokkaido.jp",
  	"shinshinotsu.hokkaido.jp",
  	"shintoku.hokkaido.jp",
  	"shiranuka.hokkaido.jp",
  	"shiraoi.hokkaido.jp",
  	"shiriuchi.hokkaido.jp",
  	"sobetsu.hokkaido.jp",
  	"sunagawa.hokkaido.jp",
  	"taiki.hokkaido.jp",
  	"takasu.hokkaido.jp",
  	"takikawa.hokkaido.jp",
  	"takinoue.hokkaido.jp",
  	"teshikaga.hokkaido.jp",
  	"tobetsu.hokkaido.jp",
  	"tohma.hokkaido.jp",
  	"tomakomai.hokkaido.jp",
  	"tomari.hokkaido.jp",
  	"toya.hokkaido.jp",
  	"toyako.hokkaido.jp",
  	"toyotomi.hokkaido.jp",
  	"toyoura.hokkaido.jp",
  	"tsubetsu.hokkaido.jp",
  	"tsukigata.hokkaido.jp",
  	"urakawa.hokkaido.jp",
  	"urausu.hokkaido.jp",
  	"uryu.hokkaido.jp",
  	"utashinai.hokkaido.jp",
  	"wakkanai.hokkaido.jp",
  	"wassamu.hokkaido.jp",
  	"yakumo.hokkaido.jp",
  	"yoichi.hokkaido.jp",
  	"aioi.hyogo.jp",
  	"akashi.hyogo.jp",
  	"ako.hyogo.jp",
  	"amagasaki.hyogo.jp",
  	"aogaki.hyogo.jp",
  	"asago.hyogo.jp",
  	"ashiya.hyogo.jp",
  	"awaji.hyogo.jp",
  	"fukusaki.hyogo.jp",
  	"goshiki.hyogo.jp",
  	"harima.hyogo.jp",
  	"himeji.hyogo.jp",
  	"ichikawa.hyogo.jp",
  	"inagawa.hyogo.jp",
  	"itami.hyogo.jp",
  	"kakogawa.hyogo.jp",
  	"kamigori.hyogo.jp",
  	"kamikawa.hyogo.jp",
  	"kasai.hyogo.jp",
  	"kasuga.hyogo.jp",
  	"kawanishi.hyogo.jp",
  	"miki.hyogo.jp",
  	"minamiawaji.hyogo.jp",
  	"nishinomiya.hyogo.jp",
  	"nishiwaki.hyogo.jp",
  	"ono.hyogo.jp",
  	"sanda.hyogo.jp",
  	"sannan.hyogo.jp",
  	"sasayama.hyogo.jp",
  	"sayo.hyogo.jp",
  	"shingu.hyogo.jp",
  	"shinonsen.hyogo.jp",
  	"shiso.hyogo.jp",
  	"sumoto.hyogo.jp",
  	"taishi.hyogo.jp",
  	"taka.hyogo.jp",
  	"takarazuka.hyogo.jp",
  	"takasago.hyogo.jp",
  	"takino.hyogo.jp",
  	"tamba.hyogo.jp",
  	"tatsuno.hyogo.jp",
  	"toyooka.hyogo.jp",
  	"yabu.hyogo.jp",
  	"yashiro.hyogo.jp",
  	"yoka.hyogo.jp",
  	"yokawa.hyogo.jp",
  	"ami.ibaraki.jp",
  	"asahi.ibaraki.jp",
  	"bando.ibaraki.jp",
  	"chikusei.ibaraki.jp",
  	"daigo.ibaraki.jp",
  	"fujishiro.ibaraki.jp",
  	"hitachi.ibaraki.jp",
  	"hitachinaka.ibaraki.jp",
  	"hitachiomiya.ibaraki.jp",
  	"hitachiota.ibaraki.jp",
  	"ibaraki.ibaraki.jp",
  	"ina.ibaraki.jp",
  	"inashiki.ibaraki.jp",
  	"itako.ibaraki.jp",
  	"iwama.ibaraki.jp",
  	"joso.ibaraki.jp",
  	"kamisu.ibaraki.jp",
  	"kasama.ibaraki.jp",
  	"kashima.ibaraki.jp",
  	"kasumigaura.ibaraki.jp",
  	"koga.ibaraki.jp",
  	"miho.ibaraki.jp",
  	"mito.ibaraki.jp",
  	"moriya.ibaraki.jp",
  	"naka.ibaraki.jp",
  	"namegata.ibaraki.jp",
  	"oarai.ibaraki.jp",
  	"ogawa.ibaraki.jp",
  	"omitama.ibaraki.jp",
  	"ryugasaki.ibaraki.jp",
  	"sakai.ibaraki.jp",
  	"sakuragawa.ibaraki.jp",
  	"shimodate.ibaraki.jp",
  	"shimotsuma.ibaraki.jp",
  	"shirosato.ibaraki.jp",
  	"sowa.ibaraki.jp",
  	"suifu.ibaraki.jp",
  	"takahagi.ibaraki.jp",
  	"tamatsukuri.ibaraki.jp",
  	"tokai.ibaraki.jp",
  	"tomobe.ibaraki.jp",
  	"tone.ibaraki.jp",
  	"toride.ibaraki.jp",
  	"tsuchiura.ibaraki.jp",
  	"tsukuba.ibaraki.jp",
  	"uchihara.ibaraki.jp",
  	"ushiku.ibaraki.jp",
  	"yachiyo.ibaraki.jp",
  	"yamagata.ibaraki.jp",
  	"yawara.ibaraki.jp",
  	"yuki.ibaraki.jp",
  	"anamizu.ishikawa.jp",
  	"hakui.ishikawa.jp",
  	"hakusan.ishikawa.jp",
  	"kaga.ishikawa.jp",
  	"kahoku.ishikawa.jp",
  	"kanazawa.ishikawa.jp",
  	"kawakita.ishikawa.jp",
  	"komatsu.ishikawa.jp",
  	"nakanoto.ishikawa.jp",
  	"nanao.ishikawa.jp",
  	"nomi.ishikawa.jp",
  	"nonoichi.ishikawa.jp",
  	"noto.ishikawa.jp",
  	"shika.ishikawa.jp",
  	"suzu.ishikawa.jp",
  	"tsubata.ishikawa.jp",
  	"tsurugi.ishikawa.jp",
  	"uchinada.ishikawa.jp",
  	"wajima.ishikawa.jp",
  	"fudai.iwate.jp",
  	"fujisawa.iwate.jp",
  	"hanamaki.iwate.jp",
  	"hiraizumi.iwate.jp",
  	"hirono.iwate.jp",
  	"ichinohe.iwate.jp",
  	"ichinoseki.iwate.jp",
  	"iwaizumi.iwate.jp",
  	"iwate.iwate.jp",
  	"joboji.iwate.jp",
  	"kamaishi.iwate.jp",
  	"kanegasaki.iwate.jp",
  	"karumai.iwate.jp",
  	"kawai.iwate.jp",
  	"kitakami.iwate.jp",
  	"kuji.iwate.jp",
  	"kunohe.iwate.jp",
  	"kuzumaki.iwate.jp",
  	"miyako.iwate.jp",
  	"mizusawa.iwate.jp",
  	"morioka.iwate.jp",
  	"ninohe.iwate.jp",
  	"noda.iwate.jp",
  	"ofunato.iwate.jp",
  	"oshu.iwate.jp",
  	"otsuchi.iwate.jp",
  	"rikuzentakata.iwate.jp",
  	"shiwa.iwate.jp",
  	"shizukuishi.iwate.jp",
  	"sumita.iwate.jp",
  	"tanohata.iwate.jp",
  	"tono.iwate.jp",
  	"yahaba.iwate.jp",
  	"yamada.iwate.jp",
  	"ayagawa.kagawa.jp",
  	"higashikagawa.kagawa.jp",
  	"kanonji.kagawa.jp",
  	"kotohira.kagawa.jp",
  	"manno.kagawa.jp",
  	"marugame.kagawa.jp",
  	"mitoyo.kagawa.jp",
  	"naoshima.kagawa.jp",
  	"sanuki.kagawa.jp",
  	"tadotsu.kagawa.jp",
  	"takamatsu.kagawa.jp",
  	"tonosho.kagawa.jp",
  	"uchinomi.kagawa.jp",
  	"utazu.kagawa.jp",
  	"zentsuji.kagawa.jp",
  	"akune.kagoshima.jp",
  	"amami.kagoshima.jp",
  	"hioki.kagoshima.jp",
  	"isa.kagoshima.jp",
  	"isen.kagoshima.jp",
  	"izumi.kagoshima.jp",
  	"kagoshima.kagoshima.jp",
  	"kanoya.kagoshima.jp",
  	"kawanabe.kagoshima.jp",
  	"kinko.kagoshima.jp",
  	"kouyama.kagoshima.jp",
  	"makurazaki.kagoshima.jp",
  	"matsumoto.kagoshima.jp",
  	"minamitane.kagoshima.jp",
  	"nakatane.kagoshima.jp",
  	"nishinoomote.kagoshima.jp",
  	"satsumasendai.kagoshima.jp",
  	"soo.kagoshima.jp",
  	"tarumizu.kagoshima.jp",
  	"yusui.kagoshima.jp",
  	"aikawa.kanagawa.jp",
  	"atsugi.kanagawa.jp",
  	"ayase.kanagawa.jp",
  	"chigasaki.kanagawa.jp",
  	"ebina.kanagawa.jp",
  	"fujisawa.kanagawa.jp",
  	"hadano.kanagawa.jp",
  	"hakone.kanagawa.jp",
  	"hiratsuka.kanagawa.jp",
  	"isehara.kanagawa.jp",
  	"kaisei.kanagawa.jp",
  	"kamakura.kanagawa.jp",
  	"kiyokawa.kanagawa.jp",
  	"matsuda.kanagawa.jp",
  	"minamiashigara.kanagawa.jp",
  	"miura.kanagawa.jp",
  	"nakai.kanagawa.jp",
  	"ninomiya.kanagawa.jp",
  	"odawara.kanagawa.jp",
  	"oi.kanagawa.jp",
  	"oiso.kanagawa.jp",
  	"sagamihara.kanagawa.jp",
  	"samukawa.kanagawa.jp",
  	"tsukui.kanagawa.jp",
  	"yamakita.kanagawa.jp",
  	"yamato.kanagawa.jp",
  	"yokosuka.kanagawa.jp",
  	"yugawara.kanagawa.jp",
  	"zama.kanagawa.jp",
  	"zushi.kanagawa.jp",
  	"aki.kochi.jp",
  	"geisei.kochi.jp",
  	"hidaka.kochi.jp",
  	"higashitsuno.kochi.jp",
  	"ino.kochi.jp",
  	"kagami.kochi.jp",
  	"kami.kochi.jp",
  	"kitagawa.kochi.jp",
  	"kochi.kochi.jp",
  	"mihara.kochi.jp",
  	"motoyama.kochi.jp",
  	"muroto.kochi.jp",
  	"nahari.kochi.jp",
  	"nakamura.kochi.jp",
  	"nankoku.kochi.jp",
  	"nishitosa.kochi.jp",
  	"niyodogawa.kochi.jp",
  	"ochi.kochi.jp",
  	"okawa.kochi.jp",
  	"otoyo.kochi.jp",
  	"otsuki.kochi.jp",
  	"sakawa.kochi.jp",
  	"sukumo.kochi.jp",
  	"susaki.kochi.jp",
  	"tosa.kochi.jp",
  	"tosashimizu.kochi.jp",
  	"toyo.kochi.jp",
  	"tsuno.kochi.jp",
  	"umaji.kochi.jp",
  	"yasuda.kochi.jp",
  	"yusuhara.kochi.jp",
  	"amakusa.kumamoto.jp",
  	"arao.kumamoto.jp",
  	"aso.kumamoto.jp",
  	"choyo.kumamoto.jp",
  	"gyokuto.kumamoto.jp",
  	"kamiamakusa.kumamoto.jp",
  	"kikuchi.kumamoto.jp",
  	"kumamoto.kumamoto.jp",
  	"mashiki.kumamoto.jp",
  	"mifune.kumamoto.jp",
  	"minamata.kumamoto.jp",
  	"minamioguni.kumamoto.jp",
  	"nagasu.kumamoto.jp",
  	"nishihara.kumamoto.jp",
  	"oguni.kumamoto.jp",
  	"ozu.kumamoto.jp",
  	"sumoto.kumamoto.jp",
  	"takamori.kumamoto.jp",
  	"uki.kumamoto.jp",
  	"uto.kumamoto.jp",
  	"yamaga.kumamoto.jp",
  	"yamato.kumamoto.jp",
  	"yatsushiro.kumamoto.jp",
  	"ayabe.kyoto.jp",
  	"fukuchiyama.kyoto.jp",
  	"higashiyama.kyoto.jp",
  	"ide.kyoto.jp",
  	"ine.kyoto.jp",
  	"joyo.kyoto.jp",
  	"kameoka.kyoto.jp",
  	"kamo.kyoto.jp",
  	"kita.kyoto.jp",
  	"kizu.kyoto.jp",
  	"kumiyama.kyoto.jp",
  	"kyotamba.kyoto.jp",
  	"kyotanabe.kyoto.jp",
  	"kyotango.kyoto.jp",
  	"maizuru.kyoto.jp",
  	"minami.kyoto.jp",
  	"minamiyamashiro.kyoto.jp",
  	"miyazu.kyoto.jp",
  	"muko.kyoto.jp",
  	"nagaokakyo.kyoto.jp",
  	"nakagyo.kyoto.jp",
  	"nantan.kyoto.jp",
  	"oyamazaki.kyoto.jp",
  	"sakyo.kyoto.jp",
  	"seika.kyoto.jp",
  	"tanabe.kyoto.jp",
  	"uji.kyoto.jp",
  	"ujitawara.kyoto.jp",
  	"wazuka.kyoto.jp",
  	"yamashina.kyoto.jp",
  	"yawata.kyoto.jp",
  	"asahi.mie.jp",
  	"inabe.mie.jp",
  	"ise.mie.jp",
  	"kameyama.mie.jp",
  	"kawagoe.mie.jp",
  	"kiho.mie.jp",
  	"kisosaki.mie.jp",
  	"kiwa.mie.jp",
  	"komono.mie.jp",
  	"kumano.mie.jp",
  	"kuwana.mie.jp",
  	"matsusaka.mie.jp",
  	"meiwa.mie.jp",
  	"mihama.mie.jp",
  	"minamiise.mie.jp",
  	"misugi.mie.jp",
  	"miyama.mie.jp",
  	"nabari.mie.jp",
  	"shima.mie.jp",
  	"suzuka.mie.jp",
  	"tado.mie.jp",
  	"taiki.mie.jp",
  	"taki.mie.jp",
  	"tamaki.mie.jp",
  	"toba.mie.jp",
  	"tsu.mie.jp",
  	"udono.mie.jp",
  	"ureshino.mie.jp",
  	"watarai.mie.jp",
  	"yokkaichi.mie.jp",
  	"furukawa.miyagi.jp",
  	"higashimatsushima.miyagi.jp",
  	"ishinomaki.miyagi.jp",
  	"iwanuma.miyagi.jp",
  	"kakuda.miyagi.jp",
  	"kami.miyagi.jp",
  	"kawasaki.miyagi.jp",
  	"marumori.miyagi.jp",
  	"matsushima.miyagi.jp",
  	"minamisanriku.miyagi.jp",
  	"misato.miyagi.jp",
  	"murata.miyagi.jp",
  	"natori.miyagi.jp",
  	"ogawara.miyagi.jp",
  	"ohira.miyagi.jp",
  	"onagawa.miyagi.jp",
  	"osaki.miyagi.jp",
  	"rifu.miyagi.jp",
  	"semine.miyagi.jp",
  	"shibata.miyagi.jp",
  	"shichikashuku.miyagi.jp",
  	"shikama.miyagi.jp",
  	"shiogama.miyagi.jp",
  	"shiroishi.miyagi.jp",
  	"tagajo.miyagi.jp",
  	"taiwa.miyagi.jp",
  	"tome.miyagi.jp",
  	"tomiya.miyagi.jp",
  	"wakuya.miyagi.jp",
  	"watari.miyagi.jp",
  	"yamamoto.miyagi.jp",
  	"zao.miyagi.jp",
  	"aya.miyazaki.jp",
  	"ebino.miyazaki.jp",
  	"gokase.miyazaki.jp",
  	"hyuga.miyazaki.jp",
  	"kadogawa.miyazaki.jp",
  	"kawaminami.miyazaki.jp",
  	"kijo.miyazaki.jp",
  	"kitagawa.miyazaki.jp",
  	"kitakata.miyazaki.jp",
  	"kitaura.miyazaki.jp",
  	"kobayashi.miyazaki.jp",
  	"kunitomi.miyazaki.jp",
  	"kushima.miyazaki.jp",
  	"mimata.miyazaki.jp",
  	"miyakonojo.miyazaki.jp",
  	"miyazaki.miyazaki.jp",
  	"morotsuka.miyazaki.jp",
  	"nichinan.miyazaki.jp",
  	"nishimera.miyazaki.jp",
  	"nobeoka.miyazaki.jp",
  	"saito.miyazaki.jp",
  	"shiiba.miyazaki.jp",
  	"shintomi.miyazaki.jp",
  	"takaharu.miyazaki.jp",
  	"takanabe.miyazaki.jp",
  	"takazaki.miyazaki.jp",
  	"tsuno.miyazaki.jp",
  	"achi.nagano.jp",
  	"agematsu.nagano.jp",
  	"anan.nagano.jp",
  	"aoki.nagano.jp",
  	"asahi.nagano.jp",
  	"azumino.nagano.jp",
  	"chikuhoku.nagano.jp",
  	"chikuma.nagano.jp",
  	"chino.nagano.jp",
  	"fujimi.nagano.jp",
  	"hakuba.nagano.jp",
  	"hara.nagano.jp",
  	"hiraya.nagano.jp",
  	"iida.nagano.jp",
  	"iijima.nagano.jp",
  	"iiyama.nagano.jp",
  	"iizuna.nagano.jp",
  	"ikeda.nagano.jp",
  	"ikusaka.nagano.jp",
  	"ina.nagano.jp",
  	"karuizawa.nagano.jp",
  	"kawakami.nagano.jp",
  	"kiso.nagano.jp",
  	"kisofukushima.nagano.jp",
  	"kitaaiki.nagano.jp",
  	"komagane.nagano.jp",
  	"komoro.nagano.jp",
  	"matsukawa.nagano.jp",
  	"matsumoto.nagano.jp",
  	"miasa.nagano.jp",
  	"minamiaiki.nagano.jp",
  	"minamimaki.nagano.jp",
  	"minamiminowa.nagano.jp",
  	"minowa.nagano.jp",
  	"miyada.nagano.jp",
  	"miyota.nagano.jp",
  	"mochizuki.nagano.jp",
  	"nagano.nagano.jp",
  	"nagawa.nagano.jp",
  	"nagiso.nagano.jp",
  	"nakagawa.nagano.jp",
  	"nakano.nagano.jp",
  	"nozawaonsen.nagano.jp",
  	"obuse.nagano.jp",
  	"ogawa.nagano.jp",
  	"okaya.nagano.jp",
  	"omachi.nagano.jp",
  	"omi.nagano.jp",
  	"ookuwa.nagano.jp",
  	"ooshika.nagano.jp",
  	"otaki.nagano.jp",
  	"otari.nagano.jp",
  	"sakae.nagano.jp",
  	"sakaki.nagano.jp",
  	"saku.nagano.jp",
  	"sakuho.nagano.jp",
  	"shimosuwa.nagano.jp",
  	"shinanomachi.nagano.jp",
  	"shiojiri.nagano.jp",
  	"suwa.nagano.jp",
  	"suzaka.nagano.jp",
  	"takagi.nagano.jp",
  	"takamori.nagano.jp",
  	"takayama.nagano.jp",
  	"tateshina.nagano.jp",
  	"tatsuno.nagano.jp",
  	"togakushi.nagano.jp",
  	"togura.nagano.jp",
  	"tomi.nagano.jp",
  	"ueda.nagano.jp",
  	"wada.nagano.jp",
  	"yamagata.nagano.jp",
  	"yamanouchi.nagano.jp",
  	"yasaka.nagano.jp",
  	"yasuoka.nagano.jp",
  	"chijiwa.nagasaki.jp",
  	"futsu.nagasaki.jp",
  	"goto.nagasaki.jp",
  	"hasami.nagasaki.jp",
  	"hirado.nagasaki.jp",
  	"iki.nagasaki.jp",
  	"isahaya.nagasaki.jp",
  	"kawatana.nagasaki.jp",
  	"kuchinotsu.nagasaki.jp",
  	"matsuura.nagasaki.jp",
  	"nagasaki.nagasaki.jp",
  	"obama.nagasaki.jp",
  	"omura.nagasaki.jp",
  	"oseto.nagasaki.jp",
  	"saikai.nagasaki.jp",
  	"sasebo.nagasaki.jp",
  	"seihi.nagasaki.jp",
  	"shimabara.nagasaki.jp",
  	"shinkamigoto.nagasaki.jp",
  	"togitsu.nagasaki.jp",
  	"tsushima.nagasaki.jp",
  	"unzen.nagasaki.jp",
  	"ando.nara.jp",
  	"gose.nara.jp",
  	"heguri.nara.jp",
  	"higashiyoshino.nara.jp",
  	"ikaruga.nara.jp",
  	"ikoma.nara.jp",
  	"kamikitayama.nara.jp",
  	"kanmaki.nara.jp",
  	"kashiba.nara.jp",
  	"kashihara.nara.jp",
  	"katsuragi.nara.jp",
  	"kawai.nara.jp",
  	"kawakami.nara.jp",
  	"kawanishi.nara.jp",
  	"koryo.nara.jp",
  	"kurotaki.nara.jp",
  	"mitsue.nara.jp",
  	"miyake.nara.jp",
  	"nara.nara.jp",
  	"nosegawa.nara.jp",
  	"oji.nara.jp",
  	"ouda.nara.jp",
  	"oyodo.nara.jp",
  	"sakurai.nara.jp",
  	"sango.nara.jp",
  	"shimoichi.nara.jp",
  	"shimokitayama.nara.jp",
  	"shinjo.nara.jp",
  	"soni.nara.jp",
  	"takatori.nara.jp",
  	"tawaramoto.nara.jp",
  	"tenkawa.nara.jp",
  	"tenri.nara.jp",
  	"uda.nara.jp",
  	"yamatokoriyama.nara.jp",
  	"yamatotakada.nara.jp",
  	"yamazoe.nara.jp",
  	"yoshino.nara.jp",
  	"aga.niigata.jp",
  	"agano.niigata.jp",
  	"gosen.niigata.jp",
  	"itoigawa.niigata.jp",
  	"izumozaki.niigata.jp",
  	"joetsu.niigata.jp",
  	"kamo.niigata.jp",
  	"kariwa.niigata.jp",
  	"kashiwazaki.niigata.jp",
  	"minamiuonuma.niigata.jp",
  	"mitsuke.niigata.jp",
  	"muika.niigata.jp",
  	"murakami.niigata.jp",
  	"myoko.niigata.jp",
  	"nagaoka.niigata.jp",
  	"niigata.niigata.jp",
  	"ojiya.niigata.jp",
  	"omi.niigata.jp",
  	"sado.niigata.jp",
  	"sanjo.niigata.jp",
  	"seiro.niigata.jp",
  	"seirou.niigata.jp",
  	"sekikawa.niigata.jp",
  	"shibata.niigata.jp",
  	"tagami.niigata.jp",
  	"tainai.niigata.jp",
  	"tochio.niigata.jp",
  	"tokamachi.niigata.jp",
  	"tsubame.niigata.jp",
  	"tsunan.niigata.jp",
  	"uonuma.niigata.jp",
  	"yahiko.niigata.jp",
  	"yoita.niigata.jp",
  	"yuzawa.niigata.jp",
  	"beppu.oita.jp",
  	"bungoono.oita.jp",
  	"bungotakada.oita.jp",
  	"hasama.oita.jp",
  	"hiji.oita.jp",
  	"himeshima.oita.jp",
  	"hita.oita.jp",
  	"kamitsue.oita.jp",
  	"kokonoe.oita.jp",
  	"kuju.oita.jp",
  	"kunisaki.oita.jp",
  	"kusu.oita.jp",
  	"oita.oita.jp",
  	"saiki.oita.jp",
  	"taketa.oita.jp",
  	"tsukumi.oita.jp",
  	"usa.oita.jp",
  	"usuki.oita.jp",
  	"yufu.oita.jp",
  	"akaiwa.okayama.jp",
  	"asakuchi.okayama.jp",
  	"bizen.okayama.jp",
  	"hayashima.okayama.jp",
  	"ibara.okayama.jp",
  	"kagamino.okayama.jp",
  	"kasaoka.okayama.jp",
  	"kibichuo.okayama.jp",
  	"kumenan.okayama.jp",
  	"kurashiki.okayama.jp",
  	"maniwa.okayama.jp",
  	"misaki.okayama.jp",
  	"nagi.okayama.jp",
  	"niimi.okayama.jp",
  	"nishiawakura.okayama.jp",
  	"okayama.okayama.jp",
  	"satosho.okayama.jp",
  	"setouchi.okayama.jp",
  	"shinjo.okayama.jp",
  	"shoo.okayama.jp",
  	"soja.okayama.jp",
  	"takahashi.okayama.jp",
  	"tamano.okayama.jp",
  	"tsuyama.okayama.jp",
  	"wake.okayama.jp",
  	"yakage.okayama.jp",
  	"aguni.okinawa.jp",
  	"ginowan.okinawa.jp",
  	"ginoza.okinawa.jp",
  	"gushikami.okinawa.jp",
  	"haebaru.okinawa.jp",
  	"higashi.okinawa.jp",
  	"hirara.okinawa.jp",
  	"iheya.okinawa.jp",
  	"ishigaki.okinawa.jp",
  	"ishikawa.okinawa.jp",
  	"itoman.okinawa.jp",
  	"izena.okinawa.jp",
  	"kadena.okinawa.jp",
  	"kin.okinawa.jp",
  	"kitadaito.okinawa.jp",
  	"kitanakagusuku.okinawa.jp",
  	"kumejima.okinawa.jp",
  	"kunigami.okinawa.jp",
  	"minamidaito.okinawa.jp",
  	"motobu.okinawa.jp",
  	"nago.okinawa.jp",
  	"naha.okinawa.jp",
  	"nakagusuku.okinawa.jp",
  	"nakijin.okinawa.jp",
  	"nanjo.okinawa.jp",
  	"nishihara.okinawa.jp",
  	"ogimi.okinawa.jp",
  	"okinawa.okinawa.jp",
  	"onna.okinawa.jp",
  	"shimoji.okinawa.jp",
  	"taketomi.okinawa.jp",
  	"tarama.okinawa.jp",
  	"tokashiki.okinawa.jp",
  	"tomigusuku.okinawa.jp",
  	"tonaki.okinawa.jp",
  	"urasoe.okinawa.jp",
  	"uruma.okinawa.jp",
  	"yaese.okinawa.jp",
  	"yomitan.okinawa.jp",
  	"yonabaru.okinawa.jp",
  	"yonaguni.okinawa.jp",
  	"zamami.okinawa.jp",
  	"abeno.osaka.jp",
  	"chihayaakasaka.osaka.jp",
  	"chuo.osaka.jp",
  	"daito.osaka.jp",
  	"fujiidera.osaka.jp",
  	"habikino.osaka.jp",
  	"hannan.osaka.jp",
  	"higashiosaka.osaka.jp",
  	"higashisumiyoshi.osaka.jp",
  	"higashiyodogawa.osaka.jp",
  	"hirakata.osaka.jp",
  	"ibaraki.osaka.jp",
  	"ikeda.osaka.jp",
  	"izumi.osaka.jp",
  	"izumiotsu.osaka.jp",
  	"izumisano.osaka.jp",
  	"kadoma.osaka.jp",
  	"kaizuka.osaka.jp",
  	"kanan.osaka.jp",
  	"kashiwara.osaka.jp",
  	"katano.osaka.jp",
  	"kawachinagano.osaka.jp",
  	"kishiwada.osaka.jp",
  	"kita.osaka.jp",
  	"kumatori.osaka.jp",
  	"matsubara.osaka.jp",
  	"minato.osaka.jp",
  	"minoh.osaka.jp",
  	"misaki.osaka.jp",
  	"moriguchi.osaka.jp",
  	"neyagawa.osaka.jp",
  	"nishi.osaka.jp",
  	"nose.osaka.jp",
  	"osakasayama.osaka.jp",
  	"sakai.osaka.jp",
  	"sayama.osaka.jp",
  	"sennan.osaka.jp",
  	"settsu.osaka.jp",
  	"shijonawate.osaka.jp",
  	"shimamoto.osaka.jp",
  	"suita.osaka.jp",
  	"tadaoka.osaka.jp",
  	"taishi.osaka.jp",
  	"tajiri.osaka.jp",
  	"takaishi.osaka.jp",
  	"takatsuki.osaka.jp",
  	"tondabayashi.osaka.jp",
  	"toyonaka.osaka.jp",
  	"toyono.osaka.jp",
  	"yao.osaka.jp",
  	"ariake.saga.jp",
  	"arita.saga.jp",
  	"fukudomi.saga.jp",
  	"genkai.saga.jp",
  	"hamatama.saga.jp",
  	"hizen.saga.jp",
  	"imari.saga.jp",
  	"kamimine.saga.jp",
  	"kanzaki.saga.jp",
  	"karatsu.saga.jp",
  	"kashima.saga.jp",
  	"kitagata.saga.jp",
  	"kitahata.saga.jp",
  	"kiyama.saga.jp",
  	"kouhoku.saga.jp",
  	"kyuragi.saga.jp",
  	"nishiarita.saga.jp",
  	"ogi.saga.jp",
  	"omachi.saga.jp",
  	"ouchi.saga.jp",
  	"saga.saga.jp",
  	"shiroishi.saga.jp",
  	"taku.saga.jp",
  	"tara.saga.jp",
  	"tosu.saga.jp",
  	"yoshinogari.saga.jp",
  	"arakawa.saitama.jp",
  	"asaka.saitama.jp",
  	"chichibu.saitama.jp",
  	"fujimi.saitama.jp",
  	"fujimino.saitama.jp",
  	"fukaya.saitama.jp",
  	"hanno.saitama.jp",
  	"hanyu.saitama.jp",
  	"hasuda.saitama.jp",
  	"hatogaya.saitama.jp",
  	"hatoyama.saitama.jp",
  	"hidaka.saitama.jp",
  	"higashichichibu.saitama.jp",
  	"higashimatsuyama.saitama.jp",
  	"honjo.saitama.jp",
  	"ina.saitama.jp",
  	"iruma.saitama.jp",
  	"iwatsuki.saitama.jp",
  	"kamiizumi.saitama.jp",
  	"kamikawa.saitama.jp",
  	"kamisato.saitama.jp",
  	"kasukabe.saitama.jp",
  	"kawagoe.saitama.jp",
  	"kawaguchi.saitama.jp",
  	"kawajima.saitama.jp",
  	"kazo.saitama.jp",
  	"kitamoto.saitama.jp",
  	"koshigaya.saitama.jp",
  	"kounosu.saitama.jp",
  	"kuki.saitama.jp",
  	"kumagaya.saitama.jp",
  	"matsubushi.saitama.jp",
  	"minano.saitama.jp",
  	"misato.saitama.jp",
  	"miyashiro.saitama.jp",
  	"miyoshi.saitama.jp",
  	"moroyama.saitama.jp",
  	"nagatoro.saitama.jp",
  	"namegawa.saitama.jp",
  	"niiza.saitama.jp",
  	"ogano.saitama.jp",
  	"ogawa.saitama.jp",
  	"ogose.saitama.jp",
  	"okegawa.saitama.jp",
  	"omiya.saitama.jp",
  	"otaki.saitama.jp",
  	"ranzan.saitama.jp",
  	"ryokami.saitama.jp",
  	"saitama.saitama.jp",
  	"sakado.saitama.jp",
  	"satte.saitama.jp",
  	"sayama.saitama.jp",
  	"shiki.saitama.jp",
  	"shiraoka.saitama.jp",
  	"soka.saitama.jp",
  	"sugito.saitama.jp",
  	"toda.saitama.jp",
  	"tokigawa.saitama.jp",
  	"tokorozawa.saitama.jp",
  	"tsurugashima.saitama.jp",
  	"urawa.saitama.jp",
  	"warabi.saitama.jp",
  	"yashio.saitama.jp",
  	"yokoze.saitama.jp",
  	"yono.saitama.jp",
  	"yorii.saitama.jp",
  	"yoshida.saitama.jp",
  	"yoshikawa.saitama.jp",
  	"yoshimi.saitama.jp",
  	"aisho.shiga.jp",
  	"gamo.shiga.jp",
  	"higashiomi.shiga.jp",
  	"hikone.shiga.jp",
  	"koka.shiga.jp",
  	"konan.shiga.jp",
  	"kosei.shiga.jp",
  	"koto.shiga.jp",
  	"kusatsu.shiga.jp",
  	"maibara.shiga.jp",
  	"moriyama.shiga.jp",
  	"nagahama.shiga.jp",
  	"nishiazai.shiga.jp",
  	"notogawa.shiga.jp",
  	"omihachiman.shiga.jp",
  	"otsu.shiga.jp",
  	"ritto.shiga.jp",
  	"ryuoh.shiga.jp",
  	"takashima.shiga.jp",
  	"takatsuki.shiga.jp",
  	"torahime.shiga.jp",
  	"toyosato.shiga.jp",
  	"yasu.shiga.jp",
  	"akagi.shimane.jp",
  	"ama.shimane.jp",
  	"gotsu.shimane.jp",
  	"hamada.shimane.jp",
  	"higashiizumo.shimane.jp",
  	"hikawa.shimane.jp",
  	"hikimi.shimane.jp",
  	"izumo.shimane.jp",
  	"kakinoki.shimane.jp",
  	"masuda.shimane.jp",
  	"matsue.shimane.jp",
  	"misato.shimane.jp",
  	"nishinoshima.shimane.jp",
  	"ohda.shimane.jp",
  	"okinoshima.shimane.jp",
  	"okuizumo.shimane.jp",
  	"shimane.shimane.jp",
  	"tamayu.shimane.jp",
  	"tsuwano.shimane.jp",
  	"unnan.shimane.jp",
  	"yakumo.shimane.jp",
  	"yasugi.shimane.jp",
  	"yatsuka.shimane.jp",
  	"arai.shizuoka.jp",
  	"atami.shizuoka.jp",
  	"fuji.shizuoka.jp",
  	"fujieda.shizuoka.jp",
  	"fujikawa.shizuoka.jp",
  	"fujinomiya.shizuoka.jp",
  	"fukuroi.shizuoka.jp",
  	"gotemba.shizuoka.jp",
  	"haibara.shizuoka.jp",
  	"hamamatsu.shizuoka.jp",
  	"higashiizu.shizuoka.jp",
  	"ito.shizuoka.jp",
  	"iwata.shizuoka.jp",
  	"izu.shizuoka.jp",
  	"izunokuni.shizuoka.jp",
  	"kakegawa.shizuoka.jp",
  	"kannami.shizuoka.jp",
  	"kawanehon.shizuoka.jp",
  	"kawazu.shizuoka.jp",
  	"kikugawa.shizuoka.jp",
  	"kosai.shizuoka.jp",
  	"makinohara.shizuoka.jp",
  	"matsuzaki.shizuoka.jp",
  	"minamiizu.shizuoka.jp",
  	"mishima.shizuoka.jp",
  	"morimachi.shizuoka.jp",
  	"nishiizu.shizuoka.jp",
  	"numazu.shizuoka.jp",
  	"omaezaki.shizuoka.jp",
  	"shimada.shizuoka.jp",
  	"shimizu.shizuoka.jp",
  	"shimoda.shizuoka.jp",
  	"shizuoka.shizuoka.jp",
  	"susono.shizuoka.jp",
  	"yaizu.shizuoka.jp",
  	"yoshida.shizuoka.jp",
  	"ashikaga.tochigi.jp",
  	"bato.tochigi.jp",
  	"haga.tochigi.jp",
  	"ichikai.tochigi.jp",
  	"iwafune.tochigi.jp",
  	"kaminokawa.tochigi.jp",
  	"kanuma.tochigi.jp",
  	"karasuyama.tochigi.jp",
  	"kuroiso.tochigi.jp",
  	"mashiko.tochigi.jp",
  	"mibu.tochigi.jp",
  	"moka.tochigi.jp",
  	"motegi.tochigi.jp",
  	"nasu.tochigi.jp",
  	"nasushiobara.tochigi.jp",
  	"nikko.tochigi.jp",
  	"nishikata.tochigi.jp",
  	"nogi.tochigi.jp",
  	"ohira.tochigi.jp",
  	"ohtawara.tochigi.jp",
  	"oyama.tochigi.jp",
  	"sakura.tochigi.jp",
  	"sano.tochigi.jp",
  	"shimotsuke.tochigi.jp",
  	"shioya.tochigi.jp",
  	"takanezawa.tochigi.jp",
  	"tochigi.tochigi.jp",
  	"tsuga.tochigi.jp",
  	"ujiie.tochigi.jp",
  	"utsunomiya.tochigi.jp",
  	"yaita.tochigi.jp",
  	"aizumi.tokushima.jp",
  	"anan.tokushima.jp",
  	"ichiba.tokushima.jp",
  	"itano.tokushima.jp",
  	"kainan.tokushima.jp",
  	"komatsushima.tokushima.jp",
  	"matsushige.tokushima.jp",
  	"mima.tokushima.jp",
  	"minami.tokushima.jp",
  	"miyoshi.tokushima.jp",
  	"mugi.tokushima.jp",
  	"nakagawa.tokushima.jp",
  	"naruto.tokushima.jp",
  	"sanagochi.tokushima.jp",
  	"shishikui.tokushima.jp",
  	"tokushima.tokushima.jp",
  	"wajiki.tokushima.jp",
  	"adachi.tokyo.jp",
  	"akiruno.tokyo.jp",
  	"akishima.tokyo.jp",
  	"aogashima.tokyo.jp",
  	"arakawa.tokyo.jp",
  	"bunkyo.tokyo.jp",
  	"chiyoda.tokyo.jp",
  	"chofu.tokyo.jp",
  	"chuo.tokyo.jp",
  	"edogawa.tokyo.jp",
  	"fuchu.tokyo.jp",
  	"fussa.tokyo.jp",
  	"hachijo.tokyo.jp",
  	"hachioji.tokyo.jp",
  	"hamura.tokyo.jp",
  	"higashikurume.tokyo.jp",
  	"higashimurayama.tokyo.jp",
  	"higashiyamato.tokyo.jp",
  	"hino.tokyo.jp",
  	"hinode.tokyo.jp",
  	"hinohara.tokyo.jp",
  	"inagi.tokyo.jp",
  	"itabashi.tokyo.jp",
  	"katsushika.tokyo.jp",
  	"kita.tokyo.jp",
  	"kiyose.tokyo.jp",
  	"kodaira.tokyo.jp",
  	"koganei.tokyo.jp",
  	"kokubunji.tokyo.jp",
  	"komae.tokyo.jp",
  	"koto.tokyo.jp",
  	"kouzushima.tokyo.jp",
  	"kunitachi.tokyo.jp",
  	"machida.tokyo.jp",
  	"meguro.tokyo.jp",
  	"minato.tokyo.jp",
  	"mitaka.tokyo.jp",
  	"mizuho.tokyo.jp",
  	"musashimurayama.tokyo.jp",
  	"musashino.tokyo.jp",
  	"nakano.tokyo.jp",
  	"nerima.tokyo.jp",
  	"ogasawara.tokyo.jp",
  	"okutama.tokyo.jp",
  	"ome.tokyo.jp",
  	"oshima.tokyo.jp",
  	"ota.tokyo.jp",
  	"setagaya.tokyo.jp",
  	"shibuya.tokyo.jp",
  	"shinagawa.tokyo.jp",
  	"shinjuku.tokyo.jp",
  	"suginami.tokyo.jp",
  	"sumida.tokyo.jp",
  	"tachikawa.tokyo.jp",
  	"taito.tokyo.jp",
  	"tama.tokyo.jp",
  	"toshima.tokyo.jp",
  	"chizu.tottori.jp",
  	"hino.tottori.jp",
  	"kawahara.tottori.jp",
  	"koge.tottori.jp",
  	"kotoura.tottori.jp",
  	"misasa.tottori.jp",
  	"nanbu.tottori.jp",
  	"nichinan.tottori.jp",
  	"sakaiminato.tottori.jp",
  	"tottori.tottori.jp",
  	"wakasa.tottori.jp",
  	"yazu.tottori.jp",
  	"yonago.tottori.jp",
  	"asahi.toyama.jp",
  	"fuchu.toyama.jp",
  	"fukumitsu.toyama.jp",
  	"funahashi.toyama.jp",
  	"himi.toyama.jp",
  	"imizu.toyama.jp",
  	"inami.toyama.jp",
  	"johana.toyama.jp",
  	"kamiichi.toyama.jp",
  	"kurobe.toyama.jp",
  	"nakaniikawa.toyama.jp",
  	"namerikawa.toyama.jp",
  	"nanto.toyama.jp",
  	"nyuzen.toyama.jp",
  	"oyabe.toyama.jp",
  	"taira.toyama.jp",
  	"takaoka.toyama.jp",
  	"tateyama.toyama.jp",
  	"toga.toyama.jp",
  	"tonami.toyama.jp",
  	"toyama.toyama.jp",
  	"unazuki.toyama.jp",
  	"uozu.toyama.jp",
  	"yamada.toyama.jp",
  	"arida.wakayama.jp",
  	"aridagawa.wakayama.jp",
  	"gobo.wakayama.jp",
  	"hashimoto.wakayama.jp",
  	"hidaka.wakayama.jp",
  	"hirogawa.wakayama.jp",
  	"inami.wakayama.jp",
  	"iwade.wakayama.jp",
  	"kainan.wakayama.jp",
  	"kamitonda.wakayama.jp",
  	"katsuragi.wakayama.jp",
  	"kimino.wakayama.jp",
  	"kinokawa.wakayama.jp",
  	"kitayama.wakayama.jp",
  	"koya.wakayama.jp",
  	"koza.wakayama.jp",
  	"kozagawa.wakayama.jp",
  	"kudoyama.wakayama.jp",
  	"kushimoto.wakayama.jp",
  	"mihama.wakayama.jp",
  	"misato.wakayama.jp",
  	"nachikatsuura.wakayama.jp",
  	"shingu.wakayama.jp",
  	"shirahama.wakayama.jp",
  	"taiji.wakayama.jp",
  	"tanabe.wakayama.jp",
  	"wakayama.wakayama.jp",
  	"yuasa.wakayama.jp",
  	"yura.wakayama.jp",
  	"asahi.yamagata.jp",
  	"funagata.yamagata.jp",
  	"higashine.yamagata.jp",
  	"iide.yamagata.jp",
  	"kahoku.yamagata.jp",
  	"kaminoyama.yamagata.jp",
  	"kaneyama.yamagata.jp",
  	"kawanishi.yamagata.jp",
  	"mamurogawa.yamagata.jp",
  	"mikawa.yamagata.jp",
  	"murayama.yamagata.jp",
  	"nagai.yamagata.jp",
  	"nakayama.yamagata.jp",
  	"nanyo.yamagata.jp",
  	"nishikawa.yamagata.jp",
  	"obanazawa.yamagata.jp",
  	"oe.yamagata.jp",
  	"oguni.yamagata.jp",
  	"ohkura.yamagata.jp",
  	"oishida.yamagata.jp",
  	"sagae.yamagata.jp",
  	"sakata.yamagata.jp",
  	"sakegawa.yamagata.jp",
  	"shinjo.yamagata.jp",
  	"shirataka.yamagata.jp",
  	"shonai.yamagata.jp",
  	"takahata.yamagata.jp",
  	"tendo.yamagata.jp",
  	"tozawa.yamagata.jp",
  	"tsuruoka.yamagata.jp",
  	"yamagata.yamagata.jp",
  	"yamanobe.yamagata.jp",
  	"yonezawa.yamagata.jp",
  	"yuza.yamagata.jp",
  	"abu.yamaguchi.jp",
  	"hagi.yamaguchi.jp",
  	"hikari.yamaguchi.jp",
  	"hofu.yamaguchi.jp",
  	"iwakuni.yamaguchi.jp",
  	"kudamatsu.yamaguchi.jp",
  	"mitou.yamaguchi.jp",
  	"nagato.yamaguchi.jp",
  	"oshima.yamaguchi.jp",
  	"shimonoseki.yamaguchi.jp",
  	"shunan.yamaguchi.jp",
  	"tabuse.yamaguchi.jp",
  	"tokuyama.yamaguchi.jp",
  	"toyota.yamaguchi.jp",
  	"ube.yamaguchi.jp",
  	"yuu.yamaguchi.jp",
  	"chuo.yamanashi.jp",
  	"doshi.yamanashi.jp",
  	"fuefuki.yamanashi.jp",
  	"fujikawa.yamanashi.jp",
  	"fujikawaguchiko.yamanashi.jp",
  	"fujiyoshida.yamanashi.jp",
  	"hayakawa.yamanashi.jp",
  	"hokuto.yamanashi.jp",
  	"ichikawamisato.yamanashi.jp",
  	"kai.yamanashi.jp",
  	"kofu.yamanashi.jp",
  	"koshu.yamanashi.jp",
  	"kosuge.yamanashi.jp",
  	"minami-alps.yamanashi.jp",
  	"minobu.yamanashi.jp",
  	"nakamichi.yamanashi.jp",
  	"nanbu.yamanashi.jp",
  	"narusawa.yamanashi.jp",
  	"nirasaki.yamanashi.jp",
  	"nishikatsura.yamanashi.jp",
  	"oshino.yamanashi.jp",
  	"otsuki.yamanashi.jp",
  	"showa.yamanashi.jp",
  	"tabayama.yamanashi.jp",
  	"tsuru.yamanashi.jp",
  	"uenohara.yamanashi.jp",
  	"yamanakako.yamanashi.jp",
  	"yamanashi.yamanashi.jp",
  	"ke",
  	"ac.ke",
  	"co.ke",
  	"go.ke",
  	"info.ke",
  	"me.ke",
  	"mobi.ke",
  	"ne.ke",
  	"or.ke",
  	"sc.ke",
  	"kg",
  	"org.kg",
  	"net.kg",
  	"com.kg",
  	"edu.kg",
  	"gov.kg",
  	"mil.kg",
  	"*.kh",
  	"ki",
  	"edu.ki",
  	"biz.ki",
  	"net.ki",
  	"org.ki",
  	"gov.ki",
  	"info.ki",
  	"com.ki",
  	"km",
  	"org.km",
  	"nom.km",
  	"gov.km",
  	"prd.km",
  	"tm.km",
  	"edu.km",
  	"mil.km",
  	"ass.km",
  	"com.km",
  	"coop.km",
  	"asso.km",
  	"presse.km",
  	"medecin.km",
  	"notaires.km",
  	"pharmaciens.km",
  	"veterinaire.km",
  	"gouv.km",
  	"kn",
  	"net.kn",
  	"org.kn",
  	"edu.kn",
  	"gov.kn",
  	"kp",
  	"com.kp",
  	"edu.kp",
  	"gov.kp",
  	"org.kp",
  	"rep.kp",
  	"tra.kp",
  	"kr",
  	"ac.kr",
  	"co.kr",
  	"es.kr",
  	"go.kr",
  	"hs.kr",
  	"kg.kr",
  	"mil.kr",
  	"ms.kr",
  	"ne.kr",
  	"or.kr",
  	"pe.kr",
  	"re.kr",
  	"sc.kr",
  	"busan.kr",
  	"chungbuk.kr",
  	"chungnam.kr",
  	"daegu.kr",
  	"daejeon.kr",
  	"gangwon.kr",
  	"gwangju.kr",
  	"gyeongbuk.kr",
  	"gyeonggi.kr",
  	"gyeongnam.kr",
  	"incheon.kr",
  	"jeju.kr",
  	"jeonbuk.kr",
  	"jeonnam.kr",
  	"seoul.kr",
  	"ulsan.kr",
  	"kw",
  	"com.kw",
  	"edu.kw",
  	"emb.kw",
  	"gov.kw",
  	"ind.kw",
  	"net.kw",
  	"org.kw",
  	"ky",
  	"com.ky",
  	"edu.ky",
  	"net.ky",
  	"org.ky",
  	"kz",
  	"org.kz",
  	"edu.kz",
  	"net.kz",
  	"gov.kz",
  	"mil.kz",
  	"com.kz",
  	"la",
  	"int.la",
  	"net.la",
  	"info.la",
  	"edu.la",
  	"gov.la",
  	"per.la",
  	"com.la",
  	"org.la",
  	"lb",
  	"com.lb",
  	"edu.lb",
  	"gov.lb",
  	"net.lb",
  	"org.lb",
  	"lc",
  	"com.lc",
  	"net.lc",
  	"co.lc",
  	"org.lc",
  	"edu.lc",
  	"gov.lc",
  	"li",
  	"lk",
  	"gov.lk",
  	"sch.lk",
  	"net.lk",
  	"int.lk",
  	"com.lk",
  	"org.lk",
  	"edu.lk",
  	"ngo.lk",
  	"soc.lk",
  	"web.lk",
  	"ltd.lk",
  	"assn.lk",
  	"grp.lk",
  	"hotel.lk",
  	"ac.lk",
  	"lr",
  	"com.lr",
  	"edu.lr",
  	"gov.lr",
  	"org.lr",
  	"net.lr",
  	"ls",
  	"ac.ls",
  	"biz.ls",
  	"co.ls",
  	"edu.ls",
  	"gov.ls",
  	"info.ls",
  	"net.ls",
  	"org.ls",
  	"sc.ls",
  	"lt",
  	"gov.lt",
  	"lu",
  	"lv",
  	"com.lv",
  	"edu.lv",
  	"gov.lv",
  	"org.lv",
  	"mil.lv",
  	"id.lv",
  	"net.lv",
  	"asn.lv",
  	"conf.lv",
  	"ly",
  	"com.ly",
  	"net.ly",
  	"gov.ly",
  	"plc.ly",
  	"edu.ly",
  	"sch.ly",
  	"med.ly",
  	"org.ly",
  	"id.ly",
  	"ma",
  	"co.ma",
  	"net.ma",
  	"gov.ma",
  	"org.ma",
  	"ac.ma",
  	"press.ma",
  	"mc",
  	"tm.mc",
  	"asso.mc",
  	"md",
  	"me",
  	"co.me",
  	"net.me",
  	"org.me",
  	"edu.me",
  	"ac.me",
  	"gov.me",
  	"its.me",
  	"priv.me",
  	"mg",
  	"org.mg",
  	"nom.mg",
  	"gov.mg",
  	"prd.mg",
  	"tm.mg",
  	"edu.mg",
  	"mil.mg",
  	"com.mg",
  	"co.mg",
  	"mh",
  	"mil",
  	"mk",
  	"com.mk",
  	"org.mk",
  	"net.mk",
  	"edu.mk",
  	"gov.mk",
  	"inf.mk",
  	"name.mk",
  	"ml",
  	"com.ml",
  	"edu.ml",
  	"gouv.ml",
  	"gov.ml",
  	"net.ml",
  	"org.ml",
  	"presse.ml",
  	"*.mm",
  	"mn",
  	"gov.mn",
  	"edu.mn",
  	"org.mn",
  	"mo",
  	"com.mo",
  	"net.mo",
  	"org.mo",
  	"edu.mo",
  	"gov.mo",
  	"mobi",
  	"mp",
  	"mq",
  	"mr",
  	"gov.mr",
  	"ms",
  	"com.ms",
  	"edu.ms",
  	"gov.ms",
  	"net.ms",
  	"org.ms",
  	"mt",
  	"com.mt",
  	"edu.mt",
  	"net.mt",
  	"org.mt",
  	"mu",
  	"com.mu",
  	"net.mu",
  	"org.mu",
  	"gov.mu",
  	"ac.mu",
  	"co.mu",
  	"or.mu",
  	"museum",
  	"academy.museum",
  	"agriculture.museum",
  	"air.museum",
  	"airguard.museum",
  	"alabama.museum",
  	"alaska.museum",
  	"amber.museum",
  	"ambulance.museum",
  	"american.museum",
  	"americana.museum",
  	"americanantiques.museum",
  	"americanart.museum",
  	"amsterdam.museum",
  	"and.museum",
  	"annefrank.museum",
  	"anthro.museum",
  	"anthropology.museum",
  	"antiques.museum",
  	"aquarium.museum",
  	"arboretum.museum",
  	"archaeological.museum",
  	"archaeology.museum",
  	"architecture.museum",
  	"art.museum",
  	"artanddesign.museum",
  	"artcenter.museum",
  	"artdeco.museum",
  	"arteducation.museum",
  	"artgallery.museum",
  	"arts.museum",
  	"artsandcrafts.museum",
  	"asmatart.museum",
  	"assassination.museum",
  	"assisi.museum",
  	"association.museum",
  	"astronomy.museum",
  	"atlanta.museum",
  	"austin.museum",
  	"australia.museum",
  	"automotive.museum",
  	"aviation.museum",
  	"axis.museum",
  	"badajoz.museum",
  	"baghdad.museum",
  	"bahn.museum",
  	"bale.museum",
  	"baltimore.museum",
  	"barcelona.museum",
  	"baseball.museum",
  	"basel.museum",
  	"baths.museum",
  	"bauern.museum",
  	"beauxarts.museum",
  	"beeldengeluid.museum",
  	"bellevue.museum",
  	"bergbau.museum",
  	"berkeley.museum",
  	"berlin.museum",
  	"bern.museum",
  	"bible.museum",
  	"bilbao.museum",
  	"bill.museum",
  	"birdart.museum",
  	"birthplace.museum",
  	"bonn.museum",
  	"boston.museum",
  	"botanical.museum",
  	"botanicalgarden.museum",
  	"botanicgarden.museum",
  	"botany.museum",
  	"brandywinevalley.museum",
  	"brasil.museum",
  	"bristol.museum",
  	"british.museum",
  	"britishcolumbia.museum",
  	"broadcast.museum",
  	"brunel.museum",
  	"brussel.museum",
  	"brussels.museum",
  	"bruxelles.museum",
  	"building.museum",
  	"burghof.museum",
  	"bus.museum",
  	"bushey.museum",
  	"cadaques.museum",
  	"california.museum",
  	"cambridge.museum",
  	"can.museum",
  	"canada.museum",
  	"capebreton.museum",
  	"carrier.museum",
  	"cartoonart.museum",
  	"casadelamoneda.museum",
  	"castle.museum",
  	"castres.museum",
  	"celtic.museum",
  	"center.museum",
  	"chattanooga.museum",
  	"cheltenham.museum",
  	"chesapeakebay.museum",
  	"chicago.museum",
  	"children.museum",
  	"childrens.museum",
  	"childrensgarden.museum",
  	"chiropractic.museum",
  	"chocolate.museum",
  	"christiansburg.museum",
  	"cincinnati.museum",
  	"cinema.museum",
  	"circus.museum",
  	"civilisation.museum",
  	"civilization.museum",
  	"civilwar.museum",
  	"clinton.museum",
  	"clock.museum",
  	"coal.museum",
  	"coastaldefence.museum",
  	"cody.museum",
  	"coldwar.museum",
  	"collection.museum",
  	"colonialwilliamsburg.museum",
  	"coloradoplateau.museum",
  	"columbia.museum",
  	"columbus.museum",
  	"communication.museum",
  	"communications.museum",
  	"community.museum",
  	"computer.museum",
  	"computerhistory.museum",
  	"comunicações.museum",
  	"contemporary.museum",
  	"contemporaryart.museum",
  	"convent.museum",
  	"copenhagen.museum",
  	"corporation.museum",
  	"correios-e-telecomunicações.museum",
  	"corvette.museum",
  	"costume.museum",
  	"countryestate.museum",
  	"county.museum",
  	"crafts.museum",
  	"cranbrook.museum",
  	"creation.museum",
  	"cultural.museum",
  	"culturalcenter.museum",
  	"culture.museum",
  	"cyber.museum",
  	"cymru.museum",
  	"dali.museum",
  	"dallas.museum",
  	"database.museum",
  	"ddr.museum",
  	"decorativearts.museum",
  	"delaware.museum",
  	"delmenhorst.museum",
  	"denmark.museum",
  	"depot.museum",
  	"design.museum",
  	"detroit.museum",
  	"dinosaur.museum",
  	"discovery.museum",
  	"dolls.museum",
  	"donostia.museum",
  	"durham.museum",
  	"eastafrica.museum",
  	"eastcoast.museum",
  	"education.museum",
  	"educational.museum",
  	"egyptian.museum",
  	"eisenbahn.museum",
  	"elburg.museum",
  	"elvendrell.museum",
  	"embroidery.museum",
  	"encyclopedic.museum",
  	"england.museum",
  	"entomology.museum",
  	"environment.museum",
  	"environmentalconservation.museum",
  	"epilepsy.museum",
  	"essex.museum",
  	"estate.museum",
  	"ethnology.museum",
  	"exeter.museum",
  	"exhibition.museum",
  	"family.museum",
  	"farm.museum",
  	"farmequipment.museum",
  	"farmers.museum",
  	"farmstead.museum",
  	"field.museum",
  	"figueres.museum",
  	"filatelia.museum",
  	"film.museum",
  	"fineart.museum",
  	"finearts.museum",
  	"finland.museum",
  	"flanders.museum",
  	"florida.museum",
  	"force.museum",
  	"fortmissoula.museum",
  	"fortworth.museum",
  	"foundation.museum",
  	"francaise.museum",
  	"frankfurt.museum",
  	"franziskaner.museum",
  	"freemasonry.museum",
  	"freiburg.museum",
  	"fribourg.museum",
  	"frog.museum",
  	"fundacio.museum",
  	"furniture.museum",
  	"gallery.museum",
  	"garden.museum",
  	"gateway.museum",
  	"geelvinck.museum",
  	"gemological.museum",
  	"geology.museum",
  	"georgia.museum",
  	"giessen.museum",
  	"glas.museum",
  	"glass.museum",
  	"gorge.museum",
  	"grandrapids.museum",
  	"graz.museum",
  	"guernsey.museum",
  	"halloffame.museum",
  	"hamburg.museum",
  	"handson.museum",
  	"harvestcelebration.museum",
  	"hawaii.museum",
  	"health.museum",
  	"heimatunduhren.museum",
  	"hellas.museum",
  	"helsinki.museum",
  	"hembygdsforbund.museum",
  	"heritage.museum",
  	"histoire.museum",
  	"historical.museum",
  	"historicalsociety.museum",
  	"historichouses.museum",
  	"historisch.museum",
  	"historisches.museum",
  	"history.museum",
  	"historyofscience.museum",
  	"horology.museum",
  	"house.museum",
  	"humanities.museum",
  	"illustration.museum",
  	"imageandsound.museum",
  	"indian.museum",
  	"indiana.museum",
  	"indianapolis.museum",
  	"indianmarket.museum",
  	"intelligence.museum",
  	"interactive.museum",
  	"iraq.museum",
  	"iron.museum",
  	"isleofman.museum",
  	"jamison.museum",
  	"jefferson.museum",
  	"jerusalem.museum",
  	"jewelry.museum",
  	"jewish.museum",
  	"jewishart.museum",
  	"jfk.museum",
  	"journalism.museum",
  	"judaica.museum",
  	"judygarland.museum",
  	"juedisches.museum",
  	"juif.museum",
  	"karate.museum",
  	"karikatur.museum",
  	"kids.museum",
  	"koebenhavn.museum",
  	"koeln.museum",
  	"kunst.museum",
  	"kunstsammlung.museum",
  	"kunstunddesign.museum",
  	"labor.museum",
  	"labour.museum",
  	"lajolla.museum",
  	"lancashire.museum",
  	"landes.museum",
  	"lans.museum",
  	"läns.museum",
  	"larsson.museum",
  	"lewismiller.museum",
  	"lincoln.museum",
  	"linz.museum",
  	"living.museum",
  	"livinghistory.museum",
  	"localhistory.museum",
  	"london.museum",
  	"losangeles.museum",
  	"louvre.museum",
  	"loyalist.museum",
  	"lucerne.museum",
  	"luxembourg.museum",
  	"luzern.museum",
  	"mad.museum",
  	"madrid.museum",
  	"mallorca.museum",
  	"manchester.museum",
  	"mansion.museum",
  	"mansions.museum",
  	"manx.museum",
  	"marburg.museum",
  	"maritime.museum",
  	"maritimo.museum",
  	"maryland.museum",
  	"marylhurst.museum",
  	"media.museum",
  	"medical.museum",
  	"medizinhistorisches.museum",
  	"meeres.museum",
  	"memorial.museum",
  	"mesaverde.museum",
  	"michigan.museum",
  	"midatlantic.museum",
  	"military.museum",
  	"mill.museum",
  	"miners.museum",
  	"mining.museum",
  	"minnesota.museum",
  	"missile.museum",
  	"missoula.museum",
  	"modern.museum",
  	"moma.museum",
  	"money.museum",
  	"monmouth.museum",
  	"monticello.museum",
  	"montreal.museum",
  	"moscow.museum",
  	"motorcycle.museum",
  	"muenchen.museum",
  	"muenster.museum",
  	"mulhouse.museum",
  	"muncie.museum",
  	"museet.museum",
  	"museumcenter.museum",
  	"museumvereniging.museum",
  	"music.museum",
  	"national.museum",
  	"nationalfirearms.museum",
  	"nationalheritage.museum",
  	"nativeamerican.museum",
  	"naturalhistory.museum",
  	"naturalhistorymuseum.museum",
  	"naturalsciences.museum",
  	"nature.museum",
  	"naturhistorisches.museum",
  	"natuurwetenschappen.museum",
  	"naumburg.museum",
  	"naval.museum",
  	"nebraska.museum",
  	"neues.museum",
  	"newhampshire.museum",
  	"newjersey.museum",
  	"newmexico.museum",
  	"newport.museum",
  	"newspaper.museum",
  	"newyork.museum",
  	"niepce.museum",
  	"norfolk.museum",
  	"north.museum",
  	"nrw.museum",
  	"nyc.museum",
  	"nyny.museum",
  	"oceanographic.museum",
  	"oceanographique.museum",
  	"omaha.museum",
  	"online.museum",
  	"ontario.museum",
  	"openair.museum",
  	"oregon.museum",
  	"oregontrail.museum",
  	"otago.museum",
  	"oxford.museum",
  	"pacific.museum",
  	"paderborn.museum",
  	"palace.museum",
  	"paleo.museum",
  	"palmsprings.museum",
  	"panama.museum",
  	"paris.museum",
  	"pasadena.museum",
  	"pharmacy.museum",
  	"philadelphia.museum",
  	"philadelphiaarea.museum",
  	"philately.museum",
  	"phoenix.museum",
  	"photography.museum",
  	"pilots.museum",
  	"pittsburgh.museum",
  	"planetarium.museum",
  	"plantation.museum",
  	"plants.museum",
  	"plaza.museum",
  	"portal.museum",
  	"portland.museum",
  	"portlligat.museum",
  	"posts-and-telecommunications.museum",
  	"preservation.museum",
  	"presidio.museum",
  	"press.museum",
  	"project.museum",
  	"public.museum",
  	"pubol.museum",
  	"quebec.museum",
  	"railroad.museum",
  	"railway.museum",
  	"research.museum",
  	"resistance.museum",
  	"riodejaneiro.museum",
  	"rochester.museum",
  	"rockart.museum",
  	"roma.museum",
  	"russia.museum",
  	"saintlouis.museum",
  	"salem.museum",
  	"salvadordali.museum",
  	"salzburg.museum",
  	"sandiego.museum",
  	"sanfrancisco.museum",
  	"santabarbara.museum",
  	"santacruz.museum",
  	"santafe.museum",
  	"saskatchewan.museum",
  	"satx.museum",
  	"savannahga.museum",
  	"schlesisches.museum",
  	"schoenbrunn.museum",
  	"schokoladen.museum",
  	"school.museum",
  	"schweiz.museum",
  	"science.museum",
  	"scienceandhistory.museum",
  	"scienceandindustry.museum",
  	"sciencecenter.museum",
  	"sciencecenters.museum",
  	"science-fiction.museum",
  	"sciencehistory.museum",
  	"sciences.museum",
  	"sciencesnaturelles.museum",
  	"scotland.museum",
  	"seaport.museum",
  	"settlement.museum",
  	"settlers.museum",
  	"shell.museum",
  	"sherbrooke.museum",
  	"sibenik.museum",
  	"silk.museum",
  	"ski.museum",
  	"skole.museum",
  	"society.museum",
  	"sologne.museum",
  	"soundandvision.museum",
  	"southcarolina.museum",
  	"southwest.museum",
  	"space.museum",
  	"spy.museum",
  	"square.museum",
  	"stadt.museum",
  	"stalbans.museum",
  	"starnberg.museum",
  	"state.museum",
  	"stateofdelaware.museum",
  	"station.museum",
  	"steam.museum",
  	"steiermark.museum",
  	"stjohn.museum",
  	"stockholm.museum",
  	"stpetersburg.museum",
  	"stuttgart.museum",
  	"suisse.museum",
  	"surgeonshall.museum",
  	"surrey.museum",
  	"svizzera.museum",
  	"sweden.museum",
  	"sydney.museum",
  	"tank.museum",
  	"tcm.museum",
  	"technology.museum",
  	"telekommunikation.museum",
  	"television.museum",
  	"texas.museum",
  	"textile.museum",
  	"theater.museum",
  	"time.museum",
  	"timekeeping.museum",
  	"topology.museum",
  	"torino.museum",
  	"touch.museum",
  	"town.museum",
  	"transport.museum",
  	"tree.museum",
  	"trolley.museum",
  	"trust.museum",
  	"trustee.museum",
  	"uhren.museum",
  	"ulm.museum",
  	"undersea.museum",
  	"university.museum",
  	"usa.museum",
  	"usantiques.museum",
  	"usarts.museum",
  	"uscountryestate.museum",
  	"usculture.museum",
  	"usdecorativearts.museum",
  	"usgarden.museum",
  	"ushistory.museum",
  	"ushuaia.museum",
  	"uslivinghistory.museum",
  	"utah.museum",
  	"uvic.museum",
  	"valley.museum",
  	"vantaa.museum",
  	"versailles.museum",
  	"viking.museum",
  	"village.museum",
  	"virginia.museum",
  	"virtual.museum",
  	"virtuel.museum",
  	"vlaanderen.museum",
  	"volkenkunde.museum",
  	"wales.museum",
  	"wallonie.museum",
  	"war.museum",
  	"washingtondc.museum",
  	"watchandclock.museum",
  	"watch-and-clock.museum",
  	"western.museum",
  	"westfalen.museum",
  	"whaling.museum",
  	"wildlife.museum",
  	"williamsburg.museum",
  	"windmill.museum",
  	"workshop.museum",
  	"york.museum",
  	"yorkshire.museum",
  	"yosemite.museum",
  	"youth.museum",
  	"zoological.museum",
  	"zoology.museum",
  	"ירושלים.museum",
  	"иком.museum",
  	"mv",
  	"aero.mv",
  	"biz.mv",
  	"com.mv",
  	"coop.mv",
  	"edu.mv",
  	"gov.mv",
  	"info.mv",
  	"int.mv",
  	"mil.mv",
  	"museum.mv",
  	"name.mv",
  	"net.mv",
  	"org.mv",
  	"pro.mv",
  	"mw",
  	"ac.mw",
  	"biz.mw",
  	"co.mw",
  	"com.mw",
  	"coop.mw",
  	"edu.mw",
  	"gov.mw",
  	"int.mw",
  	"museum.mw",
  	"net.mw",
  	"org.mw",
  	"mx",
  	"com.mx",
  	"org.mx",
  	"gob.mx",
  	"edu.mx",
  	"net.mx",
  	"my",
  	"biz.my",
  	"com.my",
  	"edu.my",
  	"gov.my",
  	"mil.my",
  	"name.my",
  	"net.my",
  	"org.my",
  	"mz",
  	"ac.mz",
  	"adv.mz",
  	"co.mz",
  	"edu.mz",
  	"gov.mz",
  	"mil.mz",
  	"net.mz",
  	"org.mz",
  	"na",
  	"info.na",
  	"pro.na",
  	"name.na",
  	"school.na",
  	"or.na",
  	"dr.na",
  	"us.na",
  	"mx.na",
  	"ca.na",
  	"in.na",
  	"cc.na",
  	"tv.na",
  	"ws.na",
  	"mobi.na",
  	"co.na",
  	"com.na",
  	"org.na",
  	"name",
  	"nc",
  	"asso.nc",
  	"nom.nc",
  	"ne",
  	"net",
  	"nf",
  	"com.nf",
  	"net.nf",
  	"per.nf",
  	"rec.nf",
  	"web.nf",
  	"arts.nf",
  	"firm.nf",
  	"info.nf",
  	"other.nf",
  	"store.nf",
  	"ng",
  	"com.ng",
  	"edu.ng",
  	"gov.ng",
  	"i.ng",
  	"mil.ng",
  	"mobi.ng",
  	"name.ng",
  	"net.ng",
  	"org.ng",
  	"sch.ng",
  	"ni",
  	"ac.ni",
  	"biz.ni",
  	"co.ni",
  	"com.ni",
  	"edu.ni",
  	"gob.ni",
  	"in.ni",
  	"info.ni",
  	"int.ni",
  	"mil.ni",
  	"net.ni",
  	"nom.ni",
  	"org.ni",
  	"web.ni",
  	"nl",
  	"no",
  	"fhs.no",
  	"vgs.no",
  	"fylkesbibl.no",
  	"folkebibl.no",
  	"museum.no",
  	"idrett.no",
  	"priv.no",
  	"mil.no",
  	"stat.no",
  	"dep.no",
  	"kommune.no",
  	"herad.no",
  	"aa.no",
  	"ah.no",
  	"bu.no",
  	"fm.no",
  	"hl.no",
  	"hm.no",
  	"jan-mayen.no",
  	"mr.no",
  	"nl.no",
  	"nt.no",
  	"of.no",
  	"ol.no",
  	"oslo.no",
  	"rl.no",
  	"sf.no",
  	"st.no",
  	"svalbard.no",
  	"tm.no",
  	"tr.no",
  	"va.no",
  	"vf.no",
  	"gs.aa.no",
  	"gs.ah.no",
  	"gs.bu.no",
  	"gs.fm.no",
  	"gs.hl.no",
  	"gs.hm.no",
  	"gs.jan-mayen.no",
  	"gs.mr.no",
  	"gs.nl.no",
  	"gs.nt.no",
  	"gs.of.no",
  	"gs.ol.no",
  	"gs.oslo.no",
  	"gs.rl.no",
  	"gs.sf.no",
  	"gs.st.no",
  	"gs.svalbard.no",
  	"gs.tm.no",
  	"gs.tr.no",
  	"gs.va.no",
  	"gs.vf.no",
  	"akrehamn.no",
  	"åkrehamn.no",
  	"algard.no",
  	"ålgård.no",
  	"arna.no",
  	"brumunddal.no",
  	"bryne.no",
  	"bronnoysund.no",
  	"brønnøysund.no",
  	"drobak.no",
  	"drøbak.no",
  	"egersund.no",
  	"fetsund.no",
  	"floro.no",
  	"florø.no",
  	"fredrikstad.no",
  	"hokksund.no",
  	"honefoss.no",
  	"hønefoss.no",
  	"jessheim.no",
  	"jorpeland.no",
  	"jørpeland.no",
  	"kirkenes.no",
  	"kopervik.no",
  	"krokstadelva.no",
  	"langevag.no",
  	"langevåg.no",
  	"leirvik.no",
  	"mjondalen.no",
  	"mjøndalen.no",
  	"mo-i-rana.no",
  	"mosjoen.no",
  	"mosjøen.no",
  	"nesoddtangen.no",
  	"orkanger.no",
  	"osoyro.no",
  	"osøyro.no",
  	"raholt.no",
  	"råholt.no",
  	"sandnessjoen.no",
  	"sandnessjøen.no",
  	"skedsmokorset.no",
  	"slattum.no",
  	"spjelkavik.no",
  	"stathelle.no",
  	"stavern.no",
  	"stjordalshalsen.no",
  	"stjørdalshalsen.no",
  	"tananger.no",
  	"tranby.no",
  	"vossevangen.no",
  	"afjord.no",
  	"åfjord.no",
  	"agdenes.no",
  	"al.no",
  	"ål.no",
  	"alesund.no",
  	"ålesund.no",
  	"alstahaug.no",
  	"alta.no",
  	"áltá.no",
  	"alaheadju.no",
  	"álaheadju.no",
  	"alvdal.no",
  	"amli.no",
  	"åmli.no",
  	"amot.no",
  	"åmot.no",
  	"andebu.no",
  	"andoy.no",
  	"andøy.no",
  	"andasuolo.no",
  	"ardal.no",
  	"årdal.no",
  	"aremark.no",
  	"arendal.no",
  	"ås.no",
  	"aseral.no",
  	"åseral.no",
  	"asker.no",
  	"askim.no",
  	"askvoll.no",
  	"askoy.no",
  	"askøy.no",
  	"asnes.no",
  	"åsnes.no",
  	"audnedaln.no",
  	"aukra.no",
  	"aure.no",
  	"aurland.no",
  	"aurskog-holand.no",
  	"aurskog-høland.no",
  	"austevoll.no",
  	"austrheim.no",
  	"averoy.no",
  	"averøy.no",
  	"balestrand.no",
  	"ballangen.no",
  	"balat.no",
  	"bálát.no",
  	"balsfjord.no",
  	"bahccavuotna.no",
  	"báhccavuotna.no",
  	"bamble.no",
  	"bardu.no",
  	"beardu.no",
  	"beiarn.no",
  	"bajddar.no",
  	"bájddar.no",
  	"baidar.no",
  	"báidár.no",
  	"berg.no",
  	"bergen.no",
  	"berlevag.no",
  	"berlevåg.no",
  	"bearalvahki.no",
  	"bearalváhki.no",
  	"bindal.no",
  	"birkenes.no",
  	"bjarkoy.no",
  	"bjarkøy.no",
  	"bjerkreim.no",
  	"bjugn.no",
  	"bodo.no",
  	"bodø.no",
  	"badaddja.no",
  	"bådåddjå.no",
  	"budejju.no",
  	"bokn.no",
  	"bremanger.no",
  	"bronnoy.no",
  	"brønnøy.no",
  	"bygland.no",
  	"bykle.no",
  	"barum.no",
  	"bærum.no",
  	"bo.telemark.no",
  	"bø.telemark.no",
  	"bo.nordland.no",
  	"bø.nordland.no",
  	"bievat.no",
  	"bievát.no",
  	"bomlo.no",
  	"bømlo.no",
  	"batsfjord.no",
  	"båtsfjord.no",
  	"bahcavuotna.no",
  	"báhcavuotna.no",
  	"dovre.no",
  	"drammen.no",
  	"drangedal.no",
  	"dyroy.no",
  	"dyrøy.no",
  	"donna.no",
  	"dønna.no",
  	"eid.no",
  	"eidfjord.no",
  	"eidsberg.no",
  	"eidskog.no",
  	"eidsvoll.no",
  	"eigersund.no",
  	"elverum.no",
  	"enebakk.no",
  	"engerdal.no",
  	"etne.no",
  	"etnedal.no",
  	"evenes.no",
  	"evenassi.no",
  	"evenášši.no",
  	"evje-og-hornnes.no",
  	"farsund.no",
  	"fauske.no",
  	"fuossko.no",
  	"fuoisku.no",
  	"fedje.no",
  	"fet.no",
  	"finnoy.no",
  	"finnøy.no",
  	"fitjar.no",
  	"fjaler.no",
  	"fjell.no",
  	"flakstad.no",
  	"flatanger.no",
  	"flekkefjord.no",
  	"flesberg.no",
  	"flora.no",
  	"fla.no",
  	"flå.no",
  	"folldal.no",
  	"forsand.no",
  	"fosnes.no",
  	"frei.no",
  	"frogn.no",
  	"froland.no",
  	"frosta.no",
  	"frana.no",
  	"fræna.no",
  	"froya.no",
  	"frøya.no",
  	"fusa.no",
  	"fyresdal.no",
  	"forde.no",
  	"førde.no",
  	"gamvik.no",
  	"gangaviika.no",
  	"gáŋgaviika.no",
  	"gaular.no",
  	"gausdal.no",
  	"gildeskal.no",
  	"gildeskål.no",
  	"giske.no",
  	"gjemnes.no",
  	"gjerdrum.no",
  	"gjerstad.no",
  	"gjesdal.no",
  	"gjovik.no",
  	"gjøvik.no",
  	"gloppen.no",
  	"gol.no",
  	"gran.no",
  	"grane.no",
  	"granvin.no",
  	"gratangen.no",
  	"grimstad.no",
  	"grong.no",
  	"kraanghke.no",
  	"kråanghke.no",
  	"grue.no",
  	"gulen.no",
  	"hadsel.no",
  	"halden.no",
  	"halsa.no",
  	"hamar.no",
  	"hamaroy.no",
  	"habmer.no",
  	"hábmer.no",
  	"hapmir.no",
  	"hápmir.no",
  	"hammerfest.no",
  	"hammarfeasta.no",
  	"hámmárfeasta.no",
  	"haram.no",
  	"hareid.no",
  	"harstad.no",
  	"hasvik.no",
  	"aknoluokta.no",
  	"ákŋoluokta.no",
  	"hattfjelldal.no",
  	"aarborte.no",
  	"haugesund.no",
  	"hemne.no",
  	"hemnes.no",
  	"hemsedal.no",
  	"heroy.more-og-romsdal.no",
  	"herøy.møre-og-romsdal.no",
  	"heroy.nordland.no",
  	"herøy.nordland.no",
  	"hitra.no",
  	"hjartdal.no",
  	"hjelmeland.no",
  	"hobol.no",
  	"hobøl.no",
  	"hof.no",
  	"hol.no",
  	"hole.no",
  	"holmestrand.no",
  	"holtalen.no",
  	"holtålen.no",
  	"hornindal.no",
  	"horten.no",
  	"hurdal.no",
  	"hurum.no",
  	"hvaler.no",
  	"hyllestad.no",
  	"hagebostad.no",
  	"hægebostad.no",
  	"hoyanger.no",
  	"høyanger.no",
  	"hoylandet.no",
  	"høylandet.no",
  	"ha.no",
  	"hå.no",
  	"ibestad.no",
  	"inderoy.no",
  	"inderøy.no",
  	"iveland.no",
  	"jevnaker.no",
  	"jondal.no",
  	"jolster.no",
  	"jølster.no",
  	"karasjok.no",
  	"karasjohka.no",
  	"kárášjohka.no",
  	"karlsoy.no",
  	"galsa.no",
  	"gálsá.no",
  	"karmoy.no",
  	"karmøy.no",
  	"kautokeino.no",
  	"guovdageaidnu.no",
  	"klepp.no",
  	"klabu.no",
  	"klæbu.no",
  	"kongsberg.no",
  	"kongsvinger.no",
  	"kragero.no",
  	"kragerø.no",
  	"kristiansand.no",
  	"kristiansund.no",
  	"krodsherad.no",
  	"krødsherad.no",
  	"kvalsund.no",
  	"rahkkeravju.no",
  	"ráhkkerávju.no",
  	"kvam.no",
  	"kvinesdal.no",
  	"kvinnherad.no",
  	"kviteseid.no",
  	"kvitsoy.no",
  	"kvitsøy.no",
  	"kvafjord.no",
  	"kvæfjord.no",
  	"giehtavuoatna.no",
  	"kvanangen.no",
  	"kvænangen.no",
  	"navuotna.no",
  	"návuotna.no",
  	"kafjord.no",
  	"kåfjord.no",
  	"gaivuotna.no",
  	"gáivuotna.no",
  	"larvik.no",
  	"lavangen.no",
  	"lavagis.no",
  	"loabat.no",
  	"loabát.no",
  	"lebesby.no",
  	"davvesiida.no",
  	"leikanger.no",
  	"leirfjord.no",
  	"leka.no",
  	"leksvik.no",
  	"lenvik.no",
  	"leangaviika.no",
  	"leaŋgaviika.no",
  	"lesja.no",
  	"levanger.no",
  	"lier.no",
  	"lierne.no",
  	"lillehammer.no",
  	"lillesand.no",
  	"lindesnes.no",
  	"lindas.no",
  	"lindås.no",
  	"lom.no",
  	"loppa.no",
  	"lahppi.no",
  	"láhppi.no",
  	"lund.no",
  	"lunner.no",
  	"luroy.no",
  	"lurøy.no",
  	"luster.no",
  	"lyngdal.no",
  	"lyngen.no",
  	"ivgu.no",
  	"lardal.no",
  	"lerdal.no",
  	"lærdal.no",
  	"lodingen.no",
  	"lødingen.no",
  	"lorenskog.no",
  	"lørenskog.no",
  	"loten.no",
  	"løten.no",
  	"malvik.no",
  	"masoy.no",
  	"måsøy.no",
  	"muosat.no",
  	"muosát.no",
  	"mandal.no",
  	"marker.no",
  	"marnardal.no",
  	"masfjorden.no",
  	"meland.no",
  	"meldal.no",
  	"melhus.no",
  	"meloy.no",
  	"meløy.no",
  	"meraker.no",
  	"meråker.no",
  	"moareke.no",
  	"moåreke.no",
  	"midsund.no",
  	"midtre-gauldal.no",
  	"modalen.no",
  	"modum.no",
  	"molde.no",
  	"moskenes.no",
  	"moss.no",
  	"mosvik.no",
  	"malselv.no",
  	"målselv.no",
  	"malatvuopmi.no",
  	"málatvuopmi.no",
  	"namdalseid.no",
  	"aejrie.no",
  	"namsos.no",
  	"namsskogan.no",
  	"naamesjevuemie.no",
  	"nååmesjevuemie.no",
  	"laakesvuemie.no",
  	"nannestad.no",
  	"narvik.no",
  	"narviika.no",
  	"naustdal.no",
  	"nedre-eiker.no",
  	"nes.akershus.no",
  	"nes.buskerud.no",
  	"nesna.no",
  	"nesodden.no",
  	"nesseby.no",
  	"unjarga.no",
  	"unjárga.no",
  	"nesset.no",
  	"nissedal.no",
  	"nittedal.no",
  	"nord-aurdal.no",
  	"nord-fron.no",
  	"nord-odal.no",
  	"norddal.no",
  	"nordkapp.no",
  	"davvenjarga.no",
  	"davvenjárga.no",
  	"nordre-land.no",
  	"nordreisa.no",
  	"raisa.no",
  	"ráisa.no",
  	"nore-og-uvdal.no",
  	"notodden.no",
  	"naroy.no",
  	"nærøy.no",
  	"notteroy.no",
  	"nøtterøy.no",
  	"odda.no",
  	"oksnes.no",
  	"øksnes.no",
  	"oppdal.no",
  	"oppegard.no",
  	"oppegård.no",
  	"orkdal.no",
  	"orland.no",
  	"ørland.no",
  	"orskog.no",
  	"ørskog.no",
  	"orsta.no",
  	"ørsta.no",
  	"os.hedmark.no",
  	"os.hordaland.no",
  	"osen.no",
  	"osteroy.no",
  	"osterøy.no",
  	"ostre-toten.no",
  	"østre-toten.no",
  	"overhalla.no",
  	"ovre-eiker.no",
  	"øvre-eiker.no",
  	"oyer.no",
  	"øyer.no",
  	"oygarden.no",
  	"øygarden.no",
  	"oystre-slidre.no",
  	"øystre-slidre.no",
  	"porsanger.no",
  	"porsangu.no",
  	"porsáŋgu.no",
  	"porsgrunn.no",
  	"radoy.no",
  	"radøy.no",
  	"rakkestad.no",
  	"rana.no",
  	"ruovat.no",
  	"randaberg.no",
  	"rauma.no",
  	"rendalen.no",
  	"rennebu.no",
  	"rennesoy.no",
  	"rennesøy.no",
  	"rindal.no",
  	"ringebu.no",
  	"ringerike.no",
  	"ringsaker.no",
  	"rissa.no",
  	"risor.no",
  	"risør.no",
  	"roan.no",
  	"rollag.no",
  	"rygge.no",
  	"ralingen.no",
  	"rælingen.no",
  	"rodoy.no",
  	"rødøy.no",
  	"romskog.no",
  	"rømskog.no",
  	"roros.no",
  	"røros.no",
  	"rost.no",
  	"røst.no",
  	"royken.no",
  	"røyken.no",
  	"royrvik.no",
  	"røyrvik.no",
  	"rade.no",
  	"råde.no",
  	"salangen.no",
  	"siellak.no",
  	"saltdal.no",
  	"salat.no",
  	"sálát.no",
  	"sálat.no",
  	"samnanger.no",
  	"sande.more-og-romsdal.no",
  	"sande.møre-og-romsdal.no",
  	"sande.vestfold.no",
  	"sandefjord.no",
  	"sandnes.no",
  	"sandoy.no",
  	"sandøy.no",
  	"sarpsborg.no",
  	"sauda.no",
  	"sauherad.no",
  	"sel.no",
  	"selbu.no",
  	"selje.no",
  	"seljord.no",
  	"sigdal.no",
  	"siljan.no",
  	"sirdal.no",
  	"skaun.no",
  	"skedsmo.no",
  	"ski.no",
  	"skien.no",
  	"skiptvet.no",
  	"skjervoy.no",
  	"skjervøy.no",
  	"skierva.no",
  	"skiervá.no",
  	"skjak.no",
  	"skjåk.no",
  	"skodje.no",
  	"skanland.no",
  	"skånland.no",
  	"skanit.no",
  	"skánit.no",
  	"smola.no",
  	"smøla.no",
  	"snillfjord.no",
  	"snasa.no",
  	"snåsa.no",
  	"snoasa.no",
  	"snaase.no",
  	"snåase.no",
  	"sogndal.no",
  	"sokndal.no",
  	"sola.no",
  	"solund.no",
  	"songdalen.no",
  	"sortland.no",
  	"spydeberg.no",
  	"stange.no",
  	"stavanger.no",
  	"steigen.no",
  	"steinkjer.no",
  	"stjordal.no",
  	"stjørdal.no",
  	"stokke.no",
  	"stor-elvdal.no",
  	"stord.no",
  	"stordal.no",
  	"storfjord.no",
  	"omasvuotna.no",
  	"strand.no",
  	"stranda.no",
  	"stryn.no",
  	"sula.no",
  	"suldal.no",
  	"sund.no",
  	"sunndal.no",
  	"surnadal.no",
  	"sveio.no",
  	"svelvik.no",
  	"sykkylven.no",
  	"sogne.no",
  	"søgne.no",
  	"somna.no",
  	"sømna.no",
  	"sondre-land.no",
  	"søndre-land.no",
  	"sor-aurdal.no",
  	"sør-aurdal.no",
  	"sor-fron.no",
  	"sør-fron.no",
  	"sor-odal.no",
  	"sør-odal.no",
  	"sor-varanger.no",
  	"sør-varanger.no",
  	"matta-varjjat.no",
  	"mátta-várjjat.no",
  	"sorfold.no",
  	"sørfold.no",
  	"sorreisa.no",
  	"sørreisa.no",
  	"sorum.no",
  	"sørum.no",
  	"tana.no",
  	"deatnu.no",
  	"time.no",
  	"tingvoll.no",
  	"tinn.no",
  	"tjeldsund.no",
  	"dielddanuorri.no",
  	"tjome.no",
  	"tjøme.no",
  	"tokke.no",
  	"tolga.no",
  	"torsken.no",
  	"tranoy.no",
  	"tranøy.no",
  	"tromso.no",
  	"tromsø.no",
  	"tromsa.no",
  	"romsa.no",
  	"trondheim.no",
  	"troandin.no",
  	"trysil.no",
  	"trana.no",
  	"træna.no",
  	"trogstad.no",
  	"trøgstad.no",
  	"tvedestrand.no",
  	"tydal.no",
  	"tynset.no",
  	"tysfjord.no",
  	"divtasvuodna.no",
  	"divttasvuotna.no",
  	"tysnes.no",
  	"tysvar.no",
  	"tysvær.no",
  	"tonsberg.no",
  	"tønsberg.no",
  	"ullensaker.no",
  	"ullensvang.no",
  	"ulvik.no",
  	"utsira.no",
  	"vadso.no",
  	"vadsø.no",
  	"cahcesuolo.no",
  	"čáhcesuolo.no",
  	"vaksdal.no",
  	"valle.no",
  	"vang.no",
  	"vanylven.no",
  	"vardo.no",
  	"vardø.no",
  	"varggat.no",
  	"várggát.no",
  	"vefsn.no",
  	"vaapste.no",
  	"vega.no",
  	"vegarshei.no",
  	"vegårshei.no",
  	"vennesla.no",
  	"verdal.no",
  	"verran.no",
  	"vestby.no",
  	"vestnes.no",
  	"vestre-slidre.no",
  	"vestre-toten.no",
  	"vestvagoy.no",
  	"vestvågøy.no",
  	"vevelstad.no",
  	"vik.no",
  	"vikna.no",
  	"vindafjord.no",
  	"volda.no",
  	"voss.no",
  	"varoy.no",
  	"værøy.no",
  	"vagan.no",
  	"vågan.no",
  	"voagat.no",
  	"vagsoy.no",
  	"vågsøy.no",
  	"vaga.no",
  	"vågå.no",
  	"valer.ostfold.no",
  	"våler.østfold.no",
  	"valer.hedmark.no",
  	"våler.hedmark.no",
  	"*.np",
  	"nr",
  	"biz.nr",
  	"info.nr",
  	"gov.nr",
  	"edu.nr",
  	"org.nr",
  	"net.nr",
  	"com.nr",
  	"nu",
  	"nz",
  	"ac.nz",
  	"co.nz",
  	"cri.nz",
  	"geek.nz",
  	"gen.nz",
  	"govt.nz",
  	"health.nz",
  	"iwi.nz",
  	"kiwi.nz",
  	"maori.nz",
  	"mil.nz",
  	"māori.nz",
  	"net.nz",
  	"org.nz",
  	"parliament.nz",
  	"school.nz",
  	"om",
  	"co.om",
  	"com.om",
  	"edu.om",
  	"gov.om",
  	"med.om",
  	"museum.om",
  	"net.om",
  	"org.om",
  	"pro.om",
  	"onion",
  	"org",
  	"pa",
  	"ac.pa",
  	"gob.pa",
  	"com.pa",
  	"org.pa",
  	"sld.pa",
  	"edu.pa",
  	"net.pa",
  	"ing.pa",
  	"abo.pa",
  	"med.pa",
  	"nom.pa",
  	"pe",
  	"edu.pe",
  	"gob.pe",
  	"nom.pe",
  	"mil.pe",
  	"org.pe",
  	"com.pe",
  	"net.pe",
  	"pf",
  	"com.pf",
  	"org.pf",
  	"edu.pf",
  	"*.pg",
  	"ph",
  	"com.ph",
  	"net.ph",
  	"org.ph",
  	"gov.ph",
  	"edu.ph",
  	"ngo.ph",
  	"mil.ph",
  	"i.ph",
  	"pk",
  	"com.pk",
  	"net.pk",
  	"edu.pk",
  	"org.pk",
  	"fam.pk",
  	"biz.pk",
  	"web.pk",
  	"gov.pk",
  	"gob.pk",
  	"gok.pk",
  	"gon.pk",
  	"gop.pk",
  	"gos.pk",
  	"info.pk",
  	"pl",
  	"com.pl",
  	"net.pl",
  	"org.pl",
  	"aid.pl",
  	"agro.pl",
  	"atm.pl",
  	"auto.pl",
  	"biz.pl",
  	"edu.pl",
  	"gmina.pl",
  	"gsm.pl",
  	"info.pl",
  	"mail.pl",
  	"miasta.pl",
  	"media.pl",
  	"mil.pl",
  	"nieruchomosci.pl",
  	"nom.pl",
  	"pc.pl",
  	"powiat.pl",
  	"priv.pl",
  	"realestate.pl",
  	"rel.pl",
  	"sex.pl",
  	"shop.pl",
  	"sklep.pl",
  	"sos.pl",
  	"szkola.pl",
  	"targi.pl",
  	"tm.pl",
  	"tourism.pl",
  	"travel.pl",
  	"turystyka.pl",
  	"gov.pl",
  	"ap.gov.pl",
  	"ic.gov.pl",
  	"is.gov.pl",
  	"us.gov.pl",
  	"kmpsp.gov.pl",
  	"kppsp.gov.pl",
  	"kwpsp.gov.pl",
  	"psp.gov.pl",
  	"wskr.gov.pl",
  	"kwp.gov.pl",
  	"mw.gov.pl",
  	"ug.gov.pl",
  	"um.gov.pl",
  	"umig.gov.pl",
  	"ugim.gov.pl",
  	"upow.gov.pl",
  	"uw.gov.pl",
  	"starostwo.gov.pl",
  	"pa.gov.pl",
  	"po.gov.pl",
  	"psse.gov.pl",
  	"pup.gov.pl",
  	"rzgw.gov.pl",
  	"sa.gov.pl",
  	"so.gov.pl",
  	"sr.gov.pl",
  	"wsa.gov.pl",
  	"sko.gov.pl",
  	"uzs.gov.pl",
  	"wiih.gov.pl",
  	"winb.gov.pl",
  	"pinb.gov.pl",
  	"wios.gov.pl",
  	"witd.gov.pl",
  	"wzmiuw.gov.pl",
  	"piw.gov.pl",
  	"wiw.gov.pl",
  	"griw.gov.pl",
  	"wif.gov.pl",
  	"oum.gov.pl",
  	"sdn.gov.pl",
  	"zp.gov.pl",
  	"uppo.gov.pl",
  	"mup.gov.pl",
  	"wuoz.gov.pl",
  	"konsulat.gov.pl",
  	"oirm.gov.pl",
  	"augustow.pl",
  	"babia-gora.pl",
  	"bedzin.pl",
  	"beskidy.pl",
  	"bialowieza.pl",
  	"bialystok.pl",
  	"bielawa.pl",
  	"bieszczady.pl",
  	"boleslawiec.pl",
  	"bydgoszcz.pl",
  	"bytom.pl",
  	"cieszyn.pl",
  	"czeladz.pl",
  	"czest.pl",
  	"dlugoleka.pl",
  	"elblag.pl",
  	"elk.pl",
  	"glogow.pl",
  	"gniezno.pl",
  	"gorlice.pl",
  	"grajewo.pl",
  	"ilawa.pl",
  	"jaworzno.pl",
  	"jelenia-gora.pl",
  	"jgora.pl",
  	"kalisz.pl",
  	"kazimierz-dolny.pl",
  	"karpacz.pl",
  	"kartuzy.pl",
  	"kaszuby.pl",
  	"katowice.pl",
  	"kepno.pl",
  	"ketrzyn.pl",
  	"klodzko.pl",
  	"kobierzyce.pl",
  	"kolobrzeg.pl",
  	"konin.pl",
  	"konskowola.pl",
  	"kutno.pl",
  	"lapy.pl",
  	"lebork.pl",
  	"legnica.pl",
  	"lezajsk.pl",
  	"limanowa.pl",
  	"lomza.pl",
  	"lowicz.pl",
  	"lubin.pl",
  	"lukow.pl",
  	"malbork.pl",
  	"malopolska.pl",
  	"mazowsze.pl",
  	"mazury.pl",
  	"mielec.pl",
  	"mielno.pl",
  	"mragowo.pl",
  	"naklo.pl",
  	"nowaruda.pl",
  	"nysa.pl",
  	"olawa.pl",
  	"olecko.pl",
  	"olkusz.pl",
  	"olsztyn.pl",
  	"opoczno.pl",
  	"opole.pl",
  	"ostroda.pl",
  	"ostroleka.pl",
  	"ostrowiec.pl",
  	"ostrowwlkp.pl",
  	"pila.pl",
  	"pisz.pl",
  	"podhale.pl",
  	"podlasie.pl",
  	"polkowice.pl",
  	"pomorze.pl",
  	"pomorskie.pl",
  	"prochowice.pl",
  	"pruszkow.pl",
  	"przeworsk.pl",
  	"pulawy.pl",
  	"radom.pl",
  	"rawa-maz.pl",
  	"rybnik.pl",
  	"rzeszow.pl",
  	"sanok.pl",
  	"sejny.pl",
  	"slask.pl",
  	"slupsk.pl",
  	"sosnowiec.pl",
  	"stalowa-wola.pl",
  	"skoczow.pl",
  	"starachowice.pl",
  	"stargard.pl",
  	"suwalki.pl",
  	"swidnica.pl",
  	"swiebodzin.pl",
  	"swinoujscie.pl",
  	"szczecin.pl",
  	"szczytno.pl",
  	"tarnobrzeg.pl",
  	"tgory.pl",
  	"turek.pl",
  	"tychy.pl",
  	"ustka.pl",
  	"walbrzych.pl",
  	"warmia.pl",
  	"warszawa.pl",
  	"waw.pl",
  	"wegrow.pl",
  	"wielun.pl",
  	"wlocl.pl",
  	"wloclawek.pl",
  	"wodzislaw.pl",
  	"wolomin.pl",
  	"wroclaw.pl",
  	"zachpomor.pl",
  	"zagan.pl",
  	"zarow.pl",
  	"zgora.pl",
  	"zgorzelec.pl",
  	"pm",
  	"pn",
  	"gov.pn",
  	"co.pn",
  	"org.pn",
  	"edu.pn",
  	"net.pn",
  	"post",
  	"pr",
  	"com.pr",
  	"net.pr",
  	"org.pr",
  	"gov.pr",
  	"edu.pr",
  	"isla.pr",
  	"pro.pr",
  	"biz.pr",
  	"info.pr",
  	"name.pr",
  	"est.pr",
  	"prof.pr",
  	"ac.pr",
  	"pro",
  	"aaa.pro",
  	"aca.pro",
  	"acct.pro",
  	"avocat.pro",
  	"bar.pro",
  	"cpa.pro",
  	"eng.pro",
  	"jur.pro",
  	"law.pro",
  	"med.pro",
  	"recht.pro",
  	"ps",
  	"edu.ps",
  	"gov.ps",
  	"sec.ps",
  	"plo.ps",
  	"com.ps",
  	"org.ps",
  	"net.ps",
  	"pt",
  	"net.pt",
  	"gov.pt",
  	"org.pt",
  	"edu.pt",
  	"int.pt",
  	"publ.pt",
  	"com.pt",
  	"nome.pt",
  	"pw",
  	"co.pw",
  	"ne.pw",
  	"or.pw",
  	"ed.pw",
  	"go.pw",
  	"belau.pw",
  	"py",
  	"com.py",
  	"coop.py",
  	"edu.py",
  	"gov.py",
  	"mil.py",
  	"net.py",
  	"org.py",
  	"qa",
  	"com.qa",
  	"edu.qa",
  	"gov.qa",
  	"mil.qa",
  	"name.qa",
  	"net.qa",
  	"org.qa",
  	"sch.qa",
  	"re",
  	"asso.re",
  	"com.re",
  	"nom.re",
  	"ro",
  	"arts.ro",
  	"com.ro",
  	"firm.ro",
  	"info.ro",
  	"nom.ro",
  	"nt.ro",
  	"org.ro",
  	"rec.ro",
  	"store.ro",
  	"tm.ro",
  	"www.ro",
  	"rs",
  	"ac.rs",
  	"co.rs",
  	"edu.rs",
  	"gov.rs",
  	"in.rs",
  	"org.rs",
  	"ru",
  	"rw",
  	"ac.rw",
  	"co.rw",
  	"coop.rw",
  	"gov.rw",
  	"mil.rw",
  	"net.rw",
  	"org.rw",
  	"sa",
  	"com.sa",
  	"net.sa",
  	"org.sa",
  	"gov.sa",
  	"med.sa",
  	"pub.sa",
  	"edu.sa",
  	"sch.sa",
  	"sb",
  	"com.sb",
  	"edu.sb",
  	"gov.sb",
  	"net.sb",
  	"org.sb",
  	"sc",
  	"com.sc",
  	"gov.sc",
  	"net.sc",
  	"org.sc",
  	"edu.sc",
  	"sd",
  	"com.sd",
  	"net.sd",
  	"org.sd",
  	"edu.sd",
  	"med.sd",
  	"tv.sd",
  	"gov.sd",
  	"info.sd",
  	"se",
  	"a.se",
  	"ac.se",
  	"b.se",
  	"bd.se",
  	"brand.se",
  	"c.se",
  	"d.se",
  	"e.se",
  	"f.se",
  	"fh.se",
  	"fhsk.se",
  	"fhv.se",
  	"g.se",
  	"h.se",
  	"i.se",
  	"k.se",
  	"komforb.se",
  	"kommunalforbund.se",
  	"komvux.se",
  	"l.se",
  	"lanbib.se",
  	"m.se",
  	"n.se",
  	"naturbruksgymn.se",
  	"o.se",
  	"org.se",
  	"p.se",
  	"parti.se",
  	"pp.se",
  	"press.se",
  	"r.se",
  	"s.se",
  	"t.se",
  	"tm.se",
  	"u.se",
  	"w.se",
  	"x.se",
  	"y.se",
  	"z.se",
  	"sg",
  	"com.sg",
  	"net.sg",
  	"org.sg",
  	"gov.sg",
  	"edu.sg",
  	"per.sg",
  	"sh",
  	"com.sh",
  	"net.sh",
  	"gov.sh",
  	"org.sh",
  	"mil.sh",
  	"si",
  	"sj",
  	"sk",
  	"sl",
  	"com.sl",
  	"net.sl",
  	"edu.sl",
  	"gov.sl",
  	"org.sl",
  	"sm",
  	"sn",
  	"art.sn",
  	"com.sn",
  	"edu.sn",
  	"gouv.sn",
  	"org.sn",
  	"perso.sn",
  	"univ.sn",
  	"so",
  	"com.so",
  	"edu.so",
  	"gov.so",
  	"me.so",
  	"net.so",
  	"org.so",
  	"sr",
  	"ss",
  	"biz.ss",
  	"com.ss",
  	"edu.ss",
  	"gov.ss",
  	"me.ss",
  	"net.ss",
  	"org.ss",
  	"sch.ss",
  	"st",
  	"co.st",
  	"com.st",
  	"consulado.st",
  	"edu.st",
  	"embaixada.st",
  	"mil.st",
  	"net.st",
  	"org.st",
  	"principe.st",
  	"saotome.st",
  	"store.st",
  	"su",
  	"sv",
  	"com.sv",
  	"edu.sv",
  	"gob.sv",
  	"org.sv",
  	"red.sv",
  	"sx",
  	"gov.sx",
  	"sy",
  	"edu.sy",
  	"gov.sy",
  	"net.sy",
  	"mil.sy",
  	"com.sy",
  	"org.sy",
  	"sz",
  	"co.sz",
  	"ac.sz",
  	"org.sz",
  	"tc",
  	"td",
  	"tel",
  	"tf",
  	"tg",
  	"th",
  	"ac.th",
  	"co.th",
  	"go.th",
  	"in.th",
  	"mi.th",
  	"net.th",
  	"or.th",
  	"tj",
  	"ac.tj",
  	"biz.tj",
  	"co.tj",
  	"com.tj",
  	"edu.tj",
  	"go.tj",
  	"gov.tj",
  	"int.tj",
  	"mil.tj",
  	"name.tj",
  	"net.tj",
  	"nic.tj",
  	"org.tj",
  	"test.tj",
  	"web.tj",
  	"tk",
  	"tl",
  	"gov.tl",
  	"tm",
  	"com.tm",
  	"co.tm",
  	"org.tm",
  	"net.tm",
  	"nom.tm",
  	"gov.tm",
  	"mil.tm",
  	"edu.tm",
  	"tn",
  	"com.tn",
  	"ens.tn",
  	"fin.tn",
  	"gov.tn",
  	"ind.tn",
  	"info.tn",
  	"intl.tn",
  	"mincom.tn",
  	"nat.tn",
  	"net.tn",
  	"org.tn",
  	"perso.tn",
  	"tourism.tn",
  	"to",
  	"com.to",
  	"gov.to",
  	"net.to",
  	"org.to",
  	"edu.to",
  	"mil.to",
  	"tr",
  	"av.tr",
  	"bbs.tr",
  	"bel.tr",
  	"biz.tr",
  	"com.tr",
  	"dr.tr",
  	"edu.tr",
  	"gen.tr",
  	"gov.tr",
  	"info.tr",
  	"mil.tr",
  	"k12.tr",
  	"kep.tr",
  	"name.tr",
  	"net.tr",
  	"org.tr",
  	"pol.tr",
  	"tel.tr",
  	"tsk.tr",
  	"tv.tr",
  	"web.tr",
  	"nc.tr",
  	"gov.nc.tr",
  	"tt",
  	"co.tt",
  	"com.tt",
  	"org.tt",
  	"net.tt",
  	"biz.tt",
  	"info.tt",
  	"pro.tt",
  	"int.tt",
  	"coop.tt",
  	"jobs.tt",
  	"mobi.tt",
  	"travel.tt",
  	"museum.tt",
  	"aero.tt",
  	"name.tt",
  	"gov.tt",
  	"edu.tt",
  	"tv",
  	"tw",
  	"edu.tw",
  	"gov.tw",
  	"mil.tw",
  	"com.tw",
  	"net.tw",
  	"org.tw",
  	"idv.tw",
  	"game.tw",
  	"ebiz.tw",
  	"club.tw",
  	"網路.tw",
  	"組織.tw",
  	"商業.tw",
  	"tz",
  	"ac.tz",
  	"co.tz",
  	"go.tz",
  	"hotel.tz",
  	"info.tz",
  	"me.tz",
  	"mil.tz",
  	"mobi.tz",
  	"ne.tz",
  	"or.tz",
  	"sc.tz",
  	"tv.tz",
  	"ua",
  	"com.ua",
  	"edu.ua",
  	"gov.ua",
  	"in.ua",
  	"net.ua",
  	"org.ua",
  	"cherkassy.ua",
  	"cherkasy.ua",
  	"chernigov.ua",
  	"chernihiv.ua",
  	"chernivtsi.ua",
  	"chernovtsy.ua",
  	"ck.ua",
  	"cn.ua",
  	"cr.ua",
  	"crimea.ua",
  	"cv.ua",
  	"dn.ua",
  	"dnepropetrovsk.ua",
  	"dnipropetrovsk.ua",
  	"donetsk.ua",
  	"dp.ua",
  	"if.ua",
  	"ivano-frankivsk.ua",
  	"kh.ua",
  	"kharkiv.ua",
  	"kharkov.ua",
  	"kherson.ua",
  	"khmelnitskiy.ua",
  	"khmelnytskyi.ua",
  	"kiev.ua",
  	"kirovograd.ua",
  	"km.ua",
  	"kr.ua",
  	"krym.ua",
  	"ks.ua",
  	"kv.ua",
  	"kyiv.ua",
  	"lg.ua",
  	"lt.ua",
  	"lugansk.ua",
  	"lutsk.ua",
  	"lv.ua",
  	"lviv.ua",
  	"mk.ua",
  	"mykolaiv.ua",
  	"nikolaev.ua",
  	"od.ua",
  	"odesa.ua",
  	"odessa.ua",
  	"pl.ua",
  	"poltava.ua",
  	"rivne.ua",
  	"rovno.ua",
  	"rv.ua",
  	"sb.ua",
  	"sebastopol.ua",
  	"sevastopol.ua",
  	"sm.ua",
  	"sumy.ua",
  	"te.ua",
  	"ternopil.ua",
  	"uz.ua",
  	"uzhgorod.ua",
  	"vinnica.ua",
  	"vinnytsia.ua",
  	"vn.ua",
  	"volyn.ua",
  	"yalta.ua",
  	"zaporizhzhe.ua",
  	"zaporizhzhia.ua",
  	"zhitomir.ua",
  	"zhytomyr.ua",
  	"zp.ua",
  	"zt.ua",
  	"ug",
  	"co.ug",
  	"or.ug",
  	"ac.ug",
  	"sc.ug",
  	"go.ug",
  	"ne.ug",
  	"com.ug",
  	"org.ug",
  	"uk",
  	"ac.uk",
  	"co.uk",
  	"gov.uk",
  	"ltd.uk",
  	"me.uk",
  	"net.uk",
  	"nhs.uk",
  	"org.uk",
  	"plc.uk",
  	"police.uk",
  	"*.sch.uk",
  	"us",
  	"dni.us",
  	"fed.us",
  	"isa.us",
  	"kids.us",
  	"nsn.us",
  	"ak.us",
  	"al.us",
  	"ar.us",
  	"as.us",
  	"az.us",
  	"ca.us",
  	"co.us",
  	"ct.us",
  	"dc.us",
  	"de.us",
  	"fl.us",
  	"ga.us",
  	"gu.us",
  	"hi.us",
  	"ia.us",
  	"id.us",
  	"il.us",
  	"in.us",
  	"ks.us",
  	"ky.us",
  	"la.us",
  	"ma.us",
  	"md.us",
  	"me.us",
  	"mi.us",
  	"mn.us",
  	"mo.us",
  	"ms.us",
  	"mt.us",
  	"nc.us",
  	"nd.us",
  	"ne.us",
  	"nh.us",
  	"nj.us",
  	"nm.us",
  	"nv.us",
  	"ny.us",
  	"oh.us",
  	"ok.us",
  	"or.us",
  	"pa.us",
  	"pr.us",
  	"ri.us",
  	"sc.us",
  	"sd.us",
  	"tn.us",
  	"tx.us",
  	"ut.us",
  	"vi.us",
  	"vt.us",
  	"va.us",
  	"wa.us",
  	"wi.us",
  	"wv.us",
  	"wy.us",
  	"k12.ak.us",
  	"k12.al.us",
  	"k12.ar.us",
  	"k12.as.us",
  	"k12.az.us",
  	"k12.ca.us",
  	"k12.co.us",
  	"k12.ct.us",
  	"k12.dc.us",
  	"k12.de.us",
  	"k12.fl.us",
  	"k12.ga.us",
  	"k12.gu.us",
  	"k12.ia.us",
  	"k12.id.us",
  	"k12.il.us",
  	"k12.in.us",
  	"k12.ks.us",
  	"k12.ky.us",
  	"k12.la.us",
  	"k12.ma.us",
  	"k12.md.us",
  	"k12.me.us",
  	"k12.mi.us",
  	"k12.mn.us",
  	"k12.mo.us",
  	"k12.ms.us",
  	"k12.mt.us",
  	"k12.nc.us",
  	"k12.ne.us",
  	"k12.nh.us",
  	"k12.nj.us",
  	"k12.nm.us",
  	"k12.nv.us",
  	"k12.ny.us",
  	"k12.oh.us",
  	"k12.ok.us",
  	"k12.or.us",
  	"k12.pa.us",
  	"k12.pr.us",
  	"k12.sc.us",
  	"k12.tn.us",
  	"k12.tx.us",
  	"k12.ut.us",
  	"k12.vi.us",
  	"k12.vt.us",
  	"k12.va.us",
  	"k12.wa.us",
  	"k12.wi.us",
  	"k12.wy.us",
  	"cc.ak.us",
  	"cc.al.us",
  	"cc.ar.us",
  	"cc.as.us",
  	"cc.az.us",
  	"cc.ca.us",
  	"cc.co.us",
  	"cc.ct.us",
  	"cc.dc.us",
  	"cc.de.us",
  	"cc.fl.us",
  	"cc.ga.us",
  	"cc.gu.us",
  	"cc.hi.us",
  	"cc.ia.us",
  	"cc.id.us",
  	"cc.il.us",
  	"cc.in.us",
  	"cc.ks.us",
  	"cc.ky.us",
  	"cc.la.us",
  	"cc.ma.us",
  	"cc.md.us",
  	"cc.me.us",
  	"cc.mi.us",
  	"cc.mn.us",
  	"cc.mo.us",
  	"cc.ms.us",
  	"cc.mt.us",
  	"cc.nc.us",
  	"cc.nd.us",
  	"cc.ne.us",
  	"cc.nh.us",
  	"cc.nj.us",
  	"cc.nm.us",
  	"cc.nv.us",
  	"cc.ny.us",
  	"cc.oh.us",
  	"cc.ok.us",
  	"cc.or.us",
  	"cc.pa.us",
  	"cc.pr.us",
  	"cc.ri.us",
  	"cc.sc.us",
  	"cc.sd.us",
  	"cc.tn.us",
  	"cc.tx.us",
  	"cc.ut.us",
  	"cc.vi.us",
  	"cc.vt.us",
  	"cc.va.us",
  	"cc.wa.us",
  	"cc.wi.us",
  	"cc.wv.us",
  	"cc.wy.us",
  	"lib.ak.us",
  	"lib.al.us",
  	"lib.ar.us",
  	"lib.as.us",
  	"lib.az.us",
  	"lib.ca.us",
  	"lib.co.us",
  	"lib.ct.us",
  	"lib.dc.us",
  	"lib.fl.us",
  	"lib.ga.us",
  	"lib.gu.us",
  	"lib.hi.us",
  	"lib.ia.us",
  	"lib.id.us",
  	"lib.il.us",
  	"lib.in.us",
  	"lib.ks.us",
  	"lib.ky.us",
  	"lib.la.us",
  	"lib.ma.us",
  	"lib.md.us",
  	"lib.me.us",
  	"lib.mi.us",
  	"lib.mn.us",
  	"lib.mo.us",
  	"lib.ms.us",
  	"lib.mt.us",
  	"lib.nc.us",
  	"lib.nd.us",
  	"lib.ne.us",
  	"lib.nh.us",
  	"lib.nj.us",
  	"lib.nm.us",
  	"lib.nv.us",
  	"lib.ny.us",
  	"lib.oh.us",
  	"lib.ok.us",
  	"lib.or.us",
  	"lib.pa.us",
  	"lib.pr.us",
  	"lib.ri.us",
  	"lib.sc.us",
  	"lib.sd.us",
  	"lib.tn.us",
  	"lib.tx.us",
  	"lib.ut.us",
  	"lib.vi.us",
  	"lib.vt.us",
  	"lib.va.us",
  	"lib.wa.us",
  	"lib.wi.us",
  	"lib.wy.us",
  	"pvt.k12.ma.us",
  	"chtr.k12.ma.us",
  	"paroch.k12.ma.us",
  	"ann-arbor.mi.us",
  	"cog.mi.us",
  	"dst.mi.us",
  	"eaton.mi.us",
  	"gen.mi.us",
  	"mus.mi.us",
  	"tec.mi.us",
  	"washtenaw.mi.us",
  	"uy",
  	"com.uy",
  	"edu.uy",
  	"gub.uy",
  	"mil.uy",
  	"net.uy",
  	"org.uy",
  	"uz",
  	"co.uz",
  	"com.uz",
  	"net.uz",
  	"org.uz",
  	"va",
  	"vc",
  	"com.vc",
  	"net.vc",
  	"org.vc",
  	"gov.vc",
  	"mil.vc",
  	"edu.vc",
  	"ve",
  	"arts.ve",
  	"bib.ve",
  	"co.ve",
  	"com.ve",
  	"e12.ve",
  	"edu.ve",
  	"firm.ve",
  	"gob.ve",
  	"gov.ve",
  	"info.ve",
  	"int.ve",
  	"mil.ve",
  	"net.ve",
  	"nom.ve",
  	"org.ve",
  	"rar.ve",
  	"rec.ve",
  	"store.ve",
  	"tec.ve",
  	"web.ve",
  	"vg",
  	"vi",
  	"co.vi",
  	"com.vi",
  	"k12.vi",
  	"net.vi",
  	"org.vi",
  	"vn",
  	"com.vn",
  	"net.vn",
  	"org.vn",
  	"edu.vn",
  	"gov.vn",
  	"int.vn",
  	"ac.vn",
  	"biz.vn",
  	"info.vn",
  	"name.vn",
  	"pro.vn",
  	"health.vn",
  	"vu",
  	"com.vu",
  	"edu.vu",
  	"net.vu",
  	"org.vu",
  	"wf",
  	"ws",
  	"com.ws",
  	"net.ws",
  	"org.ws",
  	"gov.ws",
  	"edu.ws",
  	"yt",
  	"امارات",
  	"հայ",
  	"বাংলা",
  	"бг",
  	"البحرين",
  	"бел",
  	"中国",
  	"中國",
  	"الجزائر",
  	"مصر",
  	"ею",
  	"ευ",
  	"موريتانيا",
  	"გე",
  	"ελ",
  	"香港",
  	"公司.香港",
  	"教育.香港",
  	"政府.香港",
  	"個人.香港",
  	"網絡.香港",
  	"組織.香港",
  	"ಭಾರತ",
  	"ଭାରତ",
  	"ভাৰত",
  	"भारतम्",
  	"भारोत",
  	"ڀارت",
  	"ഭാരതം",
  	"भारत",
  	"بارت",
  	"بھارت",
  	"భారత్",
  	"ભારત",
  	"ਭਾਰਤ",
  	"ভারত",
  	"இந்தியா",
  	"ایران",
  	"ايران",
  	"عراق",
  	"الاردن",
  	"한국",
  	"қаз",
  	"ລາວ",
  	"ලංකා",
  	"இலங்கை",
  	"المغرب",
  	"мкд",
  	"мон",
  	"澳門",
  	"澳门",
  	"مليسيا",
  	"عمان",
  	"پاکستان",
  	"پاكستان",
  	"فلسطين",
  	"срб",
  	"пр.срб",
  	"орг.срб",
  	"обр.срб",
  	"од.срб",
  	"упр.срб",
  	"ак.срб",
  	"рф",
  	"قطر",
  	"السعودية",
  	"السعودیة",
  	"السعودیۃ",
  	"السعوديه",
  	"سودان",
  	"新加坡",
  	"சிங்கப்பூர்",
  	"سورية",
  	"سوريا",
  	"ไทย",
  	"ศึกษา.ไทย",
  	"ธุรกิจ.ไทย",
  	"รัฐบาล.ไทย",
  	"ทหาร.ไทย",
  	"เน็ต.ไทย",
  	"องค์กร.ไทย",
  	"تونس",
  	"台灣",
  	"台湾",
  	"臺灣",
  	"укр",
  	"اليمن",
  	"xxx",
  	"ye",
  	"com.ye",
  	"edu.ye",
  	"gov.ye",
  	"net.ye",
  	"mil.ye",
  	"org.ye",
  	"ac.za",
  	"agric.za",
  	"alt.za",
  	"co.za",
  	"edu.za",
  	"gov.za",
  	"grondar.za",
  	"law.za",
  	"mil.za",
  	"net.za",
  	"ngo.za",
  	"nic.za",
  	"nis.za",
  	"nom.za",
  	"org.za",
  	"school.za",
  	"tm.za",
  	"web.za",
  	"zm",
  	"ac.zm",
  	"biz.zm",
  	"co.zm",
  	"com.zm",
  	"edu.zm",
  	"gov.zm",
  	"info.zm",
  	"mil.zm",
  	"net.zm",
  	"org.zm",
  	"sch.zm",
  	"zw",
  	"ac.zw",
  	"co.zw",
  	"gov.zw",
  	"mil.zw",
  	"org.zw",
  	"aaa",
  	"aarp",
  	"abarth",
  	"abb",
  	"abbott",
  	"abbvie",
  	"abc",
  	"able",
  	"abogado",
  	"abudhabi",
  	"academy",
  	"accenture",
  	"accountant",
  	"accountants",
  	"aco",
  	"actor",
  	"adac",
  	"ads",
  	"adult",
  	"aeg",
  	"aetna",
  	"afl",
  	"africa",
  	"agakhan",
  	"agency",
  	"aig",
  	"airbus",
  	"airforce",
  	"airtel",
  	"akdn",
  	"alfaromeo",
  	"alibaba",
  	"alipay",
  	"allfinanz",
  	"allstate",
  	"ally",
  	"alsace",
  	"alstom",
  	"amazon",
  	"americanexpress",
  	"americanfamily",
  	"amex",
  	"amfam",
  	"amica",
  	"amsterdam",
  	"analytics",
  	"android",
  	"anquan",
  	"anz",
  	"aol",
  	"apartments",
  	"app",
  	"apple",
  	"aquarelle",
  	"arab",
  	"aramco",
  	"archi",
  	"army",
  	"art",
  	"arte",
  	"asda",
  	"associates",
  	"athleta",
  	"attorney",
  	"auction",
  	"audi",
  	"audible",
  	"audio",
  	"auspost",
  	"author",
  	"auto",
  	"autos",
  	"avianca",
  	"aws",
  	"axa",
  	"azure",
  	"baby",
  	"baidu",
  	"banamex",
  	"bananarepublic",
  	"band",
  	"bank",
  	"bar",
  	"barcelona",
  	"barclaycard",
  	"barclays",
  	"barefoot",
  	"bargains",
  	"baseball",
  	"basketball",
  	"bauhaus",
  	"bayern",
  	"bbc",
  	"bbt",
  	"bbva",
  	"bcg",
  	"bcn",
  	"beats",
  	"beauty",
  	"beer",
  	"bentley",
  	"berlin",
  	"best",
  	"bestbuy",
  	"bet",
  	"bharti",
  	"bible",
  	"bid",
  	"bike",
  	"bing",
  	"bingo",
  	"bio",
  	"black",
  	"blackfriday",
  	"blockbuster",
  	"blog",
  	"bloomberg",
  	"blue",
  	"bms",
  	"bmw",
  	"bnpparibas",
  	"boats",
  	"boehringer",
  	"bofa",
  	"bom",
  	"bond",
  	"boo",
  	"book",
  	"booking",
  	"bosch",
  	"bostik",
  	"boston",
  	"bot",
  	"boutique",
  	"box",
  	"bradesco",
  	"bridgestone",
  	"broadway",
  	"broker",
  	"brother",
  	"brussels",
  	"bugatti",
  	"build",
  	"builders",
  	"business",
  	"buy",
  	"buzz",
  	"bzh",
  	"cab",
  	"cafe",
  	"cal",
  	"call",
  	"calvinklein",
  	"cam",
  	"camera",
  	"camp",
  	"cancerresearch",
  	"canon",
  	"capetown",
  	"capital",
  	"capitalone",
  	"car",
  	"caravan",
  	"cards",
  	"care",
  	"career",
  	"careers",
  	"cars",
  	"casa",
  	"case",
  	"cash",
  	"casino",
  	"catering",
  	"catholic",
  	"cba",
  	"cbn",
  	"cbre",
  	"cbs",
  	"center",
  	"ceo",
  	"cern",
  	"cfa",
  	"cfd",
  	"chanel",
  	"channel",
  	"charity",
  	"chase",
  	"chat",
  	"cheap",
  	"chintai",
  	"christmas",
  	"chrome",
  	"church",
  	"cipriani",
  	"circle",
  	"cisco",
  	"citadel",
  	"citi",
  	"citic",
  	"city",
  	"cityeats",
  	"claims",
  	"cleaning",
  	"click",
  	"clinic",
  	"clinique",
  	"clothing",
  	"cloud",
  	"club",
  	"clubmed",
  	"coach",
  	"codes",
  	"coffee",
  	"college",
  	"cologne",
  	"comcast",
  	"commbank",
  	"community",
  	"company",
  	"compare",
  	"computer",
  	"comsec",
  	"condos",
  	"construction",
  	"consulting",
  	"contact",
  	"contractors",
  	"cooking",
  	"cookingchannel",
  	"cool",
  	"corsica",
  	"country",
  	"coupon",
  	"coupons",
  	"courses",
  	"cpa",
  	"credit",
  	"creditcard",
  	"creditunion",
  	"cricket",
  	"crown",
  	"crs",
  	"cruise",
  	"cruises",
  	"cuisinella",
  	"cymru",
  	"cyou",
  	"dabur",
  	"dad",
  	"dance",
  	"data",
  	"date",
  	"dating",
  	"datsun",
  	"day",
  	"dclk",
  	"dds",
  	"deal",
  	"dealer",
  	"deals",
  	"degree",
  	"delivery",
  	"dell",
  	"deloitte",
  	"delta",
  	"democrat",
  	"dental",
  	"dentist",
  	"desi",
  	"design",
  	"dev",
  	"dhl",
  	"diamonds",
  	"diet",
  	"digital",
  	"direct",
  	"directory",
  	"discount",
  	"discover",
  	"dish",
  	"diy",
  	"dnp",
  	"docs",
  	"doctor",
  	"dog",
  	"domains",
  	"dot",
  	"download",
  	"drive",
  	"dtv",
  	"dubai",
  	"dunlop",
  	"dupont",
  	"durban",
  	"dvag",
  	"dvr",
  	"earth",
  	"eat",
  	"eco",
  	"edeka",
  	"education",
  	"email",
  	"emerck",
  	"energy",
  	"engineer",
  	"engineering",
  	"enterprises",
  	"epson",
  	"equipment",
  	"ericsson",
  	"erni",
  	"esq",
  	"estate",
  	"etisalat",
  	"eurovision",
  	"eus",
  	"events",
  	"exchange",
  	"expert",
  	"exposed",
  	"express",
  	"extraspace",
  	"fage",
  	"fail",
  	"fairwinds",
  	"faith",
  	"family",
  	"fan",
  	"fans",
  	"farm",
  	"farmers",
  	"fashion",
  	"fast",
  	"fedex",
  	"feedback",
  	"ferrari",
  	"ferrero",
  	"fiat",
  	"fidelity",
  	"fido",
  	"film",
  	"final",
  	"finance",
  	"financial",
  	"fire",
  	"firestone",
  	"firmdale",
  	"fish",
  	"fishing",
  	"fit",
  	"fitness",
  	"flickr",
  	"flights",
  	"flir",
  	"florist",
  	"flowers",
  	"fly",
  	"foo",
  	"food",
  	"foodnetwork",
  	"football",
  	"ford",
  	"forex",
  	"forsale",
  	"forum",
  	"foundation",
  	"fox",
  	"free",
  	"fresenius",
  	"frl",
  	"frogans",
  	"frontdoor",
  	"frontier",
  	"ftr",
  	"fujitsu",
  	"fun",
  	"fund",
  	"furniture",
  	"futbol",
  	"fyi",
  	"gal",
  	"gallery",
  	"gallo",
  	"gallup",
  	"game",
  	"games",
  	"gap",
  	"garden",
  	"gay",
  	"gbiz",
  	"gdn",
  	"gea",
  	"gent",
  	"genting",
  	"george",
  	"ggee",
  	"gift",
  	"gifts",
  	"gives",
  	"giving",
  	"glass",
  	"gle",
  	"global",
  	"globo",
  	"gmail",
  	"gmbh",
  	"gmo",
  	"gmx",
  	"godaddy",
  	"gold",
  	"goldpoint",
  	"golf",
  	"goo",
  	"goodyear",
  	"goog",
  	"google",
  	"gop",
  	"got",
  	"grainger",
  	"graphics",
  	"gratis",
  	"green",
  	"gripe",
  	"grocery",
  	"group",
  	"guardian",
  	"gucci",
  	"guge",
  	"guide",
  	"guitars",
  	"guru",
  	"hair",
  	"hamburg",
  	"hangout",
  	"haus",
  	"hbo",
  	"hdfc",
  	"hdfcbank",
  	"health",
  	"healthcare",
  	"help",
  	"helsinki",
  	"here",
  	"hermes",
  	"hgtv",
  	"hiphop",
  	"hisamitsu",
  	"hitachi",
  	"hiv",
  	"hkt",
  	"hockey",
  	"holdings",
  	"holiday",
  	"homedepot",
  	"homegoods",
  	"homes",
  	"homesense",
  	"honda",
  	"horse",
  	"hospital",
  	"host",
  	"hosting",
  	"hot",
  	"hoteles",
  	"hotels",
  	"hotmail",
  	"house",
  	"how",
  	"hsbc",
  	"hughes",
  	"hyatt",
  	"hyundai",
  	"ibm",
  	"icbc",
  	"ice",
  	"icu",
  	"ieee",
  	"ifm",
  	"ikano",
  	"imamat",
  	"imdb",
  	"immo",
  	"immobilien",
  	"inc",
  	"industries",
  	"infiniti",
  	"ing",
  	"ink",
  	"institute",
  	"insurance",
  	"insure",
  	"international",
  	"intuit",
  	"investments",
  	"ipiranga",
  	"irish",
  	"ismaili",
  	"ist",
  	"istanbul",
  	"itau",
  	"itv",
  	"jaguar",
  	"java",
  	"jcb",
  	"jeep",
  	"jetzt",
  	"jewelry",
  	"jio",
  	"jll",
  	"jmp",
  	"jnj",
  	"joburg",
  	"jot",
  	"joy",
  	"jpmorgan",
  	"jprs",
  	"juegos",
  	"juniper",
  	"kaufen",
  	"kddi",
  	"kerryhotels",
  	"kerrylogistics",
  	"kerryproperties",
  	"kfh",
  	"kia",
  	"kids",
  	"kim",
  	"kinder",
  	"kindle",
  	"kitchen",
  	"kiwi",
  	"koeln",
  	"komatsu",
  	"kosher",
  	"kpmg",
  	"kpn",
  	"krd",
  	"kred",
  	"kuokgroup",
  	"kyoto",
  	"lacaixa",
  	"lamborghini",
  	"lamer",
  	"lancaster",
  	"lancia",
  	"land",
  	"landrover",
  	"lanxess",
  	"lasalle",
  	"lat",
  	"latino",
  	"latrobe",
  	"law",
  	"lawyer",
  	"lds",
  	"lease",
  	"leclerc",
  	"lefrak",
  	"legal",
  	"lego",
  	"lexus",
  	"lgbt",
  	"lidl",
  	"life",
  	"lifeinsurance",
  	"lifestyle",
  	"lighting",
  	"like",
  	"lilly",
  	"limited",
  	"limo",
  	"lincoln",
  	"linde",
  	"link",
  	"lipsy",
  	"live",
  	"living",
  	"llc",
  	"llp",
  	"loan",
  	"loans",
  	"locker",
  	"locus",
  	"loft",
  	"lol",
  	"london",
  	"lotte",
  	"lotto",
  	"love",
  	"lpl",
  	"lplfinancial",
  	"ltd",
  	"ltda",
  	"lundbeck",
  	"luxe",
  	"luxury",
  	"macys",
  	"madrid",
  	"maif",
  	"maison",
  	"makeup",
  	"man",
  	"management",
  	"mango",
  	"map",
  	"market",
  	"marketing",
  	"markets",
  	"marriott",
  	"marshalls",
  	"maserati",
  	"mattel",
  	"mba",
  	"mckinsey",
  	"med",
  	"media",
  	"meet",
  	"melbourne",
  	"meme",
  	"memorial",
  	"men",
  	"menu",
  	"merckmsd",
  	"miami",
  	"microsoft",
  	"mini",
  	"mint",
  	"mit",
  	"mitsubishi",
  	"mlb",
  	"mls",
  	"mma",
  	"mobile",
  	"moda",
  	"moe",
  	"moi",
  	"mom",
  	"monash",
  	"money",
  	"monster",
  	"mormon",
  	"mortgage",
  	"moscow",
  	"moto",
  	"motorcycles",
  	"mov",
  	"movie",
  	"msd",
  	"mtn",
  	"mtr",
  	"music",
  	"mutual",
  	"nab",
  	"nagoya",
  	"natura",
  	"navy",
  	"nba",
  	"nec",
  	"netbank",
  	"netflix",
  	"network",
  	"neustar",
  	"new",
  	"news",
  	"next",
  	"nextdirect",
  	"nexus",
  	"nfl",
  	"ngo",
  	"nhk",
  	"nico",
  	"nike",
  	"nikon",
  	"ninja",
  	"nissan",
  	"nissay",
  	"nokia",
  	"northwesternmutual",
  	"norton",
  	"now",
  	"nowruz",
  	"nowtv",
  	"nra",
  	"nrw",
  	"ntt",
  	"nyc",
  	"obi",
  	"observer",
  	"office",
  	"okinawa",
  	"olayan",
  	"olayangroup",
  	"oldnavy",
  	"ollo",
  	"omega",
  	"one",
  	"ong",
  	"onl",
  	"online",
  	"ooo",
  	"open",
  	"oracle",
  	"orange",
  	"organic",
  	"origins",
  	"osaka",
  	"otsuka",
  	"ott",
  	"ovh",
  	"page",
  	"panasonic",
  	"paris",
  	"pars",
  	"partners",
  	"parts",
  	"party",
  	"passagens",
  	"pay",
  	"pccw",
  	"pet",
  	"pfizer",
  	"pharmacy",
  	"phd",
  	"philips",
  	"phone",
  	"photo",
  	"photography",
  	"photos",
  	"physio",
  	"pics",
  	"pictet",
  	"pictures",
  	"pid",
  	"pin",
  	"ping",
  	"pink",
  	"pioneer",
  	"pizza",
  	"place",
  	"play",
  	"playstation",
  	"plumbing",
  	"plus",
  	"pnc",
  	"pohl",
  	"poker",
  	"politie",
  	"porn",
  	"pramerica",
  	"praxi",
  	"press",
  	"prime",
  	"prod",
  	"productions",
  	"prof",
  	"progressive",
  	"promo",
  	"properties",
  	"property",
  	"protection",
  	"pru",
  	"prudential",
  	"pub",
  	"pwc",
  	"qpon",
  	"quebec",
  	"quest",
  	"racing",
  	"radio",
  	"read",
  	"realestate",
  	"realtor",
  	"realty",
  	"recipes",
  	"red",
  	"redstone",
  	"redumbrella",
  	"rehab",
  	"reise",
  	"reisen",
  	"reit",
  	"reliance",
  	"ren",
  	"rent",
  	"rentals",
  	"repair",
  	"report",
  	"republican",
  	"rest",
  	"restaurant",
  	"review",
  	"reviews",
  	"rexroth",
  	"rich",
  	"richardli",
  	"ricoh",
  	"ril",
  	"rio",
  	"rip",
  	"rocher",
  	"rocks",
  	"rodeo",
  	"rogers",
  	"room",
  	"rsvp",
  	"rugby",
  	"ruhr",
  	"run",
  	"rwe",
  	"ryukyu",
  	"saarland",
  	"safe",
  	"safety",
  	"sakura",
  	"sale",
  	"salon",
  	"samsclub",
  	"samsung",
  	"sandvik",
  	"sandvikcoromant",
  	"sanofi",
  	"sap",
  	"sarl",
  	"sas",
  	"save",
  	"saxo",
  	"sbi",
  	"sbs",
  	"sca",
  	"scb",
  	"schaeffler",
  	"schmidt",
  	"scholarships",
  	"school",
  	"schule",
  	"schwarz",
  	"science",
  	"scot",
  	"search",
  	"seat",
  	"secure",
  	"security",
  	"seek",
  	"select",
  	"sener",
  	"services",
  	"ses",
  	"seven",
  	"sew",
  	"sex",
  	"sexy",
  	"sfr",
  	"shangrila",
  	"sharp",
  	"shaw",
  	"shell",
  	"shia",
  	"shiksha",
  	"shoes",
  	"shop",
  	"shopping",
  	"shouji",
  	"show",
  	"showtime",
  	"silk",
  	"sina",
  	"singles",
  	"site",
  	"ski",
  	"skin",
  	"sky",
  	"skype",
  	"sling",
  	"smart",
  	"smile",
  	"sncf",
  	"soccer",
  	"social",
  	"softbank",
  	"software",
  	"sohu",
  	"solar",
  	"solutions",
  	"song",
  	"sony",
  	"soy",
  	"spa",
  	"space",
  	"sport",
  	"spot",
  	"srl",
  	"stada",
  	"staples",
  	"star",
  	"statebank",
  	"statefarm",
  	"stc",
  	"stcgroup",
  	"stockholm",
  	"storage",
  	"store",
  	"stream",
  	"studio",
  	"study",
  	"style",
  	"sucks",
  	"supplies",
  	"supply",
  	"support",
  	"surf",
  	"surgery",
  	"suzuki",
  	"swatch",
  	"swiss",
  	"sydney",
  	"systems",
  	"tab",
  	"taipei",
  	"talk",
  	"taobao",
  	"target",
  	"tatamotors",
  	"tatar",
  	"tattoo",
  	"tax",
  	"taxi",
  	"tci",
  	"tdk",
  	"team",
  	"tech",
  	"technology",
  	"temasek",
  	"tennis",
  	"teva",
  	"thd",
  	"theater",
  	"theatre",
  	"tiaa",
  	"tickets",
  	"tienda",
  	"tiffany",
  	"tips",
  	"tires",
  	"tirol",
  	"tjmaxx",
  	"tjx",
  	"tkmaxx",
  	"tmall",
  	"today",
  	"tokyo",
  	"tools",
  	"top",
  	"toray",
  	"toshiba",
  	"total",
  	"tours",
  	"town",
  	"toyota",
  	"toys",
  	"trade",
  	"trading",
  	"training",
  	"travel",
  	"travelchannel",
  	"travelers",
  	"travelersinsurance",
  	"trust",
  	"trv",
  	"tube",
  	"tui",
  	"tunes",
  	"tushu",
  	"tvs",
  	"ubank",
  	"ubs",
  	"unicom",
  	"university",
  	"uno",
  	"uol",
  	"ups",
  	"vacations",
  	"vana",
  	"vanguard",
  	"vegas",
  	"ventures",
  	"verisign",
  	"versicherung",
  	"vet",
  	"viajes",
  	"video",
  	"vig",
  	"viking",
  	"villas",
  	"vin",
  	"vip",
  	"virgin",
  	"visa",
  	"vision",
  	"viva",
  	"vivo",
  	"vlaanderen",
  	"vodka",
  	"volkswagen",
  	"volvo",
  	"vote",
  	"voting",
  	"voto",
  	"voyage",
  	"vuelos",
  	"wales",
  	"walmart",
  	"walter",
  	"wang",
  	"wanggou",
  	"watch",
  	"watches",
  	"weather",
  	"weatherchannel",
  	"webcam",
  	"weber",
  	"website",
  	"wedding",
  	"weibo",
  	"weir",
  	"whoswho",
  	"wien",
  	"wiki",
  	"williamhill",
  	"win",
  	"windows",
  	"wine",
  	"winners",
  	"wme",
  	"wolterskluwer",
  	"woodside",
  	"work",
  	"works",
  	"world",
  	"wow",
  	"wtc",
  	"wtf",
  	"xbox",
  	"xerox",
  	"xfinity",
  	"xihuan",
  	"xin",
  	"कॉम",
  	"セール",
  	"佛山",
  	"慈善",
  	"集团",
  	"在线",
  	"点看",
  	"คอม",
  	"八卦",
  	"موقع",
  	"公益",
  	"公司",
  	"香格里拉",
  	"网站",
  	"移动",
  	"我爱你",
  	"москва",
  	"католик",
  	"онлайн",
  	"сайт",
  	"联通",
  	"קום",
  	"时尚",
  	"微博",
  	"淡马锡",
  	"ファッション",
  	"орг",
  	"नेट",
  	"ストア",
  	"アマゾン",
  	"삼성",
  	"商标",
  	"商店",
  	"商城",
  	"дети",
  	"ポイント",
  	"新闻",
  	"家電",
  	"كوم",
  	"中文网",
  	"中信",
  	"娱乐",
  	"谷歌",
  	"電訊盈科",
  	"购物",
  	"クラウド",
  	"通販",
  	"网店",
  	"संगठन",
  	"餐厅",
  	"网络",
  	"ком",
  	"亚马逊",
  	"诺基亚",
  	"食品",
  	"飞利浦",
  	"手机",
  	"ارامكو",
  	"العليان",
  	"اتصالات",
  	"بازار",
  	"ابوظبي",
  	"كاثوليك",
  	"همراه",
  	"닷컴",
  	"政府",
  	"شبكة",
  	"بيتك",
  	"عرب",
  	"机构",
  	"组织机构",
  	"健康",
  	"招聘",
  	"рус",
  	"大拿",
  	"みんな",
  	"グーグル",
  	"世界",
  	"書籍",
  	"网址",
  	"닷넷",
  	"コム",
  	"天主教",
  	"游戏",
  	"vermögensberater",
  	"vermögensberatung",
  	"企业",
  	"信息",
  	"嘉里大酒店",
  	"嘉里",
  	"广东",
  	"政务",
  	"xyz",
  	"yachts",
  	"yahoo",
  	"yamaxun",
  	"yandex",
  	"yodobashi",
  	"yoga",
  	"yokohama",
  	"you",
  	"youtube",
  	"yun",
  	"zappos",
  	"zara",
  	"zero",
  	"zip",
  	"zone",
  	"zuerich",
  	"cc.ua",
  	"inf.ua",
  	"ltd.ua",
  	"611.to",
  	"graphox.us",
  	"*.devcdnaccesso.com",
  	"adobeaemcloud.com",
  	"*.dev.adobeaemcloud.com",
  	"hlx.live",
  	"adobeaemcloud.net",
  	"hlx.page",
  	"hlx3.page",
  	"beep.pl",
  	"airkitapps.com",
  	"airkitapps-au.com",
  	"airkitapps.eu",
  	"aivencloud.com",
  	"barsy.ca",
  	"*.compute.estate",
  	"*.alces.network",
  	"kasserver.com",
  	"altervista.org",
  	"alwaysdata.net",
  	"cloudfront.net",
  	"*.compute.amazonaws.com",
  	"*.compute-1.amazonaws.com",
  	"*.compute.amazonaws.com.cn",
  	"us-east-1.amazonaws.com",
  	"cn-north-1.eb.amazonaws.com.cn",
  	"cn-northwest-1.eb.amazonaws.com.cn",
  	"elasticbeanstalk.com",
  	"ap-northeast-1.elasticbeanstalk.com",
  	"ap-northeast-2.elasticbeanstalk.com",
  	"ap-northeast-3.elasticbeanstalk.com",
  	"ap-south-1.elasticbeanstalk.com",
  	"ap-southeast-1.elasticbeanstalk.com",
  	"ap-southeast-2.elasticbeanstalk.com",
  	"ca-central-1.elasticbeanstalk.com",
  	"eu-central-1.elasticbeanstalk.com",
  	"eu-west-1.elasticbeanstalk.com",
  	"eu-west-2.elasticbeanstalk.com",
  	"eu-west-3.elasticbeanstalk.com",
  	"sa-east-1.elasticbeanstalk.com",
  	"us-east-1.elasticbeanstalk.com",
  	"us-east-2.elasticbeanstalk.com",
  	"us-gov-west-1.elasticbeanstalk.com",
  	"us-west-1.elasticbeanstalk.com",
  	"us-west-2.elasticbeanstalk.com",
  	"*.elb.amazonaws.com",
  	"*.elb.amazonaws.com.cn",
  	"awsglobalaccelerator.com",
  	"s3.amazonaws.com",
  	"s3-ap-northeast-1.amazonaws.com",
  	"s3-ap-northeast-2.amazonaws.com",
  	"s3-ap-south-1.amazonaws.com",
  	"s3-ap-southeast-1.amazonaws.com",
  	"s3-ap-southeast-2.amazonaws.com",
  	"s3-ca-central-1.amazonaws.com",
  	"s3-eu-central-1.amazonaws.com",
  	"s3-eu-west-1.amazonaws.com",
  	"s3-eu-west-2.amazonaws.com",
  	"s3-eu-west-3.amazonaws.com",
  	"s3-external-1.amazonaws.com",
  	"s3-fips-us-gov-west-1.amazonaws.com",
  	"s3-sa-east-1.amazonaws.com",
  	"s3-us-gov-west-1.amazonaws.com",
  	"s3-us-east-2.amazonaws.com",
  	"s3-us-west-1.amazonaws.com",
  	"s3-us-west-2.amazonaws.com",
  	"s3.ap-northeast-2.amazonaws.com",
  	"s3.ap-south-1.amazonaws.com",
  	"s3.cn-north-1.amazonaws.com.cn",
  	"s3.ca-central-1.amazonaws.com",
  	"s3.eu-central-1.amazonaws.com",
  	"s3.eu-west-2.amazonaws.com",
  	"s3.eu-west-3.amazonaws.com",
  	"s3.us-east-2.amazonaws.com",
  	"s3.dualstack.ap-northeast-1.amazonaws.com",
  	"s3.dualstack.ap-northeast-2.amazonaws.com",
  	"s3.dualstack.ap-south-1.amazonaws.com",
  	"s3.dualstack.ap-southeast-1.amazonaws.com",
  	"s3.dualstack.ap-southeast-2.amazonaws.com",
  	"s3.dualstack.ca-central-1.amazonaws.com",
  	"s3.dualstack.eu-central-1.amazonaws.com",
  	"s3.dualstack.eu-west-1.amazonaws.com",
  	"s3.dualstack.eu-west-2.amazonaws.com",
  	"s3.dualstack.eu-west-3.amazonaws.com",
  	"s3.dualstack.sa-east-1.amazonaws.com",
  	"s3.dualstack.us-east-1.amazonaws.com",
  	"s3.dualstack.us-east-2.amazonaws.com",
  	"s3-website-us-east-1.amazonaws.com",
  	"s3-website-us-west-1.amazonaws.com",
  	"s3-website-us-west-2.amazonaws.com",
  	"s3-website-ap-northeast-1.amazonaws.com",
  	"s3-website-ap-southeast-1.amazonaws.com",
  	"s3-website-ap-southeast-2.amazonaws.com",
  	"s3-website-eu-west-1.amazonaws.com",
  	"s3-website-sa-east-1.amazonaws.com",
  	"s3-website.ap-northeast-2.amazonaws.com",
  	"s3-website.ap-south-1.amazonaws.com",
  	"s3-website.ca-central-1.amazonaws.com",
  	"s3-website.eu-central-1.amazonaws.com",
  	"s3-website.eu-west-2.amazonaws.com",
  	"s3-website.eu-west-3.amazonaws.com",
  	"s3-website.us-east-2.amazonaws.com",
  	"t3l3p0rt.net",
  	"tele.amune.org",
  	"apigee.io",
  	"siiites.com",
  	"appspacehosted.com",
  	"appspaceusercontent.com",
  	"appudo.net",
  	"on-aptible.com",
  	"user.aseinet.ne.jp",
  	"gv.vc",
  	"d.gv.vc",
  	"user.party.eus",
  	"pimienta.org",
  	"poivron.org",
  	"potager.org",
  	"sweetpepper.org",
  	"myasustor.com",
  	"cdn.prod.atlassian-dev.net",
  	"translated.page",
  	"myfritz.net",
  	"onavstack.net",
  	"*.awdev.ca",
  	"*.advisor.ws",
  	"ecommerce-shop.pl",
  	"b-data.io",
  	"backplaneapp.io",
  	"balena-devices.com",
  	"rs.ba",
  	"*.banzai.cloud",
  	"app.banzaicloud.io",
  	"*.backyards.banzaicloud.io",
  	"base.ec",
  	"official.ec",
  	"buyshop.jp",
  	"fashionstore.jp",
  	"handcrafted.jp",
  	"kawaiishop.jp",
  	"supersale.jp",
  	"theshop.jp",
  	"shopselect.net",
  	"base.shop",
  	"*.beget.app",
  	"betainabox.com",
  	"bnr.la",
  	"bitbucket.io",
  	"blackbaudcdn.net",
  	"of.je",
  	"bluebite.io",
  	"boomla.net",
  	"boutir.com",
  	"boxfuse.io",
  	"square7.ch",
  	"bplaced.com",
  	"bplaced.de",
  	"square7.de",
  	"bplaced.net",
  	"square7.net",
  	"shop.brendly.rs",
  	"browsersafetymark.io",
  	"uk0.bigv.io",
  	"dh.bytemark.co.uk",
  	"vm.bytemark.co.uk",
  	"cafjs.com",
  	"mycd.eu",
  	"drr.ac",
  	"uwu.ai",
  	"carrd.co",
  	"crd.co",
  	"ju.mp",
  	"ae.org",
  	"br.com",
  	"cn.com",
  	"com.de",
  	"com.se",
  	"de.com",
  	"eu.com",
  	"gb.net",
  	"hu.net",
  	"jp.net",
  	"jpn.com",
  	"mex.com",
  	"ru.com",
  	"sa.com",
  	"se.net",
  	"uk.com",
  	"uk.net",
  	"us.com",
  	"za.bz",
  	"za.com",
  	"ar.com",
  	"hu.com",
  	"kr.com",
  	"no.com",
  	"qc.com",
  	"uy.com",
  	"africa.com",
  	"gr.com",
  	"in.net",
  	"web.in",
  	"us.org",
  	"co.com",
  	"aus.basketball",
  	"nz.basketball",
  	"radio.am",
  	"radio.fm",
  	"c.la",
  	"certmgr.org",
  	"cx.ua",
  	"discourse.group",
  	"discourse.team",
  	"cleverapps.io",
  	"clerk.app",
  	"clerkstage.app",
  	"*.lcl.dev",
  	"*.lclstage.dev",
  	"*.stg.dev",
  	"*.stgstage.dev",
  	"clickrising.net",
  	"c66.me",
  	"cloud66.ws",
  	"cloud66.zone",
  	"jdevcloud.com",
  	"wpdevcloud.com",
  	"cloudaccess.host",
  	"freesite.host",
  	"cloudaccess.net",
  	"cloudcontrolled.com",
  	"cloudcontrolapp.com",
  	"*.cloudera.site",
  	"pages.dev",
  	"trycloudflare.com",
  	"workers.dev",
  	"wnext.app",
  	"co.ca",
  	"*.otap.co",
  	"co.cz",
  	"c.cdn77.org",
  	"cdn77-ssl.net",
  	"r.cdn77.net",
  	"rsc.cdn77.org",
  	"ssl.origin.cdn77-secure.org",
  	"cloudns.asia",
  	"cloudns.biz",
  	"cloudns.club",
  	"cloudns.cc",
  	"cloudns.eu",
  	"cloudns.in",
  	"cloudns.info",
  	"cloudns.org",
  	"cloudns.pro",
  	"cloudns.pw",
  	"cloudns.us",
  	"cnpy.gdn",
  	"codeberg.page",
  	"co.nl",
  	"co.no",
  	"webhosting.be",
  	"hosting-cluster.nl",
  	"ac.ru",
  	"edu.ru",
  	"gov.ru",
  	"int.ru",
  	"mil.ru",
  	"test.ru",
  	"dyn.cosidns.de",
  	"dynamisches-dns.de",
  	"dnsupdater.de",
  	"internet-dns.de",
  	"l-o-g-i-n.de",
  	"dynamic-dns.info",
  	"feste-ip.net",
  	"knx-server.net",
  	"static-access.net",
  	"realm.cz",
  	"*.cryptonomic.net",
  	"cupcake.is",
  	"curv.dev",
  	"*.customer-oci.com",
  	"*.oci.customer-oci.com",
  	"*.ocp.customer-oci.com",
  	"*.ocs.customer-oci.com",
  	"cyon.link",
  	"cyon.site",
  	"fnwk.site",
  	"folionetwork.site",
  	"platform0.app",
  	"daplie.me",
  	"localhost.daplie.me",
  	"dattolocal.com",
  	"dattorelay.com",
  	"dattoweb.com",
  	"mydatto.com",
  	"dattolocal.net",
  	"mydatto.net",
  	"biz.dk",
  	"co.dk",
  	"firm.dk",
  	"reg.dk",
  	"store.dk",
  	"dyndns.dappnode.io",
  	"*.dapps.earth",
  	"*.bzz.dapps.earth",
  	"builtwithdark.com",
  	"demo.datadetect.com",
  	"instance.datadetect.com",
  	"edgestack.me",
  	"ddns5.com",
  	"debian.net",
  	"deno.dev",
  	"deno-staging.dev",
  	"dedyn.io",
  	"deta.app",
  	"deta.dev",
  	"*.rss.my.id",
  	"*.diher.solutions",
  	"discordsays.com",
  	"discordsez.com",
  	"jozi.biz",
  	"dnshome.de",
  	"online.th",
  	"shop.th",
  	"drayddns.com",
  	"shoparena.pl",
  	"dreamhosters.com",
  	"mydrobo.com",
  	"drud.io",
  	"drud.us",
  	"duckdns.org",
  	"bip.sh",
  	"bitbridge.net",
  	"dy.fi",
  	"tunk.org",
  	"dyndns-at-home.com",
  	"dyndns-at-work.com",
  	"dyndns-blog.com",
  	"dyndns-free.com",
  	"dyndns-home.com",
  	"dyndns-ip.com",
  	"dyndns-mail.com",
  	"dyndns-office.com",
  	"dyndns-pics.com",
  	"dyndns-remote.com",
  	"dyndns-server.com",
  	"dyndns-web.com",
  	"dyndns-wiki.com",
  	"dyndns-work.com",
  	"dyndns.biz",
  	"dyndns.info",
  	"dyndns.org",
  	"dyndns.tv",
  	"at-band-camp.net",
  	"ath.cx",
  	"barrel-of-knowledge.info",
  	"barrell-of-knowledge.info",
  	"better-than.tv",
  	"blogdns.com",
  	"blogdns.net",
  	"blogdns.org",
  	"blogsite.org",
  	"boldlygoingnowhere.org",
  	"broke-it.net",
  	"buyshouses.net",
  	"cechire.com",
  	"dnsalias.com",
  	"dnsalias.net",
  	"dnsalias.org",
  	"dnsdojo.com",
  	"dnsdojo.net",
  	"dnsdojo.org",
  	"does-it.net",
  	"doesntexist.com",
  	"doesntexist.org",
  	"dontexist.com",
  	"dontexist.net",
  	"dontexist.org",
  	"doomdns.com",
  	"doomdns.org",
  	"dvrdns.org",
  	"dyn-o-saur.com",
  	"dynalias.com",
  	"dynalias.net",
  	"dynalias.org",
  	"dynathome.net",
  	"dyndns.ws",
  	"endofinternet.net",
  	"endofinternet.org",
  	"endoftheinternet.org",
  	"est-a-la-maison.com",
  	"est-a-la-masion.com",
  	"est-le-patron.com",
  	"est-mon-blogueur.com",
  	"for-better.biz",
  	"for-more.biz",
  	"for-our.info",
  	"for-some.biz",
  	"for-the.biz",
  	"forgot.her.name",
  	"forgot.his.name",
  	"from-ak.com",
  	"from-al.com",
  	"from-ar.com",
  	"from-az.net",
  	"from-ca.com",
  	"from-co.net",
  	"from-ct.com",
  	"from-dc.com",
  	"from-de.com",
  	"from-fl.com",
  	"from-ga.com",
  	"from-hi.com",
  	"from-ia.com",
  	"from-id.com",
  	"from-il.com",
  	"from-in.com",
  	"from-ks.com",
  	"from-ky.com",
  	"from-la.net",
  	"from-ma.com",
  	"from-md.com",
  	"from-me.org",
  	"from-mi.com",
  	"from-mn.com",
  	"from-mo.com",
  	"from-ms.com",
  	"from-mt.com",
  	"from-nc.com",
  	"from-nd.com",
  	"from-ne.com",
  	"from-nh.com",
  	"from-nj.com",
  	"from-nm.com",
  	"from-nv.com",
  	"from-ny.net",
  	"from-oh.com",
  	"from-ok.com",
  	"from-or.com",
  	"from-pa.com",
  	"from-pr.com",
  	"from-ri.com",
  	"from-sc.com",
  	"from-sd.com",
  	"from-tn.com",
  	"from-tx.com",
  	"from-ut.com",
  	"from-va.com",
  	"from-vt.com",
  	"from-wa.com",
  	"from-wi.com",
  	"from-wv.com",
  	"from-wy.com",
  	"ftpaccess.cc",
  	"fuettertdasnetz.de",
  	"game-host.org",
  	"game-server.cc",
  	"getmyip.com",
  	"gets-it.net",
  	"go.dyndns.org",
  	"gotdns.com",
  	"gotdns.org",
  	"groks-the.info",
  	"groks-this.info",
  	"ham-radio-op.net",
  	"here-for-more.info",
  	"hobby-site.com",
  	"hobby-site.org",
  	"home.dyndns.org",
  	"homedns.org",
  	"homeftp.net",
  	"homeftp.org",
  	"homeip.net",
  	"homelinux.com",
  	"homelinux.net",
  	"homelinux.org",
  	"homeunix.com",
  	"homeunix.net",
  	"homeunix.org",
  	"iamallama.com",
  	"in-the-band.net",
  	"is-a-anarchist.com",
  	"is-a-blogger.com",
  	"is-a-bookkeeper.com",
  	"is-a-bruinsfan.org",
  	"is-a-bulls-fan.com",
  	"is-a-candidate.org",
  	"is-a-caterer.com",
  	"is-a-celticsfan.org",
  	"is-a-chef.com",
  	"is-a-chef.net",
  	"is-a-chef.org",
  	"is-a-conservative.com",
  	"is-a-cpa.com",
  	"is-a-cubicle-slave.com",
  	"is-a-democrat.com",
  	"is-a-designer.com",
  	"is-a-doctor.com",
  	"is-a-financialadvisor.com",
  	"is-a-geek.com",
  	"is-a-geek.net",
  	"is-a-geek.org",
  	"is-a-green.com",
  	"is-a-guru.com",
  	"is-a-hard-worker.com",
  	"is-a-hunter.com",
  	"is-a-knight.org",
  	"is-a-landscaper.com",
  	"is-a-lawyer.com",
  	"is-a-liberal.com",
  	"is-a-libertarian.com",
  	"is-a-linux-user.org",
  	"is-a-llama.com",
  	"is-a-musician.com",
  	"is-a-nascarfan.com",
  	"is-a-nurse.com",
  	"is-a-painter.com",
  	"is-a-patsfan.org",
  	"is-a-personaltrainer.com",
  	"is-a-photographer.com",
  	"is-a-player.com",
  	"is-a-republican.com",
  	"is-a-rockstar.com",
  	"is-a-socialist.com",
  	"is-a-soxfan.org",
  	"is-a-student.com",
  	"is-a-teacher.com",
  	"is-a-techie.com",
  	"is-a-therapist.com",
  	"is-an-accountant.com",
  	"is-an-actor.com",
  	"is-an-actress.com",
  	"is-an-anarchist.com",
  	"is-an-artist.com",
  	"is-an-engineer.com",
  	"is-an-entertainer.com",
  	"is-by.us",
  	"is-certified.com",
  	"is-found.org",
  	"is-gone.com",
  	"is-into-anime.com",
  	"is-into-cars.com",
  	"is-into-cartoons.com",
  	"is-into-games.com",
  	"is-leet.com",
  	"is-lost.org",
  	"is-not-certified.com",
  	"is-saved.org",
  	"is-slick.com",
  	"is-uberleet.com",
  	"is-very-bad.org",
  	"is-very-evil.org",
  	"is-very-good.org",
  	"is-very-nice.org",
  	"is-very-sweet.org",
  	"is-with-theband.com",
  	"isa-geek.com",
  	"isa-geek.net",
  	"isa-geek.org",
  	"isa-hockeynut.com",
  	"issmarterthanyou.com",
  	"isteingeek.de",
  	"istmein.de",
  	"kicks-ass.net",
  	"kicks-ass.org",
  	"knowsitall.info",
  	"land-4-sale.us",
  	"lebtimnetz.de",
  	"leitungsen.de",
  	"likes-pie.com",
  	"likescandy.com",
  	"merseine.nu",
  	"mine.nu",
  	"misconfused.org",
  	"mypets.ws",
  	"myphotos.cc",
  	"neat-url.com",
  	"office-on-the.net",
  	"on-the-web.tv",
  	"podzone.net",
  	"podzone.org",
  	"readmyblog.org",
  	"saves-the-whales.com",
  	"scrapper-site.net",
  	"scrapping.cc",
  	"selfip.biz",
  	"selfip.com",
  	"selfip.info",
  	"selfip.net",
  	"selfip.org",
  	"sells-for-less.com",
  	"sells-for-u.com",
  	"sells-it.net",
  	"sellsyourhome.org",
  	"servebbs.com",
  	"servebbs.net",
  	"servebbs.org",
  	"serveftp.net",
  	"serveftp.org",
  	"servegame.org",
  	"shacknet.nu",
  	"simple-url.com",
  	"space-to-rent.com",
  	"stuff-4-sale.org",
  	"stuff-4-sale.us",
  	"teaches-yoga.com",
  	"thruhere.net",
  	"traeumtgerade.de",
  	"webhop.biz",
  	"webhop.info",
  	"webhop.net",
  	"webhop.org",
  	"worse-than.tv",
  	"writesthisblog.com",
  	"ddnss.de",
  	"dyn.ddnss.de",
  	"dyndns.ddnss.de",
  	"dyndns1.de",
  	"dyn-ip24.de",
  	"home-webserver.de",
  	"dyn.home-webserver.de",
  	"myhome-server.de",
  	"ddnss.org",
  	"definima.net",
  	"definima.io",
  	"ondigitalocean.app",
  	"*.digitaloceanspaces.com",
  	"bci.dnstrace.pro",
  	"ddnsfree.com",
  	"ddnsgeek.com",
  	"giize.com",
  	"gleeze.com",
  	"kozow.com",
  	"loseyourip.com",
  	"ooguy.com",
  	"theworkpc.com",
  	"casacam.net",
  	"dynu.net",
  	"accesscam.org",
  	"camdvr.org",
  	"freeddns.org",
  	"mywire.org",
  	"webredirect.org",
  	"myddns.rocks",
  	"blogsite.xyz",
  	"dynv6.net",
  	"e4.cz",
  	"eero.online",
  	"eero-stage.online",
  	"elementor.cloud",
  	"elementor.cool",
  	"en-root.fr",
  	"mytuleap.com",
  	"tuleap-partners.com",
  	"encr.app",
  	"encoreapi.com",
  	"onred.one",
  	"staging.onred.one",
  	"eu.encoway.cloud",
  	"eu.org",
  	"al.eu.org",
  	"asso.eu.org",
  	"at.eu.org",
  	"au.eu.org",
  	"be.eu.org",
  	"bg.eu.org",
  	"ca.eu.org",
  	"cd.eu.org",
  	"ch.eu.org",
  	"cn.eu.org",
  	"cy.eu.org",
  	"cz.eu.org",
  	"de.eu.org",
  	"dk.eu.org",
  	"edu.eu.org",
  	"ee.eu.org",
  	"es.eu.org",
  	"fi.eu.org",
  	"fr.eu.org",
  	"gr.eu.org",
  	"hr.eu.org",
  	"hu.eu.org",
  	"ie.eu.org",
  	"il.eu.org",
  	"in.eu.org",
  	"int.eu.org",
  	"is.eu.org",
  	"it.eu.org",
  	"jp.eu.org",
  	"kr.eu.org",
  	"lt.eu.org",
  	"lu.eu.org",
  	"lv.eu.org",
  	"mc.eu.org",
  	"me.eu.org",
  	"mk.eu.org",
  	"mt.eu.org",
  	"my.eu.org",
  	"net.eu.org",
  	"ng.eu.org",
  	"nl.eu.org",
  	"no.eu.org",
  	"nz.eu.org",
  	"paris.eu.org",
  	"pl.eu.org",
  	"pt.eu.org",
  	"q-a.eu.org",
  	"ro.eu.org",
  	"ru.eu.org",
  	"se.eu.org",
  	"si.eu.org",
  	"sk.eu.org",
  	"tr.eu.org",
  	"uk.eu.org",
  	"us.eu.org",
  	"eurodir.ru",
  	"eu-1.evennode.com",
  	"eu-2.evennode.com",
  	"eu-3.evennode.com",
  	"eu-4.evennode.com",
  	"us-1.evennode.com",
  	"us-2.evennode.com",
  	"us-3.evennode.com",
  	"us-4.evennode.com",
  	"twmail.cc",
  	"twmail.net",
  	"twmail.org",
  	"mymailer.com.tw",
  	"url.tw",
  	"onfabrica.com",
  	"apps.fbsbx.com",
  	"ru.net",
  	"adygeya.ru",
  	"bashkiria.ru",
  	"bir.ru",
  	"cbg.ru",
  	"com.ru",
  	"dagestan.ru",
  	"grozny.ru",
  	"kalmykia.ru",
  	"kustanai.ru",
  	"marine.ru",
  	"mordovia.ru",
  	"msk.ru",
  	"mytis.ru",
  	"nalchik.ru",
  	"nov.ru",
  	"pyatigorsk.ru",
  	"spb.ru",
  	"vladikavkaz.ru",
  	"vladimir.ru",
  	"abkhazia.su",
  	"adygeya.su",
  	"aktyubinsk.su",
  	"arkhangelsk.su",
  	"armenia.su",
  	"ashgabad.su",
  	"azerbaijan.su",
  	"balashov.su",
  	"bashkiria.su",
  	"bryansk.su",
  	"bukhara.su",
  	"chimkent.su",
  	"dagestan.su",
  	"east-kazakhstan.su",
  	"exnet.su",
  	"georgia.su",
  	"grozny.su",
  	"ivanovo.su",
  	"jambyl.su",
  	"kalmykia.su",
  	"kaluga.su",
  	"karacol.su",
  	"karaganda.su",
  	"karelia.su",
  	"khakassia.su",
  	"krasnodar.su",
  	"kurgan.su",
  	"kustanai.su",
  	"lenug.su",
  	"mangyshlak.su",
  	"mordovia.su",
  	"msk.su",
  	"murmansk.su",
  	"nalchik.su",
  	"navoi.su",
  	"north-kazakhstan.su",
  	"nov.su",
  	"obninsk.su",
  	"penza.su",
  	"pokrovsk.su",
  	"sochi.su",
  	"spb.su",
  	"tashkent.su",
  	"termez.su",
  	"togliatti.su",
  	"troitsk.su",
  	"tselinograd.su",
  	"tula.su",
  	"tuva.su",
  	"vladikavkaz.su",
  	"vladimir.su",
  	"vologda.su",
  	"channelsdvr.net",
  	"u.channelsdvr.net",
  	"edgecompute.app",
  	"fastly-terrarium.com",
  	"fastlylb.net",
  	"map.fastlylb.net",
  	"freetls.fastly.net",
  	"map.fastly.net",
  	"a.prod.fastly.net",
  	"global.prod.fastly.net",
  	"a.ssl.fastly.net",
  	"b.ssl.fastly.net",
  	"global.ssl.fastly.net",
  	"fastvps-server.com",
  	"fastvps.host",
  	"myfast.host",
  	"fastvps.site",
  	"myfast.space",
  	"fedorainfracloud.org",
  	"fedorapeople.org",
  	"cloud.fedoraproject.org",
  	"app.os.fedoraproject.org",
  	"app.os.stg.fedoraproject.org",
  	"conn.uk",
  	"copro.uk",
  	"hosp.uk",
  	"mydobiss.com",
  	"fh-muenster.io",
  	"filegear.me",
  	"filegear-au.me",
  	"filegear-de.me",
  	"filegear-gb.me",
  	"filegear-ie.me",
  	"filegear-jp.me",
  	"filegear-sg.me",
  	"firebaseapp.com",
  	"fireweb.app",
  	"flap.id",
  	"onflashdrive.app",
  	"fldrv.com",
  	"fly.dev",
  	"edgeapp.net",
  	"shw.io",
  	"flynnhosting.net",
  	"forgeblocks.com",
  	"id.forgerock.io",
  	"framer.app",
  	"framercanvas.com",
  	"*.frusky.de",
  	"ravpage.co.il",
  	"0e.vc",
  	"freebox-os.com",
  	"freeboxos.com",
  	"fbx-os.fr",
  	"fbxos.fr",
  	"freebox-os.fr",
  	"freeboxos.fr",
  	"freedesktop.org",
  	"freemyip.com",
  	"wien.funkfeuer.at",
  	"*.futurecms.at",
  	"*.ex.futurecms.at",
  	"*.in.futurecms.at",
  	"futurehosting.at",
  	"futuremailing.at",
  	"*.ex.ortsinfo.at",
  	"*.kunden.ortsinfo.at",
  	"*.statics.cloud",
  	"independent-commission.uk",
  	"independent-inquest.uk",
  	"independent-inquiry.uk",
  	"independent-panel.uk",
  	"independent-review.uk",
  	"public-inquiry.uk",
  	"royal-commission.uk",
  	"campaign.gov.uk",
  	"service.gov.uk",
  	"api.gov.uk",
  	"gehirn.ne.jp",
  	"usercontent.jp",
  	"gentapps.com",
  	"gentlentapis.com",
  	"lab.ms",
  	"cdn-edges.net",
  	"ghost.io",
  	"gsj.bz",
  	"githubusercontent.com",
  	"githubpreview.dev",
  	"github.io",
  	"gitlab.io",
  	"gitapp.si",
  	"gitpage.si",
  	"glitch.me",
  	"nog.community",
  	"co.ro",
  	"shop.ro",
  	"lolipop.io",
  	"angry.jp",
  	"babyblue.jp",
  	"babymilk.jp",
  	"backdrop.jp",
  	"bambina.jp",
  	"bitter.jp",
  	"blush.jp",
  	"boo.jp",
  	"boy.jp",
  	"boyfriend.jp",
  	"but.jp",
  	"candypop.jp",
  	"capoo.jp",
  	"catfood.jp",
  	"cheap.jp",
  	"chicappa.jp",
  	"chillout.jp",
  	"chips.jp",
  	"chowder.jp",
  	"chu.jp",
  	"ciao.jp",
  	"cocotte.jp",
  	"coolblog.jp",
  	"cranky.jp",
  	"cutegirl.jp",
  	"daa.jp",
  	"deca.jp",
  	"deci.jp",
  	"digick.jp",
  	"egoism.jp",
  	"fakefur.jp",
  	"fem.jp",
  	"flier.jp",
  	"floppy.jp",
  	"fool.jp",
  	"frenchkiss.jp",
  	"girlfriend.jp",
  	"girly.jp",
  	"gloomy.jp",
  	"gonna.jp",
  	"greater.jp",
  	"hacca.jp",
  	"heavy.jp",
  	"her.jp",
  	"hiho.jp",
  	"hippy.jp",
  	"holy.jp",
  	"hungry.jp",
  	"icurus.jp",
  	"itigo.jp",
  	"jellybean.jp",
  	"kikirara.jp",
  	"kill.jp",
  	"kilo.jp",
  	"kuron.jp",
  	"littlestar.jp",
  	"lolipopmc.jp",
  	"lolitapunk.jp",
  	"lomo.jp",
  	"lovepop.jp",
  	"lovesick.jp",
  	"main.jp",
  	"mods.jp",
  	"mond.jp",
  	"mongolian.jp",
  	"moo.jp",
  	"namaste.jp",
  	"nikita.jp",
  	"nobushi.jp",
  	"noor.jp",
  	"oops.jp",
  	"parallel.jp",
  	"parasite.jp",
  	"pecori.jp",
  	"peewee.jp",
  	"penne.jp",
  	"pepper.jp",
  	"perma.jp",
  	"pigboat.jp",
  	"pinoko.jp",
  	"punyu.jp",
  	"pupu.jp",
  	"pussycat.jp",
  	"pya.jp",
  	"raindrop.jp",
  	"readymade.jp",
  	"sadist.jp",
  	"schoolbus.jp",
  	"secret.jp",
  	"staba.jp",
  	"stripper.jp",
  	"sub.jp",
  	"sunnyday.jp",
  	"thick.jp",
  	"tonkotsu.jp",
  	"under.jp",
  	"upper.jp",
  	"velvet.jp",
  	"verse.jp",
  	"versus.jp",
  	"vivian.jp",
  	"watson.jp",
  	"weblike.jp",
  	"whitesnow.jp",
  	"zombie.jp",
  	"heteml.net",
  	"cloudapps.digital",
  	"london.cloudapps.digital",
  	"pymnt.uk",
  	"homeoffice.gov.uk",
  	"ro.im",
  	"goip.de",
  	"run.app",
  	"a.run.app",
  	"web.app",
  	"*.0emm.com",
  	"appspot.com",
  	"*.r.appspot.com",
  	"codespot.com",
  	"googleapis.com",
  	"googlecode.com",
  	"pagespeedmobilizer.com",
  	"publishproxy.com",
  	"withgoogle.com",
  	"withyoutube.com",
  	"*.gateway.dev",
  	"cloud.goog",
  	"translate.goog",
  	"*.usercontent.goog",
  	"cloudfunctions.net",
  	"blogspot.ae",
  	"blogspot.al",
  	"blogspot.am",
  	"blogspot.ba",
  	"blogspot.be",
  	"blogspot.bg",
  	"blogspot.bj",
  	"blogspot.ca",
  	"blogspot.cf",
  	"blogspot.ch",
  	"blogspot.cl",
  	"blogspot.co.at",
  	"blogspot.co.id",
  	"blogspot.co.il",
  	"blogspot.co.ke",
  	"blogspot.co.nz",
  	"blogspot.co.uk",
  	"blogspot.co.za",
  	"blogspot.com",
  	"blogspot.com.ar",
  	"blogspot.com.au",
  	"blogspot.com.br",
  	"blogspot.com.by",
  	"blogspot.com.co",
  	"blogspot.com.cy",
  	"blogspot.com.ee",
  	"blogspot.com.eg",
  	"blogspot.com.es",
  	"blogspot.com.mt",
  	"blogspot.com.ng",
  	"blogspot.com.tr",
  	"blogspot.com.uy",
  	"blogspot.cv",
  	"blogspot.cz",
  	"blogspot.de",
  	"blogspot.dk",
  	"blogspot.fi",
  	"blogspot.fr",
  	"blogspot.gr",
  	"blogspot.hk",
  	"blogspot.hr",
  	"blogspot.hu",
  	"blogspot.ie",
  	"blogspot.in",
  	"blogspot.is",
  	"blogspot.it",
  	"blogspot.jp",
  	"blogspot.kr",
  	"blogspot.li",
  	"blogspot.lt",
  	"blogspot.lu",
  	"blogspot.md",
  	"blogspot.mk",
  	"blogspot.mr",
  	"blogspot.mx",
  	"blogspot.my",
  	"blogspot.nl",
  	"blogspot.no",
  	"blogspot.pe",
  	"blogspot.pt",
  	"blogspot.qa",
  	"blogspot.re",
  	"blogspot.ro",
  	"blogspot.rs",
  	"blogspot.ru",
  	"blogspot.se",
  	"blogspot.sg",
  	"blogspot.si",
  	"blogspot.sk",
  	"blogspot.sn",
  	"blogspot.td",
  	"blogspot.tw",
  	"blogspot.ug",
  	"blogspot.vn",
  	"goupile.fr",
  	"gov.nl",
  	"awsmppl.com",
  	"günstigbestellen.de",
  	"günstigliefern.de",
  	"fin.ci",
  	"free.hr",
  	"caa.li",
  	"ua.rs",
  	"conf.se",
  	"hs.zone",
  	"hs.run",
  	"hashbang.sh",
  	"hasura.app",
  	"hasura-app.io",
  	"pages.it.hs-heilbronn.de",
  	"hepforge.org",
  	"herokuapp.com",
  	"herokussl.com",
  	"ravendb.cloud",
  	"myravendb.com",
  	"ravendb.community",
  	"ravendb.me",
  	"development.run",
  	"ravendb.run",
  	"homesklep.pl",
  	"secaas.hk",
  	"hoplix.shop",
  	"orx.biz",
  	"biz.gl",
  	"col.ng",
  	"firm.ng",
  	"gen.ng",
  	"ltd.ng",
  	"ngo.ng",
  	"edu.scot",
  	"sch.so",
  	"hostyhosting.io",
  	"häkkinen.fi",
  	"*.moonscale.io",
  	"moonscale.net",
  	"iki.fi",
  	"ibxos.it",
  	"iliadboxos.it",
  	"impertrixcdn.com",
  	"impertrix.com",
  	"smushcdn.com",
  	"wphostedmail.com",
  	"wpmucdn.com",
  	"tempurl.host",
  	"wpmudev.host",
  	"dyn-berlin.de",
  	"in-berlin.de",
  	"in-brb.de",
  	"in-butter.de",
  	"in-dsl.de",
  	"in-dsl.net",
  	"in-dsl.org",
  	"in-vpn.de",
  	"in-vpn.net",
  	"in-vpn.org",
  	"biz.at",
  	"info.at",
  	"info.cx",
  	"ac.leg.br",
  	"al.leg.br",
  	"am.leg.br",
  	"ap.leg.br",
  	"ba.leg.br",
  	"ce.leg.br",
  	"df.leg.br",
  	"es.leg.br",
  	"go.leg.br",
  	"ma.leg.br",
  	"mg.leg.br",
  	"ms.leg.br",
  	"mt.leg.br",
  	"pa.leg.br",
  	"pb.leg.br",
  	"pe.leg.br",
  	"pi.leg.br",
  	"pr.leg.br",
  	"rj.leg.br",
  	"rn.leg.br",
  	"ro.leg.br",
  	"rr.leg.br",
  	"rs.leg.br",
  	"sc.leg.br",
  	"se.leg.br",
  	"sp.leg.br",
  	"to.leg.br",
  	"pixolino.com",
  	"na4u.ru",
  	"iopsys.se",
  	"ipifony.net",
  	"iservschule.de",
  	"mein-iserv.de",
  	"schulplattform.de",
  	"schulserver.de",
  	"test-iserv.de",
  	"iserv.dev",
  	"iobb.net",
  	"mel.cloudlets.com.au",
  	"cloud.interhostsolutions.be",
  	"users.scale.virtualcloud.com.br",
  	"mycloud.by",
  	"alp1.ae.flow.ch",
  	"appengine.flow.ch",
  	"es-1.axarnet.cloud",
  	"diadem.cloud",
  	"vip.jelastic.cloud",
  	"jele.cloud",
  	"it1.eur.aruba.jenv-aruba.cloud",
  	"it1.jenv-aruba.cloud",
  	"keliweb.cloud",
  	"cs.keliweb.cloud",
  	"oxa.cloud",
  	"tn.oxa.cloud",
  	"uk.oxa.cloud",
  	"primetel.cloud",
  	"uk.primetel.cloud",
  	"ca.reclaim.cloud",
  	"uk.reclaim.cloud",
  	"us.reclaim.cloud",
  	"ch.trendhosting.cloud",
  	"de.trendhosting.cloud",
  	"jele.club",
  	"amscompute.com",
  	"clicketcloud.com",
  	"dopaas.com",
  	"hidora.com",
  	"paas.hosted-by-previder.com",
  	"rag-cloud.hosteur.com",
  	"rag-cloud-ch.hosteur.com",
  	"jcloud.ik-server.com",
  	"jcloud-ver-jpc.ik-server.com",
  	"demo.jelastic.com",
  	"kilatiron.com",
  	"paas.massivegrid.com",
  	"jed.wafaicloud.com",
  	"lon.wafaicloud.com",
  	"ryd.wafaicloud.com",
  	"j.scaleforce.com.cy",
  	"jelastic.dogado.eu",
  	"fi.cloudplatform.fi",
  	"demo.datacenter.fi",
  	"paas.datacenter.fi",
  	"jele.host",
  	"mircloud.host",
  	"paas.beebyte.io",
  	"sekd1.beebyteapp.io",
  	"jele.io",
  	"cloud-fr1.unispace.io",
  	"jc.neen.it",
  	"cloud.jelastic.open.tim.it",
  	"jcloud.kz",
  	"upaas.kazteleport.kz",
  	"cloudjiffy.net",
  	"fra1-de.cloudjiffy.net",
  	"west1-us.cloudjiffy.net",
  	"jls-sto1.elastx.net",
  	"jls-sto2.elastx.net",
  	"jls-sto3.elastx.net",
  	"faststacks.net",
  	"fr-1.paas.massivegrid.net",
  	"lon-1.paas.massivegrid.net",
  	"lon-2.paas.massivegrid.net",
  	"ny-1.paas.massivegrid.net",
  	"ny-2.paas.massivegrid.net",
  	"sg-1.paas.massivegrid.net",
  	"jelastic.saveincloud.net",
  	"nordeste-idc.saveincloud.net",
  	"j.scaleforce.net",
  	"jelastic.tsukaeru.net",
  	"sdscloud.pl",
  	"unicloud.pl",
  	"mircloud.ru",
  	"jelastic.regruhosting.ru",
  	"enscaled.sg",
  	"jele.site",
  	"jelastic.team",
  	"orangecloud.tn",
  	"j.layershift.co.uk",
  	"phx.enscaled.us",
  	"mircloud.us",
  	"myjino.ru",
  	"*.hosting.myjino.ru",
  	"*.landing.myjino.ru",
  	"*.spectrum.myjino.ru",
  	"*.vps.myjino.ru",
  	"jotelulu.cloud",
  	"*.triton.zone",
  	"*.cns.joyent.com",
  	"js.org",
  	"kaas.gg",
  	"khplay.nl",
  	"ktistory.com",
  	"kapsi.fi",
  	"keymachine.de",
  	"kinghost.net",
  	"uni5.net",
  	"knightpoint.systems",
  	"koobin.events",
  	"oya.to",
  	"kuleuven.cloud",
  	"ezproxy.kuleuven.be",
  	"co.krd",
  	"edu.krd",
  	"krellian.net",
  	"webthings.io",
  	"git-repos.de",
  	"lcube-server.de",
  	"svn-repos.de",
  	"leadpages.co",
  	"lpages.co",
  	"lpusercontent.com",
  	"lelux.site",
  	"co.business",
  	"co.education",
  	"co.events",
  	"co.financial",
  	"co.network",
  	"co.place",
  	"co.technology",
  	"app.lmpm.com",
  	"linkyard.cloud",
  	"linkyard-cloud.ch",
  	"members.linode.com",
  	"*.nodebalancer.linode.com",
  	"*.linodeobjects.com",
  	"ip.linodeusercontent.com",
  	"we.bs",
  	"*.user.localcert.dev",
  	"localzone.xyz",
  	"loginline.app",
  	"loginline.dev",
  	"loginline.io",
  	"loginline.services",
  	"loginline.site",
  	"servers.run",
  	"lohmus.me",
  	"krasnik.pl",
  	"leczna.pl",
  	"lubartow.pl",
  	"lublin.pl",
  	"poniatowa.pl",
  	"swidnik.pl",
  	"glug.org.uk",
  	"lug.org.uk",
  	"lugs.org.uk",
  	"barsy.bg",
  	"barsy.co.uk",
  	"barsyonline.co.uk",
  	"barsycenter.com",
  	"barsyonline.com",
  	"barsy.club",
  	"barsy.de",
  	"barsy.eu",
  	"barsy.in",
  	"barsy.info",
  	"barsy.io",
  	"barsy.me",
  	"barsy.menu",
  	"barsy.mobi",
  	"barsy.net",
  	"barsy.online",
  	"barsy.org",
  	"barsy.pro",
  	"barsy.pub",
  	"barsy.ro",
  	"barsy.shop",
  	"barsy.site",
  	"barsy.support",
  	"barsy.uk",
  	"*.magentosite.cloud",
  	"mayfirst.info",
  	"mayfirst.org",
  	"hb.cldmail.ru",
  	"cn.vu",
  	"mazeplay.com",
  	"mcpe.me",
  	"mcdir.me",
  	"mcdir.ru",
  	"mcpre.ru",
  	"vps.mcdir.ru",
  	"mediatech.by",
  	"mediatech.dev",
  	"hra.health",
  	"miniserver.com",
  	"memset.net",
  	"messerli.app",
  	"*.cloud.metacentrum.cz",
  	"custom.metacentrum.cz",
  	"flt.cloud.muni.cz",
  	"usr.cloud.muni.cz",
  	"meteorapp.com",
  	"eu.meteorapp.com",
  	"co.pl",
  	"*.azurecontainer.io",
  	"azurewebsites.net",
  	"azure-mobile.net",
  	"cloudapp.net",
  	"azurestaticapps.net",
  	"1.azurestaticapps.net",
  	"centralus.azurestaticapps.net",
  	"eastasia.azurestaticapps.net",
  	"eastus2.azurestaticapps.net",
  	"westeurope.azurestaticapps.net",
  	"westus2.azurestaticapps.net",
  	"csx.cc",
  	"mintere.site",
  	"forte.id",
  	"mozilla-iot.org",
  	"bmoattachments.org",
  	"net.ru",
  	"org.ru",
  	"pp.ru",
  	"hostedpi.com",
  	"customer.mythic-beasts.com",
  	"caracal.mythic-beasts.com",
  	"fentiger.mythic-beasts.com",
  	"lynx.mythic-beasts.com",
  	"ocelot.mythic-beasts.com",
  	"oncilla.mythic-beasts.com",
  	"onza.mythic-beasts.com",
  	"sphinx.mythic-beasts.com",
  	"vs.mythic-beasts.com",
  	"x.mythic-beasts.com",
  	"yali.mythic-beasts.com",
  	"cust.retrosnub.co.uk",
  	"ui.nabu.casa",
  	"pony.club",
  	"of.fashion",
  	"in.london",
  	"of.london",
  	"from.marketing",
  	"with.marketing",
  	"for.men",
  	"repair.men",
  	"and.mom",
  	"for.mom",
  	"for.one",
  	"under.one",
  	"for.sale",
  	"that.win",
  	"from.work",
  	"to.work",
  	"cloud.nospamproxy.com",
  	"netlify.app",
  	"4u.com",
  	"ngrok.io",
  	"nh-serv.co.uk",
  	"nfshost.com",
  	"*.developer.app",
  	"noop.app",
  	"*.northflank.app",
  	"*.build.run",
  	"*.code.run",
  	"*.database.run",
  	"*.migration.run",
  	"noticeable.news",
  	"dnsking.ch",
  	"mypi.co",
  	"n4t.co",
  	"001www.com",
  	"ddnslive.com",
  	"myiphost.com",
  	"forumz.info",
  	"16-b.it",
  	"32-b.it",
  	"64-b.it",
  	"soundcast.me",
  	"tcp4.me",
  	"dnsup.net",
  	"hicam.net",
  	"now-dns.net",
  	"ownip.net",
  	"vpndns.net",
  	"dynserv.org",
  	"now-dns.org",
  	"x443.pw",
  	"now-dns.top",
  	"ntdll.top",
  	"freeddns.us",
  	"crafting.xyz",
  	"zapto.xyz",
  	"nsupdate.info",
  	"nerdpol.ovh",
  	"blogsyte.com",
  	"brasilia.me",
  	"cable-modem.org",
  	"ciscofreak.com",
  	"collegefan.org",
  	"couchpotatofries.org",
  	"damnserver.com",
  	"ddns.me",
  	"ditchyourip.com",
  	"dnsfor.me",
  	"dnsiskinky.com",
  	"dvrcam.info",
  	"dynns.com",
  	"eating-organic.net",
  	"fantasyleague.cc",
  	"geekgalaxy.com",
  	"golffan.us",
  	"health-carereform.com",
  	"homesecuritymac.com",
  	"homesecuritypc.com",
  	"hopto.me",
  	"ilovecollege.info",
  	"loginto.me",
  	"mlbfan.org",
  	"mmafan.biz",
  	"myactivedirectory.com",
  	"mydissent.net",
  	"myeffect.net",
  	"mymediapc.net",
  	"mypsx.net",
  	"mysecuritycamera.com",
  	"mysecuritycamera.net",
  	"mysecuritycamera.org",
  	"net-freaks.com",
  	"nflfan.org",
  	"nhlfan.net",
  	"no-ip.ca",
  	"no-ip.co.uk",
  	"no-ip.net",
  	"noip.us",
  	"onthewifi.com",
  	"pgafan.net",
  	"point2this.com",
  	"pointto.us",
  	"privatizehealthinsurance.net",
  	"quicksytes.com",
  	"read-books.org",
  	"securitytactics.com",
  	"serveexchange.com",
  	"servehumour.com",
  	"servep2p.com",
  	"servesarcasm.com",
  	"stufftoread.com",
  	"ufcfan.org",
  	"unusualperson.com",
  	"workisboring.com",
  	"3utilities.com",
  	"bounceme.net",
  	"ddns.net",
  	"ddnsking.com",
  	"gotdns.ch",
  	"hopto.org",
  	"myftp.biz",
  	"myftp.org",
  	"myvnc.com",
  	"no-ip.biz",
  	"no-ip.info",
  	"no-ip.org",
  	"noip.me",
  	"redirectme.net",
  	"servebeer.com",
  	"serveblog.net",
  	"servecounterstrike.com",
  	"serveftp.com",
  	"servegame.com",
  	"servehalflife.com",
  	"servehttp.com",
  	"serveirc.com",
  	"serveminecraft.net",
  	"servemp3.com",
  	"servepics.com",
  	"servequake.com",
  	"sytes.net",
  	"webhop.me",
  	"zapto.org",
  	"stage.nodeart.io",
  	"pcloud.host",
  	"nyc.mn",
  	"static.observableusercontent.com",
  	"cya.gg",
  	"omg.lol",
  	"cloudycluster.net",
  	"omniwe.site",
  	"service.one",
  	"nid.io",
  	"opensocial.site",
  	"opencraft.hosting",
  	"orsites.com",
  	"operaunite.com",
  	"tech.orange",
  	"authgear-staging.com",
  	"authgearapps.com",
  	"skygearapp.com",
  	"outsystemscloud.com",
  	"*.webpaas.ovh.net",
  	"*.hosting.ovh.net",
  	"ownprovider.com",
  	"own.pm",
  	"*.owo.codes",
  	"ox.rs",
  	"oy.lc",
  	"pgfog.com",
  	"pagefrontapp.com",
  	"pagexl.com",
  	"*.paywhirl.com",
  	"bar0.net",
  	"bar1.net",
  	"bar2.net",
  	"rdv.to",
  	"art.pl",
  	"gliwice.pl",
  	"krakow.pl",
  	"poznan.pl",
  	"wroc.pl",
  	"zakopane.pl",
  	"pantheonsite.io",
  	"gotpantheon.com",
  	"mypep.link",
  	"perspecta.cloud",
  	"lk3.ru",
  	"on-web.fr",
  	"bc.platform.sh",
  	"ent.platform.sh",
  	"eu.platform.sh",
  	"us.platform.sh",
  	"*.platformsh.site",
  	"*.tst.site",
  	"platter-app.com",
  	"platter-app.dev",
  	"platterp.us",
  	"pdns.page",
  	"plesk.page",
  	"pleskns.com",
  	"dyn53.io",
  	"onporter.run",
  	"co.bn",
  	"postman-echo.com",
  	"pstmn.io",
  	"mock.pstmn.io",
  	"httpbin.org",
  	"prequalifyme.today",
  	"xen.prgmr.com",
  	"priv.at",
  	"prvcy.page",
  	"*.dweb.link",
  	"protonet.io",
  	"chirurgiens-dentistes-en-france.fr",
  	"byen.site",
  	"pubtls.org",
  	"pythonanywhere.com",
  	"eu.pythonanywhere.com",
  	"qoto.io",
  	"qualifioapp.com",
  	"qbuser.com",
  	"cloudsite.builders",
  	"instances.spawn.cc",
  	"instantcloud.cn",
  	"ras.ru",
  	"qa2.com",
  	"qcx.io",
  	"*.sys.qcx.io",
  	"dev-myqnapcloud.com",
  	"alpha-myqnapcloud.com",
  	"myqnapcloud.com",
  	"*.quipelements.com",
  	"vapor.cloud",
  	"vaporcloud.io",
  	"rackmaze.com",
  	"rackmaze.net",
  	"g.vbrplsbx.io",
  	"*.on-k3s.io",
  	"*.on-rancher.cloud",
  	"*.on-rio.io",
  	"readthedocs.io",
  	"rhcloud.com",
  	"app.render.com",
  	"onrender.com",
  	"repl.co",
  	"id.repl.co",
  	"repl.run",
  	"resindevice.io",
  	"devices.resinstaging.io",
  	"hzc.io",
  	"wellbeingzone.eu",
  	"wellbeingzone.co.uk",
  	"adimo.co.uk",
  	"itcouldbewor.se",
  	"git-pages.rit.edu",
  	"rocky.page",
  	"биз.рус",
  	"ком.рус",
  	"крым.рус",
  	"мир.рус",
  	"мск.рус",
  	"орг.рус",
  	"самара.рус",
  	"сочи.рус",
  	"спб.рус",
  	"я.рус",
  	"*.builder.code.com",
  	"*.dev-builder.code.com",
  	"*.stg-builder.code.com",
  	"sandcats.io",
  	"logoip.de",
  	"logoip.com",
  	"fr-par-1.baremetal.scw.cloud",
  	"fr-par-2.baremetal.scw.cloud",
  	"nl-ams-1.baremetal.scw.cloud",
  	"fnc.fr-par.scw.cloud",
  	"functions.fnc.fr-par.scw.cloud",
  	"k8s.fr-par.scw.cloud",
  	"nodes.k8s.fr-par.scw.cloud",
  	"s3.fr-par.scw.cloud",
  	"s3-website.fr-par.scw.cloud",
  	"whm.fr-par.scw.cloud",
  	"priv.instances.scw.cloud",
  	"pub.instances.scw.cloud",
  	"k8s.scw.cloud",
  	"k8s.nl-ams.scw.cloud",
  	"nodes.k8s.nl-ams.scw.cloud",
  	"s3.nl-ams.scw.cloud",
  	"s3-website.nl-ams.scw.cloud",
  	"whm.nl-ams.scw.cloud",
  	"k8s.pl-waw.scw.cloud",
  	"nodes.k8s.pl-waw.scw.cloud",
  	"s3.pl-waw.scw.cloud",
  	"s3-website.pl-waw.scw.cloud",
  	"scalebook.scw.cloud",
  	"smartlabeling.scw.cloud",
  	"dedibox.fr",
  	"schokokeks.net",
  	"gov.scot",
  	"service.gov.scot",
  	"scrysec.com",
  	"firewall-gateway.com",
  	"firewall-gateway.de",
  	"my-gateway.de",
  	"my-router.de",
  	"spdns.de",
  	"spdns.eu",
  	"firewall-gateway.net",
  	"my-firewall.org",
  	"myfirewall.org",
  	"spdns.org",
  	"seidat.net",
  	"sellfy.store",
  	"senseering.net",
  	"minisite.ms",
  	"magnet.page",
  	"biz.ua",
  	"co.ua",
  	"pp.ua",
  	"shiftcrypto.dev",
  	"shiftcrypto.io",
  	"shiftedit.io",
  	"myshopblocks.com",
  	"myshopify.com",
  	"shopitsite.com",
  	"shopware.store",
  	"mo-siemens.io",
  	"1kapp.com",
  	"appchizi.com",
  	"applinzi.com",
  	"sinaapp.com",
  	"vipsinaapp.com",
  	"siteleaf.net",
  	"bounty-full.com",
  	"alpha.bounty-full.com",
  	"beta.bounty-full.com",
  	"small-web.org",
  	"vp4.me",
  	"try-snowplow.com",
  	"srht.site",
  	"stackhero-network.com",
  	"musician.io",
  	"novecore.site",
  	"static.land",
  	"dev.static.land",
  	"sites.static.land",
  	"storebase.store",
  	"vps-host.net",
  	"atl.jelastic.vps-host.net",
  	"njs.jelastic.vps-host.net",
  	"ric.jelastic.vps-host.net",
  	"playstation-cloud.com",
  	"apps.lair.io",
  	"*.stolos.io",
  	"spacekit.io",
  	"customer.speedpartner.de",
  	"myspreadshop.at",
  	"myspreadshop.com.au",
  	"myspreadshop.be",
  	"myspreadshop.ca",
  	"myspreadshop.ch",
  	"myspreadshop.com",
  	"myspreadshop.de",
  	"myspreadshop.dk",
  	"myspreadshop.es",
  	"myspreadshop.fi",
  	"myspreadshop.fr",
  	"myspreadshop.ie",
  	"myspreadshop.it",
  	"myspreadshop.net",
  	"myspreadshop.nl",
  	"myspreadshop.no",
  	"myspreadshop.pl",
  	"myspreadshop.se",
  	"myspreadshop.co.uk",
  	"api.stdlib.com",
  	"storj.farm",
  	"utwente.io",
  	"soc.srcf.net",
  	"user.srcf.net",
  	"temp-dns.com",
  	"supabase.co",
  	"supabase.in",
  	"supabase.net",
  	"su.paba.se",
  	"*.s5y.io",
  	"*.sensiosite.cloud",
  	"syncloud.it",
  	"dscloud.biz",
  	"direct.quickconnect.cn",
  	"dsmynas.com",
  	"familyds.com",
  	"diskstation.me",
  	"dscloud.me",
  	"i234.me",
  	"myds.me",
  	"synology.me",
  	"dscloud.mobi",
  	"dsmynas.net",
  	"familyds.net",
  	"dsmynas.org",
  	"familyds.org",
  	"vpnplus.to",
  	"direct.quickconnect.to",
  	"tabitorder.co.il",
  	"taifun-dns.de",
  	"beta.tailscale.net",
  	"ts.net",
  	"gda.pl",
  	"gdansk.pl",
  	"gdynia.pl",
  	"med.pl",
  	"sopot.pl",
  	"site.tb-hosting.com",
  	"edugit.io",
  	"s3.teckids.org",
  	"telebit.app",
  	"telebit.io",
  	"*.telebit.xyz",
  	"gwiddle.co.uk",
  	"*.firenet.ch",
  	"*.svc.firenet.ch",
  	"reservd.com",
  	"thingdustdata.com",
  	"cust.dev.thingdust.io",
  	"cust.disrec.thingdust.io",
  	"cust.prod.thingdust.io",
  	"cust.testing.thingdust.io",
  	"reservd.dev.thingdust.io",
  	"reservd.disrec.thingdust.io",
  	"reservd.testing.thingdust.io",
  	"tickets.io",
  	"arvo.network",
  	"azimuth.network",
  	"tlon.network",
  	"torproject.net",
  	"pages.torproject.net",
  	"bloxcms.com",
  	"townnews-staging.com",
  	"tbits.me",
  	"12hp.at",
  	"2ix.at",
  	"4lima.at",
  	"lima-city.at",
  	"12hp.ch",
  	"2ix.ch",
  	"4lima.ch",
  	"lima-city.ch",
  	"trafficplex.cloud",
  	"de.cool",
  	"12hp.de",
  	"2ix.de",
  	"4lima.de",
  	"lima-city.de",
  	"1337.pictures",
  	"clan.rip",
  	"lima-city.rocks",
  	"webspace.rocks",
  	"lima.zone",
  	"*.transurl.be",
  	"*.transurl.eu",
  	"*.transurl.nl",
  	"site.transip.me",
  	"tuxfamily.org",
  	"dd-dns.de",
  	"diskstation.eu",
  	"diskstation.org",
  	"dray-dns.de",
  	"draydns.de",
  	"dyn-vpn.de",
  	"dynvpn.de",
  	"mein-vigor.de",
  	"my-vigor.de",
  	"my-wan.de",
  	"syno-ds.de",
  	"synology-diskstation.de",
  	"synology-ds.de",
  	"typedream.app",
  	"pro.typeform.com",
  	"uber.space",
  	"*.uberspace.de",
  	"hk.com",
  	"hk.org",
  	"ltd.hk",
  	"inc.hk",
  	"name.pm",
  	"sch.tf",
  	"biz.wf",
  	"sch.wf",
  	"org.yt",
  	"virtualuser.de",
  	"virtual-user.de",
  	"upli.io",
  	"urown.cloud",
  	"dnsupdate.info",
  	"lib.de.us",
  	"2038.io",
  	"vercel.app",
  	"vercel.dev",
  	"now.sh",
  	"router.management",
  	"v-info.info",
  	"voorloper.cloud",
  	"neko.am",
  	"nyaa.am",
  	"be.ax",
  	"cat.ax",
  	"es.ax",
  	"eu.ax",
  	"gg.ax",
  	"mc.ax",
  	"us.ax",
  	"xy.ax",
  	"nl.ci",
  	"xx.gl",
  	"app.gp",
  	"blog.gt",
  	"de.gt",
  	"to.gt",
  	"be.gy",
  	"cc.hn",
  	"blog.kg",
  	"io.kg",
  	"jp.kg",
  	"tv.kg",
  	"uk.kg",
  	"us.kg",
  	"de.ls",
  	"at.md",
  	"de.md",
  	"jp.md",
  	"to.md",
  	"indie.porn",
  	"vxl.sh",
  	"ch.tc",
  	"me.tc",
  	"we.tc",
  	"nyan.to",
  	"at.vg",
  	"blog.vu",
  	"dev.vu",
  	"me.vu",
  	"v.ua",
  	"*.vultrobjects.com",
  	"wafflecell.com",
  	"*.webhare.dev",
  	"reserve-online.net",
  	"reserve-online.com",
  	"bookonline.app",
  	"hotelwithflight.com",
  	"wedeploy.io",
  	"wedeploy.me",
  	"wedeploy.sh",
  	"remotewd.com",
  	"pages.wiardweb.com",
  	"wmflabs.org",
  	"toolforge.org",
  	"wmcloud.org",
  	"panel.gg",
  	"daemon.panel.gg",
  	"messwithdns.com",
  	"woltlab-demo.com",
  	"myforum.community",
  	"community-pro.de",
  	"diskussionsbereich.de",
  	"community-pro.net",
  	"meinforum.net",
  	"affinitylottery.org.uk",
  	"raffleentry.org.uk",
  	"weeklylottery.org.uk",
  	"wpenginepowered.com",
  	"js.wpenginepowered.com",
  	"wixsite.com",
  	"editorx.io",
  	"half.host",
  	"xnbay.com",
  	"u2.xnbay.com",
  	"u2-local.xnbay.com",
  	"cistron.nl",
  	"demon.nl",
  	"xs4all.space",
  	"yandexcloud.net",
  	"storage.yandexcloud.net",
  	"website.yandexcloud.net",
  	"official.academy",
  	"yolasite.com",
  	"ybo.faith",
  	"yombo.me",
  	"homelink.one",
  	"ybo.party",
  	"ybo.review",
  	"ybo.science",
  	"ybo.trade",
  	"ynh.fr",
  	"nohost.me",
  	"noho.st",
  	"za.net",
  	"za.org",
  	"bss.design",
  	"basicserver.io",
  	"virtualserver.io",
  	"enterprisecloud.nu"
  ];

  var rules$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': rules
  });

  var require$$0 = getCjsExportFromNamespace(rules$1);

  var psl = createCommonjsModule(function (module, exports) {

    var internals = {}; //
    // Read rules from file.
    //

    internals.rules = require$$0.map(function (rule) {
      return {
        rule: rule,
        suffix: rule.replace(/^(\*\.|\!)/, ''),
        punySuffix: -1,
        wildcard: rule.charAt(0) === '*',
        exception: rule.charAt(0) === '!'
      };
    }); //
    // Check is given string ends with `suffix`.
    //

    internals.endsWith = function (str, suffix) {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }; //
    // Find rule for a given domain.
    //


    internals.findRule = function (domain) {
      var punyDomain = punycode.toASCII(domain);
      return internals.rules.reduce(function (memo, rule) {
        if (rule.punySuffix === -1) {
          rule.punySuffix = punycode.toASCII(rule.suffix);
        }

        if (!internals.endsWith(punyDomain, '.' + rule.punySuffix) && punyDomain !== rule.punySuffix) {
          return memo;
        } // This has been commented out as it never seems to run. This is because
        // sub tlds always appear after their parents and we never find a shorter
        // match.
        //if (memo) {
        //  var memoSuffix = Punycode.toASCII(memo.suffix);
        //  if (memoSuffix.length >= punySuffix.length) {
        //    return memo;
        //  }
        //}


        return rule;
      }, null);
    }; //
    // Error codes and messages.
    //


    exports.errorCodes = {
      DOMAIN_TOO_SHORT: 'Domain name too short.',
      DOMAIN_TOO_LONG: 'Domain name too long. It should be no more than 255 chars.',
      LABEL_STARTS_WITH_DASH: 'Domain name label can not start with a dash.',
      LABEL_ENDS_WITH_DASH: 'Domain name label can not end with a dash.',
      LABEL_TOO_LONG: 'Domain name label should be at most 63 chars long.',
      LABEL_TOO_SHORT: 'Domain name label should be at least 1 character long.',
      LABEL_INVALID_CHARS: 'Domain name label can only contain alphanumeric characters or dashes.'
    }; //
    // Validate domain name and throw if not valid.
    //
    // From wikipedia:
    //
    // Hostnames are composed of series of labels concatenated with dots, as are all
    // domain names. Each label must be between 1 and 63 characters long, and the
    // entire hostname (including the delimiting dots) has a maximum of 255 chars.
    //
    // Allowed chars:
    //
    // * `a-z`
    // * `0-9`
    // * `-` but not as a starting or ending character
    // * `.` as a separator for the textual portions of a domain name
    //
    // * http://en.wikipedia.org/wiki/Domain_name
    // * http://en.wikipedia.org/wiki/Hostname
    //

    internals.validate = function (input) {
      // Before we can validate we need to take care of IDNs with unicode chars.
      var ascii = punycode.toASCII(input);

      if (ascii.length < 1) {
        return 'DOMAIN_TOO_SHORT';
      }

      if (ascii.length > 255) {
        return 'DOMAIN_TOO_LONG';
      } // Check each part's length and allowed chars.


      var labels = ascii.split('.');
      var label;

      for (var i = 0; i < labels.length; ++i) {
        label = labels[i];

        if (!label.length) {
          return 'LABEL_TOO_SHORT';
        }

        if (label.length > 63) {
          return 'LABEL_TOO_LONG';
        }

        if (label.charAt(0) === '-') {
          return 'LABEL_STARTS_WITH_DASH';
        }

        if (label.charAt(label.length - 1) === '-') {
          return 'LABEL_ENDS_WITH_DASH';
        }

        if (!/^[a-z0-9\-]+$/.test(label)) {
          return 'LABEL_INVALID_CHARS';
        }
      }
    }; //
    // Public API
    //
    //
    // Parse domain.
    //


    exports.parse = function (input) {
      if (typeof input !== 'string') {
        throw new TypeError('Domain name must be a string.');
      } // Force domain to lowercase.


      var domain = input.slice(0).toLowerCase(); // Handle FQDN.
      // TODO: Simply remove trailing dot?

      if (domain.charAt(domain.length - 1) === '.') {
        domain = domain.slice(0, domain.length - 1);
      } // Validate and sanitise input.


      var error = internals.validate(domain);

      if (error) {
        return {
          input: input,
          error: {
            message: exports.errorCodes[error],
            code: error
          }
        };
      }

      var parsed = {
        input: input,
        tld: null,
        sld: null,
        domain: null,
        subdomain: null,
        listed: false
      };
      var domainParts = domain.split('.'); // Non-Internet TLD

      if (domainParts[domainParts.length - 1] === 'local') {
        return parsed;
      }

      var handlePunycode = function () {
        if (!/xn--/.test(domain)) {
          return parsed;
        }

        if (parsed.domain) {
          parsed.domain = punycode.toASCII(parsed.domain);
        }

        if (parsed.subdomain) {
          parsed.subdomain = punycode.toASCII(parsed.subdomain);
        }

        return parsed;
      };

      var rule = internals.findRule(domain); // Unlisted tld.

      if (!rule) {
        if (domainParts.length < 2) {
          return parsed;
        }

        parsed.tld = domainParts.pop();
        parsed.sld = domainParts.pop();
        parsed.domain = [parsed.sld, parsed.tld].join('.');

        if (domainParts.length) {
          parsed.subdomain = domainParts.pop();
        }

        return handlePunycode();
      } // At this point we know the public suffix is listed.


      parsed.listed = true;
      var tldParts = rule.suffix.split('.');
      var privateParts = domainParts.slice(0, domainParts.length - tldParts.length);

      if (rule.exception) {
        privateParts.push(tldParts.shift());
      }

      parsed.tld = tldParts.join('.');

      if (!privateParts.length) {
        return handlePunycode();
      }

      if (rule.wildcard) {
        tldParts.unshift(privateParts.pop());
        parsed.tld = tldParts.join('.');
      }

      if (!privateParts.length) {
        return handlePunycode();
      }

      parsed.sld = privateParts.pop();
      parsed.domain = [parsed.sld, parsed.tld].join('.');

      if (privateParts.length) {
        parsed.subdomain = privateParts.join('.');
      }

      return handlePunycode();
    }; //
    // Get domain.
    //


    exports.get = function (domain) {
      if (!domain) {
        return null;
      }

      return exports.parse(domain).domain || null;
    }; //
    // Check whether domain belongs to a known public suffix.
    //


    exports.isValid = function (domain) {
      var parsed = exports.parse(domain);
      return Boolean(parsed.domain && parsed.listed);
    };
  });
  var psl_1 = psl.errorCodes;
  var psl_2 = psl.parse;
  var psl_3 = psl.get;
  var psl_4 = psl.isValid;

  /* eslint-disable import/prefer-default-export */

  /**
   * @param {string} host
   * @returns {import("../../target-decisioning-engine/types/DecisioningContext").DomainContext}
   */

  function parseDomainPsl(host) {
    const result = {};

    if (!psl.isValid(host)) {
      result.subdomain = "";
      result.domain = host;
      result.topLevelDomain = "";
      return result;
    }

    const parseResult = psl.parse(host);

    if (parseResult.subdomain) {
      result.subdomain = parseResult.subdomain.startsWith("www") ? parseResult.subdomain.substring(4) : parseResult.subdomain;
    } else {
      result.subdomain = "";
    }

    result.domain = parseResult.domain;
    result.topLevelDomain = parseResult.tld;
    return result;
  }

  const BUFFER = new Uint8Array(256);
  let BUFFER_PTR = BUFFER.length;
  function rng() {
    if (BUFFER_PTR > BUFFER.length - 16) {
      crypto.randomFillSync(BUFFER);
      BUFFER_PTR = 0;
    }
    /* eslint-disable no-return-assign */


    return BUFFER.slice(BUFFER_PTR, BUFFER_PTR += 16);
  }

  function createByteToHex() {
    const result = [];

    for (let i = 0; i < 256; i += 1) {
      result.push((i + 0x100).toString(16).substr(1));
    }

    return result;
  }

  const BYTE_TO_HEX = createByteToHex();
  function stringify(arr) {
    const result = [];

    for (let i = 0; i < 16; i += 1) {
      result.push(BYTE_TO_HEX[arr[i]]);
    }

    return join("", result).toLowerCase();
  }

  /* eslint-disable no-bitwise */

  function v4(rng) {
    const buffer = rng();
    buffer[6] = buffer[6] & 0x0f | 0x40;
    buffer[8] = buffer[8] & 0x3f | 0x80;
    return stringify(buffer);
  }
  /* eslint-enable no-bitwise */

  function uuid() {
    return v4(rng);
  }

  /* eslint no-param-reassign: ['error', { 'props': false }] */
  const PROTOCOL_MAP = {
    "http:": http.request,
    "https:": https.request
  };
  const HTTPS_AGENT = new https.Agent({
    keepAlive: true
  });
  const HTTP_AGENT = new http.Agent({
    keepAlive: true
  });

  var generateRandomID=function(b){var f,g,c="0123456789",d="",e="",h=8,i=10,j=10,k=""+Date.now(),l=k.substr(-6).split("").reverse("").join("");/* The first nibble can't have the left-most bit set because we are deailing with signed 64bit numbers. *//* introducing timestamp for more randomization */// TODO Extract this portion into a separate function.
  if(1==b){for(c+="ABCDEF",f=0;16>f;f++)g=Math.floor(Math.random()*h),4>f&&l[f]<h&&(g=+l[f]),d+=c.substring(g,g+1),g=Math.floor(Math.random()*h),e+=c.substring(g,g+1),h=16;return d+"-"+e}/*
       * We're dealing with 2 signed, but positive, 64bit numbers so the max for high and low is:
       * 9222372036854775807
       *    ^---------------- The 4th digit could actually be a 3 if we wanted to add more max checks
       *                      but we set the max to 2 to avoid them
       */for(f=0;19>f;f++)g=Math.floor(Math.random()*i),6>f&&l[f]<i?(d+=l[f],g=l[f]):d+=c.substring(g,g+1),0===f&&9==g?i=3:(1==f||2==f)&&10!=i&&2>g?i=10:2<f&&(i=10),g=Math.floor(Math.random()*j),e+=c.substring(g,g+1),0===f&&9==g?j=3:(1==f||2==f)&&10!=j&&2>g?j=10:2<f&&(j=10);// console.log("abc", high + low, `${high}-${low}`);
  return d+e};

  var AuthState={UNKNOWN:0,AUTHENTICATED:1,LOGGED_OUT:2};

  /*************************************************************************
  * ADOBE CONFIDENTIAL
  * ___________________
  *
  *  Copyright 2016 Adobe Systems Incorporated
  *  All Rights Reserved.
  *
  * NOTICE:  All information contained herein is, and remains
  * the property of Adobe Systems Incorporated and its suppliers,
  * if any.  The intellectual and technical concepts contained
  * herein are proprietary to Adobe Systems Incorporated and its
  * suppliers and are protected by all applicable intellectual property 
  * laws, including trade secret and copyright laws.
  * Dissemination of this information or reproduction of this material
  * is strictly forbidden unless prior written permission is obtained
  * from Adobe Systems Incorporated.
  **************************************************************************/function generateSDID(){return generateRandomID(1)}// This factory will generate a SupplementalDataID object that exposes 2 methods:
  // - getID: Main method that generates/retrieves a supplemental data ID.
  // - getState: Returns the internal state of the object.
  var supplementalDataIDFactory=function(b){b=b||{};var c=b.supplementalDataIDCurrent,d=b.supplementalDataIDCurrentConsumed||{},e=b.supplementalDataIDLast,f=b.supplementalDataIDLastConsumed||{};return {getID:function(h,i){c||i||(c=generateSDID());// Default to using the current supplemental-data ID
  var j=c;// If we have the last supplemental-data ID that has not been consumed by this consumer...
  return e&&!f[h]?(j=e,f[h]=!0):j&&(d[h]&&(e=c,f=d,c=j=i?"":generateSDID(),d={}),j&&(d[h]=!0)),j},getState:function(){return {supplementalDataIDCurrent:c,supplementalDataIDCurrentConsumed:d,supplementalDataIDLast:e,supplementalDataIDLastConsumed:f}}}};

  /*************************************************************************
  * ADOBE CONFIDENTIAL
  * ___________________
  *
  *  Copyright 2016 Adobe Systems Incorporated
  *  All Rights Reserved.
  *
  * NOTICE:  All information contained herein is, and remains
  * the property of Adobe Systems Incorporated and its suppliers,
  * if any.  The intellectual and technical concepts contained
  * herein are proprietary to Adobe Systems Incorporated and its
  * suppliers and are protected by all applicable intellectual property 
  * laws, including trade secret and copyright laws.
  * Dissemination of this information or reproduction of this material
  * is strictly forbidden unless prior written permission is obtained
  * from Adobe Systems Incorporated.
  **************************************************************************/var lib={generateMCID:generateRandomID,generateSupplementalID:function(){return generateRandomID(1)},AuthState:AuthState,supplementalDataIDFactory:supplementalDataIDFactory};

  var amcvCookie_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports,"__esModule",{value:!0});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[],_n=!0,_d=!1,_e=void 0;try{for(var _s,_i=arr[Symbol.iterator]();!(_n=(_s=_i.next()).done)&&(_arr.push(_s.value),!(i&&_arr.length===i));_n=!0);}catch(err){_d=!0,_e=err;}finally{try{!_n&&_i["return"]&&_i["return"]();}finally{if(_d)throw _e}}return _arr}return function(arr,i){if(Array.isArray(arr))return arr;if(Symbol.iterator in Object(arr))return sliceIterator(arr,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target};/*************************************************************************
  * ADOBE CONFIDENTIAL
  * ___________________
  *
  *  Copyright 2016 Adobe Systems Incorporated
  *  All Rights Reserved.
  *
  * NOTICE:  All information contained herein is, and remains
  * the property of Adobe Systems Incorporated and its suppliers,
  * if any.  The intellectual and technical concepts contained
  * herein are proprietary to Adobe Systems Incorporated and its
  * suppliers and are protected by all applicable intellectual property 
  * laws, including trade secret and copyright laws.
  * Dissemination of this information or reproduction of this material
  * is strictly forbidden unless prior written permission is obtained
  * from Adobe Systems Incorporated.
  **************************************************************************//*

  AMCV Cookie Format:

  - The cookie starts with a settings digest followed by a | that is a hash of key settings.
      If the settings of the Visitor instance do not match the hash all fields that can expire are force expired
      so they will be resynced.

  - The rest of the cookie is made up of KEY[-EXPIRATION]|VALUE pairs
    . The KEY will be one of the following fields: MCMID, MCCIDH, MCSYNCS, MCIDTS, MCOPTOUT, MCAID, MCAAMLH and MCAAMB.
    . The -EXPIRATION is optional for each field and if present after the - will be the timestamp for when that field expires.
      The expiration timestamp can also be followed by a "S" flagging that field to also expire 
      on a new browser session detected by the presence of the AMCVS_ session cookie.

  */// Parse into: { settingsDigest: { value: 3213, expire: 0, shouldExpireOnSession: false, hasExpired: false... }}
  function isSettingsDigest(a){return a.match(/^[\-0-9]+$/)}function parseSettingsDigest(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(isSettingsDigest(a[0])){var c={value:a[0],hasExpired:!1,shouldExpireOnSession:!1,expire:0};b.settingsDigest=c,a.shift(),1==a.length%2&&a.pop();}return b}function makeAmcvEntry(a){var b=new Date;return _extends({},a,{hasExpired:!!(0<a.expire&&b.getTime()>=1000*a.expire)})}var amcvCookie={pickValues:function pickValues(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"",b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:[],c=amcvCookie.parse(a);return b.reduce(function(d,e){var f=c[e];return f&&(d[e]=f.value),d},{})},parse:function parse(a){if(!a||"T"===a)return {};for(var b=decodeURIComponent(a).split("|"),c=parseSettingsDigest(b),d=0,e=b.length;d<e;d+=2){var _b$d$split=b[d].split("-"),_b$d$split2=_slicedToArray(_b$d$split,2),f=_b$d$split2[0],_b$d$split2$=_b$d$split2[1],g=_b$d$split2$===void 0?0:_b$d$split2$,h=b[d+1],j=!!(g&&g.includes("s")),k=g?parseInt(g,10):g;c[f]=makeAmcvEntry({value:h,expire:k,shouldExpireOnSession:j});}return c}};exports.default=amcvCookie;module.exports=exports["default"];
  });

  unwrapExports(amcvCookie_1);

  var Visitor_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports,"__esModule",{value:!0});function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}/*************************************************************************
  * ADOBE CONFIDENTIAL
  * ___________________
  *
  *  Copyright 2016 Adobe Systems Incorporated
  *  All Rights Reserved.
  *
  * NOTICE:  All information contained herein is, and remains
  * the property of Adobe Systems Incorporated and its suppliers,
  * if any.  The intellectual and technical concepts contained
  * herein are proprietary to Adobe Systems Incorporated and its
  * suppliers and are protected by all applicable intellectual property 
  * laws, including trade secret and copyright laws.
  * Dissemination of this information or reproduction of this material
  * is strictly forbidden unless prior written permission is obtained
  * from Adobe Systems Incorporated.
  **************************************************************************/var CONSUMER_ID_BASE="payload:",AMCV_PREFIX="AMCV_",ORG_ID_REQUIRED="Org ID is required",CONSUMER_ID_REQUIRED="Consumer ID is required",ADOBE_MC_SDID="adobe_mc_sdid",SDID_PARAM_EXPIRY=30,throwError=function throwError(a){throw new Error(a)},normalizeOrgId=function normalizeOrgId(a){return 0>a.indexOf("@")?a+"@AdobeOrg":a};function Visitor(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:throwError(ORG_ID_REQUIRED),b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null,c={},d=normalizeOrgId(a),e=function e(l){return c=Object.assign({},c,l)},f=(0, lib.supplementalDataIDFactory)(),g=function g(l,m){var n=new RegExp("[\\?&#]"+m+"=([^&#]*)"),o=n.exec(l);if(o&&o.length)return decodeURIComponent(o[1])},h=function h(l){// Parse '|' delimited k=v pairs into an object.
  var m=l.split("|");return m.reduce(function(n,o){var p=o.split("=");return n[p[0]]=decodeURIComponent(p[1]),n},{})},i=function i(){return Math.round(new Date().getTime()/1000)},k=function(j){return function(r){var s=r||commonjsGlobal.location.href;try{var t=g(s,j);if(t)return h(t)}catch(u){// Fail silently.
  }}}(ADOBE_MC_SDID);this.getVisitorValues=function(){return b?(0, amcvCookie_1.pickValues)(b,["MCMID","MCAAMB","MCAAMLH"]):{}},this.getSupplementalDataID=function(){var l=0<arguments.length&&void 0!==arguments[0]?arguments[0]:throwError(CONSUMER_ID_REQUIRED),m=f.getID(""+CONSUMER_ID_BASE+l),n=f.getState();return e({sdid:n}),m},this.attemptToPopulateSdidFromUrl=function(l){var m=k(l),n=1000000000,o=f.getState();// expired
  m&&m.TS&&(n=i()-m.TS),m&&m.SDID&&m.MCORGID===d&&n<SDID_PARAM_EXPIRY&&(o.supplementalDataIDCurrent=m.SDID,o.supplementalDataIDCurrentConsumed.SDID_URL_PARAM=!0,e({sdid:o}));},this.setCustomerIDs=function(){var l=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};e({customerIDs:l});},this.getState=function(){return _defineProperty({},d,c)},this.getCookieName=function(){return AMCV_PREFIX+d};}Visitor.AuthState=lib.AuthState;exports.default=Visitor;module.exports=exports["default"];
  });

  var Visitor = unwrapExports(Visitor_1);

  const Messages = {
    ERROR_MAX_RETRY: (numRetries, errString) => `Unable to retrieve artifact after ${numRetries} retries: ${errString}`,
    ARTIFACT_NOT_AVAILABLE: "The decisioning artifact is not available",
    ARTIFACT_VERSION_UNSUPPORTED: (artifactVersion, supportedMajorVersion) => `The decisioning artifact version (${artifactVersion}) is not supported. This library is compatible with this major version: ${supportedMajorVersion}`,
    ARTIFACT_FETCH_ERROR: reason => `Failed to retrieve artifact: ${reason}`,
    ARTIFACT_INVALID: "Invalid Artifact",
    INVALID_ENVIRONMENT: (expectedEnvironment, defaultEnvironment) => `'${expectedEnvironment}' is not a valid target environment, defaulting to '${defaultEnvironment}'.`,
    NOT_APPLICABLE: "Not Applicable",
    ARTIFACT_OBFUSCATION_ERROR: "Unable to read artifact JSON",
    UNKNOWN: "unknown"
  };

  const DEFAULT_POLLING_INTERVAL = 300000; // five minutes (in milliseconds)

  const MINIMUM_POLLING_INTERVAL = 300000; // five minutes (in milliseconds)

  const NUM_FETCH_RETRIES = 10;
  const SUPPORTED_ARTIFACT_MAJOR_VERSION = 1;
  const SUPPORTED_ARTIFACT_OBFUSCATION_VERSION = 1;
  const REGEX_ARTIFACT_FILENAME_BINARY = /.+\.bin$/i;
  const ARTIFACT_FORMAT_BINARY = "bin";
  const ARTIFACT_FORMAT_JSON = "json";
  const ARTIFACT_FORMAT_DEFAULT = ARTIFACT_FORMAT_JSON;
  const ARTIFACT_FORMATS = [ARTIFACT_FORMAT_BINARY, ARTIFACT_FORMAT_JSON];
  const ARTIFACT_FILENAME = {};
  ARTIFACT_FILENAME[ARTIFACT_FORMAT_BINARY] = "rules.bin";
  ARTIFACT_FILENAME[ARTIFACT_FORMAT_JSON] = "rules.json";
  const LOG_PREFIX = "LD";
  const CDN_BASE_PATH = "assets.adobetarget.com";
  const HTTP_HEADER_FORWARDED_FOR = "x-forwarded-for";
  const HTTP_HEADER_GEO_LATITUDE = "x-geo-latitude";
  const HTTP_HEADER_GEO_LONGITUDE = "x-geo-longitude";
  const HTTP_HEADER_GEO_COUNTRY = "x-geo-country-code";
  const HTTP_HEADER_GEO_REGION = "x-geo-region-code";
  const HTTP_HEADER_GEO_CITY = "x-geo-city";
  const CAMPAIGN_BUCKET_SALT = "0"; // Response token keys

  const AUDIENCE_IDS = "audience.ids";
  const ACTIVITY_DECISIONING_METHOD = "activity.decisioningMethod";
  const ACTIVITY_ID = "activity.id";
  const ACTIVITY_NAME = "activity.name";
  const ACTIVITY_TYPE = "activity.type";
  const EXPERIENCE_ID = "experience.id";
  const EXPERIENCE_NAME = "experience.name";
  const LOCATION_ID = "location.id";
  const LOCATION_NAME = "location.name";
  const LOCATION_TYPE = "location.type";
  const OFFER_ID = "offer.id";
  const OFFER_NAME = "offer.name";
  const OPTION_ID = "option.id";
  const OPTION_NAME = "option.name";
  const GEO_CITY = "geo.city";
  const GEO_COUNTRY = "geo.country";
  const GEO_STATE = "geo.state";
  const GEO_LATITUDE = "geo.latitude";
  const GEO_LONGITUDE = "geo.longitude";

  /**
   *
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @return {string}
   */

  function getRuleKey(rule) {
    return rule.ruleKey;
  }
  /**
   * @param {string} host
   * @returns {import("../types/DecisioningContext").DomainContext}
   */

  function parseDomainBasic(host) {
    const result = {};
    const domainParts = host.split(".");

    switch (domainParts.length) {
      case 1:
        result.subdomain = "";
        result.domain = host;
        result.topLevelDomain = "";
        break;

      case 2:
        result.subdomain = "";
        result.domain = host;
        result.topLevelDomain = domainParts[1];
        break;

      case 3:
        result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
        result.domain = host;
        result.topLevelDomain = domainParts[2];
        break;

      case 4:
        result.subdomain = domainParts[0] === "www" ? "" : domainParts[0];
        result.domain = host;
        result.topLevelDomain = `${domainParts[2]}.${domainParts[3]}`;
        break;
    }

    return result;
  }
  /**
   *
   * @param {string} url
   * @param { import("../types/DecisioningContext").ParseDomainFunc } parseDomain
   * @returns {{path: string, fragment: string, topLevelDomain?: string, query: string, domain?: string, subdomain?: string, url: string}}
   */

  function parseURL(url) {
    let parseDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : parseDomainBasic;

    if (!isString(url)) {
      // eslint-disable-next-line no-param-reassign
      url = "";
    }

    const parsed = src(url) || {};
    const {
      host = "",
      path = "",
      query = "",
      anchor = ""
    } = parsed;
    return _objectSpread2({
      url,
      path,
      query,
      fragment: anchor
    }, parseDomain(host));
  }
  /**
   *
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config
   * @returns {import("../types/DecisioningContext").ParseDomainFunc}
   */

  function getParseDomainImpl(config) {
    return isFunction(config.parseDomainImpl) ? config.parseDomainImpl : parseDomainBasic;
  }
  /**
   * @param { import("../types/DecisioningArtifact").DecisioningArtifact } artifact
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} request
   */

  function hasRemoteDependency(artifact, request) {
    // TODO: memoize this
    if (isUndefined(artifact)) {
      throw new Error(Messages.ARTIFACT_NOT_AVAILABLE);
    }

    const requestedMboxes = Array.from(getMboxNames(request));

    if (request.execute && isPojo(request.execute.pageLoad) || request.prefetch && isPojo(request.prefetch.pageLoad)) {
      requestedMboxes.push(DEFAULT_GLOBAL_MBOX);
    }

    const requestedViews = Array.from(getViewNames(request));
    const {
      remoteMboxes = [],
      localMboxes = [],
      remoteViews = [],
      localViews = []
    } = artifact;
    const mboxesThatRequireRemote = new Set([...remoteMboxes.filter(mboxName => includes(mboxName, requestedMboxes)), ...requestedMboxes.filter(mboxName => !includes(mboxName, localMboxes))]);
    const viewsThatRequireRemote = hasRequestedViews(request) && requestedViews.length === 0 ? new Set(remoteViews) : new Set([...remoteViews.filter(viewName => includes(viewName, requestedViews)), ...requestedViews.filter(viewName => !includes(viewName, localViews))]);
    return {
      remoteNeeded: mboxesThatRequireRemote.size > 0 || viewsThatRequireRemote.size > 0,
      remoteMboxes: Array.from(mboxesThatRequireRemote),
      remoteViews: Array.from(viewsThatRequireRemote)
    };
  }
  /**
   * @param { string } semanticVersion
   * @param { number } majorVersion
   */

  function matchMajorVersion(semanticVersion, majorVersion) {
    // eslint-disable-next-line no-unused-vars
    const [major, minor, patch] = semanticVersion.split(".").map(value => parseInt(value, 10));
    return majorVersion === major;
  }
  function cloneDeep(obj) {
    if (isDefined(obj)) {
      return JSON.parse(JSON.stringify(obj));
    }

    return undefined;
  }
  function getArtifactFileName() {
    let artifactFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ARTIFACT_FORMAT_DEFAULT;
    // eslint-disable-next-line no-param-reassign
    artifactFormat = includes(artifactFormat, ARTIFACT_FORMATS) ? artifactFormat : ARTIFACT_FORMAT_DEFAULT;
    return ARTIFACT_FILENAME[artifactFormat];
  }
  /**
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config Options map, required
   * @param {Boolean} addPropertyToken
   */

  function determineArtifactLocation(config) {
    const {
      client,
      propertyToken,
      artifactFormat,
      artifactLocation
    } = config;

    if (isString(artifactLocation)) {
      return artifactLocation;
    }

    const cdnBaseUrl = `https://${CDN_BASE_PATH}`;
    const targetEnvironment = config.environment ? config.environment.toLowerCase() : ENVIRONMENT_PROD;
    return [cdnBaseUrl, client, targetEnvironment, `v${SUPPORTED_ARTIFACT_MAJOR_VERSION}`, isDefined(propertyToken) ? propertyToken : undefined, getArtifactFileName(artifactFormat)].filter(value => isDefined(value)).join("/");
  }
  /**
   *
   * @param {string} artifactLocation
   */

  function determineArtifactFormat(artifactLocation) {
    return artifactLocation.match(REGEX_ARTIFACT_FILENAME_BINARY) != null ? ARTIFACT_FORMAT_BINARY : ARTIFACT_FORMAT_JSON;
  }
  /**
   * firstMatch looks through a list of objects (in order) and returns a value from the first object that has a matching key
   * @param key
   * @param {Array<Object>} searchObjects
   * @param defaultValue
   */

  function firstMatch(key) {
    let searchObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    for (let i = 0; i < searchObjects.length; i += 1) {
      const haystack = searchObjects[i];

      if (isObject(haystack) && isDefined(haystack[key])) {
        return haystack[key];
      }
    }

    return defaultValue;
  }
  /**
   * @param {object} object
   * @param { array<string> } keys
   * @param { object } value
   */

  function setNestedValue(object, keys, value) {
    let currentObj = object;

    for (let i = 0; i < keys.length - 1; i += 1) {
      currentObj[keys[i]] = currentObj[keys[i]] || {};
      currentObj = currentObj[keys[i]];
    }

    currentObj[keys[keys.length - 1]] = value;
  }
  /**
   * @param {string} key
   * @returns {boolean}
   */


  function isExpandableKey(key) {
    const keyLength = key.length;
    return includes(".", key) && !includes("..", key) && key[0] !== "." && key[keyLength - 1] !== ".";
  }
  /**
   * @param {object} object
   * @return {object} object
   */


  function unflatten(object) {
    const result = {};
    Object.keys(object).forEach(key => {
      if (isExpandableKey(key)) {
        setNestedValue(result, key.split("."), object[key]);
      } else {
        result[key] = object[key];
      }
    });
    return result;
  }

  /**
   * @type { import("@adobe/target-tools/delivery-api-client/models/Context").Context }
   */

  const EMPTY_CONTEXT = {
    channel: ChannelType.Web
  };

  function getLowerCaseAttributes(obj) {
    const result = {};
    Object.keys(obj).forEach(key => {
      result[`${key}_lc`] = isString(obj[key]) ? obj[key].toLowerCase() : obj[key];
    });
    return result;
  }

  function withLowerCaseStringValues(obj) {
    const result = _objectSpread2({}, obj);

    Object.keys(obj).forEach(key => {
      if (isString(result[key])) {
        result[`${key}_lc`] = result[key].toLowerCase();
      }

      if (isPlainObject(obj[key])) {
        result[key] = withLowerCaseStringValues(result[key]);
      }
    });
    return result;
  }

  const BROWSER_PLATFORMS_MAPPING = {
    "Windows": "windows",
    "Macintosh": "mac",
    "Mac OS": "mac",
    "macOS": "mac",
    "Linux": "linux"
  };

  const toTargetPlatform = platform => isDefined(BROWSER_PLATFORMS_MAPPING[platform]) ? BROWSER_PLATFORMS_MAPPING[platform] : platform;
  /**
   * @param { import("@adobe/target-tools/delivery-api-client/models/Context").Context } context
   * @return { import("../types/DecisioningContext").UserContext }
   */


  function createBrowserContext(context) {
    const {
      userAgent = "",
      clientHints
    } = context;
    const browser = browserFromUserAgentOrClientHintUA(userAgent, clientHints);
    const platform = operatingSystemFromUserAgentOrClientHints(userAgent, clientHints);
    return {
      browserType: browser.name.toLowerCase(),
      platform: toTargetPlatform(platform),
      locale: "en",
      // TODO: determine where this comes from
      browserVersion: browser.version
    };
  }
  /**
   * @param { string } url
   * @param { import("../types/DecisioningContext").ParseDomainFunc } parseDomainImpl
   * @return { import("../types/DecisioningContext").PageContext }
   */


  function createUrlContext(url, parseDomainImpl) {
    if (!url || !isString(url)) {
      // eslint-disable-next-line no-param-reassign
      url = "";
    }

    const urlAttributes = parseURL(url, parseDomainImpl);
    return _objectSpread2(_objectSpread2({}, urlAttributes), getLowerCaseAttributes(urlAttributes));
  }
  /**
   * @param { import("@adobe/target-tools/delivery-api-client/models/Address").Address } address
   * @param { import("../types/DecisioningContext").ParseDomainFunc } parseDomainImpl
   * @return { import("../types/DecisioningContext").PageContext }
   */


  function createPageContext(address, parseDomainImpl) {
    return createUrlContext(address ? address.url : "", parseDomainImpl);
  }
  /**
   * @param { import("@adobe/target-tools/delivery-api-client/models/Address").Address } address
   * @param { import("../types/DecisioningContext").ParseDomainFunc } parseDomainImpl
   * @return { import("../types/DecisioningContext").PageContext }
   */

  function createReferringContext(address, parseDomainImpl) {
    return createUrlContext(address ? address.referringUrl : "", parseDomainImpl);
  }
  /**
   * @param { import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest } mboxRequest
   * @return { import("../types/DecisioningContext").MboxContext }
   */

  function createMboxContext(mboxRequest) {
    if (!mboxRequest) {
      return {};
    }

    const parameters = mboxRequest.parameters || {};
    return withLowerCaseStringValues(_objectSpread2({}, unflatten(parameters)));
  }
  /**
   * @param { import("@adobe/target-tools/delivery-api-client/models/Geo").Geo } geoContext
   * @return { import("../types/DecisioningContext").GeoContext}
   */

  function createGeoContext() {
    let geoContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      country: geoContext.countryCode,
      region: geoContext.stateCode,
      city: geoContext.city,
      latitude: geoContext.latitude,
      longitude: geoContext.longitude
    };
  }

  function createTimingContext() {
    const now = new Date();

    const twoDigitString = value => value < 10 ? `0${value}` : String(value);

    const currentHours = twoDigitString(now.getUTCHours());
    const currentMinutes = twoDigitString(now.getUTCMinutes());
    const currentTime = `${currentHours}${currentMinutes}`;
    const currentDay = now.getUTCDay(); // 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.

    return {
      current_timestamp: now.getTime(),
      // in ms
      current_time: currentTime,
      // 24-hour time, UTC, HHmm
      current_day: currentDay === 0 ? 7 : currentDay // 1-7, 1 = monday, 7 = sunday

    };
  }
  /**
   *
   * The TargetDecisioningEngine initialize method
   * @param { import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest } deliveryRequest
   * @param { import("../types/DecisioningContext").ParseDomainFunc} parseDomainImpl
   * @return { import("../types/DecisioningContext").DecisioningContext }
   */


  function createDecisioningContext(deliveryRequest, parseDomainImpl) {
    const {
      context = EMPTY_CONTEXT
    } = deliveryRequest;
    return _objectSpread2(_objectSpread2({}, createTimingContext()), {}, {
      user: createBrowserContext(context),
      page: createPageContext(context.address, parseDomainImpl),
      referring: createReferringContext(context.address, parseDomainImpl),
      geo: createGeoContext(context.geo || {})
    });
  }

  /* eslint-disable import/prefer-default-export */
  const ARTIFACT_DOWNLOAD_SUCCEEDED = "artifactDownloadSucceeded";
  const ARTIFACT_DOWNLOAD_FAILED = "artifactDownloadFailed";
  const GEO_LOCATION_UPDATED = "geoLocationUpdated";
  const SEND_NOTIFICATION_ERROR = "sendNotificationError";

  const LOG_TAG = `${LOG_PREFIX}.NotificationProvider`;
  /**
   * The get NotificationProvider initialize method
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} request Target View Delivery API request, required
   * @param visitor VisitorId instance, required
   * @param { Object } logger
   * @param {function} sendNotificationFunc function used to send the notification, required
   * @param telemetryEnabled
   * @param eventEmitter
   */

  function NotificationProvider(request, visitor, logger) {
    let sendNotificationFunc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noopPromise;
    let telemetryEnabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let eventEmitter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : noop;
    const timestamp = now();
    const prevEventKeys = new Set();
    let notifications = [];
    /**
     * The get NotificationProvider initialize method
     * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mbox
     * @param { Function } traceFn
     */

    function addNotification(mbox) {
      let traceFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      const displayTokens = [];
      mbox.options.forEach(option => {
        const {
          eventToken
        } = option;
        const eventKey = `${mbox.name}-${eventToken}`;

        if (isDefined(eventToken) && !prevEventKeys.has(eventKey)) {
          displayTokens.push(eventToken);
          prevEventKeys.add(eventKey);
        }
      });

      if (displayTokens.length === 0) {
        return;
      }

      const notification = {
        id: uuid(),
        impressionId: uuid(),
        timestamp,
        type: MetricType.Display,
        mbox: {
          name: mbox.name
        },
        tokens: displayTokens
      };

      if (isFunction(traceFn)) {
        traceFn(notification);
      }

      notifications.push(notification);
    }

    function sendNotifications() {
      logger.debug(`${LOG_TAG}.sendNotifications`, notifications);

      if (notifications.length > 0 || telemetryEnabled) {
        const {
          id,
          context,
          experienceCloud
        } = request;
        const notification = {
          request: {
            id,
            context,
            experienceCloud
          },
          visitor
        };

        if (notifications.length > 0) {
          notification.request.notifications = notifications;
        }

        setTimeout(() => {
          sendNotificationFunc.call(null, notification).catch(error => {
            eventEmitter(SEND_NOTIFICATION_ERROR, {
              notification,
              error
            });
          });
        }, 0);
        notifications = [];
      }
    }

    return {
      addNotification,
      sendNotifications
    };
  }

  const byOrder = (a, b) => a.order - b.order;
  /**
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config Options map, required
   * @param {import("../types/TargetDeliveryRequest").TargetDeliveryRequest} targetOptions
   * @param { object } artifactTrace
   */


  function TraceProvider(config, targetOptions, artifactTrace) {
    const clientCode = config.client;
    const {
      sessionId,
      request
    } = targetOptions;
    const showTraces = isDefined(request.trace);
    const [tntId, profileLocation] = isDefined(request.id) && isString(request.id.tntId) ? request.id.tntId.split(".") : [undefined, undefined];
    const profile = {
      visitorId: _objectSpread2(_objectSpread2({}, request.id), {}, {
        tntId,
        profileLocation
      })
    };

    function wrap(traceResult) {
      if (!showTraces) {
        return undefined;
      }

      return {
        clientCode,
        artifact: artifactTrace,
        profile,
        request: _objectSpread2({
          sessionId
        }, traceResult.request),
        campaigns: traceResult.campaigns,
        evaluatedCampaignTargets: traceResult.evaluatedCampaignTargets
      };
    }

    return {
      wrap
    };
  }
  /**
   * @param traceProvider
   * @param { import("../types/DecisioningArtifact").DecisioningArtifact } artifact
   */

  function RequestTracer(traceProvider, artifact) {
    let request = {}; // add to as rules are evaluated

    const campaigns = {};
    let campaignOrder = 0;
    const evaluatedCampaignTargets = {};
    let evaluatedCampaignTargetOrder = 0;
    /**
     *
     * @param { 'execute'|'prefetch' } mode
     * @param { 'mbox'|'view'|'pageLoad' } requestType
     * @param mboxRequest
     * @param context
     */

    function traceRequest(mode, requestType, mboxRequest, context) {
      request = {
        pageURL: context.page.url,
        host: context.page.domain
      };
      request[requestType] = _objectSpread2(_objectSpread2({}, mboxRequest), {}, {
        type: mode
      });
    }
    /**
     *
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @param { Boolean } ruleSatisfied
     */


    function addCampaign(rule, ruleSatisfied) {
      const {
        meta
      } = rule;
      const activityId = meta[ACTIVITY_ID];

      if (ruleSatisfied && isUndefined(campaigns[activityId])) {
        campaignOrder += 1;
        campaigns[activityId] = {
          id: activityId,
          order: campaignOrder,
          campaignType: meta[ACTIVITY_TYPE],
          branchId: meta[EXPERIENCE_ID],
          offers: isDefined(meta[OFFER_ID]) ? [meta[OFFER_ID]] : [],
          environment: artifact.meta.environment
        };
      }
    }
    /**
     *
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @param { import("../types/DecisioningContext").DecisioningContext } ruleContext
     * @param { Boolean } ruleSatisfied
     */


    function addEvaluatedCampaignTarget(rule, ruleContext, ruleSatisfied) {
      const {
        meta
      } = rule;
      const audienceIds = meta[AUDIENCE_IDS];
      const activityId = meta[ACTIVITY_ID];

      if (isUndefined(evaluatedCampaignTargets[activityId])) {
        evaluatedCampaignTargetOrder += 1;
        evaluatedCampaignTargets[activityId] = {
          order: evaluatedCampaignTargetOrder,
          context: ruleContext,
          campaignId: activityId,
          campaignType: meta[ACTIVITY_TYPE],
          matchedSegmentIds: new Set(),
          unmatchedSegmentIds: new Set(),
          matchedRuleConditions: [],
          unmatchedRuleConditions: []
        };
      }

      audienceIds.forEach(audienceId => {
        evaluatedCampaignTargets[activityId][ruleSatisfied ? "matchedSegmentIds" : "unmatchedSegmentIds"].add(audienceId);
      });
      evaluatedCampaignTargets[activityId][ruleSatisfied ? "matchedRuleConditions" : "unmatchedRuleConditions"].push(rule.condition);
    }
    /**
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @param { import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails } mboxRequest
     * @param { 'mbox'|'view'|'pageLoad' } requestType
     * @param { import("../types/DecisioningContext").DecisioningContext } ruleContext
     * @param { Boolean } ruleSatisfied
     */


    function traceRuleEvaluated(rule, mboxRequest, requestType, ruleContext, ruleSatisfied) {
      addCampaign(rule, ruleSatisfied);
      addEvaluatedCampaignTarget(rule, ruleContext, ruleSatisfied);
    }
    /**
     *
     * @param {import("../types/DecisioningArtifact").Rule} rule
     */


    function traceNotification(rule) {
      const {
        meta
      } = rule;
      const activityId = meta[ACTIVITY_ID];

      if (!(campaigns[activityId].notifications instanceof Array)) {
        campaigns[activityId].notifications = [];
      }

      return notification => {
        campaigns[activityId].notifications.push(notification);
      };
    }

    function toJSON() {
      return {
        campaigns: values(campaigns).sort(byOrder).map(campaign => {
          const result = _objectSpread2({}, campaign);

          delete result.order;
          return result;
        }),
        evaluatedCampaignTargets: values(evaluatedCampaignTargets).sort(byOrder).map(evaluatedCampaignTarget => {
          const result = _objectSpread2(_objectSpread2({}, evaluatedCampaignTarget), {}, {
            matchedSegmentIds: [...evaluatedCampaignTarget.matchedSegmentIds],
            unmatchedSegmentIds: [...evaluatedCampaignTarget.unmatchedSegmentIds]
          });

          delete result.order;
          return result;
        }),
        request
      };
    }

    function getTraceResult() {
      return traceProvider.wrap(toJSON());
    }

    return {
      toJSON,
      traceRuleEvaluated,
      traceRequest,
      traceNotification,
      getTraceResult
    };
  }
  /**
   *
   * @param {string} artifactLocation
   * @param {import("../types/DecisioningArtifact").DecisioningArtifact} artifactPayload
   * @param {number} pollingInterval
   * @param {boolean} pollingHalted
   * @param {import("../types/DecisioningArtifact").DecisioningArtifact} firstArtifact
   */

  function ArtifactTracer(artifactLocation, artifactPayload, pollingInterval, pollingHalted, firstArtifact) {
    let artifact = firstArtifact;
    let artifactRetrievalCount = 1;
    let artifactLastRetrieved = new Date();

    function provideNewArtifact(value) {
      artifactLastRetrieved = new Date();
      artifactRetrievalCount += 1;
      artifact = value;
    }

    const meta = isDefined(artifact) ? artifact.meta : {};

    function toJSON() {
      return _objectSpread2({
        artifactLocation: isObject(artifactPayload) ? Messages.NOT_APPLICABLE : artifactLocation,
        pollingInterval,
        pollingHalted,
        artifactVersion: isDefined(artifact) ? artifact.version : Messages.UNKNOWN,
        artifactRetrievalCount,
        artifactLastRetrieved: artifactLastRetrieved.toISOString()
      }, meta);
    }

    return {
      provideNewArtifact,
      toJSON
    };
  }

  /* eslint-disable import/prefer-default-export */
  const RequestType = {
    MBOX: "mbox",
    VIEW: "view",
    PAGELOAD: "pageLoad"
  };
  const OptionType = {
    Html: "html",
    Json: "json",
    Redirect: "redirect",
    Dynamic: "dynamic",
    Actions: "actions"
  };

  const MACRO_PATTERN_REGEX = /\$\{([a-zA-Z0-9_.]*?)\}/gi;
  const MACRO_NAME_REPLACEMENTS = {
    campaign: "activity",
    recipe: "experience"
  };
  const MACRO_NAME_REPLACEMENTS_REGEX = new RegExp(Object.keys(MACRO_NAME_REPLACEMENTS).join("|"), "gi");
  const MACRO_NAME_REMOVALS = ["mbox"];

  function noBlankOptions(option) {
    return !(isUndefined(option.type) && isUndefined(option.content));
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */


  function prepareExecuteResponse(rule, mboxResponse, requestType, requestDetail, tracer) {
    const {
      metrics = [],
      options = []
    } = mboxResponse;

    const result = _objectSpread2(_objectSpread2({}, mboxResponse), {}, {
      options: options.filter(noBlankOptions).map(pristineOption => {
        const option = _objectSpread2({}, pristineOption);

        delete option.eventToken;
        return option;
      }),
      metrics: metrics.filter(metric => metric.type === MetricType.Click)
    });

    if (result.metrics.length === 0) {
      delete result.metrics;
    }

    return result;
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */

  function preparePrefetchResponse(rule, mboxResponse, requestType, requestDetail, tracer) {
    const {
      options = []
    } = mboxResponse;

    const result = _objectSpread2(_objectSpread2({}, mboxResponse), {}, {
      options: options.map((pristineOption, idx) => {
        let {
          eventToken
        } = pristineOption;

        if (isUndefined(eventToken) && mboxResponse.metrics.length > idx && mboxResponse.metrics[idx].type === MetricType.Display) {
          // eslint-disable-next-line prefer-destructuring
          eventToken = mboxResponse.metrics[idx].eventToken;
        }

        return _objectSpread2(_objectSpread2({}, pristineOption), {}, {
          eventToken
        });
      })
    });

    if (requestType !== RequestType.VIEW) {
      delete result.metrics;
    }

    return result;
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */

  function addTrace(rule, mboxResponse, requestType, requestDetail, tracer) {
    return _objectSpread2(_objectSpread2({}, mboxResponse), {}, {
      trace: tracer.getTraceResult()
    });
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */

  function cleanUp(rule, mboxResponse, requestType, requestDetail, tracer) {
    const result = objectWithoutUndefinedValues(mboxResponse);
    return result;
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */

  function removePageLoadAttributes(rule, mboxResponse, requestType, requestDetail, tracer) {
    const processed = _objectSpread2({}, mboxResponse);

    delete processed.index;
    delete processed.name;
    delete processed.trace;
    return processed;
  }
  /**
   * @param {import("../types/DecisioningContext").DecisioningContext} context
   * @param {Array<string>} responseTokensInArtifact
   */

  function createResponseTokensPostProcessor(context) {
    let responseTokensInArtifact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const responseTokens = {};
    responseTokens[ACTIVITY_DECISIONING_METHOD] = "on-device";

    if (includes(GEO_CITY, responseTokensInArtifact) && isDefined(context.geo.city)) {
      responseTokens[GEO_CITY] = context.geo.city;
    }

    if (includes(GEO_COUNTRY, responseTokensInArtifact) && isDefined(context.geo.country)) {
      responseTokens[GEO_COUNTRY] = context.geo.country;
    }

    if (includes(GEO_STATE, responseTokensInArtifact) && isDefined(context.geo.region)) {
      responseTokens[GEO_STATE] = context.geo.region;
    }

    if (includes(GEO_LATITUDE, responseTokensInArtifact) && isDefined(context.geo.latitude)) {
      responseTokens[GEO_LATITUDE] = context.geo.latitude;
    }

    if (includes(GEO_LONGITUDE, responseTokensInArtifact) && isDefined(context.geo.longitude)) {
      responseTokens[GEO_LONGITUDE] = context.geo.longitude;
    }
    /**
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
     */


    return function addResponseTokens(rule, mboxResponse) {
      const meta = rule.meta || {};
      const responseTokensFromMeta = [ACTIVITY_ID, ACTIVITY_NAME, ACTIVITY_TYPE, EXPERIENCE_ID, EXPERIENCE_NAME, LOCATION_ID, LOCATION_NAME, LOCATION_TYPE, OFFER_ID, OFFER_NAME, OPTION_ID, OPTION_NAME].reduce((accumulator, key) => {
        if (includes(key, responseTokensInArtifact) && isDefined(meta[key])) {
          accumulator[key] = meta[key];
        }

        return accumulator;
      }, {});
      const options = mboxResponse.options.map(option => _objectSpread2(_objectSpread2({}, option), {}, {
        responseTokens: _objectSpread2(_objectSpread2({}, responseTokensFromMeta), responseTokens)
      }));
      return _objectSpread2(_objectSpread2({}, mboxResponse), {}, {
        options
      });
    };
  }
  /**
   * @param {import("../types/DecisioningArtifact").Rule} rule
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxResponse").MboxResponse} mboxResponse
   * @param { 'mbox'|'view'|'pageLoad' } requestType
   * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
   * @param tracer
   */

  function replaceCampaignMacros(rule, mboxResponse, requestType, requestDetail, tracer) {
    function addCampainMacroValues(htmlContent) {
      if (isUndefined(htmlContent) || !isString(htmlContent)) {
        return htmlContent;
      }

      return htmlContent.replace(MACRO_PATTERN_REGEX, (defaultValue, macroKey) => {
        let parts = macroKey.replace(MACRO_NAME_REPLACEMENTS_REGEX, matched => MACRO_NAME_REPLACEMENTS[matched]).split(".");

        if (parts.length > 2) {
          parts = parts.slice(parts.length - 2);
        }

        const key = parts.filter(part => !includes(part, MACRO_NAME_REMOVALS)).join(".");
        const {
          parameters = {}
        } = requestDetail;
        return firstMatch(key, [rule.meta, requestDetail, parameters], defaultValue);
      });
    }

    return _objectSpread2(_objectSpread2({}, mboxResponse), {}, {
      options: mboxResponse.options.map(
      /**
       * @param {import("@adobe/target-tools/delivery-api-client/models/Option").Option} option
       */
      option => {
        if (option.type === OptionType.Html) {
          return _objectSpread2(_objectSpread2({}, option), {}, {
            content: addCampainMacroValues(option.content)
          });
        }

        if (option.type === OptionType.Actions) {
          return _objectSpread2(_objectSpread2({}, option), {}, {
            content: option.content.map(action => _objectSpread2(_objectSpread2({}, action), {}, {
              content: addCampainMacroValues(action.content)
            }))
          });
        }

        return option;
      })
    });
  }

  var logic = createCommonjsModule(function (module, exports) {

    (function (root, factory) {
      {
        module.exports = factory();
      }
    })(commonjsGlobal, function () {
      /* globals console:false */

      if (!Array.isArray) {
        Array.isArray = function (arg) {
          return Object.prototype.toString.call(arg) === "[object Array]";
        };
      }
      /**
       * Return an array that contains no duplicates (original not modified)
       * @param  {array} array   Original reference array
       * @return {array}         New array with no duplicates
       */


      function arrayUnique(array) {
        var a = [];

        for (var i = 0, l = array.length; i < l; i++) {
          if (a.indexOf(array[i]) === -1) {
            a.push(array[i]);
          }
        }

        return a;
      }

      var jsonLogic = {};
      var operations = {
        "==": function (a, b) {
          return a == b;
        },
        "===": function (a, b) {
          return a === b;
        },
        "!=": function (a, b) {
          return a != b;
        },
        "!==": function (a, b) {
          return a !== b;
        },
        ">": function (a, b) {
          return a > b;
        },
        ">=": function (a, b) {
          return a >= b;
        },
        "<": function (a, b, c) {
          return c === undefined ? a < b : a < b && b < c;
        },
        "<=": function (a, b, c) {
          return c === undefined ? a <= b : a <= b && b <= c;
        },
        "!!": function (a) {
          return jsonLogic.truthy(a);
        },
        "!": function (a) {
          return !jsonLogic.truthy(a);
        },
        "%": function (a, b) {
          return a % b;
        },
        "log": function (a) {
          console.log(a);
          return a;
        },
        "in": function (a, b) {
          if (!b || typeof b.indexOf === "undefined") return false;
          return b.indexOf(a) !== -1;
        },
        "cat": function () {
          return Array.prototype.join.call(arguments, "");
        },
        "substr": function (source, start, end) {
          if (end < 0) {
            // JavaScript doesn't support negative end, this emulates PHP behavior
            var temp = String(source).substr(start);
            return temp.substr(0, temp.length + end);
          }

          return String(source).substr(start, end);
        },
        "+": function () {
          return Array.prototype.reduce.call(arguments, function (a, b) {
            return parseFloat(a, 10) + parseFloat(b, 10);
          }, 0);
        },
        "*": function () {
          return Array.prototype.reduce.call(arguments, function (a, b) {
            return parseFloat(a, 10) * parseFloat(b, 10);
          });
        },
        "-": function (a, b) {
          if (b === undefined) {
            return -a;
          } else {
            return a - b;
          }
        },
        "/": function (a, b) {
          return a / b;
        },
        "min": function () {
          return Math.min.apply(this, arguments);
        },
        "max": function () {
          return Math.max.apply(this, arguments);
        },
        "merge": function () {
          return Array.prototype.reduce.call(arguments, function (a, b) {
            return a.concat(b);
          }, []);
        },
        "var": function (a, b) {
          var not_found = b === undefined ? null : b;
          var data = this;

          if (typeof a === "undefined" || a === "" || a === null) {
            return data;
          }

          var sub_props = String(a).split(".");

          for (var i = 0; i < sub_props.length; i++) {
            if (data === null || data === undefined) {
              return not_found;
            } // Descending into data


            data = data[sub_props[i]];

            if (data === undefined) {
              return not_found;
            }
          }

          return data;
        },
        "missing": function () {
          /*
          Missing can receive many keys as many arguments, like {"missing:[1,2]}
          Missing can also receive *one* argument that is an array of keys,
          which typically happens if it's actually acting on the output of another command
          (like 'if' or 'merge')
          */
          var missing = [];
          var keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = jsonLogic.apply({
              "var": key
            }, this);

            if (value === null || value === "") {
              missing.push(key);
            }
          }

          return missing;
        },
        "missing_some": function (need_count, options) {
          // missing_some takes two arguments, how many (minimum) items must be present, and an array of keys (just like 'missing') to check for presence.
          var are_missing = jsonLogic.apply({
            "missing": options
          }, this);

          if (options.length - are_missing.length >= need_count) {
            return [];
          } else {
            return are_missing;
          }
        }
      };

      jsonLogic.is_logic = function (logic) {
        return typeof logic === "object" && // An object
        logic !== null && // but not null
        !Array.isArray(logic) && // and not an array
        Object.keys(logic).length === 1 // with exactly one key
        ;
      };
      /*
      This helper will defer to the JsonLogic spec as a tie-breaker when different language interpreters define different behavior for the truthiness of primitives.  E.g., PHP considers empty arrays to be falsy, but Javascript considers them to be truthy. JsonLogic, as an ecosystem, needs one consistent answer.
       Spec and rationale here: http://jsonlogic.com/truthy
      */


      jsonLogic.truthy = function (value) {
        if (Array.isArray(value) && value.length === 0) {
          return false;
        }

        return !!value;
      };

      jsonLogic.get_operator = function (logic) {
        return Object.keys(logic)[0];
      };

      jsonLogic.get_values = function (logic) {
        return logic[jsonLogic.get_operator(logic)];
      };

      jsonLogic.apply = function (logic, data) {
        // Does this array contain logic? Only one way to find out.
        if (Array.isArray(logic)) {
          return logic.map(function (l) {
            return jsonLogic.apply(l, data);
          });
        } // You've recursed to a primitive, stop!


        if (!jsonLogic.is_logic(logic)) {
          return logic;
        }

        var op = jsonLogic.get_operator(logic);
        var values = logic[op];
        var i;
        var current;
        var scopedLogic;
        var scopedData;
        var initial; // easy syntax for unary operators, like {"var" : "x"} instead of strict {"var" : ["x"]}

        if (!Array.isArray(values)) {
          values = [values];
        } // 'if', 'and', and 'or' violate the normal rule of depth-first calculating consequents, let each manage recursion as needed.


        if (op === "if" || op == "?:") {
          /* 'if' should be called with a odd number of parameters, 3 or greater
          This works on the pattern:
          if( 0 ){ 1 }else{ 2 };
          if( 0 ){ 1 }else if( 2 ){ 3 }else{ 4 };
          if( 0 ){ 1 }else if( 2 ){ 3 }else if( 4 ){ 5 }else{ 6 };
           The implementation is:
          For pairs of values (0,1 then 2,3 then 4,5 etc)
          If the first evaluates truthy, evaluate and return the second
          If the first evaluates falsy, jump to the next pair (e.g, 0,1 to 2,3)
          given one parameter, evaluate and return it. (it's an Else and all the If/ElseIf were false)
          given 0 parameters, return NULL (not great practice, but there was no Else)
          */
          for (i = 0; i < values.length - 1; i += 2) {
            if (jsonLogic.truthy(jsonLogic.apply(values[i], data))) {
              return jsonLogic.apply(values[i + 1], data);
            }
          }

          if (values.length === i + 1) {
            return jsonLogic.apply(values[i], data);
          }

          return null;
        } else if (op === "and") {
          // Return first falsy, or last
          for (i = 0; i < values.length; i += 1) {
            current = jsonLogic.apply(values[i], data);

            if (!jsonLogic.truthy(current)) {
              return current;
            }
          }

          return current; // Last
        } else if (op === "or") {
          // Return first truthy, or last
          for (i = 0; i < values.length; i += 1) {
            current = jsonLogic.apply(values[i], data);

            if (jsonLogic.truthy(current)) {
              return current;
            }
          }

          return current; // Last
        } else if (op === "filter") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1];

          if (!Array.isArray(scopedData)) {
            return [];
          } // Return only the elements from the array in the first argument,
          // that return truthy when passed to the logic in the second argument.
          // For parity with JavaScript, reindex the returned array


          return scopedData.filter(function (datum) {
            return jsonLogic.truthy(jsonLogic.apply(scopedLogic, datum));
          });
        } else if (op === "map") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1];

          if (!Array.isArray(scopedData)) {
            return [];
          }

          return scopedData.map(function (datum) {
            return jsonLogic.apply(scopedLogic, datum);
          });
        } else if (op === "reduce") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1];
          initial = typeof values[2] !== "undefined" ? values[2] : null;

          if (!Array.isArray(scopedData)) {
            return initial;
          }

          return scopedData.reduce(function (accumulator, current) {
            return jsonLogic.apply(scopedLogic, {
              current: current,
              accumulator: accumulator
            });
          }, initial);
        } else if (op === "all") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1]; // All of an empty set is false. Note, some and none have correct fallback after the for loop

          if (!Array.isArray(scopedData) || !scopedData.length) {
            return false;
          }

          for (i = 0; i < scopedData.length; i += 1) {
            if (!jsonLogic.truthy(jsonLogic.apply(scopedLogic, scopedData[i]))) {
              return false; // First falsy, short circuit
            }
          }

          return true; // All were truthy
        } else if (op === "none") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1];

          if (!Array.isArray(scopedData) || !scopedData.length) {
            return true;
          }

          for (i = 0; i < scopedData.length; i += 1) {
            if (jsonLogic.truthy(jsonLogic.apply(scopedLogic, scopedData[i]))) {
              return false; // First truthy, short circuit
            }
          }

          return true; // None were truthy
        } else if (op === "some") {
          scopedData = jsonLogic.apply(values[0], data);
          scopedLogic = values[1];

          if (!Array.isArray(scopedData) || !scopedData.length) {
            return false;
          }

          for (i = 0; i < scopedData.length; i += 1) {
            if (jsonLogic.truthy(jsonLogic.apply(scopedLogic, scopedData[i]))) {
              return true; // First truthy, short circuit
            }
          }

          return false; // None were truthy
        } // Everyone else gets immediate depth-first recursion


        values = values.map(function (val) {
          return jsonLogic.apply(val, data);
        }); // The operation is called with "data" bound to its "this" and "values" passed as arguments.
        // Structured commands like % or > can name formal arguments while flexible commands (like missing or merge) can operate on the pseudo-array arguments
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments

        if (operations.hasOwnProperty(op) && typeof operations[op] === "function") {
          return operations[op].apply(data, values);
        } else if (op.indexOf(".") > 0) {
          // Contains a dot, and not in the 0th position
          var sub_ops = String(op).split(".");
          var operation = operations;

          for (i = 0; i < sub_ops.length; i++) {
            if (!operation.hasOwnProperty(sub_ops[i])) {
              throw new Error("Unrecognized operation " + op + " (failed at " + sub_ops.slice(0, i + 1).join(".") + ")");
            } // Descending into operations


            operation = operation[sub_ops[i]];
          }

          return operation.apply(data, values);
        }

        throw new Error("Unrecognized operation " + op);
      };

      jsonLogic.uses_data = function (logic) {
        var collection = [];

        if (jsonLogic.is_logic(logic)) {
          var op = jsonLogic.get_operator(logic);
          var values = logic[op];

          if (!Array.isArray(values)) {
            values = [values];
          }

          if (op === "var") {
            // This doesn't cover the case where the arg to var is itself a rule.
            collection.push(values[0]);
          } else {
            // Recursion!
            values.forEach(function (val) {
              collection.push.apply(collection, jsonLogic.uses_data(val));
            });
          }
        }

        return arrayUnique(collection);
      };

      jsonLogic.add_operation = function (name, code) {
        operations[name] = code;
      };

      jsonLogic.rm_operation = function (name) {
        delete operations[name];
      };

      jsonLogic.rule_like = function (rule, pattern) {
        // console.log("Is ". JSON.stringify(rule) . " like " . JSON.stringify(pattern) . "?");
        if (pattern === rule) {
          return true;
        } // TODO : Deep object equivalency?


        if (pattern === "@") {
          return true;
        } // Wildcard!


        if (pattern === "number") {
          return typeof rule === "number";
        }

        if (pattern === "string") {
          return typeof rule === "string";
        }

        if (pattern === "array") {
          // !logic test might be superfluous in JavaScript
          return Array.isArray(rule) && !jsonLogic.is_logic(rule);
        }

        if (jsonLogic.is_logic(pattern)) {
          if (jsonLogic.is_logic(rule)) {
            var pattern_op = jsonLogic.get_operator(pattern);
            var rule_op = jsonLogic.get_operator(rule);

            if (pattern_op === "@" || pattern_op === rule_op) {
              // echo "\nOperators match, go deeper\n";
              return jsonLogic.rule_like(jsonLogic.get_values(rule, false), jsonLogic.get_values(pattern, false));
            }
          }

          return false; // pattern is logic, rule isn't, can't be eq
        }

        if (Array.isArray(pattern)) {
          if (Array.isArray(rule)) {
            if (pattern.length !== rule.length) {
              return false;
            }
            /*
              Note, array order MATTERS, because we're using this array test logic to consider arguments, where order can matter. (e.g., + is commutative, but '-' or 'if' or 'var' are NOT)
            */


            for (var i = 0; i < pattern.length; i += 1) {
              // If any fail, we fail
              if (!jsonLogic.rule_like(rule[i], pattern[i])) {
                return false;
              }
            }

            return true; // If they *all* passed, we pass
          } else {
            return false; // Pattern is array, rule isn't
          }
        } // Not logic, not array, not a === match for rule.


        return false;
      };

      return jsonLogic;
    });
  });

  const TOTAL_BUCKETS = 10000;
  const MAX_PERCENTAGE = 100;
  function validTntId() {
    let tntId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    if (isString(tntId) && !isEmpty(tntId)) {
      // eslint-disable-next-line no-unused-vars
      const [id, locationHint] = tntId.split(".");
      return id;
    }

    return undefined;
  }
  /**
   *
   * @param { import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId } visitorId
   * @returns {string} first non-blank marketingCloudVisitorId, tntId, thirdPartyId
   */

  function getOrCreateVisitorId(visitorId) {
    if (visitorId) {
      return visitorId.marketingCloudVisitorId || validTntId(visitorId.tntId) || visitorId.thirdPartyId || uuid() // create a tntId
      ;
    }

    return uuid();
  }
  /**
   * @param deviceId
   * @returns {number}
   */

  function calculateAllocation(deviceId) {
    const signedNumericHashValue = hashUnencodedChars(deviceId);
    const hashFixedBucket = Math.abs(signedNumericHashValue) % TOTAL_BUCKETS;
    const allocationValue = hashFixedBucket / TOTAL_BUCKETS * MAX_PERCENTAGE;
    return Math.round(allocationValue * 100) / 100; // two decimal places
  }

  const calculateAllocationMemoized = memoize(calculateAllocation);
  /**
   *
   * @param {String} clientId Target Client Id, required
   * @param {number} activityId Target Activity Id, required
   * @param { import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId|String } visitorId
   * @param {String} salt salt value, optional
   */

  function computeAllocation(clientId, activityId, visitorId) {
    let salt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : CAMPAIGN_BUCKET_SALT;
    // Generate a device id based on visitorId, clientCode, campaignId and a salt value
    const deviceId = [clientId, activityId, isString(visitorId) && !isEmpty(visitorId) ? visitorId : getOrCreateVisitorId(visitorId), salt].join(".");
    return calculateAllocationMemoized(deviceId);
  }

  /**
   *
   * @param { String } clientId
   * @param { import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId } visitorId
   * @param { import("../types/DecisioningContext").ParseDomainFunc} parseDomainImpl
   * @return { Function }
   */

  function ruleEvaluator(clientId, visitorId, parseDomainImpl) {
    const visitorIdString = getOrCreateVisitorId(visitorId);
    /**
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @param { import("../types/DecisioningContext").DecisioningContext } context
     * @param { 'mbox'|'view'|'pageLoad' } requestType
     * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest|import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetail
     * @param { Array<Function> } postProcessors
     * @param tracer
     */

    return function processRule(rule, context, requestType, requestDetail, postProcessors, tracer) {
      let consequence;
      let {
        page,
        referring
      } = context;

      if (isDefined(requestDetail.address)) {
        page = createPageContext(requestDetail.address, parseDomainImpl) || page;
        referring = createPageContext(requestDetail.address, parseDomainImpl) || referring;
      }

      const ruleContext = _objectSpread2(_objectSpread2({}, context), {}, {
        page,
        referring,
        mbox: createMboxContext(requestDetail),
        allocation: computeAllocation(clientId, rule.meta[ACTIVITY_ID], visitorIdString)
      });

      const ruleSatisfied = logic.apply(rule.condition, ruleContext);
      tracer.traceRuleEvaluated(rule, requestDetail, requestType, ruleContext, ruleSatisfied);

      if (ruleSatisfied) {
        consequence = _objectSpread2(_objectSpread2({}, rule.consequence), {}, {
          index: requestDetail.index
        });
        postProcessors.forEach(postProcessFunc => {
          consequence = postProcessFunc(rule, consequence, requestType, requestDetail, tracer);
        });
      }

      return cloneDeep(consequence); // we return a new object because at.js has a tendency to mutate response and we don't want it to mutate the rule consequence itself
    };
  }

  /* eslint-disable import/prefer-default-export */
  /**
   *
   * @param {String} propertyToken
   * @return {function(import("../types/DecisioningArtifact").Rule): boolean}
   */

  function byPropertyToken(propertyToken) {
    /**
     * @param {import("../types/DecisioningArtifact").Rule} rule
     * @return {boolean}
     */
    function filter(rule) {
      const {
        propertyTokens = []
      } = rule;
      return isUndefined(propertyToken) ? propertyTokens.length === 0 : propertyTokens.length === 0 || includes(propertyToken, propertyTokens);
    }

    return filter;
  }

  const LOG_TAG$1 = `${LOG_PREFIX}.DecisionProvider`;
  const PARTIAL_CONTENT = 206;
  const OK = 200;
  /**
   *
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config
   * @param {import("../types/TargetDeliveryRequest").TargetDeliveryRequest} targetOptions
   * @param {import("../types/DecisioningContext").DecisioningContext} context
   * @param { import("../types/DecisioningArtifact").DecisioningArtifact } artifact
   * @param { Object } logger
   * @param traceProvider
   */

  function DecisionProvider(config, targetOptions, context, artifact, logger, traceProvider) {
    const {
      eventEmitter = noop
    } = config;
    const {
      responseTokens,
      rules
    } = artifact;
    const globalMboxName = artifact.globalMbox || DEFAULT_GLOBAL_MBOX;
    const clientId = config.client;
    const {
      request,
      visitor
    } = targetOptions;
    const propertyToken = getPropertyToken(request.property);
    const {
      sendNotificationFunc,
      telemetryEnabled = true
    } = config;
    const visitorId = request.id;
    const processRule = ruleEvaluator(clientId, visitorId, getParseDomainImpl(config));
    const dependency = hasRemoteDependency(artifact, request);
    const notificationProvider = NotificationProvider(request, visitor, logger, sendNotificationFunc, telemetryEnabled, eventEmitter);
    /**
     *
     * @param { 'execute'|'prefetch' } mode
     * @param { Function[] } postProcessors Used to process an mbox if needed, optional
     */

    function getDecisions(mode, postProcessors) {
      if (isUndefined(request[mode])) {
        return undefined;
      }

      const requestTracer = RequestTracer(traceProvider, artifact);
      /**
       *
       * @param { import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails | import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest } requestDetails
       * @param {Array<Function>} additionalPostProcessors
       */

      function processViewRequest(requestDetails) {
        let additionalPostProcessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        requestTracer.traceRequest(mode, RequestType.VIEW, requestDetails, context);
        const consequences = {};
        let viewRules = [];

        if (Object.prototype.hasOwnProperty.call(requestDetails, "name") && isDefined(requestDetails.name)) {
          viewRules = rules.views[requestDetails.name] || [];
        } else {
          viewRules = Object.keys(rules.views).reduce((result, key) => [...result, ...rules.views[key]], []);
        }

        viewRules = viewRules.filter(byPropertyToken(propertyToken));
        const matchedRuleKeys = new Set(); // eslint-disable-next-line no-restricted-syntax

        for (const rule of viewRules) {
          const ruleKey = getRuleKey(rule);
          let consequence;

          if (!matchedRuleKeys.has(ruleKey)) {
            consequence = processRule(rule, context, RequestType.VIEW, requestDetails, [...postProcessors, ...additionalPostProcessors], requestTracer);
          }

          if (consequence) {
            matchedRuleKeys.add(ruleKey);

            if (!consequences[consequence.name]) {
              consequences[consequence.name] = consequence;
            } else {
              consequences[consequence.name] = _objectSpread2(_objectSpread2({}, consequences[consequence.name]), {}, {
                options: [...consequences[consequence.name].options, ...consequence.options],
                metrics: [...consequences[consequence.name].metrics, ...consequence.metrics]
              });
            }
          }
        }

        return values(consequences);
      }
      /**
       * @param {import("@adobe/target-tools/delivery-api-client/models/MboxRequest").MboxRequest} mboxRequest
       * @param { Array<Function> } additionalPostProcessors
       */


      function processMboxRequest(mboxRequest) {
        let additionalPostProcessors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        const isGlobalMbox = mboxRequest.name === globalMboxName;
        requestTracer.traceRequest(mode, RequestType.MBOX, mboxRequest, context);
        const consequences = [];
        const mboxRules = (rules.mboxes[mboxRequest.name] || []).filter(byPropertyToken(propertyToken));
        const matchedRuleKeys = new Set(); // eslint-disable-next-line no-restricted-syntax

        for (const rule of mboxRules) {
          const ruleKey = getRuleKey(rule);
          let consequence;

          if (!isGlobalMbox || isGlobalMbox && !matchedRuleKeys.has(ruleKey)) {
            consequence = processRule(rule, context, RequestType.MBOX, mboxRequest, [...postProcessors, ...additionalPostProcessors], requestTracer);
          }

          if (consequence) {
            consequences.push(consequence);
            matchedRuleKeys.add(ruleKey);

            if (!isGlobalMbox) {
              break;
            }
          }
        } // add a blank if no consequences


        if (!isGlobalMbox && consequences.length === 0) {
          consequences.push({
            name: mboxRequest.name,
            index: mboxRequest.index,
            trace: requestTracer.getTraceResult()
          });
        }

        return consequences;
      }
      /**
       * @param {import("@adobe/target-tools/delivery-api-client/models/RequestDetails").RequestDetails} requestDetails
       */


      function processPageLoadRequest(requestDetails) {
        let trace;
        const consequences = processMboxRequest(_objectSpread2(_objectSpread2({}, requestDetails), {}, {
          name: globalMboxName
        }), [function preserveTrace(rule, mboxResponse) {
          // eslint-disable-next-line prefer-destructuring
          trace = mboxResponse.trace;
          return mboxResponse;
        }, removePageLoadAttributes]);
        const options = flatten(consequences.map(consequence => consequence.options));
        const result = {
          options,
          trace
        };
        const indexedMetrics = consequences.reduce((indexed, consequence) => {
          if (consequence.metrics instanceof Array) {
            consequence.metrics.forEach(metric => {
              // eslint-disable-next-line no-param-reassign
              indexed[metric.eventToken] = metric;
            });
          }

          return indexed;
        }, {});
        const metrics = values(indexedMetrics);

        if (metrics.length > 0) {
          result.metrics = metrics;
        }

        return result;
      }

      const response = {};

      if (request[mode].mboxes) {
        response.mboxes = flatten(request[mode].mboxes.map(mboxRequest => processMboxRequest(mboxRequest)));
      }

      if (request[mode].views) {
        response.views = flatten(request[mode].views.map(requestDetails => processViewRequest(requestDetails)));
      }

      if (request[mode].pageLoad) {
        response.pageLoad = processPageLoadRequest(request[mode].pageLoad);
      }

      return response;
    }

    function getExecuteDecisions(postProcessors) {
      return getDecisions("execute", [function prepareNotification(rule, mboxResponse, requestType, requestDetail, tracer) {
        notificationProvider.addNotification(mboxResponse, tracer.traceNotification(rule));
        return mboxResponse;
      }, prepareExecuteResponse, ...postProcessors]);
    }

    function getPrefetchDecisions(postProcessors) {
      return getDecisions("prefetch", [preparePrefetchResponse, ...postProcessors]);
    }

    const addResponseTokens = createResponseTokensPostProcessor(context, responseTokens);
    const commonPostProcessor = [addResponseTokens, replaceCampaignMacros, addTrace, cleanUp];
    const response = objectWithoutUndefinedValues({
      status: dependency.remoteNeeded ? PARTIAL_CONTENT : OK,
      remoteMboxes: dependency.remoteMboxes,
      remoteViews: dependency.remoteViews,
      requestId: request.requestId,
      id: _objectSpread2({}, request.id),
      client: clientId,
      edgeHost: undefined,
      execute: getExecuteDecisions(commonPostProcessor),
      prefetch: getPrefetchDecisions(commonPostProcessor)
    });
    notificationProvider.sendNotifications();
    logger.debug(`${LOG_TAG$1}`, request, response);
    return Promise.resolve(response);
  }

  const GEO_LOOKUP_URL = `https://${CDN_BASE_PATH}/v${SUPPORTED_ARTIFACT_MAJOR_VERSION}/geo`;
  const GEO_MAPPINGS = [{
    headerName: HTTP_HEADER_FORWARDED_FOR,
    parseValue: value => value,
    valueKey: "ipAddress"
  }, {
    headerName: HTTP_HEADER_GEO_LATITUDE,
    parseValue: value => parseFloat(value),
    valueKey: "latitude"
  }, {
    headerName: HTTP_HEADER_GEO_LONGITUDE,
    parseValue: value => parseFloat(value),
    valueKey: "longitude"
  }, {
    headerName: HTTP_HEADER_GEO_COUNTRY,
    parseValue: value => value,
    valueKey: "countryCode"
  }, {
    headerName: HTTP_HEADER_GEO_REGION,
    parseValue: value => value,
    valueKey: "stateCode"
  }, {
    headerName: HTTP_HEADER_GEO_CITY,
    parseValue: value => value,
    valueKey: "city"
  }];
  /**
   *
   * @param {Function} valueFn, function to lookup value by key
   * @param initial
   * @return {import("@adobe/target-tools/delivery-api-client/models/Geo").Geo}
   */

  function mapGeoValues(valueFn) {
    let initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return GEO_MAPPINGS.reduce((result, mapping) => {
      const value = valueFn.call(null, mapping.headerName);

      if (value != null && isDefined(value)) {
        // eslint-disable-next-line no-param-reassign
        result[mapping.valueKey] = mapping.parseValue(value);
      }

      return result;
    }, initial);
  }
  /**
   * @param { import("node-fetch").Headers  } geoHeaders;
   * @return { import("@adobe/target-tools/delivery-api-client/models/Geo").Geo }
   */


  function createGeoObjectFromHeaders(geoHeaders) {
    return mapGeoValues(key => geoHeaders.get(key));
  }
  /**
   * @param {Object.<string, any>} geoPayload
   * @return { import("@adobe/target-tools/delivery-api-client/models/Geo").Geo }
   */

  function createGeoObjectFromPayload() {
    let geoPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return mapGeoValues(key => geoPayload[key]);
  }
  /**
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config
   * @param { import("../types/DecisioningArtifact").DecisioningArtifact } artifact
   */

  function GeoProvider(config, artifact) {
    const fetchApi = getFetchApi(config.fetchApi);
    const {
      geoTargetingEnabled = false
    } = artifact;
    const {
      eventEmitter = noop
    } = config;
    /**
     * @param {import("@adobe/target-tools/delivery-api-client/models/Geo").Geo} geoRequestContext
     * @return { Promise<import("@adobe/target-tools/delivery-api-client/models/Geo").Geo> }
     */

    function validGeoRequestContext() {
      let geoRequestContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      const validatedGeoRequestContext = _objectSpread2({}, geoRequestContext);

      if (geoRequestContext.ipAddress === UNKNOWN_IP_ADDRESS || !isValidIpAddress(geoRequestContext.ipAddress)) {
        delete validatedGeoRequestContext.ipAddress;
      }

      if (geoTargetingEnabled && (geoRequestContext.ipAddress === UNKNOWN_IP_ADDRESS || isValidIpAddress(geoRequestContext.ipAddress)) && isUndefined(geoRequestContext.latitude) && isUndefined(geoRequestContext.longitude) && isUndefined(geoRequestContext.countryCode) && isUndefined(geoRequestContext.stateCode) && isUndefined(geoRequestContext.city)) {
        const headers = {};

        if (geoRequestContext.ipAddress !== UNKNOWN_IP_ADDRESS) {
          headers[HTTP_HEADER_FORWARDED_FOR] = geoRequestContext.ipAddress;
        }

        return fetchApi(GEO_LOOKUP_URL, {
          headers
        }).then(geoResponse => geoResponse.json().then(geoPayload => createGeoObjectFromPayload(geoPayload))).then(fetchedGeoValues => {
          reactorObjectAssign(validatedGeoRequestContext, fetchedGeoValues);
          eventEmitter(GEO_LOCATION_UPDATED, {
            geoContext: validatedGeoRequestContext
          });
          return validatedGeoRequestContext;
        });
      }

      return Promise.resolve(validatedGeoRequestContext);
    }

    return validGeoRequestContext;
  }

  /* eslint-disable no-bitwise */
  const HEADER_BOUNDARY = 40;
  /**
   * The ObfuscationProvider initialize method
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config Options map, required
   */

  function ObfuscationProvider(config) {
    const {
      organizationId
    } = config;
    const decoder = new TextDecoder("utf-8");

    function getHeader(buffer) {
      const dataView = new DataView(buffer);
      const text = decoder.decode(dataView);
      const [prefix, version] = text.slice(0, 8).split(":");
      const key = text.slice(8, 41);
      return {
        prefix,
        version: parseInt(version, 10),
        key
      };
    }

    function getArtifact(key, obfuscatedArtifactBuffer) {
      let deobfuscatedArtifactJSON = {};
      const keyBuffer = new TextEncoder().encode([organizationId, key].join(""));
      const keyView = new DataView(keyBuffer.buffer);
      const keyLength = keyView.byteLength;
      const obfuscatedArtifactView = new DataView(obfuscatedArtifactBuffer);
      const artifactLength = obfuscatedArtifactView.byteLength;
      const deobfuscatedArtifactView = new DataView(new ArrayBuffer(artifactLength));

      for (let i = 0; i < artifactLength; i += 1) {
        deobfuscatedArtifactView.setInt8(i, obfuscatedArtifactView.getInt8(i) ^ keyView.getInt8(i % keyLength));
      }

      const deobfuscatedArtifactString = decoder.decode(deobfuscatedArtifactView);

      try {
        deobfuscatedArtifactJSON = JSON.parse(deobfuscatedArtifactString);
      } catch (err) {
        throw new Error(Messages.ARTIFACT_OBFUSCATION_ERROR);
      }

      return deobfuscatedArtifactJSON;
    }

    function deobfuscate(buffer) {
      const header = getHeader(buffer.slice(0, HEADER_BOUNDARY));

      if (header.version !== SUPPORTED_ARTIFACT_OBFUSCATION_VERSION) {
        throw new Error(Messages.ARTIFACT_INVALID);
      }

      return getArtifact(header.key, buffer.slice(HEADER_BOUNDARY));
    }

    return {
      deobfuscate
    };
  }

  /* eslint-disable import/prefer-default-export */
  const TIMING_ARTIFACT_DOWNLOADED_TOTAL = "artifactDownloaded_total";
  const TIMING_ARTIFACT_DOWNLOADED_FETCH = "artifactDownloaded_fetch";
  const TIMING_ARTIFACT_GET_INITIAL = "artifactGetInitial";
  const TIMING_ARTIFACT_READ_JSON = "artifactDownloaded_read_JSON";
  const TIMING_ARTIFACT_DEOBFUSCATE = "deobfuscate_total";

  const LOG_TAG$2 = `${LOG_PREFIX}.ArtifactProvider`;
  const NOT_MODIFIED$1 = 304;
  const OK$1 = 200;
  const ARTIFACT_DOWNLOAD = "ArtifactDownload";
  /**
   * The ArtifactProvider initialize method
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config Options map, required
   */

  function ArtifactProvider(config, telemetryProvider) {
    const logger = getLogger(config.logger);
    const {
      eventEmitter = noop
    } = config;
    const obfuscationProvider = ObfuscationProvider(config);

    function getPollingInterval() {
      if ( // allow polling to be set to 0
      isNumber(config.pollingInterval) && config.pollingInterval === 0) {
        return 0;
      }

      return Math.max(MINIMUM_POLLING_INTERVAL, isNumber(config.pollingInterval) ? config.pollingInterval : DEFAULT_POLLING_INTERVAL);
    }

    const pollingInterval = getPollingInterval();
    const fetchApi = getFetchApi(config.fetchApi);
    let pollingHalted = false;
    let pollingTimer;
    let artifact;
    const subscriptions = {};
    let subscriptionCount = 0;
    let lastResponseEtag;
    let lastResponseData;
    const artifactLocation = determineArtifactLocation(config);
    const artifactFormat = isString(config.artifactFormat) ? config.artifactFormat : determineArtifactFormat(artifactLocation);
    const fetchWithRetry = getFetchWithRetry(fetchApi, NUM_FETCH_RETRIES, errorMessage => Messages.ERROR_MAX_RETRY(NUM_FETCH_RETRIES, errorMessage), error => eventEmitter(ARTIFACT_DOWNLOAD_FAILED, {
      artifactLocation,
      error
    }));

    function emitNewArtifact(artifactPayload) {
      let geoContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      eventEmitter(ARTIFACT_DOWNLOAD_SUCCEEDED, {
        artifactLocation,
        artifactPayload
      });
      eventEmitter(GEO_LOCATION_UPDATED, {
        geoContext
      });
      values(subscriptions).forEach(subscriptionFunc => subscriptionFunc(artifactPayload));
    }
    /**
     *
     * @param {import("node-fetch").Response} res
     * @return {Promise<import("../types/DecisioningArtifact").DecisioningArtifact>}
     */


    function deobfuscate(res) {
      if (artifactFormat === ARTIFACT_FORMAT_BINARY) {
        perfTool.timeStart(TIMING_ARTIFACT_DEOBFUSCATE);
        return res.arrayBuffer().then(buffer => obfuscationProvider.deobfuscate(buffer).then(deobfuscated => {
          perfTool.timeEnd(TIMING_ARTIFACT_DEOBFUSCATE);
          return deobfuscated;
        }));
      }

      perfTool.timeStart(TIMING_ARTIFACT_READ_JSON);
      return res.json().then(data => {
        perfTool.timeEnd(TIMING_ARTIFACT_READ_JSON);
        return data;
      });
    }

    function fetchArtifact(artifactUrl) {
      perfTool.timeStart(TIMING_ARTIFACT_DOWNLOADED_TOTAL);
      const headers = {};
      logger.debug(`${LOG_TAG$2} fetching artifact - ${artifactUrl}`);

      if (lastResponseEtag && !isBrowser() && isNodeJS()) {
        headers["If-None-Match"] = lastResponseEtag;
      }

      perfTool.timeStart(TIMING_ARTIFACT_DOWNLOADED_FETCH);
      return fetchWithRetry(artifactUrl, {
        headers,
        cache: "default"
      }).then(res => {
        const executionTime = perfTool.timeEnd(TIMING_ARTIFACT_DOWNLOADED_FETCH);
        perfTool.clearTiming(TIMING_ARTIFACT_DOWNLOADED_FETCH);
        logger.debug(`${LOG_TAG$2} artifact received - status=${res.status}`);
        const entry = {
          execution: executionTime
        };

        if (res.timings) {
          entry.parsing = res.timings.parsingTime;
          delete res.timings.parsingTime;
          entry.request = res.timings;
        }

        telemetryProvider.addArtifactRequestEntry(ARTIFACT_DOWNLOAD, entry);

        if (res.status === NOT_MODIFIED$1 && lastResponseData) {
          return lastResponseData;
        }

        if (res.ok && res.status === OK$1) {
          return deobfuscate(res).then(responseData => {
            const etag = res.headers.get("Etag");

            if (etag != null && isDefined(etag)) {
              lastResponseData = responseData;
              lastResponseEtag = etag;
            }

            emitNewArtifact(responseData, createGeoObjectFromHeaders(res.headers));
            perfTool.timeEnd(TIMING_ARTIFACT_DOWNLOADED_TOTAL);
            return responseData;
          });
        }

        return undefined;
      }).catch(err => {
        const reason = err.message || err.toString();
        logger.error(Messages.ARTIFACT_FETCH_ERROR(reason));
      });
    }

    function addSubscription(callbackFunc) {
      subscriptionCount += 1;
      subscriptions[subscriptionCount] = callbackFunc;
      return subscriptionCount;
    }

    function removeSubscription(id) {
      delete subscriptions[id];
    }

    function scheduleNextUpdate() {
      if (pollingInterval === 0 || pollingHalted) {
        return;
      }

      pollingTimer = setTimeout(() => {
        fetchArtifact(artifactLocation).then(newArtifact => {
          artifact = newArtifact;
          return newArtifact;
        });
        scheduleNextUpdate();
      }, pollingInterval);
    }

    function stopAllPolling() {
      if (isDefined(pollingTimer)) {
        clearTimeout(pollingTimer);
        pollingTimer = undefined;
      }

      pollingHalted = true;
    }

    function resumePolling() {
      pollingHalted = false;
      scheduleNextUpdate();
    }
    /**
     *
     * @return { import("../types/DecisioningArtifact").DecisioningArtifact }
     */


    function getArtifact() {
      return artifact;
    }

    function getInitialArtifact() {
      perfTool.timeStart(TIMING_ARTIFACT_GET_INITIAL);
      return isObject(config.artifactPayload) ? Promise.resolve(config.artifactPayload) : fetchArtifact(artifactLocation);
    }

    return getInitialArtifact().then(newArtifact => {
      perfTool.timeEnd(TIMING_ARTIFACT_GET_INITIAL);
      artifact = newArtifact;
      const artifactTracer = ArtifactTracer(artifactLocation, config.artifactPayload, pollingInterval, pollingHalted, artifact);
      addSubscription(value => artifactTracer.provideNewArtifact(value));
      return {
        getArtifact: () => getArtifact(),
        subscribe: callbackFunc => addSubscription(callbackFunc),
        unsubscribe: id => removeSubscription(id),
        stopPolling: () => stopAllPolling(),
        resumePolling: () => resumePolling(),
        getTrace: () => artifactTracer.toJSON()
      };
    }).finally(() => {
      scheduleNextUpdate();
    });
  }

  /**
   *
   * @param { import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId } visitorId
   * @returns {string} first non-blank marketingCloudVisitorId, tntId, thirdPartyId
   */

  function getCustomerId(visitorId) {
    if (!visitorId.customerIds || !(visitorId.customerIds instanceof Array)) {
      return undefined;
    }

    const customerIds = visitorId.customerIds.filter(customerId => customerId.authenticatedState === AuthenticatedState.Authenticated);

    if (customerIds.length > 0) {
      return customerIds[0].id;
    }

    return undefined;
  }
  /**
   *
   * @param {import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId} visitorId
   * @param {String} targetLocationHint
   * @returns {import("@adobe/target-tools/delivery-api-client/models/VisitorId").VisitorId}
   */

  function validVisitorId(visitorId, targetLocationHint) {
    const result = _objectSpread2({}, visitorId);

    if (!result.tntId && !result.marketingCloudVisitorId && !getCustomerId(result) && !result.thirdPartyId) {
      const locationHint = isString(targetLocationHint) && !isBlank(targetLocationHint) ? `.${targetLocationHint}_0` : "";
      result.tntId = `${uuid()}${locationHint}`;
    }

    return result;
  }
  /**
   *
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} request
   * @param {String} targetLocationHint
   * @param {Function} validGeoRequestContext
   * @returns {Promise<import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest>}
   */

  function validDeliveryRequest(request, targetLocationHint, validGeoRequestContext) {
    const {
      context = {}
    } = request;
    return validGeoRequestContext(context.geo || {}).then(geo => _objectSpread2(_objectSpread2({}, request), {}, {
      context: _objectSpread2(_objectSpread2({}, context), {}, {
        geo
      }),
      id: validVisitorId(request.id, targetLocationHint),
      requestId: request.requestId || uuid()
    }));
  }

  /**
   * The TargetDecisioningEngine initialize method
   * @param {import("../types/DecisioningConfig").DecisioningConfig} config Options map, required
   * @param {import("@adobe/target-tools/src/telemetryProvider")} telemetryProvider TelemetryProvider function, required
   */

  function TargetDecisioningEngine(config, telemetryProvider) {
    const logger = getLogger(config.logger);
    let artifactProvider;
    let artifact;
    /**
     * The get offers method
     * @param {import("../types/TargetDeliveryRequest").TargetDeliveryRequest} targetOptions
     */

    function getOffers(targetOptions) {
      let {
        request
      } = targetOptions;

      if (isUndefined(artifact)) {
        return Promise.reject(new Error(Messages.ARTIFACT_NOT_AVAILABLE));
      }

      if (!matchMajorVersion(artifact.version, SUPPORTED_ARTIFACT_MAJOR_VERSION)) {
        return Promise.reject(new Error(Messages.ARTIFACT_VERSION_UNSUPPORTED(artifact.version, SUPPORTED_ARTIFACT_MAJOR_VERSION)));
      }

      return validDeliveryRequest(request, targetOptions.targetLocationHint, GeoProvider(config, artifact)).then(validRequest => {
        request = validRequest;

        const options = _objectSpread2(_objectSpread2({}, targetOptions), {}, {
          request
        });

        const traceProvider = TraceProvider(config, options, artifactProvider.getTrace());
        return DecisionProvider(config, options, createDecisioningContext(request, getParseDomainImpl(config)), artifact, logger, traceProvider);
      });
    }

    function isReady() {
      return isDefined(artifact);
    }

    return ArtifactProvider(_objectSpread2(_objectSpread2({}, config), {}, {
      logger
    }), telemetryProvider).then(providerInstance => {
      artifactProvider = providerInstance;
      artifact = artifactProvider.getArtifact();

      if (isUndefined(artifact)) {
        throw new Error(Messages.ARTIFACT_NOT_AVAILABLE);
      } // subscribe to new artifacts that are downloaded on the polling interval


      artifactProvider.subscribe(data => {
        artifact = data;
      });
      return {
        getRawArtifact: () => artifact,
        stopPolling: () => artifactProvider.stopPolling(),
        getOffers: targetOptions => getOffers(targetOptions),
        hasRemoteDependency: request => hasRemoteDependency(artifact, request),
        isReady
      };
    });
  }

  /*
  Copyright 2019 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const NAVIGATOR = "navigator";
  const SEND_BEACON = "sendBeacon";
  const isObject$1 = value => value instanceof Object;
  const isPrimitiveObject = value => value instanceof String || value instanceof Number || value instanceof Boolean || value instanceof Symbol;
  const noUndefinedValues = value => !!Object.values(value).filter(obj => isDefined(obj)).length;
  const isNonEmptyObject = value => isObject$1(value) && !Array.isArray(value) && !isPrimitiveObject(value) && noUndefinedValues(value);
  const isEmptyObject = value => !isNonEmptyObject(value);
  const isNonEmptyString = value => isString(value) && !!value.length;
  const isEmptyString = value => !isNonEmptyString(value);
  const isNonEmptyArray = value => Array.isArray(value) && !!value.length && noUndefinedValues(value);
  const isEmptyArray = value => !isNonEmptyArray(value);
  const removeEmptyKeys = object => // eslint-disable-next-line no-param-reassign
  Object.keys(object).forEach(key => !object[key] && delete object[key]);
  const flatten$1 = function () {
    let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return [].concat(...array);
  };
  const getTimezoneOffset = () => -new Date().getTimezoneOffset();
  function createVisitor(options, config) {
    const {
      organizationId
    } = config;
    const {
      visitor,
      visitorCookie,
      customerIds
    } = options;
    const createdVisitor = visitor || new Visitor(organizationId, visitorCookie);

    if (customerIds) {
      createdVisitor.setCustomerIDs(customerIds);
    }

    return createdVisitor;
  }
  function isBeaconSupported() {
    return isBrowser() && // eslint-disable-next-line no-undef
    NAVIGATOR in window && // eslint-disable-next-line no-undef
    SEND_BEACON in window[NAVIGATOR];
  }
  function executeSendBeacon(url, data) {
    // eslint-disable-next-line no-undef
    return window[NAVIGATOR][SEND_BEACON](url, data);
  }

  /* eslint-disable import/prefer-default-export */
  const Messages$1 = {
    PRIVATE_CONSTRUCTOR: "Please use TargetClient.create static method instead",
    ORG_ID_REQUIRED: "Organization Id is required",
    DECISIONING_METHOD_INVALID: `Invalid Decisioning Method.  Must be set to one of: ${Object.values(DECISIONING_METHOD).join(",")}`,
    FETCH_API_REQUIRED: "Fetch API is required",
    REQUEST_REQUIRED: "Request object is required",
    EXECUTE_FIELDS_REQUIRED: "Either pageLoad or mboxes is required in execute",
    PREFETCH_FIELDS_REQUIRED: "Either views, pageLoad or mboxes is required in prefetch",
    MBOX_INVALID: "Mbox validation failed for: ",
    NOTIFICATION_INVALID: "Notification validation failed for: ",
    CLIENT_REQUIRED: "Client is required",
    OPTIONS_REQUIRED: "Options map is required",
    REQUEST_SENT: "Request sent",
    RESPONSE_RECEIVED: "Response received",
    FETCH_UNDEFINED: "Fetch is not defined!",
    DECISIONING_ENGINE_UNDEFINED: "Decisioning Engine is undefined",
    LOCATION_HINT_REQUEST_FAILED: "Unable to retrieve location hint cookie."
  };

  /*
  Copyright 2019 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  const TARGET_COOKIE = "mbox";
  const SESSION_ID_COOKIE = "session";
  const DEVICE_ID_COOKIE = "PC";
  const LOCATION_HINT_COOKIE = "mboxEdgeCluster";

  function createInternalCookie(name, value, expires) {
    return {
      name,
      value,
      expires
    };
  }

  function serializeCookie(cookie) {
    return [encodeURIComponent(cookie.name), encodeURIComponent(cookie.value), cookie.expires].join("#");
  }

  function deserializeCookie(str) {
    const parts = str.split("#");
    const len = parts.length;

    if (len === 0 || len < 3) {
      return null;
    }

    if (Number.isNaN(parseInt(parts[2], 10))) {
      return null;
    }

    return createInternalCookie(decodeURIComponent(parts[0]), decodeURIComponent(parts[1]), Number(parts[2]));
  }

  function getInternalCookies(cookieValue) {
    return cookieValue.split("|");
  }

  function getExpires(cookie) {
    return cookie.expires;
  }

  function getMaxExpires(cookies) {
    return Math.max.apply(null, cookies.map(getExpires));
  }

  function parseCookies(targetCookie) {
    const result = {};

    if (!targetCookie) {
      return result;
    }

    const rawInternalCookies = getInternalCookies(targetCookie);
    const internalCookies = rawInternalCookies.map(x => deserializeCookie(x));
    const nowInSeconds = Math.ceil(Date.now() / 1000);
    const validCookies = internalCookies.filter(cookie => cookie && nowInSeconds <= cookie.expires);
    validCookies.forEach(cookie => {
      result[cookie.name] = cookie;
    });
    return result;
  }
  function createTargetCookie(cookies) {
    const now = Date.now();
    const maxAge = Math.abs(getMaxExpires(cookies) * 1000 - now);
    const serializedCookies = cookies.map(x => serializeCookie(x));
    return {
      name: TARGET_COOKIE,
      value: serializedCookies.join("|"),
      maxAge: Math.ceil(maxAge / 1000)
    };
  }

  const BASE_PATH = "https://.tt.omtrdc.net".replace(/\/+$/, "");
  const HTTP_NO_CONTENT = 204;
  const DEFAULT_TIMEOUT = 3000;

  const isBlob = value => typeof Blob !== 'undefined' && value instanceof Blob;

  class BaseAPI {
    constructor() {
      let configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Configuration();
      this.configuration = configuration;

      this.fetchApi = async (url, init) => {
        let fetchParams = {
          url,
          init
        };

        for (const middleware of this.middleware) {
          if (middleware.pre) {
            fetchParams = (await middleware.pre(_objectSpread2({
              fetch: this.fetchApi
            }, fetchParams))) || fetchParams;
          }
        }

        let response = await this.configuration.fetchApi(fetchParams.url, fetchParams.init);

        for (const middleware of this.middleware) {
          if (middleware.post) {
            response = (await middleware.post({
              fetch: this.fetchApi,
              url,
              init,
              response: response.clone()
            })) || response;
          }
        }

        return response;
      };

      this.middleware = configuration.middleware;
    }

    withMiddleware() {
      const next = this.clone();
      next.middleware = next.middleware.concat(...arguments);
      return next;
    }

    withPreMiddleware() {
      for (var _len = arguments.length, preMiddlewares = new Array(_len), _key = 0; _key < _len; _key++) {
        preMiddlewares[_key] = arguments[_key];
      }

      const middlewares = preMiddlewares.map(pre => ({
        pre
      }));
      return this.withMiddleware(...middlewares);
    }

    withPostMiddleware() {
      for (var _len2 = arguments.length, postMiddlewares = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        postMiddlewares[_key2] = arguments[_key2];
      }

      const middlewares = postMiddlewares.map(post => ({
        post
      }));
      return this.withMiddleware(...middlewares);
    }

    async request(context) {
      const {
        url,
        init
      } = this.createFetchParams(context);
      const response = await this.fetchApi(url, init);

      if (response.status >= 200 && response.status < 300) {
        return response;
      }

      throw response;
    }

    createFetchParams(context) {
      let url = this.configuration.basePath + context.path;

      if (context.query !== undefined && Object.keys(context.query).length !== 0) {
        url += '?' + this.configuration.queryParamsStringify(context.query);
      }

      const body = context.body instanceof FormData || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(context.body);
      const headers = Object.assign({}, this.configuration.headers, context.headers);
      const init = {
        method: context.method,
        headers: headers,
        body,
        credentials: this.configuration.credentials
      };
      return {
        url,
        init
      };
    }

    clone() {
      const constructor = this.constructor;
      const next = new constructor(this.configuration);
      next.middleware = this.middleware.slice();
      return next;
    }

  }

  class RequiredError extends Error {
    constructor(field, msg) {
      super(msg);
      this.field = field;
      this.name = "RequiredError";
    }

  }

  class Configuration {
    constructor() {
      let configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.configuration = configuration;
    }

    get basePath() {
      return this.configuration.basePath || BASE_PATH;
    }

    get fetchApi() {
      const timeout = this.configuration.timeout;
      const fetch = this.configuration.fetchApi || window.fetch.bind(window);
      return function (input, init) {
        return new Promise((resolve, reject) => {
          let timer = setTimeout(() => reject(new Error('Request timed out')), timeout);
          fetch(input, init).then(response => resolve(response), err => reject(err)).finally(() => clearTimeout(timer));
        });
      };
    }

    get middleware() {
      return this.configuration.middleware || [];
    }

    get queryParamsStringify() {
      return this.configuration.queryParamsStringify || querystring;
    }

    get username() {
      return this.configuration.username;
    }

    get password() {
      return this.configuration.password;
    }

    get apiKey() {
      const apiKey = this.configuration.apiKey;

      if (apiKey) {
        return typeof apiKey === 'function' ? apiKey : () => apiKey;
      }

      return undefined;
    }

    get accessToken() {
      const accessToken = this.configuration.accessToken;

      if (accessToken) {
        return typeof accessToken === 'function' ? accessToken : () => accessToken;
      }

      return undefined;
    }

    get headers() {
      return this.configuration.headers;
    }

    get credentials() {
      return this.configuration.credentials;
    }

    get timeout() {
      return this.configuration.timeout || DEFAULT_TIMEOUT;
    }

  }

  function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
  }

  function querystring(params) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.keys(params).map(key => {
      const fullKey = prefix + (prefix.length ? `[${key}]` : key);
      const value = params[key];

      if (value instanceof Array) {
        const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
      }

      if (value instanceof Object) {
        return querystring(value, fullKey);
      }

      return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    }).filter(part => part.length > 0).join('&');
  }

  class JSONApiResponse {
    constructor(raw) {
      let transformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jsonValue => jsonValue;
      this.raw = raw;
      this.transformer = transformer;
    }

    async value() {
      return this.transformer(this.raw.status === HTTP_NO_CONTENT ? {} : await this.raw.json());
    }

  }

  function AddressFromJSON(json) {
    return AddressFromJSONTyped(json);
  }

  function AddressFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'url': !exists(json, 'url') ? undefined : json['url'],
      'referringUrl': !exists(json, 'referringUrl') ? undefined : json['referringUrl']
    };
  }

  function AddressToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'url': value.url,
      'referringUrl': value.referringUrl
    };
  }

  function AnalyticsPayloadFromJSON(json) {
    return AnalyticsPayloadFromJSONTyped(json);
  }

  function AnalyticsPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'pe': !exists(json, 'pe') ? undefined : json['pe'],
      'tnta': !exists(json, 'tnta') ? undefined : json['tnta']
    };
  }

  function AnalyticsRequestFromJSON(json) {
    return AnalyticsRequestFromJSONTyped(json);
  }

  function AnalyticsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'supplementalDataId': !exists(json, 'supplementalDataId') ? undefined : json['supplementalDataId'],
      'logging': !exists(json, 'logging') ? undefined : LoggingTypeFromJSON(json['logging']),
      'trackingServer': !exists(json, 'trackingServer') ? undefined : json['trackingServer'],
      'trackingServerSecure': !exists(json, 'trackingServerSecure') ? undefined : json['trackingServerSecure']
    };
  }

  function AnalyticsRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'supplementalDataId': value.supplementalDataId,
      'logging': LoggingTypeToJSON(value.logging),
      'trackingServer': value.trackingServer,
      'trackingServerSecure': value.trackingServerSecure
    };
  }

  function AnalyticsResponseFromJSON(json) {
    return AnalyticsResponseFromJSONTyped(json);
  }

  function AnalyticsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'payload': !exists(json, 'payload') ? undefined : AnalyticsPayloadFromJSON(json['payload'])
    };
  }

  function ApplicationFromJSON(json) {
    return ApplicationFromJSONTyped(json);
  }

  function ApplicationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'id': !exists(json, 'id') ? undefined : json['id'],
      'name': !exists(json, 'name') ? undefined : json['name'],
      'version': !exists(json, 'version') ? undefined : json['version']
    };
  }

  function ApplicationToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'id': value.id,
      'name': value.name,
      'version': value.version
    };
  }

  function AudienceManagerFromJSON(json) {
    return AudienceManagerFromJSONTyped(json);
  }

  function AudienceManagerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'locationHint': !exists(json, 'locationHint') ? undefined : json['locationHint'],
      'blob': !exists(json, 'blob') ? undefined : json['blob']
    };
  }

  function AudienceManagerToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'locationHint': value.locationHint,
      'blob': value.blob
    };
  }

  var AuthenticatedState$1;

  (function (AuthenticatedState) {
    AuthenticatedState["Unknown"] = "unknown";
    AuthenticatedState["Authenticated"] = "authenticated";
    AuthenticatedState["LoggedOut"] = "logged_out";
  })(AuthenticatedState$1 || (AuthenticatedState$1 = {}));

  function AuthenticatedStateFromJSON(json) {
    return AuthenticatedStateFromJSONTyped(json);
  }

  function AuthenticatedStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function AuthenticatedStateToJSON(value) {
    return value;
  }

  function BrowserFromJSON(json) {
    return BrowserFromJSONTyped(json);
  }

  function BrowserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'host': !exists(json, 'host') ? undefined : json['host'],
      'language': !exists(json, 'language') ? undefined : json['language'],
      'webGLRenderer': !exists(json, 'webGLRenderer') ? undefined : json['webGLRenderer']
    };
  }

  function BrowserToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'host': value.host,
      'language': value.language,
      'webGLRenderer': value.webGLRenderer
    };
  }

  var ChannelType$1;

  (function (ChannelType) {
    ChannelType["Mobile"] = "mobile";
    ChannelType["Web"] = "web";
  })(ChannelType$1 || (ChannelType$1 = {}));

  function ChannelTypeFromJSON(json) {
    return ChannelTypeFromJSONTyped(json);
  }

  function ChannelTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function ChannelTypeToJSON(value) {
    return value;
  }

  function ClientHintsFromJSON(json) {
    return ClientHintsFromJSONTyped(json);
  }

  function ClientHintsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
      'model': !exists(json, 'model') ? undefined : json['model'],
      'platform': !exists(json, 'platform') ? undefined : json['platform'],
      'platformVersion': !exists(json, 'platformVersion') ? undefined : json['platformVersion'],
      'browserUAWithMajorVersion': !exists(json, 'browserUAWithMajorVersion') ? undefined : json['browserUAWithMajorVersion'],
      'browserUAWithFullVersion': !exists(json, 'browserUAWithFullVersion') ? undefined : json['browserUAWithFullVersion'],
      'architecture': !exists(json, 'architecture') ? undefined : json['architecture'],
      'bitness': !exists(json, 'bitness') ? undefined : json['bitness']
    };
  }

  function ClientHintsToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'mobile': value.mobile,
      'model': value.model,
      'platform': value.platform,
      'platformVersion': value.platformVersion,
      'browserUAWithMajorVersion': value.browserUAWithMajorVersion,
      'browserUAWithFullVersion': value.browserUAWithFullVersion,
      'architecture': value.architecture,
      'bitness': value.bitness
    };
  }

  function ContextFromJSON(json) {
    return ContextFromJSONTyped(json);
  }

  function ContextFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'channel': ChannelTypeFromJSON(json['channel']),
      'mobilePlatform': !exists(json, 'mobilePlatform') ? undefined : MobilePlatformFromJSON(json['mobilePlatform']),
      'application': !exists(json, 'application') ? undefined : ApplicationFromJSON(json['application']),
      'screen': !exists(json, 'screen') ? undefined : ScreenFromJSON(json['screen']),
      'window': !exists(json, 'window') ? undefined : WindowFromJSON(json['window']),
      'browser': !exists(json, 'browser') ? undefined : BrowserFromJSON(json['browser']),
      'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
      'geo': !exists(json, 'geo') ? undefined : GeoFromJSON(json['geo']),
      'timeOffsetInMinutes': !exists(json, 'timeOffsetInMinutes') ? undefined : json['timeOffsetInMinutes'],
      'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
      'clientHints': !exists(json, 'clientHints') ? undefined : ClientHintsFromJSON(json['clientHints']),
      'beacon': !exists(json, 'beacon') ? undefined : json['beacon']
    };
  }

  function ContextToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'channel': ChannelTypeToJSON(value.channel),
      'mobilePlatform': MobilePlatformToJSON(value.mobilePlatform),
      'application': ApplicationToJSON(value.application),
      'screen': ScreenToJSON(value.screen),
      'window': WindowToJSON(value.window),
      'browser': BrowserToJSON(value.browser),
      'address': AddressToJSON(value.address),
      'geo': GeoToJSON(value.geo),
      'timeOffsetInMinutes': value.timeOffsetInMinutes,
      'userAgent': value.userAgent,
      'clientHints': ClientHintsToJSON(value.clientHints),
      'beacon': value.beacon
    };
  }

  function CustomerIdFromJSON(json) {
    return CustomerIdFromJSONTyped(json);
  }

  function CustomerIdFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'id': json['id'],
      'integrationCode': json['integrationCode'],
      'authenticatedState': AuthenticatedStateFromJSON(json['authenticatedState'])
    };
  }

  function CustomerIdToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'id': value.id,
      'integrationCode': value.integrationCode,
      'authenticatedState': AuthenticatedStateToJSON(value.authenticatedState)
    };
  }

  var DecisioningMethod;

  (function (DecisioningMethod) {
    DecisioningMethod["ServerSide"] = "server-side";
    DecisioningMethod["OnDevice"] = "on-device";
    DecisioningMethod["Hybrid"] = "hybrid";
  })(DecisioningMethod || (DecisioningMethod = {}));

  function DecisioningMethodFromJSON(json) {
    return DecisioningMethodFromJSONTyped(json);
  }

  function DecisioningMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function DecisioningMethodToJSON(value) {
    return value;
  }

  function DeliveryRequestFromJSON(json) {
    return DeliveryRequestFromJSONTyped(json);
  }

  function DeliveryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
      'impressionId': !exists(json, 'impressionId') ? undefined : json['impressionId'],
      'id': !exists(json, 'id') ? undefined : VisitorIdFromJSON(json['id']),
      'environmentId': !exists(json, 'environmentId') ? undefined : json['environmentId'],
      'property': !exists(json, 'property') ? undefined : PropertyFromJSON(json['property']),
      'trace': !exists(json, 'trace') ? undefined : TraceFromJSON(json['trace']),
      'context': ContextFromJSON(json['context']),
      'experienceCloud': !exists(json, 'experienceCloud') ? undefined : ExperienceCloudFromJSON(json['experienceCloud']),
      'execute': !exists(json, 'execute') ? undefined : ExecuteRequestFromJSON(json['execute']),
      'prefetch': !exists(json, 'prefetch') ? undefined : PrefetchRequestFromJSON(json['prefetch']),
      'telemetry': !exists(json, 'telemetry') ? undefined : TelemetryFromJSON(json['telemetry']),
      'notifications': !exists(json, 'notifications') ? undefined : json['notifications'].map(NotificationFromJSON),
      'qaMode': !exists(json, 'qaMode') ? undefined : QAModeFromJSON(json['qaMode']),
      'preview': !exists(json, 'preview') ? undefined : PreviewFromJSON(json['preview'])
    };
  }

  function DeliveryRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'requestId': value.requestId,
      'impressionId': value.impressionId,
      'id': VisitorIdToJSON(value.id),
      'environmentId': value.environmentId,
      'property': PropertyToJSON(value.property),
      'trace': TraceToJSON(value.trace),
      'context': ContextToJSON(value.context),
      'experienceCloud': ExperienceCloudToJSON(value.experienceCloud),
      'execute': ExecuteRequestToJSON(value.execute),
      'prefetch': PrefetchRequestToJSON(value.prefetch),
      'telemetry': TelemetryToJSON(value.telemetry),
      'notifications': value.notifications === undefined ? undefined : value.notifications.map(NotificationToJSON),
      'qaMode': QAModeToJSON(value.qaMode),
      'preview': PreviewToJSON(value.preview)
    };
  }

  function DeliveryResponseFromJSON(json) {
    return DeliveryResponseFromJSONTyped(json);
  }

  function DeliveryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'status': !exists(json, 'status') ? undefined : json['status'],
      'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
      'id': !exists(json, 'id') ? undefined : VisitorIdFromJSON(json['id']),
      'client': !exists(json, 'client') ? undefined : json['client'],
      'edgeHost': !exists(json, 'edgeHost') ? undefined : json['edgeHost'],
      'execute': !exists(json, 'execute') ? undefined : ExecuteResponseFromJSON(json['execute']),
      'prefetch': !exists(json, 'prefetch') ? undefined : PrefetchResponseFromJSON(json['prefetch']),
      'notifications': !exists(json, 'notifications') ? undefined : json['notifications'].map(NotificationResponseFromJSON),
      'telemetryServerToken': !exists(json, 'telemetryServerToken') ? undefined : json['telemetryServerToken']
    };
  }

  var DeviceType;

  (function (DeviceType) {
    DeviceType["Phone"] = "phone";
    DeviceType["Tablet"] = "tablet";
  })(DeviceType || (DeviceType = {}));

  function DeviceTypeFromJSON(json) {
    return DeviceTypeFromJSONTyped(json);
  }

  function DeviceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function DeviceTypeToJSON(value) {
    return value;
  }

  function ExecuteRequestFromJSON(json) {
    return ExecuteRequestFromJSONTyped(json);
  }

  function ExecuteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'pageLoad': !exists(json, 'pageLoad') ? undefined : RequestDetailsFromJSON(json['pageLoad']),
      'mboxes': !exists(json, 'mboxes') ? undefined : json['mboxes'].map(MboxRequestFromJSON)
    };
  }

  function ExecuteRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'pageLoad': RequestDetailsToJSON(value.pageLoad),
      'mboxes': value.mboxes === undefined ? undefined : value.mboxes.map(MboxRequestToJSON)
    };
  }

  function ExecuteResponseFromJSON(json) {
    return ExecuteResponseFromJSONTyped(json);
  }

  function ExecuteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'pageLoad': !exists(json, 'pageLoad') ? undefined : PageLoadResponseFromJSON(json['pageLoad']),
      'mboxes': !exists(json, 'mboxes') ? undefined : json['mboxes'].map(MboxResponseFromJSON)
    };
  }

  var ExecutionMode;

  (function (ExecutionMode) {
    ExecutionMode["Edge"] = "edge";
    ExecutionMode["Local"] = "local";
  })(ExecutionMode || (ExecutionMode = {}));

  function ExecutionModeFromJSON(json) {
    return ExecutionModeFromJSONTyped(json);
  }

  function ExecutionModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function ExecutionModeToJSON(value) {
    return value;
  }

  function ExperienceCloudFromJSON(json) {
    return ExperienceCloudFromJSONTyped(json);
  }

  function ExperienceCloudFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'audienceManager': !exists(json, 'audienceManager') ? undefined : AudienceManagerFromJSON(json['audienceManager']),
      'analytics': !exists(json, 'analytics') ? undefined : AnalyticsRequestFromJSON(json['analytics'])
    };
  }

  function ExperienceCloudToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'audienceManager': AudienceManagerToJSON(value.audienceManager),
      'analytics': AnalyticsRequestToJSON(value.analytics)
    };
  }

  function GeoFromJSON(json) {
    return GeoFromJSONTyped(json);
  }

  function GeoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'ipAddress': !exists(json, 'ipAddress') ? undefined : json['ipAddress'],
      'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
      'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
      'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
      'stateCode': !exists(json, 'stateCode') ? undefined : json['stateCode'],
      'city': !exists(json, 'city') ? undefined : json['city'],
      'zip': !exists(json, 'zip') ? undefined : json['zip']
    };
  }

  function GeoToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'ipAddress': value.ipAddress,
      'latitude': value.latitude,
      'longitude': value.longitude,
      'countryCode': value.countryCode,
      'stateCode': value.stateCode,
      'city': value.city,
      'zip': value.zip
    };
  }

  var LoggingType;

  (function (LoggingType) {
    LoggingType["ServerSide"] = "server_side";
    LoggingType["ClientSide"] = "client_side";
  })(LoggingType || (LoggingType = {}));

  function LoggingTypeFromJSON(json) {
    return LoggingTypeFromJSONTyped(json);
  }

  function LoggingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function LoggingTypeToJSON(value) {
    return value;
  }

  function MboxRequestFromJSON(json) {
    return MboxRequestFromJSONTyped(json, false);
  }

  function MboxRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsFromJSONTyped(json, ignoreDiscriminator)), {}, {
      'index': !exists(json, 'index') ? undefined : json['index'],
      'name': !exists(json, 'name') ? undefined : json['name']
    });
  }

  function MboxRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsToJSON(value)), {}, {
      'index': value.index,
      'name': value.name
    });
  }

  function MboxResponseFromJSON(json) {
    return MboxResponseFromJSONTyped(json, false);
  }

  function MboxResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    if (!ignoreDiscriminator) {
      if (json['$type'] === 'PrefetchMboxResponse') {
        return PrefetchMboxResponseFromJSONTyped(json, true);
      }
    }

    return {
      '$type': !exists(json, '$_type') ? undefined : json['$_type'],
      'index': !exists(json, 'index') ? undefined : json['index'],
      'name': !exists(json, 'name') ? undefined : json['name'],
      'options': !exists(json, 'options') ? undefined : json['options'].map(OptionFromJSON),
      'metrics': !exists(json, 'metrics') ? undefined : json['metrics'].map(MetricFromJSON),
      'analytics': !exists(json, 'analytics') ? undefined : AnalyticsResponseFromJSON(json['analytics']),
      'trace': !exists(json, 'trace') ? undefined : json['trace']
    };
  }

  function MetricFromJSON(json) {
    return MetricFromJSONTyped(json);
  }

  function MetricFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'type': !exists(json, 'type') ? undefined : MetricTypeFromJSON(json['type']),
      'selector': !exists(json, 'selector') ? undefined : json['selector'],
      'eventToken': !exists(json, 'eventToken') ? undefined : json['eventToken'],
      'analytics': !exists(json, 'analytics') ? undefined : AnalyticsResponseFromJSON(json['analytics'])
    };
  }

  var MetricType$1;

  (function (MetricType) {
    MetricType["Click"] = "click";
    MetricType["Display"] = "display";
  })(MetricType$1 || (MetricType$1 = {}));

  function MetricTypeFromJSON(json) {
    return MetricTypeFromJSONTyped(json);
  }

  function MetricTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function MetricTypeToJSON(value) {
    return value;
  }

  function MobilePlatformFromJSON(json) {
    return MobilePlatformFromJSONTyped(json);
  }

  function MobilePlatformFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'deviceName': !exists(json, 'deviceName') ? undefined : json['deviceName'],
      'deviceType': DeviceTypeFromJSON(json['deviceType']),
      'platformType': MobilePlatformTypeFromJSON(json['platformType']),
      'version': !exists(json, 'version') ? undefined : json['version']
    };
  }

  function MobilePlatformToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'deviceName': value.deviceName,
      'deviceType': DeviceTypeToJSON(value.deviceType),
      'platformType': MobilePlatformTypeToJSON(value.platformType),
      'version': value.version
    };
  }

  var MobilePlatformType;

  (function (MobilePlatformType) {
    MobilePlatformType["Android"] = "android";
    MobilePlatformType["Ios"] = "ios";
  })(MobilePlatformType || (MobilePlatformType = {}));

  function MobilePlatformTypeFromJSON(json) {
    return MobilePlatformTypeFromJSONTyped(json);
  }

  function MobilePlatformTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function MobilePlatformTypeToJSON(value) {
    return value;
  }

  function NotificationFromJSON(json) {
    return NotificationFromJSONTyped(json, false);
  }

  function NotificationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsFromJSONTyped(json, ignoreDiscriminator)), {}, {
      'id': !exists(json, 'id') ? undefined : json['id'],
      'impressionId': !exists(json, 'impressionId') ? undefined : json['impressionId'],
      'type': !exists(json, 'type') ? undefined : MetricTypeFromJSON(json['type']),
      'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
      'tokens': !exists(json, 'tokens') ? undefined : json['tokens'],
      'mbox': !exists(json, 'mbox') ? undefined : NotificationMboxFromJSON(json['mbox']),
      'view': !exists(json, 'view') ? undefined : NotificationViewFromJSON(json['view']),
      'pageLoad': !exists(json, 'pageLoad') ? undefined : NotificationPageLoadFromJSON(json['pageLoad'])
    });
  }

  function NotificationToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsToJSON(value)), {}, {
      'id': value.id,
      'impressionId': value.impressionId,
      'type': MetricTypeToJSON(value.type),
      'timestamp': value.timestamp,
      'tokens': value.tokens,
      'mbox': NotificationMboxToJSON(value.mbox),
      'view': NotificationViewToJSON(value.view),
      'pageLoad': NotificationPageLoadToJSON(value.pageLoad)
    });
  }

  function NotificationMboxFromJSON(json) {
    return NotificationMboxFromJSONTyped(json);
  }

  function NotificationMboxFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'name': !exists(json, 'name') ? undefined : json['name'],
      'state': !exists(json, 'state') ? undefined : json['state']
    };
  }

  function NotificationMboxToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'name': value.name,
      'state': value.state
    };
  }

  function NotificationPageLoadFromJSON(json) {
    return NotificationPageLoadFromJSONTyped(json);
  }

  function NotificationPageLoadFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'state': !exists(json, 'state') ? undefined : json['state']
    };
  }

  function NotificationPageLoadToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'state': value.state
    };
  }

  function NotificationResponseFromJSON(json) {
    return NotificationResponseFromJSONTyped(json);
  }

  function NotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'id': !exists(json, 'id') ? undefined : json['id'],
      'trace': !exists(json, 'trace') ? undefined : json['trace']
    };
  }

  function NotificationViewFromJSON(json) {
    return NotificationViewFromJSONTyped(json);
  }

  function NotificationViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'name': !exists(json, 'name') ? undefined : json['name'],
      'key': !exists(json, 'key') ? undefined : json['key'],
      'state': !exists(json, 'state') ? undefined : json['state']
    };
  }

  function NotificationViewToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'name': value.name,
      'key': value.key,
      'state': value.state
    };
  }

  function OptionFromJSON(json) {
    return OptionFromJSONTyped(json);
  }

  function OptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'type': !exists(json, 'type') ? undefined : OptionTypeFromJSON(json['type']),
      'content': !exists(json, 'content') ? undefined : OneOfstringobjectarrayFromJSON(json['content']),
      'eventToken': !exists(json, 'eventToken') ? undefined : json['eventToken'],
      'responseTokens': !exists(json, 'responseTokens') ? undefined : json['responseTokens']
    };
  }

  var OptionType$1;

  (function (OptionType) {
    OptionType["Html"] = "html";
    OptionType["Json"] = "json";
    OptionType["Redirect"] = "redirect";
    OptionType["Dynamic"] = "dynamic";
    OptionType["Actions"] = "actions";
  })(OptionType$1 || (OptionType$1 = {}));

  function OptionTypeFromJSON(json) {
    return OptionTypeFromJSONTyped(json);
  }

  function OptionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function OrderFromJSON(json) {
    return OrderFromJSONTyped(json);
  }

  function OrderFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'id': !exists(json, 'id') ? undefined : json['id'],
      'total': !exists(json, 'total') ? undefined : json['total'],
      'purchasedProductIds': !exists(json, 'purchasedProductIds') ? undefined : json['purchasedProductIds'],
      'time': !exists(json, 'time') ? undefined : new Date(json['time']),
      'experienceLocalId': !exists(json, 'experienceLocalId') ? undefined : json['experienceLocalId'],
      'duplicate': !exists(json, 'duplicate') ? undefined : json['duplicate'],
      'outlier': !exists(json, 'outlier') ? undefined : json['outlier']
    };
  }

  function OrderToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'id': value.id,
      'total': value.total,
      'purchasedProductIds': value.purchasedProductIds,
      'time': value.time === undefined ? undefined : value.time.toISOString(),
      'experienceLocalId': value.experienceLocalId,
      'duplicate': value.duplicate,
      'outlier': value.outlier
    };
  }

  function PageLoadResponseFromJSON(json) {
    return PageLoadResponseFromJSONTyped(json);
  }

  function PageLoadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'options': !exists(json, 'options') ? undefined : json['options'].map(OptionFromJSON),
      'metrics': !exists(json, 'metrics') ? undefined : json['metrics'].map(MetricFromJSON),
      'analytics': !exists(json, 'analytics') ? undefined : AnalyticsResponseFromJSON(json['analytics']),
      'state': !exists(json, 'state') ? undefined : json['state'],
      'trace': !exists(json, 'trace') ? undefined : json['trace']
    };
  }

  function PrefetchMboxResponseFromJSON(json) {
    return PrefetchMboxResponseFromJSONTyped(json, false);
  }

  function PrefetchMboxResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return _objectSpread2(_objectSpread2({}, MboxResponseFromJSONTyped(json, ignoreDiscriminator)), {}, {
      'state': !exists(json, 'state') ? undefined : json['state']
    });
  }

  function PrefetchRequestFromJSON(json) {
    return PrefetchRequestFromJSONTyped(json);
  }

  function PrefetchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'views': !exists(json, 'views') ? undefined : json['views'].map(ViewRequestFromJSON),
      'pageLoad': !exists(json, 'pageLoad') ? undefined : RequestDetailsFromJSON(json['pageLoad']),
      'mboxes': !exists(json, 'mboxes') ? undefined : json['mboxes'].map(MboxRequestFromJSON)
    };
  }

  function PrefetchRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'views': value.views === undefined ? undefined : value.views.map(ViewRequestToJSON),
      'pageLoad': RequestDetailsToJSON(value.pageLoad),
      'mboxes': value.mboxes === undefined ? undefined : value.mboxes.map(MboxRequestToJSON)
    };
  }

  function PrefetchResponseFromJSON(json) {
    return PrefetchResponseFromJSONTyped(json);
  }

  function PrefetchResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'views': !exists(json, 'views') ? undefined : json['views'].map(ViewFromJSON),
      'pageLoad': !exists(json, 'pageLoad') ? undefined : PageLoadResponseFromJSON(json['pageLoad']),
      'mboxes': !exists(json, 'mboxes') ? undefined : json['mboxes'].map(PrefetchMboxResponseFromJSON),
      'metrics': !exists(json, 'metrics') ? undefined : json['metrics'].map(MetricFromJSON)
    };
  }

  function PreviewFromJSON(json) {
    return PreviewFromJSONTyped(json);
  }

  function PreviewFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'token': !exists(json, 'token') ? undefined : json['token']
    };
  }

  function PreviewToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'token': value.token
    };
  }

  function ProductFromJSON(json) {
    return ProductFromJSONTyped(json);
  }

  function ProductFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'id': !exists(json, 'id') ? undefined : json['id'],
      'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId']
    };
  }

  function ProductToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'id': value.id,
      'categoryId': value.categoryId
    };
  }

  function PropertyFromJSON(json) {
    return PropertyFromJSONTyped(json);
  }

  function PropertyFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'token': json['token']
    };
  }

  function PropertyToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'token': value.token
    };
  }

  function QAModeFromJSON(json) {
    return QAModeFromJSONTyped(json);
  }

  function QAModeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'token': !exists(json, 'token') ? undefined : json['token'],
      'listedActivitiesOnly': !exists(json, 'listedActivitiesOnly') ? undefined : json['listedActivitiesOnly'],
      'evaluateAsTrueAudienceIds': !exists(json, 'evaluateAsTrueAudienceIds') ? undefined : json['evaluateAsTrueAudienceIds'],
      'evaluateAsFalseAudienceIds': !exists(json, 'evaluateAsFalseAudienceIds') ? undefined : json['evaluateAsFalseAudienceIds'],
      'previewIndexes': !exists(json, 'previewIndexes') ? undefined : json['previewIndexes'].map(QAModePreviewIndexFromJSON)
    };
  }

  function QAModeToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'token': value.token,
      'listedActivitiesOnly': value.listedActivitiesOnly,
      'evaluateAsTrueAudienceIds': value.evaluateAsTrueAudienceIds,
      'evaluateAsFalseAudienceIds': value.evaluateAsFalseAudienceIds,
      'previewIndexes': value.previewIndexes === undefined ? undefined : value.previewIndexes.map(QAModePreviewIndexToJSON)
    };
  }

  function QAModePreviewIndexFromJSON(json) {
    return QAModePreviewIndexFromJSONTyped(json);
  }

  function QAModePreviewIndexFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'activityIndex': !exists(json, 'activityIndex') ? undefined : json['activityIndex'],
      'experienceIndex': !exists(json, 'experienceIndex') ? undefined : json['experienceIndex']
    };
  }

  function QAModePreviewIndexToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'activityIndex': value.activityIndex,
      'experienceIndex': value.experienceIndex
    };
  }

  function RequestDetailsFromJSON(json) {
    return RequestDetailsFromJSONTyped(json, false);
  }

  function RequestDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    if (!ignoreDiscriminator) {
      if (json['$type'] === 'Notification') {
        return NotificationFromJSONTyped(json, true);
      }

      if (json['$type'] === 'MboxRequest') {
        return MboxRequestFromJSONTyped(json, true);
      }

      if (json['$type'] === 'ViewRequest') {
        return ViewRequestFromJSONTyped(json, true);
      }
    }

    return {
      '$type': !exists(json, '$_type') ? undefined : json['$_type'],
      'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
      'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
      'profileParameters': !exists(json, 'profileParameters') ? undefined : json['profileParameters'],
      'order': !exists(json, 'order') ? undefined : OrderFromJSON(json['order']),
      'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product'])
    };
  }

  function RequestDetailsToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      '$_type': value.$type,
      'address': AddressToJSON(value.address),
      'parameters': value.parameters,
      'profileParameters': value.profileParameters,
      'order': OrderToJSON(value.order),
      'product': ProductToJSON(value.product)
    };
  }

  function ScreenFromJSON(json) {
    return ScreenFromJSONTyped(json);
  }

  function ScreenFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'width': !exists(json, 'width') ? undefined : json['width'],
      'height': !exists(json, 'height') ? undefined : json['height'],
      'colorDepth': !exists(json, 'colorDepth') ? undefined : json['colorDepth'],
      'pixelRatio': !exists(json, 'pixelRatio') ? undefined : json['pixelRatio'],
      'orientation': !exists(json, 'orientation') ? undefined : ScreenOrientationTypeFromJSON(json['orientation'])
    };
  }

  function ScreenToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'width': value.width,
      'height': value.height,
      'colorDepth': value.colorDepth,
      'pixelRatio': value.pixelRatio,
      'orientation': ScreenOrientationTypeToJSON(value.orientation)
    };
  }

  var ScreenOrientationType;

  (function (ScreenOrientationType) {
    ScreenOrientationType["Portrait"] = "portrait";
    ScreenOrientationType["Landscape"] = "landscape";
  })(ScreenOrientationType || (ScreenOrientationType = {}));

  function ScreenOrientationTypeFromJSON(json) {
    return ScreenOrientationTypeFromJSONTyped(json);
  }

  function ScreenOrientationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
  }

  function ScreenOrientationTypeToJSON(value) {
    return value;
  }

  function TelemetryFromJSON(json) {
    return TelemetryFromJSONTyped(json);
  }

  function TelemetryFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'entries': !exists(json, 'entries') ? undefined : json['entries'].map(TelemetryEntryFromJSON)
    };
  }

  function TelemetryToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'entries': value.entries === undefined ? undefined : value.entries.map(TelemetryEntryToJSON)
    };
  }

  function TelemetryEntryFromJSON(json) {
    return TelemetryEntryFromJSONTyped(json);
  }

  function TelemetryEntryFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
      'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
      'mode': !exists(json, 'mode') ? undefined : ExecutionModeFromJSON(json['mode']),
      'execution': !exists(json, 'execution') ? undefined : json['execution'],
      'parsing': !exists(json, 'parsing') ? undefined : json['parsing'],
      'features': !exists(json, 'features') ? undefined : TelemetryFeaturesFromJSON(json['features']),
      'request': !exists(json, 'request') ? undefined : TelemetryRequestFromJSON(json['request']),
      'telemetryServerToken': !exists(json, 'telemetryServerToken') ? undefined : json['telemetryServerToken']
    };
  }

  function TelemetryEntryToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'requestId': value.requestId,
      'timestamp': value.timestamp,
      'mode': ExecutionModeToJSON(value.mode),
      'execution': value.execution,
      'parsing': value.parsing,
      'features': TelemetryFeaturesToJSON(value.features),
      'request': TelemetryRequestToJSON(value.request),
      'telemetryServerToken': value.telemetryServerToken
    };
  }

  function TelemetryFeaturesFromJSON(json) {
    return TelemetryFeaturesFromJSONTyped(json);
  }

  function TelemetryFeaturesFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'decisioningMethod': !exists(json, 'decisioningMethod') ? undefined : DecisioningMethodFromJSON(json['decisioningMethod']),
      'executeMboxCount': !exists(json, 'executeMboxCount') ? undefined : json['executeMboxCount'],
      'executePageLoad': !exists(json, 'executePageLoad') ? undefined : json['executePageLoad'],
      'prefetchMboxCount': !exists(json, 'prefetchMboxCount') ? undefined : json['prefetchMboxCount'],
      'prefetchPageLoad': !exists(json, 'prefetchPageLoad') ? undefined : json['prefetchPageLoad'],
      'prefetchViewCount': !exists(json, 'prefetchViewCount') ? undefined : json['prefetchViewCount']
    };
  }

  function TelemetryFeaturesToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'decisioningMethod': DecisioningMethodToJSON(value.decisioningMethod),
      'executeMboxCount': value.executeMboxCount,
      'executePageLoad': value.executePageLoad,
      'prefetchMboxCount': value.prefetchMboxCount,
      'prefetchPageLoad': value.prefetchPageLoad,
      'prefetchViewCount': value.prefetchViewCount
    };
  }

  function TelemetryRequestFromJSON(json) {
    return TelemetryRequestFromJSONTyped(json);
  }

  function TelemetryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'dns': !exists(json, 'dns') ? undefined : json['dns'],
      'tls': !exists(json, 'tls') ? undefined : json['tls'],
      'timeToFirstByte': !exists(json, 'timeToFirstByte') ? undefined : json['timeToFirstByte'],
      'download': !exists(json, 'download') ? undefined : json['download'],
      'responseSize': !exists(json, 'responseSize') ? undefined : json['responseSize']
    };
  }

  function TelemetryRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'dns': value.dns,
      'tls': value.tls,
      'timeToFirstByte': value.timeToFirstByte,
      'download': value.download,
      'responseSize': value.responseSize
    };
  }

  function TraceFromJSON(json) {
    return TraceFromJSONTyped(json);
  }

  function TraceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'authorizationToken': json['authorizationToken'],
      'usage': !exists(json, 'usage') ? undefined : json['usage']
    };
  }

  function TraceToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'authorizationToken': value.authorizationToken,
      'usage': value.usage
    };
  }

  function ViewFromJSON(json) {
    return ViewFromJSONTyped(json);
  }

  function ViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'name': !exists(json, 'name') ? undefined : json['name'],
      'key': !exists(json, 'key') ? undefined : json['key'],
      'options': !exists(json, 'options') ? undefined : json['options'].map(OptionFromJSON),
      'metrics': !exists(json, 'metrics') ? undefined : json['metrics'].map(MetricFromJSON),
      'analytics': !exists(json, 'analytics') ? undefined : AnalyticsResponseFromJSON(json['analytics']),
      'state': !exists(json, 'state') ? undefined : json['state'],
      'trace': !exists(json, 'trace') ? undefined : json['trace']
    };
  }

  function ViewRequestFromJSON(json) {
    return ViewRequestFromJSONTyped(json, false);
  }

  function ViewRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsFromJSONTyped(json, ignoreDiscriminator)), {}, {
      'name': !exists(json, 'name') ? undefined : json['name'],
      'key': !exists(json, 'key') ? undefined : json['key']
    });
  }

  function ViewRequestToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return _objectSpread2(_objectSpread2({}, RequestDetailsToJSON(value)), {}, {
      'name': value.name,
      'key': value.key
    });
  }

  function VisitorIdFromJSON(json) {
    return VisitorIdFromJSONTyped(json);
  }

  function VisitorIdFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'tntId': !exists(json, 'tntId') ? undefined : json['tntId'],
      'thirdPartyId': !exists(json, 'thirdPartyId') ? undefined : json['thirdPartyId'],
      'marketingCloudVisitorId': !exists(json, 'marketingCloudVisitorId') ? undefined : json['marketingCloudVisitorId'],
      'customerIds': !exists(json, 'customerIds') ? undefined : json['customerIds'].map(CustomerIdFromJSON)
    };
  }

  function VisitorIdToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'tntId': value.tntId,
      'thirdPartyId': value.thirdPartyId,
      'marketingCloudVisitorId': value.marketingCloudVisitorId,
      'customerIds': value.customerIds === undefined ? undefined : value.customerIds.map(CustomerIdToJSON)
    };
  }

  function WindowFromJSON(json) {
    return WindowFromJSONTyped(json);
  }

  function WindowFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
      return json;
    }

    return {
      'width': !exists(json, 'width') ? undefined : json['width'],
      'height': !exists(json, 'height') ? undefined : json['height']
    };
  }

  function WindowToJSON(value) {
    if (value === undefined) {
      return undefined;
    }

    if (value === null) {
      return null;
    }

    return {
      'width': value.width,
      'height': value.height
    };
  }

  function OneOfstringobjectarrayFromJSON(value) {
    return value;
  }

  class DeliveryApi extends BaseAPI {
    async executeRaw(requestParameters) {
      if (requestParameters.imsOrgId === null || requestParameters.imsOrgId === undefined) {
        throw new RequiredError('imsOrgId', 'Required parameter requestParameters.imsOrgId was null or undefined when calling execute.');
      }

      if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
        throw new RequiredError('sessionId', 'Required parameter requestParameters.sessionId was null or undefined when calling execute.');
      }

      if (requestParameters.deliveryRequest === null || requestParameters.deliveryRequest === undefined) {
        throw new RequiredError('deliveryRequest', 'Required parameter requestParameters.deliveryRequest was null or undefined when calling execute.');
      }

      const queryParameters = {};

      if (requestParameters.imsOrgId !== undefined) {
        queryParameters['imsOrgId'] = requestParameters.imsOrgId;
      }

      if (requestParameters.sessionId !== undefined) {
        queryParameters['sessionId'] = requestParameters.sessionId;
      }

      if (requestParameters.version !== undefined) {
        queryParameters['version'] = requestParameters.version;
      }

      const headerParameters = {};
      headerParameters['Content-Type'] = 'application/json';
      const response = await this.request({
        path: `/rest/v1/delivery`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: DeliveryRequestToJSON(requestParameters.deliveryRequest)
      });
      return new JSONApiResponse(response, jsonValue => DeliveryResponseFromJSON(jsonValue));
    }

    async execute(imsOrgId, sessionId, deliveryRequest, version) {
      const response = await this.executeRaw({
        imsOrgId: imsOrgId,
        sessionId: sessionId,
        deliveryRequest: deliveryRequest,
        version: version
      });
      return await response.value();
    }

  }

  var name = "@adobe/target-nodejs-sdk";
  var version = "2.4.2";
  var description = "Adobe Target Node.js SDK, Delivery API client";
  var main = "dist/targetclient.server.js";
  var browser = "dist/targetclient.browser.js";
  var module = "src/index.js";
  var engines = {
  	node: ">=8.16.0"
  };
  var files = [
  	"dist/*.js",
  	"src/**/!(*.spec).js",
  	"*.md",
  	"LICENSE*"
  ];
  var publishConfig = {
  	access: "public"
  };
  var scripts = {
  	clean: "rimraf dist",
  	prebuild: "npm run clean && npm run format && npm run lint",
  	build: "NODE_ENV=production rollup -c rollup.config.js",
  	postbuild: "cp dist/targetclient.browser* demo/assets",
  	www: "npm run build && node ./sample/server.js",
  	pretest: "npm run format && npm run lint",
  	test: "NODE_ENV=development jest",
  	coverage: "nyc --reporter=lcov --reporter=text-summary npm run test",
  	"lint-src": "./node_modules/.bin/eslint src/**",
  	"lint-test": "./node_modules/.bin/eslint test/**",
  	lint: "npm run lint-src && npm run lint-test",
  	format: "prettier '**/*.js' '**/*.json' --write --config '../../.prettierrc.json' --ignore-path '../../.prettierignore'",
  	prepack: "for file in `cat packfiles.txt`; do cp \"../../$file\" .; done",
  	postpack: "for file in `cat packfiles.txt`; do rm \"$file\"; done",
  	prepublishOnly: "echo //${NPM_REGISTRY}/:_authToken=${NPM_AUTH_TOKEN} > .npmrc"
  };
  var repository = {
  	type: "git",
  	url: "git@github.com:adobe/target-nodejs-sdk.git"
  };
  var keywords = [
  	"NodeJS",
  	"Server",
  	"API",
  	"Adobe",
  	"Target",
  	"MCID",
  	"Visitor",
  	"Delivery"
  ];
  var author = "Adobe Systems Inc.";
  var license = "Apache-2.0";
  var devDependencies = {
  	"@adobe/target-decisioning-engine": "^1.9.2",
  	"@adobe/target-tools": "^1.7.2",
  	"@babel/plugin-transform-regenerator": "^7.8.3",
  	"@babel/preset-env": "^7.9.5",
  	"@lwc/eslint-plugin-lwc": "^0.10.0",
  	"@rollup/plugin-commonjs": "^11.0.1",
  	"@rollup/plugin-json": "^4.0.1",
  	"@rollup/plugin-node-resolve": "^7.0.0",
  	ajv: "^5.5.2",
  	"cookie-parser": "^1.4.4",
  	"core-js": "^3.6.5",
  	eslint: "^8.24.0",
  	"eslint-config-airbnb-base": "^15.0.0",
  	"eslint-config-prettier": "^8.5.0",
  	"eslint-plugin-import": "^2.26.0",
  	"eslint-plugin-jest": "^27.1.0",
  	"eslint-plugin-prettier": "^4.2.1",
  	express: "^4.17.1",
  	jest: "^26.6.3",
  	"jest-fetch-mock": "^3.0.3",
  	mockdate: "^2.0.5",
  	nyc: "^15.1.0",
  	prettier: "^2.1.2",
  	rimraf: "^3.0.2",
  	rollup: "^1.17.0",
  	"rollup-plugin-babel": "^4.3.3",
  	"rollup-plugin-license": "^2.8.1",
  	"rollup-plugin-visualizer": "^3.3.2"
  };
  var dependencies = {
  	"@adobe-mcid/visitor-js-server": "^2.0.0",
  	"fast-text-encoding": "^1.0.3",
  	"form-data": "^3.0.0",
  	"http-status-codes": "^1.4.0",
  	"whatwg-fetch": "^3.0.0"
  };
  var packageInfo = {
  	name: name,
  	version: version,
  	description: description,
  	main: main,
  	browser: browser,
  	module: module,
  	engines: engines,
  	files: files,
  	publishConfig: publishConfig,
  	scripts: scripts,
  	repository: repository,
  	keywords: keywords,
  	author: author,
  	license: license,
  	devDependencies: devDependencies,
  	dependencies: dependencies
  };

  const SCHEME = {
    HTTP: "http://",
    HTTPS: "https://"
  };
  const AUTH_STATE = {
    0: AuthenticatedState$1.Unknown,
    1: AuthenticatedState$1.Authenticated,
    2: AuthenticatedState$1.LoggedOut
  };
  const EDGE_CLUSTER_PREFIX = "mboxedge";
  const HOST = "tt.omtrdc.net";
  const SESSION_ID_MAX_AGE = 1860;
  const DEVICE_ID_MAX_AGE = 63244800;
  const LOCATION_HINT_MAX_AGE = 1860;
  const PACKAGE_VERSION = packageInfo.version;
  DeliveryApi.prototype.decisioningMethod = DECISIONING_METHOD.SERVER_SIDE;
  function extractClusterFromDeviceId(id) {
    if (isEmptyString(id)) {
      return null;
    }

    const parts = id.split(".");

    if (parts.length !== 2 || !parts[1]) {
      return null;
    }

    const nodeDetails = parts[1].split("_");

    if (nodeDetails.length !== 2 || !nodeDetails[0]) {
      return null;
    }

    return nodeDetails[0];
  }
  function getCluster(deviceId, cluster) {
    return extractClusterFromDeviceId(deviceId) || cluster;
  }
  function getDeviceId(cookies) {
    const cookie = cookies[DEVICE_ID_COOKIE] || {};
    const {
      value
    } = cookie;

    if (isEmptyString(value)) {
      return undefined;
    }

    return value;
  }
  function getSessionId(cookies, userSessionId) {
    let uuidMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : uuid;
    const cookie = cookies[SESSION_ID_COOKIE] || {};
    const {
      value
    } = cookie;

    if (isNonEmptyString(value)) {
      return value;
    }

    if (userSessionId) {
      return userSessionId;
    }

    return uuidMethod();
  }
  function getTargetHost(serverDomain, cluster, client, secure) {
    const schemePrefix = secure === false ? SCHEME.HTTP : SCHEME.HTTPS;

    if (isNonEmptyString(cluster)) {
      return `${schemePrefix}${EDGE_CLUSTER_PREFIX}${cluster}.${HOST}`;
    }

    if (isNonEmptyString(serverDomain)) {
      return `${schemePrefix}${serverDomain}`;
    }

    return `${schemePrefix}${client}.${HOST}`;
  }
  function createHeaders() {
    let uuidMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : uuid;
    return {
      "Content-Type": "application/json",
      "X-EXC-SDK": "AdobeTargetNode",
      "X-EXC-SDK-Version": PACKAGE_VERSION,
      "X-Request-Id": uuidMethod()
    };
  }

  function getMarketingCloudVisitorId(visitor) {
    const visitorValues = visitor.getVisitorValues();
    const {
      MCMID
    } = visitorValues;
    return MCMID;
  }

  function getVisitorCustomerIds(visitor) {
    const visitorState = visitor.getState();
    const firstOrganizationState = visitorState[Object.keys(visitorState)[0]];
    return firstOrganizationState.customerIDs;
  }

  function getCustomerIds(customerIds, visitor) {
    const visitorCustomerIds = getVisitorCustomerIds(visitor);

    if (isEmptyObject(visitorCustomerIds)) {
      return customerIds;
    }

    const convertedIds = Object.keys(visitorCustomerIds).reduce((acc, key) => {
      const value = visitorCustomerIds[key];

      if (value) {
        let item;

        if (isObject$1(value)) {
          item = CustomerIdFromJSON({
            id: value.id || undefined,
            integrationCode: key || undefined,
            authenticatedState: AUTH_STATE[value.authState] || undefined
          });
        } else {
          item = CustomerIdFromJSON({
            id: value,
            integrationCode: key || undefined,
            authenticatedState: AUTH_STATE["0"]
          });
        }

        acc.push(item);
      }

      return acc;
    }, []);

    if (!convertedIds.length) {
      return customerIds;
    }

    return convertedIds.concat(customerIds || []);
  }

  function createVisitorId() {
    let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 ? arguments[1] : undefined;
    const {
      deviceId,
      visitor
    } = options;
    const {
      tntId = deviceId,
      thirdPartyId,
      marketingCloudVisitorId = getMarketingCloudVisitorId(visitor),
      customerIds
    } = id;
    const mergedCustomerIds = getCustomerIds(customerIds, visitor);
    const result = VisitorIdFromJSON({
      tntId: isNonEmptyString(tntId) ? tntId : undefined,
      thirdPartyId: isNonEmptyString(thirdPartyId) ? thirdPartyId : undefined,
      marketingCloudVisitorId: isNonEmptyString(marketingCloudVisitorId) ? marketingCloudVisitorId : undefined,
      customerIds: isNonEmptyArray(mergedCustomerIds) ? mergedCustomerIds : undefined
    });
    return isNonEmptyObject(result) ? result : undefined;
  }

  function createContext() {
    let context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const result = ContextFromJSON(_objectSpread2({
      timeOffsetInMinutes: getTimezoneOffset()
    }, context));

    if (Object.keys(ChannelType$1).includes(result.channel)) {
      return context;
    }

    result.channel = ChannelType$1.Web;
    return result;
  }

  function isCurrentSupplementalDataID(supplementalDataId, visitor) {
    const visitorState = visitor.getState();
    const firstOrganizationState = visitorState[Object.keys(visitorState)[0]];
    return isNonEmptyObject(firstOrganizationState.sdid) && firstOrganizationState.sdid.supplementalDataIDCurrent === supplementalDataId;
  }

  function createSupplementalDataId(analytics, options) {
    const {
      visitor,
      consumerId = DEFAULT_GLOBAL_MBOX
    } = options;
    const {
      supplementalDataId
    } = analytics;

    if (isCurrentSupplementalDataID(supplementalDataId, visitor)) {
      return supplementalDataId;
    }

    return visitor.getSupplementalDataID(consumerId);
  }

  function createAnalytics() {
    let analytics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 ? arguments[1] : undefined;
    return AnalyticsRequestFromJSON({
      logging: isNonEmptyString(analytics.logging) ? analytics.logging : LoggingType.ServerSide,
      supplementalDataId: createSupplementalDataId(analytics, options),
      trackingServer: isNonEmptyString(analytics.trackingServer) ? analytics.trackingServer : undefined,
      trackingServerSecure: isNonEmptyString(analytics.trackingServerSecure) ? analytics.trackingServerSecure : undefined
    });
  }

  function getLocationHint(locationHintString) {
    const hintNumber = parseInt(locationHintString, 10);
    return !isNaN(hintNumber) ? hintNumber : undefined; // eslint-disable-line no-restricted-globals
  }

  function createAudienceManager() {
    let audienceManager = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 ? arguments[1] : undefined;
    const {
      visitor
    } = options;
    const visitorValues = visitor.getVisitorValues() || {};
    const {
      locationHint = getLocationHint(visitorValues.MCAAMLH),
      blob = visitorValues.MCAAMB
    } = audienceManager;
    const result = AudienceManagerFromJSON({
      locationHint,
      blob
    });
    return isNonEmptyObject(result) ? result : undefined;
  }

  function createExperienceCloud() {
    let experienceCloud = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 ? arguments[1] : undefined;
    const {
      analytics,
      audienceManager
    } = experienceCloud;
    const createdAudienceManager = createAudienceManager(audienceManager, options);
    return ExperienceCloudFromJSON({
      analytics: createAnalytics(analytics, options),
      audienceManager: createdAudienceManager || undefined
    });
  }

  const validMbox = (mbox, logger) => {
    const result = isNonEmptyObject(mbox) && isNonEmptyString(mbox.name);

    if (!result) {
      logger.error(Messages$1.MBOX_INVALID, mbox);
    }

    return result;
  };

  function createMboxes(mboxes, logger) {
    if (isEmptyArray(mboxes)) {
      return undefined;
    }

    const resultMboxes = mboxes.filter(mbox => validMbox(mbox, logger)).map((mbox, index) => {
      const result = MboxRequestFromJSON(mbox);
      result.name = mbox.name;

      if (isNumber(mbox.index)) {
        result.index = mbox.index;
      } else {
        result.index = index;
      }

      return result;
    });
    return isNonEmptyArray(resultMboxes) ? resultMboxes : undefined;
  }

  function createViews(views) {
    if (isEmptyArray(views)) {
      return undefined;
    }

    const resultViews = views.map(view => {
      const result = ViewRequestFromJSON(view);

      if (isNonEmptyString(view.name)) {
        result.name = view.name;
      }

      if (isNonEmptyString(view.key)) {
        result.key = view.key;
      }

      return result;
    });
    return isNonEmptyArray(resultViews) ? resultViews : undefined;
  }

  function createExecute(execute, logger) {
    if (isEmptyObject(execute)) {
      return undefined;
    }

    const {
      pageLoad,
      mboxes
    } = execute;

    if (!isObject$1(pageLoad) && isEmptyArray(mboxes)) {
      return undefined;
    }

    return new ExecuteRequestFromJSON({
      pageLoad: isObject$1(pageLoad) ? RequestDetailsFromJSON(pageLoad) : undefined,
      mboxes: isNonEmptyArray(mboxes) ? createMboxes(mboxes, logger) : undefined
    });
  }

  function createPrefetch(prefetch, logger) {
    if (isEmptyObject(prefetch)) {
      return undefined;
    }

    const {
      pageLoad,
      views,
      mboxes
    } = prefetch;

    if (!isObject$1(pageLoad) && isEmptyArray(views) && isEmptyArray(mboxes)) {
      return undefined;
    }

    return PrefetchRequestFromJSON({
      pageLoad: isObject$1(pageLoad) ? RequestDetailsFromJSON(pageLoad) : undefined,
      views: isNonEmptyArray(views) ? createViews(views) : undefined,
      mboxes: isNonEmptyArray(mboxes) ? createMboxes(mboxes, logger) : undefined
    });
  }

  const validNotification = (notification, logger) => {
    const result = isNonEmptyObject(notification) && isNonEmptyString(notification.id) && isNumber(notification.timestamp) && Object.values(MetricType$1).includes(notification.type);

    if (!result) {
      logger.error(Messages$1.NOTIFICATION_INVALID, notification);
    }

    return result;
  };

  function createNotifications(notifications, logger) {
    if (isEmptyArray(notifications)) {
      return undefined;
    }

    const resultNotifications = notifications.filter(notification => validNotification(notification, logger)).map(notification => {
      const {
        id,
        type,
        timestamp,
        impressionId,
        tokens,
        mbox,
        view
      } = notification;
      const result = NotificationFromJSON(notification);
      result.id = id;
      result.type = type;
      result.timestamp = timestamp;

      if (isNonEmptyString(impressionId)) {
        result.impressionId = impressionId;
      }

      if (isNonEmptyArray(tokens)) {
        result.tokens = tokens;
      }

      if (isNonEmptyObject(mbox)) {
        result.mbox = mbox;
      }

      if (isNonEmptyObject(view)) {
        result.view = view;
      }

      return result;
    });
    return isNonEmptyArray(resultNotifications) ? resultNotifications : undefined;
  }

  function createProperty() {
    let property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      token
    } = property;

    if (isNonEmptyString(token)) {
      return PropertyFromJSON(property);
    }

    return undefined;
  }
  /**
   *
   * @param requestParam
   * @param options
   * @return { import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest }
   */


  function createDeliveryRequest(requestParam, options) {
    const {
      logger,
      uuidMethod = uuid
    } = options;
    const result = DeliveryRequestFromJSON(_objectSpread2({
      requestId: uuidMethod(),
      environmentId: options.environmentId
    }, requestParam));
    result.id = createVisitorId(result.id, options);
    result.property = createProperty(result.property);
    result.trace = TraceFromJSON(result.trace);
    result.context = createContext(result.context);
    result.experienceCloud = createExperienceCloud(result.experienceCloud, options);
    result.execute = createExecute(result.execute, logger);
    result.prefetch = createPrefetch(result.prefetch, logger);
    result.notifications = createNotifications(result.notifications, logger);
    removeEmptyKeys(result);
    return result;
  }
  /**
   *
   * @param fetchApi
   * @param host
   * @param headers
   * @param timeout
   * @return { import("@adobe/target-tools/delivery-api-client/runtime").Configuration }
   */

  function createConfiguration(fetchApi, host, headers, timeout) {
    return new Configuration({
      basePath: host,
      fetchApi,
      headers,
      timeout
    });
  }

  function createLocalDeliveryApi(decisioningEngine, visitor, targetLocationHint) {
    const localDeliveryApi = {
      // eslint-disable-next-line no-unused-vars
      execute: (organizationId, sessionId, deliveryRequest, atjsVersion) => {
        if (isUndefined(decisioningEngine)) {
          return Promise.reject(new Error(DECISIONING_ENGINE_NOT_READY));
        }

        return decisioningEngine.getOffers({
          targetLocationHint,
          request: deliveryRequest,
          sessionId,
          visitor
        });
      },
      decisioningMethod: DECISIONING_METHOD.ON_DEVICE
    };

    localDeliveryApi.withPostMiddleware = () => localDeliveryApi;

    return localDeliveryApi;
  }

  function createBeaconDeliveryApi(configuration) {
    return {
      execute: (organizationId, sessionId, deliveryRequest, atjsVersion) => {
        const query = {
          imsOrgId: organizationId,
          sessionId
        };

        if (isDefined(configuration.version)) {
          query.version = atjsVersion;
        }

        const queryString = configuration.queryParamsStringify(query);
        const success = executeSendBeacon(`${configuration.basePath}/rest/v1/delivery?${queryString}`, JSON.stringify(_objectSpread2(_objectSpread2({}, deliveryRequest), {}, {
          context: _objectSpread2(_objectSpread2({}, deliveryRequest.context), {}, {
            beacon: true
          })
        })));
        return success ? Promise.resolve() : Promise.reject();
      },
      decisioningMethod: DECISIONING_METHOD.SERVER_SIDE
    };
  }

  function createRemoteDeliveryApi(configuration, useBeacon) {
    return useBeacon && isBeaconSupported() ? createBeaconDeliveryApi(configuration) : new DeliveryApi(configuration);
  }
  /**
   * @param {import("@adobe/target-tools/delivery-api-client/runtime").Configuration} configuration
   * @param visitor VisitorId instance
   * @param { Boolean } useBeacon
   * @param decisioningMethod
   * @param { String } targetLocationHint
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} deliveryRequest
   * @param decisioningEngine
   * */


  function createDeliveryApi(configuration, visitor) {
    let useBeacon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let decisioningMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DECISIONING_METHOD.SERVER_SIDE;
    let targetLocationHint = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    let deliveryRequest = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    let decisioningEngine = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

    if (requiresDecisioningEngine(decisioningMethod)) {
      const decisioningDependency = decisioningEngine.hasRemoteDependency(deliveryRequest);

      if (decisioningMethod === DECISIONING_METHOD.HYBRID && decisioningDependency.remoteNeeded) {
        return createRemoteDeliveryApi(configuration, useBeacon);
      }

      return createLocalDeliveryApi(decisioningEngine, visitor, targetLocationHint);
    }

    return createRemoteDeliveryApi(configuration, useBeacon);
  }

  function getTargetCookie(sessionId, id) {
    const nowInSeconds = Math.ceil(Date.now() / 1000);
    const cookies = [];
    const {
      tntId
    } = id;
    cookies.push({
      name: SESSION_ID_COOKIE,
      value: sessionId,
      expires: nowInSeconds + SESSION_ID_MAX_AGE
    });

    if (tntId) {
      cookies.push({
        name: DEVICE_ID_COOKIE,
        value: tntId,
        expires: nowInSeconds + DEVICE_ID_MAX_AGE
      });
    }

    return createTargetCookie(cookies);
  }

  function extractClusterFromEdgeHost(host) {
    if (isEmptyString(host)) {
      return null;
    }

    const parts = host.split(".");

    if (parts.length !== 4 || !parts[0]) {
      return null;
    }

    return parts[0].replace(EDGE_CLUSTER_PREFIX, "");
  }

  function getTargetLocationHintCookie(requestCluster, edgeHost) {
    const hostCluster = extractClusterFromEdgeHost(edgeHost);
    const cluster = requestCluster || hostCluster;

    if (isEmptyString(cluster)) {
      return undefined;
    }

    return {
      name: LOCATION_HINT_COOKIE,
      value: cluster,
      maxAge: LOCATION_HINT_MAX_AGE
    };
  }
  function requestLocationHintCookie(targetClient, targetLocationHint) {
    return isDefined(targetLocationHint) ? Promise.resolve({
      targetLocationHintCookie: getTargetLocationHintCookie(targetLocationHint)
    }) : targetClient.getOffers({
      sessionId: "ping123",
      decisioningMethod: DECISIONING_METHOD.SERVER_SIDE,
      request: EMPTY_REQUEST
    }).catch(() => new Error(Messages$1.LOCATION_HINT_REQUEST_FAILED));
  }
  function preserveLocationHint(response) {
    if (isDefined(response.targetLocationHintCookie)) {
      this.config.targetLocationHint = response.targetLocationHintCookie.value;
    }

    return response;
  }

  function getAnalyticsFromObject() {
    let object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      analytics
    } = object;
    return isNonEmptyObject(analytics) ? [analytics] : undefined;
  }

  function getAnalyticsFromArray() {
    let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return flatten$1(array.map(getAnalyticsFromObject));
  }

  function getAnalyticsDetails(response) {
    const {
      execute = {},
      prefetch = {}
    } = response;

    if (isEmptyObject(execute) && isEmptyObject(prefetch)) {
      return undefined;
    }

    const executePageLoadAnalytics = getAnalyticsFromObject(execute.pageLoad);
    const executeMboxAnalytics = getAnalyticsFromArray(execute.mboxes);
    const prefetchPageLoadAnalytics = getAnalyticsFromObject(prefetch.pageLoad);
    const prefetchViewsAnalytics = getAnalyticsFromArray(prefetch.views);
    const prefetchMboxAnalytics = getAnalyticsFromArray(prefetch.mboxes);
    const result = flatten$1([executePageLoadAnalytics, executeMboxAnalytics, prefetchPageLoadAnalytics, prefetchViewsAnalytics, prefetchMboxAnalytics].filter(value => !!value));
    return isNonEmptyArray(result) ? result : undefined;
  }
  /**
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} request Target Delivery API request, required
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryResponse").DeliveryResponse} response Target Delivery API response, required
   * @param decisioningMethod
   * @param decisioningEngine
   * */


  function getResponseMeta(request, response, decisioningMethod, decisioningEngine) {
    let {
      remoteMboxes = [],
      remoteViews = []
    } = response;
    delete response.remoteMboxes;
    delete response.remoteViews;

    if (decisioningEngine) {
      const decisioningDependency = decisioningEngine.hasRemoteDependency(request); // eslint-disable-next-line prefer-destructuring

      remoteMboxes = decisioningDependency.remoteMboxes; // eslint-disable-next-line prefer-destructuring

      remoteViews = decisioningDependency.remoteViews;
    }

    return {
      decisioningMethod,
      remoteMboxes,
      remoteViews
    };
  }

  function getTraceFromObject() {
    let object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      trace
    } = object;
    return isNonEmptyObject(trace) ? [trace] : undefined;
  }

  function getTraceFromArray() {
    let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return flatten$1(array.map(getTraceFromObject));
  }

  function getTraceDetails(response) {
    const {
      execute = {},
      prefetch = {}
    } = response;

    if (isEmptyObject(execute) && isEmptyObject(prefetch)) {
      return undefined;
    }

    const executePageLoadTrace = getTraceFromObject(execute.pageLoad);
    const executeMboxTrace = getTraceFromArray(execute.mboxes);
    const prefetchPageLoadTrace = getTraceFromObject(prefetch.pageLoad);
    const prefetchViewsTrace = getTraceFromArray(prefetch.views);
    const prefetchMboxTrace = getTraceFromArray(prefetch.mboxes);
    const result = flatten$1([executePageLoadTrace, executeMboxTrace, prefetchPageLoadTrace, prefetchViewsTrace, prefetchMboxTrace].filter(value => !!value));
    return isNonEmptyArray(result) ? result : undefined;
  }

  function getResponseTokensFromObject() {
    let object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      options
    } = object;

    if (isEmptyArray(options)) {
      return [];
    }

    return options.map(option => option.responseTokens).filter(isNonEmptyObject);
  }

  function getResponseTokensFromArray() {
    let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return flatten$1(array.map(getResponseTokensFromObject));
  }

  function getResponseTokens(response) {
    const {
      execute = {},
      prefetch = {}
    } = response;

    if (isEmptyObject(execute) && isEmptyObject(prefetch)) {
      return undefined;
    }

    const executePageLoadTokens = getResponseTokensFromObject(execute.pageLoad);
    const executeMboxTokens = getResponseTokensFromArray(execute.mboxes);
    const prefetchPageLoadTokens = getResponseTokensFromObject(prefetch.pageLoad);
    const prefetchViewsTokens = getResponseTokensFromArray(prefetch.views);
    const prefetchMboxTokens = getResponseTokensFromArray(prefetch.mboxes);
    const result = flatten$1([executePageLoadTokens, executeMboxTokens, prefetchPageLoadTokens, prefetchViewsTokens, prefetchMboxTokens]);
    return isNonEmptyArray(result) ? result : undefined;
  }
  /**
   * processResponse method
   * @param { string } sessionId
   * @param { string } cluster
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} request Target Delivery API request
   * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryResponse").DeliveryResponse} response Target Delivery API response
   * @param {('on-device'|'server-side'|'hybrid')} decisioningMethod
   * @param { Object } decisioningEngine
   */


  function processResponse(sessionId, cluster, request, response) {
    let decisioningMethod = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DECISIONING_METHOD.SERVER_SIDE;
    let decisioningEngine = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    const {
      id = {},
      edgeHost
    } = response;
    const result = {
      targetCookie: getTargetCookie(sessionId, id),
      targetLocationHintCookie: getTargetLocationHintCookie(cluster, edgeHost),
      analyticsDetails: getAnalyticsDetails(response),
      trace: getTraceDetails(response),
      responseTokens: getResponseTokens(response),
      meta: getResponseMeta(request, response, decisioningMethod, decisioningEngine),
      response
    };
    removeEmptyKeys(result);
    return result;
  }

  /* eslint-disable import/prefer-default-export */
  function executeDelivery(options, telemetryProvider, decisioningEngine) {
    const {
      visitor,
      config,
      logger,
      targetCookie,
      consumerId,
      request,
      useBeacon,
      createDeliveryApiMethod = createDeliveryApi
    } = options;
    const property = getProperty(config, request, logger);

    if (isDefined(property)) {
      request.property = property;
    }

    const {
      serverDomain,
      client,
      organizationId,
      timeout,
      secure,
      environmentId
    } = config;
    let {
      decisioningMethod
    } = config;
    const fetchWithRetry = getFetchWithRetry(config.fetchApi);
    const targetLocationHint = options.targetLocationHint || config.targetLocationHint;

    if (requiresDecisioningEngine(decisioningMethod) && !decisioningEngineReady(decisioningEngine)) {
      // fulfill the request remotely if hybrid execution mode and decisioning engine is unavailable
      if (decisioningMethod === DECISIONING_METHOD.HYBRID) {
        decisioningMethod = DECISIONING_METHOD.SERVER_SIDE;
      } else {
        return Promise.reject(new Error(DECISIONING_ENGINE_NOT_READY));
      }
    }

    const cookies = parseCookies(targetCookie);
    const deviceId = getDeviceId(cookies);
    const cluster = getCluster(deviceId, targetLocationHint);
    const host = getTargetHost(serverDomain, cluster, client, secure);
    const sessionId = getSessionId(cookies, options.sessionId);
    const headers = createHeaders();
    const requestOptions = {
      logger,
      visitor,
      deviceId,
      consumerId,
      environmentId,
      organizationId
    };
    let deliveryRequest = createDeliveryRequest(request, requestOptions);
    const configuration = createConfiguration(fetchWithRetry, host, headers, timeout);
    const deliveryMethod = createDeliveryApiMethod(configuration, visitor, useBeacon, decisioningMethod, targetLocationHint, deliveryRequest, decisioningEngine);

    if (deliveryMethod.decisioningMethod === DECISIONING_METHOD.SERVER_SIDE) {
      deliveryRequest = telemetryProvider.addTelemetryToDeliveryRequest(deliveryRequest);
    }

    logger.debug(Messages$1.REQUEST_SENT, deliveryMethod.decisioningMethod, host, JSON.stringify(deliveryRequest, null, 2));
    perfTool.timeStart(deliveryRequest.requestId);
    let timings;

    function collectRequestTimings(httpResponse) {
      const {
        response
      } = httpResponse;
      timings = response.timings;
    }

    return deliveryMethod.withPostMiddleware(collectRequestTimings).execute(organizationId, sessionId, deliveryRequest, config.version).then(function () {
      let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const executionTime = perfTool.timeEnd(deliveryRequest.requestId);
      perfTool.clearTiming(deliveryRequest.requestId);
      logger.debug(Messages$1.RESPONSE_RECEIVED, JSON.stringify(response, null, 2));
      const entry = {
        execution: executionTime
      };

      if (timings) {
        entry.parsing = timings.parsingTime;
        delete timings.parsingTime;
        entry.request = timings;
      }

      if (response.telemetryServerToken) {
        entry.telemetryServerToken = response.telemetryServerToken;
      }

      telemetryProvider.addDeliveryRequestEntry(deliveryRequest, entry, response, deliveryMethod.decisioningMethod);
      return Object.assign({
        visitorState: visitor.getState(),
        request: deliveryRequest
      }, processResponse(sessionId, cluster, deliveryRequest, response, deliveryMethod.decisioningMethod, decisioningEngine));
    });
  }

  /*
  Copyright 2019 Adobe. All rights reserved.
  This file is licensed to you under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License. You may obtain a copy
  of the License at http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed under
  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
  OF ANY KIND, either express or implied. See the License for the specific language
  governing permissions and limitations under the License.
  */
  function validateClientOptions(options) {
    if (isEmptyObject(options)) {
      return Messages$1.OPTIONS_REQUIRED;
    }

    const {
      client,
      organizationId,
      decisioningMethod
    } = options;

    if (isEmptyString(client)) {
      return Messages$1.CLIENT_REQUIRED;
    }

    if (isEmptyString(organizationId)) {
      return Messages$1.ORG_ID_REQUIRED;
    }

    if (isDefined(decisioningMethod) && !Object.values(DECISIONING_METHOD).includes(decisioningMethod)) {
      return Messages$1.DECISIONING_METHOD_INVALID;
    }

    return null;
  }
  function validateGetOffersOptions(options) {
    if (isEmptyObject(options)) {
      return Messages$1.OPTIONS_REQUIRED;
    }

    const {
      request
    } = options;

    if (isEmptyObject(request)) {
      return Messages$1.REQUEST_REQUIRED;
    }

    const {
      execute,
      prefetch
    } = request;

    if (isNonEmptyObject(execute) && isUndefined(execute.pageLoad) && isEmptyArray(execute.mboxes)) {
      return Messages$1.EXECUTE_FIELDS_REQUIRED;
    }

    if (isNonEmptyObject(prefetch) && isUndefined(prefetch.pageLoad) && isEmptyArray(prefetch.views) && isEmptyArray(prefetch.mboxes)) {
      return Messages$1.PREFETCH_FIELDS_REQUIRED;
    }

    return null;
  }
  function validateSendNotificationsOptions(options, hasTelemetries) {
    if (isEmptyObject(options)) {
      return Messages$1.OPTIONS_REQUIRED;
    }

    const {
      request
    } = options;

    if (isEmptyObject(request)) {
      return Messages$1.REQUEST_REQUIRED;
    }

    const {
      notifications
    } = request;

    if (isEmptyArray(notifications) && !hasTelemetries) {
      return NOTIFICATIONS_REQUIRED;
    }

    return null;
  }

  /* eslint-disable import/prefer-default-export */
  const CLIENT_READY = "clientReady";

  const AMCV_PREFIX = "AMCV_";
  const DEFAULT_TIMEOUT$1 = 3000;
  function bootstrap(fetchApi) {
    const fetchImpl = getFetchApi(fetchApi);

    if (!fetchImpl) {
      throw new Error(Messages$1.FETCH_UNDEFINED);
    }

    class TargetClient {
      constructor(options) {
        if (!options || !options.internal) {
          throw new Error(Messages$1.PRIVATE_CONSTRUCTOR);
        }

        this.config = options;
        this.config.timeout = options.timeout || DEFAULT_TIMEOUT$1;
        this.logger = getLogger(options.logger);
        this.telemetryProvider = TelemetryProvider(options.telemetryEnabled, options.decisioningMethod);
        const eventEmitter = EventProvider(this.config.events).emit;

        if (requiresDecisioningEngine(options.decisioningMethod)) {
          Promise.all([requestLocationHintCookie(this, this.config.targetLocationHint), TargetDecisioningEngine({
            client: options.client,
            organizationId: options.organizationId,
            pollingInterval: options.pollingInterval,
            maximumWaitReady: options.maximumWaitReady,
            artifactFormat: options.artifactFormat,
            artifactLocation: options.artifactLocation,
            artifactPayload: options.artifactPayload,
            propertyToken: options.propertyToken,
            environment: options.environment,
            cdnEnvironment: options.cdnEnvironment,
            cdnBasePath: options.cdnBasePath,
            logger: this.logger,
            telemetryEnabled: options.telemetryEnabled,
            fetchApi: fetchImpl,
            eventEmitter,
            sendNotificationFunc: notificationOptions => this.sendNotifications(notificationOptions),
            parseDomainImpl: parseDomainPsl
          }, this.telemetryProvider)]) // eslint-disable-next-line no-unused-vars
          .then(_ref => {
            let [locationHintResponse, decisioningEngine] = _ref;
            this.decisioningEngine = decisioningEngine;
            eventEmitter(CLIENT_READY);
          }).catch(err => {
            this.logger.error(err.message);
          });
        } else {
          setTimeout(() => eventEmitter(CLIENT_READY), 100);
        }
      }
      /**
       * The TargetClient creation factory method
       * @param {Object} options Options map, required
       * @param {Function }options.fetchApi Fetch Implementation, optional
       * @param {String} options.client Target Client Id, required
       * @param {String} options.organizationId Target Organization Id, required
       * @param {Number} options.timeout Target request timeout in ms, default: 3000
       * @param {String} options.serverDomain Server domain, optional
       * @param {String} options.targetLocationHint Target Location Hint, optional
       * @param {boolean} options.secure Unset to enforce HTTP scheme, default: true
       * @param {Object} options.logger Replaces the default noop logger, optional
       * @param {('on-device'|'server-side'|'hybrid')} options.decisioningMethod The decisioning method, defaults to remote, optional
       * @param {Number} options.pollingInterval (Local Decisioning) Polling interval in ms, default: 30000
       * @param {Number} options.maximumWaitReady (Local Decisioning) The maximum amount of time (in ms) to wait for clientReady.  Default is to wait indefinitely.
       * @param {String} options.artifactLocation (Local Decisioning) Fully qualified url to the location of the artifact, optional
       * @param {import("@adobe/target-decisioning-engine/types/DecisioningArtifact").DecisioningArtifact} options.artifactPayload (Local Decisioning) A pre-fetched artifact, optional
       * @param {Number} options.environmentId The Target environment ID, defaults to production, optional
       * @param {String} options.environment The Target environment name, defaults to production, optional
       * @param {String} options.cdnEnvironment The CDN environment name, defaults to production, optional
       * @param {boolean} options.telemetryEnabled If set to false, telemetry data will not be sent to Adobe
       * @param {String} options.version The version number of at.js, optional
       * @param {String} options.propertyToken A property token used to limit the scope of evaluated target activities, optional
       * @param {Object.<String, Function>} options.events An object with event name keys and callback function values, optional
       */


      static create(options) {
        const error = validateClientOptions(options);

        if (error) {
          throw new Error(error);
        }

        return new TargetClient(Object.assign({
          internal: true,
          decisioningMethod: DECISIONING_METHOD.SERVER_SIDE,
          fetchApi: fetchImpl
        }, options));
      }
      /**
       * The TargetClient getOffers method
       * @param {Object} options
       * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} options.request Target View Delivery API request, required
       * @param {String} options.visitorCookie VisitorId cookie, optional
       * @param {String} options.targetCookie Target cookie, optional
       * @param {String} options.targetLocationHint Target Location Hint, optional
       * @param {String} options.consumerId When stitching multiple calls, different consumerIds should be provided, optional
       * @param {Array}  options.customerIds An array of Customer Ids in VisitorId-compatible format, optional
       * @param {String} options.sessionId Session Id, used for linking multiple requests, optional
       * @param {Object} options.visitor Supply an external VisitorId instance, optional
       * @param {('on-device'|'server-side'|'hybrid')} options.decisioningMethod The execution mode, defaults to remote, optional
       * @returns Promise<TargetDeliveryResponse>
       */


      getOffers(options) {
        const error = validateGetOffersOptions(options);

        if (error) {
          return Promise.reject(new Error(error));
        }

        const visitor = createVisitor(options, this.config);
        const targetOptions = Object.assign({
          visitor,
          config: _objectSpread2(_objectSpread2({}, this.config), {}, {
            decisioningMethod: options.decisioningMethod || this.config.decisioningMethod
          }),
          logger: this.logger
        }, options);
        return executeDelivery(targetOptions, this.telemetryProvider, this.decisioningEngine).then(preserveLocationHint.bind(this));
      }
      /**
       * The TargetClient getAttributes method
       * @param {Array<String>} mboxNames A list of mbox names that contains JSON content attributes, required
       * @param {Object} options, required
       * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} options.request Target View Delivery API request, required
       * @param {String} options.visitorCookie VisitorId cookie, optional
       * @param {String} options.targetCookie Target cookie, optional
       * @param {String} options.targetLocationHint Target Location Hint, optional
       * @param {String} options.consumerId When stitching multiple calls, different consumerIds should be provided, optional
       * @param {Array}  options.customerIds An array of Customer Ids in VisitorId-compatible format, optional
       * @param {String} options.sessionId Session Id, used for linking multiple requests, optional
       * @param {Object} options.visitor Supply an external VisitorId instance, optional
       * @param {('on-device'|'server-side'|'hybrid')} options.decisioningMethod The execution mode, defaults to remote, optional
       */


      getAttributes(mboxNames) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // eslint-disable-next-line no-param-reassign
        options.request = options.request || EMPTY_REQUEST;
        return this.getOffers(_objectSpread2(_objectSpread2({}, options), {}, {
          request: addMboxesToRequest(mboxNames, options.request, "execute")
        })).then(res => AttributesProvider(res));
      }
      /**
       * The TargetClient sendNotifications method
       * @param {Object} options
       * @param {import("@adobe/target-tools/delivery-api-client/models/DeliveryRequest").DeliveryRequest} options.request Target View Delivery API request, required
       * @param {String} options.visitorCookie VisitorId cookie, optional
       * @param {String} options.targetCookie Target cookie, optional
       * @param {String} options.targetLocationHint Target Location Hint, optional
       * @param {String} options.consumerId When stitching multiple calls, different consumerIds should be provided, optional
       * @param {Array}  options.customerIds An array of Customer Ids in VisitorId-compatible format, optional
       * @param {String} options.sessionId Session Id, used for linking multiple requests, optional
       * @param {Object} options.visitor Supply an external VisitorId instance, optional
       */


      sendNotifications(options) {
        const error = validateSendNotificationsOptions(options, this.telemetryProvider.hasEntries());

        if (error) {
          return Promise.reject(new Error(error));
        }

        const visitor = createVisitor(options, this.config);

        const targetOptions = _objectSpread2({
          visitor,
          config: _objectSpread2(_objectSpread2({}, this.config), {}, {
            decisioningMethod: DECISIONING_METHOD.SERVER_SIDE // execution mode for sending notifications must always be remote

          }),
          logger: this.logger,
          useBeacon: true
        }, options);

        return executeDelivery(targetOptions, this.telemetryProvider).then(preserveLocationHint.bind(this));
      }

      static getVisitorCookieName(orgId) {
        return AMCV_PREFIX + orgId;
      }

      static get TargetCookieName() {
        return TARGET_COOKIE;
      }

      static get TargetLocationHintCookieName() {
        return LOCATION_HINT_COOKIE;
      }

      static get AuthState() {
        return Visitor.AuthState;
      }

    }

    return TargetClient;
  }

  const TargetClient = bootstrap( // eslint-disable-next-line no-undef
  isDefined(window.fetch) ? // eslint-disable-next-line no-undef
  window.fetch.bind(window) : fetch);

  return TargetClient;

})));
//# sourceMappingURL=targetclient.browser.js.map


/***/ }),

/***/ 82786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// npm-package/index.ts
var npm_package_exports = {};
__export(npm_package_exports, {
  AppFeatures: () => AppFeatures,
  createPostMessageHandlers: () => createPostMessageHandlers,
  devAppConfig: () => devAppConfig,
  devConfig: () => devConfig,
  devMainWebviewTitlesRecord: () => devMainWebviewTitlesRecord,
  devWebviewSheetTitlesRecord: () => devWebviewSheetTitlesRecord,
  getDevMainWebviewTitle: () => getDevMainWebviewTitle,
  getDevWebviewSheetTitle: () => getDevWebviewSheetTitle,
  getProdMainWebviewTitle: () => getProdMainWebviewTitle,
  getProdWebviewSheetTitle: () => getProdWebviewSheetTitle,
  prodAppConfig: () => prodAppConfig,
  prodConfig: () => prodConfig,
  prodMainWebviewTitlesRecord: () => prodMainWebviewTitlesRecord,
  prodWebviewSheetTitlesRecord: () => prodWebviewSheetTitlesRecord,
  schemas: () => schemas,
  sendPostMessage: () => sendPostMessage,
  zDynamicConfig: () => zDynamicConfig,
  zMainWebviewTitleKeys: () => zMainWebviewTitleKeys,
  zMainWebviewTitles: () => zMainWebviewTitles,
  zSaleConfig: () => zSaleConfig,
  zWebviewSheetTitleKeys: () => zWebviewSheetTitleKeys,
  zWebviewSheetTitles: () => zWebviewSheetTitles
});
module.exports = __toCommonJS(npm_package_exports);

// src/env/dev/app-config.json
var app_config_default = {
  aprValue: "11.4",
  ios: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  android: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  mainWebviewLoggedInURLs: [
    "/checkout/bank-payment/",
    "/checkout/car-care/",
    "/checkout/card-details/",
    "/checkout/confirmation/",
    "/checkout/delivery/",
    "/checkout/editable-customer-info/",
    "/checkout/finance-application-approved/",
    "/checkout/finance-application-decision/",
    "/checkout/finance-application-offer/",
    "/checkout/finance-application-outgoings/",
    "/checkout/finance-application-review/",
    "/checkout/finance-bank-details/",
    "/checkout/finance-cant-apply/",
    "/checkout/finance-current-address/",
    "/checkout/finance-employment-history/",
    "/checkout/finance-offer-amends/",
    "/checkout/finance-personal-details/",
    "/checkout/finance/",
    "/checkout/id-verification/",
    "/checkout/part-exchange",
    "/checkout/payment/",
    "/checkout/personal-details/",
    "/checkout/settlement-letter-upload/",
    "/checkout/verify-email/"
  ],
  mainWebviewLoggedOutURLs: [
    "/car-finance/check-eligibility",
    "/checkout/your-order/",
    "/compare-cars",
    "/find-vehicle",
    "/help-me-choose/body-types",
    "/help-me-choose/car-makes",
    "/help-me-choose/most-important",
    "/help-me-choose/passengers",
    "/help-me-choose/price-range",
    "/help-me-choose/recommendations",
    "/offers",
    "/part-exchange/calculator",
    "/used-cars/",
    "/used-cars"
  ],
  webviewSheetURLs: [
    "/car-collections",
    "/car-finance",
    "/cars-near-me/collection-location",
    "/cinch-care",
    "/cinch-care/servicing",
    "/cinch-care/warranty-information",
    "/cinch-shield",
    "/cinchshield-lifeshine-guarantee",
    "/delivery",
    "/finance/Cinch_IDD",
    "/finance/hp-explanation",
    "/finance/pcp-explanation",
    "/part-exchange",
    "/policies/terms-and-conditions",
    "/post/ulez-explained-by-cinch",
    "/returns",
    "/sign-up",
    "/terms-and-conditions",
    "/which-car-should-i-buy"
  ],
  inAppBrowserHosts: [
    "trial.bonafidee.com",
    "secure.bonafidee.com",
    "web.evolutionfunding.com",
    "www.evolutionfunding.com",
    "evolutionfunding.com",
    "sandbox.evolutionfunding.com",
    "public.evolutionfunding.com",
    "www.blackhorse.co.uk",
    "www.google.com",
    "google.com",
    "bonafidee.com",
    "uk.trustpilot.com",
    "www.gov.uk",
    "gov.uk",
    "assets-dev.cinch.co.uk",
    "assets-production.cinch.co.uk",
    "www.ramplimited.co.uk",
    "cinch.tempcover.com",
    "www.cinch.tempcover.com",
    "www.experian.co.uk",
    "www.transunion.co.uk",
    "equifax.co.uk",
    "www.equifax.co.uk"
  ],
  inAppBrowserPaths: [
    "/privacy",
    "/terms-of-use",
    "/policies/privacy",
    "/support",
    "/car-inspection",
    "/news/ulez-explained-by-cinch",
    "/car-care/cinch-shield",
    "/car-care/charging-electric-cars",
    "/car-care/electric-car-home-charger",
    "/policies/terms-and-conditions"
  ],
  outsideAppBrowserURLs: ["wa.me", "api.whatsapp.com"],
  webviewThirdPartyURLs: ["stripe.com", "pm-redirects.stripe.com", "tink.com"],
  nativeScreenURLs: [
    "/",
    "/my-profile",
    "/native-favourites",
    "/my-profile/favourites",
    "/native-home",
    "/native-my-profile",
    "/native-part-exchange"
  ],
  mainWebviewTitles: {
    Search: "Find a car",
    ProductPage: "Car details",
    OrderOverview: "Order overview",
    CreateAccount: "Create an account",
    PersonalDetails: "Enter your details",
    WantToPartExchange: "Add a part exchange",
    HowDoYouWantToPay: "Choose a payment option",
    FinanceCalculator: "Finance calculator",
    YourDetails: "Enter your details",
    AddAddressHistory: "Add address history",
    AddWorkHistory: "Add work history",
    CompareCars: "Compare cars",
    IncomingsAndOutgoings: "Incomings and outgoings",
    BankAccountMatch: "Bank account match",
    CheckAndSubmit: "Check and submit",
    UploadYourSettlementLetter: "Upload your settlement letter",
    AllFinancePagesPostOffer: "Finance application submitted",
    ChooseADelivery: "Pick a time slot",
    CarCare: "Add car care",
    ReviewAndPay: "Review and pay",
    OrderConfirmation: "Order confirmation",
    OrderBankPayment: "Bank Payment",
    CancelOrder: "Cancel your order",
    IDVerification: "ID Verification",
    EditCustomerInformation: "Edit customer information",
    CheckEligibility: "Finance eligibility checker",
    CarFinance: "Car finance",
    HelpMeChoose: "Help me choose",
    CanNotApply: "You can't apply for car finance"
  },
  webviewSheetTitles: {
    SIGNUP: "Sign up",
    TERMS: "Terms of use",
    COOKIE: "Cookie policy",
    PRIVACY: "Privacy policy",
    SUPPORT: "Support",
    PASSWORD: "Change password",
    DELIVERY: "Home delivery",
    PARTEXCHANGE: "Part exchange",
    RETURNS: "Returns",
    CARFINANCE: "Car finance",
    PCPEXPLANATION: "Personal contract purchase (PCP)",
    HPEXPLANATION: "Hire purchase (HP)",
    ULEZEXPLAINEDBYCINCH: "ULEZ explained by Cinch",
    WARRANTYINFORMATION: "Warranty inclusions and exclusions",
    SERVICING: "Routine servicing",
    TERMSOFUSE: "Terms of use",
    SUPPORTWEBVIEW: "Support",
    PRIVACYCOOKIE: "Privacy & cookie policy",
    CINCHIDD: "Initial Disclosure Document",
    CINCHSHIELD: "Cinch Shield",
    CINCHSHIELDLIFESHINE: "Lifeshine guarantee - Terms and conditions",
    CINCHCARE: "Cinch Care",
    TERMSCOND: "Car purchase terms and conditions",
    DEFAULT: "",
    Whatsapp: "Whatsapp",
    CHECKELIGIBILITY: "Check eligibility",
    CINCHCHARGE: "cinchCharge",
    CARINSPECTION: "Car inspection",
    COLLECTIONS: "Car collections",
    COLLECTIONLOCATION: "Collection location"
  },
  saleConfig: {
    TEXT: "Black Friday Buzz - ",
    SHOW_LINK: true,
    LINK_TEXT: "Shop EVs on offer \u2794",
    LINK_TAG: "Cars-on-offer",
    TEXT_COLOR: "pureWhite",
    BACKGROUND_COLOR: "pureBlack",
    TC_TEXT: "Ends 12pm 28/11. Discount varies by car. Charging valid only at cinchCharge network locations. ",
    TC_LINK_TEXT: "T&Cs apply.",
    TC_URL: "https://mobile.snc-dev.aws.cinch.co.uk/offers"
  }
};

// src/env/prod/app-config.json
var app_config_default2 = {
  aprValue: "11.4",
  ios: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  android: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  mainWebviewLoggedInURLs: [
    "/checkout/bank-payment/",
    "/checkout/car-care/",
    "/checkout/card-details/",
    "/checkout/confirmation/",
    "/checkout/delivery/",
    "/checkout/editable-customer-info/",
    "/checkout/finance-application-approved/",
    "/checkout/finance-application-decision/",
    "/checkout/finance-application-offer/",
    "/checkout/finance-application-outgoings/",
    "/checkout/finance-application-review/",
    "/checkout/finance-bank-details/",
    "/checkout/finance-cant-apply/",
    "/checkout/finance-current-address/",
    "/checkout/finance-employment-history/",
    "/checkout/finance-offer-amends/",
    "/checkout/finance-personal-details/",
    "/checkout/finance/",
    "/checkout/id-verification/",
    "/checkout/part-exchange",
    "/checkout/payment/",
    "/checkout/personal-details/",
    "/checkout/settlement-letter-upload/",
    "/checkout/verify-email/"
  ],
  mainWebviewLoggedOutURLs: [
    "/car-finance/check-eligibility",
    "/checkout/your-order/",
    "/compare-cars",
    "/find-vehicle",
    "/help-me-choose/body-types",
    "/help-me-choose/car-makes",
    "/help-me-choose/most-important",
    "/help-me-choose/passengers",
    "/help-me-choose/price-range",
    "/help-me-choose/recommendations",
    "/offers",
    "/part-exchange/calculator",
    "/used-cars/",
    "/used-cars"
  ],
  webviewSheetURLs: [
    "/car-collections",
    "/car-finance",
    "/cars-near-me/collection-location",
    "/cinch-care",
    "/cinch-care/servicing",
    "/cinch-care/warranty-information",
    "/cinch-shield",
    "/cinchshield-lifeshine-guarantee",
    "/delivery",
    "/finance/Cinch_IDD",
    "/finance/hp-explanation",
    "/finance/pcp-explanation",
    "/part-exchange",
    "/policies/terms-and-conditions",
    "/post/ulez-explained-by-cinch",
    "/returns",
    "/sign-up",
    "/terms-and-conditions",
    "/which-car-should-i-buy"
  ],
  inAppBrowserHosts: [
    "trial.bonafidee.com",
    "secure.bonafidee.com",
    "web.evolutionfunding.com",
    "www.evolutionfunding.com",
    "evolutionfunding.com",
    "sandbox.evolutionfunding.com",
    "public.evolutionfunding.com",
    "www.blackhorse.co.uk",
    "www.google.com",
    "google.com",
    "bonafidee.com",
    "uk.trustpilot.com",
    "www.gov.uk",
    "gov.uk",
    "assets-dev.cinch.co.uk",
    "assets-production.cinch.co.uk",
    "www.ramplimited.co.uk",
    "cinch.tempcover.com",
    "www.cinch.tempcover.com",
    "www.experian.co.uk",
    "www.transunion.co.uk",
    "equifax.co.uk",
    "www.equifax.co.uk"
  ],
  inAppBrowserPaths: [
    "/privacy",
    "/terms-of-use",
    "/policies/privacy",
    "/support",
    "/car-inspection",
    "/news/ulez-explained-by-cinch",
    "/car-care/cinch-shield",
    "/car-care/charging-electric-cars",
    "/car-care/electric-car-home-charger",
    "/policies/terms-and-conditions"
  ],
  outsideAppBrowserURLs: ["wa.me", "api.whatsapp.com"],
  webviewThirdPartyURLs: ["stripe.com", "pm-redirects.stripe.com", "tink.com"],
  nativeScreenURLs: [
    "/",
    "/my-profile",
    "/my-profile/favourites",
    "/native-favourites",
    "/native-home",
    "/native-my-profile",
    "/native-part-exchange"
  ],
  mainWebviewTitles: {
    Search: "Find a car",
    ProductPage: "Car details",
    OrderOverview: "Order overview",
    CreateAccount: "Create an account",
    PersonalDetails: "Enter your details",
    WantToPartExchange: "Add a part exchange",
    HowDoYouWantToPay: "Choose a payment option",
    FinanceCalculator: "Finance calculator",
    YourDetails: "Enter your details",
    AddAddressHistory: "Add address history",
    AddWorkHistory: "Add work history",
    CompareCars: "Compare cars",
    IncomingsAndOutgoings: "Incomings and outgoings",
    BankAccountMatch: "Bank account match",
    CheckAndSubmit: "Check and submit",
    UploadYourSettlementLetter: "Upload your settlement letter",
    AllFinancePagesPostOffer: "Finance application submitted",
    ChooseADelivery: "Pick a time slot",
    CarCare: "Add car care",
    ReviewAndPay: "Review and pay",
    OrderConfirmation: "Order confirmation",
    OrderBankPayment: "Bank Payment",
    CancelOrder: "Cancel your order",
    IDVerification: "ID Verification",
    EditCustomerInformation: "Edit customer information",
    CheckEligibility: "Finance eligibility checker",
    CarFinance: "Car finance",
    HelpMeChoose: "Help me choose",
    CanNotApply: "You can't apply for car finance"
  },
  webviewSheetTitles: {
    SIGNUP: "Sign up",
    TERMS: "Terms of use",
    COOKIE: "Cookie policy",
    PRIVACY: "Privacy policy",
    SUPPORT: "Support",
    PASSWORD: "Change password",
    DELIVERY: "Home delivery",
    PARTEXCHANGE: "Part exchange",
    RETURNS: "Returns",
    CARFINANCE: "Car finance",
    PCPEXPLANATION: "Personal contract purchase (PCP)",
    HPEXPLANATION: "Hire purchase (HP)",
    ULEZEXPLAINEDBYCINCH: "ULEZ explained by Cinch",
    WARRANTYINFORMATION: "Warranty inclusions and exclusions",
    SERVICING: "Routine servicing",
    TERMSOFUSE: "Terms of use",
    SUPPORTWEBVIEW: "Support",
    PRIVACYCOOKIE: "Privacy & cookie policy",
    CINCHIDD: "Initial Disclosure Document",
    CINCHSHIELD: "Cinch Shield",
    CINCHSHIELDLIFESHINE: "Lifeshine guarantee - Terms and conditions",
    CINCHCARE: "Cinch Care",
    TERMSCOND: "Car purchase terms and conditions",
    DEFAULT: "",
    Whatsapp: "Whatsapp",
    CHECKELIGIBILITY: "Check eligibility",
    CINCHCHARGE: "cinchCharge",
    CARINSPECTION: "Car inspection",
    COLLECTIONS: "Car collections",
    COLLECTIONLOCATION: "Collection location"
  },
  saleConfig: {
    TEXT: "Black Friday Buzz - ",
    SHOW_LINK: true,
    LINK_TEXT: "Shop EVs on offer \u2794",
    LINK_TAG: "Cars-on-offer",
    TEXT_COLOR: "pureWhite",
    BACKGROUND_COLOR: "pureBlack",
    TC_TEXT: "Ends 12pm 28/11. Discount varies by car. Charging valid only at cinchCharge network locations. ",
    TC_LINK_TEXT: "T&Cs apply.",
    TC_URL: "https://mobile.snc-prod.aws.cinch.co.uk/offers"
  }
};

// src/features/index.ts
var AppFeatures = [
  "showAdminFee",
  "yourOrdersMyProfile",
  "hideHomeVehicleCardDetails",
  "pushNotificationOptIn",
  "saleBanner",
  "marketingOutboundCalling"
];

// src/post-messages/schemas.ts
var import_zod = __webpack_require__(10840);
var FavouritesPostMessageSchema = import_zod.z.object({
  make: import_zod.z.string(),
  model: import_zod.z.string(),
  modelYear: import_zod.z.number(),
  vehicleId: import_zod.z.string()
});
var SearchFiltersAppliedSchema = import_zod.z.object({
  searchResultsCount: import_zod.z.number(),
  searchParameters: import_zod.z.object({
    bodyType: import_zod.z.string(),
    colour: import_zod.z.string(),
    seats: import_zod.z.string(),
    doors: import_zod.z.string(),
    fromEngineSize: import_zod.z.number(),
    toEngineSize: import_zod.z.number(),
    fuelType: import_zod.z.string(),
    make: import_zod.z.string(),
    selectedModel: import_zod.z.string(),
    variant: import_zod.z.string(),
    mileage: import_zod.z.number(),
    fromPrice: import_zod.z.number(),
    toPrice: import_zod.z.number(),
    transmissionType: import_zod.z.string(),
    fromYear: import_zod.z.number(),
    toYear: import_zod.z.number(),
    sortingCriteria: import_zod.z.number(),
    pageSize: import_zod.z.number(),
    pageNumber: import_zod.z.number(),
    useMonthly: import_zod.z.boolean(),
    driveType: import_zod.z.string(),
    priceField: import_zod.z.enum(["subsPrice6", "subsPrice12", "subsPrice18", "subsPrice24"]),
    tags: import_zod.z.string(),
    features: import_zod.z.string()
  }).partial()
});
var CheckoutStepVisitedPostMessageSchema = import_zod.z.object({
  orderId: import_zod.z.string(),
  vehicleId: import_zod.z.string(),
  step: import_zod.z.string()
});
var AppReturnHomePostMessageSchema = import_zod.z.object({
  isReturnHome: import_zod.z.boolean()
});
var YourOrderUserUnauthenticatedSchema = import_zod.z.string();
var AppWebviewTitleSchema = import_zod.z.string();
var ShowMainWebViewBorderSchema = import_zod.z.object({
  showBorder: import_zod.z.boolean()
});
var PdpVehicleIdSchema = import_zod.z.string();
var schemas = {
  appReturnHome: AppReturnHomePostMessageSchema,
  appWebviewTitle: AppWebviewTitleSchema,
  checkoutStepVisited: CheckoutStepVisitedPostMessageSchema,
  favouriteVehicleAdded: FavouritesPostMessageSchema,
  favouriteVehicleRemoved: FavouritesPostMessageSchema,
  pdpVehicleId: PdpVehicleIdSchema,
  searchFiltersApplied: SearchFiltersAppliedSchema,
  showMainWebViewBorder: ShowMainWebViewBorderSchema,
  yourOrderUserUnauthenticated: YourOrderUserUnauthenticatedSchema
};

// src/post-messages/sendPostMessage.ts
function sendPostMessage(type, ...rest) {
  if (typeof window === "undefined" || typeof window.ReactNativeWebView === "undefined") {
    return;
  }
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type,
      ...Boolean(rest[0]) && { data: rest[0] }
    })
  );
}

// src/post-messages/createPostMessageHandlers.ts
var isValidPostMessageType = (handlers, messageType) => {
  return typeof messageType === "string" && Object.keys(handlers).includes(messageType);
};
var createPostMessageHandlers = (handlers, onError) => {
  return (msg) => {
    try {
      const parsedMessage = JSON.parse(msg);
      if (!Object.prototype.hasOwnProperty.call(parsedMessage, "type")) {
        onError(msg);
        return;
      }
      const messageType = parsedMessage.type;
      if (!isValidPostMessageType(handlers, messageType)) {
        onError(msg);
        return;
      }
      schemas[messageType].parse(parsedMessage.data);
      handlers[messageType](parsedMessage.data);
    } catch {
      onError(msg);
    }
  };
};

// src/env/dev/webviewTitles.ts
var { webviewSheetURLs, mainWebviewLoggedInURLs, mainWebviewLoggedOutURLs } = app_config_default;
var devMainWebviewTitlesRecord = {
  "/car-finance/check-eligibility": "CheckEligibility",
  "/checkout/bank-payment/": "OrderBankPayment",
  "/checkout/car-care/": "CarCare",
  "/checkout/card-details/": "ReviewAndPay",
  "/checkout/confirmation/": "OrderConfirmation",
  "/checkout/delivery/": "ChooseADelivery",
  "/checkout/editable-customer-info/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-approved/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-decision/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-offer/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-outgoings/": "IncomingsAndOutgoings",
  "/checkout/finance-application-review/": "AllFinancePagesPostOffer",
  "/checkout/finance-bank-details/": "BankAccountMatch",
  "/checkout/finance-cant-apply/": "CanNotApply",
  "/checkout/finance-current-address/": "AddAddressHistory",
  "/checkout/finance-employment-history/": "AddWorkHistory",
  "/checkout/finance-offer-amends/": "AllFinancePagesPostOffer",
  "/checkout/finance-personal-details/": "YourDetails",
  "/checkout/finance/": "FinanceCalculator",
  "/checkout/part-exchange": "WantToPartExchange",
  "/checkout/payment/": "HowDoYouWantToPay",
  "/checkout/personal-details/": "PersonalDetails",
  "/checkout/settlement-letter-upload/": "UploadYourSettlementLetter",
  "/checkout/your-order/": "OrderOverview",
  "/compare-cars": "CompareCars",
  "/find-vehicle": "Search",
  "/help-me-choose/body-types": "HelpMeChoose",
  "/help-me-choose/car-makes": "HelpMeChoose",
  "/help-me-choose/most-important": "HelpMeChoose",
  "/help-me-choose/passengers": "HelpMeChoose",
  "/help-me-choose/price-range": "HelpMeChoose",
  "/help-me-choose/recommendations": "HelpMeChoose",
  "/part-exchange/calculator": "WantToPartExchange",
  "/used-cars/": "ProductPage",
  "/used-cars": "Search"
};
var devWebviewSheetTitlesRecord = {
  "/car-care/charging-electric-cars": "CINCHCHARGE",
  "/car-collections": "COLLECTIONS",
  "/car-finance": "CARFINANCE",
  "/cars-near-me/collection-location": "COLLECTIONLOCATION",
  "/cinch-care": "CINCHCARE",
  "/cinch-care/servicing": "SERVICING",
  "/cinch-care/warranty-information": "WARRANTYINFORMATION",
  "/cinch-shield": "CINCHSHIELD",
  "/cinchshield-lifeshine-guarantee": "CINCHSHIELDLIFESHINE",
  "/delivery": "DELIVERY",
  "/finance/Cinch_IDD": "CINCHIDD",
  "/finance/hp-explanation": "HPEXPLANATION",
  "/finance/pcp-explanation": "PCPEXPLANATION",
  "/news/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/part-exchange": "PARTEXCHANGE",
  "/policies/terms-and-conditions": "TERMSCOND",
  "/post/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/returns": "RETURNS",
  "/sign-up": "SIGNUP",
  "/terms-and-conditions": "TERMSCOND"
};
var getDevMainWebviewTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = [...mainWebviewLoggedInURLs, ...mainWebviewLoggedOutURLs].find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = devMainWebviewTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};
var getDevWebviewSheetTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = webviewSheetURLs.find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = devWebviewSheetTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};

// src/env/prod/webviewTitles.ts
var { webviewSheetURLs: webviewSheetURLs2, mainWebviewLoggedInURLs: mainWebviewLoggedInURLs2, mainWebviewLoggedOutURLs: mainWebviewLoggedOutURLs2 } = app_config_default2;
var prodMainWebviewTitlesRecord = {
  "/car-finance/check-eligibility": "CheckEligibility",
  "/checkout/bank-payment/": "OrderBankPayment",
  "/checkout/car-care/": "CarCare",
  "/checkout/card-details/": "ReviewAndPay",
  "/checkout/confirmation/": "OrderConfirmation",
  "/checkout/delivery/": "ChooseADelivery",
  "/checkout/editable-customer-info/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-approved/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-decision/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-offer/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-outgoings/": "IncomingsAndOutgoings",
  "/checkout/finance-application-review/": "AllFinancePagesPostOffer",
  "/checkout/finance-bank-details/": "BankAccountMatch",
  "/checkout/finance-cant-apply/": "CanNotApply",
  "/checkout/finance-current-address/": "AddAddressHistory",
  "/checkout/finance-employment-history/": "AddWorkHistory",
  "/checkout/finance-offer-amends/": "AllFinancePagesPostOffer",
  "/checkout/finance-personal-details/": "YourDetails",
  "/checkout/finance/": "FinanceCalculator",
  "/checkout/part-exchange": "WantToPartExchange",
  "/checkout/payment/": "HowDoYouWantToPay",
  "/checkout/personal-details/": "PersonalDetails",
  "/checkout/settlement-letter-upload/": "UploadYourSettlementLetter",
  "/checkout/your-order/": "OrderOverview",
  "/compare-cars": "CompareCars",
  "/find-vehicle": "Search",
  "/help-me-choose/body-types": "HelpMeChoose",
  "/help-me-choose/car-makes": "HelpMeChoose",
  "/help-me-choose/most-important": "HelpMeChoose",
  "/help-me-choose/passengers": "HelpMeChoose",
  "/help-me-choose/price-range": "HelpMeChoose",
  "/help-me-choose/recommendations": "HelpMeChoose",
  "/part-exchange/calculator": "WantToPartExchange",
  "/used-cars/": "ProductPage",
  "/used-cars": "Search"
};
var prodWebviewSheetTitlesRecord = {
  "/car-care/charging-electric-cars": "CINCHCHARGE",
  "/car-collections": "COLLECTIONS",
  "/car-finance": "CARFINANCE",
  "/cars-near-me/collection-location": "COLLECTIONLOCATION",
  "/cinch-care": "CINCHCARE",
  "/cinch-care/servicing": "SERVICING",
  "/cinch-care/warranty-information": "WARRANTYINFORMATION",
  "/cinch-shield": "CINCHSHIELD",
  "/cinchshield-lifeshine-guarantee": "CINCHSHIELDLIFESHINE",
  "/delivery": "DELIVERY",
  "/finance/Cinch_IDD": "CINCHIDD",
  "/finance/hp-explanation": "HPEXPLANATION",
  "/finance/pcp-explanation": "PCPEXPLANATION",
  "/news/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/part-exchange": "PARTEXCHANGE",
  "/policies/terms-and-conditions": "TERMSCOND",
  "/post/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/returns": "RETURNS",
  "/sign-up": "SIGNUP",
  "/terms-and-conditions": "TERMSCOND"
};
var getProdMainWebviewTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = [...mainWebviewLoggedInURLs2, ...mainWebviewLoggedOutURLs2].find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = prodMainWebviewTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};
var getProdWebviewSheetTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = webviewSheetURLs2.find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = prodWebviewSheetTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};

// src/env/types.ts
var import_zod2 = __webpack_require__(10840);
var zMainWebviewTitles = import_zod2.z.object({
  Search: import_zod2.z.string(),
  ProductPage: import_zod2.z.string(),
  OrderOverview: import_zod2.z.string(),
  CreateAccount: import_zod2.z.string(),
  PersonalDetails: import_zod2.z.string(),
  WantToPartExchange: import_zod2.z.string(),
  HowDoYouWantToPay: import_zod2.z.string(),
  FinanceCalculator: import_zod2.z.string(),
  YourDetails: import_zod2.z.string(),
  AddAddressHistory: import_zod2.z.string(),
  AddWorkHistory: import_zod2.z.string(),
  CompareCars: import_zod2.z.string(),
  IncomingsAndOutgoings: import_zod2.z.string(),
  BankAccountMatch: import_zod2.z.string(),
  CheckAndSubmit: import_zod2.z.string(),
  UploadYourSettlementLetter: import_zod2.z.string(),
  AllFinancePagesPostOffer: import_zod2.z.string(),
  ChooseADelivery: import_zod2.z.string(),
  CarCare: import_zod2.z.string(),
  ReviewAndPay: import_zod2.z.string(),
  OrderConfirmation: import_zod2.z.string(),
  OrderBankPayment: import_zod2.z.string(),
  CancelOrder: import_zod2.z.string(),
  IDVerification: import_zod2.z.string(),
  EditCustomerInformation: import_zod2.z.string(),
  CheckEligibility: import_zod2.z.string(),
  CarFinance: import_zod2.z.string(),
  HelpMeChoose: import_zod2.z.string(),
  CanNotApply: import_zod2.z.string()
});
var zWebviewSheetTitles = import_zod2.z.object({
  SIGNUP: import_zod2.z.string(),
  TERMS: import_zod2.z.string(),
  COOKIE: import_zod2.z.string(),
  PRIVACY: import_zod2.z.string(),
  SUPPORT: import_zod2.z.string(),
  PASSWORD: import_zod2.z.string(),
  DELIVERY: import_zod2.z.string(),
  PARTEXCHANGE: import_zod2.z.string(),
  RETURNS: import_zod2.z.string(),
  CARFINANCE: import_zod2.z.string(),
  PCPEXPLANATION: import_zod2.z.string(),
  HPEXPLANATION: import_zod2.z.string(),
  ULEZEXPLAINEDBYCINCH: import_zod2.z.string(),
  WARRANTYINFORMATION: import_zod2.z.string(),
  SERVICING: import_zod2.z.string(),
  TERMSOFUSE: import_zod2.z.string(),
  SUPPORTWEBVIEW: import_zod2.z.string(),
  PRIVACYCOOKIE: import_zod2.z.string(),
  CINCHIDD: import_zod2.z.string(),
  CINCHSHIELD: import_zod2.z.string(),
  CINCHSHIELDLIFESHINE: import_zod2.z.string(),
  CINCHCARE: import_zod2.z.string(),
  TERMSCOND: import_zod2.z.string(),
  DEFAULT: import_zod2.z.string(),
  Whatsapp: import_zod2.z.string(),
  CHECKELIGIBILITY: import_zod2.z.string(),
  CINCHCHARGE: import_zod2.z.string(),
  CARINSPECTION: import_zod2.z.string(),
  COLLECTIONS: import_zod2.z.string(),
  COLLECTIONLOCATION: import_zod2.z.string()
});
var zSaleConfig = import_zod2.z.object({
  TEXT: import_zod2.z.string(),
  SHOW_LINK: import_zod2.z.boolean(),
  LINK_TEXT: import_zod2.z.string(),
  LINK_TAG: import_zod2.z.string(),
  TEXT_COLOR: import_zod2.z.string(),
  BACKGROUND_COLOR: import_zod2.z.string(),
  TC_TEXT: import_zod2.z.string(),
  TC_LINK_TEXT: import_zod2.z.string(),
  TC_URL: import_zod2.z.string()
});
var zMainWebviewTitleKeys = zMainWebviewTitles.keyof();
var zWebviewSheetTitleKeys = zWebviewSheetTitles.keyof();
var zDynamicConfigBase = import_zod2.z.object({
  aprValue: import_zod2.z.string(),
  mainWebviewLoggedInURLs: import_zod2.z.array(import_zod2.z.string()),
  mainWebviewLoggedOutURLs: import_zod2.z.array(import_zod2.z.string()),
  webviewSheetURLs: import_zod2.z.array(import_zod2.z.string()),
  inAppBrowserHosts: import_zod2.z.array(import_zod2.z.string()),
  inAppBrowserPaths: import_zod2.z.array(import_zod2.z.string()),
  outsideAppBrowserURLs: import_zod2.z.array(import_zod2.z.string()),
  webviewThirdPartyURLs: import_zod2.z.array(import_zod2.z.string()),
  nativeScreenURLs: import_zod2.z.array(import_zod2.z.string()),
  mainWebviewTitles: zMainWebviewTitles,
  webviewSheetTitles: zWebviewSheetTitles,
  saleConfig: zSaleConfig
});
var zPlatformConfig = import_zod2.z.object({
  requiredAppVersion: import_zod2.z.string(),
  recommendedAppVersion: import_zod2.z.string().optional(),
  isSuspended: import_zod2.z.boolean().default(false)
});
var zDynamicConfig = zDynamicConfigBase.merge(
  import_zod2.z.object({
    ios: zPlatformConfig,
    android: zPlatformConfig
  })
).passthrough();
var zFlatConfig = zDynamicConfigBase.merge(zPlatformConfig);
var devConfig = zDynamicConfig.parse(app_config_default);
var prodConfig = zDynamicConfig.parse(app_config_default2);

// npm-package/index.ts
var devAppConfig = app_config_default;
var prodAppConfig = app_config_default2;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 28963:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;
const util_1 = __webpack_require__(15729);
exports.ZodIssueCode = util_1.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
exports.quotelessJson = quotelessJson;
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) {
            throw new Error(`Not a ZodError: ${value}`);
        }
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util_1.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
exports.ZodError = ZodError;
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};


/***/ }),

/***/ 81417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getErrorMap = exports.setErrorMap = exports.defaultErrorMap = void 0;
const en_1 = __importDefault(__webpack_require__(62917));
exports.defaultErrorMap = en_1.default;
let overrideErrorMap = en_1.default;
function setErrorMap(map) {
    overrideErrorMap = map;
}
exports.setErrorMap = setErrorMap;
function getErrorMap() {
    return overrideErrorMap;
}
exports.getErrorMap = getErrorMap;


/***/ }),

/***/ 78653:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(81417), exports);
__exportStar(__webpack_require__(84456), exports);
__exportStar(__webpack_require__(84315), exports);
__exportStar(__webpack_require__(15729), exports);
__exportStar(__webpack_require__(50386), exports);
__exportStar(__webpack_require__(28963), exports);


/***/ }),

/***/ 46603:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.errorUtil = void 0;
var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil = exports.errorUtil || (exports.errorUtil = {}));


/***/ }),

/***/ 84456:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.addIssueToContext = exports.EMPTY_PATH = exports.makeIssue = void 0;
const errors_1 = __webpack_require__(81417);
const en_1 = __importDefault(__webpack_require__(62917));
const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    if (issueData.message !== undefined) {
        return {
            ...issueData,
            path: fullPath,
            message: issueData.message,
        };
    }
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage,
    };
};
exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, errors_1.getErrorMap)();
    const issue = (0, exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === en_1.default ? undefined : en_1.default, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
exports.addIssueToContext = addIssueToContext;
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return exports.INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return exports.INVALID;
            if (value.status === "aborted")
                return exports.INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
exports.DIRTY = DIRTY;
const OK = (value) => ({ status: "valid", value });
exports.OK = OK;
const isAborted = (x) => x.status === "aborted";
exports.isAborted = isAborted;
const isDirty = (x) => x.status === "dirty";
exports.isDirty = isDirty;
const isValid = (x) => x.status === "valid";
exports.isValid = isValid;
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
exports.isAsync = isAsync;


/***/ }),

/***/ 84315:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ 15729:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util = exports.util || (exports.util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil = exports.objectUtil || (exports.objectUtil = {}));
exports.ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return exports.ZodParsedType.undefined;
        case "string":
            return exports.ZodParsedType.string;
        case "number":
            return isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;
        case "boolean":
            return exports.ZodParsedType.boolean;
        case "function":
            return exports.ZodParsedType.function;
        case "bigint":
            return exports.ZodParsedType.bigint;
        case "symbol":
            return exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return exports.ZodParsedType.array;
            }
            if (data === null) {
                return exports.ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return exports.ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return exports.ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return exports.ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return exports.ZodParsedType.date;
            }
            return exports.ZodParsedType.object;
        default:
            return exports.ZodParsedType.unknown;
    }
};
exports.getParsedType = getParsedType;


/***/ }),

/***/ 10840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.z = void 0;
const z = __importStar(__webpack_require__(78653));
exports.z = z;
__exportStar(__webpack_require__(78653), exports);
exports["default"] = z;


/***/ }),

/***/ 62917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__(15729);
const ZodError_1 = __webpack_require__(28963);
const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodError_1.ZodIssueCode.invalid_type:
            if (issue.received === util_1.ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodError_1.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util_1.util.jsonStringifyReplacer)}`;
            break;
        case ZodError_1.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util_1.util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodError_1.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodError_1.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util_1.util.joinValues(issue.options)}`;
            break;
        case ZodError_1.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util_1.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodError_1.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodError_1.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodError_1.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodError_1.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util_1.util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodError_1.ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodError_1.ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodError_1.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodError_1.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodError_1.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodError_1.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util_1.util.assertNever(issue);
    }
    return { message };
};
exports["default"] = errorMap;


/***/ }),

/***/ 50386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _ZodEnum_cache, _ZodNativeEnum_cache;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.boolean = exports.bigint = exports.array = exports.any = exports.coerce = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.custom = exports.ZodReadonly = exports.ZodPipeline = exports.ZodBranded = exports.BRAND = exports.ZodNaN = exports.ZodCatch = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.datetimeRegex = exports.ZodType = void 0;
exports.NEVER = exports["void"] = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.symbol = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.pipeline = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports["null"] = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = exports.intersection = exports["instanceof"] = exports["function"] = exports["enum"] = exports.effect = exports.discriminatedUnion = exports.date = void 0;
const errors_1 = __webpack_require__(81417);
const errorUtil_1 = __webpack_require__(46603);
const parseUtil_1 = __webpack_require__(84456);
const util_1 = __webpack_require__(15729);
const ZodError_1 = __webpack_require__(28963);
class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if ((0, parseUtil_1.isValid)(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError_1.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        var _a, _b;
        const { message } = params;
        if (iss.code === "invalid_enum_value") {
            return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
        }
        if (typeof ctx.data === "undefined") {
            return { message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError };
        }
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        return { message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, util_1.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, util_1.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new parseUtil_1.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, util_1.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, parseUtil_1.isAsync)(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_1.getParsedType)(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_1.getParsedType)(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await ((0, parseUtil_1.isAsync)(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodError_1.ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) {
        regex = `${regex}\\.\\d{${args.precision}}`;
    }
    else if (args.precision == null) {
        regex = `${regex}(\\.\\d+)?`;
    }
    return regex;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset)
        opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
exports.datetimeRegex = datetimeRegex;
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.string,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const status = new parseUtil_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        (0, parseUtil_1.addIssueToContext)(ctx, {
                            code: ZodError_1.ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        (0, parseUtil_1.addIssueToContext)(ctx, {
                            code: ZodError_1.ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "email",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "url",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: ZodError_1.ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util_1.util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodError_1.ZodIssueCode.invalid_string,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    nanoid(message) {
        return this._addCheck({ kind: "nanoid", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    base64(message) {
        return this._addCheck({ kind: "base64", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil_1.errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                local: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...errorUtil_1.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    date(message) {
        return this._addCheck({ kind: "date", message });
    }
    time(options) {
        if (typeof options === "string") {
            return this._addCheck({
                kind: "time",
                precision: null,
                message: options,
            });
        }
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...errorUtil_1.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    duration(message) {
        return this._addCheck({ kind: "duration", ...errorUtil_1.errorUtil.errToObj(message) });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil_1.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil_1.errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil_1.errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch) => ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch) => ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch) => ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch) => ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch) => ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodString = ZodString;
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.number,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_1.ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util_1.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util_1.util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_1.errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil_1.errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util_1.util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
exports.ZodNumber = ZodNumber;
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_1.ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util_1.util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_1.errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodBigInt = ZodBigInt;
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodBoolean = ZodBoolean;
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.date,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_date,
            });
            return parseUtil_1.INVALID;
        }
        const status = new parseUtil_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util_1.util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil_1.errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
exports.ZodDate = ZodDate;
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodSymbol = ZodSymbol;
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodUndefined = ZodUndefined;
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.null,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodNull = ZodNull;
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodAny = ZodAny;
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodUnknown = ZodUnknown;
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.invalid_type,
            expected: util_1.ZodParsedType.never,
            received: ctx.parsedType,
        });
        return parseUtil_1.INVALID;
    }
}
exports.ZodNever = ZodNever;
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.void,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
}
exports.ZodVoid = ZodVoid;
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== util_1.ZodParsedType.array) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.array,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: tooBig ? ZodError_1.ZodIssueCode.too_big : ZodError_1.ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: ZodError_1.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: ZodError_1.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return parseUtil_1.ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return parseUtil_1.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil_1.errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil_1.errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil_1.errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodArray = ZodArray;
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util_1.util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.object,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, parseUtil_1.addIssueToContext)(ctx, {
                        code: ZodError_1.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") {
            }
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    syncPairs.push({
                        key,
                        value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return parseUtil_1.ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return parseUtil_1.ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil_1.errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil_1.errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util_1.util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util_1.util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util_1.util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util_1.util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util_1.util.objectKeys(this.shape));
    }
}
exports.ZodObject = ZodObject;
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError_1.ZodError(result.ctx.common.issues));
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_union,
                unionErrors,
            });
            return parseUtil_1.INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError_1.ZodError(issues));
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_union,
                unionErrors,
            });
            return parseUtil_1.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
exports.ZodUnion = ZodUnion;
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return util_1.util.objectValues(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else if (type instanceof ZodOptional) {
        return [undefined, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodNullable) {
        return [null, ...getDiscriminator(type.unwrap())];
    }
    else if (type instanceof ZodBranded) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodReadonly) {
        return getDiscriminator(type.unwrap());
    }
    else if (type instanceof ZodCatch) {
        return getDiscriminator(type._def.innerType);
    }
    else {
        return [];
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.object) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.object,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return parseUtil_1.INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;
function mergeValues(a, b) {
    const aType = (0, util_1.getParsedType)(a);
    const bType = (0, util_1.getParsedType)(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === util_1.ZodParsedType.object && bType === util_1.ZodParsedType.object) {
        const bKeys = util_1.util.objectKeys(b);
        const sharedKeys = util_1.util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === util_1.ZodParsedType.array && bType === util_1.ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === util_1.ZodParsedType.date &&
        bType === util_1.ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if ((0, parseUtil_1.isAborted)(parsedLeft) || (0, parseUtil_1.isAborted)(parsedRight)) {
                return parseUtil_1.INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: ZodError_1.ZodIssueCode.invalid_intersection_types,
                });
                return parseUtil_1.INVALID;
            }
            if ((0, parseUtil_1.isDirty)(parsedLeft) || (0, parseUtil_1.isDirty)(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
exports.ZodIntersection = ZodIntersection;
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.array) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.array,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return parseUtil_1.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return parseUtil_1.ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return parseUtil_1.ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
exports.ZodTuple = ZodTuple;
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.object) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.object,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (ctx.common.async) {
            return parseUtil_1.ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return parseUtil_1.ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
exports.ZodRecord = ZodRecord;
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.map) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.map,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return parseUtil_1.INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return parseUtil_1.INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
exports.ZodMap = ZodMap;
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.set) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.set,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: ZodError_1.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, parseUtil_1.addIssueToContext)(ctx, {
                    code: ZodError_1.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return parseUtil_1.INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil_1.errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil_1.errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodSet = ZodSet;
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.function) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.function,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, parseUtil_1.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_1.getErrorMap)(),
                    errors_1.defaultErrorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodError_1.ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, parseUtil_1.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_1.getErrorMap)(),
                    errors_1.defaultErrorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodError_1.ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_1.OK)(async function (...args) {
                const error = new ZodError_1.ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_1.OK)(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError_1.ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError_1.ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
exports.ZodFunction = ZodFunction;
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
exports.ZodLazy = ZodLazy;
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_1.ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return parseUtil_1.INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
exports.ZodLiteral = ZodLiteral;
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_1.addIssueToContext)(ctx, {
                expected: util_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_1.ZodIssueCode.invalid_type,
            });
            return parseUtil_1.INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f")) {
            __classPrivateFieldSet(this, _ZodEnum_cache, new Set(this._def.values), "f");
        }
        if (!__classPrivateFieldGet(this, _ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef,
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
            ...this._def,
            ...newDef,
        });
    }
}
exports.ZodEnum = ZodEnum;
_ZodEnum_cache = new WeakMap();
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    constructor() {
        super(...arguments);
        _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = util_1.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== util_1.ZodParsedType.string &&
            ctx.parsedType !== util_1.ZodParsedType.number) {
            const expectedValues = util_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                expected: util_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_1.ZodIssueCode.invalid_type,
            });
            return parseUtil_1.INVALID;
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f")) {
            __classPrivateFieldSet(this, _ZodNativeEnum_cache, new Set(util_1.util.getValidEnumValues(this._def.values)), "f");
        }
        if (!__classPrivateFieldGet(this, _ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = util_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return parseUtil_1.INVALID;
        }
        return (0, parseUtil_1.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
exports.ZodNativeEnum = ZodNativeEnum;
_ZodNativeEnum_cache = new WeakMap();
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_1.ZodParsedType.promise &&
            ctx.common.async === false) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        const promisified = ctx.parsedType === util_1.ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return (0, parseUtil_1.OK)(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
exports.ZodPromise = ZodPromise;
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                (0, parseUtil_1.addIssueToContext)(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) {
                return Promise.resolve(processed).then(async (processed) => {
                    if (status.value === "aborted")
                        return parseUtil_1.INVALID;
                    const result = await this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                    if (result.status === "aborted")
                        return parseUtil_1.INVALID;
                    if (result.status === "dirty")
                        return (0, parseUtil_1.DIRTY)(result.value);
                    if (status.value === "dirty")
                        return (0, parseUtil_1.DIRTY)(result.value);
                    return result;
                });
            }
            else {
                if (status.value === "aborted")
                    return parseUtil_1.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
                if (result.status === "aborted")
                    return parseUtil_1.INVALID;
                if (result.status === "dirty")
                    return (0, parseUtil_1.DIRTY)(result.value);
                if (status.value === "dirty")
                    return (0, parseUtil_1.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return parseUtil_1.INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return parseUtil_1.INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!(0, parseUtil_1.isValid)(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!(0, parseUtil_1.isValid)(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util_1.util.assertNever(effect);
    }
}
exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_1.ZodParsedType.undefined) {
            return (0, parseUtil_1.OK)(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodOptional = ZodOptional;
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_1.ZodParsedType.null) {
            return (0, parseUtil_1.OK)(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodNullable = ZodNullable;
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === util_1.ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
exports.ZodDefault = ZodDefault;
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if ((0, parseUtil_1.isAsync)(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError_1.ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError_1.ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
exports.ZodCatch = ZodCatch;
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_1.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: util_1.ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return parseUtil_1.INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
exports.ZodNaN = ZodNaN;
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
exports.BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
exports.ZodBranded = ZodBranded;
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return parseUtil_1.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, parseUtil_1.DIRTY)(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return parseUtil_1.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
exports.ZodPipeline = ZodPipeline;
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data) => {
            if ((0, parseUtil_1.isValid)(data)) {
                data.value = Object.freeze(data.value);
            }
            return data;
        };
        return (0, parseUtil_1.isAsync)(result)
            ? result.then((data) => freeze(data))
            : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodReadonly = ZodReadonly;
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
function custom(check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
}
exports.custom = custom;
exports.late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind = exports.ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._) { }
}
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
exports["instanceof"] = instanceOfType;
const stringType = ZodString.create;
exports.string = stringType;
const numberType = ZodNumber.create;
exports.number = numberType;
const nanType = ZodNaN.create;
exports.nan = nanType;
const bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
const booleanType = ZodBoolean.create;
exports.boolean = booleanType;
const dateType = ZodDate.create;
exports.date = dateType;
const symbolType = ZodSymbol.create;
exports.symbol = symbolType;
const undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
const nullType = ZodNull.create;
exports["null"] = nullType;
const anyType = ZodAny.create;
exports.any = anyType;
const unknownType = ZodUnknown.create;
exports.unknown = unknownType;
const neverType = ZodNever.create;
exports.never = neverType;
const voidType = ZodVoid.create;
exports["void"] = voidType;
const arrayType = ZodArray.create;
exports.array = arrayType;
const objectType = ZodObject.create;
exports.object = objectType;
const strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
const unionType = ZodUnion.create;
exports.union = unionType;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
const intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
const tupleType = ZodTuple.create;
exports.tuple = tupleType;
const recordType = ZodRecord.create;
exports.record = recordType;
const mapType = ZodMap.create;
exports.map = mapType;
const setType = ZodSet.create;
exports.set = setType;
const functionType = ZodFunction.create;
exports["function"] = functionType;
const lazyType = ZodLazy.create;
exports.lazy = lazyType;
const literalType = ZodLiteral.create;
exports.literal = literalType;
const enumType = ZodEnum.create;
exports["enum"] = enumType;
const nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
const promiseType = ZodPromise.create;
exports.promise = promiseType;
const effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
const optionalType = ZodOptional.create;
exports.optional = optionalType;
const nullableType = ZodNullable.create;
exports.nullable = nullableType;
const preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;
const pipelineType = ZodPipeline.create;
exports.pipeline = pipelineType;
const ostring = () => stringType().optional();
exports.ostring = ostring;
const onumber = () => numberType().optional();
exports.onumber = onumber;
const oboolean = () => booleanType().optional();
exports.oboolean = oboolean;
exports.coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
exports.NEVER = parseUtil_1.INVALID;


/***/ }),

/***/ 35473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./acceleration.svg": [
		4860,
		4860
	],
	"./alert.svg": [
		42915,
		2915
	],
	"./arrow-right.svg": [
		8864,
		8864
	],
	"./arrows-left-right.svg": [
		67329,
		7329
	],
	"./arrows-up-down.svg": [
		89384,
		9384
	],
	"./basket.svg": [
		74750,
		4750
	],
	"./battery-75.svg": [
		77371,
		7371
	],
	"./battery-full.svg": [
		17748,
		7748
	],
	"./body-type-convertible.svg": [
		77055,
		7055
	],
	"./body-type-coupe.svg": [
		8164,
		8164
	],
	"./body-type-estate.svg": [
		35311,
		5311
	],
	"./body-type-hatchback.svg": [
		97221,
		7221
	],
	"./body-type-mpv.svg": [
		66479,
		6479
	],
	"./body-type-saloon.svg": [
		35065,
		5065
	],
	"./body-type-suv.svg": [
		51090,
		1090
	],
	"./building.svg": [
		60069,
		69
	],
	"./calculator.svg": [
		20053,
		53
	],
	"./calendar.svg": [
		72447,
		2447
	],
	"./call-back.svg": [
		57312,
		7312
	],
	"./camera.svg": [
		65810,
		5810
	],
	"./card.svg": [
		49679,
		9679
	],
	"./cash.svg": [
		71632,
		1632
	],
	"./charge.svg": [
		95042,
		5042
	],
	"./chat.svg": [
		80099,
		99
	],
	"./check-circle.svg": [
		28775,
		8775
	],
	"./check-square.svg": [
		57465,
		7465
	],
	"./chevron-down.svg": [
		55631,
		5631
	],
	"./chevron-left.svg": [
		69185,
		9185
	],
	"./chevron-right.svg": [
		50068,
		68
	],
	"./cinchCare-breakdown.svg": [
		17561,
		7561
	],
	"./cinchCare-servicing.svg": [
		98287,
		8287
	],
	"./cinchCare-warranty.svg": [
		82247,
		2247
	],
	"./close-circle.svg": [
		58145,
		8145
	],
	"./closed-padlock.svg": [
		31929,
		1929
	],
	"./co2.svg": [
		4618,
		4618
	],
	"./collections.svg": [
		84363,
		4363
	],
	"./compare.svg": [
		41885,
		1885
	],
	"./copy.svg": [
		80294,
		294
	],
	"./covid-circle.svg": [
		28842,
		8842
	],
	"./covid.svg": [
		96206,
		6206
	],
	"./cross.svg": [
		86753,
		6753
	],
	"./cvc.svg": [
		82804,
		2804
	],
	"./doors.svg": [
		79290,
		9290
	],
	"./edit-v2.svg": [
		13284,
		3284
	],
	"./edit.svg": [
		28590,
		8590
	],
	"./electric.svg": [
		56798,
		6798
	],
	"./engine-power.svg": [
		1339,
		1339
	],
	"./engine.svg": [
		32946,
		2946
	],
	"./error.svg": [
		96573,
		6573
	],
	"./external-link.svg": [
		77422,
		7422
	],
	"./facebook.svg": [
		84659,
		4659
	],
	"./features.svg": [
		97442,
		7442
	],
	"./filter.svg": [
		91630,
		1630
	],
	"./finance.svg": [
		36369,
		6369
	],
	"./fuel-pump.svg": [
		10057,
		57
	],
	"./fuel.svg": [
		46938,
		6938
	],
	"./full-screen.svg": [
		22288,
		2288
	],
	"./gallery.svg": [
		50186,
		186
	],
	"./go.svg": [
		11923,
		1923
	],
	"./heart-outline.svg": [
		82179,
		2179
	],
	"./heart.svg": [
		51591,
		1591
	],
	"./home-delivery.svg": [
		11728,
		1728
	],
	"./info.svg": [
		21499,
		1499
	],
	"./instagram.svg": [
		53518,
		3518
	],
	"./learner.svg": [
		13289,
		3289
	],
	"./lightbulb.svg": [
		22161,
		2161
	],
	"./linkedin.svg": [
		50695,
		695
	],
	"./location.svg": [
		93011,
		3011
	],
	"./mail.svg": [
		84432,
		4432
	],
	"./mask.svg": [
		81497,
		1497
	],
	"./menu.svg": [
		69602,
		9602
	],
	"./mileage.svg": [
		34377,
		4377
	],
	"./new-tab.svg": [
		3216,
		3216
	],
	"./number-1.svg": [
		35355,
		5355
	],
	"./number-2.svg": [
		11795,
		1795
	],
	"./number-3.svg": [
		87457,
		7457
	],
	"./number-4.svg": [
		37249,
		7249
	],
	"./open-padlock.svg": [
		11830,
		1830
	],
	"./our-commitment.svg": [
		42053,
		2053
	],
	"./owner-user.svg": [
		25515,
		5515
	],
	"./oxford-shield.svg": [
		23751,
		3751
	],
	"./paint.svg": [
		98382,
		8382
	],
	"./parent.svg": [
		61483,
		1483
	],
	"./phone.svg": [
		86279,
		6279
	],
	"./play-v2.svg": [
		76566,
		6566
	],
	"./play.svg": [
		23661,
		3661
	],
	"./plus.svg": [
		51357,
		1357
	],
	"./question-mark.svg": [
		30459,
		459
	],
	"./range.svg": [
		79640,
		9640
	],
	"./referrals.svg": [
		36751,
		6751
	],
	"./reg-plate.svg": [
		51944,
		1944
	],
	"./rotate-360.svg": [
		40947,
		947
	],
	"./rotate-ccw.svg": [
		59669,
		9669
	],
	"./rotate.svg": [
		546,
		546
	],
	"./running-cost.svg": [
		76320,
		6320
	],
	"./search.svg": [
		92328,
		2328
	],
	"./seats.svg": [
		88086,
		8086
	],
	"./settings.svg": [
		64368,
		4368
	],
	"./share.svg": [
		20827,
		827
	],
	"./shield-heart.svg": [
		81891,
		1891
	],
	"./shield.svg": [
		23260,
		3260
	],
	"./smartphone.svg": [
		76945,
		6945
	],
	"./speech.svg": [
		34971,
		4971
	],
	"./square.svg": [
		64128,
		4128
	],
	"./star-outline.svg": [
		95564,
		5564
	],
	"./star.svg": [
		35705,
		5705
	],
	"./target.svg": [
		96968,
		6968
	],
	"./tick.svg": [
		76860,
		6860
	],
	"./time.svg": [
		86979,
		6979
	],
	"./transmission.svg": [
		24650,
		4650
	],
	"./trash.svg": [
		52955,
		2955
	],
	"./twitter.svg": [
		23387,
		3387
	],
	"./user.svg": [
		75424,
		5424
	],
	"./vehicle-drive-type.svg": [
		1272,
		1272
	],
	"./vehicle-front.svg": [
		48785,
		8785
	],
	"./vehicle-side.svg": [
		30354,
		354
	],
	"./vehicle-valuation.svg": [
		29802,
		9802
	],
	"./wallet.svg": [
		86628,
		6628
	],
	"./whatsapp.svg": [
		73232,
		3232
	],
	"./x.svg": [
		57481,
		7481
	],
	"./youtube.svg": [
		10005,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35473;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 29586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ displayAlreadyInitializedError; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42818);

function displayAlreadyInitializedError(sdkName, initConfiguration) {
    if (!initConfiguration.silentMultipleInit) {
        _tools_display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error("".concat(sdkName, " is already initialized."));
    }
}
//# sourceMappingURL=displayAlreadyInitializedError.js.map

/***/ }),

/***/ 27627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25686);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93099);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);



function makePublicApi(stub) {
    var publicApi = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({
        version: "5.10.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return _tools_monitor__WEBPACK_IMPORTED_MODULE_1__/* .setDebugMode */ .yD;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0,_tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map

/***/ }),

/***/ 7411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EZ": function() { return /* binding */ DOM_EVENT; },
/* harmony export */   "Oo": function() { return /* binding */ addEventListener; },
/* harmony export */   "yw": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56376);


// We want to use a real enum (i.e. not a const enum) here, to be able to iterate over it to automatically add _ddIsTrusted in e2e tests
// eslint-disable-next-line no-restricted-syntax
var DOM_EVENT;
(function (DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["DBL_CLICK"] = "dblclick";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["TOUCH_END"] = "touchend";
    DOM_EVENT["TOUCH_MOVE"] = "touchmove";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["PAGE_SHOW"] = "pageshow";
    DOM_EVENT["FREEZE"] = "freeze";
    DOM_EVENT["RESUME"] = "resume";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
    DOM_EVENT["MOUSE_UP"] = "mouseup";
    DOM_EVENT["MOUSE_MOVE"] = "mousemove";
    DOM_EVENT["FOCUS"] = "focus";
    DOM_EVENT["BLUR"] = "blur";
    DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
    DOM_EVENT["RESIZE"] = "resize";
    DOM_EVENT["CHANGE"] = "change";
    DOM_EVENT["INPUT"] = "input";
    DOM_EVENT["PLAY"] = "play";
    DOM_EVENT["PAUSE"] = "pause";
    DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
    DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
    DOM_EVENT["STORAGE"] = "storage";
})(DOM_EVENT || (DOM_EVENT = {}));
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
            return;
        }
        if (once) {
            stop();
        }
        listener(event);
    });
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),

/***/ 60791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OC": function() { return /* binding */ getInitCookie; },
/* harmony export */   "WQ": function() { return /* binding */ getCurrentSite; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; },
/* harmony export */   "oX": function() { return /* binding */ areCookiesAuthorized; }
/* harmony export */ });
/* unused harmony export resetInitCookies */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61206);



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    var partitioned = options && options.partitioned ? ';partitioned' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function getCookie(name) {
    return (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValue */ .MY)(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
    if (!initCookieParsed) {
        initCookieParsed = (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValues */ .kq)(document.cookie);
    }
    return initCookieParsed.get(name);
}
function resetInitCookies() {
    initCookieParsed = undefined;
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_SECOND */ .WT, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ 96817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ initFetchObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11516);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93099);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6239);





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observable) {
        if (!window.fetch) {
            return;
        }
        var stop = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .S)(window, 'fetch', function (call) { return beforeSend(call, observable); }).stop;
        return stop;
    });
}
function beforeSend(_a, observable) {
    var parameters = _a.parameters, onPostCall = _a.onPostCall;
    var input = parameters[0], init = parameters[1];
    var methodFromParams = init && init.method;
    if (methodFromParams === undefined && input instanceof Request) {
        methodFromParams = input.method;
    }
    var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
    var url = input instanceof Request ? input.url : (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__/* .normalizeUrl */ .D5)(String(input));
    var startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .clocksNow */ .$I)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    // Those properties can be changed by observable subscribers
    parameters[0] = context.input;
    parameters[1] = context.init;
    onPostCall(function (responsePromise) { return afterSend(observable, responsePromise, context); });
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0,_tools_monitor__WEBPACK_IMPORTED_MODULE_4__/* .monitor */ .zk)(reportFetch), (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_4__/* .monitor */ .zk)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map

/***/ }),

/***/ 19609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; },
/* harmony export */   "Pd": function() { return /* binding */ createPageExitObservable; },
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28852);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95959);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84164);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7411);





var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable(configuration) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observable) {
        var pagehideEnabled = (0,_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .isExperimentalFeatureEnabled */ .W_)(_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .ExperimentalFeature.PAGEHIDE */ .uh.PAGEHIDE);
        var stopListeners = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListeners */ .yw)(configuration, window, [_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.FREEZE */ .EZ.FREEZE, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.PAGE_HIDE */ .EZ.PAGE_HIDE], function (event) {
            if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.PAGE_HIDE */ .EZ.PAGE_HIDE && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: PageExitReason.PAGEHIDE });
            }
            else if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.FREEZE */ .EZ.FREEZE) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__/* .noop */ .Z;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .Oo)(configuration, window, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.BEFORE_UNLOAD */ .EZ.BEFORE_UNLOAD, function () {
                observable.notify({ reason: PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
}
function isPageExitReason(reason) {
    return (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .includes */ .q9)((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .objectValues */ .TT)(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map

/***/ }),

/***/ 76842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ initXhrObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11516);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6239);
/* harmony import */ var _tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47970);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7411);






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
function createXhrObservable(configuration) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observable) {
        var stopInstrumentingStart = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .S)(XMLHttpRequest.prototype, 'open', openXhr).stop;
        var stopInstrumentingSend = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .S)(XMLHttpRequest.prototype, 'send', function (call) {
            sendXhr(call, configuration, observable);
        }).stop;
        var stopInstrumentingAbort = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .S)(XMLHttpRequest.prototype, 'abort', abortXhr).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
}
function openXhr(_a) {
    var xhr = _a.target, _b = _a.parameters, method = _b[0], url = _b[1];
    xhrContexts.set(xhr, {
        state: 'open',
        method: String(method).toUpperCase(),
        url: (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__/* .normalizeUrl */ .D5)(String(url)),
    });
}
function sendXhr(_a, configuration, observable) {
    var xhr = _a.target;
    var context = xhrContexts.get(xhr);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .clocksNow */ .$I)();
    startContext.isAborted = false;
    startContext.xhr = xhr;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .S)(xhr, 'onreadystatechange', function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            // Try to report the XHR as soon as possible, because the XHR may be mutated by the
            // application during a future event. For example, Angular is calling .abort() on
            // completed requests during an onreadystatechange event, so the status becomes '0'
            // before the request is collected.
            onEnd();
        }
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .elapsed */ ._J)(startContext.startClocks.timeStamp, (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .timeStampNow */ .n$)());
        completeContext.status = xhr.status;
        observable.notify((0,_tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__/* .shallowClone */ .mv)(completeContext));
    };
    var unsubscribeLoadEndListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .addEventListener */ .Oo)(configuration, xhr, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr(_a) {
    var xhr = _a.target;
    var context = xhrContexts.get(xhr);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map

/***/ }),

/***/ 66869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jj": function() { return /* binding */ DefaultPrivacyLevel; },
  "JZ": function() { return /* binding */ serializeConfiguration; },
  "fP": function() { return /* binding */ validateAndBuildConfiguration; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
var catchUserErrors = __webpack_require__(25686);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js + 6 modules
var sessionStore = __webpack_require__(42133);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var trackingConsent = __webpack_require__(11198);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(6239);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js





function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function (api, payload) {
            var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        trackType: trackType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        var normalizedProxyUrl_1 = (0,urlPolyfill/* normalizeUrl */.D5)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    if (typeof proxy === 'function') {
        return function (parameters) { return proxy({ path: path, parameters: parameters }); };
    }
    var host = buildEndpointHost(initConfiguration);
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites/* INTAKE_SITE_US1 */.D_ : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites/* INTAKE_SITE_US1 */.D_) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites/* INTAKE_SITE_US1 */.D_);
    }
    if (site === intakeSites/* INTAKE_SITE_FED_STAGING */.by) {
        return "http-intake.logs.".concat(site);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("5.10.0"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.COLLECT_FLUSH_REASON */.uh.COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.10.0")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0,stringUtils/* generateUUID */.DO)()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (trackType === 'rum') {
        parameters.push("batch_time=".concat((0,timeUtils/* timeStampNow */.n$)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display/* display.warn */.jf.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0,polyfills/* objectValues */.TT)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0,polyfills/* assign */.f0)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites/* INTAKE_SITE_US1 */.D_,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0,polyfills/* assign */.f0)({}, initConfiguration, {
        site: intakeSites/* INTAKE_SITE_US1 */.D_,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0,polyfills/* objectValues */.TT)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0,polyfills/* assign */.f0)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js











var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c, _d;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display/* display.error */.jf.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sessionSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.sessionSampleRate)) {
        display/* display.error */.jf.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetrySampleRate)) {
        display/* display.error */.jf.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetryConfigurationSampleRate)) {
        display/* display.error */.jf.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.trackingConsent !== undefined &&
        !(0,objectUtils/* objectHasValue */.E5)(trackingConsent/* TrackingConsent */.h, initConfiguration.trackingConsent)) {
        display/* display.error */.jf.error('Tracking Consent should be either "granted" or "not-granted"');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        (0,experimentalFeatures/* addExperimentalFeatures */.vn)(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return (0,objectUtils/* objectHasValue */.E5)(experimentalFeatures/* ExperimentalFeature */.uh, flag);
        }));
    }
    return (0,polyfills/* assign */.f0)({
        beforeSend: initConfiguration.beforeSend && (0,catchUserErrors/* catchUserErrors */.Z)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0,sessionStore/* selectSessionStoreStrategyType */.hB)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        trackingConsent: (_d = initConfiguration.trackingConsent) !== null && _d !== void 0 ? _d : trackingConsent/* TrackingConsent.GRANTED */.h.GRANTED,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * byteUtils/* ONE_KIBI_BYTE */.Hi,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * timeUtils/* ONE_SECOND */.WT),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * byteUtils/* ONE_KIBI_BYTE */.Hi,
    }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),

/***/ 61280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "Ds": function() { return /* binding */ INTAKE_SITE_EU1; },
/* harmony export */   "by": function() { return /* binding */ INTAKE_SITE_FED_STAGING; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map

/***/ }),

/***/ 78710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getConnectivity; }
/* harmony export */ });
function getConnectivity() {
    var _a;
    var navigator = window.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map

/***/ }),

/***/ 78587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ initConsoleObservable; }
/* harmony export */ });
/* unused harmony export resetConsoleObservable */
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30331);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42818);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93099);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53185);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95959);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41192);
/* harmony import */ var _error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18666);








var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .mergeObservables.apply */ .$.apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function (observable) {
        var originalConsoleApi = _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api];
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .createHandlingStack */ .Xp)();
            (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = originalConsoleApi;
        };
    });
}
function buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    var causes;
    if (api === _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .ConsoleApiName.error */ .vA.error) {
        var firstErrorParam = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .find */ .sE)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .toStackTraceString */ .P3)((0,_error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(firstErrorParam)) : undefined;
        fingerprint = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .tryToGetFingerprint */ .un)(firstErrorParam);
        causes = firstErrorParam ? (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .flattenErrorCauses */ .mD)(firstErrorParam, 'console') : undefined;
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
        causes: causes,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param);
    }
    if (param instanceof Error) {
        return (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .formatErrorMessage */ .jN)((0,_error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(param));
    }
    return (0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map

/***/ }),

/***/ 79217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ createContextManager; }
/* harmony export */ });
/* harmony import */ var _tools_mergeInto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20377);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74505);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53185);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);




function createContextManager(customerDataTracker) {
    var context = {};
    var changeObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y();
    var contextManager = {
        getContext: function () { return (0,_tools_mergeInto__WEBPACK_IMPORTED_MODULE_1__/* .deepClone */ .I8)(context); },
        setContext: function (newContext) {
            if ((0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_2__/* .getType */ .o)(newContext) === 'object') {
                context = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__/* .sanitize */ .N)(newContext);
                customerDataTracker.updateCustomerData(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_3__/* .sanitize */ .N)(property);
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            customerDataTracker.updateCustomerData(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            customerDataTracker.resetCustomerData();
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map

/***/ }),

/***/ 46261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iv": function() { return /* binding */ createCustomerDataTrackerManager; }
/* harmony export */ });
/* unused harmony exports CUSTOMER_DATA_BYTES_LIMIT, CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT, BYTES_COMPUTATION_THROTTLING_DELAY, createCustomerDataTracker */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84164);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41192);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42818);
/* harmony import */ var _tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47970);





// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createCustomerDataTrackerManager(compressionStatus) {
    if (compressionStatus === void 0) { compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */; }
    var customerDataTrackers = new Map();
    var alreadyWarned = false;
    function checkCustomerDataLimit(initialBytesCount) {
        if (initialBytesCount === void 0) { initialBytesCount = 0; }
        if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
            return;
        }
        var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */
            ? CUSTOMER_DATA_BYTES_LIMIT
            : CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
        var bytesCount = initialBytesCount;
        customerDataTrackers.forEach(function (tracker) {
            bytesCount += tracker.getBytesCount();
        });
        if (bytesCount > bytesCountLimit) {
            displayCustomerDataLimitReachedWarning(bytesCountLimit);
            alreadyWarned = true;
        }
    }
    return {
        /**
         * Creates a detached tracker. The manager will not store a reference to that tracker, and the
         * bytes count will be counted independently from other detached trackers.
         *
         * This is particularly useful when we don't know when the tracker will be unused, so we don't
         * leak memory (ex: when used in Logger instances).
         */
        createDetachedTracker: function () {
            var tracker = createCustomerDataTracker(function () { return checkCustomerDataLimit(tracker.getBytesCount()); });
            return tracker;
        },
        /**
         * Creates a tracker if it doesn't exist, and returns it.
         */
        getOrCreateTracker: function (type) {
            if (!customerDataTrackers.has(type)) {
                customerDataTrackers.set(type, createCustomerDataTracker(checkCustomerDataLimit));
            }
            return customerDataTrackers.get(type);
        },
        setCompressionStatus: function (newCompressionStatus) {
            if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
                compressionStatus = newCompressionStatus;
                checkCustomerDataLimit();
            }
        },
        getCompressionStatus: function () { return compressionStatus; },
        stop: function () {
            customerDataTrackers.forEach(function (tracker) { return tracker.stop(); });
            customerDataTrackers.clear();
        },
    };
}
function createCustomerDataTracker(checkCustomerDataLimit) {
    var bytesCountCache = 0;
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var _a = (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .throttle */ .P)(function (context) {
        bytesCountCache = (0,_tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt)((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_2__/* .jsonStringify */ .l)(context));
        checkCustomerDataLimit();
    }, BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelComputeBytesCount = _a.cancel;
    var resetBytesCount = function () {
        cancelComputeBytesCount();
        bytesCountCache = 0;
    };
    return {
        updateCustomerData: function (context) {
            if ((0,_tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_3__/* .isEmptyObject */ .Qr)(context)) {
                resetBytesCount();
            }
            else {
                computeBytesCountThrottled(context);
            }
        },
        resetCustomerData: resetBytesCount,
        getBytesCount: function () { return bytesCountCache; },
        stop: function () {
            cancelComputeBytesCount();
        },
    };
}
function displayCustomerDataLimitReachedWarning(bytesCountLimit) {
    _tools_display__WEBPACK_IMPORTED_MODULE_4__/* .display.warn */ .jf.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}
//# sourceMappingURL=customerDataTracker.js.map

/***/ }),

/***/ 96285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ue": function() { return /* binding */ storeContextManager; }
/* harmony export */ });
/* unused harmony exports buildStorageKey, removeStorageListeners */
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7411);
/* harmony import */ var _tools_mergeInto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20377);


var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
    var storageKey = buildStorageKey(productKey, customerDataType);
    storageListeners.push((0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* .addEventListener */ .Oo)(configuration, window, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_0__/* .DOM_EVENT.STORAGE */ .EZ.STORAGE, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    contextManager.setContext((0,_tools_mergeInto__WEBPACK_IMPORTED_MODULE_1__/* .combine */ .$e)(getFromStorage(), contextManager.getContext()));
    function synchronizeWithStorage() {
        contextManager.setContext(getFromStorage());
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
    function getFromStorage() {
        var rawContext = localStorage.getItem(storageKey);
        return rawContext !== null ? JSON.parse(rawContext) : {};
    }
}
function buildStorageKey(productKey, customerDataType) {
    return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function removeStorageListeners() {
    storageListeners.map(function (listener) { return listener.stop(); });
}
//# sourceMappingURL=storeContextManager.js.map

/***/ }),

/***/ 18666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; },
/* harmony export */   "f": function() { return /* binding */ computeStackTraceFromOnErrorMessage; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */

var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .startsWith */ .Ny)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
    var stack = [{ url: url, column: column, line: line }];
    var _a = tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack,
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),

/***/ 30331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ computeRawError; },
/* harmony export */   "K$": function() { return /* binding */ NO_ERROR_STACK_PRESENT_MESSAGE; },
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "mD": function() { return /* binding */ flattenErrorCauses; },
/* harmony export */   "u5": function() { return /* binding */ getFileFromStackTraceString; },
/* harmony export */   "un": function() { return /* binding */ tryToGetFingerprint; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93099);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53185);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84164);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41192);
/* harmony import */ var _computeStackTrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18666);





var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__/* .sanitize */ .N)(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .Z)();
        }
    }
    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
        var stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 10494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map

/***/ }),

/***/ 54478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ trackRuntimeError; }
/* harmony export */ });
/* unused harmony exports instrumentOnError, instrumentUnhandledRejection */
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11516);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853);
/* harmony import */ var _computeStackTrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18666);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30331);
/* harmony import */ var _error_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10494);





function trackRuntimeError(errorObservable) {
    var handleRuntimeError = function (stackTrace, originalError) {
        var rawError = (0,_error__WEBPACK_IMPORTED_MODULE_0__/* .computeRawError */ .AP)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .clocksNow */ .$I)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: _error_types__WEBPACK_IMPORTED_MODULE_2__/* .ErrorSource.SOURCE */ .z.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
        errorObservable.notify(rawError);
    };
    var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
function instrumentOnError(callback) {
    return (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__/* .instrumentMethod */ .S)(window, 'onerror', function (_a) {
        var _b = _a.parameters, messageObj = _b[0], url = _b[1], line = _b[2], column = _b[3], errorObj = _b[4];
        var stackTrace;
        if (errorObj instanceof Error) {
            stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(errorObj);
        }
        else {
            stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTraceFromOnErrorMessage */ .f)(messageObj, url, line, column);
        }
        callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
    });
}
function instrumentUnhandledRejection(callback) {
    return (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__/* .instrumentMethod */ .S)(window, 'onunhandledrejection', function (_a) {
        var e = _a.parameters[0];
        var reason = e.reason || 'Empty reason';
        var stack = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(reason);
        callback(stack, reason);
    });
}
//# sourceMappingURL=trackRuntimeError.js.map

/***/ }),

/***/ 76427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ createEventRateLimiter; }
/* harmony export */ });
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48399);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853);
/* harmony import */ var _error_error_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10494);



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                (0,_tools_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                    eventCount = 0;
                }, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: _error_error_types__WEBPACK_IMPORTED_MODULE_2__/* .ErrorSource.AGENT */ .z.AGENT,
                        startClocks: (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .clocksNow */ .$I)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map

/***/ }),

/***/ 11954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ RawReportType; },
/* harmony export */   "v": function() { return /* binding */ initReportObservable; }
/* harmony export */ });
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30331);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93099);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87658);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7411);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61206);






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    var observables = [];
    if ((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .includes */ .q9)(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .mergeObservables.apply */ .$.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function (observable) {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
}
function createCspViolationReportObservable(configuration) {
    return new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function (observable) {
        var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .addEventListener */ .Oo)(configuration, document, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .DOM_EVENT.SECURITY_POLICY_VIOLATION */ .EZ.SECURITY_POLICY_VIOLATION, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
}
function buildRawReportFromReport(report) {
    var type = report.type, body = report.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        originalReport: report,
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__/* .safeTruncate */ ._z)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
        originalReport: event,
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? (0,_error_error__WEBPACK_IMPORTED_MODULE_5__/* .toStackTraceString */ .P3)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map

/***/ }),

/***/ 26216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "s": function() { return /* binding */ SESSION_EXPIRATION_DELAY; }
/* harmony export */ });
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);

var SESSION_TIME_OUT_DELAY = 4 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
var SESSION_EXPIRATION_DELAY = 15 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
//# sourceMappingURL=sessionConstants.js.map

/***/ }),

/***/ 42972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ startSessionManager; }
/* harmony export */ });
/* unused harmony exports VISIBILITY_CHECK_DELAY, stopSessionManager */
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87658);
/* harmony import */ var _tools_valueHistory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53769);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7411);
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48399);
/* harmony import */ var _sessionConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26216);
/* harmony import */ var _sessionStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42133);







var VISIBILITY_CHECK_DELAY = _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
var SESSION_CONTEXT_TIMEOUT_DELAY = _sessionConstants__WEBPACK_IMPORTED_MODULE_1__/* .SESSION_TIME_OUT_DELAY */ .T;
var stopCallbacks = [];
function startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
    var renewObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_2__/* .Observable */ .y();
    var expireObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_2__/* .Observable */ .y();
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0,_sessionStore__WEBPACK_IMPORTED_MODULE_3__/* .startSessionStore */ .vH)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new _tools_valueHistory__WEBPACK_IMPORTED_MODULE_4__/* .ValueHistory */ .P(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
        renewObservable.notify();
    });
    sessionStore.expireObservable.subscribe(function () {
        expireObservable.notify();
        sessionContextHistory.closeActive((0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
    });
    // We expand/renew session unconditionally as tracking consent is always granted when the session
    // manager is started.
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .clocksOrigin */ .cQ)().relative);
    trackingConsentState.observable.subscribe(function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
        else {
            sessionStore.expire();
        }
    });
    trackActivity(configuration, function () {
        if (trackingConsentState.isGranted()) {
            sessionStore.expandOrRenewSession();
        }
    });
    trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: sessionStore.expire,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(configuration, expandOrRenewSession) {
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .addEventListeners */ .yw)(configuration, window, [_browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .DOM_EVENT.CLICK */ .EZ.CLICK, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .DOM_EVENT.TOUCH_START */ .EZ.TOUCH_START, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .DOM_EVENT.KEY_DOWN */ .EZ.KEY_DOWN, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .DOM_EVENT.SCROLL */ .EZ.SCROLL], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .addEventListener */ .Oo)(configuration, document, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = (0,_tools_timer__WEBPACK_IMPORTED_MODULE_6__/* .setInterval */ .Zi)(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        (0,_tools_timer__WEBPACK_IMPORTED_MODULE_6__/* .clearInterval */ .cv)(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map

/***/ }),

/***/ 42133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ selectSessionStoreStrategyType; },
  "vH": function() { return /* binding */ startSessionStore; }
});

// UNUSED EXPORTS: STORAGE_POLL_DELAY

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(26216);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(89741);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(60791);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return (0,objectUtils/* isEmptyObject */.Qr)(session);
}
function expandSessionState(session) {
    session.expire = String((0,timeUtils/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.s);
}
function toSessionString(session) {
    return (0,polyfills/* objectEntries */.qP)(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = (0,cookie/* getInitCookie */.OC)(SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = (0,cookie/* getInitCookie */.OC)(OLD_SESSION_COOKIE_NAME);
        var oldRumType = (0,cookie/* getInitCookie */.OC)(OLD_RUM_COOKIE_NAME);
        var oldLogsType = (0,cookie/* getInitCookie */.OC)(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (!isSessionInExpiredState(session)) {
            expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js






function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return (0,cookie/* areCookiesAuthorized */.oX)(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: (0,browserDetection/* isChromium */.mJ)(),
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        (0,cookie/* setCookie */.d8)(SESSION_STORE_KEY, toSessionString(session), sessionConstants/* SESSION_EXPIRATION_DELAY */.s, options);
    };
}
function retrieveSessionCookie() {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        (0,cookie/* deleteCookie */.kT)(SESSION_STORE_KEY, options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure =
        !!initConfiguration.useSecureSessionCookie ||
            !!initConfiguration.usePartitionedCrossSiteSessionCookie ||
            !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite =
        !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0,cookie/* getCurrentSite */.WQ)();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = (0,stringUtils/* generateUUID */.DO)();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(SESSION_STORE_KEY);
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js



var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0,stringUtils/* generateUUID */.DO)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (isSessionInExpiredState(processedSession)) {
            clearSession();
        }
        else {
            expandSessionState(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0,timer/* setTimeout */.iK)(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js









/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = timeUtils/* ONE_SECOND */.WT;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new observable/* Observable */.y();
    var expireObservable = new observable/* Observable */.y();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : initLocalStorageStrategy();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0,timer/* setInterval */.Zi)(watchSession, STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        processSessionStoreOperations({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0,stringUtils/* generateUUID */.DO)();
            sessionState.created = String((0,timeUtils/* dateNow */.m6)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || (0,timeUtils/* dateNow */.m6)() - Number(sessionState.created) < sessionConstants/* SESSION_TIME_OUT_DELAY */.T) &&
            (sessionState.expire === undefined || (0,timeUtils/* dateNow */.m6)() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: (0,functionUtils/* throttle */.P)(expandOrRenewSession, STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            (0,timer/* clearInterval */.cv)(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map

/***/ }),

/***/ 27478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ getSyntheticsTestId; },
/* harmony export */   "QB": function() { return /* binding */ getSyntheticsResultId; },
/* harmony export */   "Y9": function() { return /* binding */ willSyntheticsInjectRum; }
/* harmony export */ });
/* unused harmony exports SYNTHETICS_TEST_ID_COOKIE_NAME, SYNTHETICS_RESULT_ID_COOKIE_NAME, SYNTHETICS_INJECTS_RUM_COOKIE_NAME */
/* harmony import */ var _browser_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60791);

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map

/***/ }),

/***/ 41887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "VG": function() { return /* binding */ isTelemetryReplicationAllowed; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, resetTelemetry, scrubCustomerFrames, startFakeTelemetry

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(41192);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(18666);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
var connectivity = __webpack_require__(78710);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js















var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new tools_observable/* Observable */.y();
    telemetryConfiguration.telemetryEnabled =
        !(0,polyfills/* includes */.q9)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0,numberUtils/* performDraw */.y7)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = getRuntimeEnvInfo();
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0,sendToExtension/* sendToExtension */.j)('telemetry', event_1);
        }
    };
    (0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
    (0,polyfills/* assign */.f0)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0,mergeInto/* combine */.$e)({
            type: 'telemetry',
            date: (0,timeUtils/* timeStampNow */.n$)(),
            service: telemetryService,
            version: "5.10.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: (0,mergeInto/* combine */.$e)(event, {
                runtime_env: runtimeEnvInfo,
                connectivity: (0,connectivity/* getConnectivity */.T)(),
            }),
            experimental_features: (0,polyfills/* arrayFrom */.Oc)((0,experimentalFeatures/* getExperimentalFeatures */.u0)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
    (0,monitor/* displayIfDebugEnabled */.DV)(display/* ConsoleApiName.debug */.vA.debug, message, context);
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e, context) {
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0,error/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error/* NO_ERROR_STACK_PRESENT_MESSAGE */.K$,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat((0,jsonStringify/* jsonStringify */.l)(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0,polyfills/* startsWith */.Ny)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),

/***/ 11198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ createTrackingConsentState; },
/* harmony export */   "h": function() { return /* binding */ TrackingConsent; }
/* harmony export */ });
/* harmony import */ var _tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28852);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);


var TrackingConsent = {
    GRANTED: 'granted',
    NOT_GRANTED: 'not-granted',
};
function createTrackingConsentState(currentConsent) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y();
    return {
        tryToInit: function (trackingConsent) {
            if (!currentConsent) {
                currentConsent = trackingConsent;
            }
        },
        update: function (trackingConsent) {
            currentConsent = trackingConsent;
            observable.notify();
        },
        isGranted: function () {
            return (!(0,_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .isExperimentalFeatureEnabled */ .W_)(_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .ExperimentalFeature.TRACKING_CONSENT */ .uh.TRACKING_CONSENT) ||
                currentConsent === TrackingConsent.GRANTED);
        },
        observable: observable,
    };
}
//# sourceMappingURL=trackingConsent.js.map

/***/ }),

/***/ 17662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ sanitizeUser; },
/* harmony export */   "z": function() { return /* binding */ checkUser; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74505);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__/* .getType */ .o)(newUser) === 'object';
    if (!isValid) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map

/***/ }),

/***/ 77357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ AbstractLifeCycle; }
/* harmony export */ });
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map

/***/ }),

/***/ 84554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BoundedBuffer; }
/* harmony export */ });
/* harmony import */ var _utils_arrayUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50985);

var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.remove = function (callback) {
        (0,_utils_arrayUtils__WEBPACK_IMPORTED_MODULE_0__/* .removeItem */ .c)(this.buffer, callback);
    };
    BoundedBuffer.prototype.drain = function (arg) {
        this.buffer.forEach(function (callback) { return callback(arg); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map

/***/ }),

/***/ 25686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42818);

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),

/***/ 42818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "jG": function() { return /* binding */ globalConsole; },
/* harmony export */   "jf": function() { return /* binding */ display; },
/* harmony export */   "vA": function() { return /* binding */ ConsoleApiName; }
/* harmony export */ });
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
    originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
    debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
    log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
    info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
    warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
    error: originalConsoleMethods.error.bind(globalConsole, PREFIX),
};
//# sourceMappingURL=display.js.map

/***/ }),

/***/ 68737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ createIdentityEncoder; }
/* harmony export */ });
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);

function createIdentityEncoder() {
    var output = '';
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty() {
            return !output;
        },
        write: function (data, callback) {
            var additionalEncodedBytesCount = (0,_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) {
                callback(additionalEncodedBytesCount);
            }
        },
        finish: function (callback) {
            callback(this.finishSync());
        },
        finishSync: function () {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: '',
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function (data) {
            return data.length;
        },
    };
}
//# sourceMappingURL=encoder.js.map

/***/ }),

/***/ 28852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; },
/* harmony export */   "uh": function() { return /* binding */ ExperimentalFeature; },
/* harmony export */   "vn": function() { return /* binding */ addExperimentalFeatures; }
/* harmony export */ });
/* unused harmony export resetExperimentalFeatures */
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["ZERO_LCP_TELEMETRY"] = "zero_lcp_telemetry";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
    ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
    ExperimentalFeature["TRACKING_CONSENT"] = "tracking_consent";
    ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; }
/* harmony export */ });
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map

/***/ }),

/***/ 56376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1692);

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = (0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),

/***/ 11516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "X": function() { return /* binding */ instrumentSetter; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48399);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84164);



/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall) {
    var original = targetPrototype[method];
    var instrumentation = createInstrumentedMethod(original, onPreCall);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return instrumentation.apply(this, arguments);
    };
    targetPrototype[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (targetPrototype[method] === instrumentationWrapper) {
                targetPrototype[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function createInstrumentedMethod(original, onPreCall) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return function () {
        var parameters = arguments;
        var result;
        var postCallCallback;
        (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(onPreCall, null, [
            {
                target: this,
                parameters: parameters,
                onPostCall: function (callback) {
                    postCallCallback = callback;
                },
            },
        ]);
        if (typeof original === 'function') {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            result = original.apply(this, parameters);
        }
        if (postCallCallback) {
            (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(postCallCallback, null, [result]);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return result;
    };
}
function instrumentSetter(targetPrototype, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z };
    }
    var stoppedInstrumentation = _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z;
    var instrumentation = function (target, value) {
        // put hooked setter into event loop to avoid of set latency
        (0,_timer__WEBPACK_IMPORTED_MODULE_2__/* .setTimeout */ .iK)(function () {
            if (instrumentation !== stoppedInstrumentation) {
                after(target, value);
            }
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(targetPrototype, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(targetPrototype, property, originalDescriptor);
            }
            instrumentation = stoppedInstrumentation;
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),

/***/ 20377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "I8": function() { return /* binding */ deepClone; }
/* harmony export */ });
/* unused harmony export mergeInto */
/* harmony import */ var _utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74505);

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = (0,_utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .o)(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map

/***/ }),

/***/ 93099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ displayIfDebugEnabled; },
/* harmony export */   "L6": function() { return /* binding */ callMonitored; },
/* harmony export */   "P_": function() { return /* binding */ startMonitorErrorCollection; },
/* harmony export */   "Th": function() { return /* binding */ monitored; },
/* harmony export */   "yD": function() { return /* binding */ setDebugMode; },
/* harmony export */   "zk": function() { return /* binding */ monitor; }
/* harmony export */ });
/* unused harmony export resetMonitor */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42818);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(e);
            }
        }
    }
}
function displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugMode) {
        _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error.apply */ .jf.error.apply(_display__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jf, __spreadArray(['[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),

/***/ 87658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ mergeObservables; },
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return new Observable(function (globalObservable) {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
}
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 57717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ readBytesFromStream; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84164);


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map

/***/ }),

/***/ 15017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),

/***/ 41192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ jsonStringify; },
/* harmony export */   "y": function() { return /* binding */ detachToJsonMethod; }
/* harmony export */ });
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84164);

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
}
//# sourceMappingURL=jsonStringify.js.map

/***/ }),

/***/ 53185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _jsonStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41192);



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Object.prototype);
    var restoreArrayPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    _display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .jf.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map

/***/ }),

/***/ 48399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zi": function() { return /* binding */ setInterval; },
/* harmony export */   "cv": function() { return /* binding */ clearInterval; },
/* harmony export */   "gr": function() { return /* binding */ clearTimeout; },
/* harmony export */   "iK": function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* harmony import */ var _getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56376);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93099);
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1692);



function setTimeout(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setTimeout')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearTimeout(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearTimeout')(timeoutId);
}
function setInterval(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setInterval')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearInterval(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ 50985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ removeDuplicates; },
/* harmony export */   "c": function() { return /* binding */ removeItem; }
/* harmony export */ });
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);

function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return (0,_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .arrayFrom */ .Oc)(set);
}
function removeItem(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) {
        array.splice(index, 1);
    }
}
//# sourceMappingURL=arrayUtils.js.map

/***/ }),

/***/ 89741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "mJ": function() { return /* binding */ isChromium; },
/* harmony export */   "w1": function() { return /* binding */ isIE; }
/* harmony export */ });
/* unused harmony export detectBrowser */
function isIE() {
    return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
    return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
    return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
    return browserCache !== null && browserCache !== void 0 ? browserCache : (browserCache = detectBrowser());
}
// Exported only for tests
function detectBrowser(browserWindow) {
    var _a;
    if (browserWindow === void 0) { browserWindow = window; }
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
        return 1 /* Browser.CHROMIUM */;
    }
    if (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 ||
        (/safari/i.test(userAgent) && !/chrome|android/i.test(userAgent))) {
        return 2 /* Browser.SAFARI */;
    }
    if (browserWindow.document.documentMode) {
        return 0 /* Browser.IE */;
    }
    return 3 /* Browser.OTHER */;
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),

/***/ 10160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "Kb": function() { return /* binding */ concatBuffers; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; }
/* harmony export */ });
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map

/***/ }),

/***/ 84164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throttle; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48399);

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .clearTimeout */ .gr)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map

/***/ }),

/***/ 76135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "y7": function() { return /* binding */ performDraw; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; }
/* harmony export */ });
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map

/***/ }),

/***/ 47970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "mv": function() { return /* binding */ shallowClone; }
/* harmony export */ });
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);

function shallowClone(object) {
    return (0,_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map

/***/ }),

/***/ 95959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ elementMatches; },
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "Ny": function() { return /* binding */ startsWith; },
/* harmony export */   "Oc": function() { return /* binding */ arrayFrom; },
/* harmony export */   "QA": function() { return /* binding */ cssEscape; },
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "f0": function() { return /* binding */ assign; },
/* harmony export */   "pn": function() { return /* binding */ endsWith; },
/* harmony export */   "q9": function() { return /* binding */ includes; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; },
/* harmony export */   "sE": function() { return /* binding */ find; }
/* harmony export */ });
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map

/***/ }),

/***/ 98744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isServerError; },
/* harmony export */   "u": function() { return /* binding */ tryToClone; }
/* harmony export */ });
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map

/***/ }),

/***/ 61206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ generateUUID; },
/* harmony export */   "MY": function() { return /* binding */ findCommaSeparatedValue; },
/* harmony export */   "_z": function() { return /* binding */ safeTruncate; },
/* harmony export */   "kq": function() { return /* binding */ findCommaSeparatedValues; }
/* harmony export */ });
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) {
                return match[2];
            }
        }
        else {
            break;
        }
    }
}
function findCommaSeparatedValues(rawString) {
    var result = new Map();
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            result.set(match[1], match[2]);
        }
        else {
            break;
        }
    }
    return result;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map

/***/ }),

/***/ 853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "Cn": function() { return /* binding */ looksLikeRelativeTime; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "QA": function() { return /* binding */ currentDrift; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "c0": function() { return /* binding */ toServerDuration; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "lO": function() { return /* binding */ timeStampToClocks; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "ni": function() { return /* binding */ getRelativeTime; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, ONE_YEAR, getTimeStamp, resetNavigationStart */
/* harmony import */ var _numberUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76135);

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function timeStampToClocks(timeStamp) {
    return { relative: getRelativeTime(timeStamp), timeStamp: timeStamp };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!(0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(duration)) {
        return duration;
    }
    return (0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),

/***/ 74505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getType; }
/* harmony export */ });
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),

/***/ 6239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* harmony import */ var _serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41192);

function normalizeUrl(url) {
    return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0,_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),

/***/ 53769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ValueHistory; }
/* harmony export */ });
/* unused harmony export CLEAR_OLD_VALUES_INTERVAL */
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48399);
/* harmony import */ var _utils_arrayUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50985);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);



var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .setInterval */ .Zi)(function () { return _this.clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                (0,_utils_arrayUtils__WEBPACK_IMPORTED_MODULE_2__/* .removeItem */ .c)(_this.entries, entry);
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .addDuration */ .WK)(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .clearInterval */ .cv)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());

//# sourceMappingURL=valueHistory.js.map

/***/ }),

/***/ 52325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getEventBridge; },
/* harmony export */   "x": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95959);
/* harmony import */ var _tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1692);


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__/* .endsWith */ .pn)(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),

/***/ 13152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchKeepAliveStrategy, sendXHR

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(7411);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var MAX_ONGOING_BYTES_COUNT = 80 * byteUtils/* ONE_KIBI_BYTE */.Hi;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * byteUtils/* ONE_MEBI_BYTE */.X9;
var MAX_BACKOFF_TIME = timeUtils/* ONE_MINUTE */.yR;
var INITIAL_BACKOFF_TIME = timeUtils/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    (0,timer/* setTimeout */.iK)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / byteUtils/* ONE_MEBI_BYTE */.X9, "MiB"),
            source: error_types/* ErrorSource.AGENT */.z.AGENT,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            (0,responseUtils/* isServerError */.o)(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0,telemetry/* addTelemetryError */.Sz)(e);
    }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then((0,monitor/* monitor */.zk)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0,monitor/* monitor */.zk)(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    if (data instanceof Blob) {
        // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
        // automatically, so the intake request ends up being rejected with an HTTP status 415
        // Defining the header manually fixes this issue.
        request.setRequestHeader('Content-Type', data.type);
    }
    (0,addEventListener/* addEventListener */.Oo)(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),

/***/ 22556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ startBatchWithReplica; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(41192);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/batch.js





var Batch = /** @class */ (function () {
    function Batch(encoder, request, flushController, messageBytesLimit) {
        var _this = this;
        this.encoder = encoder;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function () {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function (event) {
        var upsertMessages = (0,polyfills/* objectValues */.TT)(this.upsertBuffer).join('\n');
        this.upsertBuffer = {};
        var isPageExit = (0,pageExitObservable/* isPageExitReason */.PT)(event.reason);
        var send = isPageExit ? this.request.sendOnExit : this.request.send;
        if (isPageExit &&
            // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
            // if the encoder is async we need to send two requests in some cases (one for encoded data
            // and the other for non-encoded data). But if it's not async, we don't have to worry about
            // it and always send a single request.
            this.encoder.isAsync) {
            var encoderResult = this.encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) {
                send(formatPayloadFromEncoder(encoderResult, event));
            }
            // Send messages that are not yet encoded at this point
            var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
            if (pendingMessages) {
                send({
                    data: pendingMessages,
                    bytesCount: (0,byteUtils/* computeBytesCount */.qt)(pendingMessages),
                    flushReason: event.reason,
                });
            }
        }
        else {
            if (upsertMessages) {
                this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            }
            this.encoder.finish(function (encoderResult) {
                send(formatPayloadFromEncoder(encoderResult, event));
            });
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var serializedMessage = (0,jsonStringify/* jsonStringify */.l)(message);
        var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= this.messageBytesLimit) {
            display/* display.warn */.jf.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(serializedMessage, estimatedMessageBytesCount, key);
    };
    Batch.prototype.push = function (serializedMessage, estimatedMessageBytesCount, key) {
        var _this = this;
        this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = serializedMessage;
            this.flushController.notifyAfterAddMessage();
        }
        else {
            this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
                _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
        this.flushController.notifyAfterRemoveMessage(messageBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());

function formatPayloadFromEncoder(encoderResult, flushEvent) {
    var data;
    if (typeof encoderResult.output === 'string') {
        data = encoderResult.output;
    }
    else {
        data = new Blob([encoderResult.output], {
            // This will set the 'Content-Type: text/plain' header. Reasoning:
            // * The intake rejects the request if there is no content type.
            // * The browser will issue CORS preflight requests if we set it to 'application/json', which
            // could induce higher intake load (and maybe has other impacts).
            // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
            // new lines.
            type: 'text/plain',
        });
    }
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
        flushReason: flushEvent.reason,
    };
}
//# sourceMappingURL=batch.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var httpRequest = __webpack_require__(13152);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new observable/* Observable */.y(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = (0,timer/* setTimeout */.iK)(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        (0,timer/* clearTimeout */.gr)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */
        notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */
        notifyAfterAddMessage: function (messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) { messageBytesCountDiff = 0; }
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js



function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary);
    var replicaBatch = replica && createBatch(configuration, replica);
    function createBatch(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return new Batch(encoder, (0,httpRequest/* createHttpRequest */.UF)(configuration, endpoint, configuration.batchBytesLimit, reportError), createFlushController({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map

/***/ }),

/***/ 39806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fy": function() { return /* binding */ datadogLogs; }
});

// UNUSED EXPORTS: HandlerType, Logger, StatusType

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(27627);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(1692);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/customerDataTracker.js
var customerDataTracker = __webpack_require__(46261);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(79217);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var trackingConsent = __webpack_require__(11198);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js
var storeContextManager = __webpack_require__(96285);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(53185);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(17662);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js
var displayAlreadyInitializedError = __webpack_require__(29586);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(18666);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, customerDataTracker, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0,contextManager/* createContextManager */.W)(customerDataTracker);
        this.contextManager.setContext(loggerContext);
        if (name) {
            this.contextManager.setContextProperty('logger', { name: name });
        }
    }
    Logger.prototype.log = function (message, messageContext, status, error) {
        if (status === void 0) { status = StatusType.info; }
        var errorContext;
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */,
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
            });
            errorContext = {
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
                causes: rawError.causes,
            };
        }
        var sanitizedMessageContext = (0,sanitize/* sanitize */.N)(messageContext);
        var context = errorContext
            ? (0,mergeInto/* combine */.$e)({ error: errorContext }, sanitizedMessageContext)
            : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0,sanitize/* sanitize */.N)(message),
            context: context,
            status: status,
        }, this);
    };
    Logger.prototype.debug = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.debug, error);
    };
    Logger.prototype.info = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.info, error);
    };
    Logger.prototype.warn = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.warn, error);
    };
    Logger.prototype.error = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.error, error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.setContext(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.getContext();
    };
    Logger.prototype.setContextProperty = function (key, value) {
        this.contextManager.setContextProperty(key, value);
    };
    Logger.prototype.removeContextProperty = function (key) {
        this.contextManager.removeContextProperty(key);
    };
    Logger.prototype.clearContext = function () {
        this.contextManager.clearContext();
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitor/* monitored */.Th
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager) {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
    };
}
//# sourceMappingURL=commonContext.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(84554);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(52325);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(66869);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(11954);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js
var arrayUtils = __webpack_require__(50985);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0,polyfills/* objectValues */.TT)(display/* ConsoleApiName */.vA), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0,polyfills/* objectValues */.TT)(reportObservable/* RawReportType */._), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0,polyfills/* includes */.q9)(forwardConsoleLogs, display/* ConsoleApiName.error */.vA.error)) {
        forwardConsoleLogs.push(display/* ConsoleApiName.error */.vA.error);
    }
    return (0,polyfills/* assign */.f0)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0,polyfills/* includes */.q9)(allowedValues, api); })))) {
        display/* display.error */.jf.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : (0,arrayUtils/* removeDuplicates */.R)(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/preStartLogs.js


function createPreStartStrategy(getCommonContext, trackingConsentState, doStartLogs) {
    var bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartLogs);
    function tryStartLogs() {
        if (!cachedConfiguration || !cachedInitConfiguration || !trackingConsentState.isGranted()) {
            return;
        }
        trackingConsentStateSubscription.unsubscribe();
        var startLogsResult = doStartLogs(cachedInitConfiguration, cachedConfiguration);
        bufferApiCalls.drain(startLogsResult);
    }
    return {
        init: function (initConfiguration) {
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            if ((0,eventBridge/* canUseEventBridge */.x)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0,displayAlreadyInitializedError/* displayAlreadyInitializedError */.W)('DD_LOGS', initConfiguration);
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartLogs();
        },
        get initConfiguration() {
            return cachedInitConfiguration;
        },
        getInternalContext: functionUtils/* noop */.Z,
        handleLog: function (message, statusType, context, date) {
            if (context === void 0) { context = getCommonContext(); }
            if (date === void 0) { date = (0,timeUtils/* timeStampNow */.n$)(); }
            bufferApiCalls.add(function (startLogsResult) { return startLogsResult.handleLog(message, statusType, context, date); });
        },
    };
}
function overrideInitConfigurationForBridge(initConfiguration) {
    return (0,polyfills/* assign */.f0)({}, initConfiguration, { clientToken: 'empty' });
}
//# sourceMappingURL=preStartLogs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js




var LOGS_STORAGE_KEY = 'logs';
function makeLogsPublicApi(startLogsImpl) {
    var customerDataTrackerManager = (0,customerDataTracker/* createCustomerDataTrackerManager */.iv)();
    var globalContextManager = (0,contextManager/* createContextManager */.W)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
    var userContextManager = (0,contextManager/* createContextManager */.W)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
    var trackingConsentState = (0,trackingConsent/* createTrackingConsentState */.H)();
    function getCommonContext() {
        return buildCommonContext(globalContextManager, userContextManager);
    }
    var strategy = createPreStartStrategy(getCommonContext, trackingConsentState, function (initConfiguration, configuration) {
        if (initConfiguration.storeContextsAcrossPages) {
            (0,storeContextManager/* storeContextManager */.ue)(configuration, globalContextManager, LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            (0,storeContextManager/* storeContextManager */.ue)(configuration, userContextManager, LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */);
        }
        var startLogsResult = startLogsImpl(initConfiguration, configuration, getCommonContext, trackingConsentState);
        strategy = createPostStartStrategy(initConfiguration, startLogsResult);
        return startLogsResult;
    });
    var customLoggers = {};
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return strategy.handleLog.apply(strategy, params);
    }, customerDataTrackerManager.createDetachedTracker());
    return (0,init/* makePublicApi */.r)({
        logger: mainLogger,
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) { return strategy.init(initConfiguration); }),
        /**
         * Set the tracking consent of the current user.
         *
         * @param {"granted" | "not-granted"} trackingConsent The user tracking consent
         *
         * Logs will be sent only if it is set to "granted". This value won't be stored by the library
         * across page loads: you will need to call this method or set the appropriate `trackingConsent`
         * field in the init() method at each page load.
         *
         * If this method is called before the init() method, the provided value will take precedence
         * over the one provided as initialization parameter.
         */
        setTrackingConsent: (0,monitor/* monitor */.zk)(function (trackingConsent) { return trackingConsentState.update(trackingConsent); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        createLogger: (0,monitor/* monitor */.zk)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return strategy.handleLog.apply(strategy, params);
            }, customerDataTrackerManager.createDetachedTracker(), (0,sanitize/* sanitize */.N)(name), conf.handler, conf.level, (0,sanitize/* sanitize */.N)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0,monitor/* monitor */.zk)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return (0,mergeInto/* deepClone */.I8)(strategy.initConfiguration); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return strategy.getInternalContext(startTime); }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
    });
}
function createPostStartStrategy(initConfiguration, startLogsResult) {
    return (0,polyfills/* assign */.f0)({
        init: function (initConfiguration) {
            (0,displayAlreadyInitializedError/* displayAlreadyInitializedError */.W)('DD_LOGS', initConfiguration);
        },
        initConfiguration: initConfiguration,
    }, startLogsResult);
}
//# sourceMappingURL=logsPublicApi.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(27478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(42972);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration, trackingConsentState) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, LOGS_SESSION_KEY, function (rawTrackingType) { return computeSessionState(configuration, rawTrackingType); }, trackingConsentState);
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
        expireObservable: sessionManager.expireObservable,
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
        expireObservable: new observable/* Observable */.y(),
    };
}
function computeTrackingType(configuration) {
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* LoggerTrackingType.NOT_TRACKED */;
    }
    return "1" /* LoggerTrackingType.TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */ || trackingType === "1" /* LoggerTrackingType.TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(76427);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(41887);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/contexts/rumInternalContext.js

var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)(),
                resultId: (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=rumInternalContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/assembly.js



function startLogsAssembly(sessionManager, configuration, lifeCycle, getCommonContext, reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0,createEventRateLimiter/* createEventRateLimiter */.K)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c;
        var rawLogsEvent = _a.rawLogsEvent, _d = _a.messageContext, messageContext = _d === void 0 ? undefined : _d, _e = _a.savedCommonContext, savedCommonContext = _e === void 0 ? undefined : _e;
        var startTime = (0,timeUtils/* getRelativeTime */.ni)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || getCommonContext();
        var log = (0,mergeInto/* combine */.$e)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, messageContext);
        if (((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (log.origin !== error_types/* ErrorSource.AGENT */.z.AGENT &&
                ((_c = logRateLimiters[log.status]) !== null && _c !== void 0 ? _c : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */, log);
    });
}
//# sourceMappingURL=assembly.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(78587);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var _a;


var LogStatusForApi = (_a = {},
    _a[display/* ConsoleApiName.log */.vA.log] = StatusType.info,
    _a[display/* ConsoleApiName.debug */.vA.debug] = StatusType.debug,
    _a[display/* ConsoleApiName.info */.vA.info] = StatusType.info,
    _a[display/* ConsoleApiName.warn */.vA.warn] = StatusType.warn,
    _a[display/* ConsoleApiName.error */.vA.error] = StatusType.error,
    _a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0,consoleObservable/* initConsoleObservable */.a)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: log.message,
                origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                error: log.api === display/* ConsoleApiName.error */.vA.error
                    ? {
                        stack: log.stack,
                        fingerprint: log.fingerprint,
                        causes: log.causes,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[reportObservable/* RawReportType.cspViolation */._.cspViolation] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.intervention */._.intervention] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.deprecation */._.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0,reportObservable/* initReportObservable */.v)(configuration, configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0,error_error/* getFileFromStackTraceString */.u5)(report.stack));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: message,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(76842);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(96817);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(57717);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var xhrSubscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* RequestType.XHR */, context);
        }
    });
    var fetchSubscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* RequestType.FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || (0,responseUtils/* isServerError */.o)(request.status))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method, // Cast resource method because of case mismatch cf issue RUMF-1152
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0,error_error/* toStackTraceString */.P3)((0,computeStackTrace/* computeStackTrace */._)(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then((0,monitor/* monitor */.zk)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0,monitor/* monitor */.zk)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* RequestType.XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0,readBytesFromStream/* readBytesFromStream */.n)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js
var trackRuntimeError = __webpack_require__(54478);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var rawErrorObservable = new observable/* Observable */.y();
    var stopRuntimeErrorTracking = (0,trackRuntimeError/* trackRuntimeError */.Lp)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    stack: rawError.stack,
                    causes: rawError.causes,
                },
                origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(77357);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/logger/loggerCollection.js
var loggerCollection_a;


var STATUS_PRIORITIES = (loggerCollection_a = {},
    loggerCollection_a[StatusType.debug] = 0,
    loggerCollection_a[StatusType.info] = 1,
    loggerCollection_a[StatusType.warn] = 2,
    loggerCollection_a[StatusType.error] = 3,
    loggerCollection_a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = (0,mergeInto/* combine */.$e)(logger.getContext(), logsMessage.context);
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            displayInConsole(logsMessage, messageContext);
        }
        if (isAuthorized(logsMessage.status, HandlerType.http, logger)) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    date: savedDate || (0,timeUtils/* timeStampNow */.n$)(),
                    message: logsMessage.message,
                    status: logsMessage.status,
                    origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                },
                messageContext: messageContext,
                savedCommonContext: savedCommonContext,
            });
        }
    }
    return {
        handleLog: handleLog,
    };
}
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && (0,polyfills/* includes */.q9)(sanitizedHandlerType, handlerType));
}
function displayInConsole(logsMessage, messageContext) {
    display/* originalConsoleMethods */.LD[logsMessage.status].call(display/* globalConsole */.jG, logsMessage.message, messageContext);
}
//# sourceMappingURL=loggerCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(22556);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/encoder.js
var encoder = __webpack_require__(68737);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session) {
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
        encoder: (0,encoder/* createIdentityEncoder */.G)(),
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
        encoder: (0,encoder/* createIdentityEncoder */.G)(),
    }, reportError, pageExitObservable, session.expireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/contexts/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/reportError.js


function startReportError(lifeCycle) {
    return function (error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: error_types/* ErrorSource.AGENT */.z.AGENT,
                status: StatusType.error,
            },
        });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
}
//# sourceMappingURL=reportError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/logsTelemetry.js



function startLogsTelemetry(initConfiguration, configuration, reportError, pageExitObservable, session) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-logs-sdk" /* TelemetryService.LOGS */, configuration);
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    var cleanupTasks = [];
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
        cleanupTasks.push(function () { return telemetrySubscription_1.unsubscribe(); });
    }
    else {
        var telemetryBatch_1 = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
            encoder: (0,encoder/* createIdentityEncoder */.G)(),
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
            encoder: (0,encoder/* createIdentityEncoder */.G)(),
        }, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function () { return telemetryBatch_1.stop(); });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function (event) {
            return telemetryBatch_1.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration));
        });
        cleanupTasks.push(function () { return telemetrySubscription_2.unsubscribe(); });
    }
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeLogsConfiguration(initConfiguration));
    return {
        telemetry: telemetry,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=logsTelemetry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, getCommonContext, 
// `startLogs` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startLogs` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var lifeCycle = new LifeCycle();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (log) { return (0,sendToExtension/* sendToExtension */.j)('logs', log); });
    var reportError = startReportError(lifeCycle);
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0,eventBridge/* canUseEventBridge */.x)() && !(0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()
        ? startLogsSessionManager(configuration, trackingConsentState)
        : startLogsSessionManagerStub(configuration);
    var stopLogsTelemetry = startLogsTelemetry(initConfiguration, configuration, reportError, pageExitObservable, session).stop;
    cleanupTasks.push(function () { return stopLogsTelemetry(); });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    startLogsAssembly(session, configuration, lifeCycle, getCommonContext, reportError);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var stopLogsBatch_1 = startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session).stop;
        cleanupTasks.push(function () { return stopLogsBatch_1(); });
    }
    else {
        startLogsBridge(lifeCycle);
    }
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/entries/main.js




var datadogLogs = makeLogsPublicApi(startLogs);
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 50163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ datadogRum; }
});

// UNUSED EXPORTS: DefaultPrivacyLevel

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(27627);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(1692);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/customerDataTracker.js
var customerDataTracker = __webpack_require__(46261);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(79217);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/trackingConsent.js
var trackingConsent = __webpack_require__(11198);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(53185);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.js
var storeContextManager = __webpack_require__(96285);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/encoder.js
var encoder = __webpack_require__(68737);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(17662);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.js
var displayAlreadyInitializedError = __webpack_require__(29586);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(84554);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(52325);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(27478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(66869);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
var typeUtils = __webpack_require__(74505);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/matchOption.js



function isMatchOption(item) {
    var itemType = (0,typeUtils/* getType */.o)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? (0,polyfills/* startsWith */.Ny)(value, item) : item === value;
            }
        }
        catch (e) {
            display/* display.error */.jf.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return ((0,typeUtils/* getType */.o)(expectedItem) === 'object' &&
        isMatchOption(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0,objectUtils/* shallowClone */.mv)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0,polyfills/* objectEntries */.qP)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0,polyfills/* find */.sE)(configuration.allowedTracingUrls, function (tracingOption) {
        return matchList([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) || (0,numberUtils/* performDraw */.y7)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/configuration.js


var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        display/* display.error */.jf.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.sessionReplaySampleRate)) {
        display/* display.error */.jf.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.traceSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.traceSampleRate)) {
        display/* display.error */.jf.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display/* display.error */.jf.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    return (0,polyfills/* assign */.f0)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
        startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
        traceSampleRate: initConfiguration.traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!initConfiguration.trackUserInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!initConfiguration.trackResources,
        trackLongTasks: !!initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0,objectUtils/* objectHasValue */.E5)(configuration_configuration/* DefaultPrivacyLevel */.Jj, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            display/* display.error */.jf.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.jf.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: DEFAULT_PROPAGATOR_TYPES });
            }
            else if (isTracingOption(option)) {
                tracingOptions_1.push(option);
            }
            else {
                display/* display.warn */.jf.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
            else if ((0,typeUtils/* getType */.o)(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    return (0,polyfills/* arrayFrom */.Oc)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var baseSerializedConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/boot/preStartRum.js


function createPreStartStrategy(_a, getCommonContext, trackingConsentState, doStartRum) {
    var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum, startDeflateWorker = _a.startDeflateWorker;
    var bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
    var firstStartViewCall;
    var deflateWorker;
    var cachedInitConfiguration;
    var cachedConfiguration;
    var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
    function tryStartRum() {
        if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
            return;
        }
        trackingConsentStateSubscription.unsubscribe();
        var initialViewOptions;
        if (cachedConfiguration.trackViewsManually) {
            if (!firstStartViewCall) {
                return;
            }
            // An initial view is always created when starting RUM.
            // When tracking views automatically, any startView call before RUM start creates an extra
            // view.
            // When tracking views manually, we use the ViewOptions from the first startView call as the
            // initial view options, and we remove the actual startView call so we don't create an extra
            // view.
            bufferApiCalls.remove(firstStartViewCall.callback);
            initialViewOptions = firstStartViewCall.options;
        }
        var startRumResult = doStartRum(cachedInitConfiguration, cachedConfiguration, deflateWorker, initialViewOptions);
        bufferApiCalls.drain(startRumResult);
    }
    return {
        init: function (initConfiguration) {
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            var eventBridgeAvailable = (0,eventBridge/* canUseEventBridge */.x)();
            if (eventBridgeAvailable) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            // Expose the initial configuration regardless of initialization success.
            cachedInitConfiguration = initConfiguration;
            if (cachedConfiguration) {
                (0,displayAlreadyInitializedError/* displayAlreadyInitializedError */.W)('DD_RUM', initConfiguration);
                return;
            }
            // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
            // to completely discard the customer application RUM instance by ignoring their init() call.
            // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
            // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
            if (ignoreInitIfSyntheticsWillInjectRum && (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
                return;
            }
            var configuration = validateAndBuildRumConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
                display/* display.warn */.jf.warn('No storage available for session. We will not send any data.');
                return;
            }
            if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
                deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', 
                // Worker initialization can fail asynchronously, especially in Firefox where even CSP
                // issues are reported asynchronously. For now, the SDK will continue its execution even if
                // data won't be sent to Datadog. We could improve this behavior in the future.
                functionUtils/* noop */.Z);
                if (!deflateWorker) {
                    // `startDeflateWorker` should have logged an error message explaining the issue
                    return;
                }
            }
            cachedConfiguration = configuration;
            trackingConsentState.tryToInit(configuration.trackingConsent);
            tryStartRum();
        },
        get initConfiguration() {
            return cachedInitConfiguration;
        },
        getInternalContext: functionUtils/* noop */.Z,
        stopSession: functionUtils/* noop */.Z,
        addTiming: function (name, time) {
            if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addTiming(name, time); });
        },
        startView: function (options, startClocks) {
            if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
            var callback = function (startRumResult) {
                startRumResult.startView(options, startClocks);
            };
            bufferApiCalls.add(callback);
            if (!firstStartViewCall) {
                firstStartViewCall = { options: options, callback: callback };
                tryStartRum();
            }
        },
        addAction: function (action, commonContext) {
            if (commonContext === void 0) { commonContext = getCommonContext(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addAction(action, commonContext); });
        },
        addError: function (providedError, commonContext) {
            if (commonContext === void 0) { commonContext = getCommonContext(); }
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addError(providedError, commonContext); });
        },
        addFeatureFlagEvaluation: function (key, value) {
            bufferApiCalls.add(function (startRumResult) { return startRumResult.addFeatureFlagEvaluation(key, value); });
        },
        startDurationVital: function (vitalStart) {
            bufferApiCalls.add(function (startRumResult) { return startRumResult.startDurationVital(vitalStart); });
        },
        stopDurationVital: function (vitalStart) {
            bufferApiCalls.add(function (startRumResult) { return startRumResult.stopDurationVital(vitalStart); });
        },
    };
}
function overrideInitConfigurationForBridge(initConfiguration) {
    return (0,polyfills/* assign */.f0)({}, initConfiguration, {
        applicationId: '00000000-aaaa-0000-aaaa-000000000000',
        clientToken: 'empty',
        sessionSampleRate: 100,
    });
}
//# sourceMappingURL=preStartRum.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, options) {
    if (options === void 0) { options = {}; }
    var customerDataTrackerManager = (0,customerDataTracker/* createCustomerDataTrackerManager */.iv)(0 /* CustomerDataCompressionStatus.Unknown */);
    var globalContextManager = (0,contextManager/* createContextManager */.W)(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
    var userContextManager = (0,contextManager/* createContextManager */.W)(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
    var trackingConsentState = (0,trackingConsent/* createTrackingConsentState */.H)();
    function getCommonContext() {
        return buildCommonContext(globalContextManager, userContextManager, recorderApi);
    }
    var strategy = createPreStartStrategy(options, getCommonContext, trackingConsentState, function (initConfiguration, configuration, deflateWorker, initialViewOptions) {
        if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.CUSTOM_VITALS */.uh.CUSTOM_VITALS)) {
            /**
             * Start a custom duration vital
             * stored in @vital.custom.<name>
             *
             * @param name name of the custom vital
             * @param options.context custom context attached to the vital
             * @param options.startTime epoch timestamp of the start of the custom vital (if not set, will use current time)
             */
            ;
            rumPublicApi.startDurationVital = (0,monitor/* monitor */.zk)(function (name, options) {
                strategy.startDurationVital({
                    name: (0,sanitize/* sanitize */.N)(name),
                    startClocks: (options === null || options === void 0 ? void 0 : options.startTime) ? (0,timeUtils/* timeStampToClocks */.lO)(options.startTime) : (0,timeUtils/* clocksNow */.$I)(),
                    context: (0,sanitize/* sanitize */.N)(options === null || options === void 0 ? void 0 : options.context),
                });
            });
            rumPublicApi.stopDurationVital = (0,monitor/* monitor */.zk)(function (name, options) {
                strategy.stopDurationVital({
                    name: (0,sanitize/* sanitize */.N)(name),
                    stopClocks: (options === null || options === void 0 ? void 0 : options.stopTime) ? (0,timeUtils/* timeStampToClocks */.lO)(options.stopTime) : (0,timeUtils/* clocksNow */.$I)(),
                    context: (0,sanitize/* sanitize */.N)(options === null || options === void 0 ? void 0 : options.context),
                });
            });
        }
        if (initConfiguration.storeContextsAcrossPages) {
            (0,storeContextManager/* storeContextManager */.ue)(configuration, globalContextManager, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            (0,storeContextManager/* storeContextManager */.ue)(configuration, userContextManager, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
        }
        customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */ : 2 /* CustomerDataCompressionStatus.Disabled */);
        var startRumResult = startRumImpl(initConfiguration, configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder
            ? function (streamId) { return options.createDeflateEncoder(configuration, deflateWorker, streamId); }
            : encoder/* createIdentityEncoder */.G, trackingConsentState);
        recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
        strategy = createPostStartStrategy(initConfiguration, startRumResult);
        return startRumResult;
    });
    var startView = (0,monitor/* monitor */.zk)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        strategy.startView(sanitizedOptions);
    });
    var rumPublicApi = (0,init/* makePublicApi */.r)({
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) { return strategy.init(initConfiguration); }),
        /**
         * Set the tracking consent of the current user.
         *
         * @param {"granted" | "not-granted"} trackingConsent The user tracking consent
         *
         * Data will be sent only if it is set to "granted". This value won't be stored by the library
         * across page loads: you will need to call this method or set the appropriate `trackingConsent`
         * field in the init() method at each page load.
         *
         * If this method is called before the init() method, the provided value will take precedence
         * over the one provided as initialization parameter.
         */
        setTrackingConsent: (0,monitor/* monitor */.zk)(function (trackingConsent) { return trackingConsentState.update(trackingConsent); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return strategy.getInternalContext(startTime); }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return (0,mergeInto/* deepClone */.I8)(strategy.initConfiguration); }),
        addAction: (0,monitor/* monitor */.zk)(function (name, context) {
            strategy.addAction({
                name: (0,sanitize/* sanitize */.N)(name),
                context: (0,sanitize/* sanitize */.N)(context),
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0,error_error/* createHandlingStack */.Xp)();
            (0,monitor/* callMonitored */.L6)(function () {
                strategy.addError({
                    error: error, // Do not sanitize error here, it is needed unserialized by computeRawError()
                    handlingStack: handlingStack,
                    context: (0,sanitize/* sanitize */.N)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                });
            });
        },
        /**
         * Add a custom timing relative to the start of the current view,
         * stored in @view.custom_timings.<timing_name>
         *
         * @param name name of the custom timing
         * @param [time] epoch timestamp of the custom timing (if not set, will use current time)
         *
         * Note: passing a relative time is discouraged since it is actually used as-is but displayed relative to the view start.
         * We currently don't provide a way to retrieve the view start time, so it can be challenging to provide a timing relative to the view start.
         * see https://github.com/DataDog/browser-sdk/issues/2552
         */
        addTiming: (0,monitor/* monitor */.zk)(function (name, time) {
            // TODO: next major decide to drop relative time support or update its behaviour
            strategy.addTiming((0,sanitize/* sanitize */.N)(name), time);
        }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
        startView: startView,
        stopSession: (0,monitor/* monitor */.zk)(function () {
            strategy.stopSession();
        }),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: (0,monitor/* monitor */.zk)(function (key, value) {
            strategy.addFeatureFlagEvaluation((0,sanitize/* sanitize */.N)(key), (0,sanitize/* sanitize */.N)(value));
        }),
        getSessionReplayLink: (0,monitor/* monitor */.zk)(function () { return recorderApi.getSessionReplayLink(); }),
        startSessionReplayRecording: (0,monitor/* monitor */.zk)(function () { return recorderApi.start(); }),
        stopSessionReplayRecording: (0,monitor/* monitor */.zk)(function () { return recorderApi.stop(); }),
    });
    return rumPublicApi;
}
function createPostStartStrategy(initConfiguration, startRumResult) {
    return (0,polyfills/* assign */.f0)({
        init: function (initConfiguration) {
            (0,displayAlreadyInitializedError/* displayAlreadyInitializedError */.W)('DD_RUM', initConfiguration);
        },
        initConfiguration: initConfiguration,
    }, startRumResult);
}
//# sourceMappingURL=rumPublicApi.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
var getZoneJsOriginalValue = __webpack_require__(56376);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    return new observable/* Observable */.y(function (observable) {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0,monitor/* monitor */.zk)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(functionUtils/* noop */.Z);
            var originalInstance = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(7411);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js

function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? addEventListener/* DOM_EVENT.LOAD */.EZ.LOAD : addEventListener/* DOM_EVENT.DOM_CONTENT_LOADED */.EZ.DOM_CONTENT_LOADED;
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(6239);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) {
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = (0,urlPolyfill/* getPathName */.ye)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(startTime, responseEnd));
    }
    return (0,timeUtils/* toServerDuration */.c0)(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0,polyfills/* assign */.f0)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(start, end)),
        start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
    node.childNodes.forEach(callback);
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * timeUtils/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0,timeUtils/* dateNow */.m6)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-id'), (0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    var cleanupTasks = [];
    retrieveInitialDocumentResourceTiming(configuration, function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0,timer/* setTimeout */.iK)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0,monitor/* monitor */.zk)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = [
            RumPerformanceEntryType.RESOURCE,
            RumPerformanceEntryType.NAVIGATION,
            RumPerformanceEntryType.LONG_TASK,
            RumPerformanceEntryType.PAINT,
        ];
        var experimentalEntries = [
            RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
            RumPerformanceEntryType.FIRST_INPUT,
            RumPerformanceEntryType.LAYOUT_SHIFT,
            RumPerformanceEntryType.EVENT,
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40,
                });
                cleanupTasks.push(function () { return observer.disconnect(); });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver_1.observe({ entryTypes: mainEntries });
        cleanupTasks.push(function () { return mainObserver_1.disconnect(); });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            var removePerformanceListener = (0,addEventListener/* addEventListener */.Oo)(configuration, performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            }).stop;
            cleanupTasks.push(removePerformanceListener);
        }
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        retrieveNavigationTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
        var stopFirstInputTiming = retrieveFirstInputTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        }).stop;
        cleanupTasks.push(stopFirstInputTiming);
    }
    return {
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function retrieveInitialDocumentResourceTiming(configuration, callback) {
    runOnReadyState(configuration, 'interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
            toJSON: function () { return (0,polyfills/* assign */.f0)({}, timing, { toJSON: undefined }); },
        };
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) &&
            performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
            timing = (0,polyfills/* assign */.f0)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0,polyfills/* assign */.f0)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(configuration, callback) {
    function sendFakeTiming() {
        callback((0,polyfills/* assign */.f0)(computeRelativePerformanceTiming(), {
            entryType: RumPerformanceEntryType.NAVIGATION,
        }));
    }
    runOnReadyState(configuration, 'complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0,timer/* setTimeout */.iK)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = (0,timeUtils/* dateNow */.m6)();
    var timingSent = false;
    var removeEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.CLICK */.EZ.CLICK, addEventListener/* DOM_EVENT.MOUSE_DOWN */.EZ.MOUSE_DOWN, addEventListener/* DOM_EVENT.KEY_DOWN */.EZ.KEY_DOWN, addEventListener/* DOM_EVENT.TOUCH_START */.EZ.TOUCH_START, addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: RumPerformanceEntryType.FIRST_INPUT,
            processingStart: (0,timeUtils/* relativeNow */._q)(),
            processingEnd: (0,timeUtils/* relativeNow */._q)(),
            startTime: evt.timeStamp,
            duration: 0, // arbitrary value to avoid nullable duration and simplify INP logic
            name: '',
        };
        if (evt.type === addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    return { stop: removeEventListeners };
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP, addEventListener/* DOM_EVENT.POINTER_CANCEL */.EZ.POINTER_CANCEL], function (event) {
            if (event.type === addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0,timeUtils/* dateNow */.m6)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0,numberUtils/* isNumber */.hj)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0,timeUtils/* getRelativeTime */.ni)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return (0,objectUtils/* objectHasValue */.E5)(RumPerformanceEntryType, entry.entryType);
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === RumPerformanceEntryType.RESOURCE && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(76427);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.js
var connectivity = __webpack_require__(78710);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)();
    var resultId = (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0,mergeInto/* deepClone */.I8)(object);
    var result = modifier(clone);
    (0,polyfills/* objectEntries */.qP)(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = (0,typeUtils/* getType */.o)(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, (0,sanitize/* sanitize */.N)(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return (0,typeUtils/* getType */.o)(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/assembly.js




var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, getCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = (0,polyfills/* assign */.f0)({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = (0,polyfills/* assign */.f0)({
            'resource.url': 'string',
        }, (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL */.uh.WRITABLE_RESOURCE_GRAPHQL) && {
            'resource.graphql': 'object',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = (0,polyfills/* assign */.f0)({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = (0,polyfills/* assign */.f0)({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["vital" /* RumEventType.VITAL */] = (0,polyfills/* assign */.f0)({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b["vital" /* RumEventType.VITAL */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("vital" /* RumEventType.VITAL */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || getCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0,timeUtils/* currentDrift */.QA)(),
                    configuration: {
                        session_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionReplaySampleRate, 3),
                    },
                    browser_sdk_version: (0,eventBridge/* canUseEventBridge */.x)() ? "5.10.0" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0,timeUtils/* timeStampNow */.n$)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: displayContext.get(),
                connectivity: (0,connectivity/* getConnectivity */.T)(),
            };
            var serverRumEvent = (0,mergeInto/* combine */.$e)(rumContext, rawRumEvent);
            serverRumEvent.context = (0,mergeInto/* combine */.$e)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (serverRumEvent.type === 'view') {
                ;
                serverRumEvent.session.sampled_for_replay = session.sessionReplayAllowed;
            }
            if (!(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0,objectUtils/* isEmptyObject */.Qr)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            display/* display.warn */.jf.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(77357);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(26216);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/valueHistory.js
var valueHistory = __webpack_require__(53769);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new valueHistory/* ValueHistory */.P(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(76842);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(96817);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(57717);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0,responseUtils/* tryToClone */.u)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
    }
    else {
        (0,readBytesFromStream/* readBytesFromStream */.n)(clonedResponse.body, function () {
            callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? functionUtils/* noop */.Z : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        var _a;
        if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(11516);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js


// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: (0,timeUtils/* timeStampNow */.n$)() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        var lastChangeTime = (0,timeUtils/* timeStampNow */.n$)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        (0,timer/* clearTimeout */.gr)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    return new observable/* Observable */.y(function (observable) {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === RumPerformanceEntryType.RESOURCE && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0,instrumentMethod/* instrumentMethod */.S)(window, 'open', callback);
}
//# sourceMappingURL=waitPageActivityEnd.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(89741);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0,polyfills/* find */.sE)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0,stringUtils/* safeTruncate */._z)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0,browserDetection/* isIE */.w1)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0,polyfills/* cssEscape */.QA)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ".").concat((0,polyfills/* cssEscape */.QA)(className));
        }
    }
}
function getTagNameSelector(element) {
    return (0,polyfills/* cssEscape */.QA)(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), "[").concat(attributeName, "=\"").concat((0,polyfills/* cssEscape */.QA)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = timeUtils/* ONE_SECOND */.WT;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0,timer/* setTimeout */.iK)(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.js

function listenActionEvents(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.SELECTION_CHANGE */.EZ.SELECTION_CHANGE, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.INPUT */.EZ.INPUT, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.js

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            timeUtils/* ONE_SECOND */.WT) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0,polyfills/* elementMatches */.Ap)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.js








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new valueHistory/* ValueHistory */.P(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new observable/* Observable */.y();
    var currentClickChain;
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents(configuration, {
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) { return history.findAll(startTime); },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: getActionNameFromElement(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0,stringUtils/* generateUUID */.DO)();
    var startClocks = (0,timeUtils/* clocksNow */.$I)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0,polyfills/* includes */.q9)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new observable/* Observable */.y();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0,timeUtils/* getRelativeTime */.ni)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0,polyfills/* assign */.f0)({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0,timeUtils/* timeStampNow */.n$)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: functionUtils/* noop */.Z };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0,timeUtils/* toServerDuration */.c0)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0,mergeInto/* combine */.$e)({
        action: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(action.startClocks.relative) },
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js
var trackRuntimeError = __webpack_require__(54478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(18666);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(78587);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = (0,consoleObservable/* initConsoleObservable */.a)([display/* ConsoleApiName.error */.vA.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(11954);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.js

function trackReportError(configuration, errorObservable) {
    var subscription = (0,reportObservable/* initReportObservable */.v)(configuration, [
        reportObservable/* RawReportType.cspViolation */._.cspViolation,
        reportObservable/* RawReportType.intervention */._.intervention,
    ]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: error_types/* ErrorSource.REPORT */.z.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
            originalError: reportError.originalReport,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.js



function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new observable/* Observable */.y();
    trackConsoleError(errorObservable);
    (0,trackRuntimeError/* trackRuntimeError */.Lp)(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.CUSTOM */.z.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.js


function startLongTaskCollection(lifeCycle, configuration, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !configuration.trackLongTasks) {
                break;
            }
            var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,stringUtils/* generateUUID */.DO)(),
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/matchRequestTiming.js


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return (0,timeUtils/* addDuration */.WK)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0,timeUtils/* addDuration */.WK)(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.js




function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        var rawEvent = processRequest(request, configuration, sessionManager, pageStateHistory);
        if (rawEvent) {
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.RESOURCE && !isRequestKind(entry)) {
                var rawEvent = processResourceEntry(entry, configuration, sessionManager, pageStateHistory);
                if (rawEvent) {
                    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
                }
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? (0,timeUtils/* relativeToClocks */.DY)(matchingTiming.startTime) : request.startClocks;
    var shouldIndex = shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    if (!shouldIndex && !tracingInfo) {
        return;
    }
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !shouldIndex,
        },
    }, tracingInfo, correspondingTimingOverrides, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming,
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
    var shouldIndex = shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    if (!shouldIndex && !tracingInfo) {
        return;
    }
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            url: entry.name,
            status_code: discardZeroStatus(entry.responseStatus),
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !shouldIndex,
        },
    }, tracingInfo, entryMetrics, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: entry,
        },
    };
}
function shouldIndexResource(configuration, sessionManager, resourceStart) {
    return configuration.trackResources && sessionManager.findTrackedSession(resourceStart.relative);
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0,polyfills/* assign */.f0)({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.RESOURCE_PAGE_STATES */.uh.RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? (0,timeUtils/* toServerDuration */.c0)(duration) : undefined;
}
/**
 * The status is 0 for cross origin resources without CORS headers, so the status is meaningless and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
    return statusCode === 0 ? undefined : statusCode;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.js

function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.js


// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.PAINT &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < FCP_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstContentfulPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstInput.js




/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0,timeUtils/* elapsed */._J)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
                firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstInput.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.js


function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0,timeUtils/* relativeNow */._q)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
//# sourceMappingURL=trackNavigationTimings.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.js



// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
var wrongLcpReported = false;
var previousLcp;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction. According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0,addEventListener/* addEventListeners */.yw)(configuration, eventTarget, [addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, addEventListener/* DOM_EVENT.KEY_DOWN */.EZ.KEY_DOWN], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var biggestLcpSize = 0;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0,polyfills/* findLast */.dF)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < LCP_MAXIMUM_DELAY &&
                // Ensure to get the LCP entry with the biggest size, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
                entry.size > biggestLcpSize;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if (lcpEntry.element) {
                lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
            }
            if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.ZERO_LCP_TELEMETRY */.uh.ZERO_LCP_TELEMETRY)) {
                monitorLcpEntries(lcpEntry, entries.filter(function (entry) {
                    return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT;
                }));
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
            });
            biggestLcpSize = lcpEntry.size;
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
function monitorLcpEntries(lcpEntry, lcpEntries) {
    if (wrongLcpReported) {
        return;
    }
    var wrongLcpDetected = lcpEntry.startTime === 0
        ? 'LCP with startTime = 0'
        : previousLcp !== undefined && lcpEntry.startTime < previousLcp.startTime
            ? 'LCP with startTime < previous LCP'
            : previousLcp !== undefined && lcpEntry.size < previousLcp.size
                ? 'LCP with size < previous LCP'
                : undefined;
    if (wrongLcpDetected) {
        wrongLcpReported = true;
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)(wrongLcpDetected, {
            debug: {
                entry: toSerializableLCP(lcpEntry),
                previousLcp: previousLcp,
                timeOrigin: performance.timeOrigin,
                now: (0,timeUtils/* relativeNow */._q)(),
                lcpEntries: lcpEntries.map(toSerializableLCP),
            },
        });
    }
    previousLcp = toSerializableLCP(lcpEntry);
}
function toSerializableLCP(entry) {
    var jsonEntry = entry.toJSON();
    delete jsonEntry.element;
    return jsonEntry;
}
//# sourceMappingURL=trackLargestContentfulPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.js

function trackFirstHidden(configuration, eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') {
        timeStamp = 0;
    }
    else {
        timeStamp = Infinity;
        (stopListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, eventTarget, [addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE, addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE], function (event) {
            if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, { capture: true }).stop);
    }
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop: function () {
            stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
        },
    };
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.js





function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = trackFirstHidden(configuration);
    var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.js




/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: functionUtils/* noop */.Z,
        };
    }
    var maxClsValue = 0;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    var cls = (0,numberUtils/* round */.NM)(maxClsValue, 4);
                    var clsTarget = window.largestLayoutShiftTarget();
                    var cslTargetSelector = void 0;
                    if (clsTarget &&
                        // Check if the CLS target have been removed from the DOM between the time we collect the target reference and when we compute the selector
                        clsTarget.isConnected) {
                        cslTargetSelector = getSelectorFromElement(clsTarget, configuration.actionNameAttribute);
                    }
                    callback({
                        value: cls,
                        targetSelector: cslTargetSelector,
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    var largestLayoutShift = 0;
    var largestLayoutShiftTarget;
    var largestLayoutShiftTime;
    return {
        update: function (entry) {
            var _a, _b;
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= timeUtils/* ONE_SECOND */.WT ||
                entry.startTime - startTime >= 5 * timeUtils/* ONE_SECOND */.WT;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
                largestLayoutShift = 0;
                largestLayoutShiftTarget = undefined;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
            if (entry.value > largestLayoutShift) {
                largestLayoutShift = entry.value;
                largestLayoutShiftTime = entry.startTime;
                if ((_a = entry.sources) === null || _a === void 0 ? void 0 : _a.length) {
                    largestLayoutShiftTarget = (_b = (0,polyfills/* find */.sE)(entry.sources, function (s) { return !!s.node && isElementNode(s.node); })) === null || _b === void 0 ? void 0 : _b.node;
                }
                else {
                    largestLayoutShiftTarget = undefined;
                }
            }
        },
        value: function () { return value; },
        largestLayoutShiftTarget: function () { return largestLayoutShiftTarget; },
        largestLayoutShiftTime: function () { return largestLayoutShiftTime; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.js
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */

var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver((0,monitor/* monitor */.zk)(function (entries) {
        entries.getEntries().forEach(function (e) {
            var entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
    return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};
//# sourceMappingURL=interactionCountPolyfill.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.js





// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = (1 * timeUtils/* ONE_MINUTE */.yR);
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!isInteractionToNextPaintSupported()) {
        return {
            getInteractionToNextPaint: function () { return undefined; },
            setViewEnd: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    var _a = trackViewInteractionCount(viewLoadingType), getViewInteractionCount = _a.getViewInteractionCount, stopViewInteractionCount = _a.stopViewInteractionCount;
    var viewEnd = Infinity;
    var longestInteractions = trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if ((entry.entryType === RumPerformanceEntryType.EVENT ||
                entry.entryType === RumPerformanceEntryType.FIRST_INPUT) &&
                entry.interactionId &&
                // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
                entry.startTime >= viewStart &&
                entry.startTime <= viewEnd) {
                longestInteractions.process(entry);
            }
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction) {
            interactionToNextPaint = newInteraction.duration;
            if (newInteraction.target && isElementNode(newInteraction.target)) {
                interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
            }
            else {
                interactionToNextPaintTargetSelector = undefined;
            }
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function () {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
                    targetSelector: interactionToNextPaintTargetSelector,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        setViewEnd: function (viewEndTime) {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: stop,
    };
}
function trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function (a, b) { return b.duration - a.duration; }).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process: function (entry) {
            var interactionIndex = longestInteractions.findIndex(function (interaction) { return entry.interactionId === interaction.interactionId; });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction: function () {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    initInteractionCountPolyfill();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
    var state = { stopped: false };
    function computeViewInteractionCount() {
        return getInteractionCount() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: function () {
            if (state.stopped) {
                return state.interactionCount;
            }
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: function () {
            state = { stopped: true, interactionCount: computeViewInteractionCount() };
        },
    };
}
function isInteractionToNextPaintSupported() {
    return (supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
//# sourceMappingURL=trackInteractionToNextPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.js


function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0,timeUtils/* elapsed */._J)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
//# sourceMappingURL=trackLoadingTime.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
function createViewportObservable(configuration) {
    return new observable/* Observable */.y(function (observable) {
        var updateDimension = (0,functionUtils/* throttle */.P)(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.RESIZE */.EZ.RESIZE, updateDimension, { capture: true, passive: true })
            .stop;
    });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.js



/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = timeUtils/* ONE_SECOND */.WT;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) { scrollValues = createScrollValuesObservable(configuration); }
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function (_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0,timeUtils/* relativeNow */._q)();
            maxScrollHeightTime = (0,timeUtils/* elapsed */._J)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight: maxScrollHeight,
                maxScrollHeightTime: maxScrollHeightTime,
            });
        }
    });
    return {
        stop: function () { return subscription.unsubscribe(); },
    };
}
function computeScrollValues() {
    var scrollTop = getScrollY();
    var height = getViewportDimension().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
function createScrollValuesObservable(configuration, throttleDuration) {
    if (throttleDuration === void 0) { throttleDuration = THROTTLE_SCROLL_DURATION; }
    return new observable/* Observable */.y(function (observable) {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0,functionUtils/* throttle */.P)(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0,monitor/* monitor */.zk)(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, throttledNotify_1.throttled, {
                passive: true,
            });
            return function () {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
}
//# sourceMappingURL=trackScrollMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.js




function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, function (cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint, setViewEnd = _b.setViewEnd;
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: function () {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * timeUtils/* ONE_MINUTE */.yR;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, (0,timeUtils/* clocksOrigin */.cQ)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function () {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING || pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.PAGEHIDE */.k$.PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function (view) { return view.stop(); });
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
    // Setup initial values
    var id = (0,stringUtils/* generateUUID */.DO)();
    var stopObservable = new observable/* Observable */.y();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0,objectUtils/* shallowClone */.mv)(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    var viewCreatedEvent = {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    };
    lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
    lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
    // Update the view every time the measures are changing
    var _a = (0,functionUtils/* throttle */.P)(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, setViewEnd = _b.setViewEnd, stopCommonViewMetricsTracking = _b.stop, stopINPTracking = _b.stopINPTracking, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate)
        : { stop: functionUtils/* noop */.Z, initialViewMetrics: {} }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0,timer/* setInterval */.Zi)(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0,timeUtils/* timeStampNow */.n$)() : endClocks.timeStamp;
        lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        });
    }
    return {
        name: name,
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function (options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0,timeUtils/* clocksNow */.$I)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, { endClocks: endClocks });
            (0,timer/* clearInterval */.cv)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0,timer/* setTimeout */.iK)(function () {
                _this.stop();
            }, KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop: function () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = (0,timeUtils/* looksLikeRelativeTime */.Cn)(time) ? time : (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display/* display.warn */.jf.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.js


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStates,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
            },
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_target_selector: (_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.targetSelector,
            first_byte: (0,timeUtils/* toServerDuration */.c0)((_c = view.initialViewMetrics.navigationTimings) === null || _c === void 0 ? void 0 : _c.firstByte),
            dom_complete: (0,timeUtils/* toServerDuration */.c0)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.domComplete),
            dom_content_loaded: (0,timeUtils/* toServerDuration */.c0)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domContentLoaded),
            dom_interactive: (0,timeUtils/* toServerDuration */.c0)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0,timeUtils/* toServerDuration */.c0)((_g = view.initialViewMetrics.firstInput) === null || _g === void 0 ? void 0 : _g.delay),
            first_input_time: (0,timeUtils/* toServerDuration */.c0)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.time),
            first_input_target_selector: (_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.targetSelector,
            interaction_to_next_paint: (0,timeUtils/* toServerDuration */.c0)((_k = view.commonViewMetrics.interactionToNextPaint) === null || _k === void 0 ? void 0 : _k.value),
            interaction_to_next_paint_target_selector: (_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0,timeUtils/* toServerDuration */.c0)((_m = view.initialViewMetrics.largestContentfulPaint) === null || _m === void 0 ? void 0 : _m.value),
            largest_contentful_paint_target_selector: (_o = view.initialViewMetrics.largestContentfulPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            load_event: (0,timeUtils/* toServerDuration */.c0)((_p = view.initialViewMetrics.navigationTimings) === null || _p === void 0 ? void 0 : _p.loadEvent),
            loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0,timeUtils/* toServerDuration */.c0)(view.duration),
        },
        feature_flags: featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: (0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!(0,objectUtils/* isEmptyObject */.Qr)(view.customTimings)) {
        viewEvent.view.custom_timings = (0,objectUtils/* mapValues */.Q8)(view.customTimings, timeUtils/* toServerDuration */.c0);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0,numberUtils/* isNumber */.hj)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(42972);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, RUM_SESSION_KEY, function (rawTrackingType) { return computeSessionState(configuration, rawTrackingType); }, trackingConsentState);
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                sessionReplayAllowed: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplayAllowed: false,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: functionUtils/* noop */.Z,
        expireObservable: new observable/* Observable */.y(),
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(22556);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
    var replica = configuration.replica;
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */),
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function (message) { return (0,mergeInto/* combine */.$e)(message, { application: { id: replica.applicationId } }); },
        encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */),
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration)); });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new valueHistory/* ValueHistory */.P(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0,timeUtils/* relativeNow */._q)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(configuration, location) {
    var currentLocation = (0,objectUtils/* shallowClone */.mv)(location);
    return new observable/* Observable */.y(function (observable) {
        var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = trackHash(configuration, onLocationChange).stop;
        function onLocationChange() {
            if (currentLocation.href === location.href) {
                return;
            }
            var newLocation = (0,objectUtils/* shallowClone */.mv)(location);
            observable.notify({
                newLocation: newLocation,
                oldLocation: currentLocation,
            });
            currentLocation = newLocation;
        }
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
}
function trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0,instrumentMethod/* instrumentMethod */.S)(history, 'pushState', function (_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var stopInstrumentingReplaceState = (0,instrumentMethod/* instrumentMethod */.S)(history, 'replaceState', function (_a) {
        var onPostCall = _a.onPostCall;
        onPostCall(onHistoryChange);
    }).stop;
    var removeListener = (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POP_STATE */.EZ.POP_STATE, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.HASH_CHANGE */.EZ.HASH_CHANGE, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, customerDataTracker) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.FEATURE_FLAGS */.uh.FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            addFeatureFlagEvaluation: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    var featureFlagContexts = new valueHistory/* ValueHistory */.P(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        customerDataTracker.resetCustomerData();
    });
    lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                customerDataTracker.updateCustomerData(currentContext);
            }
        },
        stop: function () { return customerDataTracker.stop(); },
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0,numberUtils/* performDraw */.y7)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */).getBytesCount());
        updateMeasure(currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */).getBytesCount());
        updateMeasure(currentBatchMeasures.featureFlagBytes, (0,polyfills/* includes */.q9)(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type)
            ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */).getBytesCount()
            : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    (0,timer/* setInterval */.Zi)(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new valueHistory/* ValueHistory */.P(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), (0,timeUtils/* relativeNow */._q)());
    var stopEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, window, [
        addEventListener/* DOM_EVENT.PAGE_SHOW */.EZ.PAGE_SHOW,
        addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS,
        addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR,
        addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE,
        addEventListener/* DOM_EVENT.RESUME */.EZ.RESUME,
        addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE,
        addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE,
    ], function (event) {
        addPageState(computePageState(event), event.timeStamp);
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = (0,timeUtils/* relativeNow */._q)(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0,timeUtils/* elapsed */._J)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0,timeUtils/* toServerDuration */.c0)(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        isInActivePageStateAt: function (startTime) {
            var pageStateEntry = pageStateHistory.find(startTime);
            return pageStateEntry !== undefined && pageStateEntry.state === "active" /* PageState.ACTIVE */;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
function computePageState(event) {
    if (event.type === addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js

function startDisplayContext(configuration) {
    var viewport = getViewportDimension();
    var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function () { return ({ viewport: viewport }); },
        stop: unsubscribeViewport,
    };
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/vital/vitalCollection.js

function startVitalCollection(lifeCycle) {
    var vitalStartsByName = new Map();
    return {
        startDurationVital: function (vitalStart) {
            vitalStartsByName.set(vitalStart.name, vitalStart);
        },
        stopDurationVital: function (vitalStop) {
            var vitalStart = vitalStartsByName.get(vitalStop.name);
            if (!vitalStart) {
                return;
            }
            var vital = {
                name: vitalStart.name,
                type: "duration" /* VitalType.DURATION */,
                startClocks: vitalStart.startClocks,
                value: (0,timeUtils/* elapsed */._J)(vitalStart.startClocks.timeStamp, vitalStop.stopClocks.timeStamp),
                context: (0,mergeInto/* combine */.$e)(vitalStart.context, vitalStop.context),
            };
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital));
            vitalStartsByName.delete(vitalStop.name);
        },
    };
}
function processVital(vital) {
    var _a;
    return {
        rawRumEvent: {
            date: vital.startClocks.timeStamp,
            vital: {
                id: (0,stringUtils/* generateUUID */.DO)(),
                type: vital.type,
                name: vital.name,
                custom: (_a = {},
                    _a[vital.name] = vital.value,
                    _a),
            },
            type: "vital" /* RumEventType.VITAL */,
        },
        startTime: vital.startClocks.relative,
        customerContext: vital.context,
        domainContext: {},
    };
}
//# sourceMappingURL=vitalCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/boot/startRum.js
























function startRum(initConfiguration, configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder, 
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
    var cleanupTasks = [];
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return (0,sendToExtension/* sendToExtension */.j)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */));
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    cleanupTasks.push(function () { return pageExitSubscription.unsubscribe(); });
    var session = !(0,eventBridge/* canUseEventBridge */.x)()
        ? startRumSessionManager(configuration, lifeCycle, trackingConsentState)
        : startRumSessionManagerStub();
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(function () { return batch_1.stop(); });
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(configuration, location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, getCommonContext, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
    startLongTaskCollection(lifeCycle, configuration, session);
    startResourceCollection(lifeCycle, configuration, session, pageStateHistory);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    var stopPerformanceCollection = startPerformanceCollection(lifeCycle, configuration).stop;
    cleanupTasks.push(stopPerformanceCollection);
    var vitalCollection = startVitalCollection(lifeCycle);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
        startDurationVital: vitalCollection.startDurationVital,
        stopDurationVital: vitalCollection.stopDurationVital,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startRumTelemetry(configuration) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var pageStateHistory = startPageStateHistory(configuration);
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = startDisplayContext(configuration);
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, getCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case intakeSites/* INTAKE_SITE_US1 */.D_:
        case intakeSites/* INTAKE_SITE_EU1 */.Ds:
            return 'app';
        case intakeSites/* INTAKE_SITE_STAGING */.DZ:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/index.js











//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(13152);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0,polyfills/* assign */.f0)({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: (0,timeUtils/* timeStampNow */.n$)(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_configuration/* DefaultPrivacyLevel.ALLOW */.Jj.ALLOW,
    MASK: configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
    MASK_USER_INPUT: configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/privacy.js


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
    if (cache && cache.has(node)) {
        return cache.get(node);
    }
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode
        ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache)
        : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    var nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
    if (cache) {
        cache.set(node, nodePrivacyLevel);
    }
    return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0,urlPolyfill/* buildUrl */.Q2)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function censoredImageForSize(width, height) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js





function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
            // generate image with similar dimension than the original to have the same rendering behaviour
            var image = element;
            if (image.naturalWidth > 0) {
                return censoredImageForSize(image.naturalWidth, image.naturalHeight);
            }
            var _a = element.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (width > 0 || height > 0) {
                return censoredImageForSize(width, height);
            }
            // if we can't get the image size, fallback to the censored image
            return CENSORED_IMG_MARK;
        }
        // mask source URLs
        if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
            return CENSORED_IMG_MARK;
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0,polyfills/* startsWith */.Ny)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js





function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet && !(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.DISABLE_REPLAY_INLINE_CSS */.uh.DISABLE_REPLAY_INLINE_CSS)) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, (0,browserDetection/* isSafari */.G6)() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js








function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    forEachChildNodes(node, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = serializeAttributes(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (hasChildNodes(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0,polyfills/* assign */.f0)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/moveObserver.js





var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(configuration, cb) {
    var _a = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListeners */.yw)(configuration, document, [addEventListener/* DOM_EVENT.MOUSE_MOVE */.EZ.MOUSE_MOVE, addEventListener/* DOM_EVENT.TOUCH_MOVE */.EZ.TOUCH_MOVE], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
    return function () {
        removeListener();
        cancelThrottle();
    };
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=moveObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/scrollObserver.js






var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(configuration, cb, defaultPrivacyLevel, elementsScrollPositions) {
    var _a = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD), updatePosition = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListener */.Oo)(configuration, document, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, updatePosition, {
        capture: true,
        passive: true,
    }).stop;
    return function () {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=scrollObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mouseInteractionObserver.js
var _a;








var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a[addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP] = MouseInteractionType.MouseUp,
    _a[addEventListener/* DOM_EVENT.MOUSE_DOWN */.EZ.MOUSE_DOWN] = MouseInteractionType.MouseDown,
    _a[addEventListener/* DOM_EVENT.CLICK */.EZ.CLICK] = MouseInteractionType.Click,
    _a[addEventListener/* DOM_EVENT.CONTEXT_MENU */.EZ.CONTEXT_MENU] = MouseInteractionType.ContextMenu,
    _a[addEventListener/* DOM_EVENT.DBL_CLICK */.EZ.DBL_CLICK] = MouseInteractionType.DblClick,
    _a[addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS] = MouseInteractionType.Focus,
    _a[addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR] = MouseInteractionType.Blur,
    _a[addEventListener/* DOM_EVENT.TOUCH_START */.EZ.TOUCH_START] = MouseInteractionType.TouchStart,
    _a[addEventListener/* DOM_EVENT.TOUCH_END */.EZ.TOUCH_END] = MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(configuration, cb, recordIds) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0,polyfills/* assign */.f0)({ id: recordIds.getIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0,addEventListener/* addEventListeners */.yw)(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mouseInteractionObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/inputObserver.js





function initInputObserver(configuration, cb, target) {
    if (target === void 0) { target = document; }
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? [addEventListener/* DOM_EVENT.CHANGE */.EZ.CHANGE] : [addEventListener/* DOM_EVENT.INPUT */.EZ.INPUT, addEventListener/* DOM_EVENT.CHANGE */.EZ.CHANGE], function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLInputElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.X)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = functionUtils/* noop */.Z;
    }
    return function () {
        stopPropertySetterInstrumentation();
        stopEventListeners();
    };
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            (0,polyfills/* forEach */.Ed)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat((0,polyfills/* cssEscape */.QA)(name), "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0,polyfills/* assign */.f0)({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
}
//# sourceMappingURL=inputObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/styleSheetObserver.js


function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0,instrumentMethod/* instrumentMethod */.S)(CSSStyleSheet.prototype, 'insertRule', function (_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
        }),
        (0,instrumentMethod/* instrumentMethod */.S)(CSSStyleSheet.prototype, 'deleteRule', function (_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0,instrumentMethod/* instrumentMethod */.S)(cls.prototype, 'insertRule', function (_a) {
            var styleSheet = _a.target, _b = _a.parameters, rule = _b[0], index = _b[1];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
                var path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index || 0);
                    cb({ id: id, adds: [{ rule: rule, index: path }] });
                }
            });
        }), (0,instrumentMethod/* instrumentMethod */.S)(cls.prototype, 'deleteRule', function (_a) {
            var styleSheet = _a.target, index = _a.parameters[0];
            checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
                var path = getPathToNestedCSSRule(styleSheet);
                if (path) {
                    path.push(index);
                    cb({ id: id, removes: [{ index: path }] });
                }
            });
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=styleSheetObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mediaInteractionObserver.js






function initMediaInteractionObserver(configuration, mediaInteractionCb, defaultPrivacyLevel) {
    return (0,addEventListener/* addEventListeners */.yw)(configuration, document, [addEventListener/* DOM_EVENT.PLAY */.EZ.PLAY, addEventListener/* DOM_EVENT.PAUSE */.EZ.PAUSE], function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === addEventListener/* DOM_EVENT.PLAY */.EZ.PLAY ? MediaInteractionType.Play : MediaInteractionType.Pause,
        });
    }, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mediaInteractionObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/frustrationObserver.js

function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
//# sourceMappingURL=frustrationObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/viewportResizeObserver.js



var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(configuration, cb) {
    return initViewportObservable(configuration).subscribe(cb).unsubscribe;
}
function initVisualViewportResizeObserver(configuration, cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return functionUtils/* noop */.Z;
    }
    var _a = (0,functionUtils/* throttle */.P)(function () {
        cb(getVisualViewport(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListeners */.yw)(configuration, visualViewport, [addEventListener/* DOM_EVENT.RESIZE */.EZ.RESIZE, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=viewportResizeObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = functionUtils/* noop */.Z;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0,monitor/* monitor */.zk)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0,monitor/* monitor */.zk)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mutationObserver.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: functionUtils/* noop */.Z, flush: functionUtils/* noop */.Z };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0,monitor/* monitor */.zk)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    var nodePrivacyLevelCache = new Map();
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return mutation.target.isConnected &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !==
                NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController, nodePrivacyLevelCache), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration, nodePrivacyLevelCache);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    forEachChildNodes(removedNode, function (childNode) { return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/focusObserver.js

function initFocusObserver(configuration, focusCb) {
    return (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS, addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/recordIds.js
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/viewEndObserver.js


function initViewEndObserver(lifeCycle, viewEndCb) {
    return lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function () {
        viewEndCb({
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
}
//# sourceMappingURL=viewEndObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/observers.js












function initObservers(configuration, o) {
    var recordIds = initRecordIds();
    var mutationHandler = initMutationObserver(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = initMoveObserver(configuration, o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(configuration, o.mouseInteractionCb, recordIds);
    var scrollHandler = initScrollObserver(configuration, o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = initViewportResizeObserver(configuration, o.viewportResizeCb);
    var inputHandler = initInputObserver(configuration, o.inputCb);
    var mediaInteractionHandler = initMediaInteractionObserver(configuration, o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
    var focusHandler = initFocusObserver(configuration, o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(configuration, o.visualViewportResizeCb);
    var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb, recordIds);
    var viewEndHandler = initViewEndObserver(o.lifeCycle, o.viewEndCb);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
            viewEndHandler();
        },
    };
}
//# sourceMappingURL=observers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            if (controllerByShadowRoot.has(shadowRoot)) {
                return;
            }
            var _a = initMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(configuration, inputCb, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/startFullSnapshots.js





function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0,timeUtils/* timeStampNow */.n$)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        var records = [
            {
                data: {
                    height: height,
                    href: window.location.href,
                    width: width,
                },
                type: RecordType.Meta,
                timestamp: timestamp,
            },
            {
                data: {
                    has_focus: document.hasFocus(),
                },
                type: RecordType.Focus,
                timestamp: timestamp,
            },
            {
                data: {
                    node: serializeDocument(document, configuration, serializationContext),
                    initialOffset: {
                        left: getScrollX(),
                        top: getScrollY(),
                    },
                },
                type: RecordType.FullSnapshot,
                timestamp: timestamp,
            },
        ];
        if (window.visualViewport) {
            records.push({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
        return records;
    };
    fullSnapshotCallback(takeFullSnapshot());
    var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        flushMutations();
        fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
            shadowRootsController: shadowRootsController,
            status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
        }));
    }).unsubscribe;
    return {
        stop: unsubscribe,
    };
}
//# sourceMappingURL=startFullSnapshots.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/record.js








function record(options) {
    var emit = options.emit, configuration = options.configuration, lifeCycle = options.lifeCycle;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var emitAndComputeStats = function (record) {
        emit(record);
        (0,sendToExtension/* sendToExtension */.j)('record', { record: record });
        var view = options.viewContexts.findView();
        addRecord(view.id);
    };
    var elementsScrollPositions = createElementsScrollPositions();
    var mutationCb = function (mutation) {
        emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) {
        return emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.Input, s));
    };
    var shadowRootsController = initShadowRootsController(configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var stopFullSnapshots = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function (records) { return records.forEach(function (record) { return emitAndComputeStats(record); }); }).stop;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    var _a = initObservers(configuration, {
        lifeCycle: options.lifeCycle,
        configuration: configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emitAndComputeStats(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) {
            return emitAndComputeStats(assembleIncrementalSnapshot(source, { positions: positions }));
        },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) {
            return emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r));
        },
        viewportResizeCb: function (d) {
            return emitAndComputeStats(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d));
        },
        frustrationCb: function (frustrationRecord) { return emitAndComputeStats(frustrationRecord); },
        focusCb: function (data) {
            return emitAndComputeStats({
                data: data,
                type: RecordType.Focus,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emitAndComputeStats({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        viewEndCb: function (viewEndRecord) {
            flushMutations();
            emitAndComputeStats(viewEndRecord);
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
            stopFullSnapshots();
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0,polyfills/* assign */.f0)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var Segment = /** @class */ (function () {
    function Segment(encoder, context, creationReason) {
        this.encoder = encoder;
        this.encodedBytesCount = 0;
        var viewId = context.view.id;
        this.metadata = (0,polyfills/* assign */.f0)({
            start: Infinity,
            end: -Infinity,
            creation_reason: creationReason,
            records_count: 0,
            has_full_snapshot: false,
            index_in_view: getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        addSegment(viewId);
    }
    Segment.prototype.addRecord = function (record, callback) {
        var _this = this;
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        var prefix = this.encoder.isEmpty ? '{"records":[' : ',';
        this.encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
            _this.encodedBytesCount += additionalEncodedBytesCount;
            callback(_this.encodedBytesCount);
        });
    };
    Segment.prototype.flush = function (callback) {
        var _this = this;
        if (this.encoder.isEmpty) {
            throw new Error('Empty segment flushed');
        }
        this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
        this.encoder.finish(function (encoderResult) {
            addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
            callback(_this.metadata, encoderResult);
        });
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * timeUtils/* ONE_SECOND */.WT;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts); }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(function (metadata, encoderResult) {
                var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
                if ((0,browser_pageExitObservable/* isPageExitReason */.PT)(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            (0,timer/* clearTimeout */.gr)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: function (record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                var context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: new Segment(encoder, context, state.nextSegmentCreationReason),
                    expirationTimeoutId: (0,timer/* setTimeout */.iK)(function () {
                        flushSegment('segment_duration_limit');
                    }, SEGMENT_DURATION_LIMIT),
                };
            }
            state.segment.addRecord(record, function (encodedBytesCount) {
                if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/startRecording.js



function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var replayRequest = httpRequest ||
        (0,transport_httpRequest/* createHttpRequest */.UF)(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var _a = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var stopRecording = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
    }).stop;
    return {
        stop: function () {
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return getSessionReplayUrl(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.js

function createDeflateEncoder(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'message', function (_a) {
        var workerResponse = _a.data;
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
            return;
        }
        rawBytesCount += workerResponse.additionalBytesCount;
        compressedData.push(workerResponse.result);
        compressedDataTrailer = workerResponse.trailer;
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
            if (nextPendingAction.writeCallback) {
                nextPendingAction.writeCallback(workerResponse.result.byteLength);
            }
            else if (nextPendingAction.finishCallback) {
                nextPendingAction.finishCallback();
            }
        }
        else {
            removeMessageListener();
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Worker responses received out of order.');
        }
    }).stop;
    function consumeResult() {
        var output = compressedData.length === 0 ? new Uint8Array(0) : (0,byteUtils/* concatBuffers */.Kb)(compressedData.concat(compressedDataTrailer));
        var result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate',
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (nextWriteActionId > 0) {
            worker.postMessage({
                action: 'reset',
                streamId: streamId,
            });
            nextWriteActionId = 0;
        }
    }
    return {
        isAsync: true,
        get isEmpty() {
            return nextWriteActionId === 0;
        },
        write: function (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data,
            });
            nextWriteActionId += 1;
        },
        finish: function (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) {
                callback(consumeResult());
            }
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach(function (pendingWriteAction) {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () { return callback(consumeResult()); };
            }
        },
        finishSync: function () {
            sendResetIfNeeded();
            var pendingData = pendingWriteActions
                .map(function (pendingWriteAction) {
                // Make sure we do not call any write or finish callback
                delete pendingWriteAction.writeCallback;
                delete pendingWriteAction.finishCallback;
                return pendingWriteAction.data;
            })
                .join('');
            return (0,polyfills/* assign */.f0)(consumeResult(), {
                pendingData: pendingData,
            });
        },
        estimateEncodedBytesCount: function (data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop: function () {
            removeMessageListener();
        },
    };
}
//# sourceMappingURL=deflateEncoder.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.js

var INITIALIZATION_TIME_OUT_DELAY = 10 * timeUtils/* ONE_SECOND */.WT;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.10.0\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
function getDeflateWorkerStatus() {
    return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'error', function (error) {
            onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        }).stop;
        worker.postMessage({ action: 'init' });
        (0,timer/* setTimeout */.iK)(function () { return onTimeout(source); }, INITIALIZATION_TIME_OUT_DELAY);
        var stop_1 = function () {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker: worker, stop: stop_1, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version: version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            var baseMessage = void 0;
            if (configuration.workerUrl) {
                baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            }
            else {
                baseMessage = 'Please make sure CSP is correctly configured.';
            }
            display/* display.error */.jf.error("".concat(baseMessage, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        }
        else {
            (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
        }
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
function isMessageCspRelated(message) {
    return ((0,polyfills/* includes */.q9)(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        (0,polyfills/* includes */.q9)(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/recorderApi.js





function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0,eventBridge/* canUseEventBridge */.x)() || !isBrowserSupported()) {
        return {
            start: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
            getReplayStats: function () { return undefined; },
            onRumStart: functionUtils/* noop */.Z,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 1 /* RecorderStatus.IntentToStart */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    var getSessionReplayLinkStrategy = functionUtils/* noop */.Z;
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getSessionReplayLink: function () { return getSessionReplayLinkStrategy(); },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
            if (configuration.startSessionReplayRecordingManually) {
                state = { status: 0 /* RecorderStatus.Stopped */ };
            }
            lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            // Stop the recorder on page unload to avoid sending records after the page is ended.
            lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
                if (pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING || pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.PAGEHIDE */.k$.PAGEHIDE) {
                    stopStrategy();
                }
            });
            lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            var cachedDeflateEncoder;
            function getOrCreateDeflateEncoder() {
                if (!cachedDeflateEncoder) {
                    if (!worker) {
                        worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
                            stopStrategy();
                        }, createDeflateWorkerImpl);
                    }
                    if (worker) {
                        cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
                    }
                }
                return cachedDeflateEncoder;
            }
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                runOnReadyState(configuration, 'interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    var deflateEncoder = getOrCreateDeflateEncoder();
                    if (!deflateEncoder) {
                        state = {
                            status: 0 /* RecorderStatus.Stopped */,
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */,
                        stopRecording: stopRecording,
                    };
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            getSessionReplayLinkStrategy = function () {
                return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
        },
        getReplayStats: function (viewId) {
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
        },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts






var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, { startDeflateWorker: startDeflateWorker, createDeflateEncoder: createDeflateEncoder });
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 5411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var parse = (__webpack_require__(36902).parse);
var cookie = __webpack_require__(85999);

/**
 * Get the top domain.
 *
 * The function constructs the levels of domain and attempts to set a global
 * cookie on each one when it succeeds it returns the top level domain.
 *
 * The method returns an empty string when the hostname is an ip or `localhost`.
 *
 * Example levels:
 *
 *      domain.levels('http://www.google.co.uk');
 *      // => ["co.uk", "google.co.uk", "www.google.co.uk"]
 *
 * Example:
 *
 *      domain('http://localhost:3000/baz');
 *      // => ''
 *      domain('http://dev:3000/baz');
 *      // => ''
 *      domain('http://127.0.0.1:3000/baz');
 *      // => ''
 *      domain('http://segment.io/baz');
 *      // => 'segment.io'
 *
 * @param {string} url
 * @return {string}
 * @api public
 */
function domain(url) {
  var cookie = exports.cookie;
  var levels = exports.levels(url);

  // Lookup the real top level one.
  for (var i = 0; i < levels.length; ++i) {
    var cname = '__tld__';
    var domain = levels[i];
    var opts = { domain: '.' + domain };

    cookie(cname, 1, opts);
    if (cookie(cname)) {
      cookie(cname, null, opts);
      return domain;
    }
  }

  return '';
}

/**
 * Levels returns all levels of the given url.
 *
 * @param {string} url
 * @return {Array}
 * @api public
 */
domain.levels = function(url) {
  var host = parse(url).hostname;
  var parts = host.split('.');
  var last = parts[parts.length - 1];
  var levels = [];

  // Ip address.
  if (parts.length === 4 && last === parseInt(last, 10)) {
    return levels;
  }

  // Localhost.
  if (parts.length <= 1) {
    return levels;
  }

  // Create levels.
  for (var i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }

  return levels;
};

/**
 * Expose cookie on domain.
 */
domain.cookie = cookie;

/*
 * Exports.
 */

exports = module.exports = domain;


/***/ }),

/***/ 52662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* binding */ configure; },
  "BX": function() { return /* binding */ fireEvent; }
});

// UNUSED EXPORTS: buildQueries, createEvent, findAllByAltText, findAllByDisplayValue, findAllByLabelText, findAllByPlaceholderText, findAllByRole, findAllByTestId, findAllByText, findAllByTitle, findByAltText, findByDisplayValue, findByLabelText, findByPlaceholderText, findByRole, findByTestId, findByText, findByTitle, getAllByAltText, getAllByDisplayValue, getAllByLabelText, getAllByPlaceholderText, getAllByRole, getAllByTestId, getAllByText, getAllByTitle, getByAltText, getByDisplayValue, getByLabelText, getByPlaceholderText, getByRole, getByTestId, getByText, getByTitle, getConfig, getDefaultNormalizer, getElementError, getMultipleElementsFoundError, getNodeText, getQueriesForElement, getRoles, getSuggestedQuery, isInaccessible, logDOM, logRoles, makeFindQuery, makeGetAllQuery, makeSingleQuery, prettyDOM, prettyFormat, queries, queryAllByAltText, queryAllByAttribute, queryAllByDisplayValue, queryAllByLabelText, queryAllByPlaceholderText, queryAllByRole, queryAllByTestId, queryAllByText, queryAllByTitle, queryByAltText, queryByAttribute, queryByDisplayValue, queryByLabelText, queryByPlaceholderText, queryByRole, queryByTestId, queryByText, queryByTitle, queryHelpers, screen, waitFor, waitForElementToBeRemoved, within, wrapAllByQueryWithSuggestion, wrapSingleQueryWithSuggestion

// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/node_modules/pretty-format/build/index.js
var build = __webpack_require__(57745);
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/array.from.mjs
/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */
var toStr = Object.prototype.toString;

function isCallable(fn) {
  return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}

function toInteger(value) {
  var number = Number(value);

  if (isNaN(number)) {
    return 0;
  }

  if (number === 0 || !isFinite(number)) {
    return number;
  }

  return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}

var maxSafeInteger = Math.pow(2, 53) - 1;

function toLength(value) {
  var len = toInteger(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 */


/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 * @param mapfn A mapping function to call on every element of the array.
 * @param thisArg Value of 'this' used to invoke the mapfn.
 */
function arrayFrom(arrayLike, mapFn) {
  // 1. Let C be the this value.
  // edit(@eps1lon): we're not calling it as Array.from
  var C = Array; // 2. Let items be ToObject(arrayLike).

  var items = Object(arrayLike); // 3. ReturnIfAbrupt(items).

  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  } // 4. If mapfn is undefined, then let mapping be false.
  // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;


  if (typeof mapFn !== "undefined") {
    // 5. else
    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
    if (!isCallable(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
  } // 10. Let lenValue be Get(items, "length").
  // 11. Let len be ToLength(lenValue).


  var len = toLength(items.length); // 13. If IsConstructor(C) is true, then
  // 13. a. Let A be the result of calling the [[Construct]] internal method
  // of C with an argument list containing the single item len.
  // 14. a. Else, Let A be ArrayCreate(len).

  var A = isCallable(C) ? Object(new C(len)) : new Array(len); // 16. Let k be 0.

  var k = 0; // 17. Repeat, while k < len… (also steps a - h)

  var kValue;

  while (k < len) {
    kValue = items[k];

    if (mapFn) {
      A[k] = mapFn(kValue, k);
    } else {
      A[k] = kValue;
    }

    k += 1;
  } // 18. Let putStatus be Put(A, "length", len, true).


  A.length = len; // 20. Return A.

  return A;
}
//# sourceMappingURL=array.from.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/SetLike.mjs
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/function () {
  function SetLike() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, SetLike);

    _defineProperty(this, "items", void 0);

    this.items = items;
  }

  _createClass(SetLike, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function (item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this = this;

      this.items.forEach(function (item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }]);

  return SetLike;
}();

/* harmony default export */ var polyfills_SetLike = (typeof Set === "undefined" ? Set : SetLike);
//# sourceMappingURL=SetLike.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/getRole.mjs
// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html

var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: new Set(["aria-label", "aria-labelledby"]),
  code: new Set(["aria-label", "aria-labelledby"]),
  deletion: new Set(["aria-label", "aria-labelledby"]),
  emphasis: new Set(["aria-label", "aria-labelledby"]),
  generic: new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: new Set(["aria-label", "aria-labelledby"]),
  paragraph: new Set(["aria-label", "aria-labelledby"]),
  presentation: new Set(["aria-label", "aria-labelledby"]),
  strong: new Set(["aria-label", "aria-labelledby"]),
  subscript: new Set(["aria-label", "aria-labelledby"]),
  superscript: new Set(["aria-label", "aria-labelledby"])
};
/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */

function hasGlobalAriaAttributes(element, role) {
  // https://rawgit.com/w3c/aria/stable/#global_states
  // commented attributes are deprecated
  return ["aria-atomic", "aria-busy", "aria-controls", "aria-current", "aria-describedby", "aria-details", // "disabled",
  "aria-dropeffect", // "errormessage",
  "aria-flowto", "aria-grabbed", // "haspopup",
  "aria-hidden", // "invalid",
  "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription"].some(function (attributeName) {
    var _prohibitedAttributes;

    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
  });
}

function ignorePresentationalRole(element, implicitRole) {
  // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
  return hasGlobalAriaAttributes(element, implicitRole);
}

function getRole(element) {
  var explicitRole = getExplicitRole(element);

  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);

    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }

  return explicitRole;
}

function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];

  if (mappedByTag !== undefined) {
    return mappedByTag;
  }

  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }

      break;

    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }

      return "img";

    case "input":
      {
        var _ref = element,
            type = _ref.type;

        switch (type) {
          case "button":
          case "image":
          case "reset":
          case "submit":
            return "button";

          case "checkbox":
          case "radio":
            return type;

          case "range":
            return "slider";

          case "email":
          case "tel":
          case "text":
          case "url":
            if (element.hasAttribute("list")) {
              return "combobox";
            }

            return "textbox";

          case "search":
            if (element.hasAttribute("list")) {
              return "combobox";
            }

            return "searchbox";

          default:
            return null;
        }
      }

    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }

      return "combobox";
  }

  return null;
}

function getExplicitRole(element) {
  var role = element.getAttribute("role");

  if (role !== null) {
    var explicitRole = role.trim().split(" ")[0]; // String.prototype.split(sep, limit) will always return an array with at least one member
    // as long as limit is either undefined or > 0

    if (explicitRole.length > 0) {
      return explicitRole;
    }
  }

  return null;
}
//# sourceMappingURL=getRole.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/util.mjs

/**
 * Safe Element.localName for all supported environments
 * @param element
 */

function getLocalName(element) {
  var _element$localName;

  return (// eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName : // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase()
  );
}
function isElement(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
  return isElement(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
  return isElement(node) && getLocalName(node) === "input";
}
function isHTMLOptGroupElement(node) {
  return isElement(node) && getLocalName(node) === "optgroup";
}
function isHTMLSelectElement(node) {
  return isElement(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
  return isElement(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
  return isElement(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
      defaultView = _ref.defaultView;

  if (defaultView === null) {
    throw new TypeError("no window available");
  }

  return defaultView;
}
function isHTMLFieldSetElement(node) {
  return isElement(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
  return isElement(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
  return isElement(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
  return isElement(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
  return isElement(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
  return isSVGElement(node) && getLocalName(node) === "title";
}
/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */

function queryIdRefs(node, attributeName) {
  if (isElement(node) && node.hasAttribute(attributeName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var ids = node.getAttribute(attributeName).split(" ");
    return ids.map(function (id) {
      return node.ownerDocument.getElementById(id);
    }).filter(function (element) {
      return element !== null;
    } // TODO: why does this not narrow?
    );
  }

  return [];
}
function hasAnyConcreteRoles(node, roles) {
  if (isElement(node)) {
    return roles.indexOf(getRole(node)) !== -1;
  }

  return false;
}
//# sourceMappingURL=util.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name-and-description.mjs
/**
 * implements https://w3c.github.io/accname/
 */



/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */

/**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */
function asFlatString(s) {
  return s.trim().replace(/\s\s+/g, " ");
}
/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */


function isHidden(node, getComputedStyleImplementation) {
  if (!isElement(node)) {
    return false;
  }

  if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") {
    return true;
  }

  var style = getComputedStyleImplementation(node);
  return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}
/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */


function isControl(node) {
  return hasAnyConcreteRoles(node, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node, "range");
}

function hasAbstractRole(node, role) {
  if (!isElement(node)) {
    return false;
  }

  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);

    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}
/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */


function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function (root) {
    // babel transpiles this assuming an iterator
    elements.push.apply(elements, arrayFrom(root.querySelectorAll(selectors)));
  });
  return elements;
}

function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }

  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}

function isMarkedPresentational(node) {
  return hasAnyConcreteRoles(node, ["none", "presentation"]);
}
/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */


function isNativeHostLanguageTextAlternativeElement(node) {
  return isHTMLTableCaptionElement(node);
}
/**
 * https://w3c.github.io/aria/#namefromcontent
 */


function allowsNameFromContent(node) {
  return hasAnyConcreteRoles(node, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */


function isDescendantOfNativeHostLanguageTextAlternativeElement( // eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
  return false;
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/101
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet


function computeTooltipAttributeValue(node) {
  return null;
}

function getValueOfTextbox(element) {
  if (isHTMLInputElement(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  } // https://github.com/eps1lon/dom-accessibility-api/issues/4


  return element.textContent || "";
}

function getTextualContent(declaration) {
  var content = declaration.getPropertyValue("content");

  if (/^["'].*["']$/.test(content)) {
    return content.slice(1, -1);
  }

  return "";
}
/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */


function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}
/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */


function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }

  var labelableElement = null;
  element.childNodes.forEach(function (childNode) {
    if (labelableElement === null && isElement(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);

      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}
/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */


function getControlOfLabel(label) {
  if (label.control !== undefined) {
    return label.control;
  }

  var htmlFor = label.getAttribute("for");

  if (htmlFor !== null) {
    return label.ownerDocument.getElementById(htmlFor);
  }

  return findLabelableElement(label);
}
/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */


function getLabels(element) {
  var labelsProperty = element.labels;

  if (labelsProperty === null) {
    return labelsProperty;
  }

  if (labelsProperty !== undefined) {
    return arrayFrom(labelsProperty);
  } // polyfill


  if (!isLabelableElement(element)) {
    return null;
  }

  var document = element.ownerDocument;
  return arrayFrom(document.querySelectorAll("label")).filter(function (label) {
    return getControlOfLabel(label) === element;
  });
}
/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */


function getSlotContents(slot) {
  // Computing the accessible name for elements containing slots is not
  // currently defined in the spec. This implementation reflects the
  // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
  var assignedNodes = slot.assignedNodes();

  if (assignedNodes.length === 0) {
    // if no nodes are assigned to the slot, it displays the default content
    return arrayFrom(slot.childNodes);
  }

  return assignedNodes;
}
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param options
 * @returns
 */


function computeTextAlternative(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var consultedNodes = new polyfills_SetLike();
  var window = safeWindow(root);
  var _options$compute = options.compute,
      compute = _options$compute === void 0 ? "name" : _options$compute,
      _options$computedStyl = options.computedStyleSupportsPseudoElements,
      computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl,
      _options$getComputedS = options.getComputedStyle,
      getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS,
      _options$hidden = options.hidden,
      hidden = _options$hidden === void 0 ? false : _options$hidden; // 2F.i

  function computeMiscTextAlternative(node, context) {
    var accumulatedText = "";

    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle(node, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    } // FIXME: Including aria-owns is not defined in the spec
    // But it is required in the web-platform-test


    var childNodes = isHTMLSlotElement(node) ? getSlotContents(node) : arrayFrom(node.childNodes).concat(queryIdRefs(node, "aria-owns"));
    childNodes.forEach(function (child) {
      var result = computeTextAlternative(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      }); // TODO: Unclear why display affects delimiter
      // see https://github.com/w3c/accname/issues/3

      var display = isElement(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : ""; // trailing separator for wpt tests

      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });

    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle(node, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }

    return accumulatedText;
  }

  function computeElementTextAlternative(node) {
    if (!isElement(node)) {
      return null;
    }
    /**
     *
     * @param element
     * @param attributeName
     * @returns A string non-empty string or `null`
     */


    function useAttribute(element, attributeName) {
      var attribute = element.getAttributeNode(attributeName);

      if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
        consultedNodes.add(attribute);
        return attribute.value;
      }

      return null;
    } // https://w3c.github.io/html-aam/#fieldset-and-legend-elements


    if (isHTMLFieldSetElement(node)) {
      consultedNodes.add(node);
      var children = arrayFrom(node.childNodes);

      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];

        if (isHTMLLegendElement(child)) {
          return computeTextAlternative(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node)) {
      // https://w3c.github.io/html-aam/#table-element
      consultedNodes.add(node);

      var _children = arrayFrom(node.childNodes);

      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];

        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node)) {
      // https://www.w3.org/TR/svg-aam-1.0/
      consultedNodes.add(node);

      var _children2 = arrayFrom(node.childNodes);

      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];

        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }

      return null;
    } else if (getLocalName(node) === "img" || getLocalName(node) === "area") {
      // https://w3c.github.io/html-aam/#area-element
      // https://w3c.github.io/html-aam/#img-element
      var nameFromAlt = useAttribute(node, "alt");

      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    } else if (isHTMLOptGroupElement(node)) {
      var nameFromLabel = useAttribute(node, "label");

      if (nameFromLabel !== null) {
        return nameFromLabel;
      }
    }

    if (isHTMLInputElement(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
      // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
      var nameFromValue = useAttribute(node, "value");

      if (nameFromValue !== null) {
        return nameFromValue;
      } // TODO: l10n


      if (node.type === "submit") {
        return "Submit";
      } // TODO: l10n


      if (node.type === "reset") {
        return "Reset";
      }
    }

    var labels = getLabels(node);

    if (labels !== null && labels.length !== 0) {
      consultedNodes.add(node);
      return arrayFrom(labels).map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: true,
          isReferenced: false,
          recursion: true
        });
      }).filter(function (label) {
        return label.length > 0;
      }).join(" ");
    } // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
    // TODO: wpt test consider label elements but html-aam does not mention them
    // We follow existing implementations over spec


    if (isHTMLInputElement(node) && node.type === "image") {
      var _nameFromAlt = useAttribute(node, "alt");

      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }

      var nameFromTitle = useAttribute(node, "title");

      if (nameFromTitle !== null) {
        return nameFromTitle;
      } // TODO: l10n


      return "Submit Query";
    }

    return useAttribute(node, "title");
  }

  function computeTextAlternative(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    } // 2A


    if (!hidden && isHidden(current, getComputedStyle) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    } // 2B


    var labelElements = queryIdRefs(current, "aria-labelledby");

    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      return labelElements.map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // thais isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    } // 2C
    // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
    // spec says we should only consider skipping if we have a non-empty label


    var skipToStep2E = context.recursion && isControl(current) && compute === "name";

    if (!skipToStep2E) {
      var ariaLabel = (isElement(current) && current.getAttribute("aria-label") || "").trim();

      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      } // 2D


      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);

        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    } // special casing, cheating to make tests pass
    // https://github.com/w3c/accname/issues/67


    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    } // 2E


    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);

        if (selectedOptions.length === 0) {
          // defined per test `name_heading_combobox`
          return isHTMLInputElement(current) ? current.value : "";
        }

        return arrayFrom(selectedOptions).map(function (selectedOption) {
          return computeTextAlternative(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }

      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);

        if (current.hasAttribute("aria-valuetext")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuetext");
        }

        if (current.hasAttribute("aria-valuenow")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuenow");
        } // Otherwise, use the value as specified by a host language attribute.


        return current.getAttribute("value") || "";
      }

      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    } // 2F: https://w3c.github.io/accname/#step2F


    if (allowsNameFromContent(current) || isElement(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement(current)) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }

    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }

    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }

    var tooltipAttributeValue = computeTooltipAttributeValue(current);

    if (tooltipAttributeValue !== null) {
      consultedNodes.add(current);
      return tooltipAttributeValue;
    } // TODO should this be reachable?


    consultedNodes.add(current);
    return "";
  }

  return asFlatString(computeTextAlternative(root, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}
//# sourceMappingURL=accessible-name-and-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-description.mjs
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { accessible_description_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function accessible_description_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * @param root
 * @param options
 * @returns
 */

function computeAccessibleDescription(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var description = queryIdRefs(root, "aria-describedby").map(function (element) {
    return computeTextAlternative(element, _objectSpread(_objectSpread({}, options), {}, {
      compute: "description"
    }));
  }).join(" "); // TODO: Technically we need to make sure that node wasn't used for the accessible name
  //       This causes `description_1.0_combobox-focusable-manual` to fail
  //
  // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
  // says for so many elements to use the `title` that we assume all elements are considered

  if (description === "") {
    var title = root.getAttribute("title");
    description = title === null ? "" : title;
  }

  return description;
}
//# sourceMappingURL=accessible-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name.mjs


/**
 * https://w3c.github.io/aria/#namefromprohibited
 */

function prohibitsNaming(node) {
  return hasAnyConcreteRoles(node, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}
/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param options
 * @returns
 */


function computeAccessibleName(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (prohibitsNaming(root)) {
    return "";
  }

  return computeTextAlternative(root, options);
}
//# sourceMappingURL=accessible-name.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/index.mjs




//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ../../../node_modules/aria-query/lib/index.js
var lib = __webpack_require__(41516);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__(96535);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/react/node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(13158);






/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */

/* eslint-disable -- trying to stay as close to the original as possible */

/* istanbul ignore file */
function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
} // Return empty string if keys is empty.


const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys.map(key => {
    const value = props[key];
    let printed = printer(value, config, indentationNext, depth, refs);

    if (typeof value !== 'string') {
      if (printed.indexOf('\n') !== -1) {
        printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
      }

      printed = '{' + printed + '}';
    }

    return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
  }).join('');
}; // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants


const NodeTypeTextNode = 3; // Return empty string if children is empty.

const printChildren = (children, config, indentation, depth, refs, printer) => children.map(child => {
  const printedChild = typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs);

  if (printedChild === '' && typeof child === 'object' && child !== null && child.nodeType !== NodeTypeTextNode) {
    // A plugin serialized this Node to '' meaning we should ignore it.
    return '';
  }

  return config.spacingOuter + indentation + printedChild;
}).join('');

const printText = (text, config) => {
  const contentColor = config.colors.content;
  return contentColor.open + escapeHTML(text) + contentColor.close;
};

const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.


const printElement = (type, printedProps, printedChildren, config, indentation) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};

const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
};

const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;

const testNode = val => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === 'string' && tagName.includes('-') || typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === 'Text' || nodeType === COMMENT_NODE$1 && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
};

function nodeIsText(node) {
  return node.nodeType === TEXT_NODE$1;
}

function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE$1;
}

function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}

function createDOMElementFilter(filterNode) {
  return {
    test: val => {
      var _val$constructor2;

      return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
    },
    serialize: (node, config, indentation, depth, refs, printer) => {
      if (nodeIsText(node)) {
        return printText(node.data, config);
      }

      if (nodeIsComment(node)) {
        return printComment(node.data, config);
      }

      const type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();

      if (++depth > config.maxDepth) {
        return printElementAsLeaf(type, config);
      }

      return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(attr => attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute) => {
        props[attribute.name] = attribute.value;
        return props;
      }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
    }
  };
}

// We try to load node dependencies
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;

try {
  const nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, 'fs').readFileSync;
  codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
  chalk = nodeRequire.call(module, 'chalk');
} catch {// We're in a browser environment
} // frame has the form "at myMethod (location/to/my/file.js:10:2)"


function getCodeFrame(frame) {
  const locationStart = frame.indexOf('(') + 1;
  const locationEnd = frame.indexOf(')');
  const frameLocation = frame.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(':');
  const [filename, line, column] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = '';

  try {
    rawFileContents = readFileSync(filename, 'utf-8');
  } catch {
    return '';
  }

  const codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line,
      column
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}

function getUserCodeFrame() {
  // If we couldn't load dependencies, we can't generate the user trace

  /* istanbul ignore next */
  if (!readFileSync || !codeFrameColumns) {
    return '';
  }

  const err = new Error();
  const firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
  .find(frame => !frame.includes('node_modules/')); // Ignore frames from 3rd party libraries

  return getCodeFrame(firstClientCodeFrame);
}

// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;

function jestFakeTimersAreEnabled() {
  /* istanbul ignore else */
  if (typeof jest !== 'undefined' && jest !== null) {
    return (// legacy timers
      setTimeout._isMockFunction === true || // modern timers
      Object.prototype.hasOwnProperty.call(setTimeout, 'clock')
    );
  } // istanbul ignore next


  return false;
}

function getDocument() {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    throw new Error('Could not find default container');
  }

  return window.document;
}

function getWindowFromNode(node) {
  if (node.defaultView) {
    // node is document
    return node.defaultView;
  } else if (node.ownerDocument && node.ownerDocument.defaultView) {
    // node is a DOM node
    return node.ownerDocument.defaultView;
  } else if (node.window) {
    // node is window
    return node.window;
  } else if (node.ownerDocument && node.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + typeof node + ".");
  }
}

function checkContainerType(container) {
  if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
  }

  function getTypeName(object) {
    if (typeof object === 'object') {
      return object === null ? 'null' : object.constructor.name;
    }

    return typeof object;
  }
}

const inNode = () => typeof process !== 'undefined' && process.versions !== undefined && process.versions.node !== undefined;

const {
  DOMCollection
} = build/* plugins */.Gr; // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants

const ELEMENT_NODE = 1;
const COMMENT_NODE = 8; // https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50

function filterCommentsAndDefaultIgnoreTagsTags(value) {
  return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}

function prettyDOM(dom, maxLength, options) {
  if (options === void 0) {
    options = {};
  }

  if (!dom) {
    dom = getDocument().body;
  }

  if (typeof maxLength !== 'number') {
    maxLength = typeof process !== 'undefined' && process.env.DEBUG_PRINT_LIMIT || 7000;
  }

  if (maxLength === 0) {
    return '';
  }

  if (dom.documentElement) {
    dom = dom.documentElement;
  }

  let domTypeName = typeof dom;

  if (domTypeName === 'object') {
    domTypeName = dom.constructor.name;
  } else {
    // To don't fall with `in` operator
    dom = {};
  }

  if (!('outerHTML' in dom)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }

  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags,
    ...prettyFormatOptions
  } = options;
  const debugContent = build/* format */.WU(dom, {
    plugins: [createDOMElementFilter(filterNode), DOMCollection],
    printFunctionName: false,
    highlight: inNode(),
    ...prettyFormatOptions
  });
  return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}

const logDOM = function () {
  const userCodeFrame = getUserCodeFrame();

  if (userCodeFrame) {
    console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM(...arguments));
  }
};

// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
let config = {
  testIdAttribute: 'data-testid',
  asyncUtilTimeout: 1000,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: cb => cb(),
  unstable_advanceTimersWrapper: cb => cb(),
  eventWrapper: cb => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: 'script, style',
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,

  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container) {
    const prettifiedDOM = prettyDOM(container);
    const error = new Error([message, "Ignored nodes: comments, <script />, <style />\n" + prettifiedDOM].filter(Boolean).join('\n\n'));
    error.name = 'TestingLibraryElementError';
    return error;
  },

  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === 'function') {
    // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
  } // Merge the incoming config delta


  config = { ...config,
    ...newConfig
  };
}
function getConfig() {
  return config;
}

const labelledNodeNames = ['button', 'meter', 'output', 'progress', 'select', 'textarea', 'input'];

function getTextContent(node) {
  if (labelledNodeNames.includes(node.nodeName.toLowerCase())) {
    return '';
  }

  if (node.nodeType === TEXT_NODE) return node.textContent;
  return Array.from(node.childNodes).map(childNode => getTextContent(childNode)).join('');
}

function getLabelContent(element) {
  let textContent;

  if (element.tagName.toLowerCase() === 'label') {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }

  return textContent;
} // Based on https://github.com/eps1lon/dom-accessibility-api/pull/352


function getRealLabels(element) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
  if (element.labels !== undefined) {
    var _labels;

    return (_labels = element.labels) != null ? _labels : [];
  }

  if (!isLabelable(element)) return [];
  const labels = element.ownerDocument.querySelectorAll('label');
  return Array.from(labels).filter(label => label.control === element);
}

function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}

function dom_esm_getLabels(container, element, _temp) {
  let {
    selector = '*'
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
  return labelsId.length ? labelsId.map(labelId => {
    const labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: '',
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map(label => {
    const textToMatch = getLabelContent(label);
    const formControlSelector = 'button, input, meter, output, progress, select, textarea';
    const labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(formControlElement => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}

function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === undefined) {
    throw new Error( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
    "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
  }
}

function fuzzyMatches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }

  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);

  if (typeof matcher === 'string' || typeof matcher === 'number') {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === 'function') {
    return matcher(normalizedText, node);
  } else {
    return matchRegExp(matcher, normalizedText);
  }
}

function matches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }

  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);

  if (matcher instanceof Function) {
    return matcher(normalizedText, node);
  } else if (matcher instanceof RegExp) {
    return matchRegExp(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}

function getDefaultNormalizer(_temp) {
  let {
    trim = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return text => {
    let normalizedText = text;
    normalizedText = trim ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
    return normalizedText;
  };
}
/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */


function makeNormalizer(_ref) {
  let {
    trim,
    collapseWhitespace,
    normalizer
  } = _ref;

  if (!normalizer) {
    // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
      trim,
      collapseWhitespace
    });
  }

  if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') {
    // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. ' + 'If you want to use the default trim and collapseWhitespace logic in your normalizer, ' + 'use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }

  return normalizer;
}

function matchRegExp(matcher, text) {
  const match = matcher.test(text);

  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }

  return match;
}

function getNodeText(node) {
  if (node.matches('input[type=submit], input[type=button], input[type=reset]')) {
    return node.value;
  }

  return Array.from(node.childNodes).filter(child => child.nodeType === TEXT_NODE && Boolean(child.textContent)).map(c => c.textContent).join('');
}

const elementRoleList = buildElementRoleList(lib/* elementRoles */.Qv);
/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */

function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }

  if (element.getAttribute('aria-hidden') === 'true') {
    return true;
  }

  const window = element.ownerDocument.defaultView;

  if (window.getComputedStyle(element).display === 'none') {
    return true;
  }

  return false;
}
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */


function isInaccessible(element, options) {
  if (options === void 0) {
    options = {};
  }

  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible
  } = options;
  const window = element.ownerDocument.defaultView; // since visibility is inherited we can exit early

  if (window.getComputedStyle(element).visibility === 'hidden') {
    return true;
  }

  let currentElement = element;

  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
}

function getImplicitAriaRoles(currentNode) {
  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const {
    match,
    roles
  } of elementRoleList) {
    if (match(currentNode)) {
      return [...roles];
    }
  }

  return [];
}

function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref) {
    let {
      name,
      attributes
    } = _ref;
    return "" + name + attributes.map(_ref2 => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref2;
      const shouldNotExist = constraints.indexOf('undefined') !== -1;

      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + "=\"" + value + "\"]";
      } else {
        return "[" + attributeName + "]";
      }
    }).join('');
  }

  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }

  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }

  function match(element) {
    return node => {
      let {
        attributes = []
      } = element; // https://github.com/testing-library/dom-testing-library/issues/814

      const typeTextIndex = attributes.findIndex(attribute => attribute.value && attribute.name === 'type' && attribute.value === 'text');

      if (typeTextIndex >= 0) {
        // not using splice to not mutate the attributes array
        attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];

        if (node.type !== 'text') {
          return false;
        }
      }

      return node.matches(makeElementSelector({ ...element,
        attributes
      }));
    };
  }

  let result = []; // eslint bug here:
  // eslint-disable-next-line no-unused-vars

  for (const [element, roles] of elementRolesMap.entries()) {
    result = [...result, {
      match: match(element),
      roles: Array.from(roles),
      specificity: getSelectorSpecificity(element)
    }];
  }

  return result.sort(bySelectorSpecificity);
}

function getRoles(container, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;

  function flattenDOM(node) {
    return [node, ...Array.from(node.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }

  return flattenDOM(container).filter(element => {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce((acc, node) => {
    let roles = []; // TODO: This violates html-aria which does not allow any role on every element

    if (node.hasAttribute('role')) {
      roles = node.getAttribute('role').split(' ').slice(0, 1);
    } else {
      roles = getImplicitAriaRoles(node);
    }

    return roles.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? { ...rolesAcc,
      [role]: [...rolesAcc[role], node]
    } : { ...rolesAcc,
      [role]: [node]
    }, acc);
  }, {});
}

function prettyRoles(dom, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles = getRoles(dom, {
    hidden
  }); // We prefer to skip generic role, we don't recommend it

  return Object.entries(roles).filter(_ref7 => {
    let [role] = _ref7;
    return role !== 'generic';
  }).map(_ref8 => {
    let [role, elements] = _ref8;
    const delimiterBar = '-'.repeat(50);
    const elementsString = elements.map(el => {
      const nameString = "Name \"" + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + "\":\n";
      const domString = prettyDOM(el.cloneNode(false));

      if (includeDescription) {
        const descriptionString = "Description \"" + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }) + "\":\n";
        return "" + nameString + descriptionString + domString;
      }

      return "" + nameString + domString;
    }).join('\n\n');
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join('\n');
}

const logRoles = function (dom, _temp2) {
  let {
    hidden = false
  } = _temp2 === void 0 ? {} : _temp2;
  return console.log(prettyRoles(dom, {
    hidden
  }));
};
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */


function computeAriaSelected(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-97
  if (element.tagName === 'OPTION') {
    return element.selected;
  } // explicit value


  return checkBooleanAttribute(element, 'aria-selected');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */


function computeAriaChecked(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-56
  // https://www.w3.org/TR/html-aam-1.0/#details-id-67
  if ('indeterminate' in element && element.indeterminate) {
    return undefined;
  }

  if ('checked' in element) {
    return element.checked;
  } // explicit value


  return checkBooleanAttribute(element, 'aria-checked');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */


function computeAriaPressed(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
  return checkBooleanAttribute(element, 'aria-pressed');
}
/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */


function computeAriaCurrent(element) {
  var _ref9, _checkBooleanAttribut;

  // https://www.w3.org/TR/wai-aria-1.1/#aria-current
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, 'aria-current')) != null ? _checkBooleanAttribut : element.getAttribute('aria-current')) != null ? _ref9 : false;
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */


function computeAriaExpanded(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  return checkBooleanAttribute(element, 'aria-expanded');
}

function checkBooleanAttribute(element, attribute) {
  const attributeValue = element.getAttribute(attribute);

  if (attributeValue === 'true') {
    return true;
  }

  if (attributeValue === 'false') {
    return false;
  }

  return undefined;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */


function computeHeadingLevel(element) {
  // https://w3c.github.io/html-aam/#el-h1-h6
  // https://w3c.github.io/html-aam/#el-h1-h6
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  }; // explicit aria-level value
  // https://www.w3.org/TR/wai-aria-1.2/#aria-level

  const ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}

const normalize = getDefaultNormalizer();

function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function getRegExpMatcher(string) {
  return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}

function makeSuggestion(queryName, element, content, _ref) {
  let {
    variant,
    name
  } = _ref;
  let warning = '';
  const queryOptions = {};
  const queryArgs = [['Role', 'TestId'].includes(queryName) ? content : getRegExpMatcher(content)];

  if (name) {
    queryOptions.name = getRegExpMatcher(name);
  }

  if (queryName === 'Role' && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }

  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }

  const queryMethod = variant + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant,
    warning,

    toString() {
      if (warning) {
        console.warn(warning);
      }

      let [text, options] = queryArgs;
      text = typeof text === 'string' ? "'" + text + "'" : text;
      options = options ? ", { " + Object.entries(options).map(_ref2 => {
        let [k, v] = _ref2;
        return k + ": " + v;
      }).join(', ') + " }" : '';
      return queryMethod + "(" + text + options + ")";
    }

  };
}

function canSuggest(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}

function getSuggestedQuery(element, variant, method) {
  var _element$getAttribute, _getImplicitAriaRoles;

  if (variant === void 0) {
    variant = 'get';
  }

  // don't create suggestions for script and style elements
  if (element.matches(getConfig().defaultIgnore)) {
    return undefined;
  } //We prefer to suggest something else if the role is generic


  const role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];

  if (role !== 'generic' && canSuggest('Role', method, role)) {
    return makeSuggestion('Role', element, role, {
      variant,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }

  const labelText = dom_esm_getLabels(document, element).map(label => label.content).join(' ');

  if (canSuggest('LabelText', method, labelText)) {
    return makeSuggestion('LabelText', element, labelText, {
      variant
    });
  }

  const placeholderText = element.getAttribute('placeholder');

  if (canSuggest('PlaceholderText', method, placeholderText)) {
    return makeSuggestion('PlaceholderText', element, placeholderText, {
      variant
    });
  }

  const textContent = normalize(getNodeText(element));

  if (canSuggest('Text', method, textContent)) {
    return makeSuggestion('Text', element, textContent, {
      variant
    });
  }

  if (canSuggest('DisplayValue', method, element.value)) {
    return makeSuggestion('DisplayValue', element, normalize(element.value), {
      variant
    });
  }

  const alt = element.getAttribute('alt');

  if (canSuggest('AltText', method, alt)) {
    return makeSuggestion('AltText', element, alt, {
      variant
    });
  }

  const title = element.getAttribute('title');

  if (canSuggest('Title', method, title)) {
    return makeSuggestion('Title', element, title, {
      variant
    });
  }

  const testId = element.getAttribute(getConfig().testIdAttribute);

  if (canSuggest('TestId', method, testId)) {
    return makeSuggestion('TestId', element, testId, {
      variant
    });
  }

  return undefined;
}

// closer to their code (because async stack traces are hard to follow).

function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}

function waitFor(callback, _ref) {
  let {
    container = getDocument(),
    timeout = getConfig().asyncUtilTimeout,
    showOriginalStackTrace = getConfig().showOriginalStackTrace,
    stackTraceError,
    interval = 50,
    onTimeout = error => {
      error.message = getConfig().getElementError(error.message, container).message;
      return error;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref;

  if (typeof callback !== 'function') {
    throw new TypeError('Received `callback` arg must be a function');
  }

  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = 'idle';
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout);
    const usingJestFakeTimers = jestFakeTimersAreEnabled();

    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig();
      checkCallback(); // this is a dangerous rule to disable because it could lead to an
      // infinite loop. However, eslint isn't smart enough to know that we're
      // setting finished inside `onDone` which will be called when we're done
      // waiting or when we've timed out.
      // eslint-disable-next-line no-unmodified-loop-condition

      while (!finished) {
        if (!jestFakeTimersAreEnabled()) {
          const error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
          reject(error);
          return;
        } // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
        // possible that could make this loop go on forever if someone is using
        // third party code that's setting up recursive timers so rapidly that
        // the user's timer's don't get a chance to resolve. So we'll advance
        // by an interval instead. (We have a test for this case).


        advanceTimersWrapper(() => {
          jest.advanceTimersByTime(interval);
        }); // It's really important that checkCallback is run *before* we flush
        // in-flight promises. To be honest, I'm not sure why, and I can't quite
        // think of a way to reproduce the problem in a test, but I spent
        // an entire day banging my head against a wall on this.

        checkCallback();

        if (finished) {
          break;
        } // In this rare case, we *need* to wait for in-flight promises
        // to resolve before continuing. We don't need to take advantage
        // of parallelization so we're fine.
        // https://stackoverflow.com/a/59243586/971592
        // eslint-disable-next-line no-await-in-loop


        await advanceTimersWrapper(async () => {
          await new Promise(r => {
            setTimeout(r, 0);
            jest.advanceTimersByTime(0);
          });
        });
      }
    } else {
      try {
        checkContainerType(container);
      } catch (e) {
        reject(e);
        return;
      }

      intervalId = setInterval(checkRealTimersCallback, interval);
      const {
        MutationObserver
      } = getWindowFromNode(container);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container, mutationObserverOptions);
      checkCallback();
    }

    function onDone(error, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);

      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }

      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    }

    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled()) {
        const error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
        return reject(error);
      } else {
        return checkCallback();
      }
    }

    function checkCallback() {
      if (promiseStatus === 'pending') return;

      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled(callback);

        if (typeof (result == null ? void 0 : result.then) === 'function') {
          promiseStatus = 'pending';
          result.then(resolvedValue => {
            promiseStatus = 'resolved';
            onDone(null, resolvedValue);
          }, rejectedValue => {
            promiseStatus = 'rejected';
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        } // If `callback` throws, wait for the next mutation, interval, or timeout.

      } catch (error) {
        // Save the most recent callback error to reject the promise with it in the event of a timeout
        lastError = error;
      }
    }

    function handleTimeout() {
      let error;

      if (lastError) {
        error = lastError;

        if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') {
          copyStackTrace(error, stackTraceError);
        }
      } else {
        error = new Error('Timed out in waitFor.');

        if (!showOriginalStackTrace) {
          copyStackTrace(error, stackTraceError);
        }
      }

      onDone(onTimeout(error), null);
    }
  });
}

function waitForWrapper(callback, options) {
  // create the error here so its stack trace is as close to the
  // calling code as possible
  const stackTraceError = new Error('STACK_TRACE_MESSAGE');
  return getConfig().asyncWrapper(() => waitFor(callback, {
    stackTraceError,
    ...options
  }));
}
/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/

function getElementError(message, container) {
  return getConfig().getElementError(message, container);
}

function getMultipleElementsFoundError(message, container) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}

function queryAllByAttribute(attribute, container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(node => matcher(node.getAttribute(attribute), node, text, matchNormalizer));
}

function queryByAttribute(attribute, container, text, options) {
  const els = queryAllByAttribute(attribute, container, text, options);

  if (els.length > 1) {
    throw getMultipleElementsFoundError("Found multiple elements by [" + attribute + "=" + text + "]", container);
  }

  return els[0] || null;
} // this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null


function makeSingleQuery(allQuery, getMultipleError) {
  return function (container) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    const els = allQuery(container, ...args);

    if (els.length > 1) {
      const elementStrings = els.map(element => getElementError(null, element).message).join('\n\n');
      throw getMultipleElementsFoundError(getMultipleError(container, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
    }

    return els[0] || null;
  };
}

function getSuggestionError(suggestion, container) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
} // this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned


function makeGetAllQuery(allQuery, getMissingError) {
  return function (container) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    const els = allQuery(container, ...args);

    if (!els.length) {
      throw getConfig().getElementError(getMissingError(container, ...args), container);
    }

    return els;
  };
} // this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.


function makeFindQuery(getter) {
  return (container, text, options, waitForOptions) => {
    return waitForWrapper(() => {
      return getter(container, text, options);
    }, {
      container,
      ...waitForOptions
    });
  };
}

const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  const element = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);

  if (element && suggest) {
    const suggestion = getSuggestedQuery(element, variant);

    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError(suggestion.toString(), container);
    }
  }

  return element;
};

const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  const els = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);

  if (els.length && suggest) {
    // get a unique list of all suggestion messages.  We are only going to make a suggestion if
    // all the suggestions are the same
    const uniqueSuggestionMessages = [...new Set(els.map(element => {
      var _getSuggestedQuery;

      return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];

    if ( // only want to suggest if all the els have the same suggestion.
    uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith( // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
    getSuggestedQuery(els[0], variant).queryName)) {
      throw getSuggestionError(uniqueSuggestionMessages[0], container);
    }
  }

  return els;
}; // TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`


function buildQueries(queryAllBy, getMultipleError, getMissingError) {
  const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
  const getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
  const getBy = makeSingleQuery(getAllBy, getMultipleError);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
  const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
  const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}

var queryHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getElementError: getElementError,
  wrapAllByQueryWithSuggestion: wrapAllByQueryWithSuggestion,
  wrapSingleQueryWithSuggestion: wrapSingleQueryWithSuggestion,
  getMultipleElementsFoundError: getMultipleElementsFoundError,
  queryAllByAttribute: queryAllByAttribute,
  queryByAttribute: queryByAttribute,
  makeSingleQuery: makeSingleQuery,
  makeGetAllQuery: makeGetAllQuery,
  makeFindQuery: makeFindQuery,
  buildQueries: buildQueries
});

function queryAllLabels(container) {
  return Array.from(container.querySelectorAll('label,input')).map(node => {
    return {
      node,
      textToMatch: getLabelContent(node)
    };
  }).filter(_ref => {
    let {
      textToMatch
    } = _ref;
    return textToMatch !== null;
  });
}

const queryAllLabelsByText = function (container, text, _temp) {
  let {
    exact = true,
    trim,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels(container);
  return textToMatchByLabels.filter(_ref2 => {
    let {
      node,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node, text, matchNormalizer);
  }).map(_ref3 => {
    let {
      node
    } = _ref3;
    return node;
  });
};

const queryAllByLabelText = function (container, text, _temp2) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(element => {
    return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
  }).reduce((labelledElements, labelledElement) => {
    const labelList = dom_esm_getLabels(container, labelledElement, {
      selector
    });
    labelList.filter(label => Boolean(label.formControl)).forEach(label => {
      if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
    });
    const labelsValue = labelList.filter(label => Boolean(label.content)).map(label => label.content);
    if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);

    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index) => {
        if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index, 1);

        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        }
      });
    }

    return labelledElements;
  }, []).concat(queryAllByAttribute('aria-label', container, text, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter(element => element.matches(selector));
}; // the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.


const getAllByLabelText = function (container, text) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  const els = queryAllByLabelText(container, text, ...rest);

  if (!els.length) {
    const labels = queryAllLabelsByText(container, text, ...rest);

    if (labels.length) {
      const tagNames = labels.map(label => getTagNameOfElementAssociatedWithLabelViaFor(container, label)).filter(tagName => !!tagName);

      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map(tagName => "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join('\n\n'), container);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
  }

  return els;
};

function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
  const htmlFor = label.getAttribute('for');

  if (!htmlFor) {
    return null;
  }

  const element = container.querySelector("[id=\"" + htmlFor + "\"]");
  return element ? element.tagName.toLowerCase() : null;
} // the reason mentioned above is the same reason we're not using buildQueries


const getMultipleError$7 = (c, text) => "Found multiple elements with the text of: " + text;

const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');

const queryAllByPlaceholderText = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  checkContainerType(args[0]);
  return queryAllByAttribute('placeholder', ...args);
};

const getMultipleError$6 = (c, text) => "Found multiple elements with the placeholder text of: " + text;

const getMissingError$6 = (c, text) => "Unable to find an element with the placeholder text of: " + text;

const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);

const queryAllByText = function (container, text, _temp) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    ignore = getConfig().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  let baseArray = [];

  if (typeof container.matches === 'function' && container.matches(selector)) {
    baseArray = [container];
  }

  return [...baseArray, ...Array.from(container.querySelectorAll(selector))] // TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
  .filter(node => !ignore || !node.matches(ignore)).filter(node => matcher(getNodeText(node), node, text, matchNormalizer));
};

const getMultipleError$5 = (c, text) => "Found multiple elements with the text: " + text;

const getMissingError$5 = function (c, text, options) {
  if (options === void 0) {
    options = {};
  }

  const {
    collapseWhitespace,
    trim,
    normalizer
  } = options;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const normalizedText = matchNormalizer(text.toString());
  const isNormalizedDifferent = normalizedText !== text.toString();
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};

const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);

const queryAllByDisplayValue = function (container, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("input,textarea,select")).filter(node => {
    if (node.tagName === 'SELECT') {
      const selectedOptions = Array.from(node.options).filter(option => option.selected);
      return selectedOptions.some(optionNode => matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node.value, node, value, matchNormalizer);
    }
  });
};

const getMultipleError$4 = (c, value) => "Found multiple elements with the display value: " + value + ".";

const getMissingError$4 = (c, value) => "Unable to find an element with the display value: " + value + ".";

const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);

const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;

const queryAllByAltText = function (container, alt, options) {
  if (options === void 0) {
    options = {};
  }

  checkContainerType(container);
  return queryAllByAttribute('alt', container, alt, options).filter(node => VALID_TAG_REGEXP.test(node.tagName));
};

const getMultipleError$3 = (c, alt) => "Found multiple elements with the alt text: " + alt;

const getMissingError$3 = (c, alt) => "Unable to find an element with the alt text: " + alt;

const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);

const isSvgTitle = node => {
  var _node$parentElement;

  return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};

const queryAllByTitle = function (container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll('[title], svg > title')).filter(node => matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer));
};

const getMultipleError$2 = (c, title) => "Found multiple elements with the title: " + title + ".";

const getMissingError$2 = (c, title) => "Unable to find an element with the title: " + title + ".";

const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);

function queryAllByRole(container, role, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    hidden = getConfig().defaultHidden,
    name,
    description,
    trim,
    normalizer,
    queryFallbacks = false,
    selected,
    checked,
    pressed,
    current,
    level,
    expanded
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });

  if (selected !== undefined) {
    var _allRoles$get;

    // guard against unknown roles
    if (((_allRoles$get = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) {
      throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
  }

  if (checked !== undefined) {
    var _allRoles$get2;

    // guard against unknown roles
    if (((_allRoles$get2 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get2.props['aria-checked']) === undefined) {
      throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
  }

  if (pressed !== undefined) {
    var _allRoles$get3;

    // guard against unknown roles
    if (((_allRoles$get3 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get3.props['aria-pressed']) === undefined) {
      throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
  }

  if (current !== undefined) {
    var _allRoles$get4;

    /* istanbul ignore next */
    // guard against unknown roles
    // All currently released ARIA versions support `aria-current` on all roles.
    // Leaving this for symetry and forward compatibility
    if (((_allRoles$get4 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get4.props['aria-current']) === undefined) {
      throw new Error("\"aria-current\" is not supported on role \"" + role + "\".");
    }
  }

  if (level !== undefined) {
    // guard against using `level` option with any role other than `heading`
    if (role !== 'heading') {
      throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
  }

  if (expanded !== undefined) {
    var _allRoles$get5;

    // guard against unknown roles
    if (((_allRoles$get5 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get5.props['aria-expanded']) === undefined) {
      throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
  }

  const subtreeIsInaccessibleCache = new WeakMap();

  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }

    return subtreeIsInaccessibleCache.get(element);
  }

  return Array.from(container.querySelectorAll( // Only query elements that can be matched by the following filters
  makeRoleSelector(role, exact, normalizer ? matchNormalizer : undefined))).filter(node => {
    const isRoleSpecifiedExplicitly = node.hasAttribute('role');

    if (isRoleSpecifiedExplicitly) {
      const roleValue = node.getAttribute('role');

      if (queryFallbacks) {
        return roleValue.split(' ').filter(Boolean).some(text => matcher(text, node, role, matchNormalizer));
      } // if a custom normalizer is passed then let normalizer handle the role value


      if (normalizer) {
        return matcher(roleValue, node, role, matchNormalizer);
      } // other wise only send the first word to match


      const [firstWord] = roleValue.split(' ');
      return matcher(firstWord, node, role, matchNormalizer);
    }

    const implicitRoles = getImplicitAriaRoles(node);
    return implicitRoles.some(implicitRole => matcher(implicitRole, node, role, matchNormalizer));
  }).filter(element => {
    if (selected !== undefined) {
      return selected === computeAriaSelected(element);
    }

    if (checked !== undefined) {
      return checked === computeAriaChecked(element);
    }

    if (pressed !== undefined) {
      return pressed === computeAriaPressed(element);
    }

    if (current !== undefined) {
      return current === computeAriaCurrent(element);
    }

    if (expanded !== undefined) {
      return expanded === computeAriaExpanded(element);
    }

    if (level !== undefined) {
      return level === computeHeadingLevel(element);
    } // don't care if aria attributes are unspecified


    return true;
  }).filter(element => {
    if (name === undefined) {
      // Don't care
      return true;
    }

    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name, text => text);
  }).filter(element => {
    if (description === undefined) {
      // Don't care
      return true;
    }

    return matches(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, description, text => text);
  }).filter(element => {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
}

function makeRoleSelector(role, exact, customNormalizer) {
  var _roleElements$get;

  if (typeof role !== 'string') {
    // For non-string role parameters we can not determine the implicitRoleSelectors.
    return '*';
  }

  const explicitRoleSelector = exact && !customNormalizer ? "*[role~=\"" + role + "\"]" : '*[role]';
  const roleRelations = (_roleElements$get = lib/* roleElements.get */.UN.get(role)) != null ? _roleElements$get : new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map(_ref => {
    let {
      name
    } = _ref;
    return name;
  })); // Current transpilation config sometimes assumes `...` is always applied to arrays.
  // `...` is equivalent to `Array.prototype.concat` for arrays.
  // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.

  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(',');
}

const getNameHint = name => {
  let nameHint = '';

  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }

  return nameHint;
};

const getMultipleError$1 = function (c, role, _temp2) {
  let {
    name
  } = _temp2 === void 0 ? {} : _temp2;
  return "Found multiple elements with the role \"" + role + "\"" + getNameHint(name);
};

const getMissingError$1 = function (container, role, _temp3) {
  let {
    hidden = getConfig().defaultHidden,
    name,
    description
  } = _temp3 === void 0 ? {} : _temp3;

  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return "Unable to find role=\"" + role + "\"" + getNameHint(name);
  }

  let roles = '';
  Array.from(container.children).forEach(childElement => {
    roles += prettyRoles(childElement, {
      hidden,
      includeDescription: description !== undefined
    });
  });
  let roleMessage;

  if (roles.length === 0) {
    if (hidden === false) {
      roleMessage = 'There are no accessible roles. But there might be some inaccessible roles. ' + 'If you wish to access them, then set the `hidden` option to `true`. ' + 'Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole';
    } else {
      roleMessage = 'There are no available roles.';
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
  }

  let nameHint = '';

  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }

  let descriptionHint = '';

  if (description === undefined) {
    descriptionHint = '';
  } else if (typeof description === 'string') {
    descriptionHint = " and description \"" + description + "\"";
  } else {
    descriptionHint = " and description `" + description + "`";
  }

  return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};

const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);

const getTestIdAttribute = () => getConfig().testIdAttribute;

const queryAllByTestId = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  checkContainerType(args[0]);
  return queryAllByAttribute(getTestIdAttribute(), ...args);
};

const getMultipleError = (c, id) => "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";

const getMissingError = (c, id) => "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";

const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);

var queries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText: queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText: findAllByLabelText,
  findByLabelText: findByLabelText,
  queryByPlaceholderText: queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText: getByPlaceholderText,
  getAllByPlaceholderText: getAllByPlaceholderText,
  findAllByPlaceholderText: findAllByPlaceholderText,
  findByPlaceholderText: findByPlaceholderText,
  queryByText: queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText: getByText,
  getAllByText: getAllByText,
  findAllByText: findAllByText,
  findByText: findByText,
  queryByDisplayValue: queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue: getByDisplayValue,
  getAllByDisplayValue: getAllByDisplayValue,
  findAllByDisplayValue: findAllByDisplayValue,
  findByDisplayValue: findByDisplayValue,
  queryByAltText: queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText: getByAltText,
  getAllByAltText: getAllByAltText,
  findAllByAltText: findAllByAltText,
  findByAltText: findByAltText,
  queryByTitle: queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle: getByTitle,
  getAllByTitle: getAllByTitle,
  findAllByTitle: findAllByTitle,
  findByTitle: findByTitle,
  queryByRole: queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole: getAllByRole,
  getByRole: getByRole,
  findAllByRole: findAllByRole,
  findByRole: findByRole,
  queryByTestId: queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId: getByTestId,
  getAllByTestId: getAllByTestId,
  findAllByTestId: findAllByTestId,
  findByTestId: findByTestId
});

/**
 * @typedef {{[key: string]: Function}} FuncMap
 */

/**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */

function getQueriesForElement(element, queries$1, initialValue) {
  if (queries$1 === void 0) {
    queries$1 = queries;
  }

  if (initialValue === void 0) {
    initialValue = {};
  }

  return Object.keys(queries$1).reduce((helpers, key) => {
    const fn = queries$1[key];
    helpers[key] = fn.bind(null, element);
    return helpers;
  }, initialValue);
}

const isRemoved = result => !result || Array.isArray(result) && !result.length; // Check if the element is not present.
// As the name implies, waitForElementToBeRemoved should check `present` --> `removed`


function initialCheck(elements) {
  if (isRemoved(elements)) {
    throw new Error('The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the element(s) exist(s) before waiting for removal.');
  }
}

async function waitForElementToBeRemoved(callback, options) {
  // created here so we get a nice stacktrace
  const timeoutError = new Error('Timed out in waitForElementToBeRemoved.');

  if (typeof callback !== 'function') {
    initialCheck(callback);
    const elements = Array.isArray(callback) ? callback : [callback];
    const getRemainingElements = elements.map(element => {
      let parent = element.parentElement;
      if (parent === null) return () => null;

      while (parent.parentElement) parent = parent.parentElement;

      return () => parent.contains(element) ? element : null;
    });

    callback = () => getRemainingElements.map(c => c()).filter(Boolean);
  }

  initialCheck(callback());
  return waitForWrapper(() => {
    let result;

    try {
      result = callback();
    } catch (error) {
      if (error.name === 'TestingLibraryElementError') {
        return undefined;
      }

      throw error;
    }

    if (!isRemoved(result)) {
      throw timeoutError;
    }

    return undefined;
  }, options);
}
/*
eslint
  require-await: "off"
*/

const eventMap = {
  // Clipboard Events
  copy: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: 'InputEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: 'WheelEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is were this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: 'PopStateEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  }
};
const eventAliasMap = {
  doubleClick: 'dblClick'
};

function fireEvent(element, event) {
  return getConfig().eventWrapper(() => {
    if (!event) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }

    if (!element) {
      throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
    }

    return element.dispatchEvent(event);
  });
}

function createEvent(eventName, node, init, _temp) {
  let {
    EventType = 'Event',
    defaultInit = {}
  } = _temp === void 0 ? {} : _temp;

  if (!node) {
    throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
  }

  const eventInit = { ...defaultInit,
    ...init
  };
  const {
    target: {
      value,
      files,
      ...targetProperties
    } = {}
  } = eventInit;

  if (value !== undefined) {
    setNativeValue(node, value);
  }

  if (files !== undefined) {
    // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files
    });
  }

  Object.assign(node, targetProperties);
  const window = getWindowFromNode(node);
  const EventConstructor = window[EventType] || window.Event;
  let event;
  /* istanbul ignore else  */

  if (typeof EventConstructor === 'function') {
    event = new EventConstructor(eventName, eventInit);
  } else {
    // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = window.document.createEvent(EventType);
    const {
      bubbles,
      cancelable,
      detail,
      ...otherInit
    } = eventInit;
    event.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach(eventKey => {
      event[eventKey] = otherInit[eventKey];
    });
  } // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568


  const dataTransferProperties = ['dataTransfer', 'clipboardData'];
  dataTransferProperties.forEach(dataTransferKey => {
    const dataTransferValue = eventInit[dataTransferKey];

    if (typeof dataTransferValue === 'object') {
      /* istanbul ignore if  */
      if (typeof window.DataTransfer === 'function') {
        Object.defineProperty(event, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName) => {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window.DataTransfer())
        });
      } else {
        Object.defineProperty(event, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event;
}

Object.keys(eventMap).forEach(key => {
  const {
    EventType,
    defaultInit
  } = eventMap[key];
  const eventName = key.toLowerCase();

  createEvent[key] = (node, init) => createEvent(eventName, node, init, {
    EventType,
    defaultInit
  });

  fireEvent[key] = (node, init) => fireEvent(node, createEvent[key](node, init));
}); // function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776

function setNativeValue(element, value) {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, 'value') || {};
  const prototype = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};

  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    /* istanbul ignore if */
    // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
    if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      throw new Error('The given element does not have a value setter');
    }
  }
}

Object.keys(eventAliasMap).forEach(aliasKey => {
  const key = eventAliasMap[aliasKey];

  fireEvent[aliasKey] = function () {
    return fireEvent[key](...arguments);
  };
});
/* eslint complexity:["error", 9] */

function unindent(string) {
  // remove white spaces first, to save a few bytes.
  // testing-playground will reformat on load any ways.
  return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}

function encode(value) {
  return (0,lz_string.compressToEncodedURIComponent)(unindent(value));
}

function getPlaygroundUrl(markup) {
  return "https://testing-playground.com/#markup=" + encode(markup);
}

const debug = (element, maxLength, options) => Array.isArray(element) ? element.forEach(el => logDOM(el, maxLength, options)) : logDOM(element, maxLength, options);

const logTestingPlaygroundURL = function (element) {
  if (element === void 0) {
    element = getDocument().body;
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element || !('innerHTML' in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  } // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition


  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }

  const playgroundUrl = getPlaygroundUrl(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};

const initialValue = {
  debug,
  logTestingPlaygroundURL
};
const screen = typeof document !== 'undefined' && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key) => {
  // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
  // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
  // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
  helpers[key] = () => {
    throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
  };

  return helpers;
}, initialValue);




/***/ }),

/***/ 54375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


const ANSI_BACKGROUND_OFFSET = 10;

const wrapAnsi256 = (offset = 0) => code => `\u001B[${38 + offset};5;${code}m`;

const wrapAnsi16m = (offset = 0) => (red, green, blue) => `\u001B[${38 + offset};2;${red};${green};${blue}m`;

function assembleStyles() {
	const codes = new Map();
	const styles = {
		modifier: {
			reset: [0, 0],
			// 21 isn't widely supported and 22 does the same thing
			bold: [1, 22],
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			overline: [53, 55],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		color: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],

			// Bright color
			blackBright: [90, 39],
			redBright: [91, 39],
			greenBright: [92, 39],
			yellowBright: [93, 39],
			blueBright: [94, 39],
			magentaBright: [95, 39],
			cyanBright: [96, 39],
			whiteBright: [97, 39]
		},
		bgColor: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49],

			// Bright color
			bgBlackBright: [100, 49],
			bgRedBright: [101, 49],
			bgGreenBright: [102, 49],
			bgYellowBright: [103, 49],
			bgBlueBright: [104, 49],
			bgMagentaBright: [105, 49],
			bgCyanBright: [106, 49],
			bgWhiteBright: [107, 49]
		}
	};

	// Alias bright black as gray (and grey)
	styles.color.gray = styles.color.blackBright;
	styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
	styles.color.grey = styles.color.blackBright;
	styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;

	for (const [groupName, group] of Object.entries(styles)) {
		for (const [styleName, style] of Object.entries(group)) {
			styles[styleName] = {
				open: `\u001B[${style[0]}m`,
				close: `\u001B[${style[1]}m`
			};

			group[styleName] = styles[styleName];

			codes.set(style[0], style[1]);
		}

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});
	}

	Object.defineProperty(styles, 'codes', {
		value: codes,
		enumerable: false
	});

	styles.color.close = '\u001B[39m';
	styles.bgColor.close = '\u001B[49m';

	styles.color.ansi256 = wrapAnsi256();
	styles.color.ansi16m = wrapAnsi16m();
	styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
	styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);

	// From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
	Object.defineProperties(styles, {
		rgbToAnsi256: {
			value: (red, green, blue) => {
				// We use the extended greyscale palette here, with the exception of
				// black and white. normal palette only has 4 greyscale shades.
				if (red === green && green === blue) {
					if (red < 8) {
						return 16;
					}

					if (red > 248) {
						return 231;
					}

					return Math.round(((red - 8) / 247) * 24) + 232;
				}

				return 16 +
					(36 * Math.round(red / 255 * 5)) +
					(6 * Math.round(green / 255 * 5)) +
					Math.round(blue / 255 * 5);
			},
			enumerable: false
		},
		hexToRgb: {
			value: hex => {
				const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
				if (!matches) {
					return [0, 0, 0];
				}

				let {colorString} = matches.groups;

				if (colorString.length === 3) {
					colorString = colorString.split('').map(character => character + character).join('');
				}

				const integer = Number.parseInt(colorString, 16);

				return [
					(integer >> 16) & 0xFF,
					(integer >> 8) & 0xFF,
					integer & 0xFF
				];
			},
			enumerable: false
		},
		hexToAnsi256: {
			value: hex => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
			enumerable: false
		}
	});

	return styles;
}

// Make the export immutable
Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});


/***/ }),

/***/ 96535:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.4
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return LZString; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}


/***/ }),

/***/ 25171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printIteratorEntries = printIteratorEntries;
exports.printIteratorValues = printIteratorValues;
exports.printListItems = printListItems;
exports.printObjectProperties = printObjectProperties;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const getKeysOfEnumerableProperties = (object, compareKeys) => {
  const keys = Object.keys(object).sort(compareKeys);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(object).forEach(symbol => {
      if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
        keys.push(symbol);
      }
    });
  }

  return keys;
};
/**
 * Return entries (for example, of a map)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printIteratorEntries(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer, // Too bad, so sad that separator for ECMAScript Map has been ' => '
  // What a distracting diff if you change a data structure to/from
  // ECMAScript Object or Immutable.Map/OrderedMap which use the default.
  separator = ': '
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      const name = printer(
        current.value[0],
        config,
        indentationNext,
        depth,
        refs
      );
      const value = printer(
        current.value[1],
        config,
        indentationNext,
        depth,
        refs
      );
      result += indentationNext + name + separator + value;
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return values (for example, of a set)
 * with spacing, indentation, and comma
 * without surrounding punctuation (braces or brackets)
 */

function printIteratorValues(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      result +=
        indentationNext +
        printer(current.value, config, indentationNext, depth, refs);
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return items (for example, of an array)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, brackets)
 **/

function printListItems(list, config, indentation, depth, refs, printer) {
  let result = '';

  if (list.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < list.length; i++) {
      result += indentationNext;

      if (i in list) {
        result += printer(list[i], config, indentationNext, depth, refs);
      }

      if (i < list.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return properties of an object
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printObjectProperties(val, config, indentation, depth, refs, printer) {
  let result = '';
  const keys = getKeysOfEnumerableProperties(val, config.compareKeys);

  if (keys.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const name = printer(key, config, indentationNext, depth, refs);
      const value = printer(val[key], config, indentationNext, depth, refs);
      result += indentationNext + name + ': ' + value;

      if (i < keys.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}


/***/ }),

/***/ 57745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = void 0;
exports.WU = format;
exports.Gr = void 0;

var _ansiStyles = _interopRequireDefault(__webpack_require__(54375));

var _collections = __webpack_require__(25171);

var _AsymmetricMatcher = _interopRequireDefault(
  __webpack_require__(72671)
);

var _ConvertAnsi = _interopRequireDefault(__webpack_require__(98373));

var _DOMCollection = _interopRequireDefault(__webpack_require__(71316));

var _DOMElement = _interopRequireDefault(__webpack_require__(85606));

var _Immutable = _interopRequireDefault(__webpack_require__(58555));

var _ReactElement = _interopRequireDefault(__webpack_require__(9682));

var _ReactTestComponent = _interopRequireDefault(
  __webpack_require__(70680)
);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const toString = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
/**
 * Explicitly comparing typeof constructor to function avoids undefined as name
 * when mock identity-obj-proxy returns the key as the value for any key.
 */

const getConstructorName = val =>
  (typeof val.constructor === 'function' && val.constructor.name) || 'Object';
/* global window */

/** Is val is equal to global window object? Works even if it does not exist :) */

const isWindow = val => typeof window !== 'undefined' && val === window;

const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;

class PrettyFormatPluginError extends Error {
  constructor(message, stack) {
    super(message);
    this.stack = stack;
    this.name = this.constructor.name;
  }
}

function isToStringedArrayType(toStringed) {
  return (
    toStringed === '[object Array]' ||
    toStringed === '[object ArrayBuffer]' ||
    toStringed === '[object DataView]' ||
    toStringed === '[object Float32Array]' ||
    toStringed === '[object Float64Array]' ||
    toStringed === '[object Int8Array]' ||
    toStringed === '[object Int16Array]' ||
    toStringed === '[object Int32Array]' ||
    toStringed === '[object Uint8Array]' ||
    toStringed === '[object Uint8ClampedArray]' ||
    toStringed === '[object Uint16Array]' ||
    toStringed === '[object Uint32Array]'
  );
}

function printNumber(val) {
  return Object.is(val, -0) ? '-0' : String(val);
}

function printBigInt(val) {
  return String(`${val}n`);
}

function printFunction(val, printFunctionName) {
  if (!printFunctionName) {
    return '[Function]';
  }

  return '[Function ' + (val.name || 'anonymous') + ']';
}

function printSymbol(val) {
  return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
}

function printError(val) {
  return '[' + errorToString.call(val) + ']';
}
/**
 * The first port of call for printing an object, handles most of the
 * data-types in JS.
 */

function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
  if (val === true || val === false) {
    return '' + val;
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (val === null) {
    return 'null';
  }

  const typeOf = typeof val;

  if (typeOf === 'number') {
    return printNumber(val);
  }

  if (typeOf === 'bigint') {
    return printBigInt(val);
  }

  if (typeOf === 'string') {
    if (escapeString) {
      return '"' + val.replace(/"|\\/g, '\\$&') + '"';
    }

    return '"' + val + '"';
  }

  if (typeOf === 'function') {
    return printFunction(val, printFunctionName);
  }

  if (typeOf === 'symbol') {
    return printSymbol(val);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object WeakMap]') {
    return 'WeakMap {}';
  }

  if (toStringed === '[object WeakSet]') {
    return 'WeakSet {}';
  }

  if (
    toStringed === '[object Function]' ||
    toStringed === '[object GeneratorFunction]'
  ) {
    return printFunction(val, printFunctionName);
  }

  if (toStringed === '[object Symbol]') {
    return printSymbol(val);
  }

  if (toStringed === '[object Date]') {
    return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
  }

  if (toStringed === '[object Error]') {
    return printError(val);
  }

  if (toStringed === '[object RegExp]') {
    if (escapeRegex) {
      // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
      return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    return regExpToString.call(val);
  }

  if (val instanceof Error) {
    return printError(val);
  }

  return null;
}
/**
 * Handles more complex objects ( such as objects with circular references.
 * maps and sets etc )
 */

function printComplexValue(
  val,
  config,
  indentation,
  depth,
  refs,
  hasCalledToJSON
) {
  if (refs.indexOf(val) !== -1) {
    return '[Circular]';
  }

  refs = refs.slice();
  refs.push(val);
  const hitMaxDepth = ++depth > config.maxDepth;
  const min = config.min;

  if (
    config.callToJSON &&
    !hitMaxDepth &&
    val.toJSON &&
    typeof val.toJSON === 'function' &&
    !hasCalledToJSON
  ) {
    return printer(val.toJSON(), config, indentation, depth, refs, true);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object Arguments]') {
    return hitMaxDepth
      ? '[Arguments]'
      : (min ? '' : 'Arguments ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (isToStringedArrayType(toStringed)) {
    return hitMaxDepth
      ? '[' + val.constructor.name + ']'
      : (min
          ? ''
          : !config.printBasicPrototype && val.constructor.name === 'Array'
          ? ''
          : val.constructor.name + ' ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (toStringed === '[object Map]') {
    return hitMaxDepth
      ? '[Map]'
      : 'Map {' +
          (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer,
            ' => '
          ) +
          '}';
  }

  if (toStringed === '[object Set]') {
    return hitMaxDepth
      ? '[Set]'
      : 'Set {' +
          (0, _collections.printIteratorValues)(
            val.values(),
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          '}';
  } // Avoid failure to serialize global window object in jsdom test environment.
  // For example, not even relevant if window is prop of React element.

  return hitMaxDepth || isWindow(val)
    ? '[' + getConstructorName(val) + ']'
    : (min
        ? ''
        : !config.printBasicPrototype && getConstructorName(val) === 'Object'
        ? ''
        : getConstructorName(val) + ' ') +
        '{' +
        (0, _collections.printObjectProperties)(
          val,
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
}

function isNewPlugin(plugin) {
  return plugin.serialize != null;
}

function printPlugin(plugin, val, config, indentation, depth, refs) {
  let printed;

  try {
    printed = isNewPlugin(plugin)
      ? plugin.serialize(val, config, indentation, depth, refs, printer)
      : plugin.print(
          val,
          valChild => printer(valChild, config, indentation, depth, refs),
          str => {
            const indentationNext = indentation + config.indent;
            return (
              indentationNext +
              str.replace(NEWLINE_REGEXP, '\n' + indentationNext)
            );
          },
          {
            edgeSpacing: config.spacingOuter,
            min: config.min,
            spacing: config.spacingInner
          },
          config.colors
        );
  } catch (error) {
    throw new PrettyFormatPluginError(error.message, error.stack);
  }

  if (typeof printed !== 'string') {
    throw new Error(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`
    );
  }

  return printed;
}

function findPlugin(plugins, val) {
  for (let p = 0; p < plugins.length; p++) {
    try {
      if (plugins[p].test(val)) {
        return plugins[p];
      }
    } catch (error) {
      throw new PrettyFormatPluginError(error.message, error.stack);
    }
  }

  return null;
}

function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
  const plugin = findPlugin(config.plugins, val);

  if (plugin !== null) {
    return printPlugin(plugin, val, config, indentation, depth, refs);
  }

  const basicResult = printBasicValue(
    val,
    config.printFunctionName,
    config.escapeRegex,
    config.escapeString
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(
    val,
    config,
    indentation,
    depth,
    refs,
    hasCalledToJSON
  );
}

const DEFAULT_THEME = {
  comment: 'gray',
  content: 'reset',
  prop: 'yellow',
  tag: 'cyan',
  value: 'green'
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
  callToJSON: true,
  compareKeys: undefined,
  escapeRegex: false,
  escapeString: true,
  highlight: false,
  indent: 2,
  maxDepth: Infinity,
  min: false,
  plugins: [],
  printBasicPrototype: true,
  printFunctionName: true,
  theme: DEFAULT_THEME
};
__webpack_unused_export__ = DEFAULT_OPTIONS;

function validateOptions(options) {
  Object.keys(options).forEach(key => {
    if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
      throw new Error(`pretty-format: Unknown option "${key}".`);
    }
  });

  if (options.min && options.indent !== undefined && options.indent !== 0) {
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
  }

  if (options.theme !== undefined) {
    if (options.theme === null) {
      throw new Error(`pretty-format: Option "theme" must not be null.`);
    }

    if (typeof options.theme !== 'object') {
      throw new Error(
        `pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`
      );
    }
  }
}

const getColorsHighlight = options =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    const value =
      options.theme && options.theme[key] !== undefined
        ? options.theme[key]
        : DEFAULT_THEME[key];
    const color = value && _ansiStyles.default[value];

    if (
      color &&
      typeof color.close === 'string' &&
      typeof color.open === 'string'
    ) {
      colors[key] = color;
    } else {
      throw new Error(
        `pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`
      );
    }

    return colors;
  }, Object.create(null));

const getColorsEmpty = () =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    colors[key] = {
      close: '',
      open: ''
    };
    return colors;
  }, Object.create(null));

const getPrintFunctionName = options =>
  options && options.printFunctionName !== undefined
    ? options.printFunctionName
    : DEFAULT_OPTIONS.printFunctionName;

const getEscapeRegex = options =>
  options && options.escapeRegex !== undefined
    ? options.escapeRegex
    : DEFAULT_OPTIONS.escapeRegex;

const getEscapeString = options =>
  options && options.escapeString !== undefined
    ? options.escapeString
    : DEFAULT_OPTIONS.escapeString;

const getConfig = options => {
  var _options$printBasicPr;

  return {
    callToJSON:
      options && options.callToJSON !== undefined
        ? options.callToJSON
        : DEFAULT_OPTIONS.callToJSON,
    colors:
      options && options.highlight
        ? getColorsHighlight(options)
        : getColorsEmpty(),
    compareKeys:
      options && typeof options.compareKeys === 'function'
        ? options.compareKeys
        : DEFAULT_OPTIONS.compareKeys,
    escapeRegex: getEscapeRegex(options),
    escapeString: getEscapeString(options),
    indent:
      options && options.min
        ? ''
        : createIndent(
            options && options.indent !== undefined
              ? options.indent
              : DEFAULT_OPTIONS.indent
          ),
    maxDepth:
      options && options.maxDepth !== undefined
        ? options.maxDepth
        : DEFAULT_OPTIONS.maxDepth,
    min:
      options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
    plugins:
      options && options.plugins !== undefined
        ? options.plugins
        : DEFAULT_OPTIONS.plugins,
    printBasicPrototype:
      (_options$printBasicPr =
        options === null || options === void 0
          ? void 0
          : options.printBasicPrototype) !== null &&
      _options$printBasicPr !== void 0
        ? _options$printBasicPr
        : true,
    printFunctionName: getPrintFunctionName(options),
    spacingInner: options && options.min ? ' ' : '\n',
    spacingOuter: options && options.min ? '' : '\n'
  };
};

function createIndent(indent) {
  return new Array(indent + 1).join(' ');
}
/**
 * Returns a presentation string of your `val` object
 * @param val any potential JavaScript object
 * @param options Custom settings
 */

function format(val, options) {
  if (options) {
    validateOptions(options);

    if (options.plugins) {
      const plugin = findPlugin(options.plugins, val);

      if (plugin !== null) {
        return printPlugin(plugin, val, getConfig(options), '', 0, []);
      }
    }
  }

  const basicResult = printBasicValue(
    val,
    getPrintFunctionName(options),
    getEscapeRegex(options),
    getEscapeString(options)
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(val, getConfig(options), '', 0, []);
}

const plugins = {
  AsymmetricMatcher: _AsymmetricMatcher.default,
  ConvertAnsi: _ConvertAnsi.default,
  DOMCollection: _DOMCollection.default,
  DOMElement: _DOMElement.default,
  Immutable: _Immutable.default,
  ReactElement: _ReactElement.default,
  ReactTestComponent: _ReactTestComponent.default
};
exports.Gr = plugins;
var _default = format;
__webpack_unused_export__ = _default;


/***/ }),

/***/ 72671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(25171);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const asymmetricMatcher =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('jest.asymmetricMatcher')
    : 0x1357a5;
const SPACE = ' ';

const serialize = (val, config, indentation, depth, refs, printer) => {
  const stringedValue = val.toString();

  if (
    stringedValue === 'ArrayContaining' ||
    stringedValue === 'ArrayNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '[' +
      (0, _collections.printListItems)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']'
    );
  }

  if (
    stringedValue === 'ObjectContaining' ||
    stringedValue === 'ObjectNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '{' +
      (0, _collections.printObjectProperties)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'
    );
  }

  if (
    stringedValue === 'StringMatching' ||
    stringedValue === 'StringNotMatching'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  if (
    stringedValue === 'StringContaining' ||
    stringedValue === 'StringNotContaining'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  return val.toAsymmetricMatcher();
};

exports.serialize = serialize;

const test = val => val && val.$$typeof === asymmetricMatcher;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 98373:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _ansiRegex = _interopRequireDefault(__webpack_require__(42513));

var _ansiStyles = _interopRequireDefault(__webpack_require__(54375));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const toHumanReadableAnsi = text =>
  text.replace((0, _ansiRegex.default)(), match => {
    switch (match) {
      case _ansiStyles.default.red.close:
      case _ansiStyles.default.green.close:
      case _ansiStyles.default.cyan.close:
      case _ansiStyles.default.gray.close:
      case _ansiStyles.default.white.close:
      case _ansiStyles.default.yellow.close:
      case _ansiStyles.default.bgRed.close:
      case _ansiStyles.default.bgGreen.close:
      case _ansiStyles.default.bgYellow.close:
      case _ansiStyles.default.inverse.close:
      case _ansiStyles.default.dim.close:
      case _ansiStyles.default.bold.close:
      case _ansiStyles.default.reset.open:
      case _ansiStyles.default.reset.close:
        return '</>';

      case _ansiStyles.default.red.open:
        return '<red>';

      case _ansiStyles.default.green.open:
        return '<green>';

      case _ansiStyles.default.cyan.open:
        return '<cyan>';

      case _ansiStyles.default.gray.open:
        return '<gray>';

      case _ansiStyles.default.white.open:
        return '<white>';

      case _ansiStyles.default.yellow.open:
        return '<yellow>';

      case _ansiStyles.default.bgRed.open:
        return '<bgRed>';

      case _ansiStyles.default.bgGreen.open:
        return '<bgGreen>';

      case _ansiStyles.default.bgYellow.open:
        return '<bgYellow>';

      case _ansiStyles.default.inverse.open:
        return '<inverse>';

      case _ansiStyles.default.dim.open:
        return '<dim>';

      case _ansiStyles.default.bold.open:
        return '<bold>';

      default:
        return '';
    }
  });

const test = val =>
  typeof val === 'string' && !!val.match((0, _ansiRegex.default)());

exports.test = test;

const serialize = (val, config, indentation, depth, refs, printer) =>
  printer(toHumanReadableAnsi(val), config, indentation, depth, refs);

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 71316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(25171);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const SPACE = ' ';
const OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;

const testName = name =>
  OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);

const test = val =>
  val &&
  val.constructor &&
  !!val.constructor.name &&
  testName(val.constructor.name);

exports.test = test;

const isNamedNodeMap = collection =>
  collection.constructor.name === 'NamedNodeMap';

const serialize = (collection, config, indentation, depth, refs, printer) => {
  const name = collection.constructor.name;

  if (++depth > config.maxDepth) {
    return '[' + name + ']';
  }

  return (
    (config.min ? '' : name + SPACE) +
    (OBJECT_NAMES.indexOf(name) !== -1
      ? '{' +
        (0, _collections.printObjectProperties)(
          isNamedNodeMap(collection)
            ? Array.from(collection).reduce((props, attribute) => {
                props[attribute.name] = attribute.value;
                return props;
              }, {})
            : {...collection},
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}'
      : '[' +
        (0, _collections.printListItems)(
          Array.from(collection),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        ']')
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 85606:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(98326);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const COMMENT_NODE = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;

const testHasAttribute = val => {
  try {
    return typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  } catch {
    return false;
  }
};

const testNode = val => {
  const constructorName = val.constructor.name;
  const {nodeType, tagName} = val;
  const isCustomElement =
    (typeof tagName === 'string' && tagName.includes('-')) ||
    testHasAttribute(val);
  return (
    (nodeType === ELEMENT_NODE &&
      (ELEMENT_REGEXP.test(constructorName) || isCustomElement)) ||
    (nodeType === TEXT_NODE && constructorName === 'Text') ||
    (nodeType === COMMENT_NODE && constructorName === 'Comment') ||
    (nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment')
  );
};

const test = val => {
  var _val$constructor;

  return (
    (val === null || val === void 0
      ? void 0
      : (_val$constructor = val.constructor) === null ||
        _val$constructor === void 0
      ? void 0
      : _val$constructor.name) && testNode(val)
  );
};

exports.test = test;

function nodeIsText(node) {
  return node.nodeType === TEXT_NODE;
}

function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE;
}

function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}

const serialize = (node, config, indentation, depth, refs, printer) => {
  if (nodeIsText(node)) {
    return (0, _markup.printText)(node.data, config);
  }

  if (nodeIsComment(node)) {
    return (0, _markup.printComment)(node.data, config);
  }

  const type = nodeIsFragment(node)
    ? `DocumentFragment`
    : node.tagName.toLowerCase();

  if (++depth > config.maxDepth) {
    return (0, _markup.printElementAsLeaf)(type, config);
  }

  return (0, _markup.printElement)(
    type,
    (0, _markup.printProps)(
      nodeIsFragment(node)
        ? []
        : Array.from(node.attributes)
            .map(attr => attr.name)
            .sort(),
      nodeIsFragment(node)
        ? {}
        : Array.from(node.attributes).reduce((props, attribute) => {
            props[attribute.name] = attribute.value;
            return props;
          }, {}),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    (0, _markup.printChildren)(
      Array.prototype.slice.call(node.childNodes || node.children),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    config,
    indentation
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 58555:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(25171);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// SENTINEL constants are from https://github.com/facebook/immutable-js
const IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
const IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
const IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
const IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
const IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
const IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4

const IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
const IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
const IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

const getImmutableName = name => 'Immutable.' + name;

const printAsLeaf = name => '[' + name + ']';

const SPACE = ' ';
const LAZY = '…'; // Seq is lazy if it calls a method like filter

const printImmutableEntries = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '{' +
      (0, _collections.printIteratorEntries)(
        val.entries(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'; // Record has an entries method because it is a collection in immutable v3.
// Return an iterator for Immutable Record from version v3 or v4.

function getRecordEntries(val) {
  let i = 0;
  return {
    next() {
      if (i < val._keys.length) {
        const key = val._keys[i++];
        return {
          done: false,
          value: [key, val.get(key)]
        };
      }

      return {
        done: true,
        value: undefined
      };
    }
  };
}

const printImmutableRecord = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer
) => {
  // _name property is defined only for an Immutable Record instance
  // which was constructed with a second optional descriptive name arg
  const name = getImmutableName(val._name || 'Record');
  return ++depth > config.maxDepth
    ? printAsLeaf(name)
    : name +
        SPACE +
        '{' +
        (0, _collections.printIteratorEntries)(
          getRecordEntries(val),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
};

const printImmutableSeq = (val, config, indentation, depth, refs, printer) => {
  const name = getImmutableName('Seq');

  if (++depth > config.maxDepth) {
    return printAsLeaf(name);
  }

  if (val[IS_KEYED_SENTINEL]) {
    return (
      name +
      SPACE +
      '{' + // from Immutable collection of entries or from ECMAScript object
      (val._iter || val._object
        ? (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer
          )
        : LAZY) +
      '}'
    );
  }

  return (
    name +
    SPACE +
    '[' +
    (val._iter || // from Immutable collection of values
    val._array || // from ECMAScript array
    val._collection || // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
      ? (0, _collections.printIteratorValues)(
          val.values(),
          config,
          indentation,
          depth,
          refs,
          printer
        )
      : LAZY) +
    ']'
  );
};

const printImmutableValues = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '[' +
      (0, _collections.printIteratorValues)(
        val.values(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']';

const serialize = (val, config, indentation, depth, refs, printer) => {
  if (val[IS_MAP_SENTINEL]) {
    return printImmutableEntries(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map'
    );
  }

  if (val[IS_LIST_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'List'
    );
  }

  if (val[IS_SET_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set'
    );
  }

  if (val[IS_STACK_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'Stack'
    );
  }

  if (val[IS_SEQ_SENTINEL]) {
    return printImmutableSeq(val, config, indentation, depth, refs, printer);
  } // For compatibility with immutable v3 and v4, let record be the default.

  return printImmutableRecord(val, config, indentation, depth, refs, printer);
}; // Explicitly comparing sentinel properties to true avoids false positive
// when mock identity-obj-proxy returns the key as the value for any key.

exports.serialize = serialize;

const test = val =>
  val &&
  (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 9682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var ReactIs = _interopRequireWildcard(__webpack_require__(91361));

var _markup = __webpack_require__(98326);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
    return {default: obj};
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Given element.props.children, or subtree during recursive traversal,
// return flattened array of children.
const getChildren = (arg, children = []) => {
  if (Array.isArray(arg)) {
    arg.forEach(item => {
      getChildren(item, children);
    });
  } else if (arg != null && arg !== false) {
    children.push(arg);
  }

  return children;
};

const getType = element => {
  const type = element.type;

  if (typeof type === 'string') {
    return type;
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || 'Unknown';
  }

  if (ReactIs.isFragment(element)) {
    return 'React.Fragment';
  }

  if (ReactIs.isSuspense(element)) {
    return 'React.Suspense';
  }

  if (typeof type === 'object' && type !== null) {
    if (ReactIs.isContextProvider(element)) {
      return 'Context.Provider';
    }

    if (ReactIs.isContextConsumer(element)) {
      return 'Context.Consumer';
    }

    if (ReactIs.isForwardRef(element)) {
      if (type.displayName) {
        return type.displayName;
      }

      const functionName = type.render.displayName || type.render.name || '';
      return functionName !== ''
        ? 'ForwardRef(' + functionName + ')'
        : 'ForwardRef';
    }

    if (ReactIs.isMemo(element)) {
      const functionName =
        type.displayName || type.type.displayName || type.type.name || '';
      return functionName !== '' ? 'Memo(' + functionName + ')' : 'Memo';
    }
  }

  return 'UNDEFINED';
};

const getPropKeys = element => {
  const {props} = element;
  return Object.keys(props)
    .filter(key => key !== 'children' && props[key] !== undefined)
    .sort();
};

const serialize = (element, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(getType(element), config)
    : (0, _markup.printElement)(
        getType(element),
        (0, _markup.printProps)(
          getPropKeys(element),
          element.props,
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        (0, _markup.printChildren)(
          getChildren(element.props.children),
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val != null && ReactIs.isElement(val);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 70680:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(98326);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const testSymbol =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('react.test.json')
    : 0xea71357;

const getPropKeys = object => {
  const {props} = object;
  return props
    ? Object.keys(props)
        .filter(key => props[key] !== undefined)
        .sort()
    : [];
};

const serialize = (object, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(object.type, config)
    : (0, _markup.printElement)(
        object.type,
        object.props
          ? (0, _markup.printProps)(
              getPropKeys(object),
              object.props,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        object.children
          ? (0, _markup.printChildren)(
              object.children,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val && val.$$typeof === testSymbol;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 74077:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = escapeHTML;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


/***/ }),

/***/ 98326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printText =
  exports.printProps =
  exports.printElementAsLeaf =
  exports.printElement =
  exports.printComment =
  exports.printChildren =
    void 0;

var _escapeHTML = _interopRequireDefault(__webpack_require__(74077));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys
    .map(key => {
      const value = props[key];
      let printed = printer(value, config, indentationNext, depth, refs);

      if (typeof value !== 'string') {
        if (printed.indexOf('\n') !== -1) {
          printed =
            config.spacingOuter +
            indentationNext +
            printed +
            config.spacingOuter +
            indentation;
        }

        printed = '{' + printed + '}';
      }

      return (
        config.spacingInner +
        indentation +
        colors.prop.open +
        key +
        colors.prop.close +
        '=' +
        colors.value.open +
        printed +
        colors.value.close
      );
    })
    .join('');
}; // Return empty string if children is empty.

exports.printProps = printProps;

const printChildren = (children, config, indentation, depth, refs, printer) =>
  children
    .map(
      child =>
        config.spacingOuter +
        indentation +
        (typeof child === 'string'
          ? printText(child, config)
          : printer(child, config, indentation, depth, refs))
    )
    .join('');

exports.printChildren = printChildren;

const printText = (text, config) => {
  const contentColor = config.colors.content;
  return (
    contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close
  );
};

exports.printText = printText;

const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return (
    commentColor.open +
    '<!--' +
    (0, _escapeHTML.default)(comment) +
    '-->' +
    commentColor.close
  );
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.

exports.printComment = printComment;

const printElement = (
  type,
  printedProps,
  printedChildren,
  config,
  indentation
) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    (printedProps &&
      tagColor.close +
        printedProps +
        config.spacingOuter +
        indentation +
        tagColor.open) +
    (printedChildren
      ? '>' +
        tagColor.close +
        printedChildren +
        config.spacingOuter +
        indentation +
        tagColor.open +
        '</' +
        type
      : (printedProps && !config.min ? '' : ' ') + '/') +
    '>' +
    tagColor.close
  );
};

exports.printElement = printElement;

const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    tagColor.close +
    ' …' +
    tagColor.open +
    ' />' +
    tagColor.close
  );
};

exports.printElementAsLeaf = printElementAsLeaf;


/***/ }),

/***/ 89057:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 91361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(89057);
} else {}


/***/ }),

/***/ 72256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var properties = [['aria-activedescendant', {
  'type': 'id'
}], ['aria-atomic', {
  'type': 'boolean'
}], ['aria-autocomplete', {
  'type': 'token',
  'values': ['inline', 'list', 'both', 'none']
}], ['aria-busy', {
  'type': 'boolean'
}], ['aria-checked', {
  'type': 'tristate'
}], ['aria-colcount', {
  type: 'integer'
}], ['aria-colindex', {
  type: 'integer'
}], ['aria-colspan', {
  type: 'integer'
}], ['aria-controls', {
  'type': 'idlist'
}], ['aria-current', {
  type: 'token',
  values: ['page', 'step', 'location', 'date', 'time', true, false]
}], ['aria-describedby', {
  'type': 'idlist'
}], ['aria-details', {
  'type': 'id'
}], ['aria-disabled', {
  'type': 'boolean'
}], ['aria-dropeffect', {
  'type': 'tokenlist',
  'values': ['copy', 'execute', 'link', 'move', 'none', 'popup']
}], ['aria-errormessage', {
  'type': 'id'
}], ['aria-expanded', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-flowto', {
  'type': 'idlist'
}], ['aria-grabbed', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-haspopup', {
  'type': 'token',
  'values': [false, true, 'menu', 'listbox', 'tree', 'grid', 'dialog']
}], ['aria-hidden', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-invalid', {
  'type': 'token',
  'values': ['grammar', false, 'spelling', true]
}], ['aria-keyshortcuts', {
  type: 'string'
}], ['aria-label', {
  'type': 'string'
}], ['aria-labelledby', {
  'type': 'idlist'
}], ['aria-level', {
  'type': 'integer'
}], ['aria-live', {
  'type': 'token',
  'values': ['assertive', 'off', 'polite']
}], ['aria-modal', {
  type: 'boolean'
}], ['aria-multiline', {
  'type': 'boolean'
}], ['aria-multiselectable', {
  'type': 'boolean'
}], ['aria-orientation', {
  'type': 'token',
  'values': ['vertical', 'undefined', 'horizontal']
}], ['aria-owns', {
  'type': 'idlist'
}], ['aria-placeholder', {
  type: 'string'
}], ['aria-posinset', {
  'type': 'integer'
}], ['aria-pressed', {
  'type': 'tristate'
}], ['aria-readonly', {
  'type': 'boolean'
}], ['aria-relevant', {
  'type': 'tokenlist',
  'values': ['additions', 'all', 'removals', 'text']
}], ['aria-required', {
  'type': 'boolean'
}], ['aria-roledescription', {
  type: 'string'
}], ['aria-rowcount', {
  type: 'integer'
}], ['aria-rowindex', {
  type: 'integer'
}], ['aria-rowspan', {
  type: 'integer'
}], ['aria-selected', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-setsize', {
  'type': 'integer'
}], ['aria-sort', {
  'type': 'token',
  'values': ['ascending', 'descending', 'none', 'other']
}], ['aria-valuemax', {
  'type': 'number'
}], ['aria-valuemin', {
  'type': 'number'
}], ['aria-valuenow', {
  'type': 'number'
}], ['aria-valuetext', {
  'type': 'string'
}]];
var ariaPropsMap = {
  entries: function entries() {
    return properties;
  },
  get: function get(key) {
    var item = properties.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!this.get(key);
  },
  keys: function keys() {
    return properties.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return key;
    });
  },
  values: function values() {
    return properties.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];

      return values;
    });
  }
};
var _default = ariaPropsMap;
exports["default"] = _default;

/***/ }),

/***/ 92607:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var dom = [['a', {
  reserved: false
}], ['abbr', {
  reserved: false
}], ['acronym', {
  reserved: false
}], ['address', {
  reserved: false
}], ['applet', {
  reserved: false
}], ['area', {
  reserved: false
}], ['article', {
  reserved: false
}], ['aside', {
  reserved: false
}], ['audio', {
  reserved: false
}], ['b', {
  reserved: false
}], ['base', {
  reserved: true
}], ['bdi', {
  reserved: false
}], ['bdo', {
  reserved: false
}], ['big', {
  reserved: false
}], ['blink', {
  reserved: false
}], ['blockquote', {
  reserved: false
}], ['body', {
  reserved: false
}], ['br', {
  reserved: false
}], ['button', {
  reserved: false
}], ['canvas', {
  reserved: false
}], ['caption', {
  reserved: false
}], ['center', {
  reserved: false
}], ['cite', {
  reserved: false
}], ['code', {
  reserved: false
}], ['col', {
  reserved: true
}], ['colgroup', {
  reserved: true
}], ['content', {
  reserved: false
}], ['data', {
  reserved: false
}], ['datalist', {
  reserved: false
}], ['dd', {
  reserved: false
}], ['del', {
  reserved: false
}], ['details', {
  reserved: false
}], ['dfn', {
  reserved: false
}], ['dialog', {
  reserved: false
}], ['dir', {
  reserved: false
}], ['div', {
  reserved: false
}], ['dl', {
  reserved: false
}], ['dt', {
  reserved: false
}], ['em', {
  reserved: false
}], ['embed', {
  reserved: false
}], ['fieldset', {
  reserved: false
}], ['figcaption', {
  reserved: false
}], ['figure', {
  reserved: false
}], ['font', {
  reserved: false
}], ['footer', {
  reserved: false
}], ['form', {
  reserved: false
}], ['frame', {
  reserved: false
}], ['frameset', {
  reserved: false
}], ['h1', {
  reserved: false
}], ['h2', {
  reserved: false
}], ['h3', {
  reserved: false
}], ['h4', {
  reserved: false
}], ['h5', {
  reserved: false
}], ['h6', {
  reserved: false
}], ['head', {
  reserved: true
}], ['header', {
  reserved: false
}], ['hgroup', {
  reserved: false
}], ['hr', {
  reserved: false
}], ['html', {
  reserved: true
}], ['i', {
  reserved: false
}], ['iframe', {
  reserved: false
}], ['img', {
  reserved: false
}], ['input', {
  reserved: false
}], ['ins', {
  reserved: false
}], ['kbd', {
  reserved: false
}], ['keygen', {
  reserved: false
}], ['label', {
  reserved: false
}], ['legend', {
  reserved: false
}], ['li', {
  reserved: false
}], ['link', {
  reserved: true
}], ['main', {
  reserved: false
}], ['map', {
  reserved: false
}], ['mark', {
  reserved: false
}], ['marquee', {
  reserved: false
}], ['menu', {
  reserved: false
}], ['menuitem', {
  reserved: false
}], ['meta', {
  reserved: true
}], ['meter', {
  reserved: false
}], ['nav', {
  reserved: false
}], ['noembed', {
  reserved: true
}], ['noscript', {
  reserved: true
}], ['object', {
  reserved: false
}], ['ol', {
  reserved: false
}], ['optgroup', {
  reserved: false
}], ['option', {
  reserved: false
}], ['output', {
  reserved: false
}], ['p', {
  reserved: false
}], ['param', {
  reserved: true
}], ['picture', {
  reserved: true
}], ['pre', {
  reserved: false
}], ['progress', {
  reserved: false
}], ['q', {
  reserved: false
}], ['rp', {
  reserved: false
}], ['rt', {
  reserved: false
}], ['rtc', {
  reserved: false
}], ['ruby', {
  reserved: false
}], ['s', {
  reserved: false
}], ['samp', {
  reserved: false
}], ['script', {
  reserved: true
}], ['section', {
  reserved: false
}], ['select', {
  reserved: false
}], ['small', {
  reserved: false
}], ['source', {
  reserved: true
}], ['spacer', {
  reserved: false
}], ['span', {
  reserved: false
}], ['strike', {
  reserved: false
}], ['strong', {
  reserved: false
}], ['style', {
  reserved: true
}], ['sub', {
  reserved: false
}], ['summary', {
  reserved: false
}], ['sup', {
  reserved: false
}], ['table', {
  reserved: false
}], ['tbody', {
  reserved: false
}], ['td', {
  reserved: false
}], ['textarea', {
  reserved: false
}], ['tfoot', {
  reserved: false
}], ['th', {
  reserved: false
}], ['thead', {
  reserved: false
}], ['time', {
  reserved: false
}], ['title', {
  reserved: true
}], ['tr', {
  reserved: false
}], ['track', {
  reserved: true
}], ['tt', {
  reserved: false
}], ['u', {
  reserved: false
}], ['ul', {
  reserved: false
}], ['var', {
  reserved: false
}], ['video', {
  reserved: false
}], ['wbr', {
  reserved: false
}], ['xmp', {
  reserved: false
}]];
var domMap = {
  entries: function entries() {
    return dom;
  },
  get: function get(key) {
    var item = dom.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!this.get(key);
  },
  keys: function keys() {
    return dom.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return key;
    });
  },
  values: function values() {
    return dom.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];

      return values;
    });
  }
};
var _default = domMap;
exports["default"] = _default;

/***/ }),

/***/ 74490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rolesMap = _interopRequireDefault(__webpack_require__(29312));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var elementRoles = [];

var keys = _rolesMap.default.keys();

for (var i = 0; i < keys.length; i++) {
  var _key = keys[i];

  var role = _rolesMap.default.get(_key);

  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);

    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];

      if (relation.module === 'HTML') {
        var concept = relation.concept;

        if (concept) {
          (function () {
            var conceptStr = JSON.stringify(concept);
            var elementRoleRelation = elementRoles.find(function (relation) {
              return JSON.stringify(relation[0]) === conceptStr;
            });
            var roles = void 0;

            if (elementRoleRelation) {
              roles = elementRoleRelation[1];
            } else {
              roles = [];
            }

            var isUnique = true;

            for (var _i = 0; _i < roles.length; _i++) {
              if (roles[_i] === _key) {
                isUnique = false;
                break;
              }
            }

            if (isUnique) {
              roles.push(_key);
            }

            elementRoles.push([concept, roles]);
          })();
        }
      }
    }
  }
}

var elementRoleMap = {
  entries: function entries() {
    return elementRoles;
  },
  get: function get(key) {
    var item = elementRoles.find(function (tuple) {
      return JSON.stringify(tuple[0]) === JSON.stringify(key) ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!this.get(key);
  },
  keys: function keys() {
    return elementRoles.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return key;
    });
  },
  values: function values() {
    return elementRoles.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];

      return values;
    });
  }
};
var _default = elementRoleMap;
exports["default"] = _default;

/***/ }),

/***/ 69742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var commandRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = commandRole;
exports["default"] = _default;

/***/ }),

/***/ 7938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var compositeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = compositeRole;
exports["default"] = _default;

/***/ }),

/***/ 46214:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var inputRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = inputRole;
exports["default"] = _default;

/***/ }),

/***/ 10134:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var landmarkRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = landmarkRole;
exports["default"] = _default;

/***/ }),

/***/ 18950:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rangeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuemax': null,
    'aria-valuemin': null,
    'aria-valuenow': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rangeRole;
exports["default"] = _default;

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var roletypeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {
    'aria-atomic': null,
    'aria-busy': null,
    'aria-controls': null,
    'aria-current': null,
    'aria-describedby': null,
    'aria-details': null,
    'aria-dropeffect': null,
    'aria-flowto': null,
    'aria-grabbed': null,
    'aria-hidden': null,
    'aria-keyshortcuts': null,
    'aria-label': null,
    'aria-labelledby': null,
    'aria-live': null,
    'aria-owns': null,
    'aria-relevant': null,
    'aria-roledescription': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rel'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'role'
    },
    module: 'XHTML'
  }, {
    concept: {
      name: 'type'
    },
    module: 'Dublin Core'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = roletypeRole;
exports["default"] = _default;

/***/ }),

/***/ 65067:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'frontmatter'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'SMIL'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionRole;
exports["default"] = _default;

/***/ }),

/***/ 50233:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionheadRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionheadRole;
exports["default"] = _default;

/***/ }),

/***/ 27426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var selectRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'group']]
};
var _default = selectRole;
exports["default"] = _default;

/***/ }),

/***/ 12781:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var structureRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = structureRole;
exports["default"] = _default;

/***/ }),

/***/ 20182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var widgetRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = widgetRole;
exports["default"] = _default;

/***/ }),

/***/ 59943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var windowRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-modal': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = windowRole;
exports["default"] = _default;

/***/ }),

/***/ 14690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _commandRole = _interopRequireDefault(__webpack_require__(69742));

var _compositeRole = _interopRequireDefault(__webpack_require__(7938));

var _inputRole = _interopRequireDefault(__webpack_require__(46214));

var _landmarkRole = _interopRequireDefault(__webpack_require__(10134));

var _rangeRole = _interopRequireDefault(__webpack_require__(18950));

var _roletypeRole = _interopRequireDefault(__webpack_require__(65966));

var _sectionRole = _interopRequireDefault(__webpack_require__(65067));

var _sectionheadRole = _interopRequireDefault(__webpack_require__(50233));

var _selectRole = _interopRequireDefault(__webpack_require__(27426));

var _structureRole = _interopRequireDefault(__webpack_require__(12781));

var _widgetRole = _interopRequireDefault(__webpack_require__(20182));

var _windowRole = _interopRequireDefault(__webpack_require__(59943));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaAbstractRoles = [['command', _commandRole.default], ['composite', _compositeRole.default], ['input', _inputRole.default], ['landmark', _landmarkRole.default], ['range', _rangeRole.default], ['roletype', _roletypeRole.default], ['section', _sectionRole.default], ['sectionhead', _sectionheadRole.default], ['select', _selectRole.default], ['structure', _structureRole.default], ['widget', _widgetRole.default], ['window', _windowRole.default]];
var _default = ariaAbstractRoles;
exports["default"] = _default;

/***/ }),

/***/ 61413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _docAbstractRole = _interopRequireDefault(__webpack_require__(18868));

var _docAcknowledgmentsRole = _interopRequireDefault(__webpack_require__(79710));

var _docAfterwordRole = _interopRequireDefault(__webpack_require__(77958));

var _docAppendixRole = _interopRequireDefault(__webpack_require__(99074));

var _docBacklinkRole = _interopRequireDefault(__webpack_require__(23961));

var _docBiblioentryRole = _interopRequireDefault(__webpack_require__(68917));

var _docBibliographyRole = _interopRequireDefault(__webpack_require__(20555));

var _docBibliorefRole = _interopRequireDefault(__webpack_require__(85081));

var _docChapterRole = _interopRequireDefault(__webpack_require__(38935));

var _docColophonRole = _interopRequireDefault(__webpack_require__(53076));

var _docConclusionRole = _interopRequireDefault(__webpack_require__(46406));

var _docCoverRole = _interopRequireDefault(__webpack_require__(44613));

var _docCreditRole = _interopRequireDefault(__webpack_require__(2060));

var _docCreditsRole = _interopRequireDefault(__webpack_require__(79176));

var _docDedicationRole = _interopRequireDefault(__webpack_require__(97684));

var _docEndnoteRole = _interopRequireDefault(__webpack_require__(75835));

var _docEndnotesRole = _interopRequireDefault(__webpack_require__(4656));

var _docEpigraphRole = _interopRequireDefault(__webpack_require__(34767));

var _docEpilogueRole = _interopRequireDefault(__webpack_require__(34726));

var _docErrataRole = _interopRequireDefault(__webpack_require__(363));

var _docExampleRole = _interopRequireDefault(__webpack_require__(25742));

var _docFootnoteRole = _interopRequireDefault(__webpack_require__(37863));

var _docForewordRole = _interopRequireDefault(__webpack_require__(89953));

var _docGlossaryRole = _interopRequireDefault(__webpack_require__(29209));

var _docGlossrefRole = _interopRequireDefault(__webpack_require__(43145));

var _docIndexRole = _interopRequireDefault(__webpack_require__(7945));

var _docIntroductionRole = _interopRequireDefault(__webpack_require__(60022));

var _docNoterefRole = _interopRequireDefault(__webpack_require__(21913));

var _docNoticeRole = _interopRequireDefault(__webpack_require__(76648));

var _docPagebreakRole = _interopRequireDefault(__webpack_require__(13551));

var _docPagelistRole = _interopRequireDefault(__webpack_require__(87789));

var _docPartRole = _interopRequireDefault(__webpack_require__(85367));

var _docPrefaceRole = _interopRequireDefault(__webpack_require__(90938));

var _docPrologueRole = _interopRequireDefault(__webpack_require__(59955));

var _docPullquoteRole = _interopRequireDefault(__webpack_require__(99992));

var _docQnaRole = _interopRequireDefault(__webpack_require__(64565));

var _docSubtitleRole = _interopRequireDefault(__webpack_require__(23465));

var _docTipRole = _interopRequireDefault(__webpack_require__(37207));

var _docTocRole = _interopRequireDefault(__webpack_require__(33719));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaDpubRoles = [['doc-abstract', _docAbstractRole.default], ['doc-acknowledgments', _docAcknowledgmentsRole.default], ['doc-afterword', _docAfterwordRole.default], ['doc-appendix', _docAppendixRole.default], ['doc-backlink', _docBacklinkRole.default], ['doc-biblioentry', _docBiblioentryRole.default], ['doc-bibliography', _docBibliographyRole.default], ['doc-biblioref', _docBibliorefRole.default], ['doc-chapter', _docChapterRole.default], ['doc-colophon', _docColophonRole.default], ['doc-conclusion', _docConclusionRole.default], ['doc-cover', _docCoverRole.default], ['doc-credit', _docCreditRole.default], ['doc-credits', _docCreditsRole.default], ['doc-dedication', _docDedicationRole.default], ['doc-endnote', _docEndnoteRole.default], ['doc-endnotes', _docEndnotesRole.default], ['doc-epigraph', _docEpigraphRole.default], ['doc-epilogue', _docEpilogueRole.default], ['doc-errata', _docErrataRole.default], ['doc-example', _docExampleRole.default], ['doc-footnote', _docFootnoteRole.default], ['doc-foreword', _docForewordRole.default], ['doc-glossary', _docGlossaryRole.default], ['doc-glossref', _docGlossrefRole.default], ['doc-index', _docIndexRole.default], ['doc-introduction', _docIntroductionRole.default], ['doc-noteref', _docNoterefRole.default], ['doc-notice', _docNoticeRole.default], ['doc-pagebreak', _docPagebreakRole.default], ['doc-pagelist', _docPagelistRole.default], ['doc-part', _docPartRole.default], ['doc-preface', _docPrefaceRole.default], ['doc-prologue', _docPrologueRole.default], ['doc-pullquote', _docPullquoteRole.default], ['doc-qna', _docQnaRole.default], ['doc-subtitle', _docSubtitleRole.default], ['doc-tip', _docTipRole.default], ['doc-toc', _docTocRole.default]];
var _default = ariaDpubRoles;
exports["default"] = _default;

/***/ }),

/***/ 58514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _alertRole = _interopRequireDefault(__webpack_require__(66472));

var _alertdialogRole = _interopRequireDefault(__webpack_require__(84976));

var _applicationRole = _interopRequireDefault(__webpack_require__(35902));

var _articleRole = _interopRequireDefault(__webpack_require__(36883));

var _bannerRole = _interopRequireDefault(__webpack_require__(25599));

var _blockquoteRole = _interopRequireDefault(__webpack_require__(91621));

var _buttonRole = _interopRequireDefault(__webpack_require__(50855));

var _captionRole = _interopRequireDefault(__webpack_require__(31760));

var _cellRole = _interopRequireDefault(__webpack_require__(73350));

var _checkboxRole = _interopRequireDefault(__webpack_require__(58651));

var _codeRole = _interopRequireDefault(__webpack_require__(87305));

var _columnheaderRole = _interopRequireDefault(__webpack_require__(53486));

var _comboboxRole = _interopRequireDefault(__webpack_require__(81663));

var _complementaryRole = _interopRequireDefault(__webpack_require__(98889));

var _contentinfoRole = _interopRequireDefault(__webpack_require__(94961));

var _definitionRole = _interopRequireDefault(__webpack_require__(4676));

var _deletionRole = _interopRequireDefault(__webpack_require__(48978));

var _dialogRole = _interopRequireDefault(__webpack_require__(94154));

var _directoryRole = _interopRequireDefault(__webpack_require__(95707));

var _documentRole = _interopRequireDefault(__webpack_require__(53212));

var _emphasisRole = _interopRequireDefault(__webpack_require__(55530));

var _feedRole = _interopRequireDefault(__webpack_require__(43478));

var _figureRole = _interopRequireDefault(__webpack_require__(12728));

var _formRole = _interopRequireDefault(__webpack_require__(77841));

var _genericRole = _interopRequireDefault(__webpack_require__(56322));

var _gridRole = _interopRequireDefault(__webpack_require__(10417));

var _gridcellRole = _interopRequireDefault(__webpack_require__(49947));

var _groupRole = _interopRequireDefault(__webpack_require__(48498));

var _headingRole = _interopRequireDefault(__webpack_require__(67830));

var _imgRole = _interopRequireDefault(__webpack_require__(25096));

var _insertionRole = _interopRequireDefault(__webpack_require__(45799));

var _linkRole = _interopRequireDefault(__webpack_require__(78987));

var _listRole = _interopRequireDefault(__webpack_require__(20353));

var _listboxRole = _interopRequireDefault(__webpack_require__(21300));

var _listitemRole = _interopRequireDefault(__webpack_require__(8288));

var _logRole = _interopRequireDefault(__webpack_require__(10503));

var _mainRole = _interopRequireDefault(__webpack_require__(14211));

var _marqueeRole = _interopRequireDefault(__webpack_require__(67165));

var _mathRole = _interopRequireDefault(__webpack_require__(63400));

var _menuRole = _interopRequireDefault(__webpack_require__(65357));

var _menubarRole = _interopRequireDefault(__webpack_require__(78926));

var _menuitemRole = _interopRequireDefault(__webpack_require__(96077));

var _menuitemcheckboxRole = _interopRequireDefault(__webpack_require__(4332));

var _menuitemradioRole = _interopRequireDefault(__webpack_require__(5462));

var _meterRole = _interopRequireDefault(__webpack_require__(10740));

var _navigationRole = _interopRequireDefault(__webpack_require__(24772));

var _noneRole = _interopRequireDefault(__webpack_require__(12109));

var _noteRole = _interopRequireDefault(__webpack_require__(15953));

var _optionRole = _interopRequireDefault(__webpack_require__(72476));

var _paragraphRole = _interopRequireDefault(__webpack_require__(16302));

var _presentationRole = _interopRequireDefault(__webpack_require__(88757));

var _progressbarRole = _interopRequireDefault(__webpack_require__(91548));

var _radioRole = _interopRequireDefault(__webpack_require__(59538));

var _radiogroupRole = _interopRequireDefault(__webpack_require__(2964));

var _regionRole = _interopRequireDefault(__webpack_require__(36542));

var _rowRole = _interopRequireDefault(__webpack_require__(86410));

var _rowgroupRole = _interopRequireDefault(__webpack_require__(22386));

var _rowheaderRole = _interopRequireDefault(__webpack_require__(34773));

var _scrollbarRole = _interopRequireDefault(__webpack_require__(87693));

var _searchRole = _interopRequireDefault(__webpack_require__(26560));

var _searchboxRole = _interopRequireDefault(__webpack_require__(4573));

var _separatorRole = _interopRequireDefault(__webpack_require__(15026));

var _sliderRole = _interopRequireDefault(__webpack_require__(99644));

var _spinbuttonRole = _interopRequireDefault(__webpack_require__(5954));

var _statusRole = _interopRequireDefault(__webpack_require__(23977));

var _strongRole = _interopRequireDefault(__webpack_require__(86484));

var _subscriptRole = _interopRequireDefault(__webpack_require__(79727));

var _superscriptRole = _interopRequireDefault(__webpack_require__(26566));

var _switchRole = _interopRequireDefault(__webpack_require__(6248));

var _tabRole = _interopRequireDefault(__webpack_require__(56767));

var _tableRole = _interopRequireDefault(__webpack_require__(5420));

var _tablistRole = _interopRequireDefault(__webpack_require__(80523));

var _tabpanelRole = _interopRequireDefault(__webpack_require__(33043));

var _termRole = _interopRequireDefault(__webpack_require__(96567));

var _textboxRole = _interopRequireDefault(__webpack_require__(40046));

var _timeRole = _interopRequireDefault(__webpack_require__(20292));

var _timerRole = _interopRequireDefault(__webpack_require__(69895));

var _toolbarRole = _interopRequireDefault(__webpack_require__(79182));

var _tooltipRole = _interopRequireDefault(__webpack_require__(42516));

var _treeRole = _interopRequireDefault(__webpack_require__(27976));

var _treegridRole = _interopRequireDefault(__webpack_require__(39379));

var _treeitemRole = _interopRequireDefault(__webpack_require__(58532));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaLiteralRoles = [['alert', _alertRole.default], ['alertdialog', _alertdialogRole.default], ['application', _applicationRole.default], ['article', _articleRole.default], ['banner', _bannerRole.default], ['blockquote', _blockquoteRole.default], ['button', _buttonRole.default], ['caption', _captionRole.default], ['cell', _cellRole.default], ['checkbox', _checkboxRole.default], ['code', _codeRole.default], ['columnheader', _columnheaderRole.default], ['combobox', _comboboxRole.default], ['complementary', _complementaryRole.default], ['contentinfo', _contentinfoRole.default], ['definition', _definitionRole.default], ['deletion', _deletionRole.default], ['dialog', _dialogRole.default], ['directory', _directoryRole.default], ['document', _documentRole.default], ['emphasis', _emphasisRole.default], ['feed', _feedRole.default], ['figure', _figureRole.default], ['form', _formRole.default], ['generic', _genericRole.default], ['grid', _gridRole.default], ['gridcell', _gridcellRole.default], ['group', _groupRole.default], ['heading', _headingRole.default], ['img', _imgRole.default], ['insertion', _insertionRole.default], ['link', _linkRole.default], ['list', _listRole.default], ['listbox', _listboxRole.default], ['listitem', _listitemRole.default], ['log', _logRole.default], ['main', _mainRole.default], ['marquee', _marqueeRole.default], ['math', _mathRole.default], ['menu', _menuRole.default], ['menubar', _menubarRole.default], ['menuitem', _menuitemRole.default], ['menuitemcheckbox', _menuitemcheckboxRole.default], ['menuitemradio', _menuitemradioRole.default], ['meter', _meterRole.default], ['navigation', _navigationRole.default], ['none', _noneRole.default], ['note', _noteRole.default], ['option', _optionRole.default], ['paragraph', _paragraphRole.default], ['presentation', _presentationRole.default], ['progressbar', _progressbarRole.default], ['radio', _radioRole.default], ['radiogroup', _radiogroupRole.default], ['region', _regionRole.default], ['row', _rowRole.default], ['rowgroup', _rowgroupRole.default], ['rowheader', _rowheaderRole.default], ['scrollbar', _scrollbarRole.default], ['search', _searchRole.default], ['searchbox', _searchboxRole.default], ['separator', _separatorRole.default], ['slider', _sliderRole.default], ['spinbutton', _spinbuttonRole.default], ['status', _statusRole.default], ['strong', _strongRole.default], ['subscript', _subscriptRole.default], ['superscript', _superscriptRole.default], ['switch', _switchRole.default], ['tab', _tabRole.default], ['table', _tableRole.default], ['tablist', _tablistRole.default], ['tabpanel', _tabpanelRole.default], ['term', _termRole.default], ['textbox', _textboxRole.default], ['time', _timeRole.default], ['timer', _timerRole.default], ['toolbar', _toolbarRole.default], ['tooltip', _tooltipRole.default], ['tree', _treeRole.default], ['treegrid', _treegridRole.default], ['treeitem', _treeitemRole.default]];
var _default = ariaLiteralRoles;
exports["default"] = _default;

/***/ }),

/***/ 18868:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAbstractRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'abstract [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docAbstractRole;
exports["default"] = _default;

/***/ }),

/***/ 79710:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAcknowledgmentsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'acknowledgments [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAcknowledgmentsRole;
exports["default"] = _default;

/***/ }),

/***/ 77958:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAfterwordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'afterword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAfterwordRole;
exports["default"] = _default;

/***/ }),

/***/ 99074:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAppendixRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'appendix [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAppendixRole;
exports["default"] = _default;

/***/ }),

/***/ 23961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBacklinkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'content'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'referrer [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBacklinkRole;
exports["default"] = _default;

/***/ }),

/***/ 68917:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBiblioentryRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'EPUB biblioentry [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-bibliography'],
  requiredContextRole: ['doc-bibliography'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docBiblioentryRole;
exports["default"] = _default;

/***/ }),

/***/ 20555:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliographyRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'bibliography [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-biblioentry']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docBibliographyRole;
exports["default"] = _default;

/***/ }),

/***/ 85081:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliorefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'biblioref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBibliorefRole;
exports["default"] = _default;

/***/ }),

/***/ 38935:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docChapterRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'chapter [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docChapterRole;
exports["default"] = _default;

/***/ }),

/***/ 53076:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docColophonRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'colophon [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docColophonRole;
exports["default"] = _default;

/***/ }),

/***/ 46406:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docConclusionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'conclusion [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docConclusionRole;
exports["default"] = _default;

/***/ }),

/***/ 44613:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCoverRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'cover [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'img']]
};
var _default = docCoverRole;
exports["default"] = _default;

/***/ }),

/***/ 2060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credit [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docCreditRole;
exports["default"] = _default;

/***/ }),

/***/ 79176:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credits [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docCreditsRole;
exports["default"] = _default;

/***/ }),

/***/ 97684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docDedicationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'dedication [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docDedicationRole;
exports["default"] = _default;

/***/ }),

/***/ 75835:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-endnotes'],
  requiredContextRole: ['doc-endnotes'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docEndnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnotesRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnotes [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-endnote']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEndnotesRole;
exports["default"] = _default;

/***/ }),

/***/ 34767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpigraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epigraph [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docEpigraphRole;
exports["default"] = _default;

/***/ }),

/***/ 34726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpilogueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epilogue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEpilogueRole;
exports["default"] = _default;

/***/ }),

/***/ 363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docErrataRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'errata [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docErrataRole;
exports["default"] = _default;

/***/ }),

/***/ 25742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docExampleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docExampleRole;
exports["default"] = _default;

/***/ }),

/***/ 37863:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docFootnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'footnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docFootnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 89953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docForewordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'foreword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docForewordRole;
exports["default"] = _default;

/***/ }),

/***/ 29209:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossary [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['definition'], ['term']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docGlossaryRole;
exports["default"] = _default;

/***/ }),

/***/ 43145:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossrefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docGlossrefRole;
exports["default"] = _default;

/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIndexRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'index [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docIndexRole;
exports["default"] = _default;

/***/ }),

/***/ 60022:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIntroductionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'introduction [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docIntroductionRole;
exports["default"] = _default;

/***/ }),

/***/ 21913:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoterefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'noteref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docNoterefRole;
exports["default"] = _default;

/***/ }),

/***/ 76648:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoticeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'notice [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docNoticeRole;
exports["default"] = _default;

/***/ }),

/***/ 13551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagebreakRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'pagebreak [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'separator']]
};
var _default = docPagebreakRole;
exports["default"] = _default;

/***/ }),

/***/ 87789:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagelistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'page-list [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docPagelistRole;
exports["default"] = _default;

/***/ }),

/***/ 85367:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPartRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'part [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPartRole;
exports["default"] = _default;

/***/ }),

/***/ 90938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrefaceRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'preface [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrefaceRole;
exports["default"] = _default;

/***/ }),

/***/ 59955:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrologueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'prologue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrologueRole;
exports["default"] = _default;

/***/ }),

/***/ 99992:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPullquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'pullquote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['none']]
};
var _default = docPullquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 64565:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docQnaRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'qna [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docQnaRole;
exports["default"] = _default;

/***/ }),

/***/ 23465:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docSubtitleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'subtitle [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = docSubtitleRole;
exports["default"] = _default;

/***/ }),

/***/ 37207:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTipRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'help [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docTipRole;
exports["default"] = _default;

/***/ }),

/***/ 33719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTocRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'toc [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docTocRole;
exports["default"] = _default;

/***/ }),

/***/ 66472:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'assertive'
  },
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = alertRole;
exports["default"] = _default;

/***/ }),

/***/ 84976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertdialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'alert'], ['roletype', 'window', 'dialog']]
};
var _default = alertdialogRole;
exports["default"] = _default;

/***/ }),

/***/ 35902:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var applicationRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = applicationRole;
exports["default"] = _default;

/***/ }),

/***/ 36883:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var articleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'article'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'document']]
};
var _default = articleRole;
exports["default"] = _default;

/***/ }),

/***/ 25599:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var bannerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'header'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = bannerRole;
exports["default"] = _default;

/***/ }),

/***/ 91621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var blockquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = blockquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 50855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var buttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-pressed': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-pressed'
      }, {
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'false'
      }],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'true'
      }],
      constraints: ['direct descendant of details element with the open attribute defined'],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'button'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'image'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'reset'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'submit'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'button'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'trigger'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = buttonRole;
exports["default"] = _default;

/***/ }),

/***/ 31760:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var captionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: ['figure', 'grid', 'table'],
  requiredContextRole: ['figure', 'grid', 'table'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = captionRole;
exports["default"] = _default;

/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var cellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-colspan': null,
    'aria-rowindex': null,
    'aria-rowspan': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['descendant of table'],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = cellRole;
exports["default"] = _default;

/***/ }),

/***/ 58651:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var checkboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = checkboxRole;
exports["default"] = _default;

/***/ }),

/***/ 87305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var codeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = codeRole;
exports["default"] = _default;

/***/ }),

/***/ 53486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var columnheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    attributes: [{
      name: 'scope',
      value: 'col'
    }],
    concept: {
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = columnheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 81663:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var comboboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-expanded': 'false',
    'aria-haspopup': 'listbox'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        constraints: ['undefined'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        name: 'size',
        value: 1
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-expanded': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = comboboxRole;
exports["default"] = _default;

/***/ }),

/***/ 98889:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var complementaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'aside'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = complementaryRole;
exports["default"] = _default;

/***/ }),

/***/ 94961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var contentinfoRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'footer'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = contentinfoRole;
exports["default"] = _default;

/***/ }),

/***/ 4676:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var definitionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dd'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = definitionRole;
exports["default"] = _default;

/***/ }),

/***/ 48978:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var deletionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = deletionRole;
exports["default"] = _default;

/***/ }),

/***/ 94154:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dialog'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'window']]
};
var _default = dialogRole;
exports["default"] = _default;

/***/ }),

/***/ 95707:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var directoryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    module: 'DAISY Guide'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = directoryRole;
exports["default"] = _default;

/***/ }),

/***/ 53212:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var documentRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }, {
    concept: {
      name: 'body'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = documentRole;
exports["default"] = _default;

/***/ }),

/***/ 55530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var emphasisRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = emphasisRole;
exports["default"] = _default;

/***/ }),

/***/ 43478:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var feedRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['article']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = feedRole;
exports["default"] = _default;

/***/ }),

/***/ 12728:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var figureRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'figure'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = figureRole;
exports["default"] = _default;

/***/ }),

/***/ 77841:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'name'
      }],
      name: 'form'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = formRole;
exports["default"] = _default;

/***/ }),

/***/ 56322:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var genericRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'span'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'div'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = genericRole;
exports["default"] = _default;

/***/ }),

/***/ 10417:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-multiselectable': null,
    'aria-readonly': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'grid'
      }],
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'table']]
};
var _default = gridRole;
exports["default"] = _default;

/***/ }),

/***/ 49947:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridcellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-selected': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'gridcell'
      }],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'widget']]
};
var _default = gridcellRole;
exports["default"] = _default;

/***/ }),

/***/ 48498:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var groupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'details'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'fieldset'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'optgroup'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = groupRole;
exports["default"] = _default;

/***/ }),

/***/ 67830:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var headingRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-level': '2'
  },
  relatedConcepts: [{
    concept: {
      name: 'h1'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h2'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h3'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h4'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h5'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h6'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-level': '2'
  },
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = headingRole;
exports["default"] = _default;

/***/ }),

/***/ 25096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var imgRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'imggroup'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = imgRole;
exports["default"] = _default;

/***/ }),

/***/ 45799:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var insertionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = insertionRole;
exports["default"] = _default;

/***/ }),

/***/ 78987:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var linkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'a'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'area'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'link'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = linkRole;
exports["default"] = _default;

/***/ }),

/***/ 20353:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menu'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ol'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ul'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['listitem']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listRole;
exports["default"] = _default;

/***/ }),

/***/ 21300:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }, {
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'datalist'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['option', 'group'], ['option']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = listboxRole;
exports["default"] = _default;

/***/ }),

/***/ 8288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listitemRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of ol, ul or menu'],
      name: 'li'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }],
  requireContextRole: ['directory', 'list'],
  requiredContextRole: ['directory', 'list'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listitemRole;
exports["default"] = _default;

/***/ }),

/***/ 10503:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var logRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-live': 'polite'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = logRole;
exports["default"] = _default;

/***/ }),

/***/ 14211:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mainRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'main'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = mainRole;
exports["default"] = _default;

/***/ }),

/***/ 67165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var marqueeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = marqueeRole;
exports["default"] = _default;

/***/ }),

/***/ 63400:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mathRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'math'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = mathRole;
exports["default"] = _default;

/***/ }),

/***/ 65357:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'sidebar'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = menuRole;
exports["default"] = _default;

/***/ }),

/***/ 78926:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menubarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'toolbar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select', 'menu'], ['roletype', 'structure', 'section', 'group', 'select', 'menu']]
};
var _default = menubarRole;
exports["default"] = _default;

/***/ }),

/***/ 96077:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU_ITEM'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = menuitemRole;
exports["default"] = _default;

/***/ }),

/***/ 4332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemcheckboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox'], ['roletype', 'widget', 'command', 'menuitem']]
};
var _default = menuitemcheckboxRole;
exports["default"] = _default;

/***/ }),

/***/ 5462:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemradioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox', 'menuitemcheckbox'], ['roletype', 'widget', 'command', 'menuitem', 'menuitemcheckbox'], ['roletype', 'widget', 'input', 'radio']]
};
var _default = menuitemradioRole;
exports["default"] = _default;

/***/ }),

/***/ 10740:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var meterRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null,
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range']]
};
var _default = meterRole;
exports["default"] = _default;

/***/ }),

/***/ 24772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var navigationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'nav'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = navigationRole;
exports["default"] = _default;

/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noneRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = noneRole;
exports["default"] = _default;

/***/ }),

/***/ 15953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = noteRole;
exports["default"] = _default;

/***/ }),

/***/ 72476:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var optionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [{
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'option'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = optionRole;
exports["default"] = _default;

/***/ }),

/***/ 16302:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var paragraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = paragraphRole;
exports["default"] = _default;

/***/ }),

/***/ 88757:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var presentationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = presentationRole;
exports["default"] = _default;

/***/ }),

/***/ 91548:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var progressbarRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'progress'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'status'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = progressbarRole;
exports["default"] = _default;

/***/ }),

/***/ 59538:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'radio'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = radioRole;
exports["default"] = _default;

/***/ }),

/***/ 2964:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radiogroupRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['radio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = radiogroupRole;
exports["default"] = _default;

/***/ }),

/***/ 36542:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var regionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'Device Independence Glossart perceivable unit'
    }
  }, {
    concept: {
      name: 'frame'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = regionRole;
exports["default"] = _default;

/***/ }),

/***/ 86410:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-expanded': null,
    'aria-level': null,
    'aria-posinset': null,
    'aria-rowindex': null,
    'aria-selected': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'tr'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredOwnedElements: [['cell'], ['columnheader'], ['gridcell'], ['rowheader']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group'], ['roletype', 'widget']]
};
var _default = rowRole;
exports["default"] = _default;

/***/ }),

/***/ 22386:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowgroupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'tbody'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'tfoot'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'thead'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'table', 'treegrid'],
  requiredOwnedElements: [['row']],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rowgroupRole;
exports["default"] = _default;

/***/ }),

/***/ 34773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'scope',
        value: 'row'
      }],
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = rowheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 87693:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var scrollbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-valuetext': null,
    'aria-orientation': 'vertical',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = scrollbarRole;
exports["default"] = _default;

/***/ }),

/***/ 26560:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = searchRole;
exports["default"] = _default;

/***/ }),

/***/ 4573:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input', 'textbox']]
};
var _default = searchboxRole;
exports["default"] = _default;

/***/ }),

/***/ 15026:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var separatorRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0',
    'aria-valuenow': null,
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'hr'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = separatorRole;
exports["default"] = _default;

/***/ }),

/***/ 99644:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sliderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-valuetext': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'range'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = sliderRole;
exports["default"] = _default;

/***/ }),

/***/ 5954:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var spinbuttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-valuetext': null,
    'aria-valuenow': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'number'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = spinbuttonRole;
exports["default"] = _default;

/***/ }),

/***/ 23977:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var statusRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'polite'
  },
  relatedConcepts: [{
    concept: {
      name: 'output'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = statusRole;
exports["default"] = _default;

/***/ }),

/***/ 86484:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var strongRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = strongRole;
exports["default"] = _default;

/***/ }),

/***/ 79727:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var subscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = subscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 26566:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var superscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = superscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 6248:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var switchRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'button'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox']]
};
var _default = switchRole;
exports["default"] = _default;

/***/ }),

/***/ 56767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [],
  requireContextRole: ['tablist'],
  requiredContextRole: ['tablist'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead'], ['roletype', 'widget']]
};
var _default = tabRole;
exports["default"] = _default;

/***/ }),

/***/ 5420:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tableRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-colcount': null,
    'aria-rowcount': null
  },
  relatedConcepts: [{
    concept: {
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tableRole;
exports["default"] = _default;

/***/ }),

/***/ 80523:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tablistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-multiselectable': null,
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    module: 'DAISY',
    concept: {
      name: 'guide'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['tab']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite']]
};
var _default = tablistRole;
exports["default"] = _default;

/***/ }),

/***/ 33043:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabpanelRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tabpanelRole;
exports["default"] = _default;

/***/ }),

/***/ 96567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var termRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dfn'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'dt'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = termRole;
exports["default"] = _default;

/***/ }),

/***/ 40046:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var textboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-multiline': null,
    'aria-placeholder': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'type'
      }, {
        constraints: ['undefined'],
        name: 'list'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'textarea'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input']]
};
var _default = textboxRole;
exports["default"] = _default;

/***/ }),

/***/ 20292:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = timeRole;
exports["default"] = _default;

/***/ }),

/***/ 69895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'status']]
};
var _default = timerRole;
exports["default"] = _default;

/***/ }),

/***/ 79182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var toolbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'menubar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group']]
};
var _default = toolbarRole;
exports["default"] = _default;

/***/ }),

/***/ 42516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tooltipRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tooltipRole;
exports["default"] = _default;

/***/ }),

/***/ 27976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['treeitem', 'group'], ['treeitem']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = treeRole;
exports["default"] = _default;

/***/ }),

/***/ 39379:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treegridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'grid'], ['roletype', 'structure', 'section', 'table', 'grid'], ['roletype', 'widget', 'composite', 'select', 'tree'], ['roletype', 'structure', 'section', 'group', 'select', 'tree']]
};
var _default = treegridRole;
exports["default"] = _default;

/***/ }),

/***/ 58532:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [],
  requireContextRole: ['group', 'tree'],
  requiredContextRole: ['group', 'tree'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': null
  },
  superClass: [['roletype', 'structure', 'section', 'listitem'], ['roletype', 'widget', 'input', 'option']]
};
var _default = treeitemRole;
exports["default"] = _default;

/***/ }),

/***/ 41516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.UN = exports.Qv = exports.uJ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;

var _ariaPropsMap = _interopRequireDefault(__webpack_require__(72256));

var _domMap = _interopRequireDefault(__webpack_require__(92607));

var _rolesMap = _interopRequireDefault(__webpack_require__(29312));

var _elementRoleMap = _interopRequireDefault(__webpack_require__(74490));

var _roleElementMap = _interopRequireDefault(__webpack_require__(52438));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aria = _ariaPropsMap.default;
__webpack_unused_export__ = aria;
var dom = _domMap.default;
__webpack_unused_export__ = dom;
var roles = _rolesMap.default;
exports.uJ = roles;
var elementRoles = _elementRoleMap.default;
exports.Qv = elementRoles;
var roleElements = _roleElementMap.default;
exports.UN = roleElements;

/***/ }),

/***/ 52438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rolesMap = _interopRequireDefault(__webpack_require__(29312));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var roleElement = [];

var keys = _rolesMap.default.keys();

var _loop = function _loop(i) {
  var key = keys[i];

  var role = _rolesMap.default.get(key);

  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);

    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];

      if (relation.module === 'HTML') {
        var concept = relation.concept;

        if (concept) {
          var roleElementRelation = roleElement.find(function (item) {
            return item[0] === key;
          });
          var relationConcepts = void 0;

          if (roleElementRelation) {
            relationConcepts = roleElementRelation[1];
          } else {
            relationConcepts = [];
          }

          relationConcepts.push(concept);
          roleElement.push([key, relationConcepts]);
        }
      }
    }
  }
};

for (var i = 0; i < keys.length; i++) {
  _loop(i);
}

var roleElementMap = {
  entries: function entries() {
    return roleElement;
  },
  get: function get(key) {
    var item = roleElement.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!this.get(key);
  },
  keys: function keys() {
    return roleElement.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          key = _ref2[0];

      return key;
    });
  },
  values: function values() {
    return roleElement.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          values = _ref4[1];

      return values;
    });
  }
};
var _default = roleElementMap;
exports["default"] = _default;

/***/ }),

/***/ 29312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _ariaAbstractRoles = _interopRequireDefault(__webpack_require__(14690));

var _ariaLiteralRoles = _interopRequireDefault(__webpack_require__(58514));

var _ariaDpubRoles = _interopRequireDefault(__webpack_require__(61413));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var roles = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default);
roles.forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      roleDefinition = _ref2[1];

  // Conglomerate the properties
  var _iterator = _createForOfIteratorHelper(roleDefinition.superClass),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var superClassIter = _step.value;

      var _iterator2 = _createForOfIteratorHelper(superClassIter),
          _step2;

      try {
        var _loop = function _loop() {
          var superClassName = _step2.value;
          var superClassRoleTuple = roles.find(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
                name = _ref4[0];

            return name === superClassName;
          });

          if (superClassRoleTuple) {
            var superClassDefinition = superClassRoleTuple[1];

            for (var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++) {
              var prop = _Object$keys[_i2];

              if ( // $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
              !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) {
                Object.assign(roleDefinition.props, _defineProperty({}, prop, superClassDefinition.props[prop]));
              }
            }
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});
var rolesMap = {
  entries: function entries() {
    return roles;
  },
  get: function get(key) {
    var item = roles.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!this.get(key);
  },
  keys: function keys() {
    return roles.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          key = _ref6[0];

      return key;
    });
  },
  values: function values() {
    return roles.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          values = _ref8[1];

      return values;
    });
  }
};
var _default = rolesMap;
exports["default"] = _default;

/***/ }),

/***/ 43653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(61555);

/***/ }),

/***/ 29685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var settle = __webpack_require__(93063);
var cookies = __webpack_require__(9233);
var buildURL = __webpack_require__(44306);
var buildFullPath = __webpack_require__(85938);
var parseHeaders = __webpack_require__(12644);
var isURLSameOrigin = __webpack_require__(88731);
var transitionalDefaults = __webpack_require__(71987);
var AxiosError = __webpack_require__(35424);
var CanceledError = __webpack_require__(10235);
var parseProtocol = __webpack_require__(36374);
var platform = __webpack_require__(52989);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var withXSRFToken = config.withXSRFToken;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        var xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    // false, 0 (zero number), and '' (empty string) are valid JSON values
    if (!requestData && requestData !== false && requestData !== 0 && requestData !== '') {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 61555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var bind = __webpack_require__(82958);
var Axios = __webpack_require__(27303);
var mergeConfig = __webpack_require__(92445);
var defaults = __webpack_require__(80746);
var formDataToJSON = __webpack_require__(35078);
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(10235);
axios.CancelToken = __webpack_require__(89939);
axios.isCancel = __webpack_require__(18414);
axios.VERSION = (__webpack_require__(82196).version);
axios.toFormData = __webpack_require__(38428);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(35424);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(60363);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(69465);

axios.formToJSON = function(thing) {
  return formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);
};

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 89939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(10235);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i = token._listeners.length;

    while (i-- > 0) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message, config, request) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message, config, request);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 10235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(35424);
var utils = __webpack_require__(90501);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 18414:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 27303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var buildURL = __webpack_require__(44306);
var InterceptorManager = __webpack_require__(86942);
var dispatchRequest = __webpack_require__(26158);
var mergeConfig = __webpack_require__(92445);
var buildFullPath = __webpack_require__(85938);
var validator = __webpack_require__(37169);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
 * @param {?Object} config
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  var paramsSerializer = config.paramsSerializer;

  if (paramsSerializer !== undefined) {
    validator.assertOptions(paramsSerializer, {
      encode: validators.function,
      serialize: validators.function
    }, true);
  }

  utils.isFunction(paramsSerializer) && (config.paramsSerializer = {serialize: paramsSerializer});

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 35424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 86942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Clear all interceptors from the stack
 */
InterceptorManager.prototype.clear = function clear() {
  if (this.handlers) {
    this.handlers = [];
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 85938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(63473);
var combineURLs = __webpack_require__(70533);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 26158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var transformData = __webpack_require__(24097);
var isCancel = __webpack_require__(18414);
var defaults = __webpack_require__(80746);
var CanceledError = __webpack_require__(10235);
var normalizeHeaderName = __webpack_require__(34799);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    null,
    config.transformRequest
  );

  normalizeHeaderName(config.headers, 'Accept');
  normalizeHeaderName(config.headers, 'Content-Type');

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      response.status,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          reason.response.status,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 92445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isEmptyObject(source)) {
      return utils.merge({}, target);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'withXSRFToken': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 93063:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(35424);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 24097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var defaults = __webpack_require__(80746);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Number} status HTTP status code
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, status, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers, status);
  });

  return data;
};


/***/ }),

/***/ 80746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(13158);


var utils = __webpack_require__(90501);
var normalizeHeaderName = __webpack_require__(34799);
var AxiosError = __webpack_require__(35424);
var transitionalDefaults = __webpack_require__(71987);
var toFormData = __webpack_require__(38428);
var toURLEncodedForm = __webpack_require__(75912);
var platform = __webpack_require__(52989);
var formDataToJSON = __webpack_require__(35078);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(29685);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(29685);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    var contentType = headers && headers['Content-Type'] || '';
    var hasJSONContentType = contentType.indexOf('application/json') > -1;
    var isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    var isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        var _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 71987:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 46081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// eslint-disable-next-line strict
module.exports = __webpack_require__(93162);


/***/ }),

/***/ 82196:
/***/ (function(module) {

module.exports = {
  "version": "0.28.1"
};

/***/ }),

/***/ 15134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toFormData = __webpack_require__(38428);

function encode(str) {
  var charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

var prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  var _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

module.exports = AxiosURLSearchParams;


/***/ }),

/***/ 82958:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
};


/***/ }),

/***/ 44306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var AxiosURLSearchParams = __webpack_require__(15134);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var hashmarkIndex = url.indexOf('#');

  if (hashmarkIndex !== -1) {
    url = url.slice(0, hashmarkIndex);
  }

  var _encode = options && options.encode || encode;

  var serializeFn = options && options.serialize;

  var serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 70533:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 9233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 35078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

function arrayToObject(arr) {
  var obj = {};
  var keys = Object.keys(arr);
  var i;
  var len = keys.length;
  var key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    var name = path[index++];
    var isNumericKey = Number.isFinite(+name);
    var isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProperty(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    var result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    var obj = {};

    utils.forEachEntry(formData, function(name, value) {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

module.exports = formDataToJSON;


/***/ }),

/***/ 63473:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 69465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 88731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */
      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

    // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 34799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 12644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.slice(0, i)).toLowerCase();
    val = utils.trim(line.slice(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 36374:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 60363:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 38428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(75291)["Buffer"];


var utils = __webpack_require__(90501);
var AxiosError = __webpack_require__(35424);
var envFormData = __webpack_require__(46081);

function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

var predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

function isSpecCompliant(thing) {
  return thing && utils.isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator];
}

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 * @returns {Object}
 **/

function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (envFormData || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  var metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  var visitor = options.visitor || defaultVisitor;
  var dots = options.dots;
  var indexes = options.indexes;
  var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  var useBlob = _Blob && isSpecCompliant(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    var arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        (utils.isFileList(value) || utils.endsWith(key, '[]') && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !utils.isUndefined(el) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  var stack = [];

  var exposedHelpers = Object.assign(predicates, {
    defaultVisitor: defaultVisitor,
    convertValue: convertValue,
    isVisitable: isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      var result = !utils.isUndefined(el) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 75912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(90501);
var toFormData = __webpack_require__(38428);
var platform = __webpack_require__(52989);

module.exports = function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
};


/***/ }),

/***/ 37169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(82196).version);
var AxiosError = __webpack_require__(35424);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 10163:
/***/ (function(module) {

"use strict";


module.exports = FormData;


/***/ }),

/***/ 76578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosURLSearchParams = __webpack_require__(15134);

module.exports = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;


/***/ }),

/***/ 45557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = {
  isBrowser: true,
  classes: {
    URLSearchParams: __webpack_require__(76578),
    FormData: __webpack_require__(10163),
    Blob: Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};


/***/ }),

/***/ 52989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(45557);


/***/ }),

/***/ 90501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(82958);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a empty Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a empty Object, otherwise false
 */
function isEmptyObject(val) {
  return val && Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  var product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter, propFilter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 * @param {*} [thing]
 * @returns {?Array}
 */
function toArray(thing) {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  var i = thing.length;
  if (!isNumber(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

function forEachEntry(obj, fn) {
  var generator = obj && obj[Symbol.iterator];

  var iterator = generator.call(obj);

  var result;

  while ((result = iterator.next()) && !result.done) {
    var pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

function matchAll(regExp, str) {
  var matches;
  var arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

var isHTMLForm = kindOfTest('HTMLFormElement');

var hasOwnProperty = (function resolver(_hasOwnProperty) {
  return function(obj, prop) {
    return _hasOwnProperty.call(obj, prop);
  };
})(Object.prototype.hasOwnProperty);

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isEmptyObject: isEmptyObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList,
  forEachEntry: forEachEntry,
  matchAll: matchAll,
  isHTMLForm: isHTMLForm,
  hasOwnProperty: hasOwnProperty
};


/***/ }),

/***/ 55277:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 75291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(55277)
var ieee754 = __webpack_require__(2608)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 85999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(70650)('cookie');

/**
 * Set or get cookie `name` with `value` and `options` object.
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {Mixed}
 * @api public
 */

module.exports = function(name, value, options){
  switch (arguments.length) {
    case 3:
    case 2:
      return set(name, value, options);
    case 1:
      return get(name);
    default:
      return all();
  }
};

/**
 * Set cookie `name` to `value`.
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @api private
 */

function set(name, value, options) {
  options = options || {};
  var str = encode(name) + '=' + encode(value);

  if (null == value) options.maxage = -1;

  if (options.maxage) {
    options.expires = new Date(+new Date + options.maxage);
  }

  if (options.path) str += '; path=' + options.path;
  if (options.domain) str += '; domain=' + options.domain;
  if (options.expires) str += '; expires=' + options.expires.toUTCString();
  if (options.secure) str += '; secure';

  document.cookie = str;
}

/**
 * Return all cookies.
 *
 * @return {Object}
 * @api private
 */

function all() {
  var str;
  try {
    str = document.cookie;
  } catch (err) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error(err.stack || err);
    }
    return {};
  }
  return parse(str);
}

/**
 * Get cookie `name`.
 *
 * @param {String} name
 * @return {String}
 * @api private
 */

function get(name) {
  return all()[name];
}

/**
 * Parse cookie `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parse(str) {
  var obj = {};
  var pairs = str.split(/ *; */);
  var pair;
  if ('' == pairs[0]) return obj;
  for (var i = 0; i < pairs.length; ++i) {
    pair = pairs[i].split('=');
    obj[decode(pair[0])] = decode(pair[1]);
  }
  return obj;
}

/**
 * Encode.
 */

function encode(value){
  try {
    return encodeURIComponent(value);
  } catch (e) {
    debug('error `encode(%o)` - %o', value, e)
  }
}

/**
 * Decode.
 */

function decode(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    debug('error `decode(%o)` - %o', value, e)
  }
}


/***/ }),

/***/ 70650:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(13158);
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(36336);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 36336:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(24111);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 24111:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, exports) {


/**
 * Parse the given `url`.
 *
 * @param {String} str
 * @return {Object}
 * @api public
 */

exports.parse = function(url){
  var a = document.createElement('a');
  a.href = url;
  return {
    href: a.href,
    host: a.host || location.host,
    port: ('0' === a.port || '' === a.port) ? port(a.protocol) : a.port,
    hash: a.hash,
    hostname: a.hostname || location.hostname,
    pathname: a.pathname.charAt(0) != '/' ? '/' + a.pathname : a.pathname,
    protocol: !a.protocol || ':' == a.protocol ? location.protocol : a.protocol,
    search: a.search,
    query: a.search.slice(1)
  };
};

/**
 * Check if `url` is absolute.
 *
 * @param {String} url
 * @return {Boolean}
 * @api public
 */

exports.isAbsolute = function(url){
  return 0 == url.indexOf('//') || !!~url.indexOf('://');
};

/**
 * Check if `url` is relative.
 *
 * @param {String} url
 * @return {Boolean}
 * @api public
 */

exports.isRelative = function(url){
  return !exports.isAbsolute(url);
};

/**
 * Check if `url` is cross domain.
 *
 * @param {String} url
 * @return {Boolean}
 * @api public
 */

exports.isCrossDomain = function(url){
  url = exports.parse(url);
  var location = exports.parse(window.location.href);
  return url.hostname !== location.hostname
    || url.port !== location.port
    || url.protocol !== location.protocol;
};

/**
 * Return default port for `protocol`.
 *
 * @param  {String} protocol
 * @return {String}
 * @api private
 */
function port (protocol){
  switch (protocol) {
    case 'http:':
      return 80;
    case 'https:':
      return 443;
    default:
      return location.port;
  }
}


/***/ }),

/***/ 82320:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 87530:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),

/***/ 57664:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";return function(e,t){var r=t.prototype,n=r.format;r.format=function(e){var t=this,r=this.$locale();if(!this.isValid())return n.bind(this)(e);var s=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return s.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return s.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return s.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}}));return n.bind(this)(a)}}}));

/***/ }),

/***/ 55466:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return(e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e)}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1)}],a:[i,function(e){this.afternoon=u(e,!0)}],S:[/\d/,function(e){this.milliseconds=100*+e}],SS:[n,function(e){this.milliseconds=10*+e}],SSS:[/\d{3}/,function(e){this.milliseconds=+e}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r)}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"")}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else{var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"")}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={}}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""))}else i.call(this,e)}}}));

/***/ }),

/***/ 80079:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n,i=this.utcOffset(),a=this.toDate(),u=a.toLocaleString("en-US",{timeZone:t}),f=Math.round((a-new Date(u))/1e3/60),s=15*-Math.round(a.getTimezoneOffset()/15)-f;if(!Number(s))n=this.utcOffset(0,e);else if(n=o(u,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(s,!0),e){var m=n.utcOffset();n=n.add(i-m,"minute")}return n.$x.$timezone=t,n},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 79014:
/***/ (function(module) {

!function(t,i){ true?module.exports=i():0}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t)};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else r.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),

/***/ 97531:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 93162:
/***/ (function(module) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ 2608:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 47946:
/***/ (function() {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detachEvent == 'function') {
    node.detachEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),

/***/ 61937:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(13558);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 49189:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 65549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 54613:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(38145),
    hashDelete = __webpack_require__(69096),
    hashGet = __webpack_require__(65239),
    hashHas = __webpack_require__(78228),
    hashSet = __webpack_require__(95920);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 70131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(17168),
    listCacheDelete = __webpack_require__(66582),
    listCacheGet = __webpack_require__(13867),
    listCacheHas = __webpack_require__(59557),
    listCacheSet = __webpack_require__(22726);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 64438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 90278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(67076),
    mapCacheDelete = __webpack_require__(2530),
    mapCacheGet = __webpack_require__(44858),
    mapCacheHas = __webpack_require__(96265),
    mapCacheSet = __webpack_require__(59909);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 87076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 69902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 61124:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(90278),
    setCacheAdd = __webpack_require__(96718),
    setCacheHas = __webpack_require__(66996);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 4281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131),
    stackClear = __webpack_require__(30560),
    stackDelete = __webpack_require__(58282),
    stackGet = __webpack_require__(46638),
    stackHas = __webpack_require__(94270),
    stackSet = __webpack_require__(3229);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 54690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 5982:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 18965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457),
    root = __webpack_require__(70441);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 85198:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 69037:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 16222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(55092),
    isArguments = __webpack_require__(86981),
    isArray = __webpack_require__(77236),
    isBuffer = __webpack_require__(98752),
    isIndex = __webpack_require__(74363),
    isTypedArray = __webpack_require__(14812);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 26460:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 63848:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 44793:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 3833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(26530);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 56671:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(35897),
    createBaseEach = __webpack_require__(74741);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 40314:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(63848),
    isFlattenable = __webpack_require__(91754);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 60641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(32630);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 35897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(60641),
    keys = __webpack_require__(52635);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 80166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(18422),
    toKey = __webpack_require__(18780);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 39329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(63848),
    isArray = __webpack_require__(77236);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 94318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690),
    getRawTag = __webpack_require__(47077),
    objectToString = __webpack_require__(61954);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 70007:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 58520:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 31071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(67229),
    isObjectLike = __webpack_require__(3387);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 67229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(4281),
    equalArrays = __webpack_require__(12503),
    equalByTag = __webpack_require__(6001),
    equalObjects = __webpack_require__(88784),
    getTag = __webpack_require__(26686),
    isArray = __webpack_require__(77236),
    isBuffer = __webpack_require__(98752),
    isTypedArray = __webpack_require__(14812);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 9157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(4281),
    baseIsEqual = __webpack_require__(31071);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 62987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(93839),
    isMasked = __webpack_require__(47275),
    isObject = __webpack_require__(85973),
    toSource = __webpack_require__(76822);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 73749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isLength = __webpack_require__(99216),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 88904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(68418),
    baseMatchesProperty = __webpack_require__(54555),
    identity = __webpack_require__(15362),
    isArray = __webpack_require__(77236),
    property = __webpack_require__(21651);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 78803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(65003),
    nativeKeys = __webpack_require__(41466);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 52920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(56671),
    isArrayLike = __webpack_require__(81580);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 68418:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(9157),
    getMatchData = __webpack_require__(59182),
    matchesStrictComparable = __webpack_require__(57375);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 54555:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(31071),
    get = __webpack_require__(33795),
    hasIn = __webpack_require__(33646),
    isKey = __webpack_require__(73266),
    isStrictComparable = __webpack_require__(41457),
    matchesStrictComparable = __webpack_require__(57375),
    toKey = __webpack_require__(18780);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 50690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(26460),
    baseGet = __webpack_require__(80166),
    baseIteratee = __webpack_require__(88904),
    baseMap = __webpack_require__(52920),
    baseSortBy = __webpack_require__(36024),
    baseUnary = __webpack_require__(76535),
    compareMultiple = __webpack_require__(1397),
    identity = __webpack_require__(15362),
    isArray = __webpack_require__(77236);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 61712:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 14815:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(80166);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 94569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(15362),
    overRest = __webpack_require__(94468),
    setToString = __webpack_require__(98756);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 81676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(88211),
    defineProperty = __webpack_require__(9346),
    identity = __webpack_require__(15362);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 36024:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 55159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(26530);

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

module.exports = baseSortedUniq;


/***/ }),

/***/ 55092:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 90454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690),
    arrayMap = __webpack_require__(26460),
    isArray = __webpack_require__(77236),
    isSymbol = __webpack_require__(22945);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 76535:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 30555:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 18422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(77236),
    isKey = __webpack_require__(73266),
    stringToPath = __webpack_require__(23879),
    toString = __webpack_require__(41119);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 40709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(22945);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 1397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(40709);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 38507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(70441);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 74741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(81580);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 32630:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 9346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 12503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(61124),
    arraySome = __webpack_require__(44793),
    cacheHas = __webpack_require__(30555);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 6001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690),
    Uint8Array = __webpack_require__(5982),
    eq = __webpack_require__(26530),
    equalArrays = __webpack_require__(12503),
    mapToArray = __webpack_require__(52876),
    setToArray = __webpack_require__(66350);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 88784:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(36094);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 34414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 36094:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(39329),
    getSymbols = __webpack_require__(75904),
    keys = __webpack_require__(52635);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 72907:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(87620);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 59182:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(41457),
    keys = __webpack_require__(52635);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 84457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(62987),
    getValue = __webpack_require__(79741);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 47077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 75904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(69037),
    stubArray = __webpack_require__(27471);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 26686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(65549),
    Map = __webpack_require__(64438),
    Promise = __webpack_require__(87076),
    Set = __webpack_require__(69902),
    WeakMap = __webpack_require__(18965),
    baseGetTag = __webpack_require__(94318),
    toSource = __webpack_require__(76822);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 79741:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 37383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(18422),
    isArguments = __webpack_require__(86981),
    isArray = __webpack_require__(77236),
    isIndex = __webpack_require__(74363),
    isLength = __webpack_require__(99216),
    toKey = __webpack_require__(18780);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 38145:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 69096:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 65239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 78228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 95920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(75148);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 91754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(54690),
    isArguments = __webpack_require__(86981),
    isArray = __webpack_require__(77236);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 74363:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 63108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(26530),
    isArrayLike = __webpack_require__(81580),
    isIndex = __webpack_require__(74363),
    isObject = __webpack_require__(85973);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 73266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(77236),
    isSymbol = __webpack_require__(22945);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 87620:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 47275:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(38507);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 65003:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 41457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(85973);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 17168:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 66582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 13867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 59557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 22726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(3833);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 67076:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(54613),
    ListCache = __webpack_require__(70131),
    Map = __webpack_require__(64438);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 2530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 44858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 96265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 59909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(72907);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 52876:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 57375:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 97085:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(30427);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 75148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(84457);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 41466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(53717);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 91782:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(34414);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 61954:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 53717:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 94468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(85198);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 70441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(34414);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 96718:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 66996:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 66350:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 98756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(81676),
    shortOut = __webpack_require__(79116);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 79116:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 30560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 58282:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 46638:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 94270:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 3229:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(70131),
    Map = __webpack_require__(64438),
    MapCache = __webpack_require__(90278);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 23879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(97085);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 18780:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(22945);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 76822:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 88211:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 26530:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 75453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(40314);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 33795:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(80166);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 33646:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(70007),
    hasPath = __webpack_require__(37383);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 15362:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 86981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(58520),
    isObjectLike = __webpack_require__(3387);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 77236:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 81580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(93839),
    isLength = __webpack_require__(99216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 98752:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(70441),
    stubFalse = __webpack_require__(7149);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 93839:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObject = __webpack_require__(85973);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 99216:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 85973:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3387:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 22945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(94318),
    isObjectLike = __webpack_require__(3387);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 14812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(73749),
    baseUnary = __webpack_require__(76535),
    nodeUtil = __webpack_require__(91782);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 52635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(16222),
    baseKeys = __webpack_require__(78803),
    isArrayLike = __webpack_require__(81580);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 30427:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(90278);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 21651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(61712),
    basePropertyDeep = __webpack_require__(14815),
    isKey = __webpack_require__(73266),
    toKey = __webpack_require__(18780);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 98978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(40314),
    baseOrderBy = __webpack_require__(50690),
    baseRest = __webpack_require__(94569),
    isIterateeCall = __webpack_require__(63108);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ 64196:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(88904),
    baseSortedUniq = __webpack_require__(55159);

/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? baseSortedUniq(array, baseIteratee(iteratee, 2))
    : [];
}

module.exports = sortedUniqBy;


/***/ }),

/***/ 27471:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 7149:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 41119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(90454);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 13558:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 94562:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(52521);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_app; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.css
var dist = __webpack_require__(95249);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/cds-tokens/dist/css/cds-tokens.css
var cds_tokens = __webpack_require__(8028);
// EXTERNAL MODULE: ../../../node_modules/next/head.js
var head = __webpack_require__(46582);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/data/user/src/index.ts + 9 modules
var user_src = __webpack_require__(47453);
// EXTERNAL MODULE: ../../../libs/landing/feature-error-page/src/index.ts + 7 modules
var feature_error_page_src = __webpack_require__(68674);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../../node_modules/next/script.js
var script = __webpack_require__(50430);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/react-slidedown/lib/slidedown.css
var slidedown = __webpack_require__(93555);
// EXTERNAL MODULE: ../../../node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(70065);
// EXTERNAL MODULE: ../../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1663);
// EXTERNAL MODULE: ../../../libs/shared/cookie-consent/src/index.ts + 52 modules
var cookie_consent_src = __webpack_require__(93194);
// EXTERNAL MODULE: ../../../libs/data/orders/src/index.ts + 16 modules
var orders_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ./stores/index.ts



const authKeys = {
    authKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AuthKey */.X.AuthKey),
    legacyAuthKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.LegacyAuthKey */.X.LegacyAuthKey)
};
(0,user_src/* initUserStore */.mv)({
    ...authKeys,
    identityServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.IdentityServiceUrl */.X.IdentityServiceUrl),
    profileServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ProfileServiceUrl */.X.ProfileServiceUrl),
    redirectUrlKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.RedirectUrlKey */.X.RedirectUrlKey)
});
(0,orders_src/* initOrdersStore */.$0)({
    ...authKeys,
    cinchCareServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.CinchcareServiceUrl */.X.CinchcareServiceUrl),
    orderServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.OrderServiceUrl */.X.OrderServiceUrl)
});

// EXTERNAL MODULE: ./pages/_app.css
var _app = __webpack_require__(90953);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
;// CONCATENATED MODULE: ./pages/_app.tsx



















const ClientSideHead = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6829).then(__webpack_require__.bind(__webpack_require__, 76829)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(76829)
            ]
    },
    ssr: false
});
function CustomApp({ Component , pageProps , err  }) {
    const { layoutProps , ...componentProps } = pageProps;
    const { ddMeta  } = componentProps;
    const [story, setChangedStory] = (0,react.useState)(pageProps.story);
    const { fetchUser  } = (0,user_src/* useUserStore */.LM)();
    const BUILD_ID = "landing-www::b344a3f21a1f14207b5048bb702550734e68e3b7::12784956648::production";
    (0,src/* registerRumContext */.Dj)(BUILD_ID);
    (0,react.useEffect)(()=>{
        if (localStorage.getItem("updatedCookiePreferences") || localStorage.getItem("cookieConsentPreferences")) {
            const time = Number.parseInt(localStorage.getItem("lastExternalReferrerTime"), 10);
            let preferences = {
                functional: true,
                advertising: true,
                analytics: true
            };
            if (!localStorage.getItem("cookieConsentPreferences")) {
                preferences = JSON.parse(localStorage.getItem("updatedCookiePreferences"));
            }
            const cookieSetting = (0,cookie_consent_src/* getCookieSettings */.US)(time, preferences, localStorage.getItem("cookieConsentPreferences") ? "initial" : "edited");
            (0,cookie_consent_src/* cookieSettings */.EW)(cookieSetting);
            localStorage.removeItem("updatedCookiePrefs");
            localStorage.removeItem("cookieConsentPreferences");
        }
        (0,analytics_src/* preserveReferrerAndCID */.ai)();
        fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOnload = ()=>{
        const { StoryblokBridge , location  } = window;
        const storyblokInstance = new StoryblokBridge();
        storyblokInstance.on([
            "published",
            "change"
        ], ()=>{
            // reload page if save or publish is clicked
            location.reload();
        });
        storyblokInstance.on("input", (payload)=>{
            setChangedStory(payload.story);
        });
    };
    if (componentProps.story && story) {
        componentProps.story = story;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(feature_error_page_src/* ErrorBoundaryWrapper */.uW, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSideHead, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(analytics_src/* AnalyticsManager */.oM, {}),
            pageProps.preview && // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://app.storyblok.com/f/storyblok-v2-latest.js",
                type: "text/javascript",
                onLoad: handleOnload
            }),
            ddMeta ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "dd-trace-id",
                        content: ddMeta.traceId
                    }, "dd-trace-id"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "dd-trace-time",
                        content: `${ddMeta.traceTime}`
                    }, "dd-trace-time")
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Layout */.Ar, {
                ...layoutProps,
                useVerticalGradient: true,
                showBorderRadius: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                            ...componentProps,
                            err: err
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CookieConsentWrapper */.YE, {})
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var pages_app = (CustomApp);


/***/ }),

/***/ 42513:
/***/ (function(module) {

"use strict";

module.exports = ({ onlyFirst =false  } = {})=>{
    const pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(pattern, onlyFirst ? undefined : "g");
};


/***/ }),

/***/ 86634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wj": function() { return /* reexport */ getTraceId; },
  "YA": function() { return /* reexport */ setTag; },
  "$k": function() { return /* reexport */ tagError; },
  "KG": function() { return /* reexport */ traceFunction; }
});

// UNUSED EXPORTS: fetchWithTracePropagation, startSpan

// EXTERNAL MODULE: dd-trace (ignored)
var dd_trace_ignored_ = __webpack_require__(29858);
;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/is-traceable-environment.ts
/* provided dependency */ var process = __webpack_require__(13158);
/**
 * Determines if the code is executing inside a traceable (lambda) environment
 *
 * This is required to avoid issues when running locally, or when instrumented code
 * is executed in the browser (which shouldn't happen if next.js is correctly configured)
 */ const is_traceable_environment_isTraceableEnvironment = ()=>{
    var ref;
    return (ref = process.env["AWS_EXECUTION_ENV"]) === null || ref === void 0 ? void 0 : ref.startsWith("AWS_Lambda_");
};

// EXTERNAL MODULE: dd-trace (ignored)
var dd_trace_ignored_0 = __webpack_require__(38627);
var dd_trace_ignored_default_0 = /*#__PURE__*/__webpack_require__.n(dd_trace_ignored_0);
;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/start-span.ts


/**
 * Create a span that will last for the duration of the supplied callback
 *
 * Unlike `traceFunction`, this calls the supplied function immediately.
 *
 * On a non-traceable environment, this will just call the supplied function
 */ const startSpan = async (key, callback)=>isTraceableEnvironment() ? tracer.trace(key, callback) : callback();

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/trace-function.ts


/**
 * Returns an instrumented version of a function that will create a span
 * with the supplied name when the function is called
 *
 * Unlike `startSpan`, this does not call the supplied function immediately
 *
 * On a non-traceable environment, this will return the supplied function
 */ const traceFunction = (name, func)=>is_traceable_environment_isTraceableEnvironment() ? dd_trace_ignored_default_0().wrap(name, func) : func;

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/set-tag.ts
/* provided dependency */ var set_tag_process = __webpack_require__(13158);


/**
 * Tag a value on the currently active span
 *
 * In the case of array values, this will tag it as a
 * serialised version of the array
 *
 * By default, this will add things below the `context` tag,
 * but if you want to tag something at the root (such as when
 * tagging additional error details) this can be disabled
 * with the optional `config` object
 *
 * On a non-traceable environment, this will do nothing
 */ const setTag = (name, value, config)=>{
    if (!is_traceable_environment_isTraceableEnvironment()) {
        if (!set_tag_process.env["SUPPRESS_FALLBACK_DATADOG_LOGGING"]) {
            console.debug(`>> setTag: [${name}]: ${value}`);
        }
        return;
    }
    const nestInContextTag = (config === null || config === void 0 ? void 0 : config.useContextTag) ?? true;
    const tagNamePrefix = nestInContextTag ? "context." : "";
    const span = dd_trace_ignored_default_0().scope().active();
    if (!span) {
        throw new Error("Active span not available");
    }
    if (typeof value === "object" && value !== null) {
        if (Array.isArray(value)) {
            span.setTag(`${tagNamePrefix}${name}`, JSON.stringify(value));
        } else {
            for (const [_key, _value] of Object.entries(value)){
                if (typeof _value === "object") {
                    setTag(`${name}.${_key}`, _value);
                } else {
                    span.setTag(`${tagNamePrefix}${name}.${_key}`, _value);
                }
            }
        }
    } else {
        span.setTag(`${tagNamePrefix}${name}`, value);
    }
};

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/tag-error.ts
/* provided dependency */ var tag_error_process = __webpack_require__(13158);


/**
 * Tag the current span with error details
 *
 * This will mark the span as errored in Datadog
 *
 * On a non-traceable environment, this will do nothing
 */ const tagError = (tagError)=>{
    const isString = typeof tagError === "string";
    const errorInstance = isString ? new Error(tagError) : tagError;
    if (!is_traceable_environment_isTraceableEnvironment()) {
        if (!tag_error_process.env["SUPPRESS_FALLBACK_DATADOG_LOGGING"]) {
            console.error(">> tagError: [message]", errorInstance.message);
            console.error(">> tagError: [stack]", errorInstance.stack);
            console.error(">> tagError: [type]", errorInstance.name);
        }
        return;
    }
    const span = dd_trace_ignored_default_0().scope().active();
    if (!span) {
        throw new Error("Active span not available");
    }
    span.setTag("error.msg", errorInstance.message);
    span.setTag("error.stack", errorInstance.stack);
    span.setTag("error.type", errorInstance.name);
};

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/traced-fetch.ts


const getDatadogTraceHeaders = ()=>{
    var ref, ref1;
    const headers = {};
    const traceId = (ref = tracer.scope().active()) === null || ref === void 0 ? void 0 : ref.context().toTraceId();
    const spanId = (ref1 = tracer.scope().active()) === null || ref1 === void 0 ? void 0 : ref1.context().toSpanId();
    if (traceId && spanId) {
        headers["x-datadog-trace-id"] = traceId;
        headers["x-datadog-parent-id"] = spanId;
        headers["x-datadog-sampling-priority"] = "1";
    }
    return headers;
};
/**
 * Force Datadog trace propagation headers into the fetch request
 *
 * You should only need this if trace propagation/distributed tracing isn't working for some reason
 */ const fetchWithTracePropagation = (input, init)=>{
    if (!isTraceableEnvironment()) {
        return fetch(input, init);
    }
    const headers = input instanceof Request ? input.headers : (init === null || init === void 0 ? void 0 : init.headers) ?? new Headers();
    const ddHeaders = getDatadogTraceHeaders();
    if (headers instanceof Headers) {
        // headers is an instance of Headers
        Object.entries(ddHeaders).forEach(([key, value])=>{
            if (value) {
                headers.set(key, value);
            }
        });
    } else if (Array.isArray(headers)) {
        // headers is an array of tuples
        headers.push(...Object.entries(ddHeaders));
    } else {
        // headers is a record
        Object.entries(ddHeaders).forEach(([key, value])=>{
            headers[key] = value;
        });
    }
    return fetch(input, init);
};

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/lib/get-trace-id.ts


const getTraceId = ()=>{
    var ref;
    return is_traceable_environment_isTraceableEnvironment() ? (ref = dd_trace_ignored_default_0().scope().active()) === null || ref === void 0 ? void 0 : ref.context().toTraceId() : "";
};

;// CONCATENATED MODULE: ../../../libs/core/datadog-server/src/index.ts


if (is_traceable_environment_isTraceableEnvironment()) {
    // the tracer.init function should only be called once, so do it in here as a side-effect
    // so it's called before any of the modules that rely on it are exported
    dd_trace_ignored_.tracer.init();
}








/***/ }),

/***/ 72777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ CustomerDataProvider; },
  "yV": function() { return /* reexport */ identify; },
  "Md": function() { return /* reexport */ page; },
  "j": function() { return /* reexport */ track; },
  "LE": function() { return /* reexport */ useCustomerData; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/lib/helpers/cookies.ts
const getCookie = ({ name  })=>{
    var ref;
    return ((ref = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)) === null || ref === void 0 ? void 0 : ref.pop()) ?? undefined;
};
const cookiePreferencesCookieParser = (cookieContents)=>cookieContents ? JSON.parse(cookieContents) : undefined;
const cookiePreferences = ()=>cookiePreferencesCookieParser(getCookie({
        name: "cp"
    }));
const hasConsentedToCookies = (type)=>{
    var ref;
    return ((ref = cookiePreferences()) === null || ref === void 0 ? void 0 : ref[type]) ?? false;
};

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/entries/main.js + 20 modules
var main = __webpack_require__(39806);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var entries_main = __webpack_require__(50163);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/lib/library/library.ts



const getSegmentUserId = ()=>{
    var ref, ref1;
    return ((ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user().id()) ?? ((ref1 = window.analytics) === null || ref1 === void 0 ? void 0 : ref1.user().anonymousId()) ?? "";
};
const datadogMiddleware = ({ payload , next  })=>{
    if (window._DATADOG_SYNTHETICS_BROWSER) return;
    const userId = getSegmentUserId();
    datadogRum.setGlobalContextProperty("user", {
        id: userId
    });
    next(payload);
};
const excludedPagesMiddleware = ({ payload , next  })=>{
    const excludedPages = [
        "/auth-callback",
        "/silent-renew"
    ];
    if (excludedPages.includes(payload.obj.context.page.path)) return;
    next(payload);
};
const unauthenticatedMiddleware = ({ payload , next  })=>{
    var ref;
    // Have to access this via window.analytics rather than payload because
    // the payload doesn't detail if a user is authed or not
    if ((ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user().id()) return next(payload);
    const integrationWithPermissions = {
        Zendesk: false,
        "Customer.io": false
    };
    const updatedPayload = {
        ...payload,
        obj: {
            ...payload.obj,
            integrations: {
                ...integrationWithPermissions
            }
        }
    };
    next(updatedPayload);
};
const configureMiddleware = ()=>{
    var ref, ref1, ref2;
    (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.addSourceMiddleware(datadogMiddleware);
    (ref1 = window.analytics) === null || ref1 === void 0 ? void 0 : ref1.addSourceMiddleware(excludedPagesMiddleware);
    (ref2 = window.analytics) === null || ref2 === void 0 ? void 0 : ref2.addSourceMiddleware(unauthenticatedMiddleware);
};
const identify = ({ userId , data  })=>{
    try {
        // const email = readEmailFromSessionStorage()
        const identifyData = {
            ...data
        };
        if (userId) {
            var ref;
            (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.identify(userId, identifyData);
        } else {
            var ref1;
            (ref1 = window.analytics) === null || ref1 === void 0 ? void 0 : ref1.identify(identifyData);
        }
    } catch (error) {
        main/* datadogLogs.logger.error */.fy.logger.error("call to window.analytics.identify() failed", {
            userId,
            data,
            error
        });
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const track = (eventName, data)=>{
    if (!eventName || eventName.length === 0) return;
    const { adobeID , gaID  } = (0,src/* getAnalyticIDs */.cF)();
    const analyticsContext = {
        analyticIds: {
            adobeID,
            gaID
        }
    };
    // const email = readEmailFromSessionStorage()
    const options = {
        context: {
            ...analyticsContext
        }
    };
    try {
        var ref;
        (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.track(eventName, {
            ...data
        }, options);
    } catch (error) {
        main/* datadogLogs.logger.error */.fy.logger.error("call to window.analytics.track() failed", {
            eventName,
            data,
            error
        });
    }
};
const library_reset = ()=>{
    try {
        var ref;
        (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.reset();
    } catch  {
        datadogLogs.logger.error("call to window.analytics.reset() failed");
    }
};
const page = (name, data)=>{
    if (!name) return;
    try {
        var ref;
        (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.page(name, data ?? {}, {
            integrations: {
                Zendesk: false
            }
        });
    } catch (error) {
        main/* datadogLogs.logger.error */.fy.logger.error("call to window.analytics.page() failed", {
            name,
            data,
            error
        });
    }
};

;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/lib/library/index.ts


;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/lib/customer-data-segment.tsx




const noop = ()=>({});
const defaultValues = {
    trackEvent: noop,
    getSegmentUserId: ()=>""
};
const CustomerDataContext = /*#__PURE__*/ (0,react.createContext)(defaultValues);
const useCustomerData = ()=>(0,react.useContext)(CustomerDataContext);
const trackEvent = (event)=>{
    if (true) {
        if (!hasConsentedToCookies("functional")) {
            return;
        }
        switch(event.type){
            case "identify":
                if (event.userId) {
                    identify({
                        userId: event.userId,
                        data: event.data || {}
                    });
                } else {
                    identify({
                        data: event.data || {}
                    });
                }
                break;
            case "track":
                track(event.eventName, event.data);
                break;
            case "page":
                page(event.pageName, event.data);
                break;
        }
    }
};
const CustomerDataProvider = ({ children  })=>{
    const context = {
        trackEvent,
        getSegmentUserId: getSegmentUserId
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDataContext.Provider, {
        value: context,
        children: children
    });
};

;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/index.ts




/***/ }),

/***/ 2388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$0": function() { return /* reexport */ initOrdersStore; },
  "lS": function() { return /* reexport */ useOrdersStore; }
});

// UNUSED EXPORTS: OrdersStates, getValidOrders, stubAwaitingFinanceDecisionOrder, stubAwaitingFinanceDepositOrder, stubCancelledOrder, stubCompletedCinchCareOrder, stubCompletedOrder, stubCompletedOrderWithDeliverySlot, stubDeclinedFinanceDepositOrder, stubInProgressOrder, useTrackOrderTracking

// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var axios = __webpack_require__(43653);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-reservations/src/lib/data-reservations.tsx


const createAxiosInstance = (token)=>axios_default().create({
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
/**
 * @description
 * Used by **both** `front-ends` and `cinch-nx` to manage reservations.
 * Since axios instances are handled slightly differently in each monorepo, we pass in the instance as a parameter.
 * This instance needs to be set up with the correct headers using `interceptors.request.use`
 * (https://axios-http.com/docs/interceptors).
 *
 * @example
 * const { expiresAt, getReservation, extendReservation } = useReservationStore()
 *
 * const expiresAt = await getReservation(orderId, axiosInstance)
 */ const useReservationStore = (0,esm/* create */.Ue)((set, get)=>{
    return {
        legacyExtendReservation: async (orderId, orderServiceUrl, token)=>{
            const axiosInstance = createAxiosInstance(token);
            const response = await axiosInstance.post(`${orderServiceUrl}/order/extend-expiry`, {
                orderId
            });
            return response === null || response === void 0 ? void 0 : response.data;
        }
    };
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-reservations/src/lib/helpers/send-reservation-error.ts

const sendReservationError = (description, error, orderId)=>{
    var ref, ref1, ref2;
    return datadogRum.addError(description, {
        location: "reservation-service-nx",
        orderId,
        error: {
            message: (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message,
            status: (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status,
            stack: error.stack
        }
    });
};

;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-reservations/src/lib/helpers/index.ts


;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-reservations/src/lib/types.ts
var PartExOutstandingFinanceEquity;
(function(PartExOutstandingFinanceEquity) {
    PartExOutstandingFinanceEquity["Positive"] = "Positive";
    PartExOutstandingFinanceEquity["Negative"] = "Negative";
    PartExOutstandingFinanceEquity["No"] = "No";
})(PartExOutstandingFinanceEquity || (PartExOutstandingFinanceEquity = {}));

;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-reservations/src/index.ts




;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-checkout/src/lib/helpers/send-checkout-error.ts


const sendCheckoutError = (description, error, orderId)=>{
    const errorPayload = axios_default().isAxiosError(error) ? {
        message: error.message,
        response: error.response
    } : error;
    console.log({
        errorPayload
    });
    main/* datadogRum.addError */.v.addError(description, {
        location: "checkout-service-nx",
        orderId,
        error: errorPayload
    });
};

;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-checkout/src/lib/data-checkout.ts


const handleExtendReservation = async ({ orderId , token , orderServiceUrl  })=>{
    const { legacyExtendReservation  } = useReservationStore.getState();
    try {
        const res = await legacyExtendReservation(orderId, orderServiceUrl, token);
        return res;
    } catch (error) {
        sendCheckoutError("Error extending reservation (extendOrderExpiryDate)", error, orderId);
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../../libs/part-ex-and-checkout/data-checkout/src/index.ts



// EXTERNAL MODULE: ../../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(87530);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../../node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(79014);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/helpers/check-cinchcare-eligibility.ts



dayjs_min_default().extend((utc_default()));
const checkCinchCareEligibility = (vehicleOrder, allCinchCareOrders)=>{
    var ref;
    const deliverySlotDate = (ref = vehicleOrder.deliverySlot) === null || ref === void 0 ? void 0 : ref.date;
    const deliveryDate = deliverySlotDate ? dayjs_min_default().utc(deliverySlotDate) : null;
    if (!orderIsCompleted(vehicleOrder.orderStatus) || !vehicleOrder.completedAt) {
        return false;
    }
    const postDeliveryEligibleWarrantyPeriodDays = (0,src/* getCinchCareEligibilityPeriod */.qU)(vehicleOrder.completedAt);
    const isWithinEligiblePostDeliveryPeriod = dayjs_min_default().utc().subtract(postDeliveryEligibleWarrantyPeriodDays, "days").subtract(1, "days");
    const alreadyHasCinchCare = allCinchCareOrders === null || allCinchCareOrders === void 0 ? void 0 : allCinchCareOrders.map((plan)=>plan.vehicleVrm).includes(vehicleOrder.vehicle.vrm);
    if (!deliveryDate || alreadyHasCinchCare) {
        return false;
    }
    return deliveryDate.isAfter(isWithinEligiblePostDeliveryPeriod, "seconds");
};
const orderIsCompleted = (orderStatus)=>orderStatus === "OrderCompleted" || orderStatus === "Fulfilled";

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/helpers/map-cinch-care-order-to-vehicle.ts
const mapCinchCareOrderToVehicle = (cinchCarePlan, allVehicleOrders)=>{
    var ref;
    return {
        plan: cinchCarePlan,
        vehicle: (ref = allVehicleOrders === null || allVehicleOrders === void 0 ? void 0 : allVehicleOrders.find((order)=>order.vehicle.vrm === cinchCarePlan.vehicleVrm)) === null || ref === void 0 ? void 0 : ref.vehicle
    };
};

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/helpers/check-emac-servce-warranty-eligibility.ts



dayjs_min_default().extend((utc_default()));
const checkEMaCServiceWarrantyEligibility = (vehicleOrder, allCinchCareOrders)=>{
    var ref;
    const deliverySlotDate = (ref = vehicleOrder.deliverySlot) === null || ref === void 0 ? void 0 : ref.date;
    const deliveryDate = deliverySlotDate ? dayjs_min_default().utc(deliverySlotDate) : null;
    if (!check_emac_servce_warranty_eligibility_orderIsCompleted(vehicleOrder.orderStatus) || !vehicleOrder.completedAt) {
        return false;
    }
    const postDeliveryEligibleWarrantyPeriodDays = (0,src/* getEMaCServiceWarrantyEligibilityPeriod */.gY)();
    const isWithinEligiblePostDeliveryPeriod = dayjs_min_default().utc().subtract(postDeliveryEligibleWarrantyPeriodDays, "days").subtract(1, "days");
    const alreadyHasCinchCare = allCinchCareOrders === null || allCinchCareOrders === void 0 ? void 0 : allCinchCareOrders.map((plan)=>plan.vehicleVrm).includes(vehicleOrder.vehicle.vrm);
    if (!deliveryDate || alreadyHasCinchCare) {
        return false;
    }
    return deliveryDate.isAfter(isWithinEligiblePostDeliveryPeriod, "seconds");
};
const check_emac_servce_warranty_eligibility_orderIsCompleted = (orderStatus)=>orderStatus === "OrderCompleted" || orderStatus === "Fulfilled";

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/data-orders.tsx








let ordersConfig = {
    orderServiceUrl: "",
    cinchCareServiceUrl: "",
    authKey: "",
    legacyAuthKey: ""
};
let httpClient = (axios_default());
const initOrdersStore = (config, axiosImpl = (axios_default()))=>{
    ordersConfig = {
        orderServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.OrderServiceUrl */.X.OrderServiceUrl),
        cinchCareServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.CinchcareServiceUrl */.X.CinchcareServiceUrl),
        authKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AuthKey */.X.AuthKey),
        legacyAuthKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.LegacyAuthKey */.X.LegacyAuthKey),
        ...config
    };
    const _httpClient = axiosImpl.create({
        baseURL: ordersConfig.orderServiceUrl
    });
    _httpClient.interceptors.request.use((request)=>{
        const token = (0,src/* getToken */.LP)({
            authKey: ordersConfig.authKey,
            legacyAuthKey: ordersConfig.legacyAuthKey
        });
        return {
            ...request,
            headers: {
                ...request.headers,
                Authorization: `Bearer ${token === null || token === void 0 ? void 0 : token.access_token}`
            }
        };
    });
    httpClient = _httpClient;
};
/**
 * @description
 * Vehicle orders and cinchCare orders are dependent upon one another
 * cinchCare orders require the vehicle object from the order, matched by vehicle VRM
 * vehicle orders have a boolean flag to indicate their eligibility for cinchCare
 *
 * Because of this cross dependency, the functions getVehicleOrders and getCinchCareOrders
 * should be used to retrieve the enriched objects from the store instead of accessing the
 * raw response arrays inside vehicleOrdersRequest and cinchCareOrdersRequest.
 *
 * These functions will enrich the raw response each time they are requested from the store,
 * ensuring the most up-to-date data
 */ const useOrdersStore = (0,esm/* create */.Ue)((set, get)=>{
    return {
        vehicleOrdersRequest: {
            status: "pending",
            orders: []
        },
        cinchCareOrdersRequest: {
            status: "pending",
            orders: []
        },
        activeOrder: undefined,
        vehicleOrderAddingCinchCare: undefined,
        setVehicleOrderAddingCinchCare: (order)=>set({
                vehicleOrderAddingCinchCare: order
            }),
        refreshActiveOrder: async ()=>{
            const { data: { latestActiveOrder  }  } = await httpClient.get(`/orders/latest/active`);
            set(()=>({
                    activeOrder: latestActiveOrder
                }));
        },
        checkIfVehicleIsReserved: async (vehicleId)=>{
            if (!vehicleId) {
                return {
                    reserved: true
                };
            }
            return (await httpClient.get(`/reservation-status/${vehicleId}?userId=`)).data;
        },
        extendOrderExpiryDate: async (orderId, token)=>{
            try {
                await handleExtendReservation({
                    orderId,
                    token,
                    orderServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.OrderServiceUrl */.X.OrderServiceUrl)
                });
                await get().fetchOrders();
            } catch  {
                return set(()=>({
                        vehicleOrdersRequest: {
                            status: "invalid",
                            orders: undefined
                        }
                    }));
            }
        },
        cancelOrder: async (orderId, cancelOrderReason, token)=>await httpClient.post(`/order/cancel-order`, {
                orderId,
                cancelOrderReason
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }),
        cinchCareOrders: ()=>{
            const { vehicleOrdersRequest: { orders: vehicleOrders  } , cinchCareOrdersRequest: { orders: cinchCareOrders  }  } = get();
            return [
                ...cinchCareOrders ?? []
            ].map((cinchCareOrder)=>mapCinchCareOrderToVehicle(cinchCareOrder, vehicleOrders));
        },
        vehicleOrders: ()=>{
            const { vehicleOrdersRequest: { orders: vehicleOrders  } , cinchCareOrdersRequest: { orders: cinchCareOrders  }  } = get();
            return [
                ...vehicleOrders ?? []
            ].map((order)=>({
                    order,
                    eligibleForCinchCare: checkCinchCareEligibility(order, cinchCareOrders),
                    eligibleForEMaCServiceWarranty: checkEMaCServiceWarrantyEligibility(order, cinchCareOrders)
                }));
        },
        vehicleOrdersByStatus: (...statuses)=>{
            var ref;
            return (ref = get().vehicleOrders()) === null || ref === void 0 ? void 0 : ref.filter((vehicleOrder)=>statuses.includes(vehicleOrder.order.orderStatus));
        },
        fetchOrders: async ()=>{
            try {
                const { orders  } = (await httpClient.get(`/orders`)).data;
                return set(()=>({
                        vehicleOrdersRequest: {
                            status: "valid",
                            orders
                        }
                    }));
            } catch  {
                return set(()=>({
                        vehicleOrdersRequest: {
                            status: "invalid",
                            orders: undefined
                        }
                    }));
            }
        },
        fetchCinchCareOrders: async ()=>{
            try {
                const { cinchCareServiceUrl  } = ordersConfig;
                const { data: cinchCareOrders  } = await httpClient.get(`/orderdetails`, {
                    baseURL: cinchCareServiceUrl
                });
                set(()=>({
                        cinchCareOrdersRequest: {
                            status: "valid",
                            orders: cinchCareOrders
                        }
                    }));
                return;
            } catch  {
                set(()=>({
                        cinchCareOrdersRequest: {
                            status: "invalid",
                            orders: undefined
                        }
                    }));
                return;
            }
        },
        activateCinchCare: async (payload)=>{
            const { cinchCareServiceUrl  } = ordersConfig;
            const activateCinchCareUrl = `/cinchcare/activate`;
            return httpClient.post(activateCinchCareUrl, payload, {
                baseURL: cinchCareServiceUrl
            });
        }
    };
});

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/types.ts
var OrdersStates;
(function(OrdersStates) {
    OrdersStates["Both"] = "both";
    OrdersStates["None"] = "none";
    OrdersStates["OrderOutstanding"] = "orderOutstanding";
    OrdersStates["OrderFulfilled"] = "orderFulfilled";
})(OrdersStates || (OrdersStates = {}));

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/use-order-tracking.hook.ts

const useTrackOrderTracking = ()=>{
    const trackEvent = useAnalytics((state)=>state.trackEvent);
    const onTrackOrderClick = (orderRef, deliveryDate)=>{
        const evt = {
            event: {
                name: EventNames.click,
                category: EventCategories.orderTracking,
                action: EventActions.click,
                value: orderRef,
                label: deliveryDate
            }
        };
        trackEvent({
            type: TrackingEventTypes.ADOBE,
            eventName: "Profile - View order tracking clicked",
            data: evt
        });
    };
    const orderStatusesOnPageLoad = (ordersState)=>{
        const evt = {
            event: {
                name: EventNames.load,
                category: EventCategories.myProfile,
                value: ordersState,
                label: "myProfileOrderStatus"
            }
        };
        trackEvent({
            type: TrackingEventTypes.ADOBE,
            eventName: "Profile - Orders state on page load",
            data: evt
        });
    };
    const orderAwaitingFinanceDepositOnPageLoad = ()=>{
        const evt = {
            event: {
                name: EventNames.load,
                category: EventCategories.myProfile,
                value: "awaitingFinanceDeposit",
                label: "myProfileOrderStatus"
            }
        };
        trackEvent({
            type: TrackingEventTypes.ADOBE,
            eventName: "Profile - Orders that are Awaiting Finance Deposit on page load",
            data: evt
        });
    };
    return {
        onTrackOrderClick,
        orderStatusesOnPageLoad,
        orderAwaitingFinanceDepositOnPageLoad
    };
};

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/__stubs__/order-states.ts
const expiresAt = Date.now() + 7200000 // 2 Hours
;
const baseOrder = {
    expiresAt,
    id: "12345678-abcd-12ab-a1b2c3d4e5f7",
    userId: "12345678-abcd-12ab-a1b2c3d4e5f7",
    orderRef: "CI-6P8LWN-28778P",
    vehicle: {
        vrm: "YY66SYA",
        priceInPence: 1200000,
        stockType: "cinch",
        imageUrl: "https://eu.cdn.autosonshow.tv/5213/projectcambridge/YY66SYA/06_md.jpg",
        registrationDate: "2016-11-09T00:00:00.000Z",
        model: "XC60",
        derivative: "D4 [190] R DESIGN Nav 5dr Geartronic",
        vin: "YV1DZA8CDH2083943",
        id: "1b8f6fd7-4c25-42c6-9e6b-c202e3533570",
        make: "VOLVO",
        engineCapacityCc: 1969,
        mileage: 59286,
        variant: "D4 [190] R DESIGN Nav 5dr Geartronic"
    },
    amountPayableInPence: 0,
    amountPaidInPence: 123456,
    createdAt: 1621853580333,
    completedAt: 1621853580333,
    customerTitle: "Mr",
    customerFirstName: "Kanye",
    customerLastName: "Test",
    customerEmail: "kanye.test@cinch.co.uk",
    customerContactTelephoneNumber: "012345678910",
    lineItems: [
        {
            priceInPence: 1200000,
            productType: "Vehicle",
            referenceId: "162a92af-c59b-4557-8bcb-1d3fd59165c7"
        }
    ],
    orderStatus: "Cancelled",
    orderTotalInPence: 1200000,
    paymentRecords: []
};
const stubCompletedOrder = {
    ...baseOrder,
    orderStatus: "OrderCompleted"
};
const stubCancelledOrder = {
    ...baseOrder,
    orderStatus: "Cancelled"
};
const stubInProgressOrder = {
    ...baseOrder,
    orderStatus: "InProgress"
};
const stubAwaitingFinanceDepositOrder = {
    ...baseOrder,
    orderStatus: "AwaitingFinanceDeposit",
    financeApplication: {
        id: "12345678-abcd-12ab-a1b2c3d4e5f7",
        advanceAmountInPence: 10000,
        status: "ApplicationApproved"
    }
};
const stubDeclinedFinanceDepositOrder = {
    ...baseOrder,
    orderStatus: "Cancelled",
    financeApplication: {
        id: "12345678-abcd-12ab-a1b2c3d4e5f7",
        advanceAmountInPence: 10000,
        status: "ApplicationDeclined"
    }
};
const stubAwaitingFinanceDecisionOrder = {
    ...baseOrder,
    orderStatus: "AwaitingFinanceDecision"
};
const stubCompletedOrderWithDeliverySlot = {
    ...baseOrder,
    orderStatus: "OrderCompleted",
    deliverySlot: {
        date: "2021-05-30",
        startHour: 10,
        endHour: 12,
        reservationId: "1234-id-456"
    }
};

;// CONCATENATED MODULE: ../../../libs/data/orders/src/lib/__stubs__/cinchcare-states.ts
/**
 * Currently, the front-end matches cinchCare orders back to the vehicle details using the VRM
 * So it is necessary for this VRM to match the stubs in __stubs__/order-states.ts
 * otherwise tests will break 😬
 */ const stubCompletedCinchCareOrder = {
    annualMileage: 12000,
    vehicleVrm: "YY66SYA",
    planNumber: "policy-id",
    price: 3499,
    startDate: "2021-01-01",
    coverLevel: "",
    modified: ""
};

;// CONCATENATED MODULE: ../../../libs/data/orders/src/index.ts





// Stubs for Testing




/***/ }),

/***/ 15993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_G": function() { return /* reexport */ constants; }
});

// UNUSED EXPORTS: ANY_ENGINE_SIZE, ANY_PRICE, Actions, BodyTypeEnum, COLOURS_SHOW_MORE_THRESHOLD, Context, DriveTypeEnum, EXCLUDE_ELECTRIC, Errors, FuelTypeEnum, QuoteType, StockType, TransmissionTypeEnum, UpdatedBy, VARIANTS_SHOW_MORE_THRESHOLD, bodyTypesData, caseInsensitiveMatch, coloursData, createOption, doorsData, driveTypeValueMappings, driveTypesData, engineSizeRangesData, featuresData, fuelTypesData, getCustomTagMessage, getMakeOptionsFromFacets, getModelOptionsFromFacets, getSearchAPIData, getSelectDefaultValue, getStoreDataFromAggregation, getStoreOptionsFromAggregation, getVariantOptionsFromFacets, mileageData, payFullRange, payMonthlyRange, seatsData, tagsData, transmissionTypeData

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/body-type-data.ts
const bodyTypesData = [
    {
        label: "Hatchback",
        value: "hatchback"
    },
    {
        label: "SUV",
        value: "suv"
    },
    {
        label: "Estate",
        value: "estate"
    },
    {
        label: "Saloon",
        value: "saloon"
    },
    {
        label: "Coupe",
        value: "coupe"
    },
    {
        label: "Convertible",
        value: "convertible"
    },
    {
        label: "MPV",
        value: "mpv"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/colour-data.ts
const coloursData = [
    {
        label: "Black",
        value: "black",
        hex: "#000000"
    },
    {
        label: "White",
        value: "white",
        hex: "#FFFFFF"
    },
    {
        label: "Grey",
        value: "grey",
        hex: "#808080"
    },
    {
        label: "Blue",
        value: "blue",
        hex: "#0000FF",
        facetKeys: [
            "turquoise"
        ]
    },
    {
        label: "Silver",
        value: "silver",
        hex: "#C0C0C0"
    },
    {
        label: "Red",
        value: "red",
        hex: "#FF0000",
        facetKeys: [
            "maroon"
        ]
    },
    {
        label: "Orange",
        value: "orange",
        hex: "#FFA500"
    },
    {
        label: "Green",
        value: "green",
        hex: "#00FF00"
    },
    {
        label: "Purple",
        value: "purple",
        hex: "#6A0DAD"
    },
    {
        label: "Yellow",
        value: "yellow",
        hex: "#FFFF00"
    },
    {
        label: "Beige",
        value: "beige",
        hex: "#F5F5DC",
        facetKeys: [
            "buff"
        ]
    },
    {
        label: "Bronze",
        value: "bronze",
        hex: "#CD7F32"
    },
    {
        label: "Brown",
        value: "brown",
        hex: "#964B00"
    },
    {
        label: "Cream",
        value: "cream",
        hex: "#FFFDD0",
        facetKeys: [
            "ivory"
        ]
    },
    {
        label: "Gold",
        value: "gold",
        hex: "#FFD700"
    },
    {
        label: "Pink",
        value: "pink",
        hex: "#FFC0CB"
    }
];
const COLOURS_SHOW_MORE_THRESHOLD = 7;

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/doors-data.ts
const doorsData = [
    {
        label: "2 doors",
        value: "2"
    },
    {
        label: "3 doors",
        value: "3"
    },
    {
        label: "4 doors",
        value: "4"
    },
    {
        label: "5 doors",
        value: "5"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/drive-type-data.ts
const driveTypesData = [
    {
        label: "Four-wheel drive",
        value: "four-wheel drive"
    },
    {
        label: "Front-wheel drive",
        value: "front-wheel drive"
    },
    {
        label: "Rear-wheel drive",
        value: "rear-wheel drive"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/engine-size-data.ts
const EXCLUDE_ELECTRIC = 2;
const ANY_ENGINE_SIZE = -1;
const engineSizeRangesData = [
    {
        label: "1.0 litre",
        min: EXCLUDE_ELECTRIC,
        max: 1049
    },
    {
        label: "1.2 litres",
        min: 1150,
        max: 1249
    },
    {
        label: "1.4 litres",
        min: 1350,
        max: 1449
    },
    {
        label: "1.6 litres",
        min: 1550,
        max: 1649
    },
    {
        label: "1.8 litres",
        min: 1750,
        max: 1849
    },
    {
        label: "2.0 litres",
        min: 1950,
        max: 2049
    },
    {
        label: "2.5 litres",
        min: 2450,
        max: 2549
    },
    {
        label: "3.0 litres",
        min: 2950,
        max: 3049
    },
    {
        label: "4.0 litres",
        min: 3950,
        max: 4049
    },
    {
        label: "5.0 litres",
        min: 4950,
        max: ANY_ENGINE_SIZE
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/features-data.ts
const featuresData = [
    {
        label: "Android Auto",
        value: "android auto"
    },
    {
        label: "Apple CarPlay",
        value: "apple carplay"
    },
    {
        label: "Bluetooth",
        value: "bluetooth"
    },
    {
        label: "Heated Seats",
        value: "heated seats"
    },
    {
        label: "Navigation",
        value: "navigation"
    },
    {
        label: "Parking Sensors",
        value: "parking sensors"
    },
    {
        label: "Sunroof",
        value: "sunroof"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/fuel-type-data.ts
const fuelTypesData = [
    {
        label: "Petrol",
        value: "petrol"
    },
    {
        label: "Diesel",
        value: "diesel"
    },
    {
        label: "Electric",
        value: "electric",
        facetKeys: [
            "electric range extender"
        ]
    },
    {
        label: "Plug-in Hybrid",
        value: "plug-in hybrid",
        facetKeys: [
            "petrol plug-in hybrid",
            "diesel plug-in hybrid"
        ]
    },
    {
        label: "Petrol Hybrid",
        value: "petrol hybrid"
    },
    {
        label: "Diesel Hybrid",
        value: "diesel hybrid"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/mileage-data.ts
const mileageData = [
    {
        label: "Up to 5,000 miles",
        value: 5000
    },
    {
        label: "Up to 10,000 miles",
        value: 10000
    },
    {
        label: "Up to 15,000 miles",
        value: 15000
    },
    {
        label: "Up to 20,000 miles",
        value: 20000
    },
    {
        label: "Up to 25,000 miles",
        value: 25000
    },
    {
        label: "Up to 30,000 miles",
        value: 30000
    },
    {
        label: "Up to 35,000 miles",
        value: 35000
    },
    {
        label: "Up to 40,000 miles",
        value: 40000
    },
    {
        label: "Up to 45,000 miles",
        value: 45000
    },
    {
        label: "Up to 50,000 miles",
        value: 50000
    },
    {
        label: "Up to 55,000 miles",
        value: 55000
    },
    {
        label: "Up to 60,000 miles",
        value: 60000
    },
    {
        label: "Up to 65,000 miles",
        value: 65000
    },
    {
        label: "Up to 70,000 miles",
        value: 70000
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/price-range-data.ts
const ANY_PRICE = (/* unused pure expression or super */ null && (-1));
const payFullRange = [
    {
        label: "\xa35,500",
        value: 5500,
        rangeKey: "5500-6000"
    },
    {
        label: "\xa36,000",
        value: 6000,
        rangeKey: "6000-6500"
    },
    {
        label: "\xa36,500",
        value: 6500,
        rangeKey: "6500-7000"
    },
    {
        label: "\xa37,000",
        value: 7000,
        rangeKey: "7000-7500"
    },
    {
        label: "\xa37,500",
        value: 7500,
        rangeKey: "7500-8000"
    },
    {
        label: "\xa38,000",
        value: 8000,
        rangeKey: "8000-8500"
    },
    {
        label: "\xa38,500",
        value: 8500,
        rangeKey: "8500-9000"
    },
    {
        label: "\xa39,000",
        value: 9000,
        rangeKey: "9000-9500"
    },
    {
        label: "\xa39,500",
        value: 9500,
        rangeKey: "9500-10000"
    },
    {
        label: "\xa310,000",
        value: 10000,
        rangeKey: "10000-11000"
    },
    {
        label: "\xa311,000",
        value: 11000,
        rangeKey: "11000-12000"
    },
    {
        label: "\xa312,000",
        value: 12000,
        rangeKey: "12000-13000"
    },
    {
        label: "\xa313,000",
        value: 13000,
        rangeKey: "13000-14000"
    },
    {
        label: "\xa314,000",
        value: 14000,
        rangeKey: "14000-15000"
    },
    {
        label: "\xa315,000",
        value: 15000,
        rangeKey: "15000-20000"
    },
    {
        label: "\xa320,000",
        value: 20000,
        rangeKey: "20000-25000"
    },
    {
        label: "\xa325,000",
        value: 25000,
        rangeKey: "25000-30000"
    },
    {
        label: "\xa330,000",
        value: 30000,
        rangeKey: "30000-40000"
    },
    {
        label: "\xa340,000",
        value: 40000,
        rangeKey: "40000-50000"
    },
    {
        label: "\xa350,000",
        value: 50000,
        rangeKey: "50000-*"
    }
];
const payMonthlyRange = [
    {
        label: "\xa350 p/m",
        value: 50,
        rangeKey: "50-100"
    },
    {
        label: "\xa3100 p/m",
        value: 100,
        rangeKey: "100-150"
    },
    {
        label: "\xa3150 p/m",
        value: 150,
        rangeKey: "150-200"
    },
    {
        label: "\xa3200 p/m",
        value: 200,
        rangeKey: "200-250"
    },
    {
        label: "\xa3250 p/m",
        value: 250,
        rangeKey: "250-300"
    },
    {
        label: "\xa3300 p/m",
        value: 300,
        rangeKey: "300-350"
    },
    {
        label: "\xa3350 p/m",
        value: 350,
        rangeKey: "350-400"
    },
    {
        label: "\xa3400 p/m",
        value: 400,
        rangeKey: "400-450"
    },
    {
        label: "\xa3450 p/m",
        value: 450,
        rangeKey: "450-500"
    },
    {
        label: "\xa3500 p/m",
        value: 500,
        rangeKey: "500-550"
    },
    {
        label: "\xa3550 p/m",
        value: 550,
        rangeKey: "550-600"
    },
    {
        label: "\xa3600 p/m",
        value: 600,
        rangeKey: "600-650"
    },
    {
        label: "\xa3650 p/m",
        value: 650,
        rangeKey: "650-700"
    },
    {
        label: "\xa3700 p/m",
        value: 700,
        rangeKey: "700-750"
    },
    {
        label: "\xa3750 p/m",
        value: 750,
        rangeKey: "750-800"
    },
    {
        label: "\xa3800 p/m",
        value: 800,
        rangeKey: "800-850"
    },
    {
        label: "\xa3850 p/m",
        value: 850,
        rangeKey: "850-900"
    },
    {
        label: "\xa3900 p/m",
        value: 900,
        rangeKey: "900-950"
    },
    {
        label: "\xa3950 p/m",
        value: 950,
        rangeKey: "950-*"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/seats-data.ts
const seatsData = [
    {
        label: "2 seats",
        value: "2"
    },
    {
        label: "4 seats",
        value: "4"
    },
    {
        label: "5 seats",
        value: "5"
    },
    {
        label: "6 seats",
        value: "6"
    },
    {
        label: "7 seats",
        value: "7"
    },
    {
        label: "8 seats",
        value: "8"
    },
    {
        label: "9 seats",
        value: "9"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/tags-data.ts
// TODO: lowercase this variable and import tags from ../../index
const tagsData = [
    {
        label: "Nearly new",
        value: "nearly-new"
    },
    {
        label: "Cars on offer",
        value: "cars-on-offer"
    },
    {
        label: "Deposit contribution",
        value: "deposit-contribution"
    }
];
const getCustomTagMessage = (label)=>{
    const customMessages = new Map([
        [
            "Cars on offer",
            "Only show discounted cars"
        ]
    ]);
    return customMessages.get(label) ?? label;
};

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/transmission-type-data.ts
const transmissionTypeData = [
    {
        label: "Automatic",
        value: "automatic",
        facetKeys: [
            "semi-auto",
            "automatic"
        ]
    },
    {
        label: "Manual",
        value: "manual"
    }
];

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/filters/index.ts















;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/data/drive-type-mappings.ts
const driveTypeValueMappings = new Map([
    [
        "four-wheel-drive",
        "four-wheel drive"
    ],
    [
        "rwd",
        "rear-wheel drive"
    ],
    [
        "fwd",
        "front-wheel drive"
    ]
]);

// EXTERNAL MODULE: ../../../libs/data/search/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9722);
;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/api-utils/api.ts

const getSearchAPIData = async ()=>{
    const response = await fetch(VEHICLE_SEARCH_URL).then((res)=>res.json());
    return response;
};

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/types/results.ts
const BodyTypeEnum = {
    Coupe: "COUPE",
    Estate: "ESTATE",
    Hatchback: "HATCHBACK",
    Saloon: "SALOON",
    Suv: "SUV"
};
const DriveTypeEnum = {
    FourWheelDrive: "Four-wheel drive",
    FrontWheelDrive: "Front-wheel drive",
    RearWheelDrive: "Rear-wheel drive"
};
const FuelTypeEnum = {
    Diesel: "Diesel",
    Electric: "Electric",
    Petrol: "Petrol",
    PetrolHybrid: "Petrol hybrid",
    PetrolPlugInHybrid: "Petrol plug-in hybrid"
};
const QuoteType = {
    HP: "hp",
    Pcp: "pcp"
};
const StockType = {
    Marketplace: "marketplace",
    PartnerSourced: "partner_sourced"
};
const TransmissionTypeEnum = {
    Automatic: "AUTOMATIC",
    Manual: "MANUAL"
};
const UpdatedBy = {
    FinanceQuoteComponentHPQuoteUpdated: "FinanceQuoteComponent.HPQuoteUpdated",
    FinanceQuoteComponentPCPQuoteUpdated: "FinanceQuoteComponent.PCPQuoteUpdated",
    MediaVehicleImageDataUpdated: "Media.vehicleImageDataUpdated",
    VehicleReservationsVehicleReserved: "VehicleReservations.VehicleReserved"
};

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/datadog/actions.ts
var Actions;
(function(Actions) {
    Actions["VEHICLE_CARD_CLICKED"] = "Vehicle Card Clicked";
    Actions["SEARCH_ALERTS_CTA_CLICKED"] = "Search alerts - CTA clicked - Open drawer";
    Actions["SEARCH_ALERTS_FORM_SUBMIT"] = "Search alerts - Form submitted";
    Actions["SEARCH_ALERTS_CTA_CLICKED_NO_RESULTS"] = "Search alerts - CTA clicked - No results open drawer";
    Actions["SEARCH_ZERO_VEHICLE_RESULTS"] = "Search - No vehicles returned";
    Actions["COMPARE_BAR_CTA_CLICKED"] = "Compare - Bar CTA clicked";
    Actions["COMPARE_VEHICLES_CTA_VEHICLE_ADDED"] = "Compare - Vehicles CTA vehicle added";
    Actions["COMPARE_VEHICLES_CTA_VEHICLE_REMOVED"] = "Compare - Vehicles CTA vehicle removed";
    Actions["COMPARE_SHOWING_MODAL"] = "Compare - Showing max vehicles modal";
    Actions["COMPARE_BAR_VEHICLE_REMOVED"] = "Compare - Compare Bar vehicle removed";
    Actions["COMPARE_BAR_LOAD_FROM_LOCAL_STORAGE"] = "Compare - Vehicles loaded from localStorage";
    Actions["SEARCH_PART_EX_CTA_CLICKED"] = "Search - Part Ex - CTA clicked";
    Actions["SEARCH_PART_EX_EDIT_VALUATION_CLICKED"] = "Search - Part Ex - Edit valuation clicked";
    Actions["SEARCH_FPA_VEHICLE_STALE_CACHE_DATA"] = "Search - Vehicle card showing stale cached data";
    Actions["SEARCH_SEO_POPULAR_LINKS"] = "Search - SEO - Popular links";
    Actions["SEARCH_FAQ_STORYBLOK_CLICK"] = "Search - Faq storyblok click";
    Actions["READ_MORE_SHOW_LESS_TOGGLE"] = "Read more / Show less toggle";
    Actions["SEARCH_FILTER_SELECTED"] = "Search - Filter selected";
    Actions["SEARCH_OUTRO_CONTENT"] = "Search - Buying guide";
    Actions["SEARCH_VALUE_PROPOSITIONS"] = "Search - Value propositions";
    Actions["SEARCH_FREE_TEXT_SEARCH"] = "Search - Free text search";
    Actions["SEARCH_RECENTLY_VIEWED_VEHICLES"] = "Search - Recently viewed vehicles";
    Actions["SEARCH_BEFORE_POPSTATE_NAVIGATION"] = "Search - Before popstate navigation";
    Actions["SEARCH_ALTERNATIVE_VEHICLES_CLICKED"] = "Search - Alternative vehicles clicked";
    Actions["CINCHAPP_POST_MESSAGE"] = "cinchapp: Webview postMessage sent";
    Actions["CLICK_MULTIPLE_NAV_IMAGE_BUTTON"] = "Multiple images - Image nav button clicked";
    Actions["VIEWED_MULTIPLE_VEHICLE_CARD_IMAGE"] = "Multiple images - Vehicle card image viewed";
    Actions["CLICK_MULTIPLE_VEHICLE_CARD_IMAGE"] = "Multiple images - Vehicle card image clicked";
    Actions["SEARCH_STORE_LOCATIONS_SHOW_ALL_CINCH_STORE_CARS_CLICKED"] = "Store locations - Store locations show all cinch store cars clicked";
    Actions["SEARCH_STORE_LOCATIONS_FIND_OUT_MORE_CLICKED"] = "Store locations - Store locations find out more clicked";
    Actions["SEARCH_STORE_LOCATIONS_HOME_DELIVERY_CLICKED"] = "Store locations - Store locations home delivery clicked";
    Actions["SEARCH_STORE_LOCATIONS_COLLECTION_CLICKED"] = "Store locations - Store locations collection clicked";
    Actions["SEARCH_STORE_LOCATIONS_MONEY_BACK_GUARANTEE_CLICKED"] = "Store locations - Store locations money back guarantee clicked";
    Actions["SEARCH_DYNAMIC_HEADER_GENERATED"] = "Dynamic header - Dynamic header length exceeds 37 characters";
})(Actions || (Actions = {}));

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/datadog/context.ts
var Context;
(function(Context) {
    Context["SEARCH_ALERTS_SERVICE"] = "search-alerts";
    Context["SEARCH_SUGGEST_SERVICE"] = "search-suggest";
    Context["SEARCH_SIMILAR_SERVICE"] = "search-similar";
    Context["SQUAD"] = "search";
    Context["COMPARE_SERVICE"] = "compare";
    Context["SEARCH_PART_EX_SERVICE"] = "search-part-exchange";
    Context["SEARCH_SEO_POPULAR_LINKS"] = "search-seo-popular-links";
    Context["SEARCH_FAQ_STORYBLOK_CONTENT"] = "search-storyblok-content-faq";
    Context["SEARCH_STORYBLOK_INTRO_CONTENT"] = "search-storyblok-content-intro";
    Context["SEARCH_OUTRO_CONTENT"] = "search-storyblok-content-outro";
    Context["SEARCH_FILTER_SELECTED"] = "search-filter-selected";
    Context["SEARCH_VALUE_PROPOSITIONS"] = "value-proposition-selected";
    Context["SEARCH_FREE_TEXT_SEARCH"] = "free-text-search";
    Context["SEARCH_RECENTLY_VIEWED_VEHICLES"] = "recently-viewed-vehicles";
    Context["SEARCH_ALTERNATIVE_VEHICLES"] = "alternative-vehicles";
    Context["CINCHAPP"] = "cinchapp";
    Context["SEARCH_MULTIPLE_IMAGES"] = "search-multiple-images";
    Context["SEARCH_AVAILABLE_TO_VIEW"] = "available-to-view";
    Context["SEARCH_DYNAMIC_HEADER"] = "dynamic-header";
})(Context || (Context = {}));

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/datadog/errors.ts
var Errors;
(function(Errors) {
    Errors["SEARCH_ALERTS_FETCH_ERROR_API_ERROR"] = "Search alerts - Fetch error - API error";
    Errors["SEARCH_RESULTS_API_ERROR"] = "Search Results - API error";
})(Errors || (Errors = {}));

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/datadog/index.ts




;// CONCATENATED MODULE: ../../../libs/data/search/src/index.ts
// data



// types




// datadog

// constants



/***/ }),

/***/ 9722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Eb": function() { return /* reexport */ VEHICLE_SEARCH_URL; }
});

// UNUSED EXPORTS: AFFILIATE_VEHICLES_URL, DEFAULT_PAGE_SIZE, DEFAULT_SORTING_CRITERIA, defaultFilters, defaultNonFilterParams, nonFilterParamKeys, searchFilterKeys, searchParamKeys, validUrlSegmentFilterKeys

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/constants/filters-constants.ts
const searchFilterKeys = [
    "bodyType",
    "colour",
    "seats",
    "doors",
    "fromEngineSize",
    "toEngineSize",
    "fuelType",
    "make",
    "model",
    "trim",
    "mileage",
    "fromPrice",
    "toPrice",
    "gearbox",
    "fromYear",
    "toYear",
    "driveType",
    "store",
    "tags",
    "features",
    "financeType"
];
const validUrlSegmentFilterKeys = (/* unused pure expression or super */ null && ([
    "bodyType",
    "colour",
    "seats",
    "doors",
    "fuelType",
    "make",
    "model",
    "trim",
    "gearbox",
    "driveType"
]));
const nonFilterParamKeys = [
    "sortingCriteria",
    "pageSize",
    "pageNumber",
    "useMonthly"
];
const searchParamKeys = [
    ...searchFilterKeys,
    ...nonFilterParamKeys
];
const defaultFilters = {
    make: [],
    model: [],
    trim: [],
    bodyType: [],
    colour: [],
    seats: [],
    doors: [],
    fromEngineSize: [],
    toEngineSize: [],
    fuelType: [],
    mileage: [],
    fromPrice: [],
    toPrice: [],
    gearbox: [],
    fromYear: [],
    toYear: [],
    driveType: [],
    store: [],
    tags: [],
    features: [],
    financeType: []
};
const DEFAULT_PAGE_SIZE = 32;
const DEFAULT_SORTING_CRITERIA = 3;
const defaultNonFilterParams = {
    sortingCriteria: DEFAULT_SORTING_CRITERIA,
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    useMonthly: false
};

// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/constants/endpoints.ts

const VEHICLE_SEARCH_URL = `${(0,src/* readFromEnv */.u)(src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles`;
const AFFILIATE_VEHICLES_URL = `${(0,src/* readFromEnv */.u)(src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/affiliate-vehicles`;

;// CONCATENATED MODULE: ../../../libs/data/search/src/lib/constants/index.ts




/***/ }),

/***/ 60782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fs": function() { return /* reexport */ BLOK_YOUTUBE; },
  "rx": function() { return /* reexport */ getLinks; },
  "OI": function() { return /* reexport */ getStoryBySlug; },
  "Vb": function() { return /* reexport */ getStoryblokImageServiceUrl; },
  "z9": function() { return /* reexport */ isYoutubeBlok; },
  "LF": function() { return /* reexport */ editable; },
  "BE": function() { return /* reexport */ storyblokImageLoader; },
  "f0": function() { return /* reexport */ storyblok_useStoryblokState; }
});

// UNUSED EXPORTS: ComponentNameMap, generateImageLoader, getAllStories, getDatasourceEntries, getStories, getTags

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var src = __webpack_require__(86634);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/util/api.ts

const STORYBLOK_BFF_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.StoryblokBFFComponent */.X.StoryblokBFFComponent)}`;

// EXTERNAL MODULE: ../../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(12093);
;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/types/schema.ts

const component = lib.z.object({
    _uid: lib.z.string(),
    _editable: lib.z.string().optional(),
    component: lib.z.string()
}, {
    description: "The Storyblok Component Type"
});
const SbAlternateData = lib.z.object({
    id: lib.z.number(),
    name: lib.z.string(),
    slug: lib.z.string(),
    published: lib.z.boolean(),
    full_slug: lib.z.string(),
    is_folder: lib.z.boolean(),
    parent_id: lib.z.number()
});
const TranslatedSlug = lib.z.object({
    path: lib.z.string(),
    name: lib.z.string().nullable(),
    lang: lib.z.string()
});
const schema_link = lib.z.object({
    id: lib.z.number(),
    slug: lib.z.string(),
    name: lib.z.string(),
    is_folder: lib.z.boolean(),
    parent_id: lib.z.number().nullable(),
    published: lib.z.boolean(),
    position: lib.z.number(),
    uuid: lib.z.string().uuid(),
    is_startpage: lib.z.boolean(),
    path: lib.z.string().nullable(),
    real_path: lib.z.string().nullable().optional()
});
const StoryblokStoryData = lib.z.object({
    alternates: lib.z.array(SbAlternateData),
    content: component.passthrough(),
    created_at: lib.z.string(),
    full_slug: lib.z.string(),
    group_id: lib.z.string(),
    id: lib.z.number(),
    is_startpage: lib.z.boolean(),
    meta_data: lib.z.any(),
    name: lib.z.string(),
    parent_id: lib.z.number().nullable(),
    position: lib.z.number(),
    published_at: lib.z.string().nullable(),
    first_published_at: lib.z.string().nullable(),
    slug: lib.z.string(),
    lang: lib.z.string(),
    translated_slugs: lib.z.array(TranslatedSlug).optional().nullable(),
    default_full_slug: lib.z.string().optional().nullable(),
    sort_by_date: lib.z.string().nullable(),
    tag_list: lib.z.array(lib.z.string()),
    uuid: lib.z.string(),
    path: lib.z.string().nullable().optional(),
    release_id: lib.z.string().nullable().optional()
});
const SLUG_REGEX_VALIDATION = new RegExp(/^(\w+-?\/?)+/, "gim");
const ensureInputIsNumber = (input)=>{
    const result = Number.parseInt(String(input), 10);
    if (Number.isNaN(result)) {
        return input;
    }
    return result;
};
const numericString = (...params)=>lib.z.preprocess(ensureInputIsNumber, lib.z.number(params[0]));
const version = lib.z.union([
    lib.z.literal("draft"),
    lib.z.literal("published")
]).optional();
const cv = numericString({
    invalid_type_error: "expected `cv` to be number"
}).optional();
const slug = ({ displayName ="slug"  })=>lib.z.string({
        required_error: `${displayName} is required`
    }).regex(SLUG_REGEX_VALIDATION, `expected ${displayName} to match 'some-slug' or 'some/slug'`);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/util/to-url-search-params.ts
const toUrlSearchParams = (params)=>{
    const urlParams = new URLSearchParams();
    Object.entries(params ?? {}).forEach(([key, value])=>{
        if (typeof value === "string") {
            urlParams.append(key, value);
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((nestedValue)=>{
                if (typeof nestedValue === "string") {
                    urlParams.append(key, nestedValue);
                } else {
                    urlParams.append(key, JSON.stringify(nestedValue));
                }
            });
            return;
        }
        urlParams.append(key, JSON.stringify(value));
    });
    return urlParams;
};

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-stories/schema.ts



const getStoriesParams = lib.z.object({
    starts_with: slug({
        displayName: "starts_with"
    }),
    version: version,
    cv: cv,
    sort_by: lib.z.string().optional(),
    per_page: numericString().optional(),
    page: numericString().optional(),
    with_tag: lib.z.string().optional()
});
const getStoriesUrlParams = getStoriesParams.transform(toUrlSearchParams);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-stories/get-stories.ts



async function getStoriesfn(params) {
    const urlParams = getStoriesUrlParams.parse(params);
    const url = `${STORYBLOK_BFF_URL}/get-all-stories?${urlParams.toString()}`;
    try {
        const request = await fetch(url);
        (0,src/* setTag */.YA)("request.url", url);
        (0,src/* setTag */.YA)("request.params", JSON.stringify(Object.fromEntries(urlParams.entries()), null, 2));
        (0,src/* setTag */.YA)("request.method", "GET");
        (0,src/* setTag */.YA)("request.status", request.status);
        (0,src/* setTag */.YA)("request.content-length", request.headers.get("content-length") ?? "0");
        if (request.status !== 200) {
            throw new Error(`${url} responded with non-OK response status ${request.status}`);
        }
        return request.json();
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,src/* tagError */.$k)(error);
        }
        if (error instanceof Error) {
            // eslint-disable-next-line unicorn/prefer-type-error
            throw new Error(`'get-all-stories' endpoint threw an error: ${error.message}`);
        }
        throw new Error(`'get-all-stories' endpoint threw an unknown error: ${error}`);
    }
}
const getStories = (0,src/* traceFunction */.KG)("storyblok.getStories", getStoriesfn);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-all-stories/get-all-stories.ts


const MAX_PER_PAGE = 100;
/**
 * Gets all of the stories based on the `starts_with` slug.
 * @param params
 * @returns {Promise<GetStoriesResponse<Content>[]>}
 */ async function getAllStoriesFn(params) {
    const requestParams = {
        ...params,
        page: 1,
        per_page: MAX_PER_PAGE
    };
    (0,src/* setTag */.YA)("getAllStories.request[0].params", requestParams);
    const initialRequest = await getStories(requestParams);
    const total = (initialRequest === null || initialRequest === void 0 ? void 0 : initialRequest.total) ?? 0;
    let stories = initialRequest.stories ?? [];
    const numberOfExtraRequests = Math.ceil(total / MAX_PER_PAGE) - 1;
    (0,src/* setTag */.YA)("getAllStories.requests.count", numberOfExtraRequests.toString());
    if (numberOfExtraRequests === 0) {
        return {
            total,
            stories
        };
    }
    const otherStories = await Promise.all(Array.from({
        length: numberOfExtraRequests
    }, (_val, idx)=>{
        const requestParams = {
            ...params,
            page: idx + 2,
            per_page: MAX_PER_PAGE
        };
        (0,src/* setTag */.YA)(`getAllStories.request[${idx + 1}].params`, requestParams);
        return getStories(requestParams);
    })).then((responses)=>{
        return responses.filter(Boolean).flatMap((res)=>{
            return res === null || res === void 0 ? void 0 : res.stories;
        });
    }).catch((error)=>{
        if (typeof error === "string" || error instanceof Error) {
            (0,src/* tagError */.$k)(error);
        }
        // rethrow the error so that the caller can handle it
        throw error;
    });
    stories = [
        ...new Set([
            ...stories,
            ...otherStories
        ])
    ];
    return {
        total,
        stories
    };
}
const getAllStories = (0,src/* traceFunction */.KG)("storyblok.getAllStories", getAllStoriesFn);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-story-by-slug/schema.ts



const getStoryBySlugParams = lib.z.object({
    version: version,
    cv: cv,
    sort_by: lib.z.string().optional(),
    per_page: numericString().optional(),
    page: numericString().optional(),
    with_tag: lib.z.string().optional(),
    resolve_relations: lib.z.string().optional()
}).optional();
const getStoryBySlugUrlParams = getStoryBySlugParams.transform(toUrlSearchParams);


;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-story-by-slug/get-story-by-slug.ts



const hasStoryblokStory = (input)=>{
    if (!input || !Object.prototype.hasOwnProperty.call(input, "story")) {
        return false;
    }
    return true;
};
async function getStoryBySlugFn(slug, params, options = {
    strict: true
}) {
    const urlParams = getStoryBySlugUrlParams.parse(params);
    urlParams.append("slug", slug);
    const url = `${STORYBLOK_BFF_URL}/story-by-slug?${urlParams.toString()}`;
    try {
        const request = await fetch(url);
        (0,src/* setTag */.YA)("request.url", url);
        (0,src/* setTag */.YA)("request.params", JSON.stringify(Object.fromEntries(urlParams.entries()), null, 2));
        (0,src/* setTag */.YA)("request.method", "GET");
        (0,src/* setTag */.YA)("request.status", request.status);
        (0,src/* setTag */.YA)("request.content-length", request.headers.get("content-length") ?? "0");
        const response = await request.json();
        if (!hasStoryblokStory(response)) {
            throw new Error("Story Response has no story property.");
        }
        return {
            ...response.story,
            rels: response.rels
        };
    } catch (error) {
        if (!options.strict) {
            return null;
        }
        if (error instanceof Error || typeof error === "string") {
            (0,src/* tagError */.$k)(error);
        }
        let errorMessage = error || "Unknown Error";
        if (error instanceof Error) {
            errorMessage = error.message;
        }
        throw new Error(`'story-by-slug' endpoint error
        Original Error: "${errorMessage}"
        Slug: "${slug}",
        Failing Url: "${url}"
    `);
    }
}
const getStoryBySlug = (0,src/* traceFunction */.KG)("storyblok.getStoryBySlug", getStoryBySlugFn);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-tags/get-tags.ts


const get_tags_STORYBLOK_BFF_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.StoryblokBFFComponent */.X.StoryblokBFFComponent)}`;
async function getTagsfn() {
    const params = new URLSearchParams({
        cv: Date.now().toString()
    });
    const url = `${get_tags_STORYBLOK_BFF_URL}/get-tags?${params.toString()}`;
    (0,src/* setTag */.YA)("request.url", url);
    try {
        const request = await fetch(url);
        (0,src/* setTag */.YA)("request.url", url);
        (0,src/* setTag */.YA)("request.params", Object.fromEntries(params.entries()));
        (0,src/* setTag */.YA)("request.method", "GET");
        (0,src/* setTag */.YA)("request.status", request.status);
        (0,src/* setTag */.YA)("request.content-length", request.headers.get("content-length") ?? "0");
        const data = await request.json();
        return data.tags;
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,src/* tagError */.$k)(error);
        }
        throw new Error("get tags endpoint not working");
    }
}
const getTags = (0,src/* traceFunction */.KG)("storyblok.getTags", getTagsfn);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-links/schema.ts

const carReviewsV2WithMake = lib.z.custom((val)=>{
    if (!isString(val) || !val.startsWith("car-reviews-v2/") || val.replace("car-reviews-v2/", "") === "") {
        return false;
    }
    return true;
});
const carReviewsV2WithMakeModel = lib.z.custom((val)=>{
    if (!isString(val)) {
        return false;
    }
    const [prefix, make, model] = val.split("/");
    if (prefix !== "car-reviews-v2" || !make || !model) {
        return false;
    }
    return true;
});
const isString = (input)=>typeof input === "string";
const acceptedLinkStarts = lib.z.union([
    lib.z.literal("categoriespages/makes"),
    lib.z.literal("categoriespages/models"),
    lib.z.literal("car-reviews/"),
    lib.z.literal("car-reviews-v2/"),
    carReviewsV2WithMake,
    carReviewsV2WithMakeModel,
    lib.z.literal("jargon"),
    lib.z.literal("articles/guides/ask-the-experts"),
    lib.z.literal("articles/guides/car-finance"),
    lib.z.literal("articles/guides/car-maintenance"),
    lib.z.literal("articles/guides/choosing-a-car"),
    lib.z.literal("articles/guides/electric-cars"),
    lib.z.literal("articles/guides/new-drivers"),
    lib.z.literal("articles/news"),
    lib.z.literal("articles/announcements/cinch-news"),
    lib.z.literal("articles/hubs"),
    lib.z.literal("seo-pages/electric-cars"),
    lib.z.literal("seo-pages/car-finance"),
    lib.z.literal("seo-pages/offers"),
    lib.z.literal("seo-pages/car-inspection/sub-pages"),
    lib.z.literal("seo-pages/car-inspection/index"),
    lib.z.literal("seo-pages/estate-cars/sub-pages"),
    lib.z.literal("seo-pages/estate-cars/index"),
    lib.z.literal("policies"),
    lib.z.literal("policies/modern-slavery-statement"),
    lib.z.literal("policies/modern-slavery-statement/statements"),
    lib.z.literal("car-care"),
    lib.z.literal("search")
]).optional();

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-links/get-links.ts



async function getLinksFn(startsWith, linksToPull = 10) {
    startsWith = acceptedLinkStarts.parse(startsWith);
    const rawParams = {
        cv: Date.now().toString(),
        version: "published"
    };
    if (startsWith) {
        rawParams["starts_with"] = startsWith;
    }
    if (linksToPull) {
        rawParams["per_page"] = linksToPull.toString();
    }
    const urlParams = new URLSearchParams(rawParams);
    const url = `${STORYBLOK_BFF_URL}/get-links?${urlParams.toString()}`;
    try {
        const request = await fetch(url);
        (0,src/* setTag */.YA)("request.url", url);
        (0,src/* setTag */.YA)("request.params", JSON.stringify(Object.fromEntries(urlParams.entries()), null, 2));
        (0,src/* setTag */.YA)("request.method", "GET");
        (0,src/* setTag */.YA)("request.status", request.status);
        (0,src/* setTag */.YA)("request.content-length", request.headers.get("content-length") ?? "0");
        const data = await request.json();
        if (Object.keys((data === null || data === void 0 ? void 0 : data.links) ?? {}).length === 0) return {};
        return data.links;
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,src/* tagError */.$k)(error);
        }
        throw new Error("links endpoint not working");
    }
}
const getLinks = (0,src/* traceFunction */.KG)("storyblok.getLinks", getLinksFn);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-datasource-entries/schema.ts


const getDatasourceEntriesParams = lib.z.object({
    cv: cv,
    datasource: lib.z.string(),
    dimension: lib.z.string().optional()
});
const datasourceEntry = lib.z.object({
    id: lib.z.number(),
    name: lib.z.string(),
    value: lib.z.string(),
    dimension_value: lib.z.string().nullable()
});
const getDatasourceEntriesResponse = lib.z.object({
    datasource_entries: lib.z.array(datasourceEntry)
});

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/api/get-datasource-entries/get-datasource-entries.ts




async function getDatasourceEntriesfn(params, { storyblokUrl =STORYBLOK_BFF_URL  } = {}) {
    const urlParams = getDatasourceEntriesParams.transform(toUrlSearchParams).parse(params);
    const url = `${storyblokUrl}/get-datasource-entries?${urlParams.toString()}`;
    try {
        const request = await fetch(url);
        (0,src/* setTag */.YA)("request.url", url);
        (0,src/* setTag */.YA)("request.params", JSON.stringify(Object.fromEntries(urlParams.entries()), null, 2));
        (0,src/* setTag */.YA)("request.method", "GET");
        (0,src/* setTag */.YA)("request.status", request.status);
        if (request.status !== 200) {
            throw new Error(`'get-datasource-entries' responded with non-OK response status ${request.status}`);
        }
        return getDatasourceEntriesResponse.parse(await request.json());
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,src/* tagError */.$k)(error);
        }
        if (error instanceof Error) {
            // eslint-disable-next-line unicorn/prefer-type-error
            throw new Error(`'get-datasource-entries' endpoint threw an error: ${error.message}`);
        }
        throw new Error(`'get-datasource-entries' endpoint threw an unknown error: ${error}`);
    }
}
const getDatasourceEntries = (0,src/* traceFunction */.KG)("storyblok.getDatasourceEntries", getDatasourceEntriesfn);

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var axios = __webpack_require__(43653);
;// CONCATENATED MODULE: ../../../node_modules/@storyblok/react/dist/storyblok-react.mjs
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};


var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp2(a2, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp2(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
let loaded = false;
const callbacks = (/* unused pure expression or super */ null && ([]));
const loadBridge = (src) => {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined")
      return;
    window.storyblokRegisterEvent = (cb) => {
      if (window.location === window.parent.location) {
        console.warn("You are not in Draft Mode or in the Visual Editor.");
        return;
      }
      if (!loaded)
        callbacks.push(cb);
      else
        cb();
    };
    if (document.getElementById("storyblok-javascript-bridge"))
      return;
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.id = "storyblok-javascript-bridge";
    script.onerror = (error) => reject(error);
    script.onload = (ev) => {
      callbacks.forEach((cb) => cb());
      loaded = true;
      resolve(ev);
    };
    document.getElementsByTagName("head")[0].appendChild(script);
  });
};
const pick = function(attrs, allowed) {
  if (!attrs) {
    return null;
  }
  let h2 = {};
  for (let key in attrs) {
    let value = attrs[key];
    if (allowed.indexOf(key) > -1 && value !== null) {
      h2[key] = value;
    }
  }
  return h2;
};
const isEmailLinkType = (type) => type === "email";
var defaultHtmlSerializer = {
  nodes: {
    horizontal_rule() {
      return {
        singleTag: "hr"
      };
    },
    blockquote() {
      return {
        tag: "blockquote"
      };
    },
    bullet_list() {
      return {
        tag: "ul"
      };
    },
    code_block(node) {
      return {
        tag: [
          "pre",
          {
            tag: "code",
            attrs: node.attrs
          }
        ]
      };
    },
    hard_break() {
      return {
        singleTag: "br"
      };
    },
    heading(node) {
      return {
        tag: `h${node.attrs.level}`
      };
    },
    image(node) {
      return {
        singleTag: [
          {
            tag: "img",
            attrs: pick(node.attrs, ["src", "alt", "title"])
          }
        ]
      };
    },
    list_item() {
      return {
        tag: "li"
      };
    },
    ordered_list() {
      return {
        tag: "ol"
      };
    },
    paragraph() {
      return {
        tag: "p"
      };
    }
  },
  marks: {
    bold() {
      return {
        tag: "b"
      };
    },
    strike() {
      return {
        tag: "strike"
      };
    },
    underline() {
      return {
        tag: "u"
      };
    },
    strong() {
      return {
        tag: "strong"
      };
    },
    code() {
      return {
        tag: "code"
      };
    },
    italic() {
      return {
        tag: "i"
      };
    },
    link(node) {
      const attrs = __spreadValues2({}, node.attrs);
      const { linktype = "url" } = node.attrs;
      if (isEmailLinkType(linktype)) {
        attrs.href = `mailto:${attrs.href}`;
      }
      if (attrs.anchor) {
        attrs.href = `${attrs.href}#${attrs.anchor}`;
        delete attrs.anchor;
      }
      return {
        tag: [
          {
            tag: "a",
            attrs
          }
        ]
      };
    },
    styled(node) {
      return {
        tag: [
          {
            tag: "span",
            attrs: node.attrs
          }
        ]
      };
    }
  }
};
const escapeHTML = function(string) {
  const htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  const reUnescapedHtml = /[&<>"']/g;
  const reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
  return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, (chr) => htmlEscapes[chr]) : string;
};
class RichTextResolver {
  constructor(schema) {
    if (!schema) {
      schema = defaultHtmlSerializer;
    }
    this.marks = schema.marks || [];
    this.nodes = schema.nodes || [];
  }
  addNode(key, schema) {
    this.nodes[key] = schema;
  }
  addMark(key, schema) {
    this.marks[key] = schema;
  }
  render(data = {}) {
    if (data.content && Array.isArray(data.content)) {
      let html = "";
      data.content.forEach((node) => {
        html += this.renderNode(node);
      });
      return html;
    }
    console.warn("The render method must receive an object with a content field, which is an array");
    return "";
  }
  renderNode(item) {
    let html = [];
    if (item.marks) {
      item.marks.forEach((m) => {
        const mark = this.getMatchingMark(m);
        if (mark) {
          html.push(this.renderOpeningTag(mark.tag));
        }
      });
    }
    const node = this.getMatchingNode(item);
    if (node && node.tag) {
      html.push(this.renderOpeningTag(node.tag));
    }
    if (item.content) {
      item.content.forEach((content) => {
        html.push(this.renderNode(content));
      });
    } else if (item.text) {
      html.push(escapeHTML(item.text));
    } else if (node && node.singleTag) {
      html.push(this.renderTag(node.singleTag, " /"));
    } else if (node && node.html) {
      html.push(node.html);
    }
    if (node && node.tag) {
      html.push(this.renderClosingTag(node.tag));
    }
    if (item.marks) {
      item.marks.slice(0).reverse().forEach((m) => {
        const mark = this.getMatchingMark(m);
        if (mark) {
          html.push(this.renderClosingTag(mark.tag));
        }
      });
    }
    return html.join("");
  }
  renderTag(tags, ending) {
    if (tags.constructor === String) {
      return `<${tags}${ending}>`;
    }
    const all = tags.map((tag) => {
      if (tag.constructor === String) {
        return `<${tag}${ending}>`;
      } else {
        let h2 = `<${tag.tag}`;
        if (tag.attrs) {
          for (let key in tag.attrs) {
            let value = tag.attrs[key];
            if (value !== null) {
              h2 += ` ${key}="${value}"`;
            }
          }
        }
        return `${h2}${ending}>`;
      }
    });
    return all.join("");
  }
  renderOpeningTag(tags) {
    return this.renderTag(tags, "");
  }
  renderClosingTag(tags) {
    if (tags.constructor === String) {
      return `</${tags}>`;
    }
    const all = tags.slice(0).reverse().map((tag) => {
      if (tag.constructor === String) {
        return `</${tag}>`;
      } else {
        return `</${tag.tag}>`;
      }
    });
    return all.join("");
  }
  getMatchingNode(item) {
    if (typeof this.nodes[item.type] !== "function") {
      return;
    }
    return this.nodes[item.type](item);
  }
  getMatchingMark(item) {
    if (typeof this.marks[item.type] !== "function") {
      return;
    }
    return this.marks[item.type](item);
  }
}
/*!
 * storyblok-js-client v4.5.2
 * Universal JavaScript SDK for Storyblok's API
 * (c) 2020-2022 Stobylok Team
 */
function t(e2) {
  return typeof e2 == "number" && (e2 == e2 && e2 !== 1 / 0 && e2 !== -1 / 0);
}
function s(e2, s2, r2) {
  if (!t(s2))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!t(r2))
    throw new TypeError("Expected `interval` to be a finite number");
  var i2 = [], n2 = [], o2 = 0, a2 = function() {
    o2++;
    var t2 = setTimeout(function() {
      o2--, i2.length > 0 && a2(), n2 = n2.filter(function(e3) {
        return e3 !== t2;
      });
    }, r2);
    n2.indexOf(t2) < 0 && n2.push(t2);
    var s3 = i2.shift();
    s3.resolve(e2.apply(s3.self, s3.args));
  }, l2 = function() {
    var e3 = arguments, t2 = this;
    return new Promise(function(r3, n3) {
      i2.push({ resolve: r3, reject: n3, args: e3, self: t2 }), o2 < s2 && a2();
    });
  };
  return l2.abort = function() {
    n2.forEach(clearTimeout), n2 = [], i2.forEach(function(e3) {
      e3.reject(new throttle.AbortError());
    }), i2.length = 0;
  }, l2;
}
s.AbortError = function() {
  Error.call(this, "Throttled function aborted"), this.name = "AbortError";
};
const r = function(e2, t2) {
  if (!e2)
    return null;
  let s2 = {};
  for (let r2 in e2) {
    let i2 = e2[r2];
    t2.indexOf(r2) > -1 && i2 !== null && (s2[r2] = i2);
  }
  return s2;
};
var i = { nodes: { horizontal_rule: () => ({ singleTag: "hr" }), blockquote: () => ({ tag: "blockquote" }), bullet_list: () => ({ tag: "ul" }), code_block: (e2) => ({ tag: ["pre", { tag: "code", attrs: e2.attrs }] }), hard_break: () => ({ singleTag: "br" }), heading: (e2) => ({ tag: `h${e2.attrs.level}` }), image: (e2) => ({ singleTag: [{ tag: "img", attrs: r(e2.attrs, ["src", "alt", "title"]) }] }), list_item: () => ({ tag: "li" }), ordered_list: () => ({ tag: "ol" }), paragraph: () => ({ tag: "p" }) }, marks: { bold: () => ({ tag: "b" }), strike: () => ({ tag: "strike" }), underline: () => ({ tag: "u" }), strong: () => ({ tag: "strong" }), code: () => ({ tag: "code" }), italic: () => ({ tag: "i" }), link(e2) {
  const t2 = __spreadValues2({}, e2.attrs), { linktype: s2 = "url" } = e2.attrs;
  return s2 === "email" && (t2.href = `mailto:${t2.href}`), t2.anchor && (t2.href = `${t2.href}#${t2.anchor}`, delete t2.anchor), { tag: [{ tag: "a", attrs: t2 }] };
}, styled: (e2) => ({ tag: [{ tag: "span", attrs: e2.attrs }] }) } };
class n {
  constructor(e2) {
    e2 || (e2 = i), this.marks = e2.marks || [], this.nodes = e2.nodes || [];
  }
  addNode(e2, t2) {
    this.nodes[e2] = t2;
  }
  addMark(e2, t2) {
    this.marks[e2] = t2;
  }
  render(e2 = {}) {
    if (e2.content && Array.isArray(e2.content)) {
      let t2 = "";
      return e2.content.forEach((e3) => {
        t2 += this.renderNode(e3);
      }), t2;
    }
    return console.warn("The render method must receive an object with a content field, which is an array"), "";
  }
  renderNode(e2) {
    let t2 = [];
    e2.marks && e2.marks.forEach((e3) => {
      const s3 = this.getMatchingMark(e3);
      s3 && t2.push(this.renderOpeningTag(s3.tag));
    });
    const s2 = this.getMatchingNode(e2);
    return s2 && s2.tag && t2.push(this.renderOpeningTag(s2.tag)), e2.content ? e2.content.forEach((e3) => {
      t2.push(this.renderNode(e3));
    }) : e2.text ? t2.push(function(e3) {
      const t3 = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, s3 = /[&<>"']/g, r2 = RegExp(s3.source);
      return e3 && r2.test(e3) ? e3.replace(s3, (e4) => t3[e4]) : e3;
    }(e2.text)) : s2 && s2.singleTag ? t2.push(this.renderTag(s2.singleTag, " /")) : s2 && s2.html && t2.push(s2.html), s2 && s2.tag && t2.push(this.renderClosingTag(s2.tag)), e2.marks && e2.marks.slice(0).reverse().forEach((e3) => {
      const s3 = this.getMatchingMark(e3);
      s3 && t2.push(this.renderClosingTag(s3.tag));
    }), t2.join("");
  }
  renderTag(e2, t2) {
    if (e2.constructor === String)
      return `<${e2}${t2}>`;
    return e2.map((e3) => {
      if (e3.constructor === String)
        return `<${e3}${t2}>`;
      {
        let s2 = `<${e3.tag}`;
        if (e3.attrs)
          for (let t3 in e3.attrs) {
            let r2 = e3.attrs[t3];
            r2 !== null && (s2 += ` ${t3}="${r2}"`);
          }
        return `${s2}${t2}>`;
      }
    }).join("");
  }
  renderOpeningTag(e2) {
    return this.renderTag(e2, "");
  }
  renderClosingTag(e2) {
    if (e2.constructor === String)
      return `</${e2}>`;
    return e2.slice(0).reverse().map((e3) => e3.constructor === String ? `</${e3}>` : `</${e3.tag}>`).join("");
  }
  getMatchingNode(e2) {
    if (typeof this.nodes[e2.type] == "function")
      return this.nodes[e2.type](e2);
  }
  getMatchingMark(e2) {
    if (typeof this.marks[e2.type] == "function")
      return this.marks[e2.type](e2);
  }
}
const o = (e2 = 0, t2 = e2) => {
  const s2 = Math.abs(t2 - e2) || 0, r2 = e2 < t2 ? 1 : -1;
  return ((e3 = 0, t3) => [...Array(e3)].map(t3))(s2, (t3, s3) => s3 * r2 + e2);
}, a = (e2, t2, s2) => {
  const r2 = [];
  for (const i2 in e2) {
    if (!Object.prototype.hasOwnProperty.call(e2, i2))
      continue;
    const n2 = e2[i2], o2 = s2 ? "" : encodeURIComponent(i2);
    let l2;
    l2 = typeof n2 == "object" ? a(n2, t2 ? t2 + encodeURIComponent("[" + o2 + "]") : o2, Array.isArray(n2)) : (t2 ? t2 + encodeURIComponent("[" + o2 + "]") : o2) + "=" + encodeURIComponent(n2), r2.push(l2);
  }
  return r2.join("&");
};
let l = {}, c = {};
class h {
  constructor(t2, r2) {
    if (!r2) {
      let e2 = t2.region ? `-${t2.region}` : "", s2 = t2.https === false ? "http" : "https";
      r2 = t2.oauthToken === void 0 ? `${s2}://api${e2}.storyblok.com/v2` : `${s2}://api${e2}.storyblok.com/v1`;
    }
    let i2 = Object.assign({}, t2.headers), o2 = 5;
    t2.oauthToken !== void 0 && (i2.Authorization = t2.oauthToken, o2 = 3), t2.rateLimit !== void 0 && (o2 = t2.rateLimit), this.richTextResolver = new n(t2.richTextSchema), typeof t2.componentResolver == "function" && this.setComponentResolver(t2.componentResolver), this.maxRetries = t2.maxRetries || 5, this.throttle = s(this.throttledRequest, o2, 1e3), this.accessToken = t2.accessToken, this.relations = {}, this.links = {}, this.cache = t2.cache || { clear: "manual" }, this.client = e.create({ baseURL: r2, timeout: t2.timeout || 0, headers: i2, proxy: t2.proxy || false }), t2.responseInterceptor && this.client.interceptors.response.use((e2) => t2.responseInterceptor(e2)), this.resolveNestedRelations = t2.resolveNestedRelations || true;
  }
  setComponentResolver(e2) {
    this.richTextResolver.addNode("blok", (t2) => {
      let s2 = "";
      return t2.attrs.body.forEach((t3) => {
        s2 += e2(t3.component, t3);
      }), { html: s2 };
    });
  }
  parseParams(e2 = {}) {
    return e2.version || (e2.version = "published"), e2.token || (e2.token = this.getToken()), e2.cv || (e2.cv = c[e2.token]), Array.isArray(e2.resolve_relations) && (e2.resolve_relations = e2.resolve_relations.join(",")), e2;
  }
  factoryParamOptions(e2, t2 = {}) {
    return ((e3 = "") => e3.indexOf("/cdn/") > -1)(e2) ? this.parseParams(t2) : t2;
  }
  makeRequest(e2, t2, s2, r2) {
    const i2 = this.factoryParamOptions(e2, ((e3 = {}, t3 = 25, s3 = 1) => __spreadProps(__spreadValues2({}, e3), { per_page: t3, page: s3 }))(t2, s2, r2));
    return this.cacheResponse(e2, i2);
  }
  get(e2, t2) {
    let s2 = `/${e2}`;
    const r2 = this.factoryParamOptions(s2, t2);
    return this.cacheResponse(s2, r2);
  }
  async getAll(e2, t2 = {}, s2) {
    const r2 = t2.per_page || 25, i2 = `/${e2}`, n2 = i2.split("/");
    s2 = s2 || n2[n2.length - 1];
    const a2 = await this.makeRequest(i2, t2, r2, 1), l2 = a2.total ? Math.ceil(a2.total / r2) : 1;
    return ((e3 = [], t3) => e3.map(t3).reduce((e4, t4) => [...e4, ...t4], []))([a2, ...await (async (e3 = [], t3) => Promise.all(e3.map(t3)))(o(1, l2), async (e3) => this.makeRequest(i2, t2, r2, e3 + 1))], (e3) => Object.values(e3.data[s2]));
  }
  post(e2, t2) {
    let s2 = `/${e2}`;
    return this.throttle("post", s2, t2);
  }
  put(e2, t2) {
    let s2 = `/${e2}`;
    return this.throttle("put", s2, t2);
  }
  delete(e2, t2) {
    let s2 = `/${e2}`;
    return this.throttle("delete", s2, t2);
  }
  getStories(e2) {
    return this.get("cdn/stories", e2);
  }
  getStory(e2, t2) {
    return this.get(`cdn/stories/${e2}`, t2);
  }
  setToken(e2) {
    this.accessToken = e2;
  }
  getToken() {
    return this.accessToken;
  }
  _cleanCopy(e2) {
    return JSON.parse(JSON.stringify(e2));
  }
  _insertLinks(e2, t2) {
    const s2 = e2[t2];
    s2 && s2.fieldtype == "multilink" && s2.linktype == "story" && typeof s2.id == "string" && this.links[s2.id] ? s2.story = this._cleanCopy(this.links[s2.id]) : s2 && s2.linktype === "story" && typeof s2.uuid == "string" && this.links[s2.uuid] && (s2.story = this._cleanCopy(this.links[s2.uuid]));
  }
  _insertRelations(e2, t2, s2) {
    if (s2.indexOf(e2.component + "." + t2) > -1) {
      if (typeof e2[t2] == "string")
        this.relations[e2[t2]] && (e2[t2] = this._cleanCopy(this.relations[e2[t2]]));
      else if (e2[t2].constructor === Array) {
        let s3 = [];
        e2[t2].forEach((e3) => {
          this.relations[e3] && s3.push(this._cleanCopy(this.relations[e3]));
        }), e2[t2] = s3;
      }
    }
  }
  _insertAssetsRelations(e2, t2) {
    t2.forEach((t3) => {
      e2.id === t3.id && (e2.original = t3, e2.original.filename = e2.filename, e2.original.filename = e2.original.filename.includes("https://s3.amazonaws.com/") ? e2.original.filename : e2.original.filename.replace("https://", "https://s3.amazonaws.com/"), delete e2.original.s3_filename);
    });
  }
  iterateTree(e2, t2) {
    let s2 = (e3) => {
      if (e3 != null) {
        if (e3.constructor === Array)
          for (let t3 = 0; t3 < e3.length; t3++)
            s2(e3[t3]);
        else if (e3.constructor === Object) {
          if (e3._stopResolving)
            return;
          for (let r2 in e3)
            e3.component && e3._uid || e3.type === "link" ? (this._insertRelations(e3, r2, t2), this._insertLinks(e3, r2)) : "id" in e3 && e3.fieldtype === "asset" && this._insertAssetsRelations(e3, t2), s2(e3[r2]);
        }
      }
    };
    s2(e2.content);
  }
  async resolveLinks(e2, t2) {
    let s2 = [];
    if (e2.link_uuids) {
      const r2 = e2.link_uuids.length;
      let i2 = [];
      const n2 = 50;
      for (let t3 = 0; t3 < r2; t3 += n2) {
        const s3 = Math.min(r2, t3 + n2);
        i2.push(e2.link_uuids.slice(t3, s3));
      }
      for (let e3 = 0; e3 < i2.length; e3++) {
        (await this.getStories({ per_page: n2, language: t2.language, version: t2.version, by_uuids: i2[e3].join(",") })).data.stories.forEach((e4) => {
          s2.push(e4);
        });
      }
    } else
      s2 = e2.links;
    s2.forEach((e3) => {
      this.links[e3.uuid] = __spreadProps(__spreadValues2({}, e3), { _stopResolving: true });
    });
  }
  async resolveRelations(e2, t2) {
    let s2 = [];
    if (e2.rel_uuids) {
      const r2 = e2.rel_uuids.length;
      let i2 = [];
      const n2 = 50;
      for (let t3 = 0; t3 < r2; t3 += n2) {
        const s3 = Math.min(r2, t3 + n2);
        i2.push(e2.rel_uuids.slice(t3, s3));
      }
      for (let e3 = 0; e3 < i2.length; e3++) {
        (await this.getStories({ per_page: n2, language: t2.language, version: t2.version, by_uuids: i2[e3].join(",") })).data.stories.forEach((e4) => {
          s2.push(e4);
        });
      }
    } else
      s2 = e2.rels;
    s2.forEach((e3) => {
      this.relations[e3.uuid] = __spreadProps(__spreadValues2({}, e3), { _stopResolving: true });
    });
  }
  async resolveStories(e2, t2) {
    let s2 = [];
    if (t2.resolve_relations !== void 0 && t2.resolve_relations.length > 0 && (e2.rels || e2.rel_uuids) && (s2 = t2.resolve_relations.split(","), await this.resolveRelations(e2, t2)), ["1", "story", "url"].indexOf(t2.resolve_links) > -1 && (e2.links || e2.link_uuids) && await this.resolveLinks(e2, t2), this.resolveNestedRelations)
      for (const e3 in this.relations)
        this.iterateTree(this.relations[e3], s2);
    e2.story ? this.iterateTree(e2.story, s2) : e2.stories.forEach((e3) => {
      this.iterateTree(e3, s2);
    });
  }
  resolveAssetsRelations(e2) {
    const { assets: t2, stories: s2, story: r2 } = e2;
    if (s2)
      for (const e3 of s2)
        this.iterateTree(e3, t2);
    else {
      if (!r2)
        return e2;
      this.iterateTree(r2, t2);
    }
  }
  cacheResponse(e2, t2, s2) {
    return s2 === void 0 && (s2 = 0), new Promise(async (r2, i2) => {
      let n2 = a({ url: e2, params: t2 }), o2 = this.cacheProvider();
      if (this.cache.clear === "auto" && t2.version === "draft" && await this.flushCache(), t2.version === "published" && e2 != "/cdn/spaces/me") {
        const e3 = await o2.get(n2);
        if (e3)
          return r2(e3);
      }
      try {
        let s3 = await this.throttle("get", e2, { params: t2, paramsSerializer: (e3) => a(e3) }), l3 = { data: s3.data, headers: s3.headers };
        if (l3.data.assets && l3.data.assets.length && this.resolveAssetsRelations(l3.data), l3 = Object.assign({}, l3, { perPage: s3.headers["per-page"] ? parseInt(s3.headers["per-page"]) : 0, total: s3.headers["per-page"] ? parseInt(s3.headers.total) : 0 }), s3.status != 200)
          return i2(s3);
        (l3.data.story || l3.data.stories) && await this.resolveStories(l3.data, t2), t2.version === "published" && e2 != "/cdn/spaces/me" && o2.set(n2, l3), l3.data.cv && (t2.version == "draft" && c[t2.token] != l3.data.cv && this.flushCache(), c[t2.token] = l3.data.cv), r2(l3);
      } catch (n3) {
        if (n3.response && n3.response.status === 429 && (s2 += 1) < this.maxRetries)
          return console.log(`Hit rate limit. Retrying in ${s2} seconds.`), await (l2 = 1e3 * s2, new Promise((e3) => setTimeout(e3, l2))), this.cacheResponse(e2, t2, s2).then(r2).catch(i2);
        i2(n3);
      }
      var l2;
    });
  }
  throttledRequest(e2, t2, s2) {
    return this.client[e2](t2, s2);
  }
  cacheVersions() {
    return c;
  }
  cacheVersion() {
    return c[this.accessToken];
  }
  setCacheVersion(e2) {
    this.accessToken && (c[this.accessToken] = e2);
  }
  cacheProvider() {
    return this.cache.type === "memory" ? { get: (e2) => l[e2], getAll: () => l, set(e2, t2) {
      l[e2] = t2;
    }, flush() {
      l = {};
    } } : { get() {
    }, getAll() {
    }, set() {
    }, flush() {
    } };
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this;
  }
}
const apiFactory = (options = {}) => {
  const { apiOptions } = options;
  if (!apiOptions.accessToken) {
    console.error("You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication");
    return;
  }
  const storyblokApi = new h(apiOptions);
  return { storyblokApi };
};
var editable = (blok) => {
  if (typeof blok !== "object" || typeof blok._editable === "undefined") {
    return {};
  }
  const options = JSON.parse(blok._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
  return {
    "data-blok-c": JSON.stringify(options),
    "data-blok-uid": options.id + "-" + options.uid
  };
};
let richTextResolver;
const bridgeLatest = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const useStoryblokBridge = (id, cb, options = {}) => {
  if (typeof window === "undefined") {
    return;
  }
  if (typeof window.storyblokRegisterEvent === "undefined") {
    console.error("Storyblok Bridge is disabled. Please enable it to use it. Read https://github.com/storyblok/storyblok-js");
    return;
  }
  if (!id) {
    console.warn("Story ID is not defined. Please provide a valid ID.");
    return;
  }
  window.storyblokRegisterEvent(() => {
    const sbBridge = new window.StoryblokBridge(options);
    sbBridge.on(["input", "published", "change"], (event) => {
      if (event.action === "input" && event.story.id === id) {
        cb(event.story);
      } else if ((event.action === "change" || event.action === "published") && event.storyId === id) {
        window.location.reload();
      }
    });
  });
};
const storyblokInit$1 = (pluginOptions = {}) => {
  const {
    bridge,
    accessToken,
    use = [],
    apiOptions = {},
    richText = {}
  } = pluginOptions;
  apiOptions.accessToken = apiOptions.accessToken || accessToken;
  const options = { bridge, apiOptions };
  let result = {};
  use.forEach((pluginFactory) => {
    result = __spreadValues2(__spreadValues2({}, result), pluginFactory(options));
  });
  if (bridge !== false) {
    loadBridge(bridgeLatest);
  }
  richTextResolver = new RichTextResolver(richText.schema);
  if (richText.resolver) {
    setComponentResolver(richTextResolver, richText.resolver);
  }
  return result;
};
const setComponentResolver = (resolver, resolveFn) => {
  resolver.addNode("blok", (node) => {
    let html = "";
    node.attrs.body.forEach((blok) => {
      html += resolveFn(blok.component, blok);
    });
    return {
      html
    };
  });
};
const renderRichText = (data, options, resolverInstance) => {
  let localResolver = resolverInstance || richTextResolver;
  if (!localResolver) {
    console.error("Please initialize the Storyblok SDK before calling the renderRichText function");
    return;
  }
  if (data === "") {
    return "";
  } else if (!data) {
    console.warn(`${data} is not a valid Richtext object. This might be because the value of the richtext field is empty.
    
  For more info about the richtext object check https://github.com/storyblok/storyblok-js#rendering-rich-text`);
    return "";
  }
  if (options) {
    localResolver = new RichTextResolver(options.schema);
    if (options.resolver) {
      setComponentResolver(localResolver, options.resolver);
    }
  }
  return localResolver.render(data);
};
const StoryblokComponent = (0,react.forwardRef)((_a, ref) => {
  var _b = _a, { blok } = _b, restProps = __objRest(_b, ["blok"]);
  if (!blok) {
    console.error("Please provide a 'blok' property to the StoryblokComponent");
    return /* @__PURE__ */ react.createElement("div", null, "Please provide a blok property to the StoryblokComponent");
  }
  const Component = getComponent(blok.component);
  if (Component) {
    return /* @__PURE__ */ react.createElement(Component, __spreadValues({
      ref,
      blok
    }, restProps));
  }
  return /* @__PURE__ */ react.createElement("div", null);
});
StoryblokComponent.displayName = "StoryblokComponent";
const useStoryblok = (slug, apiOptions = {}, bridgeOptions = {}) => {
  let [story, setStory] = useState({});
  if (!storyblokApiInstance) {
    console.error("You can't use useStoryblok if you're not loading apiPlugin.");
    return null;
  }
  useStoryblokBridge(story.id, (story2) => setStory(story2), bridgeOptions);
  useEffect(() => {
    async function fetchData() {
      const { data } = await storyblokApiInstance.get(`cdn/stories/${slug}`, apiOptions);
      setStory(data.story);
    }
    fetchData();
  }, [slug]);
  return story;
};
const useStoryblokState = (initialStory = {}, bridgeOptions = {}, preview = true) => {
  let [story, setStory] = (0,react.useState)(initialStory);
  if (!preview) {
    return initialStory;
  }
  (0,react.useEffect)(() => {
    useStoryblokBridge(story.id, (newStory) => setStory(newStory), bridgeOptions);
    setStory(initialStory);
  }, [initialStory]);
  return story;
};
let storyblokApiInstance = null;
const useStoryblokApi = () => {
  if (!storyblokApiInstance) {
    console.error("You can't use getStoryblokApi if you're not loading apiPlugin.");
  }
  return storyblokApiInstance;
};
let componentsMap = {};
const getComponent = (componentKey) => {
  if (!componentsMap[componentKey]) {
    console.error(`Component ${componentKey} doesn't exist.`);
    return false;
  }
  return componentsMap[componentKey];
};
const storyblokInit = (pluginOptions = {}) => {
  const { storyblokApi } = storyblokInit$1(pluginOptions);
  storyblokApiInstance = storyblokApi;
  componentsMap = pluginOptions.components;
};


;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/util/storyblok.ts


const storyblok_useStoryblokState = ({ story , options , enableBridge =false  })=>useStoryblokState(story, options, enableBridge);

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/util/storyblok-image-loader.ts
/**
 * Generates the URL for the Storyblok image service based on the provided parameters.
 * @param src - The source URL of the image.
 * @param options - The options for generating the image URL.
 * @returns The generated URL for the Storyblok image service.
 * @example
 *
 * const optimisedUrl = getStoryblokImageServiceUrl(
 * 'https://a.storyblok.com/f/39865/2000x1500/3e3e3e3e3e/image.jpg',
 * {
 *   width: 150,
 *   height: 0,
 *   filters: [{ quality: 80 }, { format: 'png' }],
 * })
 *
 */ function getStoryblokImageServiceUrl(src, options) {
    const { width =0 , height =0 , filters =[] , useSmartCrop =false , fitIn , flipX =false , flipY =false  } = options || {};
    ensureStoryblokURL(src);
    const url = [
        src,
        "m"
    ] // this enables the optimised image service
    ;
    const parsedFilters = filterToUrlPath(filters);
    if (width && !fitIn) {
        let size = `${flipX ? "-" : ""}${width}`;
        size += height ? `x${flipY ? "-" : ""}${height}` : `x${flipY ? "-" : ""}0`;
        url.push(size);
    }
    if (!width && height && !fitIn) {
        url.push(`${flipX ? "-" : ""}0x${flipY ? "-" : ""}${height}`);
    }
    if (useSmartCrop) {
        if (!width || !height) {
            console.warn("cropping requires both width and height.");
        }
        url.push("smart");
    }
    if (fitIn) {
        if (flipX || flipY || useSmartCrop) {
            console.warn("fitIn wont work with smart crop / flipping");
        }
        url.push(`fit-in/${fitIn.width}x${fitIn.height}`);
    }
    if (parsedFilters) {
        url.push(`filters:${parsedFilters}`);
    }
    return url[url.length - 1] === "m" ? url.join("/") + "/" : url.join("/");
}
/**
 * A simple image loader function that generates the URL for a Storyblok image.
 * @param src - The source URL of the image.
 * @param width - The desired width of the image. Defaults to 0.
 * @param quality - The desired quality of the image. Defaults to 75.
 * @returns The URL of the image with the specified options applied.
 */ function storyblokImageLoader({ src , width =0 , quality =75  }) {
    return getStoryblokImageServiceUrl(src, {
        width,
        filters: [
            {
                quality
            }
        ]
    });
}
/**
 * a more advanced image loader function that allows for more customisation of the image URL.
 * @param options - The options for generating the image loader.
 * @returns The image loader function.
 */ function generateImageLoader({ widthOverride =0 , height =0 , filters =[] , useSmartCrop =false  }) {
    return ({ src , width =0 , quality =75  })=>getStoryblokImageServiceUrl(src, {
            width: widthOverride || width,
            height,
            filters: [
                {
                    quality
                },
                ...filters
            ],
            useSmartCrop
        });
}
function filterToUrlPath(filters) {
    const data = filters.map((filter)=>{
        if (!filter) {
            return "";
        }
        if ("fill" in filter) {
            return `fill(${filter.fill})`;
        } else if ("grayscale" in filter) {
            return filter.grayscale ? `grayscale()` : "";
        } else if ("blur" in filter) {
            if (filter.blur.length === 1) {
                return `blur(${minMax(filter.blur[0], 0, 100)})`;
            }
            return `blur(${minMax(filter.blur[0], 0, 100)},${filter.blur[1]})`;
        } else if ("rotate" in filter) {
            return `rotate(${filter.rotate})`;
        } else if ("brightness" in filter) {
            return `brightness(${minMax(filter.brightness, 0, 100)})`;
        } else if ("format" in filter) {
            return `format(${filter.format})`;
        } else if ("focal" in filter) {
            return `focal(${filter.focal[0]}x${filter.focal[1]}:${filter.focal[2]}x${filter.focal[3]})`;
        } else if ("quality" in filter) {
            return `quality(${minMax(filter.quality, 0, 100)})`;
        } else {
            return "";
        }
    }).filter((filter)=>filter !== "").join(":");
    return data ? data : "";
}
function minMax(value, min, max) {
    if (value === null || value === undefined || min === null || min === undefined || max === null || max === undefined) {
        throw new Error(`minMax: Invalid parameters, expected: value :number, min :number, max :number, received: value ${value}, min ${min}, max ${max}`);
    }
    return Math.min(Math.max(value, min), max);
}
function ensureStoryblokURL(url) {
    const storyblokUrl = new URL(url);
    if (storyblokUrl.host !== "a.storyblok.com") {
        throw new Error("Storyblok Image optimisation only works with storyblok hosted images.");
    }
}

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/types/components.ts
const ComponentNameMap = {
    Button: "Button",
    /**
   * Categories
   */ CategoriesMakePage: "CategoriesMakePage",
    CategoriesModelPage: "CategoriesModelPage",
    MakeModelHero: "MakeModelHero",
    MakeModelTeaser: "MakeModelTeaser",
    MakeModelAllModelsSection: "MakeModelAllModelsSection",
    MakeModelLink: "MakeModelLink",
    MakePopularModelsSection: "MakePopularModelsSection",
    MakePopularModel: "MakePopularModel",
    ModelBodyShapesSection: "ModelBodyShapesSection",
    ModelBodyShapes: "ModelBodyShapes",
    MakeModelCarReviewsSection: "MakeModelCarReviewsSection",
    FaqSection: "FaqSection",
    AccordionItem: "AccordionItem",
    ModelAllVariants: "ModelAllVariants",
    Text: "Text",
    ModelImageGallery: "ModelImageGallery",
    Image: "Image",
    Link: "Link",
    GenericHero: "GenericHero",
    GenericQuote: "GenericQuote",
    GenericTeaser: "GenericTeaser",
    JargonPage: "JargonPage",
    CTA: "CTA",
    FaqAccordion: "FaqAccordion",
    OpenGraph: "OpenGraph",
    TwitterCard: "TwitterCard",
    SEO: "SEO",
    CarMakeCard: "CarMakeCard",
    CarReviewCard: "CarReviewCard",
    CarTypeCard: "CarTypeCard",
    PerfectForCard: "PerfectForCard",
    Grid: "grid",
    Heading: "Heading",
    CarReviewTemplate: "CarReviewTemplate",
    CarReviewTemplateV2: "CarReviewTemplateV2",
    ReviewSection: "ReviewSection",
    ModelLookInsideSection: "ModelLookInsideSection",
    YoutubeVideo: "YoutubeVideo",
    ContentSection: "ContentSection",
    StatsSection: "StatsSection",
    StatsBlock: "StatsBlock",
    TrustPilotQuote: "TrustPilotQuote",
    ArticleTemplate: "ArticleTemplate",
    ArticlesSubHubPage: "ArticlesSubHubPage",
    ArticleBody: "Body",
    GuidesHubPage: "GuidesHubPage",
    ReviewHubPage: "ReviewHubPage",
    /**
   * About Us
   */ AboutUsPage: "AboutUsPage",
    AboutUsDeliverySection: "AboutUsDeliverySection",
    AboutUsCareers: "AboutUsCareers",
    AboutUsConstellation: "AboutUsConstellation",
    AboutUsPartnershipSection: "AboutUsPartnershipSection",
    /**
   * Electric Cars
   */ ElectricCarsTemplate: "ElectricCarsTemplate",
    /**
   * Customer Reviews
   */ CustomerReviewsTemplate: "CustomerReviewsTemplate",
    /**
   * Car Finance
   */ CarFinanceHero: "CarFinanceHero",
    /**
   * Support
   */ SupportPage: "SupportPage",
    /**
   * Partnerships
   */ PartnershipPage: "PartnershipPage",
    PartnershipsIntro: "PartnershipsIntro",
    PartnershipsPartnerOverviewList: "PartnershipsPartnerOverviewList",
    PartnershipsPartnerOverview: "PartnershipsPartnerOverview",
    /**
   * SEO
   */ SEOPageTemplate: "SEOPageTemplate",
    LatestCarsSection: "LatestCarsSection",
    MakesandModelLinks: "MakesandModelLinks",
    TextSection: "TextSection",
    LinksSection: "LinksSection",
    TextInlineImage: "TextInlineImage",
    Table: "Table",
    /**
   * Widest Range Claim
   */ WidestRangePage: "WidestRangePage",
    /**
   * Policy Pages
   */ TermsOfUsePage: "TermsOfUsePage",
    PolicyPage: "PolicyPage",
    ClauseSection: "ClauseSection",
    CookiePolicySection: "CookiePolicySection",
    TableSection: "TableSection",
    DeleteCookiesSection: "DeleteCookiesSection",
    DeleteCookiesInstructions: "DeleteCookiesInstructions",
    ClauseRichTextSection: "ClauseRichTextSection",
    /**
   * Cinch Commitment
   */ CinchCommitmentPage: "CinchCommitmentPage",
    IntroSection: "GenericContentWithImageSection",
    HelpMeChooseSection: "HelpMeChooseCTASection",
    PreFooterCTASection: "PrefooterCTA",
    ContentWithIconsSection: "ContentWithIconSection",
    ContentWithIcon: "ContentWithIconItem",
    /**
   * Home Page
   */ HomePage: "HomePage",
    HomeHero: "HomeHero",
    HomeHeroV2: "HomeHeroV2",
    ValuePropsCard: "ValuePropsCard",
    HelpMeChoose: "HelpMeChooseSection",
    WhyCinchSection: "WhyCinchSection",
    WhyCinchCard: "WhyCinchCard",
    PartExSection: "PartExSection",
    HomeUspSlide: "HomeUspSlide",
    LinkWithText: "LinkWithText",
    HeroV2PartExchange: "HeroV2PartExchange",
    /**
   * Store pages
   */ StoreInformationPage: "StoreInformationPage",
    StoreHero: "StoreHero",
    MapInformation: "MapInformation",
    StoreHowCinchWorksComponent: "StoreHowCinchWorksComponent",
    TitleAndRichText: "TitleAndRichText",
    HowCinchWorksListItem: "HowCinchWorksListItem",
    OpeningHoursListItem: "OpeningHoursListItem",
    StoreWhyBuy: "StoreWhyBuy",
    Address: "Address",
    /**
   * Store Hub
   */ FullWidthCta: "FullWidthCta",
    StoreHubTemplate: "StoreHubTemplate",
    FindStoreCard: "FindStoreCard",
    FindStoreSection: "FindStoreSection",
    /**
   * Shared
   */ RichTextSection: "RichTextSection",
    FeatureSection: "FeatureSection",
    FeatureCard: "FeatureCard",
    /**
   * VAPs
   */ VapsCarCarePage: "VapsCarCarePage",
    VapsHero: "VapsHero",
    VapsText: "VapsText",
    Aftercare: "Aftercare",
    Lifeshine: "Lifeshine",
    LifeshineSlide: "LifeshineSlide",
    FeatureImageCardSection: "FeatureImageCardSection",
    FeatureImageCard: "FeatureImageCard",
    PeaceOfMind: "PeaceOfMind",
    VapsTrustPilotQuote: "VapsTrustPilotQuote",
    VapsFaqAccordion: "VapsFaqAccordion",
    TextInlineImageSection: "TextInlineImageSection",
    TextInlineImageCard: "TextInlineImageCard",
    FeatureIconCardSection: "FeatureIconCardSection",
    VerticalStepsSection: "VerticalStepsSection",
    DownloadApp: "DownloadApp",
    FinanceExample: "FinanceExample",
    FeaturedEVsCarousel: "FeaturedEVsCarousel",
    HowToGetCinchCharge: "HowToGetCinchCharge",
    /**
   * App Landing page
   */ AppLandingPage: "AppLandingPage",
    /**
   * Testing Utils
   */ MockComponent: "MockComponent",
    MockComponentWithProps: "MockComponentWithProps",
    UnsubscribeContent: "UnsubscribeContent",
    /** Search */ SearchPage: "SearchPage",
    SearchPageCopy: "SearchPageCopy",
    SearchFaqSection: "SearchFaqSection",
    SearchAccordionItem: "SearchAccordionItem"
};

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/lib/bloks/youtube.ts
const BLOK_YOUTUBE = "YoutubeVideo";
const isYoutubeBlok = (props)=>Object.prototype.hasOwnProperty.call(props, "videoId") && Object.prototype.hasOwnProperty.call(props, "title") && Object.prototype.hasOwnProperty.call(props, "buttonLabel");

;// CONCATENATED MODULE: ../../../libs/data/storyblok/src/index.ts
// API






// Utils



// Blok Definitions.



/***/ }),

/***/ 99649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jh": function() { return /* reexport */ get_reviews_getTrustpilotReviews; },
  "Ji": function() { return /* reexport */ useTrustpilotReviewCount; },
  "b6": function() { return /* reexport */ useTrustpilotScore; }
});

// UNUSED EXPORTS: TrustpilotScoreContext, getTrustpilotReviews, useTrustpilotReviews, useTrustpilotScoreContext

// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(12093);
;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/api/get-reviews.ts


const Review = lib.z.object({
    starRating: lib.z.number(),
    title: lib.z.string(),
    description: lib.z.string(),
    customerName: lib.z.string(),
    date: lib.z.string().datetime(),
    link: lib.z.string().url()
});
const TrustpilotReviewsResponse = lib.z.object({
    trustScore: lib.z.number(),
    stars: lib.z.number(),
    total: lib.z.number(),
    starRatingLabel: lib.z.string(),
    reviews: lib.z.array(Review).min(3).max(3)
});
const fallbackResponse = {
    trustScore: 4.3,
    total: 35663,
    stars: 4.5,
    starRatingLabel: "Excellent",
    reviews: [
        {
            starRating: 5,
            title: "Everything is so easy and…",
            description: `Everything is so easy and straightforward to do and buying a car has never been so easy and stress free because of cinch’s 14 day returns and six month warranty and our delivery guy lucian stoica (lucs thank you)was a really nice bloke and went through the car with us and answered any questions we had.Couldn’t have gone any better definitely the new way to buy a car.Well done cinch.`,
            customerName: "Mark Perry",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "So pleased with the service people…",
            description: `So pleased with the service people should cinch it great experience throughout ,professional.
        The only downside for me was the £99 admin fee especially because I sent my first car back within 14 days because I changed my mind, it should be wavered 2nd time.
        I am so pleases with my new car now, thank you so much`,
            customerName: "Lisa Shelley",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "This has been an amazing experience",
            description: `This has been an amazing experience! So straightforward, well looked after every step of the way, including a welcome video from the finance company via cinch. Viru delivered the car and was simply charming 😊 I would definitely recommend buying through cinch, thanks everyone! 👏👍👏`,
            customerName: "K from London",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        }
    ]
};
async function get_reviews_getTrustpilotReviews() {
    try {
        const url = `${(0,src/* readFromEnv */.u)("TRUSTPILOT_URL")}/trustpilot-get-reviews`;
        const response = await fetch(url);
        return TrustpilotReviewsResponse.parse(await response.json());
    } catch (error) {
        console.error(error);
        return fallbackResponse;
    }
}

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-reviews.ts



function useTrustpilotReviews() {
    const [trustpilotData, setTrustpilotData] = useState();
    useEffect(()=>{
        getTrustpilotReviews().then((data)=>{
            const formattedData = {
                ...data,
                reviews: data.reviews.map((review)=>({
                        ...review,
                        description: truncateContent(review.description),
                        date: formatDate(review.date)
                    }))
            };
            setTrustpilotData(formattedData);
        });
    }, []);
    return trustpilotData;
}
/* harmony default export */ var use_trustpilot_reviews = ((/* unused pure expression or super */ null && (useTrustpilotReviews)));
/***
 * Truncates the provided str to the desiredLength.
 * @param {string} inputString - the string we want to truncate.
 * @param {number} desiredLength - the Desired Maximum length. defaults to 135.
 *
 */ function truncateContent(inputString, desiredLength = 135) {
    return inputString.length > desiredLength ? [
        ...inputString.slice(0, desiredLength),
        "..."
    ].join("") : inputString;
}
/**
 * Formats the provided date.
 * @param {string} date | the Date string to be formatted.
 * @returns the formatted string.
 */ function formatDate(date) {
    try {
        return format(parseISO(date), "d MMMM yyyy");
    } catch  {
        // RangeError: Invalid time value
        // Return existing value
        return date;
    }
}

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-score-context.ts

const defaultValues = {
    starRatingLabel: "Excellent",
    totalReviews: 10000,
    starRating: 4.5
};
const TrustpilotScoreContext = (0,react.createContext)(defaultValues);
function useTrustpilotScoreContext() {
    const context = useContext(TrustpilotScoreContext);
    if (context === undefined) {
        throw new Error("useTrustpilotScore must be used within a provider");
    }
    return context;
}

// EXTERNAL MODULE: ../../../node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(24126);
// EXTERNAL MODULE: ../../../node_modules/swr/_internal/dist/index.mjs
var _internal_dist = __webpack_require__(20056);
;// CONCATENATED MODULE: ../../../node_modules/swr/immutable/dist/index.mjs



const immutable = (useSWRNext)=>(key, fetcher, config)=>{
        // Always override all revalidate options.
        config.revalidateOnFocus = false;
        config.revalidateIfStale = false;
        config.revalidateOnReconnect = false;
        return useSWRNext(key, fetcher, config);
    };
const useSWRImmutable = (0,_internal_dist/* withMiddleware */.xD)(dist/* default */.ZP, immutable);



// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var axios = __webpack_require__(43653);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-review-count.ts




const httpClient = axios_default().create();
const fetcher = async (url)=>await httpClient.get(url).then((res)=>TrustpilotReviewsResponse.parse(res.data));
const useTrustpilotReviewCount = ()=>{
    const TRUSTPILOT_URL_FROM_ENV = `${(0,src/* readFromEnv */.u)(src/* Env.TrustpilotUrl */.X.TrustpilotUrl)}/trustpilot-get-reviews`;
    const { data  } = useSWRImmutable(TRUSTPILOT_URL_FROM_ENV, fetcher);
    return data === null || data === void 0 ? void 0 : data.total;
};

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-score.ts




const use_trustpilot_score_httpClient = axios_default().create();
const use_trustpilot_score_fetcher = async (url)=>await use_trustpilot_score_httpClient.get(url).then((res)=>TrustpilotReviewsResponse.parse(res.data));
const useTrustpilotScore = ()=>{
    const TRUSTPILOT_URL_FROM_ENV = `${(0,src/* readFromEnv */.u)(src/* Env.TrustpilotUrl */.X.TrustpilotUrl)}/trustpilot-get-reviews`;
    const { data  } = useSWRImmutable(TRUSTPILOT_URL_FROM_ENV, use_trustpilot_score_fetcher);
    return data === null || data === void 0 ? void 0 : data.trustScore;
};

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/index.ts







/***/ }),

/***/ 47453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_i": function() { return /* reexport */ fetcher; },
  "_d": function() { return /* reexport */ hasTokenExpired; },
  "mv": function() { return /* reexport */ initUserStore; },
  "LM": function() { return /* reexport */ useUserStore; }
});

// UNUSED EXPORTS: SetPermissionsAction, UNAUTHORISED_ENDPOINTS, stubAuthenticatedUserState

// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var axios = __webpack_require__(43653);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../../../node_modules/jwt-decode/build/esm/index.js
class InvalidTokenError extends Error {
}
InvalidTokenError.prototype.name = "InvalidTokenError";
function b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = "0" + code;
        }
        return "%" + code;
    }));
}
function base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return b64DecodeUnicode(output);
    }
    catch (err) {
        return atob(output);
    }
}
function jwtDecode(token, options) {
    if (typeof token !== "string") {
        throw new InvalidTokenError("Invalid token specified: must be a string");
    }
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") {
        throw new InvalidTokenError(`Invalid token specified: missing part #${pos + 1}`);
    }
    let decoded;
    try {
        decoded = base64UrlDecode(part);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    }
    catch (e) {
        throw new InvalidTokenError(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

;// CONCATENATED MODULE: ../../../node_modules/oidc-client-ts/dist/esm/oidc-client-ts.js
// src/utils/Logger.ts
var nopLogger = {
  debug: () => void 0,
  info: () => void 0,
  warn: () => void 0,
  error: () => void 0
};
var level;
var logger;
var Log = /* @__PURE__ */ ((Log2) => {
  Log2[Log2["NONE"] = 0] = "NONE";
  Log2[Log2["ERROR"] = 1] = "ERROR";
  Log2[Log2["WARN"] = 2] = "WARN";
  Log2[Log2["INFO"] = 3] = "INFO";
  Log2[Log2["DEBUG"] = 4] = "DEBUG";
  return Log2;
})(Log || {});
((Log2) => {
  function reset() {
    level = 3 /* INFO */;
    logger = nopLogger;
  }
  Log2.reset = reset;
  function setLevel(value) {
    if (!(0 /* NONE */ <= value && value <= 4 /* DEBUG */)) {
      throw new Error("Invalid log level");
    }
    level = value;
  }
  Log2.setLevel = setLevel;
  function setLogger(value) {
    logger = value;
  }
  Log2.setLogger = setLogger;
})(Log || (Log = {}));
var Logger = class _Logger {
  constructor(_name) {
    this._name = _name;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...args) {
    if (level >= 4 /* DEBUG */) {
      logger.debug(_Logger._format(this._name, this._method), ...args);
    }
  }
  info(...args) {
    if (level >= 3 /* INFO */) {
      logger.info(_Logger._format(this._name, this._method), ...args);
    }
  }
  warn(...args) {
    if (level >= 2 /* WARN */) {
      logger.warn(_Logger._format(this._name, this._method), ...args);
    }
  }
  error(...args) {
    if (level >= 1 /* ERROR */) {
      logger.error(_Logger._format(this._name, this._method), ...args);
    }
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(err) {
    this.error(err);
    throw err;
  }
  create(method) {
    const methodLogger = Object.create(this);
    methodLogger._method = method;
    methodLogger.debug("begin");
    return methodLogger;
  }
  static createStatic(name, staticMethod) {
    const staticLogger = new _Logger(`${name}.${staticMethod}`);
    staticLogger.debug("begin");
    return staticLogger;
  }
  static _format(name, method) {
    const prefix = `[${name}]`;
    return method ? `${prefix} ${method}:` : prefix;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(name, ...args) {
    if (level >= 4 /* DEBUG */) {
      logger.debug(_Logger._format(name), ...args);
    }
  }
  static info(name, ...args) {
    if (level >= 3 /* INFO */) {
      logger.info(_Logger._format(name), ...args);
    }
  }
  static warn(name, ...args) {
    if (level >= 2 /* WARN */) {
      logger.warn(_Logger._format(name), ...args);
    }
  }
  static error(name, ...args) {
    if (level >= 1 /* ERROR */) {
      logger.error(_Logger._format(name), ...args);
    }
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
Log.reset();

// src/utils/JwtUtils.ts

var JwtUtils = class {
  // IMPORTANT: doesn't validate the token
  static decode(token) {
    try {
      return jwtDecode(token);
    } catch (err) {
      Logger.error("JwtUtils.decode", err);
      throw err;
    }
  }
  static async generateSignedJwt(header, payload, privateKey) {
    const encodedHeader = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(header)));
    const encodedPayload = CryptoUtils.encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
    const encodedToken = `${encodedHeader}.${encodedPayload}`;
    const signature = await window.crypto.subtle.sign(
      {
        name: "ECDSA",
        hash: { name: "SHA-256" }
      },
      privateKey,
      new TextEncoder().encode(encodedToken)
    );
    const encodedSignature = CryptoUtils.encodeBase64Url(new Uint8Array(signature));
    return `${encodedToken}.${encodedSignature}`;
  }
};

// src/utils/CryptoUtils.ts
var UUID_V4_TEMPLATE = "10000000-1000-4000-8000-100000000000";
var toBase64 = (val) => btoa([...new Uint8Array(val)].map((chr) => String.fromCharCode(chr)).join(""));
var _CryptoUtils = class _CryptoUtils {
  static _randomWord() {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return arr[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    const uuid = UUID_V4_TEMPLATE.replace(
      /[018]/g,
      (c) => (+c ^ _CryptoUtils._randomWord() & 15 >> +c / 4).toString(16)
    );
    return uuid.replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4() + _CryptoUtils.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static async generateCodeChallenge(code_verifier) {
    if (!crypto.subtle) {
      throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
    }
    try {
      const encoder = new TextEncoder();
      const data = encoder.encode(code_verifier);
      const hashed = await crypto.subtle.digest("SHA-256", data);
      return toBase64(hashed).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (err) {
      Logger.error("CryptoUtils.generateCodeChallenge", err);
      throw err;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(client_id, client_secret) {
    const encoder = new TextEncoder();
    const data = encoder.encode([client_id, client_secret].join(":"));
    return toBase64(data);
  }
  /**
   * Generates a hash of a string using a given algorithm
   * @param alg
   * @param message
   */
  static async hash(alg, message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest(alg, msgUint8);
    return new Uint8Array(hashBuffer);
  }
  /**
   * Generates a rfc7638 compliant jwk thumbprint
   * @param jwk
   */
  static async customCalculateJwkThumbprint(jwk) {
    let jsonObject;
    switch (jwk.kty) {
      case "RSA":
        jsonObject = {
          "e": jwk.e,
          "kty": jwk.kty,
          "n": jwk.n
        };
        break;
      case "EC":
        jsonObject = {
          "crv": jwk.crv,
          "kty": jwk.kty,
          "x": jwk.x,
          "y": jwk.y
        };
        break;
      case "OKP":
        jsonObject = {
          "crv": jwk.crv,
          "kty": jwk.kty,
          "x": jwk.x
        };
        break;
      case "oct":
        jsonObject = {
          "crv": jwk.k,
          "kty": jwk.kty
        };
        break;
      default:
        throw new Error("Unknown jwk type");
    }
    const utf8encodedAndHashed = await _CryptoUtils.hash("SHA-256", JSON.stringify(jsonObject));
    return _CryptoUtils.encodeBase64Url(utf8encodedAndHashed);
  }
  static async generateDPoPProof({
    url,
    accessToken,
    httpMethod,
    keyPair,
    nonce
  }) {
    let hashedToken;
    let encodedHash;
    const payload = {
      "jti": window.crypto.randomUUID(),
      "htm": httpMethod != null ? httpMethod : "GET",
      "htu": url,
      "iat": Math.floor(Date.now() / 1e3)
    };
    if (accessToken) {
      hashedToken = await _CryptoUtils.hash("SHA-256", accessToken);
      encodedHash = _CryptoUtils.encodeBase64Url(hashedToken);
      payload.ath = encodedHash;
    }
    if (nonce) {
      payload.nonce = nonce;
    }
    try {
      const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
      const header = {
        "alg": "ES256",
        "typ": "dpop+jwt",
        "jwk": {
          "crv": publicJwk.crv,
          "kty": publicJwk.kty,
          "x": publicJwk.x,
          "y": publicJwk.y
        }
      };
      return await JwtUtils.generateSignedJwt(header, payload, keyPair.privateKey);
    } catch (err) {
      if (err instanceof TypeError) {
        throw new Error(`Error exporting dpop public key: ${err.message}`);
      } else {
        throw err;
      }
    }
  }
  static async generateDPoPJkt(keyPair) {
    try {
      const publicJwk = await crypto.subtle.exportKey("jwk", keyPair.publicKey);
      return await _CryptoUtils.customCalculateJwkThumbprint(publicJwk);
    } catch (err) {
      if (err instanceof TypeError) {
        throw new Error(`Could not retrieve dpop keys from storage: ${err.message}`);
      } else {
        throw err;
      }
    }
  }
  static async generateDPoPKeys() {
    return await window.crypto.subtle.generateKey(
      {
        name: "ECDSA",
        namedCurve: "P-256"
      },
      false,
      ["sign", "verify"]
    );
  }
};
/**
 * Generates a base64url encoded string
 */
_CryptoUtils.encodeBase64Url = (input) => {
  return toBase64(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
var CryptoUtils = _CryptoUtils;

// src/utils/Event.ts
var Event = class {
  constructor(_name) {
    this._name = _name;
    this._callbacks = [];
    this._logger = new Logger(`Event('${this._name}')`);
  }
  addHandler(cb) {
    this._callbacks.push(cb);
    return () => this.removeHandler(cb);
  }
  removeHandler(cb) {
    const idx = this._callbacks.lastIndexOf(cb);
    if (idx >= 0) {
      this._callbacks.splice(idx, 1);
    }
  }
  async raise(...ev) {
    this._logger.debug("raise:", ...ev);
    for (const cb of this._callbacks) {
      await cb(...ev);
    }
  }
};

// src/utils/PopupUtils.ts
var PopupUtils = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...features }) {
    var _a, _b, _c;
    if (features.width == null)
      features.width = (_a = [800, 720, 600, 480].find((width) => width <= window.outerWidth / 1.618)) != null ? _a : 360;
    (_b = features.left) != null ? _b : features.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - features.width) / 2));
    if (features.height != null)
      (_c = features.top) != null ? _c : features.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - features.height) / 2));
    return features;
  }
  static serialize(features) {
    return Object.entries(features).filter(([, value]) => value != null).map(([key, value]) => `${key}=${typeof value !== "boolean" ? value : value ? "yes" : "no"}`).join(",");
  }
};

// src/utils/Timer.ts
var Timer = class _Timer extends Event {
  constructor() {
    super(...arguments);
    this._logger = new Logger(`Timer('${this._name}')`);
    this._timerHandle = null;
    this._expiration = 0;
    this._callback = () => {
      const diff = this._expiration - _Timer.getEpochTime();
      this._logger.debug("timer completes in", diff);
      if (this._expiration <= _Timer.getEpochTime()) {
        this.cancel();
        void super.raise();
      }
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(durationInSeconds) {
    const logger2 = this._logger.create("init");
    durationInSeconds = Math.max(Math.floor(durationInSeconds), 1);
    const expiration = _Timer.getEpochTime() + durationInSeconds;
    if (this.expiration === expiration && this._timerHandle) {
      logger2.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel();
    logger2.debug("using duration", durationInSeconds);
    this._expiration = expiration;
    const timerDurationInSeconds = Math.min(durationInSeconds, 5);
    this._timerHandle = setInterval(this._callback, timerDurationInSeconds * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel");
    if (this._timerHandle) {
      clearInterval(this._timerHandle);
      this._timerHandle = null;
    }
  }
};

// src/utils/UrlUtils.ts
var UrlUtils = class {
  static readParams(url, responseMode = "query") {
    if (!url) throw new TypeError("Invalid URL");
    const parsedUrl = new URL(url, "http://127.0.0.1");
    const params = parsedUrl[responseMode === "fragment" ? "hash" : "search"];
    return new URLSearchParams(params.slice(1));
  }
};
var URL_STATE_DELIMITER = ";";

// src/errors/ErrorResponse.ts
var ErrorResponse = class extends Error {
  constructor(args, form) {
    var _a, _b, _c;
    super(args.error_description || args.error || "");
    this.form = form;
    /** Marker to detect class: "ErrorResponse" */
    this.name = "ErrorResponse";
    if (!args.error) {
      Logger.error("ErrorResponse", "No error passed");
      throw new Error("No error passed");
    }
    this.error = args.error;
    this.error_description = (_a = args.error_description) != null ? _a : null;
    this.error_uri = (_b = args.error_uri) != null ? _b : null;
    this.state = args.userState;
    this.session_state = (_c = args.session_state) != null ? _c : null;
    this.url_state = args.url_state;
  }
};

// src/errors/ErrorTimeout.ts
var ErrorTimeout = class extends Error {
  constructor(message) {
    super(message);
    /** Marker to detect class: "ErrorTimeout" */
    this.name = "ErrorTimeout";
  }
};

// src/AccessTokenEvents.ts
var AccessTokenEvents = class {
  constructor(args) {
    this._logger = new Logger("AccessTokenEvents");
    this._expiringTimer = new Timer("Access token expiring");
    this._expiredTimer = new Timer("Access token expired");
    this._expiringNotificationTimeInSeconds = args.expiringNotificationTimeInSeconds;
  }
  load(container) {
    const logger2 = this._logger.create("load");
    if (container.access_token && container.expires_in !== void 0) {
      const duration = container.expires_in;
      logger2.debug("access token present, remaining duration:", duration);
      if (duration > 0) {
        let expiring = duration - this._expiringNotificationTimeInSeconds;
        if (expiring <= 0) {
          expiring = 1;
        }
        logger2.debug("registering expiring timer, raising in", expiring, "seconds");
        this._expiringTimer.init(expiring);
      } else {
        logger2.debug("canceling existing expiring timer because we're past expiration.");
        this._expiringTimer.cancel();
      }
      const expired = duration + 1;
      logger2.debug("registering expired timer, raising in", expired, "seconds");
      this._expiredTimer.init(expired);
    } else {
      this._expiringTimer.cancel();
      this._expiredTimer.cancel();
    }
  }
  unload() {
    this._logger.debug("unload: canceling existing access token timers");
    this._expiringTimer.cancel();
    this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(cb) {
    return this._expiringTimer.addHandler(cb);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(cb) {
    this._expiringTimer.removeHandler(cb);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(cb) {
    return this._expiredTimer.addHandler(cb);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(cb) {
    this._expiredTimer.removeHandler(cb);
  }
};

// src/CheckSessionIFrame.ts
var CheckSessionIFrame = class {
  constructor(_callback, _client_id, url, _intervalInSeconds, _stopOnError) {
    this._callback = _callback;
    this._client_id = _client_id;
    this._intervalInSeconds = _intervalInSeconds;
    this._stopOnError = _stopOnError;
    this._logger = new Logger("CheckSessionIFrame");
    this._timer = null;
    this._session_state = null;
    this._message = (e) => {
      if (e.origin === this._frame_origin && e.source === this._frame.contentWindow) {
        if (e.data === "error") {
          this._logger.error("error message from check session op iframe");
          if (this._stopOnError) {
            this.stop();
          }
        } else if (e.data === "changed") {
          this._logger.debug("changed message from check session op iframe");
          this.stop();
          void this._callback();
        } else {
          this._logger.debug(e.data + " message from check session op iframe");
        }
      }
    };
    const parsedUrl = new URL(url);
    this._frame_origin = parsedUrl.origin;
    this._frame = window.document.createElement("iframe");
    this._frame.style.visibility = "hidden";
    this._frame.style.position = "fixed";
    this._frame.style.left = "-1000px";
    this._frame.style.top = "0";
    this._frame.width = "0";
    this._frame.height = "0";
    this._frame.src = parsedUrl.href;
  }
  load() {
    return new Promise((resolve) => {
      this._frame.onload = () => {
        resolve();
      };
      window.document.body.appendChild(this._frame);
      window.addEventListener("message", this._message, false);
    });
  }
  start(session_state) {
    if (this._session_state === session_state) {
      return;
    }
    this._logger.create("start");
    this.stop();
    this._session_state = session_state;
    const send = () => {
      if (!this._frame.contentWindow || !this._session_state) {
        return;
      }
      this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    send();
    this._timer = setInterval(send, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop");
    this._session_state = null;
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
};

// src/InMemoryWebStorage.ts
var InMemoryWebStorage = class {
  constructor() {
    this._logger = new Logger("InMemoryWebStorage");
    this._data = {};
  }
  clear() {
    this._logger.create("clear");
    this._data = {};
  }
  getItem(key) {
    this._logger.create(`getItem('${key}')`);
    return this._data[key];
  }
  setItem(key, value) {
    this._logger.create(`setItem('${key}')`);
    this._data[key] = value;
  }
  removeItem(key) {
    this._logger.create(`removeItem('${key}')`);
    delete this._data[key];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(index) {
    return Object.getOwnPropertyNames(this._data)[index];
  }
};

// src/errors/ErrorDPoPNonce.ts
var ErrorDPoPNonce = class extends Error {
  constructor(nonce, message) {
    super(message);
    /** Marker to detect class: "ErrorDPoPNonce" */
    this.name = "ErrorDPoPNonce";
    this.nonce = nonce;
  }
};

// src/JsonService.ts
var JsonService = class {
  constructor(additionalContentTypes = [], _jwtHandler = null, _extraHeaders = {}) {
    this._jwtHandler = _jwtHandler;
    this._extraHeaders = _extraHeaders;
    this._logger = new Logger("JsonService");
    this._contentTypes = [];
    this._contentTypes.push(...additionalContentTypes, "application/json");
    if (_jwtHandler) {
      this._contentTypes.push("application/jwt");
    }
  }
  async fetchWithTimeout(input, init = {}) {
    const { timeoutInSeconds, ...initFetch } = init;
    if (!timeoutInSeconds) {
      return await fetch(input, initFetch);
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutInSeconds * 1e3);
    try {
      const response = await fetch(input, {
        ...init,
        signal: controller.signal
      });
      return response;
    } catch (err) {
      if (err instanceof DOMException && err.name === "AbortError") {
        throw new ErrorTimeout("Network timed out");
      }
      throw err;
    } finally {
      clearTimeout(timeoutId);
    }
  }
  async getJson(url, {
    token,
    credentials,
    timeoutInSeconds
  } = {}) {
    const logger2 = this._logger.create("getJson");
    const headers = {
      "Accept": this._contentTypes.join(", ")
    };
    if (token) {
      logger2.debug("token passed, setting Authorization header");
      headers["Authorization"] = "Bearer " + token;
    }
    this.appendExtraHeaders(headers);
    let response;
    try {
      logger2.debug("url:", url);
      response = await this.fetchWithTimeout(url, { method: "GET", headers, timeoutInSeconds, credentials });
    } catch (err) {
      logger2.error("Network Error");
      throw err;
    }
    logger2.debug("HTTP response received, status", response.status);
    const contentType = response.headers.get("Content-Type");
    if (contentType && !this._contentTypes.find((item) => contentType.startsWith(item))) {
      logger2.throw(new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`));
    }
    if (response.ok && this._jwtHandler && (contentType == null ? void 0 : contentType.startsWith("application/jwt"))) {
      return await this._jwtHandler(await response.text());
    }
    let json;
    try {
      json = await response.json();
    } catch (err) {
      logger2.error("Error parsing JSON response", err);
      if (response.ok) throw err;
      throw new Error(`${response.statusText} (${response.status})`);
    }
    if (!response.ok) {
      logger2.error("Error from server:", json);
      if (json.error) {
        throw new ErrorResponse(json);
      }
      throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
    }
    return json;
  }
  async postForm(url, {
    body,
    basicAuth,
    timeoutInSeconds,
    initCredentials,
    extraHeaders
  }) {
    const logger2 = this._logger.create("postForm");
    const headers = {
      "Accept": this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded",
      ...extraHeaders
    };
    if (basicAuth !== void 0) {
      headers["Authorization"] = "Basic " + basicAuth;
    }
    this.appendExtraHeaders(headers);
    let response;
    try {
      logger2.debug("url:", url);
      response = await this.fetchWithTimeout(url, { method: "POST", headers, body, timeoutInSeconds, credentials: initCredentials });
    } catch (err) {
      logger2.error("Network error");
      throw err;
    }
    logger2.debug("HTTP response received, status", response.status);
    const contentType = response.headers.get("Content-Type");
    if (contentType && !this._contentTypes.find((item) => contentType.startsWith(item))) {
      throw new Error(`Invalid response Content-Type: ${contentType != null ? contentType : "undefined"}, from URL: ${url}`);
    }
    const responseText = await response.text();
    let json = {};
    if (responseText) {
      try {
        json = JSON.parse(responseText);
      } catch (err) {
        logger2.error("Error parsing JSON response", err);
        if (response.ok) throw err;
        throw new Error(`${response.statusText} (${response.status})`);
      }
    }
    if (!response.ok) {
      logger2.error("Error from server:", json);
      if (response.headers.has("dpop-nonce")) {
        const nonce = response.headers.get("dpop-nonce");
        throw new ErrorDPoPNonce(nonce, `${JSON.stringify(json)}`);
      }
      if (json.error) {
        throw new ErrorResponse(json, body);
      }
      throw new Error(`${response.statusText} (${response.status}): ${JSON.stringify(json)}`);
    }
    return json;
  }
  appendExtraHeaders(headers) {
    const logger2 = this._logger.create("appendExtraHeaders");
    const customKeys = Object.keys(this._extraHeaders);
    const protectedHeaders = [
      "authorization",
      "accept",
      "content-type"
    ];
    if (customKeys.length === 0) {
      return;
    }
    customKeys.forEach((headerName) => {
      if (protectedHeaders.includes(headerName.toLocaleLowerCase())) {
        logger2.warn("Protected header could not be overridden", headerName, protectedHeaders);
        return;
      }
      const content = typeof this._extraHeaders[headerName] === "function" ? this._extraHeaders[headerName]() : this._extraHeaders[headerName];
      if (content && content !== "") {
        headers[headerName] = content;
      }
    });
  }
};

// src/MetadataService.ts
var MetadataService = class {
  constructor(_settings) {
    this._settings = _settings;
    this._logger = new Logger("MetadataService");
    this._signingKeys = null;
    this._metadata = null;
    this._metadataUrl = this._settings.metadataUrl;
    this._jsonService = new JsonService(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    );
    if (this._settings.signingKeys) {
      this._logger.debug("using signingKeys from settings");
      this._signingKeys = this._settings.signingKeys;
    }
    if (this._settings.metadata) {
      this._logger.debug("using metadata from settings");
      this._metadata = this._settings.metadata;
    }
    if (this._settings.fetchRequestCredentials) {
      this._logger.debug("using fetchRequestCredentials from settings");
      this._fetchRequestCredentials = this._settings.fetchRequestCredentials;
    }
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const logger2 = this._logger.create("getMetadata");
    if (this._metadata) {
      logger2.debug("using cached values");
      return this._metadata;
    }
    if (!this._metadataUrl) {
      logger2.throw(new Error("No authority or metadataUrl configured on settings"));
      throw null;
    }
    logger2.debug("getting metadata from", this._metadataUrl);
    const metadata = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials, timeoutInSeconds: this._settings.requestTimeoutInSeconds });
    logger2.debug("merging remote JSON with seed metadata");
    this._metadata = Object.assign({}, this._settings.metadataSeed, metadata);
    return this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(optional = true) {
    return this._getMetadataProperty("token_endpoint", optional);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", true);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", true);
  }
  getRevocationEndpoint(optional = true) {
    return this._getMetadataProperty("revocation_endpoint", optional);
  }
  getKeysEndpoint(optional = true) {
    return this._getMetadataProperty("jwks_uri", optional);
  }
  async _getMetadataProperty(name, optional = false) {
    const logger2 = this._logger.create(`_getMetadataProperty('${name}')`);
    const metadata = await this.getMetadata();
    logger2.debug("resolved");
    if (metadata[name] === void 0) {
      if (optional === true) {
        logger2.warn("Metadata does not contain optional property");
        return void 0;
      }
      logger2.throw(new Error("Metadata does not contain property " + name));
    }
    return metadata[name];
  }
  async getSigningKeys() {
    const logger2 = this._logger.create("getSigningKeys");
    if (this._signingKeys) {
      logger2.debug("returning signingKeys from cache");
      return this._signingKeys;
    }
    const jwks_uri = await this.getKeysEndpoint(false);
    logger2.debug("got jwks_uri", jwks_uri);
    const keySet = await this._jsonService.getJson(jwks_uri, { timeoutInSeconds: this._settings.requestTimeoutInSeconds });
    logger2.debug("got key set", keySet);
    if (!Array.isArray(keySet.keys)) {
      logger2.throw(new Error("Missing keys on keyset"));
      throw null;
    }
    this._signingKeys = keySet.keys;
    return this._signingKeys;
  }
};

// src/WebStorageStateStore.ts
var WebStorageStateStore = class {
  constructor({
    prefix = "oidc.",
    store = localStorage
  } = {}) {
    this._logger = new Logger("WebStorageStateStore");
    this._store = store;
    this._prefix = prefix;
  }
  async set(key, value) {
    this._logger.create(`set('${key}')`);
    key = this._prefix + key;
    await this._store.setItem(key, value);
  }
  async get(key) {
    this._logger.create(`get('${key}')`);
    key = this._prefix + key;
    const item = await this._store.getItem(key);
    return item;
  }
  async remove(key) {
    this._logger.create(`remove('${key}')`);
    key = this._prefix + key;
    const item = await this._store.getItem(key);
    await this._store.removeItem(key);
    return item;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const len = await this._store.length;
    const keys = [];
    for (let index = 0; index < len; index++) {
      const key = await this._store.key(index);
      if (key && key.indexOf(this._prefix) === 0) {
        keys.push(key.substr(this._prefix.length));
      }
    }
    return keys;
  }
};

// src/OidcClientSettings.ts
var DefaultResponseType = "code";
var DefaultScope = "openid";
var DefaultClientAuthentication = "client_secret_post";
var DefaultStaleStateAgeInSeconds = 60 * 15;
var OidcClientSettingsStore = class {
  constructor({
    // metadata related
    authority,
    metadataUrl,
    metadata,
    signingKeys,
    metadataSeed,
    // client related
    client_id,
    client_secret,
    response_type = DefaultResponseType,
    scope = DefaultScope,
    redirect_uri,
    post_logout_redirect_uri,
    client_authentication = DefaultClientAuthentication,
    // optional protocol
    prompt,
    display,
    max_age,
    ui_locales,
    acr_values,
    resource,
    response_mode,
    // behavior flags
    filterProtocolClaims = true,
    loadUserInfo = false,
    requestTimeoutInSeconds,
    staleStateAgeInSeconds = DefaultStaleStateAgeInSeconds,
    mergeClaimsStrategy = { array: "replace" },
    disablePKCE = false,
    // other behavior
    stateStore,
    revokeTokenAdditionalContentTypes,
    fetchRequestCredentials,
    refreshTokenAllowedScope,
    // extra
    extraQueryParams = {},
    extraTokenParams = {},
    extraHeaders = {},
    dpop,
    omitScopeWhenRequesting = false
  }) {
    var _a;
    this.authority = authority;
    if (metadataUrl) {
      this.metadataUrl = metadataUrl;
    } else {
      this.metadataUrl = authority;
      if (authority) {
        if (!this.metadataUrl.endsWith("/")) {
          this.metadataUrl += "/";
        }
        this.metadataUrl += ".well-known/openid-configuration";
      }
    }
    this.metadata = metadata;
    this.metadataSeed = metadataSeed;
    this.signingKeys = signingKeys;
    this.client_id = client_id;
    this.client_secret = client_secret;
    this.response_type = response_type;
    this.scope = scope;
    this.redirect_uri = redirect_uri;
    this.post_logout_redirect_uri = post_logout_redirect_uri;
    this.client_authentication = client_authentication;
    this.prompt = prompt;
    this.display = display;
    this.max_age = max_age;
    this.ui_locales = ui_locales;
    this.acr_values = acr_values;
    this.resource = resource;
    this.response_mode = response_mode;
    this.filterProtocolClaims = filterProtocolClaims != null ? filterProtocolClaims : true;
    this.loadUserInfo = !!loadUserInfo;
    this.staleStateAgeInSeconds = staleStateAgeInSeconds;
    this.mergeClaimsStrategy = mergeClaimsStrategy;
    this.omitScopeWhenRequesting = omitScopeWhenRequesting;
    this.disablePKCE = !!disablePKCE;
    this.revokeTokenAdditionalContentTypes = revokeTokenAdditionalContentTypes;
    this.fetchRequestCredentials = fetchRequestCredentials ? fetchRequestCredentials : "same-origin";
    this.requestTimeoutInSeconds = requestTimeoutInSeconds;
    if (stateStore) {
      this.stateStore = stateStore;
    } else {
      const store = typeof window !== "undefined" ? window.localStorage : new InMemoryWebStorage();
      this.stateStore = new WebStorageStateStore({ store });
    }
    this.refreshTokenAllowedScope = refreshTokenAllowedScope;
    this.extraQueryParams = extraQueryParams;
    this.extraTokenParams = extraTokenParams;
    this.extraHeaders = extraHeaders;
    this.dpop = dpop;
    if (this.dpop && !((_a = this.dpop) == null ? void 0 : _a.store)) {
      throw new Error("A DPoPStore is required when dpop is enabled");
    }
  }
};

// src/UserInfoService.ts
var UserInfoService = class {
  constructor(_settings, _metadataService) {
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._logger = new Logger("UserInfoService");
    this._getClaimsFromJwt = async (responseText) => {
      const logger2 = this._logger.create("_getClaimsFromJwt");
      try {
        const payload = JwtUtils.decode(responseText);
        logger2.debug("JWT decoding successful");
        return payload;
      } catch (err) {
        logger2.error("Error parsing JWT response");
        throw err;
      }
    };
    this._jsonService = new JsonService(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(token) {
    const logger2 = this._logger.create("getClaims");
    if (!token) {
      this._logger.throw(new Error("No token passed"));
    }
    const url = await this._metadataService.getUserInfoEndpoint();
    logger2.debug("got userinfo url", url);
    const claims = await this._jsonService.getJson(url, {
      token,
      credentials: this._settings.fetchRequestCredentials,
      timeoutInSeconds: this._settings.requestTimeoutInSeconds
    });
    logger2.debug("got claims", claims);
    return claims;
  }
};

// src/TokenClient.ts
var TokenClient = class {
  constructor(_settings, _metadataService) {
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._logger = new Logger("TokenClient");
    this._jsonService = new JsonService(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type = "authorization_code",
    redirect_uri = this._settings.redirect_uri,
    client_id = this._settings.client_id,
    client_secret = this._settings.client_secret,
    extraHeaders,
    ...args
  }) {
    const logger2 = this._logger.create("exchangeCode");
    if (!client_id) {
      logger2.throw(new Error("A client_id is required"));
    }
    if (!redirect_uri) {
      logger2.throw(new Error("A redirect_uri is required"));
    }
    if (!args.code) {
      logger2.throw(new Error("A code is required"));
    }
    const params = new URLSearchParams({ grant_type, redirect_uri });
    for (const [key, value] of Object.entries(args)) {
      if (value != null) {
        params.set(key, value);
      }
    }
    let basicAuth;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!client_secret) {
          logger2.throw(new Error("A client_secret is required"));
          throw null;
        }
        basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
        break;
      case "client_secret_post":
        params.append("client_id", client_id);
        if (client_secret) {
          params.append("client_secret", client_secret);
        }
        break;
    }
    const url = await this._metadataService.getTokenEndpoint(false);
    logger2.debug("got token endpoint");
    const response = await this._jsonService.postForm(url, {
      body: params,
      basicAuth,
      timeoutInSeconds: this._settings.requestTimeoutInSeconds,
      initCredentials: this._settings.fetchRequestCredentials,
      extraHeaders
    });
    logger2.debug("got response");
    return response;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type = "password",
    client_id = this._settings.client_id,
    client_secret = this._settings.client_secret,
    scope = this._settings.scope,
    ...args
  }) {
    const logger2 = this._logger.create("exchangeCredentials");
    if (!client_id) {
      logger2.throw(new Error("A client_id is required"));
    }
    const params = new URLSearchParams({ grant_type });
    if (!this._settings.omitScopeWhenRequesting) {
      params.set("scope", scope);
    }
    for (const [key, value] of Object.entries(args)) {
      if (value != null) {
        params.set(key, value);
      }
    }
    let basicAuth;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!client_secret) {
          logger2.throw(new Error("A client_secret is required"));
          throw null;
        }
        basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
        break;
      case "client_secret_post":
        params.append("client_id", client_id);
        if (client_secret) {
          params.append("client_secret", client_secret);
        }
        break;
    }
    const url = await this._metadataService.getTokenEndpoint(false);
    logger2.debug("got token endpoint");
    const response = await this._jsonService.postForm(url, { body: params, basicAuth, timeoutInSeconds: this._settings.requestTimeoutInSeconds, initCredentials: this._settings.fetchRequestCredentials });
    logger2.debug("got response");
    return response;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type = "refresh_token",
    client_id = this._settings.client_id,
    client_secret = this._settings.client_secret,
    timeoutInSeconds,
    extraHeaders,
    ...args
  }) {
    const logger2 = this._logger.create("exchangeRefreshToken");
    if (!client_id) {
      logger2.throw(new Error("A client_id is required"));
    }
    if (!args.refresh_token) {
      logger2.throw(new Error("A refresh_token is required"));
    }
    const params = new URLSearchParams({ grant_type });
    for (const [key, value] of Object.entries(args)) {
      if (Array.isArray(value)) {
        value.forEach((param) => params.append(key, param));
      } else if (value != null) {
        params.set(key, value);
      }
    }
    let basicAuth;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!client_secret) {
          logger2.throw(new Error("A client_secret is required"));
          throw null;
        }
        basicAuth = CryptoUtils.generateBasicAuth(client_id, client_secret);
        break;
      case "client_secret_post":
        params.append("client_id", client_id);
        if (client_secret) {
          params.append("client_secret", client_secret);
        }
        break;
    }
    const url = await this._metadataService.getTokenEndpoint(false);
    logger2.debug("got token endpoint");
    const response = await this._jsonService.postForm(url, { body: params, basicAuth, timeoutInSeconds, initCredentials: this._settings.fetchRequestCredentials, extraHeaders });
    logger2.debug("got response");
    return response;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(args) {
    var _a;
    const logger2 = this._logger.create("revoke");
    if (!args.token) {
      logger2.throw(new Error("A token is required"));
    }
    const url = await this._metadataService.getRevocationEndpoint(false);
    logger2.debug(`got revocation endpoint, revoking ${(_a = args.token_type_hint) != null ? _a : "default token type"}`);
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(args)) {
      if (value != null) {
        params.set(key, value);
      }
    }
    params.set("client_id", this._settings.client_id);
    if (this._settings.client_secret) {
      params.set("client_secret", this._settings.client_secret);
    }
    await this._jsonService.postForm(url, { body: params, timeoutInSeconds: this._settings.requestTimeoutInSeconds });
    logger2.debug("got response");
  }
};

// src/ResponseValidator.ts
var ResponseValidator = class {
  constructor(_settings, _metadataService, _claimsService) {
    this._settings = _settings;
    this._metadataService = _metadataService;
    this._claimsService = _claimsService;
    this._logger = new Logger("ResponseValidator");
    this._userInfoService = new UserInfoService(this._settings, this._metadataService);
    this._tokenClient = new TokenClient(this._settings, this._metadataService);
  }
  async validateSigninResponse(response, state, extraHeaders) {
    const logger2 = this._logger.create("validateSigninResponse");
    this._processSigninState(response, state);
    logger2.debug("state processed");
    await this._processCode(response, state, extraHeaders);
    logger2.debug("code processed");
    if (response.isOpenId) {
      this._validateIdTokenAttributes(response);
    }
    logger2.debug("tokens validated");
    await this._processClaims(response, state == null ? void 0 : state.skipUserInfo, response.isOpenId);
    logger2.debug("claims processed");
  }
  async validateCredentialsResponse(response, skipUserInfo) {
    const logger2 = this._logger.create("validateCredentialsResponse");
    if (response.isOpenId && !!response.id_token) {
      this._validateIdTokenAttributes(response);
    }
    logger2.debug("tokens validated");
    await this._processClaims(response, skipUserInfo, response.isOpenId);
    logger2.debug("claims processed");
  }
  async validateRefreshResponse(response, state) {
    var _a, _b;
    const logger2 = this._logger.create("validateRefreshResponse");
    response.userState = state.data;
    (_a = response.session_state) != null ? _a : response.session_state = state.session_state;
    (_b = response.scope) != null ? _b : response.scope = state.scope;
    if (response.isOpenId && !!response.id_token) {
      this._validateIdTokenAttributes(response, state.id_token);
      logger2.debug("ID Token validated");
    }
    if (!response.id_token) {
      response.id_token = state.id_token;
      response.profile = state.profile;
    }
    const hasIdToken = response.isOpenId && !!response.id_token;
    await this._processClaims(response, false, hasIdToken);
    logger2.debug("claims processed");
  }
  validateSignoutResponse(response, state) {
    const logger2 = this._logger.create("validateSignoutResponse");
    if (state.id !== response.state) {
      logger2.throw(new Error("State does not match"));
    }
    logger2.debug("state validated");
    response.userState = state.data;
    if (response.error) {
      logger2.warn("Response was error", response.error);
      throw new ErrorResponse(response);
    }
  }
  _processSigninState(response, state) {
    var _a;
    const logger2 = this._logger.create("_processSigninState");
    if (state.id !== response.state) {
      logger2.throw(new Error("State does not match"));
    }
    if (!state.client_id) {
      logger2.throw(new Error("No client_id on state"));
    }
    if (!state.authority) {
      logger2.throw(new Error("No authority on state"));
    }
    if (this._settings.authority !== state.authority) {
      logger2.throw(new Error("authority mismatch on settings vs. signin state"));
    }
    if (this._settings.client_id && this._settings.client_id !== state.client_id) {
      logger2.throw(new Error("client_id mismatch on settings vs. signin state"));
    }
    logger2.debug("state validated");
    response.userState = state.data;
    response.url_state = state.url_state;
    (_a = response.scope) != null ? _a : response.scope = state.scope;
    if (response.error) {
      logger2.warn("Response was error", response.error);
      throw new ErrorResponse(response);
    }
    if (state.code_verifier && !response.code) {
      logger2.throw(new Error("Expected code in response"));
    }
  }
  async _processClaims(response, skipUserInfo = false, validateSub = true) {
    const logger2 = this._logger.create("_processClaims");
    response.profile = this._claimsService.filterProtocolClaims(response.profile);
    if (skipUserInfo || !this._settings.loadUserInfo || !response.access_token) {
      logger2.debug("not loading user info");
      return;
    }
    logger2.debug("loading user info");
    const claims = await this._userInfoService.getClaims(response.access_token);
    logger2.debug("user info claims received from user info endpoint");
    if (validateSub && claims.sub !== response.profile.sub) {
      logger2.throw(new Error("subject from UserInfo response does not match subject in ID Token"));
    }
    response.profile = this._claimsService.mergeClaims(response.profile, this._claimsService.filterProtocolClaims(claims));
    logger2.debug("user info claims received, updated profile:", response.profile);
  }
  async _processCode(response, state, extraHeaders) {
    const logger2 = this._logger.create("_processCode");
    if (response.code) {
      logger2.debug("Validating code");
      const tokenResponse = await this._tokenClient.exchangeCode({
        client_id: state.client_id,
        client_secret: state.client_secret,
        code: response.code,
        redirect_uri: state.redirect_uri,
        code_verifier: state.code_verifier,
        extraHeaders,
        ...state.extraTokenParams
      });
      Object.assign(response, tokenResponse);
    } else {
      logger2.debug("No code to process");
    }
  }
  _validateIdTokenAttributes(response, existingToken) {
    var _a;
    const logger2 = this._logger.create("_validateIdTokenAttributes");
    logger2.debug("decoding ID Token JWT");
    const incoming = JwtUtils.decode((_a = response.id_token) != null ? _a : "");
    if (!incoming.sub) {
      logger2.throw(new Error("ID Token is missing a subject claim"));
    }
    if (existingToken) {
      const existing = JwtUtils.decode(existingToken);
      if (incoming.sub !== existing.sub) {
        logger2.throw(new Error("sub in id_token does not match current sub"));
      }
      if (incoming.auth_time && incoming.auth_time !== existing.auth_time) {
        logger2.throw(new Error("auth_time in id_token does not match original auth_time"));
      }
      if (incoming.azp && incoming.azp !== existing.azp) {
        logger2.throw(new Error("azp in id_token does not match original azp"));
      }
      if (!incoming.azp && existing.azp) {
        logger2.throw(new Error("azp not in id_token, but present in original id_token"));
      }
    }
    response.profile = incoming;
  }
};

// src/State.ts
var State = class _State {
  constructor(args) {
    this.id = args.id || CryptoUtils.generateUUIDv4();
    this.data = args.data;
    if (args.created && args.created > 0) {
      this.created = args.created;
    } else {
      this.created = Timer.getEpochTime();
    }
    this.request_type = args.request_type;
    this.url_state = args.url_state;
  }
  toStorageString() {
    new Logger("State").create("toStorageString");
    return JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state
    });
  }
  static fromStorageString(storageString) {
    Logger.createStatic("State", "fromStorageString");
    return Promise.resolve(new _State(JSON.parse(storageString)));
  }
  static async clearStaleState(storage, age) {
    const logger2 = Logger.createStatic("State", "clearStaleState");
    const cutoff = Timer.getEpochTime() - age;
    const keys = await storage.getAllKeys();
    logger2.debug("got keys", keys);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const item = await storage.get(key);
      let remove = false;
      if (item) {
        try {
          const state = await _State.fromStorageString(item);
          logger2.debug("got item from key:", key, state.created);
          if (state.created <= cutoff) {
            remove = true;
          }
        } catch (err) {
          logger2.error("Error parsing state for key:", key, err);
          remove = true;
        }
      } else {
        logger2.debug("no item in storage for key:", key);
        remove = true;
      }
      if (remove) {
        logger2.debug("removed item for key:", key);
        void storage.remove(key);
      }
    }
  }
};

// src/SigninState.ts
var SigninState = class _SigninState extends State {
  constructor(args) {
    super(args);
    this.code_verifier = args.code_verifier;
    this.code_challenge = args.code_challenge;
    this.authority = args.authority;
    this.client_id = args.client_id;
    this.redirect_uri = args.redirect_uri;
    this.scope = args.scope;
    this.client_secret = args.client_secret;
    this.extraTokenParams = args.extraTokenParams;
    this.response_mode = args.response_mode;
    this.skipUserInfo = args.skipUserInfo;
  }
  static async create(args) {
    const code_verifier = args.code_verifier === true ? CryptoUtils.generateCodeVerifier() : args.code_verifier || void 0;
    const code_challenge = code_verifier ? await CryptoUtils.generateCodeChallenge(code_verifier) : void 0;
    return new _SigninState({
      ...args,
      code_verifier,
      code_challenge
    });
  }
  toStorageString() {
    new Logger("SigninState").create("toStorageString");
    return JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo
    });
  }
  static fromStorageString(storageString) {
    Logger.createStatic("SigninState", "fromStorageString");
    const data = JSON.parse(storageString);
    return _SigninState.create(data);
  }
};

// src/SigninRequest.ts
var _SigninRequest = class _SigninRequest {
  constructor(args) {
    this.url = args.url;
    this.state = args.state;
  }
  static async create({
    // mandatory
    url,
    authority,
    client_id,
    redirect_uri,
    response_type,
    scope,
    // optional
    state_data,
    response_mode,
    request_type,
    client_secret,
    nonce,
    url_state,
    resource,
    skipUserInfo,
    extraQueryParams,
    extraTokenParams,
    disablePKCE,
    dpopJkt,
    omitScopeWhenRequesting,
    ...optionalParams
  }) {
    if (!url) {
      this._logger.error("create: No url passed");
      throw new Error("url");
    }
    if (!client_id) {
      this._logger.error("create: No client_id passed");
      throw new Error("client_id");
    }
    if (!redirect_uri) {
      this._logger.error("create: No redirect_uri passed");
      throw new Error("redirect_uri");
    }
    if (!response_type) {
      this._logger.error("create: No response_type passed");
      throw new Error("response_type");
    }
    if (!scope) {
      this._logger.error("create: No scope passed");
      throw new Error("scope");
    }
    if (!authority) {
      this._logger.error("create: No authority passed");
      throw new Error("authority");
    }
    const state = await SigninState.create({
      data: state_data,
      request_type,
      url_state,
      code_verifier: !disablePKCE,
      client_id,
      authority,
      redirect_uri,
      response_mode,
      client_secret,
      scope,
      extraTokenParams,
      skipUserInfo
    });
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.append("client_id", client_id);
    parsedUrl.searchParams.append("redirect_uri", redirect_uri);
    parsedUrl.searchParams.append("response_type", response_type);
    if (!omitScopeWhenRequesting) {
      parsedUrl.searchParams.append("scope", scope);
    }
    if (nonce) {
      parsedUrl.searchParams.append("nonce", nonce);
    }
    if (dpopJkt) {
      parsedUrl.searchParams.append("dpop_jkt", dpopJkt);
    }
    let stateParam = state.id;
    if (url_state) {
      stateParam = `${stateParam}${URL_STATE_DELIMITER}${url_state}`;
    }
    parsedUrl.searchParams.append("state", stateParam);
    if (state.code_challenge) {
      parsedUrl.searchParams.append("code_challenge", state.code_challenge);
      parsedUrl.searchParams.append("code_challenge_method", "S256");
    }
    if (resource) {
      const resources = Array.isArray(resource) ? resource : [resource];
      resources.forEach((r) => parsedUrl.searchParams.append("resource", r));
    }
    for (const [key, value] of Object.entries({ response_mode, ...optionalParams, ...extraQueryParams })) {
      if (value != null) {
        parsedUrl.searchParams.append(key, value.toString());
      }
    }
    return new _SigninRequest({
      url: parsedUrl.href,
      state
    });
  }
};
_SigninRequest._logger = new Logger("SigninRequest");
var SigninRequest = _SigninRequest;

// src/SigninResponse.ts
var OidcScope = "openid";
var SigninResponse = class {
  constructor(params) {
    /** @see {@link User.access_token} */
    this.access_token = "";
    /** @see {@link User.token_type} */
    this.token_type = "";
    /** @see {@link User.profile} */
    this.profile = {};
    this.state = params.get("state");
    this.session_state = params.get("session_state");
    if (this.state) {
      const splitState = decodeURIComponent(this.state).split(URL_STATE_DELIMITER);
      this.state = splitState[0];
      if (splitState.length > 1) {
        this.url_state = splitState.slice(1).join(URL_STATE_DELIMITER);
      }
    }
    this.error = params.get("error");
    this.error_description = params.get("error_description");
    this.error_uri = params.get("error_uri");
    this.code = params.get("code");
  }
  get expires_in() {
    if (this.expires_at === void 0) {
      return void 0;
    }
    return this.expires_at - Timer.getEpochTime();
  }
  set expires_in(value) {
    if (typeof value === "string") value = Number(value);
    if (value !== void 0 && value >= 0) {
      this.expires_at = Math.floor(value) + Timer.getEpochTime();
    }
  }
  get isOpenId() {
    var _a;
    return ((_a = this.scope) == null ? void 0 : _a.split(" ").includes(OidcScope)) || !!this.id_token;
  }
};

// src/SignoutRequest.ts
var SignoutRequest = class {
  constructor({
    url,
    state_data,
    id_token_hint,
    post_logout_redirect_uri,
    extraQueryParams,
    request_type,
    client_id
  }) {
    this._logger = new Logger("SignoutRequest");
    if (!url) {
      this._logger.error("ctor: No url passed");
      throw new Error("url");
    }
    const parsedUrl = new URL(url);
    if (id_token_hint) {
      parsedUrl.searchParams.append("id_token_hint", id_token_hint);
    }
    if (client_id) {
      parsedUrl.searchParams.append("client_id", client_id);
    }
    if (post_logout_redirect_uri) {
      parsedUrl.searchParams.append("post_logout_redirect_uri", post_logout_redirect_uri);
      if (state_data) {
        this.state = new State({ data: state_data, request_type });
        parsedUrl.searchParams.append("state", this.state.id);
      }
    }
    for (const [key, value] of Object.entries({ ...extraQueryParams })) {
      if (value != null) {
        parsedUrl.searchParams.append(key, value.toString());
      }
    }
    this.url = parsedUrl.href;
  }
};

// src/SignoutResponse.ts
var SignoutResponse = class {
  constructor(params) {
    this.state = params.get("state");
    this.error = params.get("error");
    this.error_description = params.get("error_description");
    this.error_uri = params.get("error_uri");
  }
};

// src/ClaimsService.ts
var DefaultProtocolClaims = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
];
var InternalRequiredProtocolClaims = ["sub", "iss", "aud", "exp", "iat"];
var ClaimsService = class {
  constructor(_settings) {
    this._settings = _settings;
    this._logger = new Logger("ClaimsService");
  }
  filterProtocolClaims(claims) {
    const result = { ...claims };
    if (this._settings.filterProtocolClaims) {
      let protocolClaims;
      if (Array.isArray(this._settings.filterProtocolClaims)) {
        protocolClaims = this._settings.filterProtocolClaims;
      } else {
        protocolClaims = DefaultProtocolClaims;
      }
      for (const claim of protocolClaims) {
        if (!InternalRequiredProtocolClaims.includes(claim)) {
          delete result[claim];
        }
      }
    }
    return result;
  }
  mergeClaims(claims1, claims2) {
    const result = { ...claims1 };
    for (const [claim, values] of Object.entries(claims2)) {
      if (result[claim] !== values) {
        if (Array.isArray(result[claim]) || Array.isArray(values)) {
          if (this._settings.mergeClaimsStrategy.array == "replace") {
            result[claim] = values;
          } else {
            const mergedValues = Array.isArray(result[claim]) ? result[claim] : [result[claim]];
            for (const value of Array.isArray(values) ? values : [values]) {
              if (!mergedValues.includes(value)) {
                mergedValues.push(value);
              }
            }
            result[claim] = mergedValues;
          }
        } else if (typeof result[claim] === "object" && typeof values === "object") {
          result[claim] = this.mergeClaims(result[claim], values);
        } else {
          result[claim] = values;
        }
      }
    }
    return result;
  }
};

// src/DPoPStore.ts
var DPoPState = class {
  constructor(keys, nonce) {
    this.keys = keys;
    this.nonce = nonce;
  }
};

// src/OidcClient.ts
var OidcClient = class {
  constructor(settings, metadataService) {
    this._logger = new Logger("OidcClient");
    this.settings = settings instanceof OidcClientSettingsStore ? settings : new OidcClientSettingsStore(settings);
    this.metadataService = metadataService != null ? metadataService : new MetadataService(this.settings);
    this._claimsService = new ClaimsService(this.settings);
    this._validator = new ResponseValidator(this.settings, this.metadataService, this._claimsService);
    this._tokenClient = new TokenClient(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state,
    request,
    request_uri,
    request_type,
    id_token_hint,
    login_hint,
    skipUserInfo,
    nonce,
    url_state,
    response_type = this.settings.response_type,
    scope = this.settings.scope,
    redirect_uri = this.settings.redirect_uri,
    prompt = this.settings.prompt,
    display = this.settings.display,
    max_age = this.settings.max_age,
    ui_locales = this.settings.ui_locales,
    acr_values = this.settings.acr_values,
    resource = this.settings.resource,
    response_mode = this.settings.response_mode,
    extraQueryParams = this.settings.extraQueryParams,
    extraTokenParams = this.settings.extraTokenParams,
    dpopJkt,
    omitScopeWhenRequesting = this.settings.omitScopeWhenRequesting
  }) {
    const logger2 = this._logger.create("createSigninRequest");
    if (response_type !== "code") {
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    }
    const url = await this.metadataService.getAuthorizationEndpoint();
    logger2.debug("Received authorization endpoint", url);
    const signinRequest = await SigninRequest.create({
      url,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri,
      response_type,
      scope,
      state_data: state,
      url_state,
      prompt,
      display,
      max_age,
      ui_locales,
      id_token_hint,
      login_hint,
      acr_values,
      dpopJkt,
      resource,
      request,
      request_uri,
      extraQueryParams,
      extraTokenParams,
      request_type,
      response_mode,
      client_secret: this.settings.client_secret,
      skipUserInfo,
      nonce,
      disablePKCE: this.settings.disablePKCE,
      omitScopeWhenRequesting
    });
    await this.clearStaleState();
    const signinState = signinRequest.state;
    await this.settings.stateStore.set(signinState.id, signinState.toStorageString());
    return signinRequest;
  }
  async readSigninResponseState(url, removeState = false) {
    const logger2 = this._logger.create("readSigninResponseState");
    const response = new SigninResponse(UrlUtils.readParams(url, this.settings.response_mode));
    if (!response.state) {
      logger2.throw(new Error("No state in response"));
      throw null;
    }
    const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
    if (!storedStateString) {
      logger2.throw(new Error("No matching state found in storage"));
      throw null;
    }
    const state = await SigninState.fromStorageString(storedStateString);
    return { state, response };
  }
  async processSigninResponse(url, extraHeaders) {
    const logger2 = this._logger.create("processSigninResponse");
    const { state, response } = await this.readSigninResponseState(url, true);
    logger2.debug("received state from storage; validating response");
    if (this.settings.dpop && this.settings.dpop.store) {
      const dpopProof = await this.getDpopProof(this.settings.dpop.store);
      extraHeaders = { ...extraHeaders, "DPoP": dpopProof };
    }
    try {
      await this._validator.validateSigninResponse(response, state, extraHeaders);
    } catch (err) {
      if (err instanceof ErrorDPoPNonce && this.settings.dpop) {
        const dpopProof = await this.getDpopProof(this.settings.dpop.store, err.nonce);
        extraHeaders["DPoP"] = dpopProof;
        await this._validator.validateSigninResponse(response, state, extraHeaders);
      } else {
        throw err;
      }
    }
    return response;
  }
  async getDpopProof(dpopStore, nonce) {
    let keyPair;
    let dpopState;
    if (!(await dpopStore.getAllKeys()).includes(this.settings.client_id)) {
      keyPair = await CryptoUtils.generateDPoPKeys();
      dpopState = new DPoPState(keyPair, nonce);
      await dpopStore.set(this.settings.client_id, dpopState);
    } else {
      dpopState = await dpopStore.get(this.settings.client_id);
      if (dpopState.nonce !== nonce && nonce) {
        dpopState.nonce = nonce;
        await dpopStore.set(this.settings.client_id, dpopState);
      }
    }
    return await CryptoUtils.generateDPoPProof({
      url: await this.metadataService.getTokenEndpoint(false),
      httpMethod: "POST",
      keyPair: dpopState.keys,
      nonce: dpopState.nonce
    });
  }
  async processResourceOwnerPasswordCredentials({
    username,
    password,
    skipUserInfo = false,
    extraTokenParams = {}
  }) {
    const tokenResponse = await this._tokenClient.exchangeCredentials({ username, password, ...extraTokenParams });
    const signinResponse = new SigninResponse(new URLSearchParams());
    Object.assign(signinResponse, tokenResponse);
    await this._validator.validateCredentialsResponse(signinResponse, skipUserInfo);
    return signinResponse;
  }
  async useRefreshToken({
    state,
    redirect_uri,
    resource,
    timeoutInSeconds,
    extraHeaders,
    extraTokenParams
  }) {
    var _a;
    const logger2 = this._logger.create("useRefreshToken");
    let scope;
    if (this.settings.refreshTokenAllowedScope === void 0) {
      scope = state.scope;
    } else {
      const allowableScopes = this.settings.refreshTokenAllowedScope.split(" ");
      const providedScopes = ((_a = state.scope) == null ? void 0 : _a.split(" ")) || [];
      scope = providedScopes.filter((s) => allowableScopes.includes(s)).join(" ");
    }
    if (this.settings.dpop && this.settings.dpop.store) {
      const dpopProof = await this.getDpopProof(this.settings.dpop.store);
      extraHeaders = { ...extraHeaders, "DPoP": dpopProof };
    }
    let result;
    try {
      result = await this._tokenClient.exchangeRefreshToken({
        refresh_token: state.refresh_token,
        // provide the (possible filtered) scope list
        scope,
        redirect_uri,
        resource,
        timeoutInSeconds,
        extraHeaders,
        ...extraTokenParams
      });
    } catch (err) {
      if (err instanceof ErrorDPoPNonce && this.settings.dpop) {
        extraHeaders["DPoP"] = await this.getDpopProof(this.settings.dpop.store, err.nonce);
        result = await this._tokenClient.exchangeRefreshToken({
          refresh_token: state.refresh_token,
          // provide the (possible filtered) scope list
          scope,
          redirect_uri,
          resource,
          timeoutInSeconds,
          extraHeaders,
          ...extraTokenParams
        });
      } else {
        throw err;
      }
    }
    const response = new SigninResponse(new URLSearchParams());
    Object.assign(response, result);
    logger2.debug("validating response", response);
    await this._validator.validateRefreshResponse(response, {
      ...state,
      // override the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope
    });
    return response;
  }
  async createSignoutRequest({
    state,
    id_token_hint,
    client_id,
    request_type,
    post_logout_redirect_uri = this.settings.post_logout_redirect_uri,
    extraQueryParams = this.settings.extraQueryParams
  } = {}) {
    const logger2 = this._logger.create("createSignoutRequest");
    const url = await this.metadataService.getEndSessionEndpoint();
    if (!url) {
      logger2.throw(new Error("No end session endpoint"));
      throw null;
    }
    logger2.debug("Received end session endpoint", url);
    if (!client_id && post_logout_redirect_uri && !id_token_hint) {
      client_id = this.settings.client_id;
    }
    const request = new SignoutRequest({
      url,
      id_token_hint,
      client_id,
      post_logout_redirect_uri,
      state_data: state,
      extraQueryParams,
      request_type
    });
    await this.clearStaleState();
    const signoutState = request.state;
    if (signoutState) {
      logger2.debug("Signout request has state to persist");
      await this.settings.stateStore.set(signoutState.id, signoutState.toStorageString());
    }
    return request;
  }
  async readSignoutResponseState(url, removeState = false) {
    const logger2 = this._logger.create("readSignoutResponseState");
    const response = new SignoutResponse(UrlUtils.readParams(url, this.settings.response_mode));
    if (!response.state) {
      logger2.debug("No state in response");
      if (response.error) {
        logger2.warn("Response was error:", response.error);
        throw new ErrorResponse(response);
      }
      return { state: void 0, response };
    }
    const storedStateString = await this.settings.stateStore[removeState ? "remove" : "get"](response.state);
    if (!storedStateString) {
      logger2.throw(new Error("No matching state found in storage"));
      throw null;
    }
    const state = await State.fromStorageString(storedStateString);
    return { state, response };
  }
  async processSignoutResponse(url) {
    const logger2 = this._logger.create("processSignoutResponse");
    const { state, response } = await this.readSignoutResponseState(url, true);
    if (state) {
      logger2.debug("Received state from storage; validating response");
      this._validator.validateSignoutResponse(response, state);
    } else {
      logger2.debug("No state from storage; skipping response validation");
    }
    return response;
  }
  clearStaleState() {
    this._logger.create("clearStaleState");
    return State.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(token, type) {
    this._logger.create("revokeToken");
    return await this._tokenClient.revoke({
      token,
      token_type_hint: type
    });
  }
};

// src/SessionMonitor.ts
var SessionMonitor = class {
  constructor(_userManager) {
    this._userManager = _userManager;
    this._logger = new Logger("SessionMonitor");
    this._start = async (user) => {
      const session_state = user.session_state;
      if (!session_state) {
        return;
      }
      const logger2 = this._logger.create("_start");
      if (user.profile) {
        this._sub = user.profile.sub;
        logger2.debug("session_state", session_state, ", sub", this._sub);
      } else {
        this._sub = void 0;
        logger2.debug("session_state", session_state, ", anonymous user");
      }
      if (this._checkSessionIFrame) {
        this._checkSessionIFrame.start(session_state);
        return;
      }
      try {
        const url = await this._userManager.metadataService.getCheckSessionIframe();
        if (url) {
          logger2.debug("initializing check session iframe");
          const client_id = this._userManager.settings.client_id;
          const intervalInSeconds = this._userManager.settings.checkSessionIntervalInSeconds;
          const stopOnError = this._userManager.settings.stopCheckSessionOnError;
          const checkSessionIFrame = new CheckSessionIFrame(this._callback, client_id, url, intervalInSeconds, stopOnError);
          await checkSessionIFrame.load();
          this._checkSessionIFrame = checkSessionIFrame;
          checkSessionIFrame.start(session_state);
        } else {
          logger2.warn("no check session iframe found in the metadata");
        }
      } catch (err) {
        logger2.error("Error from getCheckSessionIframe:", err instanceof Error ? err.message : err);
      }
    };
    this._stop = () => {
      const logger2 = this._logger.create("_stop");
      this._sub = void 0;
      if (this._checkSessionIFrame) {
        this._checkSessionIFrame.stop();
      }
      if (this._userManager.settings.monitorAnonymousSession) {
        const timerHandle = setInterval(async () => {
          clearInterval(timerHandle);
          try {
            const session = await this._userManager.querySessionStatus();
            if (session) {
              const tmpUser = {
                session_state: session.session_state,
                profile: session.sub ? {
                  sub: session.sub
                } : null
              };
              void this._start(tmpUser);
            }
          } catch (err) {
            logger2.error("error from querySessionStatus", err instanceof Error ? err.message : err);
          }
        }, 1e3);
      }
    };
    this._callback = async () => {
      const logger2 = this._logger.create("_callback");
      try {
        const session = await this._userManager.querySessionStatus();
        let raiseEvent = true;
        if (session && this._checkSessionIFrame) {
          if (session.sub === this._sub) {
            raiseEvent = false;
            this._checkSessionIFrame.start(session.session_state);
            logger2.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", session.session_state);
            await this._userManager.events._raiseUserSessionChanged();
          } else {
            logger2.debug("different subject signed into OP", session.sub);
          }
        } else {
          logger2.debug("subject no longer signed into OP");
        }
        if (raiseEvent) {
          if (this._sub) {
            await this._userManager.events._raiseUserSignedOut();
          } else {
            await this._userManager.events._raiseUserSignedIn();
          }
        } else {
          logger2.debug("no change in session detected, no event to raise");
        }
      } catch (err) {
        if (this._sub) {
          logger2.debug("Error calling queryCurrentSigninSession; raising signed out event", err);
          await this._userManager.events._raiseUserSignedOut();
        }
      }
    };
    if (!_userManager) {
      this._logger.throw(new Error("No user manager passed"));
    }
    this._userManager.events.addUserLoaded(this._start);
    this._userManager.events.addUserUnloaded(this._stop);
    this._init().catch((err) => {
      this._logger.error(err);
    });
  }
  async _init() {
    this._logger.create("_init");
    const user = await this._userManager.getUser();
    if (user) {
      void this._start(user);
    } else if (this._userManager.settings.monitorAnonymousSession) {
      const session = await this._userManager.querySessionStatus();
      if (session) {
        const tmpUser = {
          session_state: session.session_state,
          profile: session.sub ? {
            sub: session.sub
          } : null
        };
        void this._start(tmpUser);
      }
    }
  }
};

// src/User.ts
var User = class _User {
  constructor(args) {
    var _a;
    this.id_token = args.id_token;
    this.session_state = (_a = args.session_state) != null ? _a : null;
    this.access_token = args.access_token;
    this.refresh_token = args.refresh_token;
    this.token_type = args.token_type;
    this.scope = args.scope;
    this.profile = args.profile;
    this.expires_at = args.expires_at;
    this.state = args.userState;
    this.url_state = args.url_state;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at === void 0) {
      return void 0;
    }
    return this.expires_at - Timer.getEpochTime();
  }
  set expires_in(value) {
    if (value !== void 0) {
      this.expires_at = Math.floor(value) + Timer.getEpochTime();
    }
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const expires_in = this.expires_in;
    if (expires_in === void 0) {
      return void 0;
    }
    return expires_in <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var _a, _b;
    return (_b = (_a = this.scope) == null ? void 0 : _a.split(" ")) != null ? _b : [];
  }
  toStorageString() {
    new Logger("User").create("toStorageString");
    return JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(storageString) {
    Logger.createStatic("User", "fromStorageString");
    return new _User(JSON.parse(storageString));
  }
};

// src/navigators/AbstractChildWindow.ts
var messageSource = "oidc-client";
var AbstractChildWindow = class {
  constructor() {
    this._abort = new Event("Window navigation aborted");
    this._disposeHandlers = /* @__PURE__ */ new Set();
    this._window = null;
  }
  async navigate(params) {
    const logger2 = this._logger.create("navigate");
    if (!this._window) {
      throw new Error("Attempted to navigate on a disposed window");
    }
    logger2.debug("setting URL in window");
    this._window.location.replace(params.url);
    const { url, keepOpen } = await new Promise((resolve, reject) => {
      const listener = (e) => {
        var _a;
        const data = e.data;
        const origin = (_a = params.scriptOrigin) != null ? _a : window.location.origin;
        if (e.origin !== origin || (data == null ? void 0 : data.source) !== messageSource) {
          return;
        }
        try {
          const state = UrlUtils.readParams(data.url, params.response_mode).get("state");
          if (!state) {
            logger2.warn("no state found in response url");
          }
          if (e.source !== this._window && state !== params.state) {
            return;
          }
        } catch (err) {
          this._dispose();
          reject(new Error("Invalid response from window"));
        }
        resolve(data);
      };
      window.addEventListener("message", listener, false);
      this._disposeHandlers.add(() => window.removeEventListener("message", listener, false));
      this._disposeHandlers.add(this._abort.addHandler((reason) => {
        this._dispose();
        reject(reason);
      }));
    });
    logger2.debug("got response from window");
    this._dispose();
    if (!keepOpen) {
      this.close();
    }
    return { url };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const dispose of this._disposeHandlers) {
      dispose();
    }
    this._disposeHandlers.clear();
  }
  static _notifyParent(parent, url, keepOpen = false, targetOrigin = window.location.origin) {
    parent.postMessage({
      source: messageSource,
      url,
      keepOpen
    }, targetOrigin);
  }
};

// src/UserManagerSettings.ts
var DefaultPopupWindowFeatures = {
  location: false,
  toolbar: false,
  height: 640,
  closePopupWindowAfterInSeconds: -1
};
var DefaultPopupTarget = "_blank";
var DefaultAccessTokenExpiringNotificationTimeInSeconds = 60;
var DefaultCheckSessionIntervalInSeconds = 2;
var DefaultSilentRequestTimeoutInSeconds = 10;
var UserManagerSettingsStore = class extends OidcClientSettingsStore {
  constructor(args) {
    const {
      popup_redirect_uri = args.redirect_uri,
      popup_post_logout_redirect_uri = args.post_logout_redirect_uri,
      popupWindowFeatures = DefaultPopupWindowFeatures,
      popupWindowTarget = DefaultPopupTarget,
      redirectMethod = "assign",
      redirectTarget = "self",
      iframeNotifyParentOrigin = args.iframeNotifyParentOrigin,
      iframeScriptOrigin = args.iframeScriptOrigin,
      requestTimeoutInSeconds,
      silent_redirect_uri = args.redirect_uri,
      silentRequestTimeoutInSeconds,
      automaticSilentRenew = true,
      validateSubOnSilentRenew = true,
      includeIdTokenInSilentRenew = false,
      monitorSession = false,
      monitorAnonymousSession = false,
      checkSessionIntervalInSeconds = DefaultCheckSessionIntervalInSeconds,
      query_status_response_type = "code",
      stopCheckSessionOnError = true,
      revokeTokenTypes = ["access_token", "refresh_token"],
      revokeTokensOnSignout = false,
      includeIdTokenInSilentSignout = false,
      accessTokenExpiringNotificationTimeInSeconds = DefaultAccessTokenExpiringNotificationTimeInSeconds,
      userStore
    } = args;
    super(args);
    this.popup_redirect_uri = popup_redirect_uri;
    this.popup_post_logout_redirect_uri = popup_post_logout_redirect_uri;
    this.popupWindowFeatures = popupWindowFeatures;
    this.popupWindowTarget = popupWindowTarget;
    this.redirectMethod = redirectMethod;
    this.redirectTarget = redirectTarget;
    this.iframeNotifyParentOrigin = iframeNotifyParentOrigin;
    this.iframeScriptOrigin = iframeScriptOrigin;
    this.silent_redirect_uri = silent_redirect_uri;
    this.silentRequestTimeoutInSeconds = silentRequestTimeoutInSeconds || requestTimeoutInSeconds || DefaultSilentRequestTimeoutInSeconds;
    this.automaticSilentRenew = automaticSilentRenew;
    this.validateSubOnSilentRenew = validateSubOnSilentRenew;
    this.includeIdTokenInSilentRenew = includeIdTokenInSilentRenew;
    this.monitorSession = monitorSession;
    this.monitorAnonymousSession = monitorAnonymousSession;
    this.checkSessionIntervalInSeconds = checkSessionIntervalInSeconds;
    this.stopCheckSessionOnError = stopCheckSessionOnError;
    this.query_status_response_type = query_status_response_type;
    this.revokeTokenTypes = revokeTokenTypes;
    this.revokeTokensOnSignout = revokeTokensOnSignout;
    this.includeIdTokenInSilentSignout = includeIdTokenInSilentSignout;
    this.accessTokenExpiringNotificationTimeInSeconds = accessTokenExpiringNotificationTimeInSeconds;
    if (userStore) {
      this.userStore = userStore;
    } else {
      const store = typeof window !== "undefined" ? window.sessionStorage : new InMemoryWebStorage();
      this.userStore = new WebStorageStateStore({ store });
    }
  }
};

// src/navigators/IFrameWindow.ts
var IFrameWindow = class _IFrameWindow extends AbstractChildWindow {
  constructor({
    silentRequestTimeoutInSeconds = DefaultSilentRequestTimeoutInSeconds
  }) {
    super();
    this._logger = new Logger("IFrameWindow");
    this._timeoutInSeconds = silentRequestTimeoutInSeconds;
    this._frame = _IFrameWindow.createHiddenIframe();
    this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const iframe = window.document.createElement("iframe");
    iframe.style.visibility = "hidden";
    iframe.style.position = "fixed";
    iframe.style.left = "-1000px";
    iframe.style.top = "0";
    iframe.width = "0";
    iframe.height = "0";
    window.document.body.appendChild(iframe);
    return iframe;
  }
  async navigate(params) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const timer = setTimeout(() => void this._abort.raise(new ErrorTimeout("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
    this._disposeHandlers.add(() => clearTimeout(timer));
    return await super.navigate(params);
  }
  close() {
    var _a;
    if (this._frame) {
      if (this._frame.parentNode) {
        this._frame.addEventListener("load", (ev) => {
          var _a2;
          const frame = ev.target;
          (_a2 = frame.parentNode) == null ? void 0 : _a2.removeChild(frame);
          void this._abort.raise(new Error("IFrame removed from DOM"));
        }, true);
        (_a = this._frame.contentWindow) == null ? void 0 : _a.location.replace("about:blank");
      }
      this._frame = null;
    }
    this._window = null;
  }
  static notifyParent(url, targetOrigin) {
    return super._notifyParent(window.parent, url, false, targetOrigin);
  }
};

// src/navigators/IFrameNavigator.ts
var IFrameNavigator = class {
  constructor(_settings) {
    this._settings = _settings;
    this._logger = new Logger("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new IFrameWindow({ silentRequestTimeoutInSeconds });
  }
  async callback(url) {
    this._logger.create("callback");
    IFrameWindow.notifyParent(url, this._settings.iframeNotifyParentOrigin);
  }
};

// src/navigators/PopupWindow.ts
var checkForPopupClosedInterval = 500;
var second = 1e3;
var PopupWindow = class extends AbstractChildWindow {
  constructor({
    popupWindowTarget = DefaultPopupTarget,
    popupWindowFeatures = {},
    popupSignal
  }) {
    super();
    this._logger = new Logger("PopupWindow");
    const centeredPopup = PopupUtils.center({ ...DefaultPopupWindowFeatures, ...popupWindowFeatures });
    this._window = window.open(void 0, popupWindowTarget, PopupUtils.serialize(centeredPopup));
    if (popupSignal) {
      popupSignal.addEventListener("abort", () => {
        var _a;
        void this._abort.raise(new Error((_a = popupSignal.reason) != null ? _a : "Popup aborted"));
      });
    }
    if (popupWindowFeatures.closePopupWindowAfterInSeconds && popupWindowFeatures.closePopupWindowAfterInSeconds > 0) {
      setTimeout(() => {
        if (!this._window || typeof this._window.closed !== "boolean" || this._window.closed) {
          void this._abort.raise(new Error("Popup blocked by user"));
          return;
        }
        this.close();
      }, popupWindowFeatures.closePopupWindowAfterInSeconds * second);
    }
  }
  async navigate(params) {
    var _a;
    (_a = this._window) == null ? void 0 : _a.focus();
    const popupClosedInterval = setInterval(() => {
      if (!this._window || this._window.closed) {
        void this._abort.raise(new Error("Popup closed by user"));
      }
    }, checkForPopupClosedInterval);
    this._disposeHandlers.add(() => clearInterval(popupClosedInterval));
    return await super.navigate(params);
  }
  close() {
    if (this._window) {
      if (!this._window.closed) {
        this._window.close();
        void this._abort.raise(new Error("Popup closed"));
      }
    }
    this._window = null;
  }
  static notifyOpener(url, keepOpen) {
    if (!window.opener) {
      throw new Error("No window.opener. Can't complete notification.");
    }
    return super._notifyParent(window.opener, url, keepOpen);
  }
};

// src/navigators/PopupNavigator.ts
var PopupNavigator = class {
  constructor(_settings) {
    this._settings = _settings;
    this._logger = new Logger("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures = this._settings.popupWindowFeatures,
    popupWindowTarget = this._settings.popupWindowTarget,
    popupSignal
  }) {
    return new PopupWindow({ popupWindowFeatures, popupWindowTarget, popupSignal });
  }
  async callback(url, { keepOpen = false }) {
    this._logger.create("callback");
    PopupWindow.notifyOpener(url, keepOpen);
  }
};

// src/navigators/RedirectNavigator.ts
var RedirectNavigator = class {
  constructor(_settings) {
    this._settings = _settings;
    this._logger = new Logger("RedirectNavigator");
  }
  async prepare({
    redirectMethod = this._settings.redirectMethod,
    redirectTarget = this._settings.redirectTarget
  }) {
    var _a;
    this._logger.create("prepare");
    let targetWindow = window.self;
    if (redirectTarget === "top") {
      targetWindow = (_a = window.top) != null ? _a : window.self;
    }
    const redirect = targetWindow.location[redirectMethod].bind(targetWindow.location);
    let abort;
    return {
      navigate: async (params) => {
        this._logger.create("navigate");
        const promise = new Promise((resolve, reject) => {
          abort = reject;
        });
        redirect(params.url);
        return await promise;
      },
      close: () => {
        this._logger.create("close");
        abort == null ? void 0 : abort(new Error("Redirect aborted"));
        targetWindow.stop();
      }
    };
  }
  async callback() {
    return;
  }
};

// src/UserManagerEvents.ts
var UserManagerEvents = class extends AccessTokenEvents {
  constructor(settings) {
    super({ expiringNotificationTimeInSeconds: settings.accessTokenExpiringNotificationTimeInSeconds });
    this._logger = new Logger("UserManagerEvents");
    this._userLoaded = new Event("User loaded");
    this._userUnloaded = new Event("User unloaded");
    this._silentRenewError = new Event("Silent renew error");
    this._userSignedIn = new Event("User signed in");
    this._userSignedOut = new Event("User signed out");
    this._userSessionChanged = new Event("User session changed");
  }
  async load(user, raiseEvent = true) {
    super.load(user);
    if (raiseEvent) {
      await this._userLoaded.raise(user);
    }
  }
  async unload() {
    super.unload();
    await this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(cb) {
    return this._userLoaded.addHandler(cb);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(cb) {
    return this._userLoaded.removeHandler(cb);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(cb) {
    return this._userUnloaded.addHandler(cb);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(cb) {
    return this._userUnloaded.removeHandler(cb);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(cb) {
    return this._silentRenewError.addHandler(cb);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(cb) {
    return this._silentRenewError.removeHandler(cb);
  }
  /**
   * @internal
   */
  async _raiseSilentRenewError(e) {
    await this._silentRenewError.raise(e);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(cb) {
    return this._userSignedIn.addHandler(cb);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(cb) {
    this._userSignedIn.removeHandler(cb);
  }
  /**
   * @internal
   */
  async _raiseUserSignedIn() {
    await this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(cb) {
    return this._userSignedOut.addHandler(cb);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(cb) {
    this._userSignedOut.removeHandler(cb);
  }
  /**
   * @internal
   */
  async _raiseUserSignedOut() {
    await this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(cb) {
    return this._userSessionChanged.addHandler(cb);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(cb) {
    this._userSessionChanged.removeHandler(cb);
  }
  /**
   * @internal
   */
  async _raiseUserSessionChanged() {
    await this._userSessionChanged.raise();
  }
};

// src/SilentRenewService.ts
var SilentRenewService = class {
  constructor(_userManager) {
    this._userManager = _userManager;
    this._logger = new Logger("SilentRenewService");
    this._isStarted = false;
    this._retryTimer = new Timer("Retry Silent Renew");
    this._tokenExpiring = async () => {
      const logger2 = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent();
        logger2.debug("silent token renewal successful");
      } catch (err) {
        if (err instanceof ErrorTimeout) {
          logger2.warn("ErrorTimeout from signinSilent:", err, "retry in 5s");
          this._retryTimer.init(5);
          return;
        }
        logger2.error("Error from signinSilent:", err);
        await this._userManager.events._raiseSilentRenewError(err);
      }
    };
  }
  async start() {
    const logger2 = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = true;
      this._userManager.events.addAccessTokenExpiring(this._tokenExpiring);
      this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (err) {
        logger2.error("getUser error", err);
      }
    }
  }
  stop() {
    if (this._isStarted) {
      this._retryTimer.cancel();
      this._retryTimer.removeHandler(this._tokenExpiring);
      this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring);
      this._isStarted = false;
    }
  }
};

// src/RefreshState.ts
var RefreshState = class {
  constructor(args) {
    this.refresh_token = args.refresh_token;
    this.id_token = args.id_token;
    this.session_state = args.session_state;
    this.scope = args.scope;
    this.profile = args.profile;
    this.data = args.state;
  }
};

// src/UserManager.ts
var UserManager = class {
  constructor(settings, redirectNavigator, popupNavigator, iframeNavigator) {
    this._logger = new Logger("UserManager");
    this.settings = new UserManagerSettingsStore(settings);
    this._client = new OidcClient(settings);
    this._redirectNavigator = redirectNavigator != null ? redirectNavigator : new RedirectNavigator(this.settings);
    this._popupNavigator = popupNavigator != null ? popupNavigator : new PopupNavigator(this.settings);
    this._iframeNavigator = iframeNavigator != null ? iframeNavigator : new IFrameNavigator(this.settings);
    this._events = new UserManagerEvents(this.settings);
    this._silentRenewService = new SilentRenewService(this);
    if (this.settings.automaticSilentRenew) {
      this.startSilentRenew();
    }
    this._sessionMonitor = null;
    if (this.settings.monitorSession) {
      this._sessionMonitor = new SessionMonitor(this);
    }
  }
  /**
   * Get object used to register for events raised by the `UserManager`.
   */
  get events() {
    return this._events;
  }
  /**
   * Get object used to access the metadata configuration of the identity provider.
   */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Load the `User` object for the currently authenticated user.
   *
   * @returns A promise
   */
  async getUser() {
    const logger2 = this._logger.create("getUser");
    const user = await this._loadUser();
    if (user) {
      logger2.info("user loaded");
      await this._events.load(user, false);
      return user;
    }
    logger2.info("user not found in storage");
    return null;
  }
  /**
   * Remove from any storage the currently authenticated user.
   *
   * @returns A promise
   */
  async removeUser() {
    const logger2 = this._logger.create("removeUser");
    await this.storeUser(null);
    logger2.info("user removed from storage");
    await this._events.unload();
  }
  /**
   * Trigger a redirect of the current window to the authorization endpoint.
   *
   * @returns A promise
   *
   * @throws `Error` In cases of wrong authentication.
   */
  async signinRedirect(args = {}) {
    var _a;
    this._logger.create("signinRedirect");
    const {
      redirectMethod,
      ...requestArgs
    } = args;
    let dpopJkt;
    if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) {
      dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
    }
    const handle = await this._redirectNavigator.prepare({ redirectMethod });
    await this._signinStart({
      request_type: "si:r",
      dpopJkt,
      ...requestArgs
    }, handle);
  }
  /**
   * Process the response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise containing the authenticated `User`.
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinRedirectCallback(url = window.location.href) {
    const logger2 = this._logger.create("signinRedirectCallback");
    const user = await this._signinEnd(url);
    if (user.profile && user.profile.sub) {
      logger2.info("success, signed in subject", user.profile.sub);
    } else {
      logger2.info("no subject");
    }
    return user;
  }
  /**
   * Trigger the signin with user/password.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws {@link ErrorResponse} In cases of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username,
    password,
    skipUserInfo = false
  }) {
    const logger2 = this._logger.create("signinResourceOwnerCredential");
    const signinResponse = await this._client.processResourceOwnerPasswordCredentials({
      username,
      password,
      skipUserInfo,
      extraTokenParams: this.settings.extraTokenParams
    });
    logger2.debug("got signin response");
    const user = await this._buildUser(signinResponse);
    if (user.profile && user.profile.sub) {
      logger2.info("success, signed in subject", user.profile.sub);
    } else {
      logger2.info("no subject");
    }
    return user;
  }
  /**
   * Trigger a request (via a popup window) to the authorization endpoint.
   *
   * @returns A promise containing the authenticated `User`.
   * @throws `Error` In cases of wrong authentication.
   */
  async signinPopup(args = {}) {
    var _a;
    const logger2 = this._logger.create("signinPopup");
    let dpopJkt;
    if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) {
      dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
    }
    const {
      popupWindowFeatures,
      popupWindowTarget,
      popupSignal,
      ...requestArgs
    } = args;
    const url = this.settings.popup_redirect_uri;
    if (!url) {
      logger2.throw(new Error("No popup_redirect_uri configured"));
    }
    const handle = await this._popupNavigator.prepare({ popupWindowFeatures, popupWindowTarget, popupSignal });
    const user = await this._signin({
      request_type: "si:p",
      redirect_uri: url,
      display: "popup",
      dpopJkt,
      ...requestArgs
    }, handle);
    if (user) {
      if (user.profile && user.profile.sub) {
        logger2.info("success, signed in subject", user.profile.sub);
      } else {
        logger2.info("no subject");
      }
    }
    return user;
  }
  /**
   * Notify the opening window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinPopupCallback(url = window.location.href, keepOpen = false) {
    const logger2 = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(url, { keepOpen });
    logger2.info("success");
  }
  /**
   * Trigger a silent request (via refresh token or an iframe) to the authorization endpoint.
   *
   * @returns A promise that contains the authenticated `User`.
   */
  async signinSilent(args = {}) {
    var _a, _b;
    const logger2 = this._logger.create("signinSilent");
    const {
      silentRequestTimeoutInSeconds,
      ...requestArgs
    } = args;
    let user = await this._loadUser();
    if (user == null ? void 0 : user.refresh_token) {
      logger2.debug("using refresh token");
      const state = new RefreshState(user);
      return await this._useRefreshToken({
        state,
        redirect_uri: requestArgs.redirect_uri,
        resource: requestArgs.resource,
        extraTokenParams: requestArgs.extraTokenParams,
        timeoutInSeconds: silentRequestTimeoutInSeconds
      });
    }
    let dpopJkt;
    if ((_a = this.settings.dpop) == null ? void 0 : _a.bind_authorization_code) {
      dpopJkt = await this.generateDPoPJkt(this.settings.dpop);
    }
    const url = this.settings.silent_redirect_uri;
    if (!url) {
      logger2.throw(new Error("No silent_redirect_uri configured"));
    }
    let verifySub;
    if (user && this.settings.validateSubOnSilentRenew) {
      logger2.debug("subject prior to silent renew:", user.profile.sub);
      verifySub = user.profile.sub;
    }
    const handle = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds });
    user = await this._signin({
      request_type: "si:s",
      redirect_uri: url,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
      dpopJkt,
      ...requestArgs
    }, handle, verifySub);
    if (user) {
      if ((_b = user.profile) == null ? void 0 : _b.sub) {
        logger2.info("success, signed in subject", user.profile.sub);
      } else {
        logger2.info("no subject");
      }
    }
    return user;
  }
  async _useRefreshToken(args) {
    const response = await this._client.useRefreshToken({
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds,
      ...args
    });
    const user = new User({ ...args.state, ...response });
    await this.storeUser(user);
    await this._events.load(user);
    return user;
  }
  /**
   *
   * Notify the parent window of response (callback) from the authorization endpoint.
   * It is recommended to use {@link UserManager.signinCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signinCallback}
   */
  async signinSilentCallback(url = window.location.href) {
    const logger2 = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(url);
    logger2.info("success");
  }
  /**
   * Process any response (callback) from the authorization endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signinRedirectCallback}
   * - {@link UserManager.signinPopupCallback}
   * - {@link UserManager.signinSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signin cannot be processed.
   */
  async signinCallback(url = window.location.href) {
    const { state } = await this._client.readSigninResponseState(url);
    switch (state.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(url);
      case "si:p":
        await this.signinPopupCallback(url);
        break;
      case "si:s":
        await this.signinSilentCallback(url);
        break;
      default:
        throw new Error("invalid response_type in state");
    }
    return void 0;
  }
  /**
   * Process any response (callback) from the end session endpoint, by dispatching the request_type
   * and executing one of the following functions:
   * - {@link UserManager.signoutRedirectCallback}
   * - {@link UserManager.signoutPopupCallback}
   * - {@link UserManager.signoutSilentCallback}
   *
   * @throws `Error` If request_type is unknown or signout cannot be processed.
   */
  async signoutCallback(url = window.location.href, keepOpen = false) {
    const { state } = await this._client.readSignoutResponseState(url);
    if (!state) {
      return void 0;
    }
    switch (state.request_type) {
      case "so:r":
        return await this.signoutRedirectCallback(url);
      case "so:p":
        await this.signoutPopupCallback(url, keepOpen);
        break;
      case "so:s":
        await this.signoutSilentCallback(url);
        break;
      default:
        throw new Error("invalid response_type in state");
    }
    return void 0;
  }
  /**
   * Query OP for user's current signin status.
   *
   * @returns A promise object with session_state and subject identifier.
   */
  async querySessionStatus(args = {}) {
    const logger2 = this._logger.create("querySessionStatus");
    const {
      silentRequestTimeoutInSeconds,
      ...requestArgs
    } = args;
    const url = this.settings.silent_redirect_uri;
    if (!url) {
      logger2.throw(new Error("No silent_redirect_uri configured"));
    }
    const user = await this._loadUser();
    const handle = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds });
    const navResponse = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: url,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? user == null ? void 0 : user.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: true,
      ...requestArgs
    }, handle);
    try {
      const extraHeaders = {};
      const signinResponse = await this._client.processSigninResponse(navResponse.url, extraHeaders);
      logger2.debug("got signin response");
      if (signinResponse.session_state && signinResponse.profile.sub) {
        logger2.info("success for subject", signinResponse.profile.sub);
        return {
          session_state: signinResponse.session_state,
          sub: signinResponse.profile.sub
        };
      }
      logger2.info("success, user not authenticated");
      return null;
    } catch (err) {
      if (this.settings.monitorAnonymousSession && err instanceof ErrorResponse) {
        switch (err.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            logger2.info("success for anonymous user");
            return {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              session_state: err.session_state
            };
        }
      }
      throw err;
    }
  }
  async _signin(args, handle, verifySub) {
    const navResponse = await this._signinStart(args, handle);
    return await this._signinEnd(navResponse.url, verifySub);
  }
  async _signinStart(args, handle) {
    const logger2 = this._logger.create("_signinStart");
    try {
      const signinRequest = await this._client.createSigninRequest(args);
      logger2.debug("got signin request");
      return await handle.navigate({
        url: signinRequest.url,
        state: signinRequest.state.id,
        response_mode: signinRequest.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (err) {
      logger2.debug("error after preparing navigator, closing navigator window");
      handle.close();
      throw err;
    }
  }
  async _signinEnd(url, verifySub) {
    const logger2 = this._logger.create("_signinEnd");
    const extraHeaders = {};
    const signinResponse = await this._client.processSigninResponse(url, extraHeaders);
    logger2.debug("got signin response");
    const user = await this._buildUser(signinResponse, verifySub);
    return user;
  }
  async _buildUser(signinResponse, verifySub) {
    const logger2 = this._logger.create("_buildUser");
    const user = new User(signinResponse);
    if (verifySub) {
      if (verifySub !== user.profile.sub) {
        logger2.debug("current user does not match user returned from signin. sub from signin:", user.profile.sub);
        throw new ErrorResponse({ ...signinResponse, error: "login_required" });
      }
      logger2.debug("current user matches user returned from signin");
    }
    await this.storeUser(user);
    logger2.debug("user stored");
    await this._events.load(user);
    return user;
  }
  /**
   * Trigger a redirect of the current window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutRedirect(args = {}) {
    const logger2 = this._logger.create("signoutRedirect");
    const {
      redirectMethod,
      ...requestArgs
    } = args;
    const handle = await this._redirectNavigator.prepare({ redirectMethod });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...requestArgs
    }, handle);
    logger2.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise containing signout response
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutRedirectCallback(url = window.location.href) {
    const logger2 = this._logger.create("signoutRedirectCallback");
    const response = await this._signoutEnd(url);
    logger2.info("success");
    return response;
  }
  /**
   * Trigger a redirect of a popup window to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutPopup(args = {}) {
    const logger2 = this._logger.create("signoutPopup");
    const {
      popupWindowFeatures,
      popupWindowTarget,
      popupSignal,
      ...requestArgs
    } = args;
    const url = this.settings.popup_post_logout_redirect_uri;
    const handle = await this._popupNavigator.prepare({ popupWindowFeatures, popupWindowTarget, popupSignal });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: url,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: url == null ? void 0 : {},
      ...requestArgs
    }, handle);
    logger2.info("success");
  }
  /**
   * Process response (callback) from the end session endpoint from a popup window.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutPopupCallback(url = window.location.href, keepOpen = false) {
    const logger2 = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(url, { keepOpen });
    logger2.info("success");
  }
  async _signout(args, handle) {
    const navResponse = await this._signoutStart(args, handle);
    return await this._signoutEnd(navResponse.url);
  }
  async _signoutStart(args = {}, handle) {
    var _a;
    const logger2 = this._logger.create("_signoutStart");
    try {
      const user = await this._loadUser();
      logger2.debug("loaded current user from storage");
      if (this.settings.revokeTokensOnSignout) {
        await this._revokeInternal(user);
      }
      const id_token = args.id_token_hint || user && user.id_token;
      if (id_token) {
        logger2.debug("setting id_token_hint in signout request");
        args.id_token_hint = id_token;
      }
      await this.removeUser();
      logger2.debug("user removed, creating signout request");
      const signoutRequest = await this._client.createSignoutRequest(args);
      logger2.debug("got signout request");
      return await handle.navigate({
        url: signoutRequest.url,
        state: (_a = signoutRequest.state) == null ? void 0 : _a.id,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (err) {
      logger2.debug("error after preparing navigator, closing navigator window");
      handle.close();
      throw err;
    }
  }
  async _signoutEnd(url) {
    const logger2 = this._logger.create("_signoutEnd");
    const signoutResponse = await this._client.processSignoutResponse(url);
    logger2.debug("got signout response");
    return signoutResponse;
  }
  /**
   * Trigger a silent request (via an iframe) to the end session endpoint.
   *
   * @returns A promise
   */
  async signoutSilent(args = {}) {
    var _a;
    const logger2 = this._logger.create("signoutSilent");
    const {
      silentRequestTimeoutInSeconds,
      ...requestArgs
    } = args;
    const id_token_hint = this.settings.includeIdTokenInSilentSignout ? (_a = await this._loadUser()) == null ? void 0 : _a.id_token : void 0;
    const url = this.settings.popup_post_logout_redirect_uri;
    const handle = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: url,
      id_token_hint,
      ...requestArgs
    }, handle);
    logger2.info("success");
  }
  /**
   * Notify the parent window of response (callback) from the end session endpoint.
   * It is recommended to use {@link UserManager.signoutCallback} instead.
   *
   * @returns A promise
   *
   * @see {@link UserManager.signoutCallback}
   */
  async signoutSilentCallback(url = window.location.href) {
    const logger2 = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(url);
    logger2.info("success");
  }
  async revokeTokens(types) {
    const user = await this._loadUser();
    await this._revokeInternal(user, types);
  }
  async _revokeInternal(user, types = this.settings.revokeTokenTypes) {
    const logger2 = this._logger.create("_revokeInternal");
    if (!user) return;
    const typesPresent = types.filter((type) => typeof user[type] === "string");
    if (!typesPresent.length) {
      logger2.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const type of typesPresent) {
      await this._client.revokeToken(
        user[type],
        // eslint-disable-line @typescript-eslint/no-non-null-assertion
        type
      );
      logger2.info(`${type} revoked successfully`);
      if (type !== "access_token") {
        user[type] = null;
      }
    }
    await this.storeUser(user);
    logger2.debug("user stored");
    await this._events.load(user);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew");
    void this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const logger2 = this._logger.create("_loadUser");
    const storageString = await this.settings.userStore.get(this._userStoreKey);
    if (storageString) {
      logger2.debug("user storageString loaded");
      return User.fromStorageString(storageString);
    }
    logger2.debug("no user storageString");
    return null;
  }
  async storeUser(user) {
    const logger2 = this._logger.create("storeUser");
    if (user) {
      logger2.debug("storing user");
      const storageString = user.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, storageString);
    } else {
      this._logger.debug("removing user");
      await this.settings.userStore.remove(this._userStoreKey);
      if (this.settings.dpop) {
        await this.settings.dpop.store.remove(this.settings.client_id);
      }
    }
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
  /**
   * Dynamically generates a DPoP proof for a given user, URL and optional Http method.
   * This method is useful when you need to make a request to a resource server
   * with fetch or similar, and you need to include a DPoP proof in a DPoP header.
   * @param url - The URL to generate the DPoP proof for
   * @param user - The user to generate the DPoP proof for
   * @param httpMethod - Optional, defaults to "GET"
   * @param nonce - Optional nonce provided by the resource server
   *
   * @returns A promise containing the DPoP proof or undefined if DPoP is not enabled/no user is found.
   */
  async dpopProof(url, user, httpMethod, nonce) {
    var _a, _b;
    const dpopState = await ((_b = (_a = this.settings.dpop) == null ? void 0 : _a.store) == null ? void 0 : _b.get(this.settings.client_id));
    if (dpopState) {
      return await CryptoUtils.generateDPoPProof({
        url,
        accessToken: user == null ? void 0 : user.access_token,
        httpMethod,
        keyPair: dpopState.keys,
        nonce
      });
    }
    return void 0;
  }
  async generateDPoPJkt(dpopSettings) {
    let dpopState = await dpopSettings.store.get(this.settings.client_id);
    if (!dpopState) {
      const dpopKeys = await CryptoUtils.generateDPoPKeys();
      dpopState = new DPoPState(dpopKeys);
      await dpopSettings.store.set(this.settings.client_id, dpopState);
    }
    return await CryptoUtils.generateDPoPJkt(dpopState.keys);
  }
};

// package.json
var version = "3.1.0";

// src/Version.ts
var Version = (/* unused pure expression or super */ null && (version));

// src/IndexedDbDPoPStore.ts
var IndexedDbDPoPStore = class {
  constructor() {
    this._dbName = "oidc";
    this._storeName = "dpop";
  }
  async set(key, value) {
    const store = await this.createStore(this._dbName, this._storeName);
    await store("readwrite", (str) => {
      str.put(value, key);
      return this.promisifyRequest(str.transaction);
    });
  }
  async get(key) {
    const store = await this.createStore(this._dbName, this._storeName);
    return await store("readonly", (str) => {
      return this.promisifyRequest(str.get(key));
    });
  }
  async remove(key) {
    const item = await this.get(key);
    const store = await this.createStore(this._dbName, this._storeName);
    await store("readwrite", (str) => {
      return this.promisifyRequest(str.delete(key));
    });
    return item;
  }
  async getAllKeys() {
    const store = await this.createStore(this._dbName, this._storeName);
    return await store("readonly", (str) => {
      return this.promisifyRequest(str.getAllKeys());
    });
  }
  promisifyRequest(request) {
    return new Promise((resolve, reject) => {
      request.oncomplete = request.onsuccess = () => resolve(request.result);
      request.onabort = request.onerror = () => reject(request.error);
    });
  }
  async createStore(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    const db = await this.promisifyRequest(request);
    return async (txMode, callback) => {
      const tx = db.transaction(storeName, txMode);
      const store = tx.objectStore(storeName);
      return await callback(store);
    };
  }
};

//# sourceMappingURL=oidc-client-ts.js.map

// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
;// CONCATENATED MODULE: ../../../libs/data/user/src/lib/util/preferences.ts
const mapPreferenceUpdateToUpdatedPreferences = (updatePreferences)=>{
    const updatedUserProfilePreferences = {};
    if (updatePreferences.preferenceCall) {
        updatedUserProfilePreferences.preferenceCall = updatePreferences.preferenceCall.value;
    }
    if (updatePreferences.preferenceEmail) {
        updatedUserProfilePreferences.preferenceEmail = updatePreferences.preferenceEmail.value;
    }
    if (updatePreferences.preferenceSms) {
        updatedUserProfilePreferences.preferenceSms = updatePreferences.preferenceSms.value;
    }
    return updatedUserProfilePreferences;
};

;// CONCATENATED MODULE: ../../../libs/data/user/src/lib/data-user.tsx







let userStoreConfig = {
    authKey: "",
    legacyAuthKey: "",
    profileServiceUrl: "",
    identityServiceUrl: "",
    auth0ServiceUrl: "",
    auth0DatabaseName: "",
    auth0ClientId: "",
    redirectUrlKey: "",
    cinchUrl: ""
};
let httpClient;
let userManagerInstance;
let onSessionExpiredCallback;
const initUserStore = (config, axiosImpl = (axios_default()))=>{
    const useRefreshToken = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.UseRefreshToken */.X.UseRefreshToken) === "true";
    userStoreConfig = {
        identityServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.IdentityServiceUrl */.X.IdentityServiceUrl),
        auth0ServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.Auth0ServiceUrl */.X.Auth0ServiceUrl),
        auth0DatabaseName: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.Auth0DatabaseName */.X.Auth0DatabaseName),
        auth0ClientId: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.Auth0ClientId */.X.Auth0ClientId),
        profileServiceUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ProfileServiceUrl */.X.ProfileServiceUrl),
        redirectUrlKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.RedirectUrlKey */.X.RedirectUrlKey),
        authKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AuthKey */.X.AuthKey),
        legacyAuthKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.LegacyAuthKey */.X.LegacyAuthKey),
        cinchUrl: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.cinchUrl */.X.cinchUrl),
        ...config
    };
    const _httpClient = axiosImpl.create();
    let accessToken;
    _httpClient.interceptors.request.use(async (request)=>{
        if (useRefreshToken) {
            console.log("Initiating user manager...");
            if (userManagerInstance) {
                main/* datadogRum.addAction */.v.addAction("Fetching existing user");
                const user = await userManagerInstance.getUser();
                request.headers = {
                    ...request.headers,
                    Authorization: `Bearer ${user === null || user === void 0 ? void 0 : user.access_token}`
                };
                return request;
            }
            main/* datadogRum.addAction */.v.addAction("Initiating UserManager");
            userManagerInstance = new UserManager({
                authority: userStoreConfig.auth0ServiceUrl,
                client_id: userStoreConfig.auth0ClientId,
                redirect_uri: `${window.location.origin}/auth-callback/`,
                silent_redirect_uri: `${window.location.origin}/auth-callback/`,
                post_logout_redirect_uri: `${window.location.origin}/`,
                response_type: "code",
                scope: "openid profile email offline_access",
                automaticSilentRenew: true,
                loadUserInfo: false,
                userStore: new WebStorageStateStore({
                    prefix: "oxford-",
                    store: window.localStorage
                })
            });
            const storedUser = localStorage.getItem(userStoreConfig.authKey);
            let userFromStorage = null;
            if (storedUser) {
                userFromStorage = new User(JSON.parse(storedUser));
                userManagerInstance.storeUser(userFromStorage);
            }
            const user1 = await userManagerInstance.getUser();
            userManagerInstance.events.addSilentRenewError(async ()=>{
                main/* datadogRum.addError */.v.addError(new Error("AddSilentRenewError"));
                userManagerInstance.clearStaleState();
                userManagerInstance.removeUser();
                window.location.assign("/login");
            });
            accessToken = user1 === null || user1 === void 0 ? void 0 : user1.access_token;
        } else {
            const token = (0,src/* getToken */.LP)({
                authKey: userStoreConfig.authKey,
                legacyAuthKey: userStoreConfig.legacyAuthKey
            });
            accessToken = token === null || token === void 0 ? void 0 : token.access_token;
        }
        request.headers = {
            ...request.headers,
            Authorization: `Bearer ${accessToken}`
        };
        return request;
    });
    _httpClient.interceptors.response.use(undefined, (error)=>{
        var ref, ref1;
        if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 401 || (error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 403) {
            main/* datadogRum.addError */.v.addError(new Error("SessionExpiredError"));
            onSessionExpiredCallback === null || onSessionExpiredCallback === void 0 ? void 0 : onSessionExpiredCallback();
        }
        return Promise.reject(error);
    });
    httpClient = _httpClient;
};
const useUserStore = (0,esm/* create */.Ue)((set, get)=>{
    onSessionExpiredCallback = ()=>{
        set({
            status: "expired"
        });
    };
    return {
        status: "unknown",
        setStatus: (status)=>set({
                status
            }),
        fetchUser: async ()=>{
            const { authKey , legacyAuthKey , profileServiceUrl  } = userStoreConfig;
            if ((0,src/* isSSR */.yF)()) {
                return;
            }
            const token = (0,src/* getToken */.LP)({
                authKey,
                legacyAuthKey
            });
            if (!token) {
                return set(()=>({
                        status: "invalid"
                    }));
            }
            set(()=>({
                    status: "pending",
                    token
                }));
            try {
                const profile = (await httpClient.get(`${profileServiceUrl}/v2/userprofile`)).data;
                const { preferenceCall , preferenceEmail , preferenceSms , ...profileWithoutPreferences } = profile;
                return set(()=>({
                        status: "valid",
                        profile: profileWithoutPreferences,
                        preferences: {
                            preferenceCall,
                            preferenceEmail,
                            preferenceSms
                        },
                        token
                    }));
            } catch  {
                main/* datadogRum.addError */.v.addError(new Error("FetchUserProfileActionFailed"));
            }
        },
        updatePassword: async (oldPassword, newPassword)=>{
            try {
                const { identityServiceUrl  } = userStoreConfig;
                set(()=>({
                        status: "updating"
                    }));
                await httpClient.put(`${identityServiceUrl}/password`, {
                    oldPassword,
                    newPassword
                });
                set(()=>({
                        status: "valid"
                    }));
            } catch  {
                main/* datadogRum.addError */.v.addError(new Error("UpdatePasswordActionFailed"));
            }
        },
        resetPassword: async (email)=>{
            try {
                const postUrl = "/dbconnections/change_password";
                const { auth0ServiceUrl , auth0DatabaseName , auth0ClientId  } = userStoreConfig;
                const data = {
                    email: email,
                    connection: auth0DatabaseName,
                    client_id: auth0ClientId
                };
                const axiosInstance = axios_default().create({
                    baseURL: auth0ServiceUrl,
                    validateStatus: ()=>true
                });
                const result = await axiosInstance.post(postUrl, data);
                return {
                    statusCode: result.status
                };
            } catch (error) {
                main/* datadogRum.addError */.v.addError(new Error("ResetPasswordActionFailed"));
                throw error;
            }
        },
        updateProfile: async (updatedFields)=>{
            try {
                const { profileServiceUrl  } = userStoreConfig;
                set(()=>({
                        status: "updating"
                    }));
                const fullProfile = {
                    ...get().profile,
                    ...updatedFields
                };
                const updatedProfile = {
                    ...updatedFields
                };
                await httpClient.put(`${profileServiceUrl}/v2/userprofile`, updatedProfile);
                set(()=>({
                        profile: fullProfile,
                        status: "valid"
                    }));
            } catch  {
                main/* datadogRum.addError */.v.addError(new Error("UpdateProfileActionFailed"));
            }
        },
        updateProfilePreferences: async (preferenceUpdate)=>{
            try {
                const { profileServiceUrl  } = userStoreConfig;
                set(()=>({
                        status: "updating"
                    }));
                await httpClient.put(`${profileServiceUrl}/v2/userprofile`, {
                    ...preferenceUpdate,
                    context: "Updated from Marketing Preferences page in profile"
                });
                const existingPreferences = get().preferences;
                set(()=>({
                        preferences: {
                            ...existingPreferences,
                            ...mapPreferenceUpdateToUpdatedPreferences(preferenceUpdate)
                        },
                        status: "valid"
                    }));
            } catch  {
                main/* datadogRum.addError */.v.addError(new Error("UpdateProfilePreferencesActionFailed"));
            }
        },
        logout: ()=>{
            const { redirectUrlKey  } = userStoreConfig;
            localStorage.removeItem(redirectUrlKey);
            window.location.assign("/logout");
        },
        login: ()=>{
            main/* datadogRum.addAction */.v.addAction("login redirect");
            window.location.assign("/login");
        },
        register: ()=>{
            window.location.assign("/login");
        }
    };
});

;// CONCATENATED MODULE: ../../../libs/data/user/src/__stubs__/authenticated-user-state.ts
const stubAuthenticatedUserState = {
    status: "valid",
    token: {
        access_token: "access_token",
        expires_at: Date.now() / 1000 + 60 * 60,
        profile: {
            sub: "user-id",
            "https://cinch.co.uk/user_id": "123567"
        }
    },
    profile: {
        firstName: "tester",
        lastName: "rantzen",
        email: "tester.rantzen@email.com",
        phoneNumber: "01234567910"
    },
    preferences: {
        preferenceEmail: false,
        preferenceSms: false,
        preferenceCall: false
    }
};

;// CONCATENATED MODULE: ../../../libs/data/user/src/__stubs__/index.ts


// EXTERNAL MODULE: ../../../libs/data/search/src/index.ts + 20 modules
var search_src = __webpack_require__(15993);
;// CONCATENATED MODULE: ../../../libs/data/user/src/lib/util/fetcher.ts




const UNAUTHORISED_ENDPOINTS = [
    search_src/* constants.VEHICLE_SEARCH_URL */._G.Eb
];
axios_default().interceptors.request.use((config)=>{
    const token = (0,src/* getToken */.LP)({
        authKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AuthKey */.X.AuthKey),
        legacyAuthKey: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.LegacyAuthKey */.X.LegacyAuthKey)
    });
    if (!UNAUTHORISED_ENDPOINTS.some((endpoint)=>{
        var ref;
        return (ref = config.url) === null || ref === void 0 ? void 0 : ref.includes(endpoint);
    })) {
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token === null || token === void 0 ? void 0 : token.access_token}`
        };
    }
    return config;
});
axios_default().interceptors.response.use(undefined, (error)=>Promise.reject(error));
const fetcher = (url)=>axios_default().get(url).then((res)=>res.data);

;// CONCATENATED MODULE: ../../../libs/data/user/src/lib/util/token-expired.ts
const hasTokenExpired = (axiosError)=>{
    var ref, ref1;
    if (axiosError === undefined) {
        return false;
    }
    return (axiosError === null || axiosError === void 0 ? void 0 : (ref = axiosError.response) === null || ref === void 0 ? void 0 : ref.status) === 401 || (axiosError === null || axiosError === void 0 ? void 0 : (ref1 = axiosError.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 403;
};

;// CONCATENATED MODULE: ../../../libs/data/user/src/lib/types.ts
var SetPermissionsAction;
(function(SetPermissionsAction) {
    SetPermissionsAction["PASSIVE"] = "passive";
    SetPermissionsAction["EXPLICIT"] = "explicit";
})(SetPermissionsAction || (SetPermissionsAction = {}));

;// CONCATENATED MODULE: ../../../libs/data/user/src/index.ts







/***/ }),

/***/ 39957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AccelerationIcon": function() { return /* reexport */ AccelerationIcon; },
  "AgeIcon": function() { return /* reexport */ AgeIcon; },
  "AlertIcon": function() { return /* reexport */ AlertIcon; },
  "ArrowDownIcon": function() { return /* reexport */ ArrowDownIcon; },
  "ArrowLeftIcon": function() { return /* reexport */ ArrowLeftIcon; },
  "ArrowRightIcon": function() { return /* reexport */ ArrowRightIcon; },
  "ArrowUpIcon": function() { return /* reexport */ ArrowUpIcon; },
  "ArrowsLeftRightIcon": function() { return /* reexport */ ArrowsLeftRightIcon; },
  "BasketIcon": function() { return /* reexport */ BasketIcon; },
  "BatteryChargeIcon": function() { return /* reexport */ BatteryChargeIcon; },
  "BatteryFullIcon": function() { return /* reexport */ BatteryFullIcon; },
  "BatterySeventyFiveIcon": function() { return /* reexport */ BatterySeventyFiveIcon; },
  "BinIcon": function() { return /* reexport */ BinIcon; },
  "BodyIcon": function() { return /* reexport */ BodyIcon; },
  "BuildingIcon": function() { return /* reexport */ BuildingIcon; },
  "CO2Icon": function() { return /* reexport */ CO2Icon; },
  "CVCIcon": function() { return /* reexport */ CVCIcon; },
  "CalculatorIcon": function() { return /* reexport */ CalculatorIcon; },
  "CallBackIcon": function() { return /* reexport */ CallBackIcon; },
  "CameraIcon": function() { return /* reexport */ CameraIcon; },
  "CardIcon": function() { return /* reexport */ CardIcon; },
  "CashIcon": function() { return /* reexport */ CashIcon; },
  "ChatIcon": function() { return /* reexport */ ChatIcon; },
  "CheckTickIcon": function() { return /* reexport */ CheckTickIcon; },
  "ChevronBackToTopIcon": function() { return /* reexport */ ChevronBackToTopIcon; },
  "ChevronDownIcon": function() { return /* reexport */ ChevronDownIcon; },
  "ChevronLeftIcon": function() { return /* reexport */ ChevronLeftIcon; },
  "ChevronRightIcon": function() { return /* reexport */ ChevronRightIcon; },
  "ChevronUpIcon": function() { return /* reexport */ ChevronUpIcon; },
  "CinchCareBreakdownIcon": function() { return /* reexport */ CinchCareBreakdownIcon; },
  "CinchCareServicingIcon": function() { return /* reexport */ CinchCareServicingIcon; },
  "CinchCareWarrantyIcon": function() { return /* reexport */ CinchCareWarrantyIcon; },
  "CinchChargeIcon": function() { return /* reexport */ CinchChargeIcon; },
  "CloseCircleIcon": function() { return /* reexport */ CloseCircleIcon; },
  "CollectionsIcon": function() { return /* reexport */ CollectionsIcon; },
  "CommitmentIcon": function() { return /* reexport */ CommitmentIcon; },
  "CompareIcon": function() { return /* reexport */ CompareIcon; },
  "ConvertibleCarIcon": function() { return /* reexport */ ConvertibleCarIcon; },
  "CopyIcon": function() { return /* reexport */ CopyIcon; },
  "CoupeCarIcon": function() { return /* reexport */ CoupeCarIcon; },
  "CovidCircleIcon": function() { return /* reexport */ CovidCircleIcon; },
  "CovidIcon": function() { return /* reexport */ CovidIcon; },
  "CovidShieldIcon": function() { return /* reexport */ CovidShieldIcon; },
  "CrossCircleIcon": function() { return /* reexport */ CrossCircleIcon; },
  "CrossIcon": function() { return /* reexport */ CrossIcon; },
  "DesktopIcon": function() { return /* reexport */ DesktopIcon; },
  "DoorIcon": function() { return /* reexport */ DoorIcon; },
  "DriveTypeIcon": function() { return /* reexport */ DriveTypeIcon; },
  "EditIcon": function() { return /* reexport */ EditIcon; },
  "ElectricIcon": function() { return /* reexport */ ElectricIcon; },
  "EmissionsIcon": function() { return /* reexport */ EmissionsIcon; },
  "EngineIcon": function() { return /* reexport */ EngineIcon; },
  "EnginePowerIcon": function() { return /* reexport */ EnginePowerIcon; },
  "EstateCarIcon": function() { return /* reexport */ EstateCarIcon; },
  "ExternalLinkIcon": function() { return /* reexport */ ExternalLinkIcon; },
  "FacebookIcon": function() { return /* reexport */ FacebookIcon; },
  "FeaturesIcon": function() { return /* reexport */ FeaturesIcon; },
  "FilterIcon": function() { return /* reexport */ FilterIcon; },
  "FinanceIcon": function() { return /* reexport */ FinanceIcon; },
  "FuelIcon": function() { return /* reexport */ FuelIcon; },
  "FuelPumpIcon": function() { return /* reexport */ FuelPumpIcon; },
  "FullScreenIcon": function() { return /* reexport */ FullScreenIcon; },
  "GalleryIcon": function() { return /* reexport */ GalleryIcon; },
  "GoIcon": function() { return /* reexport */ GoIcon; },
  "HandIcon": function() { return /* reexport */ HandIcon; },
  "HatchbackCarIcon": function() { return /* reexport */ HatchbackCarIcon; },
  "HeartFilledIcon": function() { return /* reexport */ HeartFilledIcon; },
  "HeartOutlineIcon": function() { return /* reexport */ HeartOutlineIcon; },
  "HelpMeChooseIcon": function() { return /* reexport */ HelpMeChooseIcon; },
  "HomeDeliveryIcon": function() { return /* reexport */ HomeDeliveryIcon; },
  "HomeIcon": function() { return /* reexport */ HomeIcon; },
  "InfoIcon": function() { return /* reexport */ InfoIcon; },
  "InstagramIcon": function() { return /* reexport */ InstagramIcon; },
  "LearnerIcon": function() { return /* reexport */ LearnerIcon; },
  "LightBulbIcon": function() { return /* reexport */ LightBulbIcon; },
  "LinkIcon": function() { return /* reexport */ LinkIcon; },
  "LoadingSpinnerIcon": function() { return /* reexport */ LoadingSpinnerIcon; },
  "LocationIcon": function() { return /* reexport */ LocationIcon; },
  "MOTIcon": function() { return /* reexport */ MOTIcon; },
  "MPVCarIcon": function() { return /* reexport */ MPVCarIcon; },
  "MailIcon": function() { return /* reexport */ MailIcon; },
  "MakeModelIcon": function() { return /* reexport */ MakeModelIcon; },
  "MaskIcon": function() { return /* reexport */ MaskIcon; },
  "MenuIcon": function() { return /* reexport */ MenuIcon; },
  "MileageIcon": function() { return /* reexport */ MileageIcon; },
  "NoInternetIcon": function() { return /* reexport */ NoInternetIcon; },
  "OwnerUserIcon": function() { return /* reexport */ OwnerUserIcon; },
  "OxfordShieldIcon": function() { return /* reexport */ OxfordShieldIcon; },
  "PadlockClosedIcon": function() { return /* reexport */ PadlockClosedIcon; },
  "PadlockOpenIcon": function() { return /* reexport */ PadlockOpenIcon; },
  "PaintIcon": function() { return /* reexport */ PaintIcon; },
  "ParentIcon": function() { return /* reexport */ ParentIcon; },
  "PartExIcon": function() { return /* reexport */ PartExIcon; },
  "PerformanceIcon": function() { return /* reexport */ PerformanceIcon; },
  "PhoneIcon": function() { return /* reexport */ PhoneIcon; },
  "PlayIcon": function() { return /* reexport */ PlayIcon; },
  "PlusIcon": function() { return /* reexport */ PlusIcon; },
  "PriceIcon": function() { return /* reexport */ PriceIcon; },
  "QuestionIcon": function() { return /* reexport */ QuestionIcon; },
  "RangeIcon": function() { return /* reexport */ RangeIcon; },
  "ReferralsIcon": function() { return /* reexport */ ReferralsIcon; },
  "RegPlateIcon": function() { return /* reexport */ RegPlateIcon; },
  "RightChevronIcon": function() { return /* reexport */ RightChevronIcon; },
  "RotateCCWIcon": function() { return /* reexport */ RotateCCWIcon; },
  "RunningCostIcon": function() { return /* reexport */ RunningCostIcon; },
  "SUVCarIcon": function() { return /* reexport */ SUVCarIcon; },
  "SaleIcon": function() { return /* reexport */ SaleIcon; },
  "SaloonCarIcon": function() { return /* reexport */ SaloonCarIcon; },
  "SearchIcon": function() { return /* reexport */ SearchIcon; },
  "SeatsIcon": function() { return /* reexport */ SeatsIcon; },
  "SettingsIcon": function() { return /* reexport */ SettingsIcon; },
  "ShareIcon": function() { return /* reexport */ ShareIcon; },
  "SignIcon": function() { return /* reexport */ SignIcon; },
  "SmartPhoneIcon": function() { return /* reexport */ SmartPhoneIcon; },
  "SortIcon": function() { return /* reexport */ SortIcon; },
  "SpecsIcon": function() { return /* reexport */ SpecsIcon; },
  "SpeechIcon": function() { return /* reexport */ SpeechIcon; },
  "StarFilledIcon": function() { return /* reexport */ StarFilledIcon; },
  "StarOutlineIcon": function() { return /* reexport */ StarOutlineIcon; },
  "StoreIcon": function() { return /* reexport */ StoreIcon; },
  "TargetIcon": function() { return /* reexport */ TargetIcon; },
  "ThreeSixtyIcon": function() { return /* reexport */ ThreeSixtyIcon; },
  "TickIcon": function() { return /* reexport */ TickIcon; },
  "TimeIcon": function() { return /* reexport */ TimeIcon; },
  "TransmissionIcon": function() { return /* reexport */ TransmissionIcon; },
  "TwitterIcon": function() { return /* reexport */ TwitterIcon; },
  "UploadIcon": function() { return /* reexport */ UploadIcon; },
  "UserIcon": function() { return /* reexport */ UserIcon; },
  "ValuationIcon": function() { return /* reexport */ ValuationIcon; },
  "WalletIcon": function() { return /* reexport */ WalletIcon; },
  "WhatsAppIcon": function() { return /* reexport */ WhatsAppIcon; },
  "YouTubeIcon": function() { return /* reexport */ YouTubeIcon; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/base-icon/base-icon.tsx

const BaseIcon = ({ children , color , height , width  })=>{
    const colorValue = color ? `var(--cds-color-${color})` : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        height: height,
        width: width,
        color: colorValue,
        role: "img",
        "aria-hidden": true,
        focusable: false,
        children: children
    });
};

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/base-icon/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/acceleration/acceleration.tsx


const AccelerationIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.25 6.75C7.25 6.33579 7.58579 6 8 6C8.41421 6 8.75 6.33579 8.75 6.75V11.25C8.75 11.6642 8.41421 12 8 12C7.58579 12 7.25 11.6642 7.25 11.25V6.75Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.25 1.5H8.75V3.03469C12.8166 3.41279 16 6.83464 16 11C16 15.4183 12.4183 19 8 19C3.58172 19 0 15.4183 0 11C0 6.83464 3.18341 3.41279 7.25 3.03469V1.5H6.75C6.33579 1.5 6 1.16421 6 0.75C6 0.335786 6.33579 0 6.75 0H9.25C9.66421 0 10 0.335786 10 0.75C10 1.16421 9.66421 1.5 9.25 1.5ZM8 17.5C11.5899 17.5 14.5 14.5899 14.5 11C14.5 7.41015 11.5899 4.5 8 4.5C4.41015 4.5 1.5 7.41015 1.5 11C1.5 14.5899 4.41015 17.5 8 17.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.9755 2.19002C24.0805 1.78932 23.8407 1.37942 23.44 1.27447C23.0393 1.16953 22.6294 1.40928 22.5245 1.80998C19.8052 12.1928 15.7008 17.3337 11.7221 19.8674C7.73762 22.4048 3.74678 22.4151 1.04537 22.2514C0.631916 22.2263 0.276432 22.5412 0.251374 22.9546C0.226316 23.3681 0.541174 23.7236 0.954629 23.7486C3.75322 23.9182 8.13738 23.9285 12.5279 21.1326C16.9242 18.333 21.1948 12.8072 23.9755 2.19002Z",
                fill: "currentColor"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/acceleration/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/age/age.tsx


const AgeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M20 3.5H4A2.5 2.5 0 0 0 1.5 6v14A2.5 2.5 0 0 0 4 22.5h16a2.5 2.5 0 0 0 2.5-2.5V6A2.5 2.5 0 0 0 20 3.5ZM4 2a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H4Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M7 .25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 7 .25ZM17 .25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 17 .25Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M1 8h22v1.5H1V8Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/age/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cvc/cvc.tsx


const CVCIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22 4H2a.5.5 0 0 0-.5.5V6h21V4.5A.5.5 0 0 0 22 4ZM1.5 19.5V9h21v10.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5Zm.5-17a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-15a2 2 0 0 0-2-2H2Zm14.75 13h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2Zm-2.5 1a2.5 2.5 0 0 1 2.5-2.5h2a2.5 2.5 0 0 1 0 5h-2a2.5 2.5 0 0 1-2.5-2.5Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cvc/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/desktop/desktop.tsx


const DesktopIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2 1.5h20a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5ZM0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm4.75 19a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H4.75Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/desktop/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cross-circle/cross-circle.tsx


const CrossCircleIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M7.47 16.53a.75.75 0 0 1 0-1.06L10.94 12 7.47 8.53a.75.75 0 0 1 1.06-1.06L12 10.94l3.47-3.47a.75.75 0 1 1 1.06 1.06L13.06 12l3.47 3.47a.75.75 0 1 1-1.06 1.06L12 13.06l-3.47 3.47a.75.75 0 0 1-1.06 0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cross-circle/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/alert/alert.tsx


const AlertIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M8.006 12.5C7.405 12.5 7 12.959 7 13.506c0 .548.405.994 1.006.994A.97.97 0 0 0 9 13.506c0-.547-.405-1.006-.994-1.006ZM8 1.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11 8a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V8ZM11 18.006c0-.547.405-1.006 1.006-1.006.589 0 .994.459.994 1.006a.97.97 0 0 1-.994.994c-.601 0-1.006-.446-1.006-.994Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M10.267 2.008c.77-1.335 2.697-1.335 3.466 0l9.79 16.994C24.29 20.335 23.328 22 21.79 22H2.21C.671 22-.29 20.335.477 19.002l9.79-16.994Zm2.166.749 9.79 16.993a.5.5 0 0 1-.433.75H2.21a.5.5 0 0 1-.433-.75l9.79-16.993a.5.5 0 0 1 .866 0Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/alert/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrows-left-right/arrows-left-right.tsx


const ArrowsLeftRightIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.47 13.28 21.19 17H.75a.75.75 0 0 0 0 1.5h20.44l-3.72 3.72a.75.75 0 1 0 1.06 1.06l5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 1 0-1.06 1.06ZM6.53 1.28A.75.75 0 0 0 5.47.22l-5 5a.75.75 0 0 0 0 1.06l5 5a.75.75 0 0 0 1.06-1.06L2.81 6.5h20.44a.75.75 0 0 0 0-1.5H2.81l3.72-3.72Z",
            fill: "currentColor"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrows-left-right/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-left/arrow-left.tsx


const ArrowLeftIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M8.54.48a.75.75 0 0 1-.019 1.06L2.607 7.25H15.25a.75.75 0 0 1 0 1.5H2.607l5.914 5.71a.75.75 0 0 1-1.042 1.08L.232 8.542a.748.748 0 0 1 .001-1.085L7.48.46a.75.75 0 0 1 1.06.02Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-left/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-right/arrow-right.tsx


const ArrowRightIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M7.46.48a.75.75 0 0 0 .019 1.06l5.914 5.71H.75a.75.75 0 0 0 0 1.5h12.643L7.48 14.46a.75.75 0 0 0 1.042 1.08l7.247-6.998a.748.748 0 0 0-.001-1.085L8.52.46a.75.75 0 0 0-1.06.02Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-right/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-up/arrow-up.tsx


const ArrowUpIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M.48 8.54a.75.75 0 0 0 1.06-.019l5.71-5.914V15.25a.75.75 0 0 0 1.5 0V2.607l5.71 5.914a.75.75 0 0 0 1.08-1.042L8.542.232a.748.748 0 0 0-1.085.001L.46 7.48a.75.75 0 0 0 .02 1.06Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-up/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-down/arrow-down.tsx


const ArrowDownIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M.48 7.46a.75.75 0 0 1 1.06.019l5.71 5.914V.75a.75.75 0 0 1 1.5 0v12.643l5.71-5.914a.75.75 0 0 1 1.08 1.042l-6.998 7.247a.748.748 0 0 1-1.085-.001L.46 8.52a.75.75 0 0 1 .02-1.06Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/arrow-down/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/building/building.tsx


const BuildingIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipPath: "url(#a)",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M.75 24a.75.75 0 0 1 0-1.5H2V3a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v19.5h1.25a.75.75 0 0 1 0 1.5H.75ZM19 1.52H5A1.48 1.48 0 0 0 3.52 3v19.48H10V19a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3.48h6.48V3A1.48 1.48 0 0 0 19 1.52Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.25 6A.75.75 0 0 1 8 5.25h2a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 6ZM7.25 10A.75.75 0 0 1 8 9.25h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM13.25 6a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM13.25 10a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM7.25 14a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM13.25 14a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/building/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/calculator/calculator.tsx


const CalculatorIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M4.5 3.5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-3Zm1.25 2.75v-2.5h4.5v2.5h-4.5Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M7.5 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.5 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM10.5 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2Zm2-.5h8a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M19 1.5H5a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5ZM5 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5Zm2.5 4.5v3h9v-3h-9ZM7 3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H7Zm2 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/calculator/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/call-back/call-back.tsx


const CallBackIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.925 1.818c.537.461.888 1.102.986 1.802.122.918.348 1.82.673 2.688a2.897 2.897 0 0 1-.66 3.068l-.832.827.06.095a15.562 15.562 0 0 0 4.8 4.778l.096.06.837-.833a2.924 2.924 0 0 1 2.894-.714l.18.06c.872.324 1.778.549 2.708.671 1.466.204 2.546 1.472 2.51 2.927v3.069a2.902 2.902 0 0 1-1.994 2.766 2.922 2.922 0 0 1-1.2.135 21.269 21.269 0 0 1-9.245-3.271 20.861 20.861 0 0 1-6.429-6.399A21.071 21.071 0 0 1 .013 4.281a2.9 2.9 0 0 1 .75-2.22 2.914 2.914 0 0 1 2.15-.948h3.08a2.923 2.923 0 0 1 1.932.705Zm-5.011.795h3.093c.346-.003.68.12.941.343.26.223.429.531.477.868.137 1.029.39 2.038.755 3.01v.002a1.397 1.397 0 0 1-.317 1.48l-.002.001-1.677 1.67.698 1.11.005.008a17.062 17.062 0 0 0 5.263 5.239l.008.005 1.11.682 1.67-1.66a1.425 1.425 0 0 1 1.39-.35l.131.043c.97.358 1.976.606 3.006.743.718.102 1.23.722 1.213 1.404v3.109a1.4 1.4 0 0 1-.461 1.043 1.417 1.417 0 0 1-1.083.362 19.77 19.77 0 0 1-8.583-3.04l-.011-.007a19.363 19.363 0 0 1-5.967-5.938l-.007-.011a19.572 19.572 0 0 1-3.06-8.593 1.4 1.4 0 0 1 .364-1.063 1.414 1.414 0 0 1 1.044-.46Zm14.558-.418c.26.26.26.683 0 .943l-2.196 2.195h7.057a.667.667 0 1 1 0 1.334h-7.056l2.195 2.195a.667.667 0 1 1-.943.943L13.195 6.47a.667.667 0 0 1 0-.942l3.334-3.334c.26-.26.682-.26.943 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/call-back/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/camera/camera.tsx


const CameraIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.75 4.5h-7.5c-.27 0-.75.295-.75 1h9c0-.705-.48-1-.75-1Zm2.25 1h3.333A2.667 2.667 0 0 1 24 8.167v10.666a2.667 2.667 0 0 1-2.667 2.667H2.667A2.667 2.667 0 0 1 0 18.833V8.167A2.667 2.667 0 0 1 2.667 5.5H6C6 4.12 7.007 3 8.25 3h7.5C16.993 3 18 4.12 18 5.5ZM21.333 7H2.667C2.022 7 1.5 7.522 1.5 8.167v10.666c0 .645.522 1.167 1.167 1.167h18.666c.645 0 1.167-.522 1.167-1.167V8.167C22.5 7.522 21.978 7 21.333 7ZM12 17.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm5.5-4a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/camera/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/card/card.tsx


const CardIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M15.5 19a2.49 2.49 0 0 0 1.5-.5 2.5 2.5 0 1 0 0-4 2.5 2.5 0 1 0-1.5 4.5Zm0-1.5a.996.996 0 0 0 .624-.219 2.5 2.5 0 0 1 0-1.562A1 1 0 1 0 15.5 17.5Zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M4.75 7a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M0 4.5a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-15ZM2 4h20a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-15A.5.5 0 0 1 2 4Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/card/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/basket/basket.tsx


const BasketIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.94 1.427a1.25 1.25 0 0 0-1.88 0l-6.624 7.57L4.433 9H1.028C.346 9-.147 9.636.04 10.275l3.311 11.274C3.603 22.408 4.41 23 5.328 23h13.344c.918 0 1.725-.592 1.977-1.45l3.31-11.275c.188-.64-.305-1.275-.988-1.275h-3.404l-.003-.003-6.623-7.57ZM17.575 9 12 2.63 6.426 9h11.148ZM4.79 21.127 1.67 10.5h20.66l-3.12 10.627a.55.55 0 0 1-.538.373H5.328a.55.55 0 0 1-.538-.373Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M0 0h24v24H0z"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/basket/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-full/battery-full.tsx


const BatteryFullIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M4.75 9a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 4.75 9ZM7 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5ZM10 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5ZM13 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5ZM16 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M22 8.5h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1V17a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h19a1 1 0 0 1 1 1v1.5Zm-1.5-1V10h2v4h-2v2.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h18.5Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-full/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-seventy-five/battery-seventy-five.tsx


const BatterySeventyFiveIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M4.75 9a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 4.75 9ZM7 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5ZM10 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5ZM13 9.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M22 8.5h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1V17a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h19a1 1 0 0 1 1 1v1.5Zm-1.5-1V10h2v4h-2v2.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h18.5Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-seventy-five/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/bin/bin.tsx


const BinIcon = ({ color , size =13 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4.5 1.5h4A.5.5 0 0 1 9 2v1H4V2a.5.5 0 0 1 .5-.5ZM2.5 3V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h1.75a.75.75 0 0 1 0 1.5H12V10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4.5H.75a.75.75 0 0 1 0-1.5H2.5Zm8 1.5h-8V10A1.5 1.5 0 0 0 4 11.5h5a1.5 1.5 0 0 0 1.5-1.5V4.5ZM4.75 6a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 4.75 6ZM9 6.75a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "m6.328 1.613-.594.887h4.532l-.594-.887a.255.255 0 0 0-.21-.113H6.535a.247.247 0 0 0-.209.113h.003ZM10.922.78l1.147 1.72h2.181c.416 0 .75.334.75.75s-.334.75-.75.75H14v9.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V4h-.25A.748.748 0 0 1 1 3.25c0-.416.334-.75.75-.75h2.181L5.078.778A1.757 1.757 0 0 1 6.534 0h2.929c.584 0 1.13.294 1.456.778l.003.003ZM3.5 4v9.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4h-9ZM6 6v6.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5Zm2.5 0v6.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5ZM11 6v6.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/bin/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/body/body.tsx


const BodyIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m18.754 10.331-.577-.133-.331-.492c-.44-.656-1.396-1.734-2.732-2.637-1.327-.898-2.948-1.569-4.75-1.569-3.686 0-6.013 1.806-6.766 2.929-.228.97-.711 1.884-1.088 2.597l-.047.089c-.555 1.05-.887 1.731-.93 2.332-.032.45-.033.948-.033 1.51 0 .877.31 1.32.507 1.513.046.012.133.026.281.03l1.037.022.345.977a3.002 3.002 0 0 0 5.66.001l.353-1h3.634l.353 1a3.002 3.002 0 0 0 5.66 0l.353-1h1.095c.498 0 .73-.12.821-.208.488-.473.901-1.142.901-1.944 0-1.318-.044-1.918-.363-2.399-.292-.439-1.05-1.08-3.383-1.618ZM2.182 7.87C3.09 6.246 6 4 10.364 4 14.727 4 18 7.246 19.09 8.87 24 10 24 11.913 24 14.348c0 1.342-.69 2.376-1.358 3.021-.49.475-1.182.631-1.864.631h-.034a4.502 4.502 0 0 1-8.488 0h-1.512a4.502 4.502 0 0 1-8.488-.001c-.444-.01-.894-.088-1.222-.385C.529 17.157 0 16.312 0 14.956c0-.549 0-1.103.037-1.616.07-.977.585-1.953 1.1-2.926.45-.851.898-1.7 1.045-2.544Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/body/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-convertible/car-shape-convertible.tsx


const ConvertibleCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M36.368 19.75a.75.75 0 1 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M29.311 13.105a.75.75 0 0 0-.887-1.21l-7.5 5.5a.76.76 0 0 0-.119.109c-1.71.021-4.8.14-6.937.496l-.812.132c-2.514.402-6.396 1.023-8.188 2.368l-.79 3.945a4.052 4.052 0 0 0 .13 2.076 2.894 2.894 0 0 0 2.73 1.979h1.52A5.53 5.53 0 0 1 8.39 27a5.5 5.5 0 1 1 10.831 1.765L20.868 30h24.5l.575-.048a5.463 5.463 0 0 1-.575-2.452 5.5 5.5 0 0 1 11 0v.031a7.302 7.302 0 0 1-.014.354l-.003.049-.004.045a5.472 5.472 0 0 1-.217 1.124L57.368 29a4.7 4.7 0 0 0 .434-.54c.64-.895 1.566-2.517 1.566-3.46 0-1.2-.667-2.167-1-2.5v-1.584a6 6 0 0 0-.634-2.683l-.567-1.133a1 1 0 0 0-.968-.55l-2.533.187-2.268-2.267a.75.75 0 0 0-.78-.177l-7.5 2.647V14a.75.75 0 1 0-1.5 0v3.5H27.992l-.413-1.237a.75.75 0 0 0-1.423.474l.254.763h-3.092l5.993-4.395ZM41.618 19v6.75h-17.5V24.5a.75.75 0 1 0-1.5 0v2c0 .414.335.75.75.75h19a.75.75 0 0 0 .75-.75V19h.305l12.553-.93.417.834a4.5 4.5 0 0 1 .475 2.012v2.205l.439.44c.039.038.193.222.334.514.136.282.227.601.227.925a1.234 1.234 0 0 1-.026.153c-.023.1-.062.226-.12.377a5.485 5.485 0 0 1-.08.2 7 7 0 0 0-13.703 2.77H21.368l-.526-.394a7 7 0 1 0-13.956-1.107 1.395 1.395 0 0 1-1.255-.952 2.552 2.552 0 0 1-.081-1.308l.664-3.322c.67-.367 1.65-.704 2.838-.998 1.438-.357 2.975-.604 4.24-.806h.004l.818-.133c2.272-.379 5.769-.48 7.254-.48h20.25Zm5.13-1.75 3.924-1.385 1.019 1.019-4.944.366Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M18.368 27.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM55.368 27.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-convertible/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-coupe/car-shape-coupe.tsx


const CoupeCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M35.618 20.5a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M21.94 16.383a.754.754 0 0 0-.132.117h-.44c-1.5 0-5.1.1-7.5.5-2.4.4-8 2-10 3.5l-.03.147a.747.747 0 0 0-.085.425l-.674 3.373a4.052 4.052 0 0 0 .129 2.076A2.894 2.894 0 0 0 5.954 28.5h.504A5.531 5.531 0 0 1 6.39 27a5.5 5.5 0 1 1 10.887 1.5h.223L20 30h25.368l.576-.046a5.46 5.46 0 0 1-.576-2.454 5.5 5.5 0 1 1 10.748 1.65L58 29c.5-.5 2-2.8 2-4 0-1.2-1.167-2.667-1.5-3l.157-.454a6 6 0 0 0-.05-4.074l-.478-1.274a1 1 0 0 0-1.005-.647l-2.828.195c-.11-.1-.226-.2-.347-.3l3.214-.714a.75.75 0 0 0-.326-1.464l-4.5 1a.75.75 0 0 0-.084.024c-1.25-.727-2.748-1.39-4.319-1.938-2.38-.83-5.02-1.428-7.38-1.571h-.016c-.352-.022-.7-.033-1.038-.033-4.062 0-8.865.674-10.763 1.011a.751.751 0 0 0-.296.122l-6.5 4.5Zm6.977-3.005-4.51 3.122h3.47l1.04-3.122Zm1.714-.399L29.457 16.5H39.75v-4.248a14.99 14.99 0 0 0-.25-.002c-3.058 0-6.579.397-8.87.73ZM5.147 21.75l-.597 2.989c-.088.435-.06.886.081 1.308.064.192.168.364.3.506a7.001 7.001 0 0 1 13.937.947v.071l1.548.929h23.523a7 7 0 1 1 13.877-1.858l.06-.108c.196-.352.364-.7.479-1.004.057-.151.096-.277.12-.377A1.203 1.203 0 0 0 58.5 25c0-.183-.116-.56-.413-1.056a5.516 5.516 0 0 0-.648-.883l-.664-.665.398-1.146H55.5a.75.75 0 0 1-.75-.75V19a.75.75 0 0 1 1.5 0v.75h1.236a4.501 4.501 0 0 0-.283-1.751l-.347-.926L43.419 18H41.25v8.5a.75.75 0 0 1-.75.75H22.368a.75.75 0 0 1-.53-.22l-2-2a.75.75 0 0 1 1.06-1.06l1.78 1.78H39.75V18H21.368c-1.485 0-4.982.101-7.254.48-1.105.184-3.03.662-4.93 1.283a35.23 35.23 0 0 0-1.754.623A.75.75 0 0 1 7 21.75H5.147Zm42.293-7.98c1.78.622 3.378 1.368 4.577 2.133l-8.65.597H41.25v-4.155c1.987.203 4.171.721 6.19 1.426Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M11.868 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM50.868 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-coupe/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-estate/car-shape-estate.tsx


const EstateCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M27.68 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM41.68 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M19.003 16.383a.746.746 0 0 0-.132.117H13.93c-6.368 0-10.5 2.5-12.5 4l-.423 5.076a2 2 0 0 0 .579 1.58l.31.31a5 5 0 0 0 3.702 1.462l1.87-.063A5.51 5.51 0 0 1 7.3 27.37a5.5 5.5 0 1 1 10.906 1.137l.225-.007 2.5 1.5h26l.548-1.097A5.5 5.5 0 1 1 58.09 29h4.84c.5-.5 1-6 1-6l-.87-5.652a.997.997 0 0 0-.229-.499l-.669-3.012a.75.75 0 0 0-.202-.367c-.553-.553-1.48-.935-2.493-1.225-1.049-.299-2.327-.534-3.707-.722-2.76-.375-6.008-.567-8.803-.667-2.996-.106-4.781-.106-6.527-.106-4.027 0-12.696.668-14.631 1.011a.755.755 0 0 0-.297.123l-6.499 4.5Zm7.216-3.17-4.75 3.287h4.337l1.128-3.384c-.283.034-.524.066-.715.096Zm2.354-.27L27.387 16.5h6.023l.635-3.986c-1.974.126-3.944.282-5.472.428Zm33.125 5.72L61.55 18H47.68v4.724A7 7 0 0 1 59.798 27.5h2.04c.103-.528.203-1.199.292-1.881a77.142 77.142 0 0 0 .284-2.526l.005-.049-.355-2.306a.753.753 0 0 1-.134.012h-2.5a.75.75 0 0 1 0-1.5h2.405l-.058-.381a.752.752 0 0 1-.08-.206Zm-.947-4.258.466 2.095H47.68v-4.115c2.584.106 5.438.293 7.879.624 1.345.183 2.545.407 3.496.679.832.237 1.386.487 1.697.717ZM46.18 12.33V16.5H34.928l.65-4.079c1.84-.103 3.582-.171 4.852-.171 1.593 0 3.208 0 5.75.081ZM13.93 18h19.25v10.5H21.345l-1.548-.929V27.5a7 7 0 0 0-13.999-.08l-.25.009a3.5 3.5 0 0 1-2.591-1.024l-.31-.31a.5.5 0 0 1-.145-.395l.247-2.972a.756.756 0 0 0 .18.022h2.5a.75.75 0 0 0 0-1.5H2.959C4.97 19.872 8.596 18 13.93 18Zm20.75.06V28.5h11.189a7.045 7.045 0 0 1 .427-3.6.747.747 0 0 1-.116-.4V18H34.69l-.01.06Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.798 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM52.798 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-estate/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-hatchback/car-shape-hatchback.tsx


const HatchbackCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M31.34 19.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M19.913 16.384a.746.746 0 0 0-.208.216c-4.797.464-7.425 2.441-9.187 3.766l-.178.134-1.295 5.18a1.493 1.493 0 0 0 .392 1.418l1.112 1.111a1.553 1.553 0 0 0 1.752.31A5.5 5.5 0 1 1 22.607 30H40.84l.548-1.098A5.5 5.5 0 1 1 52 29h1.84c.241-.242.6-1.42.906-2.572.408-1.533.046-3.159-.906-4.428l-.335-3.681a1.993 1.993 0 0 0-.484-1.133.79.79 0 0 0-.038-.072c-.325-.541-.576-1.058-.83-1.58l-.069-.143c-.272-.561-.56-1.14-.939-1.69-.787-1.146-1.92-2.108-4.042-2.903a.757.757 0 0 0-.133-.037c-6.922-1.221-15.386-.356-18.758.226a.75.75 0 0 0-.279.109l-.24.155a611.234 611.234 0 0 0-2.812 1.825c-1.682 1.099-3.69 2.422-4.968 3.308Zm8.704-3.944-.11.071a668.886 668.886 0 0 0-2.805 1.821c-1.06.692-2.243 1.47-3.288 2.168h12.278l.328-4.74c-2.668.157-4.963.439-6.403.68Zm22.19 3.753.149.307H46.59v-4.282l.05.009c1.835.698 2.688 1.478 3.27 2.323.307.448.551.933.825 1.497l.072.146ZM36.529 11.69c2.731-.102 5.736-.052 8.56.306V16.5h-8.894l.334-4.811ZM21.839 18h12.75v10.5h-9.953a7 7 0 0 0-13.834-2.158l-.301-.302 1.083-4.334a.75.75 0 0 0 .256.044h1a.75.75 0 0 0 .33-1.424C15.026 19.148 17.654 18 21.84 18Zm17.94 10.5h-3.69V18.026l.002-.026h15.422a.5.5 0 0 1 .498.455l.373 4.105.256.34c.566.755.832 1.661.76 2.543A7 7 0 0 0 39.778 28.5Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M17.707 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM51.207 27.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-hatchback/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-mpv/car-shape-mpv.tsx


const MPVCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m7 16.5 7-2 7.136-5.55c1.235-.96 2.62-1.727 4.171-1.927 2.117-.271 5.01-.391 7.677-.502l.516-.02c8.731-.365 13.05.507 16.81 1.265l.568.115c2.327.466 4.502 1.58 6.106 3.329L60 14.5V19c.5 1 1 3.4 1 5s-1.5 6-1.5 6h-3.75l-.99-1.056a5.7 5.7 0 1 0-10.98-.222L42.499 30h-23l-1.279-1.279a5.7 5.7 0 1 0-11.022.08L6 30H2.5S2 22.6 2 21c0-1.6 4-4 5-4.5Zm51.5-.307c-.34-.018-.772-.04-1.295-.064-1.498-.069-3.743-.156-6.724-.23A687.819 687.819 0 0 0 38.5 15.75c-1.252 0-3.003.02-5 .053V28.5h8.379l.28-.28a7.2 7.2 0 1 1 14.242.28h2.01a56.7 56.7 0 0 0 .398-1.316c.183-.634.36-1.3.492-1.895.138-.625.199-1.064.199-1.289 0-.669-.108-1.564-.283-2.427-.06-.299-.125-.575-.19-.823H56.5a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v.75h1.25v-3.057Zm-25-1.89c1.994-.032 3.745-.053 5-.053 2.024 0 7.406.053 10.935.125l-1.97-5.63c-3.196-.568-7.217-1.025-13.903-.746L33.5 8v6.302Zm15.667-5.236 1.87 5.346a312.946 312.946 0 0 1 7.085.259l-2.244-2.449c-1.36-1.483-3.235-2.46-5.294-2.872-.19-.037-.38-.076-.569-.114l-.027-.006c-.27-.054-.543-.11-.82-.164ZM32 14.329c-2.578.047-5.43.11-8.088.171a2883.736 2883.736 0 0 0-7.715.191l5.86-4.557c1.126-.876 2.26-1.471 3.441-1.623 1.776-.228 4.143-.347 6.502-.447v6.265Zm0 1.5c-2.564.047-5.402.109-8.053.17a2838.895 2838.895 0 0 0-9.128.23c-.38.01-.756.057-1.133.104-.15.019-.3.038-.45.054a3.91 3.91 0 0 1-.47.026l-5.211 1.489c-.492.26-1.557.89-2.517 1.626-.097.074-.192.149-.282.222H6a.75.75 0 0 1 0 1.5H3.503c.02.909.13 2.882.244 4.759.056.92.113 1.801.157 2.491H5.38l.191-.192a7.2 7.2 0 1 1 14.271-.088l.28.28H32V15.83ZM15.868 27.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm1.5 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm32.132 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM24.75 17.5a.75.75 0 0 1 .75-.75H29a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75ZM40 16.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5H40Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-mpv/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-saloon/car-shape-saloon.tsx


const SaloonCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M25.75 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM40.75 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M25.61 10.758a.747.747 0 0 0-.414.056l-.327.053a.75.75 0 0 0-.26.099l-.262.16a444.268 444.268 0 0 0-3.042 1.882c-1.806 1.128-3.946 2.485-5.232 3.375a.755.755 0 0 0-.132.117h-3.973c-5.862 0-9.666 2.907-11.508 4.352l-.389 4.884a2 2 0 0 0 .548 1.541l.134.14a5 5 0 0 0 3.788 1.542l2.995-.104a5.51 5.51 0 0 1-.167-1.496 5.5 5.5 0 1 1 10.546 2.329l.498.312H43.73l1.174-.13a5.457 5.457 0 0 1-.536-2.37 5.5 5.5 0 0 1 11 0v.037a5.5 5.5 0 0 1-.218 1.5h6.93c.46-.482.92-5.778.92-5.778l-.55-4.643a3 3 0 0 0-3.467-2.607L56 16.5h-1.763l-.155-.108a142.84 142.84 0 0 0-3.863-2.594c-1.099-.71-2.257-1.426-3.24-1.967-.49-.27-.951-.504-1.346-.673-.347-.147-.745-.291-1.093-.302l-.268-.023a424.858 424.858 0 0 0-3.31-.278c-1.893-.15-4.054-.305-4.962-.305-3.57 0-8.076.216-10.39.508Zm.474 1.453-1.17 4.289h6.561l.733-4.681c-2.364.08-4.653.224-6.124.392ZM23.358 16.5h-4.756c1.09-.71 2.353-1.506 3.496-2.22.864-.54 1.655-1.028 2.245-1.392L23.36 16.5ZM57 18H46.67l-.286 3.427A7 7 0 0 1 56.868 27.5v.037h4.097c.091-.5.18-1.122.259-1.755a77.195 77.195 0 0 0 .262-2.432l.006-.07-.303-2.554a.753.753 0 0 1-.189.024h-2.5a.75.75 0 1 1 0-1.5h2.514l-.054-.457a1.5 1.5 0 0 0-1.733-1.304l-1.683.277A.748.748 0 0 1 57 18Zm-7.594-2.942a124.37 124.37 0 0 1 2.18 1.442H46.64l-1.027-3.696c.198.1.414.214.643.34.939.517 2.063 1.212 3.151 1.914Zm-5.49-2.75 1.167 4.192h-12.09l.74-4.724c.774-.017 1.538-.026 2.267-.026.834 0 2.924.148 4.844.3a391.573 391.573 0 0 1 3.073.257ZM11.969 18H31.25v10.5H19.797a7 7 0 1 0-13.928-1.088l-1.38.048a3.5 3.5 0 0 1-2.652-1.08l-.133-.14a.5.5 0 0 1-.137-.384l.249-3.129c.059.015.12.023.184.023h2.5a.75.75 0 1 0 0-1.5H2.416C4.376 19.829 7.522 18 11.968 18Zm20.782.058V28.5H42.94a6.976 6.976 0 0 1 1.834-5.8l.391-4.7H32.76l-.009.058Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12.868 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM49.868 32a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-1.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-saloon/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-suv/car-shape-suv.tsx


const SUVCarIcon = ({ color , size =64 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: 32,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m17 11.5-13 1C3 13 2 17.4 2 19c0 1.6 1.5 7 1.5 7h3.516a7.619 7.619 0 0 1 0-1 7.5 7.5 0 0 1 14.968 1h20.032a7.598 7.598 0 0 1 0-1 7.5 7.5 0 0 1 14.968 1H60.5s1.5-2.4 1.5-4-.5-4-1-5v-.94a.748.748 0 0 0 0-1.119v-2.44l-.475-.74v-.01h-.007L56.5 5.5c-1.453-.183-2.782-.45-4.19-.735-3.76-.758-8.079-1.63-16.81-1.266-3.997.167-9.667 1.333-11.5 2l-7 6Zm41.697.19-3.085-4.797c-1.239-.18-2.4-.415-3.575-.652l-.05-.01c-1.812-.365-3.748-.756-6.267-1.016l3.24 6.196a1421.112 1421.112 0 0 1 9.737.28Zm-14.75-6.627c-2.265-.157-4.98-.206-8.385-.064L35.5 5v6.285c1.593-.022 2.975-.036 4-.036 1.968 0 4.8.05 7.746.119l-3.298-6.306ZM34 11.31V5.107a55.39 55.39 0 0 0-4.79.68c-1.932.357-3.571.753-4.452 1.039l-5.595 4.796c1.558-.037 3.36-.08 5.25-.122 3.192-.071 6.638-.142 9.587-.19Zm-19.98 1.924v.016l.84-.022A3264.154 3264.154 0 0 1 24.447 13c3.186-.071 6.619-.142 9.554-.19V24.5H23.445a9.001 9.001 0 0 0-17.89 0H4.65a96.616 96.616 0 0 1-.443-1.753 50.83 50.83 0 0 1-.5-2.262C3.565 19.752 3.5 19.241 3.5 19c0-.527.16-1.616.438-2.75H7a.75.75 0 0 0 0-1.5H4.379a7.54 7.54 0 0 1 .249-.62c.031-.069.061-.129.088-.18l9.304-.716Zm21.48-.447c1.596-.023 2.978-.037 4-.037 2.23 0 5.593.065 8.981.149a1393.324 1393.324 0 0 1 10.96.317c.02 0 .04 0 .059.002v1.532H58a.75.75 0 1 0 0 1.5h1.5v1.104l.158.317c.16.32.38 1.015.56 1.902.174.863.282 1.758.282 2.427 0 .44-.24 1.178-.608 1.963-.091.194-.182.375-.267.537h-1.18a9.001 9.001 0 0 0-17.89 0H35.5V12.787Zm-30.627.91c0 .001-.003.005-.01.011a.068.068 0 0 1 .01-.01ZM14.5 30.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm40-6.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-27.25-10a.75.75 0 0 1 .75-.75H33a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Zm11.5 0a.75.75 0 0 1 .75-.75h3.5a.75.75 0 1 1 0 1.5H41a.75.75 0 0 1-.75-.75Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/car-shape-suv/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/three-sixty/three-sixty.tsx


const ThreeSixtyIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M19.86 14.025c2.066-.946 2.64-1.95 2.64-2.525s-.574-1.579-2.64-2.525C17.926 8.088 15.15 7.5 12 7.5c-3.148 0-5.926.588-7.86 1.475-2.066.946-2.64 1.95-2.64 2.525s.574 1.579 2.64 2.525c1.895.869 4.599 1.451 7.668 1.474l-2.294-2.294a.75.75 0 0 1 1.06-1.06l3.538 3.537a.75.75 0 0 1 0 1.06l-3.537 3.538a.75.75 0 1 1-1.061-1.06l2.22-2.221C5.23 16.934 0 14.497 0 11.5 0 8.462 5.373 6 12 6s12 2.462 12 5.5c0 2.053-2.454 3.844-6.092 4.788A.731.731 0 0 1 17 15.57c0-.353.245-.657.586-.747.845-.222 1.61-.492 2.274-.796Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/three-sixty/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cash/cash.tsx


const CashIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M11.86 11.34c-.44.88-1.12 1.44-1.88 1.44-.8 0-1.8-.54-2.52-1.14.24-.5.52-1.46.52-2.48V7.44H11V6.12H7.98V4.8c0-.94.5-1.6 1.52-1.6.54 0 1.08.18 1.48.54l1-1.84c-.76-.6-1.7-.9-2.68-.9-2.18 0-3.76 1.3-3.76 3.64v1.48H3.2v1.32h2.34V8.8c0 .42-.02 1-.06 1.62-.58-.4-1.24-.6-1.86-.6C2.14 9.82 1 11.06 1 12.58c0 1.44 1.02 2.54 2.62 2.54 1.22 0 2.12-.62 2.76-1.78 1.44 1.24 2.52 1.78 3.72 1.78 1.54 0 2.82-1.04 3.58-2.74l-1.82-1.04Zm-8.14 2.12c-.62 0-1-.42-1-.96 0-.58.38-.98 1.04-.98.42 0 .94.18 1.34.66-.18.78-.68 1.28-1.38 1.28Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M15.656 14.706c-.396.792-1.008 1.296-1.692 1.296-.72 0-1.62-.486-2.268-1.026.216-.45.468-1.314.468-2.232v-1.548h2.718v-1.188h-2.718V8.82c0-.846.45-1.44 1.368-1.44.486 0 .972.162 1.332.486l.9-1.656c-.684-.54-1.53-.81-2.412-.81-1.962 0-3.384 1.17-3.384 3.276v1.332H7.862v1.188h2.106v1.224c0 .378-.018.9-.054 1.458a2.98 2.98 0 0 0-1.674-.54c-1.332 0-2.358 1.116-2.358 2.484 0 1.296.918 2.286 2.358 2.286 1.098 0 1.908-.558 2.484-1.602 1.296 1.116 2.268 1.602 3.348 1.602 1.386 0 2.538-.936 3.222-2.466l-1.638-.936ZM8.33 16.614c-.558 0-.9-.378-.9-.864 0-.522.342-.882.936-.882.378 0 .846.162 1.206.594-.162.702-.612 1.152-1.242 1.152Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cash/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-charge/battery-charge.tsx


const BatteryChargeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M10.787 17.795a.5.5 0 0 1-.895-.385l.638-3.487a.5.5 0 0 0-.492-.59H7.984a.5.5 0 0 1-.406-.792c.98-1.343 3.016-4.135 4.618-6.336a.5.5 0 0 1 .895.385l-.638 3.487a.5.5 0 0 0 .492.59h2.07a.5.5 0 0 1 .404.795l-4.632 6.333Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M10.787 17.795a.5.5 0 0 1-.895-.385l.638-3.487a.5.5 0 0 0-.492-.59H7.984a.5.5 0 0 1-.406-.792l.406-.556.106-.146.004-.006c.884-1.21 2.17-2.975 3.355-4.602l.236-.325.37-.506.141-.195a.5.5 0 0 1 .895.385l-.638 3.487a.5.5 0 0 0 .492.59h2.07a.5.5 0 0 1 .404.795l-4.632 6.333Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8.5 18H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h8.643l-1.05 1.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6.755L8.5 18Zm3.787 0H21a1 1 0 0 0 1-1v-1.5h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-1V7a1 1 0 0 0-1-1h-6.509l-.25 1.5H20.5V10h2v4h-2v2.5h-7.16L12.288 18Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/battery-charge/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chat/chat.tsx


const ChatIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13.62 11.577c1.444-1.088 2.33-2.555 2.33-4.245 0-1.694-.892-3.166-2.342-4.255C12.157 1.988 10.196 1.332 8 1.332c-2.196 0-4.156.656-5.608 1.745C.942 4.167.05 5.637.05 7.332c0 1.548.95 3.045 2.147 4.093l-.184 2.546a.65.65 0 0 0 .873.657h.001l.423-.157.546-.203a.647.647 0 0 0 .055-.025l.973-.486a.668.668 0 0 0 .04-.022l1.023-.604c.657.132 1.339.201 2.053.201 2.197 0 4.157-.656 5.608-1.745l.012-.01ZM8 12.032a9.076 9.076 0 0 1-2.02-.224.65.65 0 0 0-.475.074l-1.223.722-.9.45.135-1.857a.656.656 0 0 0-.114-.425l-.005-.008-.002-.003-.001-.001a.665.665 0 0 0-.125-.132l-.003-.002C2.132 9.719 1.35 8.424 1.35 7.332c0-1.17.63-2.319 1.823-3.215l.003-.003C4.37 3.22 6.071 2.632 8 2.632c1.93 0 3.633.589 4.827 1.485 1.194.896 1.823 2.045 1.823 3.215s-.63 2.32-1.823 3.215c-1.194.896-2.896 1.485-4.827 1.485Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M7.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM18 10a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M21 19h-8l-5.875 4.7a1 1 0 0 1-1.625-.78V19H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3ZM7 21.88V17.5H3A1.5 1.5 0 0 1 1.5 16V4A1.5 1.5 0 0 1 3 2.5h18A1.5 1.5 0 0 1 22.5 4v12a1.5 1.5 0 0 1-1.5 1.5h-8.526L7 21.88Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chat/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/check-tick/check-tick.tsx


const CheckTickIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M1.5 12C1.5 6.201 6.201 1.5 12 1.5c.751 0 1.483.079 2.188.228A.75.75 0 1 0 14.5.261 12.046 12.046 0 0 0 12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12c0-.336-.014-.67-.041-1a.75.75 0 0 0-1.495.124c.024.289.036.58.036.876 0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.54 4.021a.75.75 0 1 0-1.08-1.042L11.397 14.434l-4.87-4.801A.75.75 0 0 0 5.474 10.7l5.41 5.333a.75.75 0 0 0 1.066-.013l11.59-12Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/check-tick/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-back-to-top/chevron-back-to-top.tsx


const ChevronBackToTopIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 1L25 1",
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_743_8990)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.5303 17.5303C23.2374 17.8232 22.7626 17.8232 22.4697 17.5303L12 7.06066L1.53033 17.5303C1.23744 17.8232 0.762564 17.8232 0.469669 17.5303C0.176777 17.2374 0.176777 16.7626 0.469669 16.4697L11.4697 5.46967C11.6103 5.32902 11.8011 5.25 12 5.25C12.1989 5.25 12.3897 5.32902 12.5303 5.46967L23.5303 16.4697C23.8232 16.7626 23.8232 17.2374 23.5303 17.5303Z",
                    fill: "currentColor"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-back-to-top/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-down/chevron-down.tsx


const ChevronDownIcon = ({ color , size =13 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.208.482a.75.75 0 0 1 1.06-.024L6.5 5.462 11.732.458a.75.75 0 1 1 1.036 1.084l-5.75 5.5a.75.75 0 0 1-1.036 0l-5.75-5.5A.75.75 0 0 1 .208.482Z",
            clipRule: "evenodd"
        }) : size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.47 4.22a.75.75 0 0 1 1.06 0L8 10.69l6.47-6.47a.75.75 0 1 1 1.06 1.06l-7 7a.75.75 0 0 1-1.06 0l-7-7a.75.75 0 0 1 0-1.06Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.47 6.47a.75.75 0 0 1 1.06 0L12 16.94 22.47 6.47a.75.75 0 1 1 1.06 1.06l-11 11a.75.75 0 0 1-1.06 0l-11-11a.75.75 0 0 1 0-1.06Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-down/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-left/chevron-left.tsx


const ChevronLeftIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.53 15.53a.75.75 0 0 0 0-1.06L4.06 8l6.47-6.47A.75.75 0 1 0 9.47.47l-7 7a.75.75 0 0 0 0 1.06l7 7a.75.75 0 0 0 1.06 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17.53.47a.75.75 0 0 1 0 1.06L7.06 12l10.47 10.47a.75.75 0 1 1-1.06 1.06l-11-11a.75.75 0 0 1 0-1.06l11-11a.75.75 0 0 1 1.06 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-left/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-right/chevron-right.tsx


const ChevronRightIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.47 15.53a.75.75 0 0 1 0-1.06L11.94 8 5.47 1.53A.75.75 0 0 1 6.53.47l7 7a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6.47 23.53a.75.75 0 0 1 0-1.06L16.94 12 6.47 1.53A.75.75 0 0 1 7.53.47l11 11a.75.75 0 0 1 0 1.06l-11 11a.75.75 0 0 1-1.06 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-right/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-up/chevron-up.tsx


const ChevronUpIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.47 10.53a.75.75 0 0 0 1.06 0L8 4.06l6.47 6.47a.75.75 0 1 0 1.06-1.06l-7-7a.75.75 0 0 0-1.06 0l-7 7a.75.75 0 0 0 0 1.06Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.53 18.53a.75.75 0 0 1-1.06 0L12 8.06 1.53 18.53a.75.75 0 0 1-1.06-1.06l11-11a.75.75 0 0 1 1.06 0l11 11a.75.75 0 0 1 0 1.06Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/chevron-up/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/close-circle/close-circle.tsx


const CloseCircleIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipPath: "url(#a)",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.47 4.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.47 11.53a.75.75 0 0 1 0-1.06l6-6a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/close-circle/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/co2/co2.tsx


const CO2Icon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2.48 17.485a8.765 8.765 0 0 1-.564-1.232C.57 12.6 1.054 9.048 4 6.5c1.647-1.425 3.44-1.099 5.33-.754 1.458.265 2.973.54 4.524.032 2.62-.86 4.76-2.696 6.224-4.494.859-1.054 2.4-1.17 2.885.1C23.524 2.85 24 4.931 24 7.626c0 6.162-3.555 13.146-10.146 14.172-4.018.626-8.068-.2-10.453-2.987a12.54 12.54 0 0 0-1.392 3.116 10.347 10.347 0 0 0-.255 1.1 3.25 3.25 0 0 0-.008.054l-.002.011v.001a.75.75 0 0 1-1.488-.187L1 23l-.744-.093v-.005l.001-.007.004-.023.012-.08c.01-.068.027-.164.05-.285.049-.242.126-.583.246-.997.24-.827.652-1.949 1.346-3.138.17-.293.359-.59.565-.887Zm1.029-1.297a7.25 7.25 0 0 1-.185-.454c-1.185-3.214-.708-6.053 1.657-8.1.908-.785 1.858-.796 3.453-.525.185.032.38.068.587.107 1.431.266 3.357.625 5.3-.013 2.976-.976 5.339-3.03 6.92-4.972a.842.842 0 0 1 .264-.22.557.557 0 0 1 .08-.033c.484 1.29.915 3.169.915 5.649 0 2.814-.817 5.813-2.36 8.196-1.534 2.368-3.73 4.06-6.517 4.494-3.9.607-7.402-.287-9.308-2.77 1.332-1.601 3.336-3.106 6.357-3.817a.75.75 0 1 0-.344-1.46c-3.135.738-5.315 2.255-6.82 3.918Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/co2/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/collections/collections.tsx


const CollectionsIcon = ({ color , size =48 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2193_35033)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M30.1029 19.942C31.2681 19.942 32.253 19.1702 32.5743 18.1099H33.4063C34.3728 18.1099 35.1563 17.3264 35.1563 16.3599V15.1262C35.1563 13.3159 33.8631 11.7641 32.0825 11.4377L30.1971 11.092L29.4464 9.72781C28.4356 7.89105 26.5053 6.75 24.4088 6.75H20.865C18.8241 6.75 16.9362 7.83179 15.9043 9.59252L14.9308 11.2534L14.5238 11.5537C13.5655 12.2606 13 13.3806 13 14.5714V16.3599C13 17.3264 13.7835 18.1099 14.75 18.1099H15.1516C15.4729 19.1702 16.4579 19.942 17.623 19.942C18.7893 19.942 19.775 19.1687 20.0954 18.107L20.0945 18.1099H27.6314C27.5595 17.8726 27.5208 17.6208 27.5208 17.3599C27.5208 17.0991 27.5595 16.8473 27.6315 16.6099H20.0945C19.7731 15.5497 18.7882 14.7779 17.623 14.7779C16.4579 14.7779 15.473 15.5497 15.1516 16.6099H14.75C14.6119 16.6099 14.5 16.498 14.5 16.3599V14.5714C14.5 13.8569 14.8393 13.1849 15.4143 12.7608L15.9452 12.369C16.027 12.3087 16.0957 12.2324 16.1471 12.1447L17.1984 10.351C17.9611 9.04958 19.3565 8.25 20.865 8.25H24.4088C25.9584 8.25 27.3852 9.09339 28.1322 10.451L29.0546 12.1271C29.1632 12.3245 29.3548 12.4626 29.5764 12.5032L31.812 12.9131C32.8804 13.1089 33.6563 14.04 33.6563 15.1262V16.3599C33.6563 16.498 33.5444 16.6099 33.4063 16.6099H32.5743C32.253 15.5497 31.2681 14.7779 30.1029 14.7779C28.6769 14.7779 27.5208 15.9339 27.5208 17.3599C27.5208 18.7859 28.6769 19.942 30.1029 19.942ZM30.1029 18.442C30.7005 18.442 31.1849 17.9575 31.1849 17.3599C31.1849 16.7623 30.7005 16.2779 30.1029 16.2779C29.5053 16.2779 29.0209 16.7623 29.0209 17.3599C29.0209 17.9575 29.5053 18.442 30.1029 18.442ZM18.7051 17.3599C18.7051 17.9575 18.2206 18.442 17.623 18.442C17.0254 18.442 16.541 17.9575 16.541 17.3599C16.541 16.7623 17.0254 16.2779 17.623 16.2779C18.2206 16.2779 18.7051 16.7623 18.7051 17.3599Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.75 12.75C23.3358 12.75 23 13.0858 23 13.5C23 13.9142 23.3358 14.25 23.75 14.25H24.25C24.6642 14.25 25 13.9142 25 13.5C25 13.0858 24.6642 12.75 24.25 12.75H23.75Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23 12H28C26.8889 9.5 24.6667 9 23 9V12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.5 12H22V9C20.3333 9 18.6111 9.5 17.5 12Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M40.5 16.2C40.5 23.6166 29.1621 38.5272 25.2832 43.4112C24.4828 44.4191 24 45 24 45C24 45 23.5172 44.4191 22.7168 43.4112C18.8379 38.5272 7.5 23.6166 7.5 16.2C7.5 7.25299 14.8873 0 24 0C33.1127 0 40.5 7.25299 40.5 16.2ZM38.5 16.2C38.5 17.9438 37.6567 20.5074 36.1301 23.586C34.6395 26.5918 32.6321 29.8288 30.5948 32.8325C28.5623 35.829 26.526 38.5555 24.9958 40.535C24.6327 41.0047 24.2984 41.4319 24 41.81C23.7016 41.4319 23.3673 41.0047 23.0042 40.535C21.474 38.5555 19.4377 35.829 17.4052 32.8325C15.3679 29.8288 13.3605 26.5918 11.8699 23.586C10.3433 20.5074 9.5 17.9438 9.5 16.2C9.5 8.39199 15.9571 2 24 2C32.0429 2 38.5 8.39199 38.5 16.2Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 43C8 41.1133 11.3438 39.4707 16.2805 38.6194C16.7125 39.2441 17.1395 39.8528 17.5576 40.4417C15.9379 40.6767 14.4925 40.9954 13.2828 41.3734C11.9439 41.7919 11.0058 42.2487 10.4458 42.6624C10.2465 42.8096 10.1305 42.9231 10.0643 43C10.1305 43.0769 10.2465 43.1904 10.4458 43.3377C11.0058 43.7514 11.9439 44.2081 13.2828 44.6266C15.937 45.456 19.7265 46 24 46C28.2735 46 32.063 45.456 34.7172 44.6266C36.0561 44.2081 36.9942 43.7514 37.5542 43.3377C37.7535 43.1904 37.8695 43.0769 37.9357 43C37.8695 42.9231 37.7535 42.8096 37.5542 42.6624C36.9942 42.2487 36.0561 41.7919 34.7172 41.3734C33.5075 40.9954 32.0621 40.6767 30.4424 40.4417C30.8605 39.8528 31.2875 39.2441 31.7195 38.6194C36.6562 39.4707 40 41.1133 40 43C40 45.7614 32.8366 48 24 48C15.1634 48 8 45.7614 8 43ZM38.0139 43.1096L38.0168 43.116C38.0174 43.1176 38.0176 43.1184 38.0175 43.1185C38.0173 43.1185 38.0159 43.1155 38.0139 43.1096Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2193_35033",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "48",
                        height: "48",
                        fill: "white"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/collections/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/commitment/commitment.tsx


const CommitmentIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm5-.015a9 9 0 1 0-10 0v6.335c0 .937 1.138 1.446 1.997 1.038l.066-.032L12 21.704l2.937 2.122.066.032c.86.408 1.997-.101 1.997-1.038v-6.335Zm-1.579.842A8.973 8.973 0 0 1 12 18a8.973 8.973 0 0 1-3.421-.673v5.042l2.59-1.871a1.448 1.448 0 0 1 1.662 0l2.59 1.871v-5.042Zm.36-10.047a.75.75 0 0 0-1.061-1.06l-3.97 3.97-1.47-1.47a.75.75 0 0 0-1.06 1.06l1.914 1.915.044.04c.013.016.027.03.042.045a.75.75 0 0 0 1.06 0l4.5-4.5Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/commitment/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/compare/compare.tsx


const CompareIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM8.471 4.195c.26.26.26.683 0 .943L6.276 7.333h13.057a.667.667 0 1 1 0 1.334H6.276l2.195 2.195a.667.667 0 0 1-.942.943L4.195 8.47a.667.667 0 0 1 0-.942L7.53 4.195c.26-.26.682-.26.942 0Zm7.058 15.61a.667.667 0 0 1 0-.943l2.195-2.195H4.667a.667.667 0 1 1 0-1.334h13.057l-2.195-2.195a.667.667 0 0 1 .942-.943l3.334 3.334a.667.667 0 0 1 0 .942l-3.334 3.334a.667.667 0 0 1-.942 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/compare/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/copy/copy.tsx


const CopyIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M21 1.5h-9a1.5 1.5 0 0 0-1.415 1H9.041A3 3 0 0 1 12 0h9a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3h-3.5v-1.5H21a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 21 1.5Zm-18 4h10A1.5 1.5 0 0 1 14.5 7v14a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 21V7A1.5 1.5 0 0 1 3 5.5ZM0 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/copy/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid/covid.tsx


const CovidIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.75 10.5a.75.75 0 0 1 .75-.75h.75V9a.75.75 0 0 1 1.5 0v.75h.75a.75.75 0 0 1 0 1.5h-.75V12a.75.75 0 0 1-1.5 0v-.75H6.5a.75.75 0 0 1-.75-.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M5.033.75a.75.75 0 0 1 .75-.75h4.684l1.282.812a.75.75 0 1 1-.803 1.267l-.914-.579H8.75v.65a2 2 0 0 1 1.5 1.915v.675a4.75 4.75 0 0 1 2.5 4.184V14a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2V8.924a4.75 4.75 0 0 1 2.5-4.184v-.675a2 2 0 0 1 1.5-1.915V1.5H5.783a.75.75 0 0 1-.75-.75ZM8.25 3.587h-.5a.5.5 0 0 0-.5.478h1.5a.5.5 0 0 0-.5-.478Zm3 10.413V8.924a3.25 3.25 0 1 0-6.5 0V14a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.269 3.022c.03.015.056.037.076.063l.04.052c.402.524.611.796.611 1.187a.822.822 0 0 1-.824.823.825.825 0 0 1-.824-.823c0-.39.209-.663.61-1.187L12 3.085a.219.219 0 0 1 .27-.063Z"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M9.25 16a.75.75 0 0 1 .75-.75h1.25V14a.75.75 0 0 1 1.5 0v1.25H14a.75.75 0 0 1 0 1.5h-1.25V18a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1-.75-.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M8.25 1A.75.75 0 0 1 9 .25h6.639L17.4 1.366a.75.75 0 0 1-.802 1.268l-1.396-.884H12.75V4h.75a2 2 0 0 1 2 2v1.544A6.001 6.001 0 0 1 19 13v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9a6.001 6.001 0 0 1 3.5-5.456V6a2 2 0 0 1 2-2h.75V1.75H9A.75.75 0 0 1 8.25 1Zm5.25 4.5h-3a.5.5 0 0 0-.5.5v1h4V6a.5.5 0 0 0-.5-.5Zm-7 7.5A4.5 4.5 0 0 1 11 8.5h2a4.5 4.5 0 0 1 4.5 4.5v9a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-9Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M18.324 4.032c.043.022.08.052.11.09l.057.076c.578.752.879 1.144.879 1.705a1.182 1.182 0 0 1-1.185 1.183A1.186 1.186 0 0 1 17 5.903c0-.561.3-.953.878-1.705l.058-.075a.314.314 0 0 1 .388-.09Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid-circle/covid-circle.tsx


const CovidCircleIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Zm1.5 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM9.033 4.75a.75.75 0 0 1 .75-.75h4.684l1.282.812a.75.75 0 1 1-.803 1.267l-.914-.579H12.75v.65a2 2 0 0 1 1.5 1.915v.675a4.75 4.75 0 0 1 2.5 4.184V18a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2v-5.076a4.75 4.75 0 0 1 2.5-4.184v-.675a2 2 0 0 1 1.5-1.915V5.5H9.783a.75.75 0 0 1-.75-.75Zm3.716 3.315a.5.5 0 0 0-.499-.478h-.5a.5.5 0 0 0-.5.478h1.5ZM15.25 18v-5.076a3.25 3.25 0 0 0-6.5 0V18a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5Zm-5.5-3.5a.75.75 0 0 1 .75-.75h.75V13a.75.75 0 0 1 1.5 0v.75h.75a.75.75 0 0 1 0 1.5h-.75V16a.75.75 0 0 1-1.5 0v-.75h-.75a.75.75 0 0 1-.75-.75Zm6.595-7.415a.219.219 0 0 0-.346 0l-.04.052c-.402.524-.611.796-.611 1.187a.822.822 0 0 0 .824.823.825.825 0 0 0 .825-.823c0-.39-.21-.663-.612-1.186l-.04-.053Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid-circle/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid-shield/covid-shield.tsx


const CovidShieldIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.519.209a.747.747 0 0 0-1.038 0C10.696.96 9.255 2.09 7.535 2.98c-1.73.895-3.66 1.504-5.453 1.332a.75.75 0 0 0-.822.747v6.202c-.173 3.18 1.775 9.909 10.504 12.701a.747.747 0 0 0 .472 0c8.729-2.792 10.677-9.521 10.503-12.701V5.059a.75.75 0 0 0-.821-.747c-1.793.172-3.723-.437-5.453-1.332C14.745 2.09 13.304.961 12.52.21Zm8.722 11.116c.148 2.549-1.413 8.53-9.241 11.136-7.828-2.605-9.389-8.587-9.24-11.136V5.841c1.93-.014 3.844-.69 5.464-1.529A20.031 20.031 0 0 0 12 1.762c.912.788 2.24 1.757 3.776 2.55 1.62.838 3.534 1.515 5.463 1.529v5.44l.002.044Zm-2.444-2.561a.75.75 0 0 0-1.094-1.028l-7.238 7.706-3.203-2.99a.75.75 0 1 0-1.024 1.096l3.75 3.5a.75.75 0 0 0 1.059-.034l7.75-8.25Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/covid-shield/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cross/cross.tsx


const CrossIcon = ({ color , size =13 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.78 1.28A.75.75 0 0 0 11.72.22L6.5 5.44 1.28.22A.75.75 0 1 0 .22 1.28L5.44 6.5.22 11.72a.75.75 0 1 0 1.06 1.06L6.5 7.56l5.22 5.22a.75.75 0 1 0 1.06-1.06L7.56 6.5l5.22-5.22Z",
            clipRule: "evenodd"
        }) : size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M.47 14.47a.75.75 0 0 0 1.06 1.06L8 9.06l6.47 6.47a.75.75 0 0 0 1.06-1.06L9.06 8l6.47-6.47A.75.75 0 1 0 14.47.47L8 6.94 1.53.47A.75.75 0 1 0 .47 1.53L6.94 8 .47 14.47Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M.47 22.47a.75.75 0 1 0 1.06 1.06L12 13.06l10.47 10.47a.75.75 0 1 0 1.06-1.06L13.06 12 23.53 1.53A.75.75 0 0 0 22.47.47L12 10.94 1.53.47A.75.75 0 0 0 .47 1.53L10.94 12 .47 22.47Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cross/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-breakdown/cinch-care-breakdown.tsx


const CinchCareBreakdownIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M16.821 19.25a1 1 0 0 0 .88-1.476l-4.822-8.9a1 1 0 0 0-1.758 0l-4.821 8.9a1 1 0 0 0 .879 1.476h9.642Zm-8.803-1.5L12 10.4l3.982 7.35H8.018Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M22.818 23a1 1 0 0 0 .879-1.477L12.879 1.617a1 1 0 0 0-1.758 0L.303 21.522A1 1 0 0 0 1.182 23h21.636ZM2.022 21.5 12 3.141l9.977 18.36H2.023Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-breakdown/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-servicing/cinch-care-servicing.tsx


const CinchCareServicingIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M7.75 1a.75.75 0 0 0-1.5 0v1H4a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4h-2.25V1a.75.75 0 0 0-1.5 0v1h-8.5V1Zm8.5 4V3.5h-8.5V5a.75.75 0 0 1-1.5 0V3.5H4A2.5 2.5 0 0 0 1.5 6v2h21V6A2.5 2.5 0 0 0 20 3.5h-2.25V5a.75.75 0 0 1-1.5 0Zm6.25 4.5h-21V20A2.5 2.5 0 0 0 4 22.5h16a2.5 2.5 0 0 0 2.5-2.5V9.5Zm-8.173 2.306a2.06 2.06 0 0 0-.966 2.29L5.5 18.634a1 1 0 1 0 1 1.732l7.86-4.538a2.06 2.06 0 0 0 2.466.308l.382-.22a2.501 2.501 0 0 0 1.191-2.709l-1.849 1.068a.75.75 0 0 1-.75-1.3l1.85-1.067a2.5 2.5 0 0 0-2.941-.323l-.383.22Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M0 0h24v24H0z"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-servicing/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-warranty/cinch-care-warranty.tsx


const CinchCareWarrantyIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.557 7.251c1.691-.73 3.207.258 4.443 1.365 1.236-1.107 2.752-2.096 4.444-1.365 1.245.539 2.033 1.84 2.056 3.183 0 2.234-3.556 5.942-5.745 8.225l-.006.006-.353.368a.549.549 0 0 1-.792 0l-.357-.372v-.001C9.056 16.377 5.5 12.668 5.5 10.434c.023-1.344.81-2.644 2.057-3.183Zm8.291 1.377c.649.28 1.132 1.008 1.152 1.817-.003.201-.098.591-.417 1.196-.31.589-.765 1.255-1.318 1.965-1 1.283-2.224 2.585-3.265 3.673-1.04-1.088-2.265-2.39-3.265-3.673-.553-.71-1.008-1.376-1.318-1.965-.319-.605-.414-.995-.417-1.197.02-.808.503-1.535 1.152-1.816.768-.332 1.607-.006 2.847 1.105a1.5 1.5 0 0 0 2.002 0c1.24-1.111 2.08-1.437 2.848-1.105Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.519.209a.747.747 0 0 0-1.038 0C10.696.96 9.255 2.09 7.535 2.98c-1.73.895-3.66 1.504-5.453 1.332a.75.75 0 0 0-.822.747v6.202c-.173 3.18 1.775 9.909 10.504 12.701a.747.747 0 0 0 .472 0c8.729-2.792 10.677-9.521 10.503-12.701V5.059a.75.75 0 0 0-.821-.747c-1.793.172-3.723-.437-5.453-1.332C14.745 2.09 13.304.961 12.52.21Zm8.722 11.116c.148 2.549-1.413 8.53-9.241 11.136-7.828-2.605-9.389-8.587-9.24-11.136V5.841c1.93-.014 3.844-.69 5.464-1.529A20.031 20.031 0 0 0 12 1.762c.912.788 2.24 1.757 3.776 2.55 1.62.838 3.534 1.515 5.463 1.529v5.44l.002.044Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M0 0h24v24H0z"
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-care-warranty/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-charge/cinch-charge.tsx


const CinchChargeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            fill: "none",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M21.695 16.038a10.503 10.503 0 0 0-2.27-11.463c-4.1-4.1-10.75-4.1-14.85 0s-4.1 10.75 0 14.85a10.493 10.493 0 0 0 9.76 2.813 3.41 3.41 0 0 0 .324-.113c.235-.093.55-.238.87-.448.648-.424 1.25-1.06 1.386-2.005.13-.908-.395-1.927-1.123-2.825a9.88 9.88 0 0 0-.748-.82l-.589.589c-.22.22-.487.385-.782.483l-1.561.52a2 2 0 0 1-2.047-.483l-2.308-2.308a2 2 0 0 1 0-2.828l-1.59-1.591a.75.75 0 1 1 1.06-1.06l1.591 1.59 2.121-2.121-1.59-1.591a.75.75 0 1 1 1.06-1.06L12 7.756a2 2 0 0 1 2.828 0l2.308 2.308a2 2 0 0 1 .483 2.047l-.52 1.561a2 2 0 0 1-.483.782l-.511.511c.26.257.56.574.853.937.776.958 1.665 2.414 1.441 3.981-.218 1.53-1.2 2.492-2.048 3.048a6.37 6.37 0 0 1-1.625.755 11.991 11.991 0 0 1-11.211-3.202c-4.687-4.686-4.687-12.284 0-16.97 4.686-4.687 12.284-4.687 16.97 0 3.546 3.545 4.409 8.756 2.59 13.113a.79.79 0 0 1-.021.05l-.014.034-.001-.003a.75.75 0 0 1-1.342-.67h-.002Zm-8.634-7.22-4.243 4.243a.5.5 0 0 0 0 .707l2.308 2.308a.5.5 0 0 0 .512.12l1.561-.52a.5.5 0 0 0 .196-.12l2.16-2.161a.5.5 0 0 0 .121-.196l.52-1.561a.5.5 0 0 0-.12-.512l-2.308-2.308a.5.5 0 0 0-.707 0Z",
                clipRule: "evenodd"
            })
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/cinch-charge/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/external-link/external-link.tsx


const ExternalLinkIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.5.75A.75.75 0 0 1 7.25 0H16v8.75a.75.75 0 0 1-1.5 0V2.562L7.53 9.53a.75.75 0 1 1-1.06-1.06l6.97-6.97H7.25A.75.75 0 0 1 6.5.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 2h2v1.5H3A1.5 1.5 0 0 0 1.5 5v8A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5v-2H14v2a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.306 13.056a.75.75 0 0 1-.75-.75V2.504L10.03 15.03a.75.75 0 1 1-1.06-1.06L21.44 1.5h-9.69a.75.75 0 0 1 0-1.5h11.556a.75.75 0 0 1 .75.75v11.556a.75.75 0 0 1-.75.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.75 5.25A3.25 3.25 0 0 0 1.5 8.5v10.75a3.25 3.25 0 0 0 3.25 3.25h11A3.25 3.25 0 0 0 19 19.25v-6.362a.75.75 0 1 1 1.5 0v6.362A4.75 4.75 0 0 1 15.75 24h-11A4.75 4.75 0 0 1 0 19.25V8.5a4.75 4.75 0 0 1 4.75-4.75h6.5a.75.75 0 0 1 0 1.5h-6.5Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/external-link/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/features/features.tsx


const FeaturesIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M8.53 2.78a.75.75 0 0 0-1.06-1.06L3 6.19 1.53 4.72A.75.75 0 0 0 .47 5.78L3 8.31l5.53-5.53ZM8.53 10.53a.75.75 0 1 0-1.06-1.06L3 13.94l-1.47-1.47a.75.75 0 0 0-1.06 1.06L3 16.06l5.53-5.53ZM11 5.25a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1-.75-.75ZM11.75 12a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5h-11.5ZM11 20.25a.75.75 0 0 1 .75-.75h11.5a.75.75 0 0 1 0 1.5h-11.5a.75.75 0 0 1-.75-.75ZM3.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/features/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/filter/filter.tsx


const FilterIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8.539 5.25a3.335 3.335 0 0 1-6.411 0H.75a.75.75 0 0 1 0-1.5h1.3a3.334 3.334 0 0 1 6.566 0h6.634a.75.75 0 0 1 0 1.5H8.539Zm-1.372-.917a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0ZM10.667 9a3.334 3.334 0 0 1 3.282 2.75h1.301a.75.75 0 0 1 0 1.5h-1.378l.002-.004a3.335 3.335 0 0 1-6.413.004H.75a.75.75 0 0 1 0-1.5h6.634A3.334 3.334 0 0 1 10.667 9Zm1.833 3.333a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.944 6.75a5.001 5.001 0 0 1-9.888 0H.75a.75.75 0 0 1 0-1.5h2.306a5.001 5.001 0 0 1 9.888 0H23.25a.75.75 0 0 1 0 1.5H12.944ZM11.5 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0ZM16 13a5.001 5.001 0 0 1 4.944 4.25h2.306a.75.75 0 0 1 0 1.5h-2.306a5.001 5.001 0 0 1-9.888 0H.75a.75.75 0 0 1 0-1.5h10.306A5.001 5.001 0 0 1 16 13Zm3.5 5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/filter/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/finance/finance.tsx


const FinanceIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5 4.75A.75.75 0 0 1 5.75 4h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 5 4.75ZM5.75 7a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM5 10.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M5 0a3 3 0 0 0-3 3v5.084c-1.15.296-2 1.34-2 2.583V12a4.001 4.001 0 0 0 4 4h9a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H5Zm8 1.5H5A1.5 1.5 0 0 0 3.5 3v11a.5.5 0 0 0 .5.5h9a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 13 1.5ZM2 9.71v3.79a2.489 2.489 0 0 1-.5-1.5v-1.333c0-.397.198-.747.5-.958Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 7a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H8.75A.75.75 0 0 1 8 7ZM8.75 11.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H8.75ZM8 17a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 8 17Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M8 0a4 4 0 0 0-4 4v8H2a2 2 0 0 0-2 2v4a6.003 6.003 0 0 0 6 6h14a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H8Zm12 1.5H8A2.5 2.5 0 0 0 5.5 4v18a.5.5 0 0 0 .5.5h14a2.5 2.5 0 0 0 2.5-2.5V4A2.5 2.5 0 0 0 20 1.5Zm-16 12v8.532A4.5 4.5 0 0 1 1.5 18v-4a.5.5 0 0 1 .5-.5h2Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/finance/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/fuel/fuel.tsx


const FuelIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13.035 6.769C14.985 9.694 16 11.216 16 13.399c0 1.22-.421 2.39-1.172 3.254C14.078 17.515 13.061 18 12 18c-1.06 0-2.078-.485-2.828-1.347C8.422 15.79 8 14.62 8 13.4c0-2.184 1.015-3.706 2.965-6.632C11.218 6.39 11.49 6 12 6c.503 0 .78.388 1.035.769ZM9.5 13.399c0-1.582.644-2.686 2.5-5.478 1.856 2.792 2.5 3.896 2.5 5.479 0 .884-.307 1.698-.803 2.268-.49.564-1.107.832-1.697.832-.59 0-1.206-.268-1.697-.832-.496-.57-.803-1.383-.803-2.268Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/fuel/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/edit/edit.tsx


const EditIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.189 6.312a2 2 0 0 0 0-2.829L20.36.655a2 2 0 0 0-2.828 0L6.65 11.693c-.127.79-.28 3.066-.373 4.608-.053.871-.087 1.508-.087 1.508s.635-.039 1.508-.097c1.513-.1 3.74-.256 4.609-.362L23.189 6.312Zm-11.574 9.603 7.813-7.926-3.535-3.535-7.82 7.932a82.13 82.13 0 0 0-.23 2.927c-.021.309-.04.61-.057.89l.846-.057c1.082-.075 2.233-.16 2.983-.231Zm5.331-12.53 3.536 3.536 1.646-1.67a.5.5 0 0 0 0-.707l-2.829-2.829a.5.5 0 0 0-.704-.002l-1.649 1.672ZM3.75 3A.25.25 0 0 1 4 2.75h8.25a.75.75 0 0 0 0-1.5H4A1.75 1.75 0 0 0 2.25 3v19.5c0 .966.784 1.75 1.75 1.75h16a1.75 1.75 0 0 0 1.75-1.75V11.719a.75.75 0 0 0-1.5 0V22.5a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V3Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/edit/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/electric/electric.tsx


const ElectricIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13.768 2.05c-3.26 4.312-7.485 9.698-9.3 12.004H9.54c.711 0 1.27.588 1.211 1.274l-.592 6.9 8.902-11.782H13.95c-.739 0-1.306-.632-1.204-1.34l1.023-7.055ZM12.957.733c.23-.306.596-.482.981-.482h.166c.738 0 1.306.632 1.204 1.34l-1.08 7.444h5.312c.995 0 1.569 1.094.981 1.871L10.8 23.773c-.227.3-.587.477-.97.477-.704 0-1.257-.582-1.199-1.26l.646-7.524H3.978c-1 0-1.583-1.11-.968-1.89C4.674 11.464 9.475 5.355 12.957.732Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/electric/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/emissions/emissions.tsx


const EmissionsIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14.25 1A.75.75 0 0 1 15 .25c4.735 0 8.75 3.379 8.75 7.75 0 2.657-1.484 4.948-3.711 6.335A4.877 4.877 0 0 1 19.125 24H.75a.75.75 0 0 1 0-1.5h18.375a3.375 3.375 0 1 0 0-6.75H12.847a.75.75 0 0 1 0-1.5H15c4.101 0 7.25-2.89 7.25-6.25S19.101 1.75 15 1.75a.75.75 0 0 1-.75-.75ZM6 11a3.75 3.75 0 1 0 0 7.5h3.75a.5.5 0 0 1 0 1H1A.75.75 0 0 0 1 21h8.75a2 2 0 0 0 .622-3.901A.747.747 0 0 0 10 17H6a2.25 2.25 0 0 1 0-4.5h3A.75.75 0 0 0 9 11h-.11a3.77 3.77 0 1 1 7.117-2.187.75.75 0 1 0 1.486-.202A5.272 5.272 0 1 0 7.271 11H6Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/emissions/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/engine/engine.tsx


const EngineIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.597 14.882A3.501 3.501 0 0 1 10.5 8c1.484 0 2.753.924 3.262 2.228l3.442 3.873a2.501 2.501 0 1 1-2.607 4.02l-.006.008-4.994-3.247ZM10.5 13.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm1.507 1.16a3.51 3.51 0 0 0 1.827-2.093l1.52 1.71a2.504 2.504 0 0 0-1.302 1.712l-2.045-1.33ZM17.5 16.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.25.75A.75.75 0 0 1 6 0h13a.75.75 0 0 1 0 1.5h-1V4h.992a2 2 0 0 1 2 2v1.286a1 1 0 0 0 1 1h.508V6A.75.75 0 0 1 24 6v16a.75.75 0 0 1-1.5 0v-1.55a1.786 1.786 0 0 0-1.508 1.764c0 .987-.8 1.786-1.786 1.786H6.803a2 2 0 0 1-1.566-.756l-1.803-2.27A2 2 0 0 1 3 19.732V19H1.5v1A.75.75 0 0 1 0 20V8a.75.75 0 0 1 1.5 0v1H3v-.016a2 2 0 0 1 .434-1.245l2.37-2.983A2 2 0 0 1 7 4.035V1.5H6a.75.75 0 0 1-.75-.75ZM4.5 19.73a.5.5 0 0 0 .109.312l1.803 2.27a.5.5 0 0 0 .391.188h12.403a.286.286 0 0 0 .286-.286A3.286 3.286 0 0 1 22.5 18.94V9.786h-.508a2.5 2.5 0 0 1-2.5-2.5V6a.5.5 0 0 0-.5-.5H7.37a.5.5 0 0 0-.392.189L4.61 8.673a.5.5 0 0 0-.109.31v10.748ZM3 10.5H1.5v7H3v-7Zm5.5-9h8V4h-8V1.5Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/engine/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/engine-power/engine-power.tsx


const EnginePowerIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M12.605 5.194c2.597-1.414 5.473-2.06 8.78-2.175l-.877 2.191.755.252c.145.048.411.186.63.417.208.218.357.5.357.871v10.237l-.767.959a1.25 1.25 0 0 1-1.596.304l-1.637-.935V15.06l-.688-.057c-.897-.075-2.144-.438-3.008-1.221a3.043 3.043 0 0 1-.916-1.462c-.167-.603-.185-1.379.086-2.373a.75.75 0 1 0-1.448-.394c-.329 1.206-.335 2.26-.083 3.168a4.542 4.542 0 0 0 1.487 2.289l-5.295 5.294 1.522.19c.582.073 1.464.318 2.178.793.697.464 1.165 1.09 1.165 1.963a.75.75 0 0 0 1.5 0c0-1.528-.866-2.567-1.835-3.212a6.398 6.398 0 0 0-1.44-.703l3.501-3.5a7.373 7.373 0 0 0 1.774.569v1.781l2.393 1.367a2.75 2.75 0 0 0 3.511-.67l1.096-1.369V6.75c0-.828-.35-1.464-.769-1.904a3.21 3.21 0 0 0-.532-.45L23.608 1.5H22.5c-4.082 0-7.64.7-10.836 2.5H1a.75.75 0 0 0 0 1.5h8.412A20.755 20.755 0 0 0 7.47 7.22c-.665.664-1.684 1.12-2.762 1.405A11.337 11.337 0 0 1 2 9a.75.75 0 0 0 0 1.5c.726 0 1.891-.107 3.092-.425C6.28 9.76 7.595 9.215 8.53 8.28a18.016 18.016 0 0 1 3.543-2.783.75.75 0 0 0 .532-.303Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M19.53 7.22a.75.75 0 1 0-1.06 1.06l1 1a.75.75 0 1 0 1.06-1.06l-1-1Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/engine-power/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/door/door.tsx


const DoorIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M5.364 10.15A2 2 0 0 0 5 11.3v.7a2 2 0 0 0 2 2h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-8.274a2 2 0 0 0-1.636.85l-3.726 5.3ZM18.5 5.5h-7.774a.5.5 0 0 0-.409.212l-3.726 5.3a.5.5 0 0 0-.09.287V12a.5.5 0 0 0 .5.5h11.5v-7Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M15 15.25a.75.75 0 0 0 0 1.5h4a.75.75 0 1 0 0-1.5h-4Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M24 20a4 4 0 0 1-4 4H7.166a4 4 0 0 1-3.76-2.633L.692 13.902a4 4 0 0 1 .43-3.586l5.69-8.535A4 4 0 0 1 10.142 0H24v20Zm-1.5 0V1.5H10.14a2.5 2.5 0 0 0-2.08 1.113l-5.69 8.535a2.5 2.5 0 0 0-.269 2.241l2.715 7.465a2.5 2.5 0 0 0 2.35 1.646H20a2.5 2.5 0 0 0 2.5-2.5Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/door/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/drive-type/drive-type.tsx


const DriveTypeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0 1.5c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M11.5 17.478v-2.52a2.984 2.984 0 0 1-1.238-.513L8.48 16.227a5.475 5.475 0 0 0 3.02 1.25Zm-3.727-1.959 1.782-1.78a2.984 2.984 0 0 1-.507-1.2H6.526a5.475 5.475 0 0 0 1.247 2.98ZM6.52 11.54h2.516c.073-.471.255-.906.52-1.278L7.775 8.48a5.475 5.475 0 0 0-1.256 3.06Zm1.963-3.767 1.78 1.782a2.984 2.984 0 0 1 1.238-.513V6.522a5.475 5.475 0 0 0-3.018 1.25Zm7.037 8.455a5.476 5.476 0 0 1-3.019 1.25V14.96a2.984 2.984 0 0 0 1.238-.514l1.781 1.782Zm.708-.707a5.475 5.475 0 0 0 1.247-2.982h-2.522c-.08.441-.257.849-.507 1.2l1.782 1.782Zm1.254-3.982a5.476 5.476 0 0 0-1.255-3.058l-1.78 1.782c.264.371.446.806.519 1.276h2.516Zm-1.962-3.765-1.78 1.782A2.984 2.984 0 0 0 12.5 9.04V6.522a5.476 5.476 0 0 1 3.02 1.251ZM19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-5.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/drive-type/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/fuel-pump/fuel-pump.tsx


const FuelPumpIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7 6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7Zm-.5 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M22.416.376a.75.75 0 0 1 .208 1.04L20.75 4.227v1.099a3.751 3.751 0 0 1 0 7.348v5.353a3.455 3.455 0 0 1-.022.367 3.728 3.728 0 0 1-.197.864 2.412 2.412 0 0 1-.652.992c-.352.31-.815.5-1.379.5-.564 0-1.027-.19-1.38-.5a2.412 2.412 0 0 1-.651-.992 3.723 3.723 0 0 1-.219-1.23V8.945l.007-.046v-.012a.806.806 0 0 0-.052-.343.371.371 0 0 0-.148-.178c-.076-.048-.237-.117-.557-.117H15V21.5c.966 0 1.75.784 1.75 1.75a.75.75 0 0 1-1.5 0A.25.25 0 0 0 15 23H2a.25.25 0 0 0-.25.25.75.75 0 0 1-1.5 0c0-.966.784-1.75 1.75-1.75V7a4 4 0 0 1 4-4h5a4 4 0 0 1 3.992 3.75h.508c.54 0 .995.119 1.362.352.37.234.593.55.722.854a2.248 2.248 0 0 1 .166 1.085V18.059a2.427 2.427 0 0 0 .128.684.93.93 0 0 0 .235.382c.073.064.181.125.387.125.206 0 .314-.06.387-.125a.928.928 0 0 0 .235-.382 2.231 2.231 0 0 0 .128-.725V3.773L21.376.584a.75.75 0 0 1 1.04-.208ZM13.5 7v14.5h-10V7A2.5 2.5 0 0 1 6 4.5h5A2.5 2.5 0 0 1 13.5 7Zm7.25 4.121V6.88l.111.042a2.25 2.25 0 0 1-.111 4.2Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/fuel-pump/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/full-screen/full-screen.tsx


const FullScreenIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            fill: "currentColor",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.056.75a.75.75 0 0 1-.75.75H2.504L8.53 7.526a.75.75 0 0 1-1.06 1.06L1.5 2.618v4.69a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 .75 0h6.556a.75.75 0 0 1 .75.75ZM22.556 7.306a.75.75 0 1 0 1.5 0V.75a.75.75 0 0 0-.75-.75H16.75a.75.75 0 0 0 0 1.5h4.69l-5.97 5.97a.75.75 0 0 0 1.06 1.06l6.026-6.026v4.802ZM.75 16a.75.75 0 0 1 .75.75v4.802l6.026-6.026a.75.75 0 1 1 1.06 1.06l-5.969 5.97h4.69a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1-.75-.75V16.75A.75.75 0 0 1 .75 16ZM16 23.306a.75.75 0 0 1 .75-.75h4.802l-6.026-6.026a.75.75 0 1 1 1.06-1.06l5.97 5.97v-4.69a.75.75 0 0 1 1.5 0v6.556a.75.75 0 0 1-.75.75H16.75a.75.75 0 0 1-.75-.75Z"
            })
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/full-screen/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/gallery/gallery.tsx


const GalleryIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M17.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M0 6a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6Zm20-2.48H4A2.48 2.48 0 0 0 1.52 6v10.48l4.961-4.672c1.144-1.077 2.999-1.077 4.142 0l3.787 3.566 1.194-1.125c1.106-1.04 2.884-1.08 4.041-.09l2.835 2.426V6A2.48 2.48 0 0 0 20 3.52Zm2.416 15.044-3.845-3.292a1.391 1.391 0 0 0-1.837.041l-1.76 1.656a.834.834 0 0 1-1.129 0l-4.351-4.097a1.39 1.39 0 0 0-1.883 0l-6.03 5.678A2.48 2.48 0 0 0 4 20.48h16a2.48 2.48 0 0 0 2.416-1.916Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/gallery/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/go/go.tsx


const GoIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M11.72 22.47a.75.75 0 1 0 1.06 1.06l11-11a.75.75 0 0 0 0-1.06l-11-11a.75.75 0 1 0-1.06 1.06l9.72 9.72H.75a.75.75 0 0 0 0 1.5h20.69l-9.72 9.72Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/go/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/hand/hand.tsx


const HandIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.35 1.5c-.58 0-1.05.47-1.05 1.05v12.2a.75.75 0 0 1-1.331.474l-2.542-3.12a1.908 1.908 0 0 0-2.48-.418l4.547 8.58a3.25 3.25 0 0 0 2.317 1.68l3.267.565a.75.75 0 1 1-.256 1.478l-3.266-.565a4.75 4.75 0 0 1-3.387-2.456l-4.786-9.03A.883.883 0 0 1 .54 10.9a3.407 3.407 0 0 1 5.051.257l1.21 1.485V2.55a2.55 2.55 0 0 1 5.1 0v4.256a2.605 2.605 0 0 1 2.84 1.048 2.75 2.75 0 0 1 4.037 1.023l.026.051c1.58-.753 3.468.412 3.497 2.21v.016l-.033 6.128a10.75 10.75 0 0 1-2.056 6.265l-.104.144a.75.75 0 1 1-1.213-.882l.104-.144a9.25 9.25 0 0 0 1.77-5.391l.032-6.119c-.017-.771-.874-1.204-1.483-.799a1.176 1.176 0 0 1-1.704-.452l-.177-.356a1.25 1.25 0 0 0-1.9-.417l-.12.097a1.213 1.213 0 0 1-1.843-.405 1.1 1.1 0 0 0-1.819-.225l-.035.041A.75.75 0 0 1 10.4 8.15v-5.6c0-.58-.47-1.05-1.05-1.05Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/hand/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/heart-filled/heart-filled.tsx


const HeartFilledIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 2.49C6.48 1.125 4.613-.09 2.53.81.998 1.471.028 3.071 0 4.725c0 2.75 4.377 7.315 7.072 10.125.152.158.3.312.44.46.266.277.71.277.976 0l.44-.461C11.624 12.04 16 7.476 16 4.726c-.028-1.654-.998-3.254-2.531-3.917-2.082-.9-3.948.317-5.47 1.68Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.999 7.355c0 4.124-6.564 10.97-10.606 15.184l-.661.69a1.013 1.013 0 0 1-1.463 0l-.66-.689C6.566 18.326 0 11.48 0 7.355c.042-2.48 1.497-4.88 3.797-5.875C6.92.13 9.718 1.955 12 4c2.281-2.045 5.08-3.87 8.203-2.52 2.3.994 3.754 3.394 3.796 5.875Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/heart-filled/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/heart-outline/heart-outline.tsx


const HeartOutlineIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 2.49C6.48 1.125 4.613-.09 2.53.81.998 1.471.028 3.071 0 4.725c0 2.75 4.377 7.315 7.072 10.125.152.158.3.312.44.46.266.277.71.277.976 0l.44-.461C11.624 12.04 16 7.476 16 4.726c-.028-1.654-.998-3.254-2.531-3.917-2.082-.9-3.948.317-5.47 1.68Zm6.5 2.248c-.024-1.12-.69-2.147-1.626-2.552-1.159-.5-2.348.053-3.873 1.42a1.5 1.5 0 0 1-2.003 0c-1.524-1.367-2.713-1.92-3.872-1.42C2.19 2.591 1.525 3.62 1.5 4.738c.003.328.148.868.553 1.636.395.75.968 1.588 1.656 2.47 1.324 1.699 2.96 3.42 4.291 4.807 1.33-1.388 2.968-3.109 4.292-4.808.687-.882 1.26-1.72 1.655-2.47.405-.767.55-1.307.553-1.635Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13 5.117a1.5 1.5 0 0 1-2.002 0c-2.284-2.049-4.406-3.21-6.605-2.26C2.69 3.593 1.54 5.421 1.5 7.367c.004.712.32 1.72 1.023 3.008.69 1.264 1.67 2.65 2.806 4.07 2.03 2.54 4.45 5.063 6.36 7.056l.31.323.31-.324c1.912-1.993 4.33-4.515 6.36-7.055 1.135-1.42 2.116-2.806 2.806-4.07.703-1.287 1.02-2.296 1.023-3.008-.038-1.946-1.189-3.774-2.891-4.51-2.2-.95-4.321.211-6.607 2.26ZM24 7.355c0 4.124-6.564 10.97-10.606 15.184l-.661.69a1.013 1.013 0 0 1-1.463 0l-.66-.689C6.566 18.326 0 11.48 0 7.355c.042-2.48 1.497-4.88 3.797-5.875C6.92.13 9.718 1.955 12 4c2.281-2.045 5.08-3.87 8.203-2.52 2.3.994 3.754 3.394 3.796 5.875Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/heart-outline/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/home/home.tsx


const HomeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.436 7.89 12.519.092.59 7.872a.75.75 0 1 0 .82 1.256l1.34-.874V22.25c0 .966.784 1.75 1.75 1.75h1.75A1.75 1.75 0 0 0 8 22.25V18a.25.25 0 0 1 .25-.25H11a.25.25 0 0 1 .25.25v4.25c0 .966.784 1.75 1.75 1.75h6.5a1.75 1.75 0 0 0 1.75-1.75V8.172l1.314.938a.75.75 0 1 0 .872-1.22ZM19.75 7.1l-7.27-5.192-8.23 5.368V22.25c0 .138.112.25.25.25h1.75a.25.25 0 0 0 .25-.25V18c0-.966.784-1.75 1.75-1.75H11c.966 0 1.75.784 1.75 1.75v4.25c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25V7.1Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/home/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/home-delivery/home-delivery.tsx


const HomeDeliveryIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 24 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.436 7.89 12.519.091.59 7.872a.75.75 0 1 0 .82 1.256l11.07-7.22L19.75 7.1v15.4H3A.75.75 0 1 0 3 24h17.5a.75.75 0 0 0 .75-.75V8.17l1.314.939a.75.75 0 1 0 .872-1.22Zm-10.709 4.547C12 11.291 9.818 9 6.91 9s-4.848 1.585-5.454 2.731c-.099.596-.398 1.195-.697 1.796-.343.687-.687 1.376-.734 2.066C0 15.955 0 16.346 0 16.733c0 .958.352 1.554.69 1.877.218.209.518.265.814.271C1.915 20.116 3.027 21 4.334 21c1.04 0 1.958-.562 2.496-1.416a3.214 3.214 0 0 0 .333-.702H8.17a3.255 3.255 0 0 0 .332.702C9.041 20.438 9.958 21 11 21c1.306 0 2.418-.884 2.83-2.118h.022c.455 0 .916-.11 1.243-.445.445-.456.905-1.186.905-2.133 0-1.719 0-3.069-3.273-3.867Zm-9.855-.155c-.169.708-.496 1.362-.735 1.84l-.037.075c-.378.758-.556 1.165-.579 1.497-.02.302-.021.64-.021 1.04 0 .326.066.53.127.65l.966.022.334 1c.228.686.81 1.094 1.406 1.094.597 0 1.178-.408 1.407-1.093l.342-1.025h3.17l.342 1.025c.228.685.81 1.093 1.406 1.093.596 0 1.178-.408 1.406-1.093l.343-1.025h1.103a.755.755 0 0 0 .196-.02c.253-.27.452-.634.452-1.058 0-.959-.04-1.26-.18-1.482-.1-.159-.453-.563-1.948-.928l-.587-.143-.324-.51c-.266-.418-.862-1.134-1.698-1.733-.829-.593-1.802-1.008-2.854-1.008-2.208 0-3.581 1.119-4.037 1.782Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M25.0257 0.289551L1.45385 15.6625C0.991248 15.9642 0.86081 16.5838 1.16251 17.0464C1.4642 17.509 2.08378 17.6394 2.54638 17.3377L24.9744 2.71073L40.0796 13.5001H40V46.0001H6.00012C5.44783 46.0001 5.00012 46.4479 5.00012 47.0001C5.00012 47.5524 5.44783 48.0001 6.00012 48.0001H41C41.5523 48.0001 42 47.5524 42 47.0001V14.8719L45.4188 17.3138C45.8682 17.6349 46.4928 17.5308 46.8138 17.0814C47.1348 16.6319 47.0307 16.0074 46.5813 15.6864L25.0257 0.289551Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M29.0387 42C31.4148 42 33.341 40.0738 33.341 37.6977C33.341 35.3215 31.4148 33.3953 29.0387 33.3953C27.0068 33.3953 25.3039 34.8038 24.8531 36.6977H12.4298C11.979 34.8038 10.2761 33.3953 8.24424 33.3953C5.86812 33.3953 3.94189 35.3215 3.94189 37.6977C3.94189 40.0738 5.86812 42 8.24424 42C10.2761 42 11.9789 40.5915 12.4298 38.6977H24.8532C25.304 40.5915 27.0068 42 29.0387 42ZM29.0387 40C30.3102 40 31.341 38.9692 31.341 37.6977C31.341 36.4261 30.3102 35.3953 29.0387 35.3953C27.7671 35.3953 26.7363 36.4261 26.7363 37.6977C26.7363 38.9692 27.7671 40 29.0387 40ZM10.5466 37.6977C10.5466 38.9692 9.51579 40 8.24424 40C6.97269 40 5.94189 38.9692 5.94189 37.6977C5.94189 36.4261 6.97269 35.3953 8.24424 35.3953C9.51579 35.3953 10.5466 36.4261 10.5466 37.6977Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.0291 20.2685C10.4798 20.2685 7.19646 22.1499 5.40175 25.212L3.94758 27.6931L3.63491 27.9238C1.84621 29.2434 0.790527 31.334 0.790527 33.5568V36.6977C0.790527 37.8023 1.68596 38.6977 2.79053 38.6977H4.05868C3.98229 38.3768 3.94189 38.0419 3.94189 37.6977C3.94189 37.3534 3.98229 37.0186 4.05867 36.6977H2.79053V33.5568C2.79053 31.9691 3.54458 30.4758 4.82223 29.5332L5.30014 29.1807C5.40917 29.1002 5.50071 28.9985 5.56922 28.8816L7.12723 26.2233C8.563 23.7736 11.1897 22.2685 14.0291 22.2685H19.1556C22.0724 22.2685 24.7581 23.856 26.1644 26.4115L27.5107 28.8581C27.6556 29.1212 27.911 29.3054 28.2065 29.3595L31.1109 29.892C33.485 30.3273 35.2093 32.3964 35.2093 34.8101V36.6977H33.2244C33.3008 37.0186 33.341 37.3534 33.341 37.6977C33.341 38.0419 33.3008 38.3768 33.2244 38.6977H35.2093C36.3138 38.6977 37.2093 37.8023 37.2093 36.6977V34.8101C37.2093 31.4309 34.7953 28.5342 31.4716 27.9248L29.0341 27.4779L27.9166 25.4473C26.1588 22.2529 22.8017 20.2685 19.1556 20.2685H14.0291Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.4531 30.2661C17.9008 30.2661 17.4531 30.7138 17.4531 31.2661C17.4531 31.8184 17.9008 32.2661 18.4531 32.2661H19.2863C19.8385 32.2661 20.2863 31.8184 20.2863 31.2661C20.2863 30.7138 19.8385 30.2661 19.2863 30.2661H18.4531Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M24.9923 29.0001H18C17.4478 29.0001 17 28.5524 17 28.0001V24.0001C17 23.4478 17.4479 22.9958 17.9988 23.0345C20.6803 23.2229 23.8315 24.2486 25.8267 27.6515C26.1887 28.2688 25.7079 29.0001 24.9923 29.0001ZM18.5 27.5001H23.9179C22.4292 25.5858 20.4276 24.8261 18.5 24.5891V27.5001Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14 29.0001H8.47027C7.76463 29.0001 7.28146 28.2871 7.60261 27.6588C9.32287 24.2931 11.6514 23.2493 14.0012 23.0421C14.5514 22.9935 15 23.4478 15 24.0001V28.0001C15 28.5524 14.5523 29.0001 14 29.0001ZM9.41596 27.5001H13.5V24.6179C12.7459 24.7482 12.0391 24.9983 11.3821 25.4245C10.7176 25.8554 10.0458 26.5042 9.41596 27.5001Z",
                    fill: "currentColor"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/home-delivery/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/info/info.tsx


const InfoIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.994 5.506C8.595 5.506 9 5.048 9 4.5s-.405-.994-1.006-.994A.97.97 0 0 0 7 4.5c0 .548.405 1.006.994 1.006ZM8 12.5a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1Z"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.994 8C12.595 8 13 7.541 13 6.994 13 6.446 12.595 6 11.994 6a.97.97 0 0 0-.994.994C11 7.54 11.405 8 11.994 8ZM12 18a1 1 0 0 0 1-1v-6a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/info/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/learner/learner.tsx


const LearnerIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8 6h3v9h5v3H8V6Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M20 1.5H4A2.5 2.5 0 0 0 1.5 4v16A2.5 2.5 0 0 0 4 22.5h16a2.5 2.5 0 0 0 2.5-2.5V4A2.5 2.5 0 0 0 20 1.5ZM4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/learner/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/light-bulb/light-bulb.tsx


const LightBulbIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M15.234 20.074c.466-.366.766-.935.766-1.574v-2l.123-.493c.124-.495.438-.914.838-1.23a8 8 0 1 0-9.922 0c.4.316.714.735.838 1.23L8 16.5v2c0 .639.3 1.208.766 1.574a3.25 3.25 0 0 0 6.468 0ZM9.421 16h5.158l.09-.357c.22-.886.765-1.571 1.361-2.043a6.5 6.5 0 1 0-8.06 0c.595.472 1.14 1.157 1.362 2.043l.09.357Zm5.079 1.5h-5v1c0 .09.024.176.067.25h4.866a.498.498 0 0 0 .067-.25v-1Zm-.822 2.75h-3.356a1.75 1.75 0 0 0 3.356 0Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M3.53 3.53a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 1.06-1.061L3.53 3.53ZM20.47 3.53a.75.75 0 0 0 1.06 1.061l1.061-1.06a.75.75 0 1 0-1.06-1.061L20.47 3.53ZM21 8a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 21 8ZM21.53 11.47l1.061 1.06a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 1 1 1.06-1.061ZM3 8a.75.75 0 0 0-.75-.75H.75a.75.75 0 0 0 0 1.5h1.5A.75.75 0 0 0 3 8ZM3.53 11.47a.75.75 0 0 0-1.06 0l-1.061 1.06a.75.75 0 0 0 1.06 1.061l1.061-1.06a.75.75 0 0 0 0-1.061Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/light-bulb/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/link/link.tsx


const LinkIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.72 18.47a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06l-7-7a.75.75 0 1 0-1.06 1.06l5.72 5.72H.75a.75.75 0 0 0 0 1.5h20.69l-5.72 5.72Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/link/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/loading-spinner/loading-spinner.tsx


const LoadingSpinnerIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8 1.5A6.5 6.5 0 1 0 14.5 8 .75.75 0 0 1 16 8a8 8 0 1 1-2.5-5.81.75.75 0 0 1-1.031 1.09A6.475 6.475 0 0 0 8 1.5Z",
            clipRule: "evenodd",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                dur: "1s",
                from: "0 8 8",
                to: "360 8 8",
                repeatCount: "indefinite"
            })
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/loading-spinner/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mileage/mileage.tsx


const MileageIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M1.75 14C1.75 8.34 6.34 3.75 12 3.75S22.25 8.34 22.25 14a.75.75 0 0 0 1.5 0c0-6.49-5.26-11.75-11.75-11.75S.25 7.51.25 14a.75.75 0 0 0 1.5 0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M13 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM4 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17.5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM21 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12 20.5a2.5 2.5 0 1 0-.579-4.933L8.96 11.136a.75.75 0 0 0-1.312.728l2.485 4.473A2.5 2.5 0 0 0 12 20.5Zm1-2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mileage/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mot/mot.tsx


const MOTIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6.857 2 0 13.755h10.247l-5.104 8.75h13.714l-5.104-8.75H24L17.143 2l-5.124 8.783L12 10.75l-.02.033L6.858 2Zm5.126 11.755-4.229 7.25h8.492l-4.23-7.25h-.033ZM6.857 4.977l-4.245 7.278h8.49L6.858 4.977Zm6.04 7.278 4.246-7.278 4.245 7.278h-8.49Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mot/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/no-internet/no-internet.tsx


const NoInternetIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6 2.182c-1.998.237-3.89.819-5.613 1.686A.71.71 0 0 0 0 4.504c0 .567.623.921 1.13.67A15.414 15.414 0 0 1 6 3.693V2.182ZM6 5.021a13.673 13.673 0 0 0-4.499 1.387c-.427.217-.51.78-.188 1.134a.793.793 0 0 0 .944.165A12.18 12.18 0 0 1 6 6.535V5.02ZM10 6.617V5.094c1.555.256 3.023.772 4.356 1.502.412.226.486.776.17 1.124a.792.792 0 0 1-.963.153A12.181 12.181 0 0 0 10 6.617ZM6 7.893c-.858.133-1.685.363-2.468.677-.469.188-.579.783-.24 1.158a.807.807 0 0 0 .894.197A9.754 9.754 0 0 1 6 9.414V7.893ZM10 9.517V7.982c.82.165 1.609.42 2.355.752.45.2.546.78.215 1.145a.806.806 0 0 1-.918.184A9.748 9.748 0 0 0 10 9.518ZM10 3.689V2.177c1.996.231 3.887.808 5.611 1.668a.71.71 0 0 1 .389.638c0 .566-.621.92-1.129.67A15.414 15.414 0 0 0 10 3.69ZM7 1a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V1Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "8",
                    cy: "14.5",
                    r: "1.5"
                })
            ]
        }) : size === 24 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M9.5 6.4A20.624 20.624 0 0 0 .76 9.554a.73.73 0 0 0-.13 1.112.775.775 0 0 0 .99.119A19.132 19.132 0 0 1 9.5 7.91V6.399ZM9.5 9.935c-2.27.34-4.39 1.135-6.267 2.29a.726.726 0 0 0-.139 1.115.782.782 0 0 0 .983.127A15.153 15.153 0 0 1 9.5 11.454V9.935ZM14.5 11.454V9.935c2.27.34 4.39 1.135 6.267 2.29.39.24.45.777.139 1.115a.782.782 0 0 1-.983.127 15.152 15.152 0 0 0-5.423-2.013ZM9.5 13.477c-1.36.25-2.65.7-3.838 1.318-.425.22-.504.784-.179 1.136.241.261.63.318.945.157A12.16 12.16 0 0 1 9.5 15.005v-1.528ZM14.5 15.005v-1.528c1.36.25 2.65.7 3.838 1.318.425.22.504.784.179 1.136a.793.793 0 0 1-.945.157 12.16 12.16 0 0 0-3.072-1.083ZM14.5 7.91V6.4a20.624 20.624 0 0 1 8.74 3.155.73.73 0 0 1 .13 1.112.776.776 0 0 1-.99.119A19.131 19.131 0 0 0 14.5 7.91ZM11 4a1 1 0 1 1 2 0v10a1 1 0 0 1-2 0V4ZM13.5 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M27 38a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM23.5 9.5a1.5 1.5 0 0 1 3 0v22a1.5 1.5 0 0 1-3 0v-22Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M21 28.328a23.367 23.367 0 0 0-8.288 3.053 1 1 0 1 0 1.037 1.71A21.34 21.34 0 0 1 21 30.358v-2.03Zm8 2.03a21.34 21.34 0 0 1 7.252 2.733 1 1 0 0 0 1.036-1.71A23.367 23.367 0 0 0 29 28.328v2.03ZM21 21.245c-5.309.656-10.144 2.598-14.056 5.459a1 1 0 0 0 1.181 1.614c3.57-2.61 7.993-4.413 12.875-5.057v-2.016Zm8 2.016c4.882.644 9.305 2.447 12.875 5.057a1 1 0 0 0 1.18-1.614C39.144 23.844 34.31 21.9 29 21.244v2.017ZM21 14.19c-7.864.748-14.823 3.679-19.666 7.98a1 1 0 0 0 1.328 1.495C7.11 19.715 13.586 16.941 21 16.2v-2.01Zm8 2.008c7.414.743 13.89 3.517 18.338 7.467a1 1 0 1 0 1.328-1.495C43.824 17.869 36.864 14.938 29 14.19v2.008Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/no-internet/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/owner-user/owner-user.tsx


const OwnerUserIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17 6.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm2.535 14.961c.13.315.427.539.768.539.504 0 .876-.473.696-.943-1.4-3.655-5.57-6.307-10.5-6.307-4.927 0-9.099 2.652-10.498 6.307-.18.47.191.943.695.943a.845.845 0 0 0 .769-.539C4.163 18.559 7.577 16.25 12 16.25s7.837 2.309 9.035 5.211Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/owner-user/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/oxford-shield/oxford-shield.tsx


const OxfordShieldIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.5.191a.668.668 0 0 1 .019.018c.785.752 2.226 1.881 3.946 2.771 1.73.895 3.66 1.504 5.453 1.332a.75.75 0 0 1 .822.747v6.202c.173 3.18-1.775 9.909-10.504 12.701a.748.748 0 0 1-.472 0C3.034 21.17 1.087 14.441 1.26 11.261V5.059a.75.75 0 0 1 .822-.747c1.793.172 3.723-.437 5.453-1.332C9.255 2.09 10.695.961 11.48.21a.748.748 0 0 1 1.02-.017Zm-.5 22.27c7.828-2.605 9.389-8.587 9.24-11.136a.783.783 0 0 1 0-.043V5.84c-1.93-.014-3.844-.69-5.464-1.529A20.035 20.035 0 0 1 12 1.762a20.031 20.031 0 0 1-3.776 2.55C6.604 5.15 4.69 5.827 2.76 5.841v5.484c-.149 2.549 1.412 8.53 9.24 11.136Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/oxford-shield/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/padlock-closed/padlock-closed.tsx


const PadlockClosedIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M8.75 10.75a.75.75 0 0 0-1.5 0v1.283a.75.75 0 0 0 1.5 0V10.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M3.5 5.075v1.966A3 3 0 0 0 1 10v3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-3a3 3 0 0 0-2.5-2.959V5.075C12.5 2.361 10.687 0 8.076 0 5.465 0 3.5 2.361 3.5 5.075ZM8.076 1.5C6.235 1.454 5 3.012 5 5.075V7h6V5.075c0-2.063-1.12-3.53-2.924-3.575ZM12 8.5H4A1.5 1.5 0 0 0 2.5 10v3A1.5 1.5 0 0 0 4 14.5h8a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12 8.5Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M7.25 7.217C7.25 4.11 9.46 1.75 12 1.75s4.75 2.359 4.75 5.467V11h-9.5V7.217Zm11 3.783h1.25a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1.25V7.217C5.75 3.458 8.464.25 12 .25s6.25 3.208 6.25 6.967V11ZM3 14a1.5 1.5 0 0 1 1.5-1.5h15A1.5 1.5 0 0 1 21 14v7a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 21v-7Zm9.75 3.8a1.5 1.5 0 1 0-1.5 0v1.45a.75.75 0 0 0 1.5 0V17.8Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/padlock-closed/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/padlock-open/padlock-open.tsx


const PadlockOpenIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M8.75 10.75a.75.75 0 0 0-1.5 0v1.283a.75.75 0 0 0 1.5 0V10.75Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M8.326 1.5C6.711 1.5 5.25 3.012 5.25 5.075V7H12a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-3a3 3 0 0 1 2.75-2.99V5.075C3.75 2.361 5.715 0 8.326 0c2.611 0 4.576 2.361 4.576 5.075a.75.75 0 0 1-1.5 0c0-2.063-1.46-3.575-3.076-3.575ZM12 8.5H4A1.5 1.5 0 0 0 2.5 10v3A1.5 1.5 0 0 0 4 14.5h8a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12 8.5Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 1.75c-2.54 0-4.75 2.359-4.75 5.467V11H19.5a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3h1.25V7.217C5.75 3.458 8.464.25 12 .25s6.25 3.208 6.25 6.967V8a.75.75 0 0 1-1.5 0v-.783c0-3.108-2.21-5.467-4.75-5.467ZM4.5 12.5A1.5 1.5 0 0 0 3 14v7a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 21v-7a1.5 1.5 0 0 0-1.5-1.5h-15Zm9 4a1.5 1.5 0 0 1-.75 1.3v1.45a.75.75 0 0 1-1.5 0V17.8a1.5 1.5 0 1 1 2.25-1.3Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/padlock-open/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/paint/paint.tsx


const PaintIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "m13.456 21.998 6.5-11.258 2.724-1.148a1 1 0 0 0 .111-1.788L9.811.31a1 1 0 0 0-1.366.366L.465 14.498a2 2 0 0 0 .733 2.732l9.526 5.5a2 2 0 0 0 2.732-.732Zm5.917-12.64a1.5 1.5 0 0 0-.716.632l-1.49 2.58c-.607.053-.924-.079-1.104-.217-.234-.179-.406-.493-.54-.994a9.396 9.396 0 0 1-.165-.785l-.026-.148c-.04-.229-.082-.472-.132-.698a3.773 3.773 0 0 0-.278-.843 1.724 1.724 0 0 0-.674-.753c-.853-.493-1.595-.347-2.114-.244l-.127.024c-.269.05-.481.079-.708.058-.218-.02-.486-.09-.832-.29-.574-.33-.954-1.029-1.068-2.066-.112-1.025.058-2.246.44-3.374l-.472-.16.127-.22L21.17 8.6l-1.797.757ZM7.87 4.672 1.765 15.248a.5.5 0 0 0 .183.683l9.526 5.5a.5.5 0 0 0 .683-.183l4.164-7.212a2.578 2.578 0 0 1-1.17-.492c-.629-.481-.914-1.188-1.077-1.797a10.803 10.803 0 0 1-.193-.912l-.029-.165c-.04-.227-.074-.427-.116-.615a2.344 2.344 0 0 0-.159-.507.492.492 0 0 0-.076-.115l-.003-.002c-.356-.206-.583-.163-1.134-.06l-.081.016a3.96 3.96 0 0 1-1.12.077c-.451-.041-.927-.184-1.446-.484-1.159-.67-1.67-1.929-1.809-3.202a7.723 7.723 0 0 1-.038-1.105Zm5.628 4.758s.001 0 0 0Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M23 16c.552 0 1-.597 1-1.333C24 13.93 23.552 12 23 12s-1 1.93-1 2.667c0 .736.448 1.333 1 1.333ZM20 21c.552 0 1-.597 1-1.333C21 18.93 20.552 17 20 17s-1 1.93-1 2.667c0 .736.448 1.333 1 1.333Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/paint/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/parent/parent.tsx


const ParentIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M11.937 4.538a4.538 4.538 0 1 1-9.076 0 4.538 4.538 0 0 1 9.076 0Zm-1.513 0a3.025 3.025 0 1 1-6.05 0 3.025 3.025 0 0 1 6.05 0ZM21.516 11.963a3.53 3.53 0 1 1-7.058 0 3.53 3.53 0 0 1 7.058 0Zm-1.512 0a2.017 2.017 0 1 1-4.034 0 2.017 2.017 0 0 1 4.034 0Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M4.832 11.35a2.219 2.219 0 0 0-2.219 2.218v9.625a.807.807 0 0 1-1.613 0v-9.625a3.832 3.832 0 0 1 3.832-3.832h4.492a3.832 3.832 0 0 1 3.832 3.832v9.625a.807.807 0 1 1-1.614 0v-9.625a2.218 2.218 0 0 0-2.218-2.219H4.832ZM14.916 17.674h3.896c1.225 0 2.219.994 2.219 2.219v3.3a.807.807 0 1 0 1.613 0v-3.3a3.832 3.832 0 0 0-3.832-3.832h-3.896v1.613Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/parent/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/part-ex/part-ex.tsx


const PartExIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M14.03.47a.75.75 0 0 1 0 1.06l-1.242 1.243c4.868.34 8.712 4.397 8.712 9.352a9.352 9.352 0 0 1-2.989 6.864.75.75 0 0 1-1.022-1.098 7.876 7.876 0 0 0-4.646-13.608L14.03 5.47a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM10.47 23.53a.75.75 0 0 1 0-1.06l.992-.993c-4.868-.34-8.712-4.397-8.712-9.352a9.351 9.351 0 0 1 2.96-6.837.75.75 0 1 1 1.027 1.094 7.875 7.875 0 0 0 5.2 13.616L10.47 18.53a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/part-ex/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/performance/performance.tsx


const PerformanceIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M.75 0a.75.75 0 0 1 .75.75V14.5h13.75a.75.75 0 0 1 0 1.5H0V.75A.75.75 0 0 1 .75 0Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2.75 7.75h1.5v6h-1.5v-6ZM7.5 5.25H6v8.5h1.5v-8.5ZM9.5 7.25H11v6.5H9.5v-6.5ZM14.25 8.25h-1.5v5.5h1.5v-5.5Z"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M20 3.52H4A2.48 2.48 0 0 0 1.52 6v12A2.48 2.48 0 0 0 4 20.48h16A2.48 2.48 0 0 0 22.48 18V6A2.48 2.48 0 0 0 20 3.52ZM4 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H4Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M5.764 9.824c.421 0 .763.342.763.764v7.647a.764.764 0 1 1-1.527 0v-7.647c0-.422.342-.764.764-.764ZM10.09 6c.423 0 .764.342.764.765V17.98a.764.764 0 1 1-1.527 0V6.765c0-.423.342-.765.764-.765ZM14.164 12.118c.421 0 .763.342.763.764v5.098a.764.764 0 1 1-1.527 0v-5.098c0-.422.342-.764.764-.764ZM18.236 15.177c.422 0 .764.342.764.764v2.04a.764.764 0 1 1-1.527 0v-2.04c0-.422.342-.764.763-.764Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/performance/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/location/location.tsx


const LocationIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M21 9c0 3.68-4.935 10.684-7.496 14.07a1.871 1.871 0 0 1-3.008 0C7.936 19.685 3 12.68 3 9a9 9 0 0 1 18 0Zm-1.5 0c0 .63-.222 1.543-.7 2.707-.465 1.136-1.123 2.394-1.88 3.676-1.512 2.563-3.347 5.109-4.613 6.783a.372.372 0 0 1-.614 0c-1.266-1.674-3.101-4.22-4.613-6.783-.757-1.282-1.415-2.54-1.88-3.676-.478-1.164-.7-2.078-.7-2.707a7.5 7.5 0 1 1 15 0Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/location/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mail/mail.tsx


const MailIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1.502 2.648a.153.153 0 0 0-.152.152v10.4c0 .084.068.152.152.152h12.996a.152.152 0 0 0 .152-.152V2.8a.152.152 0 0 0-.152-.152H1.503ZM.05 2.8c0-.813.64-1.452 1.452-1.452h12.996c.813 0 1.452.64 1.452 1.452v10.4c0 .813-.64 1.452-1.452 1.452H1.503A1.44 1.44 0 0 1 .05 13.2V2.8Zm13.29 1.824a.65.65 0 0 1-.03.919l-2.468 2.31L12.38 9.5a.65.65 0 0 1-.95.887L9.893 8.742l-1.628 1.524a.65.65 0 0 1-.904-.015L5.904 8.79l-1.292 1.577a.65.65 0 0 1-1.006-.824l1.375-1.678L2.66 5.541a.65.65 0 0 1 .92-.918l2.73 2.736a.707.707 0 0 1 .012.011l1.514 1.517 1.642-1.538 2.943-2.755a.65.65 0 0 1 .919.03Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M5.048 6.988a.75.75 0 1 0-1.096 1.024 151.939 151.939 0 0 0 3.722 3.808l-2.25 2.7a.75.75 0 1 0 1.152.96l2.168-2.602.005.005a356.236 356.236 0 0 0 2.52 2.455l.212.203.53.509 3.211-3.212 2.202 2.642a.75.75 0 0 0 1.152-.96l-2.289-2.747L20.03 8.03a.75.75 0 0 0-1.06-1.06l-6.98 6.979-.256-.248a349.955 349.955 0 0 1-1.933-1.887C8.27 10.306 6.404 8.44 5.048 6.988Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M0 4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-.5h20a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mail/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/make-model/make-model.tsx


const MakeModelIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m.35 7.141 1.317-1.924.993-2.63A4 4 0 0 1 6.402 0h3.196a4 4 0 0 1 3.742 2.587l.993 2.63 1.317 1.924a2 2 0 0 1 .35 1.13V13.5a2.5 2.5 0 0 1-5 0v-.978H5v.978a2.5 2.5 0 0 1-5 0V8.271a2 2 0 0 1 .35-1.13ZM11.333 8.25H14.5a.5.5 0 0 0-.087-.261l-1.19-1.739H2.777l-1.19 1.739a.5.5 0 0 0-.088.261h3.167a1.5 1.5 0 0 1-1.5 1.5H1.5V11H5v.022h6V11h3.5V9.75h-1.667a1.5 1.5 0 0 1-1.5-1.5Zm-7.887-3.5h9.107l-.616-1.633A2.5 2.5 0 0 0 9.598 1.5H6.402a2.5 2.5 0 0 0-2.34 1.617L3.447 4.75ZM14.5 12.522h-2v.978a1 1 0 1 0 2 0v-.978Zm-13 0v.978a1 1 0 1 0 2 0v-.978h-2Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M.373 11.479 2.5 8.5l1.956-4.966A4 4 0 0 1 8.178 1h7.644a4 4 0 0 1 3.722 2.534L21.5 8.5l2.128 2.979A2 2 0 0 1 24 12.64V20.5a3.5 3.5 0 1 1-7 0V19H7v1.5a3.5 3.5 0 1 1-7 0v-7.86a2 2 0 0 1 .373-1.162ZM22.5 12.64V13H17a1.5 1.5 0 0 0 1.5 1.5h4v3h-21v-3h4A1.5 1.5 0 0 0 7 13H1.5v-.36a.5.5 0 0 1 .093-.29L3.63 9.5h16.742l2.036 2.85a.5.5 0 0 1 .093.29ZM19.69 8l-1.542-3.916A2.5 2.5 0 0 0 15.822 2.5H8.178a2.5 2.5 0 0 0-2.326 1.584L4.309 8h15.382ZM18.5 19h4v1.5a2 2 0 1 1-4 0V19Zm-17 0v1.5a2 2 0 1 0 4 0V19h-4Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/make-model/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mask/mask.tsx


const MaskIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M6.25 10.5A.75.75 0 0 1 7 9.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM6.25 13.5a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1a3 3 0 1 1 0 6v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a3 3 0 1 1 0-6v1.5a1.5 1.5 0 0 0 0 3V8Zm2-.5h14a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5ZM22.5 12a1.5 1.5 0 0 1-1.5 1.5v-3a1.5 1.5 0 0 1 1.5 1.5Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/mask/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/menu/menu.tsx


const MenuIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.95 2.667a.75.75 0 0 1-.75.751l-14.4.01a.75.75 0 1 1 0-1.5l14.4-.01a.75.75 0 0 1 .75.75ZM.8 7.255l14.4-.01a.75.75 0 1 1 0 1.5l-14.4.01a.75.75 0 1 1 0-1.5Zm0 5.327 14.4-.01a.75.75 0 0 1 0 1.5l-14.4.01a.75.75 0 1 1 0-1.5Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M0 4a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4ZM0 12a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 12ZM.75 19.25a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5H.75Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/menu/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/running-cost/running-cost.tsx


const RunningCostIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.44 1.275c.4.105.64.515.536.915-2.781 10.617-7.052 16.143-11.448 18.943-4.39 2.796-8.775 2.785-11.573 2.616a.75.75 0 1 1 .09-1.497c2.702.163 6.693.153 10.677-2.384 3.979-2.534 8.083-7.675 10.803-18.058a.75.75 0 0 1 .915-.535ZM9.98 14.78c.76 0 1.44-.56 1.88-1.44l1.82 1.04c-.76 1.7-2.04 2.74-3.58 2.74-1.2 0-2.28-.54-3.72-1.78-.64 1.16-1.54 1.78-2.76 1.78-1.6 0-2.62-1.1-2.62-2.54 0-1.52 1.14-2.76 2.62-2.76.62 0 1.28.2 1.86.6.04-.62.06-1.2.06-1.62V9.44H3.2V8.12h2.34V6.64C5.54 4.3 7.12 3 9.3 3c.98 0 1.92.3 2.68.9l-1 1.84c-.4-.36-.94-.54-1.48-.54-1.02 0-1.52.66-1.52 1.6v1.32H11v1.32H7.98v1.72c0 1.02-.28 1.98-.52 2.48.72.6 1.72 1.14 2.52 1.14Zm-7.26-.28c0 .54.38.96 1 .96.7 0 1.2-.5 1.38-1.28-.4-.48-.92-.66-1.34-.66-.66 0-1.04.4-1.04.98Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/running-cost/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sale/sale.tsx


const SaleIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "m7.664 2.773-4.89.002-.001 4.89 6.542 6.541 4.891-4.891-6.542-6.542ZM1.232 7.878c0 .272.108.533.3.726l7.056 7.055c.4.401 1.051.4 1.452 0l5.618-5.619a1.027 1.027 0 0 0 0-1.452L8.605 1.533a1.026 1.026 0 0 0-.726-.3l-5.616.002c-.567 0-1.027.46-1.028 1.027l-.002 5.616Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.485 5.071a1 1 0 1 1-1.414 1.415A1 1 0 0 1 6.485 5.07Z"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.816 2.943 20.99 13.2a1.5 1.5 0 0 1-.003 2.118l-5.67 5.67a1.5 1.5 0 0 1-2.119.004L2.943 10.816A1.5 1.5 0 0 1 2.5 9.752V3.5c0-.828.172-1 1-1h6.252c.4 0 .782.16 1.064.443ZM9.752 1a3 3 0 0 1 2.128.886l10.176 10.256a3 3 0 0 1-.007 4.236l-5.671 5.67a3 3 0 0 1-4.236.007L1.886 11.88A3 3 0 0 1 1 9.752V3c0-1.656.343-2 2-2h6.752ZM7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sale/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/search/search.tsx


const SearchIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.68 10.74a6 6 0 1 1 1.06-1.06l4.79 4.79a.75.75 0 1 1-1.06 1.06l-4.79-4.79ZM10.4 6a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.666 16.727A9.462 9.462 0 0 1 9.5 19 9.5 9.5 0 1 1 19 9.5a9.462 9.462 0 0 1-2.273 6.166l6.803 6.804a.75.75 0 1 1-1.06 1.06l-6.804-6.803ZM17.5 9.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/search/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/seats/seats.tsx


const SeatsIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m9.208 8.32-1.54-5.75A3.5 3.5 0 1 0 .905 4.38l3.623 13.524a3.499 3.499 0 0 0 2.532 2.49A3 3 0 0 0 10 24h11a3 3 0 1 0 0-6h-5.336c-.563-4.525-3.322-7.55-6.18-9.495a19.366 19.366 0 0 0-.276-.184Zm-1.84-1.074-1.15-4.289a2 2 0 1 0-3.863 1.036l.382 1.427c1.005.282 2.745.847 4.63 1.826Zm.543 2.028c-1.744-1.07-3.49-1.75-4.717-2.149l2.784 10.39c.227.847.964 1.42 1.792 1.479a2.993 2.993 0 0 1 1.857-.971c.268-.448.36-1 .215-1.543L7.91 9.274Zm1.917 1.359c2.099 1.724 3.862 4.105 4.323 7.367h-2.887c.18-.6.201-1.258.027-1.908l-1.463-5.46ZM8.5 21c0-.203.04-.397.113-.573a3.517 3.517 0 0 0 1.745-.927H21a1.5 1.5 0 0 1 0 3H10A1.5 1.5 0 0 1 8.5 21Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/seats/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/settings/settings.tsx


const SettingsIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m13.78 2.983.23.72.717.244c.357.12.704.264 1.038.43l.679.336.673-.347c.289-.149.88-.302 1.505-.414.066-.012.183.004.3.12l.972.973a.402.402 0 0 1 .127.355c-.06.313-.133.646-.21.94a3.46 3.46 0 0 1-.177.543l-.347.673.336.68c.166.333.31.68.43 1.037l.243.717.721.23c.053.017.221.092.509.26.262.152.549.337.813.515a.402.402 0 0 1 .161.341v1.328a.402.402 0 0 1-.161.341c-.264.178-.551.363-.813.516a3.446 3.446 0 0 1-.509.259l-.72.23-.244.717c-.12.357-.264.704-.43 1.038l-.336.679.347.673c.026.05.092.222.177.543.077.293.15.627.21.94.02.1-.008.236-.127.355l-.939.939a.402.402 0 0 1-.355.127 15 15 0 0 1-.94-.21 3.44 3.44 0 0 1-.543-.177l-.673-.347-.68.336c-.333.166-.68.31-1.037.43l-.717.243-.23.721a3.446 3.446 0 0 1-.26.509c-.152.262-.337.549-.515.813a.402.402 0 0 1-.341.161h-1.328a.402.402 0 0 1-.341-.161 15.001 15.001 0 0 1-.516-.813 3.446 3.446 0 0 1-.259-.509l-.23-.72-.717-.244a8.46 8.46 0 0 1-1.038-.43l-.679-.336-.673.347c-.05.026-.222.092-.543.177-.294.077-.627.15-.94.21a.402.402 0 0 1-.356-.127l-.938-.939a.402.402 0 0 1-.128-.355c.061-.313.134-.647.211-.94.085-.321.151-.494.177-.543l.347-.673-.336-.68a8.44 8.44 0 0 1-.43-1.037l-.243-.717-.721-.23a3.445 3.445 0 0 1-.509-.26 15 15 0 0 1-.813-.515.402.402 0 0 1-.161-.341v-1.328c0-.168.077-.284.161-.341a15 15 0 0 1 .813-.516c.288-.167.456-.242.509-.259l.72-.23.244-.717c.12-.357.264-.704.43-1.038l.336-.679-.347-.673a3.447 3.447 0 0 1-.177-.543c-.077-.293-.15-.627-.21-.94a.402.402 0 0 1 .127-.355l.939-.939A.402.402 0 0 1 5.4 3.98c.313.06.647.133.94.21.321.085.494.151.543.177l.673.347.68-.336c.333-.166.68-.31 1.037-.43l.717-.243.23-.721c.017-.053.092-.221.26-.509a15 15 0 0 1 .515-.813.402.402 0 0 1 .341-.161h1.328c.168 0 .284.077.341.161a15 15 0 0 1 .516.813c.167.288.242.456.259.509Zm7.714 2.704c-.129.66-.318 1.477-.526 1.883.194.393.364.801.506 1.222.435.139 1.146.583 1.703.96A1.9 1.9 0 0 1 24 11.335v1.328a1.9 1.9 0 0 1-.823 1.585c-.557.376-1.268.82-1.703.96-.142.42-.312.828-.506 1.221.209.406.397 1.223.526 1.883a1.9 1.9 0 0 1-.54 1.703l-.938.939a1.9 1.9 0 0 1-1.703.539c-.66-.129-1.477-.317-1.883-.526a9.944 9.944 0 0 1-1.222.506c-.139.435-.583 1.146-.96 1.703a1.9 1.9 0 0 1-1.584.823h-1.328a1.9 1.9 0 0 1-1.585-.823c-.376-.557-.82-1.268-.96-1.703a9.943 9.943 0 0 1-1.221-.506c-.406.209-1.223.397-1.883.526a1.9 1.9 0 0 1-1.703-.54l-.939-.938a1.9 1.9 0 0 1-.539-1.703c.129-.66.317-1.477.526-1.883a9.93 9.93 0 0 1-.506-1.222c-.435-.139-1.146-.583-1.703-.96A1.9 1.9 0 0 1 0 12.665v-1.328a1.9 1.9 0 0 1 .823-1.585c.557-.376 1.268-.82 1.703-.96.142-.42.312-.828.506-1.221-.208-.406-.397-1.223-.526-1.883a1.9 1.9 0 0 1 .54-1.703l.938-.939a1.9 1.9 0 0 1 1.703-.539c.66.129 1.477.318 1.883.526a9.937 9.937 0 0 1 1.222-.506c.139-.435.583-1.146.96-1.703A1.9 1.9 0 0 1 11.335 0h1.328a1.9 1.9 0 0 1 1.585.823c.376.557.82 1.268.96 1.703.42.142.828.312 1.221.506.51-.262 1.302-.444 1.926-.556.597-.108 1.198.107 1.627.536l.971.972a1.9 1.9 0 0 1 .54 1.703ZM15.5 12a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm1.5 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/settings/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/phone/phone.tsx


const PhoneIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 .25a.75.75 0 0 0 0 1.5A8.25 8.25 0 0 1 22.25 10a.75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.911 3.62a2.908 2.908 0 0 0-.986-1.802 2.923 2.923 0 0 0-1.933-.705H2.913a2.921 2.921 0 0 0-2.15.947 2.905 2.905 0 0 0-.75 2.22 21.072 21.072 0 0 0 3.296 9.267 20.862 20.862 0 0 0 6.429 6.399 21.269 21.269 0 0 0 9.245 3.271 2.922 2.922 0 0 0 2.242-.744 2.906 2.906 0 0 0 .953-2.157v-3.069c.035-1.455-1.044-2.723-2.51-2.927a12.443 12.443 0 0 1-2.71-.67l-.178-.06a2.93 2.93 0 0 0-2.895.713l-.837.832-.097-.059a15.562 15.562 0 0 1-4.8-4.778l-.059-.095.831-.827a2.902 2.902 0 0 0 .661-3.068 12.239 12.239 0 0 1-.673-2.688ZM6 2.613H2.914a1.421 1.421 0 0 0-1.044.46 1.405 1.405 0 0 0-.364 1.063 19.572 19.572 0 0 0 3.06 8.593l.007.01a19.363 19.363 0 0 0 5.967 5.94l.011.006a19.768 19.768 0 0 0 8.583 3.04 1.422 1.422 0 0 0 1.424-.836 1.4 1.4 0 0 0 .12-.57v-3.108a1.403 1.403 0 0 0-1.213-1.404 13.94 13.94 0 0 1-3.006-.743l-.13-.044a1.428 1.428 0 0 0-1.39.35l-1.67 1.661-1.111-.682-.008-.005a17.063 17.063 0 0 1-5.263-5.24l-.005-.008-.698-1.11L7.86 8.318l.002-.001a1.402 1.402 0 0 0 .317-1.48v-.002a13.738 13.738 0 0 1-.755-3.01 1.408 1.408 0 0 0-.477-.868 1.423 1.423 0 0 0-.94-.343H6Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.25 5a.75.75 0 0 1 .75-.75A6.75 6.75 0 0 1 19.75 11a.75.75 0 0 1-1.5 0c0-2.9-2.35-5.25-5.25-5.25a.75.75 0 0 1-.75-.75Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/phone/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/play/play.tsx


const PlayIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M5.403 3.166a1.825 1.825 0 0 1 1.733.114l11.665 7.5c.217.138.393.321.514.534.122.212.185.447.185.686 0 .239-.063.474-.185.687a1.558 1.558 0 0 1-.514.534L7.137 20.72a1.824 1.824 0 0 1-1.732.114 1.611 1.611 0 0 1-.66-.553 1.39 1.39 0 0 1-.244-.782V4.501c0-.276.084-.546.243-.781a1.61 1.61 0 0 1 .66-.554Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/play/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/price/price.tsx


const PriceIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M15.86 14.84c-.44.88-1.12 1.44-1.88 1.44-.8 0-1.8-.54-2.52-1.14.24-.5.52-1.46.52-2.48v-1.72H15V9.62h-3.02V8.3c0-.94.5-1.6 1.52-1.6.54 0 1.08.18 1.48.54l1-1.84c-.76-.6-1.7-.9-2.68-.9-2.18 0-3.76 1.3-3.76 3.64v1.48H7.2v1.32h2.34v1.36c0 .42-.02 1-.06 1.62-.58-.4-1.24-.6-1.86-.6-1.48 0-2.62 1.24-2.62 2.76 0 1.44 1.02 2.54 2.62 2.54 1.22 0 2.12-.62 2.76-1.78 1.44 1.24 2.52 1.78 3.72 1.78 1.54 0 2.82-1.04 3.58-2.74l-1.82-1.04Zm-8.14 2.12c-.62 0-1-.42-1-.96 0-.58.38-.98 1.04-.98.42 0 .94.18 1.34.66-.18.78-.68 1.28-1.38 1.28Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0 1.5c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/price/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/question/question.tsx


const QuestionIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    d: "M10.9 5.82c0 1.369-1.012 2.382-2.545 2.534v1.087a.167.167 0 0 1-.167.167H6.964a.167.167 0 0 1-.167-.167V7.674c0-.184.15-.333.334-.338 1.502-.047 2.187-.432 2.187-1.401 0-.811-.608-1.191-1.305-1.191-.65 0-1.342.319-1.765.888a.18.18 0 0 1-.26.035l-.73-.628a.161.161 0 0 1-.032-.212C5.907 3.805 7.03 3.3 8.14 3.3c1.43 0 2.76.887 2.76 2.52Zm-4.356 5.637c0-.544.418-1 1.038-1 .608 0 1.026.456 1.026 1 0 .545-.418.988-1.026.988-.62 0-1.038-.443-1.038-.988Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "currentColor",
                    fillRule: "evenodd",
                    d: "M8 14.6A6.6 6.6 0 1 0 8 1.4a6.6 6.6 0 0 0 0 13.2ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Zm1.5 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-7.374-3.219c0 2.052-1.52 3.572-3.819 3.8v1.631a.25.25 0 0 1-.25.25H10.72a.25.25 0 0 1-.25-.25v-2.651c0-.276.224-.499.5-.507 2.254-.07 3.281-.648 3.281-2.102 0-1.216-.912-1.786-1.957-1.786-.974 0-2.012.478-2.647 1.332-.093.124-.272.153-.39.052l-1.096-.942a.242.242 0 0 1-.047-.317C9.136 5.758 10.82 5 12.484 5c2.147 0 4.142 1.33 4.142 3.781Zm-6.536 8.455c0-.817.627-1.501 1.558-1.501.912 0 1.539.684 1.539 1.501 0 .817-.627 1.482-1.539 1.482-.931 0-1.558-.665-1.558-1.482Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/question/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/plus/plus.tsx


const PlusIcon = ({ color , size =13 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M7.25.75a.75.75 0 0 0-1.5 0v5h-5a.75.75 0 0 0 0 1.5h5v5a.75.75 0 0 0 1.5 0v-5h5a.75.75 0 0 0 0-1.5h-5v-5Z"
        }) : size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M8.75.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M12.75.75a.75.75 0 0 0-1.5 0v10.5H.75a.75.75 0 0 0 0 1.5h10.5v10.5a.75.75 0 0 0 1.5 0v-10.5h10.5a.75.75 0 0 0 0-1.5h-10.5V.75Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/plus/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/share/share.tsx


const ShareIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M24 4a4 4 0 0 1-7.114 2.51l-7.17 3.825a4.987 4.987 0 0 0-.707-1.323l7.17-3.824A4 4 0 1 1 24 4Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM24 20a4 4 0 1 1-7.82-1.188l-7.17-3.824c.297-.399.537-.844.706-1.323l7.17 3.824A4 4 0 0 1 24 20Zm-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M5 17A5 5 0 1 0 5 7a5 5 0 0 0 0 10Zm0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/share/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sign/sign.tsx


const SignIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.189 6.311a2 2 0 0 0 0-2.828L20.36.655a2 2 0 0 0-2.828 0L6.65 11.693c-.127.79-.28 3.066-.373 4.608-.053.871-.087 1.508-.087 1.508s.635-.039 1.508-.097c1.513-.1 3.74-.256 4.609-.362L23.189 6.311Zm-11.574 9.604 7.813-7.926-3.535-3.535-7.82 7.932c-.074.69-.158 1.82-.23 2.927-.021.309-.04.61-.057.89l.846-.057a135.91 135.91 0 0 0 2.983-.231Zm5.331-12.53 3.536 3.536 1.646-1.67a.5.5 0 0 0 0-.707l-2.829-2.829a.5.5 0 0 0-.704-.002l-1.649 1.672ZM3.75 3A.25.25 0 0 1 4 2.75h8.25a.75.75 0 0 0 0-1.5H4A1.75 1.75 0 0 0 2.25 3v19.5c0 .966.784 1.75 1.75 1.75h16a1.75 1.75 0 0 0 1.75-1.75V11.719a.75.75 0 0 0-1.5 0v10.78a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V3Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sign/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/smart-phone/smart-phone.tsx


const SmartPhoneIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.5 1.5h13a.5.5 0 0 1 .5.5v20a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 5 22V2a.5.5 0 0 1 .5-.5Zm-2 .5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V2Zm5.25 16.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/smart-phone/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/specs/specs.tsx


const SpecsIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M9.067 5.052a2.56 2.56 0 0 1 .507-3.047l.398-.377a3.108 3.108 0 0 1 3.648-.458l-1.927 1.824a.932.932 0 0 0 1.28 1.354l1.928-1.824a3.108 3.108 0 0 1-.658 3.616l-.398.377a2.56 2.56 0 0 1-3.07.34l-8.19 7.752a1.242 1.242 0 1 1-1.709-1.805l8.19-7.752Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/specs/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/range/range.tsx


const RangeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M20.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M20.377 9.682c1.067-1.421 3.123-4.36 3.123-5.905C23.5 1.691 21.821 0 19.75 0 17.679 0 16 1.691 16 3.777c0 1.545 2.056 4.484 3.123 5.905a.776.776 0 0 0 1.253 0Zm1.396-5.096c.183-.451.227-.711.227-.809A2.264 2.264 0 0 0 19.75 1.5a2.264 2.264 0 0 0-2.25 2.277c0 .098.044.358.227.81.173.424.426.913.729 1.43a27.43 27.43 0 0 0 1.294 1.98c.42-.59.888-1.286 1.294-1.98.303-.517.556-1.006.729-1.43Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 9.5h3.25a.75.75 0 0 1 0 1.5H13a2.5 2.5 0 0 0 0 5h7a4 4 0 0 1 0 8H7.75a.75.75 0 0 1 0-1.5H20a2.5 2.5 0 0 0 0-5h-7a4 4 0 0 1 0-8ZM3.75 18.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M7.5 17.777c0 1.545-2.056 4.484-3.124 5.905a.776.776 0 0 1-1.252 0C2.056 22.261 0 19.322 0 17.777 0 15.691 1.679 14 3.75 14c2.071 0 3.75 1.691 3.75 3.777Zm-1.5 0c0 .098-.044.358-.227.81-.173.424-.426.913-.729 1.43a27.451 27.451 0 0 1-1.294 1.98 27.455 27.455 0 0 1-1.294-1.98 11.574 11.574 0 0 1-.729-1.43c-.183-.452-.227-.712-.227-.81A2.264 2.264 0 0 1 3.75 15.5C4.982 15.5 6 16.51 6 17.777Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/range/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/referrals/referrals.tsx


const ReferralsIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M7 2a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V2Zm2-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M1.75 10.25C1.75 9.56 2.31 9 3 9h1.97a.75.75 0 0 0 0-1.5H3a2.75 2.75 0 0 0-2.75 2.75v11A2.75 2.75 0 0 0 3 24h11a2.75 2.75 0 0 0 2.75-2.75v-1.97a.75.75 0 0 0-1.5 0v1.97c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25v-11Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/referrals/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/reg-plate/reg-plate.tsx


const RegPlateIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4 7.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2v-9Zm1.5 0v9H22a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H5.5ZM2 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H2Zm8.75 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/reg-plate/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/right-chevron/right-chevron.tsx


const RightChevronIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.47 15.53a.75.75 0 0 1 0-1.06L11.94 8 5.47 1.53A.75.75 0 0 1 6.53.47l7 7a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/right-chevron/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/rotate-ccw/rotate-ccw.tsx


const RotateCCWIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.519.75c-1.632 0-3.195.596-4.593 1.435-1.4.84-2.678 1.95-3.75 3.039A31.016 31.016 0 0 0 1.5 8.348V5.306a.75.75 0 1 0-1.5 0v5.003a.75.75 0 0 0 .75.75h5.003a.75.75 0 0 0 0-1.5H2.47a29.519 29.519 0 0 1 2.774-3.283c1.02-1.035 2.198-2.051 3.453-2.805 1.259-.755 2.554-1.221 3.822-1.221 5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75c-4.462 0-8.226-2.998-9.383-7.09a.75.75 0 1 0-1.444.408c1.336 4.721 5.676 8.182 10.827 8.182 6.213 0 11.25-5.037 11.25-11.25S18.732.75 12.519.75Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/rotate-ccw/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-facebook/social-facebook.tsx


const FacebookIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M20.998 0H3C1.345 0 0 1.345 0 3v18c0 1.655 1.345 3 3 3h9v-8.25H8.998v-3.748h3V9a4.5 4.5 0 0 1 4.5-4.5h3v3.75h-1.5c-.828 0-1.5-.077-1.5.75v3h3.749l-1.5 3.751H16.5V24H21c1.654 0 3-1.344 3-3V3a3.005 3.005 0 0 0-3.002-3Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-facebook/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-instagram/social-instagram.tsx


const InstagramIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M18 1.5H6A4.5 4.5 0 0 0 1.5 6v12A4.5 4.5 0 0 0 6 22.5h12a4.5 4.5 0 0 0 4.5-4.5V6A4.5 4.5 0 0 0 18 1.5ZM6 0a6 6 0 0 0-6 6v12a6 6 0 0 0 6 6h12a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0 1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.5 5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-instagram/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-twitter/social-twitter.tsx


const TwitterIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M24 5.21c-.906.377-1.86.628-2.835.744a4.726 4.726 0 0 0 2.164-2.604c-.97.55-2.023.934-3.119 1.14A5.032 5.032 0 0 0 16.614 3c-2.723 0-4.916 2.116-4.916 4.71 0 .374.033.733.113 1.074-4.089-.19-7.71-2.067-10.14-4.925a4.588 4.588 0 0 0-.673 2.38c0 1.631.876 3.077 2.184 3.914a5.026 5.026 0 0 1-2.222-.58v.052c0 2.288 1.706 4.19 3.942 4.627-.4.104-.838.155-1.29.155a4.537 4.537 0 0 1-.932-.08c.638 1.866 2.446 3.236 4.597 3.28a10.17 10.17 0 0 1-6.1 2.01A9.51 9.51 0 0 1 0 19.55c2.179 1.345 4.762 2.114 7.547 2.114 9.054 0 14.003-7.179 14.003-13.401 0-.21-.007-.409-.017-.61a9.595 9.595 0 0 0 2.465-2.444H24Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-twitter/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-whatsapp/social-whatsapp.tsx


const WhatsAppIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M12.297 16.812c.556.238 1.124.447 1.702.625H14c.375.118.767.177 1.161.175a4.9 4.9 0 0 0 .725-.056 3.072 3.072 0 0 0 2.016-1.414c.195-.443.256-.935.174-1.413-.063-.1-.204-.167-.41-.266a11.408 11.408 0 0 1-.166-.081c-.299-.149-1.767-.868-2.04-.967-.274-.099-.473-.152-.672.149-.199.301-.771.968-.946 1.165-.175.198-.348.223-.647.074a8.162 8.162 0 0 1-2.4-1.474 8.96 8.96 0 0 1-1.66-2.059c-.175-.297-.02-.458.13-.606.09-.09.192-.214.295-.338l.153-.183a2.03 2.03 0 0 0 .299-.495.546.546 0 0 0-.025-.52c-.05-.1-.337-.795-.595-1.42-.125-.305-.244-.593-.326-.788-.214-.509-.43-.509-.605-.509h-.067c-.177-.01-.377-.01-.576-.01a1.1 1.1 0 0 0-.796.371 3.326 3.326 0 0 0-1.042 2.48A5.766 5.766 0 0 0 7.2 12.326a13.285 13.285 0 0 0 5.097 4.487Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "m0 24 6-1.605A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12c0 2.11.544 4.092 1.5 5.814L0 24Zm3.096-6.402-.284-.512A10.446 10.446 0 0 1 1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5c-1.915 0-3.706-.511-5.249-1.404l-.538-.311-4.16 1.113 1.043-4.3Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-whatsapp/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-youtube/social-youtube.tsx


const YouTubeIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M4 4.5h16A2.5 2.5 0 0 1 22.5 7v10a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 17V7A2.5 2.5 0 0 1 4 4.5ZM0 7a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V7Zm10.386 1.357A.75.75 0 0 0 9.25 9v6a.75.75 0 0 0 1.136.643l5-3a.75.75 0 0 0 0-1.286l-5-3ZM13.542 12l-2.792 1.675v-3.35L13.542 12Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/social-youtube/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sort/sort.tsx


const SortIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.862 4.471a.667.667 0 0 0 .943-.942L12.47.195a.667.667 0 0 0-.942 0L8.195 3.53a.667.667 0 1 0 .943.942l2.195-2.195v13.057a.667.667 0 0 0 1.334 0V2.276l2.195 2.195ZM1.138 11.529a.667.667 0 1 0-.943.942l3.334 3.334a.666.666 0 0 0 .942 0l3.334-3.334a.667.667 0 1 0-.943-.942l-2.195 2.195V.667a.667.667 0 0 0-1.334 0v13.057l-2.195-2.195Z"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "m10.47 17.47-3.72 3.72V.75a.75.75 0 0 0-1.5 0v20.44l-3.72-3.72a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0l5-5a.75.75 0 1 0-1.06-1.06ZM22.47 6.53a.75.75 0 1 0 1.06-1.06l-5-5a.75.75 0 0 0-1.06 0l-5 5a.75.75 0 0 0 1.06 1.06l3.72-3.72v20.44a.75.75 0 0 0 1.5 0V2.81l3.72 3.72Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/sort/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/time/time.tsx


const TimeIcon = ({ color , size =16 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8.75 3.667a.75.75 0 1 0-1.5 0v5.041l2.967 2.225a.75.75 0 0 0 .9-1.2L8.75 7.958V3.667Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
                    clipRule: "evenodd"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.75 5.5a.75.75 0 0 0-1.5 0v7.375l4.3 3.225a.75.75 0 1 0 .9-1.2l-3.7-2.775V5.5Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z",
                    clipRule: "evenodd"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/time/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/transmission/transmission.tsx


const TransmissionIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M3.75 5.905A3.001 3.001 0 0 0 3 0a3 3 0 0 0-.75 5.905V9A3.75 3.75 0 0 0 6 12.75h5.25v5.345a3.001 3.001 0 1 0 1.5 0V12.75h7.5v5.345A3.001 3.001 0 0 0 21 24a3 3 0 0 0 .75-5.905V5.905A3.001 3.001 0 0 0 21 0a3 3 0 0 0-.75 5.905v5.345h-7.5V5.905A3.001 3.001 0 0 0 12 0a3 3 0 0 0-.75 5.905v5.345H6A2.25 2.25 0 0 1 3.75 9V5.905ZM4.5 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm9 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM21 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM22.5 21a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM12 22.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/transmission/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/speech/speech.tsx


const SpeechIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m8.172 17.998.662.15c.997.228 2.06.352 3.166.352 3.02 0 5.697-.92 7.585-2.336S22.5 12.907 22.5 11c0-1.907-1.027-3.748-2.915-5.164C17.697 4.42 15.02 3.5 12 3.5c-3.02 0-5.697.92-7.585 2.336S1.5 9.093 1.5 11c0 1.833.947 3.601 2.695 4.994l.697.555-.154.877-.001.007-.006.03-.02.125a20.827 20.827 0 0 0-.208 1.893c-.017.298-.023.575-.017.82.34-.157.729-.366 1.13-.602a27.507 27.507 0 0 0 1.969-1.277l.03-.021.006-.005.551-.398ZM8.5 19.61S4.5 22.5 3.5 22s-.24-4.833-.24-4.833C1.24 15.557 0 13.387 0 11c0-4.97 5.373-9 12-9s12 4.03 12 9-5.373 9-12 9c-1.217 0-2.393-.136-3.5-.389Zm-4.745.95.018-.003a.091.091 0 0 1-.018.002Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/speech/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/star-filled/star-filled.tsx


const StarFilledIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "m12 20.048-5.622 2.974a1 1 0 0 1-1.453-1.052L6 15.66 1.44 11.188a1 1 0 0 1 .556-1.704l6.297-.92 2.81-5.732a1 1 0 0 1 1.796 0l2.81 5.731 6.297.921a1 1 0 0 1 .556 1.704l-4.562 4.474 1.076 6.31a1 1 0 0 1-1.454 1.051L12 20.048Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/star-filled/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/star-outline/star-outline.tsx


const StarOutlineIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m12 18.351 5.426 2.87-1.037-6.082 4.402-4.317-6.082-.89L12 4.407 9.292 9.932l-6.082.89 4.402 4.317-1.037 6.083L12 18.35Zm-6-2.69-1.075 6.31a1 1 0 0 0 1.453 1.051L12 20.048l5.621 2.974a1 1 0 0 0 1.454-1.052l-1.076-6.31 4.562-4.473a1 1 0 0 0-.556-1.704l-6.297-.92-2.81-5.732a1 1 0 0 0-1.796 0l-2.81 5.731-6.297.921a1 1 0 0 0-.556 1.704L6 15.66Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/star-outline/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/target/target.tsx


const TargetIcon = ({ color , size =48 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M39.372.629A1.012 1.012 0 0 0 37.725.29l-7.096 7.01a.985.985 0 0 0-.225 1.068L32.658 14l-6.77 6.685.176.178a4.726 4.726 0 0 0-2.544-.737c-2.598 0-4.704 2.08-4.704 4.645 0 2.566 2.107 4.646 4.704 4.646 2.599 0 4.705-2.08 4.705-4.646 0-.894-.257-1.73-.7-2.438l6.995-6.908 5.005 1.954c.373.145.798.058 1.081-.222l7.097-7.01a.988.988 0 0 0-.342-1.626l-5.32-2.078a1 1 0 0 1-.565-.558L39.372.629Zm5.824 9.183L41.301 8.29a3 3 0 0 1-1.697-1.677l-1.54-3.847-5.545 5.478 2.02 5.049 5.111 1.996 5.546-5.478ZM26.225 24.77c0 1.438-1.187 2.646-2.705 2.646-1.517 0-2.704-1.208-2.704-2.646 0-1.437 1.187-2.645 2.704-2.645 1.518 0 2.705 1.208 2.705 2.645Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M35.28 24.77c0 6.414-5.265 11.614-11.76 11.614-6.494 0-11.76-5.2-11.76-11.613 0-6.414 5.266-11.614 11.76-11.614 1.878 0 3.654.435 5.228 1.208l1.739-1.717a14.185 14.185 0 0 0-6.966-1.813c-7.795 0-14.113 6.239-14.113 13.936 0 7.696 6.319 13.936 14.112 13.936 7.794 0 14.113-6.24 14.113-13.936 0-2.667-.759-5.16-2.074-7.277l-1.72 1.699a11.448 11.448 0 0 1 1.442 5.578Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M23.52 1.545c2.931 0 5.737.53 8.325 1.496l-1.847 1.823a21.4 21.4 0 0 0-6.478-.997c-11.69 0-21.168 9.36-21.168 20.904 0 11.545 9.477 20.904 21.168 20.904 11.691 0 21.169-9.359 21.169-20.904 0-2.437-.423-4.777-1.199-6.952l1.823-1.8a22.909 22.909 0 0 1 1.728 8.752c0 12.828-10.53 23.227-23.52 23.227S0 37.6 0 24.771C0 11.944 10.53 1.545 23.52 1.545Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/target/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/tick/tick.tsx


const TickIcon = ({ color , size =13 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M1.262 6.452A.75.75 0 1 0 .238 7.548l1.024-1.096ZM4.5 10.5l-.512.548a.75.75 0 0 0 1.059-.034L4.5 10.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM.238 7.548l3.75 3.5 1.024-1.096-3.75-3.5L.238 7.548Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
        }) : size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M15.768 2.207c.3.286.31.76.025 1.06L5.884 13.66a.75.75 0 0 1-1.073.013L.22 9.08a.75.75 0 1 1 1.06-1.06l4.049 4.048 9.378-9.836a.75.75 0 0 1 1.06-.025Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.517 3.457c.3.286.312.76.026 1.06l-15 15.75a.75.75 0 0 1-1.073.013l-7-7a.75.75 0 1 1 1.06-1.06l6.457 6.456 14.47-15.193a.75.75 0 0 1 1.06-.026Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/tick/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/upload/upload.tsx


const UploadIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M11.488.204a.744.744 0 0 1 1.024 0l7.5 7.074c.303.285.319.765.036 1.07a.744.744 0 0 1-1.06.038L12.75 2.502v13.414a.754.754 0 0 1-.75.758.754.754 0 0 1-.75-.758V2.502L5.012 8.386a.745.745 0 0 1-1.06-.037.764.764 0 0 1 .036-1.071l7.5-7.074Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M1.5 15.158a.754.754 0 0 0-.75-.758c-.414 0-.75.34-.75.758V19.2C0 21.851 2.127 24 4.75 24h14.5c2.623 0 4.75-2.149 4.75-4.8v-4.042a.754.754 0 0 0-.75-.758c-.414 0-.75.34-.75.758V19.2c0 1.814-1.455 3.284-3.25 3.284H4.75c-1.795 0-3.25-1.47-3.25-3.284v-4.042Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/upload/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/user/user.tsx


const UserIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: size === 16 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M2.917 12.272c-.96-1.166-1.567-2.67-1.567-4.261C1.35 4.343 4.34 1.35 8 1.35s6.65 2.993 6.65 6.66c0 1.592-.607 3.096-1.566 4.262a7.097 7.097 0 0 1-.134.155A5.978 5.978 0 0 0 8 9.805a5.978 5.978 0 0 0-4.95 2.622 7 7 0 0 1-.133-.155Zm-.99.843c.25.304.522.588.81.848l.003.004C4.15 15.229 5.973 15.95 8 15.95c2.027 0 3.85-.721 5.26-1.984l.004-.003a8.24 8.24 0 0 0 .81-.848A7.92 7.92 0 0 0 15.95 8.01C15.95 3.615 12.392.05 8 .05S.05 3.615.05 8.01a7.92 7.92 0 0 0 1.877 5.105Zm2.098.21A6.592 6.592 0 0 0 8 14.65a6.591 6.591 0 0 0 3.975-1.326c-.868-1.278-2.38-2.22-3.975-2.22-1.594 0-3.107.942-3.975 2.22Zm.56-7.261A3.416 3.416 0 0 1 8 2.646a3.416 3.416 0 0 1 3.415 3.418A3.416 3.416 0 0 1 8 9.483a3.416 3.416 0 0 1-3.414-3.419ZM8 3.946a2.131 2.131 0 0 0-2.114 2.118c0 1.16.959 2.119 2.114 2.119 1.155 0 2.114-.96 2.114-2.119A2.131 2.131 0 0 0 8 3.946Z",
            clipRule: "evenodd"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M18.497 20.25A10.455 10.455 0 0 1 12 22.5c-2.453 0-4.71-.841-6.497-2.25A7.498 7.498 0 0 1 12 16.5a7.498 7.498 0 0 1 6.497 3.75Zm1.129-1.032A8.994 8.994 0 0 0 12 15a8.994 8.994 0 0 0-7.626 4.218A10.464 10.464 0 0 1 1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12c0 2.796-1.093 5.336-2.874 7.218ZM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-12 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
            clipRule: "evenodd"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/user/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/wallet/wallet.tsx


const WalletIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M21 13.517c0 .629-.504 1.138-1.125 1.138s-1.125-.51-1.125-1.138c0-.628.504-1.138 1.125-1.138S21 12.89 21 13.517Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M21 4.793c1.657 0 3 1.359 3 3.035v12.137C24 21.641 22.657 23 21 23H3c-1.657 0-3-1.359-3-3.035V3.275h.027C.209 1.99 1.303 1 2.625 1H18.75C19.993 1 21 2.019 21 3.276v1.517Zm-2.25-2.276H2.625c-.621 0-1.125.51-1.125 1.138 0 .629.504 1.138 1.125 1.138H19.5V3.276a.754.754 0 0 0-.75-.759ZM1.5 6.055v13.91c0 .838.672 1.518 1.5 1.518h18c.828 0 1.5-.68 1.5-1.518V7.828c0-.838-.672-1.518-1.5-1.518H2.625A2.59 2.59 0 0 1 1.5 6.055Z",
                clipRule: "evenodd"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/wallet/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/help-me-choose/help-me-choose.tsx


const HelpMeChooseIcon = ({ color , size =48 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M9.764 26.154a4.904 4.904 0 1 0 0-9.808 4.904 4.904 0 0 0 0 9.808ZM38.07 26.154a4.904 4.904 0 1 0 0-9.808 4.904 4.904 0 0 0 0 9.808Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M46.035 15.386a1.3 1.3 0 0 0-.09-.124l-.063-.075a9.789 9.789 0 0 0-.328-.391L34.278 1.335l-.083-.071a5.263 5.263 0 0 0-8.683 3.998v.113l1.216 6.902h-5.463l1.217-6.902v-.113a5.263 5.263 0 0 0-8.683-3.998l-.083.07L2.439 14.797a9.214 9.214 0 0 0-.327.391l-.063.075c-.033.04-.063.08-.09.124a9.766 9.766 0 1 0 17.419 7.597v-.01l.319-1.81 4.335-1.762 4.255 1.728.324 1.843v.011a9.769 9.769 0 1 0 17.42-7.597h.004Zm-15.992.541-.386-2.186v-.146a5.224 5.224 0 0 1 7.534-4.684l2.213 2.642a9.762 9.762 0 0 0-9.362 4.374Zm.73-13.295c.594 0 1.17.2 1.635.569l2.134 2.548a7.843 7.843 0 0 0-5.778 2.926l-.62-3.516a2.634 2.634 0 0 1 2.629-2.527Zm-15.19.569a2.632 2.632 0 0 1 4.263 1.958l-.62 3.516a7.843 7.843 0 0 0-5.779-2.926l2.136-2.548Zm2.365 12.726a9.762 9.762 0 0 0-9.362-4.374l2.213-2.642a5.224 5.224 0 0 1 7.534 4.684v.146l-.385 2.186ZM9.76 28.386a7.134 7.134 0 0 1-5.634-11.511l.332-.395A7.135 7.135 0 1 1 9.76 28.388v-.002ZM24.57 16.782a1.32 1.32 0 0 0-.3-.094l-.019-.003a1.23 1.23 0 0 0-.101-.014l-.046-.003H23.959l-.052.004c-.032.002-.064.008-.095.013l-.026.004c-.102.019-.202.05-.297.093l-3.255 1.322.565-3.192h6.39l.558 3.162-3.176-1.292Zm13.654 11.604a7.136 7.136 0 1 1 5.301-11.908l.333.395a7.134 7.134 0 0 1-5.634 11.511v.002Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/help-me-choose/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/valuation/valuation.tsx


const ValuationIcon = ({ color , size =48 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M21.734 3.84c.353.518.65 1.073.884 1.655.122-.002.244-.004.366-.004 10.618 0 19.225 8.573 19.225 19.148 0 4.365-1.472 8.507-4.13 11.857l3.854 5.702c1.011 1.496.358 3.638-1.342 4.834l-.064.045-.21.143c-1.724 1.172-3.957 1.021-4.999-.44l-.04-.058-3.47-5.136a19.132 19.132 0 0 1-8.827 2.143A19.15 19.15 0 0 1 5.451 32.34l-.036-.08C2.224 30.286.073 26.792.002 22.776c-.081-4.588 2.574-8.59 6.47-10.462A8.735 8.735 0 0 1 9.558 1.507c4.008-2.71 9.46-1.666 12.176 2.332Zm10.672 26.875a19.36 19.36 0 0 1-.749.594l2.472 3.566a.712.712 0 0 1-.196 1 .748.748 0 0 1-1-.158l-.024-.033-2.443-3.524-.027.018-.218.147 8.394 12.294a.729.729 0 0 1-.163.993l-.033.024a.74.74 0 0 1-1-.161l-.025-.034-8.411-12.32c-.268.162-.539.319-.814.469l8.32 12.31c.514.76 1.829.872 2.948.145l.06-.04.21-.142c1.112-.756 1.524-2.022 1.043-2.8l-.027-.042-8.317-12.306Zm5.65 9.644.026.035.938 1.362a.735.735 0 0 1-.201 1.031.763.763 0 0 1-1.022-.163l-.025-.035-.939-1.362a.735.735 0 0 1 .201-1.031.763.763 0 0 1 1.023.163Zm-19.094-9.196-.087.076a11.432 11.432 0 0 1-7.23 2.725 11.468 11.468 0 0 1-4.083-.67 17.695 17.695 0 0 0 15.42 8.979 17.67 17.67 0 0 0 8.004-1.903l-4.153-6.144a7.625 7.625 0 0 1-1.93.51c-2.125.259-3.963-.648-5.47-2.865-.16-.234-.316-.47-.47-.708Zm16.444 5.535.025.035.938 1.362a.735.735 0 0 1-.2 1.031.763.763 0 0 1-1.023-.163l-.025-.035-.939-1.362a.735.735 0 0 1 .201-1.031.762.762 0 0 1 1.023.163ZM23.06 6.955a8.757 8.757 0 0 1-.447 5.052c3.613 1.15 7.72 4.665 11.365 10.03l.063.093c1.448 2.18 1.594 4.188.581 6.035a7.54 7.54 0 0 1-1.134 1.539l3.726 5.513A17.555 17.555 0 0 0 40.74 24.64c0-9.67-7.79-17.526-17.462-17.682l-.217-.002Zm-5.324 6.803c-3.403 2.301-2.5 9.34 2.907 17.294 1.209 1.78 2.52 2.427 4.081 2.237 1.294-.157 2.69-.838 4.653-2.155l.116-.079c2.025-1.37 3.21-2.428 3.846-3.59.755-1.377.638-2.832-.571-4.61l-.163-.238c-3.56-5.162-7.455-8.375-10.658-9.29a8.714 8.714 0 0 1-2.551 2.659.731.731 0 0 1-1.013-.194.726.726 0 0 1 .194-1.011 7.288 7.288 0 0 0 1.792-1.72c-.99-.04-1.88.188-2.633.697Zm-6.317-1.115-.152.002c-.91.015-1.812.154-2.684.412a7.27 7.27 0 0 0 1.779 1.717 1.833 1.833 0 0 1 2.891 1.465 1.838 1.838 0 0 1-1.803 1.863 1.833 1.833 0 0 1-1.85-2.085 8.738 8.738 0 0 1-2.38-2.363l-.041-.06c-3.437 1.617-5.786 5.128-5.715 9.157.097 5.485 4.643 9.853 10.154 9.757a9.964 9.964 0 0 0 6.557-2.6 36.929 36.929 0 0 1-1.192-2.134l-.055.058c-2.867 2.952-7.598 3.035-10.568.185a7.4 7.4 0 0 1-.186-10.507.733.733 0 0 1 1.256.492.723.723 0 0 1-.204.518 5.953 5.953 0 0 0 .15 8.451 6.037 6.037 0 0 0 8.915-.622c-2.468-5.422-2.702-10.11-.543-12.736a9.97 9.97 0 0 0-4.329-.97Zm15.745 5.646.074.055c.151.05.281.15.37.282 1.209.958 2.394 2.252 3.473 3.842l.05.073c.881 1.346.885 2.666.115 3.893-.556.888-1.421 1.644-2.827 2.604l-.112.076c-1.472.997-2.523 1.542-3.583 1.734-1.451.264-2.697-.25-3.628-1.621-.17-.25-.335-.505-.494-.762a.716.716 0 0 1-.18-.298c-2.719-4.575-2.788-8.88-.047-10.736 1.89-1.279 4.367-.888 6.789.858Zm2.62 4.866-.021-.032a40.472 40.472 0 0 1-3.76 2.829 41.063 41.063 0 0 1-3.82 2.278l.12.18c1.072 1.577 2.432 1.348 5.102-.445l.168-.114.167-.114c2.491-1.73 3.168-2.882 2.167-4.402l-.123-.18-.021-.032.021.032Zm-2.633 3.353.024.034.027.039a.688.688 0 0 1-.187.961.706.706 0 0 1-.949-.152l-.024-.034-.026-.039a.688.688 0 0 1 .187-.96.706.706 0 0 1 .948.151Zm-.17-6.52-.067.056a41.603 41.603 0 0 1-3.205 2.371 41.667 41.667 0 0 1-3.41 2.065c.266.799.641 1.642 1.128 2.513a39.382 39.382 0 0 0 3.756-2.235 38.783 38.783 0 0 0 3.708-2.799 14.8 14.8 0 0 0-1.91-1.97Zm-15.232-.746c.51 0 .956.159 1.293.46.059.045.263.22.263.437 0 .276-.241.5-.538.5a.554.554 0 0 1-.372-.136l-.008-.008a.867.867 0 0 0-.61-.228c-.409 0-.617.213-.617.635v.556h1.324c.256 0 .466.195.466.434s-.21.433-.467.433h-1.323v.705c0 .4-.053.803-.148 1.129.373.289.82.588 1.178.588.305 0 .602-.21.797-.563.05-.099.2-.257.47-.257.297 0 .538.225.538.5a.64.64 0 0 1-.11.324c-.387.675-.986 1.046-1.686 1.046-.53 0-1.011-.206-1.666-.725-.313.47-.766.717-1.326.717-.789 0-1.362-.515-1.362-1.224 0-.73.59-1.301 1.344-1.301.308 0 .638.091.918.251.045-.262-.027-1.19-.027-1.19H9.066c-.255-.003-.461-.198-.461-.433 0-.24.21-.435.467-.435h.922v-.564c0-.987.706-1.65 1.756-1.65ZM9.265 24.21c-.246 0-.392.12-.392.32 0 .195.15.321.382.321.335 0 .483-.24.547-.435a.86.86 0 0 0-.537-.206Zm15.644-1.16.024.034.027.039a.688.688 0 0 1-.187.961.706.706 0 0 1-.949-.152L23.8 23.9l-.027-.04a.688.688 0 0 1 .188-.96.706.706 0 0 1 .948.152Zm-3.714-4.413c-1.182.8-1.625 2.39-1.267 4.401a40.772 40.772 0 0 0 2.965-1.815 40.597 40.597 0 0 0 2.884-2.119c-1.745-1.087-3.396-1.27-4.582-.467Zm1.471.956.024.033.027.04a.689.689 0 0 1-.187.96.706.706 0 0 1-.949-.152l-.024-.033-.026-.039a.689.689 0 0 1 .187-.961.706.706 0 0 1 .948.152ZM21.576 7.01l-.104.008a17.708 17.708 0 0 0-10.015 4.17c1.901-.001 3.772.472 5.443 1.375l.017-.011c1.23-.832 2.678-1.11 4.255-.881a7.292 7.292 0 0 0 .405-4.661Zm-11.2-4.297a7.282 7.282 0 0 0-2.55 9.056c.452-.15.914-.272 1.382-.364a.723.723 0 0 1 .183-.304 19.19 19.19 0 0 1 11.673-5.514 7.373 7.373 0 0 0-.537-.93c-2.265-3.332-6.81-4.203-10.15-1.944Z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/valuation/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/store/store.tsx


const StoreIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            id: "Layer_1",
            "data-name": "Layer 1",
            viewBox: "0 0 24 24",
            ...props,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                        children: ".cls-2{fill:none;stroke:#8f1dbf;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path",
                    fill: "currentColor",
                    d: "M8.28 9.83h7.45v.96c0 1.59-1.67 2.88-3.72 2.88h0c-2.06 0-3.72-1.29-3.72-2.88v-.96Z",
                    className: "cls-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path-2",
                    fill: "currentColor",
                    d: "M23.17 9.83v.96c0 1.59-1.67 2.88-3.72 2.88h0c-2.06 0-3.72-1.29-3.72-2.88v-.96",
                    className: "cls-2",
                    "data-name": "Path"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path-3",
                    fill: "currentColor",
                    d: "M8.28 9.83v.96c0 1.59-1.67 2.88-3.72 2.88h0c-2.06 0-3.72-1.29-3.72-2.88v-.96",
                    className: "cls-2",
                    "data-name": "Path"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path-4",
                    fill: "currentColor",
                    d: "M2.97 5.43h18.07l2.14 4.4H.83l2.14-4.4Z",
                    className: "cls-2",
                    "data-name": "Path"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "m15.08 5.43.64 4.4M8.92 5.43l-.64 4.4",
                    className: "cls-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.52 22.48h16.96v-9.73H3.52v9.73z",
                    style: {
                        fill: "none",
                        strokeWidth: 0
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M2.97 5.43V.95h18.06v4.48",
                    className: "cls-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    id: "Path-5",
                    fill: "currentColor",
                    d: "M9.07 22.96V18.8c0-.66.47-1.19 1.06-1.19h3.74c.59 0 1.06.53 1.06 1.19v4.16",
                    className: "cls-2",
                    "data-name": "Path"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.03 13.67V23H2.97v-9.33",
                    className: "cls-2"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/store/index.ts


;// CONCATENATED MODULE: ../../../libs/design-system/components/icons/src/index.ts






































































































































/***/ }),

/***/ 68674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y8": function() { return /* reexport */ custom_error_page; },
  "uW": function() { return /* reexport */ ErrorBoundaryWrapper; },
  "V8": function() { return /* reexport */ Static404Page; },
  "wc": function() { return /* reexport */ Static500Page; }
});

// UNUSED EXPORTS: LandingFeatureErrorPage, SignPost, getStaticProps

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(47533);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var src = __webpack_require__(88805);
;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/assets/404.svg
var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Svg404 = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 186,
  height: 274
}, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
  id: "a",
  x1: "15.743%",
  x2: "124.878%",
  y1: "46.977%",
  y2: "56.742%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopOpacity: 0
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "b",
  x1: "-10.987%",
  x2: "122.991%",
  y1: "-39.953%",
  y2: "134.815%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "c",
  x1: "49.352%",
  x2: "50.776%",
  y1: "-39.953%",
  y2: "134.815%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "d",
  x1: "43.025%",
  x2: "62.897%",
  y1: "-135.435%",
  y2: "77.267%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "e",
  x1: "49.314%",
  x2: "50.148%",
  y1: "-74.066%",
  y2: "77.267%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "f",
  x1: "-37.08%",
  x2: "376.842%",
  y1: "15.082%",
  y2: "50%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFFF8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF7D50"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "g",
  x1: "24.113%",
  x2: "93.189%",
  y1: "100%",
  y2: "-17.604%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#8F8F8F"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F0"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "h",
  x1: "81.196%",
  x2: "24.959%",
  y1: "-9.23%",
  y2: "100%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#CFCFCF"
})), /*#__PURE__*/react.createElement("linearGradient", {
  id: "i",
  x1: "18.555%",
  x2: "91.281%",
  y1: "110.449%",
  y2: "9.545%"
}, /*#__PURE__*/react.createElement("stop", {
  offset: "0%",
  stopColor: "#311B77"
}), /*#__PURE__*/react.createElement("stop", {
  offset: "100%",
  stopColor: "#FF2DFF"
})))), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("path", {
  fill: "url(#a)",
  d: "M151.5 272.5 0 237.5 22 220l145 45.5z",
  opacity: 0.239,
  transform: "translate(-23)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#b)",
  d: "m6.362 20.633 13.35-7.678-.027-9.41-13.35 7.677z",
  transform: "translate(125)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#c)",
  d: "m6.676 111.118.406 162.793 13.351-7.677-.406-162.794z",
  transform: "translate(125)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#d)",
  d: "M6.335 11.222.212 7.678.26 24.142l6.103-3.509z",
  transform: "translate(125)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#e)",
  d: "m.574 114.628.386 155.74 6.122 3.543-.406-162.793z",
  transform: "translate(125)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#f)",
  d: "M13.562 0 .212 7.678l6.123 3.544 13.35-7.678L13.564 0z",
  transform: "translate(125)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "m169.76 57-.76-.574L172.239 54l.761.574zm2.508-15.162.829.483c.297.931.38 1.953.382 2.783l-.83-.483c-.002-.83-.085-1.852-.381-2.783m-13.512 21.375-.83-.483 3.532-2.045.83.484z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m168.192 44 .83.484c.115.067.22.155.312.262.529.608.611 1.766.612 2.403l-.829-.484c-.001-.636-.084-1.794-.612-2.403a1.251 1.251 0 0 0-.313-.262"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M171.44 40.283a2.99 2.99 0 0 0-.755-.632l.83.483c.27.157.523.365.754.632.38.44.645.98.828 1.555l-.83-.483c-.183-.575-.448-1.116-.827-1.555m-9.18 11.38-.83-.483v-.065l.83.483zm-.83-.548c-.002-.874.055-1.956.563-3.082.277.16.553.322.83.483-.508 1.126-.566 2.208-.563 3.082l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M161.993 48.033v-.002l.83.484-.83-.482m3.269-3.411c1.342-.777 2.307-.984 2.93-.622l.83.484c-.623-.363-1.589-.156-2.93.621-.278-.16-.554-.321-.831-.482l.83.483c-1.642.95-2.74 2.237-3.268 3.409l-.83-.484c.528-1.171 1.627-2.458 3.269-3.409"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m170.684 39.65.83.483c-1.595-.929-3.773-.092-5.434.87-1.5.867-2.784 1.892-3.841 3.068l-.83-.483c1.058-1.176 2.343-2.201 3.841-3.07 1.661-.961 3.84-1.797 5.434-.868"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "m162.239 44.07-.83-.482-.013-4.658.83.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m154.79 59.573-.83-.483 2.724 1.055.83.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M150.372 67.415c2.57-1.487 4.854-4.228 6.312-7.27l.83.483c-1.46 3.043-3.743 5.783-6.313 7.27-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.729 53.708-.83-.484v-.064l.83.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M148.76 68.159a9.062 9.062 0 0 0 1.612-.744c.03.017.067.04.097.056.03.019.072.042.103.06l.106.062.109.064.108.063.107.062.102.06.097.056a9.04 9.04 0 0 1-1.612.744l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M148.422 68.265c.112-.032.224-.068.338-.107.275.162.552.323.829.484a7.124 7.124 0 0 1-.338.106l-.83-.483m6.352-14.782-.83-.484 2.71-4.2.83.484z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M144.707 67.961c1.01.59 2.288.713 3.715.304l.83.482c-1.428.41-2.706.287-3.715-.303l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m148.027 64.1-.83-.484c.812.473 1.931.41 3.163-.304 1.48-.857 2.793-2.458 3.6-4.222l.83.483c-.807 1.764-2.12 3.365-3.6 4.221-1.233.714-2.352.778-3.163.305m5.463-11.451.83.483c.164.095.316.213.453.352l-.83-.483a2.159 2.159 0 0 0-.452-.352"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M156.652 48.8a3.86 3.86 0 0 0-.669-.493l.83.483c.238.138.462.304.669.493l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.694 41.458-.829-.483 3.531-2.045.83.484z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M151 52.624c.964-.39 1.83-.362 2.49.023l.83.483c-.661-.384-1.527-.412-2.49-.023-.277-.16-.554-.322-.83-.483m-12.57 22.355-.83-.483 3.533-2.045.829.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M150.33 52.953c.228-.131.451-.24.67-.329l.83.483a5.336 5.336 0 0 0-.67.33c-2.46 1.424-4.456 4.908-4.448 7.76.003 1.427.507 2.431 1.316 2.903l-.83-.483c-.809-.472-1.312-1.477-1.316-2.903-.008-2.852 1.988-6.336 4.449-7.76"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m145.537 68.445-.83-.484c-1.449-.844-2.349-2.645-2.357-5.203l.83.483c.007 2.558.908 4.36 2.357 5.204m10.446-20.139.83.483c-1.455-.846-3.457-.734-5.664.544l-.83-.483c2.208-1.278 4.21-1.391 5.664-.544"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F8C0A4",
  d: "m169.354 11.613.829.483c7.66 4.464 12.416 13.943 12.454 27.403.076 27.096-18.995 60.218-42.514 73.832l-.83-.483c23.519-13.615 42.59-46.736 42.514-73.832-.037-13.46-4.793-22.94-12.453-27.403"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#F8C0A4",
  d: "m109.788 116.287-.83-.483c7.76 4.521 18.5 3.895 30.336-2.956l.829.484c-11.835 6.85-22.575 7.477-30.335 2.955"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m143.18 63.242-.83-.484c-.014-5.116 3.559-11.355 7.969-13.908l.83.483c-4.411 2.553-7.983 8.793-7.969 13.909"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M108.632 115.61c.277.16.553.322.83.483.11.066.22.132.33.196l-.83-.483c-.11-.064-.22-.13-.33-.196m31.404-56.895.83.483c.873 1.157 1.065 2.89 1.07 4.166l-.83-.483c-.004-1.277-.196-3.01-1.07-4.166m-12.824 22.758-.83-.483 3.532-2.044.83.483zm9.437-19.213.417.244a5.621 5.621 0 0 0-.808-.388c.143.028.273.076.39.144"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m136.649 62.26.83.484c.115.067.22.155.312.262.528.608.61 1.766.613 2.403l-.83-.484c-.002-.636-.084-1.794-.613-2.403a1.24 1.24 0 0 0-.312-.262"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M139.897 58.543a2.995 2.995 0 0 0-.756-.635l.83.484a2.98 2.98 0 0 1 .894.807l-.83-.484a3.228 3.228 0 0 0-.138-.172M122.16 84.398l-.83-.483 3.535-2.047.83.484zm7.727-15.023c-.002-.874.055-1.957.563-3.083l.83.483c-.509 1.127-.566 2.209-.563 3.083l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M130.45 66.292c.277.16.553.322.83.483-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M136.258 62.116c.003 0 .345.121.808.388l.412.24c-.622-.363-1.587-.156-2.93.621-.277-.16-.554-.32-.83-.482l.83.483c-1.638.949-2.737 2.234-3.268 3.408l-.83-.482c.532-1.175 1.63-2.462 3.269-3.41 1.088-.63 1.929-.885 2.54-.766"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m139.14 57.909.83.483c-1.593-.928-3.773-.091-5.434.87l-.829-.483c1.66-.961 3.84-1.8 5.434-.87"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m127.185 71.903-.83-.484c-.003-1.441.118-3.636 1.214-6.065 1.227-2.713 3.294-4.929 6.138-6.575l.83.483c-2.844 1.647-4.912 3.862-6.138 6.575-1.096 2.43-1.218 4.624-1.214 6.066"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M113.685 88.653c2.57-1.488 4.858-4.23 6.317-7.273l.83.483c-1.46 3.043-3.748 5.785-6.317 7.273a9.1 9.1 0 0 1-1.612.743l-.829-.484a9.048 9.048 0 0 0 1.611-.742"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m118.107 80.808-.83-.483 2.725 1.055.83.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "m118.09 74.718-.83-.483 2.71-4.2.83.483zm7.604 7.634-.83-.483-.046-16.834.829.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m122.112 67.565-.83-.484 3.536-2.046.829.483z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M108.02 89.197c1.09.636 2.49.73 4.054.198l.83.484c-1.564.531-2.964.437-4.054-.2l-.83-.482"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m111.345 85.337-.83-.483c.81.472 1.928.408 3.159-.305 1.484-.86 2.796-2.46 3.604-4.224l.83.483c-.808 1.764-2.12 3.365-3.605 4.224-1.231.713-2.348.777-3.158.305m5.463-11.454.83.483c.163.095.315.213.452.352l-.83-.483a2.175 2.175 0 0 0-.452-.352"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M119.97 70.035a3.884 3.884 0 0 0-.669-.493l.83.483c.238.14.461.304.668.493l-.829-.482v-.001m1.69-5.25c.426-.037.895-.192 1.387-.477l.83.483c-.492.285-.961.44-1.388.477l-.83-.483m-11.575 19.739.83.483c.131.129.275.24.43.33l-.829-.483a2.13 2.13 0 0 1-.43-.33"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "m125.833 56.001.83.483c.475.429.76 1.15.763 2.108.007 2.28-1.589 5.064-3.55 6.2l-.829-.484c1.96-1.135 3.556-3.918 3.55-6.2-.004-.958-.288-1.679-.764-2.107m-5.313 8.55c.325.189.71.271 1.14.234l.828.483a1.9 1.9 0 0 1-1.138-.234l-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m122.231 63.496-.829-.483c.42.245 1 .212 1.64-.159l.83.483c-.64.37-1.22.404-1.64.159m2.432-6.167.83.483c.419.244.679.765.681 1.504.004 1.48-1.03 3.284-2.303 4.021l-.83-.483c1.274-.737 2.308-2.54 2.304-4.022-.002-.738-.263-1.259-.682-1.503"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M125.833 56.001a1.715 1.715 0 0 0-.288-.21l.83.483c.102.06.198.13.288.21l-.566-.329c-.088-.051-.18-.094-.264-.154m-2.805 1.485c.637-.368 1.216-.402 1.636-.158l.83.484c-.42-.245-1-.211-1.637.158l-.83-.484"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m125.545 55.79.83.484c-.648-.377-1.54-.327-2.522.242l-.83-.484c.982-.568 1.874-.62 2.522-.241"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M120.72 61.51c-.003-1.48 1.03-3.284 2.308-4.023l.83.483c-1.278.74-2.312 2.543-2.308 4.023l-.83-.483.83.484c.002.738.262 1.259.681 1.502l-.829-.483c-.419-.244-.68-.764-.681-1.503m-7.076 12.68c1.233-.714 2.352-.78 3.162-.308l.83.483c-.81-.472-1.93-.405-3.163.309-2.46 1.424-4.453 4.906-4.445 7.759.003 1.152.332 2.03.885 2.574l-.83-.483c-.553-.544-.88-1.422-.884-2.575-.009-2.852 1.984-6.334 4.445-7.758"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m108.851 89.68-.83-.482c-1.448-.845-2.35-2.645-2.357-5.202l.83.483c.007 2.557.908 4.358 2.357 5.202m10.45-20.139.83.483c-1.455-.847-3.46-.733-5.669.546l-.83-.484c2.21-1.278 4.215-1.393 5.67-.545m2.048-4.507-.83-.484c-.645-.376-1.047-1.178-1.05-2.317-.007-2.281 1.589-5.065 3.553-6.202l.83.484c-1.965 1.137-3.56 3.92-3.554 6.201.003 1.139.405 1.941 1.05 2.318"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m106.494 84.479-.83-.483c-.014-5.117 3.562-11.358 7.969-13.909l.83.484c-4.408 2.55-7.983 8.792-7.97 13.908"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M143.364 12.306c10.102-4.663 19.185-4.655 25.983-.697l.83.483c-6.799-3.957-15.882-3.966-25.983.697-.277-.16-.553-.322-.83-.483"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M139.016 14.57a53.102 53.102 0 0 1 4.348-2.264l.83.483a53.083 53.083 0 0 0-4.349 2.264l-.83-.484"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#E85127",
  d: "M96.502 88.398c-.076-27.097 18.996-60.214 42.514-73.828l.83.483c-23.52 13.614-42.591 46.731-42.514 73.828.037 13.269 4.66 22.67 12.13 27.212l-.83-.484c-7.47-4.54-12.093-13.942-12.13-27.211"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#g)",
  d: "m45.213 6.802-.205-.12c12.53-7.254 23.903-7.916 32.119-3.13l.83.484C69.74-.751 58.367-.089 45.836 7.166 20.94 21.579.75 56.645.83 85.329c.041 14.253 5.077 24.292 13.188 29.018l-.83-.484C5.078 109.137.042 99.1 0 84.846-.08 56.161 20.11 21.095 45.008 6.682l.205.12z",
  transform: "translate(94 5)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#h)",
  d: "M45.535 107.742C22.016 121.356 2.82 110.387 2.743 83.29 2.666 56.195 21.738 23.077 45.257 9.463c23.518-13.615 42.715-2.65 42.791 24.446.077 27.096-18.995 60.218-42.513 73.833M45.249 6.576C20.352 20.988.16 56.055.24 84.739c.082 28.69 20.405 40.303 45.302 25.89 24.901-14.415 45.092-49.481 45.01-78.17C90.474 3.772 70.15-7.84 45.25 6.575",
  transform: "translate(94.588 5.59)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FEFEFE",
  d: "m158.756 63.213-.83-.483-.027-9.506.83.484z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#28337C",
  d: "M173.478 45.104c-.004-1.341-.216-3.187-1.209-4.338-1.597-1.841-4.247-.889-6.189.236-1.5.868-2.784 1.893-3.841 3.07l-.013-4.659-3.532 2.045.035 12.185v.065l.026 9.505 3.532-2.044v-.027l-.026-9.479v-.065c-.003-.874.054-1.957.563-3.083.526-1.173 1.626-2.46 3.267-3.41 1.593-.922 2.654-1.042 3.243-.359.528.608.61 1.766.613 2.403l.027 9.57 3.531-2.044-.027-9.57zm-32.752 13.922c-1.593-1.844-4.247-.889-6.19.236-2.843 1.646-4.91 3.862-6.137 6.575-1.096 2.43-1.218 4.624-1.214 6.066l.027 9.57 3.532-2.044-.027-9.57c-.003-.875.055-1.958.563-3.084.531-1.175 1.63-2.461 3.268-3.41 1.593-.922 2.654-1.041 3.243-.359.528.608.61 1.766.613 2.403l.027 9.57 3.53-2.044-.026-9.57c-.004-1.342-.216-3.188-1.209-4.339m-18.614 8.539.047 16.833 3.536-2.046-.048-16.834zm-7.609 17.467c-2.46 1.425-4.466.257-4.474-2.6-.008-2.852 1.984-6.334 4.445-7.758 1.484-.859 2.801-.78 3.616.044l2.71-4.2c-1.472-1.346-3.768-1.435-6.338.053-4.407 2.55-7.983 8.792-7.968 13.908.015 5.12 3.614 7.208 8.02 4.657 2.57-1.488 4.858-4.23 6.317-7.273l-2.724-1.055c-.807 1.764-2.12 3.365-3.604 4.224m36.687-21.237c-2.461 1.424-4.47.259-4.478-2.598-.008-2.852 1.988-6.336 4.448-7.76 1.48-.857 2.798-.778 3.613.045l2.709-4.2c-1.472-1.345-3.764-1.436-6.333.051-4.41 2.553-7.983 8.793-7.969 13.909.015 5.12 3.61 7.21 8.022 4.656 2.57-1.487 4.853-4.227 6.312-7.27l-2.724-1.055c-.808 1.764-2.12 3.365-3.6 4.222m-29.64-1.802c-.004-1.48 1.03-3.284 2.307-4.023 1.273-.738 2.314-.134 2.318 1.346.004 1.48-1.03 3.284-2.303 4.021-1.277.74-2.318.136-2.322-1.344m2.326 2.798c1.961-1.135 3.557-3.918 3.55-6.2-.006-2.28-1.612-3.21-3.573-2.076-1.965 1.138-3.56 3.921-3.554 6.203.007 2.28 1.612 3.21 3.577 2.073"
}), /*#__PURE__*/react.createElement("path", {
  fill: "url(#i)",
  d: "M45.845 10.052C22.327 23.667 3.255 56.784 3.332 83.881c.076 27.096 19.273 38.065 42.791 24.45C69.642 94.718 88.713 61.596 88.637 34.5 88.56 7.403 69.364-3.561 45.845 10.052z",
  transform: "translate(94 5)"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#FFF",
  d: "M120.3 62.717c-.008-2.28 1.588-5.064 3.553-6.202 1.96-1.135 3.566-.205 3.573 2.077.006 2.28-1.589 5.065-3.55 6.2-1.965 1.137-3.57.207-3.577-2.075zm3.572.62c1.274-.737 2.307-2.54 2.303-4.021-.004-1.48-1.044-2.084-2.318-1.346-1.277.74-2.311 2.543-2.307 4.023.005 1.48 1.045 2.083 2.322 1.344zm46.102-6.618-.027-9.57c-.002-.637-.084-1.794-.613-2.403-.589-.683-1.65-.562-3.243.36-1.642.95-2.74 2.236-3.267 3.409-.51 1.127-.566 2.209-.564 3.083v.065l.027 9.506-3.531 2.044-.027-9.506v-.065l-.035-12.184 3.532-2.045.013 4.658c1.057-1.176 2.342-2.2 3.841-3.069 1.942-1.124 4.592-2.078 6.19-.236.992 1.15 1.204 2.996 1.208 4.338l.027 9.57-3.531 2.045zM151.2 67.899c-4.41 2.553-8.006.463-8.021-4.657-.014-5.117 3.558-11.355 7.969-13.909 2.57-1.487 4.862-1.396 6.333-.05l-2.71 4.2c-.814-.825-2.132-.903-3.612-.046-2.46 1.424-4.456 4.908-4.448 7.76.007 2.857 2.017 4.022 4.478 2.598 1.48-.857 2.792-2.458 3.6-4.222l2.724 1.055c-1.46 3.043-3.743 5.783-6.313 7.27zm-12.77 7.08-.027-9.57c-.003-.637-.084-1.794-.613-2.403-.589-.682-1.65-.562-3.243.36-1.638.948-2.737 2.235-3.268 3.409-.509 1.127-.566 2.21-.563 3.084l.027 9.57-3.532 2.044-.027-9.57c-.004-1.442.118-3.637 1.214-6.066 1.226-2.713 3.293-4.928 6.138-6.575 1.942-1.124 4.596-2.08 6.189-.236.993 1.15 1.205 2.996 1.209 4.339l.027 9.57-3.531 2.044zm-16.272 9.419-.047-16.833 3.534-2.047.048 16.834-3.535 2.046zm-7.644 4.738c-4.407 2.55-8.007.463-8.021-4.657-.015-5.116 3.561-11.357 7.968-13.908 2.57-1.488 4.866-1.4 6.337-.053l-2.709 4.2c-.815-.824-2.132-.903-3.616-.044-2.46 1.424-4.453 4.906-4.445 7.759.008 2.857 2.013 4.024 4.474 2.6 1.484-.86 2.797-2.461 3.605-4.225l2.723 1.055c-1.459 3.043-3.747 5.785-6.316 7.273z"
}))));
/* harmony default export */ var _404 = (Svg404);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/feature-error-page/src/lib/components/error-page/landing-feature-error-page.module.css
var landing_feature_error_page_module = __webpack_require__(205);
var landing_feature_error_page_module_default = /*#__PURE__*/__webpack_require__.n(landing_feature_error_page_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/components/error-page/landing-feature-error-page.tsx




function LandingFeatureErrorPage({ title , subTitle , image , hasCta =false , ctaHref , ctaText , searchCarsCtaText  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (landing_feature_error_page_module_default()).container,
        role: "main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                subTitle: subTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                image: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                hasCta: hasCta,
                ctaText: ctaText,
                ctaHref: ctaHref,
                searchCarsCtaText: searchCarsCtaText
            })
        ]
    });
}
function Title({ title  }) {
    if (!title) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        element: "h1",
        className: (landing_feature_error_page_module_default()).errorPageTitle,
        children: title
    });
}
function Subtitle({ subTitle  }) {
    if (!subTitle) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        className: (landing_feature_error_page_module_default()).errorPageSubTitle,
        element: "h2",
        children: subTitle
    });
}
function Image({ image: Image  }) {
    if (!Image) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (landing_feature_error_page_module_default()).errorPageImage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {})
    });
}
function CTA({ hasCta , ctaText , ctaHref , searchCarsCtaText  }) {
    if (!hasCta || !ctaText || !ctaHref) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                element: "a",
                href: ctaHref,
                children: ctaText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCarsCTA, {
                searchCarsCtaText: searchCarsCtaText
            })
        ]
    });
}
function SearchCarsCTA({ searchCarsCtaText  }) {
    if (!searchCarsCtaText) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
        element: "a",
        href: "/used-cars",
        children: searchCarsCtaText
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/components/error-page/variants/error-boundary-page.tsx




const ErrorBoundaryPage = ({ errorTitle , errorText , homeCtaText , searchCarsCtaText , currentUrl  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(src/* Layout */.Ar, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFeatureErrorPage, {
            title: errorTitle,
            subTitle: errorText,
            image: _404,
            hasCta: true,
            ctaText: homeCtaText,
            searchCarsCtaText: searchCarsCtaText,
            ctaHref: currentUrl
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/components/error-page/variants/error-boundary-page-wrapper.tsx





function ErrorFallback({ error  }) {
    const [retryUrl, setRetryUrl] = (0,react.useState)("/");
    (0,react.useEffect)(()=>{
        const { pathname  } = window.location;
        setRetryUrl(pathname);
        if (true) {
            main/* datadogRum.addError */.v.addError(new Error(error.message), {
                error: {
                    message: "User shown error boundary",
                    name: error.name,
                    stack: error.stack
                },
                route: pathname
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundaryPage, {
        errorTitle: "Something went wrong...",
        errorText: "We are attempting to resolve the issue but if it's taking too long you can use the buttons below to continue you journey",
        homeCtaText: "Return home",
        searchCarsCtaText: "Search cars",
        currentUrl: retryUrl
    });
}
const ErrorBoundaryWrapper = ({ children  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
        FallbackComponent: ErrorFallback,
        children: children
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/components/error-page/variants/custom-error-page.tsx





const CustomError = ({ statusCode , error  })=>{
    (0,react.useEffect)(()=>{
        if (true) {
            main/* datadogRum.addError */.v.addError(new Error(`An error of statusCode ${statusCode}`), {
                route: window.location.pathname,
                errorInformation: error
            });
        } else {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFeatureErrorPage, {
        title: `${statusCode} - Oops! Something went wrong`,
        subTitle: "Don’t worry, we can put you back on track!",
        image: _404,
        hasCta: true,
        ctaText: "Take me home",
        ctaHref: "/"
    });
};
CustomError.getInitialProps = ({ res , req , err , query , pathname  })=>{
    var ref;
    const statusCode = res ? res.statusCode : err ? err.message : 404;
    const errorLogs = {
        url: req === null || req === void 0 ? void 0 : req.url,
        pathname,
        query,
        cookies: req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref.cookies,
        headers: req === null || req === void 0 ? void 0 : req.headers
    };
    const error = err ? err : errorLogs;
    return {
        statusCode,
        error
    };
};
/* harmony default export */ var custom_error_page = (CustomError);

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/404.tsx





function Static404Page() {
    (0,react.useEffect)(()=>{
        if (true) {
            main/* datadogRum.addError */.v.addError(new Error(`An error of statusCode 404 was shown to user`), {
                route: window.location.pathname,
                statusCode: 404
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFeatureErrorPage, {
        title: `404 - Oops! Something went wrong`,
        subTitle: "Don't worry, we can put you back on track!",
        image: _404,
        hasCta: true,
        ctaText: "Take me home",
        ctaHref: "/"
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/lib/500.tsx





function Static500Page() {
    (0,react.useEffect)(()=>{
        if (true) {
            main/* datadogRum.addError */.v.addError(new Error(`An error of statusCode 500 was shown to user`), {
                route: window.location.pathname,
                statusCode: 500
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFeatureErrorPage, {
        title: `500 - Oops! Something went wrong`,
        subTitle: "Don't worry, we can put you back on track!",
        image: _404,
        hasCta: true,
        ctaText: "Take me home",
        ctaHref: "/"
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-error-page/src/index.ts









/***/ }),

/***/ 88805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "og": function() { return /* reexport */ datadog_data_namespaceObject; },
  "eo": function() { return /* reexport */ FaqAccordion; },
  "qg": function() { return /* reexport */ GenericTeaser; },
  "Fb": function() { return /* reexport */ head_head; },
  "HT": function() { return /* reexport */ json_ld_script/* JsonLdScript */.H; },
  "Ar": function() { return /* reexport */ Layout; },
  "s_": function() { return /* reexport */ panel; },
  "nT": function() { return /* reexport */ rich_text_section_component; },
  "No": function() { return /* reexport */ StatsSection; },
  "kv": function() { return /* reexport */ StoryblokRenderer; },
  "iA": function() { return /* reexport */ Table; },
  "DP": function() { return /* reexport */ trustpilot_quote; },
  "vO": function() { return /* reexport */ trustpilot_overview_v2_trustpilot_overview; },
  "Ur": function() { return /* reexport */ VehicleCard; },
  "pW": function() { return /* reexport */ generate_store_name_with_type/* generateStoreNameWithType */.p; },
  "or": function() { return /* reexport */ generate_store_name_with_type/* generateStoreType */.o; },
  "be": function() { return /* reexport */ rich_text_renderer; }
});

// UNUSED EXPORTS: AdminFeeDrawer, Breadcrumbs, ContentSection, FeatureSection, FullWidthCTA, Hero, HeroWithRichText, HubCardSkeleton, ImageObject, JsonLDType, Secondary, StoryblokIcon, TrustpilotOverview, TrustpilotScore, VehicleCardV2, Video, formatBreadcrumbListSchema, formatFaqPageSchema, formatHowToSchema, formatReviewToSchema, formatVideoSchema, useLatestVehicles

// NAMESPACE OBJECT: ../../../libs/landing/ui/shared/src/lib/datadog-data/index.ts
var datadog_data_namespaceObject = {};
__webpack_require__.r(datadog_data_namespaceObject);
__webpack_require__.d(datadog_data_namespaceObject, {
  "Actions": function() { return Actions; },
  "Context": function() { return context_Context; },
  "Errors": function() { return Errors; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/storyblok-rich-text-react-renderer/dist/index.es.js


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

const _excluded = ["component"];
const NODE_HEADING = 'heading';
const NODE_CODEBLOCK = 'code_block';
const NODE_PARAGRAPH = 'paragraph';
const NODE_QUOTE = 'blockquote';
const NODE_OL = 'ordered_list';
const NODE_UL = 'bullet_list';
const NODE_LI = 'list_item';
const NODE_HR = 'horizontal_rule';
const NODE_BR = 'hard_break';
const NODE_IMAGE = 'image';
const MARK_BOLD = 'bold';
const MARK_ITALIC = 'italic';
const MARK_STRIKE = 'strike';
const MARK_UNDERLINE = 'underline';
const MARK_CODE = 'code';
const MARK_LINK = 'link';
const MARK_STYLED = 'styled';
function render(document, options = {}) {
  if (typeof document === 'object' && document.type === 'doc' && Array.isArray(document.content)) {
    const _options$blokResolver = options.blokResolvers,
          blokResolvers = _options$blokResolver === void 0 ? {} : _options$blokResolver,
          _options$defaultBlokR = options.defaultBlokResolver,
          defaultBlokResolver = _options$defaultBlokR === void 0 ? function () {
      return null;
    } : _options$defaultBlokR,
          _options$nodeResolver = options.nodeResolvers,
          customNodeResolvers = _options$nodeResolver === void 0 ? {} : _options$nodeResolver,
          _options$markResolver = options.markResolvers,
          customMarkResolvers = _options$markResolver === void 0 ? {} : _options$markResolver,
          _options$textResolver = options.textResolver,
          textResolver = _options$textResolver === void 0 ? function (str) {
      return str;
    } : _options$textResolver;

    const nodeResolvers = _objectSpread2(_objectSpread2({}, defaultNodeResolvers), customNodeResolvers);

    const markResolvers = _objectSpread2(_objectSpread2({}, defaultMarkResolvers), customMarkResolvers);

    let currentKey = 0;

    const addKey = function (element) {
      return react.isValidElement(element) ? react.cloneElement(element, {
        key: currentKey++
      }) : element;
    };

    const renderNodes = function (nodes) {
      const elements = nodes ? nodes.map(renderNode).filter(function (node) {
        return node != null;
      }) : null;
      return Array.isArray(elements) && elements.length === 0 ? null : elements;
    };

    const renderNode = function (node) {
      if (node.type === 'blok') {
        const body = node.attrs.body;
        return body.map(function (_ref) {
          let component = _ref.component,
              props = _objectWithoutProperties(_ref, _excluded);

          const resolver = blokResolvers[component];
          const element = resolver ? resolver(props) : defaultBlokResolver(component, props);
          return addKey(element);
        });
      } else {
        var _node$marks;

        let childNode;

        if (node.type === 'text') {
          childNode = textResolver(node.text);
        } else {
          const resolver = nodeResolvers[node.type];
          childNode = resolver ? addKey(resolver(renderNodes(node.content), node.attrs)) : null;
        }

        const marks = (_node$marks = node.marks) !== null && _node$marks !== void 0 ? _node$marks : [];
        return marks.reduceRight(function (children, mark) {
          const resolver = markResolvers[mark.type];
          return resolver ? addKey(resolver(children, mark.attrs)) : children;
        }, childNode);
      }
    };

    return renderNodes(document.content);
  } else if (typeof document === 'string') {
    const _options$defaultStrin = options.defaultStringResolver,
          defaultStringResolver = _options$defaultStrin === void 0 ? function (str) {
      return str;
    } : _options$defaultStrin,
          _options$textResolver2 = options.textResolver,
          textResolver = _options$textResolver2 === void 0 ? function (str) {
      return str;
    } : _options$textResolver2;
    return defaultStringResolver(textResolver(document));
  }

  return null;
}

const simpleNodeResolver = function (element) {
  return function (children) {
    return children != null ? react.createElement(element, null, children) : null;
  };
};

const emptyNodeResolver = function (element) {
  return function () {
    return react.createElement(element);
  };
};

const headingNodeResolver = function (children, props) {
  return react.createElement(`h${props.level}`, null, children);
};

const imageNodeResolver = function (children, props) {
  return react.createElement('img', props, children);
};

const codeblockNodeResolver = function (children, props) {
  const codeProps = {
    className: props.class
  };
  const code = react.createElement('code', codeProps, children);
  return react.createElement('pre', null, code);
};

const simpleMarkResolver = function (element) {
  return function (children) {
    return react.createElement(element, null, children);
  };
};

const linkMarkResolver = function (children, {
  linktype,
  href,
  target
}) {
  const props = {
    href: linktype === 'email' ? `mailto:${href}` : href,
    target
  };
  return react.createElement('a', props, children);
};

const styledMarkResolver = function (children, props) {
  return react.createElement('span', {
    className: props.class
  }, children);
};

const defaultNodeResolvers = {
  [NODE_HEADING]: headingNodeResolver,
  [NODE_CODEBLOCK]: codeblockNodeResolver,
  [NODE_IMAGE]: imageNodeResolver,
  [NODE_PARAGRAPH]: simpleNodeResolver('p'),
  [NODE_QUOTE]: simpleNodeResolver('blockquote'),
  [NODE_OL]: simpleNodeResolver('ol'),
  [NODE_UL]: simpleNodeResolver('ul'),
  [NODE_LI]: simpleNodeResolver('li'),
  [NODE_HR]: emptyNodeResolver('hr'),
  [NODE_BR]: emptyNodeResolver('br')
};
const defaultMarkResolvers = {
  [MARK_LINK]: linkMarkResolver,
  [MARK_STYLED]: styledMarkResolver,
  [MARK_BOLD]: simpleMarkResolver('b'),
  [MARK_ITALIC]: simpleMarkResolver('i'),
  [MARK_STRIKE]: simpleMarkResolver('s'),
  [MARK_UNDERLINE]: simpleMarkResolver('u'),
  [MARK_CODE]: simpleMarkResolver('code')
};


//# sourceMappingURL=index.es.js.map

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/rich-text-renderer/rich-text-renderer.module.css
var rich_text_renderer_module = __webpack_require__(25535);
var rich_text_renderer_module_default = /*#__PURE__*/__webpack_require__.n(rich_text_renderer_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/rich-text-renderer/rich-text-renderer.tsx






const resolveYoutubeVideo = (props)=>(0,storyblok_src/* isYoutubeBlok */.z9)(props) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
        ...props,
        className: (rich_text_renderer_module_default()).video,
        customThumbnail: props.thumbnail.filename
    }) : null;
/**
 * Renders Storyblok Rich Text body with custom options
 * @param body - Storyblok Rich Text field
 * @param options - Custom options
 *  - makeId: boolean - Adds an id to the bold text (this was already here, didn't want breaking change so left it)
 *  - link: ILinkOptions - Custom link options
 *    - openNewTab: boolean - Specify if the link should open in a new tab
 *    - adobeTracking: TrackingEvent - Specify the adobe tracking event for the link
 * @returns React.ReactNode
 */ const renderWithResolver = (body, options)=>{
    return render(body, {
        nodeResolvers: {
            [NODE_IMAGE]: (_, props)=>{
                const optimizedImageUrl = (0,storyblok_src/* getStoryblokImageServiceUrl */.Vb)(props.src ?? "", {
                    filters: [
                        {
                            quality: 80
                        }
                    ]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    ...props,
                    src: optimizedImageUrl,
                    style: {
                        height: "auto"
                    },
                    alt: props.alt
                });
            },
            [NODE_PARAGRAPH]: (children)=>children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    className: (rich_text_renderer_module_default()).rtParagraph,
                    children: children
                }) : null
        },
        blokResolvers: {
            [storyblok_src/* BLOK_YOUTUBE */.Fs]: (props)=>resolveYoutubeVideo(props)
        },
        markResolvers: {
            [MARK_LINK]: (children, props)=>{
                var ref;
                const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props.href,
                    target: (options === null || options === void 0 ? void 0 : (ref = options.link) === null || ref === void 0 ? void 0 : ref.openNewTab) ? "_blank" : "_self",
                    rel: "noopener noreferrer",
                    onClick: ()=>{
                        var ref, ref1;
                        return (options === null || options === void 0 ? void 0 : (ref = options.link) === null || ref === void 0 ? void 0 : ref.adobeTracking) ? trackEvent(options === null || options === void 0 ? void 0 : (ref1 = options.link) === null || ref1 === void 0 ? void 0 : ref1.adobeTracking) : null;
                    },
                    children: children
                });
            },
            ...(options === null || options === void 0 ? void 0 : options.makeId) && {
                [MARK_BOLD]: (children)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("strong", {
                        id: children === null || children === void 0 ? void 0 : children.toLocaleString().replace(/\s/g, ""),
                        children: children
                    });
                }
            }
        }
    });
};
/* harmony default export */ var rich_text_renderer = (renderWithResolver);

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/faq-accordion/faq-accordion.module.css
var faq_accordion_module = __webpack_require__(60445);
var faq_accordion_module_default = /*#__PURE__*/__webpack_require__.n(faq_accordion_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/faq-accordion/faq-accordion.tsx








const FaqAccordion = (blok)=>{
    const { title , faqs  } = blok;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const accordionItems = faqs.map((faq)=>({
            title: faq.title,
            children: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: rich_text_renderer(faq.body)
                })
        }));
    const handleItemToggle = (itemIndex, _isOpen)=>{
        const faq = faqs[itemIndex];
        trackEvent({
            eventName: "FAQ accordion",
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "FAQ accordion",
                    label: title,
                    action: faq.title
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (faq_accordion_module_default()).faqSection,
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (faq_accordion_module_default()).sectionTitle,
                element: "h2",
                fontWeight: "bold",
                id: (0,src/* dashify */.P1)(title),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Accordion */.UQ, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "model-faq-section",
                onItemToggle: handleItemToggle
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/json-ld-script/json-ld-script.tsx
var json_ld_script = __webpack_require__(20692);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/json-ld-script/helpers/structured-data.ts
var structured_data = __webpack_require__(82749);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/json-ld-script/helpers/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/json-ld-script/index.ts



// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/shared/heading/heading.module.css
var heading_module = __webpack_require__(92489);
var heading_module_default = /*#__PURE__*/__webpack_require__.n(heading_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/heading/heading.tsx




const heading_Heading = ({ children , className , element ="h2"  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        element: element,
        className: classnames_default()((heading_module_default()).root, className),
        children: children
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/shared/text/text.module.css
var text_module = __webpack_require__(7537);
var text_module_default = /*#__PURE__*/__webpack_require__.n(text_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/text/text.tsx




const text_Text = ({ children , className  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        element: "p",
        className: classnames_default()((text_module_default()).root, className),
        children: children
    });

// EXTERNAL MODULE: ../../../node_modules/next/head.js
var head = __webpack_require__(46582);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/video/video.tsx










const Video = ({ videoId , title , thumbnail , description , ...rest })=>{
    const { trackEvent  } = useAnalytics();
    const videoStyles = {
        inner: styles.videoContainer,
        container: description && title ? styles.descriptionVideoMargin : styles.videoMargin
    };
    const sendVideoEvent = ()=>trackEvent({
            eventName: `Video click - ${window.location.pathname}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "video",
                    label: "thumbnail",
                    action: "latest video"
                }
            }
        });
    const schemaData = {
        videoId,
        title,
        thumbnail,
        description
    };
    return videoId ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx(JsonLdScript, {
                    schema: formatVideoSchema(schemaData),
                    tagId: "JargonPage"
                })
            }),
            title && /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            description && /*#__PURE__*/ _jsx(Text, {
                children: description
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: videoStyles,
                children: /*#__PURE__*/ _jsx(Youtube, {
                    videoId: videoId,
                    title: title || "",
                    className: styles.video,
                    customThumbnail: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.filename,
                    buttonLabel: "Play video",
                    showNewPlayIcon: true,
                    onClick: sendVideoEvent,
                    ...rest
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var video = ((/* unused pure expression or super */ null && (Video)));

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/utils/basket-storage.ts
const BASKET_BANNER_CLOSED = "cinch-checkout-basket-banner-closed";
const getBasketBannerClosed = ()=>{
    if (true) {
        return JSON.parse(window.localStorage.getItem(BASKET_BANNER_CLOSED) ?? "false");
    }
    return false;
};
const setBasketBannerClosed = (value)=>{
    if (true) {
        window.localStorage.setItem(BASKET_BANNER_CLOSED, value ? "true" : "false");
    }
};
const clearBasketBannerClosed = ()=>{
    if (true) {
        window.localStorage.removeItem(BASKET_BANNER_CLOSED);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/utils/check-order-has-expired.ts
function checkOrderHasExpired(activeOrder, callback) {
    if (!activeOrder) {
        return;
    }
    const activeOrderExpiresCancelsAt = activeOrder.expiresAt ?? activeOrder.cancelledAt;
    if (!activeOrderExpiresCancelsAt) {
        return;
    }
    const timeDifference = activeOrderExpiresCancelsAt - Date.now();
    if (timeDifference <= 0) {
        callback();
        return;
    }
    setTimeout(callback, timeDifference);
}

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/types.ts
var CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(CheckoutStage || (CheckoutStage = {}));
var EventActions;
(function(EventActions) {
    EventActions["addCinchCare"] = "checkout - add cinchcare";
    EventActions["addCinchCareExtras"] = "added_to_order";
    EventActions["backToGuide"] = "back-to-guide";
    EventActions["backToGuideWithValuation"] = "back-to-guide-with-valuation";
    EventActions["backToBasket"] = "back-to-basket";
    EventActions["backToBasketWithValuation"] = "back-to-basket-with-valuation";
    EventActions["backToCar"] = "back-to-car";
    EventActions["checkoutAddCinchCare"] = "checkout-add-cinchcare";
    EventActions["cinchCareDirectDebit"] = "checkout - cinchcare Direct Debit";
    EventActions["cinchCareConfirmed"] = "checkout - cinchcare confirmed";
    EventActions["cinchCareOrderConfirmation"] = "cinchCare added to order";
    EventActions["close"] = "close";
    EventActions["closeDrawer"] = "close-drawer";
    EventActions["codeFailed"] = "code-failed";
    EventActions["codeSuccess"] = "code-success";
    EventActions["continueToCheckout"] = "continue-to-checkout";
    EventActions["error"] = "error";
    EventActions["expand"] = "expand";
    EventActions["find"] = "find";
    EventActions["financeAvailable"] = "finance-available";
    EventActions["financeQuote"] = "finance-available";
    EventActions["googleLogin"] = "google-login";
    EventActions["highValuation"] = "high-valuation";
    EventActions["modalOpened"] = "modal-opened";
    EventActions["modalClosed"] = "modal-closed";
    EventActions["moreMileageOptions"] = "more-mileage-options";
    EventActions["navigate"] = "navigate";
    EventActions["noPartExNoFinanceQuote"] = "no_partex-no_finance-available";
    EventActions["open"] = "open";
    EventActions["openDrawer"] = "open-drawer";
    EventActions["partexAvailable"] = "partex-available";
    EventActions["partExLanding"] = "part-ex-landing";
    EventActions["play"] = "play";
    EventActions["referAFriend"] = "refer-a-friend";
    EventActions["postcodeLookup"] = "postcode-lookup";
    EventActions["postcodeDropdown"] = "postcode-lookup-dropdown";
    EventActions["promotionalTerms"] = "promotional-terms";
    EventActions["remove"] = "remove";
    EventActions["removeCar"] = "remove-car";
    EventActions["removeFinance"] = "remove-finance";
    EventActions["removePartex"] = "remove-partex";
    EventActions["returnToCheckout"] = "return-to-checkout";
    EventActions["reviewAndPay"] = "checkout - review and pay";
    EventActions["search"] = "search";
    EventActions["select"] = "select";
    EventActions["start"] = "start";
    EventActions["submit"] = "submit";
    EventActions["thirdParty"] = "third-party";
    EventActions["valuationAvailable"] = "valuation-available";
    EventActions["tellMeMore"] = "tell-me-more";
    EventActions["ticked"] = "ticked";
    EventActions["unticked"] = "unticked";
    EventActions["view"] = "view";
    EventActions["continue"] = "continue";
    EventActions["deadClick"] = "deadClick";
    EventActions["dontWantCare"] = "i-do-not-want-this-car";
    EventActions["resumeModal"] = "checkout-resume-modal";
})(EventActions || (EventActions = {}));
var EventCategories;
(function(EventCategories) {
    EventCategories["button"] = "button";
    EventCategories["checkout"] = "checkout";
    EventCategories["chevron"] = "chevron";
    EventCategories["cinchcare"] = "cinchcare";
    EventCategories["dropdown"] = "dropdown";
    EventCategories["form"] = "form";
    EventCategories["marker"] = "marker";
    EventCategories["page"] = "page";
    EventCategories["text"] = "text";
    EventCategories["tooltip"] = "tooltip";
    EventCategories["checkbox"] = "checkbox";
    EventCategories["panel"] = "panel";
    EventCategories["partexCheckbox"] = "partex-checkbox";
    EventCategories["view"] = "view";
    EventCategories["link"] = "link";
    EventCategories["box"] = "box";
    EventCategories["vaps"] = "vaps";
    EventCategories["video"] = "video";
    EventCategories["image"] = "image";
})(EventCategories || (EventCategories = {}));
var types_EventNames;
(function(EventNames) {
    EventNames["click"] = "click";
    EventNames["error"] = "error";
    EventNames["load"] = "load";
    EventNames["scCheckout"] = "scCheckout";
    EventNames["impression"] = "impression";
})(types_EventNames || (types_EventNames = {}));

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/banner/banner-analytics.tsx

const basketBannerReturnToCheckoutEvent = ()=>({
        event: {
            name: types_EventNames.click,
            category: EventCategories.button,
            label: "checkout-resume-banner",
            action: EventActions.returnToCheckout
        }
    });
const basketBannerCloseBannerEvent = ()=>({
        event: {
            name: types_EventNames.click,
            category: EventCategories.button,
            label: "checkout-resume-banner",
            action: EventActions.modalClosed
        }
    });
const basketBannerVehicleImageClickEvent = ()=>({
        event: {
            name: types_EventNames.click,
            category: EventCategories.image,
            action: EventActions.deadClick,
            label: "checkout-return-car-image"
        }
    });
const basketBannerNoLongerWantVehicleClickEvent = ()=>({
        event: {
            name: types_EventNames.click,
            category: EventCategories.button,
            action: EventActions.dontWantCare,
            label: "checkout-resume-banner"
        }
    });

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/holding-image/assets/car.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgCar = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  d: "M22.48 12.82c-2.12-2.86-5.05-3.87-8.27-3.87-.7 0-1.42.05-2.15.13C9 9.45 6.75 11.62 6 14.75a2.98 2.98 0 0 1-.54 1.13 3.38 3.38 0 0 0-.52 3.44c.15.41.7.69 1.08 1.02.18.16.45.28.53.48.54 1.34 1.54 2.1 2.85 2.13h.12c1.65 0 2.55-.6 3.2-2.05.08-.17.35-.38.53-.38.97-.02 1.94-.02 2.9-.02h2.35c.7 1.82 1.55 2.45 3.31 2.45h.11c1.5-.02 2.42-.76 2.98-2.45l.29.01c1.06 0 1.88-.36 2.28-1.4a3.67 3.67 0 0 0-2.51-4.7 4.07 4.07 0 0 1-2.48-1.6zm-.53 13.13h-.14c-2.28 0-3.94-.8-5.1-2.45a506.8 506.8 0 0 0-2.03 0c-1.18 1.63-2.9 2.45-5.16 2.45h-.17a5.95 5.95 0 0 1-5.26-3.31 5.3 5.3 0 0 1-.06-.06l-.16-.11a6.42 6.42 0 0 1-.7-.58 3.9 3.9 0 0 1-1.05-1.54c-.8-2.2-.5-4.45.98-6.32a.08.08 0 0 0-.01.02C4.12 9.7 7.39 6.63 11.7 6.1a20.96 20.96 0 0 1 2.5-.16c4.42 0 8.1 1.6 10.68 5.08.19.25.35.35.78.46 3.77.91 6 5.14 4.6 8.72a4.94 4.94 0 0 1-3.4 3.09 5.67 5.67 0 0 1-4.92 2.65z"
})));
/* harmony default export */ var car = (SvgCar);
// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/holding-image/holding-image.module.css
var holding_image_module = __webpack_require__(42373);
var holding_image_module_default = /*#__PURE__*/__webpack_require__.n(holding_image_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/holding-image/holding-image.tsx





const { space  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const holding_image_HoldingImage = ({ className ="" , text =""  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((holding_image_module_default()).holdingImage, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (holding_image_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(car, {
                    fill: "currentColor",
                    width: space["8-x"]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                type: index_esm/* TextStyles.menuTitle */.k7.menuTitle,
                children: text
            })
        ]
    });
/* harmony default export */ var holding_image = (holding_image_HoldingImage);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/image/image.tsx




function image_Image({ className , src , alt , lazy , sendDigitalDataEvent , clickable =false  }) {
    const [hasError, updateErrorState] = (0,react.useState)(false);
    const updateError = ()=>{
        updateErrorState(true);
    };
    const defaultImageProps = {
        className: className,
        src: src,
        alt: alt || "Image",
        loading: lazy ? "lazy" : "eager",
        onError: updateError
    };
    const imageProps = clickable ? {
        ...defaultImageProps,
        "aria-hidden": true,
        onClick: ()=>sendDigitalDataEvent(basketBannerVehicleImageClickEvent())
    } : defaultImageProps;
    const { src: imageSrc , alt: imageAlt , ...restImageProps } = imageProps;
    return !src || hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(holding_image, {
        className: className,
        text: "Image Unavailable"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: imageSrc,
        alt: imageAlt,
        ...restImageProps
    });
}
/* harmony default export */ var image_image = (image_Image);

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/vehicle-information/vehicle-information.module.css
var vehicle_information_module = __webpack_require__(20969);
var vehicle_information_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_information_module);
;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/environment/environment.types.ts
const EnvironmentFromFile = {
    Fred: "FRED",
    IDontWantThisCar: "I_DONT_WANT_THIS_CAR",
    SSRProdTest: "SSR_PROD_TEST",
    ClientProdTest: "CLIENT_PROD_TEST",
    HomepageSSRTest: "HOMEPAGE_SSR_TEST",
    NextBestActionExperimentId: "NEXT_BEST_ACTION_EXPERIMENT_ID",
    BuyNowCTAMessaging: "BUY_NOW_CTA_MESSAGING_EXPERIMENT_ID",
    SearchMultipleImagesV2ExperimentId: "SEARCH_MULTIPLE_IMAGES_V2_EXPERIMENT_ID",
    FinanceSoftSearchExperimentId: "FINANCE_SOFT_SEARCH_EXPERIMENT_ID"
};
const environment_types_Env = {
    ...EnvironmentFromFile
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/environment/environment-dev.ts
const environmentDev = {
    FRED: "THIS IS A DUMMY VALUE",
    I_DONT_WANT_THIS_CAR: "956475",
    CLIENT_PROD_TEST: "1110683",
    NEXT_BEST_ACTION_EXPERIMENT_ID: "1115849",
    SEARCH_MULTIPLE_IMAGES_V2_EXPERIMENT_ID: "1138278",
    FINANCE_SOFT_SEARCH_EXPERIMENT_ID: "1156959",
    // SSR Enabled Activities
    SSR_PROD_TEST: "1084587",
    // Activity Location IDs
    HOMEPAGE_SSR_TEST: "homepage-hmc-flag",
    BUY_NOW_CTA_MESSAGING_EXPERIMENT_ID: "1127950"
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/environment/environment-prod.ts
const environmentProd = {
    FRED: "THIS IS A DUMMY VALUE",
    I_DONT_WANT_THIS_CAR: "956477",
    CLIENT_PROD_TEST: "1110683",
    NEXT_BEST_ACTION_EXPERIMENT_ID: "1115318",
    SEARCH_MULTIPLE_IMAGES_V2_EXPERIMENT_ID: "1140626",
    FINANCE_SOFT_SEARCH_EXPERIMENT_ID: "1159515",
    // SSR Enabled Activities
    SSR_PROD_TEST: "1115015",
    // Activity Location IDs
    HOMEPAGE_SSR_TEST: "homepage-aa-test-2",
    BUY_NOW_CTA_MESSAGING_EXPERIMENT_ID: "1127951"
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/environment/environment.ts


const environment =  true ? environmentProd : 0;

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/environment/read-from-env.ts

function read_from_env_readFromEnv(key) {
    const envValue = environment[key];
    if (envValue === undefined || envValue === null) {
        throw new Error(`
        Missing environment variable value for key ${key}.
        Running locally: Do you have a .env.local file in your app folder that contains ${key}?
        Running in CI: Is ${key} exposed in the CI pipeline file?
        `);
    }
    return envValue;
}


;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/constants.ts


const targetActivities = {
    FRED: read_from_env_readFromEnv(environment_types_Env.Fred),
    I_DONT_WANT_THIS_CAR: read_from_env_readFromEnv(environment_types_Env.IDontWantThisCar),
    SSR_PROD_TEST: read_from_env_readFromEnv(environment_types_Env.SSRProdTest),
    CLIENT_PROD_TEST: read_from_env_readFromEnv(environment_types_Env.ClientProdTest),
    NEXT_BEST_ACTION_EXPERIMENT_ID: read_from_env_readFromEnv(environment_types_Env.NextBestActionExperimentId),
    BUY_NOW_CTA_MESSAGING_EXPERIMENT_ID: read_from_env_readFromEnv(environment_types_Env.BuyNowCTAMessaging),
    SEARCH_MULTIPLE_IMAGES_V2_EXPERIMENT_ID: read_from_env_readFromEnv(environment_types_Env.SearchMultipleImagesV2ExperimentId),
    FINANCE_SOFT_SEARCH_EXPERIMENT_ID: read_from_env_readFromEnv(environment_types_Env.FinanceSoftSearchExperimentId)
};
const constants_targetActivityLocations = {
    HOMEPAGE_SSR_TEST: read_from_env_readFromEnv(environment_types_Env.HomepageSSRTest)
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/helpers.ts

/**
 * Retrieves the activity ID associated with the given activity constant.
 * @param activityConst The activity constant.
 * @returns The activity ID.
 */ function helpers_getActivityId(activityConst) {
    const activityId = targetActivities[activityConst];
    if (typeof activityId === "undefined") {
        // eslint-disable-next-line no-console
        console.warn(`Activity ID: ${activityConst} is missing from targetActivities in packages/hooks/target/src/constants.ts`);
    }
    return activityId;
}
/**
 * Retrieves the activity location ID associated with the given activity constant.
 * @param activityLocationConst The activity location constant.
 * @returns The activity location ID.
 */ function helpers_getActivityLocationId(activityLocationConst) {
    const activityId = targetActivityLocations[activityLocationConst];
    if (typeof activityId === "undefined") {
        // eslint-disable-next-line no-console
        console.warn(`Activity Location ID: ${activityLocationConst} is missing from targetActivities in packages/hooks/target/src/constants.ts`);
    }
    return activityId;
}
/**
 * Wraps a promise with a timeout, rejecting it if it takes longer than the specified time.
 * @param ms The timeout duration in milliseconds.
 * @param promise The promise to wrap with a timeout.
 * @param error The error to be thrown if the promise times out. Default is 'Timed out'.
 * @returns A promise that resolves with the result of the passed in promise, or rejects with the specified error if it times out.
 */ function helpers_timeoutPromise(ms, promise, error = new Error("Timed out")) {
    // Create a promise that rejects in <ms> milliseconds
    const timeout = new Promise((_, reject)=>{
        setTimeout(()=>reject(error), ms);
    });
    // Return race between timeout and passed in promise
    return Promise.race([
        promise,
        timeout
    ]);
}
/**
 * Stores the activityId in session storage to ensure that only one event per activity is fired.
 * @param existingActivityIds The activityIds already stored in session storage.
 * @param activityId The activityId to be added to the activityIds already in session storage.
 */ const storeActivityIdInSessionStorage = (existingActivityIds, activityId)=>{
    sessionStorage.setItem(`ttMetaTracking`, JSON.stringify([
        ...existingActivityIds,
        activityId
    ]));
};

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-client-side/use-adobe-target.ts




/**
 * Custom hook for retrieving Adobe Target activity data.
 *
 * @param activityConst - The constant representing the activity.
 * @param shouldFlagActivity - A flag to send an additional event to adobe when the experiment was found. One event per session per activity will be fired.
 * @param targetTimeout - The timeout duration for retrieving the activity data (default: 3000).
 * @returns The activity data or null if not found.
 * @example
 *  const experimentData = useAdobeTarget('EXAMPLE_ACTIVITY')
 *  const experimentIsActive = activityData?.ActivityState === 'Variant'
 *
 *  if (experimentIsActive) {
 *  // Do something
 *  }
 */ function useAdobeTarget(activityConst, shouldFlagActivity = false, targetTimeout = 5000) {
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const activityId = helpers_getActivityId(activityConst);
    const [activityData, setActivityData] = (0,react.useState)(()=>{
        var ref;
        if ((ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.length) {
            return getTargetActivity(activityId);
        }
        return;
    });
    const didCancel = (0,react.useRef)(false);
    const setActivityDataIfMounted = (value)=>{
        if (didCancel.current === true) {
            return;
        }
        setActivityData(value);
    };
    const handleTtMetaTracking = (activityId, experienceId)=>{
        const ttMetaTrackingActivityIdString = sessionStorage.getItem(`ttMetaTracking`);
        const eventCategory = getEventCategoryForExperienceId(experienceId);
        if (!ttMetaTrackingActivityIdString) {
            storeActivityIdInSessionStorage([], activityId);
            trackEvent(ttMetaTrackingEvent(activityId, eventCategory));
            return;
        }
        const ttMetaTrackingActivityIds = JSON.parse(ttMetaTrackingActivityIdString);
        const activityIdIsStored = ttMetaTrackingActivityIds.includes(activityId);
        if (!activityIdIsStored) {
            storeActivityIdInSessionStorage(ttMetaTrackingActivityIds, activityId);
            trackEvent(ttMetaTrackingEvent(activityId, eventCategory));
            return;
        }
        return;
    };
    (0,react.useEffect)(()=>{
        async function handle() {
            try {
                var ref;
                await helpers_timeoutPromise(targetTimeout, ttMetaMonitor());
                if ((ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.length) {
                    const activityData = getTargetActivity(activityId);
                    if (!activityData) {
                        setActivityDataIfMounted(null);
                        console.warn(`🧪 Experiment ${activityConst} - ${activityId} not found`);
                        return;
                    }
                    setActivityDataIfMounted(activityData);
                    if (shouldFlagActivity) handleTtMetaTracking(activityId, activityData.ExperienceId);
                    return;
                }
                setActivityDataIfMounted(null);
            } catch (error) {
                console.warn(`🧪 Error while retrieving experiments - ${error}`);
                setActivityDataIfMounted(null);
            }
        }
        handle();
        return ()=>{
            didCancel.current = true;
        };
    }, [
        activityConst,
        targetTimeout
    ]);
    return activityData;
}
function ttMetaTrackingEvent(activityId, categoryName) {
    return {
        eventName: `ttMETA`,
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                name: analytics_src/* EventNames.click */.Vy.click,
                category: categoryName,
                value: activityId
            }
        }
    };
}
/**
 * Monitors window.ttMeta for the adobe target property (using getTargetPropertyFromWindow) and resolves the promise when the property is available.
 * @returns A promise that resolves when the property is available.
 */ function ttMetaMonitor() {
    return new Promise((resolve)=>{
        const interval = setInterval(()=>{
            if (window["ttMETA"] !== undefined) {
                clearInterval(interval);
                resolve();
            }
        }, 100);
    });
}
/**
 * Retrieves the Adobe Target property from the window object.
 * @returns An array of TargetResponseToken objects or undefined if the window object is not available.
 */ function getTargetPropertyFromWindow() {
    return  false ? 0 : window["ttMETA"];
}
/**
 * Retrieves the target activity with the specified activity ID.
 * @param activityId The ID of the target activity.
 * @returns The target activity object if found, or null if not found.
 */ function getTargetActivity(activityId) {
    var ref;
    const targetActivity = (ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.find((activity)=>activity.ActivityId === activityId);
    if (targetActivity) {
        const { ActivityName , ExperienceName  } = targetActivity;
        main/* datadogRum.addFeatureFlagEvaluation */.v.addFeatureFlagEvaluation(transformActivityNameForDatadog(ActivityName), ExperienceName);
    }
    return targetActivity ?? null;
}
function transformActivityNameForDatadog(activityName) {
    // parse out sections of the standard activity name format
    // e.g. CI168 - Search - Multiple Image Gallery - DEV/LOCAL
    const matchResult = /(?<experimentCode>.+)\s-\s(?<squad>.+)\s-\s(?<experimentName>.+)\s-\s(?<environment>.+)/g.exec(activityName);
    if (!(matchResult === null || matchResult === void 0 ? void 0 : matchResult.groups)) {
        return `experiment_${sanitiseActivityNameForDatadogRUM(activityName)}`;
    }
    const { experimentCode , squad , experimentName  } = matchResult.groups;
    return sanitiseActivityNameForDatadogRUM(`experiment_${squad}_${experimentCode}_${experimentName.replace(/ /g, "_")}`);
}
function sanitiseActivityNameForDatadogRUM(activityName) {
    const charactersToReplace = [
        [
            /\./g,
            "_"
        ],
        [
            /:/g,
            "_"
        ],
        [
            /\+/g,
            "_"
        ],
        [
            /-/g,
            "_"
        ],
        [
            /=/g,
            "_"
        ],
        [
            /&&/g,
            "_AND_"
        ],
        [
            /\|\|/g,
            "_OR_"
        ],
        [
            />/g,
            "_greater_than_"
        ],
        [
            /</g,
            "_less_than_"
        ],
        [
            /!/g,
            ""
        ],
        [
            /\(/g,
            ""
        ],
        [
            /\)/g,
            ""
        ],
        [
            /{/g,
            ""
        ],
        [
            /}/g,
            ""
        ],
        [
            /\[/g,
            ""
        ],
        [
            /]/g,
            ""
        ],
        [
            /\^/g,
            ""
        ],
        [
            /"/g,
            "'"
        ],
        [
            /“/g,
            "'"
        ],
        [
            /”/g,
            "'"
        ],
        [
            /~/g,
            "_"
        ],
        [
            /\*/g,
            ""
        ],
        [
            /\?/g,
            ""
        ],
        [
            /\\/g,
            "_"
        ],
        [
            / /g,
            "_"
        ]
    ];
    return charactersToReplace.reduce((sanitisedActivityName, [characterToReplace, replacementCharacter])=>sanitisedActivityName.replace(characterToReplace, replacementCharacter), activityName);
}
function getEventCategoryForExperienceId(experienceId) {
    switch(experienceId){
        case "0":
            return "ttMETAControl";
        case "1":
            return "ttMETAVariant";
        // if it's not 0 or 1, we're in a multivariate test with multiple variants, so append the experienceId
        default:
            return `ttMETAVariant-${experienceId}`;
    }
}
/* harmony default export */ var use_adobe_target = ((/* unused pure expression or super */ null && (useAdobeTarget)));

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-client-side/index.ts


// EXTERNAL MODULE: ../../../node_modules/@adobe/target-nodejs-sdk/dist/targetclient.browser.js
var targetclient_browser = __webpack_require__(90099);
// EXTERNAL MODULE: ../../../node_modules/nookies/dist/index.js
var dist = __webpack_require__(59665);
;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/config.ts
const isProd = "production" === "production";
const trackingServerDomain = isProd ? "bcacinchprod.112.2o7.net" : "bcaoxforddev.112.2o7.net";
const config_CLIENT_TIMEOUT = 3000;
const config_targetClientOptions = {
    client: "bca",
    organizationId: "E5F2C8A15481C0E20A4C98BC@AdobeOrg",
    timeout: config_CLIENT_TIMEOUT,
    serverDomain: trackingServerDomain,
    decisioningMethod: "on-device",
    pollingInterval: 60000
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/errors.ts
const TARGET_CLIENT_ERROR_MESSAGES = {
    TARGET_CLIENT_DECISIONING_ENGINE_NOT_READY: "The Target Client decisioning engine is not ready",
    FAILED_TO_FETCH_TARGET_ACTIVITIES: "Failed to fetch all target activities",
    NO_TARGET_ACTIVITIES_FOUND: "No target activities found. Please check the activity location ID",
    TARGET_ACTIVITY_NOT_FOUND: "Target activity not found. Please check target activity ID",
    INIT_TIMEOUT: "Timed out on initialising target client"
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/adobe-target-server-side.ts





let targetClient;
/**
 * Initialises the target client and awaits for this to become ready, then calls
 * the client to retrieve the specified target activity.
 *
 * @param ssrCtx The server-side context object from getServerSideProps
 * @param activityLocationId The activity location or mbox name
 * @param targetActivityConst The activity constant
 * @returns The target activity object or null
 */ async function getAdobeTargetSSR(ssrCtx, activityLocationConst, targetActivityConst) {
    const cookies = nookies.get(ssrCtx);
    const checkCookiesAccepted = checkAnalyticCookieExists(cookies);
    if (!checkCookiesAccepted) {
        return null;
    }
    // Initialise the client
    targetClient = TargetClient.create({
        ...targetClientOptions,
        events: {
            artifactDownloadFailed: (event)=>handleArtifactDownloadFailure(event)
        }
    });
    try {
        var ref;
        // Wait for the client to complete it's initialisation before continuing
        await timeoutPromise(CLIENT_TIMEOUT, clientMonitor(), new Error(ERROR_MESSAGES.INIT_TIMEOUT));
        const isClientReady = (ref = targetClient.decisioningEngine) === null || ref === void 0 ? void 0 : ref.isReady();
        if (isClientReady) {
            const activityId = getActivityId(targetActivityConst);
            const activityLocationId = getActivityLocationId(activityLocationConst);
            const targetCookie = cookies[TargetClient.TargetCookieName] // 'mbox'
            ;
            const targetActivity = await fetchTargetActivity(activityLocationId, targetCookie, activityId, ssrCtx);
            return targetActivity;
        } else {
            throw new Error(ERROR_MESSAGES.TARGET_CLIENT_DECISIONING_ENGINE_NOT_READY);
        }
    } catch (error) {
        console.warn(error);
        return null;
    }
}
/**
 * Calls the initialised target client to retrieve the target activity object if it exists
 * @param activityLocationId The activity location ID
 * @param targetCookie The target cookie (string or undefined)
 * @param activityId The activity id from the environments file
 * @param ssrCtx The server-side context object from getServerSideProps
 * @returns The target activity object or null
 */ async function fetchTargetActivity(activityLocationId, targetCookie, activityId, ssrCtx) {
    try {
        const request = {
            execute: {
                mboxes: [
                    {
                        address: {
                            url: `${ssrCtx.req.headers.host}${ssrCtx.req.url}`
                        },
                        name: activityLocationId
                    }
                ]
            }
        };
        const response = await targetClient.getOffers({
            request,
            targetCookie
        });
        if (!response) {
            throw new Error(ERROR_MESSAGES.FAILED_TO_FETCH_TARGET_ACTIVITIES);
        }
        const existingTargetCookie = targetCookie;
        /**
     * If the cookie doesn't exist, it means the user has accepted the cookie banner
     * and the page has reloaded. However, Adobe scripts haven't loaded by this point (as
     * we're still in the server and scripts run client), so we want to get the targetCookie
     * returned from the get attributes response and set it before the client loads.
     * */ if (!existingTargetCookie) {
            const newTargetCookie = response.targetCookie;
            nookies.set(ssrCtx, newTargetCookie.name, newTargetCookie.value, {
                maxAge: newTargetCookie.maxAge
            });
        }
        const targetActivity = adobe_target_server_side_getTargetActivity(Number(activityId), response.responseTokens);
        return targetActivity;
    } catch (error) {
        if (error instanceof Error) {
            throw new TypeError(error.message);
        }
        return null;
    }
}
/**
 * @param activityId The activity ID for the experiment
 * @param response OfferAttributesGetResponse
 * @returns The target activity object or appropriate errors if not found
 */ function adobe_target_server_side_getTargetActivity(activityId, allTargetActivities) {
    if (!allTargetActivities) {
        throw new Error(ERROR_MESSAGES.NO_TARGET_ACTIVITIES_FOUND);
    }
    const targetActivity = allTargetActivities.find((activity)=>activity["activity.id"] === Number(activityId));
    if (!targetActivity) {
        throw new Error(ERROR_MESSAGES.TARGET_ACTIVITY_NOT_FOUND);
    }
    return targetActivity;
}
/**
 * Validates the correct cinch cookies (analytics) has been accepted
 * @param cookies
 * @returns boolean
 */ function checkAnalyticCookieExists(cookies) {
    if (cookies["cp"]) {
        const parsedCinchCookies = JSON.parse(cookies["cp"]);
        if (parsedCinchCookies.analytics) return true;
    }
    return false;
}
/**
 * Monitors the target client initialisation. Will resolve the promise once the decisioning engine is ready.
 * @returns A promise that resolves when the property is available.
 */ function clientMonitor() {
    return new Promise((resolve)=>{
        const interval = setInterval(()=>{
            var ref;
            const result = targetClient;
            if ((ref = result.decisioningEngine) === null || ref === void 0 ? void 0 : ref.isReady()) {
                clearInterval(interval);
                resolve();
            }
        }, 100);
    });
}
const handleArtifactDownloadFailure = (event)=>{
    throw new Error(`Artifact failed to download:\n${event}`);
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/adobe-target-client.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore

const PROD_TRACKING_SERVER = "bcacinchprod.112.2o7.net";
const DEV_TRACKING_SERVER = "bcaoxforddev.112.2o7.net";
const adobe_target_client_isProd = (/* unused pure expression or super */ null && ("production" === "production"));
const adobe_target_client_trackingServerDomain = (/* unused pure expression or super */ null && (adobe_target_client_isProd ? PROD_TRACKING_SERVER : DEV_TRACKING_SERVER));
const adobe_target_client_initAdobeTargetClient = async ()=>{
    try {
        let adobeTargetClient;
        const initTargetClient = new Promise((resolve)=>{
            const clientReadyCallback = ()=>resolve();
            const clientConfig = createAdobeTargetClientConfig(clientReadyCallback);
            adobeTargetClient = TargetClient.create(clientConfig);
        });
        await Promise.all([
            initTargetClient
        ]);
        return adobeTargetClient;
    } catch  {
        throw new Error("Failed to initialise Adobe Target Client");
    }
};
const createAdobeTargetClientConfig = (clientReadyCallback)=>({
        client: "bca",
        organizationId: "E5F2C8A15481C0E20A4C98BC@AdobeOrg",
        decisioningMethod: "on-device",
        serverDomain: adobe_target_client_trackingServerDomain,
        events: {
            clientReady: clientReadyCallback
        }
    });

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/adobe-target-server-side.pd-impl.ts

const DEFAULT_EXPERIENCE_UNAVAILABLE = (/* unused pure expression or super */ null && ([]));
const getAdobeExperimentSSR = async (experimentNames, context)=>{
    try {
        const cookies = context.req.cookies;
        const cookiePreferences = cookies["cp"];
        if (!cookiePreferences) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        const parsedCP = JSON.parse(cookiePreferences);
        if (!parsedCP.analytics) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        const mboxCookie = cookies["mbox"];
        if (!mboxCookie) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        return await getExperiments(experimentNames, mboxCookie);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        console.error(`Failed to retrieve Adobe Experiment data: ${errorMessage}`);
        return DEFAULT_EXPERIENCE_UNAVAILABLE;
    }
};
const getExperiments = async (experimentNames, abTestCookie)=>{
    const experiments = [];
    const adobeTargetClient = await initAdobeTargetClient();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await adobeTargetClient // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    .getAttributes(experimentNames, {
        targetCookie: abTestCookie
    }).then((response)=>{
        for (const experimentName of experimentNames){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const experiment = response.asObject(experimentName);
            if (experiment && experiment.experienceId !== undefined && experiment.experienceId !== null) {
                experiments.push({
                    name: experimentName,
                    experienceId: experiment.experienceId
                });
            }
        }
    });
    return experiments;
};

;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/adobe-target-server-side/index.ts




;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/lib/index.ts



;// CONCATENATED MODULE: ../../../libs/shared/experiments/adobe/src/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/vehicle-information/vehicle-information.tsx







function VehicleInformation({ vehicle , sendDigitalDataEvent , adminFeeFlag , adminFeeValueInPence  }) {
    const { imageUrl , make , model , derivative , priceInPence , registrationDate , id  } = vehicle;
    const regYear = new Date(registrationDate).getFullYear();
    const vehicleName = `${regYear} ${(0,src/* getMake */.Ao)(make)} ${(0,src/* getModel */.PD)(make, model)}`;
    const dontWantCarExperiment = useAdobeTarget("I_DONT_WANT_THIS_CAR");
    const basicVehicleInfo = {
        make: make,
        model: model,
        id
    };
    const { vw  } = (0,src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 768;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((vehicle_information_module_default()).basketBannerVehicleInfoContainer, {
            [(vehicle_information_module_default()).basketBannerVehicleInfoContainerWithAdminFee]: adminFeeFlag
        }),
        children: [
            dontWantCarExperiment && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* LinkToProductDetail */.si, {
                basicVehicleInfo: basicVehicleInfo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image, {
                    sendDigitalDataEvent: sendDigitalDataEvent,
                    src: imageUrl,
                    alt: vehicleName,
                    className: (vehicle_information_module_default()).vehicleImageMobile,
                    lazy: true,
                    clickable: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((vehicle_information_module_default()).priceRow, {
                    [(vehicle_information_module_default()).priceRowWithAdminFee]: adminFeeFlag
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* LinkToProductDetail */.si, {
                        basicVehicleInfo: basicVehicleInfo,
                        className: classnames_default()((vehicle_information_module_default()).underlineText, (vehicle_information_module_default()).vehicleLink),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            id: "description-of-active-order-vehicle",
                            className: (vehicle_information_module_default()).vehicleInfo,
                            fontSizeFixed: adminFeeFlag ? "s" : "m",
                            children: `${vehicleName} ${derivative}`
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (vehicle_information_module_default()).price,
                        fontSizeFixed: adminFeeFlag ? "s" : "m",
                        children: (0,src/* currencyValueFormatter */.DY)(priceInPence, true)
                    })
                ]
            }),
            adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((vehicle_information_module_default()).priceRow),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        id: "description-of-active-order-vehicle",
                        className: (vehicle_information_module_default()).vehicleInfo,
                        fontSizeFixed: "s",
                        children: "Admin fee"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (vehicle_information_module_default()).price,
                        fontSizeFixed: "s",
                        children: (0,src/* currencyValueFormatter */.DY)(adminFeeValueInPence, true)
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* LinkToProductDetail */.si, {
                basicVehicleInfo: basicVehicleInfo,
                className: (vehicle_information_module_default()).vehicleImageLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_image, {
                    sendDigitalDataEvent: sendDigitalDataEvent,
                    src: imageUrl,
                    alt: vehicleName,
                    className: classnames_default()((vehicle_information_module_default()).vehicleImage, {
                        [(vehicle_information_module_default()).vehicleImageWithAdminFee]: adminFeeFlag
                    }),
                    lazy: true,
                    clickable: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((vehicle_information_module_default()).basketBannerVehicleInfoContainer, {
                    [(vehicle_information_module_default()).basketBannerVehicleInfoContainerWithAdminFee]: adminFeeFlag
                }),
                children: [
                    adminFeeFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                id: "active-order-banner",
                                className: (vehicle_information_module_default()).bannerHeading,
                                children: "Your order"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((vehicle_information_module_default()).priceRow),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (vehicle_information_module_default()).basketBannerVehicleInfo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* LinkToProductDetail */.si, {
                                            basicVehicleInfo: basicVehicleInfo,
                                            className: classnames_default()((vehicle_information_module_default()).underlineText, (vehicle_information_module_default()).vehicleLink),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    id: "description-of-active-order-vehicle",
                                                    fontSizeFixed: "m",
                                                    children: vehicleName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontSizeFixed: "s",
                                                    children: `${derivative}`
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        className: (vehicle_information_module_default()).price,
                                        fontSizeFixed: "m",
                                        children: (0,src/* currencyValueFormatter */.DY)(priceInPence, true)
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (vehicle_information_module_default()).basketBannerVehicleInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        id: "active-order-banner",
                                        className: (vehicle_information_module_default()).bannerHeading,
                                        children: "Your order"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* LinkToProductDetail */.si, {
                                        basicVehicleInfo: basicVehicleInfo,
                                        className: classnames_default()((vehicle_information_module_default()).underlineText, (vehicle_information_module_default()).vehicleLink),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                id: "description-of-active-order-vehicle",
                                                fontSizeFixed: "l",
                                                children: vehicleName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontSizeFixed: "m",
                                                children: `${derivative}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                className: (vehicle_information_module_default()).price,
                                fontSizeFixed: "l",
                                children: (0,src/* currencyValueFormatter */.DY)(priceInPence, true)
                            })
                        ]
                    }),
                    adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((vehicle_information_module_default()).priceRow, (vehicle_information_module_default()).priceRowWithAdminFee),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSizeFixed: "s",
                                children: "Admin fee"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSizeFixed: "s",
                                children: (0,src/* currencyValueFormatter */.DY)(adminFeeValueInPence, true)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var vehicle_information = (VehicleInformation);

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/banner/banner.module.css
var banner_module = __webpack_require__(15112);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/lib/banner/banner.tsx










function Banner({ activeOrder , locale ={
    orderActive: {
        buttonText: "Return to checkout",
        cancelText: "I don't want this car"
    }
} , extendOrderExpiry , refreshActiveOrder , sendDigitalDataEvent , reportDatadogError , accessToken , adminFeeFlag =false , adminFeeValueInPence , cancelOrder  }) {
    var ref;
    const basketBannerState = getBasketBannerClosed();
    const [returnToCheckoutButtonLoading, setReturnToCheckoutButtonLoading] = (0,react.useState)(false);
    const [hideBasketBanner, setHideBasketBanner] = (0,react.useState)(basketBannerState);
    const { deepPurple  } = index_esm/* designTokens.customProperties.ds.color */.Wp.customProperties.ds.color;
    const dontWantCarExperiment = ((ref = useAdobeTarget("I_DONT_WANT_THIS_CAR")) === null || ref === void 0 ? void 0 : ref.ExperienceId) === "1";
    const { vw  } = (0,src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 768;
    (0,react.useEffect)(()=>{
        checkOrderHasExpired(activeOrder, ()=>{
            setHideBasketBanner(true);
            setBasketBannerClosed(true);
        });
    }, []);
    const extendExpiry = async ()=>{
        if (activeOrder === undefined || accessToken === undefined) return;
        setReturnToCheckoutButtonLoading(true);
        try {
            await extendOrderExpiry(activeOrder.id, accessToken);
        } catch (error) {
            reportDatadogError(new Error("Extend Expiry Error"), error);
        }
        setReturnToCheckoutButtonLoading(false);
    };
    const handleCloseBanner = (0,react.useCallback)(()=>{
        setHideBasketBanner(true);
        setBasketBannerClosed(true);
        sendDigitalDataEvent(basketBannerCloseBannerEvent());
    }, []);
    const handleCarNoLongerWanted = ()=>{
        if (activeOrder === undefined || accessToken === undefined) return;
        setHideBasketBanner(true);
        setBasketBannerClosed(true);
        sendDigitalDataEvent(basketBannerNoLongerWantVehicleClickEvent());
        const reason = "customer no longer wants car";
        cancelOrder && cancelOrder(activeOrder.id, reason, accessToken);
    };
    const handleReturnToCheckout = (0,react.useCallback)(async ()=>{
        if (activeOrder === undefined) return;
        await extendExpiry();
        const lastVisitedStage = (0,src/* getLastCheckoutStage */.nk)(activeOrder);
        await refreshActiveOrder();
        if (lastVisitedStage) {
            (0,src/* returnToCheckoutStage */.jP)(lastVisitedStage.stage, activeOrder);
            sendDigitalDataEvent(basketBannerReturnToCheckoutEvent());
        }
    }, [
        activeOrder
    ]);
    return activeOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((banner_module_default()).banner, {
            [(banner_module_default()).hideBasketBanner]: hideBasketBanner
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            role: "dialog",
            "aria-labelledby": "active-order-banner",
            "aria-describedby": "description-of-active-order-vehicle",
            "aria-hidden": hideBasketBanner,
            className: (banner_module_default()).bannerSection,
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        "data-testid": "mobileYourOrder",
                        className: (banner_module_default()).bannerHeading,
                        id: "active-order-banner",
                        children: "Your order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Close Active Order Banner",
                        "data-testid": "closeBanner",
                        className: (banner_module_default()).closeIconButton,
                        onClick: ()=>handleCloseBanner(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                            name: "cross",
                            height: 12,
                            width: 12,
                            stroke: deepPurple,
                            strokeWidth: "2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information, {
                        sendDigitalDataEvent: sendDigitalDataEvent,
                        vehicle: activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle,
                        adminFeeFlag: adminFeeFlag,
                        adminFeeValueInPence: adminFeeValueInPence
                    }),
                    dontWantCarExperiment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (banner_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                classNames: {
                                    button: (banner_module_default()).returnToCheckoutCta
                                },
                                isLoading: returnToCheckoutButtonLoading,
                                disabled: false,
                                onClick: ()=>handleReturnToCheckout(),
                                size: "large",
                                children: locale.orderActive.buttonText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                                classNames: {
                                    button: (banner_module_default()).returnToCheckoutCta
                                },
                                isLoading: returnToCheckoutButtonLoading,
                                disabled: false,
                                onClick: ()=>handleCarNoLongerWanted(),
                                size: "large",
                                children: locale.orderActive.cancelText
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                        classNames: {
                            button: (banner_module_default()).returnToCheckoutCta
                        },
                        isLoading: returnToCheckoutButtonLoading,
                        disabled: false,
                        onClick: ()=>handleReturnToCheckout(),
                        size: "large",
                        children: locale.orderActive.buttonText
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (banner_module_default()).basketBannerWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Close Active Order Banner",
                        "data-testid": "closeBanner",
                        className: (banner_module_default()).closeIconButton,
                        onClick: ()=>handleCloseBanner(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                            name: "cross",
                            height: 12,
                            width: 12,
                            stroke: deepPurple,
                            strokeWidth: "2"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information, {
                        sendDigitalDataEvent: sendDigitalDataEvent,
                        vehicle: activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle,
                        adminFeeFlag: adminFeeFlag,
                        adminFeeValueInPence: adminFeeValueInPence
                    }),
                    dontWantCarExperiment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (banner_module_default()).buttonWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                classNames: {
                                    button: (banner_module_default()).returnToCheckoutCta
                                },
                                isLoading: returnToCheckoutButtonLoading,
                                disabled: false,
                                onClick: ()=>handleReturnToCheckout(),
                                size: "large",
                                children: locale.orderActive.buttonText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                                classNames: {
                                    button: (banner_module_default()).returnToCheckoutCta
                                },
                                isLoading: returnToCheckoutButtonLoading,
                                disabled: false,
                                onClick: ()=>handleCarNoLongerWanted(),
                                size: "large",
                                children: locale.orderActive.cancelText
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                        classNames: {
                            button: (banner_module_default()).returnToCheckoutCta
                        },
                        isLoading: returnToCheckoutButtonLoading,
                        disabled: false,
                        onClick: ()=>handleReturnToCheckout(),
                        size: "large",
                        children: locale.orderActive.buttonText
                    })
                ]
            })
        })
    }) : null;
}
/* harmony default export */ var banner = ((/* unused pure expression or super */ null && (Banner)));

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-banner/src/index.ts



// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/return-to-checkout-modal.module.css
var return_to_checkout_modal_module = __webpack_require__(51282);
var return_to_checkout_modal_module_default = /*#__PURE__*/__webpack_require__.n(return_to_checkout_modal_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/return-to-checkout-modal.types.ts
var return_to_checkout_modal_types_EventActions;
(function(EventActions) {
    EventActions["click"] = "click";
    EventActions["cinchcareAddedToOrder"] = "cinchCare added to order";
    EventActions["modalOpened"] = "modal-opened";
    EventActions["modalClosed"] = "modal-closed";
    EventActions["returnToCheckout"] = "return-to-checkout";
    EventActions["orderCompleteClick"] = "order complete click";
    EventActions["orderDeclinedClick"] = "order declined click";
    EventActions["orderTrackingViewed"] = "order tracking viewed";
    EventActions["deadClick"] = "dead click";
    EventActions["iDoNotWantThisCar"] = "i-do-not-want-this-car";
})(return_to_checkout_modal_types_EventActions || (return_to_checkout_modal_types_EventActions = {}));
var return_to_checkout_modal_types_EventCategories;
(function(EventCategories) {
    EventCategories["button"] = "button";
    EventCategories["cinchcare"] = "cinchcare";
    EventCategories["favourites"] = "Favourites";
    EventCategories["orders"] = "Orders";
    EventCategories["orderTracking"] = "Order Tracking";
    EventCategories["profileDetails"] = "Profile Details";
    EventCategories["myProfile"] = "My profile";
    EventCategories["image"] = "image";
})(return_to_checkout_modal_types_EventCategories || (return_to_checkout_modal_types_EventCategories = {}));
var return_to_checkout_modal_types_EventNames;
(function(EventNames) {
    EventNames["click"] = "click";
    EventNames["error"] = "error";
    EventNames["identify"] = "identify";
    EventNames["load"] = "load";
})(return_to_checkout_modal_types_EventNames || (return_to_checkout_modal_types_EventNames = {}));
var ModalState;
(function(ModalState) {
    ModalState["active"] = "active";
    ModalState["expiringSoon"] = "expiring";
    ModalState["expiredStillAvailable"] = "expired-unreserved";
    ModalState["expiredUnavailable"] = "expired-reserved";
})(ModalState || (ModalState = {}));

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/holding-image/holding-image.module.css
var holding_image_holding_image_module = __webpack_require__(24557);
var holding_image_holding_image_module_default = /*#__PURE__*/__webpack_require__.n(holding_image_holding_image_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/holding-image/holding-image.component.tsx




const holding_image_component_HoldingImage = ({ className ="" , text =""  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((holding_image_holding_image_module_default()).holdingImage, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                className: (holding_image_holding_image_module_default()).icon,
                fill: "currentColor",
                name: "vehicle-side",
                size: 64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                type: index_esm/* TextStyles.menuTitle */.k7.menuTitle,
                children: text
            })
        ]
    });
/* harmony default export */ var holding_image_component = (holding_image_component_HoldingImage);

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/lazy-image/lazy-image.module.css
var lazy_image_module = __webpack_require__(60942);
var lazy_image_module_default = /*#__PURE__*/__webpack_require__.n(lazy_image_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/lazy-image/lazy-image.component.tsx





const LazyImage = ({ className ="" , onError , ...props })=>{
    let imgRef;
    const [isLoaded, updateLoadedState] = (0,react.useState)(false);
    const [isVisible, setVisibility] = (0,react.useState)(false);
    const handleIntersection = (isIntersecting)=>{
        if (isIntersecting && !!imgRef) {
            (0,src/* removeIntersectionObserver */.vn)(imgRef);
            setVisibility(true);
        }
    };
    const addObserver = ()=>{
        if (imgRef) {
            (0,src/* addIntersectionObserver */.kc)(handleIntersection, imgRef);
        }
    };
    (0,react.useEffect)(()=>{
        if (!imgRef) {
            return;
        }
        addObserver();
        return ()=>{
            if (imgRef) {
                (0,src/* removeIntersectionObserver */.vn)(imgRef);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.src
    ]);
    const handleRef = (ref)=>{
        if (!ref && imgRef) {
            (0,src/* removeIntersectionObserver */.vn)(imgRef);
        }
        imgRef = ref;
        addObserver();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visibleProp = {};
    if (isVisible) {
        visibleProp.src = props.src;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (lazy_image_module_default()).lazyWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            className: classnames_default()((lazy_image_module_default()).lazy, className, {
                [(lazy_image_module_default()).lazyLoaded]: isLoaded
            }),
            ref: handleRef,
            alt: props.alt || "",
            onError: onError,
            onLoad: ()=>updateLoadedState(true),
            ...visibleProp
        })
    });
};
/* harmony default export */ var lazy_image_component = (LazyImage);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/image/image.component.tsx




const image_component_Image = ({ i18n ={
    noImage: "Image Unavailable"
} , isLazy , className ="" , onError , ...props })=>{
    const [hasError, updateErrorState] = (0,react.useState)(false);
    const updateError = ()=>{
        updateErrorState(true);
    };
    return !props.src || hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(holding_image_component, {
        className: className,
        text: i18n.noImage
    }) : isLazy ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_image_component, {
        ...props,
        className: className,
        onError: onError || updateError
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: className,
        alt: props.alt || undefined,
        role: !props.alt ? "presentation" : undefined,
        src: props.src || "",
        onError: onError || updateError,
        width: props.width || undefined,
        height: props.height || undefined
    });
};
/* harmony default export */ var image_component = (image_component_Image);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/types/analytics.ts
var analytics_TrackingEventTypes;
(function(TrackingEventTypes) {
    TrackingEventTypes["TRACK"] = "trackQueue";
    TrackingEventTypes["IDENTIFY"] = "identifyQueue";
    TrackingEventTypes["PAGE"] = "pageQueue";
    TrackingEventTypes["ADOBE"] = "adobeQueue";
    TrackingEventTypes["HOTJAR_EVENT"] = "hotJarEventQueue";
    TrackingEventTypes["HOTJAR_TAG"] = "hotJarTagQueue";
    TrackingEventTypes["HOTJAR_TRIGGER"] = "hotJarTriggerQueue";
})(analytics_TrackingEventTypes || (analytics_TrackingEventTypes = {}));

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/return-to-checkout-modal.tracking.ts


const useReturnToCheckoutModalTracking = (trackEvent)=>{
    const resumeCheckoutOpenedModal = (section)=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.button,
                action: return_to_checkout_modal_types_EventActions.modalOpened,
                label: "checkout-resume",
                section
            }
        };
        trackEvent({
            eventName: "Return to Checkout - Modal Opened",
            data: {
                ...evt,
                modalState: section
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    const resumeCheckoutClosedModal = (section)=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.button,
                action: return_to_checkout_modal_types_EventActions.modalClosed,
                label: "checkout-resume",
                section
            }
        };
        trackEvent({
            eventName: "Return to Checkout - Modal Closed",
            data: {
                ...evt,
                modalState: section
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    const resumeCheckoutReturnedToCheckout = (section)=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.button,
                action: return_to_checkout_modal_types_EventActions.returnToCheckout,
                label: "checkout-resume",
                section
            }
        };
        trackEvent({
            eventName: "Return to Checkout - User Clicked Modal CTA",
            data: {
                ...evt,
                modalState: section
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    const clickModalVehicleImage = ()=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.image,
                action: return_to_checkout_modal_types_EventActions.deadClick,
                label: "checkout-return-car-image"
            }
        };
        trackEvent({
            eventName: "Return to Checkout - User Clicked Vehicle Image",
            data: {
                ...evt
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    const iDoNotWantThisCarEvent = ()=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.button,
                action: return_to_checkout_modal_types_EventActions.iDoNotWantThisCar,
                label: "checkout-resume-modal"
            }
        };
        trackEvent({
            eventName: "Return to Checkout modal - User Clicked I do not want this car",
            data: {
                ...evt
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    const returnToCheckoutModalEvent = ()=>{
        const evt = {
            event: {
                name: return_to_checkout_modal_types_EventNames.click,
                category: return_to_checkout_modal_types_EventCategories.button,
                action: return_to_checkout_modal_types_EventActions.returnToCheckout,
                label: "checkout-resume-modal"
            }
        };
        trackEvent({
            eventName: "Return to Checkout modal - User Clicked Return to Checkout",
            data: {
                ...evt
            },
            type: analytics_TrackingEventTypes.ADOBE
        });
    };
    return {
        resumeCheckoutOpenedModal,
        resumeCheckoutClosedModal,
        resumeCheckoutReturnedToCheckout,
        clickModalVehicleImage,
        returnToCheckoutModalEvent,
        iDoNotWantThisCarEvent
    };
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/vehicle-information/vehicle-information.component.tsx







const vehicle_information_component_VehicleInformation = ({ vehicle , hidePrice , grayscale =false , adminFeeFlag , adminFeeValueInPence , trackEvent , noOpTracking  })=>{
    const { clickModalVehicleImage  } = useReturnToCheckoutModalTracking(trackEvent ?? noOpTracking);
    const { imageUrl , make , model , derivative , priceInPence , id  } = vehicle;
    const vehicleName = `${make} ${model}`;
    const basicVehicleInfo = {
        make: make,
        model: model,
        id
    };
    const vehicleImageStyles = grayscale ? "vehicleImageTransparent" : "vehicleImage";
    const vehicleInfoContainerStyles = grayscale ? (return_to_checkout_modal_module_default()).vehicleInfoContainerTransparent : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: vehicleInfoContainerStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* LinkToProductDetail */.si, {
                basicVehicleInfo: basicVehicleInfo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_component, {
                    className: (return_to_checkout_modal_module_default())[vehicleImageStyles],
                    src: imageUrl,
                    alt: vehicleName,
                    isLazy: true,
                    "aria-hidden": true,
                    onClick: clickModalVehicleImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(src/* LinkToProductDetail */.si, {
                basicVehicleInfo: basicVehicleInfo,
                className: (return_to_checkout_modal_module_default()).underlineText,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSizeFixed: "m",
                        fontWeight: "semibold",
                        children: vehicleName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSizeFixed: "xs",
                        fontWeight: "light",
                        children: `${derivative}`
                    })
                ]
            }),
            !hidePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (return_to_checkout_modal_module_default()).priceWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (return_to_checkout_modal_module_default()).price,
                        fontSize: "m",
                        fontWeight: "semibold",
                        children: (0,src/* currencyValueFormatter */.DY)(priceInPence, true)
                    }),
                    adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (return_to_checkout_modal_module_default()).adminFee,
                        fontSize: "s",
                        children: i18n.adminFee.replace("{adminFeeValue}", (0,src/* currencyValueFormatter */.DY)(adminFeeValueInPence, true))
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card-content/expired-still-available/expired-still-available-card.component.tsx






const ReturnToCheckoutExpiredStillAvailable = ({ i18n , vehicle , onButtonClick , title , isButtonLoading , adminFeeFlag , adminFeeValueInPence , trackEvent , noOpTracking , onModalOpen  })=>{
    (0,react.useEffect)(()=>{
        onModalOpen(ModalState.expiredStillAvailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (return_to_checkout_modal_module_default()).contentWrapper,
        children: [
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "light",
                fontSize: "s",
                children: i18n.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information_component_VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                isLoading: isButtonLoading,
                classNames: {
                    button: (return_to_checkout_modal_module_default()).button
                },
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card-content/expired-unavailable/expired-unavailable-card.component.tsx






const ReturnToCheckoutExpiredUnavailable = ({ i18n , vehicle , onButtonClick , title , isButtonLoading , adminFeeFlag , adminFeeValueInPence , noOpTracking , trackEvent , onModalOpen  })=>{
    (0,react.useEffect)(()=>{
        onModalOpen(ModalState.expiredUnavailable);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (return_to_checkout_modal_module_default()).contentWrapper,
        children: [
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information_component_VehicleInformation, {
                vehicle: vehicle,
                hidePrice: true,
                grayscale: true,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (return_to_checkout_modal_module_default()).expiredUnavailableText,
                fontWeight: "light",
                fontSize: "s",
                children: i18n.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card-content/expiring-soon/expiring-soon-card.component.tsx








const formatTime = (timeInSeconds)=>{
    if (timeInSeconds < 60) {
        return `${timeInSeconds} seconds`;
    }
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${minutes}:${formattedSeconds} minutes`;
};
const ReturnToCheckoutExpiringSoon = ({ vehicle , onButtonClick , onSecondaryButtonClick , timeRemainingInSeconds , title , isButtonLoading , isSecondaryButtonLoading , i18n , adminFeeFlag , adminFeeValueInPence , trackEvent , noOpTracking , onModalOpen  })=>{
    (0,react.useEffect)(()=>{
        onModalOpen(ModalState.expiringSoon);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (return_to_checkout_modal_module_default()).contentWrapper,
        children: [
            title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: classnames_default()((return_to_checkout_modal_module_default()).cardText, (return_to_checkout_modal_module_default()).remainingTimeText),
                fontWeight: "light",
                fontSize: "s",
                children: (0,src/* interpolateI18n */.uR)(i18n.text, {
                    timeRemaining: formatTime(timeRemainingInSeconds)
                }, {
                    bold: (t)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontWeight: "semibold",
                            fontSize: "s",
                            className: (return_to_checkout_modal_module_default()).subheader,
                            children: t
                        }, t)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information_component_VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                trackEvent: trackEvent,
                noOpTracking: noOpTracking
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                classNames: {
                    button: (return_to_checkout_modal_module_default()).button
                },
                isLoading: isSecondaryButtonLoading,
                disabled: isSecondaryButtonLoading,
                onClick: onSecondaryButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.secondaryButtonText
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/loading-spinner/loading-spinner.module.css
var loading_spinner_module = __webpack_require__(82917);
var loading_spinner_module_default = /*#__PURE__*/__webpack_require__.n(loading_spinner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/loading-spinner/loading-spinner.tsx





const { color: palette  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const DEFAULT_SIZE = 32;
const LoadingSpinner = ({ backgroundCircleColor =palette.gainsboro , foregroundCircleColor =palette.deepPurple , size =DEFAULT_SIZE , className  })=>{
    const classNames = classnames_default()((loading_spinner_module_default()).loadingSpinner, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: classNames,
        xmlns: "https://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        "data-testid": "LoadingSpinner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                r: "11",
                stroke: backgroundCircleColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: (loading_spinner_module_default()).foregroundCircle,
                d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
                stroke: foregroundCircleColor
            })
        ]
    });
};
/* harmony default export */ var loading_spinner = (LoadingSpinner);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card-content/loading-card/loading-card.component.tsx




const LoadingCard = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (return_to_checkout_modal_module_default()).loadingDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner, {
            size: 64
        })
    });

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card-content/order-active/order-active-card.component.tsx






const ReturnToCheckoutOrderActive = ({ vehicle , onButtonClick , onSecondaryButtonClick , isButtonLoading , isSecondaryButtonLoading , i18n , adminFeeFlag , adminFeeValueInPence , trackEvent , noOpTracking , onModalOpen  })=>{
    (0,react.useEffect)(()=>{
        onModalOpen(ModalState.active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (return_to_checkout_modal_module_default()).contentWrapper,
        children: [
            i18n.title,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_information_component_VehicleInformation, {
                vehicle: vehicle,
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                isLoading: isButtonLoading,
                onClick: onButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.buttonText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                classNames: {
                    button: (return_to_checkout_modal_module_default()).button
                },
                isLoading: isSecondaryButtonLoading,
                disabled: isSecondaryButtonLoading,
                onClick: onSecondaryButtonClick,
                size: "large",
                isFullWidth: true,
                children: i18n.secondaryButtonText
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(31191);
;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

// EXTERNAL MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js + 2 modules
var useMergeRef = __webpack_require__(27553);
// EXTERNAL MODULE: ../../../node_modules/use-sidecar/dist/es2015/medium.js
var medium = __webpack_require__(42442);
;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = (0,medium/* createSidecarMedium */._)();

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0,tslib_es6.__rest)(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
    var SideCar = sideCar;
    var containerRef = (0,useMergeRef/* useMergeRefs */.q)([ref, parentRef]);
    var containerProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode: gapMode })),
        forwardProps ? (react.cloneElement(react.Children.only(children), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, (0,tslib_es6.__assign)({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(20011);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/use-callback-ref/dist/es2015/useMergeRef.js



var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react.useLayoutEffect : react.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(defaultValue || null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.propTypes =  false ? 0 : {};
/* harmony default export */ var FocusGuard = ((/* unused pure expression or super */ null && (InFocusGuard)));
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = (0,medium/* createMedium */.s)({}, function (_ref) {
  var target = _ref.target,
    currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = (0,medium/* createMedium */.s)();
var mediumEffect = (0,medium/* createMedium */.s)();
var mediumSidecar = (0,medium/* createSidecarMedium */._)({
  async: true,
  ssr: typeof document !== 'undefined'
});
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/scope.js

var focusScope = /*#__PURE__*/(0,react.createContext)(undefined);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/react.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _React$useState = react.useState(),
    realObserved = _React$useState[0],
    setObserved = _React$useState[1];
  var observed = react.useRef();
  var isActive = react.useRef(false);
  var originalFocusedElement = react.useRef(null);
  var _React$useState2 = react.useState({}),
    update = _React$useState2[1];
  var children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$noFocusGuards = props.noFocusGuards,
    noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards,
    _props$persistentFocu = props.persistentFocus,
    persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu,
    _props$crossFrame = props.crossFrame,
    crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    allowTextSelection = props.allowTextSelection,
    group = props.group,
    className = props.className,
    whiteList = props.whiteList,
    hasPositiveIndices = props.hasPositiveIndices,
    _props$shards = props.shards,
    shards = _props$shards === void 0 ? emptyArray : _props$shards,
    _props$as = props.as,
    Container = _props$as === void 0 ? 'div' : _props$as,
    _props$lockProps = props.lockProps,
    containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
    SideCar = props.sideCar,
    _props$returnFocus = props.returnFocus,
    shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus,
    focusOptions = props.focusOptions,
    onActivationCallback = props.onActivation,
    onDeactivationCallback = props.onDeactivation;
  var _React$useState3 = react.useState({}),
    id = _React$useState3[0];
  var onActivation = react.useCallback(function (_ref) {
    var captureFocusRestore = _ref.captureFocusRestore;
    if (!originalFocusedElement.current) {
      var _document;
      var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
      originalFocusedElement.current = activeElement;
      if (activeElement !== document.body) {
        originalFocusedElement.current = captureFocusRestore(activeElement);
      }
    }
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
    update();
  }, [onActivationCallback]);
  var onDeactivation = react.useCallback(function () {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
    update();
  }, [onDeactivationCallback]);
  var returnFocus = react.useCallback(function (allowDefer) {
    var focusRestore = originalFocusedElement.current;
    if (focusRestore) {
      var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus = react.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium;
  var setObserveNode = react.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (false) {}
  var lockProps = (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  var focusScopeValue = react.useMemo(function () {
    return {
      observed: observed,
      shards: shards,
      enabled: !disabled,
      active: isActive.current
    };
  }, [disabled, isActive.current, shards, realObserved]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), /*#__PURE__*/react.createElement(focusScope.Provider, {
    value: focusScopeValue
  }, children)), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
/* harmony default export */ var Lock = (FocusLock);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/UI.js








/* harmony default export */ var UI = (Lock);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/medium.js

var medium_effectCar = (0,medium/* createSidecarMedium */._)();
var focusHiddenMarker = 'data-focus-on-hidden';

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/UI.js





var PREVENT_SCROLL = { preventScroll: true };
var FocusOn = react.forwardRef(function (props, parentRef) {
    var _a = react.useState(false), lockProps = _a[0], setLockProps = _a[1];
    var children = props.children, autoFocus = props.autoFocus, shards = props.shards, crossFrame = props.crossFrame, _b = props.enabled, enabled = _b === void 0 ? true : _b, _c = props.scrollLock, scrollLock = _c === void 0 ? true : _c, _d = props.focusLock, focusLock = _d === void 0 ? true : _d, _e = props.returnFocus, returnFocus = _e === void 0 ? true : _e, inert = props.inert, allowPinchZoom = props.allowPinchZoom, sideCar = props.sideCar, className = props.className, shouldIgnore = props.shouldIgnore, preventScrollOnFocus = props.preventScrollOnFocus, style = props.style, as = props.as, gapMode = props.gapMode, rest = (0,tslib_es6.__rest)(props, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]);
    var SideCar = sideCar;
    var onActivation = lockProps.onActivation, onDeactivation = lockProps.onDeactivation, restProps = (0,tslib_es6.__rest)(lockProps, ["onActivation", "onDeactivation"]);
    var appliedLockProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, restProps), { as: as,
        style: style,
        sideCar: sideCar,
        shards: shards,
        allowPinchZoom: allowPinchZoom,
        gapMode: gapMode,
        inert: inert, enabled: enabled && scrollLock });
    return (react.createElement(react.Fragment, null,
        react.createElement(UI, { ref: parentRef, sideCar: sideCar, disabled: !(lockProps && enabled && focusLock), returnFocus: returnFocus, autoFocus: autoFocus, shards: shards, crossFrame: crossFrame, onActivation: onActivation, onDeactivation: onDeactivation, className: className, whiteList: shouldIgnore, lockProps: appliedLockProps, focusOptions: preventScrollOnFocus ? PREVENT_SCROLL : undefined, as: RemoveScroll }, children),
        enabled && (react.createElement(SideCar, (0,tslib_es6.__assign)({}, rest, { sideCar: medium_effectCar, setLockProps: setLockProps, shards: shards })))));
});


;// CONCATENATED MODULE: ../../../node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

// EXTERNAL MODULE: ../../../node_modules/react-clientside-effect/lib/index.es.js + 1 modules
var index_es = __webpack_require__(58420);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isInert = function (node) { return node.hasAttribute('inert'); };
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && !isInert(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) {
            return 1;
        }
        if (!bTab) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var getTabIndex = function (node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) {
            return 0;
        }
    }
    return node.tabIndex;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) {
        var tabIndex = getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : tabIndex,
        };
    })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function (target, focusOptions) {
    if (!target) {
        // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
        return;
    }
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, node) {
    return nodes.indexOf(correctNode(node, nodes));
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes - used to control "return focus"
 * @param innerTabbables - used to control "autofocus"
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) {
            return lastNodeInside;
        }
        return NEW_FOCUS;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) {
        // an edge case with no tabbable elements
        // return the last focusable one
        // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
        return lastNodeInside;
    }
    var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
    var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/focusSolver.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getFocusableNodes(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        return undefined;
    }
    var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function (_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = 
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) ||
            pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/moveFocusInside.js


var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = focusSolver(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/
        if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/focusables.js





/**
 * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
 * This is low-level API!
 * @returns list of focusable elements inside a given top(!) node.
 * @see {@link getFocusableNodes} providing a simpler API
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
    var innerElements = getFocusables(entries, false);
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/sibling.js



/**
 * for a given `element` in a given `scope` returns focusable siblings
 * @param element - base element
 * @param scope - common parent. Can be document, but better to narrow it down for performance reasons
 * @returns {prev,next} - references to a focusable element before and after
 * @returns undefined - if operation is not applicable
 */
var getRelativeFocusable = function (element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = asArray(scope);
    if (shards.every(function (shard) { return !contains(shard, element); })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables
        ? getTabbableNodes(shards, new Map())
        : getFocusableNodes(shards, new Map());
    var current = focusables.findIndex(function (_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) {
        // an edge case, when anchor element is not found
        return undefined;
    }
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1],
    };
};
var getBoundary = function (shards, useTabbables) {
    var set = useTabbables
        ? getTabbableNodes(asArray(shards), new Map())
        : getFocusableNodes(asArray(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1],
    };
};
var defaultOptions = function (options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true,
    }, options);
};
var moveFocus = function (fromElement, options, cb) {
    if (options === void 0) { options = {}; }
    var newOptions = defaultOptions(options);
    var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) {
        return;
    }
    var target = cb(solution, newOptions.cycle);
    if (target) {
        focusOn(target.node, newOptions.focusOptions);
    }
};
/**
 * focuses next element in the tab-order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusNextElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || (cycle && first);
    });
};
/**
 * focuses prev element in the tab order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusPrevElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || (cycle && last);
    });
};
var pickBoundary = function (scope, options, what) {
    var _a;
    var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) {
        focusOn(node.node, options.focusOptions);
    }
};
/**
 * focuses first element in the tab-order
 * @param {FocusNextOptions} options - focus options
 */
var focusFirstElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'first');
};
/**
 * focuses last element in the tab order
 * @param {FocusNextOptions} options - focus options
 */
var focusLastElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'last');
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/focus-lock/dist/es2015/return-focus.js

function weakRef(value) {
    if (!value)
        return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') {
        return function () { return value || null; };
    }
    var w = value ? new WeakRef(value) : null;
    return function () { return (w === null || w === void 0 ? void 0 : w.deref()) || null; };
}
var recordElementLocation = function (element) {
    if (!element) {
        return null;
    }
    var stack = [];
    var currentElement = element;
    while (currentElement && currentElement !== document.body) {
        stack.push({
            current: weakRef(currentElement),
            parent: weakRef(currentElement.parentElement),
            left: weakRef(currentElement.previousElementSibling),
            right: weakRef(currentElement.nextElementSibling),
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument,
    };
};
var restoreFocusTo = function (location) {
    var _a, _b, _c, _d, _e;
    if (!location) {
        return undefined;
    }
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = getTabbableNodes([parent_1], visibilityCache);
            var aim = 
            // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : 
            // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : 
            // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : 
            // or somebody to the left, something?
            left;
            while (aim) {
                for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
                        return focusable.node;
                    }
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) {
                // if parent contains a focusable - move there
                return focusables[0].node;
            }
        }
    }
    // nothing matched
    return undefined;
};
/**
 * Captures the current focused element to restore focus as close as possible in the future
 * Handles situations where the focused element is removed from the DOM or no longer focusable
 * moving focus to the closest focusable element
 * @param targetElement - element where focus should be restored
 * @returns a function returning a new element to focus
 */
var captureFocusRestore = function (targetElement) {
    var location = recordElementLocation(targetElement);
    return function () {
        return restoreFocusTo(location);
    };
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/Trap.js






var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist() {
  return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item = allNodes[i];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};
var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
      observed = _lastActiveTrap.observed,
      persistentFocus = _lastActiveTrap.persistentFocus,
      autoFocus = _lastActiveTrap.autoFocus,
      shards = _lastActiveTrap.shards,
      crossFrame = _lastActiveTrap.crossFrame,
      focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
              node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher() {
  return null;
};
var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};
FocusTrap.propTypes =  false ? 0 : {};
var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just';
  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};
var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
var focusLockAPI = {
  moveFocusInside: moveFocusInside,
  focusInside: focusInside,
  focusNextElement: focusNextElement,
  focusPrevElement: focusPrevElement,
  focusFirstElement: focusFirstElement,
  focusLastElement: focusLastElement,
  captureFocusRestore: captureFocusRestore
};
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation(focusLockAPI);
    }
    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb(focusLockAPI);
});
/* harmony default export */ var Trap = ((0,index_es/* default */.Z)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/node_modules/react-focus-lock/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(mediumSidecar, Trap));
;// CONCATENATED MODULE: ../../../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ../../../node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ../../../node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ../../../node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ../../../node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function () {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function () {
    react.useEffect(function () {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function () {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) {
                document.body.removeAttribute(lockAttribute);
            }
            else {
                document.body.setAttribute(lockAttribute, newCounter.toString());
            }
        };
    }, []);
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    if (!(node instanceof Element)) {
        return false;
    }
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) {
            target = target.host;
        }
        else {
            target = target.parentNode;
        }
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive &&
        ((noOverscroll && Math.abs(availableScroll) < 1) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && Math.abs(availableScrollTop) < 1) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var SideEffect_extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(styleSingleton)[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0,tslib_es6.__spreadArray)([props.lockRef.current], (props.shards || []).map(SideEffect_extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(SideEffect_extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should, shadowParent: getOutermostShadowParent(target) };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: props.gapMode }) : null));
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while (node !== null) {
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

;// CONCATENATED MODULE: ../../../node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var es2015_sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ../../../node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute(controlAttribute, 'true');
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/InteractivityDisabler.js



var InteractivityDisabler_Style = styleSingleton();
var InteractivityDisabler_styles = "\n [" + focusHiddenMarker + "] {\n   pointer-events: none !important;\n }\n";
var InteractivityDisabler = function () { return react.createElement(InteractivityDisabler_Style, { styles: InteractivityDisabler_styles }); };

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/Effect.js






var Effect_extractRef = function (ref) {
    return 'current' in ref ? ref.current : ref;
};
function Effect(_a) {
    var setLockProps = _a.setLockProps, onEscapeKey = _a.onEscapeKey, onClickOutside = _a.onClickOutside, shards = _a.shards, onActivation = _a.onActivation, onDeactivation = _a.onDeactivation, noIsolation = _a.noIsolation;
    var _b = (0,react.useState)(undefined), activeNode = _b[0], setActiveNode = _b[1];
    var lastEventTarget = (0,react.useRef)(null);
    var mouseTouches = (0,react.useRef)(0);
    react.useEffect(function () {
        var onKeyDown = function (event) {
            if (!event.defaultPrevented) {
                if ((event.code === 'Escape' ||
                    event.key === 'Escape' ||
                    event.keyCode === 27) &&
                    onEscapeKey) {
                    onEscapeKey(event);
                }
            }
        };
        var onMouseDown = function (event) {
            if (event.defaultPrevented ||
                event.target === lastEventTarget.current ||
                (event instanceof MouseEvent && event.button !== 0)) {
                return;
            }
            if (shards &&
                shards
                    .map(Effect_extractRef)
                    .some(function (node) {
                    return (node && node.contains(event.target)) ||
                        node === event.target;
                })) {
                return;
            }
            if (onClickOutside) {
                onClickOutside(event);
            }
        };
        var onTouchStart = function (event) {
            onMouseDown(event);
            mouseTouches.current = event.touches.length;
        };
        var onTouchEnd = function (event) {
            mouseTouches.current = event.touches.length;
        };
        if (activeNode) {
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('mousedown', onMouseDown);
            document.addEventListener('touchstart', onTouchStart);
            document.addEventListener('touchend', onTouchEnd);
            return function () {
                document.removeEventListener('keydown', onKeyDown);
                document.removeEventListener('mousedown', onMouseDown);
                document.removeEventListener('touchstart', onTouchStart);
                document.removeEventListener('touchend', onTouchEnd);
            };
        }
    }, [activeNode, onClickOutside, onEscapeKey]);
    (0,react.useEffect)(function () {
        if (activeNode) {
            if (onActivation) {
                onActivation(activeNode);
            }
            return function () {
                if (onDeactivation) {
                    onDeactivation();
                }
            };
        }
    }, [!!activeNode]);
    (0,react.useEffect)(function () {
        var _undo = function () { return null; };
        var unmounted = false;
        var onNodeActivation = function (node) {
            if (!noIsolation) {
                _undo = hideOthers((0,tslib_es6.__spreadArrays)([node], (shards || []).map(Effect_extractRef)), document.body, focusHiddenMarker);
            }
            setActiveNode(function () { return node; });
        };
        var onNodeDeactivation = function () {
            _undo();
            if (!unmounted) {
                setActiveNode(null);
            }
        };
        setLockProps({
            onMouseDown: function (e) {
                lastEventTarget.current = e.target;
            },
            onTouchStart: function (e) {
                lastEventTarget.current = e.target;
            },
            onActivation: onNodeActivation,
            onDeactivation: onNodeDeactivation
        });
        return function () {
            unmounted = true;
            setLockProps(false);
        };
    }, []);
    return react.createElement(InteractivityDisabler, null);
}

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/sidecar.js





/* harmony default export */ var dist_es2015_sidecar = (exportSidecar(medium_effectCar, Effect));

;// CONCATENATED MODULE: ../../../node_modules/react-focus-on/dist/es2015/Combination.js




var RequireSideCar = function (props) {
    return react.createElement(dist_es2015_sidecar, (0,tslib_es6.__assign)({}, props));
};
var Combination_FocusOn = react.forwardRef(function (props, ref) { return react.createElement(FocusOn, (0,tslib_es6.__assign)({}, props, { ref: ref, sideCar: RequireSideCar })); });

// EXTERNAL MODULE: ../../../node_modules/react-transition-group/esm/CSSTransition.js + 7 modules
var CSSTransition = __webpack_require__(30659);
// EXTERNAL MODULE: ../../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(12788);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/portal/portal.component.tsx


const defaultRootElemSelector = "#portal-root";
const Portal = (props)=>{
    const rootEl = props.rootElem || defaultRootElemSelector;
    const rootNode = typeof rootEl === "string" ? document.querySelector(rootEl) ? document.querySelector(rootEl) : document.body : rootEl;
    if (rootEl === document.body) {
        // eslint-disable-next-line no-console
        console.warn("Portal cannot find div:#portal-root in the document, using body instead");
    }
    const [container] = react.useState(()=>{
        const el = document.createElement("div");
        el.classList.add("portal-element");
        return el;
    });
    react.useEffect(()=>{
        rootNode.append(container);
        return ()=>{
            container.remove();
        };
    }, [
        container,
        rootNode
    ]);
    return !props.children ? null : /*#__PURE__*/ react_dom.createPortal(props.children, container);
};
/* harmony default export */ var portal_component = (Portal);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/image-components/cross.tsx

const CrossIcon = ({ className  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 32 32",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M18.121 15.664l7.933 7.933c1.414 1.414-.707 3.535-2.121 2.12L16 17.786l-7.933 7.933c-1.414 1.414-3.535-.707-2.121-2.121l7.933-7.933-7.666-7.666c-1.415-1.414.707-3.536 2.121-2.121L16 13.543l7.666-7.666c1.414-1.415 3.536.707 2.121 2.12l-7.666 7.667z"
        })
    });

// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card/card.module.css
var card_module = __webpack_require__(21829);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card/card.component.tsx





const Card = ({ children , title ="" , subtitle ="" , onClose , closeText , cardStyles , classNames , id , ...props })=>{
    const styles = cardStyles || card_module;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(styles.card, classNames === null || classNames === void 0 ? void 0 : classNames.card),
        ...props,
        "data-id": "card",
        id: id,
        children: [
            (title || onClose) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(styles.title, classNames === null || classNames === void 0 ? void 0 : classNames.titleContainer),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                        type: index_esm/* TextStyles.cardTitle */.k7.cardTitle,
                        element: "h5",
                        className: classNames === null || classNames === void 0 ? void 0 : classNames.title,
                        children: [
                            title,
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                className: styles.subtitle,
                                fontWeight: "light",
                                element: "span",
                                children: subtitle
                            })
                        ]
                    }),
                    onClose && !closeText && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "Close",
                        onClick: onClose,
                        className: classnames_default()(styles.close, classNames === null || classNames === void 0 ? void 0 : classNames.closeIcon),
                        "data-testid": "card-close-button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, {})
                    }),
                    onClose && closeText && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                        onClick: onClose,
                        classNames: {
                            button: styles.textButton
                        },
                        type: "button",
                        "data-testid": "card-close-button",
                        children: closeText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(styles.body, classNames === null || classNames === void 0 ? void 0 : classNames.body),
                "data-id": "card-body",
                children: children
            })
        ]
    });
};
/* harmony default export */ var card_component = (Card);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/card/index.ts


// EXTERNAL MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/modal/modal.module.css
var modal_module = __webpack_require__(59711);
;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/modal/modal.component.tsx








const TIMEOUT = 250;
class modal_component_Modal extends react.Component {
    constructor(props){
        super(props);
        this.elementRef = /*#__PURE__*/ react.createRef();
    }
    state = {
        mounted: false
    };
    componentDidMount() {
        this.setState({
            mounted: true
        });
        document.addEventListener("keydown", this.onKeyDown, false);
        document.addEventListener("mousedown", this.onMouseDown, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeyDown, false);
        document.removeEventListener("mousedown", this.onMouseDown, false);
    }
    close = (event)=>{
        if (this.isInTheDOM()) {
            if (this.props.onClose) {
                this.props.onClose(event);
            }
            this.setState({
                mounted: false
            });
        }
    };
    isInTheDOM() {
        return document.contains(this.elementRef.current);
    }
    backdropId = "backdrop";
    onKeyDown = (event)=>{
        if (event.key === "Escape") {
            this.close(event);
        }
    };
    onMouseDown = (event)=>{
        if (event.target.id === this.backdropId) {
            this.close(event);
        }
    };
    render() {
        const { children , title , subtitle , cardStyles , classNames , closeText , closeable =true , closeIcon , testId  } = this.props;
        const classes = {
            ...modal_module,
            ...classNames
        };
        const backdropClassNames = {
            enter: classes.backdropEnter,
            enterActive: classes.backdropEnterActive,
            exit: classes.backdropExit,
            exitActive: classes.backdropExitActive
        };
        const modalClassNames = {
            enter: classes.modalEnter,
            enterActive: classes.modalEnterActive,
            exit: classes.modalExit,
            exitActive: classes.modalExitActive
        };
        const isDesktop =  true && window.matchMedia("(min-width: 1024px)").matches;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(portal_component, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                appear: true,
                classNames: backdropClassNames,
                unmountOnExit: true,
                timeout: TIMEOUT,
                in: this.state.mounted,
                children: (state)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        id: this.backdropId,
                        ref: this.elementRef,
                        role: "presentation",
                        className: classnames_default()(classes.backdrop, classes.backdropStyle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                            appear: true,
                            classNames: modalClassNames,
                            unmountOnExit: true,
                            timeout: TIMEOUT,
                            in: state === "entered",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Combination_FocusOn, {
                                enabled: !isDesktop,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    "data-testid": testId,
                                    className: classes.modal,
                                    role: "dialog",
                                    "aria-modal": "true",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_component, {
                                        title: title,
                                        subtitle: subtitle,
                                        cardStyles: cardStyles,
                                        classNames: {
                                            card: classNames === null || classNames === void 0 ? void 0 : classNames.cardContainer,
                                            body: classNames === null || classNames === void 0 ? void 0 : classNames.cardBody,
                                            title: classNames === null || classNames === void 0 ? void 0 : classNames.cardTitle,
                                            titleContainer: classNames === null || classNames === void 0 ? void 0 : classNames.cardTitleContainer,
                                            closeIcon: classNames === null || classNames === void 0 ? void 0 : classNames.cardCloseIcon
                                        },
                                        closeIcon: closeIcon,
                                        ...closeable ? {
                                            onClose: this.close,
                                            closeText
                                        } : {},
                                        children: children
                                    })
                                })
                            })
                        })
                    });
                }
            })
        });
    }
}
/* harmony default export */ var modal_component = (modal_component_Modal);

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/modal/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/image-components/time.tsx

const TimeIcon = ({ className  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.44 17.44",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M13.08 1.18a8.81 8.81 0 0 1 3.18 3.18 8.64 8.64 0 0 1 0 8.72 9 9 0 0 1-3.18 3.18 8.64 8.64 0 0 1-8.72 0 8.81 8.81 0 0 1-3.18-3.18A8.42 8.42 0 0 1 0 8.72a8.42 8.42 0 0 1 1.18-4.36 8.66 8.66 0 0 1 3.18-3.18A8.42 8.42 0 0 1 8.72 0a8.42 8.42 0 0 1 4.36 1.18zm-.85 13.62a7 7 0 0 0 2.57-2.57 7 7 0 0 0 0-7 7.09 7.09 0 0 0-2.57-2.56 6.73 6.73 0 0 0-3.51-1 6.76 6.76 0 0 0-3.52 1A7.06 7.06 0 0 0 2.64 5.2a6.76 6.76 0 0 0-1 3.52 6.73 6.73 0 0 0 1 3.51A7 7 0 0 0 5.2 14.8a7 7 0 0 0 7 0zm-1-2.64a.46.46 0 0 0 .27-.16l.63-.92a.41.41 0 0 0-.07-.59L9.7 8.79v-5a.41.41 0 0 0-.42-.42H8.16a.41.41 0 0 0-.3.12.42.42 0 0 0-.13.3v5.77a.42.42 0 0 0 .18.35l3 2.18a.35.35 0 0 0 .3.07z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/helpers/return-to-checkout-modal.helpers.tsx










const hasExpired = (expiresAt)=>expiresAt === undefined ? false : Date.now() > expiresAt;
const useReturnToCheckoutModal = ({ activeOrder , timeRemainingInSeconds , withinExpiryTimeWindow , checkIfVehicleIsReserved , accessToken , extendOrderExpiryDate , refreshActiveOrder , cancelOrder , onClose , isLoggedIn , handleShouldShowBasketIcon , lastVisitedCheckoutStage , trackEvent  })=>{
    const { resumeCheckoutClosedModal , resumeCheckoutReturnedToCheckout , iDoNotWantThisCarEvent , returnToCheckoutModalEvent , resumeCheckoutOpenedModal  } = useReturnToCheckoutModalTracking(trackEvent ?? noOpTracking);
    const vehicle = (0,react.useMemo)(()=>{
        return activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle;
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle
    ]);
    const orderId = (0,react.useMemo)(()=>{
        return activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id;
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id
    ]);
    const [currentOrder, setCurrentOrder] = (0,react.useState)(activeOrder);
    const [buttonLoading, setButtonLoading] = (0,react.useState)(false);
    const [secondaryButtonLoading, setSecondaryButtonLoading] = (0,react.useState)(false);
    const [vehicleIsReserved, setVehicleIsReserved] = (0,react.useState)(false);
    const [modalLoading, setModalLoading] = (0,react.useState)(false);
    const [timeLeft, setTimeLeft] = (0,react.useState)(timeRemainingInSeconds);
    const [expiringSoon, setExpiringSoon] = (0,react.useState)(withinExpiryTimeWindow);
    const [orderHasExpired, setOrderHasExpired] = (0,react.useState)(hasExpired((activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ?? (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.cancelledAt)));
    (0,react.useEffect)(()=>{
        setOrderHasExpired(hasExpired((currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.expiresAt) ?? (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cancelledAt)));
        if (orderHasExpired) {
            return;
        }
        const id = setTimeout(()=>{
            const times = (0,src/* checkoutTimes */.iP)(activeOrder);
            setTimeLeft(times.timeRemainingInSeconds);
            setExpiringSoon(!!times.isExpiringSoon);
        }, 1000);
        return ()=>clearTimeout(id);
    }, [
        timeLeft
    ]);
    (0,react.useEffect)(()=>{
        if (activeOrder && orderHasExpired && checkIfVehicleIsReserved) {
            setModalLoading(true);
            const getReservationStatus = async ()=>{
                const reservationStatus = await checkIfVehicleIsReserved(activeOrder.vehicle.id);
                setVehicleIsReserved(reservationStatus === null || reservationStatus === void 0 ? void 0 : reservationStatus.reserved);
                setModalLoading(false);
            };
            getReservationStatus();
        }
    }, [
        activeOrder,
        orderHasExpired,
        vehicle,
        checkIfVehicleIsReserved
    ]);
    const extendExpiry = (0,react.useCallback)(async ()=>{
        if (!accessToken) {
            return;
        }
        if (orderId) {
            setButtonLoading(true);
            await (extendOrderExpiryDate === null || extendOrderExpiryDate === void 0 ? void 0 : extendOrderExpiryDate(orderId, accessToken));
            setButtonLoading(false);
        }
    }, [
        orderId,
        extendOrderExpiryDate,
        accessToken
    ]);
    const removeOrderForUser = async (token)=>{
        const cancelOrderReason = "Return to Checkout - I don't want this car";
        if (!refreshActiveOrder) {
            return;
        }
        try {
            var ref;
            const orderDetails = activeOrder && await (cancelOrder === null || cancelOrder === void 0 ? void 0 : cancelOrder(activeOrder.id, cancelOrderReason, token));
            switch((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) || ((ref = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data) === null || ref === void 0 ? void 0 : ref.orderStatus) === "Cancelled"){
                case 200:
                    setCurrentOrder(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data);
                    refreshActiveOrder();
                    onClose();
                    handleShouldShowBasketIcon();
                    break;
                case 403:
                    handleShouldShowBasketIcon();
                    window.location.assign("/login");
                    break;
                default:
                    refreshActiveOrder();
                    break;
            }
            return setSecondaryButtonLoading(false);
        } catch  {
            // eslint-disable-next-line unicorn/no-useless-undefined
            setCurrentOrder(undefined);
            refreshActiveOrder();
            return setSecondaryButtonLoading(false);
        }
    };
    const handleRemoveOrder = async ()=>{
        iDoNotWantThisCarEvent();
        setSecondaryButtonLoading(true);
        const isUserValid = accessToken && isLoggedIn;
        if (!isUserValid) {
            window.location.assign("/login");
        } else {
            await removeOrderForUser(accessToken);
        }
    };
    const onModalOpen = (modalState)=>{
        resumeCheckoutOpenedModal(modalState);
    };
    const onModalClose = (modalState)=>{
        resumeCheckoutClosedModal(modalState);
        onClose();
    };
    const onButtonClick = async ()=>{
        returnToCheckoutModalEvent();
        await extendExpiry();
        (0,src/* returnToCheckoutStage */.jP)((lastVisitedCheckoutStage === null || lastVisitedCheckoutStage === void 0 ? void 0 : lastVisitedCheckoutStage.stage) ?? "PersonalDetails", activeOrder);
    };
    const onButtonClickExpiredOrderVehicleStillAvailable = ()=>{
        resumeCheckoutReturnedToCheckout(ModalState.expiredStillAvailable);
        vehicle && window.location.assign(`${src/* personalDetailsPagePath */.io}${vehicle.id}`);
    };
    const onButtonClickExpiredOrderVehicleUnavailable = ()=>{
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutReturnedToCheckout(ModalState.expiredUnavailable);
        window.location.assign(src/* findVehiclePath */.xv);
    };
    const onModalCloseExpiredOrderVehicleUnavailable = ()=>{
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutClosedModal(ModalState.expiredStillAvailable);
        onClose();
    };
    return {
        vehicle,
        orderHasExpired,
        timeLeft,
        buttonLoading,
        secondaryButtonLoading,
        vehicleIsReserved,
        modalLoading,
        expiringSoon,
        handleRemoveOrder,
        onModalOpen,
        onModalClose,
        onButtonClick,
        onButtonClickExpiredOrderVehicleStillAvailable,
        onButtonClickExpiredOrderVehicleUnavailable,
        onModalCloseExpiredOrderVehicleUnavailable
    };
};
const noOpTracking = (event)=>{
    console.log(`noop::trackEvent::${event.type !== analytics_TrackingEventTypes.IDENTIFY && event.eventName}`, event);
};
const styleCardTitle = (title, icon)=>{
    if (icon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            element: "h5",
            className: (return_to_checkout_modal_module_default()).cardTitle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (return_to_checkout_modal_module_default()).titleWithIconContainer,
                "data-testid": "time-icon-modal-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeIcon, {
                        className: (return_to_checkout_modal_module_default()).timeIcon
                    }),
                    title
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        element: "h5",
        className: (return_to_checkout_modal_module_default()).cardTitle,
        children: title
    });
};
const getTitle = (modalState)=>{
    switch(modalState){
        case ModalState.active:
            return styleCardTitle(i18n.orderActive.title);
        case ModalState.expiringSoon:
            return styleCardTitle(i18n.expiringSoon.title, true);
        case ModalState.expiredStillAvailable:
            return styleCardTitle(i18n.expiredStillAvailable.title, true);
        case ModalState.expiredUnavailable:
            return styleCardTitle(i18n.expiredUnavailable.title);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/lib/return-to-checkout-modal.component.tsx










var return_to_checkout_modal_component_CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["CinchCover"] = "CinchCover";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(return_to_checkout_modal_component_CheckoutStage || (return_to_checkout_modal_component_CheckoutStage = {}));
const returnToCheckoutOrderActiveTestId = "return-to-checkout-order-active-test-id";
const returnToCheckoutExpiringSoonTestId = "return-to-checkout-expiring-soon-test-id";
const returnToCheckoutExpiredStillAvailableTestId = "return-to-checkout-expired-still-available-test-id";
const returnToCheckoutExpiredUnavailableTestId = "return-to-checkout-expired-unavailable-test-id";
const i18n = {
    orderActive: {
        title: "Continue buying this car?",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiringSoon: {
        title: "Your order is timing out",
        text: "We'll reserve this car for another {bold}{timeRemaining}{/bold}",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiredStillAvailable: {
        title: "Your order timed out",
        text: "But the car is still available! Want to start a new order with the same car?",
        buttonText: "Go to checkout"
    },
    expiredUnavailable: {
        title: "Car no longer available",
        text: "We’re sorry you missed it - but we have 1,000s of other cars in stock. Start a new search to find yours.",
        buttonText: "Browse all cars"
    },
    loading: "Loading...",
    adminFee: "Plus a {adminFeeValue} admin fee"
};
const ReturnToCheckoutModal = ({ activeOrder , onClose , lastVisitedCheckoutStage , timeRemainingInSeconds , withinExpiryTimeWindow , adminFeeFlag =false , adminFeeValueInPence =0 , cancelOrder , isLoggedIn , accessToken , refreshActiveOrder , checkIfVehicleIsReserved , extendOrderExpiryDate , trackEvent , handleShouldShowBasketIcon  })=>{
    const { vehicle , orderHasExpired , timeLeft , buttonLoading , secondaryButtonLoading , vehicleIsReserved , modalLoading , expiringSoon , handleRemoveOrder , onModalOpen , onModalClose , onButtonClick , onButtonClickExpiredOrderVehicleStillAvailable , onButtonClickExpiredOrderVehicleUnavailable , onModalCloseExpiredOrderVehicleUnavailable  } = useReturnToCheckoutModal({
        activeOrder,
        timeRemainingInSeconds,
        withinExpiryTimeWindow,
        checkIfVehicleIsReserved,
        accessToken,
        extendOrderExpiryDate,
        refreshActiveOrder,
        cancelOrder,
        onClose,
        isLoggedIn,
        handleShouldShowBasketIcon,
        lastVisitedCheckoutStage,
        trackEvent
    });
    if (modalLoading || !activeOrder) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_component, {
            onClose: onClose,
            title: "Loading",
            classNames: (return_to_checkout_modal_module_default()),
            closeable: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingCard, {})
        });
    }
    if (orderHasExpired) {
        if (!vehicleIsReserved) {
            const returnToCheckoutModalState = ModalState.expiredStillAvailable;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_component, {
                testId: returnToCheckoutExpiredStillAvailableTestId,
                onClose: ()=>onModalClose(returnToCheckoutModalState),
                classNames: (return_to_checkout_modal_module_default()),
                closeable: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnToCheckoutExpiredStillAvailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleStillAvailable,
                    title: getTitle(returnToCheckoutModalState),
                    vehicle: vehicle,
                    i18n: i18n.expiredStillAvailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        } else {
            const returnToCheckoutModalState1 = ModalState.expiredUnavailable;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_component, {
                testId: returnToCheckoutExpiredUnavailableTestId,
                onClose: onModalCloseExpiredOrderVehicleUnavailable,
                classNames: (return_to_checkout_modal_module_default()),
                closeable: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnToCheckoutExpiredUnavailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleUnavailable,
                    title: getTitle(returnToCheckoutModalState1),
                    vehicle: vehicle,
                    i18n: i18n.expiredUnavailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        }
    }
    if (expiringSoon) {
        const returnToCheckoutModalState2 = ModalState.expiringSoon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_component, {
            testId: returnToCheckoutExpiringSoonTestId,
            onClose: ()=>onModalClose(returnToCheckoutModalState2),
            classNames: (return_to_checkout_modal_module_default()),
            closeable: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnToCheckoutExpiringSoon, {
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                title: getTitle(returnToCheckoutModalState2),
                timeRemainingInSeconds: timeLeft,
                onButtonClick: ()=>onButtonClick(),
                onSecondaryButtonClick: ()=>handleRemoveOrder(),
                vehicle: vehicle,
                isButtonLoading: buttonLoading,
                isSecondaryButtonLoading: secondaryButtonLoading,
                i18n: i18n.expiringSoon,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent,
                onModalOpen: onModalOpen
            })
        });
    }
    const returnToCheckoutModalState3 = ModalState.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_component, {
        testId: returnToCheckoutOrderActiveTestId,
        onClose: ()=>onModalClose(returnToCheckoutModalState3),
        classNames: (return_to_checkout_modal_module_default()),
        closeable: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnToCheckoutOrderActive, {
            adminFeeFlag: adminFeeFlag,
            adminFeeValueInPence: adminFeeValueInPence,
            onButtonClick: ()=>onButtonClick(),
            onSecondaryButtonClick: ()=>handleRemoveOrder(),
            title: getTitle(returnToCheckoutModalState3),
            vehicle: vehicle,
            i18n: i18n.orderActive,
            isButtonLoading: buttonLoading,
            isSecondaryButtonLoading: secondaryButtonLoading,
            trackEvent: trackEvent,
            noOpTracking: noOpTracking,
            onModalOpen: onModalOpen
        })
    });
};
/* harmony default export */ var return_to_checkout_modal_component = ((/* unused pure expression or super */ null && (ReturnToCheckoutModal)));

;// CONCATENATED MODULE: ../../../libs/shared/ui-return-to-checkout-modal/src/index.ts



;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/logo.tsx

const LogoImg = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "75",
        height: "26",
        viewBox: "0 0 75 28",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.49 8.87745C17.2906 8.87745 15.5018 7.08866 15.5018 4.88923C15.5018 2.6898 17.2906 0.900052 19.49 0.900052C21.6895 0.900052 23.4783 2.68883 23.4783 4.88827C23.4783 7.0877 21.6895 8.87745 19.49 8.87745V8.87745ZM19.49 2.3003C18.0629 2.3003 16.9021 3.46109 16.9021 4.88827C16.9021 6.31545 18.0629 7.47623 19.49 7.47623C20.9172 7.47623 22.078 6.31545 22.078 4.88827C22.078 3.46109 20.9172 2.3003 19.49 2.3003V2.3003Z",
                fill: "#57E8FC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M54.0655 21.0825C53.6027 21.7207 52.9952 22.2402 52.293 22.5984C51.5908 22.9566 50.8137 23.1434 50.0253 23.1435C47.271 23.1435 45.0292 20.9027 45.0292 18.1474C45.0292 15.3921 47.27 13.1513 50.0253 13.1513C50.8137 13.1514 51.5908 13.3381 52.293 13.6964C52.9952 14.0546 53.6027 14.5741 54.0655 15.2122L57.1054 12.6752C56.2701 11.5922 55.1975 10.7153 53.97 10.1119C52.7426 9.50851 51.3931 9.19477 50.0253 9.19481C45.0889 9.19481 41.0737 13.2109 41.0737 18.1464C41.0737 23.0819 45.0898 27.099 50.0253 27.099C51.3931 27.099 52.7426 26.7853 53.97 26.1819C55.1975 25.5785 56.2701 24.7016 57.1054 23.6186L54.0655 21.0825V21.0825ZM12.9927 21.0825C12.5299 21.7207 11.9225 22.2402 11.2202 22.5984C10.518 22.9566 9.7409 23.1434 8.95257 23.1435C6.19823 23.1435 3.95648 20.9027 3.95648 18.1474C3.95648 15.3921 6.19823 13.1513 8.95257 13.1513C9.7409 13.1514 10.518 13.3381 11.2202 13.6964C11.9225 14.0546 12.5299 14.5741 12.9927 15.2122L16.0327 12.6752C15.1974 11.5922 14.1247 10.7153 12.8973 10.1119C11.6698 9.50851 10.3203 9.19477 8.95257 9.19481C4.01611 9.19577 0 13.2119 0 18.1483C0 23.0848 4.01611 27.0999 8.95257 27.0999C10.3203 27.1 11.6698 26.7863 12.8973 26.1829C14.1247 25.5795 15.1974 24.7025 16.0327 23.6195L12.9927 21.0825V21.0825ZM17.5118 10.5652H21.4673V26.7989H17.5118V10.5652ZM39.684 26.7989H35.7276V17.5694C35.7276 16.9558 35.6401 15.796 35.0524 14.9141C34.3966 13.9303 33.2108 13.4523 31.4258 13.4523C29.5899 13.4523 28.358 14.0813 27.7627 14.9141C27.1895 15.7152 27.1241 16.724 27.1241 17.5694V26.7989H23.1676V17.5694C23.1676 16.1807 23.31 14.1342 24.5438 12.4079C25.9239 10.4758 28.2397 9.49679 31.4258 9.49679C33.6012 9.49679 36.5681 10.0565 38.3444 12.7204C39.4513 14.3813 39.684 16.2749 39.684 17.5694V26.7989V26.7989ZM73.6603 12.7204C71.8841 10.0555 68.9172 9.49679 66.7418 9.49679C65.0626 9.49679 63.6258 9.76895 62.4401 10.3094V5.82113H58.4836V26.7989H62.4401V17.5694C62.4401 16.725 62.5064 15.7152 63.0786 14.9141C63.6739 14.0813 64.9059 13.4523 66.7418 13.4523C68.5267 13.4523 69.7125 13.9303 70.3684 14.9141C70.956 15.796 71.0435 16.9558 71.0435 17.5694V26.7989H75V17.5694C75 16.2749 74.7673 14.3813 73.6603 12.7204V12.7204Z"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/utils/api.ts
const SHARED_UI_HEADER_BFF = "https://bsyi8f632i.execute-api.eu-west-1.amazonaws.com/prod/search-data";
const getSharedUiHeaderBffData = async ()=>{
    try {
        const response = await fetch(SHARED_UI_HEADER_BFF);
        const searchDataResponse = await response.json();
        return searchDataResponse;
    } catch (error) {
        console.log("Error with fetching searchData", error);
        return null;
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/context/context-shared-ui-header-v2.tsx



const SharedUiHeaderV2Context = /*#__PURE__*/ (0,react.createContext)({});
const SharedUiHeaderV2Provider = ({ children , stageName , isLoggedIn , accessToken , firstName , email , favourites , activeOrder , handleTrackEvent , refreshActiveOrder , setIsCheckoutModalVisible , isCheckoutModalVisible , isGapMenuItemShown , isUpdatedCinchCareCopy  })=>{
    const [userStore, setUserStore] = (0,react.useState)({
        stageName,
        isLoggedIn,
        accessToken,
        firstName,
        email,
        favourites,
        activeOrder,
        refreshActiveOrder
    });
    const [logicStore, setLogicStore] = (0,react.useState)({
        handleTrackEvent: handleTrackEvent,
        setIsCheckoutModalVisible,
        isCheckoutModalVisible: isCheckoutModalVisible,
        searchData: null
    });
    (0,react.useEffect)(()=>{
        setLogicStore({
            handleTrackEvent: handleTrackEvent,
            setIsCheckoutModalVisible: setIsCheckoutModalVisible,
            isCheckoutModalVisible: isCheckoutModalVisible,
            searchData: null
        });
        setUserStore({
            stageName,
            isLoggedIn,
            accessToken,
            firstName,
            email,
            favourites,
            activeOrder,
            refreshActiveOrder
        });
    }, [
        stageName,
        isLoggedIn,
        accessToken,
        firstName,
        favourites,
        activeOrder,
        refreshActiveOrder,
        setIsCheckoutModalVisible,
        isCheckoutModalVisible
    ]);
    (0,react.useEffect)(()=>{
        const getSearchData = async ()=>{
            const searchData = await getSharedUiHeaderBffData();
            if ((searchData === null || searchData === void 0 ? void 0 : searchData.hasOwnProperty("find-a-car")) && // eslint-disable-next-line no-prototype-builtins
            (searchData === null || searchData === void 0 ? void 0 : searchData["find-a-car"].hasOwnProperty("popular-makes"))) {
                const findACarSearchData = searchData["find-a-car"];
                const popularMakes = findACarSearchData["popular-makes"];
                setLogicStore({
                    ...logicStore,
                    searchData: popularMakes
                });
            }
        };
        if (logicStore.searchData === null) {
            getSearchData();
        }
    }, [
        logicStore.searchData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUiHeaderV2Context.Provider, {
        value: {
            userStore,
            setUserStore,
            logicStore,
            setLogicStore,
            isGapMenuItemShown,
            isUpdatedCinchCareCopy
        },
        children: children
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/logo-container/logo-container.module.css
var logo_container_module = __webpack_require__(41803);
var logo_container_module_default = /*#__PURE__*/__webpack_require__.n(logo_container_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/logo-container/logo-container.tsx





const LogoContainer = ()=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (logo_container_module_default()).logoWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "/",
            "aria-label": "cinch homepage",
            onClick: ()=>handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "cinch logo",
                    action: "button"
                }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImg, {})
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/shared-ui-header-v2.module.css
var shared_ui_header_v2_module = __webpack_require__(33347);
var shared_ui_header_v2_module_default = /*#__PURE__*/__webpack_require__.n(shared_ui_header_v2_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/user-profile/user-profile.module.css
var user_profile_module = __webpack_require__(52854);
var user_profile_module_default = /*#__PURE__*/__webpack_require__.n(user_profile_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/user-icon.tsx

const UserIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22 12C22 15.3137 19.3137 18 16 18C12.6863 18 10 15.3137 10 12C10 8.68629 12.6863 6 16 6C19.3137 6 22 8.68629 22 12ZM20.5 12C20.5 14.4853 18.4853 16.5 16 16.5C13.5147 16.5 11.5 14.4853 11.5 12C11.5 9.51472 13.5147 7.5 16 7.5C18.4853 7.5 20.5 9.51472 20.5 12Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 28C6 28.1701 6.00664 28.339 6.01972 28.5065C6.59211 28.9639 7.1966 29.3828 7.82925 29.7593C7.61354 29.1881 7.5 28.5955 7.5 28C7.5 24.7052 10.9759 21.5 16 21.5C21.0241 21.5 24.5 24.7052 24.5 28C24.5 28.5955 24.3865 29.1881 24.1708 29.7593C24.8034 29.3828 25.4079 28.9639 25.9803 28.5065C25.9934 28.339 26 28.1701 26 28C26 23.5817 21.5228 20 16 20C10.4772 20 6 23.5817 6 28Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
                fill: "#57E8FF"
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/favourites/favourites.module.css
var favourites_module = __webpack_require__(92792);
var favourites_module_default = /*#__PURE__*/__webpack_require__.n(favourites_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/favourites/favourites.tsx






const Favourites = ()=>{
    const { logicStore , userStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { favourites  } = userStore;
    const favouritesAmount = (favourites === null || favourites === void 0 ? void 0 : favourites.length) ?? 0;
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (favourites_module_default()).link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "/my-profile/favourites",
            "aria-label": "View your favourites",
            onClick: ()=>handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "saved favourites",
                    action: "button"
                }),
            "data-testid": "Favourites/Anchor",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (favourites_module_default()).svg,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                        name: "heart",
                        height: 14
                    })
                }),
                favouritesAmount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "data-testid": "Favourites/Amount",
                    className: classnames_default()((favourites_module_default()).number, (favourites_module_default()).pulse),
                    children: favouritesAmount
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/basket-navigation/basket-navigation.module.css
var basket_navigation_module = __webpack_require__(34992);
var basket_navigation_module_default = /*#__PURE__*/__webpack_require__.n(basket_navigation_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/time.tsx

const time_TimeIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        "data-testid": "time-icon",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17.44 17.44",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M13.08 1.18a8.81 8.81 0 0 1 3.18 3.18 8.64 8.64 0 0 1 0 8.72 9 9 0 0 1-3.18 3.18 8.64 8.64 0 0 1-8.72 0 8.81 8.81 0 0 1-3.18-3.18A8.42 8.42 0 0 1 0 8.72a8.42 8.42 0 0 1 1.18-4.36 8.66 8.66 0 0 1 3.18-3.18A8.42 8.42 0 0 1 8.72 0a8.42 8.42 0 0 1 4.36 1.18zm-.85 13.62a7 7 0 0 0 2.57-2.57 7 7 0 0 0 0-7 7.09 7.09 0 0 0-2.57-2.56 6.73 6.73 0 0 0-3.51-1 6.76 6.76 0 0 0-3.52 1A7.06 7.06 0 0 0 2.64 5.2a6.76 6.76 0 0 0-1 3.52 6.73 6.73 0 0 0 1 3.51A7 7 0 0 0 5.2 14.8a7 7 0 0 0 7 0zm-1-2.64a.46.46 0 0 0 .27-.16l.63-.92a.41.41 0 0 0-.07-.59L9.7 8.79v-5a.41.41 0 0 0-.42-.42H8.16a.41.41 0 0 0-.3.12.42.42 0 0 0-.13.3v5.77a.42.42 0 0 0 .18.35l3 2.18a.35.35 0 0 0 .3.07z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/hooks/use-expiry.tsx

const useExpiry = (activeOrderExpiry, setShouldShowExpiringOrExpired, timeNow, warningTime, isExpiryingOrExpired)=>{
    const isExpiryingOrExpiredRef = (0,react.useRef)(isExpiryingOrExpired);
    (0,react.useEffect)(()=>{
        if (activeOrderExpiry) {
            const checkOrderStatus = activeOrderExpiry - warningTime;
            const timeToTriggerRefresh = checkOrderStatus - timeNow;
            const triggerRefresh = timeToTriggerRefresh > 0 ? timeToTriggerRefresh : 0;
            /* This will fire 5 minutes before the basket session runs out */ const timeoutId = setTimeout(()=>{
                setShouldShowExpiringOrExpired(isExpiryingOrExpiredRef.current);
            }, triggerRefresh);
            return ()=>clearTimeout(timeoutId);
        }
        return;
    }, [
        activeOrderExpiry,
        warningTime,
        timeNow
    ]);
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/basket-navigation/basket-component.tsx




var basket_component_CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["CinchCover"] = "CinchCover";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(basket_component_CheckoutStage || (basket_component_CheckoutStage = {}));
const getLastCheckoutStage = (activeOrder)=>{
    const storageLastCheckoutStage =  true ? JSON.parse((sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("checkout-last-visited-stage")) ?? "{}") : 0;
    if (!activeOrder) {
        return;
    }
    const { orderId , stage  } = storageLastCheckoutStage ?? {};
    if (orderId === activeOrder.id && stage) {
        return storageLastCheckoutStage;
    }
    return {
        orderId: activeOrder.id,
        stage: basket_component_CheckoutStage.PersonalDetails
    };
};
const personalDetailsPagePath = "/checkout/personal-details/";
const findVehiclePath = "/used-cars/";
const formatPath = (checkoutStage)=>{
    // Split camel case string before each uppercase letter
    const formattedPath = checkoutStage.split(/(?=[A-Z])/).join("-").toLowerCase();
    return `/checkout/${formattedPath}/`;
};
const returnToCheckoutStage = (checkoutStep, activeOrder)=>{
    const vehicle = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle;
    const orderId = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id;
    const path = formatPath(checkoutStep);
    switch(checkoutStep){
        case basket_component_CheckoutStage.PersonalDetails:
            return vehicle ? `${personalDetailsPagePath}${vehicle.id}` : findVehiclePath;
        case basket_component_CheckoutStage.PartExchange:
        case basket_component_CheckoutStage.Finance:
        case basket_component_CheckoutStage.DeliverySlots:
        case basket_component_CheckoutStage.Extras:
        case basket_component_CheckoutStage.CinchCare:
        case basket_component_CheckoutStage.CinchCover:
        case basket_component_CheckoutStage.Payment:
            return orderId ? `${path}${orderId}` : null;
        default:
            return null;
    }
};
const BasketComponent = ({ children , setShouldShowCheckoutModal , tag ="button"  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    const { userStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { activeOrder  } = userStore;
    let checkoutLink;
    const orderInformation = getLastCheckoutStage(activeOrder);
    if (orderInformation && orderInformation.stage && basket_component_CheckoutStage[orderInformation.stage]) {
        const stage = basket_component_CheckoutStage[orderInformation.stage];
        checkoutLink = returnToCheckoutStage(stage, activeOrder);
    }
    const handleClick = ()=>{
        setShouldShowCheckoutModal();
        handleTrackEvent({
            name: "click",
            category: "mega menu",
            label: "basket",
            action: "button"
        });
    };
    const Tag = tag === "a" ? "a" : "button";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        "data-testid": "checkout-basket",
        "aria-label": "Your basket order",
        className: (basket_navigation_module_default()).basketContainer,
        onClick: handleClick,
        href: tag === "a" ? checkoutLink ?? undefined : undefined,
        children: children
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/arrow-border.tsx

const ArrowBorder = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "49",
        height: "40",
        viewBox: "0 0 49 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#arrow-border-clip)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M26.2136 9.99862C26.1399 9.99425 26.068 9.97959 26 9.95559V7H18.5C10.4919 7 4 13.4919 4 21.5C4 29.5081 10.4919 36 18.5 36H19H30.5C38.5081 36 45 29.5081 45 21.5V20.9073C46.433 20.7287 47.7831 20.2978 49 19.6628V21.5C49 31.2123 41.5158 39.1765 32 39.9401V40H30.5H19H18.5C8.28273 40 0 31.7173 0 21.5C0 11.2827 8.28273 3 18.5 3H26V0.0444101C26.068 0.0204119 26.1399 0.00574628 26.2136 0.00137845C26.4098 -0.0102487 26.6029 0.0520338 26.7514 0.174829L31.7517 4.46811C31.8298 4.53521 31.8923 4.61724 31.9351 4.70887C31.9779 4.8005 32 4.89969 32 5C32 5.10031 31.9779 5.1995 31.9351 5.29113C31.8923 5.38276 31.8298 5.46479 31.7517 5.53189L26.7514 9.82517C26.6029 9.94797 26.4098 10.0102 26.2136 9.99862Z",
                    fill: "url(#arrow-border-paint)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "arrow-border-paint",
                        x1: "24.5",
                        y1: "0",
                        x2: "24.5",
                        y2: "40",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF2DFF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FF5B83"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "arrow-border-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "49",
                            height: "40",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/basket-icon.tsx

const BasketIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "checkout basket"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.11 15.3001H4.89L1 5.57015H19L15.11 15.3001Z",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.1103 1L17.0503 5.57",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.88991 1L2.94991 5.57",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeMiterlimit: "10",
                strokeLinecap: "round"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/basket-navigation/basket-icon-wrapper.tsx




const BasketIconWrapper = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (basket_navigation_module_default()).basketIconsContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basket_navigation_module_default()).basketIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketIcon, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (basket_navigation_module_default()).arrowBorder,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBorder, {})
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/basket-navigation/basket-navigation.tsx









const BasketNavigation = ({ checkoutModalAvailable , shouldShowBasketIcon  })=>{
    const { userStore , logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const [isInCheckoutJourney, setIsInCheckoutJourney] = (0,react.useState)(false);
    const [shouldShowExpiringOrExpired, setShouldShowExpiringOrExpired] = (0,react.useState)(false);
    const { isLoggedIn , activeOrder , refreshActiveOrder  } = userStore;
    const { isCheckoutModalVisible , setIsCheckoutModalVisible  } = logicStore;
    /* Times needed to calculate which icon to show*/ const warningTime = 5 * 60 * 1000;
    const timeNow = Math.floor(Date.now());
    const orderHasExpired = ((activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ?? 0) < timeNow;
    const isExpiringSoon = (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ? warningTime + timeNow > (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) : null;
    (0,react.useEffect)(()=>{
        if (true) {
            const { pathname  } = window.location;
            const regex = /checkout/;
            setIsInCheckoutJourney(regex.test(pathname));
            /* This needs to wrap the refreshActiveOrder to
       * ensure we wait for the activeOrder to be populated
       */ const refreshActiveOrderData = async ()=>{
                if (isLoggedIn) {
                    await refreshActiveOrder();
                }
            };
            refreshActiveOrderData();
        }
    }, [
        isLoggedIn
    ]);
    useExpiry(activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt, setShouldShowExpiringOrExpired, timeNow, warningTime, !!(orderHasExpired || isExpiringSoon));
    const isBasketVisible = isLoggedIn && (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) && shouldShowBasketIcon && isInCheckoutJourney === false;
    const isExpiringOrExpiredBasket = isBasketVisible && shouldShowExpiringOrExpired === true;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isExpiringOrExpiredBasket && /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: ()=>{
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((basket_navigation_module_default()).timerIcon, (basket_navigation_module_default()).pulse),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(time_TimeIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketIconWrapper, {})
                    ]
                })
            }),
            isBasketVisible && !isExpiringOrExpiredBasket && /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: ()=>{
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (basket_navigation_module_default()).number,
                            children: "1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketIconWrapper, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/user-profile/user-profile.tsx







const UserProfile = ({ checkoutModal , shouldShowBasketIcon  })=>{
    const { logicStore , userStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const [isDesktop, setIsDesktop] = (0,react.useState)(false);
    const { handleTrackEvent , isCheckoutModalVisible  } = logicStore;
    const { firstName , isLoggedIn  } = userStore;
    (0,react.useEffect)(()=>{
        if (true) {
            setIsDesktop((window === null || window === void 0 ? void 0 : window.innerWidth) >= 767);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (user_profile_module_default()).userProfileWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: (user_profile_module_default()).profileLink,
                href: "/my-profile",
                "aria-label": "my profile",
                onClick: ()=>{
                    handleTrackEvent({
                        name: "click",
                        category: "mega menu",
                        label: "my profile",
                        action: "button"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (user_profile_module_default()).profileLinkText,
                        "data-dd-privacy": "mask",
                        children: firstName ? `Hi ${firstName}!` : "My Profile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {})
                ]
            }),
            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourites, {}) : null,
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketNavigation, {
                        checkoutModalAvailable: !!checkoutModal,
                        shouldShowBasketIcon: shouldShowBasketIcon
                    }),
                    isCheckoutModalVisible && checkoutModal
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/chevron-right.tsx

const ChevronRight = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "24",
        viewBox: "0 0 13 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.46967 23.5303C0.176777 23.2374 0.176777 22.7626 0.46967 22.4697L10.9393 12L0.469669 1.53033C0.176776 1.23744 0.176776 0.762564 0.469669 0.469669C0.762562 0.176777 1.23744 0.176777 1.53033 0.469669L12.5303 11.4697C12.671 11.6103 12.75 11.8011 12.75 12C12.75 12.1989 12.671 12.3897 12.5303 12.5303L1.53033 23.5303C1.23744 23.8232 0.762563 23.8232 0.46967 23.5303Z",
            fill: "#311B77"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/chevron-left.tsx

const ChevronLeft = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "24",
        viewBox: "0 0 13 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5303 0.46967C12.8232 0.762563 12.8232 1.23744 12.5303 1.53033L2.06066 12L12.5303 22.4697C12.8232 22.7626 12.8232 23.2374 12.5303 23.5303C12.2374 23.8232 11.7626 23.8232 11.4697 23.5303L0.46967 12.5303C0.329017 12.3897 0.249999 12.1989 0.249999 12C0.249999 11.8011 0.329017 11.6103 0.46967 11.4697L11.4697 0.46967C11.7626 0.176777 12.2374 0.176777 12.5303 0.46967Z",
            fill: "#311B77"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/chevron-down.tsx

const ChevronDown = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            opacity: "0.9",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.20802 0.981584C0.494334 0.682256 0.96909 0.671706 1.26842 0.95802L6.5 5.96214L11.7316 0.95802C12.0309 0.671706 12.5057 0.682256 12.792 0.981584C13.0783 1.28091 13.0677 1.75567 12.7684 2.04198L7.01842 7.54198C6.72845 7.81934 6.27155 7.81934 5.98158 7.54198L0.231584 2.04198C-0.0677439 1.75567 -0.078294 1.28091 0.20802 0.981584Z",
            fill: "currentColor"
        })
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/nav-item/nav-item.module.css
var nav_item_module = __webpack_require__(89108);
var nav_item_module_default = /*#__PURE__*/__webpack_require__.n(nav_item_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/chevron-up.tsx

const ChevronUp = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            opacity: "0.9",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.20802 6.76842C0.494334 7.06774 0.96909 7.07829 1.26842 6.79198L6.5 1.78786L11.7316 6.79198C12.0309 7.07829 12.5057 7.06774 12.792 6.76842C13.0783 6.46909 13.0677 5.99433 12.7684 5.70802L7.01842 0.208018C6.72845 -0.0693407 6.27155 -0.0693407 5.98158 0.208018L0.231584 5.70802C-0.0677439 5.99433 -0.078294 6.46909 0.20802 6.76842Z",
            fill: "currentColor"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/nav-item/nav-item.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 






const NavItem = ({ activeMenu =null , handleItemSelection , handleTrackEvent , icon , title , subHeading , href , children  })=>{
    const handleNavItemClick = (e)=>{
        const selectedMenuTarget = e.currentTarget;
        const id = selectedMenuTarget.id;
        if (hasChildren) {
            e.preventDefault();
        }
        handleItemSelection && handleItemSelection(id);
        handleTrackEvent && handleTrackEvent();
    };
    const hasChildren = children ? true : false;
    const anchorProps = {
        href: href
    };
    if (hasChildren) {
        anchorProps["aria-expanded"] = activeMenu ? true : false;
        anchorProps["href"] = "#";
    }
    const isMobileAriaLabel =  true && window.innerWidth < 768;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "aria-label": isMobileAriaLabel ? `${title} mobile` : title,
                id: title,
                className: classnames_default()((nav_item_module_default()).navItemContainer, {
                    [(nav_item_module_default()).navItemContainerActive]: activeMenu === title,
                    [(nav_item_module_default()).secondaryNavItemContainer]: hasChildren
                }),
                onClick: (e)=>{
                    handleNavItemClick(e);
                },
                ...anchorProps,
                children: [
                    hasChildren && activeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (nav_item_module_default()).mobileChevron,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (nav_item_module_default()).menuTitleContainer,
                        children: [
                            icon && !activeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (nav_item_module_default()).menuTitleIcon,
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: subHeading ? (nav_item_module_default()).menuTitleText : "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: icon ? (nav_item_module_default()).menuTitle : "",
                                        children: title
                                    }),
                                    subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (nav_item_module_default()).menuTitleSubHeading,
                                        "data-dd-privacy": "mask",
                                        children: subHeading
                                    })
                                ]
                            })
                        ]
                    }),
                    hasChildren && !activeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((nav_item_module_default()).mobileChevron, (nav_item_module_default()).mobileChevronRight),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
                    }),
                    hasChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (nav_item_module_default()).desktopChevron,
                        children: activeMenu === title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown, {})
                    })
                ]
            }),
            activeMenu === title && children
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/desktop-nav/desktop-nav.module.css
var desktop_nav_module = __webpack_require__(232);
var desktop_nav_module_default = /*#__PURE__*/__webpack_require__.n(desktop_nav_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/part-exchange-menu/part-exchange-menu.module.css
var part_exchange_menu_module = __webpack_require__(17434);
var part_exchange_menu_module_default = /*#__PURE__*/__webpack_require__.n(part_exchange_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/part-exchange.ts
const partExchangeSnippets = [
    {
        heading: "Part exchange with cinch",
        snippet: "Guaranteed price for your car, no hidden fees.",
        image: "https://a.storyblok.com/f/132543/216x144/a32b0e8b41/part-ex.webp",
        alt: "Woman exchanging car to customer",
        linkText: "Learn more",
        href: "/part-exchange",
        ariaLabel: "Navigate to part exchange page",
        trackingTitle: "part exchange"
    },
    {
        heading: "Just looking to sell for now?",
        snippet: "Visit our sister website webuyanycar to get a quote.",
        image: "https://a.storyblok.com/f/132543/216x144/8714c261ee/wbac.webp",
        alt: "WBAC logo",
        linkText: "Go to webuyanycar.com",
        href: "https://www.webuyanycar.com/?utm_source=cinch_website&utm_medium=button_id_123&utm_campaign=sell_your_car",
        ariaLabel: "Navigate to sister site we buy any car",
        trackingTitle: "webuyanycar",
        externalLink: true
    }
];
const partExchangeFAQs = [
    {
        label: "Can I part-exchange my car if it’s still on finance?",
        href: "/support#Part Exchange-7"
    },
    {
        label: "Can I sell my car to cinch without buying one?",
        href: "/support#Part Exchange-4"
    },
    {
        label: "How do I know I’m getting a good price for my part exchange?",
        href: "/support#Part Exchange-1"
    }
];

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-snippet-item/list-snippet-item.module.css
var list_snippet_item_module = __webpack_require__(28572);
var list_snippet_item_module_default = /*#__PURE__*/__webpack_require__.n(list_snippet_item_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/arrow-right.tsx

const ArrowRight = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "12",
        viewBox: "0 0 24 12",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.4697 1.53033L21.1893 5.25L0.75 5.25C0.335787 5.25 -2.69446e-07 5.58579 -2.5134e-07 6C-2.33235e-07 6.41421 0.335787 6.75 0.75 6.75L21.1893 6.75L17.4697 10.4697C17.1768 10.7626 17.1768 11.2374 17.4697 11.5303C17.7626 11.8232 18.2374 11.8232 18.5303 11.5303L23.5303 6.53033C23.671 6.38968 23.75 6.19891 23.75 6C23.75 5.80109 23.671 5.61032 23.5303 5.46967L18.5303 0.469669C18.2374 0.176775 17.7626 0.176775 17.4697 0.469669C17.1768 0.762562 17.1768 1.23744 17.4697 1.53033Z",
            fill: "currentColor"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-snippet-item/list-snippet-item.tsx




const ListSnippetItem = ({ smallImage =false , isMobile =false , heading , snippet , linkText , href , image , alt , handleTrackEvent , customIcon  })=>{
    const handleLinkTrackingEvent = ()=>{
        handleTrackEvent();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: classnames_default()({
            [(list_snippet_item_module_default()).containerWithoutImage]: !image,
            [(list_snippet_item_module_default()).container]: image,
            [(list_snippet_item_module_default()).containerWithSmallImage]: smallImage
        }),
        children: !image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: (list_snippet_item_module_default()).heading,
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (list_snippet_item_module_default()).snippet,
                    children: [
                        snippet,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: href,
                    className: (list_snippet_item_module_default()).link,
                    onClick: handleLinkTrackingEvent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (list_snippet_item_module_default()).linkText,
                            children: [
                                linkText,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (list_snippet_item_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()({
                        [(list_snippet_item_module_default()).imageContainerSmall]: smallImage,
                        [(list_snippet_item_module_default()).imageContainer]: !smallImage
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        onClick: handleLinkTrackingEvent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: image,
                            alt: alt,
                            className: (list_snippet_item_module_default()).image
                        })
                    })
                }) : null,
                linkText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (list_snippet_item_module_default()).textContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (list_snippet_item_module_default()).heading,
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (list_snippet_item_module_default()).snippet,
                            children: [
                                snippet,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: href,
                            ...customIcon && {
                                target: "_blank"
                            },
                            className: (list_snippet_item_module_default()).link,
                            onClick: handleLinkTrackingEvent,
                            children: [
                                linkText,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((list_snippet_item_module_default()).icon, {
                                        [(list_snippet_item_module_default()).customIcon]: customIcon
                                    }),
                                    children: customIcon ? customIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (list_snippet_item_module_default()).textContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        className: (list_snippet_item_module_default()).linkHeading,
                        onClick: handleLinkTrackingEvent,
                        children: heading
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-item/list-item.module.css
var list_item_module = __webpack_require__(80667);
var list_item_module_default = /*#__PURE__*/__webpack_require__.n(list_item_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-item/list-item.tsx


const ListItem = ({ label , href , ariaLabel , handleClickEvent , apiData  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        "aria-label": ariaLabel,
        className: (list_item_module_default()).listItem,
        onClick: handleClickEvent,
        children: `${label} ${apiData ? `(${apiData})` : ""}`
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-wrapper/list-wrapper.module.css
var list_wrapper_module = __webpack_require__(92319);
var list_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(list_wrapper_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/list-wrapper/list-wrapper.tsx



const ListWrapper = ({ children , heading , urlText , href , isListCard , handleTrackEvent  })=>{
    const handleLinkTrackingEvent = ()=>{
        handleTrackEvent && handleTrackEvent();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: !isListCard ? (list_wrapper_module_default()).heading : (list_wrapper_module_default()).listCardHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (list_wrapper_module_default()).listWrapperContainer,
                children: [
                    children,
                    urlText && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: !isListCard ? (list_wrapper_module_default()).wrapperLink : (list_wrapper_module_default()).listCardWrapperLink,
                            href: href,
                            onClick: handleLinkTrackingEvent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: isListCard ? (list_wrapper_module_default()).listCardUrlText : "",
                                    children: urlText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (list_wrapper_module_default()).wrapperLinkIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/parent-menu.ts
const parentLinks = {
    YOURPROFILE: "Your profile",
    FINDACAR: "Find a car",
    PARTEXCHANGE: "Part exchange",
    CARCARE: "Car care",
    CARFINANCE: "Car finance",
    HOWCINCHWORKS: "How cinch works"
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/external-link.tsx

const ExternalLink = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.50001 0.75C6.50001 0.335786 6.83579 0 7.25001 0H16V8.75C16 9.16421 15.6642 9.5 15.25 9.5C14.8358 9.5 14.5 9.16421 14.5 8.75V2.56193L7.53028 9.53038C7.23736 9.82325 6.76249 9.8232 6.46962 9.53028C6.17675 9.23736 6.1768 8.76249 6.46972 8.46962L13.4406 1.5H7.25001C6.83579 1.5 6.50001 1.16421 6.50001 0.75Z",
                    fill: "#1565c0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3 2H5V3.5H3C2.17157 3.5 1.5 4.17157 1.5 5V13C1.5 13.8284 2.17157 14.5 3 14.5H11C11.8284 14.5 12.5 13.8284 12.5 13V11H14V13C14 14.6569 12.6569 16 11 16H3C1.34315 16 0 14.6569 0 13V5C0 3.34315 1.34315 2 3 2Z",
                    fill: "#1565c0"
                })
            ]
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/part-exchange-menu/part-exchange-menu.tsx










const PartExchangeMenu = ({ setShouldShowMobileMenu , isMobile , handleFaqClick  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            partExchangeSnippets && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                children: partExchangeSnippets.map((snippet)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListSnippetItem, {
                        isMobile: isMobile,
                        heading: snippet.heading,
                        snippet: snippet.snippet,
                        linkText: snippet.linkText,
                        href: snippet.href,
                        image: snippet.image,
                        alt: snippet.alt,
                        ...snippet.externalLink && {
                            customIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {})
                        },
                        handleTrackEvent: ()=>handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: parentLinks.PARTEXCHANGE,
                                action: snippet.trackingTitle,
                                value: snippet.linkText
                            })
                    }, snippet.heading))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (part_exchange_menu_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    heading: "FAQs",
                    urlText: "Go to help and support",
                    href: "/support",
                    isListCard: true,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.PARTEXCHANGE,
                            action: "FAQ",
                            value: "Go to help and support"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: partExchangeFAQs.map((faq)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (part_exchange_menu_module_default()).faqList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    label: faq.label,
                                    href: faq.href,
                                    ariaLabel: faq.ariaLabel,
                                    handleClickEvent: ()=>{
                                        handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.PARTEXCHANGE,
                                            action: "FAQ",
                                            value: faq.label
                                        });
                                        // handleFaqClick solve the scroll issue on desktop
                                        handleFaqClick && handleFaqClick(null);
                                        if (setShouldShowMobileMenu) {
                                            setShouldShowMobileMenu();
                                        }
                                    }
                                })
                            }, faq.label))
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/car-finance-menu/car-finance-menu.module.css
var car_finance_menu_module = __webpack_require__(1083);
var car_finance_menu_module_default = /*#__PURE__*/__webpack_require__.n(car_finance_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/car-finance.ts
const carFinance = {
    sectionTitle: "Car finance",
    navItems: [
        {
            type: "link",
            label: "How it works",
            href: "/car-finance"
        },
        {
            type: "link",
            label: "Hire purchase (HP)",
            href: "/car-finance/hire-purchase"
        },
        {
            type: "link",
            label: "Personal contract purchase (PCP)",
            href: "/car-finance/personal-contract-purchase"
        }
    ]
};
const articles = {
    sectionTitle: "Helpful guides",
    navArticles: [
        {
            title: "Can you get car finance with bad credit?",
            image: "https://a.storyblok.com/f/132543/1280x731/dbd22c266f/bad-credit-car-finance.webp",
            href: "/guides/car-finance/bad-credit-car-finance",
            alt: "car finance"
        },
        {
            title: "How to part exchange a car with finance – PCP and HP finance",
            image: "https://a.storyblok.com/f/132543/1280x731/eea6792d02/part-exchange-financed-car.webp",
            href: "/guides/car-finance/part-exchange-financed-car",
            alt: "part exchange financed car"
        },
        {
            title: "How to find out how much finance is left on my car",
            image: "https://a.storyblok.com/f/132543/1280x731/5b4c8f1fd2/how-to-find-out-how-much-finance-is-left-on-a-car.webp",
            href: "/guides/car-finance/how-to-find-out-how-much-finance-is-left-on-a-car",
            alt: "finance is left on a car"
        }
    ],
    sectionLink: "All finance guides",
    href: "/guides/car-finance"
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/car-finance-menu/car-finance-menu.tsx









const CarFinanceMenu = ({ isMobile  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    const sectionTitle = carFinance.sectionTitle;
    const carFinanceNavItems = carFinance.navItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (car_finance_menu_module_default()).carFinanceItemWrapper,
                children: sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    heading: sectionTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: carFinanceNavItems.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (car_finance_menu_module_default()).listItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    label: item.label,
                                    href: item.href,
                                    handleClickEvent: ()=>handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.CARFINANCE,
                                            action: item.label,
                                            value: item.label
                                        })
                                })
                            }, item.label))
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (car_finance_menu_module_default()).helpfulArticles,
                children: articles.sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    heading: articles.sectionTitle,
                    href: articles.href,
                    urlText: articles.sectionLink,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARFINANCE,
                            action: articles.sectionTitle,
                            value: articles.sectionLink
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: articles.navArticles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListSnippetItem, {
                                smallImage: true,
                                isMobile: isMobile,
                                heading: article.title,
                                href: article.href,
                                image: article.image,
                                alt: article.alt,
                                handleTrackEvent: ()=>handleTrackEvent({
                                        name: "click",
                                        category: "mega menu",
                                        label: parentLinks.CARFINANCE,
                                        action: articles.sectionTitle,
                                        value: article.title
                                    })
                            }, article.title))
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/car-care.ts
const snippets = [
    {
        heading: "Cover for what you care about",
        snippet: "Get extended warranty, alloy wheel and scratch & dent insurance",
        linkText: "Learn more about cinchCover",
        href: "/car-care/cinch-cover"
    },
    {
        heading: "Servicing, warranty & breakdown",
        snippet: "Keep your car running smoothly with a range of maintenance plans to suit your needs",
        linkText: "Learn more about cinchCare",
        href: "/cinch-care"
    },
    {
        heading: "Paint, glass and interior protection",
        snippet: "Protect your car inside and out, provided by AutoGlym",
        linkText: "Learn more about cinchShield",
        href: "/car-care/cinch-shield"
    },
    {
        heading: "Electric vehicle charging on the go",
        snippet: "Access to thousands of public charging points across Mainland GB",
        linkText: "Learn more about cinchCharge",
        href: "/car-care/charging-electric-cars"
    },
    {
        heading: "GAP insurance",
        snippet: "Free 30 days GAP insurance provided by Car Care Plan",
        linkText: "Learn more about GAP insurance",
        href: "/car-care/gap-insurance"
    },
    {
        heading: "Electric vehicle home charging",
        snippet: "Electric car home charging provided and installed by myenergi",
        linkText: "Learn more about home charging",
        href: "/car-care/electric-car-home-charger"
    }
];
const navCard = {
    heading: "What is car care?",
    body: "A range of services to keep your car looking and running its best",
    image: "https://a.storyblok.com/f/132543/1280x740/a8f5760c5f/cinch-care.webp",
    alt: "Mechanic fixing car",
    sectionLink: "Learn more",
    href: "/car-care"
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/nav-card/nav-card.module.css
var nav_card_module = __webpack_require__(39192);
var nav_card_module_default = /*#__PURE__*/__webpack_require__.n(nav_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/nav-card/nav-card.tsx



const NavCard = ({ heading , subHeading , link , href , imageSrc , alt , handleTrackEvent  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (nav_card_module_default()).navCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (nav_card_module_default()).heading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (nav_card_module_default()).subHeading,
                children: subHeading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                onClick: handleTrackEvent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageSrc,
                    alt: alt,
                    className: (nav_card_module_default()).image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: href,
                className: (nav_card_module_default()).link,
                onClick: handleTrackEvent,
                children: [
                    link,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (nav_card_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
                    })
                ]
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/car-care-menu/car-care-menu.module.css
var car_care_menu_module = __webpack_require__(98114);
var car_care_menu_module_default = /*#__PURE__*/__webpack_require__.n(car_care_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/car-care-menu/car-care-menu.tsx








const CarCareMenu = ({ isMobile  })=>{
    const { logicStore: { handleTrackEvent  } , isGapMenuItemShown , isUpdatedCinchCareCopy  } = (0,react.useContext)(SharedUiHeaderV2Context);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (car_care_menu_module_default()).list,
                    children: snippets.filter(filterCopy(isUpdatedCinchCareCopy, isGapMenuItemShown)).map((snippet)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListSnippetItem, {
                            isMobile: isMobile,
                            heading: snippet.heading,
                            snippet: snippet.snippet,
                            linkText: snippet.linkText,
                            href: snippet.href,
                            handleTrackEvent: ()=>handleTrackEvent({
                                    name: "click",
                                    category: "mega menu",
                                    label: parentLinks.CARCARE,
                                    action: snippet.heading
                                })
                        }, snippet.heading))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (car_care_menu_module_default()).carCareNavCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCard, {
                    heading: navCard.heading,
                    subHeading: navCard.body,
                    link: navCard.sectionLink,
                    href: navCard.href,
                    imageSrc: navCard.image,
                    alt: navCard.alt,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARCARE,
                            action: navCard.heading
                        })
                })
            })
        ]
    });
};
/**
 * a Curried function to help simplify the filter function
 * @param useUpdatedCinchCareCopy
 * @param isGapMenuItemShown
 * @returns {(snippet: NavItemSnippet) => boolean} filterFn
 */ function filterCopy(useUpdatedCinchCareCopy, isGapMenuItemShown) {
    return (snippet)=>{
        // if the env var is set to true, show the gap insurance menu item
        if (snippet.heading === "GAP insurance") {
            return isGapMenuItemShown;
        }
        // if the env var is set to true, hide the original copy...
        if (snippet.heading === "Warranty, servicing & breakdown") {
            return !useUpdatedCinchCareCopy;
        }
        // ...and show the new copy
        if (snippet.heading === "Servicing, warranty & breakdown") {
            return useUpdatedCinchCareCopy;
        }
        // don't filter anything else...
        return true;
    };
}

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/find-a-car/find-a-car-menu.module.css
var find_a_car_menu_module = __webpack_require__(36288);
var find_a_car_menu_module_default = /*#__PURE__*/__webpack_require__.n(find_a_car_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/find-a-car.ts
const popularMakes = [
    {
        heading: "Popular makes",
        navItems: [
            {
                type: "link",
                label: "Ford",
                href: "/used-cars/ford"
            },
            {
                type: "link",
                label: "BMW",
                href: "/used-cars/bmw"
            },
            {
                type: "link",
                label: "Mercedes-Benz",
                href: "/used-cars/mercedes-benz"
            },
            {
                type: "link",
                label: "Volkswagen",
                href: "/used-cars/volkswagen"
            },
            {
                type: "link",
                label: "Audi",
                href: "/used-cars/audi"
            }
        ],
        sectionLink: "View all cars",
        href: "/used-cars"
    }
];
const shopByBudget = [
    {
        heading: "Shop by budget",
        navItems: [
            {
                type: "link",
                label: "Cars under \xa37,500",
                href: "/used-cars?toPrice=7500"
            },
            {
                type: "link",
                label: "Cars under \xa310,000",
                href: "/used-cars?toPrice=10000"
            },
            {
                type: "link",
                label: "Cars under \xa315,000",
                href: "/used-cars?toPrice=15000"
            },
            {
                type: "link",
                label: "Cars under \xa320,000",
                href: "/used-cars?toPrice=20000"
            },
            {
                type: "link",
                label: "Cars over \xa320,000",
                href: "/used-cars?fromPrice=20000"
            }
        ]
    }
];
const resourcesAndGuides = [
    {
        heading: "Resources and guides",
        navItems: [
            {
                type: "link",
                label: "Car reviews",
                href: "/reviews"
            },
            {
                type: "link",
                label: "Guides",
                href: "/guides"
            },
            {
                type: "link",
                label: "Electric cars",
                href: "/electric-cars"
            },
            {
                type: "link",
                label: "News",
                href: "/news"
            }
        ]
    }
];
const shopByType = [
    {
        heading: "Shop by type",
        cards: [
            {
                type: "link",
                label: "SUV",
                href: "/used-cars/suv-body-type",
                image: "https://a.storyblok.com/f/132543/552x256/912e1f312e/suv.webp",
                alt: "SUV car"
            },
            {
                type: "link",
                label: "Hatchback",
                href: "/used-cars/hatchback-body-type",
                image: "https://a.storyblok.com/f/132543/552x256/3be1cb3f1e/hatchback.webp",
                alt: "Hatchback car"
            },
            {
                type: "link",
                label: "Estate",
                href: "/used-cars/estate-body-type",
                image: "https://a.storyblok.com/f/132543/552x256/561aaacd12/estate.webp",
                alt: "Estate car"
            },
            {
                type: "link",
                label: "Electric",
                href: "/used-cars/electric-fuel-type",
                image: "https://a.storyblok.com/f/132543/552x256/c4d58ac89f/electric.webp",
                alt: "Electric car"
            },
            {
                type: "link",
                label: "Saloon",
                href: "/used-cars/saloon-body-type",
                image: "https://a.storyblok.com/f/132543/552x256/3a5b8d2854/saloon.webp",
                alt: "Saloon car"
            },
            {
                type: "link",
                label: "Coupe",
                href: "/used-cars/coupe-body-type",
                image: "https://a.storyblok.com/f/132543/552x256/82135a63e5/coupe.webp",
                alt: "Coupe car"
            }
        ]
    }
];
const find_a_car_navCard = {
    heading: "Help me choose",
    body: "Use our nifty tool and go from 1000s of cars to tailored top picks",
    image: "https://a.storyblok.com/f/132543/1280x740/99803728e7/help-me-choose-cars.webp",
    alt: "Help me choose cars",
    isImageFullWidth: true,
    sectionLink: "Help me choose",
    href: "/help-me-choose"
};
const mobileNavCard = {
    heading: "Not sure where to start?",
    image: "https://a.storyblok.com/f/132543/1280x782/5fbb92e715/help-me-choose-mobile.webp",
    alt: "Help me choose cars",
    link: "Help me choose",
    href: "/help-me-choose"
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/shop-by-shape-thumbnail/shop-by-shape-thumbnail.module.css
var shop_by_shape_thumbnail_module = __webpack_require__(19888);
var shop_by_shape_thumbnail_module_default = /*#__PURE__*/__webpack_require__.n(shop_by_shape_thumbnail_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/shop-by-shape-thumbnail/shop-by-shape-thumbnail.tsx


const ShopByShapeThumbnail = ({ title , href , image , alt , handleTrackEvent  })=>{
    const handleLinkTrackingEvent = ()=>{
        handleTrackEvent();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (shop_by_shape_thumbnail_module_default()).container,
        href: href,
        onClick: handleLinkTrackingEvent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": "true",
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: alt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (shop_by_shape_thumbnail_module_default()).text,
                children: title
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-nav-card/mobile-nav-card.module.css
var mobile_nav_card_module = __webpack_require__(60168);
var mobile_nav_card_module_default = /*#__PURE__*/__webpack_require__.n(mobile_nav_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-nav-card/mobile-nav-card.tsx



const MobileNavCard = ({ heading , link , href , imageSrc , alt , handleTrackEvent  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (mobile_nav_card_module_default()).navCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (mobile_nav_card_module_default()).textContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (mobile_nav_card_module_default()).heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: href,
                        className: (mobile_nav_card_module_default()).link,
                        onClick: handleTrackEvent,
                        children: [
                            link,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_nav_card_module_default()).icon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobile_nav_card_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imageSrc,
                    alt: `${alt} mobile`,
                    className: (mobile_nav_card_module_default()).image
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/find-a-car/find-a-car-menu.tsx











const FindACarMenu = ({ isMobile  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent , searchData  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (find_a_car_menu_module_default()).largeMobileNavContainer,
                children: popularMakes.map((make)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListWrapper, {
                        heading: make.heading,
                        urlText: make.sectionLink,
                        href: make.href,
                        handleTrackEvent: ()=>handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: parentLinks.FINDACAR,
                                action: "popular makes",
                                value: "view all cars"
                            }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: make.navItems.map((item)=>{
                                const popularMakes = searchData ? searchData : null;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (find_a_car_menu_module_default()).listItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        label: item.label,
                                        href: item.href,
                                        ...popularMakes ? {
                                            apiData: popularMakes === null || popularMakes === void 0 ? void 0 : popularMakes[item.label.toLowerCase()]
                                        } : null,
                                        handleClickEvent: ()=>handleTrackEvent({
                                                name: "click",
                                                category: "mega menu",
                                                label: parentLinks.FINDACAR,
                                                action: "popular makes",
                                                value: item.label
                                            })
                                    }, item.label)
                                }, item.label);
                            })
                        })
                    }, make.heading);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                children: [
                    shopByBudget.map((budget)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                            heading: budget.heading,
                            urlText: budget.sectionLink,
                            href: budget.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (find_a_car_menu_module_default()).smallMobileContainer,
                                children: budget.navItems.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (find_a_car_menu_module_default()).listItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                            label: item.label,
                                            href: item.href,
                                            handleClickEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "shop by budget",
                                                    value: item.label
                                                })
                                        })
                                    }, item.label))
                            })
                        }, budget.heading)),
                    resourcesAndGuides.map((resource)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                            heading: resource.heading,
                            urlText: resource.sectionLink,
                            href: resource.href,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                className: (find_a_car_menu_module_default()).smallMobileContainer,
                                children: resource.navItems.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (find_a_car_menu_module_default()).listItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                            label: item.label,
                                            href: item.href,
                                            handleClickEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "resources and guides",
                                                    value: item.label
                                                })
                                        }, item.label)
                                    }, item.label))
                            })
                        }, resource.sectionTitle))
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (find_a_car_menu_module_default()).largeMobileNavContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavCard, {
                    heading: mobileNavCard.heading,
                    imageSrc: mobileNavCard.image,
                    alt: mobileNavCard.alt,
                    link: mobileNavCard.link,
                    href: mobileNavCard.href,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "help me choose"
                        })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                children: shopByType.map((type)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                        heading: type.heading,
                        urlText: type.sectionLink,
                        href: type.href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (find_a_car_menu_module_default()).shopByTypeContainer,
                            children: type.cards.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ShopByShapeThumbnail, {
                                    title: item.label,
                                    href: item.href,
                                    image: item.image,
                                    alt: item.alt,
                                    handleTrackEvent: ()=>handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.FINDACAR,
                                            action: "shop by type",
                                            value: item.label
                                        })
                                }, item.label))
                        })
                    }, type.sectionTitle))
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCard, {
                    heading: find_a_car_navCard.heading,
                    subHeading: find_a_car_navCard.body,
                    link: find_a_car_navCard.sectionLink,
                    href: find_a_car_navCard.href,
                    imageSrc: find_a_car_navCard.image,
                    alt: find_a_car_navCard.alt,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "help me choose"
                        })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/data/how-cinch-works.ts
const howCinchWorks = {
    sectionTitle: "Popular makes",
    navItems: [
        {
            type: "link",
            label: "Buying a car online",
            href: "/our-commitment"
        },
        {
            type: "link",
            label: "90-day warranty",
            href: "/car-care/90-day-warranty"
        },
        {
            type: "link",
            label: "Quality standards",
            href: "/car-inspection"
        },
        {
            type: "link",
            label: "Money-back guarantee",
            href: "/returns"
        },
        {
            type: "link",
            label: "Home delivery",
            href: "/delivery"
        },
        {
            type: "link",
            label: "Collection",
            href: "/car-collections"
        },
        {
            type: "link",
            label: "Visit our stores",
            href: "/store"
        }
    ]
};
const howCinchWorksFAQs = {
    sectionTitle: "FAQs",
    faqs: [
        {
            label: "Do cinch offer new cars?",
            href: "/support#cinch cars…what to expect-1",
            ariaLabel: "Do cinch offer new cars?"
        },
        {
            label: "Do your cars come with an MOT?",
            href: "/support#cinch cars…what to expect-8",
            ariaLabel: "Do your cars come with an MOT?"
        },
        {
            label: "How do I apply for finance?",
            href: "/support#Finance and payments-4",
            ariaLabel: "How do I apply for finance?"
        }
    ],
    sectionLink: "Go to help and support",
    href: "/support"
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/how-cinch-works-menu/how-cinch-works-menu.module.css
var how_cinch_works_menu_module = __webpack_require__(49113);
var how_cinch_works_menu_module_default = /*#__PURE__*/__webpack_require__.n(how_cinch_works_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/how-cinch-works-menu/how-cinch-works-items.tsx




const HowCinchWorksListItems = ({ navItems , handleTrackEvent  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: navItems.map((listItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (how_cinch_works_menu_module_default()).listItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                    label: listItem.label,
                    ariaLabel: listItem.label,
                    href: listItem.href,
                    handleClickEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            action: listItem.label,
                            label: parentLinks.HOWCINCHWORKS,
                            value: listItem.label
                        })
                }, listItem.label)
            }, listItem.label))
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/how-cinch-works-menu/how-cinch-works-menu.tsx









const HowCinchWorksMenu = ({ setShouldShowMobileMenu , handleFaqClick  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (how_cinch_works_menu_module_default()).listContainer,
                "data-testid": "how-cinch-works-dropdown-menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    heading: parentLinks.HOWCINCHWORKS,
                    isListCard: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowCinchWorksListItems, {
                        navItems: howCinchWorks.navItems,
                        handleTrackEvent: handleTrackEvent
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (how_cinch_works_menu_module_default()).faqContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    heading: howCinchWorksFAQs.sectionTitle,
                    urlText: howCinchWorksFAQs.sectionLink,
                    href: howCinchWorksFAQs.href,
                    isListCard: true,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.HOWCINCHWORKS,
                            action: "FAQ",
                            value: howCinchWorksFAQs.sectionLink
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: howCinchWorksFAQs.faqs.map((faq)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (how_cinch_works_menu_module_default()).faqList,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                    label: faq.label,
                                    href: faq.href,
                                    ariaLabel: faq.ariaLabel,
                                    handleClickEvent: ()=>{
                                        handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.HOWCINCHWORKS,
                                            action: "FAQ",
                                            value: `default - ${faq.label}`
                                        });
                                        // handleFaqClick solve the scroll issue on desktop
                                        handleFaqClick && handleFaqClick(null);
                                        if (setShouldShowMobileMenu) {
                                            setShouldShowMobileMenu();
                                        }
                                    }
                                }, faq.label)
                            }, faq.label))
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/utils/is-child.tsx
/*
 * This will traverse up the DOM tree to check if the
 * selected / clicked on element `child`, is a child
 * of the Ref `parent`
 */ const isChildOf = (child, parent)=>{
    while(child && parent){
        if (child === parent) return true;
        child = child.parentElement;
    }
    return false;
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/desktop-nav/desktop-nav.tsx












const DesktopNav = ({ activeMenu , handleItemSelection , children , isMobile =false  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const navItemDropdownRef = (0,react.useRef)(null);
    const { handleTrackEvent  } = logicStore;
    (0,react.useEffect)(()=>{
        activeMenu ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "auto";
    }, [
        activeMenu
    ]);
    const handleMenuClick = (evt)=>{
        if (navItemDropdownRef.current && navItemDropdownRef.current !== evt.target && !isChildOf(evt.target, navItemDropdownRef.current)) {
            handleItemSelection(null);
        }
    };
    const ariaHidden = isMobile ? {
        "aria-hidden": true
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (desktop_nav_module_default()).navItem,
                ...ariaHidden,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: (selectedMenu)=>{
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.FINDACAR,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "button"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (desktop_nav_module_default()).navDropdownWrapper,
                        onClick: (evt)=>handleMenuClick(evt),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (desktop_nav_module_default()).menuContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindACarMenu, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (desktop_nav_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: (selectedMenu)=>{
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.PARTEXCHANGE,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.PARTEXCHANGE,
                            action: "button"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (desktop_nav_module_default()).navDropdownWrapper,
                        onClick: (evt)=>handleMenuClick(evt),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (desktop_nav_module_default()).menuContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartExchangeMenu, {
                                        handleFaqClick: ()=>handleItemSelection(null)
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (desktop_nav_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: (selectedMenu)=>handleItemSelection(selectedMenu),
                    title: parentLinks.CARFINANCE,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARFINANCE,
                            action: "button"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (desktop_nav_module_default()).navDropdownWrapper,
                        onClick: (evt)=>handleMenuClick(evt),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (desktop_nav_module_default()).menuContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarFinanceMenu, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (desktop_nav_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: (selectedMenu)=>{
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.CARCARE,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.CARCARE,
                            action: "button"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (desktop_nav_module_default()).navDropdownWrapper,
                        onClick: (evt)=>handleMenuClick(evt),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navDropdownBG,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (desktop_nav_module_default()).carCareMenuContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarCareMenu, {})
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (desktop_nav_module_default()).navItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    href: "#",
                    activeMenu: activeMenu,
                    handleItemSelection: (selectedMenu)=>{
                        handleItemSelection(selectedMenu);
                    },
                    title: parentLinks.HOWCINCHWORKS,
                    handleTrackEvent: ()=>handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.HOWCINCHWORKS,
                            action: "button"
                        }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (desktop_nav_module_default()).navDropdownWrapper,
                        onClick: (evt)=>handleMenuClick(evt),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navDropdownBG,
                                "aria-hidden": "true",
                                "data-testid": "dropdown menu background"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (desktop_nav_module_default()).navItemDropdown,
                                ref: navItemDropdownRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: (desktop_nav_module_default()).menuContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowCinchWorksMenu, {
                                        handleFaqClick: ()=>handleItemSelection(null)
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/menu-icon.tsx

const MenuIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        preserveAspectRatio: "xMidYMid",
        height: "32px",
        width: "32px",
        fill: "currentColor",
        viewBox: "0 0 32 32",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M27.597 26.5H3.807c-2 0-2-3 0-3h23.79c2 0 2 3 0 3zm.017-18H3.806c-2 0-2-3 0-3h23.808c2 0 2 3 0 3zm-.017 9H3.807c-2 0-2-3 0-3h23.79c2 0 2 3 0 3z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/close-icon.tsx

const CloseIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.46967 22.4697C0.176777 22.7626 0.176777 23.2374 0.46967 23.5303C0.762563 23.8232 1.23744 23.8232 1.53033 23.5303L12 13.0607L22.4697 23.5303C22.7626 23.8232 23.2374 23.8232 23.5303 23.5303C23.8232 23.2374 23.8232 22.7626 23.5303 22.4697L13.0607 12L23.5303 1.53033C23.8232 1.23744 23.8232 0.762564 23.5303 0.469669C23.2374 0.176777 22.7626 0.176777 22.4697 0.469669L12 10.9393L1.53033 0.46967C1.23744 0.176777 0.762563 0.176777 0.46967 0.46967C0.176777 0.762563 0.176777 1.23744 0.46967 1.53033L10.9393 12L0.46967 22.4697Z",
            fill: "#311B77"
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/assets/my-account-icon.tsx

const MyAccountIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22 12C22 15.3137 19.3137 18 16 18C12.6863 18 10 15.3137 10 12C10 8.68629 12.6863 6 16 6C19.3137 6 22 8.68629 22 12ZM20.5 12C20.5 14.4853 18.4853 16.5 16 16.5C13.5147 16.5 11.5 14.4853 11.5 12C11.5 9.51472 13.5147 7.5 16 7.5C18.4853 7.5 20.5 9.51472 20.5 12Z",
                fill: "#2F2F2F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 28C6 28.1701 6.00664 28.339 6.01972 28.5065C6.59211 28.9639 7.1966 29.3828 7.82925 29.7593C7.61354 29.1881 7.5 28.5955 7.5 28C7.5 24.7052 10.9759 21.5 16 21.5C21.0241 21.5 24.5 24.7052 24.5 28C24.5 28.5955 24.3865 29.1881 24.1708 29.7593C24.8034 29.3828 25.4079 28.9639 25.9803 28.5065C25.9934 28.339 26 28.1701 26 28C26 23.5817 21.5228 20 16 20C10.4772 20 6 23.5817 6 28Z",
                fill: "#2F2F2F"
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-menu/mobile-menu.module.css
var mobile_menu_module = __webpack_require__(20905);
var mobile_menu_module_default = /*#__PURE__*/__webpack_require__.n(mobile_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-menu/mobile-menu.tsx








const MobileMenu = ({ handleMenuClose , children  })=>{
    const { logicStore , userStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    const { isLoggedIn  } = userStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (mobile_menu_module_default()).mobileMenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (mobile_menu_module_default()).mobileLogo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        "aria-label": "cinch home page",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImg, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (mobile_menu_module_default()).mobileProfileWrapper,
                    children: isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_menu_module_default()).favouritesIconContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourites, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (mobile_menu_module_default()).mobileProfile,
                        href: "/my-profile",
                        "aria-label": "my profile mobile",
                        onClick: ()=>{
                            handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: "my profile",
                                action: "button"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAccountIcon, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (mobile_menu_module_default()).closeIcon,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (mobile_menu_module_default()).mobileCloseButton,
                        "aria-label": "close icon",
                        onClick: handleMenuClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {})
                    })
                }),
                children
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-nav/mobile-nav.module.css
var mobile_nav_module = __webpack_require__(32261);
var mobile_nav_module_default = /*#__PURE__*/__webpack_require__.n(mobile_nav_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/your-profile-menu/your-profile-menu.module.css
var your_profile_menu_module = __webpack_require__(47451);
var your_profile_menu_module_default = /*#__PURE__*/__webpack_require__.n(your_profile_menu_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/your-profile-menu/your-profile-menu.tsx





const ProfilePageLink = ({ icon , title , link , number  })=>{
    const { logicStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: link,
        onClick: ()=>handleTrackEvent({
                name: "click",
                category: "my profile menu",
                action: title.toLowerCase(),
                label: "tab selection"
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (your_profile_menu_module_default()).profilePageLinkContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                    color: "pureBlack",
                    name: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (your_profile_menu_module_default()).profilePageLinkTitle,
                    children: title
                }),
                !!number && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (your_profile_menu_module_default()).circle,
                    children: number
                })
            ]
        })
    });
};
const YourProfileMenu = ({ favouritesCount  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (your_profile_menu_module_default()).yourProfileContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageLink, {
                title: "Your cars",
                link: "/my-profile",
                icon: "vehicle-side"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageLink, {
                title: "Your part-ex quotes",
                link: "/my-profile/part-exchange",
                icon: "cash"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageLink, {
                title: "Favourites",
                link: "/my-profile/favourites",
                icon: "heart-outline",
                number: favouritesCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageLink, {
                title: "Settings",
                link: "/my-profile/settings",
                icon: "settings"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePageLink, {
                title: "Marketing preferences",
                link: "/my-profile/marketing-preferences",
                icon: "mail"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/components/mobile-nav/mobile-nav.tsx


















const MobileNav = ({ activeMenu , checkoutModal , handleItemSelection , isMobile , shouldShowBasketIcon , favouritesCount  })=>{
    const { logicStore , userStore  } = (0,react.useContext)(SharedUiHeaderV2Context);
    const { handleTrackEvent , isCheckoutModalVisible  } = logicStore;
    const { isLoggedIn , email  } = userStore;
    const [shouldShowMobileMenu, setShouldShowMobileMenu] = (0,react.useState)(false);
    const shouldShowYourProfile = (!activeMenu || activeMenu === parentLinks.YOURPROFILE) && isLoggedIn;
    const shouldShowPartExchange = !activeMenu || activeMenu === parentLinks.PARTEXCHANGE;
    const shouldShowFindACar = !activeMenu || activeMenu === parentLinks.FINDACAR;
    const shouldShowCarCare = !activeMenu || activeMenu === parentLinks.CARCARE;
    const shouldShowCarFinance = !activeMenu || activeMenu === parentLinks.CARFINANCE;
    const shouldShowHowCinchWorks = !activeMenu || activeMenu === parentLinks.HOWCINCHWORKS;
    (0,react.useEffect)(()=>{
        shouldShowMobileMenu ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "auto";
    }, [
        shouldShowMobileMenu
    ]);
    const ariaHidden = !isMobile ? {
        "aria-hidden": true
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (mobile_nav_module_default()).menuIconWrapper,
        ...ariaHidden,
        children: [
            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourites, {}) : null,
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasketNavigation, {
                        checkoutModalAvailable: !!checkoutModal,
                        shouldShowBasketIcon: shouldShowBasketIcon
                    }),
                    isCheckoutModalVisible && checkoutModal
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-expanded": shouldShowMobileMenu,
                "aria-controls": "mobileDropDown",
                "aria-label": "mobile menu",
                onClick: ()=>setShouldShowMobileMenu(!shouldShowMobileMenu),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {})
            }),
            shouldShowMobileMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_nav_module_default()).navDropdownBG,
                        "aria-hidden": "true",
                        onClick: ()=>{
                            handleItemSelection(null);
                            setShouldShowMobileMenu(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "mobileDropDown",
                        className: classnames_default()((mobile_nav_module_default()).mobileMenuWrapper, {
                            [(mobile_nav_module_default()).circleBackground]: !activeMenu,
                            [(mobile_nav_module_default()).dropCircle]: isLoggedIn
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
                            handleMenuClose: ()=>{
                                setShouldShowMobileMenu(false);
                                handleItemSelection(null);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    shouldShowYourProfile && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                                name: "owner-user"
                                            }),
                                            title: parentLinks.YOURPROFILE,
                                            subHeading: email,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.YOURPROFILE,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YourProfileMenu, {
                                                        favouritesCount: favouritesCount
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowFindACar && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.FINDACAR,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindACarMenu, {
                                                        isMobile: isMobile
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowPartExchange && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.PARTEXCHANGE,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.PARTEXCHANGE,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartExchangeMenu, {
                                                        isMobile: isMobile,
                                                        setShouldShowMobileMenu: ()=>setShouldShowMobileMenu(false)
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowCarFinance && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.CARFINANCE,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.CARFINANCE,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarFinanceMenu, {})
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowCarCare && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.CARCARE,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.CARCARE,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarCareMenu, {})
                                                })
                                            })
                                        })
                                    }),
                                    shouldShowHowCinchWorks && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: classnames_default()((mobile_nav_module_default()).navItem, (mobile_nav_module_default()).navItemWithChildren),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            href: "#",
                                            activeMenu: activeMenu,
                                            handleItemSelection: (selectedMenu)=>{
                                                handleItemSelection(selectedMenu);
                                            },
                                            title: parentLinks.HOWCINCHWORKS,
                                            handleTrackEvent: ()=>handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.HOWCINCHWORKS,
                                                    action: "button"
                                                }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_nav_module_default()).navItemDropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowCinchWorksMenu, {
                                                        setShouldShowMobileMenu: ()=>setShouldShowMobileMenu(false)
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    !activeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (mobile_nav_module_default()).menuSignInOut,
                                        children: isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                            element: "a",
                                            "aria-label": "Sign out",
                                            href: "/logout",
                                            isFullWidth: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/logout",
                                                onClick: ()=>handleTrackEvent({
                                                        name: "click",
                                                        category: "mega menu",
                                                        label: "sign out",
                                                        action: "button"
                                                    }),
                                                children: "Sign out"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                            element: "a",
                                            "aria-label": "Sign in",
                                            href: "/my-profile",
                                            isFullWidth: true,
                                            children: "Sign in"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/hooks/use-focus-navigation.tsx

const useFocusNavigation = (selector, activeMenu)=>{
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const sharedNavV2 = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        sharedNavV2.current = document.querySelector(selector);
        if (activeMenu) {
            var ref, ref1;
            document.body.setAttribute("aria-hidden", "true");
            const navFocusableElements = (ref = sharedNavV2.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusableElements);
            const firstNavElement = (ref1 = sharedNavV2.current) === null || ref1 === void 0 ? void 0 : ref1.querySelectorAll(focusableElements)[0];
            const lastNavElement = navFocusableElements === null || navFocusableElements === void 0 ? void 0 : navFocusableElements[navFocusableElements.length - 1];
            const handleFocusNavigation = (e)=>{
                const isTabPressed = e.key === "Tab";
                if (!isTabPressed) {
                    return;
                }
                if (e.shiftKey) {
                    if (document.activeElement === firstNavElement) {
                        lastNavElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastNavElement) {
                        firstNavElement.focus();
                        e.preventDefault();
                    }
                }
            };
            document.addEventListener("keydown", handleFocusNavigation);
            return ()=>{
                document.removeEventListener("keydown", handleFocusNavigation);
            };
        }
        document.body.removeAttribute("aria-hidden");
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{} // noop when the activeMenu is not available
        ;
    }, [
        activeMenu
    ]);
    return sharedNavV2;
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/lib/shared-ui-header-v2.tsx









const SharedUiHeaderV2 = ({ handleTrackEvent , stageName , isLoggedIn , accessToken , firstName , email , favourites , children , refreshActiveOrder , activeOrder , checkoutModal , setIsCheckoutModalVisible , isCheckoutModalVisible , shouldShowBasketIcon , isGapMenuItemShown =false , isUpdatedCinchCareCopy =false  })=>{
    const [activeMenu, setActiveMenu] = (0,react.useState)(null);
    const [isMobile, setIsMobile] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if ( true && window.innerWidth < 768) {
            setIsMobile(true);
        }
    }, []);
    const handleItemSelection = (0,react.useCallback)((menuName)=>{
        if (menuName === activeMenu) {
            setActiveMenu(null);
        } else {
            setActiveMenu(menuName);
        }
    }, [
        activeMenu
    ]);
    const sharedHeaderV2Ref = useFocusNavigation("#main-header", activeMenu);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUiHeaderV2Provider, {
        stageName: stageName,
        isLoggedIn: isLoggedIn,
        accessToken: accessToken,
        firstName: firstName,
        email: email,
        handleTrackEvent: handleTrackEvent,
        favourites: favourites,
        refreshActiveOrder: refreshActiveOrder,
        activeOrder: activeOrder,
        setIsCheckoutModalVisible: setIsCheckoutModalVisible,
        isCheckoutModalVisible: isCheckoutModalVisible,
        isGapMenuItemShown: isGapMenuItemShown,
        isUpdatedCinchCareCopy: isUpdatedCinchCareCopy,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            ref: sharedHeaderV2Ref,
            id: "main-header",
            className: (shared_ui_header_v2_module_default()).sharedUiHeaderContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (shared_ui_header_v2_module_default()).sharedUiSkipLink,
                    href: "#main-content",
                    children: "skip to main content"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (shared_ui_header_v2_module_default()).sharedUiSkipLink,
                    href: "#main-footer",
                    children: "skip to footer"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shared_ui_header_v2_module_default()).sharedUiHeaderInnerWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "Main navigation",
                        className: (shared_ui_header_v2_module_default()).sharedUiHeaderNav,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (shared_ui_header_v2_module_default()).sharedUiHeaderTopLevel,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopNav, {
                                    isMobile: isMobile,
                                    activeMenu: activeMenu,
                                    handleItemSelection: handleItemSelection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile, {
                                        checkoutModal: checkoutModal,
                                        shouldShowBasketIcon: shouldShowBasketIcon ? shouldShowBasketIcon : false
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                                    isMobile: isMobile,
                                    checkoutModal: checkoutModal,
                                    activeMenu: activeMenu,
                                    handleItemSelection: handleItemSelection,
                                    shouldShowBasketIcon: shouldShowBasketIcon ? shouldShowBasketIcon : false,
                                    favouritesCount: (favourites === null || favourites === void 0 ? void 0 : favourites.length) ?? 0
                                })
                            ]
                        })
                    })
                }),
                children
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/header-v2/src/index.ts


// EXTERNAL MODULE: ../../../libs/customer-data/segment/src/index.ts + 4 modules
var segment_src = __webpack_require__(72777);
// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/black-friday/black-friday-banner.module.css
var black_friday_banner_module = __webpack_require__(7180);
var black_friday_banner_module_default = /*#__PURE__*/__webpack_require__.n(black_friday_banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/black-friday/black-friday-banner.tsx



function BlackFridayBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    const handleOnClick = ()=>{
        const data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "shop sale now"
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Black Friday sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (black_friday_banner_module_default()).saveTag,
                children: "BLACK FRIDAY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (black_friday_banner_module_default()).text,
                children: [
                    "Save ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "\xa31000"
                    }),
                    " off",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    " ",
                    "22 – 28 Nov. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/policies/black-friday-sale",
                        children: "T&Cs apply"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var black_friday_banner = (BlackFridayBanner);

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/black-friday/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/deposit-contribution/deposit-contribution.module.css
var deposit_contribution_module = __webpack_require__(38302);
var deposit_contribution_module_default = /*#__PURE__*/__webpack_require__.n(deposit_contribution_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/deposit-contribution/deposit-contribution.tsx



function DepositContributionBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    const handleOnClick = ()=>{
        const data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "selected electric cars"
            }
        };
        // TECHDEBT - currently this only fires *some* of the time,
        // there is a ticket SCD-284 to fix it and make it more accurate
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Deposit contribution promo banner",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (deposit_contribution_module_default()).saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (deposit_contribution_module_default()).text,
                children: [
                    "Up to \xa32,000 towards your finance deposit on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/find-vehicle?tags=deposit-contribution",
                        onClick: handleOnClick,
                        children: "selected electric cars"
                    }),
                    ". Ends 4pm 24 Jan.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/policies/deposit-contribution-electric-cars",
                        children: "T&Cs apply"
                    }),
                    ". 9.9% APR Representative."
                ]
            })
        ]
    });
}
/* harmony default export */ var deposit_contribution = (DepositContributionBanner);

// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/info-banner/info-banner.module.css
var info_banner_module = __webpack_require__(27463);
var info_banner_module_default = /*#__PURE__*/__webpack_require__.n(info_banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/info-banner/info-banner.tsx


const infoText = `cinch joins the nation in expressing our gratitude for the lifelong commitment made by HM Queen Elizabeth II and sends our condolences to the Royal Family.`;
/* harmony default export */ var info_banner = (()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (info_banner_module_default()).text,
        children: infoText
    }));

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/info-banner/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/sale/sale-promo-banner.module.css
var sale_promo_banner_module = __webpack_require__(76594);
var sale_promo_banner_module_default = /*#__PURE__*/__webpack_require__.n(sale_promo_banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/sale/sale-promo-banner.tsx



function SalePromoBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    const handleOnClick = ()=>{
        const data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "shop sale now"
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (sale_promo_banner_module_default()).saveTag,
                children: "SHOP"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (sale_promo_banner_module_default()).text,
                children: [
                    "Price reductions on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/used-cars?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    ", from \xa3250 - \xa31000 off"
                ]
            })
        ]
    });
}
/* harmony default export */ var sale_promo_banner = (SalePromoBanner);

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/sale/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/shared-ui-promo-banner.module.css
var shared_ui_promo_banner_module = __webpack_require__(7533);
var shared_ui_promo_banner_module_default = /*#__PURE__*/__webpack_require__.n(shared_ui_promo_banner_module);
// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/spring-sale/spring-sale-promo-banner.module.css
var spring_sale_promo_banner_module = __webpack_require__(73647);
var spring_sale_promo_banner_module_default = /*#__PURE__*/__webpack_require__.n(spring_sale_promo_banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/spring-sale/spring-sale-promo-banner.tsx



function SpringSalePromoBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    const handleOnClick = (value)=>{
        const data = {
            event: {
                name: "click",
                category: "promotions",
                action: "banner",
                label: "spring sale 2023",
                value
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (spring_sale_promo_banner_module_default()).saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (spring_sale_promo_banner_module_default()).text,
                children: [
                    "Up to \xa32000 off",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: ()=>handleOnClick("selected EV"),
                        children: "selected EVs"
                    }),
                    " ",
                    "plus \xa3500 charging on us with cinchCharge. Ends 4pm 20/03, T&Cs apply.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/offers",
                        onClick: ()=>handleOnClick("find out more"),
                        children: "Find out more"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var spring_sale_promo_banner = (SpringSalePromoBanner);

// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/winter-sale/winter-sale.module.css
var winter_sale_module = __webpack_require__(46890);
var winter_sale_module_default = /*#__PURE__*/__webpack_require__.n(winter_sale_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/winter-sale/winter-sale.tsx



function WinterSaleBanner({ sendDigitalDataEvent  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    const handleOnClick = ()=>{
        const data = {
            event: {
                name: "click",
                category: "winter flash sale",
                action: "shop cars on offer",
                label: "hero"
            }
        };
        // TECHDEBT - currently this only fires *some* of the time,
        // there is a ticket SCD-284 to fix it and make it more accurate
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Winter sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (winter_sale_module_default()).saveTag,
                children: "SAVE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (winter_sale_module_default()).text,
                children: [
                    "Save up to ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "\xa31000"
                    }),
                    " on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/find-vehicle?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    ". Discount varies by car.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/policies/winter-sale",
                        children: "T&Cs apply."
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var winter_sale = (WinterSaleBanner);

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/winter-sale/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui-promo-banner/src/lib/xmas/xmas-promo-banner.module.css
var xmas_promo_banner_module = __webpack_require__(42871);
var xmas_promo_banner_module_default = /*#__PURE__*/__webpack_require__.n(xmas_promo_banner_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/xmas/xmas-promo-banner.tsx


function XmasPromoBanner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (xmas_promo_banner_module_default()).text,
        children: [
            "Get your skates on and order by December 16 for Christmas delivery.",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/support#faq-christmas",
                className: (xmas_promo_banner_module_default()).link,
                children: "View delivery FAQs"
            })
        ]
    });
}
/* harmony default export */ var xmas_promo_banner = (XmasPromoBanner);

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/xmas/index.tsx


;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/lib/shared-ui-promo-banner.tsx












function SharedPromoBanner(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_src/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner, {
            ...props
        })
    });
}
function PromoBanner({ name , sendDigitalDataEvent , className  }) {
    const { trackEvent  } = (0,segment_src/* useCustomerData */.LE)();
    (0,react.useEffect)(()=>{
        trackEvent({
            type: "track",
            eventName: "Promotion Viewed",
            data: {
                name,
                position: "top banner"
            }
        });
    }, []);
    const ComponentMap = new Map([
        [
            "sale",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sale_promo_banner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "xmas",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(xmas_promo_banner, {})
        ],
        [
            "info",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(info_banner, {})
        ],
        [
            "winter-sale",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(winter_sale, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "blackFriday",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(black_friday_banner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "deposit-contribution",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(deposit_contribution, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ],
        [
            "spring-sale",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spring_sale_promo_banner, {
                sendDigitalDataEvent: sendDigitalDataEvent
            })
        ]
    ]);
    const Child = ComponentMap.get(name);
    if (!Child) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((shared_ui_promo_banner_module_default()).container, className, {
            [(shared_ui_promo_banner_module_default()).depositContributionContainer]: name === "deposit-contribution",
            [(shared_ui_promo_banner_module_default()).containerInfo]: name === "info" || name === "spring-sale"
        }),
        children: Child
    });
}

;// CONCATENATED MODULE: ../../../libs/shared/ui-promo-banner/src/index.ts


// EXTERNAL MODULE: ../../../libs/shared/zendesk-messenger/src/index.ts + 4 modules
var zendesk_messenger_src = __webpack_require__(5874);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var node_modules_axios = __webpack_require__(43653);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ../../../libs/data/search/src/index.ts + 20 modules
var search_src = __webpack_require__(15993);
// EXTERNAL MODULE: ../../../libs/data/user/src/index.ts + 9 modules
var user_src = __webpack_require__(47453);
// EXTERNAL MODULE: ../../../node_modules/swr/core/dist/index.mjs
var core_dist = __webpack_require__(24126);
;// CONCATENATED MODULE: ../../../libs/data/favourites/src/lib/hooks/use-favourite-vehicles.hook.tsx




const useFavouriteVehicles = (withVehicleData = false)=>{
    var ref;
    const { setStatus , status  } = (0,user_src/* useUserStore */.LM)();
    const { data: favouritesData , error: favouritesError , mutate: mutateFavourites  } = (0,core_dist/* default */.ZP)(status === "valid" && FAVOURITES_URL, user_src/* fetcher */._i);
    const directFavouritesTokenExpired = (0,user_src/* hasTokenExpired */._d)(favouritesError);
    if (directFavouritesTokenExpired) {
        setStatus("expired");
    }
    const favouritesAmount = (favouritesData === null || favouritesData === void 0 ? void 0 : (ref = favouritesData.favouriteVehicles) === null || ref === void 0 ? void 0 : ref.length) ?? 0;
    const { data: vehicleData , error: vehicleDetailsError  } = (0,core_dist/* default */.ZP)(()=>{
        return withVehicleData && !!favouritesAmount ? `${search_src/* constants.VEHICLE_SEARCH_URL */._G.Eb}?vehicleIds=${favouritesData === null || favouritesData === void 0 ? void 0 : favouritesData.favouriteVehicles.map(({ vehicleId  })=>vehicleId).join(",")}&excludeUnavailable=false&queryOnly=true` : null;
    }, user_src/* fetcher */._i);
    const favouriteVehiclesTokenExpired = (0,user_src/* hasTokenExpired */._d)(favouritesError);
    if (favouriteVehiclesTokenExpired) {
        setStatus("expired");
    }
    return {
        favouritesData,
        favouritesAmount,
        favouritesError,
        vehicleData,
        vehicleDetailsError,
        mutateFavourites
    };
};

;// CONCATENATED MODULE: ../../../libs/data/favourites/src/lib/hooks/index.ts


;// CONCATENATED MODULE: ../../../libs/data/favourites/src/index.ts



// types

// hooks

// endpoints
const USER_PROFILE_URL = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ProfileServiceUrl */.X.ProfileServiceUrl);
const FAVOURITES_URL = `${USER_PROFILE_URL}/favourites`;
const src_useFavouritesStore = (0,esm/* create */.Ue)((set)=>({
        addFavourite: async (vehicleId)=>{
            const addFavouritesReq = await axios_default().post(FAVOURITES_URL, {
                vehicleId
            });
            set(()=>({
                    favourites: addFavouritesReq.data.favouriteVehicles
                }));
        },
        removeFavourite: async (vehicleId)=>{
            const removeFavouritesReq = await axios_default()["delete"](FAVOURITES_URL, {
                data: {
                    vehicleId
                }
            });
            set(()=>({
                    favourites: removeFavouritesReq.data.favouriteVehicles
                }));
        },
        fetchFavourites: async (withVehicleData)=>{
            try {
                const favouritesReq = await axios_default().get(`${FAVOURITES_URL}?withVehicleData=${withVehicleData ? "true" : "false"}`);
                set(()=>({
                        favourites: favouritesReq.data.favouriteVehicles,
                        favouritesError: undefined,
                        fetchFavouritesStatus: "valid"
                    }));
            } catch (error) {
                let errorMessage = "Unable to fetch favourites";
                if (axios_default().isAxiosError(error)) {
                    errorMessage = `Favourites error: ${error.status}, ${error.message}`;
                }
                set(()=>({
                        favouritesError: errorMessage,
                        fetchFavouritesStatus: "invalid"
                    }));
            }
        },
        favourites: [],
        favouritesError: undefined,
        fetchFavouritesStatus: "pending"
    }));

// EXTERNAL MODULE: ../../../libs/data/orders/src/index.ts + 16 modules
var orders_src = __webpack_require__(2388);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/footer-link/footer-link.tsx


const FooterLink = ({ href , label  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
        href: href,
        isOnlyWhite: true,
        hasNoLine: false,
        textProps: {
            fontWeight: index_esm/* TextFontWeights.semibold */.Ax.semibold,
            fontSize: "s"
        },
        children: label
    });
/* harmony default export */ var footer_link = (FooterLink);

// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/footer-links-list/footer-links-list.module.css
var footer_links_list_module = __webpack_require__(81528);
var footer_links_list_module_default = /*#__PURE__*/__webpack_require__.n(footer_links_list_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/footer-links-list/footer-links-list.tsx



const FooterLinksList = ({ links  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (footer_links_list_module_default()).links,
        children: links.map(({ label , href  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (footer_links_list_module_default()).link,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_link, {
                    label: label,
                    href: href
                })
            }, label))
    });
/* harmony default export */ var footer_links_list = (FooterLinksList);

;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/assets/chat.svg
var _g;
function chat_extends() { chat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_extends.apply(this, arguments); }

const SvgChat = props => /*#__PURE__*/react.createElement("svg", chat_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 26"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
  d: "M23.654 0H3.334A3.43 3.43 0 0 0 .002 3.282L0 17.258l.013.19a3.429 3.429 0 0 0 3.333 3.134l2.628-.002v3.766l.006.112a1 1 0 0 0 1.553.717l6.819-4.595h9.313A3.43 3.43 0 0 0 27 17.3V3.282A3.423 3.423 0 0 0 23.654 0zM3.37 2H23.5c.814-.026 1.469.583 1.5 1.364v13.894c-.03.704-.63 1.298-1.37 1.323h-9.584l-.119.007a1 1 0 0 0-.44.164l-5.513 3.714v-2.885a1 1 0 0 0-1-1H3.5c-.814.026-1.469-.583-1.5-1.364V3.323c.03-.704.63-1.298 1.37-1.323z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M13.5 8.716a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
}))));
/* harmony default export */ var chat = (SvgChat);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/assets/mail.svg
var mail_g;
function mail_extends() { mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mail_extends.apply(this, arguments); }

const SvgMail = props => /*#__PURE__*/react.createElement("svg", mail_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.256 24.776"
}, props), mail_g || (mail_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}, /*#__PURE__*/react.createElement("path", {
  d: "M4.24 1h22.776a2.855 2.855 0 0 1 2.847 2.847v17.082a2.855 2.855 0 0 1-2.847 2.847H4.24a2.855 2.855 0 0 1-2.847-2.847V3.847A2.855 2.855 0 0 1 4.24 1Z"
}), /*#__PURE__*/react.createElement("path", {
  d: "m29.863 3.847-14.235 9.965L1.393 3.847"
}))));
/* harmony default export */ var mail = (SvgMail);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/assets/phone.svg
var phone_path;
function phone_extends() { phone_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_extends.apply(this, arguments); }

const SvgPhone = props => /*#__PURE__*/react.createElement("svg", phone_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 28"
}, props), phone_path || (phone_path = /*#__PURE__*/react.createElement("path", {
  d: "M6.972 1.299a3.395 3.395 0 0 1 3.396 2.924 14.31 14.31 0 0 0 .783 3.136 3.388 3.388 0 0 1-.769 3.58l-.967.965.069.11a18.131 18.131 0 0 0 5.585 5.575l.112.069.974-.971a3.4 3.4 0 0 1 3.368-.833l.208.07c1.015.378 2.07.64 3.152.783 1.706.238 2.962 1.717 2.921 3.415v3.58a3.392 3.392 0 0 1-3.717 3.385A24.705 24.705 0 0 1 11.33 23.27a24.305 24.305 0 0 1-7.48-7.465A24.626 24.626 0 0 1 .015 4.994a3.391 3.391 0 0 1 3.374-3.695zm.022 2H3.39a1.392 1.392 0 0 0-1.386 1.499 22.621 22.621 0 0 0 3.528 9.925 22.327 22.327 0 0 0 6.876 6.863 22.7 22.7 0 0 0 9.877 3.511 1.392 1.392 0 0 0 1.518-1.393v-3.606a1.388 1.388 0 0 0-1.19-1.41 16.395 16.395 0 0 1-3.582-.89 1.398 1.398 0 0 0-1.469.309l-1.52 1.517a1 1 0 0 1-1.2.162 20.131 20.131 0 0 1-7.556-7.542 1 1 0 0 1 .163-1.203l1.516-1.513c.382-.385.504-.957.312-1.467a16.29 16.29 0 0 1-.891-3.566 1.392 1.392 0 0 0-1.393-1.196zM16.68 4.9a6.979 6.979 0 0 1 5.514 5.512 1 1 0 1 1-1.962.384 4.979 4.979 0 0 0-3.934-3.932A1 1 0 0 1 16.68 4.9zM16.482.104l.116.006a11.761 11.761 0 0 1 10.4 10.366 1 1 0 1 1-1.988.226 9.761 9.761 0 0 0-8.63-8.604 1 1 0 0 1 .102-1.994z"
})));
/* harmony default export */ var phone = (SvgPhone);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/assets/whats-app.svg
var whats_app_path;
function whats_app_extends() { whats_app_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return whats_app_extends.apply(this, arguments); }

const SvgWhatsApp = props => /*#__PURE__*/react.createElement("svg", whats_app_extends({
  fill: "#fff",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}, props), whats_app_path || (whats_app_path = /*#__PURE__*/react.createElement("path", {
  d: "M1.766 18.581A12.384 12.384 0 0 1 12.552 0a12.4 12.4 0 0 1 8.805 3.633A12.283 12.283 0 0 1 25 12.4a12.436 12.436 0 0 1-12.448 12.385h-.005A12.484 12.484 0 0 1 6.6 23.277L0 25zm5.516 2.677a10.369 10.369 0 0 0 5.266 1.435A10.336 10.336 0 0 0 22.9 12.4 10.323 10.323 0 0 0 12.558 2.1a10.293 10.293 0 0 0-8.77 15.768l.246.39-1.045 3.8L6.9 21.035zm7.3-3.094a17.93 17.93 0 0 1-1.773-.652A13.839 13.839 0 0 1 7.5 12.838a6.006 6.006 0 0 1-1.27-3.2 3.465 3.465 0 0 1 1.086-2.584 1.145 1.145 0 0 1 .829-.387c.207 0 .415 0 .6.011h.07c.181 0 .407 0 .63.53.259.62.881 2.144.959 2.3a.568.568 0 0 1 .026.542 2.112 2.112 0 0 1-.311.516c-.156.181-.327.4-.467.542-.156.154-.318.322-.136.632a9.333 9.333 0 0 0 1.73 2.144 8.5 8.5 0 0 0 2.5 1.536c.311.155.492.129.674-.077s.778-.9.985-1.214.415-.258.7-.155 1.814.852 2.125 1.007.518.232.6.362a2.576 2.576 0 0 1-.181 1.472 3.2 3.2 0 0 1-2.1 1.472 5.108 5.108 0 0 1-.755.059 3.964 3.964 0 0 1-1.21-.182z"
})));
/* harmony default export */ var whats_app = (SvgWhatsApp);
// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/social-link/social-link.module.css
var social_link_module = __webpack_require__(95121);
var social_link_module_default = /*#__PURE__*/__webpack_require__.n(social_link_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-link/social-link.tsx









const getIcon = (label)=>{
    switch(label){
        case "WhatsApp":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_app, {});
            }
        case "Text us":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(chat, {});
            }
        case "Call us":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(phone, {});
            }
        case "Email us":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mail, {});
            }
        default:
            return;
    }
};
const SocialLink = ({ name , linkLabel , href , trackingEvent , target  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const onSocialLinkClick = (0,react.useCallback)(()=>{
        if (trackingEvent) {
            trackEvent(trackingEvent);
        }
    }, [
        trackingEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (social_link_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: href,
            className: (social_link_module_default()).link,
            onClick: onSocialLinkClick,
            rel: "noopener noreferrer",
            target: target,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                    className: (social_link_module_default()).body,
                    fontSize: "s",
                    lineHeight: "body",
                    fontWeight: "semibold",
                    children: [
                        getIcon(name),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (social_link_module_default()).iconName,
                            children: name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    className: (social_link_module_default()).linkLabel,
                    children: linkLabel
                })
            ]
        })
    });
};
/* harmony default export */ var social_link = (SocialLink);

// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/social-link-list/social-link-list.module.css
var social_link_list_module = __webpack_require__(96340);
var social_link_list_module_default = /*#__PURE__*/__webpack_require__.n(social_link_list_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-link-list/social-link-list.tsx



const SocialLinkList = ({ links  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (social_link_list_module_default()).list,
        children: links.map((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(social_link, {
                ...props
            }, props.name))
    });
/* harmony default export */ var social_link_list = (SocialLinkList);

// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link/social-media-link.module.css
var social_media_link_module = __webpack_require__(11361);
var social_media_link_module_default = /*#__PURE__*/__webpack_require__.n(social_media_link_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link/assets/tiktok.tsx

const TikTokIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "m12.53.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
            clipRule: "evenodd",
            fill: "currentColor"
        })
    });

;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link/assets/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link/social-media-link.tsx




const SocialMediaLink = ({ name , href , icon  })=>{
    const youtubeViewBox = "0 0 34 24";
    const defaultViewBox = "0 0 24 24";
    const isYoutube = name === "YouTube";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (social_media_link_module_default()).item,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": name,
            children: icon === "tiktok" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TikTokIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                name: icon,
                color: "pureWhite",
                width: isYoutube ? 34 : 24,
                viewBox: isYoutube ? youtubeViewBox : defaultViewBox
            })
        })
    });
};
/* harmony default export */ var social_media_link = (SocialMediaLink);

// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link-list/social-media-link-list.module.css
var social_media_link_list_module = __webpack_require__(99351);
var social_media_link_list_module_default = /*#__PURE__*/__webpack_require__.n(social_media_link_list_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/social-media-link-list/social-media-link-list.tsx



const SocialMediaLinkList = ({ links  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (social_media_link_list_module_default()).list,
        children: links.map((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(social_media_link, {
                ...props
            }, props.name))
    });
/* harmony default export */ var social_media_link_list = (SocialMediaLinkList);

;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/tracking/index.ts

const createSocialMediaLinkTrackingEvent = (linkName)=>({
        eventName: `request-callback-link-click-event`,
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                name: "click",
                category: "footer",
                action: linkName,
                label: "leads"
            }
        }
    });

;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/data/index.ts

const footerLinks = [
    {
        label: "Used cars",
        href: "/used-cars"
    },
    {
        label: "About us",
        href: "/about-us"
    },
    {
        label: "Customer reviews",
        href: "/customer-reviews"
    },
    {
        label: "Careers",
        href: "https://careers.cinch.co.uk/"
    },
    {
        label: "About delivery",
        href: "/delivery"
    },
    {
        label: "About collections",
        href: "/car-collections"
    },
    {
        label: "Which car should I buy",
        href: "/which-car-should-i-buy"
    },
    {
        label: "About returns",
        href: "/returns"
    },
    {
        label: "Terms of use",
        href: "/terms-of-use"
    },
    {
        label: "Privacy policy",
        href: "/policies/privacy"
    },
    {
        label: "Cookie policy",
        href: "/policies/cookie-policy"
    },
    {
        label: "Gender pay gap report",
        href: "https://www.constellationautomotive.com/corporate-responsibility/gender-pay-gap-report"
    },
    {
        label: "Modern slavery statement",
        href: "/policies/modern-slavery-statement"
    },
    {
        label: "Support",
        href: "/support"
    }
];
const socialLinks = [
    {
        name: "WhatsApp",
        href: "https://wa.me/447831910589",
        linkLabel: "Start a conversation",
        trackingEvent: createSocialMediaLinkTrackingEvent("whatsapp"),
        target: "_blank"
    },
    {
        name: "Text us",
        href: "sms:02033224567",
        linkLabel: "0203 322 4567",
        trackingEvent: createSocialMediaLinkTrackingEvent("textus"),
        target: "_blank"
    },
    {
        name: "Call us",
        href: "tel:03330154101",
        linkLabel: "0333 015 4101",
        trackingEvent: createSocialMediaLinkTrackingEvent("callus"),
        target: "_blank"
    },
    {
        name: "Email us",
        href: "mailto:hello@cinch.co.uk",
        linkLabel: "hello@cinch.co.uk",
        trackingEvent: createSocialMediaLinkTrackingEvent("emailus"),
        target: "_blank"
    }
];
const socialMediaLinks = [
    {
        name: "Instagram",
        href: " https://www.instagram.com/cinchuk/",
        icon: "instagram"
    },
    {
        name: "TikTok",
        href: "https://www.tiktok.com/@cinchuk",
        icon: "tiktok"
    },
    {
        name: "Facebook",
        href: " https://www.facebook.com/cinchuk",
        icon: "facebook"
    },
    {
        name: "LinkedIn",
        href: "https://www.linkedin.com/company/cinchuk",
        icon: "linkedin"
    },
    {
        name: "YouTube",
        href: "https://www.youtube.com/c/cinch",
        icon: "youtube"
    }
];

// EXTERNAL MODULE: ../../../libs/shared/ui-footer/src/lib/shared-ui-footer.module.css
var shared_ui_footer_module = __webpack_require__(81427);
var shared_ui_footer_module_default = /*#__PURE__*/__webpack_require__.n(shared_ui_footer_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/lib/shared-ui-footer.tsx










function SharedUiFooter({ showFooterBorderRadius =true  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classnames_default()((shared_ui_footer_module_default()).footer, {
            [(shared_ui_footer_module_default()).noBorderRadius]: !showFooterBorderRadius
        }),
        id: "main-footer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shared_ui_footer_module_default()).footerContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                    element: "h2",
                    className: (shared_ui_footer_module_default()).heading,
                    fontSize: "m",
                    lineHeight: "body",
                    fontWeight: "bold",
                    children: [
                        "Need a hand?",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            element: "span",
                            className: (shared_ui_footer_module_default()).subHeading,
                            fontSize: "s",
                            lineHeight: "body",
                            children: "Call, email or WhatsApp, we’re here to help."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(social_link_list, {
                    links: socialLinks
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shared_ui_footer_module_default()).appStoreButtons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.IOSAppStoreUrl */.X.IOSAppStoreUrl),
                            "aria-label": "app store badge",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://a.storyblok.com/f/132543/384x114/7266ad02b3/download-app-store.png",
                                height: 48,
                                width: 164,
                                alt: "Download on the app store"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AndroidAppStoreUrl */.X.AndroidAppStoreUrl),
                            "aria-label": "google play badge",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://a.storyblok.com/f/132543/564x168/9d227fc037/google-play-badge1.png",
                                height: 48,
                                width: 164,
                                alt: "Get it on google play"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "p",
                    className: (shared_ui_footer_module_default()).body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "Cinch Cars Limited is an appointed representative of ITC Compliance Limited which is authorised and regulated by the Financial Conduct Authority (their registration number is 313486). Permitted activities include advising on and arranging general insurance contracts and acting as a credit broker not a lender."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "p",
                    className: (shared_ui_footer_module_default()).body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "We can introduce you to a limited number of finance providers. We do not charge fees for our Consumer Credit services. We typically receive a payment(s) or other benefits from finance providers should you decide to enter into an agreement with them, typically either a fixed fee or a fixed percentage of the amount you borrow. The payment we receive may vary between finance providers and product types. The payment received does not impact the finance rate offered."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "p",
                    className: (shared_ui_footer_module_default()).body,
                    fontSize: "s",
                    fontWeight: "light",
                    lineHeight: "body",
                    children: "All finance applications are subject to status, terms and conditions apply, UK residents only, 18’s or over. Guarantees may be required."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_links_list, {
                    links: footerLinks
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(social_media_link_list, {
                    links: socialMediaLinks
                })
            ]
        })
    });
}
/* harmony default export */ var shared_ui_footer = ((/* unused pure expression or super */ null && (SharedUiFooter)));

;// CONCATENATED MODULE: ../../../libs/shared/ui-footer/src/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/breadcrumbs/breadcrumbs.module.css
var breadcrumbs_module = __webpack_require__(21377);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/breadcrumbs/breadcrumbs.tsx





const Breadcrumbs = ({ breadcrumbs  })=>{
    const linkableCrumbs = breadcrumbs.filter((el, idx)=>idx !== breadcrumbs.length - 1);
    const lastCrumb = breadcrumbs[breadcrumbs.length - 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(json_ld_script/* JsonLdScript */.H, {
                schema: (0,structured_data/* formatBreadcrumbListSchema */._y)(breadcrumbs)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isSlim: true,
                className: {
                    inner: (breadcrumbs_module_default()).wrapper
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (breadcrumbs_module_default()).list,
                    "data-testid": "bread-crumbs",
                    children: [
                        linkableCrumbs.map((crumb)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (breadcrumbs_module_default()).listItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: crumb.url,
                                    children: crumb.text
                                })
                            }, crumb.text)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumbs_module_default()).listItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: lastCrumb.text
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var breadcrumbs = (Breadcrumbs);

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/layout/layout.module.css
var layout_module = __webpack_require__(19523);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/generic-hero/generic-hero.module.css
var generic_hero_module = __webpack_require__(67536);
var generic_hero_module_default = /*#__PURE__*/__webpack_require__.n(generic_hero_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/generic-hero/generic-hero.tsx










const GenericHero = (blok)=>{
    const { title , body , image  } = blok;
    const hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    const [isAppRoute, setIsAppRoute] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsAppRoute(window.location.pathname.includes("/app"));
    }, []);
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = (label, value)=>{
        trackEvent({
            eventName: "App footer links",
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "app cta",
                    label: label,
                    action: "view",
                    value: value
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        isSlim: true,
        className: {
            inner: classnames_default()(hasImageFilename ? (generic_hero_module_default()).root : (generic_hero_module_default()).singleTitleWrapper, {
                [(generic_hero_module_default()).singleTitleWrapper]: !hasImageFilename,
                [(generic_hero_module_default()).appRoot]: isAppRoute
            })
        },
        children: [
            hasImageFilename && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((generic_hero_module_default()).imageWrapper, {
                    [(generic_hero_module_default()).appImageWrapper]: isAppRoute
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((generic_hero_module_default()).heroContent, {
                    [(generic_hero_module_default()).appHeroContent]: isAppRoute
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h1",
                        className: classnames_default()((generic_hero_module_default()).title, {
                            [(generic_hero_module_default()).appTitle]: isAppRoute
                        }),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: classnames_default()((generic_hero_module_default()).body, {
                            [(generic_hero_module_default()).appBody]: isAppRoute
                        }),
                        children: body
                    }),
                    isAppRoute && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (generic_hero_module_default()).appHeroButtons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.IOSAppStoreUrl */.X.IOSAppStoreUrl),
                                "aria-label": "app store badge",
                                onClick: ()=>handleClick("apple", "app store"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "https://a.storyblok.com/f/132543/384x114/7266ad02b3/download-app-store.png",
                                    height: 48,
                                    width: 164
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AndroidAppStoreUrl */.X.AndroidAppStoreUrl),
                                onClick: ()=>handleClick("android", "google play"),
                                "aria-label": "google play badge",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "https://a.storyblok.com/f/132543/564x168/9d227fc037/google-play-badge1.png",
                                    height: 48,
                                    width: 164
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/generic-hero/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/hero-with-rich-text/hero-with-rich-text.module.css
var hero_with_rich_text_module = __webpack_require__(60713);
var hero_with_rich_text_module_default = /*#__PURE__*/__webpack_require__.n(hero_with_rich_text_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/hero-with-rich-text/hero-with-rich-text.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-no-target-blank */ 






const HeroWithRichText = (blok)=>{
    const { title , body , image  } = blok;
    const hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    const contentBodyText = rich_text_renderer(body);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        isSlim: true,
        className: {
            inner: classnames_default()(hasImageFilename ? (hero_with_rich_text_module_default()).root : (hero_with_rich_text_module_default()).singleTitleWrapper, {
                [(hero_with_rich_text_module_default()).singleTitleWrapper]: !hasImageFilename
            })
        },
        children: [
            hasImageFilename && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (hero_with_rich_text_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (hero_with_rich_text_module_default()).heroContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h1",
                        className: (hero_with_rich_text_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (hero_with_rich_text_module_default()).body,
                        children: contentBodyText
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/hero-with-rich-text/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/store-hero/store-hero.module.css
var store_hero_module = __webpack_require__(3397);
var store_hero_module_default = /*#__PURE__*/__webpack_require__.n(store_hero_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/store-hero/store-hero.tsx






const StoreHero = (blok)=>{
    const { title , subtitle , image , address , telephoneNumber  } = blok;
    const hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        isSlim: true,
        className: {
            inner: (store_hero_module_default()).root
        },
        children: [
            hasImageFilename && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (store_hero_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_hero_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h1",
                        className: (store_hero_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (store_hero_module_default()).body,
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (store_hero_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                        className: (store_hero_module_default()).contactInformation,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (store_hero_module_default()).contactItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                        name: "location",
                                        size: 24,
                                        className: (store_hero_module_default()).svg
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        children: address
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (store_hero_module_default()).contactItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                        name: "phone",
                                        size: 24,
                                        className: (store_hero_module_default()).svg
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        children: telephoneNumber
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/store-hero/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/variants/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/hero.tsx


const Hero = ({ heroProps  })=>{
    switch(heroProps === null || heroProps === void 0 ? void 0 : heroProps.component){
        case "GenericHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericHero, {
                ...heroProps
            });
        case "CarFinanceHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroWithRichText, {
                ...heroProps
            });
        case "StoreHero":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHero, {
                ...heroProps
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hero/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/mobile-app-legal-footer/mobile-app-legal-footer.module.css
var mobile_app_legal_footer_module = __webpack_require__(13683);
var mobile_app_legal_footer_module_default = /*#__PURE__*/__webpack_require__.n(mobile_app_legal_footer_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/mobile-app-legal-footer/mobile-app-legal-footer.component.tsx




const APP_VIEW_LEGAL_TEXT = "Cinch Cars Limited is an appointed representative of ITC Compliance " + "Limited which is authorised and regulated by the Financial Conduct " + "Authority (their registration number is 313486). Permitted activities " + "include acting as a credit broker not a lender. For further details " + "visit cinch.co.uk. Representative APR {indicativeApr}. Trade-in value of " + "your car must be higher than outstanding finance amount. T&Cs & " + "exclusions apply.";
const INDICATIVE_APR = "11.4%";
//TODO: This was a copy+paste from the PD shared components. It could be moved to the shared components.
const MobileAppLegalFooter = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (mobile_app_legal_footer_module_default()).legalFooterContainer,
        "data-testid": "mobile-app-legal-footer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            element: "p",
            fontSize: "s",
            fontWeight: "light",
            lineHeight: "body",
            children: (0,src/* interpolateI18n */.uR)(APP_VIEW_LEGAL_TEXT, {
                indicativeApr: INDICATIVE_APR
            })
        })
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/mobile-app-legal-footer/index.tsx


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/layout/layout.tsx















// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries






function Layout({ children , breadCrumbs , heroProps , showBorderRadius =false , showFooterBorderRadius =true , useVerticalGradient , hasBleed , hasPromoBanner =true  }) {
    var ref;
    const trackEvent = (0,analytics_src/* useAnalytics */.z$)((state)=>state.trackEvent);
    const trackedEvent = (0,react.useRef)(null);
    const [shouldShowCheckoutModal, setShouldShowCheckoutModal] = (0,react.useState)(false);
    const [shouldShowBasketIcon, setShouldShowBasketIcon] = (0,react.useState)(false);
    const [isHomePage, setIsHomePage] = (0,react.useState)(false);
    const [shouldShowZendeskButton, setShouldShowZendeskButton] = (0,react.useState)(false);
    const { refreshActiveOrder , checkIfVehicleIsReserved , extendOrderExpiryDate , activeOrder , cancelOrder  } = (0,orders_src/* useOrdersStore */.lS)();
    const { isLoggedIn , firstName , email , token  } = (0,user_src/* useUserStore */.LM)((state)=>{
        var ref, ref1;
        return {
            isLoggedIn: state.status === "valid",
            firstName: (ref = state.profile) === null || ref === void 0 ? void 0 : ref.firstName,
            email: (ref1 = state.profile) === null || ref1 === void 0 ? void 0 : ref1.email,
            token: state.token
        };
    });
    const stageName = "production" ?? 0;
    const { favouritesData  } = useFavouriteVehicles();
    const favourites = (0,react.useMemo)(()=>{
        return (favouritesData === null || favouritesData === void 0 ? void 0 : favouritesData.favouriteVehicles) ?? [];
    }, [
        favouritesData
    ]);
    const { fetchFavourites  } = src_useFavouritesStore();
    (0,react.useEffect)(()=>{
        if (!isLoggedIn) return;
        fetchFavourites();
    }, [
        fetchFavourites,
        isLoggedIn
    ]);
    (0,react.useEffect)(()=>{
        if (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.orderRef) {
            setShouldShowBasketIcon(true);
        }
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.orderRef
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const internalAPIs = [
            "landing-www.snc-prod.aws.cinch.co.uk",
            "landing-articles.snc-prod.aws.cinch.co.uk",
            "landing-categories.snc-prod.aws.cinch.co.uk"
        ];
        if (!((ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes("_storyblok")) && !((ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href.endsWith("sitemap.xml")) && internalAPIs.some((p)=>{
            var ref;
            return (ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes(p);
        }) && "production" === "production") {
            window.location.href = `https://www.cinch.co.uk${window.location.pathname ?? ""}`;
        }
        if (window.location.pathname === "/") {
            setIsHomePage(true);
        }
    }, []);
    const { vw  } = (0,src/* useViewport */.Sj)({
        updateOnOrientationChange: true,
        updateOnResize: true
    });
    (0,react.useEffect)(()=>{
        if (window.location.pathname.startsWith("/used-cars/") && vw < 768) {
            setShouldShowZendeskButton(false);
        } else setShouldShowZendeskButton(true);
    }, [
        vw
    ]);
    const handleShouldShowBasketIcon = (0,react.useCallback)(()=>{
        setShouldShowBasketIcon(!shouldShowBasketIcon);
    }, [
        shouldShowBasketIcon
    ]);
    const handleCheckoutVisibility = (0,react.useCallback)(()=>{
        setShouldShowCheckoutModal(!shouldShowCheckoutModal);
    }, [
        shouldShowCheckoutModal
    ]);
    const handleTrackEvent = (0,react.useCallback)((data)=>{
        const trackedValue = `${data.label} ${data.action}`;
        if (trackedValue !== trackedEvent.current) {
            trackEvent({
                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                eventName: data.name,
                data: {
                    event: data
                }
            });
            trackedEvent.current = trackedValue;
            return;
        }
        if (trackedEvent.current !== null) {
            trackedEvent.current = null;
        }
    }, [
        trackEvent
    ]);
    const handleCancelOrder = async (orderid, cancelOrderReason, token)=>{
        setShouldShowBasketIcon(false);
        return await cancelOrder(orderid, cancelOrderReason, token);
    };
    const { timeRemainingInSeconds , isExpiringSoon  } = (0,src/* checkoutTimes */.iP)(activeOrder);
    const gapMenuItemShown = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.GapInsuranceFlag */.X.GapInsuranceFlag) === "true";
    const updatedCinchCareCopy = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ServicingAndWarrantyFlag */.X.ServicingAndWarrantyFlag) === "true";
    const IS_MOBILE_APP =  true && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !IS_MOBILE_APP && hasPromoBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedPromoBanner, {
                name: "sale",
                sendDigitalDataEvent: analytics_src/* sendDigitalDataEvent */.Ym
            }),
            !IS_MOBILE_APP && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((layout_module_default()).headerContainer, {
                    [(layout_module_default()).verticalGradient]: useVerticalGradient,
                    [(layout_module_default()).borderRadiusHeader]: showBorderRadius,
                    [(layout_module_default()).headerHasBleed]: hasBleed
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUiHeaderV2, {
                    handleTrackEvent: handleTrackEvent,
                    setIsCheckoutModalVisible: handleCheckoutVisibility,
                    isCheckoutModalVisible: shouldShowCheckoutModal,
                    stageName: stageName,
                    isLoggedIn: isLoggedIn,
                    accessToken: (token === null || token === void 0 ? void 0 : token.access_token) || "",
                    firstName: firstName,
                    email: email,
                    favourites: favourites,
                    refreshActiveOrder: refreshActiveOrder,
                    activeOrder: activeOrder || undefined,
                    shouldShowBasketIcon: shouldShowBasketIcon,
                    isGapMenuItemShown: gapMenuItemShown,
                    isUpdatedCinchCareCopy: updatedCinchCareCopy,
                    checkoutModal: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnToCheckoutModal, {
                        activeOrder: activeOrder || undefined,
                        lastVisitedCheckoutStage: (0,src/* getLastCheckoutStage */.nk)(activeOrder),
                        onClose: ()=>setShouldShowCheckoutModal(!shouldShowCheckoutModal),
                        handleShouldShowBasketIcon: handleShouldShowBasketIcon,
                        timeRemainingInSeconds: timeRemainingInSeconds,
                        withinExpiryTimeWindow: !!isExpiringSoon,
                        adminFeeFlag: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeReturnToCheckout */.X.AdminFeeReturnToCheckout) === "true",
                        adminFeeValueInPence: Number((0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeValue */.X.AdminFeeValue)),
                        cancelOrder: cancelOrder,
                        isLoggedIn: isLoggedIn,
                        accessToken: (token === null || token === void 0 ? void 0 : token.access_token) || "",
                        refreshActiveOrder: refreshActiveOrder,
                        checkIfVehicleIsReserved: checkIfVehicleIsReserved,
                        extendOrderExpiryDate: extendOrderExpiryDate,
                        trackEvent: trackEvent
                    }),
                    children: !IS_MOBILE_APP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                        heroProps: heroProps
                    }) : null
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                id: "main-content",
                className: classnames_default()({
                    [(layout_module_default()).borderRadiusMain]: showBorderRadius,
                    [(layout_module_default()).borderRadiusHome]: isHomePage
                }),
                children: [
                    breadCrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs, {
                        breadcrumbs: breadCrumbs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Gradient */.ph, {}),
                    children
                ]
            }),
            shouldShowZendeskButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(zendesk_messenger_src/* ZendeskChatButton */.wV, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                activeOrder: activeOrder,
                extendOrderExpiry: extendOrderExpiryDate,
                refreshActiveOrder: refreshActiveOrder,
                sendDigitalDataEvent: analytics_src/* sendDigitalDataEvent */.Ym,
                reportDatadogError: (error, ctx)=>main/* datadogRum.addError */.v.addError(error, ctx),
                accessToken: token === null || token === void 0 ? void 0 : token.access_token,
                adminFeeFlag: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeReturnToCheckout */.X.AdminFeeReturnToCheckout) === "true",
                adminFeeValueInPence: Number((0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeValue */.X.AdminFeeValue)),
                cancelOrder: handleCancelOrder
            }),
            IS_MOBILE_APP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileAppLegalFooter, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedUiFooter, {
                showFooterBorderRadius: showFooterBorderRadius
            })
        ]
    });
}
/* harmony default export */ var layout = ((/* unused pure expression or super */ null && (Layout)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/content-section/content-section.tsx





const ContentSection = (blok)=>{
    const { heading , body , image  } = blok;
    const [CTA] = (blok === null || blok === void 0 ? void 0 : blok.CTA) || [];
    return /*#__PURE__*/ _jsxs("section", {
        ...storyblokEditable(blok),
        className: styles.wrapper,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill"
                })
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textWrapper,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h2",
                        className: styles.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        element: "p",
                        className: styles.body,
                        children: body
                    }),
                    CTA ? /*#__PURE__*/ _jsx(Secondary, {
                        ...storyblokEditable(CTA),
                        href: CTA.url,
                        classNames: {
                            button: styles.button
                        },
                        children: CTA.text
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var content_section = ((/* unused pure expression or super */ null && (ContentSection)));

// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/head/head.tsx



const withTitleSuffix = (title)=>title.includes("- cinch") ? title : `${title} - cinch`;
const LandingHead = ({ title , fallbackTitle , description , fallbackDescription , canonicalUrl , robots , openGraph , twitterCard , generatedAt , HowTo  })=>{
    const router = (0,next_router.useRouter)();
    const ogData = openGraph === null || openGraph === void 0 ? void 0 : openGraph[0];
    const twitterCardData = twitterCard === null || twitterCard === void 0 ? void 0 : twitterCard[0];
    const pathname = (router === null || router === void 0 ? void 0 : router.asPath) ?? "";
    canonicalUrl = !canonicalUrl ? `https://www.cinch.co.uk${pathname.split("?")[0]}` : canonicalUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: withTitleSuffix(title || fallbackTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description || fallbackDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: (robots === null || robots === void 0 ? void 0 : robots.join(", ")) || "all"
            }, "robots"),
            generatedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "page_generated_at",
                content: `${generatedAt}`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon-32x32-bfc05e34c2d7531ace62bdb1cc158dfe.png"
            }),
            ((ogData === null || ogData === void 0 ? void 0 : ogData.title) || (ogData === null || ogData === void 0 ? void 0 : ogData.type)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.type) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: ogData.type
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: ogData.title
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: ogData.description
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: ogData.imageUrl
            }),
            (ogData === null || ogData === void 0 ? void 0 : ogData.imageAlt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:alt",
                content: ogData.imageAlt
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: twitterCardData.card
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "@cinchuk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:domain",
                content: "cinch.co.uk"
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.card) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: `https://www.cinch.co.uk${pathname}`
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.title
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.description
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageUrl
            }),
            (twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image:alt",
                content: twitterCardData === null || twitterCardData === void 0 ? void 0 : twitterCardData.imageAlt
            }),
             true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "sitemap",
                        type: "application/xml",
                        href: "/sitemap.xml"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/manifest.webmanifest",
                        crossOrigin: "anonymous"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var head_head = (LandingHead);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/buttons/primary/primary.tsx




const primary_Primary = ({ className , children , ...rest })=>/*#__PURE__*/ _jsx(DSPrimary, {
        classNames: {
            button: cx(styles.root, className)
        },
        ...rest,
        children: children
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/buttons/secondary/secondary.tsx




const secondary_Secondary = ({ className , children , innerRef , ...rest })=>/*#__PURE__*/ _jsx(DSSecondary, {
        classNames: {
            button: cx(styles.root, className)
        },
        ...rest,
        ref: innerRef,
        children: children
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/buttons/index.ts



;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/hub-header/header/header.tsx



const GenericHubPageHeader = ({ title , subtitle  })=>/*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                fontWeight: "bold",
                fontSize: "4xl",
                lineHeight: "display",
                element: "h1",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.subtitle,
                fontWeight: "medium",
                fontSize: "l",
                children: subtitle
            })
        ]
    });
/* harmony default export */ var header = ((/* unused pure expression or super */ null && (GenericHubPageHeader)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/hub-header/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/hub-card-skeleton/hub-card-skeleton.tsx





const HubCardSkeleton = ({ featured , hasDate =false  })=>{
    const prefersReducedMotion = usePrefersReducedMotion();
    return /*#__PURE__*/ _jsxs(Box, {
        className: cx(styles.root, {
            [styles.featured]: featured
        }),
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                sx: {
                    marginRight: "16px"
                },
                animation: prefersReducedMotion ? false : "wave",
                variant: "rectangular",
                width: featured ? 400 : 250,
                height: featured ? 253 : 158
            }),
            /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 400 : 125
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "text",
                        height: 24,
                        width: hasDate ? 125 : 400
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/hub-card-skeleton/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/storyblok-rich-text/rich-text-section.component.tsx





const RichTextSection = (blok)=>{
    if (Object.keys(blok).length === 0) {
        return null;
    }
    const { title , body , quote  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                title: title || "",
                children: rich_text_renderer(body)
            }),
            quote ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Quote */.pu, {
                text: quote
            }) : null
        ]
    });
};
/* harmony default export */ var rich_text_section_component = (RichTextSection);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/storyblok-rich-text/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/full-width-cta/full-width-cta.tsx








const FullWidthCTA = ({ iconName , iconColor , iconGradient , iconSize , title , subtitle , buttonLabel , onButtonClick , img , className  })=>{
    const innerClassNames = classNames(styles.inner, {
        [styles.innerButtonRight]: !img
    });
    return /*#__PURE__*/ _jsx("section", {
        className: cx(styles.fullWidthCta, className),
        children: /*#__PURE__*/ _jsxs("div", {
            className: innerClassNames,
            children: [
                iconName && /*#__PURE__*/ _jsx(SvgIcon, {
                    name: iconName,
                    size: iconSize,
                    color: iconColor ? iconColor : undefined,
                    gradient: iconGradient ? iconGradient : undefined,
                    className: styles.svg
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    className: styles.subtitle,
                                    children: subtitle
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    className: styles.title,
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Primary, {
                            element: "a",
                            onClick: onButtonClick,
                            className: styles.button,
                            children: buttonLabel
                        })
                    ]
                }),
                img && /*#__PURE__*/ _jsx("div", {
                    className: styles.img,
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: img.src,
                        alt: img.alt,
                        width: img.width,
                        height: img.height,
                        layout: "intrinsic"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/shared/table/table.module.css
var table_module = __webpack_require__(20007);
var table_module_default = /*#__PURE__*/__webpack_require__.n(table_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/table/table.component.tsx


const Table = (table)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        className: (table_module_default()).table,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                    children: table.thead.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: heading.value
                        }, heading._uid))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: table.tbody.filter((row)=>!!row.body[0].value).map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: row.body.map((cell)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                children: cell.value
                            }, cell._uid))
                    }, row._uid))
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/table/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/shared/panel/panel.module.css
var panel_module = __webpack_require__(97755);
var panel_module_default = /*#__PURE__*/__webpack_require__.n(panel_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/panel/panel.tsx




const Panel = ({ className ="" , classNames , children , isPadded , title , subtitle  })=>{
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((panel_module_default()).panel, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((panel_module_default()).bodyContent, classNames === null || classNames === void 0 ? void 0 : classNames.body, (panel_module_default()).bodyFlex, {
                [(panel_module_default()).noPadding]: !isPadded
            }),
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    type: index_esm/* TextStyles.menuTitle */.k7.menuTitle,
                    element: "div",
                    className: (panel_module_default()).title,
                    "data-testid": "panel-title",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    type: index_esm/* TextStyles.body2 */.k7.body2,
                    element: "p",
                    "data-testid": "panel-subtitle",
                    children: subtitle
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var panel = (Panel);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/panel/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/image-object/image-object.tsx


const ImageObject = ({ image  })=>/*#__PURE__*/ _jsx("img", {
        src: image.filename,
        alt: image.alt ?? "",
        className: styles.image
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/shared/index.ts











// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/generic-teaser/generic-teaser.module.css
var generic_teaser_module = __webpack_require__(3090);
var generic_teaser_module_default = /*#__PURE__*/__webpack_require__.n(generic_teaser_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/generic-teaser/generic-teaser.tsx





const GenericTeaser = (blok)=>{
    const { title , body  } = blok;
    (0,react.useEffect)(()=>{
        if (title === "test") {
            throw new Error("hell now");
        }
    }, [
        title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading_Heading, {
                className: (generic_teaser_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_Text, {
                children: body
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/stats-section/stats-section.module.css
var stats_section_module = __webpack_require__(34373);
var stats_section_module_default = /*#__PURE__*/__webpack_require__.n(stats_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/stats-section/stats-section.tsx







const StatsSection = (blok)=>{
    const { heading , stats , image , carTotal , trackingEventName  } = blok;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        className: {
            inner: (stats_section_module_default()).statsWrapper
        },
        isSlim: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (stats_section_module_default()).carSectionTitle,
                element: "h2",
                fontSizeFixed: "xl",
                fontWeight: "bold",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (stats_section_module_default()).stats,
                children: [
                    stats.map((stat, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (stats_section_module_default()).stat,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (stats_section_module_default()).statInner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        className: (stats_section_module_default()).statHeading,
                                        children: stat.heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        className: (stats_section_module_default()).statSubHeading,
                                        fontSizeFixed: "m",
                                        fontWeight: "bold",
                                        children: stat.subheading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSizeFixed: "m",
                                        children: stat.body
                                    })
                                ]
                            })
                        }, `car-point-${idx + 1}`)),
                    (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (stats_section_module_default()).statImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image === null || image === void 0 ? void 0 : image.filename,
                            alt: (image === null || image === void 0 ? void 0 : image.alt) || "Side profile of a car",
                            layout: "responsive",
                            width: 1400,
                            height: 597,
                            quality: 100
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                element: "a",
                href: "/used-cars",
                onClick: ()=>{
                    if (trackingEventName) {
                        trackEvent({
                            eventName: trackingEventName,
                            data: {
                                event: {
                                    name: "click",
                                    category: "button",
                                    label: `Browse all cars`
                                }
                            },
                            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE
                        });
                    }
                },
                classNames: {
                    button: (stats_section_module_default()).statsButton
                },
                children: `Browse ${carTotal ?? "all"} cars`
            })
        ]
    });
};
/* harmony default export */ var stats_section = ((/* unused pure expression or super */ null && (StatsSection)));

// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var next_dynamic = __webpack_require__(82070);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/icon/icon.tsx


function StoryblokIcon({ iconName , color ="monochrome-white" , size =24  }) {
    const Icon = dynamic({
        loader: async ()=>{
            const icons = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39957));
            function isIconName(input) {
                return input in icons;
            }
            if (!isIconName(iconName)) {
                return icons.BinIcon;
            }
            const Icon = icons[iconName];
            return Icon;
        },
        ssr: true
    }, {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(39957)
                ]
        },
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(39957)
                ]
        }
    });
    return /*#__PURE__*/ _jsx(Icon, {
        color: color,
        size: size
    });
}

// EXTERNAL MODULE: ../../../libs/design-system/components/icons/src/index.ts + 266 modules
var icons_src = __webpack_require__(39957);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/feature-section/feature-card/feature-card.tsx




const ComponentMap = {
    "arrow-right": /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.LinkIcon, {
        size: 24
    }),
    alert: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.AlertIcon, {
        size: 24
    }),
    card: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.CardIcon, {
        size: 24
    }),
    electric: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.ElectricIcon, {
        size: 24
    }),
    "vehicle-front": /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.MakeModelIcon, {
        size: 24
    }),
    range: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.RangeIcon, {
        size: 24
    })
};
const feature_card_FeatureCard = ({ title , body , icon  })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.card,
        "data-testid": "feature-card",
        children: [
            icon ? ComponentMap[icon] : null,
            /*#__PURE__*/ _jsx(Heading, {
                element: "h3",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/feature-section/feature-section.tsx






const FeatureSection = ({ title , body , cards  })=>/*#__PURE__*/ _jsxs(Wrapper, {
        backgroundColor: "#F2F5FF",
        className: {
            container: styles.container,
            inner: styles.inner
        },
        isFluid: true,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cards,
                children: Array.isArray(cards) && cards.length >= 3 && cards.map((card)=>/*#__PURE__*/ _createElement(FeatureCard, {
                        ...card,
                        key: card.title
                    }))
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-quote/trustpilot-quote.tsx



const TrustPilotQuote = (blok)=>{
    const { quote , author , rating  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...(0,storyblok_src/* storyblokEditable */.LF)(blok),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Quote */.pu, {
            text: quote,
            author: author,
            rating: Number.parseInt(rating, 10)
        })
    });
};
/* harmony default export */ var trustpilot_quote = (TrustPilotQuote);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/stars/assets/stars-4.5.svg
var _style, stars_4_5_path, _path2, _path3, _path4, _path5;
function stars_4_5_extends() { stars_4_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_4_5_extends.apply(this, arguments); }

const SvgStars45 = props => /*#__PURE__*/react.createElement("svg", stars_4_5_extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 512 96",
  style: {
    enableBackground: "new 0 0 512 96"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".st0{fill:#00b67a}.st2{fill:#fff}")), /*#__PURE__*/react.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, /*#__PURE__*/react.createElement("g", null, stars_4_5_path || (stars_4_5_path = /*#__PURE__*/react.createElement("path", {
  id: "Rectangle-path",
  className: "st0",
  d: "M0 0h96v96H0z"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
})), /*#__PURE__*/react.createElement("g", {
  id: "Half"
}, /*#__PURE__*/react.createElement("path", {
  style: {
    fill: "#dcdce6"
  },
  d: "M48 0h48v96H48z",
  transform: "translate(416)"
}), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M0 0h48v96H0z",
  transform: "translate(416)"
}))), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  id: "Shape",
  className: "st2",
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  className: "st2",
  d: "m152 64.7 14.6-3.7 6.1 18.8L152 64.7zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM256 64.7l14.6-3.7 6.1 18.8L256 64.7zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM360 64.7l14.6-3.7 6.1 18.8L360 64.7zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM464 64.7l14.6-3.7 6.1 18.8L464 64.7zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})))));
/* harmony default export */ var stars_4_5 = (SvgStars45);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/stars/assets/stars-4.svg
var stars_4_g;
function stars_4_extends() { stars_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_4_extends.apply(this, arguments); }

const SvgStars4 = props => /*#__PURE__*/react.createElement("svg", stars_4_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), stars_4_g || (stars_4_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#73CF11",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#DCDCE6",
  d: "M416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var stars_4 = (SvgStars4);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/stars/assets/stars-5.svg
var stars_5_g;
function stars_5_extends() { stars_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stars_5_extends.apply(this, arguments); }

const SvgStars5 = props => /*#__PURE__*/react.createElement("svg", stars_5_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), stars_5_g || (stars_5_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#00B67A",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96zM416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var stars_5 = (SvgStars5);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/stars/stars.tsx




const starSVGList = {
    4: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_4, {}),
    4.5: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_4_5, {}),
    5: /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_5, {})
};
function stars_TrustpilotStars({ className , starRating , starRatingLabel  }) {
    const alt = `${starRatingLabel} rating on Trustpilot`;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        "data-testid": "trustpilotStarsDefault",
        children: /*#__PURE__*/ _jsxs("svg", {
            "aria-labelledby": "starRating",
            viewBox: "0 0 512 96",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    id: "starRating",
                    children: alt
                }),
                starSVGList[starRating] ?? /*#__PURE__*/ _jsx(FiveStars, {})
            ]
        })
    });
}
/* harmony default export */ var stars = ((/* unused pure expression or super */ null && (stars_TrustpilotStars)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-score/assets/trustpilot-logo.svg
var trustpilot_logo_path, trustpilot_logo_path2, trustpilot_logo_path3;
function trustpilot_logo_extends() { trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trustpilot_logo_extends.apply(this, arguments); }

const SvgTrustpilotLogo = props => /*#__PURE__*/React.createElement("svg", trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), trustpilot_logo_path || (trustpilot_logo_path = /*#__PURE__*/React.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), trustpilot_logo_path2 || (trustpilot_logo_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), trustpilot_logo_path3 || (trustpilot_logo_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var trustpilot_logo = ((/* unused pure expression or super */ null && (SvgTrustpilotLogo)));
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-score/trustpilot-score.tsx







const TRUSTPILOT_URL = "https://uk.trustpilot.com/review/cinch.co.uk";
function TrustpilotScore({ numberOfReviews , starRating , starRatingLabel , className  }) {
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: {
            container: className
        },
        children: /*#__PURE__*/ _jsx("a", {
            href: TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles["container"],
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        children: [
                            "Check out our ",
                            /*#__PURE__*/ _jsx("b", {
                                children: formatNumber(numberOfReviews)
                            }),
                            " reviews"
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TrustpilotStars, {
                        className: styles["trustpilotStars"],
                        starRatingLabel: starRatingLabel,
                        starRating: starRating
                    }),
                    /*#__PURE__*/ _jsx(TrustpilotLogo, {
                        className: styles["trustpilotLogo"]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var trustpilot_score = ((/* unused pure expression or super */ null && (TrustpilotScore)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/assets/trustpilot-logo.svg
var assets_trustpilot_logo_path, assets_trustpilot_logo_path2, assets_trustpilot_logo_path3;
function assets_trustpilot_logo_extends() { assets_trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assets_trustpilot_logo_extends.apply(this, arguments); }

const trustpilot_logo_SvgTrustpilotLogo = props => /*#__PURE__*/React.createElement("svg", assets_trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), assets_trustpilot_logo_path || (assets_trustpilot_logo_path = /*#__PURE__*/React.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), assets_trustpilot_logo_path2 || (assets_trustpilot_logo_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), assets_trustpilot_logo_path3 || (assets_trustpilot_logo_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var assets_trustpilot_logo = ((/* unused pure expression or super */ null && (trustpilot_logo_SvgTrustpilotLogo)));
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview/trustpilot-overview.tsx






const trustpilot_overview_TRUSTPILOT_URL = "https://uk.trustpilot.com/review/cinch.co.uk";
function TrustpilotOverview({ starRating , starRatingLabel  }) {
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: {
            container: styles["container"],
            inner: styles["inner"]
        },
        "data-testid": "trustpilot-overview-score",
        children: /*#__PURE__*/ _jsxs("a", {
            href: trustpilot_overview_TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            className: styles["link"],
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    className: styles["trustpilotScore"],
                    children: starRatingLabel
                }),
                /*#__PURE__*/ _jsx(TrustpilotStars, {
                    className: styles["trustpilotStars"],
                    starRating: starRating,
                    starRatingLabel: starRatingLabel
                }),
                /*#__PURE__*/ _jsx(TrustpilotLogo, {
                    className: styles["trustpilotLogo"]
                })
            ]
        })
    });
}
/* harmony default export */ var trustpilot_overview = ((/* unused pure expression or super */ null && (TrustpilotOverview)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/assets/trustpilot-logo.svg
var trustpilot_overview_v2_assets_trustpilot_logo_path, trustpilot_overview_v2_assets_trustpilot_logo_path2, trustpilot_overview_v2_assets_trustpilot_logo_path3;
function trustpilot_overview_v2_assets_trustpilot_logo_extends() { trustpilot_overview_v2_assets_trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trustpilot_overview_v2_assets_trustpilot_logo_extends.apply(this, arguments); }

const assets_trustpilot_logo_SvgTrustpilotLogo = props => /*#__PURE__*/react.createElement("svg", trustpilot_overview_v2_assets_trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), trustpilot_overview_v2_assets_trustpilot_logo_path || (trustpilot_overview_v2_assets_trustpilot_logo_path = /*#__PURE__*/react.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), trustpilot_overview_v2_assets_trustpilot_logo_path2 || (trustpilot_overview_v2_assets_trustpilot_logo_path2 = /*#__PURE__*/react.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), trustpilot_overview_v2_assets_trustpilot_logo_path3 || (trustpilot_overview_v2_assets_trustpilot_logo_path3 = /*#__PURE__*/react.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var trustpilot_overview_v2_assets_trustpilot_logo = (assets_trustpilot_logo_SvgTrustpilotLogo);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/stars/assets/stars-4.5.svg
var stars_4_5_style, assets_stars_4_5_path, stars_4_5_path2, stars_4_5_path3, stars_4_5_path4, stars_4_5_path5;
function assets_stars_4_5_extends() { assets_stars_4_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assets_stars_4_5_extends.apply(this, arguments); }

const stars_4_5_SvgStars45 = props => /*#__PURE__*/react.createElement("svg", assets_stars_4_5_extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 512 96",
  style: {
    enableBackground: "new 0 0 512 96"
  },
  xmlSpace: "preserve"
}, props), stars_4_5_style || (stars_4_5_style = /*#__PURE__*/react.createElement("style", null, ".st0{fill:#00b67a}.st2{fill:#fff}")), /*#__PURE__*/react.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, /*#__PURE__*/react.createElement("g", null, assets_stars_4_5_path || (assets_stars_4_5_path = /*#__PURE__*/react.createElement("path", {
  id: "Rectangle-path",
  className: "st0",
  d: "M0 0h96v96H0z"
})), stars_4_5_path2 || (stars_4_5_path2 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
})), /*#__PURE__*/react.createElement("g", {
  id: "Half"
}, /*#__PURE__*/react.createElement("path", {
  style: {
    fill: "#dcdce6"
  },
  d: "M48 0h48v96H48z",
  transform: "translate(416)"
}), stars_4_5_path3 || (stars_4_5_path3 = /*#__PURE__*/react.createElement("path", {
  className: "st0",
  d: "M0 0h48v96H0z",
  transform: "translate(416)"
}))), stars_4_5_path4 || (stars_4_5_path4 = /*#__PURE__*/react.createElement("path", {
  id: "Shape",
  className: "st2",
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})), stars_4_5_path5 || (stars_4_5_path5 = /*#__PURE__*/react.createElement("path", {
  className: "st2",
  d: "m152 64.7 14.6-3.7 6.1 18.8L152 64.7zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM256 64.7l14.6-3.7 6.1 18.8L256 64.7zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM360 64.7l14.6-3.7 6.1 18.8L360 64.7zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM464 64.7l14.6-3.7 6.1 18.8L464 64.7zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"
})))));
/* harmony default export */ var assets_stars_4_5 = (stars_4_5_SvgStars45);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/stars/assets/stars-4.svg
var assets_stars_4_g;
function assets_stars_4_extends() { assets_stars_4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assets_stars_4_extends.apply(this, arguments); }

const stars_4_SvgStars4 = props => /*#__PURE__*/react.createElement("svg", assets_stars_4_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), assets_stars_4_g || (assets_stars_4_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#73CF11",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#DCDCE6",
  d: "M416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var assets_stars_4 = (stars_4_SvgStars4);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/stars/assets/stars-5.svg
var assets_stars_5_g;
function assets_stars_5_extends() { assets_stars_5_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assets_stars_5_extends.apply(this, arguments); }

const stars_5_SvgStars5 = props => /*#__PURE__*/react.createElement("svg", assets_stars_5_extends({
  width: 512,
  height: 96,
  viewBox: "0 0 512 96",
  xmlns: "http://www.w3.org/2000/svg"
}, props), assets_stars_5_g || (assets_stars_5_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/react.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#00B67A",
  d: "M0 0h96v96H0zM104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96zM416 0h96v96h-96z"
}), /*#__PURE__*/react.createElement("path", {
  d: "M48 64.7 62.6 61l6.1 18.8L48 64.7Zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM152 64.7l14.6-3.7 6.1 18.8L152 64.7Zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM256 64.7l14.6-3.7 6.1 18.8L256 64.7Zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM360 64.7l14.6-3.7 6.1 18.8L360 64.7Zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15ZM464 64.7l14.6-3.7 6.1 18.8L464 64.7Zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15Z",
  fill: "#FFF"
})))));
/* harmony default export */ var assets_stars_5 = (stars_5_SvgStars5);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/stars/stars.tsx




const stars_starSVGList = {
    4: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_stars_4, {}),
    4.5: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_stars_4_5, {}),
    5: /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_stars_5, {})
};
function stars_stars_TrustpilotStars({ className , starRating , starRatingLabel  }) {
    const alt = `${starRatingLabel} rating on Trustpilot`;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        "data-testid": "trustpilotStarsDefault",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            "aria-labelledby": "starRating",
            viewBox: "0 0 512 96",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    id: "starRating",
                    children: alt
                }),
                stars_starSVGList[starRating] ?? /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_stars_5, {})
            ]
        })
    });
}
/* harmony default export */ var stars_stars = (stars_stars_TrustpilotStars);

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/trustpilot-overview.module.css
var trustpilot_overview_module = __webpack_require__(9255);
var trustpilot_overview_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_overview_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/datadog-data/actions.ts
var Actions;
(function(Actions) {
    Actions["SELECT_MAKE_OPTION"] = "Select make option";
    Actions["SELECT_MODEL_OPTION"] = "Select model option";
    Actions["CLICK_MONTHLY_PRICE_RADIO"] = "Click monthly price radio button";
    Actions["CLICK_TOTAL_PRICE_RADIO"] = "Click total price radio button";
    Actions["SELECT_MONTHLY_PRICE_OPTION"] = "Select max monthly price option";
    Actions["SELECT_MAX_PRICE_OPTION"] = "Select max total price option";
    Actions["CLICK_SEARCH_CTA"] = "Click Search CTA";
    Actions["CLICK_TRUSTPILOT"] = "Click Trustpilot";
    Actions["CLICK_USP_LINK"] = "Click USP link";
    Actions["CLICK_CAR_REVIEW_CTA_PREFOOTER"] = "Click car review CTA prefooter";
    Actions["CLICK_HMC_LINK_IN_FILTERS_SECTION"] = "Click HMC link in filters section";
})(Actions || (Actions = {}));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/datadog-data/context.ts
var context_Context;
(function(Context) {
    Context["SQUAD"] = "A&E";
    Context["HERO_USP"] = "Hero - USP";
    Context["HERO_TRUSTPILOT"] = "Hero - Trustpilot";
    Context["HERO_SEARCH"] = "Hero - Search";
    Context["CAR_REVIEW"] = "Car Review";
    Context["HERO_HMC"] = "Hero - Help Me Choose";
})(context_Context || (context_Context = {}));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/datadog-data/errors.ts
var Errors;
(function(Errors) {
    Errors["LANDING_ALERTS_FETCH_ERROR_API_ERROR"] = "Landing alerts - Fetch error - API error";
    Errors["LANDING_RESULTS_API_ERROR"] = "Landing Results - API error";
})(Errors || (Errors = {}));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/datadog-data/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/trustpilot-overview-v2/trustpilot-overview.tsx











const trustpilot_overview_v2_trustpilot_overview_TRUSTPILOT_URL = "/customer-reviews";
const handleTrackEvent = ()=>{
    main/* datadogRum.addAction */.v.addAction(Actions.CLICK_TRUSTPILOT, {
        service: context_Context.HERO_TRUSTPILOT,
        squad: context_Context.SQUAD,
        page: "/",
        category: "hero",
        label: "trustpilot"
    });
    (0,analytics_src/* sendDigitalDataEvent */.Ym)({
        event: {
            name: "click",
            category: "hero",
            label: "trustpilot"
        }
    });
};
function trustpilot_overview_TrustpilotOverview({ starRating , starRatingLabel , numberOfReviews , className =""  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
        "data-testid": "trustpilot-overview-score",
        className: {
            container: className
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: trustpilot_overview_v2_trustpilot_overview_TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            className: (trustpilot_overview_module_default()).link,
            onClick: ()=>handleTrackEvent(),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (trustpilot_overview_module_default()).trustpilotScoreWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            className: (trustpilot_overview_module_default()).trustpilotText,
                            children: starRatingLabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_stars, {
                            className: (trustpilot_overview_module_default()).trustpilotStars,
                            starRating: starRating,
                            starRatingLabel: starRatingLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (trustpilot_overview_module_default()).trustpilotScoreWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            className: classnames_default()((trustpilot_overview_module_default()).numberOfReviews, (trustpilot_overview_module_default()).trustpilotScoreMobileOnly),
                            children: (0,src/* formatNumber */.uf)(numberOfReviews)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            className: classnames_default()((trustpilot_overview_module_default()).reviewsOn, (trustpilot_overview_module_default()).trustpilotScoreMobileOnly),
                            children: "reviews on"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_overview_v2_assets_trustpilot_logo, {
                            className: (trustpilot_overview_module_default()).trustpilotLogo
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var trustpilot_overview_v2_trustpilot_overview = (trustpilot_overview_TrustpilotOverview);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/storyblok-renderer/util.tsx



const hasComponent = (componentName, components)=>!!components[componentName];
const isValidBlock = (block)=>{
    return !!(block === null || block === void 0 ? void 0 : block.component) && !!(block === null || block === void 0 ? void 0 : block._uid);
};
const ElementFactory = (block, componentMap, props, componentsWithWrapper)=>{
    if (!isValidBlock(block)) {
        if (block) {
            console.error(`Unable to render malformed block as it is missing the 'component' or '_uid' properties:`);
            console.error(block);
        }
        return;
    }
    // component does exist
    if (hasComponent(block.component, componentMap)) {
        if (Array.isArray(componentsWithWrapper) && componentsWithWrapper.includes(block.component)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isSlim: true,
                children: /*#__PURE__*/ react.createElement(componentMap[block.component], {
                    ...block,
                    ...props
                })
            }, block._uid);
        }
        return /*#__PURE__*/ react.createElement(componentMap[block.component], {
            ...block,
            ...props,
            key: block._uid
        });
    }
    // component doesn't exist yet
    return /*#__PURE__*/ react.createElement(()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                "The component `",
                block.component,
                "` has not been created yet."
            ]
        }), {
        key: block._uid
    });
};
const checkNotOverLimit = (block, limitedItems)=>!(limitedItems && block.component && Object.prototype.hasOwnProperty.call(limitedItems, block.component) && (limitedItems[block.component]-- ?? 1) <= 0);

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/storyblok-renderer/storyblok-renderer.tsx




function StoryblokRenderer({ block , components , props , componentsWithWrapper , limitedItems  }) {
    if (Array.isArray(block)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: block.map((blockElement, index)=>checkNotOverLimit(blockElement, limitedItems) ? /*#__PURE__*/ (0,react.createElement)("div", {
                    ...(0,storyblok_src/* storyblokEditable */.LF)(blockElement),
                    key: index
                }, ElementFactory(blockElement, components, props, componentsWithWrapper)) : null)
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...(0,storyblok_src/* storyblokEditable */.LF)(block),
        children: ElementFactory(block, components, props)
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/hooks/use-latest-vehicles.tsx



const VEHICLE_SEARCH_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles`;
const fetcher = (url)=>axios.get(url).then((res)=>res.data);
const useLatestVehicles = ({ make , model , caller , tags , fuelType , bodyType , seats , colour , numberOfVehicles , count =!numberOfVehicles ? 3 : numberOfVehicles  })=>{
    const queryObject = {
        sortingCriteria: "13"
    };
    let browseButtonUrl = "/used-cars";
    if (caller === "seo-pages") {
        const searchFilter = {
            tags,
            fuelType,
            bodyType,
            seats,
            colour
        };
        for(const key in searchFilter){
            if (Object.prototype.hasOwnProperty.call(searchFilter, key) && searchFilter[key] && searchFilter[key] !== "") {
                const filter = key;
                const filterValue = searchFilter[key];
                queryObject[filter] = filterValue;
                browseButtonUrl = `/used-cars?${filter}=${filterValue}`;
                break;
            }
        }
    } else {
        queryObject["make"] = make ?? "";
        if (model) {
            queryObject["selectedModel"] = model;
        }
        if (fuelType) {
            queryObject["fuelType"] = fuelType;
        }
    }
    const qs = new URLSearchParams(queryObject);
    const url = `${VEHICLE_SEARCH_URL}?${qs.toString()}`;
    const { data , error  } = useSWR(url, fetcher);
    const countOfData = data === null || data === void 0 ? void 0 : data.searchResultsCount;
    data === null || data === void 0 ? void 0 : data.vehicleListings.splice(count);
    return {
        data,
        countOfData,
        browseButtonUrl,
        error
    };
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/admin-fee-button/admin-fee-button.module.css
var admin_fee_button_module = __webpack_require__(57669);
var admin_fee_button_module_default = /*#__PURE__*/__webpack_require__.n(admin_fee_button_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/admin-fee-button/admin-fee-button.tsx


const AdminFeeButton = ({ onAdminFeeClick  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onAdminFeeClick,
        "aria-label": "Plus a \xa399 admin fee. Find out more info",
        className: (admin_fee_button_module_default()).adminFeeInfoButton,
        children: "Plus a \xa399 admin fee"
    });
/* harmony default export */ var admin_fee_button = (AdminFeeButton);

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/admin-fee-drawer/admin-fee-drawer.module.css
var admin_fee_drawer_module = __webpack_require__(27190);
var admin_fee_drawer_module_default = /*#__PURE__*/__webpack_require__.n(admin_fee_drawer_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/admin-fee-drawer/admin-fee-drawer.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 


const AdminFeeDrawer = ({ showAdminFeeDrawer , onClose  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showAdminFeeDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Drawer */.dy, {
            onClose: onClose,
            header: "Admin Fee",
            ariaLabelledById: "admin-fee-drawer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (admin_fee_drawer_module_default()).paragraph,
                        children: "The \xa399 admin fee powers your faff-free customer experience, including administration costs associated with processing your car."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (admin_fee_drawer_module_default()).paragraph,
                        children: "If you return your car using our 14-day money-back guarantee, we’ll give you a full refund, including the \xa399 admin fee."
                    })
                ]
            })
        })
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/card/card.module.css
var card_card_module = __webpack_require__(48409);
var card_card_module_default = /*#__PURE__*/__webpack_require__.n(card_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/card/card.tsx



const card_Card = ({ isHoverable , element ="div" , children  })=>{
    const HtmlElement = element;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlElement, {
        className: classnames_default()((card_card_module_default()).card, {
            [(card_card_module_default()).hoverable]: isHoverable
        }),
        children: children
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/skeleton.module.css
var skeleton_module = __webpack_require__(71489);
var skeleton_module_default = /*#__PURE__*/__webpack_require__.n(skeleton_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/price/price.module.css
var price_module = __webpack_require__(32052);
var price_module_default = /*#__PURE__*/__webpack_require__.n(price_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/price/price.tsx







const numberWithCommas = (x)=>{
    if (typeof x === "string") {
        return Number.parseInt(x.replace(/,/g, ""), 10).toLocaleString();
    }
    return Math.round(x).toLocaleString();
};
const price_penceToPounds = (n)=>Math.round(n / 100);
const price_Price = ({ price , vehicleId , shouldShowCarsOnOfferTag =false , discountInPence , isPending , showSmallFontSize =false  })=>{
    const hasAdminFeeComplianceBeenSet = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeCompliance */.X.AdminFeeCompliance) === "true";
    const fullPrice = `£${numberWithCommas(price)}`;
    const wasPriceId = `${vehicleId}-was-price`;
    const renderCashPrice = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
            element: "span",
            fontSizeFixed: "l",
            fontWeight: "semibold",
            "aria-label": `Cash price. ${fullPrice}.`,
            "aria-describedby": discountInPence ? wasPriceId : undefined,
            className: classnames_default()((price_module_default()).cashPrice, {
                [(skeleton_module_default()).base]: isPending,
                [(skeleton_module_default()).active]: isPending,
                [(price_module_default()).cashPricePreAdminFeeCompliance]: !hasAdminFeeComplianceBeenSet
            }),
            children: fullPrice
        });
    const renderCashPriceAndWasPrice = ()=>{
        const discount = price_penceToPounds(discountInPence ?? 0);
        const wasPrice = `£${numberWithCommas(price + discount)}`;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((price_module_default()).cashPrice, {
                [(price_module_default()).cashPricePreAdminFeeCompliance]: !hasAdminFeeComplianceBeenSet
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                    element: "span",
                    id: wasPriceId,
                    "data-testid": "was-price",
                    fontSizeFixed: "xs",
                    fontWeight: "medium",
                    "aria-hidden": true,
                    className: classnames_default()((price_module_default()).wasPrice, {
                        [(skeleton_module_default()).base]: isPending,
                        [(skeleton_module_default()).active]: isPending
                    }),
                    children: [
                        "Was ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                            children: wasPrice
                        })
                    ]
                }),
                renderCashPrice()
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((price_module_default()).priceContainer, {
            [(price_module_default()).smallFontSize]: showSmallFontSize
        }),
        children: shouldShowCarsOnOfferTag ? renderCashPriceAndWasPrice() : renderCashPrice()
    });
};
/* harmony default export */ var price_price = (price_Price);

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/product-image/product-image.module.css
var product_image_module = __webpack_require__(13556);
var product_image_module_default = /*#__PURE__*/__webpack_require__.n(product_image_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/product-image/product-image.tsx





const ProductImage = ({ isAvailable , image , alt , children  })=>{
    const hasImage = image && image.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (product_image_module_default()).imgContainer,
        children: [
            hasImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: classnames_default()((product_image_module_default()).img, {
                    [(product_image_module_default()).unavailable]: !isAvailable
                }),
                src: image,
                alt: alt,
                layout: "fill"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* HoldingImage */.C$, {
                text: "Image Unavailable",
                isAvailable: isAvailable
            }),
            children
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/save-button/save-button.module.css
var save_button_module = __webpack_require__(98637);
var save_button_module_default = /*#__PURE__*/__webpack_require__.n(save_button_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/save-button/save-button.tsx





const SAVE_CAR = "Save car to your profile";
const UNSAVE_CAR = "Remove car from saved list";
const gradientFill = `url(#${ui_src/* SVG_GRADIENT_IDS.alpha */.dA.alpha})`;
const SVGHeart = ui_src/* HeartIcon */.h_;
const SaveButton = ({ onClick , isSaved , size , className , children , isPending =false  })=>{
    const classNames = classnames_default()([
        (save_button_module_default()).button,
        className
    ], {
        [(save_button_module_default()).loading]: isPending
    });
    const padding = index_esm/* designTokens.customProperties.ds.font.size.3xs */.Wp.customProperties.ds.font.size["3xs"];
    const height = Number.parseInt(size, 10) + Number.parseInt(padding, 10);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        style: {
            borderRadius: height * 0.5,
            visibility: isPending ? "hidden" : "visible"
        },
        className: classNames,
        disabled: isPending,
        title: isSaved ? UNSAVE_CAR : SAVE_CAR,
        type: "button",
        onClick: (e)=>{
            e.stopPropagation();
            onClick();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SVGHeart, {
                role: "presentation",
                height: size,
                width: size,
                style: {
                    display: "inline-flex",
                    width: size,
                    height: size,
                    fill: isSaved && !isPending ? gradientFill : "none",
                    stroke: !isPending ? gradientFill : "none",
                    strokeWidth: isPending ? 0 : 2.5
                }
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/constants/index.ts
const LOADING_TEXT = "Loading...";

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/subtitle/subtitle.module.css
var subtitle_module = __webpack_require__(79546);
var subtitle_module_default = /*#__PURE__*/__webpack_require__.n(subtitle_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/subtitle/subtitle.tsx






const Subtitle = ({ children , isPending =false , className ="" , fontSize  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontSizeFixed: fontSize || "xs",
        className: classnames_default()(className, (subtitle_module_default()).subtitle, {
            [(skeleton_module_default()).base]: isPending,
            [(skeleton_module_default()).active]: isPending
        }),
        children: isPending ? LOADING_TEXT : children
    });
/* harmony default export */ var subtitle = ((/* unused pure expression or super */ null && (Subtitle)));

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/tags/tags.module.css
var tags_module = __webpack_require__(54862);
var tags_module_default = /*#__PURE__*/__webpack_require__.n(tags_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/tags/tags.tsx





const tags_Tags = ({ items =[] , isPending =false , listStyleClassName , listItemClassName , isUpperCaseText =true  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: classnames_default()((tags_module_default()).list, listStyleClassName || "", {
            [(skeleton_module_default()).base]: isPending,
            [(skeleton_module_default()).active]: isPending,
            [(tags_module_default()).upperCase]: isUpperCaseText
        }),
        children: items.map(({ label , value  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                element: "li",
                fontSizeFixed: "3xs",
                className: classnames_default()((tags_module_default()).item, listItemClassName || "", {
                    [(skeleton_module_default()).base]: isPending,
                    [(skeleton_module_default()).active]: isPending
                }),
                title: label,
                children: value
            }, label))
    });
/* harmony default export */ var tags = ((/* unused pure expression or super */ null && (tags_Tags)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/title/title.tsx





const Title = ({ children , isPending =false , type , className ="" , element ="h5" , ...props })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        element: element,
        className: classnames_default()((skeleton_module_default()).base, {
            [(skeleton_module_default()).active]: isPending
        }, className),
        type: type || index_esm/* TextStyles.mainTitle */.k7.mainTitle,
        ...props,
        children: isPending ? LOADING_TEXT : children
    });
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/product-list-card/product-list-card.module.css
var product_list_card_module = __webpack_require__(25791);
var product_list_card_module_default = /*#__PURE__*/__webpack_require__.n(product_list_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/components/product-list-card/product-list-card.tsx
















const filterTestTags = (tag)=>{
    if (tag.label) {
        return tag.label.match(/Mileage|Fuel Type|Transmission Type/);
    }
    return null;
};
const hyphenate = (text)=>text ? text.replace(/\s+/g, "-").toLowerCase() : "";
const { font  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const ERROR_MESSAGE = "Image Unavailable";
const ProductListCard = ({ id , price , image , title , subtitle , isSaved , isPending =false , isAvailable , onSave , tags , unavailable , isReserved , make , model , vehicleYear , discountInPence , showActions =true , isSmallCardSize =false , isPersonalised , onCardClick  })=>{
    const hasAdminFeeComplianceBeenSet = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeCompliance */.X.AdminFeeCompliance) === "true";
    const tagsCarCards = tags.filter((tag)=>filterTestTags(tag));
    const vehicleTitle = `${vehicleYear} ${title}`;
    const showOfferTag = !!discountInPence;
    const [shouldShowAdminFeeDrawer, setShouldShowAdminFeeDrawer] = (0,react.useState)(false);
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleAdminFeeClick = ()=>{
        setShouldShowAdminFeeDrawer(!shouldShowAdminFeeDrawer);
        if (shouldShowAdminFeeDrawer === false) {
            trackEvent({
                eventName: "product list card - admin fees",
                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                data: {
                    event: {
                        name: "click",
                        category: "admin fees",
                        label: "info",
                        action: "view",
                        value: isPersonalised ? "personalised" : "non-personalised"
                    }
                }
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card_Card, {
        "data-testid": "product-list-card",
        element: "article",
        isHoverable: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((product_list_card_module_default()).meta, (product_list_card_module_default()).metaCarCards, {
                    [(product_list_card_module_default()).unavailable]: !isAvailable,
                    [(product_list_card_module_default()).metaCarCardsPreAdminFeeCompliance]: !hasAdminFeeComplianceBeenSet
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                element: "h2",
                                className: classnames_default()((product_list_card_module_default()).title, (product_list_card_module_default()).titleCarCards),
                                fontSizeFixed: "m",
                                type: "cardTitle",
                                isPending: isPending,
                                "aria-describedby": isReserved ? `vehicle-reserved-${id}` : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-testid": "product-list-card-link",
                                    href: `/used-cars/${hyphenate(make)}/${hyphenate(model)}/details/${id}`,
                                    className: (product_list_card_module_default()).link,
                                    onClick: ()=>onCardClick ? onCardClick() : null,
                                    children: vehicleTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                                isPending: isPending,
                                fontSize: "s",
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tags_Tags, {
                                isPending: isPending,
                                listStyleClassName: (product_list_card_module_default()).tagsCarCards,
                                listItemClassName: (product_list_card_module_default()).tagItemCarCard,
                                items: tagsCarCards
                            })
                        ]
                    }),
                    isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(price_price, {
                        isPending: isPending,
                        price: price,
                        vehicleId: id,
                        shouldShowCarsOnOfferTag: showOfferTag,
                        discountInPence: discountInPence,
                        showSmallFontSize: isSmallCardSize
                    }),
                    !hasAdminFeeComplianceBeenSet && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(admin_fee_button, {
                                onAdminFeeClick: ()=>handleAdminFeeClick()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminFeeDrawer, {
                                showAdminFeeDrawer: shouldShowAdminFeeDrawer,
                                onClose: ()=>handleAdminFeeClick()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (product_list_card_module_default()).imageContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        alt: title,
                        isAvailable: isAvailable,
                        image: image,
                        unavailableImageMessage: !isAvailable && " " || unavailable || ERROR_MESSAGE,
                        isPending: isPending
                    }),
                    showActions && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (product_list_card_module_default()).actions,
                        children: !!onSave && isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveButton, {
                            isPending: isPending || !isAvailable && !isSaved,
                            className: (product_list_card_module_default()).save,
                            isSaved: isSaved,
                            onClick: ()=>onSave(!isSaved),
                            size: font.size.xxl
                        })
                    }),
                    isReserved && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "book",
                        className: (product_list_card_module_default()).reserved,
                        "data-testid": "vehicle-is-reserved",
                        id: `vehicle-reserved-${id}`,
                        children: "Currently reserved"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card/vehicle-card.tsx




const VehicleCard = ({ vehicle , id , isSmallCardSize =false , isPersonalised =false , ...props })=>{
    const { vehicleId , price , variant , make , selectedModel , isReserved , vehicleYear , discountInPence , thumbnailUrl , priceIncludingAdminFee  } = vehicle;
    const title = `${make} ${selectedModel}`;
    const image = thumbnailUrl ? thumbnailUrl.replace(/0-(.*)-thumbnail\.([a-z]+)$/, "1-$1.$2") : "";
    const tags = (0,src/* getVehicleTags */.mH)(vehicle);
    const hasAdminFeeComplianceSet = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.AdminFeeCompliance */.X.AdminFeeCompliance) === "true";
    const vehiclePrice = hasAdminFeeComplianceSet ? priceIncludingAdminFee : price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListCard, {
        id: vehicleId || id,
        price: vehiclePrice,
        image: image,
        title: title,
        subtitle: variant,
        tags: tags,
        isReserved: isReserved,
        make: make,
        model: selectedModel,
        vehicleYear: vehicleYear,
        discountInPence: discountInPence,
        isSmallCardSize: isSmallCardSize,
        isPersonalised: isPersonalised,
        ...props
    });
};
/* harmony default export */ var vehicle_card = ((/* unused pure expression or super */ null && (VehicleCard)));

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/vehicle-image/vehicle-image.tsx




const vehicle_image_VehicleImage = ({ isAvailable , src , alt  })=>{
    const hasImage = src && src.length > 0;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.imageContainer,
        children: hasImage && isAvailable ? /*#__PURE__*/ _jsx(Image, {
            className: styles.image,
            src: src,
            alt: alt,
            layout: "fill"
        }) : /*#__PURE__*/ _jsx(HoldingImage, {
            text: "Image Unavailable",
            isAvailable: isAvailable
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/vehicle-image/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/tags/tags.tsx


const tags_tags_Tags = ({ fuelType , transmissionType , mileage , year  })=>{
    const tagsList = [
        {
            label: "Vehicle Year",
            value: year
        },
        {
            label: "Mileage",
            value: `${Intl.NumberFormat().format(mileage)} miles`
        },
        {
            label: "Fuel Type",
            value: fuelType
        },
        {
            label: "Transmission Type",
            value: transmissionType
        }
    ];
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.container,
        children: tagsList.map(({ label , value  })=>/*#__PURE__*/ _jsx("li", {
                className: styles.tag,
                children: /*#__PURE__*/ _jsx("p", {
                    className: styles.tagText,
                    children: value
                })
            }, label))
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/tags/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/price/price.tsx



const price_price_Price = ({ price , discountInPence  })=>{
    const formattedPrice = currencyValueFormatter(price);
    const formattedPreDiscountPrice = currencyValueFormatter(price + discountInPence / 100);
    const isDiscounted = !!discountInPence;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            isDiscounted && /*#__PURE__*/ _jsxs("span", {
                className: styles.discounted,
                children: [
                    "Was ",
                    /*#__PURE__*/ _jsx("s", {
                        children: formattedPreDiscountPrice
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.price,
                children: formattedPrice
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/price/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/admin-fee/admin-fee.tsx




const admin_fee_AdminFee = ()=>{
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const handleClick = ()=>{
        setIsDrawerOpen(true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: handleClick,
                className: styles.button,
                children: "Plus a \xa399 admin fee"
            }),
            isDrawerOpen && /*#__PURE__*/ _jsx(Drawer, {
                onClose: ()=>setIsDrawerOpen(false),
                header: "Admin Fee",
                ariaLabelledById: "admin-fee-drawer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.drawerContainer,
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.drawerText,
                            children: "The \xa399 admin fee powers your faff-free customer experience, including registration and administration costs associated with processing your car."
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.drawerText,
                            children: "If you return your vehicle using our 14-day money-back guarantee, we’ll give you a full refund, including the \xa399 admin fee."
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/admin-fee/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/lib/v2/assets/heart-with-ring.tsx

const heart_with_ring_HeartWithRing = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "43",
        height: "43",
        viewBox: "0 0 43 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0111 38.0827C30.4395 38.0827 38.0827 30.4395 38.0827 21.0111C38.0827 11.5828 30.4395 3.93959 21.0111 3.93959C11.5828 3.93959 3.93959 11.5828 3.93959 21.0111C3.93959 30.4395 11.5828 38.0827 21.0111 38.0827ZM21.0111 42.0223C32.6153 42.0223 42.0223 32.6153 42.0223 21.0111C42.0223 9.40701 32.6153 0 21.0111 0C9.40701 0 0 9.40701 0 21.0111C0 32.6153 9.40701 42.0223 21.0111 42.0223Z",
                fill: "#57E8FF"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0109 14.103C19.014 12.3124 16.5638 10.7151 13.8296 11.8969C11.8161 12.7672 10.5428 14.8684 10.5056 17.0403C10.5055 20.6513 16.254 26.6457 19.7927 30.3357C19.9927 30.5443 20.1862 30.746 20.3707 30.939C20.7193 31.3038 21.3034 31.3038 21.652 30.939C21.8369 30.7455 22.0303 30.5438 22.2309 30.3347C25.7694 26.6446 31.5167 20.651 31.5167 17.0405C31.4797 14.8686 30.2067 12.7672 28.1931 11.8969C25.4587 10.715 23.0083 12.3128 21.0109 14.103Z",
                fill: "#5234B6"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/lib/v2/auth-buttons.helper.tsx

const auth_buttons_helper_handleButtonClick = (path, trackEvent, useBrowserNavigation, routerPush)=>{
    trackEvent({
        eventName: `unauth-save-vehicle-event`,
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: EventNames.click,
                category: `auth-modal-${path}-button`,
                label: path,
                action: `auth-modal-${path}`
            }
        }
    });
    useBrowserNavigation ? window.location.assign(`/${path}`) : routerPush(`/${path}`);
};

;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/lib/v2/auth-buttons.tsx






const auth_buttons_AuthButtons = ({ useBrowserNavigation  })=>{
    const { trackEvent  } = useAnalytics();
    const { push  } = useRouter();
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.authButtonsContainer,
        children: [
            /*#__PURE__*/ _jsx(Primary, {
                classNames: {
                    button: styles.authButton
                },
                type: "button",
                onClick: ()=>{
                    handleButtonClick("sign-up", trackEvent, useBrowserNavigation, push);
                },
                isFullWidth: true,
                children: "Sign up"
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                classNames: {
                    button: styles.authButton
                },
                type: "button",
                onClick: ()=>handleButtonClick("login", trackEvent, useBrowserNavigation, push),
                isFullWidth: true,
                children: "Log in"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/lib/v2/auth-modal-v2.tsx





const auth_modal_v2_AuthModalV2 = ({ handleClose , vehicleImage , useBrowserNavigation  })=>{
    const shouldShowImage = !!vehicleImage;
    const EMPTY_TITLE = "";
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Modal, {
            classNames: {
                modal: styles.modal,
                inner: styles.modalInner
            },
            onClose: handleClose,
            ariaLabelledById: "auth-modal-title",
            heading: EMPTY_TITLE,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.contentContainer,
                children: [
                    shouldShowImage && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.iconContainer,
                                children: /*#__PURE__*/ _jsx(HeartWithRing, {})
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: vehicleImage,
                                alt: "favourited vehicle",
                                className: styles.vehicleImage
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("section", {
                        className: styles.authTitleAndText,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                children: "Sign up to favourite cars"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                children: "Sync favourites across your devices and get notified of any price changes."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(AuthButtons, {
                        useBrowserNavigation: useBrowserNavigation
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/lib/auth-modal.component.tsx


const auth_modal_component_AuthModal = ({ isOpen , handleClose , useBrowserNavigation , vehicleImage  })=>/*#__PURE__*/ _jsx(_Fragment, {
        children: isOpen && /*#__PURE__*/ _jsx(AuthModalV2, {
            handleClose: handleClose,
            vehicleImage: vehicleImage,
            useBrowserNavigation: !!useBrowserNavigation
        })
    });

;// CONCATENATED MODULE: ../../../libs/shared/auth-modal/src/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/favourite-cta/favourite-cta.tsx




const favourite_cta_FavouriteCTA = ({ isSaved , onClick  })=>{
    const FAVOURITE_CAR = "Add car to favourites";
    const UNFAVOURITE_CAR = "Remove car from favourites";
    const FavouriteIcon = isSaved ? HeartFilledIcon : HeartOutlineIcon;
    return /*#__PURE__*/ _jsx("div", {
        className: sharedStyles.ctaWrapper,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            "aria-label": isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR,
            className: cx(sharedStyles.ctaButton, isSaved && sharedStyles.toggled),
            onClick: onClick,
            children: [
                /*#__PURE__*/ _jsx(FavouriteIcon, {
                    size: 16
                }),
                "Favourite"
            ]
        })
    });
};

// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/cinchapp-config/dist/index.js
var cinchapp_config_dist = __webpack_require__(82786);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/compare-cta/compare-icon.tsx


const compare_icon_CompareIcon = ({ isToggled  })=>/*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        className: sharedStyles.compareCtaIcon,
        "aria-hidden": "true",
        children: isToggled ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M14 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 1 0-2 0v5Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M4.262 7.452a.75.75 0 1 0-1.024 1.096l1.024-1.096ZM7.5 11.5l-.512.548a.75.75 0 0 0 1.059-.034L7.5 11.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM3.238 8.548l3.75 3.5 1.024-1.096-3.75-3.5-1.024 1.096Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
                })
            ]
        }) : /*#__PURE__*/ _jsx("path", {
            d: "M 14 13 a 1 1 0 0 1 -1 1 H 3 a 1 1 0 0 1 -1 -1 V 3 a 1 1 0 0 1 1 -1 h 10 V 0 H 3 a 3 3 0 0 0 -3 3 v 10 a 3 3 0 0 0 3 3 h 10 a 3 3 0 0 0 3 -3 V 3 a 3 3 0 0 0 -3 -3 V 2 A 1 1 0 0 1 14 3 z"
        })
    });

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/lib/provider/compare-bar-provider.helpers.ts


const compare_bar_provider_helpers_getVehiclesApi = (params)=>{
    const searchService = axios.create({
        baseURL: readFromEnv(Env.SearchServiceUrl)
    });
    return searchService.request({
        url: `/vehicles?vehicleIds=${params.vehicleIds}&excludeUnavailable=false&queryOnly=true`,
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/lib/provider/compare-bar-provider.tsx





const initialVehiclesValue = (/* unused pure expression or super */ null && ([]));
const initialExpandedValue = {
    isExpanded: true
};
const CompareBarContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
const setStorage = (key, data, store)=>{
    const hasWindow = "object" !== "undefined";
    const getStorage = (store)=>store ?? window.sessionStorage;
    if (hasWindow) {
        getStorage(store).setItem(key, JSON.stringify(data));
    }
};
const CompareBarProvider = ({ children  })=>{
    const isViewportMediumOrLarger = useMediaQuery({
        query: designTokens.customMedia.l
    });
    const maxNumberOfItems = isViewportMediumOrLarger ? 3 : 2;
    const [showModal, setShowModal] = useState(false);
    const [compareBarSticky, setCompareBarSticky] = useState(false);
    const [vehicleSummaryMap, setVehicleSummaryMap] = useState({});
    const [customerHasActiveOrder, setCustomerHasActiveOrder] = useState(false);
    const [compareBarSessionData, setCompareBarSessionData] = useState(()=>{
        if (false) {}
        try {
            const item = sessionStorage.getItem("compare-bar");
            return item ? JSON.parse(item) : initialExpandedValue;
        } catch  {
            return initialExpandedValue;
        }
    });
    const [comparisonVehicles, setCompareBarData] = useState(()=>{
        if (false) {}
        try {
            const item = localStorage.getItem("compare-bar");
            if (item) {
                const parsedItem = JSON.parse(item);
                return Array.isArray(parsedItem) ? parsedItem : initialVehiclesValue;
            }
            return initialVehiclesValue;
        } catch  {
            //datadogRum.addError(error)
            return initialVehiclesValue;
        }
    });
    const addVehicle = ({ vehicleId , vehicleImage , vehicleTitle , vehicleMake , vehicleModel  })=>{
        const vehicleExists = comparisonVehicles.some((vehicle)=>vehicle.vehicleId === vehicleId);
        if (vehicleExists) return;
        const vehicleData = {
            vehicleId,
            vehicleImage,
            vehicleTitle,
            vehicleMake,
            vehicleModel
        };
        setCompareBarData([
            ...comparisonVehicles,
            vehicleData
        ]);
    };
    const removeVehicle = (vehicleId)=>{
        const currentVehicles = comparisonVehicles.filter((vehicle)=>vehicle.vehicleId !== vehicleId);
        setCompareBarData(currentVehicles);
    };
    const handleModalClosure = ()=>{
        setShowModal(false);
    };
    useEffect(()=>{
        setStorage("compare-bar", comparisonVehicles, localStorage);
    }, [
        comparisonVehicles
    ]);
    useEffect(()=>{
        setStorage("compare-bar", compareBarSessionData, sessionStorage);
    }, [
        compareBarSessionData
    ]);
    useEffect(()=>{
        if (comparisonVehicles.length > maxNumberOfItems) {
            removeVehicle(comparisonVehicles[comparisonVehicles.length - 1].vehicleId);
        }
    }, [
        maxNumberOfItems
    ]);
    useEffect(()=>{
        const vehicleIds = comparisonVehicles.map((vehicle)=>vehicle.vehicleId);
        if (comparisonVehicles.length === 0) return;
        getVehiclesApi({
            vehicleIds: vehicleIds.join(",")
        }).then(({ data  })=>{
            const vehicleListings = data.vehicleListings;
            const vehicleSummaryMap = vehicleListings.reduce((acc, vehicle)=>{
                acc[vehicle.vehicleId] = {
                    isAvailable: vehicle.isAvailable
                };
                return acc;
            }, {});
            setVehicleSummaryMap(vehicleSummaryMap);
        });
    }, []);
    return /*#__PURE__*/ _jsxs(CompareBarContext.Provider, {
        value: {
            comparisonVehicles,
            compareBarExpanded: compareBarSessionData.isExpanded,
            compareBarSticky,
            vehicleSummaryMap,
            addVehicle,
            removeVehicle,
            setCompareBarExpanded: (value)=>setCompareBarSessionData({
                    isExpanded: value
                }),
            setCompareBarSticky,
            setShowModal,
            maxNumberOfItems,
            showModal,
            customerHasActiveOrder,
            setCustomerHasActiveOrder
        },
        children: [
            showModal && /*#__PURE__*/ _jsx(Modal, {
                heading: "Your compare list is full",
                ariaLabelledById: "compare-list-full",
                onClose: handleModalClosure,
                children: /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "m",
                    children: [
                        "You can only compare ",
                        maxNumberOfItems,
                        " cars at a time. Remove a car from your compare list to add this one in."
                    ]
                })
            }),
            children
        ]
    });
};
const compare_bar_provider_useCompareBar = ()=>{
    const context = useContext(CompareBarContext);
    if (context === undefined) {
        throw new Error("useCompareBar must be used within a CompareBarProvider");
    }
    return context;
};

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/lib/tracking/tracking-events.ts

const tracking_events_compareCtaClickEvent = (comparisonVehicles)=>({
        eventName: "compare-cta-click",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "Compare",
                action: "Compare Cars",
                label: "Clickthrough",
                value: comparisonVehicles.map((vehicle)=>`${vehicle.vehicleTitle}`).join(",")
            }
        }
    });
const tracking_events_compareVehicleRemovalEvent = (vehicleMake, vehicleModel, comparisonVehicles)=>({
        eventName: "compare-vehicle-removal",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "Compare",
                action: "Remove Vehicle - compare bar",
                label: vehicleModel,
                type: vehicleMake,
                value: comparisonVehicles.length - 1
            }
        }
    });
const tracking_events_compareBarDrawerInteractionEvent = (open)=>({
        eventName: "compare-bar-drawer-interaction",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "Compare",
                action: open ? "Open Drawer" : "Close Drawer",
                label: "",
                type: "",
                value: ""
            }
        }
    });
const tracking_events_compareMaxNumberOfVehicles = (maxNumberOfItems)=>({
        eventName: "compare-max-number-of-vehicles",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "Compare",
                action: "Max cars alert",
                value: maxNumberOfItems,
                type: "",
                label: ""
            }
        }
    });
const tracking_events_clickCompareVehicle = ({ action , make , model , value  })=>({
        eventName: "click-compare-vehicle",
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: "click",
                category: "Compare",
                action,
                type: make,
                label: model,
                value
            }
        }
    });

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/lib/compare-bar.component.tsx









const CompareBarImage = ({ src , isSold  })=>{
    const [hasError, updateErrorState] = useState(false);
    const updateError = ()=>{
        updateErrorState(true);
    };
    return !src || hasError ? /*#__PURE__*/ _jsx("div", {
        className: styles.compareBarHoldingImage,
        "aria-hidden": "true",
        children: /*#__PURE__*/ _jsx(SvgIcon, {
            name: "vehicle-side",
            size: 22,
            color: "mercury",
            className: styles.compareBarImageIcon
        })
    }) : /*#__PURE__*/ _jsx("img", {
        className: cx(styles.compareBarCarImage, {
            [styles.compareBarCarImageSold]: isSold
        }),
        alt: "",
        role: "presentation",
        src: src || "",
        onError: updateError,
        loading: "lazy",
        width: 60,
        height: 34
    });
};
const CompareBar = ()=>{
    const { comparisonVehicles , compareBarExpanded , compareBarSticky , maxNumberOfItems , vehicleSummaryMap , removeVehicle , setCompareBarExpanded , customerHasActiveOrder  } = useCompareBar();
    const { trackEvent  } = useAnalytics();
    const compareButtonDisabled = comparisonVehicles.length <= 1;
    const vehicleIds = comparisonVehicles.map((vehicle)=>vehicle.vehicleId);
    const compareCtaUrl = `/compare-cars/${vehicleIds.join(";")}`;
    const handleVehicleRemoval = (vehicleId, vehicleMake, vehicleModel)=>{
        removeVehicle(vehicleId);
        trackEvent(compareVehicleRemovalEvent(vehicleMake, vehicleModel, comparisonVehicles));
        // TODO: Transfer ownership to PD
        datadogRum.addAction("Compare - Compare Bar vehicle removed", {
            service: "compare",
            squad: "search",
            vehicle: {
                vehicleId,
                make: vehicleMake,
                model: vehicleModel
            }
        });
    };
    const renderVehicleCard = (vehicle)=>{
        var ref;
        const { vehicleId , vehicleTitle , vehicleImage , vehicleMake , vehicleModel  } = vehicle;
        const isSold = (vehicleSummaryMap === null || vehicleSummaryMap === void 0 ? void 0 : (ref = vehicleSummaryMap[vehicleId]) === null || ref === void 0 ? void 0 : ref.isAvailable) === false;
        return /*#__PURE__*/ _jsx("li", {
            className: styles.compareBarListItem,
            children: /*#__PURE__*/ _jsxs("article", {
                className: styles.compareBarListArticle,
                children: [
                    /*#__PURE__*/ _jsx(CompareBarImage, {
                        src: vehicleImage,
                        isSold: isSold
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        element: "h3",
                        "aria-describedby": isSold ? `vehicle-sold-${vehicleId}` : undefined,
                        className: cx(styles.compareBarListItemHeading, {
                            [styles.compareBarListItemHeadingSold]: isSold
                        }),
                        children: vehicleTitle
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: styles.compareBarListItemButton,
                        type: "button",
                        onClick: ()=>handleVehicleRemoval(vehicleId, vehicleMake, vehicleModel),
                        "aria-label": `Remove ${vehicleTitle} from the compare list`,
                        children: /*#__PURE__*/ _jsx(SvgIcon, {
                            name: "cross",
                            size: 16,
                            color: "deepPurple"
                        })
                    }),
                    isSold && /*#__PURE__*/ _jsx(Text, {
                        element: "span",
                        fontSizeFixed: "s",
                        fontWeight: "bold",
                        className: styles.compareBarListItemSoldBadge,
                        "aria-hidden": "true",
                        children: "Sold"
                    }),
                    isSold && /*#__PURE__*/ _jsx(ScreenReaderText, {
                        "aria-hidden": "true",
                        id: `vehicle-sold-${vehicleId}`,
                        children: "This vehicle has been sold"
                    })
                ]
            })
        }, vehicleId);
    };
    const renderCompareBarItems = (_, index)=>{
        const currentVehicle = comparisonVehicles[index];
        if (currentVehicle) {
            return renderVehicleCard(currentVehicle);
        }
        return /*#__PURE__*/ _jsx("li", {
            className: cx(styles.compareBarListItem, styles.compareBarListItemEmpty),
            children: "You can add another car to compare"
        }, index);
    };
    const handleCompareBarToggle = (open)=>{
        setCompareBarExpanded(open);
        trackEvent(compareBarDrawerInteractionEvent(open));
    };
    const handleCompareCtaClick = ()=>{
        trackEvent(compareCtaClickEvent(comparisonVehicles));
        // TODO: Transfer ownership to PD
        datadogRum.addAction("Compare - Bar CTA clicked", {
            service: "compare",
            squad: "search",
            compareCount: comparisonVehicles.length,
            compareVehicleIds: comparisonVehicles.map((vehicle)=>vehicle.vehicleId)
        });
    };
    useEffect(()=>{
        if (comparisonVehicles.length === 0) {
            setCompareBarExpanded(true);
        }
    }, [
        comparisonVehicles
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        className: cx(styles.compareBar, {
            [styles.compareBarUnstuck]: !compareBarSticky
        }),
        id: "compare",
        "aria-labelledby": "compare-list-heading",
        "aria-describedby": compareBarExpanded ? "compare-list-body" : undefined,
        hidden: comparisonVehicles.length === 0 || customerHasActiveOrder,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.compareBarCollapsedView,
                children: [
                    /*#__PURE__*/ _jsxs(Text, {
                        className: styles.compareBarExpandedTitle,
                        element: "a",
                        id: !compareBarExpanded ? "compare-list-heading" : undefined,
                        hidden: compareBarExpanded,
                        children: [
                            "Your compare list",
                            " ",
                            comparisonVehicles.length > 0 && `(${comparisonVehicles.length})`
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: styles.compareBarExpansionButton,
                        onClick: ()=>handleCompareBarToggle(!compareBarExpanded),
                        "aria-expanded": compareBarExpanded,
                        "aria-label": `${compareBarExpanded ? "Collapse" : "Expand"} compare bar`,
                        children: /*#__PURE__*/ _jsx(SvgIcon, {
                            name: "chevron-down",
                            size: 16,
                            color: "mineShaft"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                hidden: !compareBarExpanded,
                className: cx(styles.container, {
                    [styles.containerExpanded]: compareBarExpanded
                }),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.compareBarContent,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                className: styles.compareBarHeading,
                                element: "h2",
                                fontSize: "l",
                                fontWeight: "bold",
                                id: compareBarExpanded ? "compare-list-heading" : undefined,
                                children: "Your compare list"
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: styles.compareBarText,
                                id: "compare-list-body",
                                children: [
                                    "Select up to ",
                                    maxNumberOfItems,
                                    " cars to compare them side-by-side."
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Primary, {
                                "aria-describedby": compareButtonDisabled ? "compare-validation" : undefined,
                                "aria-disabled": compareButtonDisabled,
                                role: compareButtonDisabled ? "link" : undefined,
                                href: compareButtonDisabled ? undefined : compareCtaUrl,
                                element: "a",
                                classNames: {
                                    button: styles.compareBarButtonDesktop
                                },
                                onClick: handleCompareCtaClick,
                                children: "Compare cars"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("ol", {
                        className: styles.compareBarList,
                        children: Array.from({
                            length: maxNumberOfItems
                        }, renderCompareBarItems)
                    }),
                    /*#__PURE__*/ _jsx(Primary, {
                        "aria-describedby": compareButtonDisabled ? "compare-validation" : undefined,
                        "aria-disabled": compareButtonDisabled,
                        role: compareButtonDisabled ? "link" : undefined,
                        href: compareButtonDisabled ? undefined : compareCtaUrl,
                        element: "a",
                        classNames: {
                            button: styles.compareBarButtonMobile
                        },
                        isFullWidth: true,
                        onClick: handleCompareCtaClick,
                        children: "Compare cars"
                    })
                ]
            }),
            compareButtonDisabled && /*#__PURE__*/ _jsxs(ScreenReaderText, {
                id: "compare-validation",
                "aria-hidden": "true",
                children: [
                    "You need to add at least 2 cars to the compare list. You currently have ",
                    comparisonVehicles.length
                ]
            }),
            /*#__PURE__*/ _jsx("a", {
                className: styles.compareBarHiddenLink,
                href: "#results",
                children: "Go back to results"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/lib/compare-toggle-button.component.tsx







const CompareToggleButton = ({ vehicleInventoryId , make , model , modelYear , thumbnailUrl  })=>{
    const { removeVehicle , addVehicle , comparisonVehicles , setShowModal , maxNumberOfItems , customerHasActiveOrder  } = useCompareBar();
    const { trackEvent  } = useAnalytics();
    const isSavedToCompare = comparisonVehicles.some((comparisonVehicle)=>comparisonVehicle.vehicleId === vehicleInventoryId);
    const handleMaxCompareTracking = (maxNumberOfVehicles)=>{
        trackEvent(compareMaxNumberOfVehicles(maxNumberOfVehicles));
        datadogRum.addAction("Showing max compare vehicles modal", {
            service: "compare",
            squad: "product-detail",
            maxNumberOfVehicles: maxNumberOfItems
        });
    };
    const handleComparisonVehicleTracking = (make, model, vehicleInventoryId, action, value)=>{
        trackEvent(clickCompareVehicle({
            action,
            make,
            model,
            value
        }));
        datadogRum.addAction("Add vehicles for comparison clicked", {
            service: "compare",
            squad: "product-detail",
            vehicle: {
                vehicleInventoryId,
                make,
                model
            }
        });
    };
    const handleClick = ()=>{
        const numberOfVehicles = comparisonVehicles.length;
        const vehicleData = {
            vehicleId: vehicleInventoryId,
            vehicleTitle: `${modelYear} ${make} ${model}`,
            vehicleImage: thumbnailUrl,
            vehicleMake: make,
            vehicleModel: model
        };
        if (numberOfVehicles >= maxNumberOfItems && !isSavedToCompare) {
            handleMaxCompareTracking(maxNumberOfItems);
            return setShowModal(true);
        }
        if (isSavedToCompare) {
            removeVehicle(vehicleInventoryId);
            handleComparisonVehicleTracking(make, model, vehicleInventoryId, "Remove Vehicle", numberOfVehicles - 1);
        } else {
            addVehicle(vehicleData);
            handleComparisonVehicleTracking(make, model, vehicleInventoryId, "Add Vehicle", numberOfVehicles + 1);
        }
    };
    if (customerHasActiveOrder) return null;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        "aria-label": isSavedToCompare ? "Remove from the compare list" : "Add to the compare list",
        onClick: handleClick,
        className: cx(styles.compareToggleButton, {
            [styles.compareToggleButtonSaved]: isSavedToCompare
        }),
        children: [
            /*#__PURE__*/ _jsxs("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                fill: "none",
                viewBox: "0 0 16 16",
                className: styles.compareToggleButtonIcon,
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M14 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 1 0-2 0v5Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.262 7.452a.75.75 0 1 0-1.024 1.096l1.024-1.096ZM7.5 11.5l-.512.548a.75.75 0 0 0 1.059-.034L7.5 11.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM3.238 8.548l3.75 3.5 1.024-1.096-3.75-3.5-1.024 1.096Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.compareText,
                children: "Compare"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/compare-cars/src/index.ts





;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/compare-cta/compare-cta.tsx









const compare_cta_CompareCTA = ({ vehicle  })=>{
    const { removeVehicle , addVehicle , comparisonVehicles , setShowModal , maxNumberOfItems  } = useCompareBar();
    const { vehicleId , make , model , thumbnailUrl  } = vehicle;
    const isSavedToCompare = comparisonVehicles.some((compareVehicle)=>vehicleId === compareVehicle.vehicleId);
    const numberOfComparedVehicles = comparisonVehicles.length;
    const handleCompareOnClick = ()=>{
        const vehicleData = {
            vehicleId,
            vehicleTitle: `${make} ${model}`,
            vehicleImage: thumbnailUrl,
            vehicleMake: make,
            vehicleModel: `${model}`
        };
        if (numberOfComparedVehicles >= maxNumberOfItems && !isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_SHOWING_MODAL, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                maxNumberOfVehicles: maxNumberOfItems
            });
            return setShowModal(true);
        }
        if (isSavedToCompare) {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_REMOVED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId,
                    make,
                    model
                }
            });
            removeVehicle(vehicleId);
        } else {
            datadogRum.addAction(SearchActions.COMPARE_VEHICLES_CTA_VEHICLE_ADDED, {
                service: SearchContext.COMPARE_SERVICE,
                squad: Context.SQUAD,
                vehicle: {
                    vehicleId,
                    make,
                    model
                }
            });
            addVehicle(vehicleData);
        }
    };
    return /*#__PURE__*/ _jsxs("button", {
        className: cx(sharedStyles.ctaButton, isSavedToCompare && sharedStyles.toggled),
        onClick: handleCompareOnClick,
        children: [
            /*#__PURE__*/ _jsx(CompareIcon, {
                isToggled: isSavedToCompare
            }),
            " Compare"
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/compare-cta/index.ts



;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/compare-and-favourite-bar.tsx









const compare_and_favourite_bar_CompareAndFavouriteBar = ({ vehicle  })=>{
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const { vehicleId , thumbnailUrl , make , model , modelYear  } = vehicle;
    const { status: userStatus  } = useUserStore();
    const { addFavourite , removeFavourite , favourites  } = useFavouritesStore();
    const isFavourited = favourites.find((favourite)=>favourite.vehicleId === vehicleId);
    const handleToggleFavourite = async ()=>{
        const messageToSend = {
            make: make,
            model: model || "",
            modelYear: Number(modelYear),
            vehicleId: vehicleId
        };
        if (isFavourited) {
            await removeFavourite(vehicleId);
            sendPostMessage("favouriteVehicleRemoved", messageToSend);
            return;
        }
        await addFavourite(vehicleId);
        sendPostMessage("favouriteVehicleAdded", messageToSend);
    };
    const handleOnFavouriteClick = async ()=>{
        const pathnameWithSearchParams = `${window.location.pathname}${window.location.search}`;
        storePreAuthFavourite({
            id: vehicleId ?? "",
            url: pathnameWithSearchParams
        });
        if (userStatus === "valid") {
            await handleToggleFavourite();
        } else {
            setIsAuthModalOpen(true);
        }
    };
    const handleAuthModalClose = ()=>{
        setIsAuthModalOpen(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsx(CompareCTA, {
                    vehicle: vehicle
                })
            }),
            /*#__PURE__*/ _jsx(FavouriteCTA, {
                isSaved: favourites.some((v)=>v.vehicleId === vehicleId),
                onClick: handleOnFavouriteClick
            }),
            /*#__PURE__*/ _jsx(AuthModal, {
                isOpen: isAuthModalOpen,
                handleClose: handleAuthModalClose,
                useBrowserNavigation: true,
                vehicleImage: thumbnailUrl
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/compare-and-favourite-bar/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/lib/vehicle-card-v2/vehicle-card-v2.tsx









const VehicleCardV2 = ({ vehicle  })=>{
    const { make , model , thumbnailUrl , isAvailable , variant , isReserved , fuelType , transmissionType , mileage , modelYear , vehicleYear , price , discountInPence  } = vehicle;
    const makeModel = `${make} ${model}`;
    const isCarOnOffer = !!discountInPence;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(VehicleImage, {
                isAvailable: isAvailable,
                src: thumbnailUrl,
                alt: makeModel
            }),
            isReserved && isAvailable && /*#__PURE__*/ _jsx("span", {
                className: cx(styles.badge, styles.reserved),
                children: "Reserved"
            }),
            isCarOnOffer && !isReserved && isAvailable && /*#__PURE__*/ _jsx("span", {
                className: cx(styles.badge, styles.discount),
                children: `${penceToPounds(discountInPence ?? 0)} off`
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: styles.title,
                                children: makeModel
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.subtitle,
                                children: variant
                            }),
                            /*#__PURE__*/ _jsx(Tags, {
                                fuelType: fuelType,
                                transmissionType: transmissionType,
                                mileage: mileage,
                                year: Number(vehicleYear || modelYear)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Price, {
                                price: price,
                                discountInPence: discountInPence || 0
                            }),
                            /*#__PURE__*/ _jsx(AdminFee, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CompareAndFavouriteBar, {
                vehicle: vehicle
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/helpers/cinch-store/generate-store-name-with-type.ts
var generate_store_name_with_type = __webpack_require__(99979);
;// CONCATENATED MODULE: ../../../libs/landing/ui/shared/src/index.ts
/** Shared UI components */ 
















/** Shared utils */ 













/***/ }),

/***/ 99979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ generateStoreType; },
/* harmony export */   "p": function() { return /* binding */ generateStoreNameWithType; }
/* harmony export */ });
const capitaliseFirstLetter = (string)=>string.replace(/(^|\s|-)([a-z])/g, (_, leadingWhitespaceOrHyphen, lowercaseLetter)=>leadingWhitespaceOrHyphen + lowercaseLetter.toUpperCase());
const generateStoreType = (storeName, shouldCapitaliseStoreType = false)=>{
    const normalisedStoreName = storeName.toLowerCase();
    const isCorby = normalisedStoreName === "corby";
    const storeType = isCorby ? "warehouse" : "store";
    return shouldCapitaliseStoreType ? capitaliseFirstLetter(storeType) : storeType;
};
const generateStoreNameWithType = (storeName, shouldCapitaliseStoreType = false)=>{
    const normalisedStoreName = storeName.toLowerCase();
    const capitalisedStoreName = capitaliseFirstLetter(normalisedStoreName);
    const capitalisedStoreType = generateStoreType(storeName, shouldCapitaliseStoreType);
    return `cinch ${capitalisedStoreType} ${capitalisedStoreName}`;
};


/***/ }),

/***/ 82749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* binding */ formatStoreToSchema; },
/* harmony export */   "_y": function() { return /* binding */ formatBreadcrumbListSchema; }
/* harmony export */ });
/* unused harmony exports formatFaqPageSchema, formatVideoSchema, formatHowToSchema, formatReviewToSchema, formatTimeTo24Hour, formatOpeningHours */
/* harmony import */ var _json_ld_script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20692);
/* harmony import */ var _helpers_cinch_store_generate_store_name_with_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99979);


const formatBreadcrumbListSchema = (breadcrumbs)=>({
        "@type": _json_ld_script__WEBPACK_IMPORTED_MODULE_0__/* .JsonLDType.BreadcrumbList */ .M.BreadcrumbList,
        itemListElement: breadcrumbs.map((crumb, index)=>({
                "@type": _json_ld_script__WEBPACK_IMPORTED_MODULE_0__/* .JsonLDType.ListItem */ .M.ListItem,
                position: index + 1,
                name: crumb.text,
                item: `${"https://landing-www-opennext.snc-prod.aws.cinch.co.uk"}${crumb.url}`
            }))
    });
const formatFaqPageSchema = (faqs)=>({
        "@type": JsonLDType.FaqPage,
        mainEntity: faqs.map(({ question , summary  })=>({
                "@type": JsonLDType.Question,
                name: question,
                acceptedAnswer: {
                    "@type": JsonLDType.Answer,
                    text: summary
                }
            }))
    });
const formatVideoSchema = (video)=>({
        "@type": JsonLDType.VideoObject,
        name: video.title,
        description: video.description,
        thumbnailUrl: video.thumbnail ? [
            video.thumbnail.filename
        ] : undefined,
        duration: video.duration,
        uploadDate: video.uploadDate
    });
const formatHowToSchema = (howto)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    return {
        "@type": JsonLDType.HowTo,
        name: (ref = howto[0]) === null || ref === void 0 ? void 0 : ref.name,
        image: (ref1 = howto[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.map((p)=>({
                "@type": "ImageObject",
                url: p.url,
                height: p.height,
                width: p.width
            })),
        video: (ref3 = howto[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.video) === null || ref4 === void 0 ? void 0 : ref4.map((p)=>{
            var ref;
            return {
                "@type": "VideoObject",
                name: p.name,
                description: p.description,
                thumbnailUrl: p.thumbnailUrl,
                contentUrl: p.contentUrl,
                embedUrl: p.embedUrl,
                uploadDate: p.uploadDate,
                duration: p.duration,
                hasPart: (ref = p.hasPart) === null || ref === void 0 ? void 0 : ref.map((element)=>({
                        "@type": "Clip",
                        "@id": element.id,
                        name: element.name,
                        startOffset: element.startOffset,
                        endOffset: element.endOffset,
                        url: element.url
                    }))
            };
        }),
        step: (ref5 = howto[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.step) === null || ref6 === void 0 ? void 0 : ref6.map((p)=>{
            var ref, ref1, ref2, ref3;
            return {
                url: p.url,
                name: p.name,
                "@type": "HowToStep",
                image: {
                    "@type": "ImageObject",
                    url: (ref = p === null || p === void 0 ? void 0 : p.image[0]) === null || ref === void 0 ? void 0 : ref.url,
                    height: (ref1 = p.image[0]) === null || ref1 === void 0 ? void 0 : ref1.height,
                    width: (ref2 = p.image[0]) === null || ref2 === void 0 ? void 0 : ref2.width
                },
                itemListElement: (ref3 = p.itemListElement) === null || ref3 === void 0 ? void 0 : ref3.map((element)=>({
                        "@type": "HowToDirection",
                        text: element.text
                    }))
            };
        }),
        supply: (ref7 = howto[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.supply) === null || ref8 === void 0 ? void 0 : ref8.map((element)=>({
                "@type": "HowToSupply",
                name: element.name
            })),
        tool: (ref9 = howto[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.tool) === null || ref10 === void 0 ? void 0 : ref10.map((element)=>({
                "@type": "HowToTool",
                name: element.name
            }))
    };
};
const formatReviewToSchema = (review, publishedDate, prosAndCons)=>{
    var ref, ref1, ref2;
    return {
        "@type": "Vehicle",
        name: `${review === null || review === void 0 ? void 0 : review.make} ${review === null || review === void 0 ? void 0 : review.model}`,
        image: (review === null || review === void 0 ? void 0 : (ref = review.gallery) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.filename) || "",
        review: {
            "@type": "Review",
            reviewRating: {
                "@type": "Rating",
                ratingValue: `${review === null || review === void 0 ? void 0 : review.starRating}`,
                bestRating: `10`,
                worstRating: `1`,
                author: {
                    "@type": "Person",
                    name: `${review === null || review === void 0 ? void 0 : review.authorName}` || `cinch`
                }
            },
            positiveNotes: {
                "@type": "ItemList",
                itemListElement: prosAndCons.pros.map((items, index)=>({
                        "@type": "ListItem",
                        position: index + 1,
                        name: items.text
                    }))
            },
            negativeNotes: {
                "@type": "ItemList",
                itemListElement: prosAndCons.cons.map((items, index)=>({
                        "@type": "ListItem",
                        position: index + 1,
                        name: items.text
                    }))
            },
            author: {
                "@type": "Person",
                name: (review === null || review === void 0 ? void 0 : review.authorName) || "cinch"
            },
            publisher: {
                "@type": "Organization",
                name: "cinch"
            },
            reviewBody: review === null || review === void 0 ? void 0 : review.snippet,
            datePublished: publishedDate.split("T")[0]
        }
    };
};
const formatTimeTo24Hour = (storeTime)=>{
    if (storeTime === "Closed") return storeTime;
    const [time, meridiem] = storeTime.split(" ");
    const [hour, minute] = time.split(":");
    const hour24 = meridiem === "AM" ? hour : Number.parseInt(hour) + 12;
    return `${hour24}:${minute}`;
};
const formatOpeningHours = (openingHoursList)=>openingHoursList.map((openingHours)=>{
        const { openingTime , closingTime , daysOfWeek  } = openingHours;
        const days = daysOfWeek.includes(" - ") ? daysOfWeek.split(" ").map((day)=>day.slice(0, 2)).join("") : daysOfWeek.slice(0, 2);
        if (openingTime === "Closed" || closingTime === "Closed") return `${days} ${openingTime}`;
        return `${days} ${formatTimeTo24Hour(openingTime)}-${formatTimeTo24Hour(closingTime)}`;
    });
const formatStoreToSchema = ({ storeSlug , storeAddress , mapInformation , phoneNumbers , openingHoursList , storeImageUrl  })=>{
    const { latitude , longitude  } = mapInformation[0];
    const { phoneNumber  } = phoneNumbers[0];
    const name = (0,_helpers_cinch_store_generate_store_name_with_type__WEBPACK_IMPORTED_MODULE_1__/* .generateStoreNameWithType */ .p)(storeSlug);
    return {
        "@type": _json_ld_script__WEBPACK_IMPORTED_MODULE_0__/* .JsonLDType.AutomotiveBusiness */ .M.AutomotiveBusiness,
        name,
        image: storeImageUrl,
        "@id": `https://cinch.co.uk/store/${storeSlug}`,
        url: `https://cinch.co.uk/store/${storeSlug}`,
        telephone: phoneNumber,
        address: {
            "@type": "PostalAddress",
            streetAddress: `${storeAddress.addressLine1}, ${storeAddress.addressLine2}`,
            addressLocality: storeAddress.townOrCity,
            postalCode: storeAddress.postCode,
            addressCountry: "GB"
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude,
            longitude
        },
        openingHours: formatOpeningHours(openingHoursList),
        contactPoint: {
            "@type": "ContactPoint",
            telephone: phoneNumber,
            contactType: "customer service",
            areaServed: "GB",
            availableLanguage: "English"
        },
        sameAs: [
            "https://www.facebook.com/cinchuk",
            "https://twitter.com/cinchuk",
            "https://www.instagram.com/cinchuk"
        ]
    };
};


/***/ }),

/***/ 20692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ JsonLdScript; },
/* harmony export */   "M": function() { return /* binding */ JsonLDType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50430);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);


var JsonLDType;
(function(JsonLDType) {
    JsonLDType["BreadcrumbList"] = "BreadcrumbList";
    JsonLDType["ListItem"] = "ListItem";
    JsonLDType["FaqPage"] = "FAQPage";
    JsonLDType["Question"] = "Question";
    JsonLDType["Answer"] = "Answer";
    JsonLDType["VideoObject"] = "VideoObject";
    JsonLDType["HowTo"] = "HowTo";
    JsonLDType["Review"] = "Review";
    JsonLDType["Vehicle"] = "Vehicle";
    JsonLDType["AutomotiveBusiness"] = "AutomotiveBusiness";
})(JsonLDType || (JsonLDType = {}));
const JsonLdScript = ({ schema , tagId  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
        type: "application/ld+json",
        "data-testid": "json-ld-script",
        id: tagId,
        strategy: "beforeInteractive",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "https://schema.org",
                ...[
                    schema
                ]
            }, null, 2)
        }
    });


/***/ }),

/***/ 40731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oM": function() { return /* reexport */ AnalyticsManager; },
  "DI": function() { return /* reexport */ EventActions; },
  "ro": function() { return /* reexport */ EventCategories; },
  "Vy": function() { return /* reexport */ EventNames; },
  "md": function() { return /* reexport */ TrackingEventTypes; },
  "ai": function() { return /* reexport */ preserveReferrerAndCID; },
  "Ym": function() { return /* reexport */ datalayer_sendDigitalDataEvent; },
  "x6": function() { return /* reexport */ simpleAnalyticsTrack; },
  "z$": function() { return /* reexport */ useAnalytics; }
});

// UNUSED EXPORTS: DirectCallRules, HotJarTriggers, addDataDogUserAction, addToDigitalDataEvent, buildTagDataAttr, customEventNames, getDataLayer, getStandardPageInfo, getTrackingTargetMeta, getVehicleReturned, isInitialPageLoad, loggedInFavouriteEvent, mapVehicleData, resetProductDisplay, segmentSnippet, sendDataLayerEvent, sendHotjarEvent, sendHotjarTag, sendHotjarTrigger, storeEvents, trackCustomEvent, trackNewVehicles, trackVehicleDisplay, updateCompareInformation, updateDataLayerUserId, updateFindVehiclePanel, updatePageInfo, updateVehicleFilters, updateVehicleInformation

// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/event-page-view.ts

function cleanPageName(str) {
    return str.replace(/[/-]/g, (substring, ...args)=>{
        const [position, original] = args;
        if (position === 0 || position === original.length - 1) {
            return "";
        }
        if (substring === "/") {
            return ":";
        }
        if (substring === "-") {
            return "_";
        }
        return substring;
    });
}
const rewritePageName = (name)=>{
    if (name === "") {
        return "homepage";
    }
    if (name.split(":")[0] === "vehicle") {
        return "vehicle_details";
    }
    if (name.split(":")[0] === "dealers") {
        if (name.split(":")[1] === "vehicle") {
            return "vehicle_details";
        }
        if (name.split(":")[1] === "find_vehicle") {
            return "find_vehicle";
        }
    }
    if (name.split(":")[0] === "direct" && name.split(":")[1] === "vehicle") {
        return "vehicle_details";
    }
    if (name.split(":")[0] === "used_cars") {
        if (name.split(":")[3] === "details") {
            return "vehicle_details";
        }
        return "find_vehicle";
    }
    return name;
};
/**
 * This method should update the data layer with location information for the pageInfo object
 */ function updatePageInfo({ location , prevLocation  }) {
    const oxfordRoutes = [
        "/dealers/find-vehicle",
        "/vehicle"
    ];
    const cambridgeRoutes = [
        "/find-vehicle",
        "/used-cars"
    ];
    if (src/* isBrowser */.jU) {
        const dl = window.adobeData;
        if (dl && dl.page && dl.page.pageInfo) {
            dl.page.pageInfo.pageURL = location.href;
            dl.page.pageInfo.pageName = rewritePageName(cleanPageName(location.pathname));
            if (prevLocation) {
                dl.page.pageInfo.previousPageName = rewritePageName(cleanPageName(prevLocation.pathname || ""));
            }
            dl.page.pageInfo.project = "";
            if (cambridgeRoutes.some((x)=>location.pathname.startsWith(x))) {
                dl.page.pageInfo.project = "cinch";
            } else if (oxfordRoutes.some((x)=>location.pathname.startsWith(x))) {
                dl.page.pageInfo.project = "dealer";
            }
        }
    }
}
function getSiteInfoForDigitalData() {
    const platformType = (0,src/* isMobile */.tq)() ? "mobileWeb" : "desktopWeb";
    return {
        brandCode: "cinch",
        brandName: "cinch",
        language: "en-gb",
        country: "gb",
        platformType
    };
}
/* Expects a string in the following format:
  'cinch:direct:veh icle:1234'
  'cinch:used-cars:audi:a1:1234'
   generated by writeStandardPageInfoToDataLayer()
 */ const pageNameContainsVehicleId = (pageName)=>{
    const pageNameSplit = pageName.split(":");
    // Only the FPA and checkout journeys contain IDs in their paths - see gatsby-node.ts for the routes
    const deprecatedFPAPageName = pageNameSplit[1] === "direct" && pageNameSplit[2] === "vehicle";
    const currentFPAPageName = pageNameSplit[1] === "used-cars" && pageNameSplit[4] === "details";
    const checkoutPageName = pageNameSplit[1] === "checkout";
    return deprecatedFPAPageName || currentFPAPageName || checkoutPageName;
};
function getStandardPageInfo(currentLocationPath, previousLocationPath) {
    let finalisedPageName;
    let eventValue = {};
    const transformedPageName = `cinch:${currentLocationPath.replace(/^\/|\/$/g, "") // trim starting and ending slashes
    .replace(/\//g, ":") // replace remaining slashes with colons
    .replace(/(%20)/g, "-")}` // replace spaces in url with hyphens
    ;
    finalisedPageName = pageNameContainsVehicleId(transformedPageName) ? transformedPageName.split(":").slice(0, -1).join(":") : transformedPageName;
    if (finalisedPageName.includes("used-cars") && finalisedPageName.includes("details")) {
        finalisedPageName = "cinch:direct:vehicle";
    }
    if (finalisedPageName.includes("track")) {
        eventValue = {
            value: finalisedPageName.split(":")[3]
        };
        finalisedPageName = "cinch:my_profile:orders:track";
    }
    if (finalisedPageName.includes("used-cars")) {
        finalisedPageName = "cinch:find_vehicle";
    }
    const payload = {
        event: {
            name: "pageView",
            ...eventValue
        },
        page: {
            pageName: finalisedPageName,
            pagePath: currentLocationPath
        }
    };
    // Only post site module on first page load
    if (previousLocationPath === undefined) {
        payload.site = getSiteInfoForDigitalData();
    }
    if (previousLocationPath !== undefined) {
        payload.page.previousPage = previousLocationPath;
    }
    return payload;
}
/* harmony default export */ var event_page_view = ((/* unused pure expression or super */ null && (updatePageInfo)));

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/custom-event-names.ts
/* harmony default export */ var custom_event_names = ({
    addToCompare: "add-to-compare",
    addToFavourite: "add-to-favourite",
    appInstallAccepted: "app-install-accepted",
    appInstallRejected: "app-install-rejected",
    appInstalled: "app-installed",
    dealerPhoneCalled: "dealer-phone-called",
    dealerPhoneClicked: "dealer-phone-clicked",
    downloadPartnerData: "download-partner-data",
    downloadUserData: "download-user-data",
    findCarIcons: "find-car-icons",
    hideMapClicked: "hide-map-clicked",
    messageCallbackClicked: "callback-popup-opened",
    messageCallbackError: "callback-request-error",
    messageCallbackSuccess: "callback-request-success",
    messageDealerClicked: "message-dealer-clicked",
    messageDealerClickedPhoneModal: "message-dealer-clicked-phone-modal",
    messageDealerError: "message-dealer-error",
    messageDealerSuccess: "message-dealer-success",
    openMarketingPreferencesClicked: "open-marketing-preferences-clicked",
    openProfileDetailsClicked: "open-profile-details-clicked",
    printAdvertClicked: "print-advert-clicked",
    registrationError: "registration-error",
    registrationSuccess: "registration-success",
    removeFromCompareBar: "remove-from-compare-bar",
    removeFromCompareCard: "remove-from-compare-card",
    removeFromFavourites: "remove-from-favourites",
    requestUserData: "request-user-data",
    showMapClicked: "show-map-clicked",
    siteExitCazoo: "site-exit-cazoo",
    siteExitExperian: "site-exit-experian",
    unregisteredUserAddToFavourite: "unregistered-user-add-to-favourite",
    vehicleDetailLoadError: "vehicle-detail-load-error",
    vehicleDetailLoadSuccess: "vehicle-detail-load-success",
    vehicleListing: "vehicle-listing",
    vehicleListingLoadSuccess: "vehicle-listing-load-success",
    vehicleListingSendImpressions: "vehicle-listing-send-impressions",
    visitWebsiteClicked: "visit-website-clicked"
});

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/simple-analytics/api-calls.ts
const simpleAnalyticsTrack = (eventName)=>{
    if (!eventName || eventName.length === 0) return;
    window && window.sa_event && window.sa_event(eventName);
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/user.ts
// import { User } from 'oidc-client'
// import { getUserId } from '../../auth/src'
// import { UserState } from '@store/user'

// export function updateDataLayerUserId(user: User) {
//   const userSub = getUserId(user) || ''
//
//   if (isBrowser) {
//     const dl = window.adobeData
//     if (dl && dl.page && dl.page.user) {
//       dl.page.user.aaId = userSub
//     }
//   }
//
//   return user
// }
function updateDataLayerUserId(profileSub) {
    if (isBrowser) {
        const dl = window.adobeData;
        if (dl && dl.page && dl.page.user) {
            dl.page.user.aaId = profileSub;
        }
    }
    return;
}

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/direct-call-rules.ts
/**
 * These names are given to by the client, do not change.
 */ var DirectCallRules;
(function(DirectCallRules) {
    DirectCallRules["NAME_PAGE_VIEW"] = "page_view";
    DirectCallRules["NAME_INITIAL_PAGE_LOAD"] = "initial_page_load";
    DirectCallRules["LOAD_INITIAL"] = "load_initial";
    DirectCallRules["LOAD_MORE"] = "load_more";
})(DirectCallRules || (DirectCallRules = {}));

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/data-layer.ts

const getDataLayer = ()=>{
    if (src/* isBrowser */.jU) {
        const dl = window.adobeData;
        if (dl) {
            return dl;
        }
    }
    return;
};
const getTrackingTargetMeta = ()=>{
    if (isBrowser) {
        const ttMETA = window.ttMETA;
        return ttMETA ?? [];
    }
    return;
};
const updateCompareInformation = (data)=>{
    const dl = getDataLayer();
    if (dl) {
        dl.page.compareInformation = data;
    }
};
// Still used by dealer favouriting
const updateVehicleInformation = (data)=>{
    const dl = getDataLayer();
    if (dl) {
        dl.page.vehicleInformation = data;
    }
};
// Still used by dealer find vehicle
const updateVehicleFilters = (data)=>{
    const dl = getDataLayer();
    if (dl) {
        dl.page.vehicleFilters = data;
    }
};
/**
 * @deprecated
 */ const updateFindVehiclePanel = (data)=>{
    const dl = getDataLayer();
    if (dl) {
        dl.page.pageInfo.findVehiclePanel = data;
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/data-layer/datalayer.ts

const sendDataLayerEvent = (data)=>{
    if (isBrowser) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addServiceTrackingIdsToEvent = (data)=>{
    if ( false || !Object.prototype.hasOwnProperty.call(data, "event")) {
        return data;
    }
    const { adobeID , gaID  } = (0,src/* getAnalyticIDs */.cF)();
    const event = data["event"];
    if (adobeID) {
        event.adobeID = adobeID;
    }
    if (gaID) {
        event.gaID = gaID;
    }
    return {
        ...data,
        event
    };
};
const datalayer_sendDigitalDataEvent = (data)=>{
    if (window && data) {
        window.digitalData = window.digitalData || [];
        const trackableEvent = addServiceTrackingIdsToEvent(data);
        window.digitalData.push(trackableEvent);
    }
};
const addToDigitalDataEvent = (data)=>{
    if ( true && window.digitalData.length > 0) {
        const updatedDigitDataLayer = window.digitalData.reduce((dataLayer, event)=>{
            const updatedDataLayerObject = {
                ...event,
                ...data
            };
            return [
                {
                    ...dataLayer,
                    ...updatedDataLayerObject
                }
            ];
        }, []);
        window.digitalData = updatedDigitDataLayer;
    }
};
const sendHotjarEvent = (event)=>{
    if ( true && window.hj) {
        window.hj("event", event);
    }
};
const sendHotjarTag = (tag)=>{
    if ( true && window.hj) {
        window.hj("tagRecording", [
            tag
        ]);
    }
};
const sendHotjarTrigger = (triggerName)=>{
    if ( true && window.hj) {
        window.hj("trigger", triggerName);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/data-layer/favourites/events.ts

const loggedInFavouriteEvent = (vehicle, action)=>{
    if (vehicle) {
        const payload = {
            event: {
                name: `logged-in-${action}`,
                category: "button",
                action,
                label: "logged in"
            },
            product: [
                {
                    vehicle: vehicle[0].vehicle
                }
            ]
        };
        sendDigitalDataEvent(payload);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/data-layer/index.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const storeEvents = {};




;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/product-display.ts



var vehicleAction;
(function(vehicleAction) {
    vehicleAction["seenInitial"] = "seenInitial";
    vehicleAction["seenMore"] = "seenMore";
    vehicleAction["notSeen"] = "notSeen";
})(vehicleAction || (vehicleAction = {}));
let isInitialPageLoad = true;
const getVehicleReturned = ()=>{
    const dl = getDataLayer();
    if (!dl) {
        return;
    }
    if (dl && !dl.page.vehicleReturned) {
        dl.page.vehicleReturned = new Map();
    }
    return dl.page.vehicleReturned;
};
const trackNewVehicles = (vehicles = [])=>{
    const dl = getVehicleReturned();
    if (!dl) {
        return;
    }
    dl.clear();
    const mappedVehicles = vehicles.map((vehicle)=>({
            advertId: typeof vehicle.vehicleId === "number" ? vehicle.vehicleId.toString() : vehicle.vehicleId,
            dealerId: vehicle.webDealerProfileId,
            imageCount: vehicle.imageCount,
            price: typeof vehicle.price === "number" ? vehicle.price : Number.parseInt(vehicle.price.replace(/\D+/g, ""), 10)
        }));
    for (const vehicle of mappedVehicles){
        dl.set(vehicle.advertId, {
            ...vehicle,
            action: vehicleAction.notSeen
        });
    }
    trackCustomEvent({
        name: customEventNames.vehicleListingLoadSuccess,
        details: mappedVehicles
    });
};
const resetProductDisplay = ()=>{
    const dl = getVehicleReturned();
    if (!dl) {
        return;
    }
    isInitialPageLoad = true;
    dl.clear();
};
const trackVehicleDisplay = (advertId, isDisplayed, isInitialLoad)=>{
    const dl = getVehicleReturned();
    if (!dl) {
        return;
    }
    const vehicle = dl.get(advertId);
    if (vehicle && isDisplayed) {
        const action = vehicle.action === vehicleAction.seenInitial || isInitialLoad ? vehicleAction.seenInitial : vehicleAction.seenMore;
        dl.set(advertId, {
            ...vehicle,
            action
        });
    }
};

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/user/src/index.ts + 9 modules
var user_src = __webpack_require__(47453);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/utils/index.ts
const getEnvironmentFromURL = (hostname)=>{
    switch(hostname){
        case "www.cinch.co.uk":
        case "landing.api.cinch.co.uk":
            return "production";
        case "cambridge.preview.aws.cinch.co.uk":
            return "cambridge";
        case "landing.preview.aws.cinch.co.uk":
            return "development";
        default:
            if (hostname.includes(".feature.")) {
                return hostname.split(".")[0];
            }
            return hostname;
    }
};
const hasWindow = "object" !== "undefined";


;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/rum/init.ts


const initDataDogRUM = ({ serviceName: service , rumGlobalSampleRate: sampleRate , rumGlobalSessionReplayRate: replaySampleRate , applicationId , datadogRumClientToken: clientToken , appVersion: version  })=>{
    if (hasWindow) {
        const env = getEnvironmentFromURL(window.location.hostname);
        const botPattern = "(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        const regex = new RegExp(botPattern, "i");
        const isBot = regex.test(navigator.userAgent);
        const conditionalSampleRate = isBot ? 0 : sampleRate;
        const conditionalReplaySampleRate = isBot ? 0 : replaySampleRate;
        main/* datadogRum.init */.v.init({
            applicationId,
            clientToken,
            sessionSampleRate: conditionalSampleRate,
            sessionReplaySampleRate: conditionalReplaySampleRate,
            env,
            trackUserInteractions: true,
            defaultPrivacyLevel: "mask-user-input",
            service,
            site: "datadoghq.eu",
            version,
            silentMultipleInit: true,
            allowedTracingUrls: [
                {
                    match: "https://api-dev.cinch.co.uk",
                    propagatorTypes: [
                        "datadog"
                    ]
                },
                {
                    match: "https://api-production.cinch.co.uk",
                    propagatorTypes: [
                        "datadog"
                    ]
                },
                {
                    match: "https://localhost:4200",
                    propagatorTypes: [
                        "datadog"
                    ]
                },
                {
                    match: /^https:\/\/.*\.snc-(dev|prod)\.aws\.cinch\.co\.uk\/.*/,
                    propagatorTypes: [
                        "datadog"
                    ]
                }
            ],
            enableExperimentalFeatures: [
                "feature_flags"
            ]
        });
        main/* datadogRum.startSessionReplayRecording */.v.startSessionReplayRecording();
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/rum/add-sms-order-tracking.ts

const addSMSDataDogUserAction = (name, context)=>{
    datadogRum.addAction(name, context);
};


;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/rum/index.ts



// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/entries/main.js + 20 modules
var entries_main = __webpack_require__(39806);
;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/logs/init.ts


const initDataDogLogging = ({ serviceName: service , datadogRumClientToken: clientToken  })=>{
    if (hasWindow) {
        const currentEnv = getEnvironmentFromURL(window.location.hostname);
        entries_main/* datadogLogs.init */.fy.init({
            clientToken,
            site: "datadoghq.eu",
            forwardErrorsToLogs: true,
            service,
            sessionSampleRate: 100,
            silentMultipleInit: true
        });
        entries_main/* datadogLogs.setGlobalContextProperty */.fy.setGlobalContextProperty("env", currentEnv);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/lib/logs/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/datadog/src/index.ts




// EXTERNAL MODULE: ../../../libs/shared/zendesk-messenger/src/index.ts + 4 modules
var zendesk_messenger_src = __webpack_require__(5874);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/next/script.js
var script = __webpack_require__(50430);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/segment/initialisation-script.ts
const segmentSnippet = `!(function () {
    var analytics = (window.analytics = window.analytics || [])
    if (!analytics.initialize)
      if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.')
      else {
        analytics.invoked = !0
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
          'addSourceMiddleware',
          'addIntegrationMiddleware',
          'setAnonymousId',
          'addDestinationMiddleware',
        ]
        analytics.factory = function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments)
            t.unshift(e)
            analytics.push(t)
            return analytics
          }
        }
        for (var e = 0; e < analytics.methods.length; e++) {
          var key = analytics.methods[e]
          analytics[key] = analytics.factory(key)
        }
        analytics.load = function (key, e) {
          var t = document.createElement('script')
          t.type = 'text/javascript'
          t.async = !0
          t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
          var n = document.getElementsByTagName('script')[0]
          n.parentNode.insertBefore(t, n)
          analytics._loadOptions = e
        }
        analytics.SNIPPET_VERSION = '4.13.1'
      }
  })()`;

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/simple-analytics/script-loader.tsx


const isProduction = "production" === "production";
const scripts = {
    development: "https://scripts.simpleanalyticscdn.com/latest.dev.js",
    production: "https://scripts.simpleanalyticscdn.com/latest.js"
};
function SimpleAnalyticsScripts() {
    const hostname = isProduction ? "www.cinch.co.uk" : "cambridge.preview.aws.cinch.co.uk";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "SA",
                src: isProduction ? scripts["production"] : scripts["development"],
                strategy: "beforeInteractive",
                "data-allow-params": "CID",
                "data-hostname": hostname
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: `https://queue.simpleanalyticscdn.com/noscript.gif?hostname=${hostname}`,
                    alt: "",
                    referrerPolicy: "no-referrer-when-downgrade"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/types.ts
var EventActions;
(function(EventActions) {
    EventActions["button"] = "button";
    EventActions["click"] = "click";
    EventActions["cinchcareAddedToOrder"] = "cinchCare added to order";
    EventActions["modalOpened"] = "modal-opened";
    EventActions["modalClosed"] = "modal-closed";
    EventActions["returnToCheckout"] = "return-to-checkout";
    EventActions["orderCompleteClick"] = "order complete click";
    EventActions["orderDeclinedClick"] = "order declined click";
    EventActions["orderTrackingViewed"] = "order tracking viewed";
    EventActions["filter"] = "filter";
    EventActions["navigate"] = "navigate";
    EventActions["noReviewsFound"] = "no reviews found";
    EventActions["saveQuote"] = "save-quote";
    EventActions["personalDetails"] = "personal details";
    EventActions["savePersonalDetails"] = "save personal details";
    EventActions["cancelPersonalDetails"] = "cancel personal details";
    EventActions["firstNameDetails"] = "first name details";
    EventActions["lastNameDetails"] = "last name details";
    EventActions["mobileNumberDetails"] = "mobile number details";
    EventActions["changePassword"] = "change password";
    EventActions["marketingPreferences"] = "marketing preferences";
    EventActions["logOut"] = "log out";
    EventActions["view"] = "view";
})(EventActions || (EventActions = {}));
var EventCategories;
(function(EventCategories) {
    EventCategories["button"] = "button";
    EventCategories["cinchcare"] = "cinchcare";
    EventCategories["favourites"] = "Favourites";
    EventCategories["orders"] = "Orders";
    EventCategories["orderTracking"] = "Order Tracking";
    EventCategories["profileDetails"] = "Profile Details";
    EventCategories["myProfile"] = "My profile";
    EventCategories["reviews"] = "reviews";
    EventCategories["personalDetails"] = "personal details";
    EventCategories["adminFee"] = "admin fees";
    EventCategories["financeChangeCar"] = "finance change car";
})(EventCategories || (EventCategories = {}));
var EventNames;
(function(EventNames) {
    EventNames["click"] = "click";
    EventNames["error"] = "error";
    EventNames["identify"] = "identify";
    EventNames["load"] = "load";
    EventNames["impression"] = "impression";
    EventNames["scAdd"] = "scAdd";
})(EventNames || (EventNames = {}));
var TrackingEventTypes;
(function(TrackingEventTypes) {
    TrackingEventTypes["TRACK"] = "trackQueue";
    TrackingEventTypes["IDENTIFY"] = "identifyQueue";
    TrackingEventTypes["PAGE"] = "pageQueue";
    TrackingEventTypes["ADOBE"] = "adobeQueue";
    TrackingEventTypes["HOTJAR_EVENT"] = "hotJarEventQueue";
    TrackingEventTypes["HOTJAR_TAG"] = "hotJarTagQueue";
    TrackingEventTypes["HOTJAR_TRIGGER"] = "hotJarTriggerQueue";
    TrackingEventTypes["PAGE_NO_ADOBE"] = "pageQueueNoAdobe";
})(TrackingEventTypes || (TrackingEventTypes = {}));
var HotJarTriggers;
(function(HotJarTriggers) {
    HotJarTriggers["MYPROFILE_WITH_ORDERS"] = "myprofile_with_orders";
})(HotJarTriggers || (HotJarTriggers = {}));

// EXTERNAL MODULE: ../../../libs/customer-data/segment/src/index.ts + 4 modules
var segment_src = __webpack_require__(72777);
// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/use-analytics.hook.ts





const getCookie = ({ name  })=>{
    var ref;
    if (!src/* isBrowser */.jU) {
        return undefined;
    }
    return ((ref = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)) === null || ref === void 0 ? void 0 : ref.pop()) ?? undefined;
};
const getCookieConsentPreferences = (name)=>cookiePreferencesCookieParser(getCookie({
        name
    }));
const cookiePreferencesCookieParser = (cookieContents)=>cookieContents ? JSON.parse(cookieContents) : undefined;
const useAnalytics = (0,esm/* create */.Ue)((set, get)=>{
    return {
        eventsQueue: [],
        next: ()=>get().eventsQueue.shift(),
        hasAcceptedAnalyticsCookies: false,
        setHasAcceptedAnalyticsCookies: (accepted)=>set({
                hasAcceptedAnalyticsCookies: accepted
            }),
        hasLoadedScripts: false,
        setHasLoadedScripts: (loaded)=>set({
                hasLoadedScripts: loaded
            }),
        trackEvent: (event)=>set((state)=>({
                    eventsQueue: [
                        ...state.eventsQueue,
                        event
                    ]
                })),
        processEventsQueue: ()=>{
            const cookiePreferences = getCookieConsentPreferences("cp");
            if (!(cookiePreferences === null || cookiePreferences === void 0 ? void 0 : cookiePreferences.analytics)) {
                return;
            }
            while(get().eventsQueue.length > 0){
                const event = get().next();
                if (!event) {
                    return;
                }
                switch(event.type){
                    case TrackingEventTypes.IDENTIFY:
                        if (event.userId) {
                            (0,segment_src/* identify */.yV)({
                                userId: event.userId,
                                data: event.data || {}
                            });
                        } else {
                            (0,segment_src/* identify */.yV)({
                                data: event.data || {}
                            });
                        }
                        break;
                    case TrackingEventTypes.TRACK:
                        (0,segment_src/* track */.j)(event.eventName, event.data);
                        break;
                    case TrackingEventTypes.ADOBE:
                        datalayer_sendDigitalDataEvent(event.data);
                        break;
                    case TrackingEventTypes.PAGE:
                        (0,segment_src/* page */.Md)(event.eventName, event.data);
                        datalayer_sendDigitalDataEvent(event.data);
                        break;
                    case TrackingEventTypes.HOTJAR_TAG:
                        sendHotjarTag(event.eventName);
                        break;
                    case TrackingEventTypes.HOTJAR_TRIGGER:
                        sendHotjarTrigger(event.eventName);
                        break;
                    case TrackingEventTypes.HOTJAR_EVENT:
                        sendHotjarEvent(event.eventName);
                        break;
                    case TrackingEventTypes.PAGE_NO_ADOBE:
                        (0,segment_src/* page */.Md)(event.eventName, event.data);
                        break;
                }
            }
        }
    };
});

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/analytics-manager.tsx

















const TIKTOK_CLICKID_QUERY_PARAMETER = "ttclid";
const isPerformanceNavigationTiming = (input)=>{
    return (input === null || input === void 0 ? void 0 : input.entryType) === "navigation";
};
const useTrackNextRouterEvents = (trackEvent, pathsWithCustomAdobePageViewEventImplementations)=>{
    const router = (0,next_router.useRouter)();
    const handleRouteChange = ()=>{
        let prevLocation = JSON.parse(sessionStorage.getItem("prevLocation") ?? "{}");
        if ((prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname) === undefined) {
            prevLocation = undefined;
        }
        // eslint-disable-next-line no-restricted-globals
        updatePageInfo({
            location,
            prevLocation
        });
        updateVehicleInformation({});
        const eventName = prevLocation ? DirectCallRules.NAME_PAGE_VIEW : DirectCallRules.NAME_INITIAL_PAGE_LOAD;
        const isPageView = eventName === DirectCallRules.NAME_PAGE_VIEW;
        if (isPageView) {
            resetProductDisplay();
        }
        if (src/* isBrowser */.jU) {
            var ref, ref1, ref2;
            const eventType = (pathsWithCustomAdobePageViewEventImplementations === null || pathsWithCustomAdobePageViewEventImplementations === void 0 ? void 0 : pathsWithCustomAdobePageViewEventImplementations.includes(window.location.pathname)) ? TrackingEventTypes.PAGE_NO_ADOBE : TrackingEventTypes.PAGE;
            trackEvent({
                type: eventType,
                eventName: (ref = window.adobeData) === null || ref === void 0 ? void 0 : (ref1 = ref.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.pageName,
                data: getStandardPageInfo(window.location.pathname, prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname)
            });
            const params = new URLSearchParams(window.location.search);
            const ttclid = params.get(TIKTOK_CLICKID_QUERY_PARAMETER);
            if (ttclid) {
                trackEvent({
                    type: TrackingEventTypes.IDENTIFY,
                    data: {
                        ttclid
                    }
                });
            }
        }
    };
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const onRouteChangeStart = ()=>{
        if (src/* isBrowser */.jU) {
            sessionStorage.setItem("prevLocation", JSON.stringify(window.location));
        }
    };
    const onRouteChangeComplete = (_url, { shallow  })=>{
        if (shallow) return;
        handleRouteChange();
    };
    const onCachedPageShow = (event)=>{
        const navigation = performance.getEntriesByType("navigation")[0];
        if (isPerformanceNavigationTiming(navigation)) {
            const navigationType = navigation.type;
            if (event.persisted && navigationType === "back_forward") {
                handleRouteChange();
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (!router) {
            return;
        }
        handleRouteChange();
        router.events.on("routeChangeStart", onRouteChangeStart);
        router.events.on("routeChangeComplete", onRouteChangeComplete);
        window.addEventListener("pageshow", onCachedPageShow);
        return ()=>{
            router.events.off("routeChangeStart", onRouteChangeStart);
            router.events.off("routeChangeComplete", onRouteChangeComplete);
            window.removeEventListener("pageshow", onCachedPageShow);
        };
    }, []);
};
const useDatadog = ()=>{
    const [hasInitialised, setHasInitialised] = (0,react.useState)(false);
    const getSampleRate = ()=>{
        const fromEnv = Number.parseInt((0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogRumGlobalSampleRate */.X.DataDogRumGlobalSampleRate), 10);
        return fromEnv && !Number.isNaN(fromEnv) ? fromEnv : 50;
    };
    const getReplaySampleRate = ()=>{
        const fromEnv = Number.parseInt((0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogRumGlobalReplaySampleRate */.X.DataDogRumGlobalReplaySampleRate), 10);
        return fromEnv && !Number.isNaN(fromEnv) ? fromEnv : 0;
    };
    const datadogEnvironment = {
        appVersion: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.BuildId */.X.BuildId),
        applicationId: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogRumApplicationId */.X.DataDogRumApplicationId),
        dataDogClientId: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogClientId */.X.DataDogClientId),
        datadogRumClientToken: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogRumClientToken */.X.DataDogRumClientToken),
        rumGlobalSampleRate: getSampleRate(),
        rumGlobalSessionReplayRate: getReplaySampleRate(),
        serviceName: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.DataDogServiceName */.X.DataDogServiceName)
    };
    (0,react.useEffect)(()=>{
        if (!hasInitialised) {
            setHasInitialised(true);
            initDataDogLogging(datadogEnvironment);
            initDataDogRUM(datadogEnvironment);
        }
    }, [
        hasInitialised
    ]);
};
const featureFlags = {
    enabledZendeskScript: (0,environments_src/* readFromEnv */.u)(environments_src/* Env.EnabledZendeskScript */.X.EnabledZendeskScript) === "true"
};
const AnalyticsManager = ({ pathsWithCustomAdobePageViewEventImplementations , enableLiveChat =true  })=>{
    var ref;
    const { status: userStatus , token  } = (0,user_src/* useUserStore */.LM)();
    const { eventsQueue , processEventsQueue , hasAcceptedAnalyticsCookies , hasLoadedScripts , trackEvent  } = useAnalytics();
    const IS_MOBILE_APP =  true && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    useDatadog();
    useTrackNextRouterEvents(trackEvent, pathsWithCustomAdobePageViewEventImplementations);
    (0,react.useEffect)(()=>{
        processEventsQueue();
    }, [
        eventsQueue,
        processEventsQueue,
        hasAcceptedAnalyticsCookies,
        hasLoadedScripts
    ]);
    (0,react.useEffect)(()=>{
        if (userStatus === "valid") {
            trackEvent({
                type: TrackingEventTypes.IDENTIFY,
                userId: token === null || token === void 0 ? void 0 : token.profile["https://cinch.co.uk/user_id"]
            });
        }
    }, [
        token === null || token === void 0 ? void 0 : token.profile.sub,
        trackEvent,
        userStatus
    ]);
    const analyticsScripts = `https://assets.adobedtm.com/${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.Adobe */.X.Adobe)}.js`;
    const marketingScripts = [
        `https://www.googletagmanager.com/gtag/js?id=DC-10250799`,
        `https://www.googletagmanager.com/gtag/js?id=G-P06Z9MC4S`,
        "https://p.teads.tv/teads-fellow.js"
    ];
    const cookiePreferences = getCookieConsentPreferences("cp");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "segment-snippet",
                dangerouslySetInnerHTML: {
                    __html: segmentSnippet
                },
                strategy: "beforeInteractive"
            }, "segment-snippet"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                "data-testid": "data-layer",
                id: "data-layer",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: `window.adobeData = ${JSON.stringify({
                        page: {
                            pageInfo: {
                                brand: "cinch",
                                pageName: "",
                                pageURL: "",
                                previousPageName: ""
                            },
                            user: {
                                aaId: ""
                            }
                        }
                    })};`
                }
            }, "data-layer"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "digital-data-layer",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: `
            window.digitalData = window.digitalData || [];
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments) }
          `
                }
            }, "digital-data-layer"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleAnalyticsScripts, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "AWIN",
                src: "https://www.dwin1.com/30879.js",
                type: "text/javascript"
            }),
            (cookiePreferences === null || cookiePreferences === void 0 ? void 0 : cookiePreferences.analytics) && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "adobe-analytics",
                src: analyticsScripts
            }, "adobe-analytics"),
            (cookiePreferences === null || cookiePreferences === void 0 ? void 0 : cookiePreferences.advertising) && marketingScripts.map((marketingScript, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: `marketing-analytics-${index}`,
                    src: marketingScript
                }, `marketing-analytics-${index}`)),
            featureFlags.enabledZendeskScript && enableLiveChat && !IS_MOBILE_APP ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                ...(0,zendesk_messenger_src/* zendeskMessengerScriptProps */.LF)({
                    id: "ze-snippet",
                    env: "production" || 0
                })
            }) : null
        ]
    }, "analytics-manager-scripts");
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/add-user-action.ts

const addDataDogUserAction = (name, context)=>{
    datadogRum.addAction(name, context);
};


;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/preserve-session-data.ts
const preserveReferrerAndCID = ()=>{
    const isBrowser = "object" !== "undefined";
    if (isBrowser) {
        const sessionStorage = window.sessionStorage;
        const savedCID = sessionStorage.getItem("CID");
        if (!savedCID) {
            const urlParams = new URLSearchParams(window.location.search);
            const cid = urlParams.get("CID") ?? urlParams.get("cid");
            sessionStorage.setItem("CID", cid ? cid : "");
        }
        const savedReferrer = sessionStorage.getItem("referrer");
        if (!savedReferrer) {
            const referrer = document.referrer;
            if (referrer.indexOf(`${window.location.protocol}//${window.location.host}`) !== 0) {
                sessionStorage.setItem("referrer", referrer ? referrer : "");
            }
        }
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/analytics-manager/index.ts






;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/lib/index.ts














;// CONCATENATED MODULE: ../../../libs/shared/analytics/src/index.ts



/***/ }),

/***/ 93194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gk": function() { return /* reexport */ cookie_consent_container; },
  "EW": function() { return /* reexport */ cookieSettings; },
  "US": function() { return /* reexport */ getCookieSettings; }
});

// UNUSED EXPORTS: getCookie, getCookieConsentPreferences, segmentSnippet, setCookie

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(49189);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ../../../node_modules/@segment/top-domain/lib/index.js
var lib = __webpack_require__(5411);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../../../node_modules/events/events.js
var events = __webpack_require__(97531);
;// CONCATENATED MODULE: ../../../node_modules/@segment/consent-manager/esm/consent-manager-builder/preferences.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// TODO: remove duplicate cookie library from bundle



var DEFAULT_COOKIE_NAME = 'tracking-preferences';
var COOKIE_DEFAULT_EXPIRES = 365;
// TODO: harden against invalid cookies
// TODO: harden against different versions of cookies
function loadPreferences(cookieName) {
    var preferences = js_cookie_default().getJSON(cookieName || DEFAULT_COOKIE_NAME);
    if (!preferences) {
        return {};
    }
    return {
        destinationPreferences: preferences.destinations,
        customPreferences: preferences.custom
    };
}
var emitter = new events.EventEmitter();
/**
 * Subscribes to consent preferences changing over time and returns
 * a cleanup function that can be invoked to remove the instantiated listener.
 *
 * @param listener a function to be invoked when ConsentPreferences are saved
 */
function onPreferencesSaved(listener) {
    emitter.on('preferencesSaved', listener);
    return function () { return emitter.off('preferencesSaved', listener); };
}
function savePreferences(_a) {
    var destinationPreferences = _a.destinationPreferences, customPreferences = _a.customPreferences, cookieDomain = _a.cookieDomain, cookieName = _a.cookieName, cookieExpires = _a.cookieExpires, _b = _a.cookieAttributes, cookieAttributes = _b === void 0 ? {} : _b;
    var wd = window;
    if (wd.analytics) {
        wd.analytics.identify({
            destinationTrackingPreferences: destinationPreferences,
            customTrackingPreferences: customPreferences
        });
    }
    var domain = cookieDomain || lib_default()(window.location.href);
    var expires = cookieExpires || COOKIE_DEFAULT_EXPIRES;
    var value = {
        version: 1,
        destinations: destinationPreferences,
        custom: customPreferences
    };
    js_cookie_default().set(cookieName || DEFAULT_COOKIE_NAME, value, __assign({ expires: expires,
        domain: domain }, cookieAttributes));
    emitter.emit('preferencesSaved', {
        destinationPreferences: destinationPreferences,
        customPreferences: customPreferences
    });
}
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ../../../node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(61937);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
// EXTERNAL MODULE: ../../../node_modules/lodash/flatten.js
var flatten = __webpack_require__(75453);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ../../../node_modules/lodash/sortedUniqBy.js
var sortedUniqBy = __webpack_require__(64196);
var sortedUniqBy_default = /*#__PURE__*/__webpack_require__.n(sortedUniqBy);
// EXTERNAL MODULE: ../../../node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(98978);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ../../../node_modules/@segment/consent-manager/esm/consent-manager-builder/fetch-destinations.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




function fetchDestinationForWriteKey(cdnHost, writeKey) {
    return __awaiter(this, void 0, void 0, function () {
        var res, destinations, _i, destinations_1, destination;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch_npm_browserify_default()("https://" + cdnHost + "/v1/projects/" + writeKey + "/integrations")];
                case 1:
                    res = _a.sent();
                    if (!res.ok) {
                        throw new Error("Failed to fetch integrations for write key " + writeKey + ": HTTP " + res.status + " " + res.statusText);
                    }
                    return [4 /*yield*/, res.json()
                        // Rename creationName to id to abstract the weird data model
                    ];
                case 2:
                    destinations = _a.sent();
                    // Rename creationName to id to abstract the weird data model
                    for (_i = 0, destinations_1 = destinations; _i < destinations_1.length; _i++) {
                        destination = destinations_1[_i];
                        // Because of the legacy Fullstory integration the creationName for this integration is the `name`
                        if (destination.name === 'Fullstory') {
                            destination.id = destination.name;
                        }
                        else {
                            destination.id = destination.creationName;
                        }
                        delete destination.creationName;
                    }
                    return [2 /*return*/, destinations];
            }
        });
    });
}
function fetchDestinations(cdnHost, writeKeys) {
    return __awaiter(this, void 0, void 0, function () {
        var destinationsRequests, _i, writeKeys_1, writeKey, destinations, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    destinationsRequests = [];
                    for (_i = 0, writeKeys_1 = writeKeys; _i < writeKeys_1.length; _i++) {
                        writeKey = writeKeys_1[_i];
                        destinationsRequests.push(fetchDestinationForWriteKey(cdnHost, writeKey));
                    }
                    _a = (flatten_default());
                    return [4 /*yield*/, Promise.all(destinationsRequests)];
                case 1:
                    destinations = _a.apply(void 0, [_b.sent()]);
                    // Remove the dummy Repeater destination
                    destinations = destinations.filter(function (d) { return d.id !== 'Repeater'; });
                    destinations = sortBy_default()(destinations, ['id']);
                    destinations = sortedUniqBy_default()(destinations, 'id');
                    return [2 /*return*/, destinations];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ../../../node_modules/@segment/consent-manager/esm/consent-manager-builder/analytics.js
function getConsentMiddleware(destinationPreferences, categoryPreferences, defaultDestinationBehavior) {
    return function (_a) {
        var payload = _a.payload, next = _a.next;
        payload.obj.context.consent = {
            defaultDestinationBehavior: defaultDestinationBehavior,
            categoryPreferences: categoryPreferences,
            destinationPreferences: destinationPreferences
        };
        next(payload);
    };
}
function conditionallyLoadAnalytics(_a) {
    var writeKey = _a.writeKey, destinations = _a.destinations, destinationPreferences = _a.destinationPreferences, isConsentRequired = _a.isConsentRequired, _b = _a.shouldReload, shouldReload = _b === void 0 ? true : _b, _c = _a.devMode, devMode = _c === void 0 ? false : _c, defaultDestinationBehavior = _a.defaultDestinationBehavior, categoryPreferences = _a.categoryPreferences;
    var wd = window;
    var integrations = { All: false, 'Segment.io': true };
    var isAnythingEnabled = false;
    if (!destinationPreferences) {
        if (isConsentRequired) {
            return;
        }
        // Load a.js normally when consent isn't required and there's no preferences
        if (!wd.analytics.initialized) {
            wd.analytics.load(writeKey);
        }
        return;
    }
    for (var _i = 0, destinations_1 = destinations; _i < destinations_1.length; _i++) {
        var destination = destinations_1[_i];
        // Was a preference explicitly set on this destination?
        var explicitPreference = destination.id in destinationPreferences;
        if (!explicitPreference && defaultDestinationBehavior === 'enable') {
            integrations[destination.id] = true;
            continue;
        }
        var isEnabled = Boolean(destinationPreferences[destination.id]);
        if (isEnabled) {
            isAnythingEnabled = true;
        }
        integrations[destination.id] = isEnabled;
    }
    // Reload the page if the trackers have already been initialised so that
    // the user's new preferences can take affect
    if (wd.analytics && wd.analytics.initialized) {
        if (shouldReload) {
            window.location.reload();
        }
        return;
    }
    if (devMode) {
        return;
    }
    // Don't load a.js at all if nothing has been enabled
    if (isAnythingEnabled) {
        var middleware = getConsentMiddleware(destinationPreferences, categoryPreferences, defaultDestinationBehavior);
        // @ts-ignore: Analytics.JS type should be updated with addSourceMiddleware
        wd.analytics.addSourceMiddleware(middleware);
        wd.analytics.load(writeKey, { integrations: integrations });
    }
}
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ../../../node_modules/@segment/consent-manager/esm/consent-manager-builder/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var consent_manager_builder_assign = (undefined && undefined.__assign) || function () {
    consent_manager_builder_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return consent_manager_builder_assign.apply(this, arguments);
};
var consent_manager_builder_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var consent_manager_builder_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};




function getNewDestinations(destinations, preferences) {
    var newDestinations = [];
    // If there are no preferences then all destinations are new
    if (!preferences) {
        return destinations;
    }
    for (var _i = 0, destinations_1 = destinations; _i < destinations_1.length; _i++) {
        var destination = destinations_1[_i];
        if (preferences[destination.id] === undefined) {
            newDestinations.push(destination);
        }
    }
    return newDestinations;
}
var ConsentManagerBuilder = /** @class */ (function (_super) {
    __extends(ConsentManagerBuilder, _super);
    function ConsentManagerBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: true,
            destinations: [],
            newDestinations: [],
            preferences: {},
            destinationPreferences: {},
            isConsentRequired: true,
            havePreferencesChanged: false,
            workspaceAddedNewDestinations: false
        };
        _this.initialise = function () { return consent_manager_builder_awaiter(_this, void 0, void 0, function () {
            var _a, writeKey, _b, otherWriteKeys, _c, shouldRequireConsent, initialPreferences, mapCustomPreferences, defaultDestinationBehavior, cookieName, _d, cdnHost, _e, shouldReload, _f, devMode, _g, destinationPreferences, customPreferences, _h, isConsentRequired, destinations, newDestinations, workspaceAddedNewDestinations, preferences, initialPrefencesHaveValue, emptyCustomPreferecences, mapped;
            return consent_manager_builder_generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _a = this.props, writeKey = _a.writeKey, _b = _a.otherWriteKeys, otherWriteKeys = _b === void 0 ? ConsentManagerBuilder.defaultProps.otherWriteKeys : _b, _c = _a.shouldRequireConsent, shouldRequireConsent = _c === void 0 ? ConsentManagerBuilder.defaultProps.shouldRequireConsent : _c, initialPreferences = _a.initialPreferences, mapCustomPreferences = _a.mapCustomPreferences, defaultDestinationBehavior = _a.defaultDestinationBehavior, cookieName = _a.cookieName, _d = _a.cdnHost, cdnHost = _d === void 0 ? ConsentManagerBuilder.defaultProps.cdnHost : _d, _e = _a.shouldReload, shouldReload = _e === void 0 ? ConsentManagerBuilder.defaultProps.shouldReload : _e, _f = _a.devMode, devMode = _f === void 0 ? ConsentManagerBuilder.defaultProps.devMode : _f;
                        _g = loadPreferences(cookieName), destinationPreferences = _g.destinationPreferences, customPreferences = _g.customPreferences;
                        return [4 /*yield*/, Promise.all([
                                shouldRequireConsent(),
                                fetchDestinations(cdnHost, __spreadArrays([writeKey], otherWriteKeys))
                            ])];
                    case 1:
                        _h = _j.sent(), isConsentRequired = _h[0], destinations = _h[1];
                        newDestinations = getNewDestinations(destinations, destinationPreferences || {});
                        workspaceAddedNewDestinations = destinationPreferences &&
                            Object.keys(destinationPreferences).length > 0 &&
                            newDestinations.length > 0;
                        initialPrefencesHaveValue = Object.values(initialPreferences || {}).some(function (v) { return v === true || v === false || v === 'N/A'; });
                        emptyCustomPreferecences = Object.values(customPreferences || {}).every(function (v) { return v === null || v === undefined || v === 'N/A'; });
                        if (mapCustomPreferences) {
                            preferences = customPreferences || initialPreferences || {};
                            if ((initialPrefencesHaveValue && emptyCustomPreferecences) ||
                                (defaultDestinationBehavior === 'imply' && workspaceAddedNewDestinations)) {
                                mapped = mapCustomPreferences(destinations, preferences);
                                destinationPreferences = mapped.destinationPreferences;
                                customPreferences = mapped.customPreferences;
                                preferences = customPreferences;
                            }
                        }
                        else {
                            preferences = destinationPreferences || initialPreferences;
                        }
                        conditionallyLoadAnalytics({
                            writeKey: writeKey,
                            destinations: destinations,
                            destinationPreferences: destinationPreferences,
                            isConsentRequired: isConsentRequired,
                            shouldReload: shouldReload,
                            devMode: devMode,
                            defaultDestinationBehavior: defaultDestinationBehavior,
                            categoryPreferences: preferences
                        });
                        this.setState({
                            isLoading: false,
                            destinations: destinations,
                            newDestinations: newDestinations,
                            preferences: preferences,
                            isConsentRequired: isConsentRequired,
                            destinationPreferences: destinationPreferences,
                            workspaceAddedNewDestinations: Boolean(workspaceAddedNewDestinations)
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSetPreferences = function (newPreferences) {
            _this.setState(function (prevState) {
                var destinations = prevState.destinations, existingPreferences = prevState.preferences;
                var preferences = _this.mergePreferences({
                    destinations: destinations,
                    newPreferences: newPreferences,
                    existingPreferences: existingPreferences
                });
                return consent_manager_builder_assign(consent_manager_builder_assign({}, prevState), { preferences: preferences, havePreferencesChanged: true });
            });
        };
        _this.handleResetPreferences = function () {
            var _a = _this.props, initialPreferences = _a.initialPreferences, mapCustomPreferences = _a.mapCustomPreferences, cookieName = _a.cookieName;
            var _b = loadPreferences(cookieName), destinationPreferences = _b.destinationPreferences, customPreferences = _b.customPreferences;
            var preferences;
            if (mapCustomPreferences) {
                preferences = customPreferences || initialPreferences;
            }
            else {
                preferences = destinationPreferences || initialPreferences;
            }
            _this.setState({ preferences: preferences });
        };
        _this.handleSaveConsent = function (newPreferences, shouldReload, devMode) {
            var _a = _this.props, writeKey = _a.writeKey, cookieDomain = _a.cookieDomain, cookieName = _a.cookieName, cookieExpires = _a.cookieExpires, cookieAttributes = _a.cookieAttributes, mapCustomPreferences = _a.mapCustomPreferences, defaultDestinationBehavior = _a.defaultDestinationBehavior;
            _this.setState(function (prevState) {
                var destinations = prevState.destinations, existingPreferences = prevState.preferences, isConsentRequired = prevState.isConsentRequired;
                var preferences = _this.mergePreferences({
                    destinations: destinations,
                    newPreferences: newPreferences,
                    existingPreferences: existingPreferences
                });
                var destinationPreferences;
                var customPreferences;
                if (mapCustomPreferences) {
                    var custom = mapCustomPreferences(destinations, preferences);
                    destinationPreferences = custom.destinationPreferences;
                    customPreferences = custom.customPreferences;
                    if (customPreferences) {
                        // Allow the customPreferences to be updated from mapCustomPreferences
                        preferences = customPreferences;
                    }
                    else {
                        // Make returning the customPreferences from mapCustomPreferences optional
                        customPreferences = preferences;
                    }
                }
                else {
                    destinationPreferences = preferences;
                }
                var newDestinations = getNewDestinations(destinations, destinationPreferences);
                if (prevState.havePreferencesChanged ||
                    newDestinations.length > 0 ||
                    typeof newPreferences === 'boolean') {
                    shouldReload = true;
                }
                savePreferences({
                    destinationPreferences: destinationPreferences,
                    customPreferences: customPreferences,
                    cookieDomain: cookieDomain,
                    cookieName: cookieName,
                    cookieExpires: cookieExpires,
                    cookieAttributes: cookieAttributes
                });
                conditionallyLoadAnalytics({
                    writeKey: writeKey,
                    destinations: destinations,
                    destinationPreferences: destinationPreferences,
                    isConsentRequired: isConsentRequired,
                    shouldReload: shouldReload,
                    devMode: devMode,
                    defaultDestinationBehavior: defaultDestinationBehavior,
                    categoryPreferences: customPreferences
                });
                return consent_manager_builder_assign(consent_manager_builder_assign({}, prevState), { destinationPreferences: destinationPreferences,
                    preferences: preferences,
                    newDestinations: newDestinations });
            });
        };
        _this.mergePreferences = function (args) {
            var destinations = args.destinations, existingPreferences = args.existingPreferences, newPreferences = args.newPreferences;
            var preferences;
            if (typeof newPreferences === 'boolean') {
                var destinationPreferences = {};
                for (var _i = 0, destinations_2 = destinations; _i < destinations_2.length; _i++) {
                    var destination = destinations_2[_i];
                    destinationPreferences[destination.id] = newPreferences;
                }
                preferences = destinationPreferences;
            }
            else if (newPreferences) {
                preferences = consent_manager_builder_assign(consent_manager_builder_assign({}, existingPreferences), newPreferences);
            }
            else {
                preferences = existingPreferences;
            }
            return preferences;
        };
        return _this;
    }
    ConsentManagerBuilder.prototype.render = function () {
        var _a = this.props, children = _a.children, customCategories = _a.customCategories;
        var _b = this.state, isLoading = _b.isLoading, destinations = _b.destinations, preferences = _b.preferences, newDestinations = _b.newDestinations, isConsentRequired = _b.isConsentRequired, havePreferencesChanged = _b.havePreferencesChanged, workspaceAddedNewDestinations = _b.workspaceAddedNewDestinations, destinationPreferences = _b.destinationPreferences;
        if (isLoading) {
            return null;
        }
        return children({
            destinations: destinations,
            customCategories: customCategories,
            newDestinations: newDestinations,
            preferences: preferences,
            isConsentRequired: isConsentRequired,
            havePreferencesChanged: havePreferencesChanged,
            workspaceAddedNewDestinations: workspaceAddedNewDestinations,
            destinationPreferences: destinationPreferences,
            setPreferences: this.handleSetPreferences,
            resetPreferences: this.handleResetPreferences,
            saveConsent: this.handleSaveConsent
        });
    };
    ConsentManagerBuilder.prototype.componentDidMount = function () {
        return consent_manager_builder_awaiter(this, void 0, void 0, function () {
            var onError, e_1;
            return consent_manager_builder_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onError = this.props.onError;
                        if (!(onError && typeof onError === 'function')) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.initialise()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [4 /*yield*/, onError(e_1)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.initialise()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ConsentManagerBuilder.displayName = 'ConsentManagerBuilder';
    ConsentManagerBuilder.defaultProps = {
        otherWriteKeys: [],
        onError: undefined,
        shouldRequireConsent: function () { return true; },
        initialPreferences: {},
        cdnHost: 'cdn.segment.com',
        shouldReload: true,
        devMode: false
    };
    return ConsentManagerBuilder;
}(react.Component));
/* harmony default export */ var consent_manager_builder = (ConsentManagerBuilder);
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ../../../node_modules/@segment/consent-manager/esm/index.js




var esm_ConsentManagerBuilder = consent_manager_builder;
var ConsentManager = (/* unused pure expression or super */ null && (CM));
function doNotTrack() {
    if (typeof window !== 'undefined' && (window.navigator || navigator)) {
        var nav = navigator;
        var doNotTrackValue = nav.doNotTrack || window.doNotTrack || nav.msDoNotTrack;
        // Normalise Firefox < 32
        // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/doNotTrack
        if (doNotTrackValue === 'yes') {
            doNotTrackValue = '1';
        }
        else if (doNotTrackValue === 'no') {
            doNotTrackValue = '0';
        }
        if (doNotTrackValue === '1') {
            return true;
        }
        if (doNotTrackValue === '0') {
            return false;
        }
    }
    return null;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxHQUFHLE1BQU0sMkJBQTJCLENBQUE7QUFDM0MsT0FBTyxFQUFFLE1BQU0sbUJBQW1CLENBQUE7QUFFbEMsT0FBTyxFQUFFLFVBQVUsSUFBSSxrQkFBa0IsRUFBRSxNQUFNLDZCQUE2QixDQUFBO0FBQzlFLE9BQU8sRUFDTCxlQUFlLEVBQ2YsZUFBZSxFQUNmLGtCQUFrQixFQUNuQixNQUFNLHVDQUF1QyxDQUFBO0FBRTlDLE1BQU0sQ0FBQyxJQUFNLHFCQUFxQixHQUFHLEdBQUcsQ0FBQTtBQUN4QyxNQUFNLENBQUMsSUFBTSxjQUFjLEdBQUcsRUFBRSxDQUFBO0FBTWhDLE1BQU0sVUFBVSxVQUFVO0lBRXhCLElBQUksT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLENBQUMsTUFBTSxDQUFDLFNBQVMsSUFBSSxTQUFTLENBQUMsRUFBRTtRQUNwRSxJQUFNLEdBQUcsR0FBRyxTQUFnQixDQUFBO1FBRTVCLElBQUksZUFBZSxHQUFHLEdBQUcsQ0FBQyxVQUFVLElBQUksTUFBTSxDQUFDLFVBQVUsSUFBSSxHQUFHLENBQUMsWUFBWSxDQUFBO1FBRTdFLHlCQUF5QjtRQUN6Qix3RUFBd0U7UUFDeEUsSUFBSSxlQUFlLEtBQUssS0FBSyxFQUFFO1lBQzdCLGVBQWUsR0FBRyxHQUFHLENBQUE7U0FDdEI7YUFBTSxJQUFJLGVBQWUsS0FBSyxJQUFJLEVBQUU7WUFDbkMsZUFBZSxHQUFHLEdBQUcsQ0FBQTtTQUN0QjtRQUVELElBQUksZUFBZSxLQUFLLEdBQUcsRUFBRTtZQUMzQixPQUFPLElBQUksQ0FBQTtTQUNaO1FBQ0QsSUFBSSxlQUFlLEtBQUssR0FBRyxFQUFFO1lBQzNCLE9BQU8sS0FBSyxDQUFBO1NBQ2I7S0FDRjtJQUVELE9BQU8sSUFBSSxDQUFBO0FBQ2IsQ0FBQyJ9
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(66017);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(20011);
;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

// EXTERNAL MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js + 2 modules
var useMergeRef = __webpack_require__(27553);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.propTypes =  false ? 0 : {};
/* harmony default export */ var FocusGuard = ((/* unused pure expression or super */ null && (InFocusGuard)));
// EXTERNAL MODULE: ../../../node_modules/use-sidecar/dist/es2015/medium.js
var medium = __webpack_require__(42442);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = (0,medium/* createMedium */.s)({}, function (_ref) {
  var target = _ref.target,
    currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = (0,medium/* createMedium */.s)();
var mediumEffect = (0,medium/* createMedium */.s)();
var mediumSidecar = (0,medium/* createSidecarMedium */._)({
  async: true,
  ssr: typeof document !== 'undefined'
});
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/scope.js

var focusScope = /*#__PURE__*/(0,react.createContext)(undefined);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/react.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _React$useState = react.useState(),
    realObserved = _React$useState[0],
    setObserved = _React$useState[1];
  var observed = react.useRef();
  var isActive = react.useRef(false);
  var originalFocusedElement = react.useRef(null);
  var _React$useState2 = react.useState({}),
    update = _React$useState2[1];
  var children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$noFocusGuards = props.noFocusGuards,
    noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards,
    _props$persistentFocu = props.persistentFocus,
    persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu,
    _props$crossFrame = props.crossFrame,
    crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    allowTextSelection = props.allowTextSelection,
    group = props.group,
    className = props.className,
    whiteList = props.whiteList,
    hasPositiveIndices = props.hasPositiveIndices,
    _props$shards = props.shards,
    shards = _props$shards === void 0 ? emptyArray : _props$shards,
    _props$as = props.as,
    Container = _props$as === void 0 ? 'div' : _props$as,
    _props$lockProps = props.lockProps,
    containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
    SideCar = props.sideCar,
    _props$returnFocus = props.returnFocus,
    shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus,
    focusOptions = props.focusOptions,
    onActivationCallback = props.onActivation,
    onDeactivationCallback = props.onDeactivation;
  var _React$useState3 = react.useState({}),
    id = _React$useState3[0];
  var onActivation = react.useCallback(function (_ref) {
    var captureFocusRestore = _ref.captureFocusRestore;
    if (!originalFocusedElement.current) {
      var _document;
      var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
      originalFocusedElement.current = activeElement;
      if (activeElement !== document.body) {
        originalFocusedElement.current = captureFocusRestore(activeElement);
      }
    }
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
    update();
  }, [onActivationCallback]);
  var onDeactivation = react.useCallback(function () {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
    update();
  }, [onDeactivationCallback]);
  var returnFocus = react.useCallback(function (allowDefer) {
    var focusRestore = originalFocusedElement.current;
    if (focusRestore) {
      var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus = react.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium;
  var setObserveNode = react.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (false) {}
  var lockProps = (0,esm_extends/* default */.Z)((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = (0,useMergeRef/* useMergeRefs */.q)([parentRef, setObserveNode]);
  var focusScopeValue = react.useMemo(function () {
    return {
      observed: observed,
      shards: shards,
      enabled: !disabled,
      active: isActive.current
    };
  }, [disabled, isActive.current, shards, realObserved]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), /*#__PURE__*/react.createElement(focusScope.Provider, {
    value: focusScopeValue
  }, children)), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
/* harmony default export */ var Lock = (FocusLock);
// EXTERNAL MODULE: ../../../node_modules/react-clientside-effect/lib/index.es.js + 1 modules
var index_es = __webpack_require__(58420);
;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isInert = function (node) { return node.hasAttribute('inert'); };
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && !isInert(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) {
            return 1;
        }
        if (!bTab) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var getTabIndex = function (node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) {
            return 0;
        }
    }
    return node.tabIndex;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) {
        var tabIndex = getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : tabIndex,
        };
    })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * !__WARNING__! Low level API.
 * @returns all tabbable nodes
 *
 * @see {@link getFocusableNodes} to get any focusable element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * !__WARNING__! Low level API.
 *
 * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
 * (without guards, as long as they are not expected to be ever focused)
 *
 * @see {@link getTabbableNodes} to get only tabble nodes element
 *
 * @param topNodes - array of top level HTMLElements to search inside
 * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
 */
var getFocusableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

/**
 * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
 * @param [inDocument]
 */
var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * checks if focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 *
 * This is a utility function coupled with {@link FOCUS_ALLOW} constant
 *
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node - node or nodes to look inside
 * @returns Element[]
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes.
 * Supports nodes hidden inside shadowDom
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function (target, focusOptions) {
    if (!target) {
        // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
        return;
    }
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, node) {
    return nodes.indexOf(correctNode(node, nodes));
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes - used to control "return focus"
 * @param innerTabbables - used to control "autofocus"
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) {
            return lastNodeInside;
        }
        return NEW_FOCUS;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) {
        // an edge case with no tabbable elements
        // return the last focusable one
        // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
        return lastNodeInside;
    }
    var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
    var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusSolver.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * contains the main logic of the `focus-lock` package.
 *
 * ! you probably dont need this function !
 *
 * given top node(s) and the last active element returns the element to be focused next
 * @returns element which should be focused to move focus inside
 * @param topNode
 * @param lastNode
 */
var focusSolver = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getFocusableNodes(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        return undefined;
    }
    var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function (_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = 
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) ||
            pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/moveFocusInside.js


var guardCount = 0;
var lockDisabled = false;
/**
 * The main functionality of the focus-lock package
 *
 * Contains focus at a given node.
 * The last focused element will help to determine which element(first or last) should be focused.
 * The found element will be focused.
 *
 * This is one time action (move), not a persistent focus-lock
 *
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @see {@link focusSolver} for the same functionality without autofocus
 */
var moveFocusInside = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = focusSolver(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/
        if (guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/focusables.js





/**
 * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
 * This is low-level API!
 * @returns list of focusable elements inside a given top(!) node.
 * @see {@link getFocusableNodes} providing a simpler API
 */
var expandFocusableNodes = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
    var innerElements = getFocusables(entries, false);
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/sibling.js



/**
 * for a given `element` in a given `scope` returns focusable siblings
 * @param element - base element
 * @param scope - common parent. Can be document, but better to narrow it down for performance reasons
 * @returns {prev,next} - references to a focusable element before and after
 * @returns undefined - if operation is not applicable
 */
var getRelativeFocusable = function (element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = asArray(scope);
    if (shards.every(function (shard) { return !contains(shard, element); })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables
        ? getTabbableNodes(shards, new Map())
        : getFocusableNodes(shards, new Map());
    var current = focusables.findIndex(function (_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) {
        // an edge case, when anchor element is not found
        return undefined;
    }
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1],
    };
};
var getBoundary = function (shards, useTabbables) {
    var set = useTabbables
        ? getTabbableNodes(asArray(shards), new Map())
        : getFocusableNodes(asArray(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1],
    };
};
var defaultOptions = function (options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true,
    }, options);
};
var moveFocus = function (fromElement, options, cb) {
    if (options === void 0) { options = {}; }
    var newOptions = defaultOptions(options);
    var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) {
        return;
    }
    var target = cb(solution, newOptions.cycle);
    if (target) {
        focusOn(target.node, newOptions.focusOptions);
    }
};
/**
 * focuses next element in the tab-order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusNextElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || (cycle && first);
    });
};
/**
 * focuses prev element in the tab order
 * @param fromElement - common parent to scope active element search or tab cycle order
 * @param {FocusNextOptions} [options] - focus options
 */
var focusPrevElement = function (fromElement, options) {
    if (options === void 0) { options = {}; }
    moveFocus(fromElement, options, function (_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || (cycle && last);
    });
};
var pickBoundary = function (scope, options, what) {
    var _a;
    var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) {
        focusOn(node.node, options.focusOptions);
    }
};
/**
 * focuses first element in the tab-order
 * @param {FocusNextOptions} options - focus options
 */
var focusFirstElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'first');
};
/**
 * focuses last element in the tab order
 * @param {FocusNextOptions} options - focus options
 */
var focusLastElement = function (scope, options) {
    if (options === void 0) { options = {}; }
    pickBoundary(scope, options, 'last');
};

;// CONCATENATED MODULE: ../../../node_modules/focus-lock/dist/es2015/return-focus.js

function weakRef(value) {
    if (!value)
        return null;
    var w = value ? new WeakRef(value) : null;
    return function () { return (w === null || w === void 0 ? void 0 : w.deref()) || null; };
}
var recordElementLocation = function (element) {
    if (!element) {
        return null;
    }
    var stack = [];
    var currentElement = element;
    while (currentElement && currentElement !== document.body) {
        stack.push({
            current: weakRef(currentElement),
            parent: weakRef(currentElement.parentElement),
            left: weakRef(currentElement.previousElementSibling),
            right: weakRef(currentElement.nextElementSibling),
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument,
    };
};
var restoreFocusTo = function (location) {
    var _a, _b, _c, _d, _e;
    if (!location) {
        return undefined;
    }
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = getTabbableNodes([parent_1], visibilityCache);
            var aim = 
            // that is element itself
            (_e = (_d = left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : 
            // or somebody to the right?
            right) !== null && _e !== void 0 ? _e : 
            // or somebody to the left
            left;
            while (aim) {
                for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
                        return focusable.node;
                    }
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) {
                // if parent contains a focusable - move there
                return focusables[0].node;
            }
        }
    }
    // nothing matched
    return undefined;
};
/**
 * Captures the current focused element to restore focus as close as possible in the future
 * Handles situations where the focused element is removed from the DOM or no longer focusable
 * moving focus to the closest focusable element
 * @param targetElement - element where focus should be restored
 * @returns a function returning a new element to focus
 */
var captureFocusRestore = function (targetElement) {
    var location = recordElementLocation(targetElement);
    return function () {
        return restoreFocusTo(location);
    };
};

;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Trap.js






var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist() {
  return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item = allNodes[i];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === 'meanwhile';
};
var checkInHost = function checkInHost(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};
var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
      observed = _lastActiveTrap.observed,
      persistentFocus = _lastActiveTrap.persistentFocus,
      autoFocus = _lastActiveTrap.autoFocus,
      shards = _lastActiveTrap.shards,
      crossFrame = _lastActiveTrap.crossFrame,
      focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
              node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher() {
  return null;
};
var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};
FocusTrap.propTypes =  false ? 0 : {};
var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just';
  deferAction(function () {
    focusWasOutsideWindow = 'meanwhile';
  });
};
var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
var focusLockAPI = {
  moveFocusInside: moveFocusInside,
  focusInside: focusInside,
  focusNextElement: focusNextElement,
  focusPrevElement: focusPrevElement,
  focusFirstElement: focusFirstElement,
  focusLastElement: focusLastElement,
  captureFocusRestore: captureFocusRestore
};
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation(focusLockAPI);
    }
    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb(focusLockAPI);
});
/* harmony default export */ var Trap = ((0,index_es/* default */.Z)(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/Combination.js





var FocusLockCombination = /*#__PURE__*/react.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/react.createElement(Lock, (0,esm_extends/* default */.Z)({
    sideCar: Trap,
    ref: ref
  }, props));
});
var _ref = Lock.propTypes || {},
  sideCar = _ref.sideCar,
  propTypes = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["sideCar"]);
FocusLockCombination.propTypes =  false ? 0 : {};
/* harmony default export */ var Combination = (FocusLockCombination);
;// CONCATENATED MODULE: ../../../node_modules/react-focus-lock/dist/es2015/index.js


/* harmony default export */ var es2015 = (Combination);
// EXTERNAL MODULE: ../../../libs/shared/cookie-consent/src/lib/components/cookie-banner/cookie-banner.module.css
var cookie_banner_module = __webpack_require__(81391);
var cookie_banner_module_default = /*#__PURE__*/__webpack_require__.n(cookie_banner_module);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/components/cookie-banner/cookie-banner.component.tsx





const CookieBanner = ({ handleManageSettingsButtonClick , handleAcceptCookiesButtonClick , isPreferencesModalOpen , hydrated  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(es2015, {
        noFocusGuards: true,
        disabled: isPreferencesModalOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "cookie-banner",
            role: "dialog",
            className: (cookie_banner_module_default()).cookieBanner,
            "data-testid": hydrated ? "cookie-banner" : "",
            "aria-labelledby": "cookie-banner-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cookie_banner_module_default()).cookieBannerInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cookie_banner_module_default()).cookieBannerContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                element: "h2",
                                fontSize: "xxl",
                                fontWeight: "bold",
                                lineHeight: "display",
                                className: (cookie_banner_module_default()).cookieBannerTitle,
                                children: "Your privacy on cinch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                id: "cookie-banner-text",
                                fontSize: "s",
                                children: [
                                    "We use some necessary cookies to make our site work. However, we also use additional cookies to understand your journey on cinch and how we can improve. These will only be set if you accept them. For more details, visit our",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                        href: "/policies/cookie-policy",
                                        hasNoLine: true,
                                        children: "cookie page"
                                    }),
                                    ".",
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cookie_banner_module_default()).cookieBannerButtons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                isFullWidth: true,
                                "data-testid": "accept",
                                size: "large",
                                onClick: (event)=>{
                                    event.preventDefault();
                                    main/* datadogRum.addAction */.v.addAction("Cookie banner accept click");
                                    localStorage.setItem("cookieConsentPreferences", "true");
                                    handleAcceptCookiesButtonClick && handleAcceptCookiesButtonClick(true);
                                },
                                children: "Accept additional cookies"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                                isFullWidth: true,
                                "data-testid": "edit-preferences-button",
                                size: "large",
                                onClick: (event)=>{
                                    event.preventDefault();
                                    main/* datadogRum.addAction */.v.addAction("Cookie banner manage settings click");
                                    handleManageSettingsButtonClick && handleManageSettingsButtonClick();
                                },
                                children: "Manage settings"
                            })
                        ]
                    })
                ]
            })
        })
    });
/* harmony default export */ var cookie_banner_component = (CookieBanner);

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/cookie.ts
const setCookie = ({ name , value , expiryInDays  })=>{
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + expiryInDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${expiryDate.toUTCString()}`;
    const isLocal = "production" === "local";
    document.cookie = isLocal ? `${name}=${value};${expires};path=/` : `${name}=${value};${expires};path=/;domain=cinch.co.uk`;
};
const getCookie = ({ name  })=>{
    var ref;
    return ((ref = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)) === null || ref === void 0 ? void 0 : ref.pop()) ?? undefined;
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/cookies.ts

const COOKIE_CONSENT_PREFERENCES_KEY = "cp";
const cookiePreferencesCookieParser = (cookieContents)=>cookieContents ? JSON.parse(cookieContents) : undefined;
const getCookiePreferencesFromUrl = ()=>{
    if (!window) {
        return;
    }
    try {
        const url = new URL(window.location.href);
        const preferences = url.searchParams.get(COOKIE_CONSENT_PREFERENCES_KEY);
        url.searchParams.delete(COOKIE_CONSENT_PREFERENCES_KEY);
        window.history.replaceState(window.history.state, "unused", url.toString());
        return cookiePreferencesCookieParser(preferences);
    } catch  {
        return;
    }
};
const getCookieConsentPreferences = ()=>{
    const cookiePreferencesFromUrl = getCookiePreferencesFromUrl();
    if (cookiePreferencesFromUrl) {
        setCookieConsentPreferences(cookiePreferencesFromUrl);
        return cookiePreferencesFromUrl;
    }
    return cookiePreferencesCookieParser(getCookie({
        name: COOKIE_CONSENT_PREFERENCES_KEY
    }));
};
const hasCookieConsentBeenSet = ()=>getCookieConsentPreferences() ? true : false;
const setCookieConsentPreferences = (preferences)=>setCookie({
        name: COOKIE_CONSENT_PREFERENCES_KEY,
        value: JSON.stringify(preferences),
        expiryInDays: 365
    });
const getCookieSettings = (time, preferences, type)=>({
        preference_functional: preferences["functional"] ? true : false,
        preference_advertising: preferences["advertising"] ? true : false,
        preference_marketing: preferences["analytics"] ? true : false,
        type: type,
        time: Math.round(Date.now() / 1000 - time / 1000)
    });
const getCookieBannerMetrics = (time, mode, count)=>({
        display_duration: Math.round(Date.now() / 1000 - time / 1000),
        acceptance_mode: mode,
        navigation_count: count,
        event_timing: Math.round(Date.now() / 1000 - time / 1000)
    });

// EXTERNAL MODULE: ../../../libs/customer-data/segment/src/index.ts + 4 modules
var segment_src = __webpack_require__(72777);
;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/track-interaction.ts

const cookieSettings = (settings)=>{
    (0,segment_src/* track */.j)("Cookie Settings", settings);
};
const cookieBannerMetrics = (settings)=>{
    (0,segment_src/* track */.j)("Cookie Banner metrics", settings);
};
const cookieEditorShown = (timeStamp)=>{
    (0,segment_src/* track */.j)("Cookie Editor Shown", {
        event_timing: timeStamp
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/events.ts


const addEvent = ({ startTime , elementType , count , cookieEditorTime , cookiePreferences , settingsType  })=>{
    window.analytics && window.analytics.ready(()=>{
        cookieSettings(getCookieSettings(startTime, cookiePreferences, settingsType));
        cookieBannerMetrics(getCookieBannerMetrics(startTime, elementType, count));
        if (cookieEditorTime !== 0) {
            cookieEditorShown(cookieEditorTime);
        }
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/group-destinations.ts
const groupDestinations = (group, prop)=>group.reduce((grouped, item)=>{
        const key = item[prop];
        if (!Object.prototype.hasOwnProperty.call(grouped, prop)) {
            grouped[key] = [];
        }
        grouped[key].push(item);
        return grouped;
    }, {});

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/scripts-config/index.ts
// Add name of third party script that is essential to the site running into string
// This list will be added into the 'Essential' row on the Cookie Banner preferences panel
const essentialCinchScriptsList = "Datadog, Stripe";
const advertisingScriptList = [
    "Tool: DC - MediaCom DoubleClick & AdWords Global Tag & GA4 Code",
    "MediaCom - Floodlight Counter - Article Page Viewed",
    "MediaCom - Floodlight Counter - Checkout Page Viewed",
    "MediaCom - Floodlight Counter - Help me choose",
    "MediaCom - Floodlight Counter - Homepage",
    "MediaCom - Floodlight Counter - Manufacturer Page Viewed",
    "MediaCom - Floodlight Counter - My Profile",
    "MediaCom - Floodlight Counter - Recommended Cars",
    "MediaCom - Floodlight Counter - Vehicles Searched",
    "MediaCom - Floodlight Counter - Vehicle Viewed",
    "MediaCom - Floodlight Counter - User Completed Sign Up Form",
    "MediaCom - Quality Traffic Pixel",
    "MediaCom - Floodlight Sales - Order Confirmation",
    "MediaCom - Floodlight Counter - Call Seller Clicked",
    "MediaCom - Floodlight Counter - Visit Dealer Website",
    "MediaCom - Floodlight Counter - Submit Email Seller Form"
];

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/preferences.ts

function processToolNames(names, extras) {
    return names.filter(Boolean).map((dest)=>dest.name) // eslint-disable-next-line unicorn/prefer-spread
    .concat((extras === null || extras === void 0 ? void 0 : extras.include) ?? []).filter((name)=>{
        var ref;
        return !(extras === null || extras === void 0 ? void 0 : (ref = extras.remove) === null || ref === void 0 ? void 0 : ref.includes(name)) ?? true;
    });
}
// Setup preferences object which constructs the data in the cookie prefs modal
const setupPreferences = (destinations)=>{
    const functionalTools = processToolNames((destinations === null || destinations === void 0 ? void 0 : destinations["Customer Success"]) ?? [], {
        include: [
            "Segment"
        ],
        remove: [
            "Zendesk"
        ]
    });
    const marketingTools = processToolNames([
        ...(destinations === null || destinations === void 0 ? void 0 : destinations["Analytics"]) ?? [],
        ...(destinations === null || destinations === void 0 ? void 0 : destinations["Email Marketing"]) ?? [],
        ...(destinations === null || destinations === void 0 ? void 0 : destinations["Heatmaps & Recordings"]) ?? []
    ], {
        include: [
            "Hotjar",
            "TikTok",
            "Amazon"
        ],
        remove: [
            "Amplitude"
        ]
    });
    const advertisingTools = processToolNames((destinations === null || destinations === void 0 ? void 0 : destinations["Advertising"]) ?? []);
    const preferences = [
        {
            title: "Functional",
            category: "Customer Success",
            purpose: "To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.",
            tools: functionalTools
        },
        {
            title: "Marketing and Analytics",
            category: "Analytics",
            purpose: "To understand user behavior in order to provide you with a more relevant browsing experience or personalize the content on our site. For example, we collect information about which pages you visit to help us present more relevant information.",
            tools: marketingTools
        },
        {
            title: "Advertising",
            category: "Advertising",
            purpose: "To personalize and measure the effectiveness of advertising on our site and other websites. For example, we may serve you a personalized ad based on the pages you visit on our site.",
            tools: advertisingTools
        },
        {
            title: "Essential",
            category: null,
            purpose: "We use browser cookies that are necessary for the site to work as intended. For example, we store your website data collection preferences so we can honor them if you return to our site, and track sales so that rewards/cashback sites can recognise a sale has occurred. You can disable these cookies in your browser settings but if you do the site may not work as intended.",
            tools: [
                essentialCinchScriptsList
            ]
        }
    ];
    // Adds the cinch script names (scripts-config.ts) into the modals category preferences
    advertisingScriptList.forEach((scriptName)=>{
        var ref, ref1, ref2, ref3;
        const name = scriptName.includes("MediaCom") ? "MediaCom" : scriptName;
        scriptName && (preferences === null || preferences === void 0 ? void 0 : (ref = preferences[2]) === null || ref === void 0 ? void 0 : (ref1 = ref.tools) === null || ref1 === void 0 ? void 0 : ref1.includes(name)) && (preferences === null || preferences === void 0 ? void 0 : (ref2 = preferences[2]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tools) === null || ref3 === void 0 ? void 0 : ref3.push(name));
    });
    return preferences;
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/utils/index.ts







// EXTERNAL MODULE: ../../../libs/shared/cookie-consent/src/lib/components/cookie-preferences-modal/cookie-preferences-modal.module.css
var cookie_preferences_modal_module = __webpack_require__(79012);
var cookie_preferences_modal_module_default = /*#__PURE__*/__webpack_require__.n(cookie_preferences_modal_module);
;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/components/cookie-preferences-modal/cookie-preferences-modal.component.tsx





const CookiePreferencesModal = ({ segmentPreferences , destinationPreferences , existingCookiePreferences , onSaveCookiePreferences , onClose  })=>{
    const isMobile = (window === null || window === void 0 ? void 0 : window.innerWidth) <= 767;
    const ModalComponent = isMobile ? index_esm/* SlideUpPanel */.ll : index_esm/* Modal */.u_;
    const [userCookiePreferences, setUserCookiePreferences] = (0,react.useState)(existingCookiePreferences);
    const categoryPreferences = setupPreferences(segmentPreferences.getDestinationsGroupedByCategory());
    const cinchCategoriesNameMapper = {
        "Customer Success": "functional",
        Advertising: "advertising",
        Analytics: "analytics"
    };
    const isCategoryChecked = (category)=>{
        const categoryName = cinchCategoriesNameMapper[category];
        return userCookiePreferences && userCookiePreferences[categoryName];
    };
    const handleCheckboxChange = (category, event)=>{
        const selectedDestinations = segmentPreferences.getSelectedDestinations(destinationPreferences);
        const destinationsGroupedByCategory = groupDestinations(selectedDestinations, "category");
        const selectedCategoryDestinationsExist = !!destinationsGroupedByCategory[category];
        // No idea what this second param is doing, looks like it was always set up to pass false and I'm not sure that's right..
        segmentPreferences.setCategoryPreference(category, selectedCategoryDestinationsExist ? false : true);
        // Update local state for user preferences
        const categoryName = cinchCategoriesNameMapper[category];
        const isChecked = event.target.checked;
        const updatedUserPreferences = {
            ...userCookiePreferences,
            [categoryName]: isChecked
        };
        setUserCookiePreferences({
            ...existingCookiePreferences,
            ...updatedUserPreferences
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, {
        heading: "My preferences",
        onClose: onClose,
        ariaLabelledById: `my-preferences-${isMobile ? "slide-up" : "modal"}`,
        "data-testid": `${isMobile ? "slide-up" : "main"}-modal`,
        primaryButtonText: "Save preferences",
        primaryButtonOnClick: ()=>{
            localStorage.setItem("updatedCookiePreferences", JSON.stringify(userCookiePreferences));
            onSaveCookiePreferences(userCookiePreferences);
        },
        children: categoryPreferences.map((preference, key)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: (cookie_preferences_modal_module_default()).preferencesSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cookie_preferences_modal_module_default()).preferencesSectionHeader,
                        children: [
                            (preference === null || preference === void 0 ? void 0 : preference.category) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Checkbox */.XZ, {
                                label: "",
                                type: "checkbox",
                                id: cinchCategoriesNameMapper[preference.category],
                                name: preference.category,
                                value: preference.category,
                                checked: isCategoryChecked(preference.category),
                                onChange: (e)=>{
                                    return (preference === null || preference === void 0 ? void 0 : preference.category) ? handleCheckboxChange(preference.category, e) : null;
                                },
                                "data-testid": `checkbox-${cinchCategoriesNameMapper[preference.category]}`
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSizeFixed: "xs",
                                fontWeight: "bold",
                                lineHeight: "display",
                                className: (cookie_preferences_modal_module_default()).preferencesSectionHeading,
                                children: preference.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSizeFixed: "xs",
                        className: (cookie_preferences_modal_module_default()).preferencesBody,
                        children: preference.purpose
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontSizeFixed: "xs",
                        children: preference.tools.join(", ")
                    })
                ]
            }, key);
        })
    });
};
/* harmony default export */ var cookie_preferences_modal_component = (CookiePreferencesModal);

// EXTERNAL MODULE: ../../../libs/shared/cookie-consent/src/lib/cookie-consent.module.css
var cookie_consent_module = __webpack_require__(91264);
var cookie_consent_module_default = /*#__PURE__*/__webpack_require__.n(cookie_consent_module);
;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/hooks/cookie-editor-time.hook.ts

const useCookieEditorTime = (isModalOpen)=>{
    const [cookieEditorTime, setCookieEditorTime] = (0,react.useState)(0);
    const [startTime] = (0,react.useState)(Date.now());
    (0,react.useEffect)(()=>{
        if (!cookieEditorTime && isModalOpen) {
            setCookieEditorTime(Math.round(Date.now() / 1000 - startTime / 1000));
        }
    }, [
        cookieEditorTime,
        isModalOpen,
        startTime
    ]);
    return {
        cookieEditorTime,
        setCookieEditorTime,
        startTime
    };
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/hooks/cookie-preferences.hook.ts


const defaultCookiePreferences = {
    advertising: false,
    analytics: false,
    functional: false
};
function useCookiePreferences(setLoaded) {
    const [cookiePreferences, setCookiePreferencesState] = (0,react.useState)(defaultCookiePreferences);
    (0,react.useEffect)(()=>{
        const cookie = getCookieConsentPreferences();
        if (cookie) {
            setCookiePreferencesState(cookie);
        } else {
            setCookiePreferencesState(defaultCookiePreferences);
        }
        setLoaded === null || setLoaded === void 0 ? void 0 : setLoaded(true);
    }, []);
    const setCookiePreferences = (state)=>{
        setCookiePreferencesState(state);
        setCookieConsentPreferences(state);
    };
    return {
        cookiePreferences: cookiePreferences,
        setCookiePreferences,
        isCookieConsentSet: hasCookieConsentBeenSet()
    };
}

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/models/segment-preferences.ts

class SegmentPreferences {
    constructor(destinations, setPreferences){
        this.destinations = destinations;
        this.setPreferences = setPreferences;
    }
    setCategoryPreference = (selectedCategory, isSelected)=>{
        const destination = this.destinations.find((x)=>x.category === selectedCategory);
        if (destination) {
            this.setPreferences({
                [destination.id]: isSelected
            });
        }
    };
    getSelectedDestinations = (preferences)=>this.destinations.filter((dest)=>preferences[dest.id] === true);
    getDestinationsGroupedByCategory = ()=>groupDestinations(this.destinations, "category");
}

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/cookie-consent.helper.ts

const waitForAdobeTargetCookie = async ()=>{
    const mboxRegex = /[a-zA-Z]+#[a-zA-Z0-9]+#\d+\|[a-zA-Z]+#[a-zA-Z0-9._]+#\d+/g;
    let timeoutId;
    try {
        const promise = new Promise((resolve)=>{
            const interval = setInterval(()=>{
                const mboxCookie = getCookie({
                    name: "mbox"
                });
                if (mboxCookie && mboxRegex.test(mboxCookie)) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
        const timeout = new Promise((resolve)=>{
            timeoutId = setTimeout(()=>resolve(), 3000);
        });
        await Promise.race([
            promise,
            timeout
        ]);
    } finally{
        clearTimeout(timeoutId);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/cookie-consent.tsx











const CookieConsent = ({ consentManager: { destinations , preferences , setPreferences , saveConsent  } , count , setLoaded , isPreferencesModalOpen , setIsPreferencesModalOpen  })=>{
    var ref;
    const segmentPreferences = new SegmentPreferences(destinations, setPreferences);
    const { setHasAcceptedAnalyticsCookies  } = (0,analytics_src/* useAnalytics */.z$)();
    const { cookieEditorTime , startTime  } = useCookieEditorTime(isPreferencesModalOpen);
    const { cookiePreferences , setCookiePreferences , isCookieConsentSet  } = useCookiePreferences(setLoaded);
    const isStoryBlokEdit = (ref = window.location) === null || ref === void 0 ? void 0 : ref.href.includes("_storyblok");
    const shouldShowCookieBanner = !isCookieConsentSet && !isStoryBlokEdit;
    const isPrivacyPage = (window === null || window === void 0 ? void 0 : window.location.pathname) === "/policies/privacy";
    const handleSaveCookiePreferencesFromModal = async (updatedCookiePreferences)=>{
        // Save Segment preferences
        saveConsent();
        setIsPreferencesModalOpen(false);
        setCookiePreferences(updatedCookiePreferences);
        addEvent({
            startTime,
            elementType: "modal",
            count,
            cookieEditorTime,
            settingsType: isPrivacyPage ? "edited" : "initial",
            cookiePreferences: updatedCookiePreferences
        });
        if (updatedCookiePreferences.analytics) {
            setHasAcceptedAnalyticsCookies(true);
            await waitForAdobeTargetCookie();
        }
        window.location.reload();
    };
    // Fired when Accept additional cookies is clicked in nested banner
    const handleSaveCookiePreferencesFromBanner = async (acceptAll)=>{
        // Do we need somewhere else to do this sort of segment related logic
        destinations.forEach((destination)=>{
            setPreferences({
                [destination.id]: acceptAll
            });
        });
        saveConsent(acceptAll ? true : undefined);
        const updatedCookiePreferences = {
            advertising: acceptAll,
            analytics: acceptAll,
            functional: acceptAll
        };
        setCookiePreferences(updatedCookiePreferences);
        addEvent({
            startTime,
            elementType: "banner",
            count,
            cookieEditorTime,
            settingsType: "initial",
            cookiePreferences: updatedCookiePreferences
        });
        setHasAcceptedAnalyticsCookies(true);
        (0,analytics_src/* simpleAnalyticsTrack */.x6)(acceptAll ? "cookie_banner_accept" : "cookie_banner_reject");
        await waitForAdobeTargetCookie();
        window.location.reload();
    };
    const openPreferencesModalAndTrack = ()=>{
        (0,analytics_src/* simpleAnalyticsTrack */.x6)("cookie_banner_customise");
        setIsPreferencesModalOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            shouldShowCookieBanner && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !isPrivacyPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (cookie_consent_module_default()).overlay,
                        "data-testid": "overlay"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_banner_component, {
                        handleManageSettingsButtonClick: openPreferencesModalAndTrack,
                        handleAcceptCookiesButtonClick: handleSaveCookiePreferencesFromBanner,
                        hydrated: true,
                        isPreferencesModalOpen: isPreferencesModalOpen
                    })
                ]
            }),
            isPreferencesModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_preferences_modal_component, {
                existingCookiePreferences: cookiePreferences,
                onClose: ()=>setIsPreferencesModalOpen(false),
                destinationPreferences: preferences,
                onSaveCookiePreferences: (updatedCookiePreferences)=>handleSaveCookiePreferencesFromModal(updatedCookiePreferences),
                segmentPreferences: segmentPreferences
            })
        ]
    });
};
/* harmony default export */ var cookie_consent = (CookieConsent);

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/lib/cookie-consent.container.tsx







const CookieConsentContainer = ({ count , setLoaded , setIsPreferencesModalOpen , isPreferencesModalOpen  })=>{
    /**
   * This block is here due to LAN-1478. A race condition in our integration
   * with the Segment ConsentManagerBuilder component is causing fragility in
   * the rendering of the cookie banner. This code changes the React key after
   * a slight delay to force the component to remount, causing a re-render,
   * which reliably displays the cookie banner.
   */ const [consentBuilderLoaded, setConsentBuilderLoaded] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const isPreferenceCookieSet = getCookieConsentPreferences() ? true : false;
        if (!isPreferenceCookieSet) {
            setTimeout(()=>{
                var ref;
                if ((ref = window.analytics) === null || ref === void 0 ? void 0 : ref.load) window.analytics.initialized = undefined;
                setConsentBuilderLoaded(true);
            }, 600);
            (0,analytics_src/* simpleAnalyticsTrack */.x6)("cookie_banner_shown");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ConsentManagerBuilder, {
        writeKey: (0,src/* readFromEnv */.u)(src/* Env.SegmentKey */.X.SegmentKey),
        children: (consentManager)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_consent, {
                consentManager: consentManager,
                setLoaded: setLoaded,
                setIsPreferencesModalOpen: setIsPreferencesModalOpen,
                isPreferencesModalOpen: isPreferencesModalOpen,
                count: count
            })
    }, `cmbLoaded-${consentBuilderLoaded}`);
};
/* harmony default export */ var cookie_consent_container = (CookieConsentContainer);

;// CONCATENATED MODULE: ../../../libs/shared/cookie-consent/src/index.ts





/***/ }),

/***/ 48114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Env; },
  "u": function() { return /* reexport */ readFromEnv; }
});

;// CONCATENATED MODULE: ../../../libs/shared/environments/src/lib/environment-dev.ts
const environmentDev = {
    ADOBE_DTM: "launch-EN4784749e433243eb8208fac004e2b1d9-development",
    IDS_AUTH_KEY: "oxford-user:https://identity-dev.cinch.co.uk/:fe",
    AUTH0_AUTH_KEY: "oxford-user:https://auth-dev.cinch.co.uk:GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU",
    CINCHCARE_SERVICE_URL: "https://cinchcare.cnv-dev.aws.cinch.co.uk",
    PERMISSION_URL: "https://permissions.snc-dev.aws.cinch.co.uk/unsubscribe",
    DELIVERY_SERVICE_URL: "https://delivery.dev.api.cinch.co.uk",
    ORDER_SERVICE_URL: "https://orders.dev.api.cinch.co.uk",
    PROFILE_SERVICE_URL: "https://profile.onr-dev.aws.cinch.co.uk",
    SEARCH_SERVICE_URL: "https://search-api.snc-dev.aws.cinch.co.uk",
    SEARCH_VALUE_PROPOSITIONS: "true",
    SEGMENT_KEY: "2EDvvodmSFPCpQV2U4a7GtoV2sxRDNsX",
    STATIC_ASSETS_URL: "https://assets-dev.cinch.co.uk",
    IDENTITY_SERVICE_URL: "https://api-dev.cinch.co.uk/idt/v1",
    AUTH0_SERVICE_URL: "https://auth-dev.cinch.co.uk",
    AUTH0_DATABASE_NAME: "Username-Password-Authentication",
    AUTH0_CLIENT_ID: "GnTyrV9M8uSC94BY0X2PBB9rX5mwmHuU",
    PROMO_BANNER_NAME: "sale",
    CINCH_URL: "https://cambridge.preview.aws.cinch.co.uk",
    CINCH_APP_URL: "https://mobile.snc-dev.aws.cinch.co.uk",
    TRUSTPILOT_URL: "https://trustpilot.snc-dev.aws.cinch.co.uk",
    STORYBLOK_BFF_COMPONENT: "https://storyblok-bff.snc-dev.aws.cinch.co.uk",
    CONSUMER_VALUATIONS_SERVICE_URL: "https://consumer-valuations.cnv-dev.aws.cinch.co.uk",
    CINCH_CHARGE_CARD_REQUEST_URL: "https://extras-cinch-charge-card.cnv-dev.aws.cinch.co.uk",
    CINCH_CHARGE_CARD_REQUEST_API_KEY: "9IHPexNUQG1RAnKt6D0Aj7gCpMbVjklaaLMir7vG",
    PRODUCT_DETAIL_SERVICE_URL: "https://product.dev.api.cinch.co.uk",
    RESERVATION_STATUS_URL: "https://orders.dev.api.cinch.co.uk/reservation-status",
    INVENTORY_SERVICE_HISTORY_URL: "https://service-history.dev.api.cinch.co.uk/basic",
    IOS_APP_STORE_URL: "https://apps.apple.com/gb/app/cinch-cars-without-the-faff/id1641060889",
    ANDROID_APP_STORE_URL: "https://play.google.com/store/apps/details?id=com.cinchapp",
    ADMIN_FEE_RETURN_TO_CHECKOUT: "true",
    ADMIN_FEE_VALUE: "9900",
    ADMIN_FEE_LOYALTY: "true",
    UNSUBSCRIBE_SERVICE_URL: "https://communication-v2-user-prefs.dev.api.cinch.co.uk/unsubscribe",
    UNSUBSCRIBE_MINIMUM_DURATION: "3000",
    CHECKOUT_RESERVATIONS_DECOUPLING: "true",
    CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: "false",
    RESERVATION_SERVICE_URL: "https://reservations.cnv-dev.aws.cinch.co.uk/source/orders",
    DELIVERY_SLOT_AVAILABILITY_SERVICE_URL: "https://delivery.dev.api.cinch.co.uk/delivery-slots",
    LOGISTICS_FEES_SERVICE_URL: "https://logistics-fees.snp-dev.aws.cinch.co.uk",
    FINANCE_APPLICATION_SERVICE_URL: "https://finance-application.dev.api.cinch.co.uk",
    FINANCE_QUOTE_SERVICE_URL: "https://finance-quote.pnf-dev.aws.cinch.co.uk",
    FINANCE_SOFT_SEARCH_URL_PATH: "/car-finance/check-eligibility",
    PAYMENT_LINK_SERVICE_URL: "https://payment-link.cnv-dev.aws.cinch.co.uk",
    STRIPE_PUBLISHABLE_KEY: "pk_test_oWH3UdQU6FjMhxofexsj2LbB00JJTg5bhT",
    GAP_SERVICE_URL: "https://gap-insurance.cnv-dev.aws.cinch.co.uk",
    ENABLE_AM_PM_SLOTS_FOR_DELIVERIES: "true",
    SERVICING_AND_WARRANTY_FLAG: "false",
    DISABLE_CINCHCARE: "false",
    GAP_INSURANCE_FLAG: "true",
    CUSTOMER_DATA_API_KEY: "579faa1b-87e1-44c0-bdbb-5ed3e4f2239c",
    CUSTOMER_DATA_API_URL: "https://customer-data.dev.api.cinch.co.uk",
    ENABLE_CINCH_APP_USER_AGENT_IN_USED_CARS_SSR: "true",
    SEARCH_MULTIPLE_IMAGES: "true",
    ENABLE_ZENDESK_SCRIPT: "true",
    VEHICLE_CARD_V2: "true",
    NEXT_BEST_ACTION: "true",
    SEARCH_STORE_LOCATIONS: "true",
    VEHICLE_OWNERSHIP_SERVICE_URL: "https://vehicle-ownership.onr-dev.aws.cinch.co.uk",
    ENABLE_ADMIN_FEE_COMPLIANCE: "true",
    ENABLE_BUY_NOW_CTA_MESSAGING: "true",
    ENABLE_EMAIL_QUOTE: "true",
    HOMEPAGE_FAVOURITING: "true",
    ENABLE_PRODUCT_DETAIL_PAGE_VARIANT: "true",
    ENABLE_QUOTES_MARKETING: "true",
    ENABLE_PX_ON_HOMEPAGE_HERO: "true",
    SEARCH_FINANCE_TYPE_FILTER: "true",
    SHOW_QUOTE_TERM_MONTHS: "true",
    SHOW_SCORELESS_TRUSTPILOT: "true",
    SOFT_SEARCH_CHANGES: "true",
    SHOW_CINCH_COVER_IN_PROFILE: "true",
    BANK_SERVICE_URL: "https://bank-details.cnv-dev.aws.cinch.co.uk",
    DELIVERY_FEE_PENCE_STANDARD: "4900",
    DELIVERY_FEE_PENCE_EXPRESS: "9900",
    VAP_SERVICE_URL: "https://yybmpue166.execute-api.eu-west-1.amazonaws.com/dev",
    USE_REFRESH_TOKEN: "true"
};

;// CONCATENATED MODULE: ../../../libs/shared/environments/src/lib/environment-prod.ts
const environmentProd = {
    ADOBE_DTM: "launch-EN4b0cc1c046db4a3da7308feed4637416.min",
    IDS_AUTH_KEY: "oxford-user:https://identity-production.cinch.co.uk:fe",
    AUTH0_AUTH_KEY: "oxford-user:https://auth.cinch.co.uk:B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7",
    CINCHCARE_SERVICE_URL: "https://cinchcare.cnv-prod.aws.cinch.co.uk",
    PERMISSION_URL: "https://permissions.snc-prod.aws.cinch.co.uk/unsubscribe",
    DELIVERY_SERVICE_URL: "https://delivery.api.cinch.co.uk",
    ORDER_SERVICE_URL: "https://orders.api.cinch.co.uk",
    PROFILE_SERVICE_URL: "https://profile.onr-prod.aws.cinch.co.uk",
    SEARCH_SERVICE_URL: "https://search-api.snc-prod.aws.cinch.co.uk",
    SEARCH_VALUE_PROPOSITIONS: "true",
    SEGMENT_KEY: "fxuC9PcNxIbVcTp5QHTWYF9QggSg3Mvs",
    STATIC_ASSETS_URL: "https://assets-production.cinch.co.uk",
    IDENTITY_SERVICE_URL: "https://api-production.cinch.co.uk/idt/v1",
    AUTH0_SERVICE_URL: "https://auth.cinch.co.uk",
    AUTH0_DATABASE_NAME: "Username-Password-Authentication",
    AUTH0_CLIENT_ID: "B5XFE1dV7b8IMpeZxY8kqCPOPiAwgwD7",
    PROMO_BANNER_NAME: "sale",
    CINCH_URL: "https://www.cinch.co.uk",
    CINCH_APP_URL: "https://mobile.snc-prod.aws.cinch.co.uk",
    TRUSTPILOT_URL: "https://trustpilot.snc-prod.aws.cinch.co.uk",
    STORYBLOK_BFF_COMPONENT: "https://storyblok-bff.snc-prod.aws.cinch.co.uk",
    CONSUMER_VALUATIONS_SERVICE_URL: "https://consumer-valuations.cnv-prod.aws.cinch.co.uk",
    CINCH_CHARGE_CARD_REQUEST_URL: "https://extras-cinch-charge-card.cnv-prod.aws.cinch.co.uk",
    CINCH_CHARGE_CARD_REQUEST_API_KEY: "R48mFOTC6BamHbg1LR8k97fvGXOBOweg1PsHdERV",
    PRODUCT_DETAIL_SERVICE_URL: "https://product.api.cinch.co.uk",
    RESERVATION_STATUS_URL: "https://orders.api.cinch.co.uk/reservation-status",
    INVENTORY_SERVICE_HISTORY_URL: "https://service-history.api.cinch.co.uk/basic",
    IOS_APP_STORE_URL: "https://apps.apple.com/gb/app/cinch-cars-without-the-faff/id1641060889",
    ANDROID_APP_STORE_URL: "https://play.google.com/store/apps/details?id=com.cinchapp",
    ADMIN_FEE_RETURN_TO_CHECKOUT: "true",
    ADMIN_FEE_VALUE: "9900",
    ADMIN_FEE_LOYALTY: "true",
    UNSUBSCRIBE_SERVICE_URL: "https://communication-v2-user-prefs.api.cinch.co.uk/unsubscribe",
    UNSUBSCRIBE_MINIMUM_DURATION: "3000",
    CHECKOUT_RESERVATIONS_DECOUPLING: "true",
    CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: "false",
    RESERVATION_SERVICE_URL: "https://reservations.cnv-prod.aws.cinch.co.uk/source/orders",
    DELIVERY_SLOT_AVAILABILITY_SERVICE_URL: "https://delivery.api.cinch.co.uk/delivery-slots",
    LOGISTICS_FEES_SERVICE_URL: "https://logistics-fees.snp-prod.aws.cinch.co.uk",
    FINANCE_APPLICATION_SERVICE_URL: "https://finance-application.api.cinch.co.uk",
    FINANCE_QUOTE_SERVICE_URL: "https://finance-quote.pnf-prod.aws.cinch.co.uk",
    FINANCE_SOFT_SEARCH_URL_PATH: "/car-finance/check-eligibility",
    PAYMENT_LINK_SERVICE_URL: "https://payment-link.cnv-prod.aws.cinch.co.uk",
    STRIPE_PUBLISHABLE_KEY: "pk_live_3rDkEJzP58ZdTSIqCDS7XoAy00NjjZYQGR",
    GAP_SERVICE_URL: "https://gap-insurance.cnv-prod.aws.cinch.co.uk",
    ENABLE_AM_PM_SLOTS_FOR_DELIVERIES: "true",
    SERVICING_AND_WARRANTY_FLAG: "false",
    DISABLE_CINCHCARE: "false",
    GAP_INSURANCE_FLAG: "false",
    CUSTOMER_DATA_API_KEY: "141271a4-f574-41de-9eee-962ee2674d80",
    CUSTOMER_DATA_API_URL: "https://customer-data.api.cinch.co.uk",
    ENABLE_CINCH_APP_USER_AGENT_IN_USED_CARS_SSR: "true",
    SEARCH_MULTIPLE_IMAGES: "true",
    ENABLE_ZENDESK_SCRIPT: "true",
    VEHICLE_CARD_V2: "false",
    NEXT_BEST_ACTION: "true",
    SEARCH_STORE_LOCATIONS: "true",
    VEHICLE_OWNERSHIP_SERVICE_URL: "https://vehicle-ownership.onr-prod.aws.cinch.co.uk",
    ENABLE_ADMIN_FEE_COMPLIANCE: "true",
    ENABLE_BUY_NOW_CTA_MESSAGING: "true",
    ENABLE_EMAIL_QUOTE: "true",
    HOMEPAGE_FAVOURITING: "false",
    ENABLE_PRODUCT_DETAIL_PAGE_VARIANT: "true",
    ENABLE_QUOTES_MARKETING: "true",
    ENABLE_PX_ON_HOMEPAGE_HERO: "false",
    SEARCH_FINANCE_TYPE_FILTER: "false",
    SHOW_QUOTE_TERM_MONTHS: "true",
    SHOW_SCORELESS_TRUSTPILOT: "false",
    SOFT_SEARCH_CHANGES: "true",
    SHOW_CINCH_COVER_IN_PROFILE: "true",
    BANK_SERVICE_URL: "https://bank-details.cnv-prod.aws.cinch.co.uk",
    DELIVERY_FEE_PENCE_STANDARD: "0",
    DELIVERY_FEE_PENCE_EXPRESS: "9900",
    VAP_SERVICE_URL: "https://6gantc3nhf.execute-api.eu-west-1.amazonaws.com/prod",
    USE_REFRESH_TOKEN: "false"
};

;// CONCATENATED MODULE: ../../../libs/shared/environments/src/lib/environment.ts


const environment =  true ? environmentProd : 0;

;// CONCATENATED MODULE: ../../../libs/shared/environments/src/lib/environment.types.ts
const BaseEnvironment = {
    RedirectUrlKey: "REDIRECT_URL_KEY"
};
const EnvironmentFromFile = {
    Adobe: "ADOBE_DTM",
    LegacyAuthKey: "IDS_AUTH_KEY",
    AuthKey: "AUTH0_AUTH_KEY",
    ProfileServiceUrl: "PROFILE_SERVICE_URL",
    StaticAssetsUrl: "STATIC_ASSETS_URL",
    OrderServiceUrl: "ORDER_SERVICE_URL",
    CinchcareServiceUrl: "CINCHCARE_SERVICE_URL",
    DeliveryServiceURl: "DELIVERY_SERVICE_URL",
    SearchServiceUrl: "SEARCH_SERVICE_URL",
    PermissionsUrl: "PERMISSION_URL",
    SearchValuePropositions: "SEARCH_VALUE_PROPOSITIONS",
    SegmentKey: "SEGMENT_KEY",
    IdentityServiceUrl: "IDENTITY_SERVICE_URL",
    Auth0ServiceUrl: "AUTH0_SERVICE_URL",
    Auth0DatabaseName: "AUTH0_DATABASE_NAME",
    Auth0ClientId: "AUTH0_CLIENT_ID",
    promoBannerName: "PROMO_BANNER_NAME",
    cinchUrl: "CINCH_URL",
    cinchAppUrl: "CINCH_APP_URL",
    TrustpilotUrl: "TRUSTPILOT_URL",
    StoryblokBFFComponent: "STORYBLOK_BFF_COMPONENT",
    consumerValuationsServiceUrl: "CONSUMER_VALUATIONS_SERVICE_URL",
    CinchChargeCardRequestUrl: "CINCH_CHARGE_CARD_REQUEST_URL",
    CinchChargeCardRequestAPIKey: "CINCH_CHARGE_CARD_REQUEST_API_KEY",
    ProductDetailServiceUrl: "PRODUCT_DETAIL_SERVICE_URL",
    ReservationStatusUrl: "RESERVATION_STATUS_URL",
    InventoryServiceHistoryUrl: "INVENTORY_SERVICE_HISTORY_URL",
    IOSAppStoreUrl: "IOS_APP_STORE_URL",
    AndroidAppStoreUrl: "ANDROID_APP_STORE_URL",
    AdminFeeReturnToCheckout: "ADMIN_FEE_RETURN_TO_CHECKOUT",
    AdminFeeValue: "ADMIN_FEE_VALUE",
    AdminFeeLoyalty: "ADMIN_FEE_LOYALTY",
    CheckoutReservationsDecoupling: "CHECKOUT_RESERVATIONS_DECOUPLING",
    CheckoutReservationsDecouplingPhaseTwo: "CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO",
    ReservationServiceUrl: "RESERVATION_SERVICE_URL",
    DeliverySlotAvailabilityServiceUrl: "DELIVERY_SLOT_AVAILABILITY_SERVICE_URL",
    LogisticsFeesServiceUrl: "LOGISTICS_FEES_SERVICE_URL",
    FinanceApplicationServiceUrl: "FINANCE_APPLICATION_SERVICE_URL",
    FinanceQuoteServiceUrl: "FINANCE_QUOTE_SERVICE_URL",
    FinanceSoftSearchUrlPath: "FINANCE_SOFT_SEARCH_URL_PATH",
    PaymentLinkServiceUrl: "PAYMENT_LINK_SERVICE_URL",
    StripePublishableKey: "STRIPE_PUBLISHABLE_KEY",
    GapServiceUrl: "GAP_SERVICE_URL",
    EnableAmPmSlotsForDeliveries: "ENABLE_AM_PM_SLOTS_FOR_DELIVERIES",
    ServicingAndWarrantyFlag: "SERVICING_AND_WARRANTY_FLAG",
    DisableCinchCare: "DISABLE_CINCHCARE",
    GapInsuranceFlag: "GAP_INSURANCE_FLAG",
    CustomerDataAPIKey: "CUSTOMER_DATA_API_KEY",
    CustomerDataAPIUrl: "CUSTOMER_DATA_API_URL",
    EnableCinchAppUserAgentInUsedCarsSSR: "ENABLE_CINCH_APP_USER_AGENT_IN_USED_CARS_SSR",
    SearchMultipleImages: "SEARCH_MULTIPLE_IMAGES",
    EnabledZendeskScript: "ENABLE_ZENDESK_SCRIPT",
    VehicleCardV2: "VEHICLE_CARD_V2",
    NextBestAction: "NEXT_BEST_ACTION",
    SearchStoreLocations: "SEARCH_STORE_LOCATIONS",
    VehicleOwnershipServiceUrl: "VEHICLE_OWNERSHIP_SERVICE_URL",
    AdminFeeCompliance: "ENABLE_ADMIN_FEE_COMPLIANCE",
    enableBuyNowMessaging: "ENABLE_BUY_NOW_CTA_MESSAGING",
    EnableEmailQuote: "ENABLE_EMAIL_QUOTE",
    EnableFavouritingHomePageChanges: "HOMEPAGE_FAVOURITING",
    EnableProductDetailPageVariant: "ENABLE_PRODUCT_DETAIL_PAGE_VARIANT",
    EnableQuotesMarketing: "ENABLE_QUOTES_MARKETING",
    EnablePXOnHomepageHero: "ENABLE_PX_ON_HOMEPAGE_HERO",
    SearchFinanceTypeFilter: "SEARCH_FINANCE_TYPE_FILTER",
    ShowQuoteTermMonths: "SHOW_QUOTE_TERM_MONTHS",
    ShowScorelessTrustpilot: "SHOW_SCORELESS_TRUSTPILOT",
    SoftSearchChanges: "SOFT_SEARCH_CHANGES",
    showCinchCoverInProfile: "SHOW_CINCH_COVER_IN_PROFILE",
    bankServiceUrl: "BANK_SERVICE_URL",
    DeliveryFeeStandard: "DELIVERY_FEE_PENCE_STANDARD",
    DeliveryFeeExpress: "DELIVERY_FEE_PENCE_EXPRESS",
    VapServiceUrl: "VAP_SERVICE_URL",
    UseRefreshToken: "USE_REFRESH_TOKEN"
};
const EnvironmentFromProcess = {
    DataDogAPIKey: "DATADOG_API_KEY",
    DataDogClientId: "DATADOG_CLIENT_ID",
    DataDogRumApplicationId: "DATADOG_RUM_APPLICATION_ID",
    DataDogRumClientToken: "DATADOG_RUM_CLIENT_TOKEN",
    DataDogRumGlobalSampleRate: "DATADOG_RUM_GLOBAL_SAMPLE_RATE",
    DataDogRumGlobalReplaySampleRate: "DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE",
    DataDogServiceName: "DATADOG_SERVICE_NAME",
    BuildId: "BUILD_ID"
};
const Env = {
    ...BaseEnvironment,
    ...EnvironmentFromFile,
    ...EnvironmentFromProcess
};

;// CONCATENATED MODULE: ../../../libs/shared/environments/src/lib/index.ts
/* provided dependency */ var process = __webpack_require__(13158);

function readFromProcessEnv() {
    return {
        BUILD_ID: "landing-www::b344a3f21a1f14207b5048bb702550734e68e3b7::12784956648::production" || 0 || 0,
        DATADOG_API_KEY: process.env["NEXT_PUBLIC_DATADOG_API_KEY"] || process.env["DATADOG_API_KEY"],
        DATADOG_CLIENT_ID: "pubd66f6c0c3fa8105f89abc58a5a6636a6" || 0,
        DATADOG_RUM_APPLICATION_ID: "2768b7ed-b8bb-4239-9d38-75cd32fc2838" || 0,
        DATADOG_RUM_CLIENT_TOKEN: "pub208a920e391db2e4bbf497e2e7021360" || 0,
        DATADOG_RUM_GLOBAL_SAMPLE_RATE: "100" || 0,
        DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE: "0" || 0,
        DATADOG_SERVICE_NAME: "landing-www" || 0
    };
}
function readFromEnv(key) {
    const staticEnv = {
        REDIRECT_URL_KEY: "cinch-account-confirm-redirectUrl"
    };
    const processEnv = readFromProcessEnv();
    const fullEnv = {
        ...staticEnv,
        ...environment,
        ...processEnv
    };
    const envValue = fullEnv[key];
    if (envValue === undefined || envValue === null) {
        throw new Error(`
        Missing environment variable value for key ${key}.
        Running locally: Do you have a .env.local file in your app folder that contains ${key}?
        Running in CI: Is ${key} exposed in the CI pipeline file?
        `);
    }
    return envValue;
}


;// CONCATENATED MODULE: ../../../libs/shared/environments/src/index.ts



/***/ }),

/***/ 99313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ accordion_component; },
  "lr": function() { return /* reexport */ carousel_wrapper_component; },
  "J8": function() { return /* reexport */ carousel_controls_component; },
  "Pn": function() { return /* reexport */ carousel_navigation_component; },
  "Jj": function() { return /* reexport */ carousel_pagination_component; },
  "qs": function() { return /* reexport */ SwiperSlide; },
  "YE": function() { return /* reexport */ cookie_consent_wrapper; },
  "ph": function() { return /* reexport */ svg_gradient; },
  "h_": function() { return /* reexport */ heart; },
  "C$": function() { return /* reexport */ HoldingImage; },
  "Wj": function() { return /* reexport */ lib_svg; },
  "dA": function() { return /* reexport */ GRADIENT_IDS; },
  "u8": function() { return /* reexport */ trustpilot_reviews; },
  "jP": function() { return /* reexport */ TrustpilotScoreless; },
  "cE": function() { return /* reexport */ trustpilot_widget; },
  "sd": function() { return /* reexport */ TrustpilotWidgetTemplates; },
  "im": function() { return /* reexport */ wrapper; },
  "LA": function() { return /* reexport */ cookie_modal_open_hook; }
});

// UNUSED EXPORTS: BaseCard, CarIcon, ContentSectionCta, LinkList, LoadingSpinner, Pagination, ReviewCard, SVG_DEFAULT_GRADIENT_ID, usePrefersReducedMotion

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/content-section-cta/content-section-cta.tsx




function ContentSectionCta({ title , body , url , buttonLabel , classes ="" , onClick  }) {
    return /*#__PURE__*/ _jsxs("article", {
        className: cx(styles.article, classes),
        children: [
            /*#__PURE__*/ _jsx(Text, {
                element: "h3",
                fontWeight: "bold",
                fontSize: "l",
                className: styles.articleTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: styles.articleBody
                },
                children: body
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                element: "a",
                href: url,
                classNames: {
                    button: styles.articleButton
                },
                onClick: onClick,
                children: buttonLabel
            })
        ]
    });
}
/* harmony default export */ var content_section_cta = ((/* unused pure expression or super */ null && (ContentSectionCta)));

// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/link-list/link-list.tsx





const LinkList = ({ title , linkItems  })=>{
    const router = useRouter();
    const { trackEvent  } = useAnalytics();
    const handleClick = (item)=>{
        trackEvent({
            eventName: `Links Section clicked`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: item.text,
                    label: `${item.text} link`,
                    action: "manual links"
                }
            }
        });
        router.push(item.url);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.sectionTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.list,
                children: linkItems === null || linkItems === void 0 ? void 0 : linkItems.map((item)=>/*#__PURE__*/ _jsx("li", {
                        className: styles.listItem,
                        onClick: ()=>handleClick(item),
                        children: /*#__PURE__*/ _jsx(TextLink, {
                            hasNoLine: true,
                            href: item.url,
                            children: item.text
                        })
                    }, item.text))
            })
        ]
    });
};
/* harmony default export */ var link_list = ((/* unused pure expression or super */ null && (LinkList)));

// EXTERNAL MODULE: ../../../node_modules/next/script.js
var script = __webpack_require__(50430);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/trustpilot-widget/trustpilot-widget.module.css
var trustpilot_widget_module = __webpack_require__(49242);
var trustpilot_widget_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_widget_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-widget/trustpilot-widget.tsx





var TrustpilotWidgetTemplates;
(function(TrustpilotWidgetTemplates) {
    TrustpilotWidgetTemplates["carousel"] = "54ad5defc6454f065c28af8b";
    TrustpilotWidgetTemplates["strip"] = "5613c9cde69ddc09340c6beb";
    TrustpilotWidgetTemplates["starter"] = "5613c9cde69ddc09340c6beb";
    TrustpilotWidgetTemplates["microTrustScore"] = "5419b637fa0340045cd0c936";
    TrustpilotWidgetTemplates["grid"] = "539adbd6dec7e10e686debee";
    TrustpilotWidgetTemplates["microStar"] = "5419b732fbfb950b10de65e5";
    TrustpilotWidgetTemplates["microCombo"] = "5419b6ffb0d04a076446a9af";
})(TrustpilotWidgetTemplates || (TrustpilotWidgetTemplates = {}));
const TrustpilotWidget = ({ widget =TrustpilotWidgetTemplates.carousel , className , height ="240px"  })=>{
    const ref = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (window.Trustpilot && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (trustpilot_widget_module_default()).trustpilotWidgetContainer,
        children: [
            widget !== TrustpilotWidgetTemplates.grid && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (trustpilot_widget_module_default()).linkOverlay,
                href: "/customer-reviews",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref,
                className: classnames_default()("trustpilot-widget", className),
                "data-locale": "en-GB",
                "data-template-id": widget,
                "data-businessunit-id": "5d513cfbed9f5f00012db9a5",
                "data-style-height": height,
                "data-style-width": "100%",
                "data-theme": "light",
                "data-stars": "4,5",
                "data-review-languages": "en",
                "data-testid": "trust-pilot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://uk.trustpilot.com/review/cinch.co.uk",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Trustpilot"
                })
            })
        ]
    });
};
/* harmony default export */ var trustpilot_widget = (TrustpilotWidget);

// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/wrapper/wrapper.module.css
var wrapper_module = __webpack_require__(44243);
var wrapper_module_default = /*#__PURE__*/__webpack_require__.n(wrapper_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/wrapper/wrapper.tsx



const Wrapper = ({ children , isFullHeight , isFluid , isSlim , hasOverflow , className , backgroundColor ="transparent" , ...rest })=>{
    const classNames = classnames_default()((wrapper_module_default()).wrapper, {
        [(wrapper_module_default()).container]: !isFluid,
        [(wrapper_module_default()).wrapperFullHeight]: isFullHeight,
        [(wrapper_module_default()).slimContainer]: !isFluid && isSlim,
        [(wrapper_module_default()).wrapperOverflow]: !hasOverflow
    }, className === null || className === void 0 ? void 0 : className.inner);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className === null || className === void 0 ? void 0 : className.container,
        style: {
            backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classNames,
            ...rest,
            children: children
        })
    });
};
/* harmony default export */ var wrapper = (Wrapper);

// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/svg/svg.module.css
var svg_module = __webpack_require__(58853);
var svg_module_default = /*#__PURE__*/__webpack_require__.n(svg_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/svg/svg-gradient.tsx



const { color: palette  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const GRADIENT_IDS = {
    alpha: "svg-gradient-alpha",
    bravo: "svg-gradient-bravo",
    charlie: "svg-gradient-charlie",
    delta: "svg-gradient-delta"
};
const DEFAULT_GRADIENT_ID = "alpha";
const Gradient = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: (svg_module_default()).gradient,
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                id: GRADIENT_IDS.alpha,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "0%",
                        stopColor: palette.deepPurple
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "100%",
                        stopColor: palette.pearlescentPink
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                id: GRADIENT_IDS.bravo,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "0%",
                        stopColor: palette.iceBlue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "100%",
                        stopColor: palette.goGreen
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                id: GRADIENT_IDS.charlie,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "0%",
                        stopColor: palette.vividViolet
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "100%",
                        stopColor: palette.iceBlue
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                id: GRADIENT_IDS.delta,
                x2: "1",
                y2: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "0%",
                        stopColor: palette.vividViolet
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                        offset: "100%",
                        stopColor: palette.warmOrange
                    })
                ]
            })
        ]
    });
/* harmony default export */ var svg_gradient = (Gradient);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/svg/svg.tsx




const SVG = ({ className , fill , stroke ="none" , size , width , height , children , preserveAspectRatio , verticalAlign , styles , hasGradient =false , gradientId =DEFAULT_GRADIENT_ID , dataTestId  })=>{
    const finalHeight = size || height;
    const finalWidth = size || width;
    const gradientFill = hasGradient ? `url(#${GRADIENT_IDS[gradientId]})` : "";
    const Icon = children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((svg_module_default()).container, [
            className,
            styles && styles.svg
        ]),
        style: {
            height: finalHeight,
            width: finalWidth
        },
        "aria-hidden": "true",
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            preserveAspectRatio: preserveAspectRatio,
            height: finalHeight,
            width: finalWidth,
            fill: hasGradient ? gradientFill : fill,
            style: {
                display: "flex",
                width: finalWidth,
                height: finalHeight,
                fill: hasGradient ? gradientFill : fill,
                stroke,
                verticalAlign
            }
        })
    });
};
SVG.defaultProps = {
    hasGradient: false,
    size: undefined,
    width: "100%",
    height: "100%",
    className: "",
    preserveAspectRatio: "xMidYMid",
    fill: "currentColor",
    verticalAlign: "middle",
    styles: {}
};
/* harmony default export */ var svg = (SVG);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/svg/index.ts


// eslint-disable-next-line unicorn/prefer-export-from
/* harmony default export */ var lib_svg = (svg);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/hooks/use-prefers-reduced-motion.tsx

function usePrefersReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);
    useEffect(()=>{
        const mediaQueryList = window.matchMedia("(prefers-reduced-motion: no-preference)");
        setPrefersReducedMotion(!window.matchMedia("(prefers-reduced-motion: no-preference)").matches);
        const listener = (event)=>{
            if (event !== null) {
                setPrefersReducedMotion(!event.matches);
            }
        };
        mediaQueryList.addEventListener("change", listener);
        return ()=>{
            mediaQueryList.removeEventListener("change", listener);
        };
    }, []);
    return prefersReducedMotion;
}
/* harmony default export */ var use_prefers_reduced_motion = ((/* unused pure expression or super */ null && (usePrefersReducedMotion)));

// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
// EXTERNAL MODULE: ../../../node_modules/next/head.js
var head = __webpack_require__(46582);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/pagination/pagination.component.tsx







const ellipses = "...";
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noOp = function() {
// this does nothing.
};
const Pagination = ({ activePage , itemsCountPerPage , totalItemsCount , sourcePage , onChange =noOp , enabledLinks =false , includedQueryParams =""  })=>{
    // Guessing this is so we can wait for API calls to resolve
    // However this is maybe irrelevant if we're server-side fetching
    // So lets revisit this once the API is hooked up
    const currentPage = activePage || 1;
    const itemsPerPage = itemsCountPerPage || 24;
    const { items  } = usePagination({
        currentPage,
        itemsPerPage,
        totalItemsCount
    });
    const { trackEvent  } = useAnalytics();
    const handleClick = ()=>{
        trackEvent({
            eventName: `${sourcePage} - Pagination click`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "page bottom",
                    label: "pagination",
                    action: EventNames.click
                }
            }
        });
    };
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === items[items.length - 1] || items.length === 0;
    const isMultipleEllipses = items.filter((item)=>item === ellipses).length > 1;
    const renderPrevNextButtons = (direction, isDisabled)=>{
        const isNext = direction === "next";
        const ariaLabel = isNext ? "Next page" : "Previous page";
        const pageNumber = isNext ? currentPage + 1 : currentPage - 1;
        const pageHref = pageNumber === 1 ? `/${sourcePage}` : `/${sourcePage}/page/${pageNumber}`;
        return enabledLinks ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        !isFirstPage && direction === "previous" ? /*#__PURE__*/ _jsx("link", {
                            rel: "prev",
                            href: pageHref
                        }, `next-link-prev`) : null,
                        !isLastPage && direction === "next" ? /*#__PURE__*/ _jsx("link", {
                            rel: "next",
                            href: pageHref
                        }, `next-link-next`) : null
                    ]
                }),
                /*#__PURE__*/ _jsx(Link, {
                    href: isDisabled ? "" : `${pageHref}${includedQueryParams}`,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ _jsx("a", {
                        "aria-disabled": isDisabled,
                        href: pageHref,
                        "aria-label": ariaLabel,
                        onClick: (e)=>!isDisabled ? onChange(pageNumber) : e.preventDefault(),
                        className: cx(styles.button, styles.nextPrevButton),
                        children: isNext ? "Next" : "Prev"
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsx("button", {
            "aria-disabled": isDisabled,
            disabled: isDisabled,
            onClick: ()=>!isDisabled ? onChange(pageNumber) : null,
            "aria-label": ariaLabel,
            className: cx(styles.button, styles.nextPrevButton),
            children: isNext ? "Next" : "Prev"
        });
    };
    const renderPageNumberButton = (pageNumber)=>{
        const isLastItem = pageNumber === items[items.length - 1];
        const ariaLabel = isLastItem ? `Page ${pageNumber}, last page` : `Page ${pageNumber}`;
        const pageHref = pageNumber === 1 ? `/${sourcePage}` : `/${sourcePage}/page/${pageNumber}`;
        return enabledLinks ? /*#__PURE__*/ _jsx(Link, {
            href: `${pageHref}${includedQueryParams}`,
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ _jsx("a", {
                href: pageHref,
                "aria-label": ariaLabel,
                "aria-current": activePage === pageNumber ? "page" : undefined,
                "data-testid": "page-number-button",
                className: cx(styles.button, styles.pageNumberButton, {
                    [styles.pageNumberButtonActive]: activePage === pageNumber
                }),
                onClick: (e)=>onChange(pageNumber),
                children: pageNumber.toLocaleString()
            })
        }) : /*#__PURE__*/ _jsx("button", {
            "aria-label": ariaLabel,
            "aria-current": activePage === pageNumber ? "page" : undefined,
            "data-testid": "page-number-button",
            onClick: ()=>onChange(pageNumber),
            className: cx(styles.button, styles.pageNumberButton, {
                [styles.pageNumberButtonActive]: activePage === pageNumber
            }),
            children: pageNumber.toLocaleString()
        });
    };
    return /*#__PURE__*/ _jsx("nav", {
        "aria-label": "Pagination",
        className: styles.pagination,
        "data-testid": "pagination",
        children: /*#__PURE__*/ _jsxs("ul", {
            onClick: handleClick,
            className: cx(styles.list, {
                [styles.listWithMultipleEllipses]: isMultipleEllipses
            }),
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: styles.listItem,
                    children: renderPrevNextButtons("previous", isFirstPage)
                }),
                items.length > 0 && items.map((pageNumber, index)=>pageNumber === ellipses ? /*#__PURE__*/ _jsx("li", {
                        className: cx(styles.listItem, styles.ellipses),
                        children: "…"
                    }, `${pageNumber}-${index}`) : /*#__PURE__*/ _jsx("li", {
                        className: styles.listItem,
                        children: renderPageNumberButton(Number(pageNumber))
                    }, pageNumber)),
                /*#__PURE__*/ _jsx("li", {
                    className: styles.listItem,
                    children: renderPrevNextButtons("next", isLastPage)
                })
            ]
        })
    });
};
/* harmony default export */ var pagination_component = ((/* unused pure expression or super */ null && (Pagination)));

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/icons/assets/car.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgCar = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  d: "M22.48 12.82c-2.12-2.86-5.05-3.87-8.27-3.87-.7 0-1.42.05-2.15.13C9 9.45 6.75 11.62 6 14.75a2.98 2.98 0 0 1-.54 1.13 3.38 3.38 0 0 0-.52 3.44c.15.41.7.69 1.08 1.02.18.16.45.28.53.48.54 1.34 1.54 2.1 2.85 2.13h.12c1.65 0 2.55-.6 3.2-2.05.08-.17.35-.38.53-.38.97-.02 1.94-.02 2.9-.02h2.35c.7 1.82 1.55 2.45 3.31 2.45h.11c1.5-.02 2.42-.76 2.98-2.45l.29.01c1.06 0 1.88-.36 2.28-1.4a3.67 3.67 0 0 0-2.51-4.7 4.07 4.07 0 0 1-2.48-1.6zm-.53 13.13h-.14c-2.28 0-3.94-.8-5.1-2.45a506.8 506.8 0 0 0-2.03 0c-1.18 1.63-2.9 2.45-5.16 2.45h-.17a5.95 5.95 0 0 1-5.26-3.31 5.3 5.3 0 0 1-.06-.06l-.16-.11a6.42 6.42 0 0 1-.7-.58 3.9 3.9 0 0 1-1.05-1.54c-.8-2.2-.5-4.45.98-6.32a.08.08 0 0 0-.01.02C4.12 9.7 7.39 6.63 11.7 6.1a20.96 20.96 0 0 1 2.5-.16c4.42 0 8.1 1.6 10.68 5.08.19.25.35.35.78.46 3.77.91 6 5.14 4.6 8.72a4.94 4.94 0 0 1-3.4 3.09 5.67 5.67 0 0 1-4.92 2.65z"
})));
/* harmony default export */ var car = (SvgCar);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/holding-image/holding-image.module.css
var holding_image_module = __webpack_require__(28812);
var holding_image_module_default = /*#__PURE__*/__webpack_require__.n(holding_image_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/holding-image/holding-image.tsx






const { space  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const HoldingImage = ({ text ="" , isAvailable , className =""  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((holding_image_module_default()).holdingImage, className, {
            [(holding_image_module_default()).holdingImageUnavailable]: !isAvailable
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_svg, {
                className: (holding_image_module_default()).icon,
                children: car,
                fill: "currentColor",
                size: space["8-x"]
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                type: index_esm/* TextStyles.menuTitle */.k7.menuTitle,
                children: text
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/shared/cookie-consent/src/index.ts + 52 modules
var cookie_consent_src = __webpack_require__(93194);
// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/hooks/cookie-modal-open.hook.ts

const useStore = (0,esm/* create */.Ue)((set)=>({
        isPreferencesModalOpen: false,
        setIsPreferencesModalOpen: (arg)=>{
            const newState = {
                isPreferencesModalOpen: arg
            };
            set(()=>({
                    ...newState
                }));
        }
    }));
const isPreferencesModalOpenSelector = (state)=>state.isPreferencesModalOpen;
const setIsPreferencesModalOpenSelector = (state)=>state.setIsPreferencesModalOpen;
const useCookieModalOpen = ()=>{
    const isPreferencesModalOpen = useStore(isPreferencesModalOpenSelector);
    const setIsPreferencesModalOpen = useStore(setIsPreferencesModalOpenSelector);
    return {
        isPreferencesModalOpen,
        setIsPreferencesModalOpen
    };
};
/* harmony default export */ var cookie_modal_open_hook = (useCookieModalOpen);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/cookie-consent-wrapper/cookie-consent-wrapper.tsx






const CookieConsentWrapper = ()=>{
    const { isPreferencesModalOpen , setIsPreferencesModalOpen  } = cookie_modal_open_hook();
    const setHasLoadedScripts = (0,src/* useAnalytics */.z$)((s)=>s.setHasLoadedScripts);
    const [routeCount, setRouteCount] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    const incrementRouteCount = (0,react.useCallback)(()=>{
        setRouteCount(routeCount + 1);
    }, [
        routeCount
    ]);
    (0,react.useEffect)(()=>{
        router.events.on("routeChangeComplete", incrementRouteCount);
        return ()=>{
            router.events.off("routeChangeComplete", incrementRouteCount);
        };
    }, [
        router.events,
        incrementRouteCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cookie_consent_src/* CookieConsent */.Gk, {
        count: routeCount,
        setLoaded: setHasLoadedScripts,
        setIsPreferencesModalOpen: setIsPreferencesModalOpen,
        isPreferencesModalOpen: isPreferencesModalOpen
    });
};
/* harmony default export */ var cookie_consent_wrapper = (CookieConsentWrapper);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/loading-spinner/loading-spinner.tsx





const { color: loading_spinner_palette  } = index_esm/* designTokens.customProperties.ds */.Wp.customProperties.ds;
const DEFAULT_SIZE = 32;
const LoadingSpinner = ({ backgroundCircleColor =loading_spinner_palette.gainsboro , foregroundCircleColor =loading_spinner_palette.deepPurple , size =DEFAULT_SIZE , className  })=>{
    const classNames = cx(styles.loadingSpinner, className);
    return /*#__PURE__*/ _jsxs("svg", {
        className: classNames,
        xmlns: "https://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        "data-testid": "LoadingSpinner",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "16",
                r: "11",
                stroke: backgroundCircleColor
            }),
            /*#__PURE__*/ _jsx("path", {
                className: styles.foregroundCircle,
                d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
                stroke: foregroundCircleColor
            })
        ]
    });
};
/* harmony default export */ var loading_spinner = ((/* unused pure expression or super */ null && (LoadingSpinner)));

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/base-card/base-card.component.tsx




const BaseCard = ({ children , className , element ="div" , hasBoxShadow =false , hasBorder =false , ...rest })=>{
    const HtmlElement = element;
    const classes = classNames({
        [styles.cardBoxShadow]: hasBoxShadow,
        [styles.cardBorder]: hasBorder
    }, className, styles.card);
    return /*#__PURE__*/ _jsx(HtmlElement, {
        className: classes,
        "data-testid": "Atoms/Base-Card",
        ...rest,
        children: children
    });
};
/* harmony default export */ var base_card_component = ((/* unused pure expression or super */ null && (BaseCard)));

// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/accordion/accordion.module.css
var accordion_module = __webpack_require__(84983);
var accordion_module_default = /*#__PURE__*/__webpack_require__.n(accordion_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/accordion/button.component.tsx





const handleArrowDown = (accordionIndex, totalItems)=>{
    const nextAccordionIndex = accordionIndex + 1;
    if (accordionIndex === totalItems) {
        return 1;
    }
    return nextAccordionIndex;
};
const handleArrowUp = (accordionIndex, totalItems)=>{
    const nextAccordionIndex = accordionIndex - 1;
    if (accordionIndex === 1) {
        return totalItems;
    }
    return nextAccordionIndex;
};
const getOpenAccordionKeyCode = (id)=>({
        "13": ()=>id,
        "32": ()=>id
    });
const getKeyCodes = (id, totalItems)=>({
        "40": ()=>handleArrowDown(id, totalItems),
        "38": ()=>handleArrowUp(id, totalItems),
        "36": ()=>1,
        "35": ()=>totalItems
    });
const AccordionButton = ({ isExpanded , id , toggleExpanded , buttonText , totalItems , setFocusActive , buttonId , sectionId , iconType , iconGradient  }, ref)=>{
    const iconGradientFill = iconGradient ? iconGradient : undefined;
    const iconColorFill = !iconGradient ? "deepPurple" : undefined;
    const keyboardEventHandler = (event)=>{
        const keyCodes = getKeyCodes(id, totalItems);
        const openAccordionKeyCode = getOpenAccordionKeyCode(id);
        if (event.keyCode in openAccordionKeyCode) {
            event.preventDefault();
            toggleExpanded();
            return;
        }
        if (event.keyCode in keyCodes) {
            event.preventDefault();
            setFocusActive(keyCodes[event.keyCode]());
            return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: (accordion_module_default()).accordionTitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-disabled": isExpanded,
            "aria-controls": `${sectionId}-${id}`,
            id: `${buttonId}-${id}`,
            "data-testid": `${buttonId}-${id}`,
            onClick: toggleExpanded,
            onKeyDown: keyboardEventHandler,
            ref: ref,
            className: (accordion_module_default()).accordionButton,
            children: [
                iconType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                    name: iconType,
                    className: (accordion_module_default()).icon,
                    color: iconColorFill,
                    size: 24,
                    gradient: iconGradientFill
                }) : null,
                buttonText,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                    name: "chevron-down",
                    className: classnames_default()((accordion_module_default()).chevron, {
                        [(accordion_module_default()).chevronRotate]: isExpanded
                    }),
                    color: "deepPurple",
                    size: 16
                })
            ]
        })
    });
};
/* harmony default export */ var button_component = (/*#__PURE__*/react.forwardRef(AccordionButton));

// EXTERNAL MODULE: ../../../node_modules/react-transition-group/esm/CSSTransition.js + 7 modules
var CSSTransition = __webpack_require__(30659);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/accordion/content.component.tsx





const AccordionContent = ({ isExpanded , id , content , sectionId , buttonId  })=>{
    const [height, setHeight] = (0,react.useState)(0);
    const [display, setDisplay] = (0,react.useState)("none");
    const innerContainerRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            if (height > 0) {
                onEntered();
            }
        };
        window.addEventListener("resize", handleResize, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        height
    ]);
    const onEntering = ()=>{
        setDisplay("block");
    };
    const onEntered = ()=>{
        if (innerContainerRef.current) {
            setHeight(innerContainerRef.current.offsetHeight);
        }
    };
    const onExiting = ()=>{
        setHeight(0);
    };
    const onExit = ()=>{
        setDisplay("none");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
        in: isExpanded,
        timeout: 200,
        onEntering: onEntering,
        onEntered: onEntered,
        onExiting: onExiting,
        onExit: onExit,
        "aria-hidden": !isExpanded,
        role: "region",
        id: `${sectionId}-${id}`,
        "aria-labelledby": `${buttonId}-${id}`,
        "data-testid": `${sectionId}-${id}`,
        className: classnames_default()((accordion_module_default()).accordionContentContainer),
        style: {
            height
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: innerContainerRef,
                style: {
                    display
                },
                className: classnames_default()((accordion_module_default()).accordionContentInnerContainer),
                children: content()
            })
        })
    });
};
/* harmony default export */ var content_component = (AccordionContent);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/accordion/item.component.tsx







const renderContent = (text)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontSize: "xs",
        fontWeight: "medium",
        children: text
    });
const accordionClassName = "accordionItemContainer";
// Accordion resource - https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
const AccordionItem = ({ title , children , id , totalItems , setCurrentFocusAccordion , sectionId , buttonId , onToggleExpanded , iconType , iconGradient , theme  }, ref)=>{
    const [isExpanded, setExpanded] = (0,react.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const content = typeof children === "string" ? ()=>renderContent(children) : children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((accordion_module_default())[accordionClassName], (accordion_module_default())[`${accordionClassName}__${theme}`]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component, {
                isExpanded: isExpanded,
                toggleExpanded: ()=>{
                    const newState = !isExpanded;
                    onToggleExpanded(newState);
                    setExpanded(newState);
                },
                setFocusActive: setCurrentFocusAccordion,
                id: id,
                ref: ref,
                buttonText: title,
                totalItems: totalItems,
                buttonId: buttonId,
                sectionId: sectionId,
                iconType: iconType,
                iconGradient: iconGradient
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(content_component, {
                isExpanded: isExpanded,
                id: id,
                buttonId: buttonId,
                sectionId: sectionId,
                content: content
            })
        ]
    });
};
/* harmony default export */ var item_component = (/*#__PURE__*/react.forwardRef(AccordionItem));

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/accordion/accordion.component.tsx





const Accordion = ({ items , title , buttonId , sectionId , onItemToggle , theme ="standard"  })=>{
    const [currentFocusAccordion, setCurrentFocusAccordion] = (0,react.useState)();
    const itemsEls = (0,react.useRef)([]);
    const totalItems = items.length;
    (0,react.useEffect)(()=>{
        itemsEls.current = Array.from({
            length: items.length
        });
    }, [
        items
    ]);
    (0,react.useEffect)(()=>{
        if (!currentFocusAccordion) return;
        if (itemsEls.current[currentFocusAccordion]) {
            itemsEls.current[currentFocusAccordion].focus();
        }
    }, [
        currentFocusAccordion,
        itemsEls
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((accordion_module_default()).accordion),
        "aria-label": `${title} - ${totalItems} items`,
        children: items.map((item, index)=>{
            const id = index + 1;
            const keyName = `accordion-${id}`;
            const getRef = (el)=>itemsEls.current[id] = el;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(item_component, {
                title: item.title,
                id: id,
                onToggleExpanded: (isOpen)=>onItemToggle && onItemToggle(index, isOpen),
                setCurrentFocusAccordion: setCurrentFocusAccordion,
                totalItems: totalItems,
                ref: getRef,
                buttonId: buttonId,
                sectionId: sectionId,
                iconType: item.iconType,
                iconGradient: item.iconGradient,
                theme: theme,
                children: item.children
            }, keyName);
        })
    });
};
/* harmony default export */ var accordion_component = (Accordion);

;// CONCATENATED MODULE: ../../../node_modules/ssr-window/ssr-window.esm.js
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function ssr_window_esm_getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}



;// CONCATENATED MODULE: ../../../node_modules/dom7/dom7.esm.js
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group) {
    return group.toUpperCase();
  });
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = ssr_window_esm_getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }

    return this;
  }

  return this;
}

function data(key, value) {
  var el;

  if (typeof value === 'undefined') {
    el = this[0];
    if (!el) return undefined; // Get value

    if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
      return el.dom7ElementDataStorage[key];
    }

    var dataKey = el.getAttribute("data-" + key);

    if (dataKey) {
      return dataKey;
    }

    return undefined;
  } // Set value


  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }

  return this;
}

function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}

function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line

  if (el.dataset) {
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      var _attr = el.attributes[i];

      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }

  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }

  return dataset;
}

function val(value) {
  if (typeof value === 'undefined') {
    // get value
    var el = this[0];
    if (!el) return undefined;

    if (el.multiple && el.nodeName.toLowerCase() === 'select') {
      var values = [];

      for (var i = 0; i < el.selectedOptions.length; i += 1) {
        values.push(el.selectedOptions[i].value);
      }

      return values;
    }

    return el.value;
  } // set value


  for (var _i = 0; _i < this.length; _i += 1) {
    var _el = this[_i];

    if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < _el.options.length; j += 1) {
        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
      }
    } else {
      _el.value = value;
    }
  }

  return this;
}

function value(value) {
  return this.val(value);
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function once() {
  var dom = this;

  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  function onceHandler() {
    for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      eventArgs[_key8] = arguments[_key8];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);

    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }

  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}

function trigger() {
  var window = ssr_window_esm_getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function animationEnd(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('animationend', fireCallBack);
  }

  if (callback) {
    dom.on('animationend', fireCallBack);
  }

  return this;
}

function width() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}

function dom7_esm_outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function height() {
  var window = getWindow();

  if (this[0] === window) {
    return window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}

function dom7_esm_outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = ssr_window_esm_getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }

  return this;
}

function show() {
  var window = getWindow();

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.style.display === 'none') {
      el.style.display = '';
    }

    if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }

  return this;
}

function dom7_esm_styles() {
  var window = ssr_window_esm_getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = ssr_window_esm_getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function dom7_esm_text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = ssr_window_esm_getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function appendTo(parent) {
  $(parent).append(this);
  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}

function insertBefore(selector) {
  var before = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}

function insertAfter(selector) {
  var after = $(selector);

  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}

function dom7_esm_parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

function detach() {
  return this.remove();
}

function add() {
  var dom = this;
  var i;
  var j;

  for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    els[_key10] = arguments[_key10];
  }

  for (i = 0; i < els.length; i += 1) {
    var toAdd = $(els[i]);

    for (j = 0; j < toAdd.length; j += 1) {
      dom.push(toAdd[j]);
    }
  }

  return dom;
}

function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }

      el.textContent = '';
    }
  }

  return this;
}

function scrollTo() {
  var window = getWindow();

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }

  if (typeof easing === 'undefined') easing = 'swing';
  return this.each(function animate() {
    var el = this;
    var currentTop;
    var currentLeft;
    var maxTop;
    var maxLeft;
    var newTop;
    var newLeft;
    var scrollTop; // eslint-disable-line

    var scrollLeft; // eslint-disable-line

    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;

    if (typeof easing === 'undefined') {
      easing = 'swing';
    }

    if (animateTop) {
      currentTop = el.scrollTop;

      if (!duration) {
        el.scrollTop = top;
      }
    }

    if (animateLeft) {
      currentLeft = el.scrollLeft;

      if (!duration) {
        el.scrollLeft = left;
      }
    }

    if (!duration) return;

    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }

    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }

    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;

    function render(time) {
      if (time === void 0) {
        time = new Date().getTime();
      }

      if (startTime === null) {
        startTime = time;
      }

      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }

      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }

      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      window.requestAnimationFrame(render);
    }

    window.requestAnimationFrame(render);
  });
} // scrollTop(top, duration, easing, callback) {


function scrollTop() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }

  return dom.scrollTo(undefined, top, duration, easing, callback);
}

function scrollLeft() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }

  var dom = this;

  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }

  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var window = getWindow();
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'

      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

    }, initialParams),
    elements: els,
    animating: false,
    que: [],
    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }

      if (typeof easing === 'function') {
        return easing(progress);
      }

      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        window.cancelAnimationFrame(a.frameId);
      }

      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);

      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }

      var elements = []; // Define & Cache Initials & Units

      a.elements.each(function (el, index) {
        var initialFullValue;
        var initialValue;
        var unit;
        var finalValue;
        var finalFullValue;
        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });
      var startTime = null;
      var time;
      var elementsDone = 0;
      var propsDone = 0;
      var done;
      var began = false;
      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress;
        var easeProgress; // let el;

        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }

        if (startTime === null) {
          startTime = time;
        }

        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;
            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;

              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }

              if (elementsDone === elements.length) {
                done = true;
              }
            }

            if (done) {
              a.done(params.complete);
              return;
            }

            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return; // Then call

        a.frameId = window.requestAnimationFrame(render);
      }

      a.frameId = window.requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance;

  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }

  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;

  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');

function shortcut(name) {
  function eventHandler() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'undefined') {
      for (var i = 0; i < this.length; i += 1) {
        if (noTrigger.indexOf(name) < 0) {
          if (name in this[i]) this[i][name]();else {
            $(this[i]).trigger(name);
          }
        }
      }

      return this;
    }

    return this.on.apply(this, [name].concat(args));
  }

  return eventHandler;
}

var click = shortcut('click');
var dom7_esm_blur = shortcut('blur');
var dom7_esm_focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var dom7_esm_submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var dom7_esm_scroll = shortcut('scroll');

/* harmony default export */ var dom7_esm = ((/* unused pure expression or super */ null && ($)));


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/utils/dom.js

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: dom7_esm_outerWidth,
  outerHeight: dom7_esm_outerHeight,
  styles: dom7_esm_styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: dom7_esm_text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: dom7_esm_parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});
/* harmony default export */ var dom = ($);
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/utils/utils.js


function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function utils_getComputedStyle(el) {
  var window = ssr_window_esm_getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = ssr_window_esm_getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = utils_getComputedStyle(el, null);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function utils_extend() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              utils_extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (utils_isObject(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/utils/get-support.js

var support;

function calcSupport() {
  var window = ssr_window_esm_getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/utils/get-device.js


var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = ssr_window_esm_getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/utils/get-browser.js

var browser;

function calcBrowser() {
  var window = ssr_window_esm_getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/modules/resize/resize.js



var supportsResizeObserver = function supportsResizeObserver() {
  var window = ssr_window_esm_getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

/* harmony default export */ var resize_resize = ({
  name: 'resize',
  create: function create() {
    var swiper = this;
    utils_extend(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = ssr_window_esm_getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = ssr_window_esm_getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/modules/observer/observer.js
function observer_extends() { observer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return observer_extends.apply(this, arguments); }



var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = ssr_window_esm_getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
/* harmony default export */ var observer = ({
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: observer_extends({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/modular.js

/* harmony default export */ var modular = ({
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        utils_extend(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events-emitter.js
/* eslint-disable no-underscore-dangle */
/* harmony default export */ var events_emitter = ({
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateSize.js

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  utils_extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateSlides.js

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  utils_extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateAutoHeight.js
function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateSlidesOffset.js
function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateSlidesProgress.js

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = dom(swiper.visibleSlides);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateProgress.js

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  utils_extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateSlidesClasses.js
function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateActiveIndex.js

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  utils_extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/updateClickedSlide.js

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = dom(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/update/index.js









/* harmony default export */ var update = ({
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/getTranslate.js

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/setTranslate.js
function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/minTranslate.js
function minTranslate() {
  return -this.snapGrid[0];
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/maxTranslate.js
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/translateTo.js
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/translate/index.js





/* harmony default export */ var translate = ({
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/transition/setTransition.js
function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/transition/transitionStart.js
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/transition/transitionEnd.js
function transitionEnd_transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/transition/index.js



/* harmony default export */ var core_transition = ({
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd_transitionEnd
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideTo.js
function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideToLoop.js
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideNext.js
/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slidePrev.js
/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideReset.js
/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideToClosest.js
/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/slideToClickedSlide.js


function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/slide/index.js







/* harmony default export */ var slide = ({
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/loop/loopCreate.js


function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = dom(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = dom(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append(dom(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend(dom(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/loop/loopFix.js
function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/loop/loopDestroy.js
function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/loop/index.js



/* harmony default export */ var loop = ({
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/grab-cursor/setGrabCursor.js
function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js
function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/grab-cursor/index.js


/* harmony default export */ var grab_cursor = ({
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/appendSlide.js
function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/prependSlide.js
function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/addSlide.js
function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/removeSlide.js
function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/manipulation/index.js





/* harmony default export */ var manipulation = ({
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onTouchStart.js


 // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === ssr_window_esm_getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = ssr_window_esm_getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = dom(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = dom(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  utils_extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onTouchMove.js



function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      utils_extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onTouchEnd.js

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onResize.js
function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onClick.js
function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/onScroll.js
function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/events/index.js







var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

/* harmony default export */ var events = ({
  attachEvents: attachEvents,
  detachEvents: detachEvents
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/breakpoints/setBreakpoint.js

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  utils_extend(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  utils_extend(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/breakpoints/getBreakpoint.js

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = ssr_window_esm_getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/breakpoints/index.js


/* harmony default export */ var breakpoints = ({
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/classes/addClasses.js
function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/classes/removeClasses.js
function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/classes/index.js


/* harmony default export */ var classes = ({
  addClasses: addClasses,
  removeClasses: removeClasses
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/images/loadImage.js


function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = ssr_window_esm_getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = dom(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/images/preloadImages.js
function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/images/index.js


/* harmony default export */ var core_images = ({
  loadImage: loadImage,
  preloadImages: preloadImages
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/check-overflow/index.js
function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

/* harmony default export */ var check_overflow = ({
  checkOverflow: checkOverflow
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/defaults.js
/* harmony default export */ var defaults = ({
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/core/core-class.js
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint no-param-reassign: "off" */























var prototypes = {
  modular: modular,
  eventsEmitter: events_emitter,
  update: update,
  translate: translate,
  transition: core_transition,
  slide: slide,
  loop: loop,
  grabCursor: grab_cursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: check_overflow,
  classes: classes,
  images: core_images
};
var extendedDefaults = {};

var Swiper = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = utils_extend({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && dom(params.el).length > 1) {
      var swipers = [];
      dom(params.el).each(function (containerEl) {
        var newParams = utils_extend({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = utils_extend({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = utils_extend({}, swiper.params);
    swiper.passedParams = utils_extend({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = dom; // Extend Swiper

    utils_extend(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: dom(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = dom(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = dom(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    utils_extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    utils_extend(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([resize_resize, observer]);
/* harmony default export */ var core_class = (Swiper);
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/navigation/navigation.js
function navigation_extends() { navigation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return navigation_extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = dom(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = dom(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    utils_extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ var navigation = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      navigation: navigation_extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/pagination/pagination.js
function pagination_extends() { pagination_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pagination_extends.apply(this, arguments); }



var pagination_Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = dom(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = dom(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = dom(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    utils_extend(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
/* harmony default export */ var pagination = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: pagination_extends({
        dynamicBulletIndex: 0
      }, pagination_Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/components/a11y/a11y.js
function a11y_extends() { a11y_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return a11y_extends.apply(this, arguments); }



var A11y = {
  getRandomNumber: function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }

    var randomChar = function randomChar() {
      return Math.round(16 * Math.random()).toString(16);
    };

    return 'x'.repeat(size).replace(/x/g, randomChar);
  },
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  makeElNotFocusable: function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElRoleDescription: function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
    return $el;
  },
  addElControls: function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  addElId: function addElId($el, id) {
    $el.attr('id', id);
    return $el;
  },
  addElLive: function addElLive($el, live) {
    $el.attr('aria-live', live);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterOrSpaceKey: function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    var swiper = this;
    var params = swiper.params.a11y;
    var $targetEl = dom(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;
    if (swiper.params.loop || !swiper.navigation) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
        swiper.a11y.makeElNotFocusable($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
        swiper.a11y.makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
        swiper.a11y.makeElNotFocusable($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
        swiper.a11y.makeElFocusable($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;

    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletEl) {
        var $bulletEl = dom(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      });
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.a11y;
    swiper.$el.append(swiper.a11y.liveRegion); // Container

    var $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      swiper.a11y.addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    var $wrapperEl = swiper.$wrapperEl;
    var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-" + swiper.a11y.getRandomNumber(16);
    var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    swiper.a11y.addElId($wrapperEl, wrapperId);
    swiper.a11y.addElLive($wrapperEl, live); // Slide

    if (params.itemRoleDescriptionMessage) {
      swiper.a11y.addElRoleDescription(dom(swiper.slides), params.itemRoleDescriptionMessage);
    }

    swiper.a11y.addElRole(dom(swiper.slides), params.slideRole);
    var slidesLength = swiper.params.loop ? swiper.slides.filter(function (el) {
      return !el.classList.contains(swiper.params.slideDuplicateClass);
    }).length : swiper.slides.length;
    swiper.slides.each(function (slideEl, index) {
      var $slideEl = dom(slideEl);
      var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
      var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
      swiper.a11y.addElLabel($slideEl, ariaLabelMessage);
    }); // Navigation

    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      swiper.a11y.makeElFocusable($nextEl);

      if ($nextEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($nextEl, 'button');
        $nextEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      swiper.a11y.addElControls($nextEl, wrapperId);
    }

    if ($prevEl && $prevEl.length) {
      swiper.a11y.makeElFocusable($prevEl);

      if ($prevEl[0].tagName !== 'BUTTON') {
        swiper.a11y.addElRole($prevEl, 'button');
        $prevEl.on('keydown', swiper.a11y.onEnterOrSpaceKey);
      }

      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      swiper.a11y.addElControls($prevEl, wrapperId);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();
    var $nextEl;
    var $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterOrSpaceKey);
    } // Pagination


    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), swiper.a11y.onEnterOrSpaceKey);
    }
  }
};
/* harmony default export */ var a11y = ({
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      a11y: a11y_extends({}, A11y, {
        liveRegion: dom("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
      })
    });
  },
  on: {
    afterInit: function afterInit(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy(swiper) {
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
});
;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/utils.js
function react_utils_isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function react_utils_extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (react_utils_isObject(src[key]) && react_utils_isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else react_utils_extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/params-list.js
/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/get-params.js
// eslint-disable-next-line




function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  react_utils_extend(params, core_class.defaults);
  react_utils_extend(params, core_class.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (react_utils_isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        react_utils_extend(params[key], obj[key]);
        react_utils_extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/init-swiper.js
// eslint-disable-next-line



function initSwiper(swiperParams) {
  return new core_class(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/loop.js
 // eslint-disable-next-line



function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = core_class.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/react.cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/react.createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/get-changed-params.js



function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (react_utils_isObject(swiperParams[key]) && react_utils_isObject(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/get-children.js


function processChildren(c) {
  var slides = [];
  react.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/update-swiper.js


function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (react_utils_isObject(currentParams[key]) && react_utils_isObject(passedParams[key])) {
      react_utils_extend(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/virtual.js


function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/use-isomorphic-layout-effect.js


function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/swiper.js
var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function swiper_extends() { swiper_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }











var swiper_Swiper = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var eventsAssigned = false;

  var _useState = (0,react.useState)('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = (0,react.useState)(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = (0,react.useRef)(false);
  var swiperElRef = (0,react.useRef)(null);
  var swiperRef = (0,react.useRef)(null);
  var oldPassedParamsRef = (0,react.useRef)(null);
  var oldSlides = (0,react.useRef)(null);
  var nextElRef = (0,react.useRef)(null);
  var prevElRef = (0,react.useRef)(null);
  var paginationElRef = (0,react.useRef)(null);
  var scrollbarElRef = (0,react.useRef)(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      react_utils_extend(swiperRef.current.params.virtual, extendWith);
      react_utils_extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  (0,react.useEffect)(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  (0,react.useEffect)(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/react.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/react.createElement(Tag, swiper_extends({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/react.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
swiper_Swiper.displayName = 'Swiper';

// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/carousel/wrapper/carousel-wrapper.module.css
var carousel_wrapper_module = __webpack_require__(68940);
var carousel_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(carousel_wrapper_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/wrapper/carousel-wrapper.component.tsx






core_class.use([
    navigation,
    pagination,
    a11y
]);
const CarouselWrapper = ({ children , clickablePagination =true , isCarouselReady =true , customClassNames , ariaLabel ="carousel" , name , swiperSettings  })=>{
    const a11yOptions = {
        enabled: true
    };
    const wrapperClassNames = classnames_default()((carousel_wrapper_module_default()).carouselWrapper, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper, {
        [(carousel_wrapper_module_default()).showCarousel]: isCarouselReady
    });
    const carouselClassNames = classnames_default()(name, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.carousel);
    const paginationSettings = {
        el: `.${name}-pagination`,
        clickable: clickablePagination,
        dynamicBullets: true
    };
    const navigationSettings = {
        prevEl: `.${name}-prev`,
        nextEl: `.${name}-next`
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: wrapperClassNames,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_Swiper, {
            className: carouselClassNames,
            pagination: paginationSettings,
            a11y: a11yOptions,
            navigation: navigationSettings,
            ...swiperSettings,
            children: children
        })
    });
};
/* harmony default export */ var carousel_wrapper_component = (CarouselWrapper);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/wrapper/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/carousel/controls/carousel-controls.module.css
var carousel_controls_module = __webpack_require__(73226);
var carousel_controls_module_default = /*#__PURE__*/__webpack_require__.n(carousel_controls_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/controls/carousel-controls.component.tsx




const CarouselControls = ({ children , customClassNames  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((carousel_controls_module_default()).wrapper, customClassNames),
        children: children
    });
/* harmony default export */ var carousel_controls_component = (CarouselControls);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/controls/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/carousel/navigation/carousel-navigation.module.css
var carousel_navigation_module = __webpack_require__(65860);
var carousel_navigation_module_default = /*#__PURE__*/__webpack_require__.n(carousel_navigation_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/navigation/carousel-navigation.component.tsx





const CarouselNavigation = ({ customClassNames , buttonIcons ={
    leftIcon: "chevron-left",
    rightIcon: "chevron-right"
} , ariaLabels , name  })=>{
    const wrapperClassNames = classnames_default()((carousel_navigation_module_default()).controls, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.wrapper);
    const prevBtnClassNames = classnames_default()(`${name}-prev`, (carousel_navigation_module_default()).controlsBtn, (carousel_navigation_module_default()).controlsBtnPrev, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.prevButton);
    const nextBtnClassNames = classnames_default()(`${name}-next`, (carousel_navigation_module_default()).controlsBtn, (carousel_navigation_module_default()).controlsBtnNext, customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.nextButton);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-slide-controls": true,
        className: wrapperClassNames,
        "data-testid": "ds-carousel-controls",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: prevBtnClassNames,
                "aria-label": ariaLabels.previous,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                    name: buttonIcons.leftIcon,
                    size: 22
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: nextBtnClassNames,
                "aria-label": ariaLabels.next,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                    name: buttonIcons.rightIcon,
                    size: 22
                })
            })
        ]
    });
};
/* harmony default export */ var carousel_navigation_component = (CarouselNavigation);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/navigation/index.tsx


// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/carousel/pagination/carousel-pagination.module.css
var carousel_pagination_module = __webpack_require__(67246);
var carousel_pagination_module_default = /*#__PURE__*/__webpack_require__.n(carousel_pagination_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/pagination/carousel-pagination.component.tsx




const CarouselPagination = ({ name , customClassNames  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(`${name}-pagination`, (carousel_pagination_module_default()).pagination, customClassNames),
        "data-testid": "ds-carousel-pagination"
    });
/* harmony default export */ var carousel_pagination_component = (CarouselPagination);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/pagination/index.tsx


;// CONCATENATED MODULE: ../../../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide_excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function swiper_slide_extends() { swiper_slide_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return swiper_slide_extends.apply(this, arguments); }

function swiper_slide_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = swiper_slide_objectWithoutPropertiesLoose(_ref, swiper_slide_excluded);

  var slideElRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react.createElement(Tag, swiper_slide_extends({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/carousel/index.ts






// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/data/trustpilot/src/index.ts + 6 modules
var trustpilot_src = __webpack_require__(99649);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/trustpilot-review-card/trustpilot-review-card.module.css
var trustpilot_review_card_module = __webpack_require__(72393);
var trustpilot_review_card_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_review_card_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-review-card/trustpilot-review-card.tsx








const ReviewCard = ({ starRating , title , description , customerName , date , link , customClassName  })=>{
    const { trackEvent  } = (0,src/* useAnalytics */.z$)();
    const trackClick = ()=>{
        trackEvent({
            eventName: "trustpilot review",
            type: src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "button",
                    label: `trustpilot review cards`,
                    action: `click on review card`,
                    value: "full review"
                }
            }
        });
    };
    const cinchStarRating = (0,trustpilot_src/* useTrustpilotScore */.b6)();
    const shouldShowTrustPilotScoreless = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ShowScorelessTrustpilot */.X.ShowScorelessTrustpilot) === "true";
    const shouldShowTruspilotScoreless = cinchStarRating ? shouldShowTrustPilotScoreless || cinchStarRating <= 4.2 : shouldShowTrustPilotScoreless;
    const reviewLink = shouldShowTruspilotScoreless ? "/customer-reviews" : link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: reviewLink,
        target: "_blank",
        rel: "noreferrer",
        "data-testid": "review-card",
        className: (trustpilot_review_card_module_default()).trustpilotReviewLink,
        onClick: trackClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (trustpilot_review_card_module_default()).reviewCardContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()(customClassName),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (trustpilot_review_card_module_default()).starRatingContainer,
                            role: "figure",
                            "aria-label": `${starRating} of 5 rating`,
                            children: [
                                ...Array.from({
                                    length: 5
                                })
                            ].map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((trustpilot_review_card_module_default()).starRatingIconContainer, {
                                        [(trustpilot_review_card_module_default()).starRatingIconContainerFilled]: i + 1 <= starRating
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: (trustpilot_review_card_module_default()).starRatingIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "m11.469 15.893 4.705-1.195 1.966 6.07-6.671-4.875Zm10.828-7.847h-8.282L11.469.23 8.923 8.046H.64l6.703 4.844-2.546 7.814L11.5 15.86l4.125-2.97 6.67-4.844Z",
                                            fill: "#fff"
                                        })
                                    })
                                }, i))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "xl",
                            fontWeight: "bold",
                            className: (trustpilot_review_card_module_default()).trustPilotTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontWeight: "medium",
                            className: (trustpilot_review_card_module_default()).trustPilotDescription,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontWeight: "bold",
                            className: (trustpilot_review_card_module_default()).trustPilotCustomerName,
                            children: customerName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "m",
                            fontWeight: "medium",
                            className: (trustpilot_review_card_module_default()).trustPilotDate,
                            children: (0,util_src/* getDayMonthYearFormat */.Al)(date)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var trustpilot_review_card = (ReviewCard);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-reviews/assets/trustpilot-logo.svg
var trustpilot_logo_path, _path2, _path3;
function trustpilot_logo_extends() { trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return trustpilot_logo_extends.apply(this, arguments); }

const SvgTrustpilotLogo = props => /*#__PURE__*/react.createElement("svg", trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), trustpilot_logo_path || (trustpilot_logo_path = /*#__PURE__*/react.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var trustpilot_logo = (SvgTrustpilotLogo);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/trustpilot-reviews/trustpilot-reviews.module.css
var trustpilot_reviews_module = __webpack_require__(5271);
var trustpilot_reviews_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_reviews_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-reviews/trustpilot-reviews.tsx









const carouselName = "trustpilot-carousel";
const navAriaLabels = {
    previous: "Go to previous slide",
    next: "Go to next slide"
};
const ReviewSection = ({ title , reviews , numberOfReviews , starRatingLabel  })=>{
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isDesktop = vw >= 1024;
    const starRating = (0,trustpilot_src/* useTrustpilotScore */.b6)();
    const shouldShowTrustPilotScoreless = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.ShowScorelessTrustpilot */.X.ShowScorelessTrustpilot) === "true";
    const shouldShowTruspilotScoreless = starRating ? shouldShowTrustPilotScoreless || starRating <= 4.2 : shouldShowTrustPilotScoreless;
    const trustpilotUrl = "/customer-reviews";
    const trustpilotSummaryText = shouldShowTruspilotScoreless ? `See our ${(0,util_src/* formatNumber */.uf)(numberOfReviews)} reviews on` : `Rated ${starRatingLabel} | ${(0,util_src/* formatNumber */.uf)(numberOfReviews)} reviews`;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapper, {
        "data-testid": "trustpilotReviews",
        className: {
            container: (trustpilot_reviews_module_default()).root
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (trustpilot_reviews_module_default()).reviewsTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (trustpilot_reviews_module_default()).trustPilotReviewsDesktopWrapper,
                            children: reviews.map((review)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_review_card, {
                                    ...review
                                }, review.title))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: trustpilotUrl,
                            className: (trustpilot_reviews_module_default()).trustPilotLink,
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (trustpilot_reviews_module_default()).trustpilotLinkText,
                                    children: trustpilotSummaryText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_logo, {
                                    className: (trustpilot_reviews_module_default()).logo,
                                    role: "img"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                            customClassNames: {
                                wrapper: (trustpilot_reviews_module_default()).carouselWrapper
                            },
                            name: carouselName,
                            children: reviews.map((review, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(trustpilot_review_card, {
                                        ...review
                                    }, review.title)
                                }, idx))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                            customClassNames: (trustpilot_reviews_module_default()).controlsWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                                    name: carouselName,
                                    customClassNames: (trustpilot_reviews_module_default()).carouselPagination
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                                    name: carouselName,
                                    ariaLabels: navAriaLabels,
                                    customClassNames: {
                                        prevButton: (trustpilot_reviews_module_default()).carouselPrevButton,
                                        nextButton: (trustpilot_reviews_module_default()).carouselNextButton
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var trustpilot_reviews = (ReviewSection);

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/icons/assets/heart.svg
var heart_path;
function heart_extends() { heart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return heart_extends.apply(this, arguments); }

const SvgHeart = props => /*#__PURE__*/react.createElement("svg", heart_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), heart_path || (heart_path = /*#__PURE__*/react.createElement("path", {
  d: "m16.064 10.162 1.607-1.607a6.023 6.023 0 0 1 8.518 0 6.241 6.241 0 0 1 .154 8.667l-9.547 10.252a1 1 0 0 1-1.463 0L5.785 17.222a6.241 6.241 0 0 1 .155-8.667 6.023 6.023 0 0 1 8.518 0l1.606 1.607z"
})));
/* harmony default export */ var heart = (SvgHeart);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/lib/trustpilot-scoreless/trustpilot-scoreless.module.css
var trustpilot_scoreless_module = __webpack_require__(26008);
var trustpilot_scoreless_module_default = /*#__PURE__*/__webpack_require__.n(trustpilot_scoreless_module);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-scoreless/assets/trustpilot-logo.svg
var assets_trustpilot_logo_path, trustpilot_logo_path2, trustpilot_logo_path3;
function assets_trustpilot_logo_extends() { assets_trustpilot_logo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assets_trustpilot_logo_extends.apply(this, arguments); }

const trustpilot_logo_SvgTrustpilotLogo = props => /*#__PURE__*/react.createElement("svg", assets_trustpilot_logo_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1132.8 278.2"
}, props), assets_trustpilot_logo_path || (assets_trustpilot_logo_path = /*#__PURE__*/react.createElement("path", {
  d: "M297.7 98.6h114.7V120h-45.1v120.3h-24.8V120h-44.9V98.6zm109.8 39.1h21.2v19.8h.4c.7-2.8 2-5.5 3.9-8.1 1.9-2.6 4.2-5.1 6.9-7.2 2.7-2.2 5.7-3.9 9-5.3 3.3-1.3 6.7-2 10.1-2 2.6 0 4.5.1 5.5.2s2 .3 3.1.4v21.8c-1.6-.3-3.2-.5-4.9-.7-1.7-.2-3.3-.3-4.9-.3-3.8 0-7.4.8-10.8 2.3-3.4 1.5-6.3 3.8-8.8 6.7-2.5 3-4.5 6.6-6 11s-2.2 9.4-2.2 15.1v48.8h-22.6V137.7zm164 102.6h-22.2V226h-.4c-2.8 5.2-6.9 9.3-12.4 12.4-5.5 3.1-11.1 4.7-16.8 4.7-13.5 0-23.3-3.3-29.3-10s-9-16.8-9-30.3v-65.1H504v62.9c0 9 1.7 15.4 5.2 19.1 3.4 3.7 8.3 5.6 14.5 5.6 4.8 0 8.7-.7 11.9-2.2 3.2-1.5 5.8-3.4 7.7-5.9 2-2.4 3.4-5.4 4.3-8.8.9-3.4 1.3-7.1 1.3-11.1v-59.5h22.6v102.5zm38.5-32.9c.7 6.6 3.2 11.2 7.5 13.9 4.4 2.6 9.6 4 15.7 4 2.1 0 4.5-.2 7.2-.5s5.3-1 7.6-1.9c2.4-.9 4.3-2.3 5.9-4.1 1.5-1.8 2.2-4.1 2.1-7-.1-2.9-1.2-5.3-3.2-7.1-2-1.9-4.5-3.3-7.6-4.5-3.1-1.1-6.6-2.1-10.6-2.9-4-.8-8-1.7-12.1-2.6-4.2-.9-8.3-2.1-12.2-3.4-3.9-1.3-7.4-3.1-10.5-5.4-3.1-2.2-5.6-5.1-7.4-8.6-1.9-3.5-2.8-7.8-2.8-13 0-5.6 1.4-10.2 4.1-14 2.7-3.8 6.2-6.8 10.3-9.1 4.2-2.3 8.8-3.9 13.9-4.9 5.1-.9 10-1.4 14.6-1.4 5.3 0 10.4.6 15.2 1.7 4.8 1.1 9.2 2.9 13.1 5.5 3.9 2.5 7.1 5.8 9.7 9.8 2.6 4 4.2 8.9 4.9 14.6h-23.6c-1.1-5.4-3.5-9.1-7.4-10.9-3.9-1.9-8.4-2.8-13.4-2.8-1.6 0-3.5.1-5.7.4-2.2.3-4.2.8-6.2 1.5-1.9.7-3.5 1.8-4.9 3.2-1.3 1.4-2 3.2-2 5.5 0 2.8 1 5 2.9 6.7 1.9 1.7 4.4 3.1 7.5 4.3 3.1 1.1 6.6 2.1 10.6 2.9 4 .8 8.1 1.7 12.3 2.6 4.1.9 8.1 2.1 12.1 3.4 4 1.3 7.5 3.1 10.6 5.4 3.1 2.3 5.6 5.1 7.5 8.5 1.9 3.4 2.9 7.7 2.9 12.7 0 6.1-1.4 11.2-4.2 15.5-2.8 4.2-6.4 7.7-10.8 10.3-4.4 2.6-9.4 4.6-14.8 5.8-5.4 1.2-10.8 1.8-16.1 1.8-6.5 0-12.5-.7-18-2.2-5.5-1.5-10.3-3.7-14.3-6.6-4-3-7.2-6.7-9.5-11.1-2.3-4.4-3.5-9.7-3.7-15.8H610zm74.6-69.7h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1zm76.1 0h21.4v13.9h.4c3.2-6 7.6-10.2 13.3-12.8 5.7-2.6 11.8-3.9 18.5-3.9 8.1 0 15.1 1.4 21.1 4.3 6 2.8 11 6.7 15 11.7 4 5 6.9 10.8 8.9 17.4 2 6.6 3 13.7 3 21.2 0 6.9-.9 13.6-2.7 20-1.8 6.5-4.5 12.2-8.1 17.2-3.6 5-8.2 8.9-13.8 11.9-5.6 3-12.1 4.5-19.7 4.5-3.3 0-6.6-.3-9.9-.9-3.3-.6-6.5-1.6-9.5-2.9-3-1.3-5.9-3-8.4-5.1-2.6-2.1-4.7-4.5-6.5-7.2h-.4v51.2h-22.6V137.7zm79 51.4c0-4.6-.6-9.1-1.8-13.5-1.2-4.4-3-8.2-5.4-11.6-2.4-3.4-5.4-6.1-8.9-8.1-3.6-2-7.7-3.1-12.3-3.1-9.5 0-16.7 3.3-21.5 9.9-4.8 6.6-7.2 15.4-7.2 26.4 0 5.2.6 10 1.9 14.4 1.3 4.4 3.1 8.2 5.7 11.4 2.5 3.2 5.5 5.7 9 7.5 3.5 1.9 7.6 2.8 12.2 2.8 5.2 0 9.5-1.1 13.1-3.2 3.6-2.1 6.5-4.9 8.8-8.2 2.3-3.4 4-7.2 5-11.5.9-4.3 1.4-8.7 1.4-13.2zm39.9-90.5h22.6V120h-22.6V98.6zm0 39.1h22.6v102.6h-22.6V137.7zm42.8-39.1H945v141.7h-22.6V98.6zm91.9 144.5c-8.2 0-15.5-1.4-21.9-4.1-6.4-2.7-11.8-6.5-16.3-11.2-4.4-4.8-7.8-10.5-10.1-17.1-2.3-6.6-3.5-13.9-3.5-21.8 0-7.8 1.2-15 3.5-21.6 2.3-6.6 5.7-12.3 10.1-17.1 4.4-4.8 9.9-8.5 16.3-11.2 6.4-2.7 13.7-4.1 21.9-4.1s15.5 1.4 21.9 4.1c6.4 2.7 11.8 6.5 16.3 11.2 4.4 4.8 7.8 10.5 10.1 17.1 2.3 6.6 3.5 13.8 3.5 21.6 0 7.9-1.2 15.2-3.5 21.8-2.3 6.6-5.7 12.3-10.1 17.1-4.4 4.8-9.9 8.5-16.3 11.2-6.4 2.7-13.7 4.1-21.9 4.1zm0-17.9c5 0 9.4-1.1 13.1-3.2 3.7-2.1 6.7-4.9 9.1-8.3 2.4-3.4 4.1-7.3 5.3-11.6 1.1-4.3 1.7-8.7 1.7-13.2 0-4.4-.6-8.7-1.7-13.1s-2.9-8.2-5.3-11.6c-2.4-3.4-5.4-6.1-9.1-8.2-3.7-2.1-8.1-3.2-13.1-3.2s-9.4 1.1-13.1 3.2c-3.7 2.1-6.7 4.9-9.1 8.2-2.4 3.4-4.1 7.2-5.3 11.6-1.1 4.4-1.7 8.7-1.7 13.1 0 4.5.6 8.9 1.7 13.2 1.1 4.3 2.9 8.2 5.3 11.6 2.4 3.4 5.4 6.2 9.1 8.3 3.7 2.2 8.1 3.2 13.1 3.2zm58.4-87.5h17.1v-30.8h22.6v30.8h20.4v16.9h-20.4v54.8c0 2.4.1 4.4.3 6.2.2 1.7.7 3.2 1.4 4.4.7 1.2 1.8 2.1 3.3 2.7 1.5.6 3.4.9 6 .9 1.6 0 3.2 0 4.8-.1 1.6-.1 3.2-.3 4.8-.7v17.5c-2.5.3-5 .5-7.3.8-2.4.3-4.8.4-7.3.4-6 0-10.8-.6-14.4-1.7-3.6-1.1-6.5-2.8-8.5-5-2.1-2.2-3.4-4.9-4.2-8.2-.7-3.3-1.2-7.1-1.3-11.3v-60.5h-17.1v-17.1z",
  fill: "#191919"
})), trustpilot_logo_path2 || (trustpilot_logo_path2 = /*#__PURE__*/react.createElement("path", {
  fill: "#00b67a",
  d: "M271.3 98.6H167.7L135.7 0l-32.1 98.6L0 98.5l83.9 61L51.8 258l83.9-60.9 83.8 60.9-32-98.5 83.8-60.9z"
})), trustpilot_logo_path3 || (trustpilot_logo_path3 = /*#__PURE__*/react.createElement("path", {
  fill: "#005128",
  d: "m194.7 181.8-7.2-22.3-51.8 37.6z"
})));
/* harmony default export */ var assets_trustpilot_logo = (trustpilot_logo_SvgTrustpilotLogo);
;// CONCATENATED MODULE: ../../../libs/shared/ui/src/lib/trustpilot-scoreless/trustpilot-scoreless.component.tsx






/**
 * TrustpilotScoreless component
 * @component
 * @param {object} props
 * @param {boolean} props.shouldShowFirstLine - Whether to show the first line of text or not
 * @param {number?} props.numberOfReviews - The number of reviews. You can get this using the `useTrustpilotReviewCount` hook if you do not have it already
 *
 * @example <TrustpilotScoreless numberOfReviews={trustpilotReviewCount} />
 * @example <TrustpilotScoreless numberOfReviews={trustpilotReviewCount} shouldShowFirstLine={true} />
 *
 * @returns {JSX.Element}
 */ const TrustpilotScoreless = ({ shouldShowFirstLine =true , numberOfReviews  })=>{
    const formattedReviews = numberOfReviews !== undefined ? (0,util_src/* formatNumber */.uf)(numberOfReviews) : "";
    const secondLineContent = formattedReviews ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "See our ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (trustpilot_scoreless_module_default()).boldText,
                children: formattedReviews
            }),
            " ",
            "reviews on"
        ]
    }) : "See our reviews on";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (trustpilot_scoreless_module_default()).container,
        "data-testid": "trust-pilot-scoreless",
        href: "/customer-reviews",
        target: "_blank",
        children: [
            shouldShowFirstLine && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (trustpilot_scoreless_module_default()).firstLine,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                    element: "p",
                    fontWeight: "book",
                    fontSizeFixed: "s",
                    lineHeight: "display",
                    children: "Don't just take our word for it."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                element: "p",
                fontWeight: "book",
                fontSizeFixed: "s",
                lineHeight: "display",
                className: classnames_default()((trustpilot_scoreless_module_default()).secondLine, !shouldShowFirstLine && (trustpilot_scoreless_module_default()).singleLine),
                children: [
                    secondLineContent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(assets_trustpilot_logo, {
                        className: (trustpilot_scoreless_module_default()).logo,
                        "aria-label": "Trustpilot"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/shared/ui/src/index.ts






















/***/ }),

/***/ 37479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "si": function() { return /* reexport */ LinkToProductDetail; },
  "kc": function() { return /* reexport */ addIntersectionObserver; },
  "iP": function() { return /* reexport */ checkoutTimes; },
  "DY": function() { return /* reexport */ currencyValueFormatter; },
  "P1": function() { return /* reexport */ dashify; },
  "xv": function() { return /* reexport */ findVehiclePath; },
  "uf": function() { return /* reexport */ formatNumber; },
  "cF": function() { return /* reexport */ getAnalyticIDs; },
  "qU": function() { return /* reexport */ getCinchCareEligibilityPeriod; },
  "Al": function() { return /* reexport */ getDayMonthYearFormat; },
  "gY": function() { return /* reexport */ getEMaCServiceWarrantyEligibilityPeriod; },
  "nk": function() { return /* reexport */ getLastCheckoutStage; },
  "Ao": function() { return /* reexport */ getMake; },
  "PD": function() { return /* reexport */ getModel; },
  "LP": function() { return /* reexport */ getToken; },
  "mH": function() { return /* reexport */ getVehicleTags; },
  "uR": function() { return /* reexport */ interpolateI18n; },
  "jU": function() { return /* reexport */ isBrowser; },
  "tq": function() { return /* reexport */ isMobile; },
  "yF": function() { return /* reexport */ isSSR; },
  "io": function() { return /* reexport */ personalDetailsPagePath; },
  "Dj": function() { return /* reexport */ registerRumContext; },
  "vn": function() { return /* reexport */ removeIntersectionObserver; },
  "jP": function() { return /* reexport */ returnToCheckoutStage; },
  "Sj": function() { return /* reexport */ useViewport; }
});

// UNUSED EXPORTS: CheckoutStage, PaymentDecision, calculateVehiclePriceWithAdminFee, cardDetailsPagePath, cinchCarePagePath, cinchCoverPagePath, createAxiosResponse, deliveryPagePath, extrasPagePath, financePagePath, formatEngineSizeInLitres, formatFuelType, formatMileage, formatPrice, getDayDateMonthFormat, getDayDateMonthYearFormat, getDeliveryTimeInAmPmFormat, getPaymentDecisionFromLocalStorage, getUTCFromDateAndTime, getUTCWithOffSet, hasChildren, partExchangePagePath, paymentDecisionInStorage, penceToPounds, pluralize, productDetailUrl, roundedValueWithoutPence, sentenceCase, sortCodeFormatter, sortCodeParser, undashifyAndCapitalise, waitForIconsToLoad

// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/is-mobile.ts

const isTouchAvailable = ()=>{
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch  {
        return false;
    }
};
function isMobile() {
    return window && window.matchMedia && !window.matchMedia(index_esm/* designTokens.customMedia.s */.Wp.customMedia.s).matches && isTouchAvailable();
}

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/is-ssr.ts
const isSSR = ()=>"object" === "undefined";
/* harmony default export */ var is_ssr = ((/* unused pure expression or super */ null && (isSSR)));

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/get-token.ts
const tokenIsInDate = (token)=>token.expires_at > Date.now() / 1000;
const isToken = (maybeToken)=>Object.prototype.hasOwnProperty.call(maybeToken, "expires_at");
const getToken = ({ authKey , legacyAuthKey  })=>{
    if (false) {}
    const maybeLegacyAuthToken = JSON.parse(localStorage.getItem(authKey) ?? "{}");
    const maybeAuthToken = JSON.parse(localStorage.getItem(legacyAuthKey) ?? "{}");
    if (isToken(maybeAuthToken) && tokenIsInDate(maybeAuthToken)) {
        return maybeAuthToken;
    }
    if (isToken(maybeLegacyAuthToken) && tokenIsInDate(maybeLegacyAuthToken)) {
        return maybeLegacyAuthToken;
    }
    return null;
};

// EXTERNAL MODULE: ../../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(87530);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../../node_modules/dayjs/plugin/advancedFormat.js
var advancedFormat = __webpack_require__(57664);
var advancedFormat_default = /*#__PURE__*/__webpack_require__.n(advancedFormat);
// EXTERNAL MODULE: ../../../node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(55466);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
// EXTERNAL MODULE: ../../../node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(80079);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ../../../node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(79014);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/format-date.ts





dayjs_min_default().extend((customParseFormat_default()));
dayjs_min_default().extend((advancedFormat_default()));
dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((timezone_default()));
const DAY_DATE_MONTH = "dddd Do MMMM";
const DAY_DATE_MONTH_YEAR = "dddd Do MMMM YYYY";
const DAY_MONTH_YEAR = "D MMMM YYYY";
const EUROPE_LONDON_TIMEZONE = "Europe/London";
const HOUR_AM_PM = "ha";
const getDayDateMonthFormat = (timestamp)=>{
    if (!timestamp) return "";
    const date = dayjs(timestamp);
    return date.format(DAY_DATE_MONTH);
};
const getDayDateMonthYearFormat = (timestamp)=>{
    if (!timestamp) return "";
    const date = dayjs(timestamp);
    return date.format(DAY_DATE_MONTH_YEAR);
};
const getUTCFromDateAndTime = (dateString, hours)=>{
    const dateAndTime = `${dateString} ${hours}:00`;
    const date = dayjs.tz(dateAndTime, EUROPE_LONDON_TIMEZONE);
    return date.utc().format();
};
const getUTCWithOffSet = (dateString, hours)=>{
    const dateAndTime = `${dateString}T${hours}:00:00`;
    const date = dayjs(dateAndTime).tz(EUROPE_LONDON_TIMEZONE);
    return date.format();
};
const getDayMonthYearFormat = (timestamp)=>{
    if (!timestamp) return "";
    const date = dayjs_min_default()(timestamp);
    return date.format(DAY_MONTH_YEAR);
};
const getDeliveryTimeInAmPmFormat = (timestamp)=>{
    if (!timestamp) return "";
    const date = dayjs(timestamp);
    return date.format(HOUR_AM_PM);
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/format-number.ts
const formatNumber = (val)=>new Intl.NumberFormat().format(val);

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/interpolate-i18n.ts

const matchTag = (val)=>{
    const regex = new RegExp(`\\{([^}]+)\\}(.*?)\\{/[^}]+\\}`, "g");
    const matches = [];
    do {
        const match = regex.exec(val);
        if (match) {
            matches.push({
                fullMatch: match[0],
                tag: match[1],
                innerText: match[2],
                index: match.index
            });
        }
    }while (regex.lastIndex > 0);
    return matches;
};
function interpolateVars(val, vars) {
    return vars ? Object.keys(vars).reduce((acc, v)=>acc.replace(new RegExp(`\\{${v}\\}`, "g"), vars[v].toString()), val) : val;
}
const interpolateTags = (val, tags)=>{
    if (tags) {
        const matches = matchTag(val);
        const interpolated = [];
        let lastMatchEndIndex = 0;
        for (const match of matches){
            // eslint-disable-next-line unicorn/prefer-string-slice
            interpolated.push(val.substring(lastMatchEndIndex, match.index));
            const handler = tags[match.tag];
            interpolated.push(handler ? handler(match.innerText, match.index) : match.fullMatch);
            lastMatchEndIndex = match.index + match.fullMatch.length;
        }
        interpolated.push(val.slice(Math.max(0, lastMatchEndIndex)));
        return interpolated;
    }
    return [
        val
    ];
};
/**
 We now have several cases across checkout where using raw i18n values isn't enough. The two common cases are:

 - We want to interpolate a single value, e.g. "You have {N} cars remaining"
 - We want to apply additional styling to some text, e.g. "Your {emphasized}conditional offer{/emphasized} is..."

 First case interpolation is easy if we are expecting a placeholder in the form {somename}, as we just replace any
 pattern of {.+} with a particular value.
 The second case is much harder as we don't know what formatting to apply for a given set of 'tags'. Additionally, it is
 not possible to interpolate JSX elements directly into a string. React provides a mechanism for doing this by allowing
 us to return a list of elements that are acceptable for React to render (string, null, undefined or a JSX element)

 Therefore, this function takes:
 - an input string,
 - an object of placeholders -> values for direct interpolation
 - an object of placeholders -> a handler function for jsx tag interpolation.

 A single placeholder is defined in the string in the form {NAME} and a tag placeholder is defined as {NAME}text{/NAME}

 The function will return an array of interpolated values that can be dropped directly into a React component.
 If the tags variable was undefined, or no placeholders were replaced, then splitting the string is unnecessary and the
 return value will be an array containing a single string (the input string unchanged if no placeholders were replaced).
 Placeholders not found in either object will be ignored and returned unchanged.

 If you are certain that no JSX elements are included in the array (either because tags was undefined or your handlers
 only return strings), you can return the result to a single string by using interpolateI18n(...).join('')

 * @param val The input string, usually taken directly from an i18n value
 * @param vars An object of the form {placeholder:value} e.g. {name: 'John', age: 25}
 * @param tags An object of the form {placeholder:(text:string)=>string}. The handler will be passed the text between
 *             the tags. E.g. {bold: (text:string) => <span className={styles.bold}>{text}</span>
 */ const interpolateI18n = (val, vars, tags)=>interpolateTags(interpolateVars(val, vars), tags);

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/format-vehicle-data.ts
const ADMIN_FEE = 99;
const sentenceCase = (input)=>input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
const formatEngineSizeInLitres = (engineCapacityInCc)=>engineCapacityInCc ? `${(engineCapacityInCc / 1000).toFixed(1)}L` : "";
const formatFuelType = (input)=>{
    if (!input) {
        return "-";
    }
    return input.toUpperCase() === "LPG" ? input.toUpperCase() : sentenceCase(input);
};
const formatMileage = (mileage)=>Intl.NumberFormat().format(mileage);
const calculateVehiclePriceWithAdminFee = (price)=>price + ADMIN_FEE;

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/vehicle-utils.ts

const vehicle_utils_sentenceCase = (input)=>input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
const getVehicleTags = (vehicle)=>[
        {
            label: "Body Type",
            value: vehicle.bodyType
        },
        {
            label: "Colour",
            value: vehicle_utils_sentenceCase(vehicle.colour)
        },
        {
            label: "Engine Size",
            value: formatEngineSizeInLitres(vehicle.engineSize || vehicle.engineCapacityCc)
        },
        {
            label: "Fuel Type",
            value: formatFuelType(vehicle.fuelType)
        },
        {
            label: "Mileage",
            value: `${Intl.NumberFormat().format(vehicle.mileage)} miles`
        },
        {
            label: "Transmission Type",
            value: vehicle_utils_sentenceCase(vehicle.transmissionType)
        },
        {
            label: "Vehicle Year",
            value: `${vehicle.vehicleYear}`
        },
        {
            label: "Doors",
            value: `${vehicle.doors} Doors`
        },
        {
            label: "Seats",
            value: `${vehicle.seats} Seats`
        }
    ].filter(({ value  })=>value !== "-").filter(({ value  })=>!!value);

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/is-browser.ts
const isBrowser = "object" !== "undefined";

// EXTERNAL MODULE: ../../../node_modules/react-is/index.js
var react_is = __webpack_require__(72594);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/has-children.ts

const hasChildren = (child)=>{
    if (!child) return false;
    if (ReactIs.isFragment(child)) {
        if (!child.props.children) return false;
        if (Array.isArray(child.props.children)) {
            return child.props.children.some((el)=>!!el);
        }
    }
    return true;
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/currency-value-formatter.ts
const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const currencyValueFormatter = (value, isPenceValue)=>{
    let val;
    if (Number.isNaN(value)) {
        val = 0;
    } else if (isPenceValue) {
        val = value / 100;
    } else {
        val = value;
    }
    return formatter.format(val).replace(".00", "");
};
const penceToPounds = (value)=>currencyValueFormatter(value, true);
const roundedValueWithoutPence = (value)=>Math.round(value / 100) * 100;
/* harmony default export */ var currency_value_formatter = ((/* unused pure expression or super */ null && (currencyValueFormatter)));

// EXTERNAL MODULE: ../../../node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(47946);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/intersection-observer.ts

class Intersection {
    static listeners = new Map();
}
const hasIntersectionObserver = (element)=>Intersection.listeners.has(element);
const removeIntersectionObserver = (element)=>{
    Intersection.observer.unobserve(element);
    Intersection.listeners.delete(element);
};
const addIntersectionObserver = (callback, element)=>{
    if (Intersection.listeners.size === 0) {
        Intersection.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const observer = Intersection.listeners.get(target);
                if (observer) {
                    observer.callback(entry.isIntersecting || !!entry.intersectionRatio, observer.isInitialLoad);
                    observer.isInitialLoad = false;
                }
            });
        });
    }
    if (!hasIntersectionObserver(element)) {
        Intersection.listeners.set(element, {
            callback,
            isInitialLoad: true
        });
        Intersection.observer.observe(element);
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/format-string.ts
const dashify = (input)=>input ? input.toLocaleLowerCase().split(" ").join("-") : "";
const undashifyAndCapitalise = (input)=>input ? input.replace(/-/g, " ").replace(/^./, input[0].toUpperCase()) : "";

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/entries/main.js + 20 modules
var main = __webpack_require__(39806);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var entries_main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/register-datadog-contexts.ts


const parseBuildId = (buildId, fallback = {})=>{
    if (buildId != "development") {
        const [appName, commitSha, githubRunId, stageName] = buildId.split("::");
        return {
            appName,
            commitSha,
            githubRunId,
            stageName
        };
    }
    return {
        appName: fallback.appName ?? "appName",
        commitSha: fallback.commitSha ?? "commitSha",
        githubRunId: fallback.githubRunId ?? "githubRunId",
        stageName: fallback.stageName ?? "development"
    };
};
const registerRumContext = (buildId, fallback = {})=>{
    const { commitSha , githubRunId , stageName  } = parseBuildId(buildId, fallback);
    entries_main/* datadogRum.setGlobalContextProperty */.v.setGlobalContextProperty("BUILD_ID", buildId);
    entries_main/* datadogRum.setGlobalContextProperty */.v.setGlobalContextProperty("STAGE_NAME", stageName);
    entries_main/* datadogRum.setGlobalContextProperty */.v.setGlobalContextProperty("GITHUB_WORKFLOW", `https://github.com/cinch-labs/cinch-nx/actions/runs/${githubRunId}`);
    entries_main/* datadogRum.setGlobalContextProperty */.v.setGlobalContextProperty("COMMIT_DETAILS", `https://github.com/cinch-labs/cinch-nx/commit/${commitSha}`);
    main/* datadogLogs.setGlobalContextProperty */.fy.setGlobalContextProperty("BUILD_ID", buildId);
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/car-data/car-data.ts
const data = {
    ABARTH: {
        displayName: "Abarth",
        models: {
            "500": "500",
            "595": "595",
            "695": "695",
            "124 SPIDER": "124 Spider",
            "GRANDE PUNTO": "Grande Punto",
            "PUNTO EVO": "Punto Evo"
        }
    },
    AC: {
        displayName: "AC",
        models: {
            COBRA: "Cobra"
        }
    },
    "ALFA ROMEO": {
        displayName: "Alfa Romeo",
        models: {
            "145": "145",
            "146": "146",
            "147": "147",
            "155": "155",
            "156": "156",
            "159": "159",
            "164": "164",
            "166": "166",
            "4C": "4C",
            "8C": "8C",
            BRERA: "Brera",
            GIULIA: "Giulia",
            GIULIETTA: "Giulietta",
            GT: "GT",
            GTV: "GTV",
            MITO: "Mito",
            SPIDER: "Spider",
            STELVIO: "Stelvio"
        }
    },
    ARIEL: {
        displayName: "Ariel",
        models: {
            ATOM: "Atom",
            NOMAD: "Nomad"
        }
    },
    "ASTON MARTIN": {
        displayName: "Aston Martin",
        models: {
            CYGNET: "Cygnet",
            DB11: "DB11",
            DB7: "DB7",
            DB9: "DB9",
            DBS: "DBs",
            RAPIDE: "Rapide",
            VANQUISH: "Vanquish",
            VANTAGE: "Vantage",
            VIRAGE: "Virage"
        }
    },
    AUDI: {
        displayName: "Audi",
        models: {
            "80": "80",
            A1: "A1",
            A2: "A2",
            A3: "A3",
            A4: "A4",
            "A4 ALLROAD": "A4 Allroad",
            A5: "A5",
            A6: "A6",
            "A6 ALLROAD": "A6 Allroad",
            A7: "A7",
            A8: "A8",
            ALLROAD: "Allroad",
            CABRIOLET: "Cabriolet",
            CONVERTIBLE: "Convertible",
            COUPE: "Coupe",
            "E-TRON": "e-tron",
            Q2: "Q2",
            Q3: "Q3",
            Q5: "Q5",
            Q7: "Q7",
            Q8: "Q8",
            R8: "R8",
            "RS Q3": "RS Q3",
            RS3: "RS3",
            RS4: "RS4",
            RS5: "RS5",
            RS6: "RS6",
            RS7: "RS7",
            S1: "S1",
            S3: "S3",
            S4: "S4",
            S5: "S5",
            S6: "S6",
            S7: "S7",
            S8: "S8",
            SQ5: "SQ5",
            SQ7: "SQ7",
            TT: "TT",
            "TT RS": "TT RS",
            TTS: "TTS"
        }
    },
    AUSTIN: {
        displayName: "Austin",
        models: {
            HEALEY: "Healey"
        }
    },
    BENTLEY: {
        displayName: "Bentley",
        models: {
            ARNAGE: "Arnage",
            AZURE: "Azure",
            BENTAYGA: "Bentayga",
            BROOKLANDS: "Brooklands",
            CONTINENTAL: "Continental",
            "FLYING SPUR": "Flying Spur",
            MULSANNE: "Mulsanne",
            "TURBO R": "Turbo R"
        }
    },
    BMW: {
        displayName: "BMW",
        models: {
            "1 SERIES": "1 Series",
            "2 SERIES": "2 Series",
            "3 SERIES": "3 Series",
            "4 SERIES": "4 Series",
            "5 SERIES": "5 Series",
            "6 SERIES": "6 Series",
            "7 SERIES": "7 Series",
            "8 SERIES": "8 Series",
            ALPINA: "Alpina",
            I3: "I3",
            I8: "I8",
            M2: "M2",
            M3: "M3",
            M4: "M4",
            M5: "M5",
            M6: "M6",
            X1: "X1",
            X2: "X2",
            X3: "X3",
            X4: "X4",
            X5: "X5",
            X6: "X6",
            Z1: "Z1",
            Z3: "Z3",
            Z4: "Z4",
            Z8: "Z8"
        }
    },
    BUGATTI: {
        displayName: "Bugatti",
        models: {
            VEYRON: "Veyron"
        }
    },
    CATERHAM: {
        displayName: "Caterham",
        models: {
            SEVEN: "Seven"
        }
    },
    CHEVROLET: {
        displayName: "Chevrolet",
        models: {
            AVEO: "Aveo",
            BLAZER: "Blazer",
            C6: "C6",
            CAMARO: "Camaro",
            CAPTIVA: "Captiva",
            CORVETTE: "Corvette",
            CRUZE: "Cruze",
            EPICA: "Epica",
            KALOS: "Kalos",
            LACETTI: "Lacetti",
            MATIZ: "Matiz",
            ORLANDO: "Orlando",
            SPARK: "Spark",
            STINGRAY: "Stingray",
            TACUMA: "Tacuma",
            TRAX: "Trax",
            VOLT: "Volt"
        }
    },
    CHRYSLER: {
        displayName: "Chrysler",
        models: {
            "300C": "300C",
            CROSSFIRE: "Crossfire",
            DELTA: "Delta",
            "GRAND VOYAGER": "Grand Voyager",
            NEON: "Neon",
            "PT CRUISER": "PT Cruiser",
            SEBRING: "Sebring",
            VOYAGER: "Voyager",
            YPSILON: "Ypsilon"
        }
    },
    CITROEN: {
        displayName: "Citroen",
        models: {
            "BERLINGO FIRST": "Berlingo First",
            "BERLINGO MULTISPACE": "Berlingo Multispace",
            "C ZERO": "C ZERO",
            C1: "C1",
            C2: "C2",
            C3: "C3",
            "C3 AIRCROSS": "C3 Aircross",
            "C3 PICASSO": "C3 Picasso",
            "C3 PLURIEL": "C3 Pluriel",
            C4: "C4",
            "C4 CACTUS": "C4 Cactus",
            "C4 PICASSO": "C4 Picasso",
            C5: "C5",
            C6: "C6",
            C8: "C8",
            "C-CROSSER": "C-Crosser",
            "DISPATCH COMBI": "Dispatch Combi",
            DS3: "DS3",
            DS4: "DS4",
            DS5: "DS5",
            "GRAND C4 PICASSO": "Grand C4 Picasso",
            "NEMO MULTISPACE": "Nemo Multispace",
            SAXO: "Saxo",
            SYNERGIE: "Synergie",
            XANTIA: "Xantia",
            XSARA: "Xsara",
            "XSARA PICASSO": "Xsara Picasso"
        }
    },
    DACIA: {
        displayName: "Dacia",
        models: {
            DUSTER: "Duster",
            LOGAN: "Logan",
            "LOGAN STEPWAY": "Logan Stepway",
            SANDERO: "Sandero",
            "SANDERO STEPWAY": "Sandero Stepway"
        }
    },
    DAEWOO: {
        displayName: "Daewoo",
        models: {
            KALOS: "Kalos",
            KORANDO: "Korando",
            LACETTI: "Lacetti",
            LANOS: "Lanos",
            LEGANZA: "Leganza",
            MATIZ: "Matiz",
            MUSSO: "Musso",
            NUBIRA: "Nubira",
            TACUMA: "Tacuma"
        }
    },
    DAIHATSU: {
        displayName: "Daihatsu",
        models: {
            CHARADE: "Charade",
            COPEN: "Copen",
            CUORE: "Cuore",
            FOURTRAK: "Fourtrak",
            "GRAND MOVE": "Grand Move",
            MATERIA: "Materia",
            MOVE: "Move",
            SIRION: "Sirion",
            SPORTRAK: "Sportrak",
            TERIOS: "Terios",
            YRV: "Yrv"
        }
    },
    DODGE: {
        displayName: "Dodge",
        models: {
            AVENGER: "Avenger",
            CALIBER: "Caliber",
            CHALLENGER: "Challenger",
            JOURNEY: "Journey",
            NITRO: "Nitro"
        }
    },
    DS: {
        displayName: "DS",
        models: {
            "DS 3": "DS 3",
            "DS 4": "DS 4",
            "DS 5": "DS 5",
            "DS 7": "DS 7"
        }
    },
    FERRARI: {
        displayName: "Ferrari",
        models: {
            "308": "308",
            "328": "328",
            "348": "348",
            "365": "365",
            "430": "430",
            "456": "456",
            "458": "458",
            "488": "488",
            "512": "512",
            "550": "550",
            "599": "599",
            "612": "612",
            "360M": "360M",
            "456M": "456M",
            "488 GTB": "488 GTB",
            "575M": "575M",
            "812 SUPERFAST": "812 Superfast",
            CALIFORNIA: "California",
            DINO: "Dino",
            ENZO: "Enzo",
            "F12 BERLINETTA": "F12 Berlinetta",
            F355: "F355",
            F430: "F430",
            FF: "FF",
            "GTC4 LUSSO": "GTC4 Lusso",
            LAFERRARI: "Laferrari",
            PORTOFINO: "Portofino",
            TESTAROSSA: "Testarossa"
        }
    },
    FIAT: {
        displayName: "Fiat",
        models: {
            "500": "500",
            "124 SPIDER": "124 Spider",
            "500L": "500L",
            "500L MPW": "500L MPW",
            "500X": "500X",
            BARCHETTA: "Barchetta",
            BRAVA: "Brava",
            BRAVO: "Bravo",
            CINQUECENTO: "Cinquecento",
            COUPE: "Coupe",
            CROMA: "Croma",
            DOBLO: "Doblo",
            FIORINO: "Fiorino",
            "GRANDE PUNTO": "Grande Punto",
            IDEA: "Idea",
            MAREA: "Marea",
            MULTIPLA: "Multipla",
            PANDA: "Panda",
            PUNTO: "Punto",
            "PUNTO EVO": "Punto Evo",
            QUBO: "Qubo",
            SCUDO: "Scudo",
            SEDICI: "Sedici",
            SEICENTO: "Seicento",
            STILO: "Stilo",
            TIPO: "Tipo",
            ULYSSE: "Ulysse"
        }
    },
    FORD: {
        displayName: "Ford",
        models: {
            "B-MAX": "B-MAX",
            CAPRI: "Capri",
            "C-MAX": "C-MAX",
            COUGAR: "Cougar",
            ECOSPORT: "Ecosport",
            EDGE: "Edge",
            ESCORT: "Escort",
            EXPLORER: "Explorer",
            F150: "F150",
            FIESTA: "Fiesta",
            FOCUS: "Focus",
            FUSION: "Fusion",
            GALAXY: "Galaxy",
            "GRAND C-MAX": "Grand C-MAX",
            "GRAND TOURNEO CONNECT": "Grand Tourneo Connect",
            KA: "KA",
            "KA+": "KA+",
            KUGA: "Kuga",
            MAVERICK: "Maverick",
            MONDEO: "Mondeo",
            MUSTANG: "Mustang",
            PROBE: "Probe",
            PUMA: "Puma",
            RANGER: "Ranger",
            SCORPIO: "Scorpio",
            SIERRA: "Sierra",
            "S-MAX": "S-MAX",
            "S-MAX VIGNALE": "S-MAX Vignale",
            "FIESTA VIGNALE": "Fiesta Vignale",
            "FOCUS VIGNALE": "Focus Vignale",
            "MONDEO VIGNALE": "Mondeo Vignale",
            "KUGA VIGNALE": "Kuga Vignale",
            STREETKA: "Streetka",
            "TOURNEO CONNECT": "Tourneo Connect",
            "TRANSIT COURIER": "Transit Courier"
        }
    },
    "GREAT WALL": {
        displayName: "Great Wall",
        models: {
            STEED: "Steed"
        }
    },
    HONDA: {
        displayName: "Honda",
        models: {
            ACCORD: "Accord",
            AERODECK: "Aerodeck",
            CIVIC: "Civic",
            "CR-V": "CR-V",
            "CR-X": "CR-X",
            "CR-Z": "CR-Z",
            "FR-V": "FR-V",
            "HR-V": "HR-V",
            INSIGHT: "Insight",
            INTEGRA: "Integra",
            JAZZ: "Jazz",
            LEGEND: "Legend",
            LOGO: "Logo",
            NSX: "Nsx",
            PRELUDE: "Prelude",
            S2000: "S2000",
            SHUTTLE: "Shuttle",
            STEPWAGON: "Stepwagon",
            STREAM: "Stream"
        }
    },
    HUMMER: {
        displayName: "Hummer",
        models: {
            H2: "H2",
            H3: "H3"
        }
    },
    HYUNDAI: {
        displayName: "Hyundai",
        models: {
            ACCENT: "Accent",
            AMICA: "Amica",
            ATOZ: "Atoz",
            COUPE: "Coupe",
            ELANTRA: "Elantra",
            GENESIS: "Genesis",
            GETZ: "Getz",
            GRANDEUR: "Grandeur",
            I10: "I10",
            I20: "I20",
            I30: "I30",
            I40: "I40",
            I800: "I800",
            IONIQ: "IONIQ",
            IX20: "IX20",
            IX35: "IX35",
            KONA: "Kona",
            LANTRA: "Lantra",
            MATRIX: "Matrix",
            "SANTA FE": "Santa Fe",
            SONATA: "Sonata",
            TERRACAN: "Terracan",
            TRAJET: "Trajet",
            TUCSON: "Tucson",
            VELOSTER: "Veloster",
            XG30: "XG30"
        }
    },
    INFINITI: {
        displayName: "Infiniti",
        models: {
            EX: "EX",
            FX: "FX",
            G37: "G37",
            M: "M",
            Q30: "Q30",
            Q50: "Q50",
            Q60: "Q60",
            Q70: "Q70",
            QX30: "QX30",
            QX50: "QX50",
            QX70: "QX70"
        }
    },
    ISUZU: {
        displayName: "Isuzu",
        models: {
            TROOPER: "Trooper"
        }
    },
    JAGUAR: {
        displayName: "Jaguar",
        models: {
            "E-PACE": "E-PACE",
            "E-TYPE": "E-TYPE",
            "F-PACE": "F-PACE",
            "F-TYPE": "F-TYPE",
            "I-PACE": "I-PACE",
            SOVEREIGN: "Sovereign",
            "S-TYPE": "S-TYPE",
            "V8 XJ SERIES": "V8 XJ Series",
            XE: "XE",
            XF: "XF",
            XJ: "XJ",
            "XJ SERIES": "XJ Series",
            XJ12: "XJ12",
            XJ6: "XJ6",
            XJR: "XJR",
            XJS: "XJS",
            XK: "XK",
            XK8: "XK8",
            XKR: "XKR",
            "X-TYPE": "X-TYPE"
        }
    },
    JEEP: {
        displayName: "Jeep",
        models: {
            CHEROKEE: "Cherokee",
            COMMANDER: "Commander",
            COMPASS: "Compass",
            "GRAND CHEROKEE": "Grand Cherokee",
            PATRIOT: "Patriot",
            RENEGADE: "Renegade",
            WRANGLER: "Wrangler"
        }
    },
    KIA: {
        displayName: "KIA",
        models: {
            CARENS: "Carens",
            CEED: "Ceed",
            CERATO: "Cerato",
            CLARUS: "Clarus",
            MAGENTIS: "Magentis",
            MENTOR: "Mentor",
            "MENTOR II": "Mentor II",
            NIRO: "Niro",
            OPTIMA: "Optima",
            PICANTO: "Picanto",
            "PRO CEED": "ProCeed",
            RIO: "Rio",
            SEDONA: "Sedona",
            SHUMA: "Shuma",
            "SHUMA II": "Shuma II",
            SORENTO: "Sorento",
            SOUL: "Soul",
            SPORTAGE: "Sportage",
            STINGER: "Stinger",
            STONIC: "Stonic",
            VENGA: "Venga"
        }
    },
    LAMBORGHINI: {
        displayName: "Lamborghini",
        models: {
            AVENTADOR: "Aventador",
            COUNTACH: "Countach",
            DIABLO: "Diablo",
            GALLARDO: "Gallardo",
            HURACAN: "Hurac\xe1n",
            MURCIELAGO: "Murcielago",
            URUS: "Urus"
        }
    },
    LANCIA: {
        displayName: "Lancia",
        models: {
            DELTA: "Delta"
        }
    },
    "LAND ROVER": {
        displayName: "Land Rover",
        models: {
            DEFENDER: "Defender",
            DISCOVERY: "Discovery",
            "DISCOVERY SPORT": "Discovery Sport",
            FREELANDER: "Freelander",
            "RANGE ROVER": "Range Rover",
            "RANGE ROVER EVOQUE": "Range Rover Evoque",
            "RANGE ROVER SPORT": "Range Rover Sport",
            "RANGE ROVER VELAR": "Range Rover Velar"
        }
    },
    LEXUS: {
        displayName: "Lexus",
        models: {
            CT: "CT",
            GS: "GS",
            IS: "IS",
            LC: "LC",
            LS: "LS",
            NX: "NX",
            RC: "RC",
            RX: "RX",
            SC: "SC"
        }
    },
    LOTUS: {
        displayName: "Lotus",
        models: {
            "2-ELEVEN": "2-Eleven",
            ELISE: "Elise",
            ESPRIT: "Esprit",
            EUROPA: "Europa",
            EVORA: "Evora",
            EXIGE: "Exige"
        }
    },
    MASERATI: {
        displayName: "Maserati",
        models: {
            "3200": "3200",
            "4200": "4200",
            GHIBLI: "Ghibli",
            GRANCABRIO: "Grancabrio",
            GRANSPORT: "Gransport",
            GRANTURISMO: "Granturismo",
            LEVANTE: "Levante",
            QUATTROPORTE: "Quattroporte",
            SPYDER: "Spyder"
        }
    },
    MAYBACH: {
        displayName: "Maybach",
        models: {
            "57": "57",
            "62": "62"
        }
    },
    MAZDA: {
        displayName: "Mazda",
        models: {
            "2": "2",
            "3": "3",
            "5": "5",
            "6": "6",
            "121": "121",
            "323": "323",
            "626": "626",
            "CX-3": "CX-3",
            "CX-5": "CX-5",
            "CX-7": "CX-7",
            DEMIO: "Demio",
            MPV: "MPV",
            "MX-3": "MX-3",
            "MX-5": "MX-5",
            PREMACY: "Premacy",
            "RX-7": "RX-7",
            "RX-8": "RX-8",
            TRIBUTE: "Tribute",
            "XEDOS 6": "Xedos 6",
            "XEDOS 9": "Xedos 9"
        }
    },
    MCLAREN: {
        displayName: "McLaren",
        models: {
            "540": "540",
            "570": "570",
            "650S": "650S",
            "675LT": "675LT",
            "720S": "720S",
            "MP4-12C": "MP4-12C",
            P1: "P1",
            SENNA: "Senna"
        }
    },
    "MERCEDES-BENZ": {
        displayName: "Mercedes-Benz",
        models: {
            "190": "190",
            "200": "200",
            "300": "300",
            "A CLASS": "A-Class",
            "A-CLASS": "A-Class",
            "AMG GT": "AMG GT",
            "B CLASS": "B-Class",
            "B-CLASS": "B-Class",
            "C CLASS": "C-Class",
            "C-CLASS": "C-Class",
            "CL CLASS": "CL-Class",
            "CL-CLASS": "CL-Class",
            CLA: "CLA",
            CLC: "CLC",
            CLK: "CLK",
            CLS: "CLS",
            "E CLASS": "E-Class",
            "E-CLASS": "E-Class",
            "G CLASS": "G-Class",
            "G-CLASS": "G-Class",
            "GL CLASS": "GL-Class",
            "GL-CLASS": "GL-Class",
            GLA: "GLA",
            GLC: "GLC",
            GLE: "GLE",
            GLS: "GLS",
            "M CLASS": "M-Class",
            "M-CLASS": "M-Class",
            "MCLAREN SLR": "McLaren SLR",
            "R CLASS": "R-Class",
            "R-CLASS": "R-Class",
            "S CLASS": "S-Class",
            "S-CLASS": "S-Class",
            "SEL SERIES": "SEL Series",
            "SL CLASS": "SL-Class",
            "SL-CLASS": "SL-Class",
            SLC: "SLC",
            SLK: "SLK",
            SLS: "SLS",
            "V CLASS": "V-Class",
            "V-CLASS": "V-Class",
            VANEO: "Vaneo",
            VIANO: "Viano",
            "X CLASS": "X-Class",
            "X-CLASS": "X-Class"
        }
    },
    MG: {
        displayName: "MG",
        models: {
            MG3: "MG3",
            MG6: "MG6",
            MGF: "MGF",
            MGTF: "MGTF",
            ZR: "ZR",
            ZS: "ZS",
            ZT: "ZT",
            "ZT-T": "ZT-T"
        }
    },
    MINI: {
        displayName: "Mini",
        models: {
            CLUBMAN: "Clubman",
            CONVERTIBLE: "Convertible",
            COUNTRYMAN: "Countryman",
            COUPE: "Coupe",
            HATCHBACK: "Hatchback",
            PACEMAN: "Paceman",
            ROADSTER: "Roadster"
        }
    },
    MITSUBISHI: {
        displayName: "Mitsubishi",
        models: {
            "3000GT": "3000GT",
            ASX: "ASX",
            CARISMA: "Carisma",
            CHALLENGER: "Challenger",
            COLT: "Colt",
            "ECLIPSE CROSS": "Eclipse Cross",
            GALANT: "Galant",
            GRANDIS: "Grandis",
            GTO: "GTO",
            "I-CAR": "iCar",
            "I-MIEV": "i-MiEV",
            L200: "L200",
            LANCER: "Lancer",
            MIRAGE: "Mirage",
            OUTLANDER: "Outlander",
            PAJERO: "Pajero",
            PININ: "Pinin",
            "RALLIART EVOLUTION VI": "Ralliart Evolution VI",
            "RALLIART EVOLUTION VII": "Ralliart Evolution VII",
            "RALLIART FTO": "Ralliart FTO",
            "RALLIART GALANT VR4": "Ralliart Galant VR4",
            SHOGUN: "Shogun",
            "SHOGUN PININ": "Shogun Pinin",
            "SHOGUN SPORT": "Shogun Sport",
            "SPACE RUNNER": "Space Runner",
            "SPACE STAR": "Space Star",
            "SPACE WAGON": "Space Wagon"
        }
    },
    MORGAN: {
        displayName: "Morgan",
        models: {
            "4/4": "4/4",
            "PLUS 4": "Plus 4"
        }
    },
    NISSAN: {
        displayName: "Nissan",
        models: {
            "200SX": "200SX",
            "350Z": "350Z",
            "370Z": "370Z",
            ALMERA: "Almera",
            "ALMERA TINO": "Almera Tino",
            CUBE: "Cube",
            "E-NV200": "E-NV200",
            "GT-R": "GT-R",
            JUKE: "Juke",
            LEAF: "Leaf",
            "MAXIMA QX": "Maxima QX",
            MICRA: "Micra",
            MURANO: "Murano",
            NAVARA: "Navara",
            NOTE: "Note",
            NV200: "NV200",
            PATHFINDER: "Pathfinder",
            PATROL: "Patrol",
            PIXO: "Pixo",
            PRIMERA: "Primera",
            PULSAR: "Pulsar",
            QASHQAI: "Qashqai",
            "QASHQAI+2": "Qashqai+2",
            QX: "QX",
            SERENA: "Serena",
            "SKYLINE GT-R": "Skyline GT-R",
            "TERRANO II": "Terrano II",
            TIIDA: "Tiida",
            "X-TRAIL": "X-Trail"
        }
    },
    NOBLE: {
        displayName: "Noble",
        models: {
            M12: "M12"
        }
    },
    OPEL: {
        displayName: "Opel",
        models: {
            ASTRA: "Astra",
            INSIGNIA: "Insignia"
        }
    },
    PAGANI: {
        displayName: "Pagani",
        models: {
            HUAYRA: "Huayra"
        }
    },
    PERODUA: {
        displayName: "Perodua",
        models: {
            KELISA: "Kelisa",
            KENARI: "Kenari",
            MYVI: "Myvi"
        }
    },
    PEUGEOT: {
        displayName: "Peugeot",
        models: {
            "106": "106",
            "107": "107",
            "108": "108",
            "205": "205",
            "206": "206",
            "207": "207",
            "208": "208",
            "306": "306",
            "307": "307",
            "308": "308",
            "405": "405",
            "406": "406",
            "407": "407",
            "508": "508",
            "607": "607",
            "806": "806",
            "807": "807",
            "1007": "1007",
            "2008": "2008",
            "3008": "3008",
            "4007": "4007",
            "5008": "5008",
            "BIPPER TEPEE": "Bipper Tepee",
            "EXPERT TEPEE": "Expert Tepee",
            ION: "iOn",
            "PARTNER COMBI": "Partner Combi",
            "PARTNER ORIGIN COMBI": "Partner Origin Combi",
            "PARTNER TEPEE": "Partner Tepee",
            RCZ: "RCZ",
            TRAVELLER: "Traveller"
        }
    },
    PORSCHE: {
        displayName: "Porsche",
        models: {
            "356": "356",
            "718": "718",
            "911": "911",
            "912": "912",
            "918": "918",
            "924": "924",
            "928": "928",
            "944": "944",
            "968": "968",
            BOXSTER: "Boxster",
            "CARRERA GT": "Carrera GT",
            CAYENNE: "Cayenne",
            CAYMAN: "Cayman",
            MACAN: "Macan",
            PANAMERA: "Panamera"
        }
    },
    PROTON: {
        displayName: "Proton",
        models: {
            EXORA: "Exora",
            "GEN-2": "GEN-2",
            IMPIAN: "Impian",
            PERSONA: "Persona",
            PREVE: "Preve",
            SATRIA: "Satria",
            "SATRIA NEO": "Satria Neo",
            SAVVY: "Savvy",
            WIRA: "Wira"
        }
    },
    RENAULT: {
        displayName: "Renault",
        models: {
            AVANTIME: "Avantime",
            CAPTUR: "Captur",
            CLIO: "Clio",
            ESPACE: "Espace",
            "GRAND ESPACE": "Grand Espace",
            "GRAND MODUS": "Grand Modus",
            "GRAND SCENIC": "Grand Scenic",
            KADJAR: "Kadjar",
            KANGOO: "Kangoo",
            KOLEOS: "Koleos",
            LAGUNA: "Laguna",
            MEGANE: "Megane",
            "MEGANE SCENIC": "Megane Scenic",
            MODUS: "Modus",
            SCENIC: "Scenic",
            "SCENIC XMOD": "Scenic XMOD",
            TRAFFIC: "Traffic",
            TWINGO: "Twingo",
            TWIZY: "Twizy",
            "VEL SATIS": "Vel Satis",
            WIND: "Wind",
            ZOE: "Zoe"
        }
    },
    "ROLLS-ROYCE": {
        displayName: "Rolls-Royce",
        models: {
            CORNICHE: "Corniche",
            DAWN: "Dawn",
            GHOST: "Ghost",
            "PARK WARD": "Park Ward",
            PHANTOM: "Phantom",
            "SILVER DAWN": "Silver Dawn",
            "SILVER SERAPH": "Silver Seraph",
            "SILVER SHADOW": "Silver Shadow",
            "SILVER SPIRIT": "Silver Spirit",
            "SILVER SPUR": "Silver Spur",
            WRAITH: "Wraith"
        }
    },
    ROVER: {
        displayName: "Rover",
        models: {
            "25": "25",
            "45": "45",
            "75": "75",
            "100": "100",
            "200": "200",
            "400": "400",
            "600": "600",
            CITYROVER: "Cityrover",
            MINI: "Mini",
            STREETWISE: "Streetwise",
            TOURER: "Tourer"
        }
    },
    SAAB: {
        displayName: "Saab",
        models: {
            "900": "900",
            "9000": "9000",
            "9-3": "9-3",
            "9-3X": "9-3X",
            "9-5": "9-5"
        }
    },
    SEAT: {
        displayName: "SEAT",
        models: {
            ALHAMBRA: "Alhambra",
            ALTEA: "Altea",
            ARONA: "Arona",
            AROSA: "Arosa",
            ATECA: "Ateca",
            CORDOBA: "Cordoba",
            EXEO: "Exeo",
            IBIZA: "Ibiza",
            LEON: "Leon",
            "LEON X-PERIENCE": "Leon X-PERIENCE",
            MII: "Mii",
            TOLEDO: "Toledo"
        }
    },
    SKODA: {
        displayName: "Skoda",
        models: {
            CITIGO: "Citigo",
            FABIA: "Fabia",
            FELICIA: "Felicia",
            KAROQ: "Karoq",
            KODIAQ: "Kodiaq",
            OCTAVIA: "Octavia",
            RAPID: "Rapid",
            ROOMSTER: "Roomster",
            SUPERB: "Superb",
            YETI: "Yeti"
        }
    },
    SMART: {
        displayName: "Smart",
        models: {
            CITY: "City",
            FORFOUR: "Forfour",
            FORTWO: "Fortwo",
            ROADSTER: "Roadster"
        }
    },
    SPYKER: {
        displayName: "Spyker",
        models: {
            C8: "C8"
        }
    },
    SSANGYONG: {
        displayName: "SsangYong",
        models: {
            KORANDO: "Korando",
            KYRON: "Kyron",
            MUSSO: "Musso",
            REXTON: "Rexton",
            "REXTON W": "Rexton W",
            RODIUS: "Rodius",
            SPORTS: "Sports",
            TIVOLI: "Tivoli",
            "TIVOLI XVL": "Tivoli XVL",
            TURISMO: "Turismo"
        }
    },
    SUBARU: {
        displayName: "Subaru",
        models: {
            BRZ: "BRZ",
            FORESTER: "Forester",
            IMPREZA: "Impreza",
            JUSTY: "Justy",
            LEGACY: "Legacy",
            LEVORG: "Levorg",
            OUTBACK: "Outback",
            TRIBECA: "Tribeca",
            "WRX STI": "WRX STI",
            XV: "XV"
        }
    },
    SUZUKI: {
        displayName: "Suzuki",
        models: {
            ALTO: "Alto",
            BALENO: "Baleno",
            CAPPUCCINO: "Cappuccino",
            CELERIO: "Celerio",
            "GRAND VITARA": "Grand Vitara",
            IGNIS: "Ignis",
            JIMNY: "Jimny",
            KIZASHI: "Kizashi",
            LIANA: "Liana",
            SPLASH: "Splash",
            SWIFT: "Swift",
            SX4: "SX4",
            "SX4 S CROSS": "SX4 S-Cross",
            VITARA: "Vitara",
            "WAGON R": "Wagon R",
            "X-90": "X-90"
        }
    },
    TESLA: {
        displayName: "Tesla",
        models: {
            "MODEL S": "Model S",
            "MODEL X": "Model X"
        }
    },
    TOYOTA: {
        displayName: "Toyota",
        models: {
            "4RUNNER": "4Runner",
            AURIS: "Auris",
            AVENSIS: "Avensis",
            AYGO: "Aygo",
            CAMRY: "Camry",
            "CARINA E": "Carina E",
            CELICA: "Celica",
            "C-HR": "C-HR",
            COROLLA: "Corolla",
            GT86: "GT86",
            HILUX: "Hilux",
            IQ: "IQ",
            "LAND CRUISER": "Land Cruiser",
            MR2: "MR2",
            PASEO: "Paseo",
            PICNIC: "Picnic",
            PREVIA: "Previa",
            PRIUS: "Prius",
            "PRIUS+": "Prius+",
            "RAV 4": "RAV 4",
            STARLET: "Starlet",
            SUPRA: "Supra",
            URBANCRUISER: "Urban Cruiser",
            VERSO: "Verso",
            YARIS: "Yaris"
        }
    },
    TRIUMPH: {
        displayName: "Triumph",
        models: {
            STAG: "Stag",
            TR3A: "TR3A",
            TR4A: "TR4A"
        }
    },
    TVR: {
        displayName: "TVR",
        models: {
            CERBERA: "Cerbera",
            CHIMAERA: "Chimaera",
            GRIFFITH: "Griffith",
            SAGARIS: "Sagaris",
            "T350 C": "T350 C",
            "T350 T": "T350 T",
            "T400 R": "T400 R",
            "T440 R": "T440 R",
            TAMORA: "Tamora",
            TUSCAN: "Tuscan",
            TYPHON: "Typhon"
        }
    },
    VAUXHALL: {
        displayName: "Vauxhall",
        models: {
            ADAM: "Adam",
            AGILA: "Agila",
            AMPERA: "Ampera",
            ANTARA: "Antara",
            ASTRA: "Astra",
            CALIBRA: "Calibra",
            CASCADA: "Cascada",
            "COMBO TOUR": "Combo Tour",
            CORSA: "Corsa",
            "CROSSLAND X": "Crossland X",
            FRONTERA: "Frontera",
            "GRANDLAND X": "Grandland X",
            INSIGNIA: "Insignia",
            MERIVA: "Meriva",
            MOKKA: "Mokka",
            MONARO: "Monaro",
            MONTEREY: "Monterey",
            OMEGA: "Omega",
            SIGNUM: "Signum",
            SINTRA: "Sintra",
            TIGRA: "Tigra",
            VECTRA: "Vectra",
            VIVA: "Viva",
            VIVARO: "Vivaro",
            VX220: "VX220",
            VXR8: "VXR8",
            ZAFIRA: "Zafira"
        }
    },
    VOLKSWAGEN: {
        displayName: "Volkswagen",
        models: {
            AMAROK: "Amarok",
            ARTEON: "Arteon",
            BEETLE: "Beetle",
            BORA: "Bora",
            "CADDY CAMPER": "Caddy Camper",
            "CADDY LIFE": "Caddy Life",
            "CADDY MAXI LIFE": "Caddy Maxi Life",
            CALIFORNIA: "California",
            CARAVELLE: "Caravelle",
            CC: "CC",
            CORRADO: "Corrado",
            EOS: "Eos",
            FOX: "Fox",
            GOLF: "Golf",
            JETTA: "Jetta",
            LUPO: "Lupo",
            PASSAT: "Passat",
            PHAETON: "Phaeton",
            POLO: "Polo",
            SCIROCCO: "Scirocco",
            SHARAN: "Sharan",
            TIGUAN: "Tiguan",
            TOUAREG: "Touareg",
            TOURAN: "Touran",
            "T-ROC": "T-Roc",
            UP: "up!"
        }
    },
    VOLVO: {
        displayName: "Volvo",
        models: {
            "440": "440",
            "460": "460",
            "480": "480",
            "850": "850",
            "940": "940",
            "960": "960",
            C30: "C30",
            C70: "C70",
            "CROSS COUNTRY": "Cross Country",
            S40: "S40",
            S60: "S60",
            "S60 R": "S60 R",
            S70: "S70",
            S80: "S80",
            S90: "S90",
            V40: "V40",
            V50: "V50",
            V60: "V60",
            V70: "V70",
            V90: "V90",
            XC40: "XC40",
            XC60: "XC60",
            XC70: "XC70",
            XC90: "XC90"
        }
    },
    WESTFIELD: {
        displayName: "Westfield",
        models: {
            ROADSTER: "Roadster",
            SEI: "SEi",
            SPORT: "Sport"
        }
    }
};
/* harmony default export */ var car_data = (data);

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/car-data/index.ts

const getMake = (make)=>{
    if (!make) {
        return "";
    }
    try {
        return car_data[make.trim()].displayName;
    } catch  {
        return make;
    }
};
const getModel = (make, model)=>{
    if (!make || !model) {
        return "";
    }
    if (car_data[make.trim()] && car_data[make.trim()].models && car_data[make.trim()].models[model.trim()]) {
        return car_data[make.trim()].models[model.trim()];
    }
    // make and model is not found!
    // todo track an event for this!
    return model;
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/checkout-stage.ts

var PaymentDecision;
(function(PaymentDecision) {
    PaymentDecision["PAY_IN_FULL"] = "PAY_IN_FULL";
    PaymentDecision["PAY_WITH_FINANCE"] = "PAY_WITH_FINANCE";
    PaymentDecision["NONE"] = "NONE";
})(PaymentDecision || (PaymentDecision = {}));
const paymentDecisionInStorage = "paymentDecision";
const getPaymentDecisionFromLocalStorage = ()=>{
    if (false) {}
    return window.localStorage.getItem(paymentDecisionInStorage);
};
const cardDetailsPagePath = "/checkout/card-details/";
const deliveryPagePath = "/checkout/delivery/";
const personalDetailsPagePath = "/checkout/personal-details/";
const findVehiclePath = "/find-vehicle/";
const partExchangePagePath = "/checkout/part-exchange/";
const financePagePath = getPaymentDecisionFromLocalStorage() === PaymentDecision.PAY_WITH_FINANCE ? "/checkout/finance/" : "/checkout/payment/";
const cinchCarePagePath = "checkout/cinch-care/";
const extrasPagePath = "/checkout/car-care/";
const cinchCoverPagePath = "/checkout/cinch-cover/";
var CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["CinchCover"] = "CinchCover";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(CheckoutStage || (CheckoutStage = {}));
const returnToCheckoutStage = (checkoutStep, activeOrder)=>{
    const vehicle = activeOrder && activeOrder.vehicle;
    const orderId = activeOrder && activeOrder.id;
    const stages = {
        [CheckoutStage.PartExchange]: partExchangePagePath,
        [CheckoutStage.Finance]: financePagePath,
        [CheckoutStage.DeliverySlots]: deliveryPagePath,
        [CheckoutStage.Extras]: extrasPagePath,
        [CheckoutStage.CinchCare]: cinchCarePagePath,
        [CheckoutStage.CinchCover]: cinchCoverPagePath,
        [CheckoutStage.Payment]: cardDetailsPagePath
    };
    if (stages[checkoutStep]) {
        return window.location.assign(`${stages[checkoutStep]}${orderId}`);
    }
    if (vehicle) {
        return window.location.assign(`${personalDetailsPagePath}${vehicle.id}`);
    }
    return;
};
const isOrderCheckoutStage = (maybeCheckoutStage)=>Object.prototype.hasOwnProperty.call(maybeCheckoutStage, "orderId") && Object.prototype.hasOwnProperty.call(maybeCheckoutStage, "stage");
const getLastCheckoutStage = (activeOrder)=>{
    const storageLastCheckoutStage = isBrowser ? JSON.parse((sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("checkout-last-visited-stage")) ?? "{}") : null;
    if (!activeOrder) {
        return;
    }
    if (storageLastCheckoutStage && isOrderCheckoutStage(storageLastCheckoutStage) && storageLastCheckoutStage.orderId === (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id)) {
        return storageLastCheckoutStage;
    }
    return {
        orderId: activeOrder.id,
        stage: CheckoutStage.PersonalDetails
    };
};
const checkoutTimes = (activeOrder)=>{
    const warningTime = 5 * 60 * 1000;
    const timeNow = Math.floor(Date.now());
    const timeRemainingInSeconds = activeOrder ? Math.floor(((activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) - timeNow) / 1000) : 0;
    const isExpiringSoon = (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ? warningTime + timeNow > (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) : null;
    return {
        timeRemainingInSeconds,
        isExpiringSoon
    };
};

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/product-detail-url.tsx


const sanitisePathSegment = (text)=>text ? text.replace(/\s+/g, "-").replace(/\[/g, "(").replace(/]/g, ")").toLowerCase() : "";
const productDetailUrl = (vehicle)=>{
    if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
        return "/used-cars";
    }
    return `/used-cars/${sanitisePathSegment(vehicle.make)}/${sanitisePathSegment(vehicle.model)}/details/${vehicle.id}`;
};
const LinkToProductDetail = ({ children , basicVehicleInfo , className  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: productDetailUrl(basicVehicleInfo),
        target: "_blank",
        "aria-label": `Open the car detail page in a new browser tab`,
        rel: "noreferrer",
        className: className,
        children: children
    });

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/hooks/use-viewport.ts

const defaultOptions = {
    updateOnResize: true,
    updateOnOrientationChange: true
};
const useViewport = (options = defaultOptions)=>{
    const [vw, setVW] = (0,react.useState)(0);
    const [vh, setVH] = (0,react.useState)(0);
    const { updateOnResize , updateOnOrientationChange  } = options;
    const setSizes = (0,react.useCallback)(()=>{
        if (window.innerWidth !== vw) {
            setVW(window.innerWidth);
        }
        if (window.innerHeight !== vh) {
            setVH(window.innerHeight);
        }
    }, [
        vw,
        vh
    ]);
    (0,react.useEffect)(()=>{
        setSizes();
        if (updateOnResize) {
            window.addEventListener("resize", setSizes);
            return ()=>window.removeEventListener("resize", setSizes);
        }
        if (updateOnOrientationChange) {
            window.addEventListener("orientationchange", setSizes);
            return ()=>window.removeEventListener("orientationchange", setSizes);
        }
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        updateOnResize,
        updateOnOrientationChange,
        vw,
        vh
    ]);
    return {
        vw,
        vh
    };
};
/* harmony default export */ var use_viewport = ((/* unused pure expression or super */ null && (useViewport)));

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/get-analytic-ids.ts
const getAnalyticIDs = ()=>{
    var ref, ref1, ref2;
    const adobeID = window === null || window === void 0 ? void 0 : (ref = window.s) === null || ref === void 0 ? void 0 : ref.marketingCloudVisitorID;
    const googleAnalyticObj = typeof (window === null || window === void 0 ? void 0 : (ref1 = window.ga) === null || ref1 === void 0 ? void 0 : ref1.getAll) === "function" && (window === null || window === void 0 ? void 0 : (ref2 = window.ga) === null || ref2 === void 0 ? void 0 : ref2.getAll());
    const gaID = Array.isArray(googleAnalyticObj) && googleAnalyticObj.length > 0 && googleAnalyticObj[0].get("clientId") || undefined;
    return {
        adobeID,
        gaID
    };
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/get-cinch-care-eligibility-period.ts
const fourteenDaysPostDeliveryWarrantyPeriodGoLiveDate = new Date("2024-03-13T09:00:00.000Z");
function getCinchCareEligibilityPeriod(completedAt) {
    return completedAt < fourteenDaysPostDeliveryWarrantyPeriodGoLiveDate.getTime() ? 100 : 14;
}

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/get-emac-service-warranty-eligibility-period.ts
function getEMaCServiceWarrantyEligibilityPeriod() {
    return 14;
}

// EXTERNAL MODULE: ../../../node_modules/react-dom/test-utils.js
var test_utils = __webpack_require__(30740);
// EXTERNAL MODULE: ../../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(12788);
// EXTERNAL MODULE: ../../../node_modules/react-dom/client.js
var client = __webpack_require__(44645);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js + 8 modules
var dom_esm = __webpack_require__(52662);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js
/* provided dependency */ var process = __webpack_require__(13158);







const domAct = test_utils.act;

function getGlobalThis() {
  /* istanbul ignore else */
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  /* istanbul ignore next */


  if (typeof self !== 'undefined') {
    return self;
  }
  /* istanbul ignore next */


  if (typeof window !== 'undefined') {
    return window;
  }
  /* istanbul ignore next */


  if (typeof __webpack_require__.g !== 'undefined') {
    return __webpack_require__.g;
  }
  /* istanbul ignore next */


  throw new Error('unable to locate global object');
}

function setIsReactActEnvironment(isReactActEnvironment) {
  getGlobalThis().IS_REACT_ACT_ENVIRONMENT = isReactActEnvironment;
}

function getIsReactActEnvironment() {
  return getGlobalThis().IS_REACT_ACT_ENVIRONMENT;
}

function withGlobalActEnvironment(actImplementation) {
  return callback => {
    const previousActEnvironment = getIsReactActEnvironment();
    setIsReactActEnvironment(true);

    try {
      // The return value of `act` is always a thenable.
      let callbackNeedsToBeAwaited = false;
      const actResult = actImplementation(() => {
        const result = callback();

        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
          callbackNeedsToBeAwaited = true;
        }

        return result;
      });

      if (callbackNeedsToBeAwaited) {
        const thenable = actResult;
        return {
          then: (resolve, reject) => {
            thenable.then(returnValue => {
              setIsReactActEnvironment(previousActEnvironment);
              resolve(returnValue);
            }, error => {
              setIsReactActEnvironment(previousActEnvironment);
              reject(error);
            });
          }
        };
      } else {
        setIsReactActEnvironment(previousActEnvironment);
        return actResult;
      }
    } catch (error) {
      // Can't be a `finally {}` block since we don't know if we have to immediately restore IS_REACT_ACT_ENVIRONMENT
      // or if we have to await the callback first.
      setIsReactActEnvironment(previousActEnvironment);
      throw error;
    }
  };
}

const act = withGlobalActEnvironment(domAct);
/* eslint no-console:0 */

// dom-testing-library's version of fireEvent. The reason
// we make this distinction however is because we have
// a few extra events that work a bit differently

const fireEvent = function () {
  return (0,dom_esm/* fireEvent */.BX)(...arguments);
};

Object.keys(dom_esm/* fireEvent */.BX).forEach(key => {
  fireEvent[key] = function () {
    return dom_esm/* fireEvent */.BX[key](...arguments);
  };
}); // React event system tracks native mouseOver/mouseOut events for
// running onMouseEnter/onMouseLeave handlers
// @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/EnterLeaveEventPlugin.js#L24-L31

const mouseEnter = fireEvent.mouseEnter;
const mouseLeave = fireEvent.mouseLeave;

fireEvent.mouseEnter = function () {
  mouseEnter(...arguments);
  return fireEvent.mouseOver(...arguments);
};

fireEvent.mouseLeave = function () {
  mouseLeave(...arguments);
  return fireEvent.mouseOut(...arguments);
};

const pointerEnter = fireEvent.pointerEnter;
const pointerLeave = fireEvent.pointerLeave;

fireEvent.pointerEnter = function () {
  pointerEnter(...arguments);
  return fireEvent.pointerOver(...arguments);
};

fireEvent.pointerLeave = function () {
  pointerLeave(...arguments);
  return fireEvent.pointerOut(...arguments);
};

const react_esm_select = fireEvent.select;

fireEvent.select = (node, init) => {
  react_esm_select(node, init); // React tracks this event only on focused inputs

  node.focus(); // React creates this event when one of the following native events happens
  // - contextMenu
  // - mouseUp
  // - dragEnd
  // - keyUp
  // - keyDown
  // so we can use any here
  // @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/SelectEventPlugin.js#L203-L224

  fireEvent.keyUp(node, init);
}; // React event system tracks native focusout/focusin events for
// running blur/focus handlers
// @link https://github.com/facebook/react/pull/19186


const react_esm_blur = fireEvent.blur;
const react_esm_focus = fireEvent.focus;

fireEvent.blur = function () {
  fireEvent.focusOut(...arguments);
  return react_esm_blur(...arguments);
};

fireEvent.focus = function () {
  fireEvent.focusIn(...arguments);
  return react_esm_focus(...arguments);
};

(0,dom_esm/* configure */.jQ)({
  unstable_advanceTimersWrapper: cb => {
    return act(cb);
  },
  // We just want to run `waitFor` without IS_REACT_ACT_ENVIRONMENT
  // But that's not necessarily how `asyncWrapper` is used since it's a public method.
  // Let's just hope nobody else is using it.
  asyncWrapper: async cb => {
    const previousActEnvironment = getIsReactActEnvironment();
    setIsReactActEnvironment(false);

    try {
      return await cb();
    } finally {
      setIsReactActEnvironment(previousActEnvironment);
    }
  },
  eventWrapper: cb => {
    let result;
    act(() => {
      result = cb();
    });
    return result;
  }
}); // Ideally we'd just use a WeakMap where containers are keys and roots are values.
// We use two variables so that we can bail out in constant time when we render with a new container (most common use case)

/**
 * @type {Set<import('react-dom').Container>}
 */

const mountedContainers = new Set();
/**
 * @type Array<{container: import('react-dom').Container, root: ReturnType<typeof createConcurrentRoot>}>
 */

const mountedRootEntries = [];

function createConcurrentRoot(container, _ref) {
  let {
    hydrate,
    ui,
    wrapper: WrapperComponent
  } = _ref;
  let root;

  if (hydrate) {
    act(() => {
      root = ReactDOMClient.hydrateRoot(container, WrapperComponent ? /*#__PURE__*/React.createElement(WrapperComponent, null, ui) : ui);
    });
  } else {
    root = ReactDOMClient.createRoot(container);
  }

  return {
    hydrate() {
      /* istanbul ignore if */
      if (!hydrate) {
        throw new Error('Attempted to hydrate a non-hydrateable root. This is a bug in `@testing-library/react`.');
      } // Nothing to do since hydration happens when creating the root object.

    },

    render(element) {
      root.render(element);
    },

    unmount() {
      root.unmount();
    }

  };
}

function createLegacyRoot(container) {
  return {
    hydrate(element) {
      ReactDOM.hydrate(element, container);
    },

    render(element) {
      ReactDOM.render(element, container);
    },

    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }

  };
}

function renderRoot(ui, _ref2) {
  let {
    baseElement,
    container,
    hydrate,
    queries,
    root,
    wrapper: WrapperComponent
  } = _ref2;

  const wrapUiIfNeeded = innerElement => WrapperComponent ? /*#__PURE__*/React.createElement(WrapperComponent, null, innerElement) : innerElement;

  act(() => {
    if (hydrate) {
      root.hydrate(wrapUiIfNeeded(ui), container);
    } else {
      root.render(wrapUiIfNeeded(ui), container);
    }
  });
  return {
    container,
    baseElement,
    debug: function (el, maxLength, options) {
      if (el === void 0) {
        el = baseElement;
      }

      return Array.isArray(el) ? // eslint-disable-next-line no-console
      el.forEach(e => console.log(prettyDOM(e, maxLength, options))) : // eslint-disable-next-line no-console,
      console.log(prettyDOM(el, maxLength, options));
    },
    unmount: () => {
      act(() => {
        root.unmount();
      });
    },
    rerender: rerenderUi => {
      renderRoot(wrapUiIfNeeded(rerenderUi), {
        container,
        baseElement,
        root
      }); // Intentionally do not return anything to avoid unnecessarily complicating the API.
      // folks can use all the same utilities we return in the first place that are bound to the container
    },
    asFragment: () => {
      /* istanbul ignore else (old jsdom limitation) */
      if (typeof document.createRange === 'function') {
        return document.createRange().createContextualFragment(container.innerHTML);
      } else {
        const template = document.createElement('template');
        template.innerHTML = container.innerHTML;
        return template.content;
      }
    },
    ...getQueriesForElement(baseElement, queries)
  };
}

function render(ui, _temp) {
  let {
    container,
    baseElement = container,
    legacyRoot = false,
    queries,
    hydrate = false,
    wrapper
  } = _temp === void 0 ? {} : _temp;

  if (!baseElement) {
    // default to document.body instead of documentElement to avoid output of potentially-large
    // head elements (such as JSS style blocks) in debug output
    baseElement = document.body;
  }

  if (!container) {
    container = baseElement.appendChild(document.createElement('div'));
  }

  let root; // eslint-disable-next-line no-negated-condition -- we want to map the evolution of this over time. The root is created first. Only later is it re-used so we don't want to read the case that happens later first.

  if (!mountedContainers.has(container)) {
    const createRootImpl = legacyRoot ? createLegacyRoot : createConcurrentRoot;
    root = createRootImpl(container, {
      hydrate,
      ui,
      wrapper
    });
    mountedRootEntries.push({
      container,
      root
    }); // we'll add it to the mounted containers regardless of whether it's actually
    // added to document.body so the cleanup method works regardless of whether
    // they're passing us a custom container or not.

    mountedContainers.add(container);
  } else {
    mountedRootEntries.forEach(rootEntry => {
      // Else is unreachable since `mountedContainers` has the `container`.
      // Only reachable if one would accidentally add the container to `mountedContainers` but not the root to `mountedRootEntries`

      /* istanbul ignore else */
      if (rootEntry.container === container) {
        root = rootEntry.root;
      }
    });
  }

  return renderRoot(ui, {
    container,
    baseElement,
    queries,
    hydrate,
    wrapper,
    root
  });
}

function cleanup() {
  mountedRootEntries.forEach(_ref3 => {
    let {
      root,
      container
    } = _ref3;
    act(() => {
      root.unmount();
    });

    if (container.parentNode === document.body) {
      document.body.removeChild(container);
    }
  });
  mountedRootEntries.length = 0;
  mountedContainers.clear();
}

function renderHook(renderCallback, options) {
  if (options === void 0) {
    options = {};
  }

  const {
    initialProps,
    ...renderOptions
  } = options;
  const result = /*#__PURE__*/React.createRef();

  function TestComponent(_ref4) {
    let {
      renderCallbackProps
    } = _ref4;
    const pendingResult = renderCallback(renderCallbackProps);
    React.useEffect(() => {
      result.current = pendingResult;
    });
    return null;
  }

  const {
    rerender: baseRerender,
    unmount
  } = render( /*#__PURE__*/React.createElement(TestComponent, {
    renderCallbackProps: initialProps
  }), renderOptions);

  function rerender(rerenderCallbackProps) {
    return baseRerender( /*#__PURE__*/React.createElement(TestComponent, {
      renderCallbackProps: rerenderCallbackProps
    }));
  }

  return {
    result,
    rerender,
    unmount
  };
} // just re-export everything from dom-testing-library
/* eslint func-name-matching:0 */

var _process$env;
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.

if (typeof process === 'undefined' || !((_process$env = process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  // ignore teardown() in code coverage because Jest does not support it

  /* istanbul ignore else */
  if (typeof afterEach === 'function') {
    afterEach(() => {
      cleanup();
    });
  } else if (typeof teardown === 'function') {
    // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(() => {
      cleanup();
    });
  } // No test setup with other test runners available

  /* istanbul ignore else */


  if (typeof beforeAll === 'function' && typeof afterAll === 'function') {
    // This matches the behavior of React < 18.
    let previousIsReactActEnvironment = getIsReactActEnvironment();
    beforeAll(() => {
      previousIsReactActEnvironment = getIsReactActEnvironment();
      setIsReactActEnvironment(true);
    });
    afterAll(() => {
      setIsReactActEnvironment(previousIsReactActEnvironment);
    });
  }
}



;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/wait-for-icons-to-load/wait-for-icons-to-load.tsx

const waitForIconsToLoad = async ()=>{
    try {
        await waitFor(()=>screen.getAllByTestId((id)=>id.startsWith(`SvgIcon`)));
    } catch  {
        console.warn("Icons not loaded... continuing");
    }
};

;// CONCATENATED MODULE: ../../../libs/shared/util/src/lib/wait-for-icons-to-load/index.ts


;// CONCATENATED MODULE: ../../../libs/shared/util/src/index.ts






























/***/ }),

/***/ 5874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wV": function() { return /* reexport */ ZendeskChatButton; },
  "LF": function() { return /* reexport */ zendeskMessengerScriptProps; }
});

// UNUSED EXPORTS: getZendeskScriptUrl

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/shared/zendesk-messenger/src/lib/zendesk-messenger.module.css
var zendesk_messenger_module = __webpack_require__(72592);
var zendesk_messenger_module_default = /*#__PURE__*/__webpack_require__.n(zendesk_messenger_module);
;// CONCATENATED MODULE: ../../../libs/shared/zendesk-messenger/src/lib/comments-sharp-regular.tsx

const CommentsSharpIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "21",
        height: "16",
        viewBox: "0 0 21 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_3353_9665)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.17812 9.34062L3.52187 8.48438L2.9125 7.79375C2.31875 7.11875 2 6.32812 2 5.5C2 3.51562 3.99375 1.5 7 1.5C10.0063 1.5 12 3.51562 12 5.5C12 7.48438 10.0063 9.5 7 9.5C6.57812 9.5 6.16875 9.45938 5.78125 9.37813L5.4625 9.3125L5.14687 9.38437L2.95937 9.89062L3.18125 9.34062H3.17812ZM0.5 12L2.28125 11.5906L5.4875 10.85C5.975 10.9469 6.48125 11 7.00313 11C10.5938 11 13.5031 8.5375 13.5031 5.5C13.5031 2.4625 10.5906 0 7 0C3.40937 0 0.5 2.4625 0.5 5.5C0.5 6.73125 0.978125 7.86875 1.7875 8.78438L1.17813 10.3031L0.5 12ZM14 15C14.5219 15 15.0281 14.9469 15.5156 14.85L18.7188 15.5906L20.5 16L19.8219 14.3031L19.2156 12.7844C20.0219 11.8688 20.5 10.7312 20.5 9.5C20.5 6.55 17.7531 4.14062 14.3062 4.00625C14.4344 4.48125 14.5 4.98125 14.5 5.5V5.51875C17.225 5.72813 19 7.62813 19 9.5C19 10.3281 18.6812 11.1187 18.0875 11.7937L17.4781 12.4875L17.8219 13.3438L18.0438 13.8938L15.8531 13.3875L15.5375 13.3156L15.2188 13.3781C14.8313 13.4563 14.4219 13.5 14 13.5C12.0719 13.5 10.5625 12.6719 9.725 11.5531C9.225 11.7219 8.7 11.8469 8.1625 11.9219C9.21875 13.7437 11.4375 15 14 15Z",
                    fill: "#57E8FF"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3353_9665",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "16",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/shared/zendesk-messenger/src/lib/zendesk-messenger.tsx




const onClick = ()=>{
    if ( true && window.zE) {
        window.zE("messenger", "open");
    }
};
const ZendeskChatButton = ()=>{
    var ref;
    const IS_MOBILE_APP =  true && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    return !IS_MOBILE_APP ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (zendesk_messenger_module_default()).buttonContainer,
        "data-testid": "zendesk-chat-button-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
            id: "zendesk-chat-button",
            "aria-label": "Chat with us",
            onClick: ()=>onClick(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (zendesk_messenger_module_default()).commentIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentsSharpIcon, {})
            })
        })
    }) : null;
};

;// CONCATENATED MODULE: ../../../libs/shared/zendesk-messenger/src/lib/zendesk-messenger.types.ts
var ZendeskMessengerKey;
(function(ZendeskMessengerKey) {
    ZendeskMessengerKey["development"] = "1b1357b8-8c8c-45bc-ad2e-a0e4355931f5";
    ZendeskMessengerKey["production"] = "50e6e8cb-4c25-46f4-a4bb-2a031989284d";
})(ZendeskMessengerKey || (ZendeskMessengerKey = {}));

;// CONCATENATED MODULE: ../../../libs/shared/zendesk-messenger/src/lib/zendesk-messenger.helpers.ts

const getZendeskScriptUrl = (env)=>{
    const key = env === "production" ? ZendeskMessengerKey.production : ZendeskMessengerKey.development;
    return `https://static.zdassets.com/ekr/snippet.js?key=${key}`;
};
const zendeskMessengerScriptProps = ({ id ="ze-snippet" , env ="localhost"  })=>({
        id,
        src: getZendeskScriptUrl(env),
        "data-testid": id
    });

;// CONCATENATED MODULE: ../../../libs/shared/zendesk-messenger/src/index.ts




/***/ }),

/***/ 63268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(62872).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(72278).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = `http${domain.http ? "" : "s"}://`;
            const finalLocale = target === domain.defaultLocale ? "" : `/${target}`;
            return `${proto}${domain.domain}${basePath}${finalLocale}${path}`;
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 4613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(45620)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(45181)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(12813)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(32735));
var _head = _interop_require_default(__webpack_require__(19404));
var _imageConfig = __webpack_require__(37399);
var _useIntersection = __webpack_require__(28227);
var _imageConfigContext = __webpack_require__(35237);
var _utils = __webpack_require__(45861);
var _normalizeTrailingSlash = __webpack_require__(88339);
function Image(_param) {
    var { src , sizes , unoptimized =false , priority =false , loading , lazyRoot =null , lazyBoundary , className , quality , width , height , style , objectFit , objectPosition , onLoadingComplete , placeholder ="empty" , blurDataURL  } = _param, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    const configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    const config = (0, _react).useMemo(()=>{
        const c = configEnv || configContext || _imageConfig.imageConfigDefault;
        const allSizes = [
            ...c.deviceSizes,
            ...c.imageSizes
        ].sort((a, b)=>a - b);
        const deviceSizes = c.deviceSizes.sort((a, b)=>a - b);
        return _extends({}, c, {
            allSizes,
            deviceSizes
        });
    }, [
        configContext
    ]);
    let rest = all;
    let layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    let loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            const customImageLoader = rest.loader;
            var _tmp;
            _tmp = (obj)=>{
                const { config: _  } = obj, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    let staticSrc = "";
    if (isStaticImport(src)) {
        const staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error(`An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ${JSON.stringify(staticImageData)}`);
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error(`An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ${JSON.stringify(staticImageData)}`);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    let isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    const [blurComplete, setBlurComplete] = (0, _react).useState(false);
    const [setIntersection, isIntersected, resetIntersected] = (0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    });
    const isVisible = !isLazy || isIntersected;
    const wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    const sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    let hasSizer = false;
    let sizerSvgUrl;
    const layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit,
        objectPosition
    };
    let widthInt = getInt(width);
    let heightInt = getInt(height);
    const qualityInt = getInt(quality);
    if (false) {}
    const imgStyle = Object.assign({}, style, layoutStyle);
    const blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: `url("${blurDataURL}")`
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        const quotient = heightInt / widthInt;
        const paddingTop = isNaN(quotient) ? "100%" : `${quotient * 100}%`;
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = `data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27${widthInt}%27%20height=%27${heightInt}%27/%3e`;
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    let imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config,
            src,
            unoptimized,
            layout,
            width: widthInt,
            quality: qualityInt,
            sizes,
            loader
        });
    }
    let srcString = src;
    if (false) {}
    let imageSrcSetPropName = "imagesrcset";
    let imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    const linkProps = {
        // Note: imagesrcset and imagesizes are not in the link element type with react 17.
        [imageSrcSetPropName]: imgAttributes.srcSet,
        [imageSizesPropName]: imgAttributes.sizes,
        crossOrigin: rest.crossOrigin
    };
    const useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    const onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    const previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(()=>{
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(()=>{
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    const imgElementArgs = _extends({
        isLazy,
        imgAttributes,
        heightInt,
        widthInt,
        qualityInt,
        layout,
        className,
        imgStyle,
        blurStyle,
        loading,
        config,
        unoptimized,
        placeholder,
        loader,
        srcString,
        onLoadingCompleteRef,
        setBlurComplete,
        setIntersection,
        isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"use client";
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
const configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"https://landing-www-opennext.snc-prod.aws.cinch.co.uk/_next/image","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
const loadedImageURLs = new Set();
const allImgs = new Map();
let perfObserver;
const emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
const VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function imgixLoader({ config , src , width , quality  }) {
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    const url = new URL(`${config.path}${normalizeSrc(src)}`);
    const params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader({ config , src , width  }) {
    return `${config.path}${normalizeSrc(src)}?imwidth=${width}`;
}
function cloudinaryLoader({ config , src , width , quality  }) {
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    const params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    const paramsString = params.join(",") + "/";
    return `${config.path}${paramsString}${normalizeSrc(src)}`;
}
function customLoader({ src  }) {
    throw new Error(`Image with src "${src}" is missing "loader" prop.` + `\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader`);
}
function defaultLoader({ config , src , width , quality  }) {
    if (false) {}
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return `${(0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path)}?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;
}
const loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ]
]);
const VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths({ deviceSizes , allSizes  }, width, layout, sizes) {
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        const viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        const percentSizes = [];
        for(let match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            const smallestRatio = Math.min(...percentSizes) * 0.01;
            return {
                widths: allSizes.filter((s)=>s >= deviceSizes[0] * smallestRatio),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2 /*, width * 3*/ 
        ].map((w)=>allSizes.find((p)=>p >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
}
function generateImgAttrs({ config , src , unoptimized , layout , width , quality , sizes , loader  }) {
    if (unoptimized) {
        return {
            src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    const { widths , kind  } = getWidths(config, width, layout, sizes);
    const last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map((w, i)=>`${loader({
                config,
                src,
                quality,
                width: w
            })} ${kind === "w" ? w : i + 1}${kind}`).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config,
            src,
            quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    const loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    const load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error(`Unknown "loader" found in "next.config.js". Expected: ${_imageConfig.VALID_LOADERS.join(", ")}. Received: ${loaderKey}`);
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(()=>{}).then(()=>{
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            const { naturalWidth , naturalHeight  } = img;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth,
                naturalHeight
            });
        }
        if (false) { var ref; }
    });
}
const ImageElement = (_param)=>{
    var { imgAttributes , heightInt , widthInt , qualityInt , layout , className , imgStyle , blurStyle , isLazy , placeholder , loading , srcString , config , unoptimized , loader , onLoadingCompleteRef , setBlurComplete , setIntersection , onLoad , onError , isVisible , noscriptSizes  } = _param, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback((img)=>{
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: (event)=>{
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config,
        src: srcString,
        unoptimized,
        layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 50422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(12813)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(32735));
var _router = __webpack_require__(86968);
var _addLocale = __webpack_require__(56515);
var _routerContext = __webpack_require__(4308);
var _appRouterContext = __webpack_require__(1017);
var _useIntersection = __webpack_require__(28227);
var _getDomainLocale = __webpack_require__(63268);
var _addBasePath = __webpack_require__(98624);
"use client";
const prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
    const curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            const method = replace ? "replace" : "push";
            // Apply `as` if it's provided.
            router[method](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter , onTouchStart , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const p = prefetchProp !== false;
    let router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    const { href , as  } = _react.default.useMemo(()=>{
        const [resolvedHref, resolvedAs] = (0, _router).resolveHref(router, hrefProp, true);
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(()=>{
        const shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        const isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 62872:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(77331).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 28227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(32735);
var _requestIdleCallback = __webpack_require__(72041);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection({ rootRef , rootMargin , disabled  }) {
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1017:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(32735));
"use client";
const AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
const LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
const GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
const TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 17111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(45620)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(32735));
var _loadable = _interop_require_default(__webpack_require__(24672));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 28386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(32735));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 24672:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(45620)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(58817)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(32735));
var _loadableContext = __webpack_require__(28386);
const { useSyncExternalStore  } =  true ? __webpack_require__(32735) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 55370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ vd; },
/* harmony export */   "$n": function() { return /* binding */ ci; },
/* harmony export */   "Ax": function() { return /* binding */ be; },
/* harmony export */   "B3": function() { return /* binding */ Lt; },
/* harmony export */   "DF": function() { return /* binding */ gi; },
/* harmony export */   "IH": function() { return /* binding */ li; },
/* harmony export */   "J8": function() { return /* binding */ Xa; },
/* harmony export */   "Jj": function() { return /* binding */ $a; },
/* harmony export */   "Pn": function() { return /* binding */ qa; },
/* harmony export */   "S3": function() { return /* binding */ zl; },
/* harmony export */   "SP": function() { return /* binding */ ui; },
/* harmony export */   "T7": function() { return /* binding */ G; },
/* harmony export */   "Wp": function() { return /* binding */ oe; },
/* harmony export */   "X6": function() { return /* binding */ Qe; },
/* harmony export */   "XZ": function() { return /* binding */ Me; },
/* harmony export */   "ZL": function() { return /* binding */ yd; },
/* harmony export */   "dm": function() { return /* binding */ gd; },
/* harmony export */   "dn": function() { return /* binding */ md; },
/* harmony export */   "dy": function() { return /* binding */ hl; },
/* harmony export */   "hh": function() { return /* binding */ at; },
/* harmony export */   "hx": function() { return /* binding */ qc; },
/* harmony export */   "k7": function() { return /* binding */ Ee; },
/* harmony export */   "le": function() { return /* binding */ we; },
/* harmony export */   "ll": function() { return /* binding */ Ks; },
/* harmony export */   "lr": function() { return /* binding */ ja; },
/* harmony export */   "mg": function() { return /* binding */ Fs; },
/* harmony export */   "nv": function() { return /* binding */ dc; },
/* harmony export */   "pu": function() { return /* binding */ ps; },
/* harmony export */   "qs": function() { return /* binding */ Ba; },
/* harmony export */   "sq": function() { return /* binding */ W; },
/* harmony export */   "uB": function() { return /* binding */ fd; },
/* harmony export */   "u_": function() { return /* binding */ as; },
/* harmony export */   "xv": function() { return /* binding */ ke; }
/* harmony export */ });
/* unused harmony exports Accordion, Alert, AlertTypes, Base, BaseCard, CardWithImage, CardWrapper, CheckboxField, ContentBlock, ContentSectionBody, ContentSectionCTA, ContentSectionHeading, ContentSectionIcon, ContentSectionWithCTA, ContentSectionWrapper, CtaButton, FeaturedBlock, FormFieldError, FormHelpText, FormLabel, FullWidth, HorizontalTabsTitle, IconCard, ImageTextBlock, InlineRadio, InlineRadioField, List, RichTextStyles, ScreenReaderText, SearchField, SectionWithImage, Select, SkipLinks, Tabs, TabsButton, TabsList, TabsPanel, TextButton, TextFontSizes, TextFontStyles, TextLineHeights, Textarea, TextareaField, Tip, Toggle, ToggleField, VerticalTabs, VerticalTabsButton, VerticalTabsList, VerticalTabsPanel, VerticalTabsTitle, Video, Warning, handleKeyboardSelect, toJSON, useTabs */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12788);




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var y = function() {
    return y = Object.assign || function(e1) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var a in t = arguments[n])Object.prototype.hasOwnProperty.call(t, a) && (e1[a] = t[a]);
        return e1;
    }, y.apply(this, arguments);
};
function x(e1, t) {
    var n = {};
    for(var r in e1)Object.prototype.hasOwnProperty.call(e1, r) && t.indexOf(r) < 0 && (n[r] = e1[r]);
    if (null != e1 && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(r = Object.getOwnPropertySymbols(e1); a < r.length; a++)t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e1, r[a]) && (n[r[a]] = e1[r[a]]);
    }
    return n;
}
var E, w = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ E = w, function() {
    var e1 = {}.hasOwnProperty;
    function t() {
        for(var n = [], r = 0; r < arguments.length; r++){
            var a = arguments[r];
            if (a) {
                var i = typeof a;
                if ("string" === i || "number" === i) n.push(a);
                else if (Array.isArray(a)) {
                    if (a.length) {
                        var o = t.apply(null, a);
                        o && n.push(o);
                    }
                } else if ("object" === i) {
                    if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
                        n.push(a.toString());
                        continue;
                    }
                    for(var l in a)e1.call(a, l) && a[l] && n.push(l);
                }
            }
        }
        return n.join(" ");
    }
    E.exports ? (t.default = t, E.exports = t) : window.classNames = t;
}();
var C = w.exports, S = "textarea-module_textarea", T = "textarea-module_fullWidth", N = "textarea-module_disabled", k = "textarea-module_error", _ = function(e1) {
    var n, r = e1.classNames, a = e1.disabled, i = e1.error, o = e1.fullWidth, l = e1.placeholder, s = e1.value, c = x(e1, [
        "classNames",
        "disabled",
        "error",
        "fullWidth",
        "placeholder",
        "value"
    ]), d = C(S, ((n = {})[N] = a, n[k] = null == i ? void 0 : i.show, n[T] = o, n), null == r ? void 0 : r.textarea);
    return /*#__PURE__*/ t.createElement("textarea", y({
        "data-testid": "Textarea",
        placeholder: l,
        className: d,
        disabled: a,
        value: s
    }, c));
}, O = {
    base: "base-button-module_base",
    disabled: "base-button-module_disabled",
    fullWidth: "base-button-module_fullWidth",
    small: "base-button-module_small",
    medium: "base-button-module_medium",
    spinnerSvg: "base-button-module_spinnerSvg"
}, M = "loading-spinner-module_loadingSpinner", P = "loading-spinner-module_foregroundCircle", L = "loading-spinner-module_backgroundCircle", I = function(e1) {
    var n = e1.size, r = void 0 === n ? 32 : n, a = e1.classNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        className: C(M, null == a ? void 0 : a.svg),
        xmlns: "https://www.w3.org/2000/svg",
        width: r,
        height: r,
        viewBox: "0 0 32 32",
        "data-testid": "LoadingSpinner/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "11",
        className: C(L, null == a ? void 0 : a.circleBackground),
        "data-testid": "LoadingSpinner/svg/circle"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
        className: C(P, null == a ? void 0 : a.circleForeground),
        "data-testid": "LoadingSpinner/svg/path"
    }));
}, z = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, r) {
    var a, i, o, l, s = e1.element, c = void 0 === s ? "button" : s, d = e1.href, u = e1.size, p = void 0 === u ? "large" : u, m = e1.disabled, f = void 0 !== m && m, v = e1.isLoading, h = void 0 !== v && v, g = e1.isFullWidth, b = void 0 !== g && g, E = e1.classNames, w = e1.children, S = x(e1, [
        "element",
        "href",
        "size",
        "disabled",
        "isLoading",
        "isFullWidth",
        "classNames",
        "children"
    ]), T = C(O.base, ((a = {})[O.fullWidth] = b, a[O.disabled] = f, a[O.small] = "small" === p, a[O.medium] = "medium" === p, a[O.link] = "a" === c, a), null == E ? void 0 : E.button), N = {
        svg: C(O.spinnerSvg, null === (i = null == E ? void 0 : E.loadingSpinner) || void 0 === i ? void 0 : i.svg),
        circleForeground: null === (o = null == E ? void 0 : E.loadingSpinner) || void 0 === o ? void 0 : o.circleForeground,
        circleBackground: null === (l = null == E ? void 0 : E.loadingSpinner) || void 0 === l ? void 0 : l.circleBackground
    }, k = c, _ = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(w).map(function(e1, n) {
        return "string" == typeof e1 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: "string_".concat(n)
        }, e1) : e1;
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(k, y({
        className: T,
        href: d,
        "data-testid": "BaseButton/button",
        disabled: f
    }, S, {
        ref: r
    }), h && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(I, {
        size: 16,
        classNames: N
    }), _);
}), F = "primary-module_button", D = "primary-module_disabled", B = "primary-module_alternative", A = "primary-module_spinnerCircleForeground", W = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, n) {
    var r, a, i, o = e1.size, l = void 0 === o ? "large" : o, s = e1.disabled, c = void 0 !== s && s, d = e1.variant, u = void 0 === d ? "default" : d, p = e1.classNames, m = e1.children, f = x(e1, [
        "size",
        "disabled",
        "variant",
        "classNames",
        "children"
    ]), v = C(F, ((r = {})[D] = c, r[B] = "alternative" === u, r)), h = {
        button: C(v, null == p ? void 0 : p.button),
        loadingSpinner: y(y({}, null == p ? void 0 : p.loadingSpinner), {
            circleForeground: C(A, null === (i = null == p ? void 0 : p.loadingSpinner) || void 0 === i ? void 0 : i.circleForeground, (a = {}, a[B] = "alternative" === u, a))
        })
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(z, y({
        size: l,
        disabled: c,
        classNames: h
    }, f, {
        ref: n
    }), m);
}), j = "secondary-module_button", R = "secondary-module_disabled", $ = "secondary-module_alternative", H = "secondary-module_spinnerCircleForeground", G = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e1, n) {
    var r, a, i, o = e1.size, l = void 0 === o ? "large" : o, s = e1.disabled, c = void 0 !== s && s, d = e1.variant, u = void 0 === d ? "default" : d, p = e1.classNames, m = e1.children, f = x(e1, [
        "size",
        "disabled",
        "variant",
        "classNames",
        "children"
    ]), v = C(j, ((r = {})[R] = c, r[$] = "alternative" === u, r)), h = {
        button: C(v, null == p ? void 0 : p.button),
        loadingSpinner: y(y({}, null == p ? void 0 : p.loadingSpinner), {
            circleForeground: C(H, null === (i = null == p ? void 0 : p.loadingSpinner) || void 0 === i ? void 0 : i.circleForeground, (a = {}, a[$] = "alternative" === u, a))
        })
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(z, y({
        size: l,
        disabled: c,
        classNames: h
    }, f, {
        ref: n
    }), m);
}), U = "warning-module_button", V = "warning-module_disabled", q = "warning-module_spinnerCircleForeground", Y = function(e1) {
    var n, r, a = e1.size, i = void 0 === a ? "large" : a, o = e1.disabled, l = void 0 !== o && o, s = e1.classNames, c = e1.children, d = x(e1, [
        "size",
        "disabled",
        "classNames",
        "children"
    ]), u = {
        button: C(U, null == s ? void 0 : s.button, (n = {}, n[V] = l, n)),
        loadingSpinner: y(y({}, null == s ? void 0 : s.loadingSpinner), {
            circleForeground: C(q, null === (r = null == s ? void 0 : s.loadingSpinner) || void 0 === r ? void 0 : r.circleForeground)
        })
    };
    return /*#__PURE__*/ t.createElement(z, y({
        size: i,
        disabled: l,
        classNames: u
    }, d), c);
}, X = "text-module_button", K = "text-module_disabled", Q = "text-module_alternative", J = function(e1) {
    var n, r = e1.disabled, a = void 0 !== r && r, i = e1.classNames, o = e1.variant, l = e1.children, s = x(e1, [
        "disabled",
        "classNames",
        "variant",
        "children"
    ]), c = {
        button: C(X, null == i ? void 0 : i.button, ((n = {})[K] = a, n[Q] = "alternative" === o, n))
    };
    return /*#__PURE__*/ t.createElement(z, y({
        size: "large",
        disabled: a,
        classNames: c
    }, s), l);
}, Z = function(e1) {
    var t = e1.replace("#", "");
    if (!/^(?:[0-9a-fA-f]{3}){1,2}$/.test(t)) throw new Error("Not a hex code");
    return 3 === t.length ? t.split("").reduce(function(e1, t) {
        return "".concat(e1).concat(parseInt("".concat(t).concat(t), 16), ",");
    }, "").slice(0, -1) : t.match(/.{1,2}/g).reduce(function(e1, t) {
        return "".concat(e1).concat(parseInt(t, 16), ",");
    }, "").slice(0, -1);
}, ee = {
    transparent: "transparent",
    deepPurple: "#311C77",
    vividViolet: "#8C32BE",
    meteorite: "#5234B6",
    pearlescentPink: "#FF2DFF",
    toreaBay: "#1565C0",
    iceBlue: "#57E8FF",
    goGreen: "#8DFFBE",
    pureBlack: "#000000",
    mineShaft: "#2F2F2F",
    dove: "#656565",
    asphaltGrey: "#A9A9A9",
    gainsboro: "#E8E8E8",
    wildSand: "#F5F5F5",
    pampas: "#FAFAFA",
    pureWhite: "#FFFFFF",
    monza: "#D90700",
    linen: "#FBECE7",
    vidaLoca: "#3ABF1F",
    tara: "#E4F1E0",
    water: "#ECF5FA",
    morningFrost: "#F2F5FF",
    spindle: "#ADC9E9",
    haze: "#CAC5DC",
    warmOrange: "#F3755D",
    brightSun: "#FDD835",
    serenade: "#FCEDE0",
    earlyDawn: "#FFFAE7",
    acadia: "#000000",
    malibu: "#45C5EE",
    mercury: "#A9A9A9",
    alertWarning: "#FF7E0E",
    purpleTint: "#F8F6FF"
}, te = Object.entries(ee).filter(function(e1) {
    return "transparent" !== e1[0];
}).reduce(function(e1, t) {
    var n, r = t[0], a = t[1];
    return y(y({}, e1), ((n = {})["".concat(r, "-rgb")] = Z(a), n));
}, {}), ne = {
    "half-x": "4px",
    "1-x": "8px",
    "1-and-a-half-x": "12px",
    "2-x": "16px",
    "3-x": "24px",
    "4-x": "32px",
    "5-x": "40px",
    "6-x": "48px",
    "7-x": "56px",
    "8-x": "64px",
    "12-x": "96px",
    "20-x": "160px"
}, re = {
    xxxs: {
        min: 375,
        max: 0
    },
    xxs: {
        min: 0,
        max: 599
    },
    xs: {
        min: 600,
        max: 767
    },
    s: {
        min: 768,
        max: 1023
    },
    m: {
        min: 1024,
        max: 1439
    },
    l: {
        min: 1440,
        max: 1919
    },
    xl: {
        min: 1920,
        max: 1 / 0
    }
}, ae = {
    xxxs: "(min-width: ".concat(re.xxxs.min, "px)"),
    xxs: "(max-width: ".concat(re.xxs.max, "px)"),
    xs: "(min-width: ".concat(re.xs.min, "px)"),
    xsMax: "(max-width: ".concat(re.xs.max, "px)"),
    s: "(min-width: ".concat(re.s.min, "px)"),
    m: "(min-width: ".concat(re.m.min, "px)"),
    l: "(min-width: ".concat(re.l.min, "px)"),
    xl: "(min-width: ".concat(re.xl.min, "px)"),
    mediumPhone: "(min-height: ".concat(re.xxs.max, "px)"),
    mediumDesktop: "(min-height: ".concat(re.s.min, "px) and (min-width: ").concat(re.m.min, "px)")
}, ie = {
    "field-container": {
        "margin-bottom": ne["1-and-a-half-x"]
    },
    "form-field": {
        height: "48px",
        color: ee.deepPurple,
        padding: "".concat(ne["1-and-a-half-x"], " ").concat(ne["2-x"]),
        border: "1px solid ".concat(ee.asphaltGrey),
        "background-color": ee.pureWhite,
        "border-radius": "3px",
        "placeholder-color": ee.dove,
        "hover-border-color": ee.mineShaft,
        "focus-border-color": ee.deepPurple,
        "disabled-color": ee.dove,
        "disabled-background-color": ee.gainsboro,
        "error-border-color": ee.monza
    }
}, oe = {
    customProperties: {
        ds: {
            breakpoint: re,
            color: y(y({}, ee), te),
            opacities: {
                low: .25,
                medium: .5,
                high: .75
            },
            space: ne,
            dimensions: {
                slim: "1024px",
                max: "1280px"
            },
            font: {
                family: "'Buenos Aires', Avenir, Futura, Arial, SansSerif, sans-serif",
                size: {
                    "6xl": "72px",
                    "5xl": "56px",
                    "4xl": "42px",
                    "3xl": "32px",
                    xxl: "28px",
                    xl: "24px",
                    l: "22px",
                    m: "18px",
                    s: "16px",
                    xs: "14px",
                    "3xs": "12px",
                    "4xs": "10px"
                },
                weight: {
                    light: 200,
                    book: 300,
                    medium: 400,
                    semibold: 600,
                    bold: 700
                },
                "line-height": {
                    display: 1.35,
                    body: 1.55
                }
            },
            transitions: {
                "slide-outs": "250ms ease-in-out"
            },
            components: ie
        }
    },
    customMedia: ae
}, le = de;
function se(e1) {
    return e1 && e1.constructor && "function" == typeof e1.constructor.isBuffer && e1.constructor.isBuffer(e1);
}
function ce(e1) {
    return e1;
}
function de(e1, t) {
    const n = (t = t || {}).delimiter || ".", r = t.maxDepth, a = t.transformKey || ce, i = {};
    return function e1(o, l, s) {
        s = s || 1, Object.keys(o).forEach(function(c) {
            const d = o[c], u = t.safe && Array.isArray(d), p = Object.prototype.toString.call(d), m = se(d), f = "[object Object]" === p || "[object Array]" === p, v = l ? l + n + a(c) : a(c);
            if (!u && !m && f && Object.keys(d).length && (!t.maxDepth || s < r)) return e1(d, v, s + 1);
            i[v] = d;
        });
    }(e1), i;
}
de.flatten = de, de.unflatten = function e1(t, n) {
    const r = (n = n || {}).delimiter || ".", a = n.overwrite || !1, i = n.transformKey || ce, o = {};
    if (se(t) || "[object Object]" !== Object.prototype.toString.call(t)) return t;
    function l(e1) {
        const t = Number(e1);
        return isNaN(t) || -1 !== e1.indexOf(".") || n.object ? e1 : t;
    }
    return t = Object.keys(t).reduce(function(e1, a) {
        const i = Object.prototype.toString.call(t[a]);
        return !("[object Object]" === i || "[object Array]" === i) || function(e1) {
            const t = Object.prototype.toString.call(e1), n = "[object Array]" === t, r = "[object Object]" === t;
            if (!e1) return !0;
            if (n) return !e1.length;
            if (r) return !Object.keys(e1).length;
        }(t[a]) ? (e1[a] = t[a], e1) : function(e1, t, n) {
            return Object.keys(n).reduce(function(t, a) {
                return t[e1 + r + a] = n[a], t;
            }, t);
        }(a, e1, de(t[a], n));
    }, {}), Object.keys(t).forEach(function(s) {
        const c = s.split(r).map(i);
        let d = l(c.shift()), u = l(c[0]), p = o;
        for(; void 0 !== u;){
            if ("__proto__" === d) return;
            const e2 = Object.prototype.toString.call(p[d]), t1 = "[object Object]" === e2 || "[object Array]" === e2;
            if (!a && !t1 && void 0 !== p[d]) return;
            (a && !t1 || !a && null == p[d]) && (p[d] = "number" != typeof u || n.object ? {} : []), p = p[d], c.length > 0 && (d = l(c.shift()), u = l(c[0]));
        }
        p[d] = e1(t[s], n);
    }), o;
};
var ue, pe, me = function(e1, t) {
    var n = le(e1, {
        delimiter: "-"
    });
    return Object.keys(n).reduce(function(e1, r) {
        var a;
        return y(y({}, e1), ((a = {})["".concat(t).concat(r)] = n[r], a));
    }, {});
}, fe = function(e1) {
    var t = e1.customMedia, n = e1.customProperties;
    return {
        customMedia: me(t, "--"),
        customProperties: me(n, "--")
    };
};
!function(e1) {
    e1.cinchCare = "cinch-care", e1.galaxy = "galaxy", e1.newGalaxy = "new-galaxy", e1.ocean = "ocean";
}(ue || (ue = {})), function(e1) {
    e1.acceleration = "acceleration", e1.alert = "alert", e1["arrow-right"] = "arrow-right", e1["arrows-left-right"] = "arrows-left-right", e1["arrows-up-down"] = "arrows-up-down", e1.basket = "basket", e1["battery-75"] = "battery-75", e1["battery-full"] = "battery-full", e1["body-type-convertible"] = "body-type-convertible", e1["body-type-coupe"] = "body-type-coupe", e1["body-type-estate"] = "body-type-estate", e1["body-type-hatchback"] = "body-type-hatchback", e1["body-type-mpv"] = "body-type-mpv", e1["body-type-saloon"] = "body-type-saloon", e1["body-type-suv"] = "body-type-suv", e1.building = "building", e1.calculator = "calculator", e1.calendar = "calendar", e1["call-back"] = "call-back", e1.camera = "camera", e1.card = "card", e1.cash = "cash", e1.charge = "charge", e1.chat = "chat", e1["check-circle"] = "check-circle", e1["check-square"] = "check-square", e1["chevron-right"] = "chevron-right", e1["chevron-down"] = "chevron-down", e1["chevron-left"] = "chevron-left", e1["cinchCare-servicing"] = "cinchCare-servicing", e1["cinchCare-breakdown"] = "cinchCare-breakdown", e1["cinchCare-warranty"] = "cinchCare-warranty", e1["close-circle"] = "close-circle", e1["closed-padlock"] = "closed-padlock", e1.co2 = "co2", e1.collections = "collections", e1.copy = "copy", e1.covid = "covid", e1["covid-circle"] = "covid-circle", e1.cross = "cross", e1.cvc = "cvc", e1.doors = "doors", e1.electric = "electric", e1.engine = "engine", e1["engine-power"] = "engine-power", e1.error = "error", e1.edit = "edit", e1["edit-v2"] = "edit-v2", e1["external-link"] = "external-link", e1.facebook = "facebook", e1.features = "features", e1.filter = "filter", e1.finance = "finance", e1.fuel = "fuel", e1["fuel-pump"] = "fuel-pump", e1["full-screen"] = "full-screen", e1.gallery = "gallery", e1.go = "go", e1.heart = "heart", e1["heart-outline"] = "heart-outline", e1["home-delivery"] = "home-delivery", e1.info = "info", e1.instagram = "instagram", e1.linkedin = "linkedin", e1.learner = "learner", e1.lightbulb = "lightbulb", e1.location = "location", e1.mail = "mail", e1.mask = "mask", e1.menu = "menu", e1.mileage = "mileage", e1["new-tab"] = "new-tab", e1["number-1"] = "number-1", e1["number-2"] = "number-2", e1["number-3"] = "number-3", e1["number-4"] = "number-4", e1["oxford-shield"] = "oxford-shield", e1["open-padlock"] = "open-padlock", e1["our-commitment"] = "our-commitment", e1["owner-user"] = "owner-user", e1.paint = "paint", e1.parent = "parent", e1.play = "play", e1["play-v2"] = "play-v2", e1.plus = "plus", e1.phone = "phone", e1["question-mark"] = "question-mark", e1.range = "range", e1["reg-plate"] = "reg-plate", e1.referrals = "referrals", e1.rotate = "rotate", e1["rotate-360"] = "rotate-360", e1["running-cost"] = "running-cost", e1.seats = "seats", e1.search = "search", e1.settings = "settings", e1.share = "share", e1.shield = "shield", e1["shield-heart"] = "shield-heart", e1.smartphone = "smartphone", e1.speech = "speech", e1.star = "star", e1["star-outline"] = "star-outline", e1.square = "square", e1.target = "target", e1.tick = "tick", e1.time = "time", e1.transmission = "transmission", e1.trash = "trash", e1.twitter = "twitter", e1.user = "user", e1["vehicle-drive-type"] = "vehicle-drive-type", e1["vehicle-front"] = "vehicle-front", e1["vehicle-side"] = "vehicle-side", e1["vehicle-valuation"] = "vehicle-valuation", e1.wallet = "wallet", e1.whatsapp = "whatsapp", e1.x = "x", e1.youtube = "youtube";
}(pe || (pe = {}));
var ve = oe.customProperties.ds.color, he = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(e1) {
    var n = e1.id, r = e1.name, a = e1.color, l = e1.gradient, s = e1.size, c = e1.className, d = x(e1, [
        "id",
        "name",
        "color",
        "gradient",
        "size",
        "className"
    ]), u = a ? ve[a] : "currentColor", p = "-".concat(n || Math.random().toString(36).substr(2, 9)), m = {
        "aria-hidden": !0,
        focusable: !1,
        fill: l ? "url(#".concat(r, "-").concat(ue[l]).concat(p, ")") : u,
        width: s || 24,
        height: s || 24,
        pointerEvents: "none"
    }, f = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(function() {
        return __webpack_require__(35473)("./".concat(pe[r], ".svg"));
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Suspense, {
        fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", y({
        className: c,
        viewBox: "0 0 ".concat(s || 24, " ").concat(s || 24),
        "data-testid": "SvgIcon/".concat(r)
    }, m, d), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(f, {
        width: "100%",
        height: "100%"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
        id: "".concat(r, "-cinch-care").concat(p),
        x1: "87.857%",
        x2: "46.1505%",
        y1: "85.7825%",
        y2: "6.639%",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        stopColor: "#4FD9FB"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: ".612",
        stopColor: "#7947C1"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
        id: "".concat(r, "-galaxy").concat(p),
        y2: "100%"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "0",
        stopColor: "#311C77"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "1",
        stopColor: "#FF2DFF"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
        id: "".concat(r, "-ocean").concat(p),
        y2: "100%"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "0",
        stopColor: "#57E8FF"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "1",
        stopColor: "#8DFFBE"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
        id: "".concat(r, "-new-galaxy").concat(p),
        y2: "100%"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "0",
        stopColor: "#51339E"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
        offset: "1",
        stopColor: "#AE30C5"
    })))));
});
he.displayName = "SvgIconWrapper";
var ge, be, ye, xe, Ee, we = function(e1) {
    var n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), r = n[0], a = n[1];
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        a(!0);
    }, []), r ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(he, y({}, e1)) : null;
}, Ce = "field-label-module_label", Se = "field-label-module_labelVisuallyHidden", Te = {
    textSize6XL: "text-module_textSize6XL",
    textSize5XL: "text-module_textSize5XL",
    textSize4XL: "text-module_textSize4XL",
    textSize3XL: "text-module_textSize3XL",
    textSizeXXL: "text-module_textSizeXXL",
    textSizeXL: "text-module_textSizeXL",
    textSizeL: "text-module_textSizeL",
    textSizeM: "text-module_textSizeM",
    textSizeS: "text-module_textSizeS",
    textSizeXS: "text-module_textSizeXS",
    textSize3XS: "text-module_textSize3XS",
    textSize4XS: "text-module_textSize4XS",
    textSizeFixed5XL: "text-module_textSizeFixed5XL",
    textSizeFixed4XL: "text-module_textSizeFixed4XL",
    textSizeFixed3XL: "text-module_textSizeFixed3XL",
    textSizeFixedXXL: "text-module_textSizeFixedXXL",
    textSizeFixedXL: "text-module_textSizeFixedXL",
    textSizeFixedL: "text-module_textSizeFixedL",
    textSizeFixedM: "text-module_textSizeFixedM",
    textSizeFixedS: "text-module_textSizeFixedS",
    textSizeFixedXS: "text-module_textSizeFixedXS",
    textSizeFixed3XS: "text-module_textSizeFixed3XS",
    textSizeFixed4XS: "text-module_textSizeFixed4XS",
    textWeightLIGHT: "text-module_textWeightLIGHT",
    textWeightBOOK: "text-module_textWeightBOOK",
    textWeightMEDIUM: "text-module_textWeightMEDIUM",
    textWeightSEMIBOLD: "text-module_textWeightSEMIBOLD",
    textWeightBOLD: "text-module_textWeightBOLD",
    textFontStyleNORMAL: "text-module_textFontStyleNORMAL",
    textFontStyleITALIC: "text-module_textFontStyleITALIC",
    textLineHeightBODY: "text-module_textLineHeightBODY",
    textLineHeightDISPLAY: "text-module_textLineHeightDISPLAY"
};
!function(e1) {
    e1["6xl"] = "6xl", e1["5xl"] = "5xl", e1["4xl"] = "4xl", e1["3xl"] = "3xl", e1.xxl = "xxl", e1.xl = "xl", e1.l = "l", e1.m = "m", e1.s = "s", e1.xs = "xs", e1["3xs"] = "3xs", e1["4xs"] = "4xs";
}(ge || (ge = {})), function(e1) {
    e1.light = "light", e1.book = "book", e1.medium = "medium", e1.semibold = "semibold", e1.bold = "bold";
}(be || (be = {})), function(e1) {
    e1.display = "display", e1.body = "body";
}(ye || (ye = {})), function(e1) {
    e1.italic = "italic", e1.normal = "normal";
}(xe || (xe = {})), function(e1) {
    e1.test = "test", e1.mainTitle = "mainTitle", e1.vehicleTitle = "vehicleTitle", e1.vehicleSubTitle = "vehicleSubTitle", e1.vehiclePrice = "vehiclePrice", e1.vehicleBody = "vehicleBody", e1.cardTitle = "cardTitle", e1.menuTitle = "menuTitle", e1.menuItem = "menuItem", e1.bullet = "bullet", e1.cardFocalText = "cardFocalText", e1.body1 = "body1", e1.body2 = "body2", e1.button = "button", e1.caption = "caption", e1.smallCaption = "smallCaption", e1.overline = "overline", e1.fieldHelpText = "fieldHelpText";
}(Ee || (Ee = {}));
var Ne = {
    test: {
        fontSize: ge.xxl,
        fontWeight: be.bold,
        lineHeight: ye.display,
        fontStyle: xe.italic
    },
    mainTitle: {
        fontSize: ge.xxl,
        fontWeight: be.bold,
        lineHeight: ye.display
    },
    vehicleTitle: {
        fontSize: ge["4xl"],
        fontWeight: be.bold
    },
    vehicleSubTitle: {
        fontSize: ge.xl,
        fontWeight: be.bold
    },
    vehiclePrice: {
        fontSize: ge["3xl"],
        fontWeight: be.semibold
    },
    vehicleBody: {
        fontSize: ge.xs,
        fontWeight: be.medium
    },
    cardTitle: {
        fontSize: ge.m,
        fontWeight: be.semibold
    },
    menuTitle: {
        fontSize: ge.m,
        fontWeight: be.semibold
    },
    menuItem: {
        fontSize: ge.m,
        fontWeight: be.bold
    },
    bullet: {
        fontSize: ge.xs,
        fontWeight: be.book
    },
    cardFocalText: {
        fontSize: ge["3xl"],
        fontWeight: be.bold
    },
    body1: {
        fontSize: ge.m,
        fontWeight: be.book
    },
    body2: {
        fontSize: ge.s,
        fontWeight: be.medium
    },
    button: {
        fontSize: ge.s,
        fontWeight: be.medium
    },
    caption: {
        fontSize: ge["3xs"],
        fontWeight: be.book
    },
    smallCaption: {
        fontSize: ge["3xs"],
        fontWeight: be.medium
    },
    overline: {
        fontSize: ge["3xs"],
        fontWeight: be.book
    },
    fieldHelpText: {
        fontSize: ge["3xs"],
        fontWeight: be.book
    }
}, ke = function(e1) {
    var n = e1.children, r = e1.fontSize, a = void 0 === r ? "m" : r, i = e1.fontSizeFixed, o = e1.fontWeight, l = void 0 === o ? "medium" : o, s = e1.fontStyle, c = void 0 === s ? "normal" : s, d = e1.lineHeight, u = void 0 === d ? "body" : d, p = e1.element, m = void 0 === p ? "p" : p, f = e1.type, v = e1.className, h = x(e1, [
        "children",
        "fontSize",
        "fontSizeFixed",
        "fontWeight",
        "fontStyle",
        "lineHeight",
        "element",
        "type",
        "className"
    ]), g = m, b = f ? Ne[f] : {}, E = C([
        Te["textSize".concat(b.fontSize ? b.fontSize.toUpperCase() : a.toUpperCase())]
    ], i && [
        Te["textSizeFixed".concat(i.toUpperCase())]
    ], [
        Te["textWeight".concat(b.fontWeight ? b.fontWeight.toUpperCase() : l.toUpperCase())]
    ], [
        Te["textLineHeight".concat(b.lineHeight ? b.lineHeight.toUpperCase() : u.toUpperCase())]
    ], [
        Te["textFontStyle".concat(b.fontStyle ? b.fontStyle.toUpperCase() : c.toUpperCase())]
    ], v);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(g, y({
        className: E
    }, h), n);
}, _e = function(e1) {
    var n = e1.element, r = void 0 === n ? "label" : n, a = e1.htmlFor, i = e1.children, o = e1.classNames, l = e1.optional, s = e1.visuallyHidden, c = void 0 !== s && s, d = C(Ce, null == o ? void 0 : o.label, c && Se);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        element: r,
        htmlFor: a,
        className: d,
        "data-testid": "FormLabel",
        fontWeight: be.semibold
    }, i, l && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        element: "span",
        fontStyle: xe.italic,
        className: null == o ? void 0 : o.optionalText,
        "data-testid": "FormLabel/OptionalText"
    }, "\xa0(optional)"));
}, Oe = {
    wrapper: "checkbox-module_wrapper",
    disabled: "checkbox-module_disabled",
    checkedIcon: "checkbox-module_checkedIcon",
    uncheckedIcon: "checkbox-module_uncheckedIcon",
    error: "checkbox-module_error",
    input: "checkbox-module_input",
    label: "checkbox-module_label",
    description: "checkbox-module_description"
}, Me = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, n) {
    var r, a, i, o, l = e1.id, s = e1.checked, c = e1.classNames, d = e1.disabled, u = e1.error, p = e1.label, m = e1.name, f = e1.value, v = e1.optional, h = e1.description, g = x(e1, [
        "id",
        "checked",
        "classNames",
        "disabled",
        "error",
        "label",
        "name",
        "value",
        "optional",
        "description"
    ]), b = C(Oe.wrapper, null == c ? void 0 : c.wrapper, ((r = {})[Oe.disabled] = d, r)), E = C(Oe.label, null == c ? void 0 : c.label, ((a = {})[Oe.disabled] = d, a[Oe.error] = null == u ? void 0 : u.show, a)), w = C(Oe.icon, null == c ? void 0 : c.icon, ((i = {})[Oe.disabled] = d, i[Oe.error] = null == u ? void 0 : u.show, i)), S = (o = w, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: "check-square",
        className: C(Oe.checkedIcon, o)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: "square",
        className: C(Oe.uncheckedIcon, o)
    })));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: b,
        "data-testid": "Checkbox/Wrapper"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", y({
        id: l || m,
        type: "checkbox",
        "data-testid": "Checkbox/Input",
        checked: s,
        disabled: d,
        value: f,
        className: Oe.input,
        name: m,
        ref: n
    }, g)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_e, {
        htmlFor: l || m,
        classNames: {
            label: E
        },
        optional: v
    }, S, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, p, (null == h ? void 0 : h.length) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        element: "span",
        fontSizeFixed: "3xs",
        className: Oe.description
    }, h))));
}), Pe = "field-error-module_error", Le = "field-error-module_icon", Ie = "field-error-module_message", ze = function(e1) {
    return e1 ? "".concat(e1.slice(0, 1).toUpperCase()).concat(e1.slice(1)) : e1;
}, Fe = function(e1) {
    var n = e1.show, r = e1.collapse, a = void 0 !== r && r, i = e1.message, o = e1.classNames;
    return n && i ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Pe, null == o ? void 0 : o.container),
        "data-testid": "FormFieldError/Container"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: "error",
        size: 12,
        className: C(Le, null == o ? void 0 : o.icon)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        element: "span",
        className: C(Ie, null == o ? void 0 : o.message),
        fontSizeFixed: ge.xs,
        role: "alert",
        "data-testid": "FormFieldError/Message"
    }, ze(i))) : a ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Pe, null == o ? void 0 : o.container),
        "data-testid": "FormFieldError/Container"
    }, "\xa0");
}, De = "field-help-text-module_helpText", Be = function(e1) {
    var n = e1.className, r = e1.children, a = C(De, n);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        className: a,
        fontSizeFixed: ge.xs,
        "data-testid": "FieldHelpText/Text"
    }, r);
}, Ae = {
    inlineRadioText: "inline-radio-module_inlineRadioText",
    inlineRadioInput: "inline-radio-module_inlineRadioInput"
}, We = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.forwardRef(function(e1, n) {
    var r = e1.children, a = e1.htmlFor, i = e1.classNames, o = e1.name, l = e1.checked, s = e1.value, c = x(e1, [
        "children",
        "htmlFor",
        "classNames",
        "name",
        "checked",
        "value"
    ]), d = C(Ae.inlineRadioText, null == i ? void 0 : i.label), u = C(Ae.inlineRadioInput, null == i ? void 0 : i.input);
    return /*#__PURE__*/ t.createElement("div", {
        className: C(Ae.inlineRadio, null == i ? void 0 : i.container)
    }, /*#__PURE__*/ t.createElement("input", y({
        type: "radio",
        name: o,
        id: a,
        className: u,
        defaultChecked: l,
        value: s,
        ref: n
    }, c)), /*#__PURE__*/ t.createElement("label", {
        htmlFor: a,
        className: d
    }, r));
}))), je = "list-module_list", Re = "list-module_listItem", $e = "list-module_listItemWithNumbers", He = function(e1) {
    var n = e1.element, r = void 0 === n ? "ul" : n, a = e1.classNames, i = e1.items, o = e1.textProps;
    return /*#__PURE__*/ t.createElement(r, {
        className: C(je, null == a ? void 0 : a.list)
    }, i.map(function(e1, n) {
        return /*#__PURE__*/ t.createElement(ke, y({
            element: "li",
            className: C(Re, "ol" === r && $e, null == a ? void 0 : a.item),
            key: n,
            fontSize: "m",
            fontWeight: "book"
        }, o), /*#__PURE__*/ t.createElement("span", null, "function" == typeof e1 ? e1() : e1));
    }));
}, Ge = "select-module_select", Ue = "select-module_placeholder", Ve = "select-module_disabled", qe = "select-module_error", Ye = "select-module_option", Xe = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, n) {
    var r, a = e1.options, i = e1.placeholder, o = e1.placeholderValue, l = void 0 === o ? "" : o, s = e1.disabled, c = e1.value, d = e1.error, u = void 0 === d ? {
        show: !1,
        collapse: !1
    } : d, p = e1.classNames, m = x(e1, [
        "options",
        "placeholder",
        "placeholderValue",
        "disabled",
        "value",
        "error",
        "classNames"
    ]), f = C(Ge, ((r = {})[Ve] = s, r[qe] = null == u ? void 0 : u.show, r[Ue] = i, r), null == p ? void 0 : p.select), v = C(Ye, null == p ? void 0 : p.option);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("select", y({
        className: f,
        value: c,
        disabled: s,
        ref: n
    }, m), i && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
        value: l,
        hidden: !l,
        "data-testid": "SelectField/Placeholder"
    }, i), a.map(function(e1) {
        var n = e1.label, r = e1.value, a = e1.disabled;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
            key: r,
            value: r,
            disabled: a,
            "data-testid": "SelectField/Option",
            className: v
        }, n);
    }));
}), Ke = {
    displayXl: ge["5xl"],
    display: ge["4xl"],
    h1: ge["3xl"],
    h2: ge.xxl,
    h3: ge.xl,
    h4: ge.l,
    h5: ge.m,
    h6: ge.s
}, Qe = function(e1) {
    var n = e1.element, r = void 0 === n ? "h2" : n, a = e1.fontSize, i = e1.className, o = e1.children, l = x(e1, [
        "element",
        "fontSize",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, y({
        element: r,
        fontSize: Ke[a || r],
        className: i,
        lineHeight: ye.display,
        fontWeight: be.bold
    }, l), o);
}, Je = "text-link-module_textLink", Ze = "text-link-module_textLinkOnDark", et = "text-link-module_textLinkDisabled", tt = "text-link-module_textLinkDisabledOnDark", nt = "text-link-module_textLinkVariantOnlyWhite", rt = "text-link-module_textLinkTextNoLine", at = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, n) {
    var r = e1.className, a = e1.element, i = void 0 === a ? "a" : a, o = e1.children, l = e1.textProps, s = e1.isDisabled, c = e1.isVariant, d = e1.isOnlyWhite, u = e1.hasNoLine, p = x(e1, [
        "className",
        "element",
        "children",
        "textProps",
        "isDisabled",
        "isVariant",
        "isOnlyWhite",
        "hasNoLine"
    ]), m = i, f = C(Je, u ? rt : void 0, s ? et : void 0, c ? Ze : void 0, s && c ? tt : void 0, d ? nt : void 0, r), v = C(null == l ? void 0 : l.className), h = "_blank" === (null == p ? void 0 : p.target) ? {
        rel: "noreferrer"
    } : void 0;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(m, y({
        className: f
    }, p, h, {
        ref: n
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, y({
        element: "span"
    }, l, {
        className: v
    }), o));
});
function it(e1, t) {
    for(var n = [], r = 2; r < arguments.length; r++)n[r - 2] = arguments[r];
    if ("Enter" === e1.key || " " === e1.key) return t.apply(void 0, n);
}
var ot = "screen-reader-text-module_visuallyHidden", lt = function(e1) {
    var n = e1.children, r = e1.element, a = void 0 === r ? "span" : r, i = e1.className, o = x(e1, [
        "children",
        "element",
        "className"
    ]);
    return /*#__PURE__*/ t.createElement(a, y({
        className: C(ot, i)
    }, o), n);
}, st = "skip-links-module_textLink", ct = "skip-links-module_skipLinks", dt = function(e1) {
    var n = e1.copy, r = e1.to;
    return /*#__PURE__*/ t.createElement(lt, {
        key: r,
        element: "a",
        className: C(ct, st),
        href: "#".concat(r)
    }, n);
}, ut = function(e1) {
    var n = e1.links, r = e1.showSkipToFooter, a = void 0 === r || r;
    return /*#__PURE__*/ t.createElement(c, null, /*#__PURE__*/ t.createElement(lt, {
        element: "a",
        className: C(ct, st),
        href: "#main-content"
    }, "skip to main content"), n && n.map(dt), a && /*#__PURE__*/ t.createElement(lt, {
        element: "a",
        className: C(ct, st),
        href: "#main-footer"
    }, "skip to footer"));
}, pt = "content-block-styles-module_contentBlockContainer", mt = function(e1) {
    var n = e1.children, r = e1.className, a = e1.element, i = void 0 === a ? "div" : a, o = C(pt, r), l = i;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(l, {
        className: o
    }, n);
}, ft = "rich-text-styles-module_richTextContainer", vt = function(e1) {
    var n = e1.children, r = e1.className, a = C(ft, r);
    return /*#__PURE__*/ t.createElement("div", {
        className: a
    }, n);
}, ht = "toggle-module_toggle", gt = "toggle-module_toggleLabelContainer", bt = "toggle-module_toggleInput", yt = "toggle-module_toggleLabel", xt = function(e1) {
    var n = e1.options, r = e1.name, a = e1.onSelected, i = e1.classNames;
    return /*#__PURE__*/ t.createElement("div", {
        className: C(ht, null == i ? void 0 : i.container)
    }, n.map(function(e1) {
        return /*#__PURE__*/ t.createElement("label", {
            className: C(gt, null == i ? void 0 : i.labelContainer),
            key: e1.id,
            htmlFor: e1.id
        }, /*#__PURE__*/ t.createElement("input", y({
            className: C(bt, null == i ? void 0 : i.input),
            type: "radio",
            defaultChecked: e1.defaultChecked,
            name: r,
            onClick: a
        }, e1)), /*#__PURE__*/ t.createElement("span", {
            className: C(yt, null == i ? void 0 : i.label)
        }, e1.label));
    }));
}, Et = {
    cardWrapper: "card-wrapper-module_cardWrapper"
}, wt = function(e1) {
    var r = e1.children, a = e1.className, i = C(Et.cardWrapper, a);
    return /*#__PURE__*/ t.createElement("div", {
        className: i,
        "data-testid": "CardWrapper"
    }, n.map(r, function(e1) {
        return /*#__PURE__*/ d(e1, {
            className: Et.cardWrapperChildElement
        });
    }));
}, Ct = "base-card-module_card", St = "base-card-module_cardBoxShadow", Tt = "base-card-module_cardBorder", Nt = function(e1) {
    var n, r = e1.children, a = e1.className, i = e1.element, o = void 0 === i ? "div" : i, l = e1.hasBoxShadow, s = void 0 !== l && l, c = e1.hasBorder, d = void 0 !== c && c, u = x(e1, [
        "children",
        "className",
        "element",
        "hasBoxShadow",
        "hasBorder"
    ]), p = o, m = C(((n = {})[St] = s, n[Tt] = d, n), a, Ct);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(p, y({
        className: m,
        "data-testid": "Atoms/Base-Card"
    }, u), r);
}, kt = "icon-card-module_iconCard", _t = "icon-card-module_heading", Ot = "icon-card-module_boxShadow", Mt = function(e1) {
    var n = e1.iconColor, r = e1.iconGradient, a = e1.iconName, i = e1.heading, o = e1.bodyText, l = e1.children, s = e1.className, c = e1.hasBoxShadow, d = e1.hasBorder;
    return /*#__PURE__*/ t.createElement(Nt, {
        className: C(kt, s, c && Ot),
        "data-testid": "IconCard",
        hasBorder: d
    }, /*#__PURE__*/ t.createElement(we, {
        name: a,
        color: n || void 0,
        gradient: r || void 0,
        size: 32
    }), /*#__PURE__*/ t.createElement(ke, {
        element: "h2",
        fontWeight: "semibold",
        fontSize: "l",
        className: _t
    }, i), o && /*#__PURE__*/ t.createElement(ke, {
        element: "p",
        fontSizeFixed: "m"
    }, o), l);
}, Pt = "card-with-icon-module_cardWithIconWrapper";
oe.customProperties.ds.color;
var Lt = function(e1) {
    var n = e1.iconName, r = e1.iconSize, a = void 0 === r ? 32 : r, i = e1.iconColor, o = e1.iconGradient, l = e1.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        className: C(Pt, l),
        "data-testid": "CardWithIcon"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: n,
        size: a,
        color: i,
        gradient: o
    }));
}, It = function(e1) {
    return e1.charAt(0).toUpperCase() + e1.slice(1);
}, zt = {
    button: "cta-button-module_button",
    buttonPrimary: "cta-button-module_buttonPrimary",
    buttonLoading: "cta-button-module_buttonLoading",
    buttonPrimaryVariant: "cta-button-module_buttonPrimaryVariant",
    buttonSecondary: "cta-button-module_buttonSecondary",
    buttonSecondaryVariant: "cta-button-module_buttonSecondaryVariant",
    buttonSizeSmall: "cta-button-module_buttonSizeSmall",
    buttonSizeMedium: "cta-button-module_buttonSizeMedium",
    buttonSizeLarge: "cta-button-module_buttonSizeLarge",
    buttonContainer: "cta-button-module_buttonContainer",
    buttonFullWidthContainer: "cta-button-module_buttonFullWidthContainer",
    buttonIcon: "cta-button-module_buttonIcon",
    buttonIconLeft: "cta-button-module_buttonIconLeft",
    buttonIconRight: "cta-button-module_buttonIconRight"
}, Ft = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.memo(function(e1) {
    var n = e1.className, r = e1.children, a = e1.isLoading, i = e1.icon, o = e1.size, l = void 0 === o ? "medium" : o, s = e1.buttonStyle, c = void 0 === s ? "primary" : s, d = e1.iconRight, u = e1.spaceBetween, p = e1.type, m = void 0 === p ? "button" : p, f = x(e1, [
        "className",
        "children",
        "isLoading",
        "icon",
        "size",
        "buttonStyle",
        "iconRight",
        "spaceBetween",
        "type"
    ]), v = C(zt.button, n, a ? zt.buttonLoading : void 0, zt["buttonSize".concat(It(l))], zt["button".concat(It(c))]), h = C(zt.buttonContainer, u ? zt.buttonFullWidthContainer : void 0), g = function(e1) {
        return void 0 === e1 && (e1 = "left"), C(zt.buttonIcon, zt["buttonIcon".concat(It(e1))]);
    };
    return /*#__PURE__*/ t.createElement("button", y({
        type: m,
        className: v,
        disabled: a
    }, f), /*#__PURE__*/ t.createElement("span", {
        className: h
    }, i && !a && !d && /*#__PURE__*/ t.createElement(we, {
        name: i,
        className: g()
    }), a && !d && /*#__PURE__*/ t.createElement(I, {
        classNames: {
            svg: g()
        }
    }), r, a && d && /*#__PURE__*/ t.createElement(I, {
        classNames: {
            svg: g("right")
        }
    }), i && !a && d && /*#__PURE__*/ t.createElement(we, {
        name: i,
        className: g("right")
    })));
}))), Dt = {
    accordion: "accordion-module_accordion",
    accordionTitle: "accordion-module_accordionTitle",
    accordionItemContainer: "accordion-module_accordionItemContainer",
    accordionItemContainer__standard: "accordion-module_accordionItemContainer__standard",
    accordionItemContainer__alternative: "accordion-module_accordionItemContainer__alternative",
    accordionButton: "accordion-module_accordionButton",
    chevron: "accordion-module_chevron",
    chevronRotate: "accordion-module_chevronRotate",
    accordionContentContainer: "accordion-module_accordionContentContainer",
    accordionContentInnerContainer: "accordion-module_accordionContentInnerContainer",
    icon: "accordion-module_icon"
}, Bt = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.forwardRef(function(e1, n) {
    var r, a = e1.isExpanded, i = e1.id, o = e1.toggleExpanded, l = e1.buttonText, s = e1.totalItems, c = e1.setFocusActive, d = e1.buttonId, u = e1.sectionId, p = e1.iconType, m = e1.iconGradient, f = m || void 0, v = m ? void 0 : "deepPurple";
    return /*#__PURE__*/ t.createElement("h3", {
        className: Dt.accordionTitle
    }, /*#__PURE__*/ t.createElement("button", {
        type: "button",
        "aria-expanded": a,
        "aria-disabled": a,
        "aria-controls": "".concat(u, "-").concat(i),
        id: "".concat(d, "-").concat(i),
        "data-testid": "".concat(d, "-").concat(i),
        onClick: o,
        onKeyDown: function(e1) {
            var t = function(e1, t) {
                return {
                    40: function() {
                        return function(e1, t) {
                            return e1 === t ? 1 : e1 + 1;
                        }(e1, t);
                    },
                    38: function() {
                        return function(e1, t) {
                            return 1 === e1 ? t : e1 - 1;
                        }(e1, t);
                    },
                    36: function() {
                        return 1;
                    },
                    35: function() {
                        return t;
                    }
                };
            }(i, s), n = function(e1) {
                return {
                    13: function() {
                        return e1;
                    },
                    32: function() {
                        return e1;
                    }
                };
            }(i);
            return e1.keyCode in n ? (e1.preventDefault(), void o()) : e1.keyCode in t ? (e1.preventDefault(), void c(t[e1.keyCode]())) : void 0;
        },
        ref: n,
        className: Dt.accordionButton
    }, p ? /*#__PURE__*/ t.createElement(we, {
        name: p,
        className: Dt.icon,
        color: v,
        size: 24,
        gradient: f
    }) : null, l, /*#__PURE__*/ t.createElement(we, {
        name: "chevron-down",
        className: C(Dt.chevron, (r = {}, r[Dt.chevronRotate] = a, r)),
        color: "deepPurple",
        size: 16
    })));
})));
function At() {
    return At = Object.assign ? Object.assign.bind() : function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, At.apply(this, arguments);
}
function Wt(e1, t) {
    if (null == e1) return {};
    var n, r, a = {}, i = Object.keys(e1);
    for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (a[n] = e1[n]);
    return a;
}
function jt(e1, t) {
    return jt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
        return e1.__proto__ = t, e1;
    }, jt(e1, t);
}
function Rt(e1, t) {
    e1.prototype = Object.create(t.prototype), e1.prototype.constructor = e1, jt(e1, t);
}
var $t = {
    exports: {}
}, Ht = {
    exports: {}
}, Gt = {}, Ut = "function" == typeof Symbol && Symbol.for, Vt = Ut ? Symbol.for("react.element") : 60103, qt = Ut ? Symbol.for("react.portal") : 60106, Yt = Ut ? Symbol.for("react.fragment") : 60107, Xt = Ut ? Symbol.for("react.strict_mode") : 60108, Kt = Ut ? Symbol.for("react.profiler") : 60114, Qt = Ut ? Symbol.for("react.provider") : 60109, Jt = Ut ? Symbol.for("react.context") : 60110, Zt = Ut ? Symbol.for("react.async_mode") : 60111, en = Ut ? Symbol.for("react.concurrent_mode") : 60111, tn = Ut ? Symbol.for("react.forward_ref") : 60112, nn = Ut ? Symbol.for("react.suspense") : 60113, rn = Ut ? Symbol.for("react.suspense_list") : 60120, an = Ut ? Symbol.for("react.memo") : 60115, on = Ut ? Symbol.for("react.lazy") : 60116, ln = Ut ? Symbol.for("react.block") : 60121, sn = Ut ? Symbol.for("react.fundamental") : 60117, cn = Ut ? Symbol.for("react.responder") : 60118, dn = Ut ? Symbol.for("react.scope") : 60119;
function un(e1) {
    if ("object" == typeof e1 && null !== e1) {
        var t = e1.$$typeof;
        switch(t){
            case Vt:
                switch(e1 = e1.type){
                    case Zt:
                    case en:
                    case Yt:
                    case Kt:
                    case Xt:
                    case nn:
                        return e1;
                    default:
                        switch(e1 = e1 && e1.$$typeof){
                            case Jt:
                            case tn:
                            case on:
                            case an:
                            case Qt:
                                return e1;
                            default:
                                return t;
                        }
                }
            case qt:
                return t;
        }
    }
}
function pn(e1) {
    return un(e1) === en;
}
Gt.AsyncMode = Zt, Gt.ConcurrentMode = en, Gt.ContextConsumer = Jt, Gt.ContextProvider = Qt, Gt.Element = Vt, Gt.ForwardRef = tn, Gt.Fragment = Yt, Gt.Lazy = on, Gt.Memo = an, Gt.Portal = qt, Gt.Profiler = Kt, Gt.StrictMode = Xt, Gt.Suspense = nn, Gt.isAsyncMode = function(e1) {
    return pn(e1) || un(e1) === Zt;
}, Gt.isConcurrentMode = pn, Gt.isContextConsumer = function(e1) {
    return un(e1) === Jt;
}, Gt.isContextProvider = function(e1) {
    return un(e1) === Qt;
}, Gt.isElement = function(e1) {
    return "object" == typeof e1 && null !== e1 && e1.$$typeof === Vt;
}, Gt.isForwardRef = function(e1) {
    return un(e1) === tn;
}, Gt.isFragment = function(e1) {
    return un(e1) === Yt;
}, Gt.isLazy = function(e1) {
    return un(e1) === on;
}, Gt.isMemo = function(e1) {
    return un(e1) === an;
}, Gt.isPortal = function(e1) {
    return un(e1) === qt;
}, Gt.isProfiler = function(e1) {
    return un(e1) === Kt;
}, Gt.isStrictMode = function(e1) {
    return un(e1) === Xt;
}, Gt.isSuspense = function(e1) {
    return un(e1) === nn;
}, Gt.isValidElementType = function(e1) {
    return "string" == typeof e1 || "function" == typeof e1 || e1 === Yt || e1 === en || e1 === Kt || e1 === Xt || e1 === nn || e1 === rn || "object" == typeof e1 && null !== e1 && (e1.$$typeof === on || e1.$$typeof === an || e1.$$typeof === Qt || e1.$$typeof === Jt || e1.$$typeof === tn || e1.$$typeof === sn || e1.$$typeof === cn || e1.$$typeof === dn || e1.$$typeof === ln);
}, Gt.typeOf = un;
var mn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */  false && 0,  true ? Ht.exports = Gt : 0 /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ ;
var fn = Object.getOwnPropertySymbols, vn = Object.prototype.hasOwnProperty, hn = Object.prototype.propertyIsEnumerable;
var gn = function() {
    try {
        if (!Object.assign) return !1;
        var e1 = new String("abc");
        if (e1[5] = "de", "5" === Object.getOwnPropertyNames(e1)[0]) return !1;
        for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
        var r = Object.getOwnPropertyNames(t).map(function(e1) {
            return t[e1];
        });
        if ("0123456789" !== r.join("")) return !1;
        var a = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(e1) {
            a[e1] = e1;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
    } catch (e2) {
        return !1;
    }
}() ? Object.assign : function(e1, t) {
    for(var n, r, a = function(e1) {
        if (null == e1) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e1);
    }(e1), i = 1; i < arguments.length; i++){
        for(var o in n = Object(arguments[i]))vn.call(n, o) && (a[o] = n[o]);
        if (fn) {
            r = fn(n);
            for(var l = 0; l < r.length; l++)hn.call(n, r[l]) && (a[r[l]] = n[r[l]]);
        }
    }
    return a;
}, bn = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", yn = Function.call.bind(Object.prototype.hasOwnProperty), xn = function() {};
if (false) { var En, wn, Cn; }
function Sn(e1, t, n, r, a) {
    if (false) { var s, l, o, i; }
}
Sn.resetWarningCache = function() {
     false && (0);
};
var Tn = (/* unused pure expression or super */ null && (Sn)), Nn = Ht.exports, kn = (/* unused pure expression or super */ null && (gn)), _n = (/* unused pure expression or super */ null && (bn)), On = (/* unused pure expression or super */ null && (yn)), Mn = (/* unused pure expression or super */ null && (Tn)), Pn = function() {};
function Ln() {
    return null;
}
 false && (0);
var In = bn;
function zn() {}
function Fn() {}
Fn.resetWarningCache = zn;
if (false) { var Dn; } else $t.exports = function() {
    function e1(e1, t, n, r, a, i) {
        if (i !== In) {
            var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw o.name = "Invariant Violation", o;
        }
    }
    function t() {
        return e1;
    }
    e1.isRequired = e1;
    var n = {
        array: e1,
        bigint: e1,
        bool: e1,
        func: e1,
        number: e1,
        object: e1,
        string: e1,
        symbol: e1,
        any: e1,
        arrayOf: t,
        element: e1,
        elementType: e1,
        instanceOf: t,
        node: e1,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: Fn,
        resetWarningCache: zn
    };
    return n.PropTypes = n, n;
}();
var Bn = $t.exports;
function An(e1, t) {
    return e1.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
var Wn = !1, jn =  false ? 0 : null, Rn =  false ? 0 : null, $n = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null), Hn = function(e1) {
    return e1.scrollTop;
}, Gn = "unmounted", Un = "exited", Vn = "entering", qn = "entered", Yn = "exiting", Xn = function(e1) {
    function n(t, n) {
        var r;
        r = e1.call(this, t, n) || this;
        var a, i = n && !n.isMounting ? t.enter : t.appear;
        return r.appearStatus = null, t.in ? i ? (a = Un, r.appearStatus = Vn) : a = qn : a = t.unmountOnExit || t.mountOnEnter ? Gn : Un, r.state = {
            status: a
        }, r.nextCallback = null, r;
    }
    Rt(n, e1), n.getDerivedStateFromProps = function(e1, t) {
        return e1.in && t.status === Gn ? {
            status: Un
        } : null;
    };
    var r = n.prototype;
    return r.componentDidMount = function() {
        this.updateStatus(!0, this.appearStatus);
    }, r.componentDidUpdate = function(e1) {
        var t = null;
        if (e1 !== this.props) {
            var n = this.state.status;
            this.props.in ? n !== Vn && n !== qn && (t = Vn) : n !== Vn && n !== qn || (t = Yn);
        }
        this.updateStatus(!1, t);
    }, r.componentWillUnmount = function() {
        this.cancelNextCallback();
    }, r.getTimeouts = function() {
        var e1, t, n, r = this.props.timeout;
        return e1 = t = n = r, null != r && "number" != typeof r && (e1 = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
            exit: e1,
            enter: t,
            appear: n
        };
    }, r.updateStatus = function(e1, t) {
        if (void 0 === e1 && (e1 = !1), null !== t) if (this.cancelNextCallback(), t === Vn) {
            if (this.props.unmountOnExit || this.props.mountOnEnter) {
                var n = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this);
                n && Hn(n);
            }
            this.performEnter(e1);
        } else this.performExit();
        else this.props.unmountOnExit && this.state.status === Un && this.setState({
            status: Gn
        });
    }, r.performEnter = function(e1) {
        var t = this, n = this.props.enter, r = this.context ? this.context.isMounting : e1, a = this.props.nodeRef ? [
            r
        ] : [
            react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this),
            r
        ], i = a[0], o = a[1], l = this.getTimeouts(), s = r ? l.appear : l.enter;
        !e1 && !n || Wn ? this.safeSetState({
            status: qn
        }, function() {
            t.props.onEntered(i);
        }) : (this.props.onEnter(i, o), this.safeSetState({
            status: Vn
        }, function() {
            t.props.onEntering(i, o), t.onTransitionEnd(s, function() {
                t.safeSetState({
                    status: qn
                }, function() {
                    t.props.onEntered(i, o);
                });
            });
        }));
    }, r.performExit = function() {
        var e1 = this, t = this.props.exit, n = this.getTimeouts(), r = this.props.nodeRef ? void 0 : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this);
        t && !Wn ? (this.props.onExit(r), this.safeSetState({
            status: Yn
        }, function() {
            e1.props.onExiting(r), e1.onTransitionEnd(n.exit, function() {
                e1.safeSetState({
                    status: Un
                }, function() {
                    e1.props.onExited(r);
                });
            });
        })) : this.safeSetState({
            status: Un
        }, function() {
            e1.props.onExited(r);
        });
    }, r.cancelNextCallback = function() {
        null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
    }, r.safeSetState = function(e1, t) {
        t = this.setNextCallback(t), this.setState(e1, t);
    }, r.setNextCallback = function(e1) {
        var t = this, n = !0;
        return this.nextCallback = function(r) {
            n && (n = !1, t.nextCallback = null, e1(r));
        }, this.nextCallback.cancel = function() {
            n = !1;
        }, this.nextCallback;
    }, r.onTransitionEnd = function(e1, t) {
        this.setNextCallback(t);
        var n = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this), r = null == e1 && !this.props.addEndListener;
        if (n && !r) {
            if (this.props.addEndListener) {
                var a = this.props.nodeRef ? [
                    this.nextCallback
                ] : [
                    n,
                    this.nextCallback
                ], i = a[0], o = a[1];
                this.props.addEndListener(i, o);
            }
            null != e1 && setTimeout(this.nextCallback, e1);
        } else setTimeout(this.nextCallback, 0);
    }, r.render = function() {
        var e1 = this.state.status;
        if (e1 === Gn) return null;
        var n = this.props, r = n.children;
        n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
        var a = Wt(n, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement($n.Provider, {
            value: null
        }, "function" == typeof r ? r(e1, a) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(react__WEBPACK_IMPORTED_MODULE_0__.Children.only(r), a));
    }, n;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
function Kn() {}
Xn.contextType = $n, Xn.propTypes =  false ? 0 : {}, Xn.defaultProps = {
    in: !1,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    enter: !0,
    exit: !0,
    onEnter: Kn,
    onEntering: Kn,
    onEntered: Kn,
    onExit: Kn,
    onExiting: Kn,
    onExited: Kn
}, Xn.UNMOUNTED = Gn, Xn.EXITED = Un, Xn.ENTERING = Vn, Xn.ENTERED = qn, Xn.EXITING = Yn;
var Qn = Xn, Jn = function(e1, t) {
    return e1 && t && t.split(" ").forEach(function(t) {
        return r = t, void ((n = e1).classList ? n.classList.remove(r) : "string" == typeof n.className ? n.className = An(n.className, r) : n.setAttribute("class", An(n.className && n.className.baseVal || "", r)));
        var n, r;
    });
}, Zn = function(e1) {
    function n() {
        for(var t, n = arguments.length, r = new Array(n), a = 0; a < n; a++)r[a] = arguments[a];
        return (t = e1.call.apply(e1, [
            this
        ].concat(r)) || this).appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        }, t.onEnter = function(e1, n) {
            var r = t.resolveArguments(e1, n), a = r[0], i = r[1];
            t.removeClasses(a, "exit"), t.addClass(a, i ? "appear" : "enter", "base"), t.props.onEnter && t.props.onEnter(e1, n);
        }, t.onEntering = function(e1, n) {
            var r = t.resolveArguments(e1, n), a = r[0], i = r[1] ? "appear" : "enter";
            t.addClass(a, i, "active"), t.props.onEntering && t.props.onEntering(e1, n);
        }, t.onEntered = function(e1, n) {
            var r = t.resolveArguments(e1, n), a = r[0], i = r[1] ? "appear" : "enter";
            t.removeClasses(a, i), t.addClass(a, i, "done"), t.props.onEntered && t.props.onEntered(e1, n);
        }, t.onExit = function(e1) {
            var n = t.resolveArguments(e1)[0];
            t.removeClasses(n, "appear"), t.removeClasses(n, "enter"), t.addClass(n, "exit", "base"), t.props.onExit && t.props.onExit(e1);
        }, t.onExiting = function(e1) {
            var n = t.resolveArguments(e1)[0];
            t.addClass(n, "exit", "active"), t.props.onExiting && t.props.onExiting(e1);
        }, t.onExited = function(e1) {
            var n = t.resolveArguments(e1)[0];
            t.removeClasses(n, "exit"), t.addClass(n, "exit", "done"), t.props.onExited && t.props.onExited(e1);
        }, t.resolveArguments = function(e1, n) {
            return t.props.nodeRef ? [
                t.props.nodeRef.current,
                e1
            ] : [
                e1,
                n
            ];
        }, t.getClassNames = function(e1) {
            var n = t.props.classNames, r = "string" == typeof n, a = r ? "" + (r && n ? n + "-" : "") + e1 : n[e1];
            return {
                baseClassName: a,
                activeClassName: r ? a + "-active" : n[e1 + "Active"],
                doneClassName: r ? a + "-done" : n[e1 + "Done"]
            };
        }, t;
    }
    Rt(n, e1);
    var r = n.prototype;
    return r.addClass = function(e1, t, n) {
        var r = this.getClassNames(t)[n + "ClassName"], a = this.getClassNames("enter").doneClassName;
        "appear" === t && "done" === n && a && (r += " " + a), "active" === n && e1 && Hn(e1), r && (this.appliedClasses[t][n] = r, function(e1, t) {
            e1 && t && t.split(" ").forEach(function(t) {
                return r = t, void ((n = e1).classList ? n.classList.add(r) : function(e1, t) {
                    return e1.classList ? !!t && e1.classList.contains(t) : -1 !== (" " + (e1.className.baseVal || e1.className) + " ").indexOf(" " + t + " ");
                }(n, r) || ("string" == typeof n.className ? n.className = n.className + " " + r : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + r)));
                var n, r;
            });
        }(e1, r));
    }, r.removeClasses = function(e1, t) {
        var n = this.appliedClasses[t], r = n.base, a = n.active, i = n.done;
        this.appliedClasses[t] = {}, r && Jn(e1, r), a && Jn(e1, a), i && Jn(e1, i);
    }, r.render = function() {
        var e1 = this.props;
        e1.classNames;
        var n = Wt(e1, [
            "classNames"
        ]);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qn, At({}, n, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    }, n;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
Zn.defaultProps = {
    classNames: ""
}, Zn.propTypes =  false ? 0 : {};
var er, tr = Zn, nr = function(e1) {
    var n = e1.isExpanded, r = e1.id, a = e1.content, i = e1.sectionId, o = e1.buttonId, c = l(0), d = c[0], p = c[1], m = l("none"), f = m[0], v = m[1], h = u(null);
    s(function() {
        var e1 = function() {
            d > 0 && g();
        };
        return window.addEventListener("resize", e1, {
            passive: !0
        }), function() {
            window.removeEventListener("resize", e1);
        };
    }, [
        d
    ]);
    var g = function() {
        h.current && p(h.current.offsetHeight);
    };
    return /*#__PURE__*/ t.createElement(tr, {
        in: n,
        timeout: 200,
        onEntering: function() {
            v("block");
        },
        onEntered: g,
        onExiting: function() {
            p(0);
        },
        onExit: function() {
            v("none");
        },
        "aria-hidden": !n,
        role: "region",
        id: "".concat(i, "-").concat(r),
        "aria-labelledby": "".concat(o, "-").concat(r),
        "data-testid": "".concat(i, "-").concat(r),
        className: C(Dt.accordionContentContainer),
        style: {
            height: d
        }
    }, /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement("div", {
        ref: h,
        style: {
            display: f
        },
        className: C(Dt.accordionContentInnerContainer)
    }, a())));
}, rr = "accordionItemContainer", ar = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.forwardRef(function(e1, n) {
    var r = e1.title, a = e1.children, i = e1.id, o = e1.totalItems, s = e1.setCurrentFocusAccordion, c = e1.sectionId, d = e1.buttonId, u = e1.onToggleExpanded, p = e1.iconType, m = e1.iconGradient, f = e1.theme, v = l(!1), h = v[0], g = v[1], b = "string" == typeof a ? function() {
        return function(e1) {
            return /*#__PURE__*/ t.createElement(ke, {
                fontSize: "xs",
                fontWeight: "medium"
            }, e1);
        }(a);
    } : a;
    return /*#__PURE__*/ t.createElement("div", {
        className: C(Dt[rr], Dt["".concat(rr, "__").concat(f)])
    }, /*#__PURE__*/ t.createElement(Bt, {
        isExpanded: h,
        toggleExpanded: function() {
            var e1 = !h;
            u(e1), g(e1);
        },
        setFocusActive: s,
        id: i,
        ref: n,
        buttonText: r,
        totalItems: o,
        buttonId: d,
        sectionId: c,
        iconType: p,
        iconGradient: m
    }), /*#__PURE__*/ t.createElement(nr, {
        isExpanded: h,
        id: i,
        buttonId: d,
        sectionId: c,
        content: b
    }));
}))), ir = function(e1) {
    var n = e1.items, r = e1.title, a = e1.buttonId, i = e1.sectionId, o = e1.onItemToggle, c = e1.theme, d = void 0 === c ? "standard" : c, p = l(), m = p[0], f = p[1], v = u([]), h = n.length;
    return s(function() {
        v.current = new Array(n.length);
    }, [
        n
    ]), s(function() {
        m && v.current[m] && v.current[m].focus();
    }, [
        m,
        v
    ]), /*#__PURE__*/ t.createElement("section", {
        className: C(Dt.accordion),
        "aria-label": "".concat(r, " - ").concat(h, " items")
    }, n.map(function(e1, n) {
        var r = n + 1, l = "accordion-".concat(r);
        return /*#__PURE__*/ t.createElement(ar, {
            title: e1.title,
            key: l,
            id: r,
            onToggleExpanded: function(e1) {
                return o && o(n, e1);
            },
            setCurrentFocusAccordion: f,
            totalItems: h,
            ref: function(e1) {
                return v.current[r] = e1;
            },
            buttonId: a,
            sectionId: i,
            iconType: e1.iconType,
            iconGradient: e1.iconGradient,
            theme: d
        }, e1.children);
    }));
}, or = {
    alert: "alert-module_alert",
    alertIcon: "alert-module_alertIcon",
    alertError: "alert-module_alertError",
    alertSuccess: "alert-module_alertSuccess",
    alertWarning: "alert-module_alertWarning",
    alertInfo: "alert-module_alertInfo",
    alertBulb: "alert-module_alertBulb",
    alertVariant: "alert-module_alertVariant",
    alertTitle: "alert-module_alertTitle"
};
!function(e1) {
    e1.error = "error", e1.warning = "warning", e1.info = "info", e1.success = "success", e1.bulb = "bulb";
}(er || (er = {}));
var lr = function(e1) {
    var n = e1.children, r = e1.id, a = e1.type, i = void 0 === a ? "error" : a, o = e1.className, l = e1.element, s = void 0 === l ? "p" : l, c = e1.displayPanelVariant, d = e1.title, u = c ? "".concat(i, "-variant") : i, p = r || u, m = C(c ? or.alertVariant : or.alert, or["alert".concat(It(i))], o), f = {
        error: c ? "close-circle" : "alert",
        success: c ? "check-circle" : "tick",
        warning: "alert",
        info: "info",
        bulb: "lightbulb"
    };
    return /*#__PURE__*/ t.createElement("div", {
        "data-testid": "Alert",
        id: p,
        role: "error" === i ? "alert" : void 0,
        className: m
    }, /*#__PURE__*/ t.createElement(we, {
        name: f[i],
        className: or.alertIcon
    }), /*#__PURE__*/ t.createElement("div", null, d && c && /*#__PURE__*/ t.createElement(ke, {
        fontSizeFixed: ge.s,
        fontWeight: be.semibold,
        className: or.alertTitle
    }, d), n && /*#__PURE__*/ t.createElement(ke, {
        element: s,
        fontSizeFixed: c ? ge.s : ge["3xs"],
        fontWeight: c ? be.medium : be.book,
        "data-testid": "Alert/Container"
    }, n)));
};
function sr(e1) {
    return null !== e1 && "object" == typeof e1 && "constructor" in e1 && e1.constructor === Object;
}
function cr(e1, t) {
    void 0 === e1 && (e1 = {}), void 0 === t && (t = {}), Object.keys(t).forEach(function(n) {
        void 0 === e1[n] ? e1[n] = t[n] : sr(t[n]) && sr(e1[n]) && Object.keys(t[n]).length > 0 && cr(e1[n], t[n]);
    });
}
var dr = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function ur() {
    var e1 = "undefined" != typeof document ? document : {};
    return cr(e1, dr), e1;
}
var pr = {
    document: dr,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(e1) {
        return "undefined" == typeof setTimeout ? (e1(), null) : setTimeout(e1, 0);
    },
    cancelAnimationFrame: function(e1) {
        "undefined" != typeof setTimeout && clearTimeout(e1);
    }
};
function mr() {
    var e1 =  true ? window : 0;
    return cr(e1, pr), e1;
}
function fr(e1) {
    return fr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
        return e1.__proto__ || Object.getPrototypeOf(e1);
    }, fr(e1);
}
function vr(e1, t) {
    return vr = Object.setPrototypeOf || function(e1, t) {
        return e1.__proto__ = t, e1;
    }, vr(e1, t);
}
function hr(e1, t, n) {
    return hr = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
        } catch (e1) {
            return !1;
        }
    }() ? Reflect.construct : function(e1, t, n) {
        var r = [
            null
        ];
        r.push.apply(r, t);
        var a = new (Function.bind.apply(e1, r));
        return n && vr(a, n.prototype), a;
    }, hr.apply(null, arguments);
}
function gr(e1) {
    var t = "function" == typeof Map ? new Map : void 0;
    return gr = function(e1) {
        if (null === e1 || (n = e1, -1 === Function.toString.call(n).indexOf("[native code]"))) return e1;
        var n;
        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
            if (t.has(e1)) return t.get(e1);
            t.set(e1, r);
        }
        function r() {
            return hr(e1, arguments, fr(this).constructor);
        }
        return r.prototype = Object.create(e1.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), vr(r, e1);
    }, gr(e1);
}
var br = function(e1) {
    var t, n;
    function r(t) {
        var n, r, a;
        return n = e1.call.apply(e1, [
            this
        ].concat(t)) || this, r = function(e1) {
            if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e1;
        }(n), a = r.__proto__, Object.defineProperty(r, "__proto__", {
            get: function() {
                return a;
            },
            set: function(e1) {
                a.__proto__ = e1;
            }
        }), n;
    }
    return n = e1, (t = r).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, r;
}(gr(Array));
function yr(e1) {
    void 0 === e1 && (e1 = []);
    var t = [];
    return e1.forEach(function(e1) {
        Array.isArray(e1) ? t.push.apply(t, yr(e1)) : t.push(e1);
    }), t;
}
function xr(e1, t) {
    return Array.prototype.filter.call(e1, t);
}
function Er(e1, t) {
    var n = mr(), r = ur(), a = [];
    if (!t && e1 instanceof br) return e1;
    if (!e1) return new br(a);
    if ("string" == typeof e1) {
        var i = e1.trim();
        if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
            var o = "div";
            0 === i.indexOf("<li") && (o = "ul"), 0 === i.indexOf("<tr") && (o = "tbody"), 0 !== i.indexOf("<td") && 0 !== i.indexOf("<th") || (o = "tr"), 0 === i.indexOf("<tbody") && (o = "table"), 0 === i.indexOf("<option") && (o = "select");
            var l = r.createElement(o);
            l.innerHTML = i;
            for(var s = 0; s < l.childNodes.length; s += 1)a.push(l.childNodes[s]);
        } else a = function(e1, t) {
            if ("string" != typeof e1) return [
                e1
            ];
            for(var n = [], r = t.querySelectorAll(e1), a = 0; a < r.length; a += 1)n.push(r[a]);
            return n;
        }(e1.trim(), t || r);
    } else if (e1.nodeType || e1 === n || e1 === r) a.push(e1);
    else if (Array.isArray(e1)) {
        if (e1 instanceof br) return e1;
        a = e1;
    }
    return new br(function(e1) {
        for(var t = [], n = 0; n < e1.length; n += 1)-1 === t.indexOf(e1[n]) && t.push(e1[n]);
        return t;
    }(a));
}
Er.fn = br.prototype;
var wr, Cr, Sr, Tr = {
    addClass: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = yr(t.map(function(e1) {
            return e1.split(" ");
        }));
        return this.forEach(function(e1) {
            var t;
            (t = e1.classList).add.apply(t, r);
        }), this;
    },
    removeClass: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = yr(t.map(function(e1) {
            return e1.split(" ");
        }));
        return this.forEach(function(e1) {
            var t;
            (t = e1.classList).remove.apply(t, r);
        }), this;
    },
    hasClass: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = yr(t.map(function(e1) {
            return e1.split(" ");
        }));
        return xr(this, function(e1) {
            return r.filter(function(t) {
                return e1.classList.contains(t);
            }).length > 0;
        }).length > 0;
    },
    toggleClass: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = yr(t.map(function(e1) {
            return e1.split(" ");
        }));
        this.forEach(function(e1) {
            r.forEach(function(t) {
                e1.classList.toggle(t);
            });
        });
    },
    attr: function(e1, t) {
        if (1 === arguments.length && "string" == typeof e1) return this[0] ? this[0].getAttribute(e1) : void 0;
        for(var n = 0; n < this.length; n += 1)if (2 === arguments.length) this[n].setAttribute(e1, t);
        else for(var r in e1)this[n][r] = e1[r], this[n].setAttribute(r, e1[r]);
        return this;
    },
    removeAttr: function(e1) {
        for(var t = 0; t < this.length; t += 1)this[t].removeAttribute(e1);
        return this;
    },
    transform: function(e1) {
        for(var t = 0; t < this.length; t += 1)this[t].style.transform = e1;
        return this;
    },
    transition: function(e1) {
        for(var t = 0; t < this.length; t += 1)this[t].style.transitionDuration = "string" != typeof e1 ? e1 + "ms" : e1;
        return this;
    },
    on: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = t[0], a = t[1], i = t[2], o = t[3];
        function l(e1) {
            var t = e1.target;
            if (t) {
                var n = e1.target.dom7EventData || [];
                if (n.indexOf(e1) < 0 && n.unshift(e1), Er(t).is(a)) i.apply(t, n);
                else for(var r = Er(t).parents(), o = 0; o < r.length; o += 1)Er(r[o]).is(a) && i.apply(r[o], n);
            }
        }
        function s(e1) {
            var t = e1 && e1.target && e1.target.dom7EventData || [];
            t.indexOf(e1) < 0 && t.unshift(e1), i.apply(this, t);
        }
        "function" == typeof t[1] && (r = t[0], i = t[1], o = t[2], a = void 0), o || (o = !1);
        for(var c, d = r.split(" "), u = 0; u < this.length; u += 1){
            var p = this[u];
            if (a) for(c = 0; c < d.length; c += 1){
                var m = d[c];
                p.dom7LiveListeners || (p.dom7LiveListeners = {}), p.dom7LiveListeners[m] || (p.dom7LiveListeners[m] = []), p.dom7LiveListeners[m].push({
                    listener: i,
                    proxyListener: l
                }), p.addEventListener(m, l, o);
            }
            else for(c = 0; c < d.length; c += 1){
                var f = d[c];
                p.dom7Listeners || (p.dom7Listeners = {}), p.dom7Listeners[f] || (p.dom7Listeners[f] = []), p.dom7Listeners[f].push({
                    listener: i,
                    proxyListener: s
                }), p.addEventListener(f, s, o);
            }
        }
        return this;
    },
    off: function() {
        for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
        var r = t[0], a = t[1], i = t[2], o = t[3];
        "function" == typeof t[1] && (r = t[0], i = t[1], o = t[2], a = void 0), o || (o = !1);
        for(var l = r.split(" "), s = 0; s < l.length; s += 1)for(var c = l[s], d = 0; d < this.length; d += 1){
            var u = this[d], p = void 0;
            if (!a && u.dom7Listeners ? p = u.dom7Listeners[c] : a && u.dom7LiveListeners && (p = u.dom7LiveListeners[c]), p && p.length) for(var m = p.length - 1; m >= 0; m -= 1){
                var f = p[m];
                i && f.listener === i || i && f.listener && f.listener.dom7proxy && f.listener.dom7proxy === i ? (u.removeEventListener(c, f.proxyListener, o), p.splice(m, 1)) : i || (u.removeEventListener(c, f.proxyListener, o), p.splice(m, 1));
            }
        }
        return this;
    },
    trigger: function() {
        for(var e1 = mr(), t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        for(var a = n[0].split(" "), i = n[1], o = 0; o < a.length; o += 1)for(var l = a[o], s = 0; s < this.length; s += 1){
            var c = this[s];
            if (e1.CustomEvent) {
                var d = new e1.CustomEvent(l, {
                    detail: i,
                    bubbles: !0,
                    cancelable: !0
                });
                c.dom7EventData = n.filter(function(e1, t) {
                    return t > 0;
                }), c.dispatchEvent(d), c.dom7EventData = [], delete c.dom7EventData;
            }
        }
        return this;
    },
    transitionEnd: function(e1) {
        var t = this;
        return e1 && t.on("transitionend", function n(r) {
            r.target === this && (e1.call(this, r), t.off("transitionend", n));
        }), this;
    },
    outerWidth: function(e1) {
        if (this.length > 0) {
            if (e1) {
                var t = this.styles();
                return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
            }
            return this[0].offsetWidth;
        }
        return null;
    },
    outerHeight: function(e1) {
        if (this.length > 0) {
            if (e1) {
                var t = this.styles();
                return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
            }
            return this[0].offsetHeight;
        }
        return null;
    },
    styles: function() {
        var e1 = mr();
        return this[0] ? e1.getComputedStyle(this[0], null) : {};
    },
    offset: function() {
        if (this.length > 0) {
            var e1 = mr(), t = ur(), n = this[0], r = n.getBoundingClientRect(), a = t.body, i = n.clientTop || a.clientTop || 0, o = n.clientLeft || a.clientLeft || 0, l = n === e1 ? e1.scrollY : n.scrollTop, s = n === e1 ? e1.scrollX : n.scrollLeft;
            return {
                top: r.top + l - i,
                left: r.left + s - o
            };
        }
        return null;
    },
    css: function(e1, t) {
        var n, r = mr();
        if (1 === arguments.length) {
            if ("string" != typeof e1) {
                for(n = 0; n < this.length; n += 1)for(var a in e1)this[n].style[a] = e1[a];
                return this;
            }
            if (this[0]) return r.getComputedStyle(this[0], null).getPropertyValue(e1);
        }
        if (2 === arguments.length && "string" == typeof e1) {
            for(n = 0; n < this.length; n += 1)this[n].style[e1] = t;
            return this;
        }
        return this;
    },
    each: function(e1) {
        return e1 ? (this.forEach(function(t, n) {
            e1.apply(t, [
                t,
                n
            ]);
        }), this) : this;
    },
    html: function(e1) {
        if (void 0 === e1) return this[0] ? this[0].innerHTML : null;
        for(var t = 0; t < this.length; t += 1)this[t].innerHTML = e1;
        return this;
    },
    text: function(e1) {
        if (void 0 === e1) return this[0] ? this[0].textContent.trim() : null;
        for(var t = 0; t < this.length; t += 1)this[t].textContent = e1;
        return this;
    },
    is: function(e1) {
        var t, n, r = mr(), a = ur(), i = this[0];
        if (!i || void 0 === e1) return !1;
        if ("string" == typeof e1) {
            if (i.matches) return i.matches(e1);
            if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e1);
            if (i.msMatchesSelector) return i.msMatchesSelector(e1);
            for(t = Er(e1), n = 0; n < t.length; n += 1)if (t[n] === i) return !0;
            return !1;
        }
        if (e1 === a) return i === a;
        if (e1 === r) return i === r;
        if (e1.nodeType || e1 instanceof br) {
            for(t = e1.nodeType ? [
                e1
            ] : e1, n = 0; n < t.length; n += 1)if (t[n] === i) return !0;
            return !1;
        }
        return !1;
    },
    index: function() {
        var e1, t = this[0];
        if (t) {
            for(e1 = 0; null !== (t = t.previousSibling);)1 === t.nodeType && (e1 += 1);
            return e1;
        }
    },
    eq: function(e1) {
        if (void 0 === e1) return this;
        var t = this.length;
        if (e1 > t - 1) return Er([]);
        if (e1 < 0) {
            var n = t + e1;
            return Er(n < 0 ? [] : [
                this[n]
            ]);
        }
        return Er([
            this[e1]
        ]);
    },
    append: function() {
        for(var e1, t = ur(), n = 0; n < arguments.length; n += 1){
            e1 = n < 0 || arguments.length <= n ? void 0 : arguments[n];
            for(var r = 0; r < this.length; r += 1)if ("string" == typeof e1) {
                var a = t.createElement("div");
                for(a.innerHTML = e1; a.firstChild;)this[r].appendChild(a.firstChild);
            } else if (e1 instanceof br) for(var i = 0; i < e1.length; i += 1)this[r].appendChild(e1[i]);
            else this[r].appendChild(e1);
        }
        return this;
    },
    prepend: function(e1) {
        var t, n, r = ur();
        for(t = 0; t < this.length; t += 1)if ("string" == typeof e1) {
            var a = r.createElement("div");
            for(a.innerHTML = e1, n = a.childNodes.length - 1; n >= 0; n -= 1)this[t].insertBefore(a.childNodes[n], this[t].childNodes[0]);
        } else if (e1 instanceof br) for(n = 0; n < e1.length; n += 1)this[t].insertBefore(e1[n], this[t].childNodes[0]);
        else this[t].insertBefore(e1, this[t].childNodes[0]);
        return this;
    },
    next: function(e1) {
        return this.length > 0 ? e1 ? this[0].nextElementSibling && Er(this[0].nextElementSibling).is(e1) ? Er([
            this[0].nextElementSibling
        ]) : Er([]) : this[0].nextElementSibling ? Er([
            this[0].nextElementSibling
        ]) : Er([]) : Er([]);
    },
    nextAll: function(e1) {
        var t = [], n = this[0];
        if (!n) return Er([]);
        for(; n.nextElementSibling;){
            var r = n.nextElementSibling;
            e1 ? Er(r).is(e1) && t.push(r) : t.push(r), n = r;
        }
        return Er(t);
    },
    prev: function(e1) {
        if (this.length > 0) {
            var t = this[0];
            return e1 ? t.previousElementSibling && Er(t.previousElementSibling).is(e1) ? Er([
                t.previousElementSibling
            ]) : Er([]) : t.previousElementSibling ? Er([
                t.previousElementSibling
            ]) : Er([]);
        }
        return Er([]);
    },
    prevAll: function(e1) {
        var t = [], n = this[0];
        if (!n) return Er([]);
        for(; n.previousElementSibling;){
            var r = n.previousElementSibling;
            e1 ? Er(r).is(e1) && t.push(r) : t.push(r), n = r;
        }
        return Er(t);
    },
    parent: function(e1) {
        for(var t = [], n = 0; n < this.length; n += 1)null !== this[n].parentNode && (e1 ? Er(this[n].parentNode).is(e1) && t.push(this[n].parentNode) : t.push(this[n].parentNode));
        return Er(t);
    },
    parents: function(e1) {
        for(var t = [], n = 0; n < this.length; n += 1)for(var r = this[n].parentNode; r;)e1 ? Er(r).is(e1) && t.push(r) : t.push(r), r = r.parentNode;
        return Er(t);
    },
    closest: function(e1) {
        var t = this;
        return void 0 === e1 ? Er([]) : (t.is(e1) || (t = t.parents(e1).eq(0)), t);
    },
    find: function(e1) {
        for(var t = [], n = 0; n < this.length; n += 1)for(var r = this[n].querySelectorAll(e1), a = 0; a < r.length; a += 1)t.push(r[a]);
        return Er(t);
    },
    children: function(e1) {
        for(var t = [], n = 0; n < this.length; n += 1)for(var r = this[n].children, a = 0; a < r.length; a += 1)e1 && !Er(r[a]).is(e1) || t.push(r[a]);
        return Er(t);
    },
    filter: function(e1) {
        return Er(xr(this, e1));
    },
    remove: function() {
        for(var e1 = 0; e1 < this.length; e1 += 1)this[e1].parentNode && this[e1].parentNode.removeChild(this[e1]);
        return this;
    }
};
function Nr(e1, t) {
    return void 0 === t && (t = 0), setTimeout(e1, t);
}
function kr() {
    return Date.now();
}
function _r(e1, t) {
    void 0 === t && (t = "x");
    var n, r, a, i = mr(), o = function(e1) {
        var t, n = mr();
        return n.getComputedStyle && (t = n.getComputedStyle(e1, null)), !t && e1.currentStyle && (t = e1.currentStyle), t || (t = e1.style), t;
    }(e1);
    return i.WebKitCSSMatrix ? ((r = o.transform || o.webkitTransform).split(",").length > 6 && (r = r.split(", ").map(function(e1) {
        return e1.replace(",", ".");
    }).join(", ")), a = new i.WebKitCSSMatrix("none" === r ? "" : r)) : n = (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (r = i.WebKitCSSMatrix ? a.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])), "y" === t && (r = i.WebKitCSSMatrix ? a.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])), r || 0;
}
function Or(e1) {
    return "object" == typeof e1 && null !== e1 && e1.constructor && "Object" === Object.prototype.toString.call(e1).slice(8, -1);
}
function Mr() {
    for(var e1, t = Object(arguments.length <= 0 ? void 0 : arguments[0]), n = [
        "__proto__",
        "constructor",
        "prototype"
    ], r = 1; r < arguments.length; r += 1){
        var a = r < 0 || arguments.length <= r ? void 0 : arguments[r];
        if (null != a && (e1 = a, !( true && void 0 !== window.HTMLElement ? e1 instanceof HTMLElement : e1 && (1 === e1.nodeType || 11 === e1.nodeType)))) for(var i = Object.keys(Object(a)).filter(function(e1) {
            return n.indexOf(e1) < 0;
        }), o = 0, l = i.length; o < l; o += 1){
            var s = i[o], c = Object.getOwnPropertyDescriptor(a, s);
            void 0 !== c && c.enumerable && (Or(t[s]) && Or(a[s]) ? a[s].__swiper__ ? t[s] = a[s] : Mr(t[s], a[s]) : !Or(t[s]) && Or(a[s]) ? (t[s] = {}, a[s].__swiper__ ? t[s] = a[s] : Mr(t[s], a[s])) : t[s] = a[s]);
        }
    }
    return t;
}
function Pr(e1, t) {
    Object.keys(t).forEach(function(n) {
        Or(t[n]) && Object.keys(t[n]).forEach(function(r) {
            "function" == typeof t[n][r] && (t[n][r] = t[n][r].bind(e1));
        }), e1[n] = t[n];
    });
}
function Lr(e1) {
    return void 0 === e1 && (e1 = ""), "." + e1.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".");
}
function Ir(e1, t, n, r) {
    var a = ur();
    return n && Object.keys(r).forEach(function(n) {
        if (!t[n] && !0 === t.auto) {
            var i = a.createElement("div");
            i.className = r[n], e1.append(i), t[n] = i;
        }
    }), t;
}
function zr() {
    return wr || (wr = function() {
        var e1 = mr(), t = ur();
        return {
            touch: !!("ontouchstart" in e1 || e1.DocumentTouch && t instanceof e1.DocumentTouch),
            pointerEvents: !!e1.PointerEvent && "maxTouchPoints" in e1.navigator && e1.navigator.maxTouchPoints >= 0,
            observer: "MutationObserver" in e1 || "WebkitMutationObserver" in e1,
            passiveListener: function() {
                var t = !1;
                try {
                    var n = Object.defineProperty({}, "passive", {
                        get: function() {
                            t = !0;
                        }
                    });
                    e1.addEventListener("testPassiveListener", null, n);
                } catch (e2) {}
                return t;
            }(),
            gestures: "ongesturestart" in e1
        };
    }()), wr;
}
function Fr(e1) {
    return void 0 === e1 && (e1 = {}), Cr || (Cr = function(e1) {
        var t = (void 0 === e1 ? {} : e1).userAgent, n = zr(), r = mr(), a = r.navigator.platform, i = t || r.navigator.userAgent, o = {
            ios: !1,
            android: !1
        }, l = r.screen.width, s = r.screen.height, c = i.match(/(Android);?[\s\/]+([\d.]+)?/), d = i.match(/(iPad).*OS\s([\d_]+)/), u = i.match(/(iPod)(.*OS\s([\d_]+))?/), p = !d && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), m = "Win32" === a, f = "MacIntel" === a;
        return !d && f && n.touch && [
            "1024x1366",
            "1366x1024",
            "834x1194",
            "1194x834",
            "834x1112",
            "1112x834",
            "768x1024",
            "1024x768",
            "820x1180",
            "1180x820",
            "810x1080",
            "1080x810"
        ].indexOf(l + "x" + s) >= 0 && ((d = i.match(/(Version)\/([\d.]+)/)) || (d = [
            0,
            1,
            "13_0_0"
        ]), f = !1), c && !m && (o.os = "android", o.android = !0), (d || p || u) && (o.os = "ios", o.ios = !0), o;
    }(e1)), Cr;
}
function Dr() {
    return Sr || (Sr = function() {
        var e1, t = mr();
        return {
            isEdge: !!t.navigator.userAgent.match(/Edge/g),
            isSafari: (e1 = t.navigator.userAgent.toLowerCase(), e1.indexOf("safari") >= 0 && e1.indexOf("chrome") < 0 && e1.indexOf("android") < 0),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
        };
    }()), Sr;
}
Object.keys(Tr).forEach(function(e1) {
    Object.defineProperty(Er.fn, e1, {
        value: Tr[e1],
        writable: !0
    });
});
var Br = {
    name: "resize",
    create: function() {
        var e1 = this;
        Mr(e1, {
            resize: {
                observer: null,
                createObserver: function() {
                    e1 && !e1.destroyed && e1.initialized && (e1.resize.observer = new ResizeObserver(function(t) {
                        var n = e1.width, r = e1.height, a = n, i = r;
                        t.forEach(function(t) {
                            var n = t.contentBoxSize, r = t.contentRect, o = t.target;
                            o && o !== e1.el || (a = r ? r.width : (n[0] || n).inlineSize, i = r ? r.height : (n[0] || n).blockSize);
                        }), a === n && i === r || e1.resize.resizeHandler();
                    }), e1.resize.observer.observe(e1.el));
                },
                removeObserver: function() {
                    e1.resize.observer && e1.resize.observer.unobserve && e1.el && (e1.resize.observer.unobserve(e1.el), e1.resize.observer = null);
                },
                resizeHandler: function() {
                    e1 && !e1.destroyed && e1.initialized && (e1.emit("beforeResize"), e1.emit("resize"));
                },
                orientationChangeHandler: function() {
                    e1 && !e1.destroyed && e1.initialized && e1.emit("orientationchange");
                }
            }
        });
    },
    on: {
        init: function(e1) {
            var t = mr();
            e1.params.resizeObserver && void 0 !== mr().ResizeObserver ? e1.resize.createObserver() : (t.addEventListener("resize", e1.resize.resizeHandler), t.addEventListener("orientationchange", e1.resize.orientationChangeHandler));
        },
        destroy: function(e1) {
            var t = mr();
            e1.resize.removeObserver(), t.removeEventListener("resize", e1.resize.resizeHandler), t.removeEventListener("orientationchange", e1.resize.orientationChangeHandler);
        }
    }
};
function Ar() {
    return Ar = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, Ar.apply(this, arguments);
}
var Wr = {
    attach: function(e1, t) {
        void 0 === t && (t = {});
        var n = mr(), r = this, a = new (n.MutationObserver || n.WebkitMutationObserver)(function(e1) {
            if (1 !== e1.length) {
                var t = function() {
                    r.emit("observerUpdate", e1[0]);
                };
                n.requestAnimationFrame ? n.requestAnimationFrame(t) : n.setTimeout(t, 0);
            } else r.emit("observerUpdate", e1[0]);
        });
        a.observe(e1, {
            attributes: void 0 === t.attributes || t.attributes,
            childList: void 0 === t.childList || t.childList,
            characterData: void 0 === t.characterData || t.characterData
        }), r.observer.observers.push(a);
    },
    init: function() {
        var e1 = this;
        if (e1.support.observer && e1.params.observer) {
            if (e1.params.observeParents) for(var t = e1.$el.parents(), n = 0; n < t.length; n += 1)e1.observer.attach(t[n]);
            e1.observer.attach(e1.$el[0], {
                childList: e1.params.observeSlideChildren
            }), e1.observer.attach(e1.$wrapperEl[0], {
                attributes: !1
            });
        }
    },
    destroy: function() {
        this.observer.observers.forEach(function(e1) {
            e1.disconnect();
        }), this.observer.observers = [];
    }
}, jr = {
    name: "observer",
    params: {
        observer: !1,
        observeParents: !1,
        observeSlideChildren: !1
    },
    create: function() {
        Pr(this, {
            observer: Ar({}, Wr, {
                observers: []
            })
        });
    },
    on: {
        init: function(e1) {
            e1.observer.init();
        },
        destroy: function(e1) {
            e1.observer.destroy();
        }
    }
}, Rr = {
    useParams: function(e1) {
        var t = this;
        t.modules && Object.keys(t.modules).forEach(function(n) {
            var r = t.modules[n];
            r.params && Mr(e1, r.params);
        });
    },
    useModules: function(e1) {
        void 0 === e1 && (e1 = {});
        var t = this;
        t.modules && Object.keys(t.modules).forEach(function(n) {
            var r = t.modules[n], a = e1[n] || {};
            r.on && t.on && Object.keys(r.on).forEach(function(e1) {
                t.on(e1, r.on[e1]);
            }), r.create && r.create.bind(t)(a);
        });
    }
}, $r = {
    on: function(e1, t, n) {
        var r = this;
        if ("function" != typeof t) return r;
        var a = n ? "unshift" : "push";
        return e1.split(" ").forEach(function(e1) {
            r.eventsListeners[e1] || (r.eventsListeners[e1] = []), r.eventsListeners[e1][a](t);
        }), r;
    },
    once: function(e1, t, n) {
        var r = this;
        if ("function" != typeof t) return r;
        function a() {
            r.off(e1, a), a.__emitterProxy && delete a.__emitterProxy;
            for(var n = arguments.length, i = new Array(n), o = 0; o < n; o++)i[o] = arguments[o];
            t.apply(r, i);
        }
        return a.__emitterProxy = t, r.on(e1, a, n);
    },
    onAny: function(e1, t) {
        var n = this;
        if ("function" != typeof e1) return n;
        var r = t ? "unshift" : "push";
        return n.eventsAnyListeners.indexOf(e1) < 0 && n.eventsAnyListeners[r](e1), n;
    },
    offAny: function(e1) {
        var t = this;
        if (!t.eventsAnyListeners) return t;
        var n = t.eventsAnyListeners.indexOf(e1);
        return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
    },
    off: function(e1, t) {
        var n = this;
        return n.eventsListeners ? (e1.split(" ").forEach(function(e1) {
            void 0 === t ? n.eventsListeners[e1] = [] : n.eventsListeners[e1] && n.eventsListeners[e1].forEach(function(r, a) {
                (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e1].splice(a, 1);
            });
        }), n) : n;
    },
    emit: function() {
        var e1, t, n, r = this;
        if (!r.eventsListeners) return r;
        for(var a = arguments.length, i = new Array(a), o = 0; o < a; o++)i[o] = arguments[o];
        return "string" == typeof i[0] || Array.isArray(i[0]) ? (e1 = i[0], t = i.slice(1, i.length), n = r) : (e1 = i[0].events, t = i[0].data, n = i[0].context || r), t.unshift(n), (Array.isArray(e1) ? e1 : e1.split(" ")).forEach(function(e1) {
            r.eventsAnyListeners && r.eventsAnyListeners.length && r.eventsAnyListeners.forEach(function(r) {
                r.apply(n, [
                    e1
                ].concat(t));
            }), r.eventsListeners && r.eventsListeners[e1] && r.eventsListeners[e1].forEach(function(e1) {
                e1.apply(n, t);
            });
        }), r;
    }
};
var Hr = {
    updateSize: function() {
        var e1, t, n = this, r = n.$el;
        e1 = void 0 !== n.params.width && null !== n.params.width ? n.params.width : r[0].clientWidth, t = void 0 !== n.params.height && null !== n.params.height ? n.params.height : r[0].clientHeight, 0 === e1 && n.isHorizontal() || 0 === t && n.isVertical() || (e1 = e1 - parseInt(r.css("padding-left") || 0, 10) - parseInt(r.css("padding-right") || 0, 10), t = t - parseInt(r.css("padding-top") || 0, 10) - parseInt(r.css("padding-bottom") || 0, 10), Number.isNaN(e1) && (e1 = 0), Number.isNaN(t) && (t = 0), Mr(n, {
            width: e1,
            height: t,
            size: n.isHorizontal() ? e1 : t
        }));
    },
    updateSlides: function() {
        var e1 = this;
        function t(t) {
            return e1.isHorizontal() ? t : ({
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom"
            })[t];
        }
        function n(e1, n) {
            return parseFloat(e1.getPropertyValue(t(n)) || 0);
        }
        var r = e1.params, a = e1.$wrapperEl, i = e1.size, o = e1.rtlTranslate, l = e1.wrongRTL, s = e1.virtual && r.virtual.enabled, c = s ? e1.virtual.slides.length : e1.slides.length, d = a.children("." + e1.params.slideClass), u = s ? e1.virtual.slides.length : d.length, p = [], m = [], f = [], v = r.slidesOffsetBefore;
        "function" == typeof v && (v = r.slidesOffsetBefore.call(e1));
        var h = r.slidesOffsetAfter;
        "function" == typeof h && (h = r.slidesOffsetAfter.call(e1));
        var g = e1.snapGrid.length, b = e1.slidesGrid.length, y = r.spaceBetween, x = -v, E = 0, w = 0;
        if (void 0 !== i) {
            var C, S;
            "string" == typeof y && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * i), e1.virtualSize = -y, o ? d.css({
                marginLeft: "",
                marginBottom: "",
                marginTop: ""
            }) : d.css({
                marginRight: "",
                marginBottom: "",
                marginTop: ""
            }), r.slidesPerColumn > 1 && (C = Math.floor(u / r.slidesPerColumn) === u / e1.params.slidesPerColumn ? u : Math.ceil(u / r.slidesPerColumn) * r.slidesPerColumn, "auto" !== r.slidesPerView && "row" === r.slidesPerColumnFill && (C = Math.max(C, r.slidesPerView * r.slidesPerColumn)));
            for(var T, N, k, _ = r.slidesPerColumn, O = C / _, M = Math.floor(u / r.slidesPerColumn), P = 0; P < u; P += 1){
                S = 0;
                var L = d.eq(P);
                if (r.slidesPerColumn > 1) {
                    var I = void 0, z = void 0, F = void 0;
                    if ("row" === r.slidesPerColumnFill && r.slidesPerGroup > 1) {
                        var D = Math.floor(P / (r.slidesPerGroup * r.slidesPerColumn)), B = P - r.slidesPerColumn * r.slidesPerGroup * D, A = 0 === D ? r.slidesPerGroup : Math.min(Math.ceil((u - D * _ * r.slidesPerGroup) / _), r.slidesPerGroup);
                        I = (z = B - (F = Math.floor(B / A)) * A + D * r.slidesPerGroup) + F * C / _, L.css({
                            "-webkit-box-ordinal-group": I,
                            "-moz-box-ordinal-group": I,
                            "-ms-flex-order": I,
                            "-webkit-order": I,
                            order: I
                        });
                    } else "column" === r.slidesPerColumnFill ? (F = P - (z = Math.floor(P / _)) * _, (z > M || z === M && F === _ - 1) && (F += 1) >= _ && (F = 0, z += 1)) : z = P - (F = Math.floor(P / O)) * O;
                    L.css(t("margin-top"), 0 !== F ? r.spaceBetween && r.spaceBetween + "px" : "");
                }
                if ("none" !== L.css("display")) {
                    if ("auto" === r.slidesPerView) {
                        var W = getComputedStyle(L[0]), j = L[0].style.transform, R = L[0].style.webkitTransform;
                        if (j && (L[0].style.transform = "none"), R && (L[0].style.webkitTransform = "none"), r.roundLengths) S = e1.isHorizontal() ? L.outerWidth(!0) : L.outerHeight(!0);
                        else {
                            var $ = n(W, "width"), H = n(W, "padding-left"), G = n(W, "padding-right"), U = n(W, "margin-left"), V = n(W, "margin-right"), q = W.getPropertyValue("box-sizing");
                            if (q && "border-box" === q) S = $ + U + V;
                            else {
                                var Y = L[0], X = Y.clientWidth;
                                S = $ + H + G + U + V + (Y.offsetWidth - X);
                            }
                        }
                        j && (L[0].style.transform = j), R && (L[0].style.webkitTransform = R), r.roundLengths && (S = Math.floor(S));
                    } else S = (i - (r.slidesPerView - 1) * y) / r.slidesPerView, r.roundLengths && (S = Math.floor(S)), d[P] && (d[P].style[t("width")] = S + "px");
                    d[P] && (d[P].swiperSlideSize = S), f.push(S), r.centeredSlides ? (x = x + S / 2 + E / 2 + y, 0 === E && 0 !== P && (x = x - i / 2 - y), 0 === P && (x = x - i / 2 - y), Math.abs(x) < .001 && (x = 0), r.roundLengths && (x = Math.floor(x)), w % r.slidesPerGroup == 0 && p.push(x), m.push(x)) : (r.roundLengths && (x = Math.floor(x)), (w - Math.min(e1.params.slidesPerGroupSkip, w)) % e1.params.slidesPerGroup == 0 && p.push(x), m.push(x), x = x + S + y), e1.virtualSize += S + y, E = S, w += 1;
                }
            }
            if (e1.virtualSize = Math.max(e1.virtualSize, i) + h, o && l && ("slide" === r.effect || "coverflow" === r.effect) && a.css({
                width: e1.virtualSize + r.spaceBetween + "px"
            }), r.setWrapperSize) a.css(((N = {})[t("width")] = e1.virtualSize + r.spaceBetween + "px", N));
            if (r.slidesPerColumn > 1) {
                if (e1.virtualSize = (S + r.spaceBetween) * C, e1.virtualSize = Math.ceil(e1.virtualSize / r.slidesPerColumn) - r.spaceBetween, a.css(((k = {})[t("width")] = e1.virtualSize + r.spaceBetween + "px", k)), r.centeredSlides) {
                    T = [];
                    for(var K = 0; K < p.length; K += 1){
                        var Q = p[K];
                        r.roundLengths && (Q = Math.floor(Q)), p[K] < e1.virtualSize + p[0] && T.push(Q);
                    }
                    p = T;
                }
            }
            if (!r.centeredSlides) {
                T = [];
                for(var J = 0; J < p.length; J += 1){
                    var Z = p[J];
                    r.roundLengths && (Z = Math.floor(Z)), p[J] <= e1.virtualSize - i && T.push(Z);
                }
                p = T, Math.floor(e1.virtualSize - i) - Math.floor(p[p.length - 1]) > 1 && p.push(e1.virtualSize - i);
            }
            if (0 === p.length && (p = [
                0
            ]), 0 !== r.spaceBetween) {
                var ee, te = e1.isHorizontal() && o ? "marginLeft" : t("marginRight");
                d.filter(function(e1, t) {
                    return !r.cssMode || t !== d.length - 1;
                }).css(((ee = {})[te] = y + "px", ee));
            }
            if (r.centeredSlides && r.centeredSlidesBounds) {
                var ne = 0;
                f.forEach(function(e1) {
                    ne += e1 + (r.spaceBetween ? r.spaceBetween : 0);
                });
                var re = (ne -= r.spaceBetween) - i;
                p = p.map(function(e1) {
                    return e1 < 0 ? -v : e1 > re ? re + h : e1;
                });
            }
            if (r.centerInsufficientSlides) {
                var ae = 0;
                if (f.forEach(function(e1) {
                    ae += e1 + (r.spaceBetween ? r.spaceBetween : 0);
                }), (ae -= r.spaceBetween) < i) {
                    var ie = (i - ae) / 2;
                    p.forEach(function(e1, t) {
                        p[t] = e1 - ie;
                    }), m.forEach(function(e1, t) {
                        m[t] = e1 + ie;
                    });
                }
            }
            Mr(e1, {
                slides: d,
                snapGrid: p,
                slidesGrid: m,
                slidesSizesGrid: f
            }), u !== c && e1.emit("slidesLengthChange"), p.length !== g && (e1.params.watchOverflow && e1.checkOverflow(), e1.emit("snapGridLengthChange")), m.length !== b && e1.emit("slidesGridLengthChange"), (r.watchSlidesProgress || r.watchSlidesVisibility) && e1.updateSlidesOffset();
        }
    },
    updateAutoHeight: function(e1) {
        var t, n = this, r = [], a = n.virtual && n.params.virtual.enabled, i = 0;
        "number" == typeof e1 ? n.setTransition(e1) : !0 === e1 && n.setTransition(n.params.speed);
        var o = function(e1) {
            return a ? n.slides.filter(function(t) {
                return parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e1;
            })[0] : n.slides.eq(e1)[0];
        };
        if ("auto" !== n.params.slidesPerView && n.params.slidesPerView > 1) if (n.params.centeredSlides) n.visibleSlides.each(function(e1) {
            r.push(e1);
        });
        else for(t = 0; t < Math.ceil(n.params.slidesPerView); t += 1){
            var l = n.activeIndex + t;
            if (l > n.slides.length && !a) break;
            r.push(o(l));
        }
        else r.push(o(n.activeIndex));
        for(t = 0; t < r.length; t += 1)if (void 0 !== r[t]) {
            var s = r[t].offsetHeight;
            i = s > i ? s : i;
        }
        i && n.$wrapperEl.css("height", i + "px");
    },
    updateSlidesOffset: function() {
        for(var e1 = this.slides, t = 0; t < e1.length; t += 1)e1[t].swiperSlideOffset = this.isHorizontal() ? e1[t].offsetLeft : e1[t].offsetTop;
    },
    updateSlidesProgress: function(e1) {
        void 0 === e1 && (e1 = this && this.translate || 0);
        var t = this, n = t.params, r = t.slides, a = t.rtlTranslate;
        if (0 !== r.length) {
            void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
            var i = -e1;
            a && (i = e1), r.removeClass(n.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
            for(var o = 0; o < r.length; o += 1){
                var l = r[o], s = (i + (n.centeredSlides ? t.minTranslate() : 0) - l.swiperSlideOffset) / (l.swiperSlideSize + n.spaceBetween);
                if (n.watchSlidesVisibility || n.centeredSlides && n.autoHeight) {
                    var c = -(i - l.swiperSlideOffset), d = c + t.slidesSizesGrid[o];
                    (c >= 0 && c < t.size - 1 || d > 1 && d <= t.size || c <= 0 && d >= t.size) && (t.visibleSlides.push(l), t.visibleSlidesIndexes.push(o), r.eq(o).addClass(n.slideVisibleClass));
                }
                l.progress = a ? -s : s;
            }
            t.visibleSlides = Er(t.visibleSlides);
        }
    },
    updateProgress: function(e1) {
        var t = this;
        if (void 0 === e1) {
            var n = t.rtlTranslate ? -1 : 1;
            e1 = t && t.translate && t.translate * n || 0;
        }
        var r = t.params, a = t.maxTranslate() - t.minTranslate(), i = t.progress, o = t.isBeginning, l = t.isEnd, s = o, c = l;
        0 === a ? (i = 0, o = !0, l = !0) : (o = (i = (e1 - t.minTranslate()) / a) <= 0, l = i >= 1), Mr(t, {
            progress: i,
            isBeginning: o,
            isEnd: l
        }), (r.watchSlidesProgress || r.watchSlidesVisibility || r.centeredSlides && r.autoHeight) && t.updateSlidesProgress(e1), o && !s && t.emit("reachBeginning toEdge"), l && !c && t.emit("reachEnd toEdge"), (s && !o || c && !l) && t.emit("fromEdge"), t.emit("progress", i);
    },
    updateSlidesClasses: function() {
        var e1, t = this, n = t.slides, r = t.params, a = t.$wrapperEl, i = t.activeIndex, o = t.realIndex, l = t.virtual && r.virtual.enabled;
        n.removeClass(r.slideActiveClass + " " + r.slideNextClass + " " + r.slidePrevClass + " " + r.slideDuplicateActiveClass + " " + r.slideDuplicateNextClass + " " + r.slideDuplicatePrevClass), (e1 = l ? t.$wrapperEl.find("." + r.slideClass + '[data-swiper-slide-index="' + i + '"]') : n.eq(i)).addClass(r.slideActiveClass), r.loop && (e1.hasClass(r.slideDuplicateClass) ? a.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + o + '"]').addClass(r.slideDuplicateActiveClass) : a.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + o + '"]').addClass(r.slideDuplicateActiveClass));
        var s = e1.nextAll("." + r.slideClass).eq(0).addClass(r.slideNextClass);
        r.loop && 0 === s.length && (s = n.eq(0)).addClass(r.slideNextClass);
        var c = e1.prevAll("." + r.slideClass).eq(0).addClass(r.slidePrevClass);
        r.loop && 0 === c.length && (c = n.eq(-1)).addClass(r.slidePrevClass), r.loop && (s.hasClass(r.slideDuplicateClass) ? a.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + s.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass) : a.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + s.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicateNextClass), c.hasClass(r.slideDuplicateClass) ? a.children("." + r.slideClass + ":not(." + r.slideDuplicateClass + ')[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass) : a.children("." + r.slideClass + "." + r.slideDuplicateClass + '[data-swiper-slide-index="' + c.attr("data-swiper-slide-index") + '"]').addClass(r.slideDuplicatePrevClass)), t.emitSlidesClasses();
    },
    updateActiveIndex: function(e1) {
        var t, n = this, r = n.rtlTranslate ? n.translate : -n.translate, a = n.slidesGrid, i = n.snapGrid, o = n.params, l = n.activeIndex, s = n.realIndex, c = n.snapIndex, d = e1;
        if (void 0 === d) {
            for(var u = 0; u < a.length; u += 1)void 0 !== a[u + 1] ? r >= a[u] && r < a[u + 1] - (a[u + 1] - a[u]) / 2 ? d = u : r >= a[u] && r < a[u + 1] && (d = u + 1) : r >= a[u] && (d = u);
            o.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
        }
        if (i.indexOf(r) >= 0) t = i.indexOf(r);
        else {
            var p = Math.min(o.slidesPerGroupSkip, d);
            t = p + Math.floor((d - p) / o.slidesPerGroup);
        }
        if (t >= i.length && (t = i.length - 1), d !== l) {
            var m = parseInt(n.slides.eq(d).attr("data-swiper-slide-index") || d, 10);
            Mr(n, {
                snapIndex: t,
                realIndex: m,
                previousIndex: l,
                activeIndex: d
            }), n.emit("activeIndexChange"), n.emit("snapIndexChange"), s !== m && n.emit("realIndexChange"), (n.initialized || n.params.runCallbacksOnInit) && n.emit("slideChange");
        } else t !== c && (n.snapIndex = t, n.emit("snapIndexChange"));
    },
    updateClickedSlide: function(e1) {
        var t, n = this, r = n.params, a = Er(e1.target).closest("." + r.slideClass)[0], i = !1;
        if (a) {
            for(var o = 0; o < n.slides.length; o += 1)if (n.slides[o] === a) {
                i = !0, t = o;
                break;
            }
        }
        if (!a || !i) return n.clickedSlide = void 0, void (n.clickedIndex = void 0);
        n.clickedSlide = a, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(Er(a).attr("data-swiper-slide-index"), 10) : n.clickedIndex = t, r.slideToClickedSlide && void 0 !== n.clickedIndex && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
    }
};
var Gr = {
    getTranslate: function(e1) {
        void 0 === e1 && (e1 = this.isHorizontal() ? "x" : "y");
        var t = this, n = t.params, r = t.rtlTranslate, a = t.translate, i = t.$wrapperEl;
        if (n.virtualTranslate) return r ? -a : a;
        if (n.cssMode) return a;
        var o = _r(i[0], e1);
        return r && (o = -o), o || 0;
    },
    setTranslate: function(e1, t) {
        var n = this, r = n.rtlTranslate, a = n.params, i = n.$wrapperEl, o = n.wrapperEl, l = n.progress, s = 0, c = 0;
        n.isHorizontal() ? s = r ? -e1 : e1 : c = e1, a.roundLengths && (s = Math.floor(s), c = Math.floor(c)), a.cssMode ? o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -s : -c : a.virtualTranslate || i.transform("translate3d(" + s + "px, " + c + "px, 0px)"), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? s : c;
        var d = n.maxTranslate() - n.minTranslate();
        (0 === d ? 0 : (e1 - n.minTranslate()) / d) !== l && n.updateProgress(e1), n.emit("setTranslate", n.translate, t);
    },
    minTranslate: function() {
        return -this.snapGrid[0];
    },
    maxTranslate: function() {
        return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function(e1, t, n, r, a) {
        void 0 === e1 && (e1 = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), void 0 === r && (r = !0);
        var i = this, o = i.params, l = i.wrapperEl;
        if (i.animating && o.preventInteractionOnTransition) return !1;
        var s, c = i.minTranslate(), d = i.maxTranslate();
        if (s = r && e1 > c ? c : r && e1 < d ? d : e1, i.updateProgress(s), o.cssMode) {
            var u, p = i.isHorizontal();
            if (0 === t) l[p ? "scrollLeft" : "scrollTop"] = -s;
            else if (l.scrollTo) l.scrollTo(((u = {})[p ? "left" : "top"] = -s, u.behavior = "smooth", u));
            else l[p ? "scrollLeft" : "scrollTop"] = -s;
            return !0;
        }
        return 0 === t ? (i.setTransition(0), i.setTranslate(s), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionEnd"))) : (i.setTransition(t), i.setTranslate(s), n && (i.emit("beforeTransitionStart", t, a), i.emit("transitionStart")), i.animating || (i.animating = !0, i.onTranslateToWrapperTransitionEnd || (i.onTranslateToWrapperTransitionEnd = function(e1) {
            i && !i.destroyed && e1.target === this && (i.$wrapperEl[0].removeEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.$wrapperEl[0].removeEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd), i.onTranslateToWrapperTransitionEnd = null, delete i.onTranslateToWrapperTransitionEnd, n && i.emit("transitionEnd"));
        }), i.$wrapperEl[0].addEventListener("transitionend", i.onTranslateToWrapperTransitionEnd), i.$wrapperEl[0].addEventListener("webkitTransitionEnd", i.onTranslateToWrapperTransitionEnd))), !0;
    }
};
var Ur = {
    slideTo: function(e1, t, n, r, a) {
        if (void 0 === e1 && (e1 = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0), "number" != typeof e1 && "string" != typeof e1) throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof e1 + "] given.");
        if ("string" == typeof e1) {
            var i = parseInt(e1, 10);
            if (!isFinite(i)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + e1 + "] given.");
            e1 = i;
        }
        var o = this, l = e1;
        l < 0 && (l = 0);
        var s = o.params, c = o.snapGrid, d = o.slidesGrid, u = o.previousIndex, p = o.activeIndex, m = o.rtlTranslate, f = o.wrapperEl, v = o.enabled;
        if (o.animating && s.preventInteractionOnTransition || !v && !r && !a) return !1;
        var h = Math.min(o.params.slidesPerGroupSkip, l), g = h + Math.floor((l - h) / o.params.slidesPerGroup);
        g >= c.length && (g = c.length - 1), (p || s.initialSlide || 0) === (u || 0) && n && o.emit("beforeSlideChangeStart");
        var b, y = -c[g];
        if (o.updateProgress(y), s.normalizeSlideIndex) for(var x = 0; x < d.length; x += 1){
            var E = -Math.floor(100 * y), w = Math.floor(100 * d[x]), C = Math.floor(100 * d[x + 1]);
            void 0 !== d[x + 1] ? E >= w && E < C - (C - w) / 2 ? l = x : E >= w && E < C && (l = x + 1) : E >= w && (l = x);
        }
        if (o.initialized && l !== p) {
            if (!o.allowSlideNext && y < o.translate && y < o.minTranslate()) return !1;
            if (!o.allowSlidePrev && y > o.translate && y > o.maxTranslate() && (p || 0) !== l) return !1;
        }
        if (b = l > p ? "next" : l < p ? "prev" : "reset", m && -y === o.translate || !m && y === o.translate) return o.updateActiveIndex(l), s.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), "slide" !== s.effect && o.setTranslate(y), "reset" !== b && (o.transitionStart(n, b), o.transitionEnd(n, b)), !1;
        if (s.cssMode) {
            var S, T = o.isHorizontal(), N = -y;
            if (m && (N = f.scrollWidth - f.offsetWidth - N), 0 === t) f[T ? "scrollLeft" : "scrollTop"] = N;
            else if (f.scrollTo) f.scrollTo(((S = {})[T ? "left" : "top"] = N, S.behavior = "smooth", S));
            else f[T ? "scrollLeft" : "scrollTop"] = N;
            return !0;
        }
        return 0 === t ? (o.setTransition(0), o.setTranslate(y), o.updateActiveIndex(l), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, b), o.transitionEnd(n, b)) : (o.setTransition(t), o.setTranslate(y), o.updateActiveIndex(l), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, r), o.transitionStart(n, b), o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(e1) {
            o && !o.destroyed && e1.target === this && (o.$wrapperEl[0].removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].removeEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(n, b));
        }), o.$wrapperEl[0].addEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.$wrapperEl[0].addEventListener("webkitTransitionEnd", o.onSlideToWrapperTransitionEnd))), !0;
    },
    slideToLoop: function(e1, t, n, r) {
        void 0 === e1 && (e1 = 0), void 0 === t && (t = this.params.speed), void 0 === n && (n = !0);
        var a = this, i = e1;
        return a.params.loop && (i += a.loopedSlides), a.slideTo(i, t, n, r);
    },
    slideNext: function(e1, t, n) {
        void 0 === e1 && (e1 = this.params.speed), void 0 === t && (t = !0);
        var r = this, a = r.params, i = r.animating;
        if (!r.enabled) return r;
        var o = r.activeIndex < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup;
        if (a.loop) {
            if (i && a.loopPreventsSlide) return !1;
            r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
        }
        return r.slideTo(r.activeIndex + o, e1, t, n);
    },
    slidePrev: function(e1, t, n) {
        void 0 === e1 && (e1 = this.params.speed), void 0 === t && (t = !0);
        var r = this, a = r.params, i = r.animating, o = r.snapGrid, l = r.slidesGrid, s = r.rtlTranslate;
        if (!r.enabled) return r;
        if (a.loop) {
            if (i && a.loopPreventsSlide) return !1;
            r.loopFix(), r._clientLeft = r.$wrapperEl[0].clientLeft;
        }
        function c(e1) {
            return e1 < 0 ? -Math.floor(Math.abs(e1)) : Math.floor(e1);
        }
        var d, u = c(s ? r.translate : -r.translate), p = o.map(function(e1) {
            return c(e1);
        }), m = o[p.indexOf(u) - 1];
        return void 0 === m && a.cssMode && o.forEach(function(e1) {
            !m && u >= e1 && (m = e1);
        }), void 0 !== m && (d = l.indexOf(m)) < 0 && (d = r.activeIndex - 1), r.slideTo(d, e1, t, n);
    },
    slideReset: function(e1, t, n) {
        return void 0 === e1 && (e1 = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e1, t, n);
    },
    slideToClosest: function(e1, t, n, r) {
        void 0 === e1 && (e1 = this.params.speed), void 0 === t && (t = !0), void 0 === r && (r = .5);
        var a = this, i = a.activeIndex, o = Math.min(a.params.slidesPerGroupSkip, i), l = o + Math.floor((i - o) / a.params.slidesPerGroup), s = a.rtlTranslate ? a.translate : -a.translate;
        if (s >= a.snapGrid[l]) {
            var c = a.snapGrid[l];
            s - c > (a.snapGrid[l + 1] - c) * r && (i += a.params.slidesPerGroup);
        } else {
            var d = a.snapGrid[l - 1];
            s - d <= (a.snapGrid[l] - d) * r && (i -= a.params.slidesPerGroup);
        }
        return i = Math.max(i, 0), i = Math.min(i, a.slidesGrid.length - 1), a.slideTo(i, e1, t, n);
    },
    slideToClickedSlide: function() {
        var e1, t = this, n = t.params, r = t.$wrapperEl, a = "auto" === n.slidesPerView ? t.slidesPerViewDynamic() : n.slidesPerView, i = t.clickedIndex;
        if (n.loop) {
            if (t.animating) return;
            e1 = parseInt(Er(t.clickedSlide).attr("data-swiper-slide-index"), 10), n.centeredSlides ? i < t.loopedSlides - a / 2 || i > t.slides.length - t.loopedSlides + a / 2 ? (t.loopFix(), i = r.children("." + n.slideClass + '[data-swiper-slide-index="' + e1 + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), Nr(function() {
                t.slideTo(i);
            })) : t.slideTo(i) : i > t.slides.length - a ? (t.loopFix(), i = r.children("." + n.slideClass + '[data-swiper-slide-index="' + e1 + '"]:not(.' + n.slideDuplicateClass + ")").eq(0).index(), Nr(function() {
                t.slideTo(i);
            })) : t.slideTo(i);
        } else t.slideTo(i);
    }
};
var Vr = {
    loopCreate: function() {
        var e1 = this, t = ur(), n = e1.params, r = e1.$wrapperEl;
        r.children("." + n.slideClass + "." + n.slideDuplicateClass).remove();
        var a = r.children("." + n.slideClass);
        if (n.loopFillGroupWithBlank) {
            var i = n.slidesPerGroup - a.length % n.slidesPerGroup;
            if (i !== n.slidesPerGroup) {
                for(var o = 0; o < i; o += 1){
                    var l = Er(t.createElement("div")).addClass(n.slideClass + " " + n.slideBlankClass);
                    r.append(l);
                }
                a = r.children("." + n.slideClass);
            }
        }
        "auto" !== n.slidesPerView || n.loopedSlides || (n.loopedSlides = a.length), e1.loopedSlides = Math.ceil(parseFloat(n.loopedSlides || n.slidesPerView, 10)), e1.loopedSlides += n.loopAdditionalSlides, e1.loopedSlides > a.length && (e1.loopedSlides = a.length);
        var s = [], c = [];
        a.each(function(t, n) {
            var r = Er(t);
            n < e1.loopedSlides && c.push(t), n < a.length && n >= a.length - e1.loopedSlides && s.push(t), r.attr("data-swiper-slide-index", n);
        });
        for(var d = 0; d < c.length; d += 1)r.append(Er(c[d].cloneNode(!0)).addClass(n.slideDuplicateClass));
        for(var u = s.length - 1; u >= 0; u -= 1)r.prepend(Er(s[u].cloneNode(!0)).addClass(n.slideDuplicateClass));
    },
    loopFix: function() {
        var e1 = this;
        e1.emit("beforeLoopFix");
        var t, n = e1.activeIndex, r = e1.slides, a = e1.loopedSlides, i = e1.allowSlidePrev, o = e1.allowSlideNext, l = e1.snapGrid, s = e1.rtlTranslate;
        e1.allowSlidePrev = !0, e1.allowSlideNext = !0;
        var c = -l[n] - e1.getTranslate();
        if (n < a) t = r.length - 3 * a + n, t += a, e1.slideTo(t, 0, !1, !0) && 0 !== c && e1.setTranslate((s ? -e1.translate : e1.translate) - c);
        else if (n >= r.length - a) {
            t = -r.length + n + a, t += a, e1.slideTo(t, 0, !1, !0) && 0 !== c && e1.setTranslate((s ? -e1.translate : e1.translate) - c);
        }
        e1.allowSlidePrev = i, e1.allowSlideNext = o, e1.emit("loopFix");
    },
    loopDestroy: function() {
        var e1 = this, t = e1.$wrapperEl, n = e1.params, r = e1.slides;
        t.children("." + n.slideClass + "." + n.slideDuplicateClass + ",." + n.slideClass + "." + n.slideBlankClass).remove(), r.removeAttr("data-swiper-slide-index");
    }
};
var qr = {
    appendSlide: function(e1) {
        var t = this, n = t.$wrapperEl, r = t.params;
        if (r.loop && t.loopDestroy(), "object" == typeof e1 && "length" in e1) for(var a = 0; a < e1.length; a += 1)e1[a] && n.append(e1[a]);
        else n.append(e1);
        r.loop && t.loopCreate(), r.observer && t.support.observer || t.update();
    },
    prependSlide: function(e1) {
        var t = this, n = t.params, r = t.$wrapperEl, a = t.activeIndex;
        n.loop && t.loopDestroy();
        var i = a + 1;
        if ("object" == typeof e1 && "length" in e1) {
            for(var o = 0; o < e1.length; o += 1)e1[o] && r.prepend(e1[o]);
            i = a + e1.length;
        } else r.prepend(e1);
        n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), t.slideTo(i, 0, !1);
    },
    addSlide: function(e1, t) {
        var n = this, r = n.$wrapperEl, a = n.params, i = n.activeIndex;
        a.loop && (i -= n.loopedSlides, n.loopDestroy(), n.slides = r.children("." + a.slideClass));
        var o = n.slides.length;
        if (e1 <= 0) n.prependSlide(t);
        else if (e1 >= o) n.appendSlide(t);
        else {
            for(var l = i > e1 ? i + 1 : i, s = [], c = o - 1; c >= e1; c -= 1){
                var d = n.slides.eq(c);
                d.remove(), s.unshift(d);
            }
            if ("object" == typeof t && "length" in t) {
                for(var u = 0; u < t.length; u += 1)t[u] && r.append(t[u]);
                l = i > e1 ? i + t.length : i;
            } else r.append(t);
            for(var p = 0; p < s.length; p += 1)r.append(s[p]);
            a.loop && n.loopCreate(), a.observer && n.support.observer || n.update(), a.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
        }
    },
    removeSlide: function(e1) {
        var t = this, n = t.params, r = t.$wrapperEl, a = t.activeIndex;
        n.loop && (a -= t.loopedSlides, t.loopDestroy(), t.slides = r.children("." + n.slideClass));
        var i, o = a;
        if ("object" == typeof e1 && "length" in e1) {
            for(var l = 0; l < e1.length; l += 1)i = e1[l], t.slides[i] && t.slides.eq(i).remove(), i < o && (o -= 1);
            o = Math.max(o, 0);
        } else i = e1, t.slides[i] && t.slides.eq(i).remove(), i < o && (o -= 1), o = Math.max(o, 0);
        n.loop && t.loopCreate(), n.observer && t.support.observer || t.update(), n.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
    },
    removeAllSlides: function() {
        for(var e1 = [], t = 0; t < this.slides.length; t += 1)e1.push(t);
        this.removeSlide(e1);
    }
};
function Yr(e1) {
    var t = this, n = ur(), r = mr(), a = t.touchEventsData, i = t.params, o = t.touches;
    if (t.enabled && (!t.animating || !i.preventInteractionOnTransition)) {
        var l = e1;
        l.originalEvent && (l = l.originalEvent);
        var s = Er(l.target);
        if (("wrapper" !== i.touchEventsTarget || s.closest(t.wrapperEl).length) && (a.isTouchEvent = "touchstart" === l.type, (a.isTouchEvent || !("which" in l) || 3 !== l.which) && !(!a.isTouchEvent && "button" in l && l.button > 0 || a.isTouched && a.isMoved))) {
            !!i.noSwipingClass && "" !== i.noSwipingClass && l.target && l.target.shadowRoot && e1.path && e1.path[0] && (s = Er(e1.path[0]));
            var c = i.noSwipingSelector ? i.noSwipingSelector : "." + i.noSwipingClass, d = !(!l.target || !l.target.shadowRoot);
            if (i.noSwiping && (d ? function(e1, t) {
                return void 0 === t && (t = this), function t(n) {
                    return n && n !== ur() && n !== mr() ? (n.assignedSlot && (n = n.assignedSlot), n.closest(e1) || t(n.getRootNode().host)) : null;
                }(t);
            }(c, l.target) : s.closest(c)[0])) t.allowClick = !0;
            else if (!i.swipeHandler || s.closest(i.swipeHandler)[0]) {
                o.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX, o.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY;
                var u = o.currentX, p = o.currentY, m = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection, f = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
                if (m && (u <= f || u >= r.innerWidth - f)) {
                    if ("prevent" !== m) return;
                    e1.preventDefault();
                }
                if (Mr(a, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0
                }), o.startX = u, o.startY = p, a.touchStartTime = kr(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, i.threshold > 0 && (a.allowThresholdMove = !1), "touchstart" !== l.type) {
                    var v = !0;
                    s.is(a.focusableElements) && (v = !1), n.activeElement && Er(n.activeElement).is(a.focusableElements) && n.activeElement !== s[0] && n.activeElement.blur();
                    var h = v && t.allowTouchMove && i.touchStartPreventDefault;
                    !i.touchStartForcePreventDefault && !h || s[0].isContentEditable || l.preventDefault();
                }
                t.emit("touchStart", l);
            }
        }
    }
}
function Xr(e1) {
    var t = ur(), n = this, r = n.touchEventsData, a = n.params, i = n.touches, o = n.rtlTranslate;
    if (n.enabled) {
        var l = e1;
        if (l.originalEvent && (l = l.originalEvent), r.isTouched) {
            if (!r.isTouchEvent || "touchmove" === l.type) {
                var s = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]), c = "touchmove" === l.type ? s.pageX : l.pageX, d = "touchmove" === l.type ? s.pageY : l.pageY;
                if (l.preventedByNestedSwiper) return i.startX = c, void (i.startY = d);
                if (!n.allowTouchMove) return n.allowClick = !1, void (r.isTouched && (Mr(i, {
                    startX: c,
                    startY: d,
                    currentX: c,
                    currentY: d
                }), r.touchStartTime = kr()));
                if (r.isTouchEvent && a.touchReleaseOnEdges && !a.loop) {
                    if (n.isVertical()) {
                        if (d < i.startY && n.translate <= n.maxTranslate() || d > i.startY && n.translate >= n.minTranslate()) return r.isTouched = !1, void (r.isMoved = !1);
                    } else if (c < i.startX && n.translate <= n.maxTranslate() || c > i.startX && n.translate >= n.minTranslate()) return;
                }
                if (r.isTouchEvent && t.activeElement && l.target === t.activeElement && Er(l.target).is(r.focusableElements)) return r.isMoved = !0, void (n.allowClick = !1);
                if (r.allowTouchCallbacks && n.emit("touchMove", l), !(l.targetTouches && l.targetTouches.length > 1)) {
                    i.currentX = c, i.currentY = d;
                    var u = i.currentX - i.startX, p = i.currentY - i.startY;
                    if (!(n.params.threshold && Math.sqrt(Math.pow(u, 2) + Math.pow(p, 2)) < n.params.threshold)) {
                        var m;
                        if (void 0 === r.isScrolling) n.isHorizontal() && i.currentY === i.startY || n.isVertical() && i.currentX === i.startX ? r.isScrolling = !1 : u * u + p * p >= 25 && (m = 180 * Math.atan2(Math.abs(p), Math.abs(u)) / Math.PI, r.isScrolling = n.isHorizontal() ? m > a.touchAngle : 90 - m > a.touchAngle);
                        if (r.isScrolling && n.emit("touchMoveOpposite", l), void 0 === r.startMoving && (i.currentX === i.startX && i.currentY === i.startY || (r.startMoving = !0)), r.isScrolling) r.isTouched = !1;
                        else if (r.startMoving) {
                            n.allowClick = !1, !a.cssMode && l.cancelable && l.preventDefault(), a.touchMoveStopPropagation && !a.nested && l.stopPropagation(), r.isMoved || (a.loop && n.loopFix(), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating && n.$wrapperEl.trigger("webkitTransitionEnd transitionend"), r.allowMomentumBounce = !1, !a.grabCursor || !0 !== n.allowSlideNext && !0 !== n.allowSlidePrev || n.setGrabCursor(!0), n.emit("sliderFirstMove", l)), n.emit("sliderMove", l), r.isMoved = !0;
                            var f = n.isHorizontal() ? u : p;
                            i.diff = f, f *= a.touchRatio, o && (f = -f), n.swipeDirection = f > 0 ? "prev" : "next", r.currentTranslate = f + r.startTranslate;
                            var v = !0, h = a.resistanceRatio;
                            if (a.touchReleaseOnEdges && (h = 0), f > 0 && r.currentTranslate > n.minTranslate() ? (v = !1, a.resistance && (r.currentTranslate = n.minTranslate() - 1 + Math.pow(-n.minTranslate() + r.startTranslate + f, h))) : f < 0 && r.currentTranslate < n.maxTranslate() && (v = !1, a.resistance && (r.currentTranslate = n.maxTranslate() + 1 - Math.pow(n.maxTranslate() - r.startTranslate - f, h))), v && (l.preventedByNestedSwiper = !0), !n.allowSlideNext && "next" === n.swipeDirection && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && "prev" === n.swipeDirection && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), n.allowSlidePrev || n.allowSlideNext || (r.currentTranslate = r.startTranslate), a.threshold > 0) {
                                if (!(Math.abs(f) > a.threshold || r.allowThresholdMove)) return void (r.currentTranslate = r.startTranslate);
                                if (!r.allowThresholdMove) return r.allowThresholdMove = !0, i.startX = i.currentX, i.startY = i.currentY, r.currentTranslate = r.startTranslate, void (i.diff = n.isHorizontal() ? i.currentX - i.startX : i.currentY - i.startY);
                            }
                            a.followFinger && !a.cssMode && ((a.freeMode || a.watchSlidesProgress || a.watchSlidesVisibility) && (n.updateActiveIndex(), n.updateSlidesClasses()), a.freeMode && (0 === r.velocities.length && r.velocities.push({
                                position: i[n.isHorizontal() ? "startX" : "startY"],
                                time: r.touchStartTime
                            }), r.velocities.push({
                                position: i[n.isHorizontal() ? "currentX" : "currentY"],
                                time: kr()
                            })), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
                        }
                    }
                }
            }
        } else r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", l);
    }
}
function Kr(e1) {
    var t = this, n = t.touchEventsData, r = t.params, a = t.touches, i = t.rtlTranslate, o = t.$wrapperEl, l = t.slidesGrid, s = t.snapGrid;
    if (t.enabled) {
        var c = e1;
        if (c.originalEvent && (c = c.originalEvent), n.allowTouchCallbacks && t.emit("touchEnd", c), n.allowTouchCallbacks = !1, !n.isTouched) return n.isMoved && r.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, void (n.startMoving = !1);
        r.grabCursor && n.isMoved && n.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
        var d, u = kr(), p = u - n.touchStartTime;
        if (t.allowClick && (t.updateClickedSlide(c), t.emit("tap click", c), p < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", c)), n.lastClickTime = kr(), Nr(function() {
            t.destroyed || (t.allowClick = !0);
        }), !n.isTouched || !n.isMoved || !t.swipeDirection || 0 === a.diff || n.currentTranslate === n.startTranslate) return n.isTouched = !1, n.isMoved = !1, void (n.startMoving = !1);
        if (n.isTouched = !1, n.isMoved = !1, n.startMoving = !1, d = r.followFinger ? i ? t.translate : -t.translate : -n.currentTranslate, !r.cssMode) if (r.freeMode) {
            if (d < -t.minTranslate()) return void t.slideTo(t.activeIndex);
            if (d > -t.maxTranslate()) return void (t.slides.length < s.length ? t.slideTo(s.length - 1) : t.slideTo(t.slides.length - 1));
            if (r.freeModeMomentum) {
                if (n.velocities.length > 1) {
                    var m = n.velocities.pop(), f = n.velocities.pop(), v = m.position - f.position, h = m.time - f.time;
                    t.velocity = v / h, t.velocity /= 2, Math.abs(t.velocity) < r.freeModeMinimumVelocity && (t.velocity = 0), (h > 150 || kr() - m.time > 300) && (t.velocity = 0);
                } else t.velocity = 0;
                t.velocity *= r.freeModeMomentumVelocityRatio, n.velocities.length = 0;
                var g = 1e3 * r.freeModeMomentumRatio, b = t.velocity * g, y = t.translate + b;
                i && (y = -y);
                var x, E, w = !1, C = 20 * Math.abs(t.velocity) * r.freeModeMomentumBounceRatio;
                if (y < t.maxTranslate()) r.freeModeMomentumBounce ? (y + t.maxTranslate() < -C && (y = t.maxTranslate() - C), x = t.maxTranslate(), w = !0, n.allowMomentumBounce = !0) : y = t.maxTranslate(), r.loop && r.centeredSlides && (E = !0);
                else if (y > t.minTranslate()) r.freeModeMomentumBounce ? (y - t.minTranslate() > C && (y = t.minTranslate() + C), x = t.minTranslate(), w = !0, n.allowMomentumBounce = !0) : y = t.minTranslate(), r.loop && r.centeredSlides && (E = !0);
                else if (r.freeModeSticky) {
                    for(var S, T = 0; T < s.length; T += 1)if (s[T] > -y) {
                        S = T;
                        break;
                    }
                    y = -(y = Math.abs(s[S] - y) < Math.abs(s[S - 1] - y) || "next" === t.swipeDirection ? s[S] : s[S - 1]);
                }
                if (E && t.once("transitionEnd", function() {
                    t.loopFix();
                }), 0 !== t.velocity) {
                    if (g = i ? Math.abs((-y - t.translate) / t.velocity) : Math.abs((y - t.translate) / t.velocity), r.freeModeSticky) {
                        var N = Math.abs((i ? -y : y) - t.translate), k = t.slidesSizesGrid[t.activeIndex];
                        g = N < k ? r.speed : N < 2 * k ? 1.5 * r.speed : 2.5 * r.speed;
                    }
                } else if (r.freeModeSticky) return void t.slideToClosest();
                r.freeModeMomentumBounce && w ? (t.updateProgress(x), t.setTransition(g), t.setTranslate(y), t.transitionStart(!0, t.swipeDirection), t.animating = !0, o.transitionEnd(function() {
                    t && !t.destroyed && n.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(r.speed), setTimeout(function() {
                        t.setTranslate(x), o.transitionEnd(function() {
                            t && !t.destroyed && t.transitionEnd();
                        });
                    }, 0));
                })) : t.velocity ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(y), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, o.transitionEnd(function() {
                    t && !t.destroyed && t.transitionEnd();
                }))) : (t.emit("_freeModeNoMomentumRelease"), t.updateProgress(y)), t.updateActiveIndex(), t.updateSlidesClasses();
            } else {
                if (r.freeModeSticky) return void t.slideToClosest();
                r.freeMode && t.emit("_freeModeNoMomentumRelease");
            }
            (!r.freeModeMomentum || p >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
        } else {
            for(var _ = 0, O = t.slidesSizesGrid[0], M = 0; M < l.length; M += M < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup){
                var P = M < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
                void 0 !== l[M + P] ? d >= l[M] && d < l[M + P] && (_ = M, O = l[M + P] - l[M]) : d >= l[M] && (_ = M, O = l[l.length - 1] - l[l.length - 2]);
            }
            var L = (d - l[_]) / O, I = _ < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
            if (p > r.longSwipesMs) {
                if (!r.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection && (L >= r.longSwipesRatio ? t.slideTo(_ + I) : t.slideTo(_)), "prev" === t.swipeDirection && (L > 1 - r.longSwipesRatio ? t.slideTo(_ + I) : t.slideTo(_));
            } else {
                if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
                t.navigation && (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl) ? c.target === t.navigation.nextEl ? t.slideTo(_ + I) : t.slideTo(_) : ("next" === t.swipeDirection && t.slideTo(_ + I), "prev" === t.swipeDirection && t.slideTo(_));
            }
        }
    }
}
function Qr() {
    var e1 = this, t = e1.params, n = e1.el;
    if (!n || 0 !== n.offsetWidth) {
        t.breakpoints && e1.setBreakpoint();
        var r = e1.allowSlideNext, a = e1.allowSlidePrev, i = e1.snapGrid;
        e1.allowSlideNext = !0, e1.allowSlidePrev = !0, e1.updateSize(), e1.updateSlides(), e1.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && e1.isEnd && !e1.isBeginning && !e1.params.centeredSlides ? e1.slideTo(e1.slides.length - 1, 0, !1, !0) : e1.slideTo(e1.activeIndex, 0, !1, !0), e1.autoplay && e1.autoplay.running && e1.autoplay.paused && e1.autoplay.run(), e1.allowSlidePrev = a, e1.allowSlideNext = r, e1.params.watchOverflow && i !== e1.snapGrid && e1.checkOverflow();
    }
}
function Jr(e1) {
    var t = this;
    t.enabled && (t.allowClick || (t.params.preventClicks && e1.preventDefault(), t.params.preventClicksPropagation && t.animating && (e1.stopPropagation(), e1.stopImmediatePropagation())));
}
function Zr() {
    var e1 = this, t = e1.wrapperEl, n = e1.rtlTranslate;
    if (e1.enabled) {
        e1.previousTranslate = e1.translate, e1.isHorizontal() ? e1.translate = n ? t.scrollWidth - t.offsetWidth - t.scrollLeft : -t.scrollLeft : e1.translate = -t.scrollTop, -0 === e1.translate && (e1.translate = 0), e1.updateActiveIndex(), e1.updateSlidesClasses();
        var r = e1.maxTranslate() - e1.minTranslate();
        (0 === r ? 0 : (e1.translate - e1.minTranslate()) / r) !== e1.progress && e1.updateProgress(n ? -e1.translate : e1.translate), e1.emit("setTranslate", e1.translate, !1);
    }
}
var ea = !1;
function ta() {}
var na = {
    attachEvents: function() {
        var e1 = this, t = ur(), n = e1.params, r = e1.touchEvents, a = e1.el, i = e1.wrapperEl, o = e1.device, l = e1.support;
        e1.onTouchStart = Yr.bind(e1), e1.onTouchMove = Xr.bind(e1), e1.onTouchEnd = Kr.bind(e1), n.cssMode && (e1.onScroll = Zr.bind(e1)), e1.onClick = Jr.bind(e1);
        var s = !!n.nested;
        if (!l.touch && l.pointerEvents) a.addEventListener(r.start, e1.onTouchStart, !1), t.addEventListener(r.move, e1.onTouchMove, s), t.addEventListener(r.end, e1.onTouchEnd, !1);
        else {
            if (l.touch) {
                var c = !("touchstart" !== r.start || !l.passiveListener || !n.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                a.addEventListener(r.start, e1.onTouchStart, c), a.addEventListener(r.move, e1.onTouchMove, l.passiveListener ? {
                    passive: !1,
                    capture: s
                } : s), a.addEventListener(r.end, e1.onTouchEnd, c), r.cancel && a.addEventListener(r.cancel, e1.onTouchEnd, c), ea || (t.addEventListener("touchstart", ta), ea = !0);
            }
            (n.simulateTouch && !o.ios && !o.android || n.simulateTouch && !l.touch && o.ios) && (a.addEventListener("mousedown", e1.onTouchStart, !1), t.addEventListener("mousemove", e1.onTouchMove, s), t.addEventListener("mouseup", e1.onTouchEnd, !1));
        }
        (n.preventClicks || n.preventClicksPropagation) && a.addEventListener("click", e1.onClick, !0), n.cssMode && i.addEventListener("scroll", e1.onScroll), n.updateOnWindowResize ? e1.on(o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Qr, !0) : e1.on("observerUpdate", Qr, !0);
    },
    detachEvents: function() {
        var e1 = this, t = ur(), n = e1.params, r = e1.touchEvents, a = e1.el, i = e1.wrapperEl, o = e1.device, l = e1.support, s = !!n.nested;
        if (!l.touch && l.pointerEvents) a.removeEventListener(r.start, e1.onTouchStart, !1), t.removeEventListener(r.move, e1.onTouchMove, s), t.removeEventListener(r.end, e1.onTouchEnd, !1);
        else {
            if (l.touch) {
                var c = !("onTouchStart" !== r.start || !l.passiveListener || !n.passiveListeners) && {
                    passive: !0,
                    capture: !1
                };
                a.removeEventListener(r.start, e1.onTouchStart, c), a.removeEventListener(r.move, e1.onTouchMove, s), a.removeEventListener(r.end, e1.onTouchEnd, c), r.cancel && a.removeEventListener(r.cancel, e1.onTouchEnd, c);
            }
            (n.simulateTouch && !o.ios && !o.android || n.simulateTouch && !l.touch && o.ios) && (a.removeEventListener("mousedown", e1.onTouchStart, !1), t.removeEventListener("mousemove", e1.onTouchMove, s), t.removeEventListener("mouseup", e1.onTouchEnd, !1));
        }
        (n.preventClicks || n.preventClicksPropagation) && a.removeEventListener("click", e1.onClick, !0), n.cssMode && i.removeEventListener("scroll", e1.onScroll), e1.off(o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Qr);
    }
};
var ra = {
    setBreakpoint: function() {
        var e1 = this, t = e1.activeIndex, n = e1.initialized, r = e1.loopedSlides, a = void 0 === r ? 0 : r, i = e1.params, o = e1.$el, l = i.breakpoints;
        if (l && (!l || 0 !== Object.keys(l).length)) {
            var s = e1.getBreakpoint(l, e1.params.breakpointsBase, e1.el);
            if (s && e1.currentBreakpoint !== s) {
                var c = s in l ? l[s] : void 0;
                c && [
                    "slidesPerView",
                    "spaceBetween",
                    "slidesPerGroup",
                    "slidesPerGroupSkip",
                    "slidesPerColumn"
                ].forEach(function(e1) {
                    var t = c[e1];
                    void 0 !== t && (c[e1] = "slidesPerView" !== e1 || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e1 ? parseFloat(t) : parseInt(t, 10) : "auto");
                });
                var d = c || e1.originalParams, u = i.slidesPerColumn > 1, p = d.slidesPerColumn > 1, m = i.enabled;
                u && !p ? (o.removeClass(i.containerModifierClass + "multirow " + i.containerModifierClass + "multirow-column"), e1.emitContainerClasses()) : !u && p && (o.addClass(i.containerModifierClass + "multirow"), (d.slidesPerColumnFill && "column" === d.slidesPerColumnFill || !d.slidesPerColumnFill && "column" === i.slidesPerColumnFill) && o.addClass(i.containerModifierClass + "multirow-column"), e1.emitContainerClasses());
                var f = d.direction && d.direction !== i.direction, v = i.loop && (d.slidesPerView !== i.slidesPerView || f);
                f && n && e1.changeDirection(), Mr(e1.params, d);
                var h = e1.params.enabled;
                Mr(e1, {
                    allowTouchMove: e1.params.allowTouchMove,
                    allowSlideNext: e1.params.allowSlideNext,
                    allowSlidePrev: e1.params.allowSlidePrev
                }), m && !h ? e1.disable() : !m && h && e1.enable(), e1.currentBreakpoint = s, e1.emit("_beforeBreakpoint", d), v && n && (e1.loopDestroy(), e1.loopCreate(), e1.updateSlides(), e1.slideTo(t - a + e1.loopedSlides, 0, !1)), e1.emit("breakpoint", d);
            }
        }
    },
    getBreakpoint: function(e1, t, n) {
        if (void 0 === t && (t = "window"), e1 && ("container" !== t || n)) {
            var r = !1, a = mr(), i = "window" === t ? a.innerHeight : n.clientHeight, o = Object.keys(e1).map(function(e1) {
                if ("string" == typeof e1 && 0 === e1.indexOf("@")) {
                    var t = parseFloat(e1.substr(1));
                    return {
                        value: i * t,
                        point: e1
                    };
                }
                return {
                    value: e1,
                    point: e1
                };
            });
            o.sort(function(e1, t) {
                return parseInt(e1.value, 10) - parseInt(t.value, 10);
            });
            for(var l = 0; l < o.length; l += 1){
                var s = o[l], c = s.point, d = s.value;
                "window" === t ? a.matchMedia("(min-width: " + d + "px)").matches && (r = c) : d <= n.clientWidth && (r = c);
            }
            return r || "max";
        }
    }
};
var aa = {
    addClasses: function() {
        var e1, t, n, r = this, a = r.classNames, i = r.params, o = r.rtl, l = r.$el, s = r.device, c = r.support, d = (e1 = [
            "initialized",
            i.direction,
            {
                "pointer-events": c.pointerEvents && !c.touch
            },
            {
                "free-mode": i.freeMode
            },
            {
                autoheight: i.autoHeight
            },
            {
                rtl: o
            },
            {
                multirow: i.slidesPerColumn > 1
            },
            {
                "multirow-column": i.slidesPerColumn > 1 && "column" === i.slidesPerColumnFill
            },
            {
                android: s.android
            },
            {
                ios: s.ios
            },
            {
                "css-mode": i.cssMode
            }
        ], t = i.containerModifierClass, n = [], e1.forEach(function(e1) {
            "object" == typeof e1 ? Object.keys(e1).forEach(function(r) {
                e1[r] && n.push(t + r);
            }) : "string" == typeof e1 && n.push(t + e1);
        }), n);
        a.push.apply(a, d), l.addClass([].concat(a).join(" ")), r.emitContainerClasses();
    },
    removeClasses: function() {
        var e1 = this, t = e1.$el, n = e1.classNames;
        t.removeClass(n.join(" ")), e1.emitContainerClasses();
    }
};
var ia = {
    init: !0,
    direction: "horizontal",
    touchEventsTarget: "container",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !1,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: !0,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: !1,
    freeModeMinimumVelocity: .02,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: "column",
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !1,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 0,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    watchSlidesVisibility: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    preloadImages: !0,
    updateOnImagesReady: !0,
    loop: !1,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: !1,
    loopPreventsSlide: !0,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    containerModifierClass: "swiper-container-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    runCallbacksOnInit: !0,
    _emitClasses: !1
};
function oa(e1, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, r.key, r);
    }
}
var la = {
    modular: Rr,
    eventsEmitter: $r,
    update: Hr,
    translate: Gr,
    transition: {
        setTransition: function(e1, t) {
            var n = this;
            n.params.cssMode || n.$wrapperEl.transition(e1), n.emit("setTransition", e1, t);
        },
        transitionStart: function(e1, t) {
            void 0 === e1 && (e1 = !0);
            var n = this, r = n.activeIndex, a = n.params, i = n.previousIndex;
            if (!a.cssMode) {
                a.autoHeight && n.updateAutoHeight();
                var o = t;
                if (o || (o = r > i ? "next" : r < i ? "prev" : "reset"), n.emit("transitionStart"), e1 && r !== i) {
                    if ("reset" === o) return void n.emit("slideResetTransitionStart");
                    n.emit("slideChangeTransitionStart"), "next" === o ? n.emit("slideNextTransitionStart") : n.emit("slidePrevTransitionStart");
                }
            }
        },
        transitionEnd: function(e1, t) {
            void 0 === e1 && (e1 = !0);
            var n = this, r = n.activeIndex, a = n.previousIndex, i = n.params;
            if (n.animating = !1, !i.cssMode) {
                n.setTransition(0);
                var o = t;
                if (o || (o = r > a ? "next" : r < a ? "prev" : "reset"), n.emit("transitionEnd"), e1 && r !== a) {
                    if ("reset" === o) return void n.emit("slideResetTransitionEnd");
                    n.emit("slideChangeTransitionEnd"), "next" === o ? n.emit("slideNextTransitionEnd") : n.emit("slidePrevTransitionEnd");
                }
            }
        }
    },
    slide: Ur,
    loop: Vr,
    grabCursor: {
        setGrabCursor: function(e1) {
            var t = this;
            if (!(t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode)) {
                var n = t.el;
                n.style.cursor = "move", n.style.cursor = e1 ? "-webkit-grabbing" : "-webkit-grab", n.style.cursor = e1 ? "-moz-grabbin" : "-moz-grab", n.style.cursor = e1 ? "grabbing" : "grab";
            }
        },
        unsetGrabCursor: function() {
            var e1 = this;
            e1.support.touch || e1.params.watchOverflow && e1.isLocked || e1.params.cssMode || (e1.el.style.cursor = "");
        }
    },
    manipulation: qr,
    events: na,
    breakpoints: ra,
    checkOverflow: {
        checkOverflow: function() {
            var e1 = this, t = e1.params, n = e1.isLocked, r = e1.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (e1.slides.length - 1) + e1.slides[0].offsetWidth * e1.slides.length;
            t.slidesOffsetBefore && t.slidesOffsetAfter && r ? e1.isLocked = r <= e1.size : e1.isLocked = 1 === e1.snapGrid.length, e1.allowSlideNext = !e1.isLocked, e1.allowSlidePrev = !e1.isLocked, n !== e1.isLocked && e1.emit(e1.isLocked ? "lock" : "unlock"), n && n !== e1.isLocked && (e1.isEnd = !1, e1.navigation && e1.navigation.update());
        }
    },
    classes: aa,
    images: {
        loadImage: function(e1, t, n, r, a, i) {
            var o, l = mr();
            function s() {
                i && i();
            }
            Er(e1).parent("picture")[0] || e1.complete && a ? s() : t ? ((o = new l.Image).onload = s, o.onerror = s, r && (o.sizes = r), n && (o.srcset = n), t && (o.src = t)) : s();
        },
        preloadImages: function() {
            var e1 = this;
            function t() {
                null != e1 && e1 && !e1.destroyed && (void 0 !== e1.imagesLoaded && (e1.imagesLoaded += 1), e1.imagesLoaded === e1.imagesToLoad.length && (e1.params.updateOnImagesReady && e1.update(), e1.emit("imagesReady")));
            }
            e1.imagesToLoad = e1.$el.find("img");
            for(var n = 0; n < e1.imagesToLoad.length; n += 1){
                var r = e1.imagesToLoad[n];
                e1.loadImage(r, r.currentSrc || r.getAttribute("src"), r.srcset || r.getAttribute("srcset"), r.sizes || r.getAttribute("sizes"), !0, t);
            }
        }
    }
}, sa = {}, ca = function() {
    function e1() {
        for(var t, n, r = arguments.length, a = new Array(r), i = 0; i < r; i++)a[i] = arguments[i];
        if (1 === a.length && a[0].constructor && "Object" === Object.prototype.toString.call(a[0]).slice(8, -1) ? n = a[0] : (t = a[0], n = a[1]), n || (n = {}), n = Mr({}, n), t && !n.el && (n.el = t), n.el && Er(n.el).length > 1) {
            var o = [];
            return Er(n.el).each(function(t) {
                var r = Mr({}, n, {
                    el: t
                });
                o.push(new e1(r));
            }), o;
        }
        var l = this;
        l.__swiper__ = !0, l.support = zr(), l.device = Fr({
            userAgent: n.userAgent
        }), l.browser = Dr(), l.eventsListeners = {}, l.eventsAnyListeners = [], void 0 === l.modules && (l.modules = {}), Object.keys(l.modules).forEach(function(e1) {
            var t = l.modules[e1];
            if (t.params) {
                var r = Object.keys(t.params)[0], a = t.params[r];
                if ("object" != typeof a || null === a) return;
                if ([
                    "navigation",
                    "pagination",
                    "scrollbar"
                ].indexOf(r) >= 0 && !0 === n[r] && (n[r] = {
                    auto: !0
                }), !(r in n) || !("enabled" in a)) return;
                !0 === n[r] && (n[r] = {
                    enabled: !0
                }), "object" != typeof n[r] || "enabled" in n[r] || (n[r].enabled = !0), n[r] || (n[r] = {
                    enabled: !1
                });
            }
        });
        var s, c, d = Mr({}, ia);
        return l.useParams(d), l.params = Mr({}, d, sa, n), l.originalParams = Mr({}, l.params), l.passedParams = Mr({}, n), l.params && l.params.on && Object.keys(l.params.on).forEach(function(e1) {
            l.on(e1, l.params.on[e1]);
        }), l.params && l.params.onAny && l.onAny(l.params.onAny), l.$ = Er, Mr(l, {
            enabled: l.params.enabled,
            el: t,
            classNames: [],
            slides: Er(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal: function() {
                return "horizontal" === l.params.direction;
            },
            isVertical: function() {
                return "vertical" === l.params.direction;
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            allowSlideNext: l.params.allowSlideNext,
            allowSlidePrev: l.params.allowSlidePrev,
            touchEvents: (s = [
                "touchstart",
                "touchmove",
                "touchend",
                "touchcancel"
            ], c = [
                "mousedown",
                "mousemove",
                "mouseup"
            ], l.support.pointerEvents && (c = [
                "pointerdown",
                "pointermove",
                "pointerup"
            ]), l.touchEventsTouch = {
                start: s[0],
                move: s[1],
                end: s[2],
                cancel: s[3]
            }, l.touchEventsDesktop = {
                start: c[0],
                move: c[1],
                end: c[2]
            }, l.support.touch || !l.params.simulateTouch ? l.touchEventsTouch : l.touchEventsDesktop),
            touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: l.params.focusableElements,
                lastClickTime: kr(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0
            },
            allowClick: !0,
            allowTouchMove: l.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            imagesToLoad: [],
            imagesLoaded: 0
        }), l.useModules(), l.emit("_swiper"), l.params.init && l.init(), l;
    }
    var t, n, r, a = e1.prototype;
    return a.enable = function() {
        var e1 = this;
        e1.enabled || (e1.enabled = !0, e1.params.grabCursor && e1.setGrabCursor(), e1.emit("enable"));
    }, a.disable = function() {
        var e1 = this;
        e1.enabled && (e1.enabled = !1, e1.params.grabCursor && e1.unsetGrabCursor(), e1.emit("disable"));
    }, a.setProgress = function(e1, t) {
        var n = this;
        e1 = Math.min(Math.max(e1, 0), 1);
        var r = n.minTranslate(), a = (n.maxTranslate() - r) * e1 + r;
        n.translateTo(a, void 0 === t ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
    }, a.emitContainerClasses = function() {
        var e1 = this;
        if (e1.params._emitClasses && e1.el) {
            var t = e1.el.className.split(" ").filter(function(t) {
                return 0 === t.indexOf("swiper-container") || 0 === t.indexOf(e1.params.containerModifierClass);
            });
            e1.emit("_containerClasses", t.join(" "));
        }
    }, a.getSlideClasses = function(e1) {
        var t = this;
        return e1.className.split(" ").filter(function(e1) {
            return 0 === e1.indexOf("swiper-slide") || 0 === e1.indexOf(t.params.slideClass);
        }).join(" ");
    }, a.emitSlidesClasses = function() {
        var e1 = this;
        if (e1.params._emitClasses && e1.el) {
            var t = [];
            e1.slides.each(function(n) {
                var r = e1.getSlideClasses(n);
                t.push({
                    slideEl: n,
                    classNames: r
                }), e1.emit("_slideClass", n, r);
            }), e1.emit("_slideClasses", t);
        }
    }, a.slidesPerViewDynamic = function() {
        var e1 = this, t = e1.params, n = e1.slides, r = e1.slidesGrid, a = e1.size, i = e1.activeIndex, o = 1;
        if (t.centeredSlides) {
            for(var l, s = n[i].swiperSlideSize, c = i + 1; c < n.length; c += 1)n[c] && !l && (o += 1, (s += n[c].swiperSlideSize) > a && (l = !0));
            for(var d = i - 1; d >= 0; d -= 1)n[d] && !l && (o += 1, (s += n[d].swiperSlideSize) > a && (l = !0));
        } else for(var u = i + 1; u < n.length; u += 1)r[u] - r[i] < a && (o += 1);
        return o;
    }, a.update = function() {
        var e1 = this;
        if (e1 && !e1.destroyed) {
            var t = e1.snapGrid, n = e1.params;
            n.breakpoints && e1.setBreakpoint(), e1.updateSize(), e1.updateSlides(), e1.updateProgress(), e1.updateSlidesClasses(), e1.params.freeMode ? (r(), e1.params.autoHeight && e1.updateAutoHeight()) : (("auto" === e1.params.slidesPerView || e1.params.slidesPerView > 1) && e1.isEnd && !e1.params.centeredSlides ? e1.slideTo(e1.slides.length - 1, 0, !1, !0) : e1.slideTo(e1.activeIndex, 0, !1, !0)) || r(), n.watchOverflow && t !== e1.snapGrid && e1.checkOverflow(), e1.emit("update");
        }
        function r() {
            var t = e1.rtlTranslate ? -1 * e1.translate : e1.translate, n = Math.min(Math.max(t, e1.maxTranslate()), e1.minTranslate());
            e1.setTranslate(n), e1.updateActiveIndex(), e1.updateSlidesClasses();
        }
    }, a.changeDirection = function(e1, t) {
        void 0 === t && (t = !0);
        var n = this, r = n.params.direction;
        return e1 || (e1 = "horizontal" === r ? "vertical" : "horizontal"), e1 === r || "horizontal" !== e1 && "vertical" !== e1 || (n.$el.removeClass("" + n.params.containerModifierClass + r).addClass("" + n.params.containerModifierClass + e1), n.emitContainerClasses(), n.params.direction = e1, n.slides.each(function(t) {
            "vertical" === e1 ? t.style.width = "" : t.style.height = "";
        }), n.emit("changeDirection"), t && n.update()), n;
    }, a.mount = function(e1) {
        var t = this;
        if (t.mounted) return !0;
        var n = Er(e1 || t.params.el);
        if (!(e1 = n[0])) return !1;
        e1.swiper = t;
        var r = function() {
            return "." + (t.params.wrapperClass || "").trim().split(" ").join(".");
        }, a = function() {
            if (e1 && e1.shadowRoot && e1.shadowRoot.querySelector) {
                var t = Er(e1.shadowRoot.querySelector(r()));
                return t.children = function(e1) {
                    return n.children(e1);
                }, t;
            }
            return n.children(r());
        }();
        if (0 === a.length && t.params.createElements) {
            var i = ur().createElement("div");
            a = Er(i), i.className = t.params.wrapperClass, n.append(i), n.children("." + t.params.slideClass).each(function(e1) {
                a.append(e1);
            });
        }
        return Mr(t, {
            $el: n,
            el: e1,
            $wrapperEl: a,
            wrapperEl: a[0],
            mounted: !0,
            rtl: "rtl" === e1.dir.toLowerCase() || "rtl" === n.css("direction"),
            rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e1.dir.toLowerCase() || "rtl" === n.css("direction")),
            wrongRTL: "-webkit-box" === a.css("display")
        }), !0;
    }, a.init = function(e1) {
        var t = this;
        return t.initialized || !1 === t.mount(e1) || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
    }, a.destroy = function(e1, t) {
        void 0 === e1 && (e1 = !0), void 0 === t && (t = !0);
        var n, r = this, a = r.params, i = r.$el, o = r.$wrapperEl, l = r.slides;
        return void 0 === r.params || r.destroyed || (r.emit("beforeDestroy"), r.initialized = !1, r.detachEvents(), a.loop && r.loopDestroy(), t && (r.removeClasses(), i.removeAttr("style"), o.removeAttr("style"), l && l.length && l.removeClass([
            a.slideVisibleClass,
            a.slideActiveClass,
            a.slideNextClass,
            a.slidePrevClass
        ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), r.emit("destroy"), Object.keys(r.eventsListeners).forEach(function(e1) {
            r.off(e1);
        }), !1 !== e1 && (r.$el[0].swiper = null, n = r, Object.keys(n).forEach(function(e1) {
            try {
                n[e1] = null;
            } catch (e2) {}
            try {
                delete n[e1];
            } catch (e3) {}
        })), r.destroyed = !0), null;
    }, e1.extendDefaults = function(e1) {
        Mr(sa, e1);
    }, e1.installModule = function(t) {
        e1.prototype.modules || (e1.prototype.modules = {});
        var n = t.name || Object.keys(e1.prototype.modules).length + "_" + kr();
        e1.prototype.modules[n] = t;
    }, e1.use = function(t) {
        return Array.isArray(t) ? (t.forEach(function(t) {
            return e1.installModule(t);
        }), e1) : (e1.installModule(t), e1);
    }, t = e1, r = [
        {
            key: "extendedDefaults",
            get: function() {
                return sa;
            }
        },
        {
            key: "defaults",
            get: function() {
                return ia;
            }
        }
    ], (n = null) && oa(t.prototype, n), r && oa(t, r), e1;
}();
Object.keys(la).forEach(function(e1) {
    Object.keys(la[e1]).forEach(function(t) {
        ca.prototype[t] = la[e1][t];
    });
}), ca.use([
    Br,
    jr
]);
var da = ca;
function ua() {
    return ua = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, ua.apply(this, arguments);
}
var pa = {
    toggleEl: function(e1, t) {
        e1[t ? "addClass" : "removeClass"](this.params.navigation.disabledClass), e1[0] && "BUTTON" === e1[0].tagName && (e1[0].disabled = t);
    },
    update: function() {
        var e1 = this, t = e1.params.navigation, n = e1.navigation.toggleEl;
        if (!e1.params.loop) {
            var r = e1.navigation, a = r.$nextEl, i = r.$prevEl;
            i && i.length > 0 && (e1.isBeginning ? n(i, !0) : n(i, !1), e1.params.watchOverflow && e1.enabled && i[e1.isLocked ? "addClass" : "removeClass"](t.lockClass)), a && a.length > 0 && (e1.isEnd ? n(a, !0) : n(a, !1), e1.params.watchOverflow && e1.enabled && a[e1.isLocked ? "addClass" : "removeClass"](t.lockClass));
        }
    },
    onPrevClick: function(e1) {
        var t = this;
        e1.preventDefault(), t.isBeginning && !t.params.loop || t.slidePrev();
    },
    onNextClick: function(e1) {
        var t = this;
        e1.preventDefault(), t.isEnd && !t.params.loop || t.slideNext();
    },
    init: function() {
        var e1, t, n = this, r = n.params.navigation;
        (n.params.navigation = Ir(n.$el, n.params.navigation, n.params.createElements, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        }), r.nextEl || r.prevEl) && (r.nextEl && (e1 = Er(r.nextEl), n.params.uniqueNavElements && "string" == typeof r.nextEl && e1.length > 1 && 1 === n.$el.find(r.nextEl).length && (e1 = n.$el.find(r.nextEl))), r.prevEl && (t = Er(r.prevEl), n.params.uniqueNavElements && "string" == typeof r.prevEl && t.length > 1 && 1 === n.$el.find(r.prevEl).length && (t = n.$el.find(r.prevEl))), e1 && e1.length > 0 && e1.on("click", n.navigation.onNextClick), t && t.length > 0 && t.on("click", n.navigation.onPrevClick), Mr(n.navigation, {
            $nextEl: e1,
            nextEl: e1 && e1[0],
            $prevEl: t,
            prevEl: t && t[0]
        }), n.enabled || (e1 && e1.addClass(r.lockClass), t && t.addClass(r.lockClass)));
    },
    destroy: function() {
        var e1 = this, t = e1.navigation, n = t.$nextEl, r = t.$prevEl;
        n && n.length && (n.off("click", e1.navigation.onNextClick), n.removeClass(e1.params.navigation.disabledClass)), r && r.length && (r.off("click", e1.navigation.onPrevClick), r.removeClass(e1.params.navigation.disabledClass));
    }
}, ma = {
    name: "navigation",
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock"
        }
    },
    create: function() {
        Pr(this, {
            navigation: ua({}, pa)
        });
    },
    on: {
        init: function(e1) {
            e1.navigation.init(), e1.navigation.update();
        },
        toEdge: function(e1) {
            e1.navigation.update();
        },
        fromEdge: function(e1) {
            e1.navigation.update();
        },
        destroy: function(e1) {
            e1.navigation.destroy();
        },
        "enable disable": function(e1) {
            var t = e1.navigation, n = t.$nextEl, r = t.$prevEl;
            n && n[e1.enabled ? "removeClass" : "addClass"](e1.params.navigation.lockClass), r && r[e1.enabled ? "removeClass" : "addClass"](e1.params.navigation.lockClass);
        },
        click: function(e1, t) {
            var n = e1.navigation, r = n.$nextEl, a = n.$prevEl, i = t.target;
            if (e1.params.navigation.hideOnClick && !Er(i).is(a) && !Er(i).is(r)) {
                if (e1.pagination && e1.params.pagination && e1.params.pagination.clickable && (e1.pagination.el === i || e1.pagination.el.contains(i))) return;
                var o;
                r ? o = r.hasClass(e1.params.navigation.hiddenClass) : a && (o = a.hasClass(e1.params.navigation.hiddenClass)), !0 === o ? e1.emit("navigationShow") : e1.emit("navigationHide"), r && r.toggleClass(e1.params.navigation.hiddenClass), a && a.toggleClass(e1.params.navigation.hiddenClass);
            }
        }
    }
};
function fa() {
    return fa = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, fa.apply(this, arguments);
}
var va = {
    update: function() {
        var e1 = this, t = e1.rtl, n = e1.params.pagination;
        if (n.el && e1.pagination.el && e1.pagination.$el && 0 !== e1.pagination.$el.length) {
            var r, a = e1.virtual && e1.params.virtual.enabled ? e1.virtual.slides.length : e1.slides.length, i = e1.pagination.$el, o = e1.params.loop ? Math.ceil((a - 2 * e1.loopedSlides) / e1.params.slidesPerGroup) : e1.snapGrid.length;
            if (e1.params.loop ? ((r = Math.ceil((e1.activeIndex - e1.loopedSlides) / e1.params.slidesPerGroup)) > a - 1 - 2 * e1.loopedSlides && (r -= a - 2 * e1.loopedSlides), r > o - 1 && (r -= o), r < 0 && "bullets" !== e1.params.paginationType && (r = o + r)) : r = void 0 !== e1.snapIndex ? e1.snapIndex : e1.activeIndex || 0, "bullets" === n.type && e1.pagination.bullets && e1.pagination.bullets.length > 0) {
                var l, s, c, d = e1.pagination.bullets;
                if (n.dynamicBullets && (e1.pagination.bulletSize = d.eq(0)[e1.isHorizontal() ? "outerWidth" : "outerHeight"](!0), i.css(e1.isHorizontal() ? "width" : "height", e1.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"), n.dynamicMainBullets > 1 && void 0 !== e1.previousIndex && (e1.pagination.dynamicBulletIndex += r - e1.previousIndex, e1.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1 ? e1.pagination.dynamicBulletIndex = n.dynamicMainBullets - 1 : e1.pagination.dynamicBulletIndex < 0 && (e1.pagination.dynamicBulletIndex = 0)), l = r - e1.pagination.dynamicBulletIndex, c = ((s = l + (Math.min(d.length, n.dynamicMainBullets) - 1)) + l) / 2), d.removeClass(n.bulletActiveClass + " " + n.bulletActiveClass + "-next " + n.bulletActiveClass + "-next-next " + n.bulletActiveClass + "-prev " + n.bulletActiveClass + "-prev-prev " + n.bulletActiveClass + "-main"), i.length > 1) d.each(function(e1) {
                    var t = Er(e1), a = t.index();
                    a === r && t.addClass(n.bulletActiveClass), n.dynamicBullets && (a >= l && a <= s && t.addClass(n.bulletActiveClass + "-main"), a === l && t.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), a === s && t.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next"));
                });
                else {
                    var u = d.eq(r), p = u.index();
                    if (u.addClass(n.bulletActiveClass), n.dynamicBullets) {
                        for(var m = d.eq(l), f = d.eq(s), v = l; v <= s; v += 1)d.eq(v).addClass(n.bulletActiveClass + "-main");
                        if (e1.params.loop) if (p >= d.length - n.dynamicMainBullets) {
                            for(var h = n.dynamicMainBullets; h >= 0; h -= 1)d.eq(d.length - h).addClass(n.bulletActiveClass + "-main");
                            d.eq(d.length - n.dynamicMainBullets - 1).addClass(n.bulletActiveClass + "-prev");
                        } else m.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), f.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next");
                        else m.prev().addClass(n.bulletActiveClass + "-prev").prev().addClass(n.bulletActiveClass + "-prev-prev"), f.next().addClass(n.bulletActiveClass + "-next").next().addClass(n.bulletActiveClass + "-next-next");
                    }
                }
                if (n.dynamicBullets) {
                    var g = Math.min(d.length, n.dynamicMainBullets + 4), b = (e1.pagination.bulletSize * g - e1.pagination.bulletSize) / 2 - c * e1.pagination.bulletSize, y = t ? "right" : "left";
                    d.css(e1.isHorizontal() ? y : "top", b + "px");
                }
            }
            if ("fraction" === n.type && (i.find(Lr(n.currentClass)).text(n.formatFractionCurrent(r + 1)), i.find(Lr(n.totalClass)).text(n.formatFractionTotal(o))), "progressbar" === n.type) {
                var x;
                x = n.progressbarOpposite ? e1.isHorizontal() ? "vertical" : "horizontal" : e1.isHorizontal() ? "horizontal" : "vertical";
                var E = (r + 1) / o, w = 1, C = 1;
                "horizontal" === x ? w = E : C = E, i.find(Lr(n.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + w + ") scaleY(" + C + ")").transition(e1.params.speed);
            }
            "custom" === n.type && n.renderCustom ? (i.html(n.renderCustom(e1, r + 1, o)), e1.emit("paginationRender", i[0])) : e1.emit("paginationUpdate", i[0]), e1.params.watchOverflow && e1.enabled && i[e1.isLocked ? "addClass" : "removeClass"](n.lockClass);
        }
    },
    render: function() {
        var e1 = this, t = e1.params.pagination;
        if (t.el && e1.pagination.el && e1.pagination.$el && 0 !== e1.pagination.$el.length) {
            var n = e1.virtual && e1.params.virtual.enabled ? e1.virtual.slides.length : e1.slides.length, r = e1.pagination.$el, a = "";
            if ("bullets" === t.type) {
                var i = e1.params.loop ? Math.ceil((n - 2 * e1.loopedSlides) / e1.params.slidesPerGroup) : e1.snapGrid.length;
                e1.params.freeMode && !e1.params.loop && i > n && (i = n);
                for(var o = 0; o < i; o += 1)t.renderBullet ? a += t.renderBullet.call(e1, o, t.bulletClass) : a += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
                r.html(a), e1.pagination.bullets = r.find(Lr(t.bulletClass));
            }
            "fraction" === t.type && (a = t.renderFraction ? t.renderFraction.call(e1, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', r.html(a)), "progressbar" === t.type && (a = t.renderProgressbar ? t.renderProgressbar.call(e1, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', r.html(a)), "custom" !== t.type && e1.emit("paginationRender", e1.pagination.$el[0]);
        }
    },
    init: function() {
        var e1 = this;
        e1.params.pagination = Ir(e1.$el, e1.params.pagination, e1.params.createElements, {
            el: "swiper-pagination"
        });
        var t = e1.params.pagination;
        if (t.el) {
            var n = Er(t.el);
            0 !== n.length && (e1.params.uniqueNavElements && "string" == typeof t.el && n.length > 1 && (n = e1.$el.find(t.el)), "bullets" === t.type && t.clickable && n.addClass(t.clickableClass), n.addClass(t.modifierClass + t.type), "bullets" === t.type && t.dynamicBullets && (n.addClass("" + t.modifierClass + t.type + "-dynamic"), e1.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), "progressbar" === t.type && t.progressbarOpposite && n.addClass(t.progressbarOppositeClass), t.clickable && n.on("click", Lr(t.bulletClass), function(t) {
                t.preventDefault();
                var n = Er(this).index() * e1.params.slidesPerGroup;
                e1.params.loop && (n += e1.loopedSlides), e1.slideTo(n);
            }), Mr(e1.pagination, {
                $el: n,
                el: n[0]
            }), e1.enabled || n.addClass(t.lockClass));
        }
    },
    destroy: function() {
        var e1 = this, t = e1.params.pagination;
        if (t.el && e1.pagination.el && e1.pagination.$el && 0 !== e1.pagination.$el.length) {
            var n = e1.pagination.$el;
            n.removeClass(t.hiddenClass), n.removeClass(t.modifierClass + t.type), e1.pagination.bullets && e1.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && n.off("click", Lr(t.bulletClass));
        }
    }
}, ha = {
    name: "pagination",
    params: {
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(e1) {
                return e1;
            },
            formatFractionTotal: function(e1) {
                return e1;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock"
        }
    },
    create: function() {
        Pr(this, {
            pagination: fa({
                dynamicBulletIndex: 0
            }, va)
        });
    },
    on: {
        init: function(e1) {
            e1.pagination.init(), e1.pagination.render(), e1.pagination.update();
        },
        activeIndexChange: function(e1) {
            (e1.params.loop || void 0 === e1.snapIndex) && e1.pagination.update();
        },
        snapIndexChange: function(e1) {
            e1.params.loop || e1.pagination.update();
        },
        slidesLengthChange: function(e1) {
            e1.params.loop && (e1.pagination.render(), e1.pagination.update());
        },
        snapGridLengthChange: function(e1) {
            e1.params.loop || (e1.pagination.render(), e1.pagination.update());
        },
        destroy: function(e1) {
            e1.pagination.destroy();
        },
        "enable disable": function(e1) {
            var t = e1.pagination.$el;
            t && t[e1.enabled ? "removeClass" : "addClass"](e1.params.pagination.lockClass);
        },
        click: function(e1, t) {
            var n = t.target;
            if (e1.params.pagination.el && e1.params.pagination.hideOnClick && e1.pagination.$el.length > 0 && !Er(n).hasClass(e1.params.pagination.bulletClass)) {
                if (e1.navigation && (e1.navigation.nextEl && n === e1.navigation.nextEl || e1.navigation.prevEl && n === e1.navigation.prevEl)) return;
                !0 === e1.pagination.$el.hasClass(e1.params.pagination.hiddenClass) ? e1.emit("paginationShow") : e1.emit("paginationHide"), e1.pagination.$el.toggleClass(e1.params.pagination.hiddenClass);
            }
        }
    }
};
function ga() {
    return ga = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, ga.apply(this, arguments);
}
var ba = {
    getRandomNumber: function(e1) {
        void 0 === e1 && (e1 = 16);
        return "x".repeat(e1).replace(/x/g, function() {
            return Math.round(16 * Math.random()).toString(16);
        });
    },
    makeElFocusable: function(e1) {
        return e1.attr("tabIndex", "0"), e1;
    },
    makeElNotFocusable: function(e1) {
        return e1.attr("tabIndex", "-1"), e1;
    },
    addElRole: function(e1, t) {
        return e1.attr("role", t), e1;
    },
    addElRoleDescription: function(e1, t) {
        return e1.attr("aria-roledescription", t), e1;
    },
    addElControls: function(e1, t) {
        return e1.attr("aria-controls", t), e1;
    },
    addElLabel: function(e1, t) {
        return e1.attr("aria-label", t), e1;
    },
    addElId: function(e1, t) {
        return e1.attr("id", t), e1;
    },
    addElLive: function(e1, t) {
        return e1.attr("aria-live", t), e1;
    },
    disableEl: function(e1) {
        return e1.attr("aria-disabled", !0), e1;
    },
    enableEl: function(e1) {
        return e1.attr("aria-disabled", !1), e1;
    },
    onEnterOrSpaceKey: function(e1) {
        if (13 === e1.keyCode || 32 === e1.keyCode) {
            var t = this, n = t.params.a11y, r = Er(e1.target);
            t.navigation && t.navigation.$nextEl && r.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(n.lastSlideMessage) : t.a11y.notify(n.nextSlideMessage)), t.navigation && t.navigation.$prevEl && r.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(n.firstSlideMessage) : t.a11y.notify(n.prevSlideMessage)), t.pagination && r.is(Lr(t.params.pagination.bulletClass)) && r[0].click();
        }
    },
    notify: function(e1) {
        var t = this.a11y.liveRegion;
        0 !== t.length && (t.html(""), t.html(e1));
    },
    updateNavigation: function() {
        var e1 = this;
        if (!e1.params.loop && e1.navigation) {
            var t = e1.navigation, n = t.$nextEl, r = t.$prevEl;
            r && r.length > 0 && (e1.isBeginning ? (e1.a11y.disableEl(r), e1.a11y.makeElNotFocusable(r)) : (e1.a11y.enableEl(r), e1.a11y.makeElFocusable(r))), n && n.length > 0 && (e1.isEnd ? (e1.a11y.disableEl(n), e1.a11y.makeElNotFocusable(n)) : (e1.a11y.enableEl(n), e1.a11y.makeElFocusable(n)));
        }
    },
    updatePagination: function() {
        var e1 = this, t = e1.params.a11y;
        e1.pagination && e1.params.pagination.clickable && e1.pagination.bullets && e1.pagination.bullets.length && e1.pagination.bullets.each(function(n) {
            var r = Er(n);
            e1.a11y.makeElFocusable(r), e1.params.pagination.renderBullet || (e1.a11y.addElRole(r, "button"), e1.a11y.addElLabel(r, t.paginationBulletMessage.replace(/\{\{index\}\}/, r.index() + 1)));
        });
    },
    init: function() {
        var e1 = this, t = e1.params.a11y;
        e1.$el.append(e1.a11y.liveRegion);
        var n = e1.$el;
        t.containerRoleDescriptionMessage && e1.a11y.addElRoleDescription(n, t.containerRoleDescriptionMessage), t.containerMessage && e1.a11y.addElLabel(n, t.containerMessage);
        var r = e1.$wrapperEl, a = r.attr("id") || "swiper-wrapper-" + e1.a11y.getRandomNumber(16), i = e1.params.autoplay && e1.params.autoplay.enabled ? "off" : "polite";
        e1.a11y.addElId(r, a), e1.a11y.addElLive(r, i), t.itemRoleDescriptionMessage && e1.a11y.addElRoleDescription(Er(e1.slides), t.itemRoleDescriptionMessage), e1.a11y.addElRole(Er(e1.slides), t.slideRole);
        var o, l, s = e1.params.loop ? e1.slides.filter(function(t) {
            return !t.classList.contains(e1.params.slideDuplicateClass);
        }).length : e1.slides.length;
        e1.slides.each(function(n, r) {
            var a = Er(n), i = e1.params.loop ? parseInt(a.attr("data-swiper-slide-index"), 10) : r, o = t.slideLabelMessage.replace(/\{\{index\}\}/, i + 1).replace(/\{\{slidesLength\}\}/, s);
            e1.a11y.addElLabel(a, o);
        }), e1.navigation && e1.navigation.$nextEl && (o = e1.navigation.$nextEl), e1.navigation && e1.navigation.$prevEl && (l = e1.navigation.$prevEl), o && o.length && (e1.a11y.makeElFocusable(o), "BUTTON" !== o[0].tagName && (e1.a11y.addElRole(o, "button"), o.on("keydown", e1.a11y.onEnterOrSpaceKey)), e1.a11y.addElLabel(o, t.nextSlideMessage), e1.a11y.addElControls(o, a)), l && l.length && (e1.a11y.makeElFocusable(l), "BUTTON" !== l[0].tagName && (e1.a11y.addElRole(l, "button"), l.on("keydown", e1.a11y.onEnterOrSpaceKey)), e1.a11y.addElLabel(l, t.prevSlideMessage), e1.a11y.addElControls(l, a)), e1.pagination && e1.params.pagination.clickable && e1.pagination.bullets && e1.pagination.bullets.length && e1.pagination.$el.on("keydown", Lr(e1.params.pagination.bulletClass), e1.a11y.onEnterOrSpaceKey);
    },
    destroy: function() {
        var e1, t, n = this;
        n.a11y.liveRegion && n.a11y.liveRegion.length > 0 && n.a11y.liveRegion.remove(), n.navigation && n.navigation.$nextEl && (e1 = n.navigation.$nextEl), n.navigation && n.navigation.$prevEl && (t = n.navigation.$prevEl), e1 && e1.off("keydown", n.a11y.onEnterOrSpaceKey), t && t.off("keydown", n.a11y.onEnterOrSpaceKey), n.pagination && n.params.pagination.clickable && n.pagination.bullets && n.pagination.bullets.length && n.pagination.$el.off("keydown", Lr(n.params.pagination.bulletClass), n.a11y.onEnterOrSpaceKey);
    }
}, ya = {
    name: "a11y",
    params: {
        a11y: {
            enabled: !0,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group"
        }
    },
    create: function() {
        Pr(this, {
            a11y: ga({}, ba, {
                liveRegion: Er('<span class="' + this.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
            })
        });
    },
    on: {
        afterInit: function(e1) {
            e1.params.a11y.enabled && (e1.a11y.init(), e1.a11y.updateNavigation());
        },
        toEdge: function(e1) {
            e1.params.a11y.enabled && e1.a11y.updateNavigation();
        },
        fromEdge: function(e1) {
            e1.params.a11y.enabled && e1.a11y.updateNavigation();
        },
        paginationUpdate: function(e1) {
            e1.params.a11y.enabled && e1.a11y.updatePagination();
        },
        destroy: function(e1) {
            e1.params.a11y.enabled && e1.a11y.destroy();
        }
    }
};
function xa(e1) {
    return "object" == typeof e1 && null !== e1 && e1.constructor && "Object" === Object.prototype.toString.call(e1).slice(8, -1);
}
function Ea(e1, t) {
    var n = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(t).filter(function(e1) {
        return n.indexOf(e1) < 0;
    }).forEach(function(n) {
        void 0 === e1[n] ? e1[n] = t[n] : xa(t[n]) && xa(e1[n]) && Object.keys(t[n]).length > 0 ? t[n].__swiper__ ? e1[n] = t[n] : Ea(e1[n], t[n]) : e1[n] = t[n];
    });
}
function wa(e1) {
    return void 0 === e1 && (e1 = {}), e1.navigation && void 0 === e1.navigation.nextEl && void 0 === e1.navigation.prevEl;
}
function Ca(e1) {
    return void 0 === e1 && (e1 = {}), e1.pagination && void 0 === e1.pagination.el;
}
function Sa(e1) {
    return void 0 === e1 && (e1 = {}), e1.scrollbar && void 0 === e1.scrollbar.el;
}
function Ta(e1) {
    void 0 === e1 && (e1 = "");
    var t = e1.split(" ").map(function(e1) {
        return e1.trim();
    }).filter(function(e1) {
        return !!e1;
    }), n = [];
    return t.forEach(function(e1) {
        n.indexOf(e1) < 0 && n.push(e1);
    }), n.join(" ");
}
var Na = [
    "init",
    "_direction",
    "touchEventsTarget",
    "initialSlide",
    "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver",
    "nested",
    "focusableElements",
    "_enabled",
    "_width",
    "_height",
    "preventInteractionOnTransition",
    "userAgent",
    "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode",
    "_freeModeMomentum",
    "_freeModeMomentumRatio",
    "_freeModeMomentumBounce",
    "_freeModeMomentumBounceRatio",
    "_freeModeMomentumVelocityRatio",
    "_freeModeSticky",
    "_freeModeMinimumVelocity",
    "_autoHeight",
    "setWrapperSize",
    "virtualTranslate",
    "_effect",
    "breakpoints",
    "_spaceBetween",
    "_slidesPerView",
    "_slidesPerColumn",
    "_slidesPerColumnFill",
    "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths",
    "touchRatio",
    "touchAngle",
    "simulateTouch",
    "_shortSwipes",
    "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs",
    "_followFinger",
    "allowTouchMove",
    "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_watchSlidesVisibility",
    "_grabCursor",
    "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide",
    "_preloadImages",
    "updateOnImagesReady",
    "_loop",
    "_loopAdditionalSlides",
    "_loopedSlides",
    "_loopFillGroupWithBlank",
    "loopPreventsSlide",
    "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler",
    "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideBlankClass",
    "slideActiveClass",
    "slideDuplicateActiveClass",
    "slideVisibleClass",
    "slideDuplicateClass",
    "slideNextClass",
    "slideDuplicateNextClass",
    "slidePrevClass",
    "slideDuplicatePrevClass",
    "wrapperClass",
    "runCallbacksOnInit",
    "observer",
    "observeParents",
    "observeSlideChildren",
    "a11y",
    "autoplay",
    "_controller",
    "coverflowEffect",
    "cubeEffect",
    "fadeEffect",
    "flipEffect",
    "hashNavigation",
    "history",
    "keyboard",
    "lazy",
    "mousewheel",
    "_navigation",
    "_pagination",
    "parallax",
    "_scrollbar",
    "_thumbs",
    "virtual",
    "zoom"
];
function ka(e1, t) {
    var n = t.slidesPerView;
    if (t.breakpoints) {
        var r = da.prototype.getBreakpoint(t.breakpoints), a = r in t.breakpoints ? t.breakpoints[r] : void 0;
        a && a.slidesPerView && (n = a.slidesPerView);
    }
    var i = Math.ceil(parseFloat(t.loopedSlides || n, 10));
    return (i += t.loopAdditionalSlides) > e1.length && (i = e1.length), i;
}
function _a(e1) {
    var n = [];
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(e1).forEach(function(e1) {
        e1.type && "SwiperSlide" === e1.type.displayName ? n.push(e1) : e1.props && e1.props.children && _a(e1.props.children).forEach(function(e1) {
            return n.push(e1);
        });
    }), n;
}
function Oa(e1) {
    var n = [], r = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": []
    };
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(e1).forEach(function(e1) {
        if (e1.type && "SwiperSlide" === e1.type.displayName) n.push(e1);
        else if (e1.props && e1.props.slot && r[e1.props.slot]) r[e1.props.slot].push(e1);
        else if (e1.props && e1.props.children) {
            var t = _a(e1.props.children);
            t.length > 0 ? t.forEach(function(e1) {
                return n.push(e1);
            }) : r["container-end"].push(e1);
        } else r["container-end"].push(e1);
    }), {
        slides: n,
        slots: r
    };
}
function Ma(e1) {
    var t, n, r, a, i, o = e1.swiper, l = e1.slides, s = e1.passedParams, c = e1.changedParams, d = e1.nextEl, u = e1.prevEl, p = e1.scrollbarEl, m = e1.paginationEl, f = c.filter(function(e1) {
        return "children" !== e1 && "direction" !== e1;
    }), v = o.params, h = o.pagination, g = o.navigation, b = o.scrollbar, y = o.virtual, x = o.thumbs;
    c.includes("thumbs") && s.thumbs && s.thumbs.swiper && v.thumbs && !v.thumbs.swiper && (t = !0), c.includes("controller") && s.controller && s.controller.control && v.controller && !v.controller.control && (n = !0), c.includes("pagination") && s.pagination && (s.pagination.el || m) && (v.pagination || !1 === v.pagination) && h && !h.el && (r = !0), c.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || p) && (v.scrollbar || !1 === v.scrollbar) && b && !b.el && (a = !0), c.includes("navigation") && s.navigation && (s.navigation.prevEl || u) && (s.navigation.nextEl || d) && (v.navigation || !1 === v.navigation) && g && !g.prevEl && !g.nextEl && (i = !0);
    (f.forEach(function(e1) {
        if (xa(v[e1]) && xa(s[e1])) Ea(v[e1], s[e1]);
        else {
            var t = s[e1];
            !0 !== t && !1 !== t || "navigation" !== e1 && "pagination" !== e1 && "scrollbar" !== e1 ? v[e1] = s[e1] : !1 === t && o[n = e1] && (o[n].destroy(), "navigation" === n ? (v[n].prevEl = void 0, v[n].nextEl = void 0, o[n].prevEl = void 0, o[n].nextEl = void 0) : (v[n].el = void 0, o[n].el = void 0));
        }
        var n;
    }), c.includes("children") && y && v.virtual.enabled ? (y.slides = l, y.update(!0)) : c.includes("children") && o.lazy && o.params.lazy.enabled && o.lazy.load(), t) && x.init() && x.update(!0);
    n && (o.controller.control = v.controller.control), r && (m && (v.pagination.el = m), h.init(), h.render(), h.update()), a && (p && (v.scrollbar.el = p), b.init(), b.updateSize(), b.setTranslate()), i && (d && (v.navigation.nextEl = d), u && (v.navigation.prevEl = u), g.init(), g.update()), c.includes("allowSlideNext") && (o.allowSlideNext = s.allowSlideNext), c.includes("allowSlidePrev") && (o.allowSlidePrev = s.allowSlidePrev), c.includes("direction") && o.changeDirection(s.direction, !1), o.update();
}
function Pa(e1, t) {
    return  false ? 0 : (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(e1, t);
}
var La = [
    "className",
    "tag",
    "wrapperTag",
    "children",
    "onSwiper"
];
function Ia() {
    return Ia = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, Ia.apply(this, arguments);
}
var za = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e1, n) {
    var r = void 0 === e1 ? {} : e1, a = r.className, i = r.tag, o = void 0 === i ? "div" : i, c = r.wrapperTag, d = void 0 === c ? "div" : c, p = r.children, m = r.onSwiper, f = function(e1, t) {
        if (null == e1) return {};
        var n, r, a = {}, i = Object.keys(e1);
        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (a[n] = e1[n]);
        return a;
    }(r, La), v = !1, h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("swiper-container"), g = h[0], b = h[1], y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), x = y[0], E = y[1], w = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), C = w[0], S = w[1], T = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!1), N = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), k = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), _ = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), O = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), M = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), P = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), L = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), I = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), z = function(e1) {
        void 0 === e1 && (e1 = {});
        var t = {
            on: {}
        }, n = {}, r = {};
        Ea(t, da.defaults), Ea(t, da.extendedDefaults), t._emitClasses = !0, t.init = !1;
        var a = {}, i = Na.map(function(e1) {
            return e1.replace(/_/, "");
        });
        return Object.keys(e1).forEach(function(o) {
            i.indexOf(o) >= 0 ? xa(e1[o]) ? (t[o] = {}, r[o] = {}, Ea(t[o], e1[o]), Ea(r[o], e1[o])) : (t[o] = e1[o], r[o] = e1[o]) : 0 === o.search(/on[A-Z]/) && "function" == typeof e1[o] ? n["" + o[2].toLowerCase() + o.substr(3)] = e1[o] : a[o] = e1[o];
        }), [
            "navigation",
            "pagination",
            "scrollbar"
        ].forEach(function(e1) {
            !0 === t[e1] && (t[e1] = {}), !1 === t[e1] && delete t[e1];
        }), {
            params: t,
            passedParams: r,
            rest: a,
            events: n
        };
    }(f), F = z.params, D = z.passedParams, B = z.rest, A = z.events, W = Oa(p), j = W.slides, R = W.slots, $ = function() {
        S(!C);
    };
    if (Object.assign(F.on, {
        _containerClasses: function(e1, t) {
            b(t);
        }
    }), !N.current && (Object.assign(F.on, A), v = !0, k.current = function(e1) {
        return new da(e1);
    }(F), k.current.loopCreate = function() {}, k.current.loopDestroy = function() {}, F.loop && (k.current.loopedSlides = ka(j, F)), k.current.virtual && k.current.params.virtual.enabled)) {
        k.current.virtual.slides = j;
        var H = {
            cache: !1,
            renderExternal: E,
            renderExternalUpdate: !1
        };
        Ea(k.current.params.virtual, H), Ea(k.current.originalParams.virtual, H);
    }
    k.current && k.current.on("_beforeBreakpoint", $);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            k.current && k.current.off("_beforeBreakpoint", $);
        };
    }), (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        !T.current && k.current && (k.current.emitSlidesClasses(), T.current = !0);
    }), Pa(function() {
        if (n && (n.current = N.current), N.current) return function(e1, t) {
            var n = e1.el, r = e1.nextEl, a = e1.prevEl, i = e1.paginationEl, o = e1.scrollbarEl, l = e1.swiper;
            wa(t) && r && a && (l.params.navigation.nextEl = r, l.originalParams.navigation.nextEl = r, l.params.navigation.prevEl = a, l.originalParams.navigation.prevEl = a), Ca(t) && i && (l.params.pagination.el = i, l.originalParams.pagination.el = i), Sa(t) && o && (l.params.scrollbar.el = o, l.originalParams.scrollbar.el = o), l.init(n);
        }({
            el: N.current,
            nextEl: M.current,
            prevEl: P.current,
            paginationEl: L.current,
            scrollbarEl: I.current,
            swiper: k.current
        }, F), m && m(k.current), function() {
            k.current && !k.current.destroyed && k.current.destroy(!0, !1);
        };
    }, []), Pa(function() {
        !v && A && k.current && Object.keys(A).forEach(function(e1) {
            k.current.on(e1, A[e1]);
        });
        var e1 = function(e1, t, n, r) {
            var a = [];
            if (!t) return a;
            var i = function(e1) {
                a.indexOf(e1) < 0 && a.push(e1);
            }, o = r.map(function(e1) {
                return e1.key;
            }), l = n.map(function(e1) {
                return e1.key;
            });
            return o.join("") !== l.join("") && i("children"), r.length !== n.length && i("children"), Na.filter(function(e1) {
                return "_" === e1[0];
            }).map(function(e1) {
                return e1.replace(/_/, "");
            }).forEach(function(n) {
                if (n in e1 && n in t) if (xa(e1[n]) && xa(t[n])) {
                    var r = Object.keys(e1[n]), a = Object.keys(t[n]);
                    r.length !== a.length ? i(n) : (r.forEach(function(r) {
                        e1[n][r] !== t[n][r] && i(n);
                    }), a.forEach(function(r) {
                        e1[n][r] !== t[n][r] && i(n);
                    }));
                } else e1[n] !== t[n] && i(n);
            }), a;
        }(D, _.current, j, O.current);
        return _.current = D, O.current = j, e1.length && k.current && !k.current.destroyed && Ma({
            swiper: k.current,
            slides: j,
            passedParams: D,
            changedParams: e1,
            nextEl: M.current,
            prevEl: P.current,
            scrollbarEl: I.current,
            paginationEl: L.current
        }), function() {
            A && k.current && Object.keys(A).forEach(function(e1) {
                k.current.off(e1, A[e1]);
            });
        };
    }), Pa(function() {
        var e1;
        !(e1 = k.current) || e1.destroyed || !e1.params.virtual || e1.params.virtual && !e1.params.virtual.enabled || (e1.updateSlides(), e1.updateProgress(), e1.updateSlidesClasses(), e1.lazy && e1.params.lazy.enabled && e1.lazy.load(), e1.parallax && e1.params.parallax && e1.params.parallax.enabled && e1.parallax.setTranslate());
    }, [
        x
    ]), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(o, Ia({
        ref: N,
        className: Ta(g + (a ? " " + a : ""))
    }, B), R["container-start"], wa(F) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        ref: P,
        className: "swiper-button-prev"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        ref: M,
        className: "swiper-button-next"
    })), Sa(F) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        ref: I,
        className: "swiper-scrollbar"
    }), Ca(F) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        ref: L,
        className: "swiper-pagination"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(d, {
        className: "swiper-wrapper"
    }, R["wrapper-start"], F.virtual ? function(e1, n, r) {
        var a;
        if (!r) return null;
        var i = e1.isHorizontal() ? ((a = {})[e1.rtlTranslate ? "right" : "left"] = r.offset + "px", a) : {
            top: r.offset + "px"
        };
        return n.filter(function(e1, t) {
            return t >= r.from && t <= r.to;
        }).map(function(n) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(n, {
                swiper: e1,
                style: i
            });
        });
    }(k.current, j, x) : !F.loop || k.current && k.current.destroyed ? j.map(function(e1) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, {
            swiper: k.current
        });
    }) : function(e1, n, r) {
        var a = n.map(function(n, r) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(n, {
                swiper: e1,
                "data-swiper-slide-index": r
            });
        });
        function i(e1, n, a) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, {
                key: e1.key + "-duplicate-" + n + "-" + a,
                className: (e1.props.className || "") + " " + r.slideDuplicateClass
            });
        }
        if (r.loopFillGroupWithBlank) {
            var o = r.slidesPerGroup - a.length % r.slidesPerGroup;
            if (o !== r.slidesPerGroup) for(var l = 0; l < o; l += 1){
                var s = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
                    className: r.slideClass + " " + r.slideBlankClass
                });
                a.push(s);
            }
        }
        "auto" !== r.slidesPerView || r.loopedSlides || (r.loopedSlides = a.length);
        var c = ka(a, r), d = [], u = [];
        return a.forEach(function(e1, t) {
            t < c && u.push(i(e1, t, "prepend")), t < a.length && t >= a.length - c && d.push(i(e1, t, "append"));
        }), e1 && (e1.loopedSlides = c), [].concat(d, a, u);
    }(k.current, j, F), R["wrapper-end"]), R["container-end"]);
});
za.displayName = "Swiper";
var Fa = [
    "tag",
    "children",
    "className",
    "swiper",
    "zoom",
    "virtualIndex"
];
function Da() {
    return Da = Object.assign || function(e1) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e1[r] = n[r]);
        }
        return e1;
    }, Da.apply(this, arguments);
}
var Ba = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e1, n) {
    var r, a = void 0 === e1 ? {} : e1, i = a.tag, o = void 0 === i ? "div" : i, s = a.children, c = a.className, d = void 0 === c ? "" : c, p = a.swiper, m = a.zoom, f = a.virtualIndex, v = function(e1, t) {
        if (null == e1) return {};
        var n, r, a = {}, i = Object.keys(e1);
        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (a[n] = e1[n]);
        return a;
    }(a, Fa), h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("swiper-slide"), b = g[0], y = g[1];
    function x(e1, t, n) {
        t === h.current && y(n);
    }
    Pa(function() {
        if (n && (n.current = h.current), h.current && p) {
            if (!p.destroyed) return p.on("_slideClass", x), function() {
                p && p.off("_slideClass", x);
            };
            "swiper-slide" !== b && y("swiper-slide");
        }
    }), Pa(function() {
        p && h.current && y(p.getSlideClasses(h.current));
    }, [
        p
    ]), "function" == typeof s && (r = {
        isActive: b.indexOf("swiper-slide-active") >= 0 || b.indexOf("swiper-slide-duplicate-active") >= 0,
        isVisible: b.indexOf("swiper-slide-visible") >= 0,
        isDuplicate: b.indexOf("swiper-slide-duplicate") >= 0,
        isPrev: b.indexOf("swiper-slide-prev") >= 0 || b.indexOf("swiper-slide-duplicate-prev") >= 0,
        isNext: b.indexOf("swiper-slide-next") >= 0 || b.indexOf("swiper-slide-duplicate-next") >= 0
    });
    var E = function() {
        return "function" == typeof s ? s(r) : s;
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(o, Da({
        ref: h,
        className: Ta(b + (d ? " " + d : "")),
        "data-swiper-slide-index": f
    }, v), m ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": "number" == typeof m ? m : void 0
    }, E()) : E());
});
Ba.displayName = "SwiperSlide";
var Aa = "carousel-wrapper-module_carouselWrapper", Wa = "carousel-wrapper-module_showCarousel";
da.use([
    ma,
    ha,
    ya
]);
var ja = function(e1) {
    var n, r = e1.children, a = e1.clickablePagination, i = void 0 === a || a, o = e1.isCarouselReady, l = void 0 === o || o, s = e1.customClassNames, c = e1.ariaLabel, d = void 0 === c ? "carousel" : c, u = e1.name, p = e1.swiperSettings, m = C(Aa, null == s ? void 0 : s.wrapper, ((n = {})[Wa] = l, n)), f = C(u, null == s ? void 0 : s.carousel), v = {
        el: ".".concat(u, "-pagination"),
        clickable: i,
        dynamicBullets: !0
    }, h = {
        prevEl: ".".concat(u, "-prev"),
        nextEl: ".".concat(u, "-next")
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
        className: m,
        "aria-label": d
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(za, y({
        className: f,
        pagination: v,
        a11y: {
            enabled: !0
        },
        navigation: h
    }, p), r));
}, Ra = "carousel-pagination-module_pagination", $a = function(e1) {
    var n = e1.name, r = e1.customClassNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C("".concat(n, "-pagination"), Ra, r),
        "data-testid": "ds-carousel-pagination"
    });
}, Ha = "carousel-navigation-module_controls", Ga = "carousel-navigation-module_controlsBtnPrev", Ua = "carousel-navigation-module_controlsBtnNext", Va = "carousel-navigation-module_controlsBtn", qa = function(e1) {
    var n = e1.customClassNames, r = e1.buttonIcons, a = e1.ariaLabels, i = e1.name, o = C(Ha, null == n ? void 0 : n.wrapper), l = C("".concat(i, "-prev"), Va, Ga, null == n ? void 0 : n.prevButton), s = C("".concat(i, "-next"), Va, Ua, null == n ? void 0 : n.nextButton);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        "data-slide-controls": !0,
        className: o,
        "data-testid": "ds-carousel-controls"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
        type: "button",
        className: l,
        "aria-label": a.previous
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: (null == r ? void 0 : r.leftIcon) || "chevron-left",
        size: 22
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
        type: "button",
        className: s,
        "aria-label": a.next
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: (null == r ? void 0 : r.rightIcon) || "chevron-right",
        size: 22
    })));
}, Ya = "carousel-controls-module_wrapper", Xa = function(e1) {
    var n = e1.children, r = e1.customClassNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Ya, r)
    }, n);
}, Ka = "checkbox-field-module_fullWidth", Qa = "checkbox-field-module_errorWrapper", Ja = "checkbox-field-module_helpText", Za = "checkbox-field-module_fieldWrapper", ei = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.forwardRef(function(e1, n) {
    var r, a, i = e1.id, o = e1.classNames, l = e1.disabled, s = e1.error, c = void 0 === s ? {
        show: !1,
        collapse: !1
    } : s, d = e1.fullWidth, u = e1.helpText, p = e1.label, m = e1.value, f = x(e1, [
        "id",
        "classNames",
        "disabled",
        "error",
        "fullWidth",
        "helpText",
        "label",
        "value"
    ]), v = C(((r = {})[Ka] = d, r), Za, null == o ? void 0 : o.fieldWrapper), h = y(y({}, null == o ? void 0 : o.error), {
        container: C(Qa, null === (a = null == o ? void 0 : o.error) || void 0 === a ? void 0 : a.container)
    }), g = C(null == o ? void 0 : o.helpText, Ja);
    return /*#__PURE__*/ t.createElement("div", {
        className: v,
        "data-field": i,
        "data-testid": "CheckboxField/Wrapper"
    }, /*#__PURE__*/ t.createElement(Me, y({
        id: i,
        classNames: {
            wrapper: null == o ? void 0 : o.wrapper,
            icon: null == o ? void 0 : o.icon,
            label: null == o ? void 0 : o.label
        },
        "data-testid": "CheckboxField/Checkbox",
        disabled: l,
        error: c,
        label: p,
        value: m,
        ref: n
    }, f)), u && /*#__PURE__*/ t.createElement(Be, {
        className: g
    }, u), /*#__PURE__*/ t.createElement(Fe, y({}, c, {
        classNames: h
    })));
}))), ti = {
    sectionWrapper: "content-section-module_sectionWrapper",
    heading: "content-section-module_heading",
    contentSectionWithCTA: "content-section-module_contentSectionWithCTA",
    contentSectionWithCTAInner: "content-section-module_contentSectionWithCTAInner",
    button: "content-section-module_button",
    contentSectionWithIcon: "content-section-module_contentSectionWithIcon",
    svg: "content-section-module_svg"
}, ni = function(e1) {
    var n = e1.children, r = e1.element, a = void 0 === r ? "div" : r, i = e1.sectionWrapperClass, o = e1.id, l = C(ti.sectionWrapper, i), s = a;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(s, {
        id: o,
        className: l
    }, n);
}, ri = function(e1) {
    var n = e1.children, r = e1.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qe, {
        element: "h2",
        className: C(ti.heading, r)
    }, n);
}, ai = function(e1) {
    var n = e1.children, r = e1.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mt, {
        className: C(ti.contentWrapper, r)
    }, n);
};
oe.customProperties.ds.color;
var ii = function(e1) {
    var n = e1.iconName, r = e1.iconSize, a = e1.className, i = e1.iconColor, o = e1.iconGradient;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: n,
        size: r,
        className: C(ti.svg, a),
        color: i,
        gradient: o || void 0
    });
}, oi = function(e1) {
    var n = e1.children, r = e1.onClick, a = e1.className;
    return /*#__PURE__*/ t.createElement(G, {
        onClick: r,
        classNames: {
            button: C(ti.button, a)
        }
    }, n);
};
oe.customProperties.ds.color;
var li = function(e1) {
    var n = e1.title, r = e1.children, a = e1.sectionWrapperClass, i = e1.element, o = e1.id, l = e1.classNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ni, {
        id: o,
        sectionWrapperClass: a,
        element: i
    }, n && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ri, {
        className: null == l ? void 0 : l.title
    }, n), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ai, {
        className: null == l ? void 0 : l.body
    }, r));
}, si = function(e1) {
    var n = e1.title, r = e1.onClick, a = e1.sectionWrapperClass, i = e1.buttonLabel, o = e1.children, l = e1.element, s = e1.classNames;
    return /*#__PURE__*/ t.createElement(ni, {
        element: l,
        sectionWrapperClass: C(ti.contentSectionWithCTA, a)
    }, /*#__PURE__*/ t.createElement("div", {
        className: ti.contentSectionWithCTAInner
    }, n && /*#__PURE__*/ t.createElement(ri, {
        className: null == s ? void 0 : s.title
    }, n), /*#__PURE__*/ t.createElement(ai, {
        className: null == s ? void 0 : s.body
    }, o)), /*#__PURE__*/ t.createElement(oi, {
        onClick: r,
        className: null == s ? void 0 : s.button
    }, i));
}, ci = function(e1) {
    var n = e1.title, r = e1.iconName, a = e1.iconSize, i = e1.children, o = e1.sectionWrapperClass, l = e1.element, s = e1.iconColor, c = e1.iconGradient, d = e1.classNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ni, {
        element: l,
        sectionWrapperClass: C(ti.contentSectionWithIcon, o)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ii, {
        iconName: r,
        iconSize: a,
        iconColor: s,
        iconGradient: c
    }), n && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ri, {
        className: null == d ? void 0 : d.title
    }, n), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ai, {
        className: null == d ? void 0 : d.body
    }, i));
}, di = "custom-list-module_customListWrapper", ui = function(e1) {
    var n = e1.children, r = e1.customClassNames;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
        className: C(di, null == r ? void 0 : r.list),
        "data-testid": "ds-custom-list"
    }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(n, function(e1) {
        var n = Object.assign({}, {
            customClassNames: r
        }, e1.props);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, n);
    }));
}, pi = "custom-list-item-module_customListItem", mi = "custom-list-item-module_bulletContainer", fi = "custom-list-item-module_defaultBullet", vi = "custom-list-item-module_contentContainer", hi = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: fi
}, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    width: "5px",
    height: "5px"
}, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: "0",
    y: "0",
    width: "5px",
    height: "5px",
    fill: "#000000",
    stroke: "none"
}))), gi = function(e1) {
    var n = e1.bullet, r = e1.children, a = e1.customClassNames, i = C(pi, null == a ? void 0 : a.listItem), o = C(mi, null == a ? void 0 : a.bulletContainer), l = C(vi, null == a ? void 0 : a.contentContainer);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
        className: i,
        "data-testid": "ds-custom-list-item"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: o
    }, null != n ? n : hi), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: l
    }, r));
}, bi = function(e1) {
    var n = e1.children, r = function(e1) {
        return "string" == typeof e1 ? document.querySelector(e1) ? document.querySelector(e1) : document.body : e1;
    }(e1.rootElem || "#portal-root"), a = react__WEBPACK_IMPORTED_MODULE_0__.useState(function() {
        var e1 = document.createElement("div");
        return e1.classList.add("portal-element"), e1;
    })[0];
    return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return r.appendChild(a), function() {
            r.removeChild(a);
        };
    }, []), n ? /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(n, a) : null;
}, yi = "backdrop-module_backdrop", xi = "backdrop-module_backdropEnter", Ei = "backdrop-module_backdropEnterActive", wi = "backdrop-module_backdropExit", Ci = "backdrop-module_backdropExitActive", Si = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({}), Ti = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Si);
}, Ni = function(e1) {
    var n = e1.children, r = e1.onClose, a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), i = a[0], o = a[1], c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        var e1 = {
            position: window.getComputedStyle(document.body).position,
            top: window.getComputedStyle(document.body).top,
            bottom: window.getComputedStyle(document.body).bottom,
            left: window.getComputedStyle(document.body).left,
            right: window.getComputedStyle(document.body).right,
            overflow: window.getComputedStyle(document.body).overflow
        };
        return document.body.style.top = "-".concat(window.scrollY, "px"), document.body.style.bottom = "0", document.body.style.left = "0", document.body.style.right = "0", document.body.style.position = "fixed", document.body.style.overflow = "hidden", function() {
            var t = document.body.style.top;
            document.body.style.top = e1.top, document.body.style.bottom = e1.bottom, document.body.style.left = e1.left, document.body.style.right = e1.right, document.body.style.position = e1.position, document.body.style.overflow = e1.overflow, window.scrollTo(0, -1 * parseInt(t || "0"));
        };
    }, []);
    var d = {
        enter: xi,
        enterActive: Ei,
        exit: wi,
        exitActive: Ci
    }, m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var e1;
        e1 = c.current, document.contains(e1) && o(!1);
    }, []), v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e1) {
        "Escape" === e1.key && m();
    }, [
        m
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return o(!0), document.addEventListener("keydown", v, !1), function() {
            return document.removeEventListener("keydown", v, !1);
        };
    }, [
        v
    ]), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bi, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tr, {
        classNames: d,
        unmountOnExit: !0,
        timeout: 250,
        in: i,
        appear: !0,
        onExited: r
    }, function(e1) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            id: "backdrop-overlay",
            "data-testid": "Backdrop/Overlay",
            role: "presentation",
            className: yi,
            onClick: function(e1) {
                return t = e1.target.id, void (c.current && t === c.current.id && m());
                var t;
            },
            ref: c
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Si.Provider, {
            value: {
                transitionState: e1,
                close: m
            }
        }, n));
    }));
}, ki = "data-focus-lock", _i = "data-focus-lock-disabled";
function Oi(e1, t) {
    return n = t || null, r = function(t) {
        return e1.forEach(function(e1) {
            return function(e1, t) {
                return "function" == typeof e1 ? e1(t) : e1 && (e1.current = t), e1;
            }(e1, t);
        });
    }, (a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return {
            value: n,
            callback: r,
            facade: {
                get current () {
                    return a.value;
                },
                set current (e){
                    var t = a.value;
                    t !== e && (a.value = e, a.callback(e, t));
                }
            }
        };
    })[0]).callback = r, a.facade;
    var n, r, a;
}
var Mi = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
 true || 0;
var Pi = function() {
    return Pi = Object.assign || function(e1) {
        for(var t, n = 1, r = arguments.length; n < r; n++)for(var a in t = arguments[n])Object.prototype.hasOwnProperty.call(t, a) && (e1[a] = t[a]);
        return e1;
    }, Pi.apply(this, arguments);
};
function Li(e1) {
    return e1;
}
function Ii(e1, t) {
    void 0 === t && (t = Li);
    var n = [], r = !1, a = {
        read: function() {
            if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            return n.length ? n[n.length - 1] : e1;
        },
        useMedium: function(e1) {
            var a = t(e1, r);
            return n.push(a), function() {
                n = n.filter(function(e1) {
                    return e1 !== a;
                });
            };
        },
        assignSyncMedium: function(e1) {
            for(r = !0; n.length;){
                var t = n;
                n = [], t.forEach(e1);
            }
            n = {
                push: function(t) {
                    return e1(t);
                },
                filter: function() {
                    return n;
                }
            };
        },
        assignMedium: function(e1) {
            r = !0;
            var t = [];
            if (n.length) {
                var a = n;
                n = [], a.forEach(e1), t = n;
            }
            var i = function() {
                var n = t;
                t = [], n.forEach(e1);
            }, o = function() {
                return Promise.resolve().then(i);
            };
            o(), n = {
                push: function(e1) {
                    t.push(e1), o();
                },
                filter: function(e1) {
                    return t = t.filter(e1), n;
                }
            };
        }
    };
    return a;
}
function zi(e1, t) {
    return void 0 === t && (t = Li), Ii(e1, t);
}
var Fi = zi({}, function(e1) {
    return {
        target: e1.target,
        currentTarget: e1.currentTarget
    };
}), Di = zi(), Bi = zi(), Ai = function(e1) {
    void 0 === e1 && (e1 = {});
    var t = Ii(null);
    return t.options = Pi({
        async: !0,
        ssr: !1
    }, e1), t;
}({
    async: !0
}), Wi = [], ji = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(t, n) {
    var r, a = react__WEBPACK_IMPORTED_MODULE_0__.useState(), i = a[0], o = a[1], l = react__WEBPACK_IMPORTED_MODULE_0__.useRef(), c = react__WEBPACK_IMPORTED_MODULE_0__.useRef(!1), d = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null), u = t.children, p = t.disabled, m = t.noFocusGuards, f = t.persistentFocus, v = t.crossFrame, h = t.autoFocus, g = t.allowTextSelection, b = t.group, y = t.className, x = t.whiteList, E = t.hasPositiveIndices, w = t.shards, C = void 0 === w ? Wi : w, S = t.as, T = void 0 === S ? "div" : S, N = t.lockProps, k = void 0 === N ? {} : N, _ = t.sideCar, O = t.returnFocus, M = t.focusOptions, P = t.onActivation, L = t.onDeactivation, I = react__WEBPACK_IMPORTED_MODULE_0__.useState({})[0], z = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        d.current = d.current || document && document.activeElement, l.current && P && P(l.current), c.current = !0;
    }, [
        P
    ]), F = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        c.current = !1, L && L(l.current);
    }, [
        L
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        p || (d.current = null);
    }, []);
    var D = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(e1) {
        var t = d.current;
        if (t && t.focus) {
            var n = "function" == typeof O ? O(t) : O;
            if (n) {
                var r = "object" == typeof n ? n : void 0;
                d.current = null, e1 ? Promise.resolve().then(function() {
                    return t.focus(r);
                }) : t.focus(r);
            }
        }
    }, [
        O
    ]), B = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(e1) {
        c.current && Fi.useMedium(e1);
    }, []), A = Di.useMedium, W = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(e1) {
        l.current !== e1 && (l.current = e1, o(e1));
    }, []);
     false && (0);
    var j = At(((r = {})[_i] = p && "disabled", r[ki] = b, r), k), R = !0 !== m, $ = R && "tail" !== m, H = Oi([
        n,
        W
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, R && [
        /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: "guard-first",
            "data-focus-guard": !0,
            tabIndex: p ? -1 : 0,
            style: Mi
        }),
        E ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": !0,
            tabIndex: p ? -1 : 1,
            style: Mi
        }) : null
    ], !p && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_, {
        id: I,
        sideCar: Ai,
        observed: i,
        disabled: p,
        persistentFocus: f,
        crossFrame: v,
        autoFocus: h,
        whiteList: x,
        shards: C,
        onActivation: z,
        onDeactivation: F,
        returnFocus: D,
        focusOptions: M
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(T, At({
        ref: H
    }, j, {
        className: y,
        onBlur: A,
        onFocus: B
    }), u), $ && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        "data-focus-guard": !0,
        tabIndex: p ? -1 : 0,
        style: Mi
    }));
});
ji.propTypes =  false ? 0 : {}, ji.defaultProps = {
    children: void 0,
    disabled: !1,
    returnFocus: !1,
    focusOptions: void 0,
    noFocusGuards: !1,
    autoFocus: !0,
    persistentFocus: !1,
    crossFrame: !0,
    hasPositiveIndices: void 0,
    allowTextSelection: void 0,
    group: void 0,
    className: void 0,
    whiteList: void 0,
    shards: void 0,
    as: "div",
    lockProps: {},
    onActivation: void 0,
    onDeactivation: void 0
};
var Ri = ji;
function $i(e1) {
    return $i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
        return typeof e1;
    } : function(e1) {
        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
    }, $i(e1);
}
function Hi(e1) {
    var t = function(e1, t) {
        if ("object" !== $i(e1) || null === e1) return e1;
        var n = e1[Symbol.toPrimitive];
        if (void 0 !== n) {
            var r = n.call(e1, t || "default");
            if ("object" !== $i(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e1);
    }(e1, "string");
    return "symbol" === $i(t) ? t : String(t);
}
var Gi = function(e1) {
    for(var t = Array(e1.length), n = 0; n < e1.length; ++n)t[n] = e1[n];
    return t;
}, Ui = function(e1) {
    return Array.isArray(e1) ? e1 : [
        e1
    ];
}, Vi = function(e1) {
    return Array.isArray(e1) ? e1[0] : e1;
}, qi = function(e1) {
    return e1.parentNode && e1.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? e1.parentNode.host : e1.parentNode;
}, Yi = function(e1) {
    return e1 === document || e1 && e1.nodeType === Node.DOCUMENT_NODE;
}, Xi = function(e1, t) {
    return !e1 || Yi(e1) || !function(e1) {
        if (e1.nodeType !== Node.ELEMENT_NODE) return !1;
        var t = window.getComputedStyle(e1, null);
        return !(!t || !t.getPropertyValue || "none" !== t.getPropertyValue("display") && "hidden" !== t.getPropertyValue("visibility"));
    }(e1) && t(qi(e1));
}, Ki = function(e1, t) {
    var n = e1.get(t);
    if (void 0 !== n) return n;
    var r = Xi(t, Ki.bind(void 0, e1));
    return e1.set(t, r), r;
}, Qi = function(e1, t) {
    var n = e1.get(t);
    if (void 0 !== n) return n;
    var r = function(e1, t) {
        return !(e1 && !Yi(e1)) || !!to(e1) && t(qi(e1));
    }(t, Qi.bind(void 0, e1));
    return e1.set(t, r), r;
}, Ji = function(e1) {
    return e1.dataset;
}, Zi = function(e1) {
    return "INPUT" === e1.tagName;
}, eo = function(e1) {
    return Zi(e1) && "radio" === e1.type;
}, to = function(e1) {
    var t = e1.getAttribute("data-no-autofocus");
    return ![
        !0,
        "true",
        ""
    ].includes(t);
}, no = function(e1) {
    var t;
    return Boolean(e1 && (null === (t = Ji(e1)) || void 0 === t ? void 0 : t.focusGuard));
}, ro = function(e1) {
    return !no(e1);
}, ao = function(e1) {
    return Boolean(e1);
}, io = function(e1, t) {
    var n = e1.tabIndex - t.tabIndex, r = e1.index - t.index;
    if (n) {
        if (!e1.tabIndex) return 1;
        if (!t.tabIndex) return -1;
    }
    return n || r;
}, oo = function(e1, t, n) {
    return Gi(e1).map(function(e1, t) {
        return {
            node: e1,
            index: t,
            tabIndex: n && -1 === e1.tabIndex ? (e1.dataset || {}).focusGuard ? 0 : -1 : e1.tabIndex
        };
    }).filter(function(e1) {
        return !t || e1.tabIndex >= 0;
    }).sort(io);
}, lo = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
].join(","), so = "".concat(lo, ", [data-focus-guard]"), co = function(e1, t) {
    return Gi((e1.shadowRoot || e1).children).reduce(function(e1, n) {
        return e1.concat(n.matches(t ? so : lo) ? [
            n
        ] : [], co(n));
    }, []);
}, uo = function(e1, t) {
    return e1.reduce(function(e1, n) {
        var r, a = co(n, t), i = (r = []).concat.apply(r, a.map(function(e1) {
            return function(e1, t) {
                var n;
                return e1 instanceof HTMLIFrameElement && (null === (n = e1.contentDocument) || void 0 === n ? void 0 : n.body) ? uo([
                    e1.contentDocument.body
                ], t) : [
                    e1
                ];
            }(e1, t);
        }));
        return e1.concat(i, n.parentNode ? Gi(n.parentNode.querySelectorAll(lo)).filter(function(e1) {
            return e1 === n;
        }) : []);
    }, []);
}, po = function(e1, t) {
    return Gi(e1).filter(function(e1) {
        return Ki(t, e1);
    }).filter(function(e1) {
        return function(e1) {
            return !((Zi(e1) || function(e1) {
                return "BUTTON" === e1.tagName;
            }(e1)) && ("hidden" === e1.type || e1.disabled));
        }(e1);
    });
}, mo = function(e1, t) {
    return void 0 === t && (t = new Map), Gi(e1).filter(function(e1) {
        return Qi(t, e1);
    });
}, fo = function(e1, t, n) {
    return oo(po(uo(e1, n), t), !0, n);
}, vo = function(e1, t) {
    return oo(po(uo(e1), t), !1);
}, ho = function(e1, t) {
    return po(function(e1) {
        var t = e1.querySelectorAll("[".concat("data-autofocus-inside", "]"));
        return Gi(t).map(function(e1) {
            return uo([
                e1
            ]);
        }).reduce(function(e1, t) {
            return e1.concat(t);
        }, []);
    }(e1), t);
}, go = function(e1, t) {
    return e1.shadowRoot ? go(e1.shadowRoot, t) : !(void 0 === Object.getPrototypeOf(e1).contains || !Object.getPrototypeOf(e1).contains.call(e1, t)) || Gi(e1.children).some(function(e1) {
        var n;
        if (e1 instanceof HTMLIFrameElement) {
            var r = null === (n = e1.contentDocument) || void 0 === n ? void 0 : n.body;
            return !!r && go(r, t);
        }
        return go(e1, t);
    });
}, bo = function(e1) {
    return e1.parentNode ? bo(e1.parentNode) : e1;
}, yo = function(e1) {
    return Ui(e1).filter(Boolean).reduce(function(e1, t) {
        var n = t.getAttribute(ki);
        return e1.push.apply(e1, n ? function(e1) {
            for(var t = new Set, n = e1.length, r = 0; r < n; r += 1)for(var a = r + 1; a < n; a += 1){
                var i = e1[r].compareDocumentPosition(e1[a]);
                (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(a), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
            }
            return e1.filter(function(e1, n) {
                return !t.has(n);
            });
        }(Gi(bo(t).querySelectorAll("[".concat(ki, '="').concat(n, '"]:not([').concat(_i, '="disabled"])')))) : [
            t
        ]), e1;
    }, []);
}, xo = function(e1) {
    if (void 0 === e1 && (e1 = document), e1 && e1.activeElement) {
        var t = e1.activeElement;
        return t.shadowRoot ? xo(t.shadowRoot) : t instanceof HTMLIFrameElement && function(e1) {
            try {
                return e1();
            } catch (e2) {
                return;
            }
        }(function() {
            return t.contentWindow.document;
        }) ? xo(t.contentWindow.document) : t;
    }
}, Eo = function(e1, t) {
    return void 0 === t && (t = xo(Vi(e1).ownerDocument)), !(!t || t.dataset && t.dataset.focusGuard) && yo(e1).some(function(e1) {
        return go(e1, t) || function(e1, t) {
            return Boolean(Gi(e1.querySelectorAll("iframe")).some(function(e1) {
                return function(e1, t) {
                    return e1 === t;
                }(e1, t);
            }));
        }(e1, t);
    });
}, wo = function(e1, t) {
    return eo(e1) && e1.name ? function(e1, t) {
        return t.filter(eo).filter(function(t) {
            return t.name === e1.name;
        }).filter(function(e1) {
            return e1.checked;
        })[0] || e1;
    }(e1, t) : e1;
}, Co = function(e1) {
    return e1[0] && e1.length > 1 ? wo(e1[0], e1) : e1[0];
}, So = function(e1, t) {
    return e1.length > 1 ? e1.indexOf(wo(e1[t], e1)) : t;
}, To = "NEW_FOCUS", No = function(e1, t, n, r) {
    var a = e1.length, i = e1[0], o = e1[a - 1], l = no(n);
    if (!(n && e1.indexOf(n) >= 0)) {
        var s, c, d = void 0 !== n ? t.indexOf(n) : -1, u = r ? t.indexOf(r) : d, p = r ? e1.indexOf(r) : -1, m = d - u, f = t.indexOf(i), v = t.indexOf(o), h = (s = t, c = new Set, s.forEach(function(e1) {
            return c.add(wo(e1, s));
        }), s.filter(function(e1) {
            return c.has(e1);
        })), g = (void 0 !== n ? h.indexOf(n) : -1) - (r ? h.indexOf(r) : d), b = So(e1, 0), y = So(e1, a - 1);
        return -1 === d || -1 === p ? To : !m && p >= 0 ? p : d <= f && l && Math.abs(m) > 1 ? y : d >= v && l && Math.abs(m) > 1 ? b : m && Math.abs(g) > 1 ? p : d <= f ? y : d > v ? b : m ? Math.abs(m) > 1 ? p : (a + p + m) % a : void 0;
    }
}, ko = function(e1, t, n) {
    var r, a = e1.map(function(e1) {
        return e1.node;
    }), i = mo(a.filter((r = n, function(e1) {
        var t, n = null === (t = Ji(e1)) || void 0 === t ? void 0 : t.autofocus;
        return e1.autofocus || void 0 !== n && "false" !== n || r.indexOf(e1) >= 0;
    })));
    return i && i.length ? Co(i) : Co(mo(t));
}, _o = function(e1, t) {
    return void 0 === t && (t = []), t.push(e1), e1.parentNode && _o(e1.parentNode.host || e1.parentNode, t), t;
}, Oo = function(e1, t) {
    for(var n = _o(e1), r = _o(t), a = 0; a < n.length; a += 1){
        var i = n[a];
        if (r.indexOf(i) >= 0) return i;
    }
    return !1;
}, Mo = function(e1, t, n) {
    var r = Ui(e1), a = Ui(t), i = r[0], o = !1;
    return a.filter(Boolean).forEach(function(e1) {
        o = Oo(o || e1, e1) || o, n.filter(Boolean).forEach(function(e1) {
            var t = Oo(i, e1);
            t && (o = !o || go(t, o) ? t : Oo(t, o));
        });
    }), o;
}, Po = function(e1, t) {
    var n = xo(Ui(e1).length > 0 ? document : Vi(e1).ownerDocument), r = yo(e1).filter(ro), a = Mo(n || e1, e1, r), i = new Map, o = vo(r, i), l = fo(r, i).filter(function(e1) {
        var t = e1.node;
        return ro(t);
    });
    if (l[0] || (l = o)[0]) {
        var s, c, d, u = vo([
            a
        ], i).map(function(e1) {
            return e1.node;
        }), p = (s = u, c = l, d = new Map, c.forEach(function(e1) {
            return d.set(e1.node, e1);
        }), s.map(function(e1) {
            return d.get(e1);
        }).filter(ao)), m = p.map(function(e1) {
            return e1.node;
        }), f = No(m, u, n, t);
        if (f === To) {
            var v = ko(o, m, function(e1, t) {
                return e1.reduce(function(e1, n) {
                    return e1.concat(ho(n, t));
                }, []);
            }(r, i));
            return v ? {
                node: v
            } : void console.warn("focus-lock: cannot find any node to move focus into");
        }
        return void 0 === f ? f : p[f];
    }
}, Lo = 0, Io = !1, zo = function(e1, t, n) {
    void 0 === n && (n = {});
    var r, a, i = Po(e1, t);
    if (!Io && i) {
        if (Lo > 2) return console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Io = !0, void setTimeout(function() {
            Io = !1;
        }, 1);
        Lo++, r = i.node, a = n.focusOptions, "focus" in r && r.focus(a), "contentWindow" in r && r.contentWindow && r.contentWindow.focus(), Lo--;
    }
};
function Fo(e1) {
    var t = window.setImmediate;
    void 0 !== t ? t(e1) : setTimeout(e1, 1);
}
var Do = function() {
    return document && document.activeElement === document.body || function(e1) {
        void 0 === e1 && (e1 = document);
        var t = xo(e1);
        return !!t && Gi(e1.querySelectorAll("[".concat("data-no-focus-lock", "]"))).some(function(e1) {
            return go(e1, t);
        });
    }();
}, Bo = null, Ao = null, Wo = null, jo = !1, Ro = function() {
    return !0;
};
function $o(e1, t, n, r) {
    var a = null, i = e1;
    do {
        var o = r[i];
        if (o.guard) o.node.dataset.focusAutoGuard && (a = o);
        else {
            if (!o.lockItem) break;
            if (i !== e1) return;
            a = null;
        }
    }while ((i += n) !== t);
    a && (a.node.tabIndex = 0);
}
var Ho = function(e1) {
    return e1 && "current" in e1 ? e1.current : e1;
}, Go = function e1(t, n, r) {
    return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e1(t, n.parentNode, r));
}, Uo = function() {
    var e1, t, n, r, a, i, o, l = !1;
    if (Bo) {
        var s = Bo, c = s.observed, d = s.persistentFocus, u = s.autoFocus, p = s.shards, m = s.crossFrame, f = s.focusOptions, v = c || Wo && Wo.portaledElement, h = document && document.activeElement;
        if (v) {
            var g = [
                v
            ].concat(p.map(Ho).filter(Boolean));
            if (h && !function(e1) {
                return (Bo.whiteList || Ro)(e1);
            }(h) || (d || (m ? Boolean(jo) : "meanwhile" === jo) || !Do() || !Ao && u) && (v && !(Eo(g) || h && function(e1, t) {
                return t.some(function(t) {
                    return Go(e1, t, t);
                });
            }(h, g) || (o = h, Wo && Wo.portaledElement === o)) && (document && !Ao && h && !u ? (h.blur && h.blur(), document.body.focus()) : (l = zo(g, Ao, {
                focusOptions: f
            }), Wo = {})), jo = !1, Ao = document && document.activeElement), document) {
                var b = document && document.activeElement, y = (t = yo(e1 = g).filter(ro), n = Mo(e1, e1, t), r = new Map, a = fo([
                    n
                ], r, !0), i = fo(t, r).filter(function(e1) {
                    var t = e1.node;
                    return ro(t);
                }).map(function(e1) {
                    return e1.node;
                }), a.map(function(e1) {
                    var t = e1.node;
                    return {
                        node: t,
                        index: e1.index,
                        lockItem: i.indexOf(t) >= 0,
                        guard: no(t)
                    };
                })), x = y.map(function(e1) {
                    return e1.node;
                }).indexOf(b);
                x > -1 && (y.filter(function(e1) {
                    var t = e1.guard, n = e1.node;
                    return t && n.dataset.focusAutoGuard;
                }).forEach(function(e1) {
                    return e1.node.removeAttribute("tabIndex");
                }), $o(x, y.length, 1, y), $o(x, -1, -1, y));
            }
        }
    }
    return l;
}, Vo = function(e1) {
    Uo() && e1 && (e1.stopPropagation(), e1.preventDefault());
}, qo = function() {
    return Fo(Uo);
};
 true || 0;
var Yo = function() {
    jo = "just", setTimeout(function() {
        jo = "meanwhile";
    }, 0);
};
Fi.assignSyncMedium(function(e1) {
    var t = e1.target, n = e1.currentTarget;
    n.contains(t) || (Wo = {
        observerNode: n,
        portaledElement: t
    });
}), Di.assignMedium(qo), Bi.assignMedium(function(e1) {
    return e1({
        moveFocusInside: zo,
        focusInside: Eo
    });
});
var Xo = (function(e1, n) {
    if (false) {}
    return function(r) {
        if (false) {}
        var a, i = [];
        function o() {
            a = e1(i.map(function(e1) {
                return e1.props;
            })), n(a);
        }
        var l, s, c, d = function(e1) {
            function n() {
                return e1.apply(this, arguments) || this;
            }
            Rt(n, e1), n.peek = function() {
                return a;
            };
            var l = n.prototype;
            return l.componentDidMount = function() {
                i.push(this), o();
            }, l.componentDidUpdate = function() {
                o();
            }, l.componentWillUnmount = function() {
                var e1 = i.indexOf(this);
                i.splice(e1, 1), o();
            }, l.render = function() {
                return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(r, this.props);
            }, n;
        }(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
        return l = d, s = "displayName", c = "SideEffect(" + function(e1) {
            return e1.displayName || e1.name || "Component";
        }(r) + ")", (s = Hi(s)) in l ? Object.defineProperty(l, s, {
            value: c,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : l[s] = c, d;
    };
})(function(e1) {
    return e1.filter(function(e1) {
        return !e1.disabled;
    });
}, function(e1) {
    var t = e1.slice(-1)[0];
    t && !Bo && (document.addEventListener("focusin", Vo), document.addEventListener("focusout", qo), window.addEventListener("blur", Yo));
    var n = Bo, r = n && t && t.id === n.id;
    Bo = t, n && !r && (n.onDeactivation(), e1.filter(function(e1) {
        return e1.id === n.id;
    }).length || n.returnFocus(!t)), t ? (Ao = null, r && n.observed === t.observed || t.onActivation(), Uo(), Fo(Uo)) : (document.removeEventListener("focusin", Vo), document.removeEventListener("focusout", qo), window.removeEventListener("blur", Yo), Ao = null);
})(function() {
    return null;
}), Ko = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(t, n) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ri, At({
        sideCar: Xo,
        ref: n
    }, t));
}), Qo = Ri.propTypes || {};
Qo.sideCar;
var Jo = Wt(Qo, [
    "sideCar"
]);
Ko.propTypes =  false ? 0 : {};
var Zo = Ko, el = "drawer-module_drawerContainer", tl = "drawer-module_drawer", nl = "drawer-module_drawerFromRight", rl = "drawer-module_drawerFromLeft", al = "drawer-module_drawerInner", il = "drawer-module_drawerEnter", ol = "drawer-module_drawerEnterActive", ll = "drawer-module_drawerExit", sl = "drawer-module_drawerExitActive", cl = "close-button-module_closeButton", dl = function(e1) {
    var n = e1.ariaCloseLabelText, r = e1.className, a = x(e1, [
        "ariaCloseLabelText",
        "className"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", y({
        type: "button",
        "data-testid": "Atom/Close",
        className: C(cl, r),
        "aria-label": null != n ? n : "Close"
    }, a), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: "cross",
        size: 16
    }));
}, ul = "drawer-header-module_drawerHeader", pl = "drawer-header-module_drawerHeaderText", ml = "drawer-header-module_drawerClose", fl = function(e1) {
    var n = e1.heading, r = e1.onClose, a = e1.classNames, i = e1.ariaLabelledById, o = e1.ariaCloseLabelText, l = e1.hideCloseButton, s = x(e1, [
        "heading",
        "onClose",
        "classNames",
        "ariaLabelledById",
        "ariaCloseLabelText",
        "hideCloseButton"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        className: C(ul)
    }, s), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qe, {
        id: i,
        element: "h1",
        className: C(pl, null == a ? void 0 : a.heading)
    }, n), !l && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(dl, {
        className: C(ml, null == a ? void 0 : a.closeButton),
        onClick: r,
        ariaCloseLabelText: null != o ? o : "Close drawer"
    }));
}, vl = function(e1) {
    var n = e1.children, r = e1.fromLeft, a = e1.header, i = e1.ariaLabelledById, o = Ti(), l = o.close, s = o.transitionState, c = {
        enter: il,
        enterActive: ol,
        exit: ll,
        exitActive: sl
    }, d = {
        "--drawerTransformDirection": r ? "-100%" : "100%"
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: d
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tr, {
        appear: !0,
        classNames: c,
        unmountOnExit: !0,
        timeout: 250,
        in: "entered" === s
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": i
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zo, {
        returnFocus: !0
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        "aria-labelledby": "drawerHeading",
        className: C(tl, r ? rl : nl)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(fl, {
        ariaLabelledById: "drawerHeading",
        heading: a,
        onClose: function() {
            return l();
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: el
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        "aria-labelledby": "drawerHeading"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: al,
        "data-testid": "Drawer/Content"
    }, n))))))));
}, hl = function(e1) {
    var n = e1.children, r = e1.onClose, a = e1.fromLeft, i = void 0 !== a && a, o = e1.headerElement, l = e1.header, s = e1.ariaLabelledById;
    return function(e1) {
        e1.headerElement && console.warn("prop: headerElement is deprecated, please use header instead"), e1.bodyId && console.warn("prop: bodyId has been removed, add aria labels to your content as needed"), e1.ariaLabelledById || console.warn("prop: ariaLabelledById will be required in the next update");
    }(e1), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ni, {
        onClose: r
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(vl, {
        header: o || l,
        fromLeft: i,
        ariaLabelledById: s || "aria title label"
    }, n));
}, gl = "featured-block-module_container", bl = "featured-block-module_wrapper", yl = "featured-block-module_inner", xl = "featured-block-module_reverse", El = "featured-block-module_title", wl = "featured-block-module_bodyCopy", Cl = function(e1) {
    var n = e1.title, r = e1.content, a = e1.placeholder, i = e1.className, o = e1.align, l = void 0 === o ? "left" : o, s = C(gl, i), c = C(yl, "right" === l && xl);
    return /*#__PURE__*/ t.createElement("section", {
        className: s
    }, /*#__PURE__*/ t.createElement("div", {
        className: bl
    }, /*#__PURE__*/ t.createElement("div", {
        className: c
    }, /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement(ke, {
        element: "h2",
        fontSize: "3xl",
        lineHeight: "display",
        fontWeight: "bold",
        className: El
    }, n), r && /*#__PURE__*/ t.createElement(ke, {
        fontSize: "m",
        fontWeight: "book",
        className: wl
    }, r)), /*#__PURE__*/ t.createElement("div", null, a))));
}, Sl = "full-width-module_outer", Tl = function(e1) {
    var n = e1.backgroundColor, r = e1.children, a = e1.customClass, i = n ? {
        backgroundColor: n
    } : void 0;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
        className: "".concat(Sl, " ").concat(a),
        style: i
    }, r);
}, Nl = "full-width-cta-module_inner", kl = "full-width-cta-module_svg", _l = "full-width-cta-module_content", Ol = "full-width-cta-module_subtitle", Ml = "full-width-cta-module_title", Pl = "full-width-cta-module_button", Ll = "full-width-cta-module_img", Il = "full-width-cta-module_innerButtonRight", zl = function(e1) {
    var n, r = e1.iconName, a = e1.iconColor, i = e1.iconGradient, o = e1.iconSize, l = e1.title, s = e1.subtitle, c = e1.buttonLabel, d = e1.onButtonClick, u = e1.img, p = e1.className, m = C(Nl, ((n = {})[Il] = !u, n));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tl, {
        customClass: p
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: m
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: r,
        size: o,
        color: a || void 0,
        gradient: i || void 0,
        className: kl
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: _l
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        className: Ol
    }, s), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        fontWeight: "bold",
        className: Ml
    }, l), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, {
        onClick: d,
        classNames: {
            button: Pl
        }
    }, c)), u && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: u.src,
        alt: u.alt,
        className: Ll
    })));
}, Fl = {
    container: "image-text-block-module_container",
    reverse: "image-text-block-module_reverse",
    title: "image-text-block-module_title",
    picture: "image-text-block-module_picture",
    image: "image-text-block-module_image"
}, Dl = function(e1) {
    var n = e1.title, r = e1.content, a = e1.image, i = e1.align, o = void 0 === i ? "left" : i, l = e1.className;
    return /*#__PURE__*/ t.createElement("article", {
        className: C(Fl.container, l, "left" === o ? "" : Fl.reverse)
    }, /*#__PURE__*/ t.createElement("div", {
        className: Fl.content
    }, /*#__PURE__*/ t.createElement(ke, {
        element: "h3",
        fontSize: "l",
        fontWeight: "bold",
        className: Fl.title
    }, n), r), /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement("picture", {
        className: Fl.picture
    }, /*#__PURE__*/ t.createElement("source", {
        srcSet: a.small.webp,
        media: oe.customMedia.xxs,
        type: "image/webp"
    }), /*#__PURE__*/ t.createElement("source", {
        srcSet: a.small.png,
        media: oe.customMedia.xxs,
        type: "image/png"
    }), /*#__PURE__*/ t.createElement("source", {
        srcSet: a.large.webp,
        media: oe.customMedia.m,
        type: "image/webp"
    }), /*#__PURE__*/ t.createElement("source", {
        srcSet: a.large.png,
        media: oe.customMedia.m,
        type: "image/png"
    }), /*#__PURE__*/ t.createElement("img", {
        className: Fl.image,
        alt: a.alt,
        src: a.large.png
    }))));
}, Bl = "inline-radio-field-module_inlineRadioGroup", Al = "inline-radio-field-module_inlineRadioGroupOptions", Wl = "inline-radio-field-module_inlineRadioGroupInput", jl = "inline-radio-field-module_inlineRadioGroupSubLabel", Rl = function(e1, t) {
    return "function" == typeof e1 ? e1(t) : e1;
}, $l = /*#__PURE__*/ (/* unused pure expression or super */ null && (t.forwardRef(function(e1, n) {
    var r, a = e1.options, i = e1.label, o = e1.name, l = e1.error, s = void 0 === l ? {
        show: !1,
        collapse: !1
    } : l, c = e1.classNames, d = e1.helpText, u = x(e1, [
        "options",
        "label",
        "name",
        "error",
        "classNames",
        "helpText"
    ]), p = C(null == c ? void 0 : c.legend), m = y(y({}, null == c ? void 0 : c.radio), {
        container: C(Wl, null === (r = null == c ? void 0 : c.radio) || void 0 === r ? void 0 : r.container)
    });
    return /*#__PURE__*/ t.createElement("fieldset", {
        className: C(Bl, null == c ? void 0 : c.fieldset)
    }, /*#__PURE__*/ t.createElement(_e, {
        element: "legend",
        classNames: {
            label: p
        }
    }, i), d && /*#__PURE__*/ t.createElement(Be, {
        className: null == c ? void 0 : c.helpText
    }, d), /*#__PURE__*/ t.createElement("div", {
        className: C(Al, null == c ? void 0 : c.container)
    }, a.map(function(e1) {
        var r = e1.value, a = e1.id, i = e1.label, l = e1.subLabel, s = u.value && r === u.value, d = Rl(i, s), p = Rl(l, s);
        return /*#__PURE__*/ t.createElement(We, y({}, u, {
            key: a,
            name: o,
            htmlFor: a,
            value: r,
            classNames: m,
            checked: s,
            ref: n
        }), /*#__PURE__*/ t.createElement("span", {
            className: C(null == c ? void 0 : c.labelText)
        }, d), p && /*#__PURE__*/ t.createElement(ke, {
            element: "span",
            className: C(jl, null == c ? void 0 : c.subLabelText),
            fontSize: "3xs"
        }, p));
    })), /*#__PURE__*/ t.createElement(Fe, {
        show: s.show,
        message: s.message,
        collapse: s.collapse,
        classNames: null == c ? void 0 : c.error
    }));
}))), Hl = "modal-module_modal", Gl = "modal-module_modalOuter", Ul = "modal-module_modalEnter", Vl = "modal-module_modalEnterActive", ql = "modal-module_modalExit", Yl = "modal-module_modalExitActive", Xl = "modal-module_modalBody", Kl = "modal-module_modalInner", Ql = "modal-header-module_modalHeader", Jl = "modal-header-module_modalHeaderText", Zl = "modal-header-module_modalClose", es = function(e1) {
    var n = e1.heading, r = e1.onClose, a = e1.classNames, i = e1.ariaLabelledById, o = e1.ariaCloseLabelText, l = e1.hideCloseButton, s = x(e1, [
        "heading",
        "onClose",
        "classNames",
        "ariaLabelledById",
        "ariaCloseLabelText",
        "hideCloseButton"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        className: C(Ql)
    }, s), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qe, {
        id: i,
        element: "h1",
        className: C(Jl, null == a ? void 0 : a.heading)
    }, n), !l && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(dl, {
        className: C(Zl, null == a ? void 0 : a.closeButton),
        onClick: r,
        ariaCloseLabelText: null != o ? o : "Close modal"
    }));
}, ts = "modal-footer-module_ModalFooter", ns = function(e1) {
    var n = e1.primaryButtonText, r = e1.primaryButtonOnClick, a = x(e1, [
        "primaryButtonText",
        "primaryButtonOnClick"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        className: C(ts)
    }, a), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, {
        isFullWidth: !0,
        onClick: r
    }, n));
}, rs = function(e1) {
    var n = e1.heading, r = e1.ariaLabelledById, a = e1.children, i = e1.classNames, o = e1.ariaCloseButtonText, l = e1.hideCloseButton, s = e1.primaryButtonText, c = e1.primaryButtonOnClick, d = x(e1, [
        "heading",
        "ariaLabelledById",
        "children",
        "classNames",
        "ariaCloseButtonText",
        "hideCloseButton",
        "primaryButtonText",
        "primaryButtonOnClick"
    ]), u = Ti(), p = u.close, m = u.transitionState, f = {
        enter: Ul,
        enterActive: Vl,
        exit: ql,
        exitActive: Yl
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tr, {
        appear: !0,
        timeout: 250,
        unmountOnExit: !0,
        classNames: f,
        in: "entered" === m
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": r,
        className: C(Hl, null == i ? void 0 : i.modal)
    }, d), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zo, {
        returnFocus: !0
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        className: Gl
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(es, {
        ariaCloseLabelText: o,
        classNames: {
            heading: null == i ? void 0 : i.title,
            closeButton: null == i ? void 0 : i.closeButton
        },
        ariaLabelledById: r,
        heading: n,
        hideCloseButton: l,
        onClose: p
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Xl, null == i ? void 0 : i.body)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        className: C(Kl, null == i ? void 0 : i.inner)
    }, a)), s && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ns, {
        primaryButtonText: s,
        primaryButtonOnClick: c
    })))));
}, as = function(e1) {
    var n = e1.onClose, r = e1.children, a = e1.titleId, i = e1.title, o = e1.heading, l = e1.ariaCloseButtonText, s = e1.closeText, c = e1.ariaLabelledById, d = e1.primaryButtonText, u = e1.primaryButtonOnClick, p = x(e1, [
        "onClose",
        "children",
        "titleId",
        "title",
        "heading",
        "ariaCloseButtonText",
        "closeText",
        "ariaLabelledById",
        "primaryButtonText",
        "primaryButtonOnClick"
    ]);
    return function(e1) {
        e1.titleId && console.warn("prop: titleId is deprecated, please use ariaLabelledById instead"), e1.title && console.warn("prop: title is deprecated, please use heading instead"), e1.bodyId && console.warn("prop: bodyId has been removed, add aria labels to your content as needed"), e1.closeText && console.warn("prop: closeText is deprecated, please use ariaCloseButtonText instead");
    }(e1), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ni, {
        onClose: n
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rs, y({
        heading: i || o,
        ariaLabelledById: c || a || "aria title label",
        ariaCloseButtonText: l || s,
        primaryButtonText: d,
        primaryButtonOnClick: u
    }, p), r));
}, is = "quote-module_outer", os = "quote-module_inner", ls = "quote-module_author", ss = "quote-module_rating", cs = "quote-module_ratingStar", ds = "quote-module_ratingStarActive", us = "quote-module_ratingStarIcon", ps = function(e1) {
    var n = e1.author, r = e1.text, a = e1.rating;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: is
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: os
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "“"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, r)), n && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: ls
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, n)), a && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: ss,
        role: "figure",
        "aria-label": "".concat(a, " of 5 rating")
    }, (function(e1, t, n) {
        if (n || 2 === arguments.length) for(var r, a = 0, i = t.length; a < i; a++)!r && a in t || (r || (r = Array.prototype.slice.call(t, 0, a)), r[a] = t[a]);
        return e1.concat(r || Array.prototype.slice.call(t));
    })([], Array(5), !0).map(function(e1, n) {
        var r;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
            className: C(cs, (r = {}, r[ds] = n + 1 <= a, r)),
            key: n
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: us
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
            d: "m11.469 15.893 4.705-1.195 1.966 6.07-6.671-4.875Zm10.828-7.847h-8.282L11.469.23 8.923 8.046H.64l6.703 4.844-2.546 7.814L11.5 15.86l4.125-2.97 6.67-4.844Z",
            fill: "#fff"
        })));
    })));
}, ms = "search-field-module_searchField", fs = "search-field-module_searchFieldInput", vs = "search-field-module_searchFieldInputDisabled", hs = "search-field-module_searchFieldInputError", gs = "search-field-module_searchFieldButton", bs = "search-field-module_searchFieldButtonErrorVisible", ys = "search-field-module_searchFieldLabel", xs = "search-field-module_searchFieldHelpText", Es = /*#__PURE__*/ (/* unused pure expression or super */ null && (r(function(e1, n) {
    var r, a, i, o, l = e1.label, s = e1.helpText, c = e1.error, d = void 0 === c ? {
        show: !1,
        collapse: !1
    } : c, u = e1.className, p = e1.button, m = e1.input, f = x(e1, [
        "label",
        "helpText",
        "error",
        "className",
        "button",
        "input"
    ]), v = C(fs, ((r = {})[vs] = null == m ? void 0 : m.disabled, r[hs] = null == d ? void 0 : d.show, r), null == m ? void 0 : m.className);
    return /*#__PURE__*/ t.createElement("div", y({
        className: C(ms, u)
    }, f), /*#__PURE__*/ t.createElement(_e, y({}, l, {
        classNames: y(y({}, null == l ? void 0 : l.classNames), {
            label: C(null === (a = null == l ? void 0 : l.classNames) || void 0 === a ? void 0 : a.label, ys)
        })
    })), s && /*#__PURE__*/ t.createElement(Be, y({}, s, {
        className: C(null == s ? void 0 : s.className, xs)
    })), /*#__PURE__*/ t.createElement("input", y({
        type: "search",
        "aria-invalid": d.show,
        ref: n
    }, m, {
        className: v
    })), /*#__PURE__*/ t.createElement(Fe, y({}, d, {
        classNames: y(y({}, null == d ? void 0 : d.classNames), {
            container: xs
        })
    })), /*#__PURE__*/ t.createElement(W, y({}, p, {
        classNames: y(y({}, null == p ? void 0 : p.classNames), {
            button: C(null === (i = null == p ? void 0 : p.classNames) || void 0 === i ? void 0 : i.button, gs, (null == d ? void 0 : d.show) ? bs : void 0)
        }),
        type: null !== (o = null == p ? void 0 : p.type) && void 0 !== o ? o : "submit",
        isFullWidth: !0
    })));
}))), ws = "section-with-image-module_container", Cs = "section-with-image-module_inner", Ss = "section-with-image-module_contentContainer", Ts = "section-with-image-module_text", Ns = "section-with-image-module_button", ks = "section-with-image-module_icon", _s = "section-with-image-module_imageContainer", Os = "section-with-image-module_image", Ms = function(e1) {
    var n = e1.image, r = e1.onButtonClick, a = e1.text, i = e1.buttonLabel, o = e1.iconName, l = void 0 === o ? "arrows-left-right" : o, s = e1.iconColor, c = e1.iconGradient, d = e1.backgroundColor, u = void 0 === d ? "#5234B6" : d, p = e1.customClassNames, m = C(Ts, null == p ? void 0 : p.text), f = C(Ns, null == p ? void 0 : p.button), v = C(ks, null == p ? void 0 : p.icon);
    return /*#__PURE__*/ t.createElement("section", {
        className: ws,
        style: {
            backgroundColor: u
        }
    }, /*#__PURE__*/ t.createElement("div", {
        className: Cs
    }, /*#__PURE__*/ t.createElement("div", {
        className: Ss
    }, /*#__PURE__*/ t.createElement(we, {
        name: l,
        color: s || void 0,
        gradient: c || void 0,
        className: v
    }), /*#__PURE__*/ t.createElement(ke, {
        className: m
    }, a), /*#__PURE__*/ t.createElement(G, {
        variant: "alternative",
        classNames: {
            button: f
        },
        onClick: r
    }, i)), /*#__PURE__*/ t.createElement("div", {
        className: _s
    }, /*#__PURE__*/ t.cloneElement(n, {
        className: Os
    }))));
}, Ps = "select-field-module_container", Ls = "select-field-module_wrapper", Is = "select-field-module_select", zs = "select-field-module_svg", Fs = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(e1, n) {
    var r = e1.id, a = e1.label, i = e1.labelHidden, o = void 0 !== i && i, l = e1.disabled, s = e1.optional, c = e1.error, d = void 0 === c ? {
        show: !1,
        collapse: !1
    } : c, u = e1.value, p = e1.classNames, m = e1.helpText, f = x(e1, [
        "id",
        "label",
        "labelHidden",
        "disabled",
        "optional",
        "error",
        "value",
        "classNames",
        "helpText"
    ]), v = C(zs, null == p ? void 0 : p.arrow), h = C(Ps, null == p ? void 0 : p.container), g = C(Ls, null == p ? void 0 : p.selectWrapper), b = C(Is, null == p ? void 0 : p.select);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: h,
        "data-field": r
    }, a && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_e, {
        htmlFor: r,
        optional: s,
        visuallyHidden: o
    }, a), m && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Be, {
        className: null == p ? void 0 : p.helpText
    }, m), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: g
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xe, y({
        id: r,
        error: d,
        disabled: l,
        value: u,
        "data-testid": "SelectField/Select",
        classNames: {
            select: b,
            option: null == p ? void 0 : p.option
        },
        ref: n
    }, f)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        className: v,
        name: "chevron-down",
        color: l ? "asphaltGrey" : "deepPurple"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe, y({}, d)));
}), Ds = "slide-up-panel-module_slideUpPanelContainer", Bs = "slide-up-panel-module_slideUpPanel", As = "slide-up-panel-module_slideUpPanelInner", Ws = "slide-up-panel-module_slideUpPanelEnter", js = "slide-up-panel-module_slideUpPanelEnterActive", Rs = "slide-up-panel-module_slideUpPanelExit", $s = "slide-up-panel-module_slideUpPanelExitActive", Hs = "slide-up-panel-header-module_slideUpPanelHeader", Gs = "slide-up-panel-header-module_slideUpPanelHeaderText", Us = "slide-up-panel-header-module_slideUpPanelClose", Vs = function(e1) {
    var n = e1.heading, r = e1.onClose, a = e1.ariaLabelledById, i = e1.ariaCloseLabelText, o = x(e1, [
        "heading",
        "onClose",
        "ariaLabelledById",
        "ariaCloseLabelText"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        className: C(Hs)
    }, o), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Qe, {
        id: a,
        element: "h1",
        className: C(Gs)
    }, n), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(dl, {
        className: C(Us),
        onClick: r,
        ariaCloseLabelText: null != i ? i : "Close modal"
    }));
}, qs = "slide-up-panel-footer-module_SlideUpPanelFooter", Ys = function(e1) {
    var n = e1.primaryButtonText, r = e1.primaryButtonOnClick, a = x(e1, [
        "primaryButtonText",
        "primaryButtonOnClick"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", y({
        className: C(qs)
    }, a), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(W, {
        isFullWidth: !0,
        onClick: r
    }, n));
}, Xs = function(e1) {
    var n = e1.children, r = e1.ariaLabelledById, a = e1.ariaCloseButtonText, i = e1.heading, o = e1.primaryButtonText, l = e1.primaryButtonOnClick, s = Ti(), c = s.close, d = s.transitionState, u = {
        enter: Ws,
        enterActive: js,
        exit: Rs,
        exitActive: $s
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tr, {
        appear: !0,
        classNames: u,
        unmountOnExit: !0,
        timeout: 250,
        in: "entered" === d
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": r
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Zo, {
        returnFocus: !0
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        "aria-labelledby": "slideUpPanelHeading",
        className: C(Bs)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vs, {
        ariaCloseLabelText: a,
        ariaLabelledById: r,
        heading: i,
        onClose: c
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: Ds
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Nt, {
        "aria-labelledby": "slideUpPanelHeading"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: As,
        "data-testid": "slideUpPanel/Content"
    }, n))), o && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ys, {
        primaryButtonText: o,
        primaryButtonOnClick: l
    }))))));
}, Ks = function(e1) {
    var n = e1.onClose, r = e1.children, a = e1.heading, i = e1.ariaCloseButtonText, o = e1.ariaLabelledById, l = e1.primaryButtonText, s = e1.primaryButtonOnClick;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ni, {
        onClose: n
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Xs, {
        heading: a,
        ariaLabelledById: o || "aria title label",
        ariaCloseButtonText: i,
        primaryButtonText: l,
        primaryButtonOnClick: s
    }, r));
}, Qs = {
    tabsButton: "tabs-module_tabsButton",
    tabsPanel: "tabs-module_tabsPanel",
    hiddenPanel: "tabs-module_hiddenPanel"
}, Js = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)([
    {
        activeId: "",
        numberOfTabs: 0,
        activeIndex: 0
    },
    function() {
        return null;
    },
    function() {
        return null;
    },
    function() {
        return null;
    }
]), Zs = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(Js);
}, ec = function(e1) {
    var n = e1.children, r = e1.className, a = e1.activeTabId, i = void 0 === a ? "" : a, o = e1.activeIndexId, c = void 0 === o ? 0 : o, d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(i), u = d[0], p = d[1], m = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(c), f = m[0], v = m[1], h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), g = h[0], b = h[1];
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        i && p(i), c && v(c);
    }, [
        i,
        c
    ]), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Js.Provider, {
        value: [
            {
                activeId: u,
                numberOfTabs: g,
                activeIndex: f
            },
            p,
            b,
            v
        ]
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Qs.tabs, r)
    }, n));
}, tc = function(e1) {
    var n, r = e1.children, a = e1.ariaLabel, i = e1.className, o = e1.leftAligned, c = Zs(), d = c[0].activeIndex, u = c[1], p = c[2], m = c[3], f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), v = f[0], h = f[1], g = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(r, function(e1) {
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(e1) && e1.props.id) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1);
    }), b = null !== (n = null == g ? void 0 : g.length) && void 0 !== n ? n : 0;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (g && b > 0) {
            var e1 = g[d].props.id;
            u(e1), p(b);
        }
    }, [
        d
    ]), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        role: "tablist",
        className: C(Qs.tabsList, i),
        "aria-label": a
    }, null == g ? void 0 : g.map(function(e1, n) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, {
            indexId: n,
            setActiveIndex: m,
            totalItems: o ? b - 2 : b - 1,
            isTouched: v,
            setIsTouched: h
        });
    }));
}, nc = function(e1) {
    var n = e1.children, r = e1.id, a = e1.panelId, i = e1.indexId, o = e1.totalItems, l = e1.setActiveIndex, c = e1.isTouched, d = e1.setIsTouched, p = e1.onActive, m = e1.className, f = e1.onButtonClick, v = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), h = Zs()[0].activeId === r;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        v.current && h && c && v.current.focus();
    }, [
        h,
        c
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
        tabIndex: h ? 0 : -1,
        role: "tab",
        id: r,
        "aria-controls": a,
        "aria-selected": h,
        onKeyDown: function(e1) {
            if (l && void 0 !== i && o && d) {
                var t = function(e1, t, n) {
                    return "ArrowRight" === e1 ? t === n ? t : t + 1 : "ArrowLeft" === e1 ? 0 === t ? t : t - 1 : t;
                }(e1.key, i, o);
                l(t), d(!0), p && p();
            }
        },
        onClick: function(e1) {
            e1.preventDefault(), l && d && (l(i || 0), d(!0)), p && p(), f && f();
        },
        className: C(Qs.tabsButton, m),
        ref: v
    }, n);
}, rc = function(e1) {
    var n = e1.children, r = e1.id, a = e1.buttonId, i = e1.className, o = Zs()[0].activeId === a, l = !o && Qs.hiddenPanel;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(Qs.tabsPanel, i, l),
        tabIndex: 0,
        role: "tabpanel",
        id: r,
        "aria-labelledby": a,
        "data-testid": "tabs-panel",
        hidden: !o
    }, n);
}, ac = "text-field-module_fieldText", ic = "text-field-module_disabled", oc = "text-field-module_error", lc = "text-field-module_fullWidth", sc = "text-field-module_fieldWrapper", cc = {
    show: !1,
    collapse: !1
}, dc = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(e1, n) {
    var r, a, i, o = e1.id, l = e1.name, s = e1.type, c = e1.label, d = e1.labelHidden, u = void 0 !== d && d, p = e1.placeholder, m = e1.helpText, f = e1.optional, v = void 0 !== f && f, h = e1.disabled, g = void 0 !== h && h, b = e1.fullWidth, E = void 0 !== b && b, w = e1.error, S = void 0 === w ? cc : w, T = e1.classNames, N = e1.inputElement, k = void 0 === N ? "input" : N, _ = x(e1, [
        "id",
        "name",
        "type",
        "label",
        "labelHidden",
        "placeholder",
        "helpText",
        "optional",
        "disabled",
        "fullWidth",
        "error",
        "classNames",
        "inputElement"
    ]), O = C(sc, ((r = {})[lc] = E, r)), M = C(ac, ((a = {})[lc] = E, a[ic] = g, a[oc] = null == S ? void 0 : S.show, a), null == T ? void 0 : T.input), P = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(k, y({
        id: o,
        name: l,
        type: s,
        disabled: g,
        placeholder: ze(p),
        "aria-invalid": null == S ? void 0 : S.show,
        className: M,
        "data-testid": "TextField/Input",
        ref: n
    }, _));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(O, null == T ? void 0 : T.container),
        "data-testid": "TextField/Container"
    }, c && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_e, {
        htmlFor: o,
        optional: v,
        classNames: {
            label: null === (i = null == T ? void 0 : T.label) || void 0 === i ? void 0 : i.label,
            optionalText: null == T ? void 0 : T.labelOptionalText
        },
        visuallyHidden: u
    }, c), m && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Be, {
        className: null == T ? void 0 : T.helpText
    }, m), P, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Fe, y({}, S, {
        classNames: null == T ? void 0 : T.error
    })));
}), uc = "textarea-field-module_fullWidth", pc = "textarea-field-module_textarea", mc = function(e1) {
    var n, r = e1.id, a = e1.classNames, i = e1.disabled, o = e1.error, l = void 0 === o ? {
        show: !1,
        collapse: !1
    } : o, s = e1.fullWidth, c = e1.label, d = e1.labelHidden, u = void 0 !== d && d, p = e1.optional, m = e1.value, f = e1.helpText, v = x(e1, [
        "id",
        "classNames",
        "disabled",
        "error",
        "fullWidth",
        "label",
        "labelHidden",
        "optional",
        "value",
        "helpText"
    ]), h = C(((n = {})[uc] = s, n), null == a ? void 0 : a.fieldWrapper);
    return /*#__PURE__*/ t.createElement("div", {
        className: h,
        "data-field": r,
        "data-testid": "TextareaField/Wrapper"
    }, c && /*#__PURE__*/ t.createElement(_e, {
        htmlFor: r,
        optional: p,
        classNames: null == a ? void 0 : a.label,
        visuallyHidden: u
    }, c), f && /*#__PURE__*/ t.createElement(Be, {
        className: null == a ? void 0 : a.helpText
    }, f), /*#__PURE__*/ t.createElement(_, y({
        id: r,
        error: l,
        disabled: i,
        value: m,
        "data-testid": "TextareaField/Textarea",
        classNames: {
            textarea: C(pc, null == a ? void 0 : a.textarea)
        }
    }, v)), /*#__PURE__*/ t.createElement(Fe, y({}, l, {
        classNames: null == a ? void 0 : a.error
    })));
}, fc = "tip-module_tip", vc = "tip-module_tipAlignMiddle", hc = "tip-module_tipIcon", gc = function(e1) {
    var n = e1.titleEl, r = void 0 === n ? "h3" : n, a = e1.title, i = e1.text, o = e1.textProps, l = void 0 === o ? {} : o, s = e1.titleProps, c = void 0 === s ? {} : s, d = e1.classNames;
    return /*#__PURE__*/ t.createElement("div", {
        className: C(fc, !a && vc, null == d ? void 0 : d.container)
    }, /*#__PURE__*/ t.createElement(we, {
        name: "lightbulb",
        className: C(hc, null == d ? void 0 : d.icon)
    }), /*#__PURE__*/ t.createElement("div", null, a && /*#__PURE__*/ t.createElement(ke, y({
        element: r,
        fontSize: ge.m,
        fontWeight: be.semibold,
        lineHeight: ye.display
    }, c, {
        className: null == d ? void 0 : d.title
    }), a), /*#__PURE__*/ t.createElement(ke, y({
        fontSize: ge.s,
        fontWeight: be.book
    }, l, {
        className: null == d ? void 0 : d.text
    }), i)));
}, bc = "toggle-field-module_toggleField", yc = "toggle-field-module_toggleFieldLabel", xc = function(e1) {
    var n, r = e1.label, a = e1.name, i = e1.options, o = e1.error, l = void 0 === o ? {
        show: !1,
        collapse: !1
    } : o, s = e1.helpText, c = e1.onSelected, d = e1.classNames, u = y(y({}, null == d ? void 0 : d.label), {
        label: C(yc, null === (n = null == d ? void 0 : d.label) || void 0 === n ? void 0 : n.label)
    });
    return /*#__PURE__*/ t.createElement("fieldset", {
        className: C(bc, null == d ? void 0 : d.fieldWrapper)
    }, /*#__PURE__*/ t.createElement(_e, {
        classNames: u,
        element: "legend"
    }, r), s && /*#__PURE__*/ t.createElement(Be, {
        className: null == d ? void 0 : d.helpText
    }, s), /*#__PURE__*/ t.createElement(xt, {
        name: a,
        options: i,
        onSelected: c,
        classNames: null == d ? void 0 : d.toggle
    }), /*#__PURE__*/ t.createElement(Fe, y({}, l, {
        classNames: null == d ? void 0 : d.error
    })));
}, Ec = "vertical-tabs-module_tabsButton", wc = "vertical-tabs-module_tabsList", Cc = "vertical-tabs-module_tabsPanel", Sc = "vertical-tabs-module_tabsTitle", Tc = "vertical-tabs-module_tabsSvg", Nc = "vertical-tabs-module_tabs", kc = function(e1) {
    var n = e1.children, r = x(e1, [
        "children"
    ]);
    return /*#__PURE__*/ t.createElement(nc, y({}, r, {
        className: C(Ec, r.className)
    }), /*#__PURE__*/ t.createElement(ke, {
        element: "span",
        fontSize: ge.s
    }, n), /*#__PURE__*/ t.createElement(we, {
        id: r.id,
        name: "chevron-down",
        color: "mineShaft",
        className: Tc
    }));
}, _c = function(e1) {
    var n = e1.children, r = e1.id, a = e1.buttonId, i = e1.className, o = Zs()[0].activeId, s = l(!0), c = s[0], d = s[1], u = l("0"), p = u[0], m = u[1], f = o === a;
    return /*#__PURE__*/ t.createElement(rc, {
        id: r,
        "aria-labelledby": a,
        buttonId: a,
        className: C(Cc, i)
    }, /*#__PURE__*/ t.createElement(tr, {
        in: f,
        timeout: 200,
        onEntering: function() {
            d(!1);
        },
        onEntered: function() {
            m("1");
        },
        onExiting: function() {
            m("0");
        },
        onExit: function() {
            d(!0);
        },
        hidden: c,
        style: {
            opacity: p
        }
    }, /*#__PURE__*/ t.createElement("div", null, /*#__PURE__*/ t.createElement("article", null, n))));
}, Oc = function(e1) {
    var n = e1.children, r = e1.className;
    return /*#__PURE__*/ t.createElement(ke, {
        element: "h3",
        fontSize: ge.xl,
        fontWeight: be.bold,
        lineHeight: ye.display,
        className: C(Sc, r)
    }, n);
}, Mc = function(e1) {
    var n = e1.children, r = e1.className;
    return /*#__PURE__*/ t.createElement(ec, {
        className: C(Nc, r)
    }, n);
}, Pc = function(e1) {
    var n = e1.children, r = e1.ariaLabel, a = e1.className;
    return /*#__PURE__*/ t.createElement(tc, {
        className: C(wc, a),
        ariaLabel: r
    }, n);
}, Lc = "video-module_wrapper", Ic = "video-module_fullWidth", zc = "video-module_video", Fc = "video-module_playButton", Dc = "video-module_icon", Bc = "video-module_iconInner", Ac = function(e1) {
    var n, r = e1.autoPlay, a = void 0 !== r && r, i = e1.muted, o = void 0 !== i && i, s = e1.controls, c = void 0 !== s && s, d = e1.isFullWidth, p = void 0 !== d && d, m = e1.volume, f = void 0 === m ? .5 : m, v = e1.ariaLabel, h = e1.thumbnail, g = e1.width, b = e1.height, x = e1.captions, E = void 0 === x ? {
        src: "./default-captions.vtt",
        srcLang: "en"
    } : x, w = e1.children, S = l(!1), T = S[0], N = S[1], k = u(null), _ = function() {
        T ? M() : O();
    }, O = function() {
        k.current && (k.current.volume = f, k.current.play(), N(!0));
    }, M = function() {
        k.current && (k.current.pause(), N(!1));
    };
    return /*#__PURE__*/ t.createElement("div", {
        style: {
            width: g,
            height: b
        },
        className: C(Lc, (n = {}, n[Ic] = p, n)),
        onClick: function() {
            return _();
        },
        onKeyDown: function(e1) {
            return it(e1, _);
        },
        role: "button",
        tabIndex: 0,
        "aria-label": v
    }, T || a ? null : /*#__PURE__*/ t.createElement("div", {
        className: Fc
    }, /*#__PURE__*/ t.createElement("div", {
        className: Dc
    }, /*#__PURE__*/ t.createElement("div", {
        className: Bc
    }, /*#__PURE__*/ t.createElement(we, {
        name: "play",
        color: "deepPurple"
    })))), /*#__PURE__*/ t.createElement("video", {
        playsInline: !0,
        controls: c,
        muted: o,
        autoPlay: a,
        className: zc,
        ref: k,
        poster: h,
        width: g,
        height: b,
        "data-testid": "VideoComponent"
    }, /*#__PURE__*/ t.createElement("track", y({
        default: !0,
        kind: "captions"
    }, E)), w, "Sorry, your browser doesn't support embedded videos."));
}, Wc = function(e1) {
    var n = e1.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        xmlns: "https://www.w3.org/2000/svg",
        width: "256",
        height: "256",
        fill: "none",
        viewBox: "0 0 256 256",
        className: n
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#ff0101",
        d: "M240.429 71.151c-2.699-10.162-10.65-18.165-20.747-20.881C201.381 45.334 128 45.334 128 45.334s-73.383 0-91.683 4.936C26.22 52.986 18.268 60.988 15.571 71.15 10.667 89.57 10.667 128 10.667 128s0 38.43 4.902 56.851c2.699 10.16 10.65 18.164 20.748 20.88 18.3 4.936 91.683 4.936 91.683 4.936s73.382 0 91.681-4.935c10.098-2.717 18.049-10.72 20.748-20.881 4.904-18.421 4.904-56.851 4.904-56.851s0-38.43-4.904-56.849z"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#fff",
        d: "M104 162.892L165.333 128 104 93.107v69.785z"
    }));
}, jc = "youtube-module_container", Rc = "youtube-module_media", $c = "youtube-module_button", Hc = "youtube-module_icon", Gc = "youtube-module_fullWidth", Uc = "youtube-module_newIcon", Vc = "youtube-module_newIconInner", qc = function(e1) {
    var n = e1.videoId, r = e1.title, a = e1.buttonLabel, i = e1.videoUrlOptions, o = void 0 === i ? {
        autoplay: 1,
        mute: 1
    } : i, s = e1.className, c = e1.isFullWidth, d = e1.showNewPlayIcon, u = e1.customThumbnail, p = e1.onClick, m = x(e1, [
        "videoId",
        "title",
        "buttonLabel",
        "videoUrlOptions",
        "className",
        "isFullWidth",
        "showNewPlayIcon",
        "customThumbnail",
        "onClick"
    ]), f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), v = f[0], h = f[1], g = "https://www.youtube.com/embed/".concat(n), b = u || "https://i3.ytimg.com/vi/".concat(n, "/maxresdefault.jpg"), E = Object.keys(o).map(function(e1) {
        return "".concat(e1, "=").concat(o[e1]);
    }).join("&");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: c ? Gc : ""
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "".concat(jc, " ").concat(s || ""),
        "data-testid": "youtube"
    }, !v && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: b,
        alt: "",
        loading: "lazy",
        className: Rc,
        width: "400",
        height: "225",
        role: "presentation",
        "data-testid": "youtube--overlay-image"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
        className: $c,
        onClick: function() {
            return h(!0), void (p && p());
        },
        "aria-label": a,
        title: a
    }, d ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: Uc
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: Vc
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(we, {
        name: "play",
        color: "deepPurple"
    }))) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wc, {
        className: Hc
    }))), v && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("iframe", y({
        "data-testid": "youtube-iframe",
        title: r,
        className: Rc,
        src: "".concat(g, "?").concat(E),
        frameBorder: "0",
        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        loading: "lazy",
        allowFullScreen: !0
    }, m))));
}, Yc = "horizontal-tabs-module_tabs", Xc = "horizontal-tabs-module_withBorder", Kc = "horizontal-tabs-module_tabsButton", Qc = "horizontal-tabs-module_tabsList", Jc = "horizontal-tabs-module_stretchTabs", Zc = "horizontal-tabs-module_finalScoopWrapper", ed = "horizontal-tabs-module_finalScoopContainer", td = "horizontal-tabs-module_finalScoop", nd = "horizontal-tabs-module_tabsButtonContainerSelected", rd = "horizontal-tabs-module_tabsButtonContainer", ad = "horizontal-tabs-module_tabsButtonWithRightScoop", id = "horizontal-tabs-module_tabsButtonWithLeftScoop", od = "horizontal-tabs-module_tabsPanel", ld = "horizontal-tabs-module_curvedTopRightPanel", sd = "horizontal-tabs-module_curvedTopLeftPanel", cd = "horizontal-tabs-module_tabsTitle", dd = "horizontal-tabs-module_rightShadow", ud = "horizontal-tabs-module_leftShadow", pd = function(e1) {
    return e1 ? parseInt(e1.replace(/[^0-9]/g, ""), 10) : 0;
}, md = function(e1) {
    var n = e1.className, r = e1.children, a = e1.indexId, i = e1.onButtonClick, o = x(e1, [
        "className",
        "children",
        "indexId",
        "onButtonClick"
    ]), l = Zs()[0].activeId, s = void 0 === a ? 0 : a + 1, c = function(e1, t) {
        var n = e1 === t, r = n && 2 === t && dd, a = n && 1 === t && ud;
        return {
            container: n ? nd : rd,
            button: C(Kc, t === e1 + 1 && id, t === e1 - 1 && ad),
            buttonShadow: C(a, r)
        };
    }(pd(l), s), d = C(c.button, n);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        "data-testid": "button-container_".concat(s),
        className: C(c.container, c.buttonShadow)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(nc, y({}, o, {
        indexId: a,
        className: d,
        onButtonClick: i
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ke, {
        element: "span",
        fontSize: ge.m
    }, r)));
}, fd = function(e1) {
    var n = e1.children, r = e1.id, a = e1.buttonId, i = e1.className, o = e1.numberOfPanels, l = e1.leftAligned, s = function(e1, t, n) {
        var r = 1 === e1, a = e1 === t, i = !r && !a;
        return [
            (a || i) && sd,
            (r || i || a && n) && ld
        ];
    }(pd(a), null != o ? o : 0, null != l && l);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc, {
        id: r,
        "aria-labelledby": a,
        buttonId: a,
        className: C(od, i, s)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("article", null, n));
}, vd = function(e1) {
    var n = e1.children, r = e1.leftAligned;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(n, function(e1) {
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(e1)) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, {
            numberOfPanels: react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(n).length,
            leftAligned: r
        });
    }));
}, hd = function(e1) {
    var n = e1.children, r = e1.className;
    return /*#__PURE__*/ t.createElement(ke, {
        element: "h3",
        fontSize: ge.xl,
        fontWeight: be.bold,
        lineHeight: ye.display,
        className: C(cd, r)
    }, n);
}, gd = function(e1) {
    var n, r = e1.children, a = e1.className, i = e1.leftAligned, o = e1.activeTabId, l = e1.activeIndexId, s = e1.withBorder, c = void 0 !== s && s;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ec, {
        className: C(Yc, a, (n = {}, n[Xc] = c, n)),
        activeTabId: o,
        activeIndexId: l
    }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(r, function(e1) {
        if (/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(e1)) return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(e1, {
            leftAligned: i
        });
    }));
}, bd = function(e1) {
    var n, r = e1.isLastTabActive;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        id: "final-scoop",
        className: C(Zc)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: C(ed, (n = {}, n[td] = r, n))
    }));
}, yd = function(e1) {
    var n = e1.children, r = e1.ariaLabel, a = e1.className, i = e1.leftAligned, o = Zs()[0], l = o.activeId, s = o.numberOfTabs - 1 === pd(l);
    return i ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tc, {
        className: C(Qc, a),
        ariaLabel: r,
        leftAligned: i
    }, n, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(bd, {
        isLastTabActive: s
    })) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(tc, {
        className: C(Qc, a, Jc),
        ariaLabel: r
    }, n);
};
function xd(e1) {
    if (null === e1 || !0 === e1 || !1 === e1) return NaN;
    var t = Number(e1);
    return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ed(e1, t) {
    if (t.length < e1) throw new TypeError(e1 + " argument" + (e1 > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function wd(e1) {
    Ed(1, arguments);
    var t = Object.prototype.toString.call(e1);
    return e1 instanceof Date || "object" === $i(e1) && "[object Date]" === t ? new Date(e1.getTime()) : "number" == typeof e1 || "[object Number]" === t ? new Date(e1) : ("string" != typeof e1 && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn((new Error).stack)), new Date(NaN));
}
var Cd = {};
function Sd() {
    return Cd;
}
var Td = 6e4, Nd = 36e5;
function kd(e1) {
    if (Ed(1, arguments), !function(e1) {
        return Ed(1, arguments), e1 instanceof Date || "object" === $i(e1) && "[object Date]" === Object.prototype.toString.call(e1);
    }(e1) && "number" != typeof e1) return !1;
    var t = wd(e1);
    return !isNaN(Number(t));
}
function _d(e1, t) {
    return Ed(2, arguments), function(e1, t) {
        Ed(2, arguments);
        var n = wd(e1).getTime(), r = xd(t);
        return new Date(n + r);
    }(e1, -xd(t));
}
function Od(e1) {
    Ed(1, arguments);
    var t = wd(e1), n = t.getUTCDay(), r = (n < 1 ? 7 : 0) + n - 1;
    return t.setUTCDate(t.getUTCDate() - r), t.setUTCHours(0, 0, 0, 0), t;
}
function Md(e1) {
    Ed(1, arguments);
    var t = wd(e1), n = t.getUTCFullYear(), r = new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var a = Od(r), i = new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var o = Od(i);
    return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function Pd(e1) {
    Ed(1, arguments);
    var t = wd(e1), n = Od(t).getTime() - (function(e1) {
        Ed(1, arguments);
        var t = Md(e1), n = new Date(0);
        return n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0), Od(n);
    })(t).getTime();
    return Math.round(n / 6048e5) + 1;
}
function Ld(e1, t) {
    var n, r, a, i, o, l, s, c;
    Ed(1, arguments);
    var d = Sd(), u = xd(null !== (n = null !== (r = null !== (a = null !== (i = null == t ? void 0 : t.weekStartsOn) && void 0 !== i ? i : null == t || null === (o = t.locale) || void 0 === o || null === (l = o.options) || void 0 === l ? void 0 : l.weekStartsOn) && void 0 !== a ? a : d.weekStartsOn) && void 0 !== r ? r : null === (s = d.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.weekStartsOn) && void 0 !== n ? n : 0);
    if (!(u >= 0 && u <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var p = wd(e1), m = p.getUTCDay(), f = (m < u ? 7 : 0) + m - u;
    return p.setUTCDate(p.getUTCDate() - f), p.setUTCHours(0, 0, 0, 0), p;
}
function Id(e1, t) {
    var n, r, a, i, o, l, s, c;
    Ed(1, arguments);
    var d = wd(e1), u = d.getUTCFullYear(), p = Sd(), m = xd(null !== (n = null !== (r = null !== (a = null !== (i = null == t ? void 0 : t.firstWeekContainsDate) && void 0 !== i ? i : null == t || null === (o = t.locale) || void 0 === o || null === (l = o.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== a ? a : p.firstWeekContainsDate) && void 0 !== r ? r : null === (s = p.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.firstWeekContainsDate) && void 0 !== n ? n : 1);
    if (!(m >= 1 && m <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var f = new Date(0);
    f.setUTCFullYear(u + 1, 0, m), f.setUTCHours(0, 0, 0, 0);
    var v = Ld(f, t), h = new Date(0);
    h.setUTCFullYear(u, 0, m), h.setUTCHours(0, 0, 0, 0);
    var g = Ld(h, t);
    return d.getTime() >= v.getTime() ? u + 1 : d.getTime() >= g.getTime() ? u : u - 1;
}
function zd(e1, t) {
    Ed(1, arguments);
    var n = wd(e1), r = Ld(n, t).getTime() - (function(e1, t) {
        var n, r, a, i, o, l, s, c;
        Ed(1, arguments);
        var d = Sd(), u = xd(null !== (n = null !== (r = null !== (a = null !== (i = null == t ? void 0 : t.firstWeekContainsDate) && void 0 !== i ? i : null == t || null === (o = t.locale) || void 0 === o || null === (l = o.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== a ? a : d.firstWeekContainsDate) && void 0 !== r ? r : null === (s = d.locale) || void 0 === s || null === (c = s.options) || void 0 === c ? void 0 : c.firstWeekContainsDate) && void 0 !== n ? n : 1), p = Id(e1, t), m = new Date(0);
        return m.setUTCFullYear(p, 0, u), m.setUTCHours(0, 0, 0, 0), Ld(m, t);
    })(n, t).getTime();
    return Math.round(r / 6048e5) + 1;
}
function Fd(e1, t) {
    for(var n = e1 < 0 ? "-" : "", r = Math.abs(e1).toString(); r.length < t;)r = "0" + r;
    return n + r;
}
var Dd = {
    y: function(e1, t) {
        var n = e1.getUTCFullYear(), r = n > 0 ? n : 1 - n;
        return Fd("yy" === t ? r % 100 : r, t.length);
    },
    M: function(e1, t) {
        var n = e1.getUTCMonth();
        return "M" === t ? String(n + 1) : Fd(n + 1, 2);
    },
    d: function(e1, t) {
        return Fd(e1.getUTCDate(), t.length);
    },
    a: function(e1, t) {
        var n = e1.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(t){
            case "a":
            case "aa":
                return n.toUpperCase();
            case "aaa":
                return n;
            case "aaaaa":
                return n[0];
            default:
                return "am" === n ? "a.m." : "p.m.";
        }
    },
    h: function(e1, t) {
        return Fd(e1.getUTCHours() % 12 || 12, t.length);
    },
    H: function(e1, t) {
        return Fd(e1.getUTCHours(), t.length);
    },
    m: function(e1, t) {
        return Fd(e1.getUTCMinutes(), t.length);
    },
    s: function(e1, t) {
        return Fd(e1.getUTCSeconds(), t.length);
    },
    S: function(e1, t) {
        var n = t.length, r = e1.getUTCMilliseconds();
        return Fd(Math.floor(r * Math.pow(10, n - 3)), t.length);
    }
}, Bd = "midnight", Ad = "noon", Wd = "morning", jd = "afternoon", Rd = "evening", $d = "night", Hd = {
    G: function(e1, t, n) {
        var r = e1.getUTCFullYear() > 0 ? 1 : 0;
        switch(t){
            case "G":
            case "GG":
            case "GGG":
                return n.era(r, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return n.era(r, {
                    width: "narrow"
                });
            default:
                return n.era(r, {
                    width: "wide"
                });
        }
    },
    y: function(e1, t, n) {
        if ("yo" === t) {
            var r = e1.getUTCFullYear(), a = r > 0 ? r : 1 - r;
            return n.ordinalNumber(a, {
                unit: "year"
            });
        }
        return Dd.y(e1, t);
    },
    Y: function(e1, t, n, r) {
        var a = Id(e1, r), i = a > 0 ? a : 1 - a;
        return "YY" === t ? Fd(i % 100, 2) : "Yo" === t ? n.ordinalNumber(i, {
            unit: "year"
        }) : Fd(i, t.length);
    },
    R: function(e1, t) {
        return Fd(Md(e1), t.length);
    },
    u: function(e1, t) {
        return Fd(e1.getUTCFullYear(), t.length);
    },
    Q: function(e1, t, n) {
        var r = Math.ceil((e1.getUTCMonth() + 1) / 3);
        switch(t){
            case "Q":
                return String(r);
            case "QQ":
                return Fd(r, 2);
            case "Qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "QQQ":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return n.quarter(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    q: function(e1, t, n) {
        var r = Math.ceil((e1.getUTCMonth() + 1) / 3);
        switch(t){
            case "q":
                return String(r);
            case "qq":
                return Fd(r, 2);
            case "qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "qqq":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return n.quarter(r, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    M: function(e1, t, n) {
        var r = e1.getUTCMonth();
        switch(t){
            case "M":
            case "MM":
                return Dd.M(e1, t);
            case "Mo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "MMM":
                return n.month(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return n.month(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n.month(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    L: function(e1, t, n) {
        var r = e1.getUTCMonth();
        switch(t){
            case "L":
                return String(r + 1);
            case "LL":
                return Fd(r + 1, 2);
            case "Lo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "LLL":
                return n.month(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return n.month(r, {
                    width: "narrow",
                    context: "standalone"
                });
            default:
                return n.month(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    w: function(e1, t, n, r) {
        var a = zd(e1, r);
        return "wo" === t ? n.ordinalNumber(a, {
            unit: "week"
        }) : Fd(a, t.length);
    },
    I: function(e1, t, n) {
        var r = Pd(e1);
        return "Io" === t ? n.ordinalNumber(r, {
            unit: "week"
        }) : Fd(r, t.length);
    },
    d: function(e1, t, n) {
        return "do" === t ? n.ordinalNumber(e1.getUTCDate(), {
            unit: "date"
        }) : Dd.d(e1, t);
    },
    D: function(e1, t, n) {
        var r = function(e1) {
            Ed(1, arguments);
            var t = wd(e1), n = t.getTime();
            t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
            var r = n - t.getTime();
            return Math.floor(r / 864e5) + 1;
        }(e1);
        return "Do" === t ? n.ordinalNumber(r, {
            unit: "dayOfYear"
        }) : Fd(r, t.length);
    },
    E: function(e1, t, n) {
        var r = e1.getUTCDay();
        switch(t){
            case "E":
            case "EE":
            case "EEE":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    e: function(e1, t, n, r) {
        var a = e1.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(t){
            case "e":
                return String(i);
            case "ee":
                return Fd(i, 2);
            case "eo":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "eee":
                return n.day(a, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return n.day(a, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return n.day(a, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n.day(a, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    c: function(e1, t, n, r) {
        var a = e1.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(t){
            case "c":
                return String(i);
            case "cc":
                return Fd(i, t.length);
            case "co":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "ccc":
                return n.day(a, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return n.day(a, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return n.day(a, {
                    width: "short",
                    context: "standalone"
                });
            default:
                return n.day(a, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    i: function(e1, t, n) {
        var r = e1.getUTCDay(), a = 0 === r ? 7 : r;
        switch(t){
            case "i":
                return String(a);
            case "ii":
                return Fd(a, t.length);
            case "io":
                return n.ordinalNumber(a, {
                    unit: "day"
                });
            case "iii":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    a: function(e1, t, n) {
        var r = e1.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(t){
            case "a":
            case "aa":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    b: function(e1, t, n) {
        var r, a = e1.getUTCHours();
        switch(r = 12 === a ? Ad : 0 === a ? Bd : a / 12 >= 1 ? "pm" : "am", t){
            case "b":
            case "bb":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    B: function(e1, t, n) {
        var r, a = e1.getUTCHours();
        switch(r = a >= 17 ? Rd : a >= 12 ? jd : a >= 4 ? Wd : $d, t){
            case "B":
            case "BB":
            case "BBB":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    h: function(e1, t, n) {
        if ("ho" === t) {
            var r = e1.getUTCHours() % 12;
            return 0 === r && (r = 12), n.ordinalNumber(r, {
                unit: "hour"
            });
        }
        return Dd.h(e1, t);
    },
    H: function(e1, t, n) {
        return "Ho" === t ? n.ordinalNumber(e1.getUTCHours(), {
            unit: "hour"
        }) : Dd.H(e1, t);
    },
    K: function(e1, t, n) {
        var r = e1.getUTCHours() % 12;
        return "Ko" === t ? n.ordinalNumber(r, {
            unit: "hour"
        }) : Fd(r, t.length);
    },
    k: function(e1, t, n) {
        var r = e1.getUTCHours();
        return 0 === r && (r = 24), "ko" === t ? n.ordinalNumber(r, {
            unit: "hour"
        }) : Fd(r, t.length);
    },
    m: function(e1, t, n) {
        return "mo" === t ? n.ordinalNumber(e1.getUTCMinutes(), {
            unit: "minute"
        }) : Dd.m(e1, t);
    },
    s: function(e1, t, n) {
        return "so" === t ? n.ordinalNumber(e1.getUTCSeconds(), {
            unit: "second"
        }) : Dd.s(e1, t);
    },
    S: function(e1, t) {
        return Dd.S(e1, t);
    },
    X: function(e1, t, n, r) {
        var a = (r._originalDate || e1).getTimezoneOffset();
        if (0 === a) return "Z";
        switch(t){
            case "X":
                return Ud(a);
            case "XXXX":
            case "XX":
                return Vd(a);
            default:
                return Vd(a, ":");
        }
    },
    x: function(e1, t, n, r) {
        var a = (r._originalDate || e1).getTimezoneOffset();
        switch(t){
            case "x":
                return Ud(a);
            case "xxxx":
            case "xx":
                return Vd(a);
            default:
                return Vd(a, ":");
        }
    },
    O: function(e1, t, n, r) {
        var a = (r._originalDate || e1).getTimezoneOffset();
        switch(t){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + Gd(a, ":");
            default:
                return "GMT" + Vd(a, ":");
        }
    },
    z: function(e1, t, n, r) {
        var a = (r._originalDate || e1).getTimezoneOffset();
        switch(t){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + Gd(a, ":");
            default:
                return "GMT" + Vd(a, ":");
        }
    },
    t: function(e1, t, n, r) {
        var a = r._originalDate || e1;
        return Fd(Math.floor(a.getTime() / 1e3), t.length);
    },
    T: function(e1, t, n, r) {
        return Fd((r._originalDate || e1).getTime(), t.length);
    }
};
function Gd(e1, t) {
    var n = e1 > 0 ? "-" : "+", r = Math.abs(e1), a = Math.floor(r / 60), i = r % 60;
    if (0 === i) return n + String(a);
    var o = t || "";
    return n + String(a) + o + Fd(i, 2);
}
function Ud(e1, t) {
    return e1 % 60 == 0 ? (e1 > 0 ? "-" : "+") + Fd(Math.abs(e1) / 60, 2) : Vd(e1, t);
}
function Vd(e1, t) {
    var n = t || "", r = e1 > 0 ? "-" : "+", a = Math.abs(e1);
    return r + Fd(Math.floor(a / 60), 2) + n + Fd(a % 60, 2);
}
var qd = (/* unused pure expression or super */ null && (Hd)), Yd = function(e1, t) {
    switch(e1){
        case "P":
            return t.date({
                width: "short"
            });
        case "PP":
            return t.date({
                width: "medium"
            });
        case "PPP":
            return t.date({
                width: "long"
            });
        default:
            return t.date({
                width: "full"
            });
    }
}, Xd = function(e1, t) {
    switch(e1){
        case "p":
            return t.time({
                width: "short"
            });
        case "pp":
            return t.time({
                width: "medium"
            });
        case "ppp":
            return t.time({
                width: "long"
            });
        default:
            return t.time({
                width: "full"
            });
    }
}, Kd = {
    p: Xd,
    P: function(e1, t) {
        var n, r = e1.match(/(P+)(p+)?/) || [], a = r[1], i = r[2];
        if (!i) return Yd(e1, t);
        switch(a){
            case "P":
                n = t.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                n = t.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                n = t.dateTime({
                    width: "long"
                });
                break;
            default:
                n = t.dateTime({
                    width: "full"
                });
        }
        return n.replace("{{date}}", Yd(a, t)).replace("{{time}}", Xd(i, t));
    }
}, Qd = (/* unused pure expression or super */ null && (Kd)), Jd = (/* unused pure expression or super */ null && ([
    "D",
    "DD"
])), Zd = (/* unused pure expression or super */ null && ([
    "YY",
    "YYYY"
]));
function eu(e1, t, n) {
    if ("YYYY" === e1) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("YY" === e1) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("D" === e1) throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if ("DD" === e1) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var tu = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
}, nu = function(e1, t, n) {
    var r, a = tu[e1];
    return r = "string" == typeof a ? a : 1 === t ? a.one : a.other.replace("{{count}}", t.toString()), null != n && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ru(e1) {
    return function() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.width ? String(t.width) : e1.defaultWidth;
        return e1.formats[n] || e1.formats[e1.defaultWidth];
    };
}
var au = {
    date: ru({
        formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
        },
        defaultWidth: "full"
    }),
    time: ru({
        formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
        },
        defaultWidth: "full"
    }),
    dateTime: ru({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
        },
        defaultWidth: "full"
    })
}, iu = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
}, ou = function(e1, t, n, r) {
    return iu[e1];
};
function lu(e1) {
    return function(t, n) {
        var r;
        if ("formatting" === (null != n && n.context ? String(n.context) : "standalone") && e1.formattingValues) {
            var a = e1.defaultFormattingWidth || e1.defaultWidth, i = null != n && n.width ? String(n.width) : a;
            r = e1.formattingValues[i] || e1.formattingValues[a];
        } else {
            var o = e1.defaultWidth, l = null != n && n.width ? String(n.width) : e1.defaultWidth;
            r = e1.values[l] || e1.values[o];
        }
        return r[e1.argumentCallback ? e1.argumentCallback(t) : t];
    };
}
var su = {
    ordinalNumber: function(e1, t) {
        var n = Number(e1), r = n % 100;
        if (r > 20 || r < 10) switch(r % 10){
            case 1:
                return n + "st";
            case 2:
                return n + "nd";
            case 3:
                return n + "rd";
        }
        return n + "th";
    },
    era: lu({
        values: {
            narrow: [
                "B",
                "A"
            ],
            abbreviated: [
                "BC",
                "AD"
            ],
            wide: [
                "Before Christ",
                "Anno Domini"
            ]
        },
        defaultWidth: "wide"
    }),
    quarter: lu({
        values: {
            narrow: [
                "1",
                "2",
                "3",
                "4"
            ],
            abbreviated: [
                "Q1",
                "Q2",
                "Q3",
                "Q4"
            ],
            wide: [
                "1st quarter",
                "2nd quarter",
                "3rd quarter",
                "4th quarter"
            ]
        },
        defaultWidth: "wide",
        argumentCallback: function(e1) {
            return e1 - 1;
        }
    }),
    month: lu({
        values: {
            narrow: [
                "J",
                "F",
                "M",
                "A",
                "M",
                "J",
                "J",
                "A",
                "S",
                "O",
                "N",
                "D"
            ],
            abbreviated: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            wide: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ]
        },
        defaultWidth: "wide"
    }),
    day: lu({
        values: {
            narrow: [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
            ],
            short: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            abbreviated: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            wide: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        },
        defaultWidth: "wide"
    }),
    dayPeriod: lu({
        values: {
            narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            },
            abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            },
            wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
            }
        },
        defaultWidth: "wide",
        formattingValues: {
            narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            },
            abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            },
            wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
            }
        },
        defaultFormattingWidth: "wide"
    })
};
function cu(e1) {
    return function(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = n.width, a = r && e1.matchPatterns[r] || e1.matchPatterns[e1.defaultMatchWidth], i = t.match(a);
        if (!i) return null;
        var o, l = i[0], s = r && e1.parsePatterns[r] || e1.parsePatterns[e1.defaultParseWidth], c = Array.isArray(s) ? function(e1, t) {
            for(var n = 0; n < e1.length; n++)if (t(e1[n])) return n;
            return;
        }(s, function(e1) {
            return e1.test(l);
        }) : function(e1, t) {
            for(var n in e1)if (e1.hasOwnProperty(n) && t(e1[n])) return n;
            return;
        }(s, function(e1) {
            return e1.test(l);
        });
        return o = e1.valueCallback ? e1.valueCallback(c) : c, {
            value: o = n.valueCallback ? n.valueCallback(o) : o,
            rest: t.slice(l.length)
        };
    };
}
var du, uu = {
    ordinalNumber: (du = {
        matchPattern: /^(\d+)(th|st|nd|rd)?/i,
        parsePattern: /\d+/i,
        valueCallback: function(e1) {
            return parseInt(e1, 10);
        }
    }, function(e1) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = e1.match(du.matchPattern);
        if (!n) return null;
        var r = n[0], a = e1.match(du.parsePattern);
        if (!a) return null;
        var i = du.valueCallback ? du.valueCallback(a[0]) : a[0];
        return {
            value: i = t.valueCallback ? t.valueCallback(i) : i,
            rest: e1.slice(r.length)
        };
    }),
    era: cu({
        matchPatterns: {
            narrow: /^(b|a)/i,
            abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
            wide: /^(before christ|before common era|anno domini|common era)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            any: [
                /^b/i,
                /^(a|c)/i
            ]
        },
        defaultParseWidth: "any"
    }),
    quarter: cu({
        matchPatterns: {
            narrow: /^[1234]/i,
            abbreviated: /^q[1234]/i,
            wide: /^[1234](th|st|nd|rd)? quarter/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            any: [
                /1/i,
                /2/i,
                /3/i,
                /4/i
            ]
        },
        defaultParseWidth: "any",
        valueCallback: function(e1) {
            return e1 + 1;
        }
    }),
    month: cu({
        matchPatterns: {
            narrow: /^[jfmasond]/i,
            abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
            wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            narrow: [
                /^j/i,
                /^f/i,
                /^m/i,
                /^a/i,
                /^m/i,
                /^j/i,
                /^j/i,
                /^a/i,
                /^s/i,
                /^o/i,
                /^n/i,
                /^d/i
            ],
            any: [
                /^ja/i,
                /^f/i,
                /^mar/i,
                /^ap/i,
                /^may/i,
                /^jun/i,
                /^jul/i,
                /^au/i,
                /^s/i,
                /^o/i,
                /^n/i,
                /^d/i
            ]
        },
        defaultParseWidth: "any"
    }),
    day: cu({
        matchPatterns: {
            narrow: /^[smtwf]/i,
            short: /^(su|mo|tu|we|th|fr|sa)/i,
            abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
            wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
        },
        defaultMatchWidth: "wide",
        parsePatterns: {
            narrow: [
                /^s/i,
                /^m/i,
                /^t/i,
                /^w/i,
                /^t/i,
                /^f/i,
                /^s/i
            ],
            any: [
                /^su/i,
                /^m/i,
                /^tu/i,
                /^w/i,
                /^th/i,
                /^f/i,
                /^sa/i
            ]
        },
        defaultParseWidth: "any"
    }),
    dayPeriod: cu({
        matchPatterns: {
            narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
            any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
        },
        defaultMatchWidth: "any",
        parsePatterns: {
            any: {
                am: /^a/i,
                pm: /^p/i,
                midnight: /^mi/i,
                noon: /^no/i,
                morning: /morning/i,
                afternoon: /afternoon/i,
                evening: /evening/i,
                night: /night/i
            }
        },
        defaultParseWidth: "any"
    })
}, pu = {
    code: "en-US",
    formatDistance: nu,
    formatLong: au,
    formatRelative: ou,
    localize: su,
    match: uu,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
}, mu = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, fu = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vu = /^'([^]*?)'?$/, hu = /''/g, gu = /[a-zA-Z]/;
function bu(e1, t, n) {
    var r, a, i, o, l, s, c, d, u, p, m, f, v, h, g, b, y, x;
    Ed(2, arguments);
    var E = String(t), w = Sd(), C = null !== (r = null !== (a = null == n ? void 0 : n.locale) && void 0 !== a ? a : w.locale) && void 0 !== r ? r : pu, S = xd(null !== (i = null !== (o = null !== (l = null !== (s = null == n ? void 0 : n.firstWeekContainsDate) && void 0 !== s ? s : null == n || null === (c = n.locale) || void 0 === c || null === (d = c.options) || void 0 === d ? void 0 : d.firstWeekContainsDate) && void 0 !== l ? l : w.firstWeekContainsDate) && void 0 !== o ? o : null === (u = w.locale) || void 0 === u || null === (p = u.options) || void 0 === p ? void 0 : p.firstWeekContainsDate) && void 0 !== i ? i : 1);
    if (!(S >= 1 && S <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var T = xd(null !== (m = null !== (f = null !== (v = null !== (h = null == n ? void 0 : n.weekStartsOn) && void 0 !== h ? h : null == n || null === (g = n.locale) || void 0 === g || null === (b = g.options) || void 0 === b ? void 0 : b.weekStartsOn) && void 0 !== v ? v : w.weekStartsOn) && void 0 !== f ? f : null === (y = w.locale) || void 0 === y || null === (x = y.options) || void 0 === x ? void 0 : x.weekStartsOn) && void 0 !== m ? m : 0);
    if (!(T >= 0 && T <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!C.localize) throw new RangeError("locale must contain localize property");
    if (!C.formatLong) throw new RangeError("locale must contain formatLong property");
    var N = wd(e1);
    if (!kd(N)) throw new RangeError("Invalid time value");
    var k = function(e1) {
        var t = new Date(Date.UTC(e1.getFullYear(), e1.getMonth(), e1.getDate(), e1.getHours(), e1.getMinutes(), e1.getSeconds(), e1.getMilliseconds()));
        return t.setUTCFullYear(e1.getFullYear()), e1.getTime() - t.getTime();
    }(N), _ = _d(N, k), O = {
        firstWeekContainsDate: S,
        weekStartsOn: T,
        locale: C,
        _originalDate: N
    };
    return E.match(fu).map(function(e1) {
        var t = e1[0];
        return "p" === t || "P" === t ? (0, Qd[t])(e1, C.formatLong) : e1;
    }).join("").match(mu).map(function(r) {
        if ("''" === r) return "'";
        var a = r[0];
        if ("'" === a) return function(e1) {
            var t = e1.match(vu);
            if (!t) return e1;
            return t[1].replace(hu, "'");
        }(r);
        var i, o = qd[a];
        if (o) return null != n && n.useAdditionalWeekYearTokens || (i = r, -1 === Zd.indexOf(i)) || eu(r, t, String(e1)), null != n && n.useAdditionalDayOfYearTokens || !function(e1) {
            return -1 !== Jd.indexOf(e1);
        }(r) || eu(r, t, String(e1)), o(_, r, C.localize, O);
        if (a.match(gu)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + a + "`");
        return r;
    }).join("");
}
function yu(e1, t) {
    var n;
    Ed(1, arguments);
    var r = xd(null !== (n = null == t ? void 0 : t.additionalDigits) && void 0 !== n ? n : 2);
    if (2 !== r && 1 !== r && 0 !== r) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if ("string" != typeof e1 && "[object String]" !== Object.prototype.toString.call(e1)) return new Date(NaN);
    var a, i = function(e1) {
        var t, n = {}, r = e1.split(xu.dateTimeDelimiter);
        if (r.length > 2) return n;
        /:/.test(r[0]) ? t = r[0] : (n.date = r[0], t = r[1], xu.timeZoneDelimiter.test(n.date) && (n.date = e1.split(xu.timeZoneDelimiter)[0], t = e1.substr(n.date.length, e1.length)));
        if (t) {
            var a = xu.timezone.exec(t);
            a ? (n.time = t.replace(a[1], ""), n.timezone = a[1]) : n.time = t;
        }
        return n;
    }(e1);
    if (i.date) {
        var o = function(e1, t) {
            var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e1.match(n);
            if (!r) return {
                year: NaN,
                restDateString: ""
            };
            var a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
            return {
                year: null === i ? a : 100 * i,
                restDateString: e1.slice((r[1] || r[2]).length)
            };
        }(i.date, r);
        a = function(e1, t) {
            if (null === t) return new Date(NaN);
            var n = e1.match(Eu);
            if (!n) return new Date(NaN);
            var r = !!n[4], a = Su(n[1]), i = Su(n[2]) - 1, o = Su(n[3]), l = Su(n[4]), s = Su(n[5]) - 1;
            if (r) return function(e1, t, n) {
                return t >= 1 && t <= 53 && n >= 0 && n <= 6;
            }(0, l, s) ? function(e1, t, n) {
                var r = new Date(0);
                r.setUTCFullYear(e1, 0, 4);
                var a = r.getUTCDay() || 7, i = 7 * (t - 1) + n + 1 - a;
                return r.setUTCDate(r.getUTCDate() + i), r;
            }(t, l, s) : new Date(NaN);
            var c = new Date(0);
            return function(e1, t, n) {
                return t >= 0 && t <= 11 && n >= 1 && n <= (Nu[t] || (ku(e1) ? 29 : 28));
            }(t, i, o) && function(e1, t) {
                return t >= 1 && t <= (ku(e1) ? 366 : 365);
            }(t, a) ? (c.setUTCFullYear(t, i, Math.max(a, o)), c) : new Date(NaN);
        }(o.restDateString, o.year);
    }
    if (!a || isNaN(a.getTime())) return new Date(NaN);
    var l, s = a.getTime(), c = 0;
    if (i.time && (c = function(e1) {
        var t = e1.match(wu);
        if (!t) return NaN;
        var n = Tu(t[1]), r = Tu(t[2]), a = Tu(t[3]);
        if (!function(e1, t, n) {
            if (24 === e1) return 0 === t && 0 === n;
            return n >= 0 && n < 60 && t >= 0 && t < 60 && e1 >= 0 && e1 < 25;
        }(n, r, a)) return NaN;
        return n * Nd + r * Td + 1e3 * a;
    }(i.time), isNaN(c))) return new Date(NaN);
    if (!i.timezone) {
        var d = new Date(s + c), u = new Date(0);
        return u.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), u.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), u;
    }
    return l = function(e1) {
        if ("Z" === e1) return 0;
        var t = e1.match(Cu);
        if (!t) return 0;
        var n = "+" === t[1] ? -1 : 1, r = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
        if (!function(e1, t) {
            return t >= 0 && t <= 59;
        }(0, a)) return NaN;
        return n * (r * Nd + a * Td);
    }(i.timezone), isNaN(l) ? new Date(NaN) : new Date(s + c + l);
}
var xu = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
}, Eu = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, wu = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Cu = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Su(e1) {
    return e1 ? parseInt(e1) : 1;
}
function Tu(e1) {
    return e1 && parseFloat(e1.replace(",", ".")) || 0;
}
var Nu = (/* unused pure expression or super */ null && ([
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]));
function ku(e1) {
    return e1 % 400 == 0 || e1 % 4 == 0 && e1 % 100 != 0;
}
var _u = "card-with-image-module_title", Ou = "card-with-image-module_article", Mu = "card-with-image-module_date", Pu = "card-with-image-module_image", Lu = "card-with-image-module_body", Iu = "card-with-image-module_imageContainer", zu = function(e1) {
    var n = e1.headline, r = e1.date, a = e1.body, i = e1.image, o = e1.classNames;
    return /*#__PURE__*/ t.createElement("article", {
        "data-testid": "card-with-image",
        className: C(Ou, o.article)
    }, /*#__PURE__*/ t.createElement("div", {
        className: Iu
    }, /*#__PURE__*/ t.cloneElement(i, {
        className: Pu
    })), /*#__PURE__*/ t.createElement("div", {
        className: o.metaContainer
    }, r && /*#__PURE__*/ t.createElement(ke, {
        type: Ee.caption,
        element: "div",
        className: C(Mu, o.date),
        "data-published": r
    }, bu(yu(r), "MMM d yyyy")), /*#__PURE__*/ t.createElement(ke, {
        type: Ee.mainTitle,
        element: "h3",
        className: C(_u, o.title),
        lineHeight: "display"
    }, n), /*#__PURE__*/ t.createElement(ke, {
        type: Ee.body2,
        element: "p",
        className: C(Lu, o.body)
    }, a)));
};



/***/ }),

/***/ 65301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(75291)["Buffer"];
/* provided dependency */ var process = __webpack_require__(13158);
(function(){var e={7160:function(e,t,r){var i=t;i.bignum=r(711);i.define=r(495).define;i.base=r(853);i.constants=r(7335);i.decoders=r(6701);i.encoders=r(3418)},495:function(e,t,r){var i=r(7160);var n=r(3782);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},6483:function(e,t,r){var i=r(3782);var n=r(853).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},853:function(e,t,r){var i=t;i.Reporter=r(1293).b;i.DecoderBuffer=r(6483).C;i.EncoderBuffer=r(6483).R;i.Node=r(9374)},9374:function(e,t,r){var i=r(853).Reporter;var n=r(853).EncoderBuffer;var a=r(853).DecoderBuffer;var s=r(3523);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var h=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var u=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;h.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};u.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var h=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(h)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var u;if(r.obj&&n)u=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var h=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(h);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(u);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var h=o._decode(e,t);if(e.isError(h))return false;i={type:a,value:h};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var h=this.clone();h._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),h))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var u=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(u===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(u,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},1293:function(e,t,r){var i=r(3782);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},9791:function(e,t,r){var i=r(7335);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},7335:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(9791)},2259:function(e,t,r){var i=r(3782);var n=r(7160);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var h=n[0]%40;if(r)i=n;else i=[o,h].concat(n.slice(1));if(t){var u=t[i.join(" ")];if(u===undefined)u=t[i.join(".")];if(u!==undefined)i=u}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var h=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var h=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,h,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},6701:function(e,t,r){var i=t;i.der=r(2259);i.pem=r(8527)},8527:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(2259);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var h=-1;for(var u=0;u<r.length;u++){var d=r[u].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=u}else{if(d[1]!=="END")break;h=u;break}}if(o===-1||h===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,h).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},7804:function(e,t,r){var i=r(3782);var n=r(4300).Buffer;var a=r(7160);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var h=i.length;h>=256;h>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var h=1+o,u=i.length;u>0;h--,u>>=8)s[h]=u&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var h=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[h--]=s&127;while((s>>=7)>0)o[h--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},3418:function(e,t,r){var i=t;i.der=r(7804);i.pem=r(1564)},1564:function(e,t,r){var i=r(3782);var n=r(7804);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},711:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,h;var u=this.clone();if(!a){for(h=0;h<n-i;h++){s[h]=0}for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[n-h-1]=o}}else{for(h=0;!u.isZero();h++){o=u.andln(255);u.iushrn(8);s[h]=o}for(;h<n;h++){s[h]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},1670:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var h;if(o>=49&&o<=54){h=o-49+10}else if(o>=17&&o<=22){h=o-17+10}else{h=o}i|=h;a|=h}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var h=e.charCodeAt(o)-48;n*=i;if(h>=49){a=h-49+10}else if(h>=17){a=h-17+10}else{a=h}assert(h>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var h=0;for(var u=r;u<o;u+=i){h=parseBase(e,u,u+i,t);this.imuln(n);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}if(s!==0){var d=1;h=parseBase(e,u,e.length,t);for(u=0;u<s;u++){d*=t}this.imuln(d);if(this.words[0]+h<67108864){this.words[0]+=h}else{this._iaddn(h)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var h=0;h<this.length;h++){var u=this.words[h];var d=((u<<i|o)&16777215).toString(16);o=u>>>24-i&16777215;if(o!==0||h!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;h--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var v=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-v.length]+v+r}else{r=v+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var h=s/67108864|0;r.words[0]=o;for(var u=1;u<i;u++){var d=h>>>26;var c=h&67108863;var l=Math.min(u,t.length-1);for(var p=Math.max(0,u-e.length+1);p<=l;p++){var v=u-p|0;n=e.words[v]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[u]=c|0;h=d|0}if(h!==0){r.words[u]=h|0}else{r.length--}return r._strip()}var h=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var h;var u;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var v=p&8191;var b=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var B=i[4]|0;var E=B&8191;var k=B>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var I=x&8191;var C=x>>>13;var D=i[7]|0;var T=D&8191;var j=D>>>13;var q=i[8]|0;var O=q&8191;var H=q>>>13;var L=i[9]|0;var z=L&8191;var F=L>>>13;var U=n[0]|0;var W=U&8191;var V=U>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var fe=ae&8191;var se=ae>>>13;var oe=n[6]|0;var he=oe&8191;var ue=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var ve=pe&8191;var be=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);h=Math.imul(c,V);h=h+Math.imul(l,W)|0;u=Math.imul(l,V);var _e=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(v,W);h=Math.imul(v,V);h=h+Math.imul(b,W)|0;u=Math.imul(b,V);o=o+Math.imul(c,J)|0;h=h+Math.imul(c,Z)|0;h=h+Math.imul(l,J)|0;u=u+Math.imul(l,Z)|0;var we=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);h=Math.imul(y,V);h=h+Math.imul(g,W)|0;u=Math.imul(g,V);o=o+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;h=h+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;o=o+Math.imul(c,Y)|0;h=h+Math.imul(c,$)|0;h=h+Math.imul(l,Y)|0;u=u+Math.imul(l,$)|0;var Me=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);h=Math.imul(w,V);h=h+Math.imul(M,W)|0;u=Math.imul(M,V);o=o+Math.imul(y,J)|0;h=h+Math.imul(y,Z)|0;h=h+Math.imul(g,J)|0;u=u+Math.imul(g,Z)|0;o=o+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;h=h+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;o=o+Math.imul(c,ee)|0;h=h+Math.imul(c,te)|0;h=h+Math.imul(l,ee)|0;u=u+Math.imul(l,te)|0;var Se=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(E,W);h=Math.imul(E,V);h=h+Math.imul(k,W)|0;u=Math.imul(k,V);o=o+Math.imul(w,J)|0;h=h+Math.imul(w,Z)|0;h=h+Math.imul(M,J)|0;u=u+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;h=h+Math.imul(y,$)|0;h=h+Math.imul(g,Y)|0;u=u+Math.imul(g,$)|0;o=o+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;h=h+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;o=o+Math.imul(c,ie)|0;h=h+Math.imul(c,ne)|0;h=h+Math.imul(l,ie)|0;u=u+Math.imul(l,ne)|0;var Be=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(N,W);h=Math.imul(N,V);h=h+Math.imul(P,W)|0;u=Math.imul(P,V);o=o+Math.imul(E,J)|0;h=h+Math.imul(E,Z)|0;h=h+Math.imul(k,J)|0;u=u+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;h=h+Math.imul(w,$)|0;h=h+Math.imul(M,Y)|0;u=u+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;h=h+Math.imul(y,te)|0;h=h+Math.imul(g,ee)|0;u=u+Math.imul(g,te)|0;o=o+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;h=h+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;o=o+Math.imul(c,fe)|0;h=h+Math.imul(c,se)|0;h=h+Math.imul(l,fe)|0;u=u+Math.imul(l,se)|0;var Ee=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(I,W);h=Math.imul(I,V);h=h+Math.imul(C,W)|0;u=Math.imul(C,V);o=o+Math.imul(N,J)|0;h=h+Math.imul(N,Z)|0;h=h+Math.imul(P,J)|0;u=u+Math.imul(P,Z)|0;o=o+Math.imul(E,Y)|0;h=h+Math.imul(E,$)|0;h=h+Math.imul(k,Y)|0;u=u+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;h=h+Math.imul(w,te)|0;h=h+Math.imul(M,ee)|0;u=u+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;h=h+Math.imul(y,ne)|0;h=h+Math.imul(g,ie)|0;u=u+Math.imul(g,ne)|0;o=o+Math.imul(v,fe)|0;h=h+Math.imul(v,se)|0;h=h+Math.imul(b,fe)|0;u=u+Math.imul(b,se)|0;o=o+Math.imul(c,he)|0;h=h+Math.imul(c,ue)|0;h=h+Math.imul(l,he)|0;u=u+Math.imul(l,ue)|0;var ke=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(T,W);h=Math.imul(T,V);h=h+Math.imul(j,W)|0;u=Math.imul(j,V);o=o+Math.imul(I,J)|0;h=h+Math.imul(I,Z)|0;h=h+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;o=o+Math.imul(N,Y)|0;h=h+Math.imul(N,$)|0;h=h+Math.imul(P,Y)|0;u=u+Math.imul(P,$)|0;o=o+Math.imul(E,ee)|0;h=h+Math.imul(E,te)|0;h=h+Math.imul(k,ee)|0;u=u+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;h=h+Math.imul(w,ne)|0;h=h+Math.imul(M,ie)|0;u=u+Math.imul(M,ne)|0;o=o+Math.imul(y,fe)|0;h=h+Math.imul(y,se)|0;h=h+Math.imul(g,fe)|0;u=u+Math.imul(g,se)|0;o=o+Math.imul(v,he)|0;h=h+Math.imul(v,ue)|0;h=h+Math.imul(b,he)|0;u=u+Math.imul(b,ue)|0;o=o+Math.imul(c,ce)|0;h=h+Math.imul(c,le)|0;h=h+Math.imul(l,ce)|0;u=u+Math.imul(l,le)|0;var Ae=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(O,W);h=Math.imul(O,V);h=h+Math.imul(H,W)|0;u=Math.imul(H,V);o=o+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;h=h+Math.imul(j,J)|0;u=u+Math.imul(j,Z)|0;o=o+Math.imul(I,Y)|0;h=h+Math.imul(I,$)|0;h=h+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;o=o+Math.imul(N,ee)|0;h=h+Math.imul(N,te)|0;h=h+Math.imul(P,ee)|0;u=u+Math.imul(P,te)|0;o=o+Math.imul(E,ie)|0;h=h+Math.imul(E,ne)|0;h=h+Math.imul(k,ie)|0;u=u+Math.imul(k,ne)|0;o=o+Math.imul(w,fe)|0;h=h+Math.imul(w,se)|0;h=h+Math.imul(M,fe)|0;u=u+Math.imul(M,se)|0;o=o+Math.imul(y,he)|0;h=h+Math.imul(y,ue)|0;h=h+Math.imul(g,he)|0;u=u+Math.imul(g,ue)|0;o=o+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;h=h+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;o=o+Math.imul(c,ve)|0;h=h+Math.imul(c,be)|0;h=h+Math.imul(l,ve)|0;u=u+Math.imul(l,be)|0;var Ne=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(z,W);h=Math.imul(z,V);h=h+Math.imul(F,W)|0;u=Math.imul(F,V);o=o+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;h=h+Math.imul(H,J)|0;u=u+Math.imul(H,Z)|0;o=o+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;h=h+Math.imul(j,Y)|0;u=u+Math.imul(j,$)|0;o=o+Math.imul(I,ee)|0;h=h+Math.imul(I,te)|0;h=h+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;o=o+Math.imul(N,ie)|0;h=h+Math.imul(N,ne)|0;h=h+Math.imul(P,ie)|0;u=u+Math.imul(P,ne)|0;o=o+Math.imul(E,fe)|0;h=h+Math.imul(E,se)|0;h=h+Math.imul(k,fe)|0;u=u+Math.imul(k,se)|0;o=o+Math.imul(w,he)|0;h=h+Math.imul(w,ue)|0;h=h+Math.imul(M,he)|0;u=u+Math.imul(M,ue)|0;o=o+Math.imul(y,ce)|0;h=h+Math.imul(y,le)|0;h=h+Math.imul(g,ce)|0;u=u+Math.imul(g,le)|0;o=o+Math.imul(v,ve)|0;h=h+Math.imul(v,be)|0;h=h+Math.imul(b,ve)|0;u=u+Math.imul(b,be)|0;o=o+Math.imul(c,ye)|0;h=h+Math.imul(c,ge)|0;h=h+Math.imul(l,ye)|0;u=u+Math.imul(l,ge)|0;var Re=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(z,J);h=Math.imul(z,Z);h=h+Math.imul(F,J)|0;u=Math.imul(F,Z);o=o+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;h=h+Math.imul(H,Y)|0;u=u+Math.imul(H,$)|0;o=o+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;h=h+Math.imul(j,ee)|0;u=u+Math.imul(j,te)|0;o=o+Math.imul(I,ie)|0;h=h+Math.imul(I,ne)|0;h=h+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;o=o+Math.imul(N,fe)|0;h=h+Math.imul(N,se)|0;h=h+Math.imul(P,fe)|0;u=u+Math.imul(P,se)|0;o=o+Math.imul(E,he)|0;h=h+Math.imul(E,ue)|0;h=h+Math.imul(k,he)|0;u=u+Math.imul(k,ue)|0;o=o+Math.imul(w,ce)|0;h=h+Math.imul(w,le)|0;h=h+Math.imul(M,ce)|0;u=u+Math.imul(M,le)|0;o=o+Math.imul(y,ve)|0;h=h+Math.imul(y,be)|0;h=h+Math.imul(g,ve)|0;u=u+Math.imul(g,be)|0;o=o+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;h=h+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;var Pe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(z,Y);h=Math.imul(z,$);h=h+Math.imul(F,Y)|0;u=Math.imul(F,$);o=o+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;h=h+Math.imul(H,ee)|0;u=u+Math.imul(H,te)|0;o=o+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;h=h+Math.imul(j,ie)|0;u=u+Math.imul(j,ne)|0;o=o+Math.imul(I,fe)|0;h=h+Math.imul(I,se)|0;h=h+Math.imul(C,fe)|0;u=u+Math.imul(C,se)|0;o=o+Math.imul(N,he)|0;h=h+Math.imul(N,ue)|0;h=h+Math.imul(P,he)|0;u=u+Math.imul(P,ue)|0;o=o+Math.imul(E,ce)|0;h=h+Math.imul(E,le)|0;h=h+Math.imul(k,ce)|0;u=u+Math.imul(k,le)|0;o=o+Math.imul(w,ve)|0;h=h+Math.imul(w,be)|0;h=h+Math.imul(M,ve)|0;u=u+Math.imul(M,be)|0;o=o+Math.imul(y,ye)|0;h=h+Math.imul(y,ge)|0;h=h+Math.imul(g,ye)|0;u=u+Math.imul(g,ge)|0;var xe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(z,ee);h=Math.imul(z,te);h=h+Math.imul(F,ee)|0;u=Math.imul(F,te);o=o+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;h=h+Math.imul(H,ie)|0;u=u+Math.imul(H,ne)|0;o=o+Math.imul(T,fe)|0;h=h+Math.imul(T,se)|0;h=h+Math.imul(j,fe)|0;u=u+Math.imul(j,se)|0;o=o+Math.imul(I,he)|0;h=h+Math.imul(I,ue)|0;h=h+Math.imul(C,he)|0;u=u+Math.imul(C,ue)|0;o=o+Math.imul(N,ce)|0;h=h+Math.imul(N,le)|0;h=h+Math.imul(P,ce)|0;u=u+Math.imul(P,le)|0;o=o+Math.imul(E,ve)|0;h=h+Math.imul(E,be)|0;h=h+Math.imul(k,ve)|0;u=u+Math.imul(k,be)|0;o=o+Math.imul(w,ye)|0;h=h+Math.imul(w,ge)|0;h=h+Math.imul(M,ye)|0;u=u+Math.imul(M,ge)|0;var Ie=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(z,ie);h=Math.imul(z,ne);h=h+Math.imul(F,ie)|0;u=Math.imul(F,ne);o=o+Math.imul(O,fe)|0;h=h+Math.imul(O,se)|0;h=h+Math.imul(H,fe)|0;u=u+Math.imul(H,se)|0;o=o+Math.imul(T,he)|0;h=h+Math.imul(T,ue)|0;h=h+Math.imul(j,he)|0;u=u+Math.imul(j,ue)|0;o=o+Math.imul(I,ce)|0;h=h+Math.imul(I,le)|0;h=h+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;o=o+Math.imul(N,ve)|0;h=h+Math.imul(N,be)|0;h=h+Math.imul(P,ve)|0;u=u+Math.imul(P,be)|0;o=o+Math.imul(E,ye)|0;h=h+Math.imul(E,ge)|0;h=h+Math.imul(k,ye)|0;u=u+Math.imul(k,ge)|0;var Ce=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(z,fe);h=Math.imul(z,se);h=h+Math.imul(F,fe)|0;u=Math.imul(F,se);o=o+Math.imul(O,he)|0;h=h+Math.imul(O,ue)|0;h=h+Math.imul(H,he)|0;u=u+Math.imul(H,ue)|0;o=o+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;h=h+Math.imul(j,ce)|0;u=u+Math.imul(j,le)|0;o=o+Math.imul(I,ve)|0;h=h+Math.imul(I,be)|0;h=h+Math.imul(C,ve)|0;u=u+Math.imul(C,be)|0;o=o+Math.imul(N,ye)|0;h=h+Math.imul(N,ge)|0;h=h+Math.imul(P,ye)|0;u=u+Math.imul(P,ge)|0;var De=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(z,he);h=Math.imul(z,ue);h=h+Math.imul(F,he)|0;u=Math.imul(F,ue);o=o+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;h=h+Math.imul(H,ce)|0;u=u+Math.imul(H,le)|0;o=o+Math.imul(T,ve)|0;h=h+Math.imul(T,be)|0;h=h+Math.imul(j,ve)|0;u=u+Math.imul(j,be)|0;o=o+Math.imul(I,ye)|0;h=h+Math.imul(I,ge)|0;h=h+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;var Te=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(z,ce);h=Math.imul(z,le);h=h+Math.imul(F,ce)|0;u=Math.imul(F,le);o=o+Math.imul(O,ve)|0;h=h+Math.imul(O,be)|0;h=h+Math.imul(H,ve)|0;u=u+Math.imul(H,be)|0;o=o+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;h=h+Math.imul(j,ye)|0;u=u+Math.imul(j,ge)|0;var je=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(z,ve);h=Math.imul(z,be);h=h+Math.imul(F,ve)|0;u=Math.imul(F,be);o=o+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;h=h+Math.imul(H,ye)|0;u=u+Math.imul(H,ge)|0;var qe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(qe>>>26)|0;qe&=67108863;o=Math.imul(z,ye);h=Math.imul(z,ge);h=h+Math.imul(F,ye)|0;u=Math.imul(F,ge);var Oe=(s+o|0)+((h&8191)<<13)|0;s=(u+(h>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Be;a[5]=Ee;a[6]=ke;a[7]=Ae;a[8]=Ne;a[9]=Re;a[10]=Pe;a[11]=xe;a[12]=Ie;a[13]=Ce;a[14]=De;a[15]=Te;a[16]=je;a[17]=qe;a[18]=Oe;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){h=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var h=Math.min(a,t.length-1);for(var u=Math.max(0,a-e.length+1);u<=h;u++){var d=a-u;var c=e.words[d]|0;var l=t.words[u]|0;var p=c*l;var v=p&67108863;s=s+(p/67108864|0)|0;v=v+o|0;o=v&67108863;s=s+(v>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=h(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var h=Math.cos(2*Math.PI/o);var u=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=h;var l=u;for(var p=0;p<s;p++){var v=r[d+p];var b=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=v+m;i[d+p]=b+y;r[d+p+s]=v-m;i[d+p+s]=b-y;if(p!==o){g=h*c-u*l;l=h*l+u*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var h=new Array(i);var u=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,u,i);this.transform(s,a,o,h,i,n);this.transform(u,a,d,c,i,n);for(var p=0;p<i;p++){var v=o[p]*d[p]-h[p]*c[p];h[p]=o[p]*c[p]+h[p]*d[p];o[p]=v}this.conjugate(o,h,i);this.transform(o,h,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var h=0;h<a;h++){o.words[h]=this.words[h]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(h=0;h<this.length;h++){this.words[h]=this.words[h+a]}}else{this.words[0]=0;this.length=1}var u=0;for(h=this.length-1;h>=0&&(u!==0||h>=i);h--){var d=this.words[h]|0;this.words[h]=u<<26-n|d>>>n;u=d&s}if(o&&u!==0){o.words[o.length++]=u}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var h;if(t!=="mod"){h=new BN(null);h.length=o+1;h.words=new Array(h.length);for(var u=0;u<h.length;u++){h.words[u]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(h){h.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(h){h.words[c]=l}}if(h){h._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:h||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var h=r.clone();var u=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(h);n.isub(u)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(h);s.isub(u)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var h=0,u=1;(r.words[0]&u)===0&&h<26;++h,u<<=1);if(h>0){r.iushrn(h);while(h-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var h=this.m.bitLength();h=new BN(2*h*h).toRed(this);while(this.pow(h,o).cmp(s)!==0){h.redIAdd(s)}var u=this.pow(h,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var v=0;p.cmp(a)!==0;v++){p=p.redSqr()}assert(v<l);var b=this.pow(u,new BN(1).iushln(l-v-1));d=d.redMul(b);u=b.redSqr();c=c.redMul(u);l=v}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var h=t.bitLength()%26;if(h===0){h=26}for(n=t.length-1;n>=0;n--){var u=t.words[n];for(var d=h-1;d>=0;d--){var c=u>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}h=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},3500:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},1387:function(e,t,r){var i=r(5055).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var h=r[3];var u=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,v,b,m;var y=4;for(var g=1;g<n;g++){p=a[u>>>24]^s[d>>>16&255]^o[c>>>8&255]^h[l&255]^t[y++];v=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^h[u&255]^t[y++];b=a[c>>>24]^s[l>>>16&255]^o[u>>>8&255]^h[d&255]^t[y++];m=a[l>>>24]^s[u>>>16&255]^o[d>>>8&255]^h[c&255]^t[y++];u=p;d=v;c=b;l=m}p=(i[u>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];v=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[u&255])^t[y++];b=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[u>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[u>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;v=v>>>0;b=b>>>0;m=m>>>0;return[p,v,b,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var h=0;h<256;++h){var u=o^o<<1^o<<2^o<<3^o<<4;u=u>>>8^u&255^99;r[s]=u;i[u]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[u]*257^u*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][u]=p<<24|p>>>8;a[1][u]=p<<16|p>>>16;a[2][u]=p<<8|p>>>24;a[3][u]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var h=s[o-1];if(o%t===0){h=h<<8|h>>>24;h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255];h^=n[o/t|0]<<24}else if(t>6&&o%t===4){h=a.SBOX[h>>>24]<<24|a.SBOX[h>>>16&255]<<16|a.SBOX[h>>>8&255]<<8|a.SBOX[h&255]}s[o]=s[o-t]^h}var u=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){u[d]=l}else{u[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=u};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},6624:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);var o=r(7225);var h=r(4734);var u=r(598);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var h=a*8;var d=n.alloc(8);d.writeUIntBE(h,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);u(c);return c}function StreamCipher(e,t,r,s){a.call(this);var h=n.alloc(4,0);this._cipher=new i.AES(t);var u=this._cipher.encryptBlock(h);this._ghash=new o(u);r=calcIv(this,r,u);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=h(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},6594:function(e,t,r){var i=r(2);var n=r(2598);var a=r(5866);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},2598:function(e,t,r){var i=r(6624);var n=r(5055).Buffer;var a=r(6370);var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new h.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=u(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},2:function(e,t,r){var i=r(6370);var n=r(6624);var a=r(5055).Buffer;var s=r(126);var o=r(1043);var h=r(1387);var u=r(8368);var d=r(3782);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new h.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=u(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7225:function(e,t,r){var i=r(5055).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},598:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},9825:function(e,t,r){var i=r(4734);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},321:function(e,t,r){var i=r(5055).Buffer;var n=r(4734);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},3147:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,h;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;h=i[0]^o;s+=(h&128)>>n%8;e._prev=shiftIn(e._prev,r?o:h)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},2430:function(e,t,r){var i=r(5055).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3361:function(e,t,r){var i=r(4734);var n=r(5055).Buffer;var a=r(598);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var h=getBlock(e);var u=a+o*s;e._cache.writeUInt32BE(h[0],u+0);e._cache.writeUInt32BE(h[1],u+4);e._cache.writeUInt32BE(h[2],u+8);e._cache.writeUInt32BE(h[3],u+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},1590:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},6370:function(e,t,r){var i={ECB:r(1590),CBC:r(9825),CFB:r(321),CFB8:r(2430),CFB1:r(3147),OFB:r(3412),CTR:r(3361),GCM:r(3361)};var n=r(5866);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},3412:function(e,t,r){var i=r(4734);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},126:function(e,t,r){var i=r(1387);var n=r(5055).Buffer;var a=r(1043);var s=r(3782);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},8996:function(e,t,r){var i=r(5238);var n=r(6594);var a=r(6370);var s=r(6280);var o=r(8368);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},5238:function(e,t,r){var i=r(1043);var n=r(9536);var a=r(3782);var s=r(5055).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var h=e.iv;if(!s.isBuffer(h)){h=s.from(h)}this._des=r.create({key:a,iv:h,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},6280:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},7166:function(e,t,r){var i=r(711);var n=r(7223);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var h=s.toRed(i.mont(t.prime2));var u=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=h.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var v=l.isub(p).imul(u).umod(d);v.imul(c);p.iadd(v);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},9276:function(e,t,r){e.exports=r(2908)},4078:function(e,t,r){var i=r(5055).Buffer;var n=r(9739);var a=r(3726);var s=r(3782);var o=r(9807);var h=r(4013);var u=r(2908);Object.keys(u).forEach((function(e){u[e].id=i.from(u[e].id,"hex");u[e.toLowerCase()]=u[e]}));function Sign(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=u[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return h(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},9807:function(e,t,r){var i=r(5055).Buffer;var n=r(4873);var a=r(7166);var s=r(949).ec;var o=r(1670);var h=r(9902);var u=r(9267);function sign(e,t,r,n,s){var o=h(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var u=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<u)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=u[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var h=new o(0);var u;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){u=makeKey(a,l,r);h=makeR(s,u,n,a);c=u.invm(a).imul(d.add(i.mul(h))).mod(a);if(c.cmpn(0)===0){c=false;h=new o(0)}}return toDER(h,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var h=bits2octets(r,t);var u=i.alloc(o);u.fill(1);var d=i.alloc(o);d=n(a,d).update(u).update(i.from([0])).update(e).update(h).digest();u=n(a,d).update(u).digest();d=n(a,d).update(u).update(i.from([1])).update(e).update(h).digest();u=n(a,d).update(u).digest();return{k:d,v:u}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},4013:function(e,t,r){var i=r(5055).Buffer;var n=r(1670);var a=r(949).ec;var s=r(9902);var o=r(9267);function verify(e,t,r,a,o){var h=s(r);if(h.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,h)}else if(h.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,h)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var u=h.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<u){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(h.modulus);e=new n(e).toRed(p);e=e.redPow(new n(h.publicExponent));e=i.from(e.fromRed().toArray());var v=c<8?1:0;u=Math.min(e.length,d.length);if(e.length!==d.length)v=1;l=-1;while(++l<u)v|=e[l]^d[l];return v===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var h=r.data.pub_key;var u=s.signature.decode(e,"der");var d=u.s;var c=u.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var v=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(h.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return v.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},4734:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},1043:function(e,t,r){var i=r(5055).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(3782);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},9942:function(e,t,r){var i=r(949);var n=r(711);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},9739:function(e,t,r){"use strict";var i=r(3782);var n=r(3533);var a=r(3225);var s=r(4371);var o=r(1043);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},450:function(e,t,r){var i=r(3533);e.exports=function(e){return(new i).update(e).digest()}},4873:function(e,t,r){"use strict";var i=r(3782);var n=r(8119);var a=r(1043);var s=r(5055).Buffer;var o=r(450);var h=r(3225);var u=r(4371);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new h:u(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new h:u(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new h:u(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},8119:function(e,t,r){"use strict";var i=r(3782);var n=r(5055).Buffer;var a=r(1043);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var h=0;h<o;h++){r[h]=t[h]^54;i[h]=t[h]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},9536:function(e,t,r){"use strict";t.utils=r(5334);t.Cipher=r(9876);t.DES=r(1016);t.CBC=r(8641);t.EDE=r(6159)},8641:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},9876:function(e,t,r){"use strict";var i=r(3523);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},1016:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(5334);var s=r(9876);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var h=o[s>>>1];r=a.r28shl(r,h);n=a.r28shl(n,h);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var h=0;h<e.keys.length;h+=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(o,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var h=e.keys.length-2;h>=0;h-=2){var u=e.keys[h];var d=e.keys[h+1];a.expand(s,e.tmp,0);u^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(u,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},6159:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);var a=r(9876);var s=r(1016);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},5334:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var h=0;h<o;h++){a<<=1;a|=e>>>r[h]&1}for(var h=o;h<r.length;h++){s<<=1;s|=t>>>r[h]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},6587:function(e,t,r){var i=r(296);var n=r(7992);var a=r(373);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},373:function(e,t,r){var i=r(711);var n=r(1354);var a=new n;var s=new i(24);var o=new i(11);var h=new i(10);var u=new i(3);var d=new i(7);var c=r(296);var l=r(7223);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(h);if(l.cmp(u)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},296:function(e,t,r){var i=r(7223);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(711);var a=new n(24);var s=r(1354);var o=new s;var h=new n(1);var u=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var v=new n(3);var b=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(h)}if(!r.testn(1)){r.iadd(u)}if(!t.cmp(u)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(v)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},949:function(e,t,r){"use strict";var i=t;i.version=r(2531).i8;i.utils=r(4401);i.rand=r(3500);i.curve=r(9359);i.curves=r(6226);i.ec=r(4088);i.eddsa=r(8511)},2727:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var h=0;h<i.length;h+=r.step){var u=0;for(var t=h+r.step-1;t>=h;t--)u=(u<<1)+i[t];s.push(u)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var h=0;h<s.length;h++){var u=s[h];if(u===l)c=c.mixedAdd(r.points[h]);else if(u===-l)c=c.mixedAdd(r.points[h].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var h=this.jpoint(null,null,null);for(var u=s.length-1;u>=0;u--){for(var t=0;u>=0&&s[u]===0;u--)t++;if(u>=0)t++;h=h.dblp(t);if(u<0)break;var d=s[u];o(d!==0);if(e.type==="affine"){if(d>0)h=h.mixedAdd(n[d-1>>1]);else h=h.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)h=h.add(n[d-1>>1]);else h=h.add(n[-d-1>>1].neg())}}return e.type==="affine"?h.toP():h};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var h=this._wnafT2;var u=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;h[c]=p.points}for(var c=i-1;c>=1;c-=2){var v=c-1;var b=c;if(o[v]!==1||o[b]!==1){u[v]=a(r[v],o[v],this._bitLength);u[b]=a(r[b],o[b],this._bitLength);d=Math.max(u[v].length,d);d=Math.max(u[b].length,d);continue}var m=[t[v],null,null,t[b]];if(t[v].y.cmp(t[b].y)===0){m[1]=t[v].add(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}else if(t[v].y.cmp(t[b].y.redNeg())===0){m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].add(t[b].neg())}else{m[1]=t[v].toJ().mixedAdd(t[b]);m[2]=t[v].toJ().mixedAdd(t[b].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[v],r[b]);d=Math.max(g[0].length,d);u[v]=new Array(d);u[b]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;u[v][_]=y[(w+1)*3+(M+1)];u[b][_]=0;h[v]=m}}var B=this.jpoint(null,null,null);var E=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){E[_]=u[_][c]|0;if(E[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;B=B.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=E[_];var l;if(N===0)continue;else if(N>0)l=h[_][N-1>>1];else if(N<0)l=h[_][-N-1>>1].neg();if(l.type==="affine")B=B.mixedAdd(l);else B=B.add(l)}}for(var c=0;c<i;c++)h[c]=null;if(n)return B;else return B.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},2705:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var h=o.fromRed().isOdd();if(t&&!h||!t&&h)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var h=n.redMul(s);var u=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(h,u,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var h=this.z.redSqr();var u=o.redSub(h).redISub(h);i=e.redSub(t).redISub(r).redMul(u);n=o.redMul(s.redSub(r));a=o.redMul(u)}}else{var s=t.redAdd(r);var h=this.curve._mulC(this.z).redSqr();var u=s.redSub(h).redSub(h);i=this.curve._mulC(e.redISub(s)).redMul(u);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(u)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var h=r.redAdd(t);var u=a.redMul(s);var d=o.redMul(h);var c=a.redMul(h);var l=s.redMul(o);return this.curve.point(u,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var h=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var u=t.redMul(s).redMul(h);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(u,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},9359:function(e,t,r){"use strict";var i=t;i.base=r(2727);i.short=r(4720);i.mont=r(6653);i.edwards=r(2705)},6653:function(e,t,r){"use strict";var i=r(711);var n=r(3782);var a=r(2727);var s=r(4401);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var h=t.z.redMul(s.redAdd(o).redSqr());var u=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(h,u)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},4720:function(e,t,r){"use strict";var i=r(4401);var n=r(711);var a=r(3782);var s=r(2727);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var h=new n(1);var u;var d;var c;var l;var p;var v;var b;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=h.sub(_.mul(s));if(!c&&y.cmp(t)<0){u=b.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}b=y;i=r;r=y;o=a;a=g;h=s;s=w}p=y.neg();v=g;var M=c.sqr().add(l.sqr());var B=p.sqr().add(v.sqr());if(B.cmp(M)>=0){p=u;v=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();v=v.neg()}return[{a:c,b:l},{a:p,b:v}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var h=n.mul(r.b);var u=a.mul(i.b);var d=e.sub(s).sub(o);var c=h.add(u).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var h=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();h=h.neg(true)}i[a*2]=o;i[a*2+1]=h;n[a*2]=s.k1;n[a*2+1]=s.k2}var u=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return u};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var h=a.redSub(s);if(o.cmpn(0)===0){if(h.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=o.redSqr();var d=u.redMul(o);var c=i.redMul(u);var l=h.redSqr().redIAdd(d).redISub(c).redISub(c);var p=h.redMul(c.redISub(l)).redISub(a.redMul(d));var v=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,v)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=s.redSqr();var u=h.redMul(s);var d=r.redMul(h);var c=o.redSqr().redIAdd(u).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(u));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var h=o.redSqr().redSqr();var u=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=u.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(h));var v=a.redMul(c);var b=p.redSqr().redISub(v.redAdd(v));var m=v.redISub(b);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=u.redMul(o);if(r+1<e)h=h.redMul(l);a=b;o=g;u=y}return this.curve.jpoint(a,u.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var h=o.redSqr().redISub(s).redISub(s);var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);e=h;t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var v=d.redAdd(d).redIAdd(d);var b=v.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=b.redISub(p).redISub(p);t=v.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var h=o.redSqr().redISub(s).redISub(s);e=h;var u=a.redIAdd(a);u=u.redIAdd(u);u=u.redIAdd(u);t=o.redMul(s.redISub(h)).redISub(u);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var v=l.redIAdd(l);v=v.redIAdd(v);var b=v.redAdd(v);e=p.redSqr().redISub(b);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(v.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var h=t.redAdd(t);h=h.redIAdd(h);var u=h.redMul(s);var d=o.redSqr().redISub(u.redAdd(u));var c=u.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var v=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,v)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var h=i.redIAdd(i);h=h.redIAdd(h);h=h.redIAdd(h);h=h.redIAdd(h);var u=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(h);var d=t.redMul(u);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(u.redMul(h.redISub(u)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},6226:function(e,t,r){"use strict";var i=t;var n=r(7028);var a=r(9359);var s=r(4401);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var h;try{h=r(9702)}catch(e){h=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",h]})},4088:function(e,t,r){"use strict";var i=r(711);var n=r(4910);var a=r(4401);var s=r(6226);var o=r(3500);var h=a.assert;var u=r(4724);var d=r(7526);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){h(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new u(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return u.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return u.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var h=e.toArray("be",s);var u=new n({hash:this.hash,entropy:o,nonce:h,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(u.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var v=this.g.mul(p);if(v.isInfinity())continue;var b=v.getX();var m=b.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(v.getY().isOdd()?1:0)|(b.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var h=o.mul(e).umod(this.n);var u=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(h,r.getPublic(),u);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){h((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var u=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var v=a.sub(s).mul(p).umod(a);var b=u.mul(p).umod(a);return this.g.mulAdd(v,o,b)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},4724:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},7526:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var h=getLength(e,r);if(h===false){return false}if(e.length!==h+r.place){return false}var u=e.slice(r.place,h+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(u[0]===0){if(u[1]&128){u=u.slice(1)}else{return false}}this.r=new i(o);this.s=new i(u);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},8511:function(e,t,r){"use strict";var i=r(7028);var n=r(6226);var a=r(4401);var s=a.assert;var o=a.parseBytes;var h=r(9917);var u=r(9314);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var h=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:h,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return h.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return h.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof u)return e;return new u(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9917:function(e,t,r){"use strict";var i=r(4401);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},9314:function(e,t,r){"use strict";var i=r(711);var n=r(4401);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},9702:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},4401:function(e,t,r){"use strict";var i=t;var n=r(711);var a=r(3523);var s=r(6545);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var h=a.andln(n-1);if(a.isOdd()){if(h>(n>>1)-1)o=(n>>1)-h;else o=h;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var h=e.andln(7)+i&7;if((h===3||h===5)&&s===2)o=-a;else o=a}r[0].push(o);var u;if((s&1)===0){u=0}else{var h=t.andln(7)+n&7;if((h===3||h===5)&&a===2)u=-s;else u=s}r[1].push(u);if(2*i===o+1)i=1-i;if(2*n===u+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},8368:function(e,t,r){var i=r(5055).Buffer;var n=r(3533);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var h=i.alloc(a||0);var u=i.alloc(0);while(s>0||a>0){var d=new n;d.update(u);d.update(e);if(t)d.update(t);u=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,u.length);u.copy(o,l,0,c);s-=c}if(c<u.length&&a>0){var p=h.length-a;var v=Math.min(a,u.length-c);u.copy(h,p,c,c+v);a-=v}}u.fill(0);return{key:o,iv:h}}e.exports=EVP_BytesToKey},9029:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=r(3726).Transform;var a=r(3782);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},7028:function(e,t,r){var i=t;i.utils=r(263);i.common=r(1330);i.sha=r(301);i.ripemd=r(3079);i.hmac=r(3092);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},1330:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},3092:function(e,t,r){"use strict";var i=r(263);var n=r(3523);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},3079:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var h=i.sum32_4;var u=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;u.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,u);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var u=this.h[3];var v=this.h[4];var b=r;var m=i;var y=n;var g=u;var _=v;for(var w=0;w<80;w++){var M=s(a(h(r,f(w,i,n,u),e[d[w]+t],K(w)),l[w]),v);r=v;v=u;u=a(n,10);n=i;i=M;M=s(a(h(b,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);b=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],u,_);this.h[2]=o(this.h[3],v,b);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},301:function(e,t,r){"use strict";t.sha1=r(2742);t.sha224=r(7105);t.sha256=r(1525);t.sha384=r(9948);t.sha512=r(1319)},2742:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=i.rotl32;var o=i.sum32;var h=i.sum32_5;var u=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var v=~~(i/20);var b=h(s(n,5),u(v,a,d,l),p,r[i],c[v]);p=l;l=d;d=s(a,30);a=n;n=b}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},7105:function(e,t,r){"use strict";var i=r(263);var n=r(1525);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},1525:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(2975);var s=r(3523);var o=i.sum32;var h=i.sum32_4;var u=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var v=a.g0_256;var b=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=h(b(r[i-2]),r[i-7],v(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var B=u(M,p(g),d(g,_,w),this.k[i],r[i]);var E=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,B);y=m;m=a;a=n;n=o(B,E)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9948:function(e,t,r){"use strict";var i=r(263);var n=r(1319);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},1319:function(e,t,r){"use strict";var i=r(263);var n=r(1330);var a=r(3523);var s=i.rotr64_hi;var o=i.rotr64_lo;var h=i.shr64_hi;var u=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var v=i.sum64_4_lo;var b=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var h=g0_512_hi(r[i-30],r[i-29]);var u=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,h,u,d,c);r[i+1]=v(n,a,s,o,h,u,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var h=this.h[4];var u=this.h[5];var p=this.h[6];var v=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var B=this.h[13];var E=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=E;var P=k;var x=s1_512_hi(y,g);var I=s1_512_lo(y,g);var C=ch64_hi(y,g,_,w,M,B);var D=ch64_lo(y,g,_,w,M,B);var T=this.k[A];var j=this.k[A+1];var q=r[A];var O=r[A+1];var H=b(N,P,x,I,C,D,T,j,q,O);var L=m(N,P,x,I,C,D,T,j,q,O);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,h,u);I=maj64_lo(i,n,s,o,h,u);var z=c(N,P,x,I);var F=l(N,P,x,I);E=M;k=B;M=_;B=w;_=y;w=g;y=c(p,v,H,L);g=l(v,v,H,L);p=h;v=u;h=s;u=o;s=i;o=n;i=c(H,L,z,F);n=l(H,L,z,F)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,h,u);d(this.h,6,p,v);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,B);d(this.h,14,E,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},2975:function(e,t,r){"use strict";var i=r(263);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},263:function(e,t,r){"use strict";var i=r(3523);var n=r(3782);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,h=t;o<s.length;o++,h+=4){var u;if(n==="big")u=e[h]<<24|e[h+1]<<16|e[h+2]<<8|e[h+3];else u=e[h+3]<<24|e[h+2]<<16|e[h+1]<<8|e[h];s[o]=u>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var h=0;var u=t;u=u+i>>>0;h+=u<t?1:0;u=u+a>>>0;h+=u<a?1:0;u=u+o>>>0;h+=u<o?1:0;var d=e+r+n+s+h;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var h=t+i+a+o;return h>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,h,u){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+u>>>0;d+=c<u?1:0;var l=e+r+n+s+h+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,h,u){var d=t+i+a+o+u;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},4910:function(e,t,r){"use strict";var i=r(7028);var n=r(6545);var a=r(3523);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},3782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},3533:function(e,t,r){"use strict";var i=r(3782);var n=r(9029);var a=r(5055).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},1354:function(e,t,r){var i=r(711);var n=r(3500);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var h=0;!o.testn(h);h++){}var u=e.shrn(h);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(u);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var v=1;v<h;v++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(v===h)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var h=e.shrn(o);var u=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(h);if(l.cmp(a)===0||l.cmp(u)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(u)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},3523:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6545:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},8687:function(e,t,r){"use strict";var i=r(7160);t.certificate=r(8782);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var h=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=h;var u=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=u;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8782:function(e,t,r){"use strict";var i=r(7160);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var h=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var u=i.define("RDNSequence",(function(){this.seqof(h)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(u)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var v=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=v},6501:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(8368);var o=r(6594);var h=r(5055).Buffer;e.exports=function(e,t){var r=e.toString();var u=r.match(i);var d;if(!u){var c=r.match(a);d=new h(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+u[1];var p=h.from(u[2],"hex");var v=h.from(u[3].replace(/[\r\n]/g,""),"base64");var b=s(t,p.slice(0,8),parseInt(u[1],10)).key;var m=[];var y=o.createDecipheriv(l,b,p);m.push(y.update(v));m.push(y.final());d=h.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},9902:function(e,t,r){var i=r(8687);var n=r(2510);var a=r(6501);var s=r(6594);var o=r(4978);var h=r(5055).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!h.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=h.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,u;switch(n){case"CERTIFICATE":u=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!u){u=i.PublicKey.decode(s,"der")}o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(u.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":u.subjectPrivateKey=u.subjectPublicKey;return{type:"ec",data:u};case"1.2.840.10040.4.1":u.algorithm.params.pub_key=i.DSAparam.decode(u.subjectPublicKey.data,"der");return{type:"dsa",data:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":u=i.PrivateKey.decode(s,"der");o=u.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(u.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:u.algorithm.curve,privateKey:i.ECPrivateKey.decode(u.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":u.algorithm.params.priv_key=i.DSAparam.decode(u.subjectPrivateKey,"der");return{type:"dsa",params:u.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var u=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,u);var v=[];v.push(p.update(d));v.push(p.final());return h.concat(v)}},4978:function(e,t,r){var i=r(6113);var n=r(5349);var a=r(7007);var s=r(5407);function nativePBKDF2(e,t,r,o,h,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof h==="function"){u=h;h="sha1"}if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,h,u)}function nativePBKDF2Sync(e,t,r,o,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");h=h||"sha1";return i.pbkdf2Sync(e,t,r,o,h)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2127);t.pbkdf2=r(9601)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},9601:function(e,t,r){var i=r(5055).Buffer;var n=r(5349);var a=r(7007);var s=r(2127);var o=r(5407);var h;var u=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!u||!u.importKey||!u.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}h=h||i.alloc(8);var t=browserPbkdf2(h,h,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return u.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return u.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,h,u){if(typeof h==="function"){u=h;h=undefined}h=h||"sha1";var c=d[h.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,h)}catch(e){return u(e)}u(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof u!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,h)})),u)}},7007:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},5349:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2127:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(4873);var a=r(5055).Buffer;var s=r(5349);var o=r(7007);var h=r(5407);function pbkdf2(e,t,r,u,d){s(r,u);e=h(e,o,"Password");t=h(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(u);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var v=i[d];var b=Math.ceil(u/v);for(var m=1;m<=b;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<v;w++)y[w]^=g[w]}y.copy(c,p);p+=v}return c}e.exports=pbkdf2},5407:function(e,t,r){var i=r(5055).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},9783:function(e,t,r){t.publicEncrypt=r(3995);t.privateDecrypt=r(4366);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},5520:function(e,t,r){var i=r(9739);var n=r(5055).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},4366:function(e,t,r){var i=r(9902);var n=r(5520);var a=r(6386);var s=r(711);var o=r(7166);var h=r(9739);var u=r(1607);var d=r(5055).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var h=a.modulus.byteLength();if(t.length>h||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=u(new s(t),a)}else{c=o(t,a)}var l=d.alloc(h-c.length);c=d.concat([l,c],h);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=h("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var u=t.slice(s+1);var c=a(o,n(u,s));var l=a(u,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3995:function(e,t,r){var i=r(9902);var n=r(7223);var a=r(9739);var s=r(5520);var o=r(6386);var h=r(711);var u=r(1607);var d=r(7166);var c=r(5055).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new h(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return u(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var u=a("sha1").update(c.alloc(0)).digest();var d=u.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var v=r-d-1;var b=n(d);var m=o(c.concat([u,p,c.alloc(1,1),t],v),s(b,v));var y=o(b,s(m,d));return new h(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new h(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},1607:function(e,t,r){var i=r(711);var n=r(5055).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},6386:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},7223:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(5055).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},6445:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(5055);var n=r(7223);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var h=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>h||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>h||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var h=n(r);h.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},4646:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},2403:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(1709);var a=r(7337);r(3782)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var h=s[o];if(!Duplex.prototype[h])Duplex.prototype[h]=a.prototype[h]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},7889:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(1170);r(3782)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},1709:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(4678);var o=r(4300).Buffer;var h=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof h}var u=r(3837);var d;if(u&&u.debuglog){d=u.debuglog("stream")}else{d=function debug(){}}var c=r(4379);var l=r(7025);var p=r(6776),v=p.getHighWaterMark;var b=r(4646).q,m=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,g=b.ERR_METHOD_NOT_IMPLEMENTED,_=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var B;r(3782)(Readable,s);var E=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=v(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(3704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(2403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){E(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)E(e,new _);else addChunk(e,a,t,true)}else if(a.ended){E(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(3704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){E(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var h=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);h=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!h){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)E(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(6871)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(B===undefined){B=r(9727)}return B(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},1170:function(e,t,r){"use strict";e.exports=Transform;var i=r(4646).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var h=r(2403);r(3782)(Transform,h);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);h.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return h.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){h.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},7337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(6769)};var a=r(4678);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var h=r(7025);var u=r(6776),d=u.getHighWaterMark;var c=r(4646).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,v=c.ERR_MULTIPLE_CALLBACK,b=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=h.errorOrDestroy;r(3782)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(2403);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(2403);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var h=t.length<t.highWaterMark;if(!h)t.needDrain=true;if(t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(u){u.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return h}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new v;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var h=r.chunk;var u=r.encoding;var d=r.callback;var c=t.objectMode?1:h.length;doWrite(e,t,false,c,h,u,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=h.destroy;Writable.prototype._undestroy=h.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},6871:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9698);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var h=Symbol("ended");var u=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[u]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[h]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[h]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[u];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[u]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var v=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,h,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[u]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[u]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[u]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[u]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[h]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=v},4379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},7025:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9698:function(e,t,r){"use strict";var i=r(4646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)h()};var o=e._writableState&&e._writableState.finished;var h=function onfinish(){a=false;o=true;if(!n)r.call(e)};var u=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;u=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!u){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",h)};if(isRequest(e)){e.on("complete",h);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",h);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",h);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",h);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",h);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},9727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var h=o.value}catch(e){r(e);return}if(o.done){t(h)}else{Promise.resolve(h).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(4646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},8442:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(4646).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9698);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var h=false;return function(t){if(o)return;if(h)return;h=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},6776:function(e,t,r){"use strict";var i=r(4646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},4678:function(e,t,r){e.exports=r(2781)},3726:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(1709);t.Stream=i||t;t.Readable=t;t.Writable=r(7337);t.Duplex=r(2403);t.Transform=r(1170);t.PassThrough=r(7889);t.finished=r(9698);t.pipeline=r(8442)}},3225:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(3782);var a=r(9029);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var h=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var u=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var v=this._a|0;var b=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],u[_]);M=fn5(v,b,m,y,g,e[h[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],u[_]);M=fn4(v,b,m,y,g,e[h[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],u[_]);M=fn3(v,b,m,y,g,e[h[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],u[_]);M=fn2(v,b,m,y,g,e[h[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],u[_]);M=fn1(v,b,m,y,g,e[h[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;v=g;g=y;y=rotl(m,10);m=b;b=M}var B=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+v|0;this._d=this._e+r+b|0;this._e=this._a+i+m|0;this._a=B};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},5055:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},2858:function(e,t,r){var i=r(5055).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var h=s%n;var u=Math.min(a-o,n-h);for(var d=0;d<u;d++){r[h+d]=e[o+d]}s+=u;o+=u;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},4371:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(4018);i.sha1=r(4179);i.sha224=r(532);i.sha256=r(1843);i.sha384=r(7455);i.sha512=r(9934)},4018:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=t[h-3]^t[h-8]^t[h-14]^t[h-16];for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},4179:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var h=0;h<16;++h)t[h]=e.readInt32BE(h*4);for(;h<80;++h)t[h]=rotl1(t[h-3]^t[h-8]^t[h-14]^t[h-16]);for(var u=0;u<80;++u){var d=~~(u/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[u]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},532:function(e,t,r){var i=r(3782);var n=r(1843);var a=r(2858);var s=r(5055).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},1843:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var h=this._f|0;var u=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,h,u)+s[l]+t[l]|0;var v=sigma0(r)+maj(r,i,n)|0;d=u;u=h;h=o;o=a+p|0;a=n;n=i;i=r;r=p+v|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=h+this._f|0;this._g=u+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},7455:function(e,t,r){var i=r(3782);var n=r(9934);var a=r(2858);var s=r(5055).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},9934:function(e,t,r){var i=r(3782);var n=r(2858);var a=r(5055).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var h=this._fh|0;var u=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var v=this._dl|0;var b=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var B=Gamma0(w,M);var E=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var I=t[_-16*2+1];var C=E+P|0;var D=B+N+getCarry(C,E)|0;C=C+A|0;D=D+k+getCarry(C,A)|0;C=C+I|0;D=D+x+getCarry(C,I)|0;t[_]=D;t[_+1]=C}for(var T=0;T<160;T+=2){D=t[T];C=t[T+1];var j=maj(r,i,n);var q=maj(c,l,p);var O=sigma0(r,c);var H=sigma0(c,r);var L=sigma1(o,b);var z=sigma1(b,o);var F=s[T];var U=s[T+1];var W=Ch(o,h,u);var V=Ch(b,m,y);var G=g+z|0;var J=d+L+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+U|0;J=J+F+getCarry(G,U)|0;G=G+C|0;J=J+D+getCarry(G,C)|0;var Z=H+q|0;var X=O+j+getCarry(Z,H)|0;d=u;g=y;u=h;y=m;h=o;m=b;b=v+G|0;o=a+J+getCarry(b,v)|0;a=n;v=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+v|0;this._el=this._el+b|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,v)|0;this._eh=this._eh+o+getCarry(this._el,b)|0;this._fh=this._fh+h+getCarry(this._fl,m)|0;this._gh=this._gh+u+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},3704:function(e,t,r){"use strict";var i=r(5055).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},6769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(75291)},6113:function(e){"use strict";e.exports=__webpack_require__(65301)},2361:function(e){"use strict";e.exports=__webpack_require__(97531)},2781:function(e){"use strict";e.exports=__webpack_require__(98394)},1576:function(e){"use strict";e.exports=__webpack_require__(87682)},3837:function(e){"use strict";e.exports=__webpack_require__(82019)},6144:function(e){"use strict";e.exports=__webpack_require__(73218)},5866:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},2908:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9267:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},7992:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}')},2531:function(e){"use strict";e.exports={i8:"6.5.3"}},2510:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(7223);e.createHash=e.Hash=__nccwpck_require__(9739);e.createHmac=e.Hmac=__nccwpck_require__(4873);var t=__nccwpck_require__(9276);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(4978);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(8996);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(6587);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var h=__nccwpck_require__(4078);e.createSign=h.createSign;e.Sign=h.Sign;e.createVerify=h.createVerify;e.Verify=h.Verify;e.createECDH=__nccwpck_require__(9942);var u=__nccwpck_require__(9783);e.publicEncrypt=u.publicEncrypt;e.privateEncrypt=u.privateEncrypt;e.publicDecrypt=u.publicDecrypt;e.privateDecrypt=u.privateDecrypt;var d=__nccwpck_require__(6445);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 74676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var r={528:function(r,e,t){var o=t(685);var a=t(310);var i=r.exports;for(var n in o){if(o.hasOwnProperty(n))i[n]=o[n]}i.request=function(r,e){r=validateParams(r);return o.request.call(this,r,e)};i.get=function(r,e){r=validateParams(r);return o.get.call(this,r,e)};function validateParams(r){if(typeof r==="string"){r=a.parse(r)}if(!r.protocol){r.protocol="https:"}if(r.protocol!=="https:"){throw new Error('Protocol "'+r.protocol+'" not supported. Expected "https:"')}return r}},685:function(r){"use strict";r.exports=__webpack_require__(37122)},310:function(r){"use strict";r.exports=__webpack_require__(22512)}};var e={};function __nccwpck_require__(t){var o=e[t];if(o!==undefined){return o.exports}var a=e[t]={exports:{}};var i=true;try{r[t](a,a.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return a.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(528);module.exports=t})();

/***/ }),

/***/ 205:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"landing-feature-error-page_container__PyoGO","errorPageTitle":"landing-feature-error-page_errorPageTitle__l8wPR","errorPageSubTitle":"landing-feature-error-page_errorPageSubTitle__Nqe0n","errorPageImage":"landing-feature-error-page_errorPageImage__pTfkV","actionButtons":"landing-feature-error-page_actionButtons__YwkDd"};

/***/ }),

/***/ 34992:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"basketContainer":"basket-navigation_basketContainer__GqzxY","basketIconsContainer":"basket-navigation_basketIconsContainer__TlJAr","basketIcon":"basket-navigation_basketIcon__JcjCG","arrowBorder":"basket-navigation_arrowBorder__pALte","number":"basket-navigation_number__sjl_z","timerIcon":"basket-navigation_timerIcon__6p_15","pulsing":"basket-navigation_pulsing__pXsa_","pulse":"basket-navigation_pulse__Os8wC"};

/***/ }),

/***/ 98114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carCareNavCard":"car-care-menu_carCareNavCard__9YgOU","list":"car-care-menu_list__sYuqw"};

/***/ }),

/***/ 1083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"car-finance-menu_listItem__asWla","helpfulArticles":"car-finance-menu_helpfulArticles__f6Fdd","carFinanceItemWrapper":"car-finance-menu_carFinanceItemWrapper__A0TG7"};

/***/ }),

/***/ 232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navItem":"desktop-nav_navItem__98fKu","navItemDropdown":"desktop-nav_navItemDropdown__hJNeV","navDropdownWrapper":"desktop-nav_navDropdownWrapper__deKUx","navDropdownBG":"desktop-nav_navDropdownBG__v1Zcp","carCareMenuContainer":"desktop-nav_carCareMenuContainer__9qyeG","menuContainer":"desktop-nav_menuContainer__38MXv"};

/***/ }),

/***/ 92792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"svg":"favourites_svg__FLArc","link":"favourites_link__axYHV","number":"favourites_number__VfSSr","pulse":"favourites_pulse__C_FHB","pulsing":"favourites_pulsing__gqs0W"};

/***/ }),

/***/ 36288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"find-a-car-menu_listItem___HXES","largeMobileNavContainer":"find-a-car-menu_largeMobileNavContainer__icVIn","shopByTypeContainer":"find-a-car-menu_shopByTypeContainer__w7LBZ","smallMobileContainer":"find-a-car-menu_smallMobileContainer__gw2WT"};

/***/ }),

/***/ 49113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"how-cinch-works-menu_listItem___KMRV","listContainer":"how-cinch-works-menu_listContainer__CKG8a","faqContainer":"how-cinch-works-menu_faqContainer___KKgh","faqList":"how-cinch-works-menu_faqList__74ZS5"};

/***/ }),

/***/ 80667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listItem":"list-item_listItem__7bq08"};

/***/ }),

/***/ 28572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"list-snippet-item_container__uFhsh","containerWithoutImage":"list-snippet-item_containerWithoutImage__GcLQR","containerWithSmallImage":"list-snippet-item_containerWithSmallImage__lrp2t","textContainer":"list-snippet-item_textContainer__du1rH","heading":"list-snippet-item_heading__wnR2_","snippet":"list-snippet-item_snippet__fut4c","date":"list-snippet-item_date__P0VyY","link":"list-snippet-item_link__HTe7Q","linkHeading":"list-snippet-item_linkHeading__Zjtlm","icon":"list-snippet-item_icon__Uv89T","customIcon":"list-snippet-item_customIcon__NDOAo","imageContainer":"list-snippet-item_imageContainer__LFB3i","image":"list-snippet-item_image__C9APl","imageContainerSmall":"list-snippet-item_imageContainerSmall__MTX4R","linkText":"list-snippet-item_linkText__ob_iw"};

/***/ }),

/***/ 92319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listWrapperContainer":"list-wrapper_listWrapperContainer__yMYWQ","heading":"list-wrapper_heading__qEJ_q","listCardHeading":"list-wrapper_listCardHeading__uXbzf","wrapperLink":"list-wrapper_wrapperLink__DdfwK","listCardWrapperLink":"list-wrapper_listCardWrapperLink__yrh6Q","wrapperLinkIcon":"list-wrapper_wrapperLinkIcon__3ENG5","listCardUrlText":"list-wrapper_listCardUrlText__v_q05"};

/***/ }),

/***/ 41803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"logo-container_logoWrapper__WegjL"};

/***/ }),

/***/ 20905:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileMenu":"mobile-menu_mobileMenu__zEIxO","mobileProfileWrapper":"mobile-menu_mobileProfileWrapper___ehye","mobileProfile":"mobile-menu_mobileProfile__yIOUK","mobileCloseButton":"mobile-menu_mobileCloseButton__csbB9","mobileLogo":"mobile-menu_mobileLogo__op_Lg","favouritesIconContainer":"mobile-menu_favouritesIconContainer__z0xdB"};

/***/ }),

/***/ 60168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navCard":"mobile-nav-card_navCard__qq_eO","textContainer":"mobile-nav-card_textContainer__tImVA","heading":"mobile-nav-card_heading__mId8O","link":"mobile-nav-card_link__GAPll","icon":"mobile-nav-card_icon__8IGNB","imageWrapper":"mobile-nav-card_imageWrapper__RN5X4"};

/***/ }),

/***/ 32261:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuIconWrapper":"mobile-nav_menuIconWrapper__PbNxk","mobileMenuWrapper":"mobile-nav_mobileMenuWrapper__ZV8sG","circleBackground":"mobile-nav_circleBackground__JUMtP","dropCircle":"mobile-nav_dropCircle__3NyIb","navItemDropdown":"mobile-nav_navItemDropdown__ePoOV","navItem":"mobile-nav_navItem__Xi_R1","navItemWithChildren":"mobile-nav_navItemWithChildren__4seg3","navDropdownBG":"mobile-nav_navDropdownBG__6J40s","menuSignInOut":"mobile-nav_menuSignInOut__Fka8z"};

/***/ }),

/***/ 39192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navCard":"nav-card_navCard__nZ02x","headingContainer":"nav-card_headingContainer__0zbu3","heading":"nav-card_heading__KblXz","subHeading":"nav-card_subHeading__8fZc7","link":"nav-card_link__oGTTq","icon":"nav-card_icon__f1wxV","image":"nav-card_image__zxL_t"};

/***/ }),

/***/ 89108:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-item_container__h7ol3","navItemContainer":"nav-item_navItemContainer__Irheb","navItemContainerActive":"nav-item_navItemContainerActive__LV2A8","secondaryNavItemContainer":"nav-item_secondaryNavItemContainer__G5mIP","mobileChevron":"nav-item_mobileChevron__iwwL_","mobileChevronRight":"nav-item_mobileChevronRight__Ij_yj","desktopChevron":"nav-item_desktopChevron__uJneI","menuTitleContainer":"nav-item_menuTitleContainer__ASv8V","menuTitleText":"nav-item_menuTitleText__5VPql","menuTitle":"nav-item_menuTitle__KpVxu","menuTitleSubHeading":"nav-item_menuTitleSubHeading__b4WES","menuTitleIcon":"nav-item_menuTitleIcon__9TPw1"};

/***/ }),

/***/ 17434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"part-exchange-menu_container__3U2a7","faqList":"part-exchange-menu_faqList__n1Awc"};

/***/ }),

/***/ 19888:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shop-by-shape-thumbnail_container__dblJI","text":"shop-by-shape-thumbnail_text__NzdXP"};

/***/ }),

/***/ 52854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"userProfileWrapper":"user-profile_userProfileWrapper__8T7qt","profileLink":"user-profile_profileLink__mz7dw","profileLinkText":"user-profile_profileLinkText__NkOq8"};

/***/ }),

/***/ 47451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"yourProfileContainer":"your-profile-menu_yourProfileContainer__SzVN1","profilePageLinkContainer":"your-profile-menu_profilePageLinkContainer__7oHyC","profilePageLinkTitle":"your-profile-menu_profilePageLinkTitle__iFEfG","circle":"your-profile-menu_circle__eFA1B"};

/***/ }),

/***/ 33347:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sharedUiHeaderContainer":"shared-ui-header-v2_sharedUiHeaderContainer__tB3t3","sharedUiHeaderTopLevel":"shared-ui-header-v2_sharedUiHeaderTopLevel__miJWl","sharedUiSkipLink":"shared-ui-header-v2_sharedUiSkipLink__0HXnB"};

/***/ }),

/***/ 21377:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumbs_wrapper__N50S_","list":"breadcrumbs_list__J0jup","listItem":"breadcrumbs_listItem__5sG6W"};

/***/ }),

/***/ 60445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"faq-accordion_sectionTitle__3aanX","faqSection":"faq-accordion_faqSection__glnww"};

/***/ }),

/***/ 3090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"generic-teaser_heading__xXSuz"};

/***/ }),

/***/ 67536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../../../../variables.css'","layout-container-border-radius":"30px","root":"generic-hero_root__zHWoA","singleTitleWrapper":"generic-hero_singleTitleWrapper__O04mf","title":"generic-hero_title__j_UZ2","heroContent":"generic-hero_heroContent__vI3ec","body":"generic-hero_body__6Irze","imageWrapper":"generic-hero_imageWrapper__bNPkj","appRoot":"generic-hero_appRoot__5v4qF","appTitle":"generic-hero_appTitle__RP2hx","appBody":"generic-hero_appBody__LBZTP","appImageWrapper":"generic-hero_appImageWrapper__S9ff1","appHeroButtons":"generic-hero_appHeroButtons__kEMGQ"};

/***/ }),

/***/ 60713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../../../../variables.css'","layout-container-border-radius":"30px","root":"hero-with-rich-text_root__nCKww","singleTitleWrapper":"hero-with-rich-text_singleTitleWrapper__zisQz","title":"hero-with-rich-text_title__NM4kh","heroContent":"hero-with-rich-text_heroContent__xuekX","body":"hero-with-rich-text_body__a6UfI","imageWrapper":"hero-with-rich-text_imageWrapper__6HQkR"};

/***/ }),

/***/ 3397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../../../../variables.css'","layout-container-border-radius":"30px","root":"store-hero_root__qzVat","content":"store-hero_content__vt4qx","title":"store-hero_title___btHU","body":"store-hero_body__NJO2k","imageWrapper":"store-hero_imageWrapper__n0i0z","divider":"store-hero_divider__WqfWU","contactInformation":"store-hero_contactInformation__NqU9m","contactItem":"store-hero_contactItem__PcRb_","svg":"store-hero_svg__QrINt"};

/***/ }),

/***/ 19523:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../../variables.css'","layout-container-border-radius":"30px","headerContainer":"layout_headerContainer__DASYo","borderRadiusHeader":"layout_borderRadiusHeader__NSxzA","verticalGradient":"layout_verticalGradient__x6ELw","borderRadiusMain":"layout_borderRadiusMain__sxbXr","borderRadiusHome":"layout_borderRadiusHome__Ck01w","headerHasBleed":"layout_headerHasBleed__iCUOQ","v2Modal":"layout_v2Modal__hHOQl","v2ModalHeading":"layout_v2ModalHeading__cmYGX"};

/***/ }),

/***/ 13683:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"legalFooterContainer":"mobile-app-legal-footer_legalFooterContainer__43ZgU"};

/***/ }),

/***/ 25535:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__b05fv","rtParagraph":"rich-text-renderer_rtParagraph__9x5RV"};

/***/ }),

/***/ 92489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"heading_root__C209y"};

/***/ }),

/***/ 97755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"borderLeftRadius":"panel_borderLeftRadius__aEC0S","borderRightRadius":"panel_borderRightRadius__eSoiI","panel":"panel_panel__WJwUH panel_borderLeftRadius__aEC0S panel_borderRightRadius__eSoiI","low":"panel_low__uZHtv","mid":"panel_mid__uZFzS","top":"panel_top__MSeOu","bodyContent":"panel_bodyContent__6iQLA","bodyFlex":"panel_bodyFlex__kVuqj","title":"panel_title__2u4j_","noPadding":"panel_noPadding__AGD_A","addornmentLeft":"panel_addornmentLeft__UEg2R panel_borderLeftRadius__aEC0S"};

/***/ }),

/***/ 20007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__mO4IW","small":"table_small__DLCcW"};

/***/ }),

/***/ 7537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"text_root__oO5yC"};

/***/ }),

/***/ 34373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"statsWrapper":"stats-section_statsWrapper__M19PT","carSectionTitle":"stats-section_carSectionTitle__gRf6v","stats":"stats-section_stats__NNemp","statsButton":"stats-section_statsButton__b90uX","stat":"stats-section_stat__KOyAS","statInner":"stats-section_statInner__eiyEB","statHeading":"stats-section_statHeading__TZU1l","statSubHeading":"stats-section_statSubHeading__WVlLD","statImage":"stats-section_statImage__Kqb4i"};

/***/ }),

/***/ 9255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"trustpilot-overview_link__EqiYS","trustpilotStars":"trustpilot-overview_trustpilotStars__c8nCQ","trustpilotScoreWrapper":"trustpilot-overview_trustpilotScoreWrapper__0Z_l9","trustpilotText":"trustpilot-overview_trustpilotText__D5A3o","trustpilotScoreMobileOnly":"trustpilot-overview_trustpilotScoreMobileOnly__y4gjF","numberOfReviews":"trustpilot-overview_numberOfReviews__vN7bz","reviewsOn":"trustpilot-overview_reviewsOn__ht0Qp","trustpilotLogo":"trustpilot-overview_trustpilotLogo__dCh5F"};

/***/ }),

/***/ 57669:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"adminFeeInfoButton":"admin-fee-button_adminFeeInfoButton__Xrou2"};

/***/ }),

/***/ 27190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"admin-fee-drawer_paragraph__D6_77"};

/***/ }),

/***/ 48409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__fc1S6","hoverable":"card_hoverable__deHdu"};

/***/ }),

/***/ 32052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"price_priceContainer__UH_Xn","smallFontSize":"price_smallFontSize__CrVx3","wasPrice":"price_wasPrice__BKep0","cashPrice":"price_cashPrice__eZX9_","cashPricePreAdminFeeCompliance":"price_cashPricePreAdminFeeCompliance__USpDa"};

/***/ }),

/***/ 13556:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"product-image_imgContainer__0TM0f","img":"product-image_img__4hVbU","unavailable":"product-image_unavailable__VzdCe"};

/***/ }),

/***/ 25791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"product-list-card_container__y1ncJ","link":"product-list-card_link__duMSe","meta":"product-list-card_meta__e3qEJ","imageContainer":"product-list-card_imageContainer___HEY0","actions":"product-list-card_actions__DkaZk","save":"product-list-card_save__jTqkh","unavailable":"product-list-card_unavailable__WuEGP","deliveryImage":"product-list-card_deliveryImage__kadkv","reserved":"product-list-card_reserved__dIdp1","titleCarCards":"product-list-card_titleCarCards__UdDKy","metaCarCards":"product-list-card_metaCarCards__6_e7R","metaCarCardsPreAdminFeeCompliance":"product-list-card_metaCarCardsPreAdminFeeCompliance__CCFs6","tagsCarCards":"product-list-card_tagsCarCards__qgvHo","tagItemCarCard":"product-list-card_tagItemCarCard__Srqw9"};

/***/ }),

/***/ 98637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button_button__phgUo","loading":"save-button_loading__R5361"};

/***/ }),

/***/ 71489:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__Qn1yv","active":"skeleton_active__k9sfS","skeleton":"skeleton_skeleton__uenic"};

/***/ }),

/***/ 79546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__eDITQ"};

/***/ }),

/***/ 54862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"tags_list__2kTwd","item":"tags_item__jrukZ","upperCase":"tags_upperCase__OUDIn"};

/***/ }),

/***/ 81391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"cookie-banner_cookieBanner__W_P9b","cookieBannerInner":"cookie-banner_cookieBannerInner__JdPr4","cookieBannerContent":"cookie-banner_cookieBannerContent__5zHAR","cookieBannerTitle":"cookie-banner_cookieBannerTitle__i6f4h","cookieBannerButtons":"cookie-banner_cookieBannerButtons__ootwI"};

/***/ }),

/***/ 79012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preferencesSection":"cookie-preferences-modal_preferencesSection__6QZvq","preferencesSectionHeader":"cookie-preferences-modal_preferencesSectionHeader__ZmKK3","preferencesSectionHeading":"cookie-preferences-modal_preferencesSectionHeading__YDEH0","preferencesBody":"cookie-preferences-modal_preferencesBody__GvBVy"};

/***/ }),

/***/ 91264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"cookie-consent_overlay__QytSD"};

/***/ }),

/***/ 81528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"links":"footer-links-list_links__c9WGB","link":"footer-links-list_link__P7Mp7"};

/***/ }),

/***/ 81427:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"shared-ui-footer_footer__G6wEC","footerContainer":"shared-ui-footer_footerContainer__Pgf8m","heading":"shared-ui-footer_heading__hRggf","subHeading":"shared-ui-footer_subHeading__MNzps","body":"shared-ui-footer_body__f3P73","noBorderRadius":"shared-ui-footer_noBorderRadius__7Nzqw","appStoreButtons":"shared-ui-footer_appStoreButtons__pBKAY"};

/***/ }),

/***/ 96340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"social-link-list_list__gEokJ"};

/***/ }),

/***/ 95121:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"social-link_item__kE3EZ","link":"social-link_link__mKgv4","iconName":"social-link_iconName__lqIG0","linkLabel":"social-link_linkLabel__MfAyW","body":"social-link_body__FdHgi"};

/***/ }),

/***/ 99351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"social-media-link-list_list__ea7PF"};

/***/ }),

/***/ 11361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"social-media-link_item__GC1h0"};

/***/ }),

/***/ 7180:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"black-friday-banner_saveTag__WXG_K","text":"black-friday-banner_text__DvIkg"};

/***/ }),

/***/ 38302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"deposit-contribution_saveTag__PK7rn","text":"deposit-contribution_text__9Gwtn"};

/***/ }),

/***/ 27463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"info-banner_text__tiShP"};

/***/ }),

/***/ 76594:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"sale-promo-banner_saveTag__QnsMv","text":"sale-promo-banner_text__ibbC7"};

/***/ }),

/***/ 7533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shared-ui-promo-banner_container__2hyqP","depositContributionContainer":"shared-ui-promo-banner_depositContributionContainer__vppjM","containerInfo":"shared-ui-promo-banner_containerInfo__vwrsK"};

/***/ }),

/***/ 73647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"spring-sale-promo-banner_saveTag__5BtFc","text":"spring-sale-promo-banner_text__pnpeD"};

/***/ }),

/***/ 46890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"winter-sale_saveTag__SiUfT","text":"winter-sale_text__pjuUI"};

/***/ }),

/***/ 42871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"xmas-promo-banner_text__EUo9U","link":"xmas-promo-banner_link__bB4_S","svg":"xmas-promo-banner_svg__5HVtN"};

/***/ }),

/***/ 15112:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__ZBm3z","bannerSection":"banner_bannerSection__G4Ho1","hideBasketBanner":"banner_hideBasketBanner__9CLfo","closeIconButton":"banner_closeIconButton__VfYxi","bannerHeading":"banner_bannerHeading__sJk8Q","basketBannerWrapper":"banner_basketBannerWrapper__dBlXa","returnToCheckoutCta":"banner_returnToCheckoutCta__HqpEB","buttonWrapper":"banner_buttonWrapper__J0I9N"};

/***/ }),

/***/ 42373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__qFTVn","icon":"holding-image_icon__zXB2P"};

/***/ }),

/***/ 20969:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"basketBannerVehicleInfoContainer":"vehicle-information_basketBannerVehicleInfoContainer__RHsaG","vehicleInfo":"vehicle-information_vehicleInfo__UL8Ra","price":"vehicle-information_price__poErW","basketBannerVehicleInfo":"vehicle-information_basketBannerVehicleInfo__RA7CC","vehicleImage":"vehicle-information_vehicleImage__DDPL2","vehicleImageWithAdminFee":"vehicle-information_vehicleImageWithAdminFee__4HPJo","vehicleImageLink":"vehicle-information_vehicleImageLink__ueITg","vehicleImageMobile":"vehicle-information_vehicleImageMobile__WrqLi","bannerHeading":"vehicle-information_bannerHeading___zsyE","basketBannerVehicleInfoContainerWithAdminFee":"vehicle-information_basketBannerVehicleInfoContainerWithAdminFee__nlAFf","priceRow":"vehicle-information_priceRow__uUSzO","priceRowWithAdminFee":"vehicle-information_priceRowWithAdminFee__blFBL","underlineText":"vehicle-information_underlineText__TsELc","vehicleLink":"vehicle-information_vehicleLink__37kaD"};

/***/ }),

/***/ 21829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__Lwvxh","title":"card_title__llES3","subtitle":"card_subtitle__dwFcP","close":"card_close__5pup5","textButton":"card_textButton__37I7_","body":"card_body__BFaI8"};

/***/ }),

/***/ 24557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__gCTQ0","icon":"holding-image_icon__ZKY6W"};

/***/ }),

/***/ 60942:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lazy":"lazy-image_lazy__su7R_","lazyLoaded":"lazy-image_lazyLoaded__icQo2"};

/***/ }),

/***/ 82917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"loading-spinner_loadingSpinner__r_D1D","spinner-rotation":"loading-spinner_spinner-rotation__DmQcg","foregroundCircle":"loading-spinner_foregroundCircle__WElce","foreground-dash":"loading-spinner_foreground-dash__eAS5A"};

/***/ }),

/***/ 59711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__BJeHT","backdropEnter":"modal_backdropEnter__i6WLh","backdropEnterActive":"modal_backdropEnterActive__sWqdh","backdropExit":"modal_backdropExit__pI_Tu","backdropExitActive":"modal_backdropExitActive__nIVYj","modal":"modal_modal__uj2xp","modalEnter":"modal_modalEnter__Y3x9u","modalEnterActive":"modal_modalEnterActive__PWD_f","modalExit":"modal_modalExit__bvSMZ","modalExitActive":"modal_modalExitActive___awzA"};

/***/ }),

/***/ 51282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"return-to-checkout-modal_cardContainer__tnJmL","cardTitleContainer":"return-to-checkout-modal_cardTitleContainer__sU5M8","cardBody":"return-to-checkout-modal_cardBody__Y7O2C","cardCloseIcon":"return-to-checkout-modal_cardCloseIcon__X2tbi","modal":"return-to-checkout-modal_modal__nNWqH","backdrop":"return-to-checkout-modal_backdrop__bQtnM","backdropStyle":"return-to-checkout-modal_backdropStyle__DgNbF","priceWrapper":"return-to-checkout-modal_priceWrapper_____Fl","price":"return-to-checkout-modal_price__GIlsS","adminFee":"return-to-checkout-modal_adminFee__GYvld","vehicleImage":"return-to-checkout-modal_vehicleImage__2_B5F","vehicleImageTransparent":"return-to-checkout-modal_vehicleImageTransparent__tY1he","vehicleInfoContainerTransparent":"return-to-checkout-modal_vehicleInfoContainerTransparent___hske","loadingDiv":"return-to-checkout-modal_loadingDiv__EI4Tk","subheader":"return-to-checkout-modal_subheader__hUfLx","remainingTimeText":"return-to-checkout-modal_remainingTimeText__XzGkH","expiredUnavailableText":"return-to-checkout-modal_expiredUnavailableText__tgKbR","titleWithIconContainer":"return-to-checkout-modal_titleWithIconContainer__xhEc_","timeIcon":"return-to-checkout-modal_timeIcon__3UKD7","cardTitle":"return-to-checkout-modal_cardTitle__Mq2IQ","button":"return-to-checkout-modal_button__rHnHx","underlineText":"return-to-checkout-modal_underlineText__3952X"};

/***/ }),

/***/ 84983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion_accordion__P8PKg","accordionTitle":"accordion_accordionTitle__BlijT","accordionItemContainer":"accordion_accordionItemContainer__iCkZK","accordionItemContainer__standard":"accordion_accordionItemContainer__standard__brwTk","accordionItemContainer__alternative":"accordion_accordionItemContainer__alternative__vAq6K","accordionButton":"accordion_accordionButton__OALxr","chevron":"accordion_chevron__bCDlU","chevronRotate":"accordion_chevronRotate__GF47q","accordionContentContainer":"accordion_accordionContentContainer__XQ_U8","accordionContentInnerContainer":"accordion_accordionContentInnerContainer__Fenjc","icon":"accordion_icon__wBKFB"};

/***/ }),

/***/ 73226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel-controls_wrapper__8YgXe"};

/***/ }),

/***/ 65860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controls":"carousel-navigation_controls__8axXv","controlsBtnPrev":"carousel-navigation_controlsBtnPrev__bj5hW","controlsBtnNext":"carousel-navigation_controlsBtnNext__PXYrY","controlsBtn":"carousel-navigation_controlsBtn__eZPPN"};

/***/ }),

/***/ 67246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"carousel-pagination_pagination__x4Pzn"};

/***/ }),

/***/ 68940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"carousel-wrapper_carouselWrapper__757C_","showCarousel":"carousel-wrapper_showCarousel__dg6HF"};

/***/ }),

/***/ 28812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"holdingImage":"holding-image_holdingImage__agH4f","icon":"holding-image_icon__ge_L8","holdingImageUnavailable":"holding-image_holdingImageUnavailable__XFySj"};

/***/ }),

/***/ 58853:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__GQ72p","gradient":"svg_gradient__3fhZ0"};

/***/ }),

/***/ 72393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reviewCardContainer":"trustpilot-review-card_reviewCardContainer__IvIKf","trustPilotTitle":"trustpilot-review-card_trustPilotTitle__VkCyj","trustPilotDescription":"trustpilot-review-card_trustPilotDescription__4Q83A","trustPilotCustomerName":"trustpilot-review-card_trustPilotCustomerName__ac7OE","trustPilotDate":"trustpilot-review-card_trustPilotDate__YVrhb","starRatingContainer":"trustpilot-review-card_starRatingContainer__i0y89","starRatingIconContainer":"trustpilot-review-card_starRatingIconContainer__b5L0S","starRatingIconContainerFilled":"trustpilot-review-card_starRatingIconContainerFilled__GM7g5","starRatingIcon":"trustpilot-review-card_starRatingIcon__E6Ck_","trustpilotReviewLink":"trustpilot-review-card_trustpilotReviewLink__ceJ_C"};

/***/ }),

/***/ 5271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"trustpilot-reviews_root__7E5kd","reviewsTitle":"trustpilot-reviews_reviewsTitle__mS3fV","trustPilotReviewsDesktopWrapper":"trustpilot-reviews_trustPilotReviewsDesktopWrapper__6mG2x","trustPilotLink":"trustpilot-reviews_trustPilotLink__Nn8JA","trustpilotLinkText":"trustpilot-reviews_trustpilotLinkText__judbT","logo":"trustpilot-reviews_logo__ph35S","controlsWrapper":"trustpilot-reviews_controlsWrapper__vh5cZ","carouselPagination":"trustpilot-reviews_carouselPagination__lnZq8","carouselPrevButton":"trustpilot-reviews_carouselPrevButton__3U83e","carouselNextButton":"trustpilot-reviews_carouselNextButton__ux_Tl"};

/***/ }),

/***/ 26008:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"trustpilot-scoreless_container__8lLQw","boldText":"trustpilot-scoreless_boldText__C_8fd","firstLine":"trustpilot-scoreless_firstLine__5_eZc","secondLine":"trustpilot-scoreless_secondLine__2d9DB","singleLine":"trustpilot-scoreless_singleLine__rdwHE","logo":"trustpilot-scoreless_logo__PSK4E"};

/***/ }),

/***/ 49242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilotWidgetContainer":"trustpilot-widget_trustpilotWidgetContainer__1N4RU","linkOverlay":"trustpilot-widget_linkOverlay__SGS_T"};

/***/ }),

/***/ 44243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_wrapper__pEXGA","container":"wrapper_container__lt04s","slimContainer":"wrapper_slimContainer__c12gH","wrapperFullHeight":"wrapper_wrapperFullHeight__yZpl8","wrapperOverflow":"wrapper_wrapperOverflow__ZMXn1"};

/***/ }),

/***/ 72592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"zendesk-messenger_buttonContainer__WK2WA","commentIcon":"zendesk-messenger_commentIcon__czBWN"};

/***/ }),

/***/ 8028:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 95249:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 93555:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70065:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1663:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 90953:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 22512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(3543)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 3543:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ }),

/***/ 98394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(13158);
(function(){var e={782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(782)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(704).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(704).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(871)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(727)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},173:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(782);i(Stream,n);Stream.Readable=r(709);Stream.Writable=r(337);Stream.Duplex=r(403);Stream.Transform=r(170);Stream.PassThrough=r(889);Stream.finished=r(698);Stream.pipeline=r(442);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(75291)},361:function(e){"use strict";e.exports=__webpack_require__(97531)},781:function(e){"use strict";e.exports=(__webpack_require__(97531).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(82019)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(173);module.exports=r})();

/***/ }),

/***/ 37122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(13158);
/* provided dependency */ var Buffer = __webpack_require__(75291)["Buffer"];
(function(){var e={523:function(e){e.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},782:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},646:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},403:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(709);var a=r(337);r(782)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},889:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(170);r(782)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},709:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(678);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(379);var c=r(25);var h=r(776),p=h.getHighWaterMark;var b=r(646).q,y=b.ERR_INVALID_ARG_TYPE,g=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var m;var w;var R;r(782)(Readable,o);var S=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!m)m=r(704).s;this.decoder=new m(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(403);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){S(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)S(e,new v);else addChunk(e,a,t,true)}else if(a.ended){S(e,new g)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new y("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!m)m=r(704).s;var t=new m(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){S(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)S(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(w===undefined){w=r(871)}return w(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(R===undefined){R=r(727)}return R(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},170:function(e,t,r){"use strict";e.exports=Transform;var n=r(646).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(403);r(782)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},337:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(769)};var a=r(678);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(25);var l=r(776),u=l.getHighWaterMark;var d=r(646).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,y=d.ERR_STREAM_DESTROYED,g=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var m=f.errorOrDestroy;r(782)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(403);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var w;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){w=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(w.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{w=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(403);var t=this instanceof n;if(!t&&!w.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){m(this,new b)};function writeAfterEnd(e,t){var r=new _;m(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new g}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){m(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new y("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;m(e,n)}else{i(n);e._writableState.errorEmitted=true;m(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){m(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},871:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(698);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},379:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},25:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},698:function(e,t,r){"use strict";var n=r(646).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},727:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(646).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},442:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(646).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(698);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},776:function(e,t,r){"use strict";var n=r(646).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},678:function(e,t,r){e.exports=r(781)},726:function(e,t,r){var n=r(781);if(process.env.READABLE_STREAM==="disable"&&n){e.exports=n.Readable;Object.assign(e.exports,n);e.exports.Stream=n}else{t=e.exports=r(709);t.Stream=n||t;t.Readable=t;t.Writable=r(337);t.Duplex=r(403);t.Transform=r(170);t.PassThrough=r(889);t.finished=r(698);t.pipeline=r(442)}},55:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},813:function(e,t,r){var n=r(450);var i=r(254);var a=r(911);var o=r(523);var s=r(310);var f=t;f.request=function(e,t){if(typeof e==="string")e=s.parse(e);else e=a(e);var r=__webpack_require__.g.location.protocol.search(/^https?:$/)===-1?"http:":"";var i=e.protocol||r;var o=e.hostname||e.host;var f=e.port;var l=e.path||"/";if(o&&o.indexOf(":")!==-1)o="["+o+"]";e.url=(o?i+"//"+o:"")+(f?":"+f:"")+l;e.method=(e.method||"GET").toUpperCase();e.headers=e.headers||{};var u=new n(e);if(t)u.on("response",t);return u};f.get=function get(e,t){var r=f.request(e,t);r.end();return r};f.ClientRequest=n;f.IncomingMessage=i.IncomingMessage;f.Agent=function(){};f.Agent.defaultMaxSockets=4;f.globalAgent=new f.Agent;f.STATUS_CODES=o;f.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]},301:function(e,t){t.fetch=isFunction(__webpack_require__.g.fetch)&&isFunction(__webpack_require__.g.ReadableStream);t.writableStream=isFunction(__webpack_require__.g.WritableStream);t.abortController=isFunction(__webpack_require__.g.AbortController);var r;function getXHR(){if(r!==undefined)return r;if(__webpack_require__.g.XMLHttpRequest){r=new __webpack_require__.g.XMLHttpRequest;try{r.open("GET",__webpack_require__.g.XDomainRequest?"/":"https://example.com")}catch(e){r=null}}else{r=null}return r}function checkTypeSupport(e){var t=getXHR();if(!t)return false;try{t.responseType=e;return t.responseType===e}catch(e){}return false}t.arraybuffer=t.fetch||checkTypeSupport("arraybuffer");t.msstream=!t.fetch&&checkTypeSupport("ms-stream");t.mozchunkedarraybuffer=!t.fetch&&checkTypeSupport("moz-chunked-arraybuffer");t.overrideMimeType=t.fetch||(getXHR()?isFunction(getXHR().overrideMimeType):false);function isFunction(e){return typeof e==="function"}r=null},450:function(e,t,r){var n=r(301);var i=r(782);var a=r(254);var o=r(726);var s=a.IncomingMessage;var f=a.readyStates;function decideMode(e,t){if(n.fetch&&t){return"fetch"}else if(n.mozchunkedarraybuffer){return"moz-chunked-arraybuffer"}else if(n.msstream){return"ms-stream"}else if(n.arraybuffer&&e){return"arraybuffer"}else{return"text"}}var l=e.exports=function(e){var t=this;o.Writable.call(t);t._opts=e;t._body=[];t._headers={};if(e.auth)t.setHeader("Authorization","Basic "+Buffer.from(e.auth).toString("base64"));Object.keys(e.headers).forEach((function(r){t.setHeader(r,e.headers[r])}));var r;var i=true;if(e.mode==="disable-fetch"||"requestTimeout"in e&&!n.abortController){i=false;r=true}else if(e.mode==="prefer-streaming"){r=false}else if(e.mode==="allow-wrong-content-type"){r=!n.overrideMimeType}else if(!e.mode||e.mode==="default"||e.mode==="prefer-fast"){r=true}else{throw new Error("Invalid value for opts.mode")}t._mode=decideMode(r,i);t._fetchTimer=null;t.on("finish",(function(){t._onFinish()}))};i(l,o.Writable);l.prototype.setHeader=function(e,t){var r=this;var n=e.toLowerCase();if(u.indexOf(n)!==-1)return;r._headers[n]={name:e,value:t}};l.prototype.getHeader=function(e){var t=this._headers[e.toLowerCase()];if(t)return t.value;return null};l.prototype.removeHeader=function(e){var t=this;delete t._headers[e.toLowerCase()]};l.prototype._onFinish=function(){var e=this;if(e._destroyed)return;var t=e._opts;var r=e._headers;var i=null;if(t.method!=="GET"&&t.method!=="HEAD"){i=new Blob(e._body,{type:(r["content-type"]||{}).value||""})}var a=[];Object.keys(r).forEach((function(e){var t=r[e].name;var n=r[e].value;if(Array.isArray(n)){n.forEach((function(e){a.push([t,e])}))}else{a.push([t,n])}}));if(e._mode==="fetch"){var o=null;if(n.abortController){var s=new AbortController;o=s.signal;e._fetchAbortController=s;if("requestTimeout"in t&&t.requestTimeout!==0){e._fetchTimer=__webpack_require__.g.setTimeout((function(){e.emit("requestTimeout");if(e._fetchAbortController)e._fetchAbortController.abort()}),t.requestTimeout)}}__webpack_require__.g.fetch(e._opts.url,{method:e._opts.method,headers:a,body:i||undefined,mode:"cors",credentials:t.withCredentials?"include":"same-origin",signal:o}).then((function(t){e._fetchResponse=t;e._connect()}),(function(t){__webpack_require__.g.clearTimeout(e._fetchTimer);if(!e._destroyed)e.emit("error",t)}))}else{var l=e._xhr=new __webpack_require__.g.XMLHttpRequest;try{l.open(e._opts.method,e._opts.url,true)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}if("responseType"in l)l.responseType=e._mode;if("withCredentials"in l)l.withCredentials=!!t.withCredentials;if(e._mode==="text"&&"overrideMimeType"in l)l.overrideMimeType("text/plain; charset=x-user-defined");if("requestTimeout"in t){l.timeout=t.requestTimeout;l.ontimeout=function(){e.emit("requestTimeout")}}a.forEach((function(e){l.setRequestHeader(e[0],e[1])}));e._response=null;l.onreadystatechange=function(){switch(l.readyState){case f.LOADING:case f.DONE:e._onXHRProgress();break}};if(e._mode==="moz-chunked-arraybuffer"){l.onprogress=function(){e._onXHRProgress()}}l.onerror=function(){if(e._destroyed)return;e.emit("error",new Error("XHR error"))};try{l.send(i)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}}};function statusValid(e){try{var t=e.status;return t!==null&&t!==0}catch(e){return false}}l.prototype._onXHRProgress=function(){var e=this;if(!statusValid(e._xhr)||e._destroyed)return;if(!e._response)e._connect();e._response._onXHRProgress()};l.prototype._connect=function(){var e=this;if(e._destroyed)return;e._response=new s(e._xhr,e._fetchResponse,e._mode,e._fetchTimer);e._response.on("error",(function(t){e.emit("error",t)}));e.emit("response",e._response)};l.prototype._write=function(e,t,r){var n=this;n._body.push(e);r()};l.prototype.abort=l.prototype.destroy=function(){var e=this;e._destroyed=true;__webpack_require__.g.clearTimeout(e._fetchTimer);if(e._response)e._response._destroyed=true;if(e._xhr)e._xhr.abort();else if(e._fetchAbortController)e._fetchAbortController.abort()};l.prototype.end=function(e,t,r){var n=this;if(typeof e==="function"){r=e;e=undefined}o.Writable.prototype.end.call(n,e,t,r)};l.prototype.flushHeaders=function(){};l.prototype.setTimeout=function(){};l.prototype.setNoDelay=function(){};l.prototype.setSocketKeepAlive=function(){};var u=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]},254:function(e,t,r){var n=r(301);var i=r(782);var a=r(726);var o=t.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4};var s=t.IncomingMessage=function(e,t,r,i){var o=this;a.Readable.call(o);o._mode=r;o.headers={};o.rawHeaders=[];o.trailers={};o.rawTrailers=[];o.on("end",(function(){process.nextTick((function(){o.emit("close")}))}));if(r==="fetch"){o._fetchResponse=t;o.url=t.url;o.statusCode=t.status;o.statusMessage=t.statusText;t.headers.forEach((function(e,t){o.headers[t.toLowerCase()]=e;o.rawHeaders.push(t,e)}));if(n.writableStream){var s=new WritableStream({write:function(e){return new Promise((function(t,r){if(o._destroyed){r()}else if(o.push(Buffer.from(e))){t()}else{o._resumeFetch=t}}))},close:function(){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.push(null)},abort:function(e){if(!o._destroyed)o.emit("error",e)}});try{t.body.pipeTo(s).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}));return}catch(e){}}var f=t.body.getReader();function read(){f.read().then((function(e){if(o._destroyed)return;if(e.done){__webpack_require__.g.clearTimeout(i);o.push(null);return}o.push(Buffer.from(e.value));read()})).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}))}read()}else{o._xhr=e;o._pos=0;o.url=e.responseURL;o.statusCode=e.status;o.statusMessage=e.statusText;var l=e.getAllResponseHeaders().split(/\r?\n/);l.forEach((function(e){var t=e.match(/^([^:]+):\s*(.*)/);if(t){var r=t[1].toLowerCase();if(r==="set-cookie"){if(o.headers[r]===undefined){o.headers[r]=[]}o.headers[r].push(t[2])}else if(o.headers[r]!==undefined){o.headers[r]+=", "+t[2]}else{o.headers[r]=t[2]}o.rawHeaders.push(t[1],t[2])}}));o._charset="x-user-defined";if(!n.overrideMimeType){var u=o.rawHeaders["mime-type"];if(u){var d=u.match(/;\s*charset=([^;])(;|$)/);if(d){o._charset=d[1].toLowerCase()}}if(!o._charset)o._charset="utf-8"}}};i(s,a.Readable);s.prototype._read=function(){var e=this;var t=e._resumeFetch;if(t){e._resumeFetch=null;t()}};s.prototype._onXHRProgress=function(){var e=this;var t=e._xhr;var r=null;switch(e._mode){case"text":r=t.responseText;if(r.length>e._pos){var n=r.substr(e._pos);if(e._charset==="x-user-defined"){var i=Buffer.alloc(n.length);for(var a=0;a<n.length;a++)i[a]=n.charCodeAt(a)&255;e.push(i)}else{e.push(n,e._charset)}e._pos=r.length}break;case"arraybuffer":if(t.readyState!==o.DONE||!t.response)break;r=t.response;e.push(Buffer.from(new Uint8Array(r)));break;case"moz-chunked-arraybuffer":r=t.response;if(t.readyState!==o.LOADING||!r)break;e.push(Buffer.from(new Uint8Array(r)));break;case"ms-stream":r=t.response;if(t.readyState!==o.LOADING)break;var s=new __webpack_require__.g.MSStreamReader;s.onprogress=function(){if(s.result.byteLength>e._pos){e.push(Buffer.from(new Uint8Array(s.result.slice(e._pos))));e._pos=s.result.byteLength}};s.onload=function(){e.push(null)};s.readAsArrayBuffer(r);break}if(e._xhr.readyState===o.DONE&&e._mode!=="ms-stream"){e.push(null)}}},704:function(e,t,r){"use strict";var n=r(55).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},769:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},911:function(e){e.exports=extend;var t=Object.prototype.hasOwnProperty;function extend(){var e={};for(var r=0;r<arguments.length;r++){var n=arguments[r];for(var i in n){if(t.call(n,i)){e[i]=n[i]}}}return e}},300:function(e){"use strict";e.exports=__webpack_require__(75291)},361:function(e){"use strict";e.exports=__webpack_require__(97531)},781:function(e){"use strict";e.exports=__webpack_require__(98394)},310:function(e){"use strict";e.exports=__webpack_require__(22512)},837:function(e){"use strict";e.exports=__webpack_require__(82019)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(813);module.exports=r})();

/***/ }),

/***/ 73218:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={950:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[950](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 82070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(17111)


/***/ }),

/***/ 46582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19404)


/***/ }),

/***/ 19601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4613)


/***/ }),

/***/ 89218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(50422)


/***/ }),

/***/ 35837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8439)


/***/ }),

/***/ 50430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(35236)


/***/ }),

/***/ 59665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(82320);
var setCookieParser = __webpack_require__(85184);
var utils_1 = __webpack_require__(59495);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 59495:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 13158:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 62234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "decode": function() { return /* binding */ decode; },
/* harmony export */   "encode": function() { return /* binding */ encode; },
/* harmony export */   "toASCII": function() { return /* binding */ toASCII; },
/* harmony export */   "toUnicode": function() { return /* binding */ toUnicode; },
/* harmony export */   "ucs2decode": function() { return /* binding */ ucs2decode; },
/* harmony export */   "ucs2encode": function() { return /* binding */ ucs2encode; }
/* harmony export */ });


/** Highest positive signed 32-bit float value */
const maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
const base = 36;
const tMin = 1;
const tMax = 26;
const skew = 38;
const damp = 700;
const initialBias = 72;
const initialN = 128; // 0x80
const delimiter = '-'; // '\x2D'

/** Regular expressions */
const regexPunycode = /^xn--/;
const regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
const errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
const baseMinusTMin = base - tMin;
const floor = Math.floor;
const stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	const result = [];
	let length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	const parts = string.split('@');
	let result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	const labels = string.split('.');
	const encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	const output = [];
	let counter = 0;
	const length = string.length;
	while (counter < length) {
		const value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			const extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
const ucs2encode = array => String.fromCodePoint(...array);

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
const basicToDigit = function(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
const digitToBasic = function(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
const adapt = function(delta, numPoints, firstTime) {
	let k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
const decode = function(input) {
	// Don't use UCS-2.
	const output = [];
	const inputLength = input.length;
	let i = 0;
	let n = initialN;
	let bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	let basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (let j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (let index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		let oldi = i;
		for (let w = 1, k = base; /* no condition */; k += base) {

			if (index >= inputLength) {
				error('invalid-input');
			}

			const digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error('overflow');
			}

			i += digit * w;
			const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

			if (digit < t) {
				break;
			}

			const baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error('overflow');
			}

			w *= baseMinusT;

		}

		const out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);

	}

	return String.fromCodePoint(...output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
const encode = function(input) {
	const output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	let inputLength = input.length;

	// Initialize the state.
	let n = initialN;
	let delta = 0;
	let bias = initialBias;

	// Handle the basic code points.
	for (const currentValue of input) {
		if (currentValue < 0x80) {
			output.push(stringFromCharCode(currentValue));
		}
	}

	let basicLength = output.length;
	let handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		let m = maxInt;
		for (const currentValue of input) {
			if (currentValue >= n && currentValue < m) {
				m = currentValue;
			}
		}

		// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
		// but guard against overflow.
		const handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		for (const currentValue of input) {
			if (currentValue < n && ++delta > maxInt) {
				error('overflow');
			}
			if (currentValue == n) {
				// Represent delta as a generalized variable-length integer.
				let q = delta;
				for (let k = base; /* no condition */; k += base) {
					const t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
					if (q < t) {
						break;
					}
					const qMinusT = q - t;
					const baseMinusT = base - t;
					output.push(
						stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
					);
					q = floor(qMinusT / baseMinusT);
				}

				output.push(stringFromCharCode(digitToBasic(q, 0)));
				bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
				delta = 0;
				++handledCPCount;
			}
		}

		++delta;
		++n;

	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
const toUnicode = function(input) {
	return mapDomain(input, function(string) {
		return regexPunycode.test(string)
			? decode(string.slice(4).toLowerCase())
			: string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
const toASCII = function(input) {
	return mapDomain(input, function(string) {
		return regexNonASCII.test(string)
			? 'xn--' + encode(string)
			: string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
const punycode = {
	/**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */
	'version': '2.1.0',
	/**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};


/* harmony default export */ __webpack_exports__["default"] = (punycode);


/***/ }),

/***/ 58420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ index_es; }
});

// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(19930);
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      (0,inheritsLoose/* default */.Z)(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ var index_es = (withSideEffect);


/***/ }),

/***/ 47533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(32735)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 26697:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 72594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(26697);
} else {}


/***/ }),

/***/ 30659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_CSSTransition; }
});

// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(20011);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(66017);
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(19930);
;// CONCATENATED MODULE: ../../../node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ../../../node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ../../../node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(12788);
;// CONCATENATED MODULE: ../../../node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ../../../node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ../../../node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ../../../node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ../../../node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(esm_Transition, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);

/***/ }),

/***/ 80707:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(75291)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 85184:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);

  var nameValuePairStr = parts.shift();
  var parsed = parseNameValuePair(nameValuePairStr);
  var name = parsed.name;
  var value = parsed.value;

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name,
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parseNameValuePair(nameValuePairStr) {
  // Parses name-value-pair according to rfc6265bis draft

  var name = "";
  var value = "";
  var nameValueArr = nameValuePairStr.split("=");
  if (nameValueArr.length > 1) {
    name = nameValueArr.shift();
    value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
  } else {
    value = nameValuePairStr;
  }

  return { name: name, value: value };
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers) {
    if (typeof input.headers.getSetCookie === "function") {
      // for fetch responses - they combine headers of the same type in the headers array,
      // but getSetCookie returns an uncombined array
      input = input.headers.getSetCookie();
    } else if (input.headers["set-cookie"]) {
      // fast-path for node.js (which automatically normalizes header names to lower-case
      input = input.headers["set-cookie"];
    } else {
      // slow-path for other environments - see #25
      var sch =
        input.headers[
          Object.keys(input.headers).find(function (key) {
            return key.toLowerCase() === "set-cookie";
          })
        ];
      // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
      if (!sch && input.headers.cookie && !options.silent) {
        console.warn(
          "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
        );
      }
      input = sch;
    }
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 87682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(80707).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 31191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),

/***/ 27553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useMergeRefs; }
});

;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ../../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}


/***/ }),

/***/ 42442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ createSidecarMedium; },
/* harmony export */   "s": function() { return /* binding */ createMedium; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31191);

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({ async: true, ssr: false }, options);
    return medium;
}


/***/ }),

/***/ 22173:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(32735);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 5917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(32735),n=__webpack_require__(21374);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 21374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(22173);
} else {}


/***/ }),

/***/ 55668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(5917);
} else {}


/***/ }),

/***/ 97323:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 77502:
/***/ (function(module) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 82019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(13158);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(__webpack_require__.g.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(77502);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(97323);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/***/ }),

/***/ 38627:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 29858:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 95685:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 20011:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 19930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 66017:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 20056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ OBJECT; },
/* harmony export */   "BN": function() { return /* binding */ internalMutate; },
/* harmony export */   "DY": function() { return /* binding */ SWRGlobalState; },
/* harmony export */   "J$": function() { return /* binding */ SWRConfig; },
/* harmony export */   "JN": function() { return /* binding */ createCacheHelper; },
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "PM": function() { return /* binding */ mergeObjects; },
/* harmony export */   "W6": function() { return /* binding */ IS_SERVER; },
/* harmony export */   "i_": function() { return /* binding */ UNDEFINED; },
/* harmony export */   "ko": function() { return /* binding */ subscribeCallback; },
/* harmony export */   "kw": function() { return /* binding */ rAF; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "o8": function() { return /* binding */ isUndefined; },
/* harmony export */   "qC": function() { return /* binding */ serialize; },
/* harmony export */   "s6": function() { return /* binding */ withArgs; },
/* harmony export */   "sj": function() { return /* binding */ events; },
/* harmony export */   "u3": function() { return /* binding */ getTimestamp; },
/* harmony export */   "u_": function() { return /* binding */ defaultConfig; },
/* harmony export */   "w6": function() { return /* binding */ IS_REACT_LEGACY; },
/* harmony export */   "xD": function() { return /* binding */ withMiddleware; }
/* harmony export */ });
/* unused harmony exports INFINITE_PREFIX, cache, compare, defaultConfigOptions, hasRequestAnimationFrame, initCache, isDocumentDefined, isPromiseLike, isWindowDefined, mergeConfigs, mutate, noop, normalize, preload, preset, slowConnection, stableHash, useSWRConfig */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);


// Shared state between server components and client components
const noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const UNDEFINED = /*#__NOINLINE__*/ noop();
const OBJECT = Object;
const isUndefined = (v)=>v === UNDEFINED;
const isFunction = (v)=>typeof v == 'function';
const mergeObjects = (a, b)=>({
        ...a,
        ...b
    });
const isPromiseLike = (x)=>isFunction(x.then);

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const table = new WeakMap();
// counter of the key
let counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const stableHash = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++){
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            const keys = OBJECT.keys(arg).sort();
            while(!isUndefined(index = keys.pop())){
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    } else {
        result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    }
    return result;
};

// Global state used to deduplicate requests and store listeners
const SWRGlobalState = new WeakMap();

const EMPTY_CACHE = {};
const INITIAL_CACHE = {};
const STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const isWindowDefined = typeof window != STR_UNDEFINED;
const isDocumentDefined = typeof document != STR_UNDEFINED;
const hasRequestAnimationFrame = ()=>isWindowDefined && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
const createCacheHelper = (cache, key)=>{
    const state = SWRGlobalState.get(cache);
    return [
        // Getter
        ()=>!isUndefined(key) && cache.get(key) || EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!isUndefined(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in INITIAL_CACHE)) {
                    INITIAL_CACHE[key] = prev;
                }
                state[5](key, mergeObjects(prev, info), prev || EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!isUndefined(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in INITIAL_CACHE) return INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !isUndefined(key) && cache.get(key) || EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;

/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let online = true;
const isOnline = ()=>online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [onWindowEvent, offWindowEvent] = isWindowDefined && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    noop,
    noop
];
const isVisible = ()=>{
    const visibilityState = isDocumentDefined && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
const initFocus = (callback)=>{
    // focus revalidate
    if (isDocumentDefined) {
        document.addEventListener('visibilitychange', callback);
    }
    onWindowEvent('focus', callback);
    return ()=>{
        if (isDocumentDefined) {
            document.removeEventListener('visibilitychange', callback);
        }
        offWindowEvent('focus', callback);
    };
};
const initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return ()=>{
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
const preset = {
    isOnline,
    isVisible
};
const defaultConfigOptions = {
    initFocus,
    initReconnect
};

const IS_REACT_LEGACY = !react__WEBPACK_IMPORTED_MODULE_0__.useId;
const IS_SERVER = !isWindowDefined || 'Deno' in window;
// Polyfill requestAnimationFrame
const rAF = (f)=>hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
const navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const slowConnection = !IS_SERVER && navigatorConnection && ([
    'slow-2g',
    '2g'
].includes(navigatorConnection.effectiveType) || navigatorConnection.saveData);

const serialize = (key)=>{
    if (isFunction(key)) {
        try {
            key = key();
        } catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? stableHash(key) : '';
    return [
        key,
        args
    ];
};

// Global timestamp.
let __timestamp = 0;
const getTimestamp = ()=>++__timestamp;

const FOCUS_EVENT = 0;
const RECONNECT_EVENT = 1;
const MUTATE_EVENT = 2;
const ERROR_REVALIDATE_EVENT = 3;

var events = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: ERROR_REVALIDATE_EVENT,
  FOCUS_EVENT: FOCUS_EVENT,
  MUTATE_EVENT: MUTATE_EVENT,
  RECONNECT_EVENT: RECONNECT_EVENT
};

async function internalMutate(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = mergeObjects({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if (isFunction(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it){
            if (// Skip the special useSWRInfinite and useSWRSubscription keys.
            !/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) {
                matchedKeys.push(key);
            }
        }
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = serialize(_k);
        if (!key) return;
        const [get, set] = createCacheHelper(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = SWRGlobalState.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) {
                    return revalidators[0](MUTATE_EVENT).then(()=>get().data);
                }
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) {
            // Revalidate and broadcast state.
            return startRevalidate();
        }
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = getTimestamp();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !isUndefined(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = isUndefined(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = isFunction(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if (isFunction(data)) {
            // `data` is a function, call it passing current cache value.
            try {
                data = data(committedData);
            } catch (err) {
                // If it throws an error synchronously, we shouldn't update the cache.
                error = err;
            }
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && isPromiseLike(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: UNDEFINED
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if (isFunction(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: UNDEFINED,
                        _c: UNDEFINED
                    });
                } else {
                    // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                    set({
                        data,
                        error: UNDEFINED,
                        _c: UNDEFINED
                    });
                }
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = getTimestamp();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: UNDEFINED
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}

const revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators){
        if (revalidators[key][0]) revalidators[key][0](type);
    }
};
const initCache = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        const opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = internalMutate.bind(UNDEFINED, provider);
        let unmount = noop;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) {
                for (const fn of subs){
                    fn(value, prev);
                }
            }
        };
        const initProvider = ()=>{
            if (!SWRGlobalState.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                SWRGlobalState.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!IS_SERVER) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        SWRGlobalState.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        SWRGlobalState.get(provider)[4]
    ];
};

// error retry
const onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
const compare = (currentData, newData)=>stableHash(currentData) == stableHash(newData);
// Default cache provider
const [cache, mutate] = initCache(new Map());
// Default config
const defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare,
    isPaused: ()=>false,
    cache,
    mutate,
    fallback: {}
}, // use web preset by default
preset);

const mergeConfigs = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

const SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
const SWRConfig = (props)=>{
    const { value } = props;
    const parentConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext);
    const isFunctionalConfig = isFunction(value);
    const config = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>isFunctionalConfig ? config : mergeConfigs(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(UNDEFINED);
    if (provider && !cacheContextRef.current) {
        cacheContextRef.current = initCache(provider(extendedConfig.cache || cache), config);
    }
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

const INFINITE_PREFIX = '$inf$';

// @ts-expect-error
const enableDevtools = isWindowDefined && window.__SWR_DEVTOOLS_USE__;
const use = enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const setupDevTools = ()=>{
    if (enableDevtools) {
        // @ts-expect-error
        window.__SWR_DEVTOOLS_REACT__ = react__WEBPACK_IMPORTED_MODULE_0__;
    }
};

const normalize = (args)=>{
    return isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};

const useSWRConfig = ()=>{
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

const preload = (key_, fetcher)=>{
    const [key, fnArg] = serialize(key_);
    const [, , , PRELOAD] = SWRGlobalState.get(cache);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = serialize(key_);
            const [, , , PRELOAD] = SWRGlobalState.get(cache);
            if (key.startsWith(INFINITE_PREFIX)) {
                // we want the infinite fetcher to be called.
                // handling of the PRELOAD cache happens there.
                return fetcher_(...args);
            }
            const req = PRELOAD[key];
            if (isUndefined(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };

const BUILT_IN_MIDDLEWARE = use.concat(middleware);

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const withArgs = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = useSWRConfig();
        // Normalize arguments.
        const [key, fn, _config] = normalize(args);
        // Merge configurations.
        const config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use } = config;
        const middleware = (use || []).concat(BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;){
            next = middleware[i](next);
        }
        return next(key, fn || config.fetcher || null, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const subscribeCallback = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

// Create a custom hook with a middleware
const withMiddleware = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = normalize(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};

setupDevTools();




/***/ }),

/***/ 24126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useSWR; }
/* harmony export */ });
/* unused harmony exports SWRConfig, unstable_serialize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21374);
/* harmony import */ var swr_internal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20056);






const unstable_serialize = (key)=>serialize(key)[0];

/// <reference types="react/experimental" />
const use = react__WEBPACK_IMPORTED_MODULE_0__.use || ((promise)=>{
    if (promise.status === 'pending') {
        throw promise;
    } else if (promise.status === 'fulfilled') {
        return promise.value;
    } else if (promise.status === 'rejected') {
        throw promise.reason;
    } else {
        promise.status = 'pending';
        promise.then((v)=>{
            promise.status = 'fulfilled';
            promise.value = v;
        }, (e)=>{
            promise.status = 'rejected';
            promise.reason = e;
        });
        throw promise;
    }
});
const WITH_DEDUPE = {
    dedupe: true
};
const useSWRHandler = (_key, fetcher, config)=>{
    const { cache, compare, suspense, fallbackData, revalidateOnMount, revalidateIfStale, refreshInterval, refreshWhenHidden, refreshWhenOffline, keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRGlobalState.get */ .DY.get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .serialize */ .qC)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    const fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    const configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .createCacheHelper */ .JN)(cache, key);
    const stateDependencies = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    const fallback = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(prev[t])) {
                        return false;
                    }
                    if (!compare(returnedData, current[t])) {
                        return false;
                    }
                }
            } else {
                if (current[t] !== prev[t]) {
                    return false;
                }
            }
        }
        return true;
    };
    const getSnapshot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .mergeObjects */ .PM)(state);
            delete snapshot._k;
            if (!shouldStartRequest) {
                return snapshot;
            }
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0,use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_1__.useSyncExternalStore)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(data);
    const returnedData = keepPreviousData ? (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) {
            return false;
        }
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6) {
                return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            }
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) {
                delete FETCH[key];
            }
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
            initialState.isLoading = true;
        }
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(getCache().data)) {
                    setTimeout(()=>{
                        if (loading && callbackSafeguard()) {
                            getConfig().onLoadingSlow(key, config);
                        }
                    }, config.loadingTimeout);
                }
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .getTimestamp */ .u3)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) {
                // If the request isn't interrupted, clean it up after the
                // deduplication interval.
                setTimeout(cleanupState, config.dedupingInterval);
            }
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Clear error.
            finalState.error = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_;
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) {
                        getConfig().onDiscarded(key);
                    }
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) {
                    getConfig().onSuccess(newData, key, config);
                }
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) {
                            // If it's inactive, stop. It will auto-revalidate when
                            // refocusing or reconnecting.
                            // When retrying, deduplication is always enabled.
                            currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                                const revalidators = EVENT_REVALIDATORS[key];
                                if (revalidators && revalidators[0]) {
                                    revalidators[0](swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.ERROR_REVALIDATE_EVENT */ .sj.ERROR_REVALIDATE_EVENT, _opts);
                                }
                            }, {
                                retryCount: (opts.retryCount || 0) + 1,
                                dedupe: true
                            });
                        }
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(// Use callback to make sure `keyRef.current` returns latest result every time
    (...args)=>{
        return (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .internalMutate */ .BN)(cache, keyRef.current, ...args);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // The logic for updating refs.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(cachedData)) {
            laggyDataRef.current = cachedData;
        }
    });
    // After mounted or key changed.
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .UNDEFINED */ .i_, WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.FOCUS_EVENT */ .sj.FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.RECONNECT_EVENT */ .sj.RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            } else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.MUTATE_EVENT */ .sj.MUTATE_EVENT) {
                return revalidate();
            } else if (type == swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .revalidateEvents.ERROR_REVALIDATE_EVENT */ .sj.ERROR_REVALIDATE_EVENT) {
                return revalidate(opts);
            }
            return;
        };
        const unsubEvents = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .subscribeCallback */ .ko)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) || swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
                // Revalidate immediately.
                softRevalidate();
            } else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .rAF */ .kw)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .LI)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isFunction */ .mf)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            } else {
                // Schedule the next interval to check again.
                next();
            }
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_REACT_LEGACY */ .w6 && swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .IS_SERVER */ .W6) {
            throw new Error('Fallback data is required when using suspense in SSR.');
        }
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(req)) {
            const promise = boundMutate(req);
            use(promise);
        }
        if ((0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(error)) {
            const promise = revalidate(WITH_DEDUPE);
            if (!(0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .isUndefined */ .o8)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            use(promise);
        } else {
            throw error;
        }
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const SWRConfig = swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .OBJECT.defineProperty */ .$l.defineProperty(swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .SWRConfig */ .J$, 'defaultValue', {
    value: swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .defaultConfig */ .u_
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const useSWR = (0,swr_internal__WEBPACK_IMPORTED_MODULE_2__/* .withArgs */ .s6)(useSWRHandler);




/***/ }),

/***/ 12093:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ z; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodCatch, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPipeline, ZodPromise, ZodReadonly, ZodRecord, ZodSchema, ZodSet, ZodString, ZodSymbol, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, boolean, coerce, custom, date, default, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, literal, makeIssue, map, nan, nativeEnum, never, null, nullable, number, object, objectUtil, oboolean, onumber, optional, ostring, pipeline, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, string, symbol, transformer, tuple, undefined, union, unknown, util, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ }),

/***/ 23939:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ../../../node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(55668);
;// CONCATENATED MODULE: ../../../node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(94562), __webpack_exec__(8439); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);